webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(765);
	
	var _rpGuiGuide = __webpack_require__(134);
	
	var _rpGuiGuide2 = _interopRequireDefault(_rpGuiGuide);
	
	var _rpAdvertising = __webpack_require__(748);
	
	var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);
	
	var _rpNavigation = __webpack_require__(153);
	
	var _rpPopup = __webpack_require__(757);
	
	var _rpPopup2 = _interopRequireDefault(_rpPopup);
	
	var _rpCookie = __webpack_require__(83);
	
	var _rpUrlNavigationPrefs = __webpack_require__(1869);
	
	var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);
	
	var _analyticsPage = __webpack_require__(1645);
	
	var _analyticsPage2 = _interopRequireDefault(_analyticsPage);
	
	var _jquery = __webpack_require__(23);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1695);
	
	var _secondaryNavConfig = __webpack_require__(1701);
	
	var _secondaryNavConfig2 = _interopRequireDefault(_secondaryNavConfig);
	
	var _rpBettingSpecialOffer = __webpack_require__(1810);
	
	var _rpBettingSpecialOffer2 = _interopRequireDefault(_rpBettingSpecialOffer);
	
	var _storage = __webpack_require__(731);
	
	__webpack_require__(1481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_jquery2.default.cookie('to_force_inclusion_in_code');
	
	(0, _analyticsPage2.default)();
	(0, _secondaryNavConfig2.default)();
	(0, _rpCookie.cleanLegacy)();
	(0, _rpPopup2.default)();
	(0, _rpPopup.backLink)();
	(0, _rpBettingSpecialOffer2.default)();
	(0, _rpGuiGuide2.default)({
	    svg: { polyfill: true }
	});
	(0, _rpAdvertising2.default)({
	    targeting: ['pedigree'],
	    targetingEvent: _storage.UPDATE_TARGETING,
	    localStorageKey: _storage.STORAGE_ITEM_NAME
	});
	(0, _rpUrlNavigationPrefs2.default)();
	_rpNavigation.appPromo.init();

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module IO
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Long = __webpack_require__(44);
	// bitmasks for int64 read/write
	var x80 = Long.fromNumber(0x80);
	var x7F = Long.fromNumber(0x7F);
	// long.not returns a different value than ~
	var x7FInv = x7F.not(); // not Long.fromNumber(~0x7F);
	/**
	 * Read a single byte from the input
	 *
	 * @param  input the input stream to read from
	 * @return       the next byte in the input stream
	 * @throws an error if no more data is available
	 */
	function readByte(input) {
	    var i = input.read();
	    if (i === -1) {
	        throw new Error('End of stream');
	    }
	    return i;
	}
	exports.readByte = readByte;
	/**
	 * Read an encoded Int64
	 *
	 * This will return the value as a Long instance.
	 *
	 * @param input the input stream from which to read
	 * @returns the decoded Int64, represented as Long
	 * @throws an error if an int64 is malformed and cannot be read
	 */
	function readInt64(input) {
	    var result = Long.fromNumber(0);
	    var shift = 0;
	    while (shift < 64) {
	        var i = readByte(input);
	        var l = Long.fromNumber(i);
	        result = result.or(l.and(x7F).shiftLeft(shift));
	        if (l.and(x80).equals(0)) {
	            return result;
	        }
	        shift += 7;
	    }
	    throw new Error('Malformed int64');
	}
	exports.readInt64 = readInt64;
	/**
	 * Write an encoded Int64
	 *
	 * Writes a number as an Int64 to the given Output stream.
	 *
	 * @param bos the output stream to write to
	 * @param value the number to write
	 */
	function writeInt64(bos, value) {
	    var int64 = value instanceof Long ? value : Long.fromNumber(value, false);
	    while (!int64.and(x7FInv).equals(0)) {
	        bos.write(int64.and(x7F).or(x80).toInt());
	        int64 = int64.shiftRightUnsigned(7);
	    }
	    bos.write(int64.toInt());
	}
	exports.writeInt64 = writeInt64;
	/**
	 * Read an encoded Int32
	 *
	 * @param bis The input stream to read from
	 * @returns the Int32 that was read
	 * @throws an error if an int32 is malformed and cannot be read
	 */
	function readInt32(bis) {
	    var shift = 0;
	    var result = 0;
	    while (shift < 32) {
	        var i = readByte(bis);
	        /* tslint:disable-next-line:no-bitwise */
	        result |= (i & 0x7F) << shift;
	        /* tslint:disable-next-line:no-bitwise */
	        if ((i & 0x80) === 0) {
	            return result;
	        }
	        shift += 7;
	    }
	    throw new Error('Malformed int32');
	}
	exports.readInt32 = readInt32;
	/**
	 * Write an encoded Int32
	 *
	 * @param bos the output stream to write to
	 * @param value the number to write as an int32
	 */
	function writeInt32(bos, value) {
	    /* tslint:disable-next-line:no-bitwise */
	    while ((value & ~0x7F) !== 0) {
	        /* tslint:disable-next-line:no-bitwise */
	        bos.write((value & 0x7F) | 0x80);
	        /* tslint:disable-next-line:no-bitwise */
	        value = value >>> 7;
	    }
	    bos.write(value);
	}
	exports.writeInt32 = writeInt32;
	/**
	 * Write a single signed byte
	 *
	 * @param bos the output stream to write to
	 * @param value the byte value to write. Must be between 0 and 255
	 */
	function writeByte(bos, value) {
	    bos.write(value);
	}
	exports.writeByte = writeByte;
	/**
	 * Read bytes as a Buffer
	 *
	 * @param bis the input stream to read from
	 * @returns the bytes that were read
	 */
	function readBytes(bis) {
	    var length = readInt32(bis);
	    return bis.readMany(length);
	}
	exports.readBytes = readBytes;
	/**
	 * Write multiple bytes
	 *
	 * @param bos the output stream to write to
	 * @param value the bytes to be written
	 */
	function writeBytes(bos, value) {
	    writeInt32(bos, value.length);
	    bos.writeMany(value);
	}
	exports.writeBytes = writeBytes;
	/**
	 * Read a UTF-8 encoded String
	 *
	 * @param bis the input stream to read from
	 * @returns the string that was read
	 */
	function readString(bis) {
	    var buffer = readBytes(bis);
	    return buffer ? buffer.toString('utf8') : '';
	}
	exports.readString = readString;
	/**
	 * Write a string using UTF-8 encoding
	 *
	 * @param bos the output stream to write to
	 * @param value the string to write
	 */
	function writeString(bos, value) {
	    writeBytes(bos, Buffer.from(value, 'utf8'));
	}
	exports.writeString = writeString;
	/**
	 * Write a collection of objects, using a specific writer function
	 *
	 * @param bos the output stream to write to
	 * @param arr array of values
	 * @param write writer function
	 * @param <T> the type of data in the collection
	 */
	function writeCollection(bos, arr, write) {
	    var e_1, _a;
	    writeInt32(bos, arr.length);
	    try {
	        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
	            var val = arr_1_1.value;
	            write(bos, val);
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	exports.writeCollection = writeCollection;
	/**
	 * Read a collection of objects, using a specific reader function
	 *
	 * @param bis the input stream to read from
	 * @param read the reader function
	 * @returns an array of read values
	 * @param <T> the type of data in the collection
	 */
	function readCollection(bis, read) {
	    var length = readInt32(bis);
	    var arr = [];
	    for (var i = 0; i < length; ++i) {
	        arr.push(read(bis));
	    }
	    return arr;
	}
	exports.readCollection = readCollection;
	/**
	 * Read a dictionary of strings and values of a given type
	 *
	 * @param bis the input stream to read from
	 * @param read value reader function
	 * @returns a dictionary of values
	 * @param <T> the type of data stored in the dictionary
	 */
	function readDictionary(bis, read) {
	    return readObject(bis, readString, read);
	}
	exports.readDictionary = readDictionary;
	/**
	 * Write a dictionary of strings and values
	 *
	 * @param bos the output stream to write to
	 * @param dict the dictionary of values
	 * @param write value writer function
	 * @param <T> the type of data stored in the dictionary
	 */
	function writeDictionary(bos, dict, write) {
	    writeObject(bos, dict, writeString, write);
	}
	exports.writeDictionary = writeDictionary;
	/**
	 * Write an object of keys/values
	 *
	 * @param bos the output stream to write to
	 * @param dict the map of values
	 * @param keyWriter the Key writer function
	 * @param valueWriter the Value writer function
	 * @param <T> the type of data stored in the object
	 * @param <K> the type of the object keys
	 */
	function writeObject(bos, dict, keyWriter, valueWriter) {
	    var e_2, _a;
	    writeInt32(bos, Object.keys(dict).length);
	    try {
	        for (var _b = __values(Object.getOwnPropertyNames(dict)), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var k = _c.value;
	            keyWriter(bos, k);
	            valueWriter(bos, dict[k]);
	        }
	    }
	    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_2) throw e_2.error; }
	    }
	}
	exports.writeObject = writeObject;
	/**
	 * Read a map of keys/values as an object
	 *
	 * @param bos the output stream to write to
	 * @param keyReader the key reader function
	 * @param valueReader the Value reader function
	 * @returns the read map
	 * @param <T> the type of data stored in the object
	 * @param <K> the type of the object keys
	 */
	function readObject(bis, keyReader, valueReader) {
	    var length = readInt32(bis);
	    var dict = {};
	    for (var i = 0; i < length; ++i) {
	        var k = keyReader(bis);
	        dict[k] = valueReader(bis);
	    }
	    return dict;
	}
	exports.readObject = readObject;
	/**
	 * Read a map of keys/values
	 *
	 * @param bos the output stream to write to
	 * @param keyReader the key reader function
	 * @param valueReader the Value reader function
	 * @returns the read map
	 * @param <T> the type of data stored in the map
	 * @param <K> the type of the map keys
	 */
	function readMap(bis, keyReader, valueReader) {
	    var length = readInt32(bis);
	    var map = new Map();
	    for (var i = 0; i < length; ++i) {
	        var k = keyReader(bis);
	        map.set(k, valueReader(bis));
	    }
	    return map;
	}
	exports.readMap = readMap;
	/**
	 * Write an object of keys/values
	 *
	 * @param bos the output stream to write to
	 * @param dict the map of values
	 * @param keyWriter the Key writer function
	 * @param valueWriter the Value writer function
	 * @param <T> the type of data stored in the map
	 * @param <K> the type of the map keys
	 */
	function writeMap(bos, map, keyWriter, valueWriter) {
	    writeInt32(bos, map.size);
	    map.forEach(function (v, k) {
	        keyWriter(bos, k);
	        valueWriter(bos, v);
	    });
	}
	exports.writeMap = writeMap;
	/**
	 * Read a boolean value
	 *
	 * @param bis the input stream to read from
	 * @returns the boolean that was read
	 */
	function readBoolean(bis) {
	    var b = bis.readInt8();
	    return (b !== 0);
	}
	exports.readBoolean = readBoolean;
	/**
	 * Write a boolean value
	 *
	 * @param bos the output stream to write to
	 * @param value the boolean value to write
	 */
	function writeBoolean(bos, value) {
	    bos.writeInt8(value ? 1 : 0);
	}
	exports.writeBoolean = writeBoolean;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An abstract serialiser that implements {@link Serialiser.read} and
	 * {@link Serialiser.write} withe methods that throw an error.
	 */
	var AbstractSerialiser = /** @class */ (function () {
	    function AbstractSerialiser() {
	    }
	    /**
	     * @inheritdoc
	     *
	     * @throws not implemented error
	     */
	    AbstractSerialiser.prototype.read = function (bis) {
	        throw new Error('AbstractSerialiser#read is not implemented');
	    };
	    /**
	     * @inheritdoc
	     *
	     * @throws not implemented error
	     */
	    AbstractSerialiser.prototype.write = function (bos, val) {
	        throw new Error('AbstractSerialiser#write is not implemented');
	    };
	    return AbstractSerialiser;
	}());
	exports.AbstractSerialiser = AbstractSerialiser;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var getOwnPropertyDescriptor = __webpack_require__(218).f;
	var createNonEnumerableProperty = __webpack_require__(98);
	var redefine = __webpack_require__(99);
	var setGlobal = __webpack_require__(314);
	var copyConstructorProperties = __webpack_require__(1048);
	var isForced = __webpack_require__(217);
	
	/*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/
	module.exports = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global;
	  } else if (STATIC) {
	    target = global[TARGET] || setGlobal(TARGET, {});
	  } else {
	    target = (global[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.noTargetGet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty === typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    // extend global
	    redefine(target, key, sourceProperty, options);
	  }
	};


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	module.exports = function (it) {
	  if (!isObject(it)) {
	    throw TypeError(String(it) + ' is not an object');
	  } return it;
	};


/***/ }),
/* 14 */
95,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var isArrayIteratorMethod = __webpack_require__(470);
	var toLength = __webpack_require__(38);
	var bind = __webpack_require__(32);
	var getIteratorMethod = __webpack_require__(309);
	var callWithSafeIterationClosing = __webpack_require__(456);
	
	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};
	
	var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
	  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
	  var iterator, iterFn, index, length, result, next, step;
	
	  if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = toLength(iterable.length); length > index; index++) {
	        result = AS_ENTRIES
	          ? boundFunction(anObject(step = iterable[index])[0], step[1])
	          : boundFunction(iterable[index]);
	        if (result && result instanceof Result) return result;
	      } return new Result(false);
	    }
	    iterator = iterFn.call(iterable);
	  }
	
	  next = iterator.next;
	  while (!(step = next.call(iterator)).done) {
	    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
	    if (typeof result == 'object' && result && result instanceof Result) return result;
	  } return new Result(false);
	};
	
	iterate.stop = function (result) {
	  return new Result(true, result);
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Util.Logger
	 *
	 * @brief Verbose logging output
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger = __webpack_require__(1157);
	/**
	 * An enum for the available logging functions
	 *
	 * This is identical to {@link LogLevel} but without the `silent` value
	 */
	var LoggingLevel;
	(function (LoggingLevel) {
	    LoggingLevel["trace"] = "trace";
	    LoggingLevel["debug"] = "debug";
	    LoggingLevel["info"] = "info";
	    LoggingLevel["warn"] = "warn";
	    LoggingLevel["error"] = "error";
	})(LoggingLevel = exports.LoggingLevel || (exports.LoggingLevel = {}));
	/**
	 * Verbose logging output
	 *
	 * Adds date, level information and prfix information to logging output
	 *
	 * @param  level  the logging level
	 * @param  prefix the prefix
	 * @return        a logging function that writes verbose output
	 */
	function log(level, prefix) {
	    var c = '|' + level.toUpperCase() + '|' + prefix + '|';
	    var now = function () { return (new Date()); };
	    return function (msg, arg) {
	        if (arg) {
	            logger[level](now() + c + msg, arg);
	        }
	        else {
	            logger[level](now() + c + msg);
	        }
	    };
	}
	/**
	 * Create a {@link Logger} with a given prefix
	 *
	 * @param  prefix the prefix
	 * @return        a newly created {@link Logger} that contains a writer for each
	 *                log level
	 */
	function create(prefix) {
	    var e_1, _a;
	    var l = {};
	    try {
	        for (var _b = __values(Object.keys(LoggingLevel)), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var level = _c.value;
	            l[level] = log(level, prefix);
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return l;
	}
	exports.create = create;
	/**
	 * Disables logging below the given level.
	 *
	 * Export is forwarded from `loglevel.setLevel`.
	 * @see https://www.npmjs.com/package/loglevel
	 */
	exports.setLevel = logger.setLevel;


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(781)
	var ieee754 = __webpack_require__(1497)
	var isArray = __webpack_require__(783)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') {
	    throw TypeError(String(it) + ' is not a function');
	  } return it;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Check
	 *
	 * @brief Utility functions for checking arguments
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Throw an error if the checked value is null/undefined.
	 *
	 * @param value the value to check
	 * @param what  description to include in thrown error
	 * @returns     the checked value
	 * @throws      an error if value is null or undefined
	 */
	function requireNonNull(value, what) {
	    if (value === undefined || value === null) {
	        throw new Error(what + ' is null');
	    }
	    return value;
	}
	exports.requireNonNull = requireNonNull;


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Read an enum from a Buffer stream
	 *
	 * @param  input     the stream from which to read the enum value
	 * @param  enumType  the enum type
	 * @return           the value read from the stream if it is a valid enum value
	 *
	 * @throws an error if the value read is not a valid enum value
	 */
	function read(input, enumType) {
	    var e = Codec.readByte(input);
	    if (enumType[e] === undefined) {
	        throw new Error('Unable to decode enum value ' + e);
	    }
	    // reverse lookup, then forward lookup
	    // for enum-like objects storing  objects with id, this returns the object instead of the id
	    return enumType[enumType[e]];
	}
	exports.read = read;
	/**
	 * Write an enum to a Buffer stream
	 *
	 * @param  output   the stream to which to write the enum value
	 * @param  val      the numeric enum value or an object that contains the enum value
	 *                  as `id` property
	 */
	function write(output, val) {
	    if (typeof val === 'number') {
	        Codec.writeByte(output, val);
	    }
	    else {
	        Codec.writeByte(output, val.id);
	    }
	}
	exports.write = write;


/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
	  return it && it.Math == Math && it;
	};
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	module.exports =
	  // eslint-disable-next-line no-undef
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  check(typeof self == 'object' && self) ||
	  check(typeof global == 'object' && global) ||
	  // eslint-disable-next-line no-new-func
	  Function('return this')();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21);
	
	// optional / simple context binding
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 0: return function () {
	      return fn.call(that);
	    };
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Request type enum
	 */
	var GatewayRequestType;
	(function (GatewayRequestType) {
	    // Whole client
	    GatewayRequestType[GatewayRequestType["GET_CONFIGURATION"] = 1] = "GET_CONFIGURATION";
	    GatewayRequestType[GatewayRequestType["GET_STATUS"] = 2] = "GET_STATUS";
	    GatewayRequestType[GatewayRequestType["GET_OPERATIONS"] = 3] = "GET_OPERATIONS";
	    GatewayRequestType[GatewayRequestType["GET_OPERATION_DETAIL"] = 4] = "GET_OPERATION_DETAIL";
	    GatewayRequestType[GatewayRequestType["INVOKE_OPERATION"] = 5] = "INVOKE_OPERATION";
	    // Services
	    GatewayRequestType[GatewayRequestType["ADD_SERVICE"] = 6] = "ADD_SERVICE";
	    GatewayRequestType[GatewayRequestType["UPDATE_SERVICE"] = 7] = "UPDATE_SERVICE";
	    GatewayRequestType[GatewayRequestType["REMOVE_SERVICE"] = 8] = "REMOVE_SERVICE";
	    GatewayRequestType[GatewayRequestType["GET_SERVICES"] = 9] = "GET_SERVICES";
	    GatewayRequestType[GatewayRequestType["GET_SERVICE_TYPES"] = 10] = "GET_SERVICE_TYPES";
	    GatewayRequestType[GatewayRequestType["GET_SERVICE_CONFIGURATION"] = 11] = "GET_SERVICE_CONFIGURATION";
	    GatewayRequestType[GatewayRequestType["GET_SERVICE_STATUS"] = 12] = "GET_SERVICE_STATUS";
	    GatewayRequestType[GatewayRequestType["GET_SERVICE_OPERATIONS"] = 13] = "GET_SERVICE_OPERATIONS";
	    GatewayRequestType[GatewayRequestType["GET_SERVICE_OPERATION_DETAIL"] = 14] = "GET_SERVICE_OPERATION_DETAIL";
	    GatewayRequestType[GatewayRequestType["INVOKE_SERVICE_OPERATION"] = 15] = "INVOKE_SERVICE_OPERATION";
	})(GatewayRequestType = exports.GatewayRequestType || (exports.GatewayRequestType = {}));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var path = __webpack_require__(122);
	var global = __webpack_require__(27);
	
	var aFunction = function (variable) {
	  return typeof variable == 'function' ? variable : undefined;
	};
	
	module.exports = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
	    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var shared = __webpack_require__(484);
	var has = __webpack_require__(58);
	var uid = __webpack_require__(319);
	var NATIVE_SYMBOL = __webpack_require__(475);
	var USE_SYMBOL_AS_UID = __webpack_require__(1066);
	
	var WellKnownSymbolsStore = shared('wks');
	var Symbol = global.Symbol;
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;
	
	module.exports = function (name) {
	  if (!has(WellKnownSymbolsStore, name)) {
	    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
	    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Conversation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var conversation_id_1 = __webpack_require__(124);
	/**
	 * A Serialiser for {@link ConversationId}s
	 */
	var CIDSerialiserClass = /** @class */ (function () {
	    function CIDSerialiserClass() {
	    }
	    /**
	     * @inheritdoc
	     */
	    CIDSerialiserClass.prototype.read = function (bis) {
	        return new conversation_id_1.ConversationId(Codec.readInt64(bis));
	    };
	    /**
	     * @inheritdoc
	     */
	    CIDSerialiserClass.prototype.write = function (bos, cid) {
	        Codec.writeInt64(bos, cid.val);
	    };
	    return CIDSerialiserClass;
	}());
	exports.CIDSerialiserClass = CIDSerialiserClass;
	/**
	 * The {@link CIDSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CIDSerialiser = new CIDSerialiserClass();


/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(87);
	
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.github.io/ecma262/#sec-tolength
	module.exports = function (argument) {
	  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(579);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var fails = __webpack_require__(31);
	var has = __webpack_require__(58);
	
	var defineProperty = Object.defineProperty;
	var cache = {};
	
	var thrower = function (it) { throw it; };
	
	module.exports = function (METHOD_NAME, options) {
	  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
	  if (!options) options = {};
	  var method = [][METHOD_NAME];
	  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
	  var argument0 = has(options, 0) ? options[0] : thrower;
	  var argument1 = has(options, 1) ? options[1] : undefined;
	
	  return cache[METHOD_NAME] = !!method && !fails(function () {
	    if (ACCESSORS && !DESCRIPTORS) return true;
	    var O = { length: -1 };
	
	    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
	    else O[1] = 1;
	
	    method.call(O, argument0, argument1);
	  });
	};


/***/ }),
/* 43 */
20,
/* 44 */
/***/ (function(module, exports) {

	module.exports = Long;
	
	/**
	 * wasm optimizations, to do native i64 multiplication and divide
	 */
	var wasm = null;
	
	try {
	  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
	    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
	  ])), {}).exports;
	} catch (e) {
	  // no wasm support :(
	}
	
	/**
	 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
	 *  See the from* functions below for more convenient ways of constructing Longs.
	 * @exports Long
	 * @class A Long class for representing a 64 bit two's-complement integer value.
	 * @param {number} low The low (signed) 32 bits of the long
	 * @param {number} high The high (signed) 32 bits of the long
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @constructor
	 */
	function Long(low, high, unsigned) {
	
	    /**
	     * The low 32 bits as a signed value.
	     * @type {number}
	     */
	    this.low = low | 0;
	
	    /**
	     * The high 32 bits as a signed value.
	     * @type {number}
	     */
	    this.high = high | 0;
	
	    /**
	     * Whether unsigned or not.
	     * @type {boolean}
	     */
	    this.unsigned = !!unsigned;
	}
	
	// The internal representation of a long is the two given signed, 32-bit values.
	// We use 32-bit pieces because these are the size of integers on which
	// Javascript performs bit-operations.  For operations like addition and
	// multiplication, we split each number into 16 bit pieces, which can easily be
	// multiplied within Javascript's floating-point representation without overflow
	// or change in sign.
	//
	// In the algorithms below, we frequently reduce the negative case to the
	// positive case by negating the input(s) and then post-processing the result.
	// Note that we must ALWAYS check specially whether those values are MIN_VALUE
	// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
	// a positive number, it overflows back into a negative).  Not handling this
	// case would often result in infinite recursion.
	//
	// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
	// methods on which they depend.
	
	/**
	 * An indicator used to reliably determine if an object is a Long or not.
	 * @type {boolean}
	 * @const
	 * @private
	 */
	Long.prototype.__isLong__;
	
	Object.defineProperty(Long.prototype, "__isLong__", { value: true });
	
	/**
	 * @function
	 * @param {*} obj Object
	 * @returns {boolean}
	 * @inner
	 */
	function isLong(obj) {
	    return (obj && obj["__isLong__"]) === true;
	}
	
	/**
	 * Tests if the specified object is a Long.
	 * @function
	 * @param {*} obj Object
	 * @returns {boolean}
	 */
	Long.isLong = isLong;
	
	/**
	 * A cache of the Long representations of small integer values.
	 * @type {!Object}
	 * @inner
	 */
	var INT_CACHE = {};
	
	/**
	 * A cache of the Long representations of small unsigned integer values.
	 * @type {!Object}
	 * @inner
	 */
	var UINT_CACHE = {};
	
	/**
	 * @param {number} value
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromInt(value, unsigned) {
	    var obj, cachedObj, cache;
	    if (unsigned) {
	        value >>>= 0;
	        if (cache = (0 <= value && value < 256)) {
	            cachedObj = UINT_CACHE[value];
	            if (cachedObj)
	                return cachedObj;
	        }
	        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
	        if (cache)
	            UINT_CACHE[value] = obj;
	        return obj;
	    } else {
	        value |= 0;
	        if (cache = (-128 <= value && value < 128)) {
	            cachedObj = INT_CACHE[value];
	            if (cachedObj)
	                return cachedObj;
	        }
	        obj = fromBits(value, value < 0 ? -1 : 0, false);
	        if (cache)
	            INT_CACHE[value] = obj;
	        return obj;
	    }
	}
	
	/**
	 * Returns a Long representing the given 32 bit integer value.
	 * @function
	 * @param {number} value The 32 bit integer in question
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromInt = fromInt;
	
	/**
	 * @param {number} value
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromNumber(value, unsigned) {
	    if (isNaN(value))
	        return unsigned ? UZERO : ZERO;
	    if (unsigned) {
	        if (value < 0)
	            return UZERO;
	        if (value >= TWO_PWR_64_DBL)
	            return MAX_UNSIGNED_VALUE;
	    } else {
	        if (value <= -TWO_PWR_63_DBL)
	            return MIN_VALUE;
	        if (value + 1 >= TWO_PWR_63_DBL)
	            return MAX_VALUE;
	    }
	    if (value < 0)
	        return fromNumber(-value, unsigned).neg();
	    return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
	}
	
	/**
	 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
	 * @function
	 * @param {number} value The number in question
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromNumber = fromNumber;
	
	/**
	 * @param {number} lowBits
	 * @param {number} highBits
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromBits(lowBits, highBits, unsigned) {
	    return new Long(lowBits, highBits, unsigned);
	}
	
	/**
	 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
	 *  assumed to use 32 bits.
	 * @function
	 * @param {number} lowBits The low 32 bits
	 * @param {number} highBits The high 32 bits
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromBits = fromBits;
	
	/**
	 * @function
	 * @param {number} base
	 * @param {number} exponent
	 * @returns {number}
	 * @inner
	 */
	var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
	
	/**
	 * @param {string} str
	 * @param {(boolean|number)=} unsigned
	 * @param {number=} radix
	 * @returns {!Long}
	 * @inner
	 */
	function fromString(str, unsigned, radix) {
	    if (str.length === 0)
	        throw Error('empty string');
	    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
	        return ZERO;
	    if (typeof unsigned === 'number') {
	        // For goog.math.long compatibility
	        radix = unsigned,
	        unsigned = false;
	    } else {
	        unsigned = !! unsigned;
	    }
	    radix = radix || 10;
	    if (radix < 2 || 36 < radix)
	        throw RangeError('radix');
	
	    var p;
	    if ((p = str.indexOf('-')) > 0)
	        throw Error('interior hyphen');
	    else if (p === 0) {
	        return fromString(str.substring(1), unsigned, radix).neg();
	    }
	
	    // Do several (8) digits each time through the loop, so as to
	    // minimize the calls to the very expensive emulated div.
	    var radixToPower = fromNumber(pow_dbl(radix, 8));
	
	    var result = ZERO;
	    for (var i = 0; i < str.length; i += 8) {
	        var size = Math.min(8, str.length - i),
	            value = parseInt(str.substring(i, i + size), radix);
	        if (size < 8) {
	            var power = fromNumber(pow_dbl(radix, size));
	            result = result.mul(power).add(fromNumber(value));
	        } else {
	            result = result.mul(radixToPower);
	            result = result.add(fromNumber(value));
	        }
	    }
	    result.unsigned = unsigned;
	    return result;
	}
	
	/**
	 * Returns a Long representation of the given string, written using the specified radix.
	 * @function
	 * @param {string} str The textual representation of the Long
	 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
	 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromString = fromString;
	
	/**
	 * @function
	 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromValue(val, unsigned) {
	    if (typeof val === 'number')
	        return fromNumber(val, unsigned);
	    if (typeof val === 'string')
	        return fromString(val, unsigned);
	    // Throws for non-objects, converts non-instanceof Long:
	    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
	}
	
	/**
	 * Converts the specified value to a Long using the appropriate from* function for its type.
	 * @function
	 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long}
	 */
	Long.fromValue = fromValue;
	
	// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
	// no runtime penalty for these.
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_16_DBL = 1 << 16;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_24_DBL = 1 << 24;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
	
	/**
	 * @type {!Long}
	 * @const
	 * @inner
	 */
	var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var ZERO = fromInt(0);
	
	/**
	 * Signed zero.
	 * @type {!Long}
	 */
	Long.ZERO = ZERO;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var UZERO = fromInt(0, true);
	
	/**
	 * Unsigned zero.
	 * @type {!Long}
	 */
	Long.UZERO = UZERO;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var ONE = fromInt(1);
	
	/**
	 * Signed one.
	 * @type {!Long}
	 */
	Long.ONE = ONE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var UONE = fromInt(1, true);
	
	/**
	 * Unsigned one.
	 * @type {!Long}
	 */
	Long.UONE = UONE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var NEG_ONE = fromInt(-1);
	
	/**
	 * Signed negative one.
	 * @type {!Long}
	 */
	Long.NEG_ONE = NEG_ONE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);
	
	/**
	 * Maximum signed value.
	 * @type {!Long}
	 */
	Long.MAX_VALUE = MAX_VALUE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);
	
	/**
	 * Maximum unsigned value.
	 * @type {!Long}
	 */
	Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var MIN_VALUE = fromBits(0, 0x80000000|0, false);
	
	/**
	 * Minimum signed value.
	 * @type {!Long}
	 */
	Long.MIN_VALUE = MIN_VALUE;
	
	/**
	 * @alias Long.prototype
	 * @inner
	 */
	var LongPrototype = Long.prototype;
	
	/**
	 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
	 * @returns {number}
	 */
	LongPrototype.toInt = function toInt() {
	    return this.unsigned ? this.low >>> 0 : this.low;
	};
	
	/**
	 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
	 * @returns {number}
	 */
	LongPrototype.toNumber = function toNumber() {
	    if (this.unsigned)
	        return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
	    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
	};
	
	/**
	 * Converts the Long to a string written in the specified radix.
	 * @param {number=} radix Radix (2-36), defaults to 10
	 * @returns {string}
	 * @override
	 * @throws {RangeError} If `radix` is out of range
	 */
	LongPrototype.toString = function toString(radix) {
	    radix = radix || 10;
	    if (radix < 2 || 36 < radix)
	        throw RangeError('radix');
	    if (this.isZero())
	        return '0';
	    if (this.isNegative()) { // Unsigned Longs are never negative
	        if (this.eq(MIN_VALUE)) {
	            // We need to change the Long value before it can be negated, so we remove
	            // the bottom-most digit in this base and then recurse to do the rest.
	            var radixLong = fromNumber(radix),
	                div = this.div(radixLong),
	                rem1 = div.mul(radixLong).sub(this);
	            return div.toString(radix) + rem1.toInt().toString(radix);
	        } else
	            return '-' + this.neg().toString(radix);
	    }
	
	    // Do several (6) digits each time through the loop, so as to
	    // minimize the calls to the very expensive emulated div.
	    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
	        rem = this;
	    var result = '';
	    while (true) {
	        var remDiv = rem.div(radixToPower),
	            intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
	            digits = intval.toString(radix);
	        rem = remDiv;
	        if (rem.isZero())
	            return digits + result;
	        else {
	            while (digits.length < 6)
	                digits = '0' + digits;
	            result = '' + digits + result;
	        }
	    }
	};
	
	/**
	 * Gets the high 32 bits as a signed integer.
	 * @returns {number} Signed high bits
	 */
	LongPrototype.getHighBits = function getHighBits() {
	    return this.high;
	};
	
	/**
	 * Gets the high 32 bits as an unsigned integer.
	 * @returns {number} Unsigned high bits
	 */
	LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
	    return this.high >>> 0;
	};
	
	/**
	 * Gets the low 32 bits as a signed integer.
	 * @returns {number} Signed low bits
	 */
	LongPrototype.getLowBits = function getLowBits() {
	    return this.low;
	};
	
	/**
	 * Gets the low 32 bits as an unsigned integer.
	 * @returns {number} Unsigned low bits
	 */
	LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
	    return this.low >>> 0;
	};
	
	/**
	 * Gets the number of bits needed to represent the absolute value of this Long.
	 * @returns {number}
	 */
	LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
	    if (this.isNegative()) // Unsigned Longs are never negative
	        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
	    var val = this.high != 0 ? this.high : this.low;
	    for (var bit = 31; bit > 0; bit--)
	        if ((val & (1 << bit)) != 0)
	            break;
	    return this.high != 0 ? bit + 33 : bit + 1;
	};
	
	/**
	 * Tests if this Long's value equals zero.
	 * @returns {boolean}
	 */
	LongPrototype.isZero = function isZero() {
	    return this.high === 0 && this.low === 0;
	};
	
	/**
	 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
	 * @returns {boolean}
	 */
	LongPrototype.eqz = LongPrototype.isZero;
	
	/**
	 * Tests if this Long's value is negative.
	 * @returns {boolean}
	 */
	LongPrototype.isNegative = function isNegative() {
	    return !this.unsigned && this.high < 0;
	};
	
	/**
	 * Tests if this Long's value is positive.
	 * @returns {boolean}
	 */
	LongPrototype.isPositive = function isPositive() {
	    return this.unsigned || this.high >= 0;
	};
	
	/**
	 * Tests if this Long's value is odd.
	 * @returns {boolean}
	 */
	LongPrototype.isOdd = function isOdd() {
	    return (this.low & 1) === 1;
	};
	
	/**
	 * Tests if this Long's value is even.
	 * @returns {boolean}
	 */
	LongPrototype.isEven = function isEven() {
	    return (this.low & 1) === 0;
	};
	
	/**
	 * Tests if this Long's value equals the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.equals = function equals(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
	        return false;
	    return this.high === other.high && this.low === other.low;
	};
	
	/**
	 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.eq = LongPrototype.equals;
	
	/**
	 * Tests if this Long's value differs from the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.notEquals = function notEquals(other) {
	    return !this.eq(/* validates */ other);
	};
	
	/**
	 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.neq = LongPrototype.notEquals;
	
	/**
	 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.ne = LongPrototype.notEquals;
	
	/**
	 * Tests if this Long's value is less than the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lessThan = function lessThan(other) {
	    return this.comp(/* validates */ other) < 0;
	};
	
	/**
	 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lt = LongPrototype.lessThan;
	
	/**
	 * Tests if this Long's value is less than or equal the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
	    return this.comp(/* validates */ other) <= 0;
	};
	
	/**
	 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lte = LongPrototype.lessThanOrEqual;
	
	/**
	 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.le = LongPrototype.lessThanOrEqual;
	
	/**
	 * Tests if this Long's value is greater than the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.greaterThan = function greaterThan(other) {
	    return this.comp(/* validates */ other) > 0;
	};
	
	/**
	 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.gt = LongPrototype.greaterThan;
	
	/**
	 * Tests if this Long's value is greater than or equal the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
	    return this.comp(/* validates */ other) >= 0;
	};
	
	/**
	 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.gte = LongPrototype.greaterThanOrEqual;
	
	/**
	 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.ge = LongPrototype.greaterThanOrEqual;
	
	/**
	 * Compares this Long's value with the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	 *  if the given one is greater
	 */
	LongPrototype.compare = function compare(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    if (this.eq(other))
	        return 0;
	    var thisNeg = this.isNegative(),
	        otherNeg = other.isNegative();
	    if (thisNeg && !otherNeg)
	        return -1;
	    if (!thisNeg && otherNeg)
	        return 1;
	    // At this point the sign bits are the same
	    if (!this.unsigned)
	        return this.sub(other).isNegative() ? -1 : 1;
	    // Both are positive if at least one is unsigned
	    return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
	};
	
	/**
	 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	 *  if the given one is greater
	 */
	LongPrototype.comp = LongPrototype.compare;
	
	/**
	 * Negates this Long's value.
	 * @returns {!Long} Negated Long
	 */
	LongPrototype.negate = function negate() {
	    if (!this.unsigned && this.eq(MIN_VALUE))
	        return MIN_VALUE;
	    return this.not().add(ONE);
	};
	
	/**
	 * Negates this Long's value. This is an alias of {@link Long#negate}.
	 * @function
	 * @returns {!Long} Negated Long
	 */
	LongPrototype.neg = LongPrototype.negate;
	
	/**
	 * Returns the sum of this and the specified Long.
	 * @param {!Long|number|string} addend Addend
	 * @returns {!Long} Sum
	 */
	LongPrototype.add = function add(addend) {
	    if (!isLong(addend))
	        addend = fromValue(addend);
	
	    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
	
	    var a48 = this.high >>> 16;
	    var a32 = this.high & 0xFFFF;
	    var a16 = this.low >>> 16;
	    var a00 = this.low & 0xFFFF;
	
	    var b48 = addend.high >>> 16;
	    var b32 = addend.high & 0xFFFF;
	    var b16 = addend.low >>> 16;
	    var b00 = addend.low & 0xFFFF;
	
	    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
	    c00 += a00 + b00;
	    c16 += c00 >>> 16;
	    c00 &= 0xFFFF;
	    c16 += a16 + b16;
	    c32 += c16 >>> 16;
	    c16 &= 0xFFFF;
	    c32 += a32 + b32;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c48 += a48 + b48;
	    c48 &= 0xFFFF;
	    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
	};
	
	/**
	 * Returns the difference of this and the specified Long.
	 * @param {!Long|number|string} subtrahend Subtrahend
	 * @returns {!Long} Difference
	 */
	LongPrototype.subtract = function subtract(subtrahend) {
	    if (!isLong(subtrahend))
	        subtrahend = fromValue(subtrahend);
	    return this.add(subtrahend.neg());
	};
	
	/**
	 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
	 * @function
	 * @param {!Long|number|string} subtrahend Subtrahend
	 * @returns {!Long} Difference
	 */
	LongPrototype.sub = LongPrototype.subtract;
	
	/**
	 * Returns the product of this and the specified Long.
	 * @param {!Long|number|string} multiplier Multiplier
	 * @returns {!Long} Product
	 */
	LongPrototype.multiply = function multiply(multiplier) {
	    if (this.isZero())
	        return ZERO;
	    if (!isLong(multiplier))
	        multiplier = fromValue(multiplier);
	
	    // use wasm support if present
	    if (wasm) {
	        var low = wasm.mul(this.low,
	                           this.high,
	                           multiplier.low,
	                           multiplier.high);
	        return fromBits(low, wasm.get_high(), this.unsigned);
	    }
	
	    if (multiplier.isZero())
	        return ZERO;
	    if (this.eq(MIN_VALUE))
	        return multiplier.isOdd() ? MIN_VALUE : ZERO;
	    if (multiplier.eq(MIN_VALUE))
	        return this.isOdd() ? MIN_VALUE : ZERO;
	
	    if (this.isNegative()) {
	        if (multiplier.isNegative())
	            return this.neg().mul(multiplier.neg());
	        else
	            return this.neg().mul(multiplier).neg();
	    } else if (multiplier.isNegative())
	        return this.mul(multiplier.neg()).neg();
	
	    // If both longs are small, use float multiplication
	    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
	        return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
	
	    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
	    // We can skip products that would overflow.
	
	    var a48 = this.high >>> 16;
	    var a32 = this.high & 0xFFFF;
	    var a16 = this.low >>> 16;
	    var a00 = this.low & 0xFFFF;
	
	    var b48 = multiplier.high >>> 16;
	    var b32 = multiplier.high & 0xFFFF;
	    var b16 = multiplier.low >>> 16;
	    var b00 = multiplier.low & 0xFFFF;
	
	    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
	    c00 += a00 * b00;
	    c16 += c00 >>> 16;
	    c00 &= 0xFFFF;
	    c16 += a16 * b00;
	    c32 += c16 >>> 16;
	    c16 &= 0xFFFF;
	    c16 += a00 * b16;
	    c32 += c16 >>> 16;
	    c16 &= 0xFFFF;
	    c32 += a32 * b00;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c32 += a16 * b16;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c32 += a00 * b32;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
	    c48 &= 0xFFFF;
	    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
	};
	
	/**
	 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
	 * @function
	 * @param {!Long|number|string} multiplier Multiplier
	 * @returns {!Long} Product
	 */
	LongPrototype.mul = LongPrototype.multiply;
	
	/**
	 * Returns this Long divided by the specified. The result is signed if this Long is signed or
	 *  unsigned if this Long is unsigned.
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Quotient
	 */
	LongPrototype.divide = function divide(divisor) {
	    if (!isLong(divisor))
	        divisor = fromValue(divisor);
	    if (divisor.isZero())
	        throw Error('division by zero');
	
	    // use wasm support if present
	    if (wasm) {
	        // guard against signed division overflow: the largest
	        // negative number / -1 would be 1 larger than the largest
	        // positive number, due to two's complement.
	        if (!this.unsigned &&
	            this.high === -0x80000000 &&
	            divisor.low === -1 && divisor.high === -1) {
	            // be consistent with non-wasm code path
	            return this;
	        }
	        var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
	            this.low,
	            this.high,
	            divisor.low,
	            divisor.high
	        );
	        return fromBits(low, wasm.get_high(), this.unsigned);
	    }
	
	    if (this.isZero())
	        return this.unsigned ? UZERO : ZERO;
	    var approx, rem, res;
	    if (!this.unsigned) {
	        // This section is only relevant for signed longs and is derived from the
	        // closure library as a whole.
	        if (this.eq(MIN_VALUE)) {
	            if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
	                return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
	            else if (divisor.eq(MIN_VALUE))
	                return ONE;
	            else {
	                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
	                var halfThis = this.shr(1);
	                approx = halfThis.div(divisor).shl(1);
	                if (approx.eq(ZERO)) {
	                    return divisor.isNegative() ? ONE : NEG_ONE;
	                } else {
	                    rem = this.sub(divisor.mul(approx));
	                    res = approx.add(rem.div(divisor));
	                    return res;
	                }
	            }
	        } else if (divisor.eq(MIN_VALUE))
	            return this.unsigned ? UZERO : ZERO;
	        if (this.isNegative()) {
	            if (divisor.isNegative())
	                return this.neg().div(divisor.neg());
	            return this.neg().div(divisor).neg();
	        } else if (divisor.isNegative())
	            return this.div(divisor.neg()).neg();
	        res = ZERO;
	    } else {
	        // The algorithm below has not been made for unsigned longs. It's therefore
	        // required to take special care of the MSB prior to running it.
	        if (!divisor.unsigned)
	            divisor = divisor.toUnsigned();
	        if (divisor.gt(this))
	            return UZERO;
	        if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
	            return UONE;
	        res = UZERO;
	    }
	
	    // Repeat the following until the remainder is less than other:  find a
	    // floating-point that approximates remainder / other *from below*, add this
	    // into the result, and subtract it from the remainder.  It is critical that
	    // the approximate value is less than or equal to the real value so that the
	    // remainder never becomes negative.
	    rem = this;
	    while (rem.gte(divisor)) {
	        // Approximate the result of division. This may be a little greater or
	        // smaller than the actual value.
	        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
	
	        // We will tweak the approximate result by changing it in the 48-th digit or
	        // the smallest non-fractional digit, whichever is larger.
	        var log2 = Math.ceil(Math.log(approx) / Math.LN2),
	            delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),
	
	        // Decrease the approximation until it is smaller than the remainder.  Note
	        // that if it is too large, the product overflows and is negative.
	            approxRes = fromNumber(approx),
	            approxRem = approxRes.mul(divisor);
	        while (approxRem.isNegative() || approxRem.gt(rem)) {
	            approx -= delta;
	            approxRes = fromNumber(approx, this.unsigned);
	            approxRem = approxRes.mul(divisor);
	        }
	
	        // We know the answer can't be zero... and actually, zero would cause
	        // infinite recursion since we would make no progress.
	        if (approxRes.isZero())
	            approxRes = ONE;
	
	        res = res.add(approxRes);
	        rem = rem.sub(approxRem);
	    }
	    return res;
	};
	
	/**
	 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Quotient
	 */
	LongPrototype.div = LongPrototype.divide;
	
	/**
	 * Returns this Long modulo the specified.
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.modulo = function modulo(divisor) {
	    if (!isLong(divisor))
	        divisor = fromValue(divisor);
	
	    // use wasm support if present
	    if (wasm) {
	        var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
	            this.low,
	            this.high,
	            divisor.low,
	            divisor.high
	        );
	        return fromBits(low, wasm.get_high(), this.unsigned);
	    }
	
	    return this.sub(this.div(divisor).mul(divisor));
	};
	
	/**
	 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.mod = LongPrototype.modulo;
	
	/**
	 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.rem = LongPrototype.modulo;
	
	/**
	 * Returns the bitwise NOT of this Long.
	 * @returns {!Long}
	 */
	LongPrototype.not = function not() {
	    return fromBits(~this.low, ~this.high, this.unsigned);
	};
	
	/**
	 * Returns the bitwise AND of this Long and the specified.
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.and = function and(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
	};
	
	/**
	 * Returns the bitwise OR of this Long and the specified.
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.or = function or(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
	};
	
	/**
	 * Returns the bitwise XOR of this Long and the given one.
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.xor = function xor(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
	};
	
	/**
	 * Returns this Long with bits shifted to the left by the given amount.
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftLeft = function shiftLeft(numBits) {
	    if (isLong(numBits))
	        numBits = numBits.toInt();
	    if ((numBits &= 63) === 0)
	        return this;
	    else if (numBits < 32)
	        return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
	    else
	        return fromBits(0, this.low << (numBits - 32), this.unsigned);
	};
	
	/**
	 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shl = LongPrototype.shiftLeft;
	
	/**
	 * Returns this Long with bits arithmetically shifted to the right by the given amount.
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftRight = function shiftRight(numBits) {
	    if (isLong(numBits))
	        numBits = numBits.toInt();
	    if ((numBits &= 63) === 0)
	        return this;
	    else if (numBits < 32)
	        return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
	    else
	        return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
	};
	
	/**
	 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shr = LongPrototype.shiftRight;
	
	/**
	 * Returns this Long with bits logically shifted to the right by the given amount.
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
	    if (isLong(numBits))
	        numBits = numBits.toInt();
	    numBits &= 63;
	    if (numBits === 0)
	        return this;
	    else {
	        var high = this.high;
	        if (numBits < 32) {
	            var low = this.low;
	            return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
	        } else if (numBits === 32)
	            return fromBits(high, 0, this.unsigned);
	        else
	            return fromBits(high >>> (numBits - 32), 0, this.unsigned);
	    }
	};
	
	/**
	 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shru = LongPrototype.shiftRightUnsigned;
	
	/**
	 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
	
	/**
	 * Converts this Long to signed.
	 * @returns {!Long} Signed long
	 */
	LongPrototype.toSigned = function toSigned() {
	    if (!this.unsigned)
	        return this;
	    return fromBits(this.low, this.high, false);
	};
	
	/**
	 * Converts this Long to unsigned.
	 * @returns {!Long} Unsigned long
	 */
	LongPrototype.toUnsigned = function toUnsigned() {
	    if (this.unsigned)
	        return this;
	    return fromBits(this.low, this.high, true);
	};
	
	/**
	 * Converts this Long to its byte representation.
	 * @param {boolean=} le Whether little or big endian, defaults to big endian
	 * @returns {!Array.<number>} Byte representation
	 */
	LongPrototype.toBytes = function toBytes(le) {
	    return le ? this.toBytesLE() : this.toBytesBE();
	};
	
	/**
	 * Converts this Long to its little endian byte representation.
	 * @returns {!Array.<number>} Little endian byte representation
	 */
	LongPrototype.toBytesLE = function toBytesLE() {
	    var hi = this.high,
	        lo = this.low;
	    return [
	        lo        & 0xff,
	        lo >>>  8 & 0xff,
	        lo >>> 16 & 0xff,
	        lo >>> 24       ,
	        hi        & 0xff,
	        hi >>>  8 & 0xff,
	        hi >>> 16 & 0xff,
	        hi >>> 24
	    ];
	};
	
	/**
	 * Converts this Long to its big endian byte representation.
	 * @returns {!Array.<number>} Big endian byte representation
	 */
	LongPrototype.toBytesBE = function toBytesBE() {
	    var hi = this.high,
	        lo = this.low;
	    return [
	        hi >>> 24       ,
	        hi >>> 16 & 0xff,
	        hi >>>  8 & 0xff,
	        hi        & 0xff,
	        lo >>> 24       ,
	        lo >>> 16 & 0xff,
	        lo >>>  8 & 0xff,
	        lo        & 0xff
	    ];
	};
	
	/**
	 * Creates a Long from its byte representation.
	 * @param {!Array.<number>} bytes Byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @param {boolean=} le Whether little or big endian, defaults to big endian
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytes = function fromBytes(bytes, unsigned, le) {
	    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
	};
	
	/**
	 * Creates a Long from its little endian byte representation.
	 * @param {!Array.<number>} bytes Little endian byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
	    return new Long(
	        bytes[0]       |
	        bytes[1] <<  8 |
	        bytes[2] << 16 |
	        bytes[3] << 24,
	        bytes[4]       |
	        bytes[5] <<  8 |
	        bytes[6] << 16 |
	        bytes[7] << 24,
	        unsigned
	    );
	};
	
	/**
	 * Creates a Long from its big endian byte representation.
	 * @param {!Array.<number>} bytes Big endian byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
	    return new Long(
	        bytes[4] << 24 |
	        bytes[5] << 16 |
	        bytes[6] <<  8 |
	        bytes[7],
	        bytes[0] << 24 |
	        bytes[1] << 16 |
	        bytes[2] <<  8 |
	        bytes[3],
	        unsigned
	    );
	};


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !fails(function () {
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
	});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var IE8_DOM_DEFINE = __webpack_require__(467);
	var anObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(221);
	
	var nativeDefineProperty = Object.defineProperty;
	
	// `Object.defineProperty` method
	// https://tc39.github.io/ecma262/#sec-object.defineproperty
	exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return nativeDefineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var requireObjectCoercible = __webpack_require__(170);
	
	// `ToObject` abstract operation
	// https://tc39.github.io/ecma262/#sec-toobject
	module.exports = function (argument) {
	  return Object(requireObjectCoercible(argument));
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable-next-line:variable-name
	exports.NullSerialiser = {
	    read: function () { return null; },
	    write: function () { }
	};


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var wellKnownSymbol = __webpack_require__(35);
	
	var SPECIES = wellKnownSymbol('species');
	
	// `SpeciesConstructor` abstract operation
	// https://tc39.github.io/ecma262/#sec-speciesconstructor
	module.exports = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of the {@link Stream} interface.
	 *
	 * @inheritdoc
	 */
	var StreamImpl = /** @class */ (function () {
	    /**
	     * Create a new `Stream` object
	     *
	     * @param  listeners the listeners that will be attached to this stream
	     * @param  error     a callback to call in the case of an error
	     * @param  close     a callback to call when the stream is closed
	     * @param  events    a list of allowed event names. If `events` is not specified
	     *                   then any events are allowed in the `on` and `off`
	     *                   methods. If events are specified, then any event
	     *                   listener will be checked agains the list of allowed
	     *                   events. The events `close`, `error`, and `complete` are
	     *                   always allowed because they are used by {@link Stream}
	     *                   and {@link Result} internally.
	     */
	    function StreamImpl(helper, events) {
	        this.listeners = helper.getListeners();
	        this.errorCallback = helper.getErrorCallback();
	        this.closeCallback = helper.getCloseCallback();
	        if (events) {
	            this.allowedEvents = ['close', 'error', 'complete'].concat(events);
	        }
	    }
	    /**
	     * @inheritdoc
	     */
	    StreamImpl.prototype.on = function (events, listener) {
	        this.attach(events, listener);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    StreamImpl.prototype.off = function (events, listener) {
	        this.remove(events, listener);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     *
	     * Will cause `closeCallback` to be called.
	     *
	     * @param reason the reason for closing the stream. This can be of any type.
	     *               The type of the close reason should be documented in the
	     *               class extending StreamImpl.
	     */
	    StreamImpl.prototype.close = function (reason) {
	        this.closeCallback(reason);
	        return this;
	    };
	    /**
	     * Close the stream. This will emit a 'close' event to any assigned listeners.
	     * No further events will be emitted.
	     */
	    StreamImpl.prototype.error = function (reason) {
	        this.errorCallback(reason);
	        return this;
	    };
	    /**
	     * Set one or more properties on an object;
	     *
	     * @param {Object} object - The object to attach properties to
	     * @param {String|Object} key - The key, or an object map of properties
	     * @param {*} value - If the key is a string, this is the value to be associated with it
	     *
	     * @returns The object, with attached properties
	     */
	    StreamImpl.prototype.attach = function (key, value) {
	        var e_1, _a;
	        if (typeof key === 'object') {
	            try {
	                for (var _b = __values(Object.keys(key)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var k = _c.value;
	                    this.attach(k, key[k]);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        else if (value) {
	            if (!this.listeners.hasOwnProperty(key)) {
	                if (this.allowedEvents && this.allowedEvents.indexOf(key) === -1) {
	                    throw new Error("Event " + key + " not emitted on this stream, allowed events are " + this.allowedEvents);
	                }
	                this.listeners[key] = [];
	            }
	            this.listeners[key].push(value);
	        }
	    };
	    /**
	     * Remove one or more properties from an object
	     *
	     * @param {Object} object - The object to remove properties from
	     * @param {String|Object} key - The key, or an object map of properties
	     * @param {*} value - If the key is a string, this is the value to remove from it
	     *
	     * @returns The object, sans specified properties
	     */
	    StreamImpl.prototype.remove = function (key, value) {
	        var e_2, _a;
	        if (typeof key === 'object') {
	            try {
	                for (var _b = __values(Object.keys(key)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var k = _c.value;
	                    this.remove(k, key[k]);
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	        }
	        else if (this.listeners.hasOwnProperty(key)) {
	            if (value) {
	                this.listeners[key] = this.listeners[key].filter(function (e) {
	                    return e !== value;
	                });
	            }
	            else {
	                this.listeners[key] = [];
	            }
	        }
	    };
	    return StreamImpl;
	}());
	exports.StreamImpl = StreamImpl;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Session
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var session_id_1 = __webpack_require__(127);
	/**
	 * A serialiser for {@link SessionId}
	 */
	var SessionIdSerialiserClass = /** @class */ (function () {
	    function SessionIdSerialiserClass() {
	    }
	    /**
	     * @inheritdoc
	     */
	    SessionIdSerialiserClass.prototype.read = function (input) {
	        var server = Codec.readInt64(input);
	        var value = Codec.readInt64(input);
	        return new session_id_1.SessionId(server, value);
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionIdSerialiserClass.prototype.write = function (output, sessionId) {
	        Codec.writeInt64(output, sessionId.server);
	        Codec.writeInt64(output, sessionId.value);
	    };
	    return SessionIdSerialiserClass;
	}());
	exports.SessionIdSerialiserClass = SessionIdSerialiserClass;
	/**
	 * The {@link BooleanSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionIdSerialiser = new SessionIdSerialiserClass();


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Type guard for responses from a {@link ServiceSender}.
	 *
	 * @param err       the response error, if present
	 * @param response  the response data
	 * @return          returns `true` if the error is falsy. In this case, the {@link ServiceSender} should have called
	 *                  the response callback with a valid response.
	 */
	function responseSuccess(err, response) {
	    return !err;
	}
	exports.responseSuccess = responseSuccess;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enumerize_1 = __webpack_require__(103);
	/**
	 * A topic type
	 *
	 * Documentation of the TopicType values can be found under {@link TopicTypeEnum}.
	 */
	var TopicType = /** @class */ (function () {
	    /**
	     * Create a new TopicType instance
	     *
	     * @deprecated since 6.5
	     *             <p>
	     *             In the future, TopicType objects will be replaced by a string
	     *             constants.
	     *
	     * @param  id          the topic type ID
	     * @param  stateful    a flag indicating whether the topic type is stateful
	     * @param  functional  a flag indicating whether the topic type is functional
	     */
	    function TopicType(id, stateful, functional) {
	        // tslint:disable-next-line:deprecation
	        this.id = id;
	        // tslint:disable-next-line:deprecation
	        this.stateful = stateful;
	        // tslint:disable-next-line:deprecation
	        this.functional = functional;
	    }
	    return TopicType;
	}());
	exports.TopicType = TopicType;
	/**
	 * Enum containing possible Topic Types.
	 *
	 * **Example:**
	 * ```
	 * // Get a topic type for adding topics
	 * var topicType = diffusion.topics.TopicType.JSON;
	 *
	 * session.topics.add("foo", topicType);
	 * ```
	 */ // tslint:disable-next-line:variable-name
	exports.TopicTypeEnum = {
	    /**
	     * Routing Topic (deprecated).
	     *
	     * A functional topic that can point to different
	     * target topics for different clients.
	     *
	     * From the point of view of a client subscribing to such a topic this would
	     * be seen as a normal stateful topic but it has no
	     * state of its own and cannot be published to.
	     *
	     * Such a topic may specify a user written Java class which will be invoked
	     * to define the mapping of the topic to another data topic when a client
	     * subscribes. Alternatively the mapping can be delegated to a control
	     * client using the SubscriptionControl feature.
	     *
	     * Routing topics are deprecated in favor of {@link SessionTrees}.
	     *
	     * @deprecated since 6.7
	     */ // tslint:disable-next-line:deprecation
	    ROUTING: new TopicType(12, false, true),
	    /**
	     * Binary Topic.
	     *
	     * This is a stateful topic that handles data in Binary format.
	     * @since 5.7
	     */ // tslint:disable-next-line:deprecation
	    BINARY: new TopicType(14, true, false),
	    /**
	     * JSON (JavaScript Object Notation) Topic.
	     *
	     * This is a stateful topic that handles data in JSON representation.
	     * @since 5.7
	     */ // tslint:disable-next-line:deprecation
	    JSON: new TopicType(15, true, false),
	    /**
	     * Topic that stores and publishes String values. Based on the {@link string string data type}.
	     *
	     * Supports null String values.
	     *
	     * Supports delta-streams.
	     *
	     * @since 6.0
	     */ // tslint:disable-next-line:deprecation
	    STRING: new TopicType(17, true, false),
	    /**
	     * Topic that stores and publishes 64-bit integer values. Based on the
	     * {@link int64 int64 data type}. Values are of the type
	     * {@link Int64}.
	     *
	     * Supports null int64 values.
	     *
	     * Does not support delta-streams - only complete values are transmitted.
	     *
	     * @since 6.0
	     */ // tslint:disable-next-line:deprecation
	    INT64: new TopicType(18, true, false),
	    /**
	     * Topic that stores and publishes IEEE 754 double-precision floating point
	     * numbers (i.e native JavaScript Numbers). Based on the {@link double double data type}.
	     *
	     * Supports null Double values.
	     *
	     * The topic does not support delta-streams - only complete values are transmitted.
	     *
	     * @since 6.0
	     */ // tslint:disable-next-line:deprecation
	    DOUBLE: new TopicType(19, true, false),
	    /**
	     * Time Series Topic.
	     *
	     * A <em>time series</em> is a sequence of events. Each event contains a
	     * value and has server-assigned metadata comprised of a sequence number,
	     * timestamp, and author.
	     *
	     * A time series topic allows sessions to access a time series that is
	     * maintained by the server. A time series topic has an associated
	     * {@link DataType event data type}, such as `Binary`, `String`,
	     * or `JSON`, that determines the type of value associated with each
	     * event.
	     *
	     * <h4>Retained range</h4>
	     *
	     * The {@link TopicSpecification.TIME_SERIES_SUBSCRIPTION_RANGE
	     * TIME_SERIES_SUBSCRIPTION_RANGE} property configures the range of historic
	     * events retained by a time series topic. If the property is not specified,
	     * a time series topic will retain the ten most recent events.
	     *
	     * <h4>Subscription range</h4>
	     *
	     * The {@link TopicSpecification.TIME_SERIES_SUBSCRIPTION_RANGE
	     * TIME_SERIES_SUBSCRIPTION_RANGE} property configures a time series topic
	     * to send a range of historic events from the end of the time series to new
	     * subscribers. This is a convenient way to synchronize new subscribers
	     * without requiring the use of a {@link TimeSeries.rangeQuery range query}.
	     *
	     * By default, new subscribers will be sent the latest event if delta
	     * streams are enabled and no events if delta streams are disabled. See the
	     * description of <em>Subscription range</em> in the {@link
	     * Session.timeseries} time series feature} documentation.
	     *
	     *
	     * <h4>Mandatory properties</h4>
	     *
	     * The {@link TopicSpecification.TIME_SERIES_EVENT_VALUE_TYPE
	     * TIME_SERIES_EVENT_VALUE_TYPE} property must be provided when creating a
	     * time series topic.
	     *
	     *
	     * @since 6.0
	     * @see diffusion.datatypes.TimeSeriesDataType
	     */ // tslint:disable-next-line:deprecation
	    TIME_SERIES: new TopicType(16, true, false),
	    /**
	     * Topic that stores and publishes data in the form of records and fields.
	     * Based on the {@link RecordV2DataType RecordV2 data type}.
	     *
	     * Supports delta-streams.
	     *
	     * @since 6.0
	     */ // tslint:disable-next-line:deprecation
	    RECORD_V2: new TopicType(20, true, false),
	    /**
	     * A topic type that is unsupported by the session.
	     *
	     * @since 6.3
	     */ // tslint:disable-next-line:deprecation
	    UNKNOWN_TOPIC_TYPE: new TopicType(21, false, false)
	};
	enumerize_1.enumerize(exports.TopicTypeEnum);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var wellKnownSymbol = __webpack_require__(35);
	var create = __webpack_require__(169);
	var definePropertyModule = __webpack_require__(49);
	
	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;
	
	// Array.prototype[@@unscopables]
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] == undefined) {
	  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create(null)
	  });
	}
	
	// add a key to Array.prototype[@@unscopables]
	module.exports = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var IS_PURE = __webpack_require__(14);
	var getIterator = __webpack_require__(310);
	
	module.exports = IS_PURE ? getIterator : function (it) {
	  // eslint-disable-next-line no-undef
	  return Map.prototype.entries.call(it);
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var any_datatype_1 = __webpack_require__(227);
	var binary_datatype_impl_1 = __webpack_require__(1170);
	var binary_impl_1 = __webpack_require__(497);
	var json_datatype_impl_1 = __webpack_require__(1172);
	var json_impl_1 = __webpack_require__(328);
	var double_datatype_impl_1 = __webpack_require__(1176);
	var int64_datatype_impl_1 = __webpack_require__(1177);
	var int64_impl_1 = __webpack_require__(176);
	var string_datatype_impl_1 = __webpack_require__(1178);
	var recordv2_datatype_impl_1 = __webpack_require__(1182);
	var recordv2_impl_1 = __webpack_require__(330);
	var time_series_event_datatype_1 = __webpack_require__(179);
	var topic_type_1 = __webpack_require__(69);
	/**
	 * The implementation of the {@link DataTypes} interface
	 */
	var DataTypesImpl = /** @class */ (function () {
	    function DataTypesImpl() {
	        /**
	         * The RecordV2 datatype
	         */
	        this.recordv2Impl = new recordv2_datatype_impl_1.RecordV2DataTypeImpl();
	        /**
	         * The binary datatype
	         */
	        this.binaryImpl = new binary_datatype_impl_1.BinaryDataTypeImpl();
	        /**
	         * The string datatype
	         */
	        this.stringImpl = new string_datatype_impl_1.StringDataTypeImpl();
	        /**
	         * The double datatype
	         */
	        this.doubleImpl = new double_datatype_impl_1.DoubleDataTypeImpl();
	        /**
	         * The Int64 datatype
	         */
	        this.int64Impl = new int64_datatype_impl_1.Int64DataTypeImpl();
	        /**
	         * The JSON datatype
	         */
	        this.jsonImpl = new json_datatype_impl_1.JSONDataTypeImpl();
	        /**
	         * The Any datatype
	         */
	        this.anyImpl = new any_datatype_1.AnyDataTypeImpl();
	    }
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.binary = function () {
	        return this.binaryImpl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.string = function () {
	        return this.stringImpl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.double = function () {
	        return this.doubleImpl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.int64 = function () {
	        return this.int64Impl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.json = function () {
	        return this.jsonImpl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.recordv2 = function () {
	        return this.recordv2Impl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.any = function () {
	        return this.anyImpl;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.timeseries = function (valueType) {
	        return time_series_event_datatype_1.TimeSeriesEventDataType.create(valueType);
	    };
	    /**
	     * Obtain a {@link DataType} implementation by type
	     * name
	     *
	     * @param name  the type name as returned by {@link DataType.name DataType.name}
	     * @return      the data type or `null` if no datatype was found
	     */
	    DataTypesImpl.prototype.getByName = function (name) {
	        switch (name.toLowerCase()) {
	            case 'json':
	                return this.json();
	            case 'int64':
	                return this.int64();
	            case 'binary':
	                return this.binary();
	            case 'string':
	                return this.string();
	            case 'double':
	                return this.double();
	            case 'record_v2':
	                return this.recordv2();
	            default:
	                return undefined;
	        }
	    };
	    /**
	     * Obtain a {@link DataType} implementation by topic
	     * type, or value class
	     *
	     * @param name  the value or a topic type
	     * @return      the data type or `null` if no datatype was found
	     * @throws       an Error if there is no data type for provided class
	     */ // tslint:disable-next-line:cyclomatic-complexity
	    DataTypesImpl.prototype.getByValue = function (value) {
	        if (value === topic_type_1.TopicTypeEnum.BINARY || value instanceof binary_impl_1.BinaryImpl || Buffer.isBuffer(value)) {
	            return this.binary();
	        }
	        if (value === topic_type_1.TopicTypeEnum.JSON
	            || value instanceof json_impl_1.JSONImpl
	            || value.constructor === Object
	            || typeof value === 'boolean') {
	            return this.json();
	        }
	        if (value === topic_type_1.TopicTypeEnum.STRING || typeof value === 'string') {
	            return this.string();
	        }
	        if (value === topic_type_1.TopicTypeEnum.DOUBLE || typeof value === 'number') {
	            return this.double();
	        }
	        if (value === topic_type_1.TopicTypeEnum.INT64 || value instanceof int64_impl_1.Int64Impl) {
	            return this.int64();
	        }
	        if (value === topic_type_1.TopicTypeEnum.RECORD_V2 || value instanceof recordv2_impl_1.RecordV2Impl) {
	            return this.recordv2();
	        }
	        return undefined;
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.get = function (type) {
	        var datatype;
	        if (typeof type === 'string') {
	            datatype = this.getByName(type);
	        }
	        if (!datatype) {
	            datatype = this.getByValue(type);
	        }
	        if (!datatype) {
	            datatype = this.getByClassSafely(type);
	        }
	        return datatype ? datatype : null;
	    };
	    /**
	     * Obtain a {@link DataType} implementation by type
	     * name, topic type, or value class
	     *
	     * @param name  the type name as returned by {@link DataType.name DataType.name}, the value
	     *              or a topic type.
	     * @return      the data type or `null` if no datatype was found
	     * @throws       an Error if there is no data type for provided class
	     */
	    DataTypesImpl.prototype.getChecked = function (type) {
	        if (type === null || type === undefined) {
	            throw new Error("No data type for " + type);
	        }
	        if (type instanceof recordv2_datatype_impl_1.RecordV2DataTypeImpl ||
	            type instanceof binary_datatype_impl_1.BinaryDataTypeImpl ||
	            type instanceof string_datatype_impl_1.StringDataTypeImpl ||
	            type instanceof double_datatype_impl_1.DoubleDataTypeImpl ||
	            type instanceof int64_datatype_impl_1.Int64DataTypeImpl ||
	            type instanceof json_datatype_impl_1.JSONDataTypeImpl) {
	            return type;
	        }
	        var datatype = this.get(type);
	        if (datatype === null) {
	            throw new Error("No data type for " + type);
	        }
	        return datatype;
	    };
	    /**
	     * Obtain a value class implementation by {@link DataType}, string, or topic type
	     *
	     * For {@link DoubleDataType}, the associated value class is `Number`.
	     *
	     * @param valueClass  the class, type name, or topic type
	     * @return            the data type or `undefined` if no data type was found
	     */
	    DataTypesImpl.prototype.getValueClassChecked = function (type) {
	        var datatype = this.getChecked(type);
	        switch (datatype) {
	            case this.jsonImpl:
	                return json_impl_1.JSONImpl;
	            case this.binaryImpl:
	                return binary_impl_1.BinaryImpl;
	            case this.stringImpl:
	                return String;
	            case this.doubleImpl:
	                return Number;
	            case this.int64Impl:
	                return int64_impl_1.Int64Impl;
	            case this.recordv2Impl:
	                return recordv2_impl_1.RecordV2Impl;
	            default:
	                return undefined;
	        }
	    };
	    /**
	     * Obtain a {@link DataType} implementation by value class.
	     *
	     * For {@link DoubleDataType}, the associated value class is `Number`.
	     *
	     * @param valueClass  the class
	     * @return            the data type or `undefined` if no data type was found
	     */
	    DataTypesImpl.prototype.getByClassSafely = function (valueClass) {
	        switch (valueClass) {
	            case json_impl_1.JSONImpl:
	                return this.jsonImpl;
	            case binary_impl_1.BinaryImpl:
	                return this.binaryImpl;
	            case String:
	                return this.stringImpl;
	            case Number:
	                return this.doubleImpl;
	            case int64_impl_1.Int64Impl:
	                return this.int64Impl;
	            case recordv2_impl_1.RecordV2Impl:
	                return this.recordv2Impl;
	            default:
	                return undefined;
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    DataTypesImpl.prototype.getByClass = function (valueClass) {
	        var datatype = this.getByClassSafely(valueClass);
	        if (!datatype) {
	            throw new Error("No data type for " + valueClass);
	        }
	        else {
	            return datatype;
	        }
	    };
	    return DataTypesImpl;
	}());
	exports.DataTypesImpl = DataTypesImpl;
	// tslint:disable-next-line:variable-name
	var DataTypesSingleton = new DataTypesImpl();
	exports.DataTypes = DataTypesSingleton;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/**
	 * @module events
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var functions = __webpack_require__(89);
	var stream_1 = __webpack_require__(66);
	var EmitterEventQueue = /** @class */ (function () {
	    function EmitterEventQueue() {
	        this.pendingEvents = [];
	        this.events = [];
	        this.busy = false;
	    }
	    /**
	     * Add an emitter event to the queue
	     */
	    EmitterEventQueue.prototype.addEmitterEvent = function (event) {
	        var _this = this;
	        this.pendingEvents.push(event);
	        if (!this.busy) {
	            this.busy = true;
	            process.nextTick(function () {
	                _this.drainEmitterQueue();
	            });
	        }
	    };
	    /**
	     * Process all pending events
	     */
	    EmitterEventQueue.prototype.drainEmitterQueue = function () {
	        var _this = this;
	        var e_1, _a;
	        this.events = this.pendingEvents;
	        this.pendingEvents = [];
	        try {
	            for (var _b = __values(this.events), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var event_1 = _c.value;
	                try {
	                    event_1();
	                }
	                catch (err) { /* no-op */ }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        if (this.pendingEvents.length > 0) {
	            process.nextTick(function () {
	                _this.drainEmitterQueue();
	            });
	        }
	        else {
	            this.busy = false;
	        }
	    };
	    return EmitterEventQueue;
	}());
	var emitterEventQueue = new EmitterEventQueue();
	/**
	 * An internal class to construct implementations of {@link events.Stream} with
	 * a privately scoped emit function.
	 *
	 * This allows safe construction of event-based interfaces without exposing the
	 * means of emitting events.
	 */
	var Emitter = /** @class */ (function () {
	    /**
	     * Create an Emitter
	     *
	     * If a {@link Stream} is provided in the options, the Emitter will use it as
	     * the stream to emit events to. In this case, the `listeners` must also be
	     * supplied.
	     *
	     * If no {@link Stream} is provided, one will be created with the optional
	     * `allowedEvents` option.
	     *
	     * If the `event` option is specified, listeners will be registered by calling
	     * {@link Stream.on} passing the `event` option and the `callback` option as
	     * parameters.
	     *
	     * @param  options options for creating the Emitter
	     */
	    function Emitter(options) {
	        var _this = this;
	        /**
	         * The listeners object mapping event names to arrays of callback functions
	         */
	        this.listeners = {};
	        /**
	         * A flag indicating whether the Emitter is closed
	         */
	        this.closed = false;
	        /**
	         * A single listener that will be called whenever an event is emitted. The
	         * event name will be passed as the first argument.
	         */
	        this.listener = function () { };
	        if (options === undefined || options.stream === undefined) {
	            var helper = {
	                getListeners: function () {
	                    return _this.listeners;
	                },
	                getErrorCallback: function () {
	                    return _this.error.bind(_this);
	                },
	                getCloseCallback: function () {
	                    return _this.close.bind(_this);
	                }
	            };
	            this.stream = new stream_1.StreamImpl(helper, options && options.allowedEvents);
	        }
	        else {
	            this.stream = options.stream;
	            if (options.listeners === undefined) {
	                throw new Error('Listeners must be defined when supplying a stream');
	            }
	            this.listeners = options.listeners;
	        }
	        if (options !== undefined && options.event !== undefined) {
	            this.stream.on(options.event, options.callback);
	        }
	    }
	    /**
	     * Create an emitter factory that can create an Emitter.
	     *
	     * @param  allowedEvents a list of allowed event names
	     * @return a factory that creates an Emitter
	     */
	    Emitter.create = function (allowedEvents) {
	        var listeners = {};
	        var errorCallback = function () { };
	        var closeCallback = function () { };
	        return {
	            getListeners: function () {
	                return listeners;
	            },
	            getErrorCallback: function () {
	                return function (err) {
	                    errorCallback(err);
	                };
	            },
	            getCloseCallback: function () {
	                return function (reason) {
	                    closeCallback(reason);
	                };
	            },
	            emitter: function (stream) {
	                var emitter = new Emitter({
	                    stream: stream,
	                    listeners: listeners,
	                    allowedEvents: allowedEvents
	                });
	                errorCallback = emitter.error.bind(emitter);
	                closeCallback = emitter.close.bind(emitter);
	                return emitter;
	            }
	        };
	    };
	    /**
	     * Emit an event without checking if the emitter is closed.
	     *
	     * @see {@link Emitter.emit}
	     *
	     * @param event the event name
	     * @param args  arguments to pass to the listeners
	     */
	    Emitter.prototype.emit_unsafe = function (event, args) {
	        var _this = this;
	        var dispatch = function (listener) {
	            functions.callWithArguments(listener, args || []);
	        };
	        emitterEventQueue.addEmitterEvent(function () {
	            if (_this.listeners.hasOwnProperty(event)) {
	                _this.listeners[event].forEach(dispatch);
	            }
	        });
	        this.listener(event, args);
	    };
	    /**
	     * Emit an event.
	     *
	     * When an event is emitted, all listeners registered with the `Stream` for
	     * this event will be called.
	     *
	     * If the emitter is closed, or no `event` is specified, nothing will be emitted.
	     *
	     * Any additional arguments will be passed to the listeners.
	     *
	     * @param event the event name
	     * @param args  arguments to pass to the listeners
	     */
	    Emitter.prototype.emit = function (event) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (this.closed || !event) {
	            return;
	        }
	        this.emit_unsafe(event, args);
	    };
	    /**
	     * Process an event immediately.
	     *
	     * <p>Experimental.
	     */
	    Emitter.prototype.immediate = function (event) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (this.closed || !event) {
	            return;
	        }
	        var dispatch = function (listener) {
	            try {
	                functions.callWithArguments(listener, args || []);
	            }
	            catch (err) { /* no-op */ }
	        };
	        if (this.listeners.hasOwnProperty(event)) {
	            this.listeners[event].forEach(dispatch);
	        }
	    };
	    /**
	     * Signal a error and close the emitter. This will emit an `error` event and
	     * subsequently a `close` event.  No further events will be emitted.
	     *
	     * @param reason the error causing the emitter to close
	     */
	    Emitter.prototype.error = function (reason) {
	        if (this.closed) {
	            return;
	        }
	        this.emit_unsafe('error', [reason]);
	        this.close((reason) ? reason.message : undefined);
	    };
	    /**
	     * Close the emitter. This will emit a `close` event.
	     * No further events will be emitted.
	     *
	     * @param reason the reason for closing the emitter. This can be of any type.
	     *               The type of the close reason should be documented in the
	     *               concrete implementation of the {@link Stream} that the
	     *               emitter is linked to.
	     */
	    Emitter.prototype.close = function (reason) {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        this.emit_unsafe('close', [reason]);
	    };
	    /**
	     * Add a listener to all events
	     *
	     * @param fn a callback function that will be called whenever an event is
	     *           emitted. The event name will be passed as the first argument.
	     */
	    Emitter.prototype.listen = function (fn) {
	        this.listener = fn;
	    };
	    /**
	     * Get the stream that is used to register the callbacks
	     *
	     * @return the internal stream object
	     */
	    Emitter.prototype.get = function () {
	        return this.stream;
	    };
	    return Emitter;
	}());
	exports.Emitter = Emitter;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module IO
	 *
	 * @brief Basic stream based input and output using an underlying `Buffer`
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Wrapper around a single Buffer, providing auto-resizing capabilities.
	 *
	 * All write operations will append to the internal buffer.
	 *
	 * Loosely inspired by Java's ByteArrayOutputStream.
	 */
	var BufferOutputStream = /** @class */ (function () {
	    /**
	     * Create a new output stream from a buffer
	     *
	     * @param initial the initial size for the internal Buffer, or buffer to use as source.
	     */
	    function BufferOutputStream(initial) {
	        if (initial === void 0) { initial = 32; }
	        if (typeof (initial) === 'number') {
	            this.buffer = Buffer.alloc(initial);
	            this.count = 0;
	        }
	        else {
	            this.buffer = initial;
	            this.count = initial.length;
	        }
	    }
	    /**
	     * Write a single byte.
	     *
	     * @param val the byte to append
	     */
	    BufferOutputStream.prototype.write = function (val) {
	        this.ensureCapacity(this.count + 1);
	        this.buffer[this.count++] = val;
	    };
	    /**
	     * Write many bytes.
	     *
	     * The contents of the provided buffer will be copied and appended. The full
	     * length of the buffer will be copied, irrespective of byte content.
	     *
	     * @param buffer - The bytes to append.
	     * @param [offset=0] - The offset to start copying from the provided buffer
	     * @param [length=buffer.length] - The amount of bytes to copy from the provided buffer
	     */
	    BufferOutputStream.prototype.writeMany = function (buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        if (length === 0) {
	            // nothing to write, just bail out here
	            return;
	        }
	        this.ensureCapacity(this.count + length);
	        buffer.copy(this.buffer, this.count, offset, offset + length);
	        this.count += length;
	    };
	    /**
	     * Write a String in UTF-8 format.
	     *
	     * @param val the string value to be appended.
	     */
	    BufferOutputStream.prototype.writeString = function (val) {
	        var length = Buffer.byteLength(val);
	        this.ensureCapacity(this.count + length);
	        // strings are encoded as UTF-8 by default
	        this.buffer.write(val, this.count, length);
	        this.count += length;
	    };
	    /**
	     * Write a signed 8-bit integer.
	     * @param val the number to write
	     */
	    BufferOutputStream.prototype.writeInt8 = function (val) {
	        this.ensureCapacity(this.count + 1);
	        this.buffer.writeInt8(val, this.count++);
	    };
	    /**
	     * Write a signed, big-endian 32-bit integer.
	     * @param val the number to write
	     */
	    BufferOutputStream.prototype.writeInt32 = function (val) {
	        this.ensureCapacity(this.count + 4);
	        this.buffer.writeInt32BE(val, this.count);
	        this.count += 4;
	    };
	    /**
	     * Write a signed, big-endian 64-bit long.
	     * @param val the number to write.
	     */
	    BufferOutputStream.prototype.writeInt64 = function (val) {
	        this.ensureCapacity(this.count + 8);
	        this.buffer.writeInt32BE(val.getHighBits(), this.count);
	        this.buffer.writeInt32BE(val.getLowBits(), this.count + 4);
	        this.count += 8;
	    };
	    /**
	     * Return the written bytes as a buffer, sized to the last value written.
	     * <p>
	     * Any modifications to the returned buffer will be reflected in this OutputStream.
	     *
	     * @returns A Buffer containing all the bytes current written to this OutputStream.
	     */
	    BufferOutputStream.prototype.getBuffer = function () {
	        return this.buffer.slice(0, this.count);
	    };
	    /**
	     * Return written bytes as a base64 encoded string.
	     * @returns The base64 encoded string
	     */
	    BufferOutputStream.prototype.getBase64 = function () {
	        return this.getBuffer().toString('base64');
	    };
	    /**
	     * Ensure that the output stream has enough capacity
	     *
	     * @param  min the capacity the buffer should have
	     */
	    BufferOutputStream.prototype.ensureCapacity = function (min) {
	        if (min - this.buffer.length > 0) {
	            this.grow(min);
	        }
	    };
	    /**
	     * Grow the buffer up to the next minimum capacity (or higher).
	     *
	     * @param minCapacity the minimum capacity required
	     * @throws If the new capacity exceeds that with which a Buffer can be created,
	     *         an error will be thrown.
	     */
	    BufferOutputStream.prototype.grow = function (minCapacity) {
	        var oldCapacity = this.buffer.length;
	        /* tslint:disable-next-line:no-bitwise */
	        var newCapacity = oldCapacity << 1;
	        if (newCapacity - minCapacity < 0) {
	            newCapacity = minCapacity;
	        }
	        try {
	            var replacement = Buffer.alloc(newCapacity);
	            this.buffer.copy(replacement);
	            this.buffer = replacement;
	        }
	        catch (e) {
	            throw new Error('Unable to resize BufferOutputStream to ' + newCapacity);
	        }
	    };
	    return BufferOutputStream;
	}());
	exports.BufferOutputStream = BufferOutputStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Base type for a GATEWAY_CLIENT_REQUEST request.
	 */
	var BaseGatewayClientRequest = /** @class */ (function () {
	    /**
	     * Create a new BaseGatewayClientRequest instance
	     *
	     * @param sessionId  the gateway session identifier
	     */
	    function BaseGatewayClientRequest(sessionId) {
	        this.sessionId = sessionId;
	    }
	    return BaseGatewayClientRequest;
	}());
	exports.BaseGatewayClientRequest = BaseGatewayClientRequest;


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(31);
	
	module.exports = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call,no-throw-literal
	    method.call(null, argument || function () { throw 1; }, 1);
	  });
	};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `ToInteger` abstract operation
	// https://tc39.github.io/ecma262/#sec-tointeger
	module.exports = function (argument) {
	  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.errors
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_reason_1 = __webpack_require__(325);
	var enumerize_1 = __webpack_require__(103);
	/**
	 * Enum containing reason codes used to report error conditions.
	 * <p>
	 * Some common ErrorReason values are defined as global constants. More specific reasons may be defined by
	 * individual features.
	 *
	 * **Example:**
	 * ```
	 * // Handle an error from the server
	 * session.addStream('foo', diffusion.datatypes.string()).on('error', function(e) {
	 *     if (e == diffusion.errors.ACCESS_DENIED) {
	 *         // Handle authorisation error
	 *     } else {
	 *         // Log the problem
	 *         console.log(e);
	 *     }
	 * });
	 * ```
	 */ // tslint:disable-next-line:variable-name
	exports.ErrorReason = {
	    /** Communication with the server failed. */
	    COMMUNICATION_FAILURE: new error_reason_1.ErrorReason(100, 'Communication with server failed'),
	    /** Communication with the server failed because the session is closed. */
	    SESSION_CLOSED: new error_reason_1.ErrorReason(101, 'Session is closed'),
	    /** Communication with the server failed because a service request timed out. */
	    REQUEST_TIME_OUT: new error_reason_1.ErrorReason(102, 'Request time out'),
	    /** The request was rejected because the caller has insufficient permissions. */
	    ACCESS_DENIED: new error_reason_1.ErrorReason(103, 'Access denied'),
	    /** The request was rejected because the requested operation is unsupported for this caller. */
	    UNSUPPORTED: new error_reason_1.ErrorReason(104, 'Unsupported service'),
	    /** An application callback threw an exception. Check logs for more information. */
	    CALLBACK_EXCEPTION: new error_reason_1.ErrorReason(105, 'An application callback threw an exception. Check logs for more information'),
	    /** An operation failed because invalid data was received. */
	    INVALID_DATA: new error_reason_1.ErrorReason(106, 'Invalid data'),
	    /** An operation failed because an addressed session could not be found. */
	    NO_SUCH_SESSION: new error_reason_1.ErrorReason(107, 'A requested session could not be found'),
	    /** An operation failed due to using an incompatible data type. */
	    INCOMPATIBLE_DATATYPE: new error_reason_1.ErrorReason(108, 'Data type is incompatible'),
	    /** A sent message was not handled by the specified recipient. */
	    UNHANDLED_MESSAGE: new error_reason_1.ErrorReason(109, 'A message was not handled'),
	    /**
	     * A cluster operation failed because partition ownership changed during
	     * processing.
	     *
	     * This is a transient error that occurs while the cluster is recovering
	     * from failure. The session can retry the operation.
	     */
	    CLUSTER_REPARTITION: new error_reason_1.ErrorReason(110, 'The cluster was repartitioning and the request could not be routed.'),
	    /**
	     * A topic update could not be performed because the topic is managed by a
	     * component (for example,fan-out) which prohibits external updates.
	     */
	    INCOMPATIBLE_STATE: new error_reason_1.ErrorReason(111, 'Topic operation not performed because it is managed by a component that prohibits external updates'),
	    /**
	     * A cluster operation failed to be routed to a server within the cluster
	     * due to a communication failure, or the server that owns a partition is
	     * not currently known.
	     *
	     * This is a transient error that occurs while the cluster is recovering
	     * from failure. The session can retry the operation.
	     */
	    CLUSTER_ROUTING: new error_reason_1.ErrorReason(112, 'The cluster operation could not be routed.'),
	    /** A conflicting registration exists on the same branch of the topic tree. */
	    TOPIC_TREE_REGISTRATION_CONFLICT: new error_reason_1.ErrorReason(200, 'A conflicting registration exists on the same branch of the topic tree'),
	    /** A conflicting registration exists on the server. */
	    HANDLER_CONFLICT: new error_reason_1.ErrorReason(201, 'Conflict with an existing handler'),
	    /** An invalid path was supplied. */
	    INVALID_PATH: new error_reason_1.ErrorReason(202, 'Invalid path'),
	    /** A recipient session has rejected a received message request. */
	    REJECTED_REQUEST: new error_reason_1.ErrorReason(9003, 'A request has been rejected by the recipient session')
	};
	enumerize_1.enumerize(exports.ErrorReason);


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Function
	 *
	 * @brief Utility functions for function calls
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Basic curry-right; provides partial application with arguments on the right
	 *
	 * @param fn   the function to call
	 * @param args the arguments passed to the function as the trailing arguments
	 * @return     the curried function
	 */
	function curryR(fn) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    return function () {
	        var leftArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            leftArgs[_i] = arguments[_i];
	        }
	        return callWithArguments(fn, leftArgs.concat(args));
	    };
	}
	exports.curryR = curryR;
	/**
	 * Call a function with arguments passed in as an array
	 *
	 * Optimisation of `Function.apply` for small number of arguments
	 *
	 * `Function.apply` is more than 20 times slower than direct function calls
	 * see https://jsperf.com/function-versus-function-call-versus-function-apply
	 *
	 * @param fn   the function to call
	 * @param args the arguments in n array
	 * @return     the return value of the function call
	 */
	function callWithArguments(fn, args) {
	    // optimise for manageable numbers of arguments
	    switch (args.length) {
	        case 0:
	            return fn();
	        case 1:
	            return fn(args[0]);
	        case 2:
	            return fn(args[0], args[1]);
	        case 3:
	            return fn(args[0], args[1], args[2]);
	        case 4:
	            return fn(args[0], args[1], args[2], args[3]);
	        case 5:
	            return fn(args[0], args[1], args[2], args[3], args[4]);
	        case 6:
	            return fn(args[0], args[1], args[2], args[3], args[4], args[5]);
	        case 7:
	            return fn(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        case 8:
	            return fn(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
	    }
	    return fn.apply(fn, args);
	}
	exports.callWithArguments = callWithArguments;
	/**
	 * The identity function
	 *
	 * @param  val a value
	 * @return the input value `val`
	 */
	function identity(val) {
	    return val;
	}
	exports.identity = identity;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Provide access to
	 * {@link UpdateConstraint UpdateConstraint},
	 * {@link UpdateConstraintFactory UpdateConstraintFactory},
	 * {@link PartialJSON PartialJSON},
	 * {@link TopicCreationResult TopicCreationResult}, and
	 * {@link UpdateStream UpdateStream}.
	 *
	 * @module diffusion.topicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:variable-name */
	/**
	 * Result indicating whether the operation caused a topic to be created or if
	 * it already existed.
	 *
	 * @since 6.2
	 */
	var TopicCreationResult;
	(function (TopicCreationResult) {
	    /**
	     * A new topic was created.
	     */
	    TopicCreationResult[TopicCreationResult["CREATED"] = 1] = "CREATED";
	    /**
	     * A topic with the same specification already exists.
	     */
	    TopicCreationResult[TopicCreationResult["EXISTS"] = 2] = "EXISTS";
	})(TopicCreationResult = exports.TopicCreationResult || (exports.TopicCreationResult = {}));
	exports.TopicUpdateNamespace = {
	    TopicCreationResult: TopicCreationResult
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
60,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var definePropertyModule = __webpack_require__(49);
	var createPropertyDescriptor = __webpack_require__(165);
	
	module.exports = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var createNonEnumerableProperty = __webpack_require__(98);
	var has = __webpack_require__(58);
	var setGlobal = __webpack_require__(314);
	var inspectSource = __webpack_require__(311);
	var InternalStateModule = __webpack_require__(143);
	
	var getInternalState = InternalStateModule.get;
	var enforceInternalState = InternalStateModule.enforce;
	var TEMPLATE = String(String).split('String');
	
	(module.exports = function (O, key, value, options) {
	  var unsafe = options ? !!options.unsafe : false;
	  var simple = options ? !!options.enumerable : false;
	  var noTargetGet = options ? !!options.noTargetGet : false;
	  if (typeof value == 'function') {
	    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
	    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
	  }
	  if (O === global) {
	    if (simple) O[key] = value;
	    else setGlobal(key, value);
	    return;
	  } else if (!unsafe) {
	    delete O[key];
	  } else if (!noTargetGet && O[key]) {
	    simple = true;
	  }
	  if (simple) O[key] = value;
	  else createNonEnumerableProperty(O, key, value);
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, 'toString', function toString() {
	  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
	});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = __webpack_require__(216);
	var requireObjectCoercible = __webpack_require__(170);
	
	module.exports = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Session.security
	 *
	 * Access to the [[Security]] feature
	 * @preferred
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Permissions that are applied globally
	 */
	var GlobalPermission;
	(function (GlobalPermission) {
	    /**
	     * Add an authentication handler
	     */
	    GlobalPermission["AUTHENTICATE"] = "AUTHENTICATE";
	    /**
	     *  List or listen to client sessions
	     */
	    GlobalPermission["VIEW_SESSION"] = "VIEW_SESSION";
	    /**
	     * Alter a client session
	     */
	    GlobalPermission["MODIFY_SESSION"] = "MODIFY_SESSION";
	    /**
	     * Required to register any server-side handler
	     */
	    GlobalPermission["REGISTER_HANDLER"] = "REGISTER_HANDLER";
	    /**
	     * View the server's runtime state
	     */
	    GlobalPermission["VIEW_SERVER"] = "VIEW_SERVER";
	    /**
	     * Change the server's runtime state
	     */
	    GlobalPermission["CONTROL_SERVER"] = "CONTROL_SERVER";
	    /**
	     * Read the security configuration
	     */
	    GlobalPermission["VIEW_SECURITY"] = "VIEW_SECURITY";
	    /**
	     * Change the security configuration
	     */
	    GlobalPermission["MODIFY_SECURITY"] = "MODIFY_SECURITY";
	    /**
	     * A permission that is unsupported by the session
	     */
	    GlobalPermission["UNKNOWN_GLOBAL_PERMISSION"] = "UNKNOWN_GLOBAL_PERMISSION";
	    /**
	     * List topic views
	     */
	    GlobalPermission["READ_TOPIC_VIEWS"] = "READ_TOPIC_VIEWS";
	    /**
	     * Modify topic views
	     */
	    GlobalPermission["MODIFY_TOPIC_VIEWS"] = "MODIFY_TOPIC_VIEWS";
	})(GlobalPermission = exports.GlobalPermission || (exports.GlobalPermission = {}));
	/**
	 * Permissions that are applied on a path
	 */
	var PathPermission;
	(function (PathPermission) {
	    /**
	     * Required to receive information from a topic.
	     *
	     * If a session does not have read_path permission for a topic, the topic
	     * will be excluded from the results of subscription or fetch operations for
	     * the session, and the topic's details cannot be retrieved by the session.
	     */
	    PathPermission["READ_TOPIC"] = "READ_TOPIC";
	    /**
	     * Update topics
	     */
	    PathPermission["UPDATE_TOPIC"] = "UPDATE_TOPIC";
	    /**
	     * Add or remove topics
	     */
	    PathPermission["MODIFY_TOPIC"] = "MODIFY_TOPIC";
	    /**
	     * Send a message to a handler registered with the server
	     */
	    PathPermission["SEND_TO_MESSAGE_HANDLER"] = "SEND_TO_MESSAGE_HANDLER";
	    /**
	     * Send a message another session
	     */
	    PathPermission["SEND_TO_SESSION"] = "SEND_TO_SESSION";
	    /**
	     * Use a topic selector that selects the topic path
	     *
	     * A session must have this permission for the path prefix of any topic selector
	     * used to subscribe or fetch.
	     *
	     * When the subscription or fetch request completes, the resulting topics
	     * are further filtered based on the `READ_TOPIC` permission.
	     *
	     * A session that has `READ_TOPIC` but not
	     * `SELECT_TOPIC` for a particular topic path cannot
	     * subscribe directly to topics belonging to the path. However, the session can
	     * be independently subscribed by a control session that has the
	     * `MODIFY_SESSION` global permission in addition to the
	     * appropriate `SELECT_TOPIC` permission.
	     *
	     * A session granted `SELECT_TOPIC` for a particular path effectively
	     * has the permission for all descendant paths. From a security perspective,
	     * if a role grants `SELECT_TOPIC` at branch `X` it is
	     * ineffectual for it also to deny `SELECT_TOPIC` at a child branch
	     * `X/Y` because a a topic selector with a path prefix of `X`
	     * can still select paths below `X/Y`.
	     */
	    PathPermission["SELECT_TOPIC"] = "SELECT_TOPIC";
	    /**
	     * Evaluate queries that return a non-current view of a time series topic.
	     *
	     * <p>
	     * The `READ_TOPIC` permission is required to evaluate any type of
	     * `Query` for a time series topic. This permission is additionally
	     * required for queries that potentially return a non-current view of all or
	     * part of a time series. Such queries include value range queries that
	     * specify an edit range, and all types of edit range query.
	     */
	    PathPermission["QUERY_OBSOLETE_TIME_SERIES_EVENTS"] = "QUERY_OBSOLETE_TIME_SERIES_EVENTS";
	    /*
	     * Submit edits to time series topic events.
	     *
	     * <p>
	     * The `UPDATE_TOPIC` permission is required to update a time series
	     * topic. This permission is additionally required to submit
	     * edits to a time series topic.
	     */
	    PathPermission["EDIT_TIME_SERIES_EVENTS"] = "EDIT_TIME_SERIES_EVENTS";
	    /**
	     * Submit edits to time series topic events which have an author which is
	     * the same as the principal of the calling session.
	     *
	     * <p>This permission is a more restrictive alternative to
	     * `EDIT_TIME_SERIES_EVENTS`.
	     *
	     * <p>
	     * The `UPDATE_TOPIC` permission is required to update a time series
	     * topic. This permission is additionally required to submit
	     * edits to a time series topic where the event
	     * author is the same as the principal of the calling session.
	     */
	    PathPermission["EDIT_OWN_TIME_SERIES_EVENTS"] = "EDIT_OWN_TIME_SERIES_EVENTS";
	    /**
	     * Acquire a session lock.
	     */
	    PathPermission["ACQUIRE_LOCK"] = "ACQUIRE_LOCK";
	    /**
	     * Expose a branch of the topic tree as a virtual session tree.
	     *
	     * The `EXPOSE_BRANCH` path permission is powerful since it allows a
	     * session to expose a whole branch of the topic tree under a different set
	     * of path permissions.
	     *
	     * A session granted `EXPOSE_BRANCH` for a particular path effectively
	     * has the permission for all descendant paths. From a security perspective,
	     * if a role grants `EXPOSE_BRANCH` at branch `X` it is
	     * ineffectual for it also to deny `EXPOSE_BRANCH` at a child branch
	     * `X/Y` because a branch mapping to `X` can still expose paths
	     * below `X/Y`.
	     */
	    PathPermission["EXPOSE_BRANCH"] = "EXPOSE_BRANCH";
	    /**
	     * A permission that is unsupported by the session
	     */
	    PathPermission["UNKNOWN_PATH_PERMISSION"] = "UNKNOWN_PATH_PERMISSION";
	    /**
	     * A permission that is unsupported by the session
	     * @deprecated since 6.5
	     */
	    PathPermission["UNKNOWN_TOPIC_PERMISSION"] = "UNKNOWN_TOPIC_PERMISSION";
	})(PathPermission = exports.PathPermission || (exports.PathPermission = {}));
	/**
	 * Type of a SessionPropertyValidation for a correspondent client proposed property.
	 */
	var ValidationType;
	(function (ValidationType) {
	    ValidationType[ValidationType["REGEX"] = 0] = "REGEX";
	    ValidationType[ValidationType["VALUES"] = 1] = "VALUES";
	})(ValidationType = exports.ValidationType || (exports.ValidationType = {}));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var buffer_slice_1 = __webpack_require__(229);
	/**
	 * Implementation of the {@link Bytes} interface
	 */
	var BytesImpl = /** @class */ (function (_super) {
	    __extends(BytesImpl, _super);
	    /**
	     * Create a new BytesImpl instance
	     *
	     * @param  buffer  the internal buffer
	     * @param  offset  the offset of the slice
	     * @param  length  the number of bytes in the slice
	     */
	    function BytesImpl(buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        return _super.call(this, buffer, offset, length) || this;
	    }
	    BytesImpl.toString = function () {
	        return 'BytesImpl';
	    };
	    /**
	     * @inheritdoc
	     */
	    BytesImpl.prototype.length = function () {
	        return this.$length;
	    };
	    /**
	     * @inheritdoc
	     */
	    BytesImpl.prototype.asBuffer = function () {
	        return this.$buffer.slice(this.$offset, this.$offset + this.$length);
	    };
	    /**
	     * @inheritdoc
	     */
	    BytesImpl.prototype.copyTo = function (target, offset) {
	        if (offset === void 0) { offset = 0; }
	        this.$buffer.copy(target, offset, this.$offset, this.$offset + this.$length);
	    };
	    /**
	     * Check if the Bytes are equal to a buffer slices
	     *
	     * @param  bytes the buffer slice
	     * @return       `true` if the two bytes are equal
	     */
	    BytesImpl.prototype.equals = function (bytes) {
	        return this.equalBytes(bytes.$buffer, bytes.$offset, bytes.$length);
	    };
	    /**
	     * Check if the Bytes are equal to a buffer slices
	     *
	     * @param  buffer  the buffer
	     * @param  offset  the offset of the slice
	     * @param  length  the number of bytes in the slice
	     * @return         `true` if the two bytes are equal
	     */
	    BytesImpl.prototype.equalBytes = function (buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        if (this.$length !== length) {
	            return false;
	        }
	        if (this.$buffer === buffer && this.$offset === offset) {
	            return true;
	        }
	        for (var i = 0; i < length; ++i) {
	            if (this.$buffer[this.$offset + i] !== buffer[offset + i]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return BytesImpl;
	}(buffer_slice_1.BufferSlice));
	exports.BytesImpl = BytesImpl;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Enumerize
	 *
	 * @brief Utility function for turning objects into Enum like objects
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Add reverse lookup to an enum-like object in order to imitate TypeScript
	 * style enums. Each value must be an object that defines a numeric `id`
	 * property.
	 *
	 * **Example:**
	 * ```
	 * const enumLike = {
	 *   FOO: { id: 0, msg: 'This is a Foo'},
	 *   BAR: { id: 1, msg: 'This is a Bar'}
	 * }
	 *
	 * enumerize(enumLike);
	 *
	 * // enumLike = {
	 * //  FOO: { id: 0, msg: 'This is a Foo'},
	 * //  BAR: { id: 1, msg: 'This is a Bar'},
	 * //  0: 'FOO',
	 * //  1: 'BAR'
	 * // }
	 * ```
	 *
	 * @param obj  the enum-like object
	 */
	function enumerize(obj) {
	    Object.keys(obj).forEach(function (key) {
	        var id = obj[key].id;
	        if (id !== undefined) {
	            obj[id] = key;
	        }
	    });
	}
	exports.enumerize = enumerize;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Math
	 *
	 * @brief Mathenatical utility functions
	 */
	/* tslint:disable:no-bitwise */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Calculate the number of leading zeros in the binary representation of a number
	 * using the minimal amount of bit-shifting
	 *
	 * @param  i the number to analyse
	 * @return   the number of leading binary zeros
	 */
	function leadingZeros(i) {
	    if (i === 0) {
	        return 32;
	    }
	    var n = 1;
	    if (i >>> 16 === 0) {
	        n += 16;
	        i <<= 16;
	    }
	    if (i >>> 24 === 0) {
	        n += 8;
	        i <<= 8;
	    }
	    if (i >>> 28 === 0) {
	        n += 4;
	        i <<= 4;
	    }
	    if (i >>> 30 === 0) {
	        n += 2;
	        i <<= 2;
	    }
	    n -= i >>> 31;
	    return n;
	}
	/**
	 * Cheap approximation to a square root.
	 *
	 * @param value the argument of the square-root function
	 * @return      a power of two that approximates the square root of a value
	 */
	function approximateSquareRoot(value) {
	    if (value < 0) {
	        throw new Error('Value must be great or equal to 0');
	    }
	    if (value === 0) {
	        return 0;
	    }
	    var h = 32 - leadingZeros(value);
	    return 1 << Math.round(h / 2);
	}
	exports.approximateSquareRoot = approximateSquareRoot;
	/**
	 * Find the next integer, equal or higher to the value, which is a power of two.
	 *
	 * @param value the value to search from
	 * @returns     the next power of two
	 */
	function findNextPowerOfTwo(value) {
	    if (value < 0 || value > 1 << 30) {
	        throw new Error('Illegal argument: ' + value);
	    }
	    // see: https://graphics.stanford.edu/~seander/bithacks.html#RoundUpPowerOf2
	    value--;
	    value |= value >> 1;
	    value |= value >> 2;
	    value |= value >> 4;
	    value |= value >> 8;
	    value |= value >> 16;
	    value++;
	    return value;
	}
	exports.findNextPowerOfTwo = findNextPowerOfTwo;
	/**
	 * Converts an integer conforming to IEEE 754 Single bit format to a floating
	 * point value. This is similar to Java's Float#intBitsToFloat.
	 *
	 * See https://en.wikipedia.org/wiki/Single-precision_floating-point_format for
	 * detail on the bit layout.
	 *
	 * Code taken from http://stackoverflow.com/a/16001019 - most succinct
	 * implementation I could find that avoided unnecessary loops or reads.
	 *
	 * @param bytes integer containing IEEE-754 value bytes
	 * @returns     the resulting float
	 */
	function intBitsToFloat(bytes) {
	    var sign = (bytes & 0x80000000) ? -1 : 1;
	    var exponent = ((bytes >> 23) & 0xFF) - 127;
	    var significand = (bytes & ~(-1 << 23));
	    if (exponent === 128) {
	        return sign * ((significand) ? Number.NaN : Number.POSITIVE_INFINITY);
	    }
	    if (exponent === -127) {
	        if (significand === 0) {
	            return sign * 0.0;
	        }
	        exponent = -126;
	        significand /= (1 << 22);
	    }
	    else {
	        significand = (significand | (1 << 23)) / (1 << 23);
	    }
	    return sign * significand * Math.pow(2, exponent);
	}
	exports.intBitsToFloat = intBitsToFloat;
	/**
	 * Maximum 32 bit integer value: 2^32 - 1
	 */
	exports.MAX_INT32 = 2147483647;
	/**
	 * Maximum safe integer value for JavaScript numbers: 2^53 - 1
	 */
	exports.MAX_SAFE_INTEGER = 9007199254740991;


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(32);
	var IndexedObject = __webpack_require__(216);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(38);
	var arraySpeciesCreate = __webpack_require__(164);
	
	var push = [].push;
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var boundFunction = bind(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push.call(target, value); // filter
	        } else if (IS_EVERY) return false;  // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.forEach` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6)
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var IS_PURE = __webpack_require__(14);
	var getIterator = __webpack_require__(310);
	
	module.exports = IS_PURE ? getIterator : function (it) {
	  // eslint-disable-next-line no-undef
	  return Set.prototype.values.call(it);
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(97);
	
	// `IsArray` abstract operation
	// https://tc39.github.io/ecma262/#sec-isarray
	module.exports = Array.isArray || function isArray(arg) {
	  return classof(arg) == 'Array';
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	
	module.exports = global;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module CBOR
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(174);
	var tokeniser_1 = __webpack_require__(324);
	/**
	 * Recursive token-parsing function; will evaluate tokens and build up complete object representations in order.
	 */
	/* tslint:disable-next-line:cyclomatic-complexity  */
	function decode(token, tokeniser) {
	    switch (token.type) {
	        case consts_1.tokens.VALUE:
	            return token.value;
	        case consts_1.tokens.MAP_START:
	            var obj = {};
	            for (;;) {
	                var field = tokeniser.nextToken();
	                if (field === null) {
	                    throw new Error('Unexpected EOF (reading: map key)');
	                }
	                if (field.type === consts_1.tokens.MAP_END) {
	                    break;
	                }
	                var value = tokeniser.nextToken();
	                if (value === null || value.type === consts_1.tokens.MAP_END) {
	                    throw new Error('Unexpected EOF (reading: map value)');
	                }
	                var key = decode(field, tokeniser);
	                if (key === undefined || key === null) {
	                    throw new Error('Cannot have undefined key (reading: map key)');
	                }
	                obj[key.toString()] = decode(value, tokeniser);
	            }
	            return obj;
	        case consts_1.tokens.ARRAY_START:
	            var arr = [];
	            for (;;) {
	                var element = tokeniser.nextToken();
	                if (element === null) {
	                    throw new Error('Unexpected EOF (reading: array value)');
	                }
	                if (element.type === consts_1.tokens.ARRAY_END) {
	                    break;
	                }
	                arr.push(decode(element, tokeniser));
	            }
	            return arr;
	        case consts_1.tokens.STRING_START:
	            var chunks = [];
	            for (;;) {
	                var chunk = tokeniser.nextToken();
	                if (chunk === null) {
	                    throw new Error('Unexpected EOF (reading: indefinite-length string');
	                }
	                if (chunk.type === consts_1.tokens.STRING_END) {
	                    break;
	                }
	                if (chunk.header.type !== token.header.type) {
	                    throw new Error('Unexpected chunk type (' + chunk.header.type + ') within string');
	                }
	                chunks.push(chunk.value);
	            }
	            switch (token.header.type) {
	                case consts_1.types.BYTES:
	                    return Buffer.concat(chunks);
	                case consts_1.types.STRING:
	                    return chunks.join('');
	                default:
	                    throw new Error('Unexpected chunk type ('
	                        + token.header.type + ') (reading: string)');
	            }
	        default:
	            throw new Error('Unexpected token: ' + JSON.stringify(token));
	    }
	}
	/**
	 * Provide a higher-level interface around Tokeniser, to enable the reading of
	 * complex values as represented in arrays/objects etc.
	 */
	var Decoder = /** @class */ (function () {
	    /**
	     * Create a decoder
	     *
	     * @param  initial the `Buffer` or `Tokeniser` to read from
	     * @param  offset  if a `Buffer` is supplied as first argument, the optional
	     *                 offset from which to start reading. Ignored otherwise.
	     * @param  length  if a `Buffer` is supplied as first argument, the optional
	     *                 number of bytes to read. Ignored otherwise.
	     */
	    function Decoder(initial, offset, length) {
	        this.tokeniser = (Buffer.isBuffer(initial)) ? new tokeniser_1.Tokeniser(initial, offset, length) : initial;
	    }
	    /**
	     * Check if more tokens can be read from the tokeniser
	     *
	     * @return `true` if there are more tokens
	     */
	    Decoder.prototype.hasRemaining = function () {
	        return this.tokeniser.hasRemaining();
	    };
	    /**
	     * Return the next value, parsed recursively.
	     *
	     * If no tokens can be read, a read error will be thrown.
	     *
	     * @return the next value
	     * @throws a read error if no value can be read
	     */
	    Decoder.prototype.nextValue = function () {
	        return this.nextValueExpecting(isAny);
	    };
	    /**
	     * Return the next value, if its CBOR type is acceptable to `cborTypePredicate`
	     *
	     * @parame cborTypePredicate a predicate that should return true if the
	     *                           CBOR type is acceptable, false otherwise.
	     * @return the next value
	     * @throws an error if no value can be read
	     */
	    Decoder.prototype.nextValueExpecting = function (cborTypePredicate) {
	        if (!this.tokeniser.hasRemaining()) {
	            throw new Error('Token stream exhausted');
	        }
	        var token = this.tokeniser.nextToken();
	        if (cborTypePredicate(token.header.type)) {
	            return decode(token, this.tokeniser);
	        }
	        else {
	            throw new Error('Unexpected CBOR type');
	        }
	    };
	    return Decoder;
	}());
	exports.Decoder = Decoder;
	/**
	 * Allow only floating point CBOR types
	 *
	 * @param  cborType the CBOR type
	 * @return `true` if the type is a floating point number
	 */
	function isDouble(cborType) {
	    return cborType === consts_1.types.FLOAT;
	}
	exports.isDouble = isDouble;
	/**
	 * Allow only int CBOR types
	 *
	 * @param  cborType the CBOR type
	 * @return `true` if the type is an integer
	 */
	function isInt64(cborType) {
	    return cborType === consts_1.types.UINT ||
	        cborType === consts_1.types.INT;
	}
	exports.isInt64 = isInt64;
	/**
	 * Allow only string CBOR types
	 *
	 * @param  cborType the CBOR type
	 * @return `true` if the type is a string
	 */
	function isString(cborType) {
	    return cborType === consts_1.types.STRING;
	}
	exports.isString = isString;
	/**
	 * Allow any CBOR types
	 *
	 * @return will always return `true`
	 */
	function isAny() {
	    return true;
	}
	exports.isAny = isAny;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Conversation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Long = __webpack_require__(44);
	/**
	 * A conversation ID
	 */
	var ConversationId = /** @class */ (function () {
	    /**
	     * Construct the conversation ID with a value
	     *
	     * @param  val  the value of the conversation ID
	     */
	    function ConversationId(val) {
	        this.val = val;
	    }
	    /**
	     * Create a new ConversationID from a string
	     *
	     * @param val  a string representation of the ID
	     * @return     a new ConversationID
	     */
	    ConversationId.fromString = function (val) {
	        return new ConversationId(Long.fromString(val, false));
	    };
	    /**
	     * Convert the conversation ID to a string
	     *
	     * @return  the string representation of the ID
	     */
	    ConversationId.prototype.toString = function () {
	        return this.val.toString(10);
	    };
	    /**
	     * Check equality of the ConversationId with another.
	     *
	     * @param other  another conversation ID
	     * @return       `true` if the two conversation ID contain the same value
	     */
	    ConversationId.prototype.equals = function (other) {
	        return other.val && this.val.equals(other.val);
	    };
	    return ConversationId;
	}());
	exports.ConversationId = ConversationId;
	/**
	 * A special conversation ID for one-way conversations
	 */
	exports.ONEWAY_CID = new ConversationId(Long.fromNumber(0));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module IO
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Long = __webpack_require__(44);
	/**
	 * Sequential reading of values from a given Buffer.
	 * Loosely inspired by Java's ByteArrayInputStream.
	 */
	var BufferInputStream = /** @class */ (function () {
	    /**
	     * Construct an input stream from a Buffer
	     *
	     * @param {Buffer} buffer - The source Buffer.
	     */
	    function BufferInputStream(buffer) {
	        this.buffer = buffer;
	        this.count = buffer.length;
	        this.pos = 0;
	    }
	    /**
	     * Read one byte.
	     * @returns The byte that was read, or -1 if the stream is exhausted.
	     */
	    BufferInputStream.prototype.read = function () {
	        /* tslint:disable-next-line:no-bitwise */
	        return (this.pos < this.count) ? (this.buffer[this.pos++] & 0xFF) : -1;
	    };
	    /**
	     * Returns the next byte in the input stream, without extracting it.
	     *
	     * @returns The byte that was read, or -1 if the stream is exhausted.
	     */
	    BufferInputStream.prototype.peek = function () {
	        /* tslint:disable-next-line:no-bitwise */
	        return (this.pos < this.count) ? (this.buffer[this.pos] & 0xFF) : -1;
	    };
	    /**
	     * Read a specified amount of bytes.
	     *
	     * If the length is greater than the remaining number of bytes, this function
	     * will read up to the last available byte in the buffer.
	     *
	     * @param length the number of bytes you wish to read.
	     * @returns the bytes that have been read
	     * @throws will throw an OutOfBounds error if length is a negative number.
	     */
	    BufferInputStream.prototype.readMany = function (length) {
	        var lengthAdjusted = Math.min(length, this.count - this.pos);
	        if (lengthAdjusted < 0) {
	            throw new Error('Length out of bounds');
	        }
	        var result = this.buffer.slice(this.pos, this.pos + lengthAdjusted);
	        this.pos += lengthAdjusted;
	        return result;
	    };
	    /**
	     * Read until a specified byte (delimiter) is found.
	     *
	     * The buffer position is updated to point to just after the
	     * delimiter.
	     *
	     * If the delimiter can't be found, then return all bytes until the
	     * end of the buffer.
	     *
	     * @param delim the delimiter byte
	     * @returns a buffer containing the bytes up to but not including the
	     *          delimiter byte.
	     */
	    BufferInputStream.prototype.readUntil = function (delim) {
	        var found = this.count;
	        for (var i = this.pos; i < this.count; i++) {
	            if (this.buffer[i] === delim) {
	                found = i;
	                break;
	            }
	        }
	        var buffer = this.buffer.slice(this.pos, found);
	        this.pos = (found === this.count) ? found : found + 1;
	        return buffer;
	    };
	    /**
	     * Read a signed 8-bit integer.
	     * @returns the number that has been read.
	     */
	    BufferInputStream.prototype.readInt8 = function () {
	        return this.buffer.readInt8(this.pos++);
	    };
	    /**
	     * Read a signed, big-endian 32-bit integer.
	     * @returns the number that has been read.
	     */
	    BufferInputStream.prototype.readInt32 = function () {
	        var i = this.buffer.readInt32BE(this.pos);
	        this.pos += 4;
	        return i;
	    };
	    /**
	     * Read a signed, big-endian 64-bit long.
	     * @returns the number that has been read.
	     */
	    BufferInputStream.prototype.readInt64 = function () {
	        var hi = this.buffer.readInt32BE(this.pos);
	        this.pos += 4;
	        var lo = this.buffer.readInt32BE(this.pos);
	        this.pos += 4;
	        return Long.fromBits(lo, hi, false);
	    };
	    /**
	     * Read an unsigned, big-endian 64-bit long.
	     * @returns the number that has been read.
	     */
	    BufferInputStream.prototype.readUInt64 = function () {
	        var hi = this.buffer.readInt32BE(this.pos);
	        this.pos += 4;
	        var lo = this.buffer.readInt32BE(this.pos);
	        this.pos += 4;
	        return Long.fromBits(lo, hi, true);
	    };
	    /**
	     * Indicates if there are remaining bytes to be found
	     *
	     * @returns `true` if there are remaining bytes
	     */
	    BufferInputStream.prototype.hasRemaining = function () {
	        return this.pos < this.buffer.length;
	    };
	    return BufferInputStream;
	}());
	exports.BufferInputStream = BufferInputStream;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	/**
	 * Base type for GATEWAY_CLIENT_REQUEST requests targeted at services.
	 */
	var BaseGatewayServiceRequest = /** @class */ (function (_super) {
	    __extends(BaseGatewayServiceRequest, _super);
	    /**
	     * Create a new BaseGatewayClientRequest instance
	     *
	     * @param sessionId  the gateway session identifier
	     */
	    function BaseGatewayServiceRequest(sessionId, serviceId) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.serviceId = serviceId;
	        return _this;
	    }
	    return BaseGatewayServiceRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.BaseGatewayServiceRequest = BaseGatewayServiceRequest;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Session
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Long = __webpack_require__(44);
	var PADDING = '0000000000000000';
	/**
	 * A session ID
	 */
	var SessionId = /** @class */ (function () {
	    /**
	     * Create a new session ID
	     *
	     * @param server  server part of the ID
	     * @param value   value part of the ID
	     */
	    function SessionId(server, value) {
	        this.server = server;
	        this.value = value;
	    }
	    /**
	     * Create a new session ID from a string
	     *
	     * @param str  the string representation of a session ID
	     * @return     a new session ID
	     */
	    SessionId.fromString = function (str) {
	        var parts = str.split('-');
	        var sessionId;
	        if (parts.length !== 2) {
	            throw new Error('SessionId must consist of two hexadecimal parts, joined with a \'-\'');
	        }
	        try {
	            var server = Long.fromString(parts[0], false, 16);
	            var value = Long.fromString(parts[1], false, 16);
	            sessionId = new SessionId(server, value);
	        }
	        catch (e) {
	            throw new Error('SessionId must consist of two hexadecimal parts, joined with a \'-\'');
	        }
	        return sessionId;
	    };
	    /**
	     * Determines if a given string is a valid SessionID. If true, the returned
	     * value will be the parsed SessionID
	     *
	     * @param str  the session id string
	     * @returns    `false` if the string cannot be parsed, or a constructed SessionID
	     */
	    SessionId.validate = function (str) {
	        if (str instanceof SessionId) {
	            return str;
	        }
	        if (str.length === 0 || str.indexOf('-') < 0 || str.indexOf(' ') >= 0) {
	            return false;
	        }
	        try {
	            // attempt to construct an actual session id; catch any errors thrown by the Long#fromString methods
	            return SessionId.fromString(str);
	        }
	        catch (e) {
	            return false;
	        }
	    };
	    /**
	     * Convert the session ID to a string
	     *
	     * @return  a string representation of the session ID
	     */
	    SessionId.prototype.toString = function () {
	        // it appears that converting back into strings requires unsigned longs
	        var server = PADDING + this.server.toUnsigned().toString(16);
	        var client = PADDING + this.value.toUnsigned().toString(16);
	        return (server.substr(server.length - 16) + '-' + client.substr(client.length - 16)).toLowerCase();
	    };
	    return SessionId;
	}());
	exports.SessionId = SessionId;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The topic path separator character.
	 */
	exports.PATH_SEPARATOR = '/';
	/**
	 * Split a path into parts.
	 *
	 * @param path  the path
	 * @return      the parts
	 */
	function split(path) {
	    return path.split(exports.PATH_SEPARATOR);
	}
	exports.split = split;
	/**
	 * Provide a canonical representation of a given path, stripping leading and
	 * trailing path separators
	 *
	 * @param path  the path
	 * @returns     the canonicalised path
	 */
	function canonicalise(path) {
	    if (!path) {
	        return '';
	    }
	    var l = path.length;
	    var s = l > 0 && path.charAt(0) === exports.PATH_SEPARATOR ? 1 : 0;
	    var e = l > 1 && path.charAt(l - 1) === exports.PATH_SEPARATOR ? 1 : 0;
	    return path.substring(s, l - e);
	}
	exports.canonicalise = canonicalise;
	/**
	 * Minimal representation of DescendantQualifier enum type.
	 */
	var DQ = /** @class */ (function () {
	    /**
	     * Create a DQ instance
	     *
	     * @param descendants  the match includes descendants
	     */
	    function DQ(descendants) {
	        this.includesDescendants = descendants;
	    }
	    return DQ;
	}());
	exports.DQ = DQ;
	/**
	 * An enum like object containing descendant qualifiers
	 */ // tslint:disable-next-line:variable-name
	exports.DescendantQualifier = Object.freeze({
	    MATCH: new DQ(false),
	    DESCENDANTS_OF_MATCH: new DQ(true),
	    MATCH_AND_DESCENDANTS: new DQ(true)
	});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_selector_parser_1 = __webpack_require__(344);
	/**
	 * Serialiser for {@link AbstractTopicSelector}
	 */
	var TopicSelectorSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicSelectorSerialiserClass, _super);
	    function TopicSelectorSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AbstractTopicSelector} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link AbstractTopicSelector} that was read
	     */
	    TopicSelectorSerialiserClass.prototype.read = function (bis) {
	        return topic_selector_parser_1.parseSelector(Codec.readString(bis));
	    };
	    /**
	     * Write a {@link TopicSelector} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicSelector} to be written
	     */
	    TopicSelectorSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.expression);
	    };
	    return TopicSelectorSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicSelectorSerialiserClass = TopicSelectorSerialiserClass;
	/**
	 * The {@link TopicSelectorSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicSelectorSerialiser = new TopicSelectorSerialiserClass();


/***/ }),
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(150),
	    getRawTag = __webpack_require__(1557),
	    objectToString = __webpack_require__(1589);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1523),
	    getValue = __webpack_require__(1558);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var NATIVE_WEAK_MAP = __webpack_require__(1055);
	var global = __webpack_require__(27);
	var isObject = __webpack_require__(43);
	var createNonEnumerableProperty = __webpack_require__(98);
	var objectHas = __webpack_require__(58);
	var sharedKey = __webpack_require__(316);
	var hiddenKeys = __webpack_require__(215);
	
	var WeakMap = global.WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP) {
	  var store = new WeakMap();
	  var wmget = store.get;
	  var wmhas = store.has;
	  var wmset = store.set;
	  set = function (it, metadata) {
	    wmset.call(store, it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return wmget.call(store, it) || {};
	  };
	  has = function (it) {
	    return wmhas.call(store, it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return objectHas(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return objectHas(it, STATE);
	  };
	}
	
	module.exports = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var any_datatype_1 = __webpack_require__(227);
	var binary_delta_impl_1 = __webpack_require__(496);
	var binary_delta_type_impl_1 = __webpack_require__(228);
	var bytes_impl_1 = __webpack_require__(102);
	/**
	 * An abstract implementation of the {@link DataType} interface
	 *
	 * @param <ValueType>   the value type of the data type
	 * @param <SourceType>  the type(s) from which a value can be constructed
	 * @param <CBORType>    the binary type containing the CBOR data
	 */
	var AbstractDataType = /** @class */ (function () {
	    /**
	     * Create a new instance of `AbstractDataType`
	     *
	     * @param typeName          the data type name
	     * @param valueClass        the constructor function creating the value type
	     * @param implementation    a constructor function that creates the binary CBOR representation
	     * @param vToC              a converter function that converts a value to binary CBOR data
	     * @param cToV              a converter function that converts the binary CBOR data to a value
	     * @param converters        an array of constructor functions. These will be added to the
	     *                          {@link valueConverters} map. Each constructor must implement
	     *                          a static `toString` function.
	     * @param withBinaryDelta   a flag indicating if the data type supports binary deltas
	     */
	    function AbstractDataType(typeName, valueClass, implementation, vToC, cToV, converters, withBinaryDelta) {
	        var _this = this;
	        /**
	         * A map of value converters
	         *
	         * Value converters convert binary data containing the CBOR value into a
	         * different value type.
	         *
	         * The key of the map is a string representation of the destination type.
	         */
	        this.valueConverters = {};
	        this.typeName = typeName;
	        this.cToV = cToV;
	        this.vToC = vToC;
	        this.implementation = implementation;
	        converters.forEach(function (converter) {
	            _this.valueConverters[converter.name] = converter.convert;
	        });
	        this.valueConverters[bytes_impl_1.BytesImpl.toString()] = function (buffer, offset, length) {
	            return new bytes_impl_1.BytesImpl(buffer, offset, length);
	        };
	        this.valueConverters[valueClass.toString()] = this.readValue.bind(this);
	        this.valueConverters[any_datatype_1.AnyDataTypeImpl.toString()] = this.readValue.bind(this);
	        this.valueClass = valueClass;
	        if (withBinaryDelta) {
	            this.binaryDeltaTypeImpl
	                = new binary_delta_type_impl_1.BinaryDeltaTypeImpl(implementation, vToC, cToV);
	        }
	    }
	    /**
	     * @inheritdoc
	     */
	    AbstractDataType.prototype.name = function () {
	        return this.typeName;
	    };
	    /**
	     * Convert the objet to a string
	     *
	     * @return  a string representation of the AbstractDataType
	     */
	    AbstractDataType.prototype.toString = function () {
	        return this.typeName + " data type";
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractDataType.prototype.writeValue = function (value) {
	        var internal = this.vToC(value);
	        if (internal === null) {
	            throw new Error(this + " cannot write " + value);
	        }
	        return internal.asBuffer();
	    };
	    /**
	     * Convert a value to bytes
	     *
	     * @param value  the value
	     * @return       a CBOR representation of the value
	     * @throws       an error if the supplied value could not be converted
	     */
	    AbstractDataType.prototype.toBytes = function (value) {
	        var bytes = this.vToC(value);
	        if (bytes) {
	            return bytes;
	        }
	        throw new Error(this + " cannot convert value to Bytes: " + value);
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractDataType.prototype.readValue = function (buffer, offset, length) {
	        if (buffer instanceof bytes_impl_1.BytesImpl) {
	            if (buffer instanceof this.implementation) {
	                return this.cToV(buffer);
	            }
	            return this.readValue(buffer.$buffer, buffer.$offset, buffer.$length);
	        }
	        return this.cToV(new this.implementation(buffer, offset, length));
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractDataType.prototype.canReadAs = function (valueClass) {
	        // tslint:disable-next-line:strict-type-predicates
	        return this.valueConverters[valueClass.toString()] !== undefined;
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractDataType.prototype.readAs = function (valueClass, buffer, offset, length) {
	        if (buffer instanceof bytes_impl_1.BytesImpl) {
	            return this.readAs(valueClass, buffer.$buffer, buffer.$offset, buffer.$length);
	        }
	        if (this.valueConverters[valueClass.toString()]) {
	            return this.valueConverters[valueClass.toString()](buffer, offset, length);
	        }
	        throw new Error(this + " is incompatible with values of " + valueClass);
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractDataType.prototype.deltaType = function (name) {
	        if (!name || name === 'binary' || name instanceof binary_delta_impl_1.BinaryDeltaImpl) {
	            return this.binaryDeltaType();
	        }
	        throw new Error(this + " has no '" + name + "' delta type");
	    };
	    /**
	     * The binary delta type
	     *
	     * @returns      the delta type
	     */
	    AbstractDataType.prototype.binaryDeltaType = function () {
	        if (this.binaryDeltaTypeImpl === undefined) {
	            throw new Error(this + " has no binary delta type");
	        }
	        return this.binaryDeltaTypeImpl;
	    };
	    return AbstractDataType;
	}());
	exports.AbstractDataType = AbstractDataType;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * A Serialiser for string values
	 */
	var StringSerialiserClass = /** @class */ (function () {
	    function StringSerialiserClass() {
	    }
	    /**
	     * @inheritdoc
	     */
	    StringSerialiserClass.prototype.read = function (bis) {
	        return Codec.readString(bis);
	    };
	    /**
	     * @inheritdoc
	     */
	    StringSerialiserClass.prototype.write = function (bos, val) {
	        Codec.writeString(bos, val);
	    };
	    return StringSerialiserClass;
	}());
	exports.StringSerialiserClass = StringSerialiserClass;
	/**
	 * The {@link StringSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.StringSerialiser = new StringSerialiserClass();


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var update_constraint_1 = __webpack_require__(343);
	var BinaryValueSerialiser = __webpack_require__(1408);
	var ConjunctionSerialiser = __webpack_require__(1409);
	var LockedSerialiser = __webpack_require__(1418);
	var NoTopicSerialiser = __webpack_require__(1419);
	var NoValueSerialiser = __webpack_require__(1420);
	var PartialJSONSerialiser = __webpack_require__(1421);
	var UnconstrainedSerialiser = __webpack_require__(1423);
	/**
	 * The serialisers for each constraint type
	 */
	var constraintSerialisers = {
	    UNCONSTRAINED: UnconstrainedSerialiser,
	    CONJUNCTION: ConjunctionSerialiser,
	    BINARY_VALUE: BinaryValueSerialiser,
	    NO_VALUE: NoValueSerialiser,
	    LOCKED: LockedSerialiser,
	    NO_TOPIC: NoTopicSerialiser,
	    PARTIAL_JSON: PartialJSONSerialiser
	};
	/**
	 * Write an {@link UpdateConstraint} update constraint to the stream
	 */
	function write(bos, value) {
	    // tslint:disable-next-line:strict-type-predicates
	    if (value.getConstraintType === undefined
	        // tslint:disable-next-line:strict-type-predicates
	        || update_constraint_1.ConstraintType[value.getConstraintType()] === undefined) {
	        throw new Error('Unknown constraint type');
	    }
	    Codec.writeByte(bos, update_constraint_1.ConstraintType[value.getConstraintType()]);
	    constraintSerialisers[value.getConstraintType()].write(bos, value, write);
	}
	exports.write = write;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module Topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var topic_specification_1 = __webpack_require__(238);
	var topic_type_1 = __webpack_require__(69);
	var cachedTopicSpecification;
	var cachedHash;
	var cacheBytesRead;
	/**
	 * Read a {@link TopicSpecification} from the stream
	 *
	 * @param bis the input stream
	 * @return    the {@link TopicSpecification} that was read
	 */
	function read(bis) {
	    if (cachedHash) {
	        var newHash = bis.buffer.slice(bis.pos, bis.pos + cacheBytesRead);
	        if (newHash.equals(cachedHash)) {
	            bis.readMany(cacheBytesRead);
	            return cachedTopicSpecification;
	        }
	    }
	    var offset = bis.pos;
	    var type = BEES.read(bis, topic_type_1.TopicTypeEnum);
	    var properties = Codec.readDictionary(bis, Codec.readString);
	    var topicSpecification = new topic_specification_1.TopicSpecification(type, properties);
	    cacheBytesRead = bis.pos - offset;
	    cachedHash = Buffer.from(bis.buffer.slice(offset, bis.pos));
	    cachedTopicSpecification = Object.freeze(topicSpecification);
	    return topicSpecification;
	}
	exports.read = read;
	/**
	 * Write a {@link TopicSpecification} to the stream
	 *
	 * @param bos   the output stream
	 * @param value the {@link TopicSpecification} to be written
	 */
	function write(bos, value) {
	    BEES.write(bos, value.type);
	    Codec.writeDictionary(bos, value.properties, Codec.writeString);
	}
	exports.write = write;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Provide access to {@link TopicType TopicType},
	 * {@link TopicSpecification TopicSpecification}, and
	 * {@link UnsubscribeReason UnsubscribeReason}
	 * @namespace diffusion.topics
	 *
	 * @module diffusion.topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enumerize_1 = __webpack_require__(103);
	var fetch_request_1 = __webpack_require__(551);
	var topic_specification_1 = __webpack_require__(238);
	var topic_type_1 = __webpack_require__(69);
	/**
	 * A type containing information about the reason for an unsubscription
	 */
	var UnsubscribeReason = /** @class */ (function () {
	    /**
	     * Create a `UnsubscribeReason`
	     *
	     * @param  id      the unsubscribe reason's id
	     * @param  reason  the unsubscribe reason's description
	     */
	    function UnsubscribeReason(id, reason) {
	        this.id = id;
	        this.reason = reason;
	    }
	    return UnsubscribeReason;
	}());
	exports.UnsubscribeReason = UnsubscribeReason;
	/**
	 * Enum containing reasons that an unsubscription occurred.
	 *
	 * **Example:**
	 * ```
	 * // Use UnsubscribeReason to validate unsubscription notifications
	 * session.addStream('>foo', diffusion.datatypes.string())
	 *        .on('unsubscribe', function(topic, specification, reason) {
	 *     switch (reason) {
	 *         case diffusion.topics.UnsubscribeReason.REMOVED :
	 *             // Do something if the topic was removed
	 *         default :
	 *             // Do something else if the client was explicitly unsubscribed
	 *     }
	 * });
	 * ```
	 */ // tslint:disable-next-line:variable-name
	exports.UnsubscribeReasonEnum = {
	    /**
	     * The server has re-subscribed this session to the topic. Existing
	     * streams are unsubscribed because the topic type and other attributes
	     * may have changed.
	     *
	     * This can happen if a set of servers are configured to use session
	     * replication, and the session connected to one server reconnects
	     * ('fails over') to a different server.
	     *
	     * A stream that receives an unsubscription notification with this
	     * reason will also receive a subscription notification with the new
	     * {@link TopicSpecification}.
	     *
	     * @since 5.9
	     */
	    SUBSCRIPTION_REFRESH: new UnsubscribeReason(undefined, 'The server has re-subscribed this session'),
	    /**
	     * A fallback stream has been unsubscribed or subscribed due to the
	     * addition or removal of a stream that selects the topic.
	     *
	     * @since 5.9
	     */
	    STREAM_CHANGE: new UnsubscribeReason(undefined, 'A more specific stream has been registered to the same path'),
	    /**
	     * The unsubscription was requested by this client.
	     */
	    REQUESTED: new UnsubscribeReason(0, 'The unsubscription was requested by this client'),
	    /**
	     * The server or another client unsubscribed this client.
	     */
	    CONTROL: new UnsubscribeReason(1, 'The server or another client unsubscribed this client'),
	    /**
	     * The topic was removed
	     */
	    REMOVED: new UnsubscribeReason(2, 'The topic was removed'),
	    /**
	     * The unsubscription occurred because the session is no longer authorized to access the topic.
	     * @since 5.9
	     */
	    AUTHORIZATION: new UnsubscribeReason(3, 'Not authorized to subscribe to this topic'),
	    /**
	     * A reason that is unsupported by the session.
	     *
	     * @since 6.1
	     */
	    UNKNOWN_UNSUBSCRIBE_REASON: new UnsubscribeReason(4, 'Unknown unsubscribe reason'),
	    /**
	     * The server has a significant backlog of messages for the session, and
	     * the topic specification has the {@link TopicSpecification.CONFLATION
	     * conflation topic property} set to 'unsubscribe'. The session can
	     * resubscribe to the topic. The unsubscription is not persisted to the
	     * cluster. If the session fails over to a different server it will be
	     * resubscribed to the topic.
	     *
	     * @since 6.1
	     */
	    BACK_PRESSURE: new UnsubscribeReason(5, 'The server has unsubscribed due to a backlog of messages'),
	    /**
	     * The unsubscription occurred because branch mapping rules changed.
	     *
	     * @since 6.7
	     * @see SessionTrees
	     */
	    BRANCH_MAPPINGS: new UnsubscribeReason(6, 'Branch mapping rules have changed')
	};
	enumerize_1.enumerize(exports.UnsubscribeReasonEnum);
	Object.freeze(exports.UnsubscribeReasonEnum);
	/**
	 * A type containing information about the reason for failure of an update
	 */
	var UpdateFailReason = /** @class */ (function () {
	    /**
	     * Create a `UpdateFailReason`
	     *
	     * @param  id      the update fail reason's id
	     * @param  reason  the update fail reason's description
	     */
	    function UpdateFailReason(id, reason) {
	        this.id = id;
	        this.reason = reason;
	    }
	    return UpdateFailReason;
	}());
	exports.UpdateFailReason = UpdateFailReason;
	/**
	 * The reason that a topic could not be updated.
	 *
	 * **Example:**
	 * ```
	 * session.topics.update('foo', 'bar').then(function() { ... }, function(err) {
	 *     switch (err) {
	 *         case diffusion.topics.UpdateFailReason.MISSING_TOPIC:
	 *             ...
	 *         case diffusion.topics.UpdateFailReason.EXCLUSIVE_UPDATER_CONFLICT:
	 *             ...
	 *     }
	 * });
	 * ```
	 */ // tslint:disable-next-line:variable-name
	exports.UpdateFailReasonEnum = {
	    /**
	     * The update was of a type that is not compatible with the topic it was submitted for, or
	     * the topic does not support updating.
	     */
	    INCOMPATIBLE_UPDATE: new UpdateFailReason(1, 'Update type is incompatible with topic type'),
	    /**
	     * The update failed, possibly because the content sent with the update was invalid/incompatible with topic type or
	     * data format.
	     */
	    UPDATE_FAILED: new UpdateFailReason(2, 'Update failed - possible content incompatibility'),
	    /**
	     * The updater used is not active.
	     *
	     * @deprecated Since 6.6
	     *             <p>
	     *             This value is no longer used and will be removed in a future release.
	     */
	    INVALID_UPDATER: new UpdateFailReason(3, 'Updater is invalid for updating'),
	    /**
	     * The topic being updated does not exist.
	     */
	    MISSING_TOPIC: new UpdateFailReason(4, 'Topic does not exist'),
	    /**
	     * Attempt to perform a non-exclusive update to a topic branch that already has an update source registered to it.
	     *
	     * @deprecated Since 6.6
	     *             <p>
	     *             This value is no longer used and will be removed in a future release.
	     */
	    EXCLUSIVE_UPDATER_CONFLICT: new UpdateFailReason(7, 'An exclusive update source is already registered for the topic branch'),
	    /**
	     * An attempt has been made to apply a delta to a topic that has not yet has a value specified for it.
	     */
	    DELTA_WITHOUT_VALUE: new UpdateFailReason(8, 'An attempt has been made to apply a delta to a topic that does not yet have a value'),
	    /**
	     * An update to a replicated topic failed because the cluster was
	     * repartitioning due to a server starting, stopping, or failing. The
	     * session can retry the operation.
	     */
	    CLUSTER_REPARTITION: new UpdateFailReason(9, 'When trying to update the topic the cluster was migrating the partition that owns the topic'),
	    /**
	     * An update could not be performed because the topic is managed by a
	     * component (e.g fan-out) that prohibits updates from the caller.
	     */
	    INCOMPATIBLE_STATE: new UpdateFailReason(10, 'An update could not be performed because the topic is managed by' +
	        'a component (e.g fan-out) that prohibits updates from the caller'),
	    /**
	     * An update was not performed because the constraint was not satisfied.
	     */
	    UNSATISFIED_CONSTRAINT: new UpdateFailReason(-1, 'The topic update failed because the constraint was not satisfied'),
	    /**
	     * An update to a replicated topic failed because the cluster was
	     * repartitioning due to a server starting, stopping, or failing. The
	     * session can retry the operation.
	     */
	    INVALID_UPDATE_STREAM: new UpdateFailReason(-2, 'The topic update failed because the update stream is no longer valid'),
	};
	enumerize_1.enumerize(exports.UpdateFailReasonEnum);
	Object.freeze(exports.UpdateFailReasonEnum);
	/**
	 * A type containing information about the reason for failure of adding a topic
	 */
	var TopicAddFailReason = /** @class */ (function () {
	    /**
	     * Create a `TopicAddFailReason`
	     *
	     * @param  id      the topic add failure reason's id
	     * @param  reason  the topic add failure reason's description
	     */
	    function TopicAddFailReason(id, reason) {
	        this.id = id;
	        this.reason = reason;
	    }
	    return TopicAddFailReason;
	}());
	exports.TopicAddFailReason = TopicAddFailReason;
	/**
	 * The reason that a topic could not be added.
	 *
	 * **Example:**
	 * ```
	 * session.topics.add('foo').then(function() { ... }, function(err) {
	 *     switch (err) {
	 *          case diffusion.topics.TopicAddFailReason.EXISTS:
	 *              ...
	 *          case diffusion.topics.TopicAddFailReason.INVALID_PATH:
	 *              ...
	 *     }
	 * });
	 * ```
	 *
	 */ // tslint:disable-next-line:variable-name
	exports.TopicAddFailReasonEnum = {
	    /**
	     * The topic already exists with the same details.
	     */
	    EXISTS: new TopicAddFailReason(1, 'The topic already exists with the same details'),
	    /**
	     * The topic already exists, with different details.
	     */
	    EXISTS_MISMATCH: new TopicAddFailReason(2, 'The topic already exists, with different details'),
	    /**
	     * The supplied topic path is invalid.
	     */
	    INVALID_NAME: new TopicAddFailReason(15, 'The supplied topic path is invalid.'),
	    /**
	     * @deprecated since 6.7
	     *             <p>
	     *             This value is not used and will be removed in a future release.
	     */
	    INVALID_PATH: new TopicAddFailReason(3, 'The topic path is invalid'),
	    /**
	     * The topic details are invalid.
	     */
	    INVALID_DETAILS: new TopicAddFailReason(4, 'The topic details are invalid'),
	    /**
	     * Invalid permissions to add a topic at the specified path.
	     */
	    PERMISSIONS_FAILURE: new TopicAddFailReason(7, 'Invalid permissions to add a topic at the specified path'),
	    /**
	     *  An unexpected error occured while creating the topic.
	     */
	    UNEXPECTED_ERROR: new TopicAddFailReason(9, 'An unexpected error occured while creating the topic'),
	    /**
	     * When trying to create the topic the cluster was migrating the partition
	     * that owns the topic. The correct owner could not be identified and the
	     * request failed. This is a transient failure for the duration of the
	     * partition migration.
	     */
	    CLUSTER_REPARTITION: new TopicAddFailReason(10, 'When trying to create the topic the cluster was migrating the partition that owns the topic'),
	    /**
	     * Adding the topic failed because of a license limit.
	     */
	    EXCEEDED_LICENSE_LIMIT: new TopicAddFailReason(11, 'Adding the topic failed because of a license limit'),
	    /**
	     * Adding the topic failed because an incompatible topic owned is already bound to the parent path.
	     *
	     * @deprecated Since 6.5
	     *             <p>
	     *             This value is no longer used and will be removed in a future release.
	     */
	    INCOMPATIBLE_PARENT: new TopicAddFailReason(12, 'Adding the topic failed because an incompatible topic is already bound to the parent path'),
	    /**
	     * Adding the topic failed because a topic is already bound to the specified
	     * path but the caller does not have the rights to manage it.
	     *
	     * This can be because the topic is being managed by a component with
	     * exclusive control over the topic, such as fan-out and thus
	     * the caller will not be able to update or remove the topic.
	     *
	     * If the caller has suitable permissions then it could still subscribe to
	     * the topic, but the topic's specification may be different from that
	     * requested.
	     */
	    EXISTS_INCOMPATIBLE: new TopicAddFailReason(14, 'Adding the topic failed because a topic is already bound to the specified' +
	        'path but the caller does not have the rights to manage it'),
	};
	enumerize_1.enumerize(exports.TopicAddFailReasonEnum);
	Object.freeze(exports.TopicAddFailReasonEnum);
	exports.topicsNamespace = {
	    FetchRequest: fetch_request_1.FetchRequest,
	    TopicType: topic_type_1.TopicTypeEnum,
	    TopicSpecification: topic_specification_1.TopicSpecification,
	    UnsubscribeReason: exports.UnsubscribeReasonEnum,
	    UpdateFailReason: exports.UpdateFailReasonEnum,
	    TopicAddFailReason: exports.TopicAddFailReasonEnum
	};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(253);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(162);
	util.inherits = __webpack_require__(149);
	/*</replacement>*/
	
	var Readable = __webpack_require__(732);
	var Writable = __webpack_require__(734);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.singleValue = singleValue;
	exports.dictionary = dictionary;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function singleValue(func) {
	    var cache = void 0;
	    return {
	        getValue: function getValue() {
	            return cache || (cache = func());
	        },
	        reset: function reset() {
	            cache = null;
	        }
	    };
	}
	
	function dictionary(func) {
	    var cache = new Map();
	    var reverseOutdated = false;
	    var reverseCache = new Map();
	    var updateReverse = function updateReverse() {
	        if (reverseOutdated) {
	            reverseCache = new Map([].concat(_toConsumableArray(cache)).map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    a = _ref2[0],
	                    b = _ref2[1];
	
	                return [b, a];
	            }));
	        }
	        reverseOutdated = false;
	    };
	    return {
	        getValue: function getValue(key) {
	            if (cache.has(key)) {
	                return cache.get(key);
	            }
	            var value = func(key);
	            if (value === key) {
	                return value;
	            }
	            cache.set(key, value);
	            reverseOutdated = true;
	            return value;
	        },
	        delete: function _delete() {
	            cache.delete.apply(cache, arguments);
	            reverseOutdated = true;
	        },
	        reset: function reset() {
	            cache.clear();
	            reverseCache.clear();
	        },
	        keys: function keys() {
	            return Array.from(cache.keys());
	        },
	        values: function values() {
	            updateReverse();
	            return Array.from(reverseCache.keys());
	        },
	        getKey: function getKey(value) {
	            updateReverse();
	            if (reverseCache.has(value)) {
	                return reverseCache.get(value);
	            }
	            return value;
	        }
	    };
	}

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	var wellKnownSymbol = __webpack_require__(35);
	var V8_VERSION = __webpack_require__(307);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	var isArray = __webpack_require__(121);
	var wellKnownSymbol = __webpack_require__(35);
	
	var SPECIES = wellKnownSymbol('species');
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray, length) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
	};


/***/ }),
/* 165 */
113,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toPrimitive = __webpack_require__(221);
	var definePropertyModule = __webpack_require__(49);
	var createPropertyDescriptor = __webpack_require__(165);
	
	module.exports = function (object, key, value) {
	  var propertyKey = toPrimitive(key);
	  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
	  else object[propertyKey] = value;
	};


/***/ }),
/* 167 */
137,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(21);
	
	var PromiseCapability = function (C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	};
	
	// 25.4.1.5 NewPromiseCapability(C)
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var defineProperties = __webpack_require__(1058);
	var enumBugKeys = __webpack_require__(308);
	var hiddenKeys = __webpack_require__(215);
	var html = __webpack_require__(466);
	var documentCreateElement = __webpack_require__(306);
	var sharedKey = __webpack_require__(316);
	
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	
	var EmptyConstructor = function () { /* empty */ };
	
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};
	
	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};
	
	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    /* global ActiveXObject */
	    activeXDocument = document.domain && new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	
	hiddenKeys[IE_PROTO] = true;
	
	// `Object.create` method
	// https://tc39.github.io/ecma262/#sec-object.create
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : defineProperties(result, Properties);
	};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	// `RequireObjectCoercible` abstract operation
	// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on " + it);
	  return it;
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(87);
	
	var max = Math.max;
	var min = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	module.exports = function (index, length) {
	  var integer = toInteger(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.clients
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var close_reason_1 = __webpack_require__(491);
	var enumerize_1 = __webpack_require__(103);
	/**
	 * Enum representing the reason that the session has been closed.
	 *
	 * **Example:**
	 * ```
	 * diffusion.connect({...}).then(function(session) {...}, function(err) {
	 *   switch(err) {
	 *       case diffusion.clients.CloseReason.CLOSED_BY_CLIENT:
	 *       // Do something
	 *       case diffusion.clients.CloseReason.ACCESS_DENIED:
	 *       // Do something else
	 *       ...
	 *   }
	 * });
	 * ```
	 *
	 */ // tslint:disable-next-line:variable-name
	exports.CloseReasonEnum = {
	    /**
	     * The client requested close. Not recoverable.
	     */
	    CLOSED_BY_CLIENT: new close_reason_1.CloseReasonImpl(0, 'The session was closed by the client', false),
	    /**
	     * The session has been closed by the server, or another session using the
	     * {@link ClientControl} feature.
	     */
	    CLOSED_BY_SERVER: new close_reason_1.CloseReasonImpl(1, 'The session was closed by the server', false),
	    /**
	     * Whilst disconnected, the client explicitly aborted a reconnect attempt.
	     */
	    RECONNECT_ABORTED: new close_reason_1.CloseReasonImpl(2, 'Client aborted a reconnect attempt', false),
	    /**
	     * The connection attempt timed out, waiting for a response from the server.
	     *
	     * The reconnection timeout can be controlled by the {@link
	     * Options.reconnect reconnect} options.
	     */
	    CONNECTION_TIMEOUT: new close_reason_1.CloseReasonImpl(3, 'The connection attempt timed out', false),
	    /**
	     * The connection handshake was rejected by the server.
	     *
	     * The server responded with an unknown error code when the client attempted
	     * to connect.
	     */
	    HANDSHAKE_REJECTED: new close_reason_1.CloseReasonImpl(4, 'The connection handshake was rejected by the server', false),
	    /**
	     * There was an error parsing the handshake response.
	     *
	     * The client received a handshake response from the server but the response
	     * was malformed and could not be deserialised.
	     */
	    HANDSHAKE_ERROR: new close_reason_1.CloseReasonImpl(5, 'There was an error parsing the handshake response', false),
	    /**
	     * There was an unexpected error with the network connection.
	     *
	     * The underlying transport (Websocket, XHR) received an error that could
	     * not be handled.
	     */
	    TRANSPORT_ERROR: new close_reason_1.CloseReasonImpl(6, 'There was an unexpected error with the connection', true),
	    /**
	     * The client could not establish a connection to the server.
	     *
	     * An error was thrown while the client was attempting to connect to the
	     * server.
	     */
	    CONNECTION_ERROR: new close_reason_1.CloseReasonImpl(7, 'The client could not establish a connection to the server', true),
	    /**
	     * The client detected that the connection was idle.
	     *
	     * The client has not received a ping message from the server for an
	     * extended period of time.
	     */
	    IDLE_CONNECTION: new close_reason_1.CloseReasonImpl(8, 'The activity monitor detected the connection was idle', true),
	    /**
	     * Loss of messages from the client has been detected. For example,
	     * whilst waiting for the arrival of missing messages in a sequence of
	     * messages a timeout has occurred.
	     *
	     * HTTP based transports use multiple TCP connections. This can cause
	     * the messages to be received out of order. To reorder the messages
	     * those sent to the server may contain a sequence number indicating the
	     * correct order.
	     *
	     * If a message is received out of order there is a short time for the
	     * earlier messages to be received. If the messages are not received in
	     * this time the client is closed.
	     *
	     * Missing, invalid or duplicate sequence numbers will also close the
	     * client for this reason.
	     *
	     * This cannot be recovered from as the client and the server are in
	     * inconsistent states.
	     */
	    LOST_MESSAGES: new close_reason_1.CloseReasonImpl(16, 'Loss of messages has been detected', false),
	    /**
	     * The handshake response contained an incompatible protocol version.
	     *
	     * The server does not support the client's protocol version.
	     */
	    PROTOCOL_VERSION_MISMATCH: new close_reason_1.CloseReasonImpl(17, 'There was a mismatch in the protocol versions', false),
	    /**
	     * The connection request was rejected because the license limit was reached.
	     */
	    LICENSE_EXCEEDED: new close_reason_1.CloseReasonImpl(18, 'The license limit was exceeded', false),
	    /**
	     * The connection attempt failed due to a security restraint or due to
	     * invalid credentials.
	     */
	    ACCESS_DENIED: new close_reason_1.CloseReasonImpl(99, 'The connection attempt was rejected by the server because authentication failed', false)
	};
	enumerize_1.enumerize(exports.CloseReasonEnum);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.locks
	 *
	 * Provide access to {@link SessionLockScope}
	 *
	 * **Example:**
	 * ```
	 * // Get a reference to the security feature
	 * var locks = diffusion.locks;
	 * ```
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Enum containing <code>scope</code> parameter of {@link Session.lock}
	 *
	 * **Example:**
	 * ```
	 * // Get the ALL_FIXED_PROPERTIES key
	 * var scope = diffusion.locks.SessionLockScope.UNLOCK_ON_SESSION_LOSS;
	 * ```
	 *
	 * @since 6.2
	 */
	var SessionLockScope;
	(function (SessionLockScope) {
	    /**
	     * The lock will be released when the acquiring session is closed.
	     */
	    SessionLockScope[SessionLockScope["UNLOCK_ON_SESSION_LOSS"] = 0] = "UNLOCK_ON_SESSION_LOSS";
	    /**
	     * The lock will be released when the acquiring session loses its
	     * current connection to the server.
	     */
	    SessionLockScope[SessionLockScope["UNLOCK_ON_CONNECTION_LOSS"] = 1] = "UNLOCK_ON_CONNECTION_LOSS";
	})(SessionLockScope = exports.SessionLockScope || (exports.SessionLockScope = {}));
	// tslint:disable-next-line:variable-name
	exports.SessionLockOptions = {
	    SessionLockScope: SessionLockScope
	};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module CBOR
	 *
	 * @brief This module contains functions and classes to encode and decode CBOR to and
	 * from a `Buffer`.
	 *
	 * Follows [RFC 7049](https://tools.ietf.org/html/rfc7049#section-2.1) standard
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The data types that can be encoded in CBOR
	 *
	 * Follows [RFC 7049](https://tools.ietf.org/html/rfc7049#section-2.1) standard
	 * for the major type.
	 */
	var types;
	(function (types) {
	    types[types["UINT"] = 0] = "UINT";
	    types[types["INT"] = 1] = "INT";
	    types[types["BYTES"] = 2] = "BYTES";
	    types[types["STRING"] = 3] = "STRING";
	    types[types["ARRAY"] = 4] = "ARRAY";
	    types[types["MAP"] = 5] = "MAP";
	    types[types["SEMANTIC"] = 6] = "SEMANTIC";
	    types[types["SIMPLE"] = 7] = "SIMPLE";
	    types[types["FLOAT"] = 7] = "FLOAT";
	})(types = exports.types || (exports.types = {}));
	/**
	 * Additional information about a data type
	 *
	 * Follows [RFC 7049](https://tools.ietf.org/html/rfc7049#section-2.3) standard
	 * for additional information on floating-point numbers and values with no content.
	 */
	var additional;
	(function (additional) {
	    additional[additional["FALSE"] = 20] = "FALSE";
	    additional[additional["TRUE"] = 21] = "TRUE";
	    additional[additional["NULL"] = 22] = "NULL";
	    additional[additional["UNDEFINED"] = 23] = "UNDEFINED";
	    additional[additional["SIMPLE"] = 24] = "SIMPLE";
	    additional[additional["HALF_PRECISION"] = 25] = "HALF_PRECISION";
	    additional[additional["SINGLE_PRECISION"] = 26] = "SINGLE_PRECISION";
	    additional[additional["DOUBLE_PRECISION"] = 27] = "DOUBLE_PRECISION";
	    additional[additional["BREAK"] = 31] = "BREAK";
	})(additional = exports.additional || (exports.additional = {}));
	exports.BYTE_BREAK = 255;
	/**
	 * Token types
	 */
	var tokens;
	(function (tokens) {
	    tokens[tokens["ARRAY_START"] = 0] = "ARRAY_START";
	    tokens[tokens["ARRAY_END"] = 1] = "ARRAY_END";
	    tokens[tokens["MAP_START"] = 2] = "MAP_START";
	    tokens[tokens["MAP_END"] = 3] = "MAP_END";
	    tokens[tokens["STRING_START"] = 4] = "STRING_START";
	    tokens[tokens["STRING_END"] = 5] = "STRING_END";
	    tokens[tokens["VALUE"] = 6] = "VALUE";
	})(tokens = exports.tokens || (exports.tokens = {}));
	/**
	 * Utility function to check for starting tokens of arrays, maps, or strings
	 *
	 * @param  token the token to check
	 * @return       `true` if the token starts a structure
	 */
	function isStructStart(token) {
	    switch (token) {
	        case tokens.ARRAY_START:
	        case tokens.MAP_START:
	        case tokens.STRING_START:
	            return true;
	        default:
	            return false;
	    }
	}
	exports.isStructStart = isStructStart;
	/**
	 * Utility function to check for ending tokens of arrays, maps, or strings
	 *
	 * @param  token the token to check
	 * @return       `true` if the token ends a structure
	 */
	function isStructEnd(token) {
	    switch (token) {
	        case tokens.ARRAY_END:
	        case tokens.MAP_END:
	        case tokens.STRING_END:
	            return true;
	        default:
	            return false;
	    }
	}
	exports.isStructEnd = isStructEnd;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(339);
	var Logger = __webpack_require__(17);
	var logger = Logger.create('Registration');
	/**
	 * State of a response handler
	 */
	var ResponseHandlerState;
	(function (ResponseHandlerState) {
	    ResponseHandlerState[ResponseHandlerState["REGISTERING"] = 0] = "REGISTERING";
	    ResponseHandlerState[ResponseHandlerState["ACTIVE"] = 1] = "ACTIVE";
	    ResponseHandlerState[ResponseHandlerState["CLOSED"] = 2] = "CLOSED";
	})(ResponseHandlerState = exports.ResponseHandlerState || (exports.ResponseHandlerState = {}));
	/**
	 * An error that indicating that a user defined handler has thrown an exception.
	 */
	var RegisteredHandlerException = /** @class */ (function (_super) {
	    __extends(RegisteredHandlerException, _super);
	    /**
	     * Create a RegisteredHandlerException
	     *
	     * @param  cause     the exception thrown by the user defined handler
	     * @param  ...args   additional parameters passed to the `Error` constructor
	     */
	    function RegisteredHandlerException(cause) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _this = _super.apply(this, __spread(args)) || this;
	        _this.cause = cause;
	        return _this;
	    }
	    return RegisteredHandlerException;
	}(Error));
	/**
	 * Create a new response handler
	 *
	 * @param  internal        the internal session
	 * @param  adapter         the registration adapter
	 * @param  deregistration  the deregistration callback
	 * @return                 a new response handler
	 */
	function responseHandler(internal, adapter, deregistration) {
	    var state = ResponseHandlerState.REGISTERING;
	    var close;
	    return {
	        onDiscard: function (cid, err) {
	            try {
	                if (err instanceof internal.getContext().CloseReason) {
	                    adapter.close();
	                }
	                else {
	                    adapter.close(err);
	                }
	            }
	            catch (err) {
	                logger.error('REGISTERED_HANDLER_EXCEPTION', err);
	            }
	            state = ResponseHandlerState.CLOSED;
	        },
	        onOpen: function (cid) {
	            close = function () {
	                return new Promise(function (resolve, reject) {
	                    if (state !== ResponseHandlerState.CLOSED) {
	                        deregistration(cid, function (err) {
	                            if (err) {
	                                internal.getConversationSet().discard(cid, err);
	                                reject(err);
	                            }
	                            else {
	                                internal.getConversationSet().respondIfPresent(cid, ResponseHandlerState.CLOSED);
	                                resolve();
	                            }
	                        });
	                    }
	                    else {
	                        reject(new Error('Handler already closed'));
	                    }
	                });
	            };
	        },
	        onResponse: function (cid, response) {
	            if (response === ResponseHandlerState.CLOSED) {
	                try {
	                    adapter.close();
	                }
	                catch (err) {
	                    logger.error('REGISTERED_HANDLER_EXCEPTION', err);
	                }
	                state = response;
	                return true;
	            }
	            try {
	                if (response === ResponseHandlerState.ACTIVE) {
	                    adapter.active(close, cid);
	                    state = response;
	                    return false;
	                }
	                else {
	                    return adapter.respond(response);
	                }
	            }
	            catch (err) {
	                logger.error('REGISTERED_HANDLER_EXCEPTION', err);
	                internal.getConversationSet().discard(cid, new RegisteredHandlerException(err, 'An error was thrown by the handler'));
	                close().catch(function (closeErr) {
	                    logger.debug('Failed to deregister with the server', closeErr);
	                });
	            }
	            return true;
	        }
	    };
	}
	exports.responseHandler = responseHandler;
	/**
	 * Create a registration callback function
	 *
	 * @param conversationSet  the conversation set
	 * @param cid              the conversation ID
	 * @param emitter          the emitter to emit events on
	 * @return                 a new registration callback function
	 */
	function registrationCallback(conversationSet, cid, resolve, reject) {
	    return function (err) {
	        if (err) {
	            conversationSet.discard(cid, err);
	            reject(err);
	        }
	        else {
	            conversationSet.respondIfPresent(cid, ResponseHandlerState.ACTIVE);
	            resolve();
	        }
	    };
	}
	exports.registrationCallback = registrationCallback;
	/**
	 * Register a handler with the conversation set.
	 *
	 * @param internal  the internal session
	 * @param params    the registration parameters to send to the server
	 * @param adapter   the registration adapter
	 * @param reg       the registration service that is used to register with the server
	 * @param dereg     the deregistration service that is used to deregister with the server
	 */
	function registerHandler(internal, params, adapter, reg, dereg) {
	    return __awaiter(this, void 0, void 0, function () {
	        var conversationSet, serviceLocator, registration, deregistration, cid;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    conversationSet = internal.getConversationSet();
	                    serviceLocator = internal.getServiceLocator();
	                    registration = serviceLocator.obtain(reg);
	                    deregistration = serviceLocator.obtain(dereg);
	                    return [4 /*yield*/, conversationSet.newConversation(responseHandler(internal, adapter, function (conversationId, callback) {
	                            deregistration.send(params, callback);
	                        }))];
	                case 1:
	                    cid = _a.sent();
	                    return [2 /*return*/, new Promise(function (resolve, reject) {
	                            registration.send({ params: params, cid: cid }, registrationCallback(conversationSet, cid, resolve, reject));
	                        })];
	            }
	        });
	    });
	}
	exports.registerHandler = registerHandler;
	/**
	 * Register a handler for the messaging service
	 *
	 * @param internal  the internal session
	 * @param params    the registration parameters to send to the server
	 * @param adapter   the registration adapter
	 */
	function registerRequestHandler(internal, params, adapter) {
	    return registerHandler(internal, params, adapter, Services.MESSAGING_RECEIVER_CONTROL_REGISTRATION, Services.MESSAGING_RECEIVER_CONTROL_DEREGISTRATION);
	}
	exports.registerRequestHandler = registerRequestHandler;
	/**
	 * Register a handler for topic control notifications
	 *
	 * @param internal  the internal session
	 * @param params    the registration parameters to send to the server
	 * @param adapter   the registration adapter
	 */
	function registerTopicHandler(internal, params, adapter) {
	    return registerHandler(internal, params, adapter, Services.TOPIC_CONTROL_REGISTRATION, Services.TOPIC_CONTROL_DEREGISTRATION);
	}
	exports.registerTopicHandler = registerTopicHandler;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var P16 = 1 << 16;
	var P24 = 1 << 24;
	var P32 = P16 * P16;
	/**
	 * Store a 32 bit integer in the buffer
	 *
	 * @param  value   the 32 bit integer to store
	 * @param  buffer  the buffer to write into
	 * @param  high    a flag indicating whether to store the integer in the high or
	 *                 the low bits of the buffer
	 */
	function putInt32(value, buffer, high) {
	    var offset = high ? 0 : 4;
	    for (var i = 3; i >= 0; --i) {
	        buffer[offset + i] = value & 255;
	        value = value >> 8;
	    }
	}
	/**
	 * Read a 32 bit integer from the buffer
	 *
	 * @param  buffer  the buffer to write into
	 * @param  high    a flag indicating whether to read the high or
	 *                 the low bits of the buffer
	 * @return         the integer that was read from the buffer
	 */
	function getInt32(buffer, high) {
	    var offset = high ? 0 : 4;
	    return (buffer[offset] * P24) +
	        (buffer[offset + 1] << 16) +
	        (buffer[offset + 2] << 8) +
	        buffer[offset + 3];
	}
	/**
	 * Store a positive number in the buffer
	 *
	 * @param  value   the number to store
	 * @param  buffer  the buffer to write into
	 */
	function putPositiveNumber(value, buffer) {
	    for (var i = 7; i >= 0; --i) {
	        buffer[i] = value & 255;
	        value /= 256;
	    }
	}
	/**
	 * Store a negative number in the buffer
	 *
	 * @param  value   the number to store
	 * @param  buffer  the buffer to write into
	 */
	function putNegativeNumber(value, buffer) {
	    value++;
	    for (var i = 7; i >= 0; --i) {
	        buffer[i] = ((-value) & 255) ^ 255;
	        value /= 256;
	    }
	}
	/**
	 * Store an integer represented by a string in the buffer
	 *
	 * @param  value   the string containing the number to store
	 * @param  radix   the radix of the number representation
	 * @param  buffer  the buffer to write into
	 */
	function putString(value, radix, buffer) {
	    var e_1, _a;
	    var negative = value[0] === '-';
	    if (negative) {
	        value = value.substring(1);
	    }
	    else if (value.substring(0, 2) === '0x') {
	        value = value.substring(2);
	        radix = 16;
	    }
	    var high = 0;
	    var low = 0;
	    try {
	        for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
	            var char = value_1_1.value;
	            low = low * radix + parseInt(char, radix);
	            high = high * radix + Math.floor(low / P32);
	            low %= P32;
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    if (negative) {
	        high = ~high;
	        if (low) {
	            low = P32 - low;
	        }
	        else {
	            high++;
	        }
	    }
	    putInt32(high, buffer, true);
	    putInt32(low, buffer, false);
	}
	/**
	 * Implementation of signed 64-bit integer. May be constructed from a buffer, string or number.
	 */
	var Int64Impl = /** @class */ (function () {
	    /**
	     * Create a new Int64Impl instance
	     *
	     * @param  value  the value of the integer
	     * @param  radix  if `value` is a string the represents the radix and
	     *                defaults to 10. If value is a number, this represents the
	     *                optional low bits of the number.           description
	     */
	    function Int64Impl(value, radix) {
	        this.buffer = Buffer.from([0, 0, 0, 0, 0, 0, 0, 0]);
	        if (Buffer.isBuffer(value)) {
	            this.buffer = value;
	        }
	        if (typeof value === 'string') {
	            radix = radix || 10;
	            putString(value, radix, this.buffer);
	        }
	        if (typeof value === 'number') {
	            // explicit high/low bits
	            if (typeof radix === 'number') {
	                putInt32(value, this.buffer, true);
	                putInt32(radix, this.buffer, false);
	            }
	            else if (value >= 0) {
	                putPositiveNumber(value, this.buffer);
	            }
	            else {
	                putNegativeNumber(value, this.buffer);
	            }
	        }
	        if (value instanceof Int64Impl) {
	            putInt32(value.getHighBits(), this.buffer, true);
	            putInt32(value.getLowBits(), this.buffer, false);
	        }
	    }
	    /**
	     * Return the name of the data type
	     *
	     * @return `Int64Impl`
	     */
	    Int64Impl.toString = function () {
	        return 'Int64Impl';
	    };
	    /**
	     * Get the high bits of the integer
	     *
	     * @return the high bits of the number
	     */
	    Int64Impl.prototype.getHighBits = function () {
	        return getInt32(this.buffer, true);
	    };
	    /**
	     * Get the low bits of the integer
	     *
	     * @return the low bits of the number
	     */
	    Int64Impl.prototype.getLowBits = function () {
	        return getInt32(this.buffer, false);
	    };
	    /**
	     * Get the integer stored in a buffer
	     *
	     * @return  the internal buffer
	     */
	    Int64Impl.prototype.toBuffer = function () {
	        return this.buffer;
	    };
	    /**
	     * @inheritdoc
	     */
	    Int64Impl.prototype.toNumber = function () {
	        var high = this.getHighBits() | 0;
	        var low = this.getLowBits();
	        // this is a lossy operation - see docs. Will be accurate for numbers up to 2 ^ 53
	        return high ? high * P32 + low : low;
	    };
	    /**
	     * Check is the number is negative
	     *
	     * @return  `true` if the integer is negative
	     */
	    Int64Impl.prototype.isNegative = function () {
	        return !!(this.getHighBits() & 0x80000000);
	    };
	    /**
	     * @inheritdoc
	     */
	    Int64Impl.prototype.toString = function (radix) {
	        if (radix === void 0) { radix = 10; }
	        var high = this.getHighBits();
	        var low = this.getLowBits();
	        var sign = this.isNegative();
	        if (sign) {
	            high = ~high;
	            low = P32 - low;
	        }
	        if (high === 0 && low === 0) {
	            return '0';
	        }
	        var result = '';
	        while (high || low) {
	            // multiply modulo remainder up to its 'real' value (since it
	            // represents the top 32 bits of a single value)
	            var rem = (high % radix) * P32 + low;
	            // divide by radix, essentially reducing the high/low values by the
	            // digits we've taken from the modulo remainder. We can't use
	            // bitwise operations to coerce to integer, as that would truncate
	            // to 32 bits
	            high = Math.floor(high / radix);
	            low = Math.floor(rem / radix);
	            result = (rem % radix).toString(radix) + result;
	        }
	        if (sign) {
	            result = '-' + result;
	        }
	        return result;
	    };
	    /**
	     * Check if the number is equal to another object
	     *
	     * @return  `true` if the other object is an Int64Impl containing the same
	     *          data
	     */
	    Int64Impl.prototype.equals = function (other) {
	        if (other && other instanceof Int64Impl) {
	            return this.getHighBits() === other.getHighBits() && this.getLowBits() === other.getLowBits();
	        }
	        return false;
	    };
	    return Int64Impl;
	}());
	exports.Int64Impl = Int64Impl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Protocol
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enumerize_1 = __webpack_require__(103);
	/**
	 * Create a new response code
	 *
	 * @param  id       the respnse code id
	 * @param  message  the message
	 * @return          a new response code
	 */
	function code(id, message) {
	    return {
	        id: id,
	        message: message
	    };
	}
	/**
	 * Connection handshake response codes
	 */
	exports.responseCodes = {
	    OK: code(100, 'Connected successfully'),
	    DOWNGRADE: code(102, 'Server does not support the requested protocol level'),
	    RECONNECTED: code(105, 'Reconnected successfully'),
	    RECONNECTED_WITH_MESSAGE_LOSS: code(106, 'Reconnected with message loss'),
	    LICENSE_EXCEEDED: code(113, 'Connection rejected due to license limit'),
	    RECONNECTION_UNSUPPORTED: code(114, 'Reconnection not supported by connector'),
	    CONNECTION_PROTOCOL_ERROR: code(115, 'Connection failed - protocol error'),
	    AUTHENTICATION_FAILED: code(116, 'Connection failed - authentication failed'),
	    UNKNOWN_SESSION: code(117, 'Reconnection failed - the session is unknown'),
	    RECONNECTION_FAILED_MESSAGE_LOSS: code(118, 'Reconnection failed due to message loss'),
	    REJECTED_SERVER_INITIALISING: code(119, 'Connection rejected because the server is not ready'),
	};
	enumerize_1.enumerize(exports.responseCodes);
	/**
	 * Check if the response code indicates a success
	 *
	 * @param  responseCode  the response code
	 * @return               `true` if the response code indicates a success
	 */
	function isSuccess(responseCode) {
	    switch (responseCode) {
	        case exports.responseCodes.OK:
	        case exports.responseCodes.RECONNECTED:
	        case exports.responseCodes.RECONNECTED_WITH_MESSAGE_LOSS:
	            return true;
	        default:
	            return false;
	    }
	}
	exports.isSuccess = isSuccess;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_list_1 = __webpack_require__(1287);
	var error_report_serialiser_1 = __webpack_require__(233);
	/**
	 * Serialiser for {@link ErrorReportList}
	 */
	var ErrorReportListSerialiserClass = /** @class */ (function (_super) {
	    __extends(ErrorReportListSerialiserClass, _super);
	    function ErrorReportListSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ErrorReportList} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link ErrorReportList} that was read
	     */
	    ErrorReportListSerialiserClass.prototype.read = function (input) {
	        var errors = Codec.readCollection(input, error_report_serialiser_1.ErrorReportSerialiser.read);
	        return new error_report_list_1.ErrorReportList(errors);
	    };
	    /**
	     * Write a {@link ErrorReportList} to the stream
	     *
	     * @param bis   the input stream
	     * @param value the {@link ErrorReportList} to be written
	     */
	    ErrorReportListSerialiserClass.prototype.write = function (output, value) {
	        Codec.writeCollection(output, value.errors, error_report_serialiser_1.ErrorReportSerialiser.write);
	    };
	    return ErrorReportListSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ErrorReportListSerialiserClass = ErrorReportListSerialiserClass;
	/**
	 * The {@link ErrorReportListSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ErrorReportListSerialiser = new ErrorReportListSerialiserClass();


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_datatype_1 = __webpack_require__(144);
	var buffer_slice_1 = __webpack_require__(229);
	var bytes_impl_1 = __webpack_require__(102);
	var datatypes_1 = __webpack_require__(78);
	var buffer_input_stream_1 = __webpack_require__(125);
	var buffer_output_stream_1 = __webpack_require__(80);
	var Codec = __webpack_require__(3);
	var time_series_event_1 = __webpack_require__(340);
	var time_series_event_metadata_serialiser_1 = __webpack_require__(536);
	/**
	 * Event type constants
	 */
	var EventType;
	(function (EventType) {
	    EventType[EventType["ORIGINAL_EVENT"] = 0] = "ORIGINAL_EVENT";
	    EventType[EventType["EDIT_EVENT"] = 1] = "EDIT_EVENT";
	})(EventType || (EventType = {}));
	/**
	 * A converter function that converts an event to bytes data
	 *
	 * @param valueToBytes  a converter function that converts an underlying value to bytes data
	 * @param event         the event to convert
	 * @return              the bytes containing the event
	 */
	function eventToBytes(valueToBytes, event) {
	    if (!event) {
	        throw new Error('Cannot convert null event to Bytes');
	    }
	    return new bytes_impl_1.BytesImpl(writeValue(valueToBytes, event));
	}
	/**
	 * A converter function that converts an event to buffer data
	 *
	 * @param valueToBytes  a converter function that converts an underlying value to bytes data
	 * @param event         the event to convert
	 * @return              the buffer containing the event
	 */
	function writeValue(valueToBytes, event) {
	    var output = new buffer_output_stream_1.BufferOutputStream();
	    if (event.isEditEvent) {
	        Codec.writeByte(output, EventType.EDIT_EVENT);
	        time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser.write(output, event.originalEvent);
	    }
	    else {
	        Codec.writeByte(output, EventType.ORIGINAL_EVENT);
	    }
	    time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser.write(output, event);
	    var serialised = valueToBytes(event.value);
	    Codec.writeBytes(output, serialised.$buffer);
	    return output.getBuffer();
	}
	/**
	 * A converter function that converts bytes data to an event
	 *
	 * @param bytesToValue  a converter function that converts bytes data to an underlying value
	 * @param bytes         the bytes containing the event in binary form
	 * @return              the event that was extracted from the bytes
	 */
	function bytesToEvent(bytesToValue, bytes) {
	    var input = new buffer_input_stream_1.BufferInputStream(bytes.$buffer);
	    var eventType = Codec.readByte(input);
	    switch (eventType) {
	        case EventType.ORIGINAL_EVENT:
	            return readOriginalEvent(bytesToValue, input);
	        case EventType.EDIT_EVENT:
	            return readEditEvent(bytesToValue, input);
	        default:
	            throw new Error('Unrecognised event type: ' + eventType);
	    }
	}
	/**
	 * Read an original event from an input stream
	 *
	 * @param bytesToValue a converter function that converts a byte data to a value
	 * @param input        the input stream
	 * @return             the event that was read from the stream
	 */
	function readOriginalEvent(bytesToValue, input) {
	    var metadata = time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser.read(input);
	    var value = bytesToValue(Codec.readBytes(input));
	    return time_series_event_1.EventImpl.create(metadata, metadata, value);
	}
	/**
	 * Read an edit event from an input stream
	 *
	 * @param bytesToValue a converter function that converts a byte data to a value
	 * @param input        the input stream
	 * @return             the event that was read from the stream
	 */
	function readEditEvent(bytesToValue, input) {
	    var originalEvent = time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser.read(input);
	    var metadata = time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser.read(input);
	    var value = bytesToValue(Codec.readBytes(input));
	    return time_series_event_1.EventImpl.create(metadata, originalEvent, value);
	}
	/**
	 * A data type for time series {@link Event} values
	 *
	 * @param <ValueType>   the value type of the data type
	 * @param <SourceType>  the type(s) from which a value can be constructed
	 */
	var TimeSeriesEventDataType = /** @class */ (function (_super) {
	    __extends(TimeSeriesEventDataType, _super);
	    /**
	     * Create a new TimeSeriesEventDataType instance
	     *
	     * @param name  the name of the data type
	     * @param valueTypeName  the data type name of the event's value type
	     * @param bytesToValue a converter function that converts a byte data to a value
	     * @param valueToBytes a converter function that converts a value to bytes data
	     */
	    function TimeSeriesEventDataType(name, valueTypeName, bytesToValue, valueToBytes) {
	        var _this = this;
	        var eventValueType = datatypes_1.DataTypes.getByName(valueTypeName);
	        var converters = eventValueType !== undefined
	            ? [{
	                    name: eventValueType.valueClass.toString(),
	                    convert: function (buffer, offset, length) {
	                        var bytes = new bytes_impl_1.BytesImpl(buffer, offset, length);
	                        var event = bytesToEvent(bytesToValue, bytes);
	                        return event.value;
	                    }
	                }]
	            : [];
	        _this = _super.call(this, name, time_series_event_1.EventImpl, bytes_impl_1.BytesImpl, function (e) {
	            return eventToBytes(valueToBytes, e);
	        }, function (b) {
	            return bytesToEvent(bytesToValue, b);
	        }, converters, true) || this;
	        _this.valueToBytes = valueToBytes;
	        _this.valueTypeName = valueTypeName;
	        return _this;
	    }
	    /**
	     * Create a new time series event datatype from a delegate datatype.
	     *
	     * @param  delegate  the delegate data type
	     * @param <ValueType>   the value type of the data type
	     * @param <SourceType>  the type(s) from which a value can be constructed
	     * @param <CBORType>    the binary type containing the CBOR data
	     */
	    TimeSeriesEventDataType.create = function (delegate) {
	        return new TimeSeriesEventDataType("timeseriesevent-" + delegate.name(), delegate.name(), delegate.readValue.bind(delegate), delegate.toBytes.bind(delegate));
	    };
	    /**
	     * @inheritdoc
	     */
	    TimeSeriesEventDataType.prototype.writeValue = function (event) {
	        return writeValue(this.valueToBytes, event);
	    };
	    /**
	     * @inheritdoc
	     */
	    TimeSeriesEventDataType.prototype.validate = function () {
	        // no-op: validates on read
	    };
	    /**
	     * @inheritdoc
	     */
	    TimeSeriesEventDataType.prototype.from = function (value) {
	        return (value instanceof buffer_slice_1.BufferSlice)
	            ? value
	            : this.valueToBytes(value.value);
	    };
	    return TimeSeriesEventDataType;
	}(abstract_datatype_1.AbstractDataType));
	exports.TimeSeriesEventDataType = TimeSeriesEventDataType;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(128);
	/**
	 * An abstract implementation of {@link TopicSelector}
	 */
	var AbstractTopicSelector = /** @class */ (function () {
	    /**
	     * Create a new AbstractTopicSelector
	     *
	     * @param  type        the type of this selector
	     * @param  prefix      the maximum topic path prefix from this selector
	     * @param  expression  the original expression of this selector
	     */
	    function AbstractTopicSelector(type, prefix, expression) {
	        this.type = type;
	        this.prefix = prefix;
	        this.expression = expression;
	    }
	    /**
	     * @inheritdoc
	     */
	    AbstractTopicSelector.prototype.selects = function (topicPath) {
	        var canonical = util.canonicalise(topicPath);
	        return canonical.indexOf(this.prefix) === 0 && this.doSelects(canonical);
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractTopicSelector.prototype.toString = function () {
	        return this.expression;
	    };
	    return AbstractTopicSelector;
	}());
	exports.AbstractTopicSelector = AbstractTopicSelector;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.selectors
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A Topic Selector Prefix
	 */
	var Prefix;
	(function (Prefix) {
	    /** Prefix used for {@link Type.PATH} expressions. */
	    Prefix["PATH"] = ">";
	    /** Prefix used for {@link Type.SPLIT_PATH_PATTERN} expressions. */
	    Prefix["SPLIT_PATH_PATTERN"] = "?";
	    /** Prefix used for {@link Type.FULL_PATH_PATTERN} expressions. */
	    Prefix["FULL_PATH_PATTERN"] = "*";
	    /** Prefix used for {@link Type.SELECTOR_SET} expressions. */
	    Prefix["SELECTOR_SET"] = "#";
	})(Prefix = exports.Prefix || (exports.Prefix = {}));
	/**
	 * Topic Selector type.
	 */
	var Type;
	(function (Type) {
	    /** A selector that selects a single topic. */
	    Type["PATH"] = ">";
	    /** A selector that is a split-path pattern. */
	    Type["SPLIT_PATH_PATTERN"] = "?";
	    /** A selector that is a full-path pattern. */
	    Type["FULL_PATH_PATTERN"] = "*";
	    /** A composite of multiple selectors. */
	    Type["SELECTOR_SET"] = "#";
	})(Type = exports.Type || (exports.Type = {}));


/***/ }),
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1504),
	    Map = __webpack_require__(349),
	    Promise = __webpack_require__(1506),
	    Set = __webpack_require__(1507),
	    WeakMap = __webpack_require__(556),
	    baseGetTag = __webpack_require__(131),
	    toSource = __webpack_require__(593);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(190);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(372),
	    isLength = __webpack_require__(373);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(557),
	    baseKeys = __webpack_require__(567),
	    isArrayLike = __webpack_require__(189);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
137,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	var classof = __webpack_require__(97);
	
	var split = ''.split;
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	module.exports = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins
	  return !Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) == 'String' ? split.call(it, '') : Object(it);
	} : Object;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	
	var replacement = /#|\.prototype\./;
	
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true
	    : value == NATIVE ? false
	    : typeof detection == 'function' ? fails(detection)
	    : !!detection;
	};
	
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	
	module.exports = isForced;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var propertyIsEnumerableModule = __webpack_require__(480);
	var createPropertyDescriptor = __webpack_require__(165);
	var toIndexedObject = __webpack_require__(100);
	var toPrimitive = __webpack_require__(221);
	var has = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(467);
	
	var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
	exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return nativeGetOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
	};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { error: false, value: exec() };
	  } catch (error) {
	    return { error: true, value: error };
	  }
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(49).f;
	var has = __webpack_require__(58);
	var wellKnownSymbol = __webpack_require__(35);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	
	module.exports = function (it, TAG, STATIC) {
	  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
	    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	// `ToPrimitive` abstract operation
	// https://tc39.github.io/ecma262/#sec-toprimitive
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (input, PREFERRED_STRING) {
	  if (!isObject(input)) return input;
	  var fn, val;
	  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
	  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
	  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(1064).charAt;
	var InternalStateModule = __webpack_require__(143);
	var defineIterator = __webpack_require__(305);
	
	var STRING_ITERATOR = 'String Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
	
	// `String.prototype[@@iterator]` method
	// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
	defineIterator(String, 'String', function (iterated) {
	  setInternalState(this, {
	    type: STRING_ITERATOR,
	    string: String(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return { value: undefined, done: true };
	  point = charAt(string, index);
	  state.index += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Session.notifications
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The type of topic notification that has been received.
	 */
	var TopicNotificationType;
	(function (TopicNotificationType) {
	    /**
	     * The topic was added.
	     */
	    TopicNotificationType[TopicNotificationType["ADDED"] = 0] = "ADDED";
	    /**
	     * The topic existed at the time of the selector registration.
	     */
	    TopicNotificationType[TopicNotificationType["SELECTED"] = 1] = "SELECTED";
	    /**
	     * The topic was removed.
	     */
	    TopicNotificationType[TopicNotificationType["REMOVED"] = 2] = "REMOVED";
	    /**
	     * The topic was deselected.
	     */
	    TopicNotificationType[TopicNotificationType["DESELECTED"] = 3] = "DESELECTED";
	})(TopicNotificationType = exports.TopicNotificationType || (exports.TopicNotificationType = {}));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module CBOR
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:no-bitwise */
	var buffer_output_stream_1 = __webpack_require__(80);
	var consts_1 = __webpack_require__(174);
	var int64_impl_1 = __webpack_require__(176);
	var TWO_POW_32 = 4294967296;
	/**
	 * Encoder to encode values into CBOR
	 */
	var Encoder = /** @class */ (function () {
	    /**
	     * Create an encoder
	     */
	    function Encoder() {
	        this.bos = new buffer_output_stream_1.BufferOutputStream();
	    }
	    /**
	     * Write a byte to the output stream
	     *
	     * @param byte the byte to wryte
	     */
	    Encoder.prototype.writeByte = function (byte) {
	        this.bos.write(byte);
	    };
	    /**
	     * Write a `Buffer` to the output stream
	     *
	     * @param buf the buffer to write
	     * @param offset the starting position in the buffer
	     * @param length the number of bytes to write
	     */
	    Encoder.prototype.writeBuffer = function (buf, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buf.length; }
	        this.bos.writeMany(buf, offset, length);
	    };
	    /**
	     * Write an unsigned 16 bit integer to the output stream
	     *
	     * @param val the integer to write
	     */
	    Encoder.prototype.writeUint16 = function (val) {
	        this.writeByte((val >> 8) & 0xff);
	        this.writeByte(val & 0xff);
	    };
	    /**
	     * Write an unsigned 32 bit integer to the output stream
	     *
	     * @param val the integer to write
	     */
	    Encoder.prototype.writeUint32 = function (val) {
	        this.writeUint16((val >> 16) & 0xffff);
	        this.writeUint16(val & 0xffff);
	    };
	    /**
	     * Write an unsigned 64 bit integer to the output stream
	     *
	     * @param val the integer to write
	     */
	    Encoder.prototype.writeUint64 = function (val) {
	        this.writeUint32(Math.floor(val / TWO_POW_32));
	        this.writeUint32(val % TWO_POW_32);
	    };
	    /**
	     * Write a break header to the output stream
	     *
	     * @param type the header type
	     */
	    Encoder.prototype.writeBreakHeader = function (type) {
	        this.writeByte(type << 5 | consts_1.additional.BREAK);
	    };
	    /**
	     * Write a token to the output stream
	     *
	     * @param  type the token type
	     * @param  val  the numeric value associated with the token
	     */
	    Encoder.prototype.writeToken = function (type, val) {
	        var first = type << 5;
	        if (val < 24) {
	            this.writeByte(first | val);
	        }
	        else if (val < 256) {
	            this.writeByte(first | 24);
	            this.writeByte(val);
	        }
	        else if (val < 65536) {
	            this.writeByte(first | 25);
	            this.writeUint16(val);
	        }
	        else if (val < TWO_POW_32) {
	            this.writeByte(first | 26);
	            this.writeUint32(val);
	        }
	        else {
	            this.writeByte(first | 27);
	            this.writeUint64(val);
	        }
	    };
	    /**
	     * Write a number of any type to the output stream
	     *
	     * @param val the number to write
	     */
	    Encoder.prototype.writeNumber = function (val) {
	        // determine if the number is int or not
	        if (val.toString().indexOf('.') > -1) {
	            /* Because Numbers are 53 bits, always write non-integers as doubles
	             * Can't bit-twiddle to figure out how to encode, as bitwise operations
	             * will coerce to a 32-bit integer under the hood.
	             */
	            var buf = Buffer.alloc(8);
	            buf.writeDoubleBE(val, 0);
	            this.writeByte((consts_1.types.SIMPLE << 5) | consts_1.additional.DOUBLE_PRECISION);
	            this.writeBuffer(buf);
	        }
	        else {
	            if (val < 0) {
	                this.writeToken(consts_1.types.INT, -1 - val);
	            }
	            else {
	                this.writeToken(consts_1.types.UINT, val);
	            }
	        }
	    };
	    /**
	     * Write a string to the output stream
	     *
	     * @param val the string to write
	     */
	    Encoder.prototype.writeString = function (val) {
	        var buf = Buffer.from(val, 'utf-8');
	        this.writeToken(consts_1.types.STRING, buf.length);
	        this.writeBuffer(buf);
	    };
	    /**
	     * Write a Binary value to the output stream
	     *
	     * @param buf the buffer that contains the binary value
	     * @param offset the starting position in the buffer
	     * @param length the number of bytes to write
	     */
	    Encoder.prototype.writeBinary = function (val, offset, length) {
	        if (length === void 0) { length = val.length; }
	        this.writeToken(consts_1.types.BYTES, length);
	        this.writeBuffer(val, offset, length);
	    };
	    /**
	     * Write a boolean to the output stream
	     *
	     * @param val the boolean to write
	     */
	    Encoder.prototype.writeBoolean = function (val) {
	        this.writeToken(consts_1.types.SIMPLE, val ? consts_1.additional.TRUE : consts_1.additional.FALSE);
	    };
	    /**
	     * Write `undefined` to the output stream
	     */
	    Encoder.prototype.writeUndefined = function () {
	        this.writeToken(consts_1.types.SIMPLE, consts_1.additional.UNDEFINED);
	    };
	    /**
	     * Write `null` to the output stream
	     */
	    Encoder.prototype.writeNull = function () {
	        this.writeToken(consts_1.types.SIMPLE, consts_1.additional.NULL);
	    };
	    /**
	     * Write an object to the output stream
	     *
	     * @param  val the object to encode
	     */
	    Encoder.prototype.writeObject = function (val) {
	        var e_1, _a;
	        var keys = Object.getOwnPropertyNames(val);
	        this.startObject();
	        try {
	            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
	                var key = keys_1_1.value;
	                this.encode(key);
	                this.encode(val[key]);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        this.break();
	    };
	    /**
	     * Write an array to the output stream
	     *
	     * @param  val the array to encode
	     */
	    Encoder.prototype.writeArray = function (val) {
	        var e_2, _a;
	        this.startArray();
	        try {
	            for (var val_1 = __values(val), val_1_1 = val_1.next(); !val_1_1.done; val_1_1 = val_1.next()) {
	                var entry = val_1_1.value;
	                this.encode(entry);
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (val_1_1 && !val_1_1.done && (_a = val_1.return)) _a.call(val_1);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        this.break();
	    };
	    /**
	     * Write a BREAK stop code. This is not constrained by any pre-written strucutural context.
	     *
	     * @returns this encoder
	     */
	    Encoder.prototype.break = function () {
	        this.writeBreakHeader(consts_1.types.SIMPLE);
	        return this;
	    };
	    /**
	     * Write the header for an array.
	     *
	     * Data may be subsequently written. No constraints are applied to subsequent data, i.e the header for a
	     * fixed-length array may be immediately followed by a break flag
	     *
	     * @param length the length of the array. If not provided, this array will be considered
	     *               indefinite-length
	     *
	     * @returns this encoder
	     */
	    Encoder.prototype.startArray = function (length) {
	        if (length === undefined) {
	            this.writeBreakHeader(consts_1.types.ARRAY);
	        }
	        else {
	            this.writeToken(consts_1.types.ARRAY, length);
	        }
	        return this;
	    };
	    /**
	     * Write the header for an object.
	     *
	     * Data may be subsequently written. No constraints are applied to subsequent data, i.e the header for a
	     * fixed-length object may be immediately followed by a break flag
	     *
	     * @param length the number of keys in the object. If not provided, this object will be considered
	     *               indefinite-length
	     *
	     * @returns this encoder
	     */
	    Encoder.prototype.startObject = function (length) {
	        if (length === undefined) {
	            this.writeBreakHeader(consts_1.types.MAP);
	        }
	        else {
	            this.writeToken(consts_1.types.MAP, length);
	        }
	        return this;
	    };
	    /**
	     * Write an {@link Int64Impl} value.
	     *
	     * @param val the int64 value to encode
	     * @returns this encoder
	     */
	    Encoder.prototype.writeInt64 = function (val) {
	        var high = val.getHighBits() | 0;
	        if (high === 0 || high === -1) {
	            this.writeNumber(val.toNumber());
	        }
	        else {
	            if (val.isNegative()) {
	                this.writeByte((consts_1.types.INT << 5) | 27);
	                var buf = Buffer.from(val.toBuffer());
	                for (var i = 0; i < 8; ++i) {
	                    buf[i] = ~buf[i];
	                }
	                this.writeBuffer(buf);
	            }
	            else {
	                this.writeByte((consts_1.types.UINT << 5) | 27);
	                this.writeBuffer(val.toBuffer());
	            }
	        }
	        return this;
	    };
	    /** Write a double value.
	     *
	     * @param val the double value to encode
	     * @returns this encoder
	     */
	    Encoder.prototype.writeDouble = function (val) {
	        var buf = Buffer.alloc(8);
	        buf.writeDoubleBE(val, 0);
	        this.writeByte((consts_1.types.SIMPLE << 5) | consts_1.additional.DOUBLE_PRECISION);
	        this.writeBuffer(buf);
	        return this;
	    };
	    /**
	     * Encode a value to a CBOR representation.
	     *
	     * If a buffer is provided, optional offset & length parameters may be provided to
	     * dictate which bytes are to be encoded.
	     *
	     * @param value the value to encode
	     * @param offset the offset to use if encoding a buffer. Defaults to 0
	     * @param length the length to use if encoding a buffer. Defaults to the length of the buffer
	     *
	     * @returns this encoder
	     */
	    Encoder.prototype.encode = function (value, offset, length) {
	        if (value instanceof Date) {
	            this.writeString(value.toJSON());
	        }
	        else if (value === null) {
	            this.writeNull();
	        }
	        else if (value === undefined) {
	            this.writeUndefined();
	        }
	        else if (value instanceof int64_impl_1.Int64Impl) {
	            this.writeInt64(value);
	        }
	        else {
	            switch (typeof value) {
	                case 'boolean':
	                    this.writeBoolean(value);
	                    break;
	                case 'string':
	                    this.writeString(value);
	                    break;
	                case 'number':
	                    this.writeNumber(value);
	                    break;
	                case 'object':
	                    if (Buffer.isBuffer(value)) {
	                        this.writeBinary(value, offset, length);
	                    }
	                    else if (Array.isArray(value)) {
	                        this.writeArray(value);
	                    }
	                    else {
	                        this.writeObject(value);
	                    }
	            }
	        }
	        return this;
	    };
	    /**
	     * Flush the encoded data and empty the internal buffer
	     *
	     * @return the contents of the buffer
	     */
	    Encoder.prototype.flush = function () {
	        var res = this.bos.getBuffer();
	        this.bos = new buffer_output_stream_1.BufferOutputStream();
	        return res;
	    };
	    return Encoder;
	}());
	exports.Encoder = Encoder;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Factory for command services, wrapping the service implementation to catch
	 * errors and dispatch an appropriate error response to the request callback.
	 *
	 * @param service the command service handler function
	 * @return        command service wrapper
	 */
	function create(service) {
	    return {
	        onRequest: function (internal, message, callback) {
	            try {
	                service(internal, message, callback);
	            }
	            catch (e) {
	                callback.fail(internal.getContext().ErrorReason.CALLBACK_EXCEPTION, e.message);
	            }
	        }
	    };
	}
	exports.create = create;


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a Control Group request.
	 */
	var ControlGroup = /** @class */ (function () {
	    /**
	     * Create a new ControlGroup instance
	     *
	     * @param name   the control group name
	     */
	    function ControlGroup(name) {
	        this.name = name;
	    }
	    return ControlGroup;
	}());
	exports.ControlGroup = ControlGroup;
	/**
	 * A default Control Group
	 */
	exports.DEFAULT = Object.freeze(new ControlGroup('default'));


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AnyDataTypeImpl = /** @class */ (function () {
	    function AnyDataTypeImpl() {
	        /**
	         * The constructor function creating the value type
	         */
	        this.valueClass = AnyDataTypeImpl;
	    }
	    /**
	     * @inheritdoc
	     */
	    AnyDataTypeImpl.prototype.name = function () {
	        return 'any';
	    };
	    return AnyDataTypeImpl;
	}());
	exports.AnyDataTypeImpl = AnyDataTypeImpl;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var decoder_1 = __webpack_require__(123);
	var encoder_1 = __webpack_require__(224);
	var binary_delta_impl_1 = __webpack_require__(496);
	var myers_binary_diff_1 = __webpack_require__(1171);
	var buffer_output_stream_1 = __webpack_require__(80);
	/**
	 * Global CBOR encoder
	 */
	var encoder = new encoder_1.Encoder();
	/**
	 * Global no-change constant
	 */
	exports.NO_CHANGE = new binary_delta_impl_1.BinaryDeltaImpl(Buffer.from([-10]), 0, 1);
	/**
	 * Create a delta that contains only the new value
	 *
	 * @param  value  the buffer containing the value
	 * @return        the resulting delta
	 */
	function replace(value) {
	    encoder.encode(value.$buffer, value.$offset, value.$length);
	    return new binary_delta_impl_1.BinaryDeltaImpl(encoder.flush());
	}
	/**
	 * The CBOR cost of an unsigned integer in bytes. It's cheaper to
	 * calculate than flush the encoder and check the number of written
	 * bytes.
	 *
	 * @param  i  the integer to check
	 * @returns   byte cost
	 */
	function cborCost(i) {
	    if (i < 24) {
	        return 1;
	    }
	    else if (i < 0xFF) {
	        return 2;
	    }
	    else if (i <= 0xFFFF) {
	        return 3;
	    }
	    return 5;
	}
	/**
	 * Check if a match should be conflated with an insert
	 *
	 * @param matchStart    the starting position of the match
	 * @param matchLength   the number of bytes in the match
	 * @param insertLength  the number of bytes to be instered
	 *
	 * @return true if it is worth conflating a match with an adjacent insert
	 */
	function conflatableMatch(matchStart, matchLength, insertLength) {
	    var matchCost = cborCost(matchStart) + 1;
	    var insertCost = cborCost(matchLength + insertLength) - cborCost(insertLength) + matchLength;
	    return insertCost <= matchCost;
	}
	/**
	 * A script for Myers Binary Diff algorithm to process the differences between two
	 * pieces of CBOR data
	 */
	var BinaryDeltaScript = /** @class */ (function () {
	    /**
	     * Create a new Script instance
	     *
	     * @param encoder      the CBOR encoder
	     * @param buffer       the buffer containing the data
	     * @param offset       the offset in the buffer to encode from
	     * @param blowsBudget  a function that indicates whether or not to send the
	     *                     new value instead of * the difference, depending on
	     *                     the byte cost.
	     */
	    function BinaryDeltaScript(cborEncoder, buffer, offset, blowsBudget) {
	        /**
	         *  If insertStart is not -1, there is an unflushed insert of insertLength bytes.
	         */
	        this.insertStart = -1;
	        /**
	         * If matchStart is not -1, there is an unflushed/uncoalesced match
	         * of matchLength bytes. If insertStart is also not -1, the match
	         * follows the insert; they could not be coalesced, but that might
	         * change if the next insert is small.
	         */
	        this.matchStart = -1;
	        this.cborEncoder = cborEncoder;
	        this.buffer = buffer;
	        this.offset = offset;
	        this.blowsBudget = blowsBudget;
	    }
	    /**
	     * Process an insert operation
	     *
	     * @param  bStart  the starting position of the insert
	     * @param  length  the number of bytes of the insert
	     * @return         a flag indicating success
	     */
	    BinaryDeltaScript.prototype.insert = function (bStart, length) {
	        if (this.matchStart !== -1) {
	            if (conflatableMatch(this.matchStart, this.matchLength, length)) {
	                this.matchStart = -1;
	                if (this.insertStart === -1) {
	                    this.insertStart = bStart - this.matchLength;
	                    this.insertLength = this.matchLength + length;
	                }
	                else {
	                    // else triple play!: insert, match, insert -> insert
	                    this.insertLength += this.matchLength + length;
	                }
	                return true;
	            }
	            if (!this.flush()) {
	                return false;
	            }
	        }
	        if (this.insertStart === -1) {
	            this.insertStart = bStart;
	            this.insertLength = length;
	        }
	        else {
	            this.insertLength += length;
	        }
	        return true;
	    };
	    /**
	     * Process a match operation
	     *
	     * @param  bStart  the starting position of the match
	     * @param  length  the number of bytes of the match
	     * @return         a flag indicating success
	     */
	    BinaryDeltaScript.prototype.match = function (aStart, length) {
	        if (this.matchStart !== -1) {
	            if (!this.flush()) {
	                return false;
	            }
	        }
	        else if (this.insertStart !== -1 &&
	            conflatableMatch(aStart, length, this.insertLength)) {
	            this.insertLength += length;
	            return true;
	        }
	        this.matchStart = aStart;
	        this.matchLength = length;
	        return true;
	    };
	    /**
	     * Process a delete operation
	     *
	     * @param  bStart  the starting position of the delete
	     * @param  length  the number of bytes of the delete
	     * @return         a flag indicating success
	     */
	    BinaryDeltaScript.prototype.delete = function (aStart, length) {
	        return true;
	    };
	    /**
	     * Close the script and flush all pending operations
	     *
	     * @return         a flag indicating success
	     */
	    BinaryDeltaScript.prototype.close = function () {
	        return this.flush();
	    };
	    /**
	     * Flush all pending operations
	     *
	     * @return         a flag indicating success
	     */
	    BinaryDeltaScript.prototype.flush = function () {
	        return (this.insertStart === -1 || this.writeInsert())
	            && (this.matchStart === -1 || this.writeMatch());
	    };
	    /**
	     * Write an insert to the encoder
	     *
	     * @param start   the starting position of the insert
	     * @param length  the number of bytes of the insert
	     * @return        a flag indicating success
	     */
	    BinaryDeltaScript.prototype.writeInsert = function () {
	        if (this.blowsBudget(this.insertLength + cborCost(this.insertLength))) {
	            return false;
	        }
	        encoder.encode(this.buffer, this.offset + this.insertStart, this.insertLength);
	        this.insertStart = -1;
	        return true;
	    };
	    /**
	     * Write a match to the encoder
	     *
	     * @param start   the starting position of the match
	     * @param length  the number of bytes of the match
	     * @return        a flag indicating success
	     */
	    BinaryDeltaScript.prototype.writeMatch = function () {
	        if (this.blowsBudget(cborCost(this.matchStart) + cborCost(this.matchLength))) {
	            return false;
	        }
	        this.cborEncoder.encode(this.matchStart);
	        this.cborEncoder.encode(this.matchLength);
	        this.matchStart = -1;
	        return true;
	    };
	    return BinaryDeltaScript;
	}());
	/**
	 * Implementation of {@link DeltaType}
	 *
	 * @inheritdoc
	 */
	var BinaryDeltaTypeImpl = /** @class */ (function () {
	    /**
	     *  Create a new instance of BinaryDeltaTypeImpl
	     *
	     * @param implementation  constructor function to create new instances of the type `T`
	     * @param cToV            conversion function to calculate the value from a CBOR buffer
	     * @param vToC            conversion function to calculate a CBOR buffer from the value
	     */
	    function BinaryDeltaTypeImpl(implementation, vToC, cToV) {
	        /**
	         * The Myers Binary Difference algorithm to calculate the differences
	         */
	        this.binaryDiff = new myers_binary_diff_1.MyersBinaryDiff();
	        this.implementation = implementation;
	        this.cToV = cToV;
	        this.vToC = vToC;
	    }
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.name = function () {
	        return 'binary';
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.diff = function (oldValueObj, newValueObj) {
	        var oldValue = this.vToC(oldValueObj);
	        var newValue = this.vToC(newValueObj);
	        var buffer = newValue.$buffer;
	        var offset = newValue.$offset;
	        var length = newValue.$length;
	        var budget = length;
	        var script = new BinaryDeltaScript(encoder, buffer, offset, function (cost) { return ((budget -= cost) <= 0); });
	        // perform diff
	        var result = this.binaryDiff.diff(oldValue.$buffer, oldValue.$offset, oldValue.$length, buffer, offset, length, script);
	        // flush will reset global encoder
	        var delta = encoder.flush();
	        switch (result) {
	            case myers_binary_diff_1.REPLACE:
	                return replace(newValue);
	            case myers_binary_diff_1.NO_CHANGE:
	                return exports.NO_CHANGE;
	            default:
	                return this.readDelta(delta);
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.apply = function (oldValueObj, delta) {
	        return this.applyImpl(oldValueObj, delta).value;
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.applyImpl = function (oldValueObj, delta, oldBuffer) {
	        var deltaImpl = delta;
	        var oldValue = oldBuffer || this.vToC(oldValueObj);
	        if (!delta || !delta.hasChanges()) {
	            return {
	                value: this.cToV(oldValue),
	                cbor: oldValue
	            };
	        }
	        var decoder = new decoder_1.Decoder(deltaImpl.$buffer);
	        var bos = new buffer_output_stream_1.BufferOutputStream();
	        while (decoder.hasRemaining()) {
	            var start = decoder.nextValue();
	            if (Buffer.isBuffer(start)) {
	                bos.writeMany(start);
	            }
	            else if (typeof start === 'number') {
	                bos.writeMany(oldValue.$buffer, oldValue.$offset + start, decoder.nextValue());
	            }
	        }
	        var impl = new this.implementation(bos.getBuffer());
	        return {
	            value: this.cToV(impl),
	            cbor: impl
	        };
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.readDelta = function (buffer, offset, length) {
	        var delta = new binary_delta_impl_1.BinaryDeltaImpl(buffer, offset, length);
	        // because JS handles object equality solely by reference, check (unique) properties
	        if (delta.$length === 1 && buffer[delta.$offset] === exports.NO_CHANGE.$buffer[0]) {
	            return exports.NO_CHANGE;
	        }
	        return delta;
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.writeDelta = function (delta) {
	        var deltaImpl = delta;
	        return deltaImpl.$buffer.slice(deltaImpl.$offset, deltaImpl.$offset + deltaImpl.$length);
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.noChange = function () {
	        return exports.NO_CHANGE;
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryDeltaTypeImpl.prototype.isValueCheaper = function (value, delta) {
	        return value.$length <= delta.$length;
	    };
	    return BinaryDeltaTypeImpl;
	}());
	exports.BinaryDeltaTypeImpl = BinaryDeltaTypeImpl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A class representing a slice of a buffer
	 */
	var BufferSlice = /** @class */ (function () {
	    /**
	     * Create a new buffer slice
	     *
	     * @param  buffer  the internal buffer
	     * @param  offset  the offset of the slice
	     * @param  length  the number of bytes in the slice
	     */
	    function BufferSlice(buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        this.$buffer = buffer;
	        this.$offset = offset;
	        this.$length = length;
	    }
	    return BufferSlice;
	}());
	exports.BufferSlice = BufferSlice;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(104);
	/**
	 * JSONPointer segment representing an index
	 */
	var IndexSegment = /** @class */ (function () {
	    /**
	     * Create a new IndexSegment
	     *
	     * @param  index  the index of the segment
	     */
	    function IndexSegment(index) {
	        this.index = index;
	    }
	    /**
	     * Compare two segments.
	     *
	     * Allows comparison of the IndexSegment with another IndexSegment or a
	     * {@link KeySegment}.
	     *
	     * @return 'true' if the other segment is an IndexSegment and the indexes are equal
	     */
	    IndexSegment.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        if (!other || !(other instanceof IndexSegment)) {
	            return false;
	        }
	        return other.index === this.index;
	    };
	    /**
	     * Convert the index segment to a string
	     *
	     * @returns  a string representation of the segment
	     */
	    IndexSegment.prototype.toString = function () {
	        return '/' + this.index;
	    };
	    return IndexSegment;
	}());
	exports.IndexSegment = IndexSegment;
	var INDEX0 = new IndexSegment(0);
	/**
	 * JSONPointer segment representing a key
	 * @param key
	 * @constructor
	 */
	var KeySegment = /** @class */ (function () {
	    /**
	     * Create a new KeySegment
	     *
	     * @param  key  the key of the segment
	     */
	    function KeySegment(key) {
	        this.expression = '/' + escapeKey(key);
	    }
	    /**
	     * Compare two segments.
	     *
	     * Allows comparison of the KeySegment with another KeySegment or a
	     * {@link IndexSegment}.
	     *
	     * @return 'true' if the other segment is an KeySegment and the keys are equal
	     */
	    KeySegment.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        if (!other || !(other instanceof KeySegment)) {
	            return false;
	        }
	        return other.expression === this.expression;
	    };
	    /**
	     * Convert the key segment to a string
	     *
	     * @returns  a string representation of the segment
	     */
	    KeySegment.prototype.toString = function () {
	        return this.expression;
	    };
	    return KeySegment;
	}());
	exports.KeySegment = KeySegment;
	/**
	 * A parser for parsing JSON pointer string expressions to JSON pointer objects
	 */
	var Parser = /** @class */ (function () {
	    /**
	     * Create a new parser
	     *
	     * @param  expression  the expression to be parsed
	     */
	    function Parser(expression) {
	        // each iteration leaves p at the next separator
	        this.pos = 0;
	        if (expression !== '' && expression.charAt(0) !== '/') {
	            throw new Error('JSON Pointer expression must be empty or start with \'/\' : ' + expression);
	        }
	        this.expression = expression;
	    }
	    /**
	     * Get the next segment string
	     *
	     * @return a string containing the next segment
	     */
	    Parser.prototype.nextSegmentString = function () {
	        var start = this.pos;
	        for (; this.pos < this.expression.length; ++this.pos) {
	            var c = this.expression[this.pos];
	            if (c === '/') {
	                break;
	            }
	            else if (c === '~') {
	                var parts = [this.expression.substring(start, this.pos)];
	                var length_1 = this.expression.length;
	                for (; this.pos < length_1; ++this.pos) {
	                    var c1 = this.expression.charAt(this.pos);
	                    if (c1 === '/') {
	                        break;
	                    }
	                    else if (c1 === '~' && this.pos !== length_1 - 1) {
	                        ++this.pos;
	                        var c2 = this.expression.charAt(this.pos);
	                        if (c2 === '0') {
	                            parts.push('~');
	                        }
	                        else if (c2 === '1') {
	                            parts.push('/');
	                        }
	                        else {
	                            parts.push('~');
	                            parts.push(c2);
	                        }
	                    }
	                    else {
	                        parts.push(c1);
	                    }
	                }
	                return parts.join('');
	            }
	        }
	        return this.expression.substring(start, this.pos);
	    };
	    /**
	     * Create an index segment, if the string contains an index.
	     *
	     * The index must be the decimal representation of a positive 32 bit integer
	     * without leading `0` or `+`
	     *
	     * @return a new index segment if the string contained an index, otherwise `null`
	     */
	    Parser.prototype.maybeIndex = function (s) {
	        var digits = s.length;
	        // numbers with more than ten digits are larger than MAX_INT32
	        if (digits === 0 || digits > 10) {
	            return null;
	        }
	        for (var i = 0; i < digits; ++i) {
	            var c = s.charAt(i);
	            if (c < '0' || c > '9') {
	                return null;
	            }
	            if (c === '0' && i === 0) {
	                // no leading zeroes allowed
	                return digits === 1 ? INDEX0 : null;
	            }
	        }
	        var index = parseInt(s, 10);
	        // cap at max int32
	        if (index > math_1.MAX_INT32) {
	            return null;
	        }
	        return new IndexSegment(index);
	    };
	    /**
	     * Get the next segment
	     *
	     * @return a key segment or an index segment. `null` if there are no more segments
	     */
	    Parser.prototype.next = function () {
	        if (this.pos === this.expression.length) {
	            return null;
	        }
	        ++this.pos;
	        var s = this.nextSegmentString();
	        var is = this.maybeIndex(s);
	        if (is !== null) {
	            return is;
	        }
	        return new KeySegment(s);
	    };
	    return Parser;
	}());
	/**
	 * JSON Pointer implementation that allows incremental building of pointers.
	 *
	 * @param nodes - Segments from parent context
	 * @constructor
	 * @since 5.9
	 */
	var JSONPointer = /** @class */ (function () {
	    /**
	     * Create a JSONPointer
	     *
	     * @param  segments  segments from parent context
	     */
	    function JSONPointer(segments) {
	        this.segments = segments;
	    }
	    /**
	     * Parse a string containing a JSON pointer into a JSONPointer object.
	     *
	     * A segment that has only decimal digits will be interpreted as an index unless it has leading zeros
	     * (RFC 6901, section4), or its value is larger than Integer.MAX_VALUE
	     *
	     * @param expression  a string containing the JSON pointer expression. If a JSONPointer object
	     *                    is supplied, then it will be returned unchanged
	     * @returns           a JSONPointer that corresponds to the expression
	     */
	    JSONPointer.parse = function (expression) {
	        if (expression instanceof JSONPointer) {
	            return expression;
	        }
	        /* tslint:disable-next-line:no-use-before-declare */
	        var result = exports.ROOT;
	        var segmentParser = new Parser(expression);
	        while (true) {
	            var s = segmentParser.next();
	            if (s === null) {
	                return result;
	            }
	            result = result.withSegment(s);
	        }
	    };
	    /**
	     * Append a key segment to the pointer
	     *
	     * @return a new instance equal to this instance with key appended
	     */
	    JSONPointer.prototype.withKey = function (key) {
	        return this.withSegment(new KeySegment(key));
	    };
	    /**
	     * Append a index segment to the pointer
	     *
	     * @return a new instance equal to this instance with index appended
	     */
	    JSONPointer.prototype.withIndex = function (index) {
	        return this.withSegment(new IndexSegment(index));
	    };
	    /**
	     * Append a segment to the pointer
	     *
	     * @return  a new instance equal to this instance with segment appended
	     */
	    JSONPointer.prototype.withSegment = function (newNode) {
	        var newNodes = this.segments.concat(newNode);
	        return new JSONPointer(newNodes);
	    };
	    /**
	     * Returns whether this JSONPointer is equal to another JSONPointer,
	     * ignoring the values of array index segments.
	     *
	     * This implements an equivalence relation between JSONPointers that
	     * considers two values equal if they have the same number of segments,
	     * corresponding segments are of the same type, and corresponding key
	     * segments are equal. It is used by the structural delta code to identify
	     * potential matches between two pointers to different values.
	     *
	     * @param other  the other pointer to compare to
	     * @returns      whether the other pointer is equal (ignoring indexes)
	     */
	    JSONPointer.prototype.equalIgnoringIndexes = function (other) {
	        if (other === this) {
	            return true;
	        }
	        var length = this.segments.length;
	        if (length !== other.segments.length) {
	            return false;
	        }
	        for (var i = 0; i < length; ++i) {
	            var s = this.segments[i];
	            var o = other.segments[i];
	            if (s instanceof IndexSegment) {
	                if (o instanceof KeySegment) {
	                    return false;
	                }
	            }
	            else if (!s.equals(o)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * Convert the JSON pointer to a string
	     *
	     * @returns  the JSONPointer expression
	     */
	    JSONPointer.prototype.toString = function () {
	        var e_1, _a;
	        var parts = [];
	        try {
	            for (var _b = __values(this.segments), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var segment = _c.value;
	                parts.push(segment.toString());
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return parts.join('');
	    };
	    /**
	     * Compare two JSONPointer objects
	     *
	     * Non-equal JSONPointer instances can have the same expression.
	     * E.g. ROOT.withIndex(1) is not equal to ROOT.withKey('1'), but both have the same expression '/1'
	     *
	     * @param other  the other pointer instance to compare to
	     * @returns      whether the two instances are equal
	     */
	    JSONPointer.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        if (!other || !(other instanceof JSONPointer)) {
	            return false;
	        }
	        if (this.segments.length !== other.segments.length) {
	            return false;
	        }
	        var length = this.segments.length;
	        for (var i = 0; i < length; ++i) {
	            var s1 = this.segments[i];
	            var s2 = other.segments[i];
	            if (!s1.equals(s2)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return JSONPointer;
	}());
	exports.JSONPointer = JSONPointer;
	/**
	 * JSONPointer representing the root
	 */
	exports.ROOT = new JSONPointer([]);
	/**
	 * Escape special characters in the JSON pointer key string
	 *
	 * @param  key  the key string to escape
	 * @return      the escaped string
	 */
	function escapeKey(key) {
	    for (var i = 0; i < key.length; ++i) {
	        var c = key.charAt(i);
	        if (c === '/' || c === '~') {
	            var length_2 = key.length;
	            var parts = [];
	            parts.push(key.substring(0, i));
	            for (var j = i; j < length_2; ++j) {
	                var c1 = key.charAt(j);
	                if (c1 === '/') {
	                    parts.push('~1');
	                }
	                else if (c1 === '~') {
	                    parts.push('~0');
	                }
	                else {
	                    parts.push(c1);
	                }
	            }
	            return parts.join('');
	        }
	    }
	    return key;
	}


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Delimiter byte for records
	 */
	exports.RECORD_DELIMITER = 0x1;
	/**
	 * Delimiter byte for fields
	 */
	exports.FIELD_DELIMITER = 0x2;
	/**
	 * Byte indicating an empty field
	 */
	exports.EMPTY_FIELD = 0x3;
	/**
	 * Byte indicating a single record
	 */
	exports.RECORD_MU = 0x4;
	/**
	 * Byte indicating a single field
	 */
	exports.FIELD_MU = 0x5;
	/**
	 * String representation of a delimiter byte for records
	 */
	exports.RECORD_DELIMITER_STRING = String.fromCharCode(exports.RECORD_DELIMITER);
	/**
	 * String representation of a delimiter byte for fields
	 */
	exports.FIELD_DELIMITER_STRING = String.fromCharCode(exports.FIELD_DELIMITER);
	/**
	 * String representation of a byte indicating an empty field
	 */
	exports.EMPTY_FIELD_STRING = String.fromCharCode(exports.EMPTY_FIELD);
	/**
	 * String representation of a byte indicating a single record
	 */
	exports.RECORD_MU_STRING = String.fromCharCode(exports.RECORD_MU);
	/**
	 * String representation of a byte indicating a single field
	 */
	exports.FIELD_MU_STRING = String.fromCharCode(exports.FIELD_MU);
	/**
	 * Convert a buffer or array of bytes containing Record V2 data into a string
	 *
	 * @param  bytes   the bytes to convert
	 * @param  offset  the starting position in the buffer
	 * @param  length  the number of bytes to convert
	 * @return         a string representation of the bytes
	 */
	function bytesToString(bytes, offset, length) {
	    var ret = '';
	    for (var i = offset; i < offset + length; ++i) {
	        switch (bytes[i]) {
	            case exports.FIELD_DELIMITER:
	                ret += '<FD>';
	                break;
	            case exports.RECORD_DELIMITER:
	                ret += '<RD>';
	                break;
	            case exports.EMPTY_FIELD:
	                ret += '<EF>';
	                break;
	            case exports.FIELD_MU:
	                ret += '<FM>';
	                break;
	            case exports.RECORD_MU:
	                ret += '<RM>';
	                break;
	            default:
	                ret += String.fromCharCode(bytes[i]);
	        }
	    }
	    return ret;
	}
	exports.bytesToString = bytesToString;
	/**
	 * Count the number of records or fields in the raw Record V2 data
	 *
	 * @param  bytes      the bytes to check
	 * @param  offset     the starting position in the buffer
	 * @param  length     the number of bytes to convert
	 * @param  mu         the token indicating an empty set
	 * @param  delimiter  the token separating two entities
	 * @return            the number of records in the data
	 */
	function entityCount(bytes, offset, length, mu, delimiter) {
	    if (length === 0) {
	        return 0;
	    }
	    if (bytes[0] === mu) {
	        return 1;
	    }
	    var count = 1;
	    for (var i = offset; i < offset + length; i++) {
	        if (bytes[i] === delimiter) {
	            count++;
	        }
	    }
	    return count;
	}
	/**
	 * Count the number of records in the raw Record V2 data
	 *
	 * @param  bytes   the bytes to check
	 * @param  offset  the starting position in the buffer
	 * @param  length  the number of bytes to convert
	 * @return         the number of records in the data
	 */
	function recordCount(bytes, offset, length) {
	    return entityCount(bytes, offset, length, exports.RECORD_MU, exports.RECORD_DELIMITER);
	}
	exports.recordCount = recordCount;
	/**
	 * Count the number of fields in the raw Record V2 data
	 *
	 * @param  bytes   the bytes to check
	 * @param  offset  the starting position in the buffer
	 * @param  length  the number of bytes to convert
	 * @return         the number of fields in the data
	 */
	function fieldCount(bytes, offset, length) {
	    return entityCount(bytes, offset, length, exports.FIELD_MU, exports.FIELD_DELIMITER);
	}
	exports.fieldCount = fieldCount;
	/**
	 * Find a delimiter in the raw Record V2 data. Returns the position of the
	 * within the range [`startIndex`, `endIndex`). If the delimiter is not found,
	 * `endIndex` will be returned.
	 *
	 * @param  bytes       the bytes to check
	 * @param  startIndex  the first index to begin searching
	 * @param  endIndex    the last index to stop searching
	 * @param  delimiter   the delimiter to search for
	 * @return             the index of the delimiter
	 */
	function findDelimiter(bytes, startIndex, endIndex, delimiter) {
	    for (var pos = startIndex; pos < endIndex; pos++) {
	        if (bytes[pos] === delimiter) {
	            return pos;
	        }
	    }
	    return endIndex;
	}
	exports.findDelimiter = findDelimiter;
	/**
	 * Checks if the data contains a single empty record
	 *
	 * @param  bytes   the bytes to check
	 * @param  offset  the starting position in the buffer
	 * @param  length  the number of bytes to convert
	 * @return         `true` if the data contains a single empty record
	 */
	function isSingleEmptyRecord(bytes, offset, length) {
	    return length === 1 && bytes[offset] === exports.RECORD_MU;
	}
	exports.isSingleEmptyRecord = isSingleEmptyRecord;
	/**
	 * Checks if the data contains a single empty field
	 *
	 * @param  bytes   the bytes to check
	 * @param  offset  the starting position in the buffer
	 * @param  length  the number of bytes to convert
	 * @return         `true` if the data contains a single empty field
	 */
	function recordIsSingleEmptyField(bytes, offset, length) {
	    return length === 1 && (bytes[offset] === exports.FIELD_MU || bytes[offset] === exports.EMPTY_FIELD);
	}
	exports.recordIsSingleEmptyField = recordIsSingleEmptyField;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	/**
	 * The type of the credentials data
	 */
	var Type;
	(function (Type) {
	    /**
	     * No data (null)
	     */
	    Type[Type["NONE"] = 0] = "NONE";
	    /**
	     * Plain string data
	     */
	    Type[Type["PLAIN"] = 1] = "PLAIN";
	    /**
	     * Custom data stored in a Buffer
	     */
	    Type[Type["CUSTOM"] = 2] = "CUSTOM";
	})(Type || (Type = {}));
	/**
	 * Read credentials from an input stream
	 *
	 * @param  input  the input stream
	 * @return        the credentials that were read
	 */
	function read(input) {
	    var type = BEES.read(input, Type);
	    switch (type) {
	        case Type.NONE:
	            Codec.readBytes(input);
	            return null;
	        case Type.PLAIN:
	            return Codec.readString(input) || null;
	        case Type.CUSTOM:
	            return Codec.readBytes(input);
	    }
	}
	exports.read = read;
	/**
	 * Write credentials to an output stream
	 *
	 * @param output       the output stream
	 * @param credentials  the credentials to write
	 */
	function write(output, credentials) {
	    if (credentials !== null && credentials !== undefined) {
	        if (typeof credentials === 'string') {
	            BEES.write(output, Type.PLAIN);
	            Codec.writeString(output, credentials);
	        }
	        else {
	            BEES.write(output, Type.CUSTOM);
	            Codec.writeBytes(output, credentials);
	        }
	    }
	    else {
	        BEES.write(output, Type.NONE);
	        Codec.writeInt32(output, 0);
	    }
	}
	exports.write = write;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_1 = __webpack_require__(1288);
	/**
	 * Serialiser for {@link ErrorReport}
	 */
	var ErrorReportSerialiserClass = /** @class */ (function (_super) {
	    __extends(ErrorReportSerialiserClass, _super);
	    function ErrorReportSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read an error report from the stream
	     *
	     * @param bis the input stream
	     * @return    the error report that was read
	     */
	    ErrorReportSerialiserClass.prototype.read = function (input) {
	        var message = Codec.readString(input);
	        var line = Codec.readInt32(input);
	        var column = Codec.readInt32(input);
	        return new error_report_1.ErrorReportImpl(message, line, column);
	    };
	    /**
	     * Write an error report to the stream
	     *
	     * @param bis   the input stream
	     * @param value the error report to be written
	     */
	    ErrorReportSerialiserClass.prototype.write = function (output, value) {
	        Codec.writeString(output, value.message);
	        Codec.writeInt32(output, value.line);
	        Codec.writeInt32(output, value.column);
	    };
	    return ErrorReportSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ErrorReportSerialiserClass = ErrorReportSerialiserClass;
	/**
	 * The {@link ErrorReportSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ErrorReportSerialiser = new ErrorReportSerialiserClass();


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var update_stream_id_1 = __webpack_require__(1428);
	/**
	 * Serialiser for {@link UpdateStreamId}
	 */
	var UpdateStreamIdSerialiserClass = /** @class */ (function (_super) {
	    __extends(UpdateStreamIdSerialiserClass, _super);
	    function UpdateStreamIdSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link UpdateStreamId} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link UpdateStreamId} that was read
	     */
	    UpdateStreamIdSerialiserClass.prototype.read = function (bis) {
	        var topicId = Codec.readInt32(bis);
	        var instanceId = Codec.readInt32(bis);
	        var partitionId = Codec.readInt32(bis);
	        var generationId = Codec.readInt32(bis);
	        var clustered = (partitionId !== 0);
	        return new update_stream_id_1.UpdateStreamId(topicId, instanceId, clustered, clustered ? (partitionId - 1) : 0, clustered ? generationId : 0);
	    };
	    /**
	     * Write a {@link UpdateStreamId} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link UpdateStreamId} to be written
	     */
	    UpdateStreamIdSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.topicId);
	        Codec.writeInt32(bos, value.instanceId);
	        if (value.clustered) {
	            Codec.writeInt32(bos, value.partitionId + 1);
	            Codec.writeInt32(bos, value.generationId);
	        }
	        else {
	            Codec.writeInt32(bos, 0);
	            Codec.writeInt32(bos, 0);
	        }
	    };
	    return UpdateStreamIdSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.UpdateStreamIdSerialiserClass = UpdateStreamIdSerialiserClass;
	/**
	 * The {@link UpdateStreamIdSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.UpdateStreamIdSerialiser = new UpdateStreamIdSerialiserClass();


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a STREAM_SET_TOPIC_SERVICE or STREAM_APPLY_DELTA_SERVICE request.
	 */
	var UpdateStreamRequest = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamRequest instance
	     *
	     * @param streamId  the id of the update stream
	     * @param update  the data to send
	     */
	    function UpdateStreamRequest(streamId, update) {
	        this.streamId = streamId;
	        this.update = update;
	    }
	    return UpdateStreamRequest;
	}());
	exports.UpdateStreamRequest = UpdateStreamRequest;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module V4Stack
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var buffer_input_stream_1 = __webpack_require__(125);
	var buffer_output_stream_1 = __webpack_require__(80);
	var consts_1 = __webpack_require__(336);
	var Logger = __webpack_require__(17);
	var message_encoding_1 = __webpack_require__(1461);
	var object_1 = __webpack_require__(1462);
	var logger = Logger.create('Message');
	var zlib;
	if (consts_1.PROTOCOL.CAPABILITIES === 10) {
	    /* tslint:disable-next-line:no-var-requires */
	    zlib = __webpack_require__(1464);
	}
	else {
	    logger.warn('Per message compression is disabled because \'zlib\' bundle is not included');
	    zlib = null;
	}
	/**
	 * Message types
	 */
	var types;
	(function (types) {
	    types[types["SERVICE_REQUEST"] = 0] = "SERVICE_REQUEST";
	    types[types["SERVICE_RESPONSE"] = 6] = "SERVICE_RESPONSE";
	    types[types["SERVICE_ERROR"] = 7] = "SERVICE_ERROR";
	    types[types["TOPIC_VALUE"] = 4] = "TOPIC_VALUE";
	    types[types["TOPIC_DELTA"] = 5] = "TOPIC_DELTA";
	    types[types["ABORT_NOTIFICATION"] = 28] = "ABORT_NOTIFICATION";
	    types[types["CLOSE_REQUEST"] = 29] = "CLOSE_REQUEST";
	    types[types["FETCH_REPLY"] = 34] = "FETCH_REPLY";
	})(types = exports.types || (exports.types = {}));
	/**
	 * Message encodings
	 */
	var encoding;
	(function (encoding) {
	    encoding[encoding["NONE"] = 0] = "NONE";
	    encoding[encoding["ENCRYPTION_REQUESTED"] = 1] = "ENCRYPTION_REQUESTED";
	    encoding[encoding["COMPRESSION_REQUESTED"] = 2] = "COMPRESSION_REQUESTED";
	    encoding[encoding["BASE64_REQUESTED"] = 3] = "BASE64_REQUESTED";
	    encoding[encoding["ENCRYPTED"] = 17] = "ENCRYPTED";
	    encoding[encoding["COMPRESSED"] = 18] = "COMPRESSED";
	    encoding[encoding["BASE64"] = 19] = "BASE64";
	})(encoding = exports.encoding || (exports.encoding = {}));
	/**
	 * Basic message type
	 */
	var Message = /** @class */ (function () {
	    /**
	     * Create a new message
	     *
	     * @param  type      the message type
	     * @param  encoding  the message encoding
	     * @param  fields    optional message fields
	     * @param  data      the message's data
	     * @param  headers   additional message headers
	     */
	    function Message(type, msgEncoding, fields, data, headers) {
	        this.type = type;
	        this.encoding = msgEncoding;
	        this.id = fields.id;
	        this.topic = fields.topic;
	        this.data = data;
	        this.headers = headers;
	    }
	    /**
	     * Create an input stream from the message's data
	     *
	     * @return an input stream that can be deserialised
	     */
	    Message.prototype.getInputStream = function () {
	        return new buffer_input_stream_1.BufferInputStream(this.data);
	    };
	    return Message;
	}());
	exports.Message = Message;
	/**
	 * A writable message that can be serialised into a {@link BufferOutputStream}
	 */
	var WriteableMessage = /** @class */ (function (_super) {
	    __extends(WriteableMessage, _super);
	    /**
	     * Create a writeable message
	     *
	     * @param  the message fields in an object
	     */
	    function WriteableMessage(fields) {
	        var _this = _super.call(this, fields.type, fields.encoding, fields, fields.buffer, fields.headers) || this;
	        _this.stream = new buffer_output_stream_1.BufferOutputStream(fields.buffer);
	        return _this;
	    }
	    /**
	     * Get the output stream
	     *
	     * @return the output stream that writes into the message's data buffer
	     */
	    WriteableMessage.prototype.getStream = function () {
	        return this.stream;
	    };
	    /**
	     * Get the buffer
	     *
	     * @return the buffer that the output has been written into
	     */
	    WriteableMessage.prototype.getBuffer = function () {
	        return this.stream.getBuffer();
	    };
	    return WriteableMessage;
	}(Message));
	exports.WriteableMessage = WriteableMessage;
	/**
	 * Parse a message from a buffer
	 *
	 * @param  buffer    the buffer to parse
	 * @param  callback  a callback that is called when the message has been parsed
	 *                   or an error has occurred.
	 */
	function parse(buffer, callback) {
	    var bis = new buffer_input_stream_1.BufferInputStream(buffer);
	    var typeAndEncoding = bis.read();
	    var type = message_encoding_1.MessageEncoding.extractMessageType(typeAndEncoding);
	    var encodingType = message_encoding_1.MessageEncoding.extractMessageEncoding(typeAndEncoding);
	    /* tslint:disable-next-line:strict-type-predicates */
	    if (types[type] === undefined) {
	        callback(new Error("Invalid message type: " + type), null);
	    }
	    if (type === types.SERVICE_REQUEST || type === types.SERVICE_RESPONSE || type === types.SERVICE_ERROR) {
	        callback(null, parseServiceMessage(type, bis));
	    }
	    else if (type === types.TOPIC_VALUE || type === types.TOPIC_DELTA) {
	        parseClientTopicMessage(type, encodingType, bis, callback);
	    }
	    else {
	        var headers = bis.readUntil(0x01).toString().split('\u0002');
	        var body = bis.readMany(bis.count);
	        var topic = (type === types.FETCH_REPLY) ? headers.shift() : undefined;
	        callback(null, new Message(type, encoding.NONE, { topic: topic }, body, headers));
	    }
	}
	exports.parse = parse;
	/**
	 * Helper function to create a service message
	 *
	 * @param  type  the message type to create
	 * @param  bis   the buffer that is passed into the {@link Message.data} property
	 *               of the message
	 * @return       the newly constructed message
	 */
	function parseServiceMessage(type, bis) {
	    var body = bis.readMany(bis.count);
	    return new Message(type, encoding.NONE, {}, body, []);
	}
	/**
	 * Helper function to create a client topic message
	 *
	 * @param  type          the message type to create
	 * @param  encodingType  the message encoding
	 * @param  bis           the buffer that is passed into the {@link Message.data} property
	 * @param  callback      a callback that is called when the message has been parsed
	 *                       or an error has occurred.
	 */
	function parseClientTopicMessage(type, encodingType, bis, callback) {
	    var headers = [];
	    var fields = { id: bis.readInt32() };
	    if (encodingType === message_encoding_1.EncodingType.ZLIB && zlib !== null) {
	        try {
	            var bytes = zlib.decompressSync(bis.readMany(bis.count));
	            callback(null, new Message(type, encoding.COMPRESSED, fields, bytes, headers));
	        }
	        catch (error) {
	            callback(error, null);
	        }
	    }
	    else {
	        callback(null, new Message(type, encoding.NONE, fields, bis.readMany(bis.count), headers));
	    }
	}
	/**
	 * Create a writeable Message.
	 *
	 * @param type  provide a number to specify a message type; use an object to provide fields
	 * @return      the created message
	 */
	function create(type) {
	    var fields;
	    /* tslint:disable-next-line:strict-type-predicates */
	    if (type === undefined || (typeof type === 'number' && types[type] === undefined)) {
	        throw new Error("Invalid message type: " + type);
	    }
	    else if (object_1.isObjectAs(type)) {
	        fields = type;
	    }
	    else {
	        fields = { type: type };
	    }
	    fields.encoding = fields.encoding || 0;
	    fields.headers = fields.headers || [];
	    fields.buffer = fields.buffer || Buffer.alloc(0);
	    return new WriteableMessage(fields);
	}
	exports.create = create;
	/**
	 * Construct a header string
	 *
	 * @param  message  the message from which to construct the header string
	 * @return          the string to be serialised in the header
	 */
	function getHeaderString(message) {
	    if (message.type !== types.FETCH_REPLY) {
	        return '';
	    }
	    var sh = [message.topic].concat(message.headers);
	    return sh.join('\u0002') + '\u0001';
	}
	/**
	 * Serialise a message into a buffer
	 *
	 * @param  message  the message to write
	 * @param  bos      the buffer to write into
	 */
	function writeToBuffer(message, bos) {
	    bos.write(message.type);
	    bos.writeString(getHeaderString(message));
	    bos.writeMany(message.getBuffer());
	}
	exports.writeToBuffer = writeToBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Commands that are sent to a shared session in a webworker
	 */
	var WorkerCommand;
	(function (WorkerCommand) {
	    WorkerCommand["CONNECT"] = "connect";
	    WorkerCommand["CONNECT_EXISTING"] = "connect-existing";
	    WorkerCommand["CLOSE"] = "close";
	    WorkerCommand["MESSAGE"] = "message";
	    WorkerCommand["STREAM"] = "stream";
	    WorkerCommand["SERVICE"] = "service";
	    WorkerCommand["LOCK"] = "lock";
	    WorkerCommand["CID"] = "cid";
	})(WorkerCommand = exports.WorkerCommand || (exports.WorkerCommand = {}));
	/**
	 * Webworker commands to manage a session lock
	 */
	var WorkerSessionLockCommand;
	(function (WorkerSessionLockCommand) {
	    WorkerSessionLockCommand["ACQUIRED"] = "acquired";
	    WorkerSessionLockCommand["ACQUIRE_ERROR"] = "acquire_error";
	    WorkerSessionLockCommand["OWNED"] = "owned";
	    WorkerSessionLockCommand["REMOVED"] = "removed";
	    WorkerSessionLockCommand["RELEASED"] = "released";
	    WorkerSessionLockCommand["RELEASE_ERROR"] = "release_error";
	})(WorkerSessionLockCommand = exports.WorkerSessionLockCommand || (exports.WorkerSessionLockCommand = {}));
	/**
	 * Webworker commands relating to stream events
	 */
	var WorkerStreamCommand;
	(function (WorkerStreamCommand) {
	    WorkerStreamCommand["OPEN"] = "open";
	    WorkerStreamCommand["VALUE"] = "value";
	    WorkerStreamCommand["SUBSCRIPTION"] = "subscription";
	    WorkerStreamCommand["UNSUBSCRIPTION"] = "unsubscription";
	    WorkerStreamCommand["SUBSCRIPTION_ERROR"] = "subscription_error";
	})(WorkerStreamCommand = exports.WorkerStreamCommand || (exports.WorkerStreamCommand = {}));


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Valid TopicSpecification keys
	 */
	var keys = [
	    'PUBLISH_VALUES_ONLY',
	    'SCHEMA',
	    'VALIDATE_VALUES',
	    'TIDY_ON_UNSUBSCRIBE',
	    'TIME_SERIES_EVENT_VALUE_TYPE',
	    'TIME_SERIES_RETAINED_RANGE',
	    'TIME_SERIES_SUBSCRIPTION_RANGE',
	    'DONT_RETAIN_VALUE',
	    'PERSISTENT',
	    'REMOVAL',
	    'OWNER',
	    'COMPRESSION',
	    'CONFLATION',
	    'PRIORITY',
	];
	/**
	 * Topic specifications provide the information required to create a topic.
	 * Topics can be created from a topic specification using
	 * {@link TopicControl.add}.
	 *
	 * Topic specifications allow an application to introspect the type and
	 * capabilities of a topic. Topic specifications are provided to
	 * {@link ValueStream ValueStreams} and {@link TopicNotificationListener topic
	 * notification listeners}.
	 *
	 * A topic is specified in terms of its {@link TopicType type}
	 * and a map of optional property settings which can alter the default behavior
	 * of the topic.
	 *
	 * <h4>Topic Properties</h4>
	 *
	 * Depending on the topic type, some properties must be included in the
	 * specification when creating a topic and some properties have no effect. All
	 * topic specification property values must be supplied as strings.
	 *
	 * The required and optional properties for each topic type are set out in the following table.
	 *
	 * <table style="width: 100%; font-size: 0.7rem">
	 * <tr>
	 * <th></th>
	 * <th>{@link TopicTypeEnum.STRING STRING}<br/>
	 * {@link TopicTypeEnum.JSON JSON}<br/>
	 * {@link TopicTypeEnum.BINARY BINARY}<br/>
	 * </th>
	 * <th>{@link TopicTypeEnum.DOUBLE DOUBLE}<br/>
	 * {@link TopicTypeEnum.INT64 INT64}</th>
	 * <th>{@link TopicTypeEnum.ROUTING ROUTING} (deprecated)<br/>
	 * <th>{@link TopicTypeEnum.TIME_SERIES TIME_SERIES}</th>
	 * <th>{@link TopicTypeEnum.RECORD_V2 RECORD_V2}</th>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.COMPRESSION COMPRESSION}</th>
	 * <td>Optional</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.CONFLATION CONFLATION}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.DONT_RETAIN_VALUE DONT_RETAIN_VALUE}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.PUBLISH_VALUES_ONLY PUBLISH_VALUES_ONLY}</th>
	 * <td>Optional</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.SCHEMA SCHEMA}</th>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.TIDY_ON_UNSUBSCRIBE TIDY_ON_UNSUBSCRIBE}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.TIME_SERIES_EVENT_VALUE_TYPE TIME_SERIES_EVENT_VALUE_TYPE}</th>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>Required</td>
	 * <td>-</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.TIME_SERIES_RETAINED_RANGE TIME_SERIES_RETAINED_RANGE}</th>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * <td>-</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.TIME_SERIES_SUBSCRIPTION_RANGE TIME_SERIES_SUBSCRIPTION_RANGE}</th>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * <td>-</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.VALIDATE_VALUES VALIDATE_VALUES}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>-</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.PERSISTENT PERSISTENT}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.PRIORITY PRIORITY}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.REMOVAL REMOVAL}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * <tr>
	 * <th>{@link TopicSpecification.OWNER OWNER}</th>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * <td>Optional</td>
	 * </tr>
	 * </table>
	 *
	 * `TIME_SERIES` topics have restricted values for the
	 * `CONFLATION` property. They are only allowed to have the values
	 * `off` or `unsubscribe`.
	 *
	 * `ROUTING` topics (deprecated) are references to other topics, and have no
	 * value of their own. Instead, they reflect the value of the appropriate source
	 * topic. Observed behavior depends on the values of the `DONT_RETAIN_VALUE`,
	 * `PUBLISH_VALUES_ONLY`, and `VALIDATE_VALUES` properties that are set on the
	 * source topic.
	 *
	 */
	var TopicSpecification = /** @class */ (function () {
	    /**
	     * Create a new TopicSpecification
	     *
	     * @param type        the topic type for this specification.
	     * @param properties  the properties to use for this specification.
	     * @since 5.9
	     *
	     * **Example:**
	     *
	     * Properties can be set when creating the specification by passing an object
	     * ```
	     * // Create specification for JSON topics which validate update values on the server
	     * const TopicSpecification = diffusion.topics.TopicSpecification;
	     *
	     * var specification = new TopicSpecification(diffusion.topics.TopicType.JSON, {
	     *     "VALIDATE_VALUES" : "true"
	     * });
	     * ```
	     *
	     * **Example:** <caption>New specifications can be created with additional properties</caption>
	     * ```
	     * // Create specification for JSON topics which validate update values on the server
	     * const TopicSpecification = diffusion.topics.TopicSpecification;
	     *
	     * var specification = new TopicSpecification(diffusion.topics.TopicType.JSON)
	     *     .withProperty(TopicSpecification.VALIDATE_VALUES, "true");
	     * ```
	     */
	    function TopicSpecification(type, properties) {
	        if (properties === void 0) { properties = {}; }
	        this.type = type;
	        this.properties = properties;
	    }
	    /**
	     * Returns a new TopicSpecification with the specified property set to the supplied value.
	     * @param  key    the new property key
	     * @param  value  the new property value
	     * @returns       a new TopicSpecification with the specified property set.
	     */
	    TopicSpecification.prototype.withProperty = function (key, value) {
	        /* tslint:disable-next-line:strict-type-predicates */
	        if (typeof key !== 'string' || keys.indexOf(key.toUpperCase()) < 0) {
	            throw new Error("Invalid key: " + key);
	        }
	        /* tslint:disable-next-line:strict-type-predicates */
	        if (typeof value !== 'string') {
	            throw new Error("Invalid value, must be string: " + value);
	        }
	        var newProperties = {};
	        newProperties[key] = value;
	        for (var k in this.properties) {
	            if (k !== key) {
	                newProperties[k] = this.properties[k];
	            }
	        }
	        return new TopicSpecification(this.type, newProperties);
	    };
	    /**
	     * Key of the topic property that specifies whether a topic should publish
	     * only values.
	     *
	     * By default, a topic that supports delta streams will publish the
	     * difference between two values (a delta) when doing so is more efficient
	     * than publishing the complete new value. Subscribing sessions can use a
	     * {@link ValueStream} to automatically apply the delta to a local copy of
	     * the topic value to calculate the new value.
	     *
	     * Setting PUBLISH_VALUES_ONLY to `true` disables this behavior so that
	     * deltas are never published. Doing so is usually not recommended because
	     * it will result in more data being transmitted, less efficient use of
	     * network resources, and increased transmission latency. On the other hand,
	     * calculating deltas can require significant CPU from the server or, if
	     * update streams are used, from the updating client. The CPU cost will be
	     * higher if there are many differences between successive values, in which
	     * case delta streams confer fewer benefits. If successive values are
	     * unrelated to each other, consider setting PUBLISH_VALUES_ONLY to `true`.
	     * Also consider setting PUBLISH_VALUES_ONLY to `true` if the network
	     * capacity is high and the bandwidth savings of deltas are not required.
	     *
	     * @see {@link TopicSpecification.DONT_RETAIN_VALUE}
	     */
	    TopicSpecification.PUBLISH_VALUES_ONLY = 'PUBLISH_VALUES_ONLY';
	    /**
	     * Key of the topic property indicating whether a topic should validate
	     * inbound values.
	     *
	     * By default, the server does not validate received values before sending
	     * them on to client sessions. Invalid or corrupt values will be stored in
	     * the topic and passed on to sessions. If this property is set to `true`,
	     * the server will perform additional validation on values to check that
	     * they are valid instances of the data type, and if it is not then it will
	     * return an error to the updater and not update the topic.
	     *
	     * If this value is not set (or set to something other than `true`), no
	     * server validation of inbound values is performed. This is the recommended
	     * setting as there is a performance overhead to validation and values
	     * produced through the {@link DataTypes data type} API will not
	     * be invalid anyway.
	     */
	    TopicSpecification.VALIDATE_VALUES = 'VALIDATE_VALUES';
	    /**
	     * Key of the topic property that specifies the 'tidy on unsubscribe' option
	     * for a topic.
	     *
	     * By default, if a session unsubscribes from a topic, it will receive any
	     * updates for that topic that were previously queued but not sent.
	     *
	     * If this property is set to `true`, when a session unsubscribes from the
	     * topic, any updates for the topic that are still queued for the session
	     * are removed. There is a performance overhead to using this option as the
	     * client queue must be scanned to find topic updates to remove, however it
	     * may prove useful for preventing unwanted data being sent to sessions.
	     *
	     * @since 6.0
	     */
	    TopicSpecification.TIDY_ON_UNSUBSCRIBE = 'TIDY_ON_UNSUBSCRIBE';
	    /**
	     * Key of the topic property that specifies the event data type for a time
	     * series topic.
	     *
	     * The value is the {@link DataType.name type name} of a
	     * data type.
	     *
	     * @since 6.0
	     */
	    TopicSpecification.TIME_SERIES_EVENT_VALUE_TYPE = 'TIME_SERIES_EVENT_VALUE_TYPE';
	    /**
	     * Key of the topic property that specifies the range of events retained by
	     * a time series topic.
	     *
	     * When a new event is added to the time series, older events that fall
	     * outside of the range are discarded.
	     *
	     * If the property is not specified, a time series topic will retain the ten
	     * most recent events.
	     *
	     * <h4>Time series range expressions</h4>
	     *
	     * The property value is a time series <em>range expression</em> string
	     * composed of one or more constraint clauses. Constraints are combined to
	     * provide a range of events from the end of the time series.
	     *
	     * <dl>
	     * <dt>limit constraint
	     * <dd>A limit constraint specifies the maximum number of events from the
	     * end of the time series.
	     * <dt>last clause
	     * <dd>A last constraint specifies the maximum duration of events from the
	     * end of the time series. The duration is expressed as an integer followed
	     * by one of the following time units. <br>
	     * <br>
	     * <code>MS</code> &ndash; milliseconds; <br>
	     * <code>S</code> &ndash; seconds; <br>
	     * <code>H</code> &ndash; hours.
	     * </dl>
	     *
	     * If a range expression contains multiple constraints, the constraint that
	     * selects the smallest range is used.
	     *
	     * Property value  | Meaning
	     * --------------- | ---------
	     * `limit 5`       | The five most recent events
	     * `last 10s`      | All events that are no more than ten seconds older than the latest event
	     * `last 10s limit 5` | The five most recent events that are no more than ten seconds older than the latest event
	     *
	     * Range expressions are not case sensitive: `limit 5 last 10s` is
	     * equivalent to `LIMIT 5 LAST 10S`.
	     *
	     * @since 6.0
	     */
	    TopicSpecification.TIME_SERIES_RETAINED_RANGE = 'TIME_SERIES_RETAINED_RANGE';
	    /**
	     * Key of the topic property that specifies the range of time series topic
	     * events to send to new subscribers.
	     *
	     * The property value is a time series range expression, following the
	     * format used for {@link TopicSpecification.TIME_SERIES_RETAINED_RANGE
	     * TIME_SERIES_RETAINED_RANGE}.
	     *
	     * If the property is not specified, new subscribers will be sent the latest
	     * event if delta streams are enabled and no events if delta streams are
	     * disabled. See the description of <em>Subscription range</em> in the
	     * {@link TimeSeries time series feature} documentation.
	     *
	     * @since 6.0
	     */
	    TopicSpecification.TIME_SERIES_SUBSCRIPTION_RANGE = 'TIME_SERIES_SUBSCRIPTION_RANGE';
	    /**
	     * Key of the topic property that specifies a schema which constrains topic
	     * values.
	     *
	     * This property is only used by {@link TopicTypeEnum.RECORD_V2
	     * RECORD_V2} topics. The value is converted to a Diffusion record schema
	     * using {@link RecordV2DataType.parseSchema}.
	     *
	     * @since 6.0
	     */
	    TopicSpecification.SCHEMA = 'SCHEMA';
	    /**
	     * Key of the topic property that specifies a topic should not retain its
	     * last value.
	     *
	     * By default, a topic (other than a `ROUTING` topic) will retain its latest
	     * value. The latest value will be sent to new subscribers. Setting this
	     * property to `true` disables this behavior. New subscribers will not be
	     * sent an initial value. No value will be returned for fetch operations
	     * that select the topic. This is useful for data streams where the values
	     * are only transiently valid.
	     *
	     * Setting DONT_RETAIN_VALUE to `true` also disables delta streams,
	     * regardless of the {@link TopicSpecification.PUBLISH_VALUES_ONLY
	     * PUBLISH_VALUES_ONLY} value. If subsequent values are likely to be
	     * related, delta streams usually provide performance benefits (see {@link
	     * TopicSpecification.PUBLISH_VALUES_ONLY PUBLISH_VALUES_ONLY}). Consider
	     * leaving DONT_RETAIN_VALUE set to `false` to benefit from delta streams,
	     * even if there is no other requirement to retain the last value.
	     *
	     * Bearing in mind the performance trade-offs of disabling delta streams,
	     * there are two reasons to consider setting DONT_RETAIN_VALUE to `true`.
	     * First, it stops the server and each subscribed client from keeping a copy
	     * of the value, reducing their memory requirements. Second, when a topic
	     * has a high update rate and is replicated across a cluster, it can
	     * significantly improve throughput because the values need not be persisted
	     * to the cluster.
	     *
	     * Time series topics ignore this property and always retain the latest
	     * value.
	     *
	     * @since 6.0
	     */
	    TopicSpecification.DONT_RETAIN_VALUE = 'DONT_RETAIN_VALUE';
	    /**
	     * Key of the topic property that can be used to prevent a topic from being
	     * persisted when the server is configured to enable persistence.
	     *
	     * By default, a topic will be persisted if persistence is enabled at the
	     * server and the topic type supports persistence.
	     *
	     * Setting PERSISTENT to `false` will prevent the topic from being
	     * persisted.
	     *
	     * @since 6.1
	     */
	    TopicSpecification.PERSISTENT = 'PERSISTENT';
	    /**
	     * Key of the topic property that specifies a removal policy for automatic
	     * removal of the topic (and/or other topics).
	     *
	     * This property is specified as an expression which defines one or more
	     * conditions that are to be satisfied before automatic removal occurs.
	     *
	     * The expression takes the form:
	     *
	     * <code>
	     * when <i>conditions</i> [remove '<i>selector</i>']
	     * </code>
	     *
	     * At least one condition must be supplied. If more than one is supplied,
	     * they must be separated by logical operators (`and` or `or`).
	     * The natural evaluation order of the operators may be changed by
	     * surrounding with parentheses (e.g. (<i>condition</i> `and`
	     * <i>condition</i>)).
	     *
	     * The `remove` clause is optional. It provides a {@link TopicSelector}
	     * expression representing the topics to be removed. If a `remove` clause is
	     * specified, the topic with the removal policy will only be removed if its
	     * path matches the selector expression. The selector must be surrounded by
	     * either double or single quotes.
	     *
	     * When many topics have the same removal policy, it is better to
	     * set the `REMOVAL` property for one of them, using a `remove`
	     * clause that selects all of the topics. This is more efficient because it
	     * allows the server to avoid evaluating the same condition many times.
	     *
	     * The permissions that are applied at the time of removal are those defined
	     * by the roles of the principal that created the topic at the time of
	     * creation. The roles of that principal may therefore change before the
	     * removal with no effect, but if the permissions given to the roles change
	     * it may have an effect upon the final removal.
	     *
	     * Only one occurrence of each of the following condition types may be
	     * included within the expression:
	     * <table style="width: 100%; font-size:0.9rem;">
	     * <tr>
	     * <th align="left" style="width:20%">Condition&nbsp;Type</th>
	     * <th align="left">Format</th>
	     * <th align="left">Usage</th>
	     * </tr>
	     * <tr valign="top">
	     * <th align="left" style="width:20%"><b>time&nbsp;after</b></th>
	     * <td style="width:40%"><code>time&nbsp;after&nbsp;<i>absoluteTime</i></code></td>
	     * <td style="width:40%">Removal should occur after a specified absolute time. Absolute time
	     * may be specified as a number of milliseconds since the epoch (00:00:00 on
	     * 1 January 1970) <b>or</b> as a quoted date and time formatted in <a href=
	     * "https://docs.oracle.com/javase/8/docs/api/java/time/format/DateTimeFormatter.html#RFC_1123_DATE_TIME">RFC_1123
	     * date time format</a>. Either single or double quotes may be used.</td>
	     * </tr>
	     * <tr valign="top">
	     * <th align="left" style="width:20%"><b>subscriptions&nbsp;less&nbsp;than</b></th>
	     * <td style="width:40%"><code>[local]&nbsp;subscriptions&nbsp;&lt;&nbsp;<i>n</i> for&nbsp;<i>forPeriod</i>&nbsp;[after&nbsp;<i>afterPeriod</i>]</code></td>
	     * <td style="width:40%">Removal should occur when the topic has had less than the specified
	     * number (<i>n</i>) of subscriptions for a given period (<i>forPeriod</i>)
	     * of time. Optionally, an initial period (<i>afterPeriod</i>) may be
	     * specified by which to delay the initial checking of this condition. See
	     * below for period formats.
	     * <p>The optional <code>local</code> keyword restricts evaluation to only count
	     * subscriptions from sessions belonging to the local server or cluster,
	     * ignoring subscriptions from sessions belonging to downstream remote servers that
	     * host fanout replicas of the topic.</td>
	     * </tr>
	     * <tr valign="top">
	     * <th align="left" style="width:20%"><b>no&nbsp;updates&nbsp;for</b></th>
	     * <td style="width:40%"><code>no&nbsp;updates&nbsp;for&nbsp;<i>forPeriod</i> [after&nbsp;<i>afterPeriod</i>]</code></td>
	     * <td style="width:40%">Removal should occur when the topic has had no updates for a given
	     * period (<i>forPeriod</i>) of time. Optionally, an initial period
	     * (<i>afterPeriod</i>) may be specified by which to delay the initial
	     * checking of this condition. See below for period formats.</td>
	     * </tr>
	     * </table>
	     *
	     * Multiple occurrences of the following condition types may be
	     * included within the expression:
	     * <table style="width: 100%; font-size:0.9rem;">
	     * <tr>
	     * <th align="left" style="width:20%">Condition&nbsp;Type</th>
	     * <th align="left">Format</th>
	     * <th align="left">Usage</th>
	     * </tr>
	     * <tr valign="top">
	     * <th align="left" style="width:20%"><b>no&nbsp;session&nbsp;has</b></th>
	     * <td style="width:40%"><code>no&nbsp;[local]&nbsp;session&nbsp;has&nbsp;<i>'criteria'</i> [for&nbsp;<i>forPeriod</i>]&nbsp;[after&nbsp;<i>afterPeriod</i>]</code></td>
	     * <td style="width:40%">Removal should occur when no sessions satisfy certain <i>criteria</i>.
	     * Optionally the criteria can be required to be satisfied for a period of time
	     * (<i>forPeriod</i>). Optionally, an initial period (<i>afterPeriod</i>) can
	     * be specified to delay the initial check of the criteria. Session selection
	     * criteria are specified as defined in {@link Session session filters} and
	     * must be surrounded by single or double quotes. See below for period formats.
	     * <p>The optional <code>local</code> keyword restricts evaluation to sessions
	     * belonging to the local server or cluster, ignoring sessions belonging to
	     * downstream remote servers that host fanout replicas of the topic.</td>
	     * </tr>
	     * <tr valign="top">
	     * <th style="width:20%"></th>
	     * <td style="width:40%"><code>this&nbsp;session&nbsp;closes</code></td>
	     * <td style="width:40%">This is a shorthand form of `no local session has` that may be used to
	     * indicate that the topic is to be removed when the session that created it
	     * closes.</td>
	     * </tr>
	     * </table>
	     *
	     * Time periods are specified as a number followed (with no intermediate
	     * space) by a single letter representing the time unit. The time unit may
	     * be `s` (seconds), `m` (minutes), `h` (hours) or `d` (days). For example,
	     * 10 minutes would be specified as 10m.
	     *
	     * If quotes or backslashes (`\`) are required within quoted values such as
	     * selectors or session criteria then they may be escaped by preceding with
	     * `\`. The convenience method {@link escape} is provided to escape such
	     * characters in a value. The expression is validated only by the server and
	     * therefore if an invalid expression is specified it will be reported as an
	     * Error.
	     *
	     * **Examples:**
	     *
	     * ```
	     * when time after 1518780068112
	     * ```
	     *
	     * The topic will be removed when the date and time indicated by the
	     * specified number of milliseconds since the epoch has passed.
	     *
	     * ```
	     * when time after 'Tue, 3 Jun 2018 11:05:30 GMT'
	     * ```
	     *
	     * The topic will be removed when the specified date and time has passed.
	     *
	     * ```
	     * when time after 'Tue, 3 Jun 2018 11:05:30 GMT' remove '*alpha/beta//'
	     * ```
	     *
	     * The topic alpha/beta and all topics subordinate to it will be removed
	     * when the specified date and time has passed.
	     *
	     * ```
	     * when subscriptions &lt; 1 for 20m
	     * ```
	     *
	     * The topic will be removed when it has had no subscriptions for a
	     * continuous period of 20 minutes.
	     *
	     * ```
	     * when subscriptions &lt; 2 for 20m after 1h
	     * ```
	     *
	     * The topic will be removed when it has had less than 2 subscriptions for a
	     * continuous period of 20 minutes after one hour has passed since its
	     * creation.
	     *
	     * ```
	     * when no updates for 3h
	     * ```
	     *
	     * The topic will be removed when it has had no updates for a continuous
	     * period of 3 hours.
	     *
	     * ```
	     * when no updates for 15m after 1d
	     * ```
	     *
	     * The topic will be removed when it has had no updates for a continuous
	     * period of 15 minutes after one day has passed since its creation.
	     *
	     * ```
	     * when this session closes
	     * ```
	     *
	     * The topic will be removed when the session that created it closes.
	     *
	     * ```
	     * when no session has '$Principal is "Alice"'
	     * ```
	     *
	     * The topic will be removed when there is no session with the principal 'Alice'.
	     *
	     * ```
	     * when no session has '$Principal is "Alice"' for 10m
	     * ```
	     *
	     * The topic will be removed when there have been no sessions with the principal
	     * 'Alice' for a continuous period of 10 minutes.
	     *
	     * ```
	     * when no session has 'Department is "Accounts"' for 30m after 2h
	     * ```
	     *
	     * The topic will be removed when there have been no sessions from the Account
	     * department for a continuous period of 30 minutes after 2 hours have passed
	     * since its creation.
	     *
	     * ```
	     * when time after "Tue, 3 Jun 2018 11:05:30 GMT" and subscriptions &lt; 1 for 30m
	     * ```
	     *
	     * The topic will be removed when the specified date and time has passed and
	     * the topic has had no subscriptions for a continuous period of 30 minutes
	     * after that time.
	     *
	     * ```
	     * when time after "Tue, 3 Jun 2018 11:05:30 GMT" and subscriptions &lt; 2 for 10m after 1h
	     * ```
	     *
	     * The topic will be removed when the specified date and time has passed and
	     * the topic has had less than 2 subscriptions for a continuous period of 10
	     * minutes after that time plus one hour.
	     *
	     * ```
	     * when time after "Tue, 3 Jun 2018 11:05:30 GMT" or subscriptions &lt; 2 for 10m after 1h
	     * ```
	     *
	     * The topic will be removed when the specified date and time has passed or
	     * the topic has had less than 2 subscriptions for a continuous period of 10
	     * minutes after one hour from its creation.
	     *
	     * ```
	     * when time after "Tue, 3 Jun 2018 11:05:30 GMT" and (subscriptions &lt; 2 for 10m after 1h or no updates for 20m)
	     * ```
	     *
	     * The topic will be removed when the specified date and time has passed and
	     * either the topic has had less than 2 subscriptions for a continuous
	     * period of 10 minutes after that time plus one hour or it has had no
	     * updates for a continuous period of 20 minutes. Note that the parentheses
	     * are significant here as without them the topic would be removed if it had
	     * had no updates for 20 minutes regardless of the time and subscriptions
	     * clause.
	     *
	     * **Notes and restrictions on use**
	     *
	     * The `after` time periods refer to the period since the topic was
	     * created or restored from persistence store after a server is restarted.
	     * They are designed as a 'grace' period after the topic comes into
	     * existence before the related conditions starts to be evaluated. When not
	     * specified the conditions start to be evaluated as soon as the topic is
	     * created or restored.
	     *
	     * The server will evaluate conditions on a periodic basis (every few
	     * seconds) so the exact removal time will not be precise for low periodic
	     * granularity.
	     *
	     * The meaning of the `for` period in a `no session has` condition is subtly
	     * different from its use in other conditions. It does not guarantee that
	     * there has been no session satisfying the condition at some point between
	     * evaluations, only that when evaluated the given period of time has passed
	     * since it was last evaluated and found to have no matching sessions.
	     *
	     * Automatic topic removal is supported for a topic that is replicated
	     * across the local cluster, and for a topic with with fanout replicas on
	     * downstream remote servers. A `subscriptions less than` condition will be evaluated
	     * against the total number of subscriptions across the cluster and on all
	     * fanout replicas on downstream remote servers. A `no session has`
	     * condition will consider all sessions hosted across the cluster and all
	     * sessions hosted by downstream remote servers that have a fanout replica
	     * of the topic. The `local` keyword can be used to restrict evaluation to
	     * the local cluster, ignoring fanout replicas.
	     *
	     * @since 6.1
	     */
	    TopicSpecification.REMOVAL = 'REMOVAL';
	    /**
	     * Key of the topic property that specifies the conflation policy of the
	     * topic. The policy specifies how the server manages queued topic updates.
	     * Conflation is applied individually to each session queue.
	     *
	     * Conflation is the process of merging or discarding topic updates queued
	     * for a session to reduce the server memory footprint and network data. The
	     * server will conflate sessions that have a large number of queued messages
	     * to meet configured queue size targets. The sessions with the largest
	     * queues are typically slow consumers or have been disconnected - both will
	     * benefit from conflation. This property allows conflation behavior to be
	     * tuned on a topic-by-topic basis.
	     *
	     * The supported policies are:
	     *
	     * * `off`
	     * * `conflate`
	     * * `unsubscribe`
	     * * `always`
	     *
	     * The default policy used when the property is not specified and the topic
	     * type is not time series is `conflate`. The default policy used when the
	     * property is not specified and the topic type is time series is `off`.
	     *
	     * The policy `off` disables conflation for the topic. This policy
	     * disables all conflation for the topic, so topic updates will never be
	     * merged or discarded.
	     *
	     * The policy `conflate` automatically conflates topic updates when
	     * back pressure is detected by the server.
	     *
	     * The policy `unsubscribe` automatically unsubscribes the topic when
	     * back pressure is detected by the server. The unsubscription is not
	     * persisted to the cluster. If a session fails over to a different server
	     * it will be resubscribed to the topic.
	     *
	     * The policy `always` automatically conflates topic updates as they
	     * are queued for the session. This is an eager policy that ensures only the
	     * latest update is queued for the topic, minimising the server memory and
	     * network bandwidth used by the session.
	     *
	     * The `conflate` and `unsubscribe` policies are applied when
	     * the server detects back pressure for a session. The server configuration
	     * places limits on the data queued for each session. If these limits are
	     * breached, the server will conflate the session queue to attempt to reduce
	     * its size. If the session queue still exceeds the limits after conflation,
	     * the session will be terminated.
	     *
	     * Conflation can be disabled on a session-by-session basis. If conflation is
	     * disabled for a session the policy will not be applied to topic updates
	     * queued for the session but will be for other sessions that have conflation
	     * enabled.
	     *
	     * The policies `conflate` and `always` are not supported for
	     * time series topics as they would cause missing events. Attempts to enable
	     * these policies with time series topics will cause the creation of the
	     * topic to fail, reporting that the specification is invalid.
	     *
	     * @since 6.2
	     */
	    TopicSpecification.CONFLATION = 'CONFLATION';
	    /**
	     * Key of the topic property that allows the creator of a topic to extend
	     * READ_TOPIC, MODIFY_TOPIC, and UPDATE_TOPIC permissions to a specific
	     * principal, in addition to the permissions granted by the authorisation
	     * rules in the security store.
	     *
	     * A session that has authenticated using the principal can update and
	     * remove the topic, so the principal can be considered the topic owner. To
	     * fetch or subscribe to the topic, the principal must also be granted
	     * the SELECT_TOPIC permission by the security store rules.
	     *
	     * This may be used in the following cases:
	     * 1) A session creates a topic and makes its own principal the owner.
	     * 2) A session creates a topic and makes another principal the owner.
	     *
	     * The format of the property value is:
	     *
	     * `$Principal is "<i>name</i>"`
	     *
	     * where <i>name</i> is the name of the principal. Single quotes may be used
	     * instead of double quotes and special characters can be escaped using
	     * {@link escape} if required.
	     *
	     * The purpose of this property is to allow a client to create topics on
	     * behalf of other users. This can be used in conjunction with the
	     * {@link REMOVAL} property so that such topics are removed when there are
	     * no longer any sessions for the named principal.
	     *
	     * **Example:**
	     * ```
	     * specification.withProperty(diffusion.topics.TopicSpecification.OWNER,
	     *                            "$Principal is 'myPrincipal'")
	     *              .withProperty(diffusion.topics.TopicSpecification.REMOVAL,
	     *                            "when no session has '$Principal is \"myPrincipal\"' for 5s");
	     * ```
	     *
	     * @since 6.1
	     */
	    TopicSpecification.OWNER = 'OWNER';
	    /**
	     * Key of the topic property that allows the compression policy to be set
	     * on a per-topic basis.
	     *
	     * Compression reduces the bandwidth required to broadcast topic updates to
	     * subscribed sessions, at the cost of increased server CPU.
	     *
	     * Changes to a topic's value are published to each subscribed session as a
	     * sequence of topic messages. A topic message can carry the latest value or
	     * the difference between the latest value and the previous value (a delta).
	     * The compression policy determines if and how published topic messages
	     * are compressed. Topic messages are not exposed through the client API;
	     * the client library handles decompression and decodes deltas
	     * automatically, passing reconstructed values to the application.
	     *
	     * The compression policy for a topic is specified by setting this property
	     * to one of several values:
	     *
	     * * `off`
	     * * `low`
	     * * `medium`
	     * * `high`
	     *
	     * The policies are listed in the order of increasing compression and
	     * increasing CPU cost. `off` disables compression completely for the
	     * topic and requires no additional CPU; `high` compresses the topic
	     * messages to the smallest number of bytes, but has the highest CPU cost.
	     * Generally some compression is beneficial, so the default value for this
	     * property is `low`.
	     *
	     * Prior to version 6.4, only two values were allowed: `true`
	     * (equivalent to `medium`, and the previous default policy) and
	     * `false` (equivalent to `off`). These values are still
	     * supported.
	     *
	     * This property is only one factor that determines whether a topic message
	     * will be compressed. Other factors include:
	     *
	     * * Compression must be enabled in the server configuration.
	     *
	     * * The client library must support the server's compression
	     *   scheme. In this release, the server supports zlib
	     *   compression, and also allows compression to be disabled on a
	     *   per-connector basis. From 6.4, all client libraries are
	     *   capable of zlib compression. A JavaScript client may or may
	     *   not support zlib compression, depending on whether the zlib
	     *   library can be loaded. The zlib library is packaged
	     *   separately to reduce the download size of the core library.
	     *
	     * @since 6.2
	     */
	    TopicSpecification.COMPRESSION = 'COMPRESSION';
	    /**
	     * Key of the topic property that specifies the topic delivery priority.
	     *
	     * The supported delivery priorities are:
	     *
	     * * `low`
	     * * `default`
	     * * `high`
	     *
	     * The delivery priority affects the order of topic updates sent to a
	     * subscribed client session. When there are multiple topic updates for
	     * topics with different priorities in a session's outbound queue, updates
	     * for `high` priority topics will be delivered first, followed by
	     * updates for `default` priority topics, followed by updates for
	     * `low` priority topics. Topic subscription and unsubscription
	     * notifications are also delivered according to the topic delivery
	     * priority.
	     *
	     * Using different delivery priorities is most beneficial when there is a
	     * large backlog of queued updates to deliver to a client session. On
	     * lightly loaded systems, updates typically remain in the outbound queue
	     * for a few milliseconds and so there is a lower chance of topic updates
	     * being reordered based on their priority. The backlog will be larger if
	     * the topic update rate is higher; the server or the client are more
	     * heavily loaded; the client session becomes temporarily disconnected; or
	     * if there is poor network connectivity between the server and the client.
	     *
	     * Messages from the server to the client that are not topic updates, for
	     * example ping requests and responses, are queued with the
	     * `default` delivery priority.
	     *
	     * @since 6.4
	     */
	    TopicSpecification.PRIORITY = 'PRIORITY';
	    return TopicSpecification;
	}());
	exports.TopicSpecification = TopicSpecification;


/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1574),
	    listCacheDelete = __webpack_require__(1575),
	    listCacheGet = __webpack_require__(1576),
	    listCacheHas = __webpack_require__(1577),
	    listCacheSet = __webpack_require__(1578);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(368);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(558),
	    baseAssignValue = __webpack_require__(560);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(245),
	    isObject = __webpack_require__(91);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1571);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setLevel = undefined;
	exports.create = create;
	
	var _loglevel = __webpack_require__(1640);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var methods = ['trace', 'debug', 'info', 'warn', 'error'];
	
	function getDate() {
	    return new Date();
	}
	
	function log(level, prefix) {
	    var logLevel = level.toUpperCase();
	    return function (msg) {
	        _loglevel2.default[level](getDate() + '|' + logLevel + '|' + prefix + '|' + msg);
	    };
	}
	
	function create(classname) {
	    return methods.reduce(function (aggr, method) {
	        return Object.assign(_defineProperty({}, method, log(method, classname)), aggr);
	    }, {});
	}
	
	var setLevel = exports.setLevel = _loglevel2.default.setLevel;

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(19)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	/*
	WildEmitter.js is a slim little event emitter by @henrikjoreteg largely based
	on @visionmedia's Emitter from UI Kit.
	
	Why? I wanted it standalone.
	
	I also wanted support for wildcard emitters like this:
	
	emitter.on('*', function (eventName, other, event, payloads) {
	
	});
	
	emitter.on('somenamespace*', function (eventName, payloads) {
	
	});
	
	Please note that callbacks triggered by wildcard registered events also get
	the event name as the first argument.
	*/
	
	module.exports = WildEmitter;
	
	function WildEmitter() { }
	
	WildEmitter.mixin = function (constructor) {
	    var prototype = constructor.prototype || constructor;
	
	    prototype.isWildEmitter= true;
	
	    // Listen on the given `event` with `fn`. Store a group name if present.
	    prototype.on = function (event, groupName, fn) {
	        this.callbacks = this.callbacks || {};
	        var hasGroup = (arguments.length === 3),
	            group = hasGroup ? arguments[1] : undefined,
	            func = hasGroup ? arguments[2] : arguments[1];
	        func._groupName = group;
	        (this.callbacks[event] = this.callbacks[event] || []).push(func);
	        return this;
	    };
	
	    // Adds an `event` listener that will be invoked a single
	    // time then automatically removed.
	    prototype.once = function (event, groupName, fn) {
	        var self = this,
	            hasGroup = (arguments.length === 3),
	            group = hasGroup ? arguments[1] : undefined,
	            func = hasGroup ? arguments[2] : arguments[1];
	        function on() {
	            self.off(event, on);
	            func.apply(this, arguments);
	        }
	        this.on(event, group, on);
	        return this;
	    };
	
	    // Unbinds an entire group
	    prototype.releaseGroup = function (groupName) {
	        this.callbacks = this.callbacks || {};
	        var item, i, len, handlers;
	        for (item in this.callbacks) {
	            handlers = this.callbacks[item];
	            for (i = 0, len = handlers.length; i < len; i++) {
	                if (handlers[i]._groupName === groupName) {
	                    //console.log('removing');
	                    // remove it and shorten the array we're looping through
	                    handlers.splice(i, 1);
	                    i--;
	                    len--;
	                }
	            }
	        }
	        return this;
	    };
	
	    // Remove the given callback for `event` or all
	    // registered callbacks.
	    prototype.off = function (event, fn) {
	        this.callbacks = this.callbacks || {};
	        var callbacks = this.callbacks[event],
	            i;
	
	        if (!callbacks) return this;
	
	        // remove all handlers
	        if (arguments.length === 1) {
	            delete this.callbacks[event];
	            return this;
	        }
	
	        // remove specific handler
	        i = callbacks.indexOf(fn);
	        callbacks.splice(i, 1);
	        if (callbacks.length === 0) {
	            delete this.callbacks[event];
	        }
	        return this;
	    };
	
	    /// Emit `event` with the given args.
	    // also calls any `*` handlers
	    prototype.emit = function (event) {
	        this.callbacks = this.callbacks || {};
	        var args = [].slice.call(arguments, 1),
	            callbacks = this.callbacks[event],
	            specialCallbacks = this.getWildcardCallbacks(event),
	            i,
	            len,
	            item,
	            listeners;
	
	        if (callbacks) {
	            listeners = callbacks.slice();
	            for (i = 0, len = listeners.length; i < len; ++i) {
	                if (!listeners[i]) {
	                    break;
	                }
	                listeners[i].apply(this, args);
	            }
	        }
	
	        if (specialCallbacks) {
	            len = specialCallbacks.length;
	            listeners = specialCallbacks.slice();
	            for (i = 0, len = listeners.length; i < len; ++i) {
	                if (!listeners[i]) {
	                    break;
	                }
	                listeners[i].apply(this, [event].concat(args));
	            }
	        }
	
	        return this;
	    };
	
	    // Helper for for finding special wildcard event handlers that match the event
	    prototype.getWildcardCallbacks = function (eventName) {
	        this.callbacks = this.callbacks || {};
	        var item,
	            split,
	            result = [];
	
	        for (item in this.callbacks) {
	            split = item.split('*');
	            if (item === '*' || (split.length === 2 && eventName.slice(0, split[0].length) === split[0])) {
	                result = result.concat(this.callbacks[item]);
	            }
	        }
	        return result;
	    };
	
	};
	
	WildEmitter.mixin(WildEmitter);


/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name) {
	  if (!(it instanceof Constructor)) {
	    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
	  } return it;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var toIndexedObject = __webpack_require__(100);
	var toLength = __webpack_require__(38);
	var toAbsoluteIndex = __webpack_require__(171);
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.includes` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var wellKnownSymbol = __webpack_require__(35);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return { done: !!called++ };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };
	  iteratorWithReturn[ITERATOR] = function () {
	    return this;
	  };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(iteratorWithReturn, function () { throw 2; });
	} catch (error) { /* empty */ }
	
	module.exports = function (exec, SKIP_CLOSING) {
	  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  var ITERATION_SUPPORT = false;
	  try {
	    var object = {};
	    object[ITERATOR] = function () {
	      return {
	        next: function () {
	          return { done: ITERATION_SUPPORT = true };
	        }
	      };
	    };
	    exec(object);
	  } catch (error) { /* empty */ }
	  return ITERATION_SUPPORT;
	};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var createIteratorConstructor = __webpack_require__(1050);
	var getPrototypeOf = __webpack_require__(312);
	var setPrototypeOf = __webpack_require__(313);
	var setToStringTag = __webpack_require__(220);
	var createNonEnumerableProperty = __webpack_require__(98);
	var redefine = __webpack_require__(99);
	var wellKnownSymbol = __webpack_require__(35);
	var IS_PURE = __webpack_require__(14);
	var Iterators = __webpack_require__(167);
	var IteratorsCore = __webpack_require__(472);
	
	var IteratorPrototype = IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR = wellKnownSymbol('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);
	
	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    } return function () { return new IteratorConstructor(this); };
	  };
	
	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;
	
	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
	    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
	        if (setPrototypeOf) {
	          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
	        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
	          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // Set @@toStringTag to native iterators
	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
	    }
	  }
	
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    INCORRECT_VALUES_NAME = true;
	    defaultIterator = function values() { return nativeIterator.call(this); };
	  }
	
	  // define iterator
	  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
	    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
	  }
	  Iterators[NAME] = defaultIterator;
	
	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        redefine(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }
	
	  return methods;
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var isObject = __webpack_require__(43);
	
	var document = global.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);
	
	module.exports = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var userAgent = __webpack_require__(464);
	
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8;
	var match, version;
	
	if (v8) {
	  match = v8.split('.');
	  version = match[0] + match[1];
	} else if (userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = match[1];
	  }
	}
	
	module.exports = version && +version;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	// IE8- don't enum bug keys
	module.exports = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(457);
	var Iterators = __webpack_require__(167);
	var wellKnownSymbol = __webpack_require__(35);
	
	var ITERATOR = wellKnownSymbol('iterator');
	
	module.exports = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var getIteratorMethod = __webpack_require__(309);
	
	module.exports = function (it) {
	  var iteratorMethod = getIteratorMethod(it);
	  if (typeof iteratorMethod != 'function') {
	    throw TypeError(String(it) + ' is not iterable');
	  } return anObject(iteratorMethod.call(it));
	};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(483);
	
	var functionToString = Function.toString;
	
	// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
	if (typeof store.inspectSource != 'function') {
	  store.inspectSource = function (it) {
	    return functionToString.call(it);
	  };
	}
	
	module.exports = store.inspectSource;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toObject = __webpack_require__(50);
	var sharedKey = __webpack_require__(316);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(1049);
	
	var IE_PROTO = sharedKey('IE_PROTO');
	var ObjectPrototype = Object.prototype;
	
	// `Object.getPrototypeOf` method
	// https://tc39.github.io/ecma262/#sec-object.getprototypeof
	module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectPrototype : null;
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var aPossiblePrototype = __webpack_require__(1041);
	
	// `Object.setPrototypeOf` method
	// https://tc39.github.io/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
	    setter.call(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    anObject(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter.call(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var createNonEnumerableProperty = __webpack_require__(98);
	
	module.exports = function (key, value) {
	  try {
	    createNonEnumerableProperty(global, key, value);
	  } catch (error) {
	    global[key] = value;
	  } return value;
	};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(34);
	var definePropertyModule = __webpack_require__(49);
	var wellKnownSymbol = __webpack_require__(35);
	var DESCRIPTORS = __webpack_require__(48);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (CONSTRUCTOR_NAME) {
	  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
	  var defineProperty = definePropertyModule.f;
	
	  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
	    defineProperty(Constructor, SPECIES, {
	      configurable: true,
	      get: function () { return this; }
	    });
	  }
	};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(484);
	var uid = __webpack_require__(319);
	
	var keys = shared('keys');
	
	module.exports = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var requireObjectCoercible = __webpack_require__(170);
	var whitespaces = __webpack_require__(320);
	
	var whitespace = '[' + whitespaces + ']';
	var ltrim = RegExp('^' + whitespace + whitespace + '*');
	var rtrim = RegExp(whitespace + whitespace + '*$');
	
	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod = function (TYPE) {
	  return function ($this) {
	    var string = String(requireObjectCoercible($this));
	    if (TYPE & 1) string = string.replace(ltrim, '');
	    if (TYPE & 2) string = string.replace(rtrim, '');
	    return string;
	  };
	};
	
	module.exports = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
	  start: createMethod(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
	  end: createMethod(2),
	  // `String.prototype.trim` method
	  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
	  trim: createMethod(3)
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var wellKnownSymbol = __webpack_require__(35);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};
	
	test[TO_STRING_TAG] = 'z';
	
	module.exports = String(test) === '[object z]';


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	var id = 0;
	var postfix = Math.random();
	
	module.exports = function (key) {
	  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
	};


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	// a string of all valid unicode whitespaces
	// eslint-disable-next-line max-len
	module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_STRING_TAG_SUPPORT = __webpack_require__(318);
	var redefine = __webpack_require__(99);
	var toString = __webpack_require__(1061);
	
	// `Object.prototype.toString` method
	// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  redefine(Object.prototype, 'toString', toString, { unsafe: true });
	}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var DOMIterables = __webpack_require__(1051);
	var ArrayIteratorMethods = __webpack_require__(487);
	var createNonEnumerableProperty = __webpack_require__(98);
	var wellKnownSymbol = __webpack_require__(35);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var ArrayValues = ArrayIteratorMethods.values;
	
	for (var COLLECTION_NAME in DOMIterables) {
	  var Collection = global[COLLECTION_NAME];
	  var CollectionPrototype = Collection && Collection.prototype;
	  if (CollectionPrototype) {
	    // some Chrome versions have non-configurable methods on DOMTokenList
	    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
	      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
	    } catch (error) {
	      CollectionPrototype[ITERATOR] = ArrayValues;
	    }
	    if (!CollectionPrototype[TO_STRING_TAG]) {
	      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
	    }
	    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
	      // some Chrome versions have non-configurable methods on DOMTokenList
	      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
	        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
	      } catch (error) {
	        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
	      }
	    }
	  }
	}


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Session.remoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Connection option key.
	 */
	var ConnectionOption;
	(function (ConnectionOption) {
	    /**
	     * Specifies the connection timeout session attribute value (in milliseconds).
	     *
	     * If a value is not specified the session's default connection timeout is used.
	     */
	    ConnectionOption[ConnectionOption["CONNECTION_TIMEOUT"] = 1] = "CONNECTION_TIMEOUT";
	    /**
	     * Specifies the input buffer size session attribute.
	     *
	     * This is the size of the input buffer to use for the connection with the remote server.
	     * It is used to receive messages from the remote server.
	     * This should be set to the same size as the output buffer used at the remote server.
	     *
	     * If not specified, a default of 1024k is used.
	     */
	    ConnectionOption[ConnectionOption["INPUT_BUFFER_SIZE"] = 2] = "INPUT_BUFFER_SIZE";
	    /**
	     * Specifies the maximum queue size session attribute.
	     *
	     * This is the maximum number of messages that can be queued to send to the remote server.
	     * If this number is exceeded, the connection will be closed.
	     * This must be sufficient to cater for messages that may be queued whilst disconnected (awaiting reconnect).
	     *
	     * The default value is 10,000 messages.
	     */
	    ConnectionOption[ConnectionOption["MAXIMUM_QUEUE_SIZE"] = 3] = "MAXIMUM_QUEUE_SIZE";
	    /**
	     * Specifies the output buffer size session attribute.
	     *
	     * This is the size of the output buffer to use for the connection with the remote server.
	     * It is used to send messages to the remote server.
	     * This should be set to the same size as the input buffer used by the remote server.
	     *
	     * If not specified, a default of 1024k is used.
	     */
	    ConnectionOption[ConnectionOption["OUTPUT_BUFFER_SIZE"] = 4] = "OUTPUT_BUFFER_SIZE";
	    /**
	     * Specifies the reconnection timeout session attribute.
	     *
	     * This is the total time in milliseconds that will be allowed to reconnect a failed connectionto the
	     * remote server.
	     *
	     * For reconnection to work the remote server connector must have been configured to support reconnection.
	     *
	     * If a value is not specified the session's default reconnection timeout is used.
	     */
	    ConnectionOption[ConnectionOption["RECONNECTION_TIMEOUT"] = 5] = "RECONNECTION_TIMEOUT";
	    /**
	     * Specifies the recovery buffer size session attribute.
	     *
	     * If the remote server is configured to support reconnection, a session established with a non-zero
	     * reconnect-timeout retains a buffer of sent messages.
	     * If the session disconnects and reconnects, this buffer is used to re-send messages that the server
	     * has not received.
	     *
	     * The default value is 10,000 messages. If reconnect-timeout is 0 then this value is ignored.
	     */
	    ConnectionOption[ConnectionOption["RECOVERY_BUFFER_SIZE"] = 6] = "RECOVERY_BUFFER_SIZE";
	    /**
	     * Specifies the delay after losing a connection before attempting a reconnection.
	     *
	     * The value is specified in milliseconds. Default 1000 (1 second).
	     */
	    ConnectionOption[ConnectionOption["RETRY_DELAY"] = 7] = "RETRY_DELAY";
	    /**
	     * Specifies the write timeout session attribute value (in milliseconds).
	     *
	     * If a value is not specified the session's default write timeout is used.
	     */
	    ConnectionOption[ConnectionOption["WRITE_TIMEOUT"] = 8] = "WRITE_TIMEOUT";
	})(ConnectionOption = exports.ConnectionOption || (exports.ConnectionOption = {}));
	/**
	 * Represents the current connection state of a remote server.
	 */
	var ConnectionState;
	(function (ConnectionState) {
	    /**
	     * The connection is inactive.
	     * <p>
	     * This means that the remote server can successfully connect but a
	     * physical connection is not being maintained as there are no
	     * components that require the remote server.
	     * <p>
	     * If in an inactive or failed state, a test connection will have
	     * been tried to check that the connection can be made and the
	     * connection will then have been closed.
	     */
	    ConnectionState[ConnectionState["INACTIVE"] = 1] = "INACTIVE";
	    /**
	     * The remote server is connected and actively in use by components
	     * that require it.
	     */
	    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
	    /**
	     * The connection has failed but a retry is scheduled.
	     * <p>
	     * In this case {@link RemoteServerStatus.failureMessage}
	     * will provide details of the failure that resulted in a retry.
	     */
	    ConnectionState[ConnectionState["RETRYING"] = 3] = "RETRYING";
	    /**
	     * The connection failed to establish.
	     * <p>
	     * If the connection was in an inactive or failed state state, a
	     * test connection was tried and failed.
	     * <p>
	     * In this case {@link RemoteServerStatus.failureMessage}
	     * will provide more detail.
	     */
	    ConnectionState[ConnectionState["FAILED"] = 4] = "FAILED";
	    /**
	     * The named remote server did not exist.
	     */
	    ConnectionState[ConnectionState["MISSING"] = 5] = "MISSING";
	})(ConnectionState = exports.ConnectionState || (exports.ConnectionState = {}));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module CBOR
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(174);
	var context_1 = __webpack_require__(1162);
	var int64_impl_1 = __webpack_require__(176);
	// unique object for representing break codes
	var BREAK_FLAG = new Error();
	// used for buffer value of virtual tokens
	var EMPTY_BUFFER = Buffer.alloc(0);
	var MAX_SAFE_INTEGER = 9007199254740991;
	var MIN_SAFE_INTEGER = -9007199254740991;
	/**
	 * Tokeniser for CBOR objects
	 */
	var Tokeniser = /** @class */ (function () {
	    /**
	     * Create a tokeniser
	     *
	     * @param  data   the buffer to tokenise
	     * @param  offset the starting position in the buffer
	     * @param  length the number of bytes to read from the buffer
	     */
	    function Tokeniser(data, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = data.length; }
	        this.bufferOffset = offset;
	        this.length = length;
	        this.data = data;
	        this.context = new context_1.Context();
	        this.pos = this.bufferOffset;
	    }
	    /**
	     * Reset the tokeniser
	     */
	    Tokeniser.prototype.reset = function () {
	        this.context = new context_1.Context();
	        this.token = undefined;
	        this.type = undefined;
	        this.pos = this.bufferOffset;
	    };
	    /**
	     * Check if more tokens can be read from the buffer
	     *
	     * @return `true` if there are more tokens
	     */
	    Tokeniser.prototype.hasRemaining = function () {
	        // if we're parsing a collection, there will be a single
	        // virtual token which does not derive from a concrete byte
	        var ctx = this.context.type();
	        var len = ctx === context_1.TokenContextType.root ? this.length : this.length + 1;
	        return this.pos < this.bufferOffset + len;
	    };
	    /**
	     * Return the current reading position in the buffer
	     */
	    Tokeniser.prototype.offset = function () {
	        return this.pos;
	    };
	    /**
	     * Get the current context
	     */
	    Tokeniser.prototype.getContext = function () {
	        return this.context;
	    };
	    /**
	     * Get the current token
	     */
	    Tokeniser.prototype.getToken = function () {
	        return this.token;
	    };
	    /**
	     * Read the next token and return it
	     *
	     * @return the next token or null if no more tokens are remaining in the buffer
	     */
	    /* tslint:disable-next-line:cyclomatic-complexity  */
	    Tokeniser.prototype.nextToken = function () {
	        if (!this.hasRemaining()) {
	            return null;
	        }
	        var ctx = this.context.type();
	        var previousPos = this.pos;
	        if (ctx !== context_1.TokenContextType.root && !this.context.hasRemaining()) {
	            switch (ctx) {
	                case context_1.TokenContextType.object:
	                    this.type = consts_1.tokens.MAP_END;
	                    break;
	                case context_1.TokenContextType.array:
	                    this.type = consts_1.tokens.ARRAY_END;
	                    break;
	                case context_1.TokenContextType.string:
	                    this.type = consts_1.tokens.STRING_END;
	                    break;
	            }
	            this.context.pop();
	            return {
	                pos: this.pos,
	                type: this.type,
	                getBuffer: function () {
	                    return EMPTY_BUFFER;
	                }
	            };
	        }
	        else {
	            this.context.next();
	        }
	        // parse next header
	        var header = this.readHeader();
	        var value;
	        switch (header.type) {
	            case consts_1.types.INT:
	            case consts_1.types.UINT:
	            case consts_1.types.FLOAT:
	            case consts_1.types.SIMPLE:
	                this.type = consts_1.tokens.VALUE;
	                value = this.readValue(header);
	                break;
	            case consts_1.types.BYTES:
	            case consts_1.types.STRING:
	                // handle indefinite length strings: https://tools.ietf.org/html/rfc7049#section-2.2.2
	                if (header.raw === consts_1.additional.BREAK) {
	                    this.context.push(context_1.TokenContextType.string, -1);
	                    this.type = consts_1.tokens.STRING_START;
	                }
	                else {
	                    this.type = consts_1.tokens.VALUE;
	                    value = this.readValue(header);
	                }
	                break;
	            case consts_1.types.ARRAY:
	                this.context.push(context_1.TokenContextType.array, this.readCollectionLength(header));
	                this.type = consts_1.tokens.ARRAY_START;
	                break;
	            case consts_1.types.MAP:
	                var len = this.readCollectionLength(header);
	                // length specifies how many entries; we need to count keys/values separately
	                if (len >= 0) {
	                    len = len * 2;
	                }
	                this.context.push(context_1.TokenContextType.object, len);
	                this.type = consts_1.tokens.MAP_START;
	                break;
	            case consts_1.types.SEMANTIC:
	                return this.nextToken();
	            default:
	                throw new Error('Unknown CBOR header type: ' + header.type);
	        }
	        // break out of existing context if we encounter a break value
	        if (value instanceof Error) {
	            if (this.context.acceptsBreakMarker()) {
	                // by breaking the current context and then recursing, we synthesise the same conditions as if the
	                // collection had naturally exhausted its length
	                this.context.break();
	                return this.nextToken();
	            }
	            else {
	                throw new Error('Unexpected break flag outside of indefinite-length context');
	            }
	        }
	        var data = this.data;
	        this.token = {
	            pos: previousPos,
	            type: this.type,
	            value: value,
	            header: header,
	            length: this.pos,
	            // non-arrow function
	            // `this` refers to the token's properties
	            getBuffer: function () {
	                return data.slice(this.pos, this.length);
	            }
	        };
	        return this.token;
	    };
	    /**
	     * Read a value from the CBOR buffer
	     *
	     * @param  header the type information from the vallue's header
	     * @return        the value that was read
	     * @throws an error if the value type was not recognised
	     */
	    Tokeniser.prototype.readValue = function (header) {
	        switch (header.type) {
	            case consts_1.types.UINT:
	                return this.readHeaderValue(header);
	            case consts_1.types.INT:
	                return this.readHeaderValue(header, true);
	            case consts_1.types.BYTES:
	                return this.readBuffer(this.readHeaderValue(header));
	            case consts_1.types.STRING:
	                return this.readBuffer(this.readHeaderValue(header)).toString('utf-8');
	            case consts_1.types.SIMPLE:
	                return this.readSimpleValue(header.raw);
	        }
	        throw new Error('Unrecognised value type (' + header.type + ')');
	    };
	    /**
	     * Read a primitive value
	     *
	     * @param  type the type of the value to read
	     * @return      the value that was read. A break is signalled by an Error
	     *              being returned (not thrown).
	     */
	    Tokeniser.prototype.readSimpleValue = function (type) {
	        switch (type) {
	            case consts_1.additional.TRUE:
	                return true;
	            case consts_1.additional.FALSE:
	                return false;
	            case consts_1.additional.NULL:
	                return null;
	            case consts_1.additional.BREAK:
	                return BREAK_FLAG;
	            case consts_1.additional.HALF_PRECISION:
	                return this.readFloat16();
	            case consts_1.additional.SINGLE_PRECISION:
	                return this.readFloat32();
	            case consts_1.additional.DOUBLE_PRECISION:
	                return this.readFloat64();
	            default:
	                // undefined value
	                return;
	        }
	    };
	    /**
	     * Read a single byte from the buffer
	     *
	     * @return the byte read from the buffer
	     * @throws an error is there are no more bytes to read
	     */
	    Tokeniser.prototype.readByte = function () {
	        if (this.pos < this.data.length) {
	            return this.data[this.pos++];
	        }
	        else {
	            throw new Error('Exhausted token stream');
	        }
	    };
	    /**
	     * Read a number of bytes and return them as a buffer
	     *
	     * @return the byte read from the buffer
	     */
	    Tokeniser.prototype.readBuffer = function (len) {
	        return this.data.slice(this.pos, this.pos += len);
	    };
	    /**
	     * Read a 16 bit unsigned integer from the buffer
	     *
	     * @return the value read from the buffer
	     */
	    Tokeniser.prototype.readUint16 = function () {
	        var res = this.data.readUInt16BE(this.pos);
	        this.pos += 2;
	        return res;
	    };
	    /**
	     * Read a 32 bit unsigned integer from the buffer
	     *
	     * @return the value read from the buffer
	     */
	    Tokeniser.prototype.readUint32 = function () {
	        var res = this.data.readUInt32BE(this.pos);
	        this.pos += 4;
	        return res;
	    };
	    /**
	     * Read a 64 bit unsigned integer from the buffer
	     *
	     * @return the value read from the buffer. If it is possible to represent
	     *         the integer using the primitive `number` type, a `number` is returned,
	     *         otherwise an `Int64`.
	     */
	    Tokeniser.prototype.readUint64 = function (signed) {
	        var buf = Buffer.from(this.readBuffer(8));
	        if (signed) {
	            for (var j = 0; j < 8; ++j) {
	                /* tslint:disable-next-line:no-bitwise */
	                buf[j] = ~buf[j];
	            }
	        }
	        var i = new int64_impl_1.Int64Impl(buf);
	        var n = i.toNumber();
	        // if addressable as a native 53bit integer, return as a Number
	        if (n <= MAX_SAFE_INTEGER && n >= MIN_SAFE_INTEGER) {
	            return n;
	        }
	        return i;
	    };
	    /**
	     * Read a 16 bit float from the buffer
	     *
	     * @return the value read from the buffer
	     *
	     * See: http://stackoverflow.com/questions/5678432/decompressing-half-precision-floats-in-javascript
	     */
	    Tokeniser.prototype.readFloat16 = function () {
	        var h = this.readUint16();
	        /* tslint:disable-next-line:no-bitwise */
	        var f = (h & 0x03ff);
	        /* tslint:disable-next-line:no-bitwise */
	        var s = (h & 0x8000) >> 15;
	        /* tslint:disable-next-line:no-bitwise */
	        var e = (h & 0x7c00) >> 10;
	        var sign = s ? -1 : 1;
	        if (e === 0) {
	            return sign * Math.pow(2, -14) * (f / Math.pow(2, 10));
	        }
	        else if (e === 0x1f) {
	            return f ? NaN : sign * Infinity;
	        }
	        return sign * Math.pow(2, e - 15) * (1 + (f / Math.pow(2, 10)));
	    };
	    /**
	     *  Read a 32 bit float from the buffer
	     *
	     * @return the value read from the buffer
	     */
	    Tokeniser.prototype.readFloat32 = function () {
	        var res = this.data.readFloatBE(this.pos);
	        this.pos += 4;
	        return res;
	    };
	    /**
	     * Read a 64 bit float from the buffer
	     *
	     * @return the value read from the buffer
	     */
	    Tokeniser.prototype.readFloat64 = function () {
	        var res = this.data.readDoubleBE(this.pos);
	        this.pos += 8;
	        return res;
	    };
	    /**
	     * Read a value header from the buffer
	     *
	     * @return the header information read from the buffer
	     */
	    Tokeniser.prototype.readHeader = function () {
	        var header = this.readByte();
	        return {
	            /* tslint:disable-next-line:no-bitwise */
	            type: header >> 5,
	            /* tslint:disable-next-line:no-bitwise */
	            raw: header & 0x1F
	        };
	    };
	    /**
	     * Read a header value
	     *
	     * @param  header the header type information
	     * @param  signed a flag indicating if the value is negative
	     * @return the header value
	     */
	    Tokeniser.prototype.readHeaderValue = function (header, signed) {
	        if (signed === void 0) { signed = false; }
	        var low = header.raw;
	        var sign = function (value) { return signed ? -1 - value : value; };
	        if (low < 24) {
	            return sign(low);
	        }
	        switch (low) {
	            case consts_1.additional.SIMPLE:
	                return sign(this.readByte());
	            case consts_1.additional.HALF_PRECISION:
	                return sign(this.readUint16());
	            case consts_1.additional.SINGLE_PRECISION:
	                return sign(this.readUint32());
	            case consts_1.additional.DOUBLE_PRECISION:
	                return this.readUint64(signed);
	            case consts_1.additional.BREAK:
	                return BREAK_FLAG;
	            default:
	                throw new Error('Unexpected value ' + low);
	        }
	    };
	    /**
	     * Read the length of a collection
	     *
	     * @param  header the CBOR header
	     * @return the number of elements in the collection or -1 for an empty collection
	     */
	    Tokeniser.prototype.readCollectionLength = function (header) {
	        var result = this.readHeaderValue(header);
	        return (result === BREAK_FLAG) ? -1 : result;
	    };
	    return Tokeniser;
	}());
	exports.Tokeniser = Tokeniser;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Defined reason code and message used to report error conditions.
	 */
	var ErrorReason = /** @class */ (function () {
	    /**
	     * Create an error reason
	     *
	     * @param  id       the error reason's id
	     * @param  reason   the error reason's description
	     */
	    function ErrorReason(id, reason) {
	        this.id = id;
	        this.reason = reason;
	    }
	    /**
	     * Convert the error reson to a string
	     *
	     * @return a string representation of the error reason
	     */
	    ErrorReason.prototype.toString = function () {
	        return this.id + ': ' + this.reason;
	    };
	    return ErrorReason;
	}());
	exports.ErrorReason = ErrorReason;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The state of the internal session
	 */
	var InternalSessionState;
	(function (InternalSessionState) {
	    InternalSessionState["INITIALISING"] = "initialising";
	    InternalSessionState["CONNECTING"] = "connecting";
	    InternalSessionState["CONNECTED"] = "connected";
	    InternalSessionState["DISCONNECTED"] = "disconnected";
	    InternalSessionState["RECONNECTING"] = "reconnecting";
	    InternalSessionState["CLOSING"] = "closing";
	    InternalSessionState["CLOSED"] = "closed";
	})(InternalSessionState = exports.InternalSessionState || (exports.InternalSessionState = {}));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var control_group_1 = __webpack_require__(226);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link ControlGroup}
	 */
	var ControlGroupSerialiserClass = /** @class */ (function (_super) {
	    __extends(ControlGroupSerialiserClass, _super);
	    function ControlGroupSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ControlGroup} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link ControlGroup} that was read
	     */
	    ControlGroupSerialiserClass.prototype.read = function (bis) {
	        var name = Codec.readString(bis);
	        return new control_group_1.ControlGroup(name);
	    };
	    /**
	     * Write a {@link ControlGroup} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link ControlGroup} to be written
	     */
	    ControlGroupSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	    };
	    return ControlGroupSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ControlGroupSerialiserClass = ControlGroupSerialiserClass;
	/**
	 * The {@link ControlGroupSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ControlGroupSerialiser = new ControlGroupSerialiserClass();


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var decoder_1 = __webpack_require__(123);
	var encoder_1 = __webpack_require__(224);
	var binary_delta_type_impl_1 = __webpack_require__(228);
	var bytes_impl_1 = __webpack_require__(102);
	var json_delta_impl_1 = __webpack_require__(1173);
	var int64_impl_1 = __webpack_require__(176);
	var function_1 = __webpack_require__(89);
	var encoder = new encoder_1.Encoder();
	/**
	 * Create a new JSON object from a raw object or a {@link RecordV2Impl}. If a
	 * {@link RecordV2Impl} is passed as argument it is simply returned.
	 *
	 * @param  value  the object to create a JSON from
	 * @return        the JSON created
	 */
	function fromValue(value) {
	    // tslint:disable-next-line:no-use-before-declare
	    if (value instanceof JSONImpl) {
	        return value;
	    }
	    else {
	        // tslint:disable-next-line:no-use-before-declare
	        return new JSONImpl(encoder.encode(value).flush());
	    }
	}
	/**
	 * Replacer function for JSON.stringify that replaces {@link Int64Impl} objects
	 * with their string representation
	 *
	 * @param  key    the object key (this argument is ignored)
	 * @param  value  the value to replace
	 * @return        if `value` is an {@link Int64Impl} then the string
	 *                representation is returned. Otherwise `value` is returned
	 *                unchanged.
	 */
	function int64Replacer(key, value) {
	    if (value instanceof int64_impl_1.Int64Impl) {
	        return value.toString();
	    }
	    return value;
	}
	/**
	 * Implementation of {@link JSON} object.
	 */
	var JSONImpl = /** @class */ (function (_super) {
	    __extends(JSONImpl, _super);
	    /**
	     * Create a new JSONImpl instance
	     *
	     * @param  buffer  the internal buffer containing the JSON`
	     * @param  offset  the offset of the data in the buffer
	     * @param  length  the number of bytes of the data in the buffer
	     */
	    function JSONImpl(buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        return _super.call(this, buffer, offset, length) || this;
	    }
	    /**
	     * Return the name of the data type
	     *
	     * @return `JSONImpl`
	     */
	    JSONImpl.toString = function () {
	        return 'JSONImpl';
	    };
	    /**
	     * Create a new JSON object from a raw object or a {@link RecordV2Impl}. If a
	     * {@link RecordV2Impl} is passed as argument it is simply returned.
	     *
	     * @param  value  the object to create a JSON from
	     * @return        the JSON created
	     */
	    JSONImpl.from = function (value) {
	        return fromValue(value);
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONImpl.prototype.get = function () {
	        var decoder = new decoder_1.Decoder(this.$buffer, this.$offset, this.$length);
	        return decoder.nextValue();
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONImpl.prototype.diff = function (original, type) {
	        var originalJson = fromValue(original);
	        var binaryDiff = this.binaryDiff(originalJson);
	        if (type === 'json') {
	            return new json_delta_impl_1.JSONDeltaImpl(JSONImpl, originalJson, this, binaryDiff);
	        }
	        else {
	            return binaryDiff;
	        }
	    };
	    /**
	     * Compare this JSON value with an earlier version to create a structural
	     * {@link JSONDelta json delta}.
	     *
	     * Convenient equivalent to:
	     * `this.diff(original, 'binary');`
	     *
	     * Standard JSON objects may also be provided as the value to diff instead
	     * of a {@link JSON} instance.
	     *
	     * **Example:**
	     * ```
	     * const delta = binaryDiff.jsonDiff({ foo : 'bar' });
	     * ```
	     *
	     * @param original  the value to diff against this
	     * @return          a delta representing the difference between this and
	     *                  the provided value
	     */
	    JSONImpl.prototype.binaryDiff = function (original) {
	        // tslint:disable-next-line:no-use-before-declare
	        return BINARY_DELTA_TYPE.diff(original, this);
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONImpl.prototype.jsonDiff = function (original) {
	        return this.diff(original, 'json');
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONImpl.prototype.apply = function (delta) {
	        // tslint:disable-next-line:no-use-before-declare
	        return BINARY_DELTA_TYPE.apply(this, delta);
	    };
	    /**
	     * Convert the objet to a string
	     *
	     * @return  a string representation of the JSONImpl
	     */
	    JSONImpl.prototype.toString = function () {
	        return JSON.stringify(this.get());
	    };
	    /**
	     * Convert the objet to a JSON string
	     *
	     * @return  a JSON string representation of the JSON object
	     */
	    JSONImpl.prototype.toJsonString = function () {
	        return JSON.stringify(this.get(), int64Replacer);
	    };
	    return JSONImpl;
	}(bytes_impl_1.BytesImpl));
	exports.JSONImpl = JSONImpl;
	/**
	 * A unique binary delta type instance to calculate deltas of {@link JSONImpl}
	 */
	var BINARY_DELTA_TYPE = new binary_delta_type_impl_1.BinaryDeltaTypeImpl(JSONImpl, fromValue, function_1.identity);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var decoder_1 = __webpack_require__(123);
	var encoder_1 = __webpack_require__(224);
	var abstract_datatype_1 = __webpack_require__(144);
	var bytes_impl_1 = __webpack_require__(102);
	var json_impl_1 = __webpack_require__(328);
	var encoder = new encoder_1.Encoder();
	var NULL_CBOR = new bytes_impl_1.BytesImpl(Buffer.from([0xf6]));
	/**
	 * The primitive data type acts as the base class for primitive value types
	 * `string`, `double`, and `Int64`.
	 *
	 * @param <ValueType>   the value type of the data type
	 * @param <SourceType>  the type(s) from which a value can be constructed
	 */
	var PrimitiveDataType = /** @class */ (function (_super) {
	    __extends(PrimitiveDataType, _super);
	    /**
	     * Create a new instance of `PrimitiveDataType`
	     *
	     * @param typeName           the data type name
	     * @param valueClass         the constructor function creating the value type
	     * @param serialise          serialise the value into a CBOR encoder
	     * @param cborTypePredicate  a predicate returning `true` if the CBOR type is
	     *                           supported by this data type.
	     * @param withBinaryDelta    a flag indicating if the data type supports binary deltas
	     */
	    function PrimitiveDataType(typeName, valueClass, serialise, cborTypePredicate, withBinaryDelta) {
	        var _this = this;
	        var vToC = function (value) {
	            serialise(value, encoder);
	            return new bytes_impl_1.BytesImpl(encoder.flush());
	        };
	        var cToV = function (bytes) {
	            if (NULL_CBOR.equals(bytes)) {
	                return null;
	            }
	            var decoder = new decoder_1.Decoder(bytes.$buffer, bytes.$offset, bytes.$length);
	            return decoder.nextValueExpecting(cborTypePredicate);
	        };
	        var jsonConverter = {
	            name: json_impl_1.JSONImpl.toString(),
	            convert: function (buffer, offset, length) {
	                return new json_impl_1.JSONImpl(buffer, offset, length);
	            }
	        };
	        _this = _super.call(this, typeName, valueClass, bytes_impl_1.BytesImpl, vToC, cToV, [jsonConverter], withBinaryDelta) || this;
	        _this.serialise = serialise;
	        _this.fromValue = vToC;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    PrimitiveDataType.prototype.writeValue = function (value) {
	        if (value === null || value === undefined) {
	            return NULL_CBOR.asBuffer();
	        }
	        else {
	            this.serialise(value, encoder);
	            return encoder.flush();
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    PrimitiveDataType.prototype.validate = function () {
	        // no-op. This data type validates on read.
	    };
	    /**
	     * Create a new Bytes instance from data
	     *
	     * @param value  the value or CBOR data containing the record
	     * @return       a new Binary representation of the value
	     */
	    PrimitiveDataType.prototype.from = function (value) {
	        if (value.$buffer) {
	            return value;
	        }
	        else {
	            return this.fromValue(value);
	        }
	    };
	    return PrimitiveDataType;
	}(abstract_datatype_1.AbstractDataType));
	exports.PrimitiveDataType = PrimitiveDataType;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var binary_delta_type_impl_1 = __webpack_require__(228);
	var bytes_impl_1 = __webpack_require__(102);
	var record_model_impl_1 = __webpack_require__(1180);
	var recordv2_delta_impl_1 = __webpack_require__(1183);
	var recordv2_parser_1 = __webpack_require__(499);
	var recordv2_utils_1 = __webpack_require__(231);
	var buffer_output_stream_1 = __webpack_require__(80);
	var function_1 = __webpack_require__(89);
	/**
	 * The result of a difference operation between two RecordV2 instances
	 */
	var DiffResult = /** @class */ (function () {
	    function DiffResult() {
	        /**
	         * A stream recording the delta between the two records
	         */
	        this.delta = new buffer_output_stream_1.BufferOutputStream();
	        /**
	         * A flag indicating whether there are changes between the records
	         */
	        this.changed = false;
	        /**
	         * The record changes
	         */
	        this.recordChanges = null;
	        /**
	         * The field changes
	         */
	        this.fieldChanges = {};
	    }
	    /**
	     * Record a change
	     *
	     * @param buffer  the buffer of the change to record or a single number
	     * @param offset  the offset in the buffer
	     * @param length  the amount of bytes to write from the provided buffer
	     */
	    DiffResult.prototype.write = function (buffer, offset, length) {
	        if (offset !== undefined && length !== undefined) {
	            this.delta.writeMany(buffer, offset, length);
	        }
	        else {
	            this.delta.write(buffer);
	        }
	    };
	    /**
	     * Get the delta
	     *
	     * @return the delta inside a buffer
	     */
	    DiffResult.prototype.getDelta = function () {
	        return this.delta.getBuffer();
	    };
	    /**
	     * The size of the delta
	     *
	     * @return the number of bytes recorded
	     */
	    DiffResult.prototype.size = function () {
	        return this.delta.count;
	    };
	    /**
	     * Check if there are any changes
	     *
	     * @return `true` if a change has been recorded
	     */
	    DiffResult.prototype.hasChanges = function () {
	        return this.changed;
	    };
	    /**
	     * Record a change
	     */
	    DiffResult.prototype.setChanged = function () {
	        this.changed = true;
	    };
	    /**
	     * Record a changed record
	     *
	     * @param added  a flag indicating if the record was added or removed
	     * @param index  the record index
	     */
	    DiffResult.prototype.setRecordsChanged = function (added, index) {
	        this.recordChanges = [added, index];
	        this.changed = true;
	    };
	    /**
	     * Get the recorded record changes
	     *
	     * @return the record changes or `null` if there were no changes
	     */
	    DiffResult.prototype.getRecordChanges = function () {
	        return this.recordChanges;
	    };
	    /**
	     * Record an added field
	     *
	     * @param recordIndex  the index of the record
	     * @param fieldIndex   the index of the field
	     */
	    DiffResult.prototype.setFieldsAdded = function (recordIndex, fieldIndex) {
	        this.fieldChanges[recordIndex] = [true, fieldIndex];
	        this.changed = true;
	    };
	    /**
	     * Record a removed field
	     *
	     * @param recordIndex  the index of the record
	     * @param fieldIndex   the index of the field
	     */
	    DiffResult.prototype.setFieldsRemoved = function (recordIndex, fieldIndex) {
	        this.fieldChanges[recordIndex] = [false, fieldIndex];
	        this.changed = true;
	    };
	    /**
	     * Get the recorded field changes
	     *
	     * @return the field changes
	     */
	    DiffResult.prototype.getFieldChanges = function () {
	        return this.fieldChanges;
	    };
	    return DiffResult;
	}());
	/**
	 * Calculate the differences between two records
	 *
	 * @param oldBytes   the buffer of the old record
	 * @param oldOffset  the offset in the buffer of the old record
	 * @param oldLength  the number of bytes in the old record
	 * @param newBytes   the buffer of the new record
	 * @param newOffset  the offset in the buffer of the new record
	 * @param newLength  the number of bytes in the new record
	 * @return           the difference between the buffers
	 */
	function diffRecords(oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength) {
	    var result = new DiffResult();
	    var oldCount = recordv2_utils_1.recordCount(oldBytes, oldOffset, oldLength);
	    var newCount = recordv2_utils_1.recordCount(newBytes, newOffset, newLength);
	    var minCount = Math.min(oldCount, newCount);
	    var oldStart = oldOffset;
	    var oldEnd = oldOffset;
	    var newStart = newOffset;
	    var newEnd = newOffset;
	    for (var i = 0; i < minCount; ++i) {
	        oldEnd = recordv2_utils_1.findDelimiter(oldBytes, oldEnd, oldOffset + oldLength, recordv2_utils_1.RECORD_DELIMITER);
	        newEnd = recordv2_utils_1.findDelimiter(newBytes, newEnd, newOffset + newLength, recordv2_utils_1.RECORD_DELIMITER);
	        if (i > 0) {
	            result.write(recordv2_utils_1.RECORD_DELIMITER);
	        }
	        diffRecord(i, oldBytes, oldStart, oldEnd - oldStart, newBytes, newStart, newEnd - newStart, result);
	        oldStart = ++oldEnd;
	        newStart = ++newEnd;
	    }
	    if (newCount !== oldCount) {
	        if (newCount > oldCount) {
	            result.write(newBytes, newStart - 1, newOffset + newLength - newStart + 1);
	        }
	        result.setRecordsChanged(newCount > oldCount, minCount);
	    }
	    return result;
	}
	/**
	 * Calculate the differences between two record entries
	 *
	 * @param recordIndex  the index of the record
	 * @param oldBytes     the buffer of the old record
	 * @param oldOffset    the offset in the buffer of the old record
	 * @param oldLength    the number of bytes in the old record
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @param result       the result recording the difference between the buffers
	 */
	function diffRecord(recordIndex, oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength, result) {
	    if (newLength === 0) {
	        if (oldLength !== 0) {
	            result.setFieldsRemoved(recordIndex, 0);
	        }
	        return;
	    }
	    if (recordv2_utils_1.recordIsSingleEmptyField(newBytes, newOffset, newLength)) {
	        diffWhenNewIsSingleEmptyField(recordIndex, oldBytes, oldOffset, oldLength, result);
	        return;
	    }
	    if (oldLength === 0) {
	        result.write(newBytes, newOffset, newLength);
	        result.setFieldsAdded(recordIndex, 0);
	        return;
	    }
	    if (recordv2_utils_1.recordIsSingleEmptyField(oldBytes, oldOffset, oldLength)) {
	        diffWhenOldIsSingleEmptyField(recordIndex, newBytes, newOffset, newLength, result);
	        return;
	    }
	    diffRecordFields(recordIndex, oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength, result);
	}
	/**
	 * Calculate the differences between two record entries when the new record
	 * contains a single empty field
	 *
	 * @param recordIndex  the index of the record
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @param result       the result recording the difference between the buffers
	 */
	function diffWhenNewIsSingleEmptyField(recordIndex, oldBytes, oldOffset, oldLength, result) {
	    if (recordv2_utils_1.recordIsSingleEmptyField(oldBytes, oldOffset, oldLength)) {
	        result.write(recordv2_utils_1.FIELD_MU);
	    }
	    else {
	        var oldCount = recordv2_utils_1.fieldCount(oldBytes, oldOffset, oldLength);
	        if (oldCount > 1) {
	            result.setFieldsRemoved(recordIndex, 1);
	        }
	        result.write(recordv2_utils_1.EMPTY_FIELD);
	        result.setChanged();
	    }
	}
	/**
	 * Calculate the differences between two record entries when the old record
	 * contains a single empty field
	 *
	 * @param recordIndex  the index of the record
	 * @param oldBytes     the buffer of the old record
	 * @param oldOffset    the offset in the buffer of the old record
	 * @param oldLength    the number of bytes in the old record
	 * @param result       the result recording the difference between the buffers
	 */
	function diffWhenOldIsSingleEmptyField(recordIndex, newBytes, newOffset, newLength, result) {
	    var b = newBytes[newOffset];
	    if (b === recordv2_utils_1.EMPTY_FIELD) {
	        result.write(newBytes, newOffset + 1, newLength - 1);
	    }
	    else {
	        result.write(newBytes, newOffset, newLength);
	        if (b !== recordv2_utils_1.FIELD_DELIMITER) {
	            result.setChanged();
	        }
	    }
	    if (recordv2_utils_1.fieldCount(newBytes, newOffset, newLength) > 1) {
	        result.setFieldsAdded(recordIndex, 1);
	    }
	}
	/**
	 * Calculate the differences between the fields of two record entries
	 *
	 * @param recordIndex  the index of the record
	 * @param oldBytes     the buffer of the old record
	 * @param oldOffset    the offset in the buffer of the old record
	 * @param oldLength    the number of bytes in the old record
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @param result       the result recording the difference between the buffers
	 */
	function diffRecordFields(recordIndex, oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength, result) {
	    var oldCount = recordv2_utils_1.fieldCount(oldBytes, oldOffset, oldLength);
	    var newCount = recordv2_utils_1.fieldCount(newBytes, newOffset, newLength);
	    var same = Math.min(oldCount, newCount);
	    var oldStart = oldOffset;
	    var oldEnd = oldOffset;
	    var newStart = newOffset;
	    var newEnd = newOffset;
	    var startSize = result.size();
	    for (var i = 0; i < same; ++i) {
	        oldEnd = recordv2_utils_1.findDelimiter(oldBytes, oldEnd, oldOffset + oldLength, recordv2_utils_1.FIELD_DELIMITER);
	        newEnd = recordv2_utils_1.findDelimiter(newBytes, newEnd, newOffset + newLength, recordv2_utils_1.FIELD_DELIMITER);
	        if (i > 0) {
	            result.write(recordv2_utils_1.FIELD_DELIMITER);
	        }
	        diffField(oldBytes, oldStart, oldEnd - oldStart, newBytes, newStart, newEnd - newStart, result);
	        oldStart = ++oldEnd;
	        newStart = ++newEnd;
	    }
	    if (newCount !== oldCount) {
	        if (newCount > oldCount) {
	            result.write(newBytes, newStart - 1, newOffset + newLength - newStart + 1);
	            result.setFieldsAdded(recordIndex, same);
	        }
	        else {
	            result.setFieldsRemoved(recordIndex, same);
	        }
	    }
	    if (newCount === 1 && startSize === result.size()) {
	        result.write(recordv2_utils_1.FIELD_MU);
	    }
	}
	/**
	 * Calculate the differences between two fields
	 *
	 * @param oldBytes     the buffer of the old record
	 * @param oldOffset    the offset in the buffer of the old record
	 * @param oldLength    the number of bytes in the old record
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @param result       the result recording the difference between the buffers
	 */
	function diffField(oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength, result) {
	    if (fieldsAreEqual(oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength)) {
	        return;
	    }
	    if (newLength === 0) {
	        result.write(recordv2_utils_1.EMPTY_FIELD);
	    }
	    else {
	        result.write(newBytes, newOffset, newLength);
	    }
	    result.setChanged();
	}
	/**
	 * Check if two fields are equal. The fields may be empty.
	 *
	 * @param oldBytes     the buffer of the old record
	 * @param oldOffset    the offset in the buffer of the old record
	 * @param oldLength    the number of bytes in the old record
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @return             `true` if the two fields are equal
	 */
	function fieldsAreEqual(oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength) {
	    if (oldLength === newLength) {
	        if (oldLength === 0 || fieldEquals(oldBytes, oldOffset, newBytes, newOffset, oldLength)) {
	            return true;
	        }
	    }
	    else if (oldLength === 1 && oldBytes[oldOffset] === recordv2_utils_1.EMPTY_FIELD && newLength === 0) {
	        return true;
	    }
	    else if (newLength === 1 && newBytes[newOffset] === recordv2_utils_1.EMPTY_FIELD && oldLength === 0) {
	        return true;
	    }
	    return false;
	}
	/**
	 * Check if two non-empty fields are equal
	 *
	 * @param oldBytes     the buffer of the old record
	 * @param oldOffset    the offset in the buffer of the old record
	 * @param oldLength    the number of bytes in the old record
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @return             `true` if the two fields are equal
	 */
	function fieldEquals(oldBytes, oldOffset, newBytes, newOffset, length) {
	    for (var i = 0; i < length; ++i) {
	        if (oldBytes[oldOffset + i] !== newBytes[newOffset + i]) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * Create a new RecordV2DeltaImpl for an empty value
	 *
	 * @return a new RecordV2DeltaImpl
	 */
	function deltaForEmptyNewValue() {
	    return new recordv2_delta_impl_1.RecordV2DeltaImpl(Buffer.from([]), 0, 0, [false, 0], {});
	}
	/**
	 * Create a new RecordV2DeltaImpl for a single record with no fields
	 *
	 * @return a new RecordV2DeltaImpl
	 */
	function deltaForSingleEmptyRecordNewValue(oldRecordCount) {
	    switch (oldRecordCount) {
	        case 0:
	            return new recordv2_delta_impl_1.RecordV2DeltaImpl(Buffer.from([recordv2_utils_1.RECORD_MU]), 0, 1, [true, 0], {});
	        case 1:
	            return new recordv2_delta_impl_1.RecordV2DeltaImpl(Buffer.from([recordv2_utils_1.RECORD_MU]), 0, 1, null, { 0: [false, 0] });
	        default:
	            return new recordv2_delta_impl_1.RecordV2DeltaImpl(Buffer.from([recordv2_utils_1.RECORD_MU]), 0, 1, [false, 1], { 0: [false, 0] });
	    }
	}
	/**
	 * Create a RecordV2DeltaImpl that contains only new records
	 *
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @return a new RecordV2DeltaImpl
	 */
	function deltaForAllNewRecords(newBytes, newOffset, newLength) {
	    return new recordv2_delta_impl_1.RecordV2DeltaImpl(newBytes, newOffset, newLength, [true, 0], {});
	}
	/**
	 * Return a delta for when the old value is a single empty record.
	 * This assumes that the new record is neither empty nor a single empty
	 * record.
	 *
	 * @param newBytes     the buffer of the new record
	 * @param newOffset    the offset in the buffer of the new record
	 * @param newLength    the number of bytes in the new record
	 * @return a new RecordV2DeltaImpl
	 */
	function deltaForOldSingleEmptyRecord(newBytes, newOffset, newLength) {
	    var newRecordCount = recordv2_utils_1.recordCount(newBytes, newOffset, newLength);
	    if (newRecordCount === 1) {
	        // single record so fields added to first
	        return new recordv2_delta_impl_1.RecordV2DeltaImpl(newBytes, newOffset, newLength, null, { 0: [true, 0] });
	    }
	    else {
	        // records added
	        return new recordv2_delta_impl_1.RecordV2DeltaImpl(newBytes, newOffset, newLength, [true, 1], newBytes[0] === recordv2_utils_1.RECORD_DELIMITER ? {} : { 0: [true, 0] });
	    }
	}
	/**
	 * Create a new RecordV2 object from a buffer or {@link RecordV2Impl}. If a
	 * {@link RecordV2Impl} is passed as argument it is simply returned.
	 *
	 * @param  value  the object to create a record from
	 * @return        the record created
	 */
	function fromValue(value) {
	    // tslint:disable-next-line:no-use-before-declare
	    if (value instanceof RecordV2Impl) {
	        return value;
	    }
	    else if (Buffer.isBuffer(value)) {
	        // tslint:disable-next-line:no-use-before-declare
	        return new RecordV2Impl(value);
	    }
	    else {
	        throw new Error("Unable to read RecordV2 value from: " + value);
	    }
	}
	/**
	 * Implementation of {@link RecordV2Delta}
	 */
	var RecordV2Impl = /** @class */ (function (_super) {
	    __extends(RecordV2Impl, _super);
	    /**
	     * Create a RecordV2DeltaImpl instance
	     *
	     * @param  buffer  the internal buffer
	     * @param  offset  the offset of the slice
	     * @param  length  the number of bytes in the slice
	     * @param  recordChanges  an array containing a record index at position 0
	     *                        and a boolean at position 1 indicating if a record
	     *                        has changed
	     * @param  fieldChanges   an array of arrays containing a field index at
	     *                        position 0 and a boolean at position 1 indicating
	     *                        which fields have changed
	     */
	    function RecordV2Impl(buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        return _super.call(this, buffer, offset, length) || this;
	    }
	    /**
	     * Return the name of the data type
	     *
	     * @return `RecordV2Impl`
	     */
	    RecordV2Impl.toString = function () {
	        return 'RecordV2Impl';
	    };
	    /**
	     * Create a new RecordV2 object from a buffer or {@link RecordV2Impl}. If a
	     * {@link RecordV2Impl} is passed as argument it is simply returned.
	     *
	     * @param  value  the object to create a record from
	     * @return        the record created
	     */
	    RecordV2Impl.from = function (value) {
	        return fromValue(value);
	    };
	    /**
	     * Apply a delta and return a buffer with containing a modified record.
	     *
	     * If the delta does not contain any changes `this` is returned.
	     *
	     * @param delta  the delta to apply
	     * @return       the modified record
	     */
	    RecordV2Impl.prototype.apply = function (delta) {
	        // tslint:disable-next-line:no-use-before-declare
	        return BINARY_DELTA_TYPE.apply(this, delta);
	    };
	    /**
	     * Convert the objet to a string
	     *
	     * @return  a string representation of the RecordV2Impl
	     */
	    RecordV2Impl.prototype.toString = function () {
	        return JSON.stringify(this.asRecords());
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2Impl.prototype.asRecords = function () {
	        return recordv2_parser_1.parse(this.$buffer, this.$offset, this.$length);
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2Impl.prototype.asFields = function () {
	        return this.asRecords().reduce(function (fields, record) {
	            return fields.concat(record);
	        }, []);
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2Impl.prototype.asModel = function (schema) {
	        return new record_model_impl_1.RecordModelImpl(RecordV2Impl, schema, this.asRecords(), false);
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2Impl.prototype.asValidatedModel = function (schema) {
	        return new record_model_impl_1.RecordModelImpl(RecordV2Impl, schema, this.asRecords(), true);
	    };
	    /**
	     * Calculate the binary difference between the record and another buffer.
	     */
	    RecordV2Impl.prototype.binaryDiff = function (original) {
	        // tslint:disable-next-line:no-use-before-declare
	        return BINARY_DELTA_TYPE.diff(original, this);
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2Impl.prototype.diff = function (original) {
	        var oldBytes = original.$buffer;
	        var oldOffset = original.$offset;
	        var oldLength = original.$length;
	        var newBytes = this.$buffer;
	        var newOffset = this.$offset;
	        var newLength = this.$length;
	        if (newLength === 0) {
	            if (oldLength === 0) {
	                return recordv2_delta_impl_1.NO_CHANGE;
	            }
	            return deltaForEmptyNewValue();
	        }
	        else if (recordv2_utils_1.isSingleEmptyRecord(newBytes, newOffset, newLength)) {
	            if (recordv2_utils_1.isSingleEmptyRecord(oldBytes, oldOffset, oldLength)) {
	                return recordv2_delta_impl_1.NO_CHANGE;
	            }
	            return deltaForSingleEmptyRecordNewValue(recordv2_utils_1.recordCount(oldBytes, oldOffset, oldLength));
	        }
	        if (oldLength === 0) {
	            return deltaForAllNewRecords(newBytes, newOffset, newLength);
	        }
	        else if (recordv2_utils_1.isSingleEmptyRecord(oldBytes, oldOffset, oldLength)) {
	            return deltaForOldSingleEmptyRecord(newBytes, newOffset, newLength);
	        }
	        var result = diffRecords(oldBytes, oldOffset, oldLength, newBytes, newOffset, newLength);
	        if (result.hasChanges()) {
	            var delta = result.getDelta();
	            return new recordv2_delta_impl_1.RecordV2DeltaImpl(delta, 0, delta.length, result.getRecordChanges(), result.getFieldChanges());
	        }
	        else {
	            return recordv2_delta_impl_1.NO_CHANGE;
	        }
	    };
	    return RecordV2Impl;
	}(bytes_impl_1.BytesImpl));
	exports.RecordV2Impl = RecordV2Impl;
	/**
	 * A unique binary delta type instance to calculate deltas of {@link RecordV2Impl}
	 */
	var BINARY_DELTA_TYPE = new binary_delta_type_impl_1.BinaryDeltaTypeImpl(RecordV2Impl, fromValue, function_1.identity);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A Record V2 field type
	 */
	var Type;
	(function (Type) {
	    Type["DECIMAL"] = "DECIMAL";
	    Type["INTEGER"] = "INTEGER";
	    Type["STRING"] = "STRING";
	})(Type = exports.Type || (exports.Type = {}));
	/**
	 * A Record V2 field schema entry
	 */
	var FieldImpl = /** @class */ (function () {
	    /**
	     * Create a new field
	     *
	     * @param  name   the name of the field
	     * @param  type   the datatype of the field
	     * @param  min    the minimum number of occurrences of the node within its parent
	     * @param  max    the maximum number of occurrences of the node within its parent
	     * @param  index  the index of the field
	     * @param  scale  an optional scale for decimal field types
	     */
	    function FieldImpl(name, type, min, max, index, scale) {
	        this.name = name;
	        this.type = type;
	        this.min = min;
	        this.max = max;
	        this.scale = scale;
	        this.index = index;
	        this.isVariable = min !== max;
	    }
	    /**
	     * Calculate the absolute index of the field
	     *
	     * @param  index  the index offset
	     * @return        the absolute index
	     * @throws        an error if the index offset is out of range
	     */
	    FieldImpl.prototype.getAbsoluteIndex = function (index) {
	        if (index < 0 || this.max !== -1 && index > this.max - 1) {
	            throw new Error("Invalid index '" + index + "' for field '" + this.name + "'");
	        }
	        return this.index + index;
	    };
	    /**
	     * Convert the field to a string
	     *
	     * @return  a string representation of the field
	     */
	    FieldImpl.prototype.toString = function () {
	        var ret = "Name=" + this.name + ", Type=" + this.type;
	        if (this.min === this.max) {
	            ret += ", Occurs=" + this.min;
	        }
	        else {
	            ret += ", Min=" + this.min + ", Max=";
	            if (this.max === -1) {
	                ret += 'Unlimited';
	            }
	            else {
	                ret += this.max;
	            }
	        }
	        if (this.type === Type.DECIMAL) {
	            ret += ", Scale=" + this.scale;
	        }
	        return "Field [" + ret + "]";
	    };
	    /**
	     * Returns a model string representation of the field's data type.
	     *
	     * @return       the zero value or empty string formatted according to the data
	     *               type
	     */
	    FieldImpl.prototype.modelValue = function () {
	        switch (this.type) {
	            case Type.DECIMAL:
	                return decimalModelValue(this);
	            case Type.INTEGER:
	                return '0';
	            case Type.STRING:
	            default:
	                return '';
	        }
	    };
	    /**
	     * Convert the field schema to a raw data object
	     *
	     * @return  a data object that can be serialised into a JSON string
	     */
	    FieldImpl.prototype.toJSON = function () {
	        var o = {
	            name: this.name,
	            type: this.type,
	            min: this.min,
	            max: this.max
	        };
	        if (this.type === Type.DECIMAL) {
	            o.scale = this.scale;
	        }
	        return o;
	    };
	    return FieldImpl;
	}());
	exports.FieldImpl = FieldImpl;
	/**
	 * Returns a validated value in the format indicated by the field
	 *
	 * @param field  the field providing the type information
	 * @param value  the value to convert
	 * @return       a string representation of the value
	 */
	function normalise(field, value) {
	    switch (field.type) {
	        case Type.DECIMAL:
	            var f = parseFloat(value);
	            if (Number.isNaN(f)) {
	                throw new Error("Invalid decimal value: '" + value + "'");
	            }
	            return f.toFixed(field.scale);
	        case Type.INTEGER:
	            var i = parseInt(value, 10);
	            var s = i.toString();
	            if (Number.isNaN(i) || s.indexOf('.') > -1) {
	                throw new Error("Invalid integer value: '" + value + "'");
	            }
	            return s;
	        case Type.STRING:
	            return value;
	        default:
	            return '';
	    }
	}
	exports.normalise = normalise;
	/**
	 * Returns a model string representation of the field's data type for the
	 * decimal type.
	 *
	 * @param field  the field providing the type information
	 * @return       the zero value formatted according to the data type and scale
	 */
	function decimalModelValue(field) {
	    switch (field.scale) {
	        case undefined:
	        case 1:
	            return '0.0';
	        case 2:
	            return '0.00';
	        case 3:
	            return '0.000';
	        default:
	            var ret = '0.';
	            for (var i = 0; i < field.scale; ++i) {
	                ret += '0';
	            }
	            return ret;
	    }
	}


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module GatewayControl
	 */
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_client_add_service_request_1 = __webpack_require__(1298);
	var gateway_client_get_configuration_request_1 = __webpack_require__(1299);
	var gateway_client_get_service_types_request_1 = __webpack_require__(1300);
	var gateway_client_get_services_request_1 = __webpack_require__(1301);
	var gateway_client_get_status_request_1 = __webpack_require__(1302);
	var gateway_client_update_service_request_1 = __webpack_require__(1304);
	var gateway_client_get_operation_detail_request_1 = __webpack_require__(1310);
	var gateway_client_get_operations_request_1 = __webpack_require__(1311);
	var gateway_client_invoke_operation_request_1 = __webpack_require__(1312);
	var remove_service_request_1 = __webpack_require__(1317);
	var service_get_configuration_request_1 = __webpack_require__(1318);
	var service_get_operation_detail_request_1 = __webpack_require__(1319);
	var service_get_operations_request_1 = __webpack_require__(1320);
	var service_get_status_request_1 = __webpack_require__(1321);
	var service_invoke_operation_request_1 = __webpack_require__(1322);
	var GatewayServices = __webpack_require__(1325);
	var session_id_1 = __webpack_require__(127);
	/** Gateway client status item severity indicator */
	var StatusLevel;
	(function (StatusLevel) {
	    StatusLevel[StatusLevel["GREEN"] = 0] = "GREEN";
	    StatusLevel[StatusLevel["AMBER"] = 1] = "AMBER";
	    StatusLevel[StatusLevel["RED"] = 2] = "RED";
	})(StatusLevel = exports.StatusLevel || (exports.StatusLevel = {}));
	/**
	 * Implements the {@link GatewayControl} feature
	 */
	var GatewayControlImpl = /** @class */ (function () {
	    /**
	     * Create a new GatewayControlImpl instance
	     *
	     * @param internal     the internal session
	     */
	    function GatewayControlImpl(internal) {
	        this.internal = internal;
	        this.clientRequestsService = internal.getServiceLocator().obtain(GatewayServices.GATEWAY_CLIENT_REQUEST);
	        this.getClientsService = internal.getServiceLocator().obtain(GatewayServices.GET_GATEWAY_CLIENTS);
	        this.registerClientService = internal.getServiceLocator().obtain(GatewayServices.REGISTER_GATEWAY_CLIENT);
	        this.removeClientService = internal.getServiceLocator().obtain(GatewayServices.REMOVE_GATEWAY_CLIENT);
	    }
	    GatewayControlImpl.prototype.checkSessionId = function (sessionId) {
	        if (sessionId instanceof session_id_1.SessionId) {
	            return sessionId;
	        }
	        else if (typeof sessionId === 'string') {
	            return session_id_1.SessionId.fromString(sessionId);
	        }
	        else if (sessionId === null) {
	            throw Error("Session ID must be a string or instance of SessionId, but was null");
	        }
	        throw Error("Session ID must be a string or instance of SessionId, but was of type: " + typeof sessionId);
	    };
	    GatewayControlImpl.prototype.checkClientKey = function (clientKey) {
	        // tslint:disable-next-line: strict-type-predicates
	        if (clientKey === null || clientKey === undefined || typeof clientKey !== 'object') {
	            throw Error("clientKey must be a non-null object");
	            // tslint:disable-next-line: strict-type-predicates
	        }
	        else if (clientKey.type === null || clientKey.type === undefined) {
	            throw Error("clientKey type must not be null or undefined");
	            // tslint:disable-next-line: strict-type-predicates
	        }
	        else if (clientKey.id === null || clientKey.id === undefined) {
	            throw Error("clientKey id must not be null or undefined");
	        }
	        return clientKey;
	    };
	    GatewayControlImpl.prototype.checkOperationName = function (operationName) {
	        return this.checkStringArgument(operationName, 'Operation name');
	    };
	    GatewayControlImpl.prototype.checkStringArgument = function (argument, argName) {
	        if (typeof argument === 'string') {
	            return argument;
	        }
	        else if (argument === null) {
	            throw Error(argName + " must be a string, but was null");
	        }
	        throw Error(argName + " must be a string, but was of type: " + typeof argument);
	    };
	    GatewayControlImpl.prototype.checkServiceId = function (serviceId) {
	        return {
	            name: this.checkStringArgument(serviceId.name, 'Service ID name'),
	            type: this.checkStringArgument(serviceId.type, 'Service ID type')
	        };
	    };
	    GatewayControlImpl.prototype.checkServiceHandle = function (serviceHandle) {
	        return __assign({}, this.checkServiceId(serviceHandle), { sessionId: this.checkSessionId(serviceHandle.sessionId) });
	    };
	    GatewayControlImpl.prototype.sessionContextTransformer = function (sessionId) {
	        return function (gsi) {
	            return (__assign({}, gsi, { id: __assign({}, gsi.id, { sessionId: sessionId }) }));
	        };
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getConfiguration = function (sessionId) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_get_configuration_request_1.GatewayClientGetConfigurationRequest(sid), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getStatus = function (sessionId) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_get_status_request_1.GatewayClientGetStatusRequest(sid), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getClients = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.getClientsService.send(null, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.registerClient = function (clientKey) {
	        var _this = this;
	        var key = this.checkClientKey(clientKey);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.registerClientService.send(key, function (err) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.removeClient = function (clientKey) {
	        var _this = this;
	        var key = this.checkClientKey(clientKey);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.removeClientService.send(key, function (err) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getOperations = function (sessionId) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_get_operations_request_1.GatewayClientGetOperationsRequest(sid), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getOperationDetail = function (sessionId, operationName) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        var opName = this.checkOperationName(operationName);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_get_operation_detail_request_1.GatewayClientGetOperationDetailRequest(sid, opName), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.invokeOperation = function (sessionId, operationName, input) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        var opName = this.checkOperationName(operationName);
	        // tslint:disable-next-line: strict-type-predicates
	        var opInput = input === null ? undefined : input;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_invoke_operation_request_1.GatewayClientInvokeOperationRequest(sid, opName, opInput), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getServiceTypes = function (sessionId) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_get_service_types_request_1.GatewayClientGetServiceTypesRequest(sid), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response.serviceTypes);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getServices = function (sessionId) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_get_services_request_1.GatewayClientGetServicesRequest(sid), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        var addSessionId = _this.sessionContextTransformer(sid);
	                        resolve(response.services.map(addSessionId));
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.addService = function (sessionId, newServiceId, description, configuration) {
	        var _this = this;
	        var sid = this.checkSessionId(sessionId);
	        var serviceId = this.checkServiceId(newServiceId);
	        var desc = this.checkStringArgument(description, 'Service description');
	        var conf = this.checkStringArgument(configuration, 'Service configuration');
	        var newService = {
	            id: serviceId,
	            description: desc,
	            configuration: conf
	        };
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_add_service_request_1.GatewayClientAddServiceRequest(sid, newService), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        var addSessionId = _this.sessionContextTransformer(sid);
	                        resolve(addSessionId(response.service));
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.updateService = function (serviceId, description, configuration) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        // tslint:disable-next-line: strict-type-predicates
	        if ((description === null || description === undefined)
	            // tslint:disable-next-line: strict-type-predicates
	            && (configuration === null || configuration === undefined)) {
	            return Promise.reject(new Error('Missing parameter: you must provide configuration or description (or both) when calling updateService'));
	        }
	        var newService = {
	            id: svcId,
	            description: description,
	            configuration: configuration
	        };
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new gateway_client_update_service_request_1.GatewayClientUpdateServiceRequest(sessionId, newService), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        var addSessionId = _this.sessionContextTransformer(sessionId);
	                        resolve(addSessionId(response.service));
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.removeService = function (serviceId) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new remove_service_request_1.GatewayClientRemoveServiceRequest(sessionId, svcId), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getServiceStatus = function (serviceId) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new service_get_status_request_1.GatewayServiceGetStatusRequest(sessionId, svcId), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getServiceConfiguration = function (serviceId) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new service_get_configuration_request_1.GatewayServiceGetConfigurationRequest(sessionId, svcId), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getServiceOperations = function (serviceId) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new service_get_operations_request_1.GatewayServiceGetOperationsRequest(sessionId, svcId), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.getServiceOperationDetail = function (serviceId, operationName) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        var opName = this.checkOperationName(operationName);
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new service_get_operation_detail_request_1.GatewayServiceGetOperationDetailRequest(sessionId, svcId, opName), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    GatewayControlImpl.prototype.invokeServiceOperation = function (serviceId, operationName, input) {
	        var _this = this;
	        var _a = this.checkServiceHandle(serviceId), sessionId = _a.sessionId, svcId = __rest(_a, ["sessionId"]);
	        var opName = this.checkOperationName(operationName);
	        // tslint:disable-next-line: strict-type-predicates
	        var opInput = input === null ? undefined : input;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.clientRequestsService.send(new service_invoke_operation_request_1.GatewayServiceInvokeOperationRequest(sessionId, svcId, opName, opInput), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    return GatewayControlImpl;
	}());
	exports.GatewayControlImpl = GatewayControlImpl;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Permissions that are applied globally
	 *
	 * This enum maps the values of {@link GlobalPermission} to internal protocol codes
	 */
	var GlobalPermissionCode;
	(function (GlobalPermissionCode) {
	    GlobalPermissionCode[GlobalPermissionCode["AUTHENTICATE"] = 0] = "AUTHENTICATE";
	    GlobalPermissionCode[GlobalPermissionCode["VIEW_SESSION"] = 1] = "VIEW_SESSION";
	    GlobalPermissionCode[GlobalPermissionCode["MODIFY_SESSION"] = 2] = "MODIFY_SESSION";
	    GlobalPermissionCode[GlobalPermissionCode["REGISTER_HANDLER"] = 3] = "REGISTER_HANDLER";
	    GlobalPermissionCode[GlobalPermissionCode["VIEW_SERVER"] = 4] = "VIEW_SERVER";
	    GlobalPermissionCode[GlobalPermissionCode["CONTROL_SERVER"] = 5] = "CONTROL_SERVER";
	    GlobalPermissionCode[GlobalPermissionCode["VIEW_SECURITY"] = 6] = "VIEW_SECURITY";
	    GlobalPermissionCode[GlobalPermissionCode["MODIFY_SECURITY"] = 7] = "MODIFY_SECURITY";
	    GlobalPermissionCode[GlobalPermissionCode["UNKNOWN_GLOBAL_PERMISSION"] = 8] = "UNKNOWN_GLOBAL_PERMISSION";
	    GlobalPermissionCode[GlobalPermissionCode["READ_TOPIC_VIEWS"] = 9] = "READ_TOPIC_VIEWS";
	    GlobalPermissionCode[GlobalPermissionCode["MODIFY_TOPIC_VIEWS"] = 10] = "MODIFY_TOPIC_VIEWS";
	})(GlobalPermissionCode = exports.GlobalPermissionCode || (exports.GlobalPermissionCode = {}));
	/**
	 * Permissions that are applied on a path
	 *
	 * This enum maps the values of {@link PathPermission} to internal protocol codes
	 */
	var PathPermissionCode;
	(function (PathPermissionCode) {
	    PathPermissionCode[PathPermissionCode["READ_TOPIC"] = 0] = "READ_TOPIC";
	    PathPermissionCode[PathPermissionCode["UPDATE_TOPIC"] = 1] = "UPDATE_TOPIC";
	    PathPermissionCode[PathPermissionCode["MODIFY_TOPIC"] = 2] = "MODIFY_TOPIC";
	    PathPermissionCode[PathPermissionCode["SEND_TO_MESSAGE_HANDLER"] = 3] = "SEND_TO_MESSAGE_HANDLER";
	    PathPermissionCode[PathPermissionCode["SEND_TO_SESSION"] = 4] = "SEND_TO_SESSION";
	    PathPermissionCode[PathPermissionCode["SELECT_TOPIC"] = 5] = "SELECT_TOPIC";
	    PathPermissionCode[PathPermissionCode["QUERY_OBSOLETE_TIME_SERIES_EVENTS"] = 6] = "QUERY_OBSOLETE_TIME_SERIES_EVENTS";
	    PathPermissionCode[PathPermissionCode["EDIT_TIME_SERIES_EVENTS"] = 7] = "EDIT_TIME_SERIES_EVENTS";
	    PathPermissionCode[PathPermissionCode["EDIT_OWN_TIME_SERIES_EVENTS"] = 8] = "EDIT_OWN_TIME_SERIES_EVENTS";
	    PathPermissionCode[PathPermissionCode["ACQUIRE_LOCK"] = 9] = "ACQUIRE_LOCK";
	    PathPermissionCode[PathPermissionCode["UNKNOWN_TOPIC_PERMISSION"] = 10] = "UNKNOWN_TOPIC_PERMISSION";
	    PathPermissionCode[PathPermissionCode["UNKNOWN_PATH_PERMISSION"] = 10] = "UNKNOWN_PATH_PERMISSION";
	    PathPermissionCode[PathPermissionCode["EXPOSE_BRANCH"] = 11] = "EXPOSE_BRANCH";
	})(PathPermissionCode = exports.PathPermissionCode || (exports.PathPermissionCode = {}));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var range_1 = __webpack_require__(335);
	var enumerize_1 = __webpack_require__(103);
	var math_1 = __webpack_require__(104);
	/**
	 * Timeseries stream structure
	 *
	 * Value type of the {@link StreamStructures} enum-like object
	 */
	var StreamStructure = /** @class */ (function () {
	    /**
	     * Create a new StreamStructure instance
	     *
	     * @param id    the id of the stream structure
	     * @param name  the name of the stream structure
	     */
	    function StreamStructure(id, name) {
	        this.id = id;
	        this.name = name;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the StreamStructure
	     */
	    StreamStructure.prototype.toString = function () {
	        return this.name;
	    };
	    return StreamStructure;
	}());
	exports.StreamStructure = StreamStructure;
	/**
	 * Enum-like object for timeseries stream structures
	 */ // tslint:disable-next-line:variable-name
	exports.StreamStructures = {
	    /**
	     * A value event stream
	     */
	    VALUE_EVENT_STREAM: new StreamStructure(1, 'VALUE_EVENT_STREAM'),
	    /**
	     * An edit event stream
	     */
	    EDIT_EVENT_STREAM: new StreamStructure(2, 'EDIT_EVENT_STREAM')
	};
	enumerize_1.enumerize(exports.StreamStructures);
	Object.freeze(exports.StreamStructures);
	/**
	 * Timeseries query type
	 *
	 * Value type of the {@link QueryTypes} enum-like object
	 */
	var QueryType = /** @class */ (function () {
	    /**
	     * Create a new QueryType instance
	     *
	     * @param id               the id of the stream structure
	     * @param streamStructure  the stream structure associated with the query type
	     */
	    function QueryType(id, streamStructure) {
	        this.id = id;
	        this.streamStructure = streamStructure;
	    }
	    return QueryType;
	}());
	exports.QueryType = QueryType;
	/**
	 * Enum-like object for timeseries query types
	 */ // tslint:disable-next-line:variable-name
	exports.QueryTypes = {
	    /**
	     * A values query type
	     */
	    VALUES: new QueryType(0, exports.StreamStructures.VALUE_EVENT_STREAM),
	    /**
	     * A query type for all edits
	     */
	    ALL_EDITS: new QueryType(1, exports.StreamStructures.EDIT_EVENT_STREAM),
	    /**
	     * A query type for the latest edits
	     */
	    LATEST_EDITS: new QueryType(2, exports.StreamStructures.EDIT_EVENT_STREAM)
	};
	enumerize_1.enumerize(exports.QueryTypes);
	Object.freeze(exports.QueryTypes);
	/**
	 * Throw an error if the checked value is negative
	 *
	 * @param i     the value to check
	 * @param what  description to include in thrown error
	 * @returns     the checked value
	 * @throws      an error if value is negative
	 */
	function requireNonNegative(i, what) {
	    if (i < 0) {
	        throw new Error(what + "\" is negative: " + i);
	    }
	    return i;
	}
	/**
	 * Range query parameters
	 *
	 * These parameters are used in the {@link RangeQueryImpl} implementation of
	 * {@link RangeQuery}.
	 *
	 * An instance of RangeQueryParameters is an immutable object and follows the
	 * builder pattern to create modifications of itself.
	 */
	var RangeQueryParameters = /** @class */ (function () {
	    /**
	     * Create a new RangeQueryParameters instance
	     *
	     * @param  queryType  the query type
	     * @param  viewRange  the view range
	     * @param  editRange  the edit range
	     * @param  limit      the limit on the number of entries
	     */
	    function RangeQueryParameters(queryType, viewRange, editRange, limit) {
	        this.queryType = queryType;
	        this.viewRange = viewRange;
	        this.editRange = editRange;
	        this.limit = limit;
	    }
	    /**
	     * Create a copy of the range query parameters with a modified
	     * view range.
	     *
	     * @param  range   the new view range
	     * @return         a modified range query
	     */
	    RangeQueryParameters.prototype.withViewRange = function (range) {
	        return new RangeQueryParameters(this.queryType, range, this.editRange, this.limit);
	    };
	    /**
	     * Create a copy of the range query parameters with a modified
	     * edit range.
	     *
	     * @param  range   the new edit range
	     * @return         a modified range query
	     */
	    RangeQueryParameters.prototype.withEditRange = function (range) {
	        return new RangeQueryParameters(this.queryType, this.viewRange, range, this.limit);
	    };
	    /**
	     * Create a copy of the range query parameters with a modified
	     * limit.
	     *
	     * @param  limit   the new limit
	     * @return         a modified range query
	     */
	    RangeQueryParameters.prototype.withLimit = function (limit) {
	        return new RangeQueryParameters(this.queryType, this.viewRange, this.editRange, requireNonNegative(limit, 'limit'));
	    };
	    /**
	     * Create a copy of the range query parameters with a modified
	     * query type.
	     *
	     * @param  type    the new query type
	     * @return         a modified range query
	     */
	    RangeQueryParameters.prototype.withQueryType = function (type) {
	        return new RangeQueryParameters(type, this.viewRange, this.editRange, this.limit);
	    };
	    /**
	     * Check if the RangeQueryParameters is equal to another object
	     *
	     * @param  other the other object
	     * @return       `true` if the other object is a RangeQueryParameters and is equal
	     */
	    RangeQueryParameters.prototype.equals = function (other) {
	        if (other && other instanceof RangeQueryParameters) {
	            return this.queryType === other.queryType &&
	                this.viewRange.equals(other.viewRange) &&
	                this.editRange.equals(other.editRange) &&
	                this.limit === other.limit;
	        }
	        return false;
	    };
	    return RangeQueryParameters;
	}());
	exports.RangeQueryParameters = RangeQueryParameters;
	/**
	 * A default range query
	 */
	exports.DEFAULT_RANGE_QUERY = Object.freeze(new RangeQueryParameters(exports.QueryTypes.VALUES, range_1.DEFAULT_RANGE, range_1.DEFAULT_RANGE, math_1.MAX_SAFE_INTEGER));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var point_1 = __webpack_require__(506);
	/**
	 * A range of events in a time series specified by an anchor point and a span
	 */
	var Range = /** @class */ (function () {
	    /**
	     * Create a new Range instance
	     *
	     * @param  anchor  the anchor point
	     * @param  span    the span
	     */
	    function Range(anchor, span) {
	        this.anchor = anchor;
	        this.span = span;
	    }
	    /**
	     * Check if the Range is equal to another object
	     *
	     * @param  other the other object
	     * @return       `true` if the other object is a Range and is equal
	     */
	    Range.prototype.equals = function (other) {
	        if (other && other instanceof Range) {
	            return this.anchor.equals(other.anchor) &&
	                this.span.equals(other.span);
	        }
	        return false;
	    };
	    /**
	     * Create a new Range with the same span but a new anchor at a given time
	     * or event count
	     *
	     * @param  start  the starting anchor
	     * @return        a new Range object
	     */
	    Range.prototype.from = function (start) {
	        return new Range(point_1.Point.at(start), this.span);
	    };
	    /**
	     * Create a new Range with the same span but anchored at the beginning of
	     * the time series
	     *
	     * @return  a new Range object
	     */
	    Range.prototype.fromStart = function () {
	        return new Range(point_1.Point.atStart(), this.span);
	    };
	    /**
	     * Create a new Range with the same span but a new anchor at a given
	     * event count before the end of the time series.
	     *
	     * @param  count  the offset from the end of the time series
	     * @return        a new Range object
	     */
	    Range.prototype.fromLast = function (count) {
	        return new Range(point_1.Point.offset(count), this.span);
	    };
	    /**
	     * Create a new Range with the same span but a new anchor at a given
	     * timespan before the end of the time series.
	     *
	     * @param  timespan  the timespan from the end of the time series
	     * @return           a new Range object
	     */
	    Range.prototype.fromLastMillis = function (timespan) {
	        return new Range(point_1.Point.offsetMillis(timespan), this.span);
	    };
	    /**
	     * Create a new Range with the same anchor but a new span at a given time
	     * or event count
	     *
	     * @param  sequence  the end anchor
	     * @return           a new Range object
	     */
	    Range.prototype.to = function (sequence) {
	        return new Range(this.anchor, point_1.Point.at(sequence));
	    };
	    /**
	     * Create a new Range with the same anchor but ending at the beginning of
	     * the time series
	     *
	     * @return  a new Range object
	     */
	    Range.prototype.toStart = function () {
	        return new Range(this.anchor, point_1.Point.atStart());
	    };
	    /**
	     * Create a new Range with the same anchor but a new end point at a given
	     * event count before the end of the time series.
	     *
	     * @param  count  the offset from the end of the time series
	     * @return        a new Range object
	     */
	    Range.prototype.untilLast = function (count) {
	        return new Range(this.anchor, point_1.Point.offset(count));
	    };
	    /**
	     * Create a new Range with the same anchor but a new end point at a given
	     * timespan before the end of the time series.
	     *
	     * @param  timespan  the timespan from the end of the time series
	     * @return           a new Range object
	     */
	    Range.prototype.untilLastMillis = function (timespan) {
	        return new Range(this.anchor, point_1.Point.offsetMillis(timespan));
	    };
	    /**
	     * Create a new Range with the same anchor but a span containing a fixed
	     * number of events.
	     *
	     * @param  count  the number of events in the span
	     * @return        a new Range object
	     */
	    Range.prototype.next = function (count) {
	        return new Range(this.anchor, point_1.Point.next(count));
	    };
	    /**
	     * Create a new Range with the same anchor but a span covering a fixed
	     * timespan.
	     *
	     * @param  timespan  the timespan covered by the range
	     * @return           a new Range object
	     */
	    Range.prototype.nextMillis = function (timespan) {
	        return new Range(this.anchor, point_1.Point.nextMillis(timespan));
	    };
	    /**
	     * Create a new Range with the same anchor but a span containing a fixed
	     * number of events before the anchor.
	     *
	     * @param  count  the number of events in the span
	     * @return        a new Range object
	     */
	    Range.prototype.previous = function (count) {
	        return new Range(this.anchor, point_1.Point.previous(count));
	    };
	    /**
	     * Create a new Range with the same anchor but a span covering a fixed
	     * timespan before the anchor.
	     *
	     * @param  timespan  the timespan covered by the range
	     * @return           a new Range object
	     */
	    Range.prototype.previousMillis = function (timespan) {
	        return new Range(this.anchor, point_1.Point.previousMillis(timespan));
	    };
	    return Range;
	}());
	exports.Range = Range;
	/**
	 * A unique range covering the complete time series
	 */
	exports.DEFAULT_RANGE = new Range(point_1.Point.atStart(), point_1.Point.offset(0));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Protocol
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Protocol constants
	 */
	exports.PROTOCOL = {
	    /**
	     * The protocol type
	     */
	    TYPE: 'WB',
	    /**
	     * A code indicating the clients capabilities
	     */
	    CAPABILITIES: isZlibBundleLoaded() ? 10 : 8,
	    /**
	     * A byte inticating the diffusion protocol
	     */
	    PROTOCOL_BYTE: 35,
	    /**
	     * The client's protocol version
	     */
	    CURRENT_VERSION: 23
	};
	/**
	 * Check if the zlib library is installed
	 *
	 * @return `true` if the zlib module is provided
	 */
	function isZlibBundleLoaded() {
	    try {
	        if (__webpack_require__(390)) {
	            return true;
	        }
	    }
	    catch (err) {
	        return false;
	    }
	    return false;
	}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * A Serialiser for Boolean values
	 */
	var BooleanSerialiserClass = /** @class */ (function () {
	    function BooleanSerialiserClass() {
	    }
	    /**
	     * @inheritdoc
	     */
	    BooleanSerialiserClass.prototype.read = function (bis) {
	        return Codec.readBoolean(bis);
	    };
	    /**
	     * @inheritdoc
	     */
	    BooleanSerialiserClass.prototype.write = function (bos, val) {
	        Codec.writeBoolean(bos, val);
	    };
	    return BooleanSerialiserClass;
	}());
	exports.BooleanSerialiserClass = BooleanSerialiserClass;
	/**
	 * The {@link BooleanSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.BooleanSerialiser = new BooleanSerialiserClass();


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for the command header
	 */
	var CommandHeader = /** @class */ (function () {
	    /**
	     * Create a new CommandHeader instance
	     *
	     * @param service  the service identifier
	     * @param cid  the conversation ID
	     */
	    function CommandHeader(service, cid) {
	        this.service = service;
	        this.cid = cid;
	    }
	    /**
	     * Create a new CommandHeader instance
	     *
	     * @param service  the service identifier
	     * @param cid  the conversation ID
	     * @return     the new command header
	     */
	    CommandHeader.createRequestHeader = function (service, cid) {
	        return new CommandHeader(service, cid);
	    };
	    /**
	     * Create a response header from this command header
	     *
	     * @return  the command header that can be used for a response
	     */
	    CommandHeader.prototype.createResponseHeader = function () {
	        return new CommandHeader(this.service, this.cid);
	    };
	    /**
	     * Create a error header from this command header
	     *
	     * @return  the command header that can be used for an error response
	     */
	    CommandHeader.prototype.createErrorHeader = function () {
	        return new CommandHeader(this.service, this.cid);
	    };
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the CommandHeader object
	     */
	    CommandHeader.prototype.toString = function () {
	        return '<' + this.service + ', ' + this.cid.toString() + '>';
	    };
	    return CommandHeader;
	}());
	exports.CommandHeader = CommandHeader;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:max-line-length */
	var service_definition_1 = __webpack_require__(51);
	var topic_specification_info_serialiser_1 = __webpack_require__(1450);
	var message_receiver_control_registration_params_serialiser_1 = __webpack_require__(514);
	var message_receiver_control_registration_request_serialiser_1 = __webpack_require__(1257);
	var topic_control_registration_params_serialiser_1 = __webpack_require__(517);
	var topic_control_registration_request_serialiser_1 = __webpack_require__(1284);
	var unsubscription_notification_serialiser_1 = __webpack_require__(1437);
	exports.TOPIC_CONTROL_REGISTRATION = {
	    id: 20,
	    request: topic_control_registration_request_serialiser_1.TopicControlRegistrationRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.TOPIC_CONTROL_DEREGISTRATION = {
	    id: 21,
	    request: topic_control_registration_params_serialiser_1.TopicControlRegistrationParamsSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.UNSUBSCRIPTION_NOTIFICATION = {
	    id: 42,
	    request: unsubscription_notification_serialiser_1.UnsubscriptionNotificationSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.MESSAGE_RECEIVER_CONTROL_REGISTRATION = {
	    id: 63,
	    request: message_receiver_control_registration_request_serialiser_1.MessageReceiverControlRegistrationRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.MESSAGE_RECEIVER_CONTROL_DEREGISTRATION = {
	    id: 64,
	    request: message_receiver_control_registration_params_serialiser_1.MessageReceiverControlRegistrationParamsSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.NOTIFY_SUBSCRIPTION = {
	    id: 87,
	    request: topic_specification_info_serialiser_1.TopicSpecificationInfoSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.MESSAGING_RECEIVER_CONTROL_REGISTRATION = {
	    id: 97,
	    request: message_receiver_control_registration_request_serialiser_1.MessageReceiverControlRegistrationRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.MESSAGING_RECEIVER_CONTROL_DEREGISTRATION = {
	    id: 98,
	    request: message_receiver_control_registration_params_serialiser_1.MessageReceiverControlRegistrationParamsSerialiser,
	    response: service_definition_1.NullSerialiser
	};


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of a time series event
	 */
	var EventImpl = /** @class */ (function () {
	    /**
	     * Create a new EventImpl instance
	     *
	     * @param  metadata       the metadata of the event
	     * @param  originalEvent  the original event
	     * @param  value          the value of the event
	     */
	    function EventImpl(metadata, originalEvent, value) {
	        this.metadata = metadata;
	        this.originalEvent = originalEvent;
	        this.value = value;
	        this.sequence = metadata.sequence;
	        this.timestamp = metadata.timestamp;
	        this.author = metadata.author;
	        this.isEditEvent = !metadata.equals(originalEvent);
	        this.isOriginalEvent = !this.isEditEvent;
	    }
	    /**
	     * Static factory to create a new EventImpl instance
	     *
	     * @param  metadata       the metadata of the event
	     * @param  originalEvent  the original event
	     * @param  value          the value of the event
	     * @return                a new EventImpl instance
	     */
	    EventImpl.create = function (metadata, originalEvent, value) {
	        return new EventImpl(metadata, originalEvent, value);
	    };
	    /**
	     * Createa copy of this EventImpl with a different value
	     *
	     * @param newValue  the new value
	     * @return          a new EventImpl instance
	     */
	    EventImpl.prototype.withValue = function (newValue) {
	        return new EventImpl(this.metadata, this.originalEvent, newValue);
	    };
	    /**
	     * @inheritdoc
	     */
	    EventImpl.prototype.equals = function (other) {
	        if (other && other instanceof EventImpl) {
	            return this.metadata.equals(other.metadata) &&
	                this.originalEvent.equals(other.originalEvent) &&
	                this.value === other.value;
	        }
	        return false;
	    };
	    /**
	     * Convert the time series event into a string
	     *
	     * @return  a string representation of the event
	     */
	    EventImpl.prototype.toString = function () {
	        var s = this.isEditEvent ? "Edit of [" + this.originalEvent + "]" : '';
	        return s + "[" + this.metadata + "] " + this.value;
	    };
	    return EventImpl;
	}());
	exports.EventImpl = EventImpl;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An update stream delegate that is used after the update stream has encountered
	 * an invalid operation and a value was set.
	 */
	var InvalidSetStream = /** @class */ (function () {
	    /**
	     * Create a new InvalidSetStream instance
	     *
	     * @param err    the error that occurred
	     * @param value  the last value
	     */
	    function InvalidSetStream(err, value) {
	        this.value = value;
	        this.err = err;
	    }
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.set = function () {
	        return Promise.reject(this.err);
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.get = function () {
	        return this.value;
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.validate = function () {
	        return Promise.reject(this.err);
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.onSetComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.onSetFailed = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.onValidateComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidSetStream.prototype.onValidateFailed = function () {
	        // no-op
	    };
	    return InvalidSetStream;
	}());
	exports.InvalidSetStream = InvalidSetStream;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var update_stream_request_1 = __webpack_require__(235);
	var invalid_set_stream_1 = __webpack_require__(341);
	var logger = __webpack_require__(17);
	var topic_update_1 = __webpack_require__(90);
	var log = logger.create('diffusion.TopicUpdate');
	/**
	 * An update stream delegate that is used when a {@link set} operation has
	 * completed successfully. A cached value is available.
	 */
	var SetStream = /** @class */ (function () {
	    /**
	     * Create a new SetStream instance
	     *
	     * @param streamServices   the stream services
	     * @param options          the update stream options
	     * @param stream           the stream that using this stream as a delegate
	     * @param streamId         the stream ID
	     * @param value            the cached value
	     */
	    function SetStream(streamServices, options, stream, streamId, value) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.streamId = streamId;
	        this.cache = value;
	    }
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        return new Promise(function (resolve, reject) {
	            var buffer = _this.options.toBuffer(_this.cache, value);
	            _this.cache = value;
	            _this.options.deltaService.send(new update_stream_request_1.UpdateStreamRequest(_this.streamId, buffer), function (err) {
	                if (err) {
	                    log.debug('Set update stream failed');
	                    _this.stream.onSetFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onSetComplete(_this.streamId, _this.options.retainsValue, _this.options.supportsConflation);
	                    resolve();
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.get = function () {
	        return this.cache;
	    };
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.validate = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.streamServices.CHECK_UPDATE_STREAM.send(_this.streamId, function (err) {
	                if (err) {
	                    log.debug('Validate update stream failed');
	                    _this.stream.onValidateFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onValidateComplete(_this.streamId, _this.options.retainsValue, _this.options.supportsConflation);
	                    resolve(topic_update_1.TopicCreationResult.EXISTS);
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.onSetComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.onSetFailed = function (err) {
	        this.stream.setDelegate(new invalid_set_stream_1.InvalidSetStream(err, this.cache));
	    };
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.onValidateComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    SetStream.prototype.onValidateFailed = function (err) {
	        this.stream.setDelegate(new invalid_set_stream_1.InvalidSetStream(err, this.cache));
	    };
	    return SetStream;
	}());
	exports.SetStream = SetStream;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var datatypes_1 = __webpack_require__(78);
	var json_pointer_1 = __webpack_require__(230);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Enum mapping the different constraint types to their protocol code
	 */
	var ConstraintType;
	(function (ConstraintType) {
	    ConstraintType[ConstraintType["UNCONSTRAINED"] = 0] = "UNCONSTRAINED";
	    ConstraintType[ConstraintType["CONJUNCTION"] = 1] = "CONJUNCTION";
	    ConstraintType[ConstraintType["BINARY_VALUE"] = 2] = "BINARY_VALUE";
	    ConstraintType[ConstraintType["NO_VALUE"] = 3] = "NO_VALUE";
	    ConstraintType[ConstraintType["LOCKED"] = 4] = "LOCKED";
	    ConstraintType[ConstraintType["NO_TOPIC"] = 5] = "NO_TOPIC";
	    ConstraintType[ConstraintType["PARTIAL_JSON"] = 6] = "PARTIAL_JSON";
	})(ConstraintType = exports.ConstraintType || (exports.ConstraintType = {}));
	/**
	 * Base implementation of {@link UpdateConstraint} that implements only
	 * the  {@link UpdateConstraint.and and} method but no other functionality
	 */
	var UpdateConstraintImpl = /** @class */ (function () {
	    function UpdateConstraintImpl() {
	    }
	    /**
	     * @inheritdoc
	     */
	    UpdateConstraintImpl.prototype.and = function (other) {
	        if (!Array.isArray(other)
	            && other.getConstraintType() === 'CONJUNCTION') {
	            return other.and(this);
	        }
	        var constraints = Array.isArray(other) ? other.concat(this) : [this, other];
	        checkSatisfiability(constraints);
	        /* tslint:disable-next-line:no-use-before-declare */
	        return new Conjunction(constraints);
	    };
	    return UpdateConstraintImpl;
	}());
	exports.UpdateConstraintImpl = UpdateConstraintImpl;
	/**
	 * Unconstrained update constraint
	 */
	var Unconstrained = /** @class */ (function (_super) {
	    __extends(Unconstrained, _super);
	    function Unconstrained() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Get the constraint type
	     *
	     * @return  `'UNCONSTRAINED'`
	     */
	    Unconstrained.prototype.getConstraintType = function () {
	        return 'UNCONSTRAINED';
	    };
	    return Unconstrained;
	}(UpdateConstraintImpl));
	exports.Unconstrained = Unconstrained;
	/**
	 * A conjunction update constraint that is fulfilled only when all of its
	 * member constraints are fulfilled
	 */
	var Conjunction = /** @class */ (function () {
	    /**
	     * Create a new Conjunction instance
	     *
	     * @param constraints  the member constraints which are ANDed together
	     */
	    function Conjunction(constraints) {
	        checkSatisfiability(constraints);
	        this.constraints = constraints;
	    }
	    /**
	     * @inheritdoc
	     */
	    Conjunction.prototype.and = function (other) {
	        if (!Array.isArray(other)
	            && other.getConstraintType() === 'CONJUNCTION') {
	            return other.and(this.constraints);
	        }
	        var newConstraints = this.constraints.concat(other);
	        checkSatisfiability(newConstraints);
	        return new Conjunction(newConstraints);
	    };
	    /**
	     * Get the member constraints
	     *
	     * @return  a copy of the member constraints
	     */
	    Conjunction.prototype.getConstraints = function () {
	        return this.constraints.slice();
	    };
	    /**
	     * Get the constraint type
	     *
	     * @return  `'CONJUNCTION'`
	     */
	    Conjunction.prototype.getConstraintType = function () {
	        return 'CONJUNCTION';
	    };
	    return Conjunction;
	}());
	exports.Conjunction = Conjunction;
	/**
	 * A Constraint requiring the current value of the topic to match a specific
	 * value.
	 */
	var BinaryValue = /** @class */ (function (_super) {
	    __extends(BinaryValue, _super);
	    /**
	     * Create a new BinaryValue instance
	     *
	     * @param bytes  the value that the topic needs to match
	     */
	    function BinaryValue(bytes) {
	        var _this = _super.call(this) || this;
	        _this.bytes = bytes;
	        return _this;
	    }
	    /**
	     * Get the binary representation of the value
	     *
	     * @return  the bytes containing the value
	     */
	    BinaryValue.prototype.getBytes = function () {
	        return this.bytes;
	    };
	    /**
	     * Get the constraint type
	     *
	     * @return  `'BINARY_VALUE'`
	     */
	    BinaryValue.prototype.getConstraintType = function () {
	        return 'BINARY_VALUE';
	    };
	    return BinaryValue;
	}(UpdateConstraintImpl));
	exports.BinaryValue = BinaryValue;
	/**
	 * A constraint requiring a lock to be held by the session.
	 */
	var Locked = /** @class */ (function (_super) {
	    __extends(Locked, _super);
	    /**
	     * Create a new Locked instance
	     *
	     * @param lock  the lock that need to be held
	     */
	    function Locked(lock) {
	        var _this = _super.call(this) || this;
	        _this.lock = lock;
	        _this.lockName = lock.getName();
	        _this.sequence = lock.getSequence();
	        return _this;
	    }
	    /**
	     * Get the lock name
	     *
	     * @return  the lock name
	     */
	    Locked.prototype.getLockName = function () {
	        return this.lockName;
	    };
	    /**
	     * Get the lock sequence number
	     *
	     * @return the lock sequence number
	     */
	    Locked.prototype.getSequence = function () {
	        return this.sequence;
	    };
	    /**
	     * Get the constraint type
	     *
	     * @return  `'LOCKED'`
	     */
	    Locked.prototype.getConstraintType = function () {
	        return 'LOCKED';
	    };
	    return Locked;
	}(UpdateConstraintImpl));
	exports.Locked = Locked;
	/**
	 * A constraint requiring the path to have no topic
	 */
	var NoTopic = /** @class */ (function (_super) {
	    __extends(NoTopic, _super);
	    function NoTopic() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Get the constraint type
	     *
	     * @return  `'NO_TOPIC'`
	     */
	    NoTopic.prototype.getConstraintType = function () {
	        return 'NO_TOPIC';
	    };
	    return NoTopic;
	}(UpdateConstraintImpl));
	exports.NoTopic = NoTopic;
	/**
	 * A constraint requiring the topic to have no value
	 */
	var NoValue = /** @class */ (function (_super) {
	    __extends(NoValue, _super);
	    function NoValue() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Get the constraint type
	     *
	     * @return  `'NO_VALUE'`
	     */
	    NoValue.prototype.getConstraintType = function () {
	        return 'NO_VALUE';
	    };
	    return NoValue;
	}(UpdateConstraintImpl));
	exports.NoValue = NoValue;
	/**
	 * A constraint that partially matches the current JSON topic value
	 */
	var PartialJSONImpl = /** @class */ (function (_super) {
	    __extends(PartialJSONImpl, _super);
	    /**
	     * Create a new PartialJSONImpl instance
	     *
	     * @param withValues     the values required to exist in the JSON value
	     * @param withoutValues  the JSON pointers that should hold no value
	     */
	    function PartialJSONImpl(withValues, withoutValues) {
	        if (withValues === void 0) { withValues = {}; }
	        if (withoutValues === void 0) { withoutValues = new Set(); }
	        var _this = _super.call(this) || this;
	        _this.withValues = withValues;
	        _this.withoutValues = withoutValues;
	        return _this;
	    }
	    /**
	     * Get the required JSON values
	     *
	     * @return the a map of JSON values that are required
	     */
	    PartialJSONImpl.prototype.getWithValues = function () {
	        return Object.assign({}, this.withValues);
	    };
	    /**
	     * Get the JSON pointer expressions that should be empty in the JSON value
	     *
	     * @return  a set of pointer expressions
	     */
	    PartialJSONImpl.prototype.getWithoutValues = function () {
	        return new Set(this.withoutValues);
	    };
	    /**
	     * @inheritdoc
	     */
	    PartialJSONImpl.prototype.with = function (pointer, value, dataType) {
	        var valueType = ((dataType !== undefined)
	            ? dataType
	            : datatypes_1.DataTypes.getByValue(value));
	        if (valueType === undefined) {
	            throw new Error('Datatype invalid or could not be inferred');
	        }
	        require_non_null_1.requireNonNull(value, 'value');
	        json_pointer_1.JSONPointer.parse(require_non_null_1.requireNonNull(pointer, 'pointer'));
	        var withProperty = {};
	        withProperty[pointer.toString()] = valueType.toBytes(value);
	        var newWithValues = Object.assign({}, this.withValues, withProperty);
	        return new PartialJSONImpl(newWithValues, this.withoutValues);
	    };
	    /**
	     * @inheritdoc
	     */
	    PartialJSONImpl.prototype.without = function (pointer) {
	        json_pointer_1.JSONPointer.parse(require_non_null_1.requireNonNull(pointer, 'pointer'));
	        var newWithoutValues = new Set(this.withoutValues);
	        newWithoutValues.add(pointer.toString());
	        return new PartialJSONImpl(this.withValues, newWithoutValues);
	    };
	    /**
	     * Get the constraint type
	     *
	     * @return  `'PARTIAL_JSON'`
	     */
	    PartialJSONImpl.prototype.getConstraintType = function () {
	        return 'PARTIAL_JSON';
	    };
	    return PartialJSONImpl;
	}(UpdateConstraintImpl));
	exports.PartialJSONImpl = PartialJSONImpl;
	/**
	 * Check the satisfiability of applying a number of constraints.
	 *
	 * @param constraints   the constraints that are ANDed together
	 * @throws              an error if multiple constraints constrain the topic
	 *                      value
	 */
	function checkSatisfiability(constraints) {
	    var previousConstraintOnValue;
	    constraints.forEach(function (constraint) {
	        if (isConstraintOnTopic(constraint)) {
	            if (previousConstraintOnValue !== undefined) {
	                throw new Error("Multiple value constraints found: " + previousConstraintOnValue + " and " + constraint);
	            }
	            else {
	                previousConstraintOnValue = constraint;
	            }
	        }
	    });
	}
	/**
	 * Check if the constraint constrains the topic value
	 *
	 * @param constraint  the constraint to check
	 * @return            `true` if the constraint type is one of
	 *                    `'BINARY_VALUE', 'NO_VALUE', 'NO_TOPIC', 'PARTIAL_JSON'`
	 */
	function isConstraintOnTopic(constraint) {
	    switch (constraint.getConstraintType()) {
	        case 'BINARY_VALUE':
	        case 'NO_VALUE':
	        case 'NO_TOPIC':
	        case 'PARTIAL_JSON':
	            return true;
	        default:
	            return false;
	    }
	}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/**
	 * @module Topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var memoize_1 = __webpack_require__(1460);
	var string_1 = __webpack_require__(549);
	// topic selector API
	var topic_selector_1 = __webpack_require__(181);
	// internal topic classes
	var abstract_topic_selector_1 = __webpack_require__(180);
	var full_path_selector_1 = __webpack_require__(1452);
	var path_selector_1 = __webpack_require__(1453);
	var selector_set_1 = __webpack_require__(546);
	var split_path_selector_1 = __webpack_require__(1454);
	var utils = __webpack_require__(128);
	var DQ = utils.DescendantQualifier;
	/**
	 * Parse a selector expression into a specific TopicSelector implementation.
	 * @param expression  the selector's string expression
	 * @return            a new topic selector
	 */
	function parseSelector(expression) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    if (!expression) {
	        throw new Error('Empty topic selector expression');
	    }
	    if (args.length > 0) {
	        expression = [expression].concat(args);
	    }
	    if (expression instanceof Array) {
	        var actual = expression.map(function (s) { return (s instanceof abstract_topic_selector_1.AbstractTopicSelector ? s : parseSelector(s)); });
	        return new selector_set_1.SelectorSet(actual);
	    }
	    if (typeof expression === 'string') {
	        var components = getComponents(expression);
	        if (isTopicPath(components)) {
	            return new path_selector_1.PathSelector(components);
	        }
	        switch (components.type) {
	            case topic_selector_1.Type.SPLIT_PATH_PATTERN:
	                return new split_path_selector_1.SplitPathSelector(components);
	            case topic_selector_1.Type.FULL_PATH_PATTERN:
	                return new full_path_selector_1.FullPathSelector(components);
	            case topic_selector_1.Type.SELECTOR_SET:
	                var parts = string_1.split(components.remainder, selector_set_1.DELIMITER);
	                var selectors = parts.map(function (e) { return parseSelector(e); });
	                return new selector_set_1.SelectorSet(selectors);
	        }
	    }
	    if (expression instanceof abstract_topic_selector_1.AbstractTopicSelector) {
	        return expression;
	    }
	    throw new Error('Topic selector expression must be a string or array');
	}
	/**
	 * Extract a component group from a single expression
	 * @param expression  the selector expression
	 * @returns           an object containing parsed properties
	 */
	function getComponents(expression) {
	    var type = getType(expression);
	    // treat expressions as Path selectors by default
	    if (type === null) {
	        expression = topic_selector_1.Prefix.PATH + expression;
	        type = topic_selector_1.Type.PATH;
	    }
	    var remainder = expression.substring(1);
	    var qualifier;
	    var base;
	    if (type === topic_selector_1.Type.PATH) {
	        base = remainder;
	        qualifier = DQ.MATCH;
	    }
	    else if (remainder[remainder.length - 1] === '/') {
	        if (remainder[remainder.length - 2] === '/') {
	            qualifier = DQ.MATCH_AND_DESCENDANTS;
	            base = utils.canonicalise(remainder.substring(0, remainder.length - 2));
	        }
	        else {
	            qualifier = DQ.DESCENDANTS_OF_MATCH;
	            base = utils.canonicalise(remainder.substring(0, remainder.length - 1));
	        }
	    }
	    else {
	        base = utils.canonicalise(remainder);
	        qualifier = DQ.MATCH;
	    }
	    var prefix = (type === topic_selector_1.Type.PATH) ? utils.canonicalise(remainder) : extractPrefixFromRegex(base);
	    return {
	        type: type,
	        base: base,
	        prefix: prefix,
	        remainder: remainder,
	        qualifier: qualifier,
	        expression: type + remainder
	    };
	}
	/**
	 * Determine if a component group can be treated as a topic path.
	 *
	 * @param  c  the component group
	 * @returns   if the components represent a topic path selector
	 */
	function isTopicPath(c) {
	    if (c.type === topic_selector_1.Type.PATH) {
	        return true;
	    }
	    if (c.type === topic_selector_1.Type.SELECTOR_SET || c.prefix === '') {
	        return false;
	    }
	    return c.prefix === c.base;
	}
	/**
	 * Determine the Topic Selector type of a given expression.
	 *
	 * @param expression  the selector expression
	 * @returns           the topic selector type, or null
	 */
	function getType(expression) {
	    switch (expression[0]) {
	        case topic_selector_1.Prefix.PATH:
	            return topic_selector_1.Type.PATH;
	        case topic_selector_1.Prefix.SPLIT_PATH_PATTERN:
	            return topic_selector_1.Type.SPLIT_PATH_PATTERN;
	        case topic_selector_1.Prefix.FULL_PATH_PATTERN:
	            return topic_selector_1.Type.FULL_PATH_PATTERN;
	        case topic_selector_1.Prefix.SELECTOR_SET:
	            return topic_selector_1.Type.SELECTOR_SET;
	        case '$':
	        case '%':
	        case '&':
	        case '<':
	            // reserved character
	            throw new Error('Invalid expression type: ' + expression);
	        default:
	            // default is to treat null as a path
	            return null;
	    }
	}
	/**
	 * Invalid characters for a topic path to contain
	 */
	var metaChars = ['*', '.', '+', '?', '^', '$', '{', '}', '(', ')', '[', ']', '\\', '|'];
	/**
	 * Validate characters in a normal parsing mode
	 *
	 * @param c  the character to check
	 * @return   `true` if the character is a normal path character
	 */
	function normal(c) {
	    return metaChars.indexOf(c) === -1;
	}
	/**
	 * Validated characters within a quoted block (\Q \E)
	 *
	 * @return  `true`
	 */
	function quoted() {
	    return true;
	}
	/**
	 * Extract the largest possible topic path prefix from a string that may
	 * contain a regular expression.
	 *
	 * @param {String} remainder - The remainder (i.e expression minus prefix)
	 * @returns {String} The maximum topic path that could be extracted
	 */ // tslint:disable-next-line:cyclomatic-complexity
	function extractPrefixFromRegex(remainder) {
	    var buffer = [];
	    var composite = [];
	    var validator = normal;
	    for (var i = 0, l = remainder.length; i < l; ++i) {
	        var char = remainder[i];
	        // identify a metachar and transition to an appropriate parse mode.
	        // we can then safely skip over the '\' char & following metachar.
	        if (char === '\\' && i < l - 1) {
	            var next = remainder[i + 1];
	            if (validator === normal) {
	                i++;
	                if (next === 'Q') {
	                    validator = quoted;
	                }
	                else if ((next < 'a' || next > 'z') && (next < 'A' || next > 'Z')) {
	                    // an escaped alphabetic character can be assumed to be a meta construct
	                    buffer.push(next);
	                }
	                else {
	                    // an escaped metachar indicates the end of the run
	                    buffer.length = 0;
	                    break;
	                }
	            }
	            else if (next === 'E') {
	                i++;
	                validator = normal;
	            }
	            else {
	                buffer.push(char);
	            }
	        }
	        else if (char === utils.PATH_SEPARATOR) {
	            composite.push(buffer.join(''));
	            buffer.length = 0;
	            buffer.push(char);
	        }
	        else if (validator(char)) {
	            buffer.push(char);
	        }
	        else {
	            buffer.length = 0;
	            break;
	        }
	    }
	    composite.push(buffer.join(''));
	    return utils.canonicalise(composite.join(''));
	}
	/**
	 * A matcher function to memoize arguments for the {@link parseSelector} function
	 *
	 * @param  args  the arguments
	 * @return       a JSON string of the arguments
	 */
	function memoizeMatcher(args) {
	    return JSON.stringify(args);
	}
	var disableTopicCache = process && ({"NODE_ENV":"production"}) && (({"NODE_ENV":"production"}).DISABLE_TOPIC_CACHE === 'true');
	/**
	 * Wrap the parse function to cache results
	 */
	var cachedParse = disableTopicCache ? parseSelector : memoize_1.memoize(parseSelector, {}, memoizeMatcher);
	exports.parseSelector = cachedParse;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Array
	 *
	 * @brief Utility functions for array manipulation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Remove an element from an array.
	 *
	 * @param arr     the array
	 * @param element the object to remove
	 * @param <T>     the type of the elements stored in the array
	 * @returns       `true` if the element was present in the array
	 */
	function remove(array, element) {
	    var i = array.indexOf(element);
	    if (i > -1) {
	        array.splice(i, 1);
	        return true;
	    }
	    return false;
	}
	exports.remove = remove;
	/**
	 * Fill an array with a given value, within an optional range
	 *
	 * @param array the array to fill
	 * @param value the value to fill the array with
	 * @param start optional range start
	 * @param end   optional range end
	 */
	function fill(array, value, start, end) {
	    if (start === void 0) { start = 0; }
	    if (end === void 0) { end = array.length; }
	    for (var i = start; i < end; ++i) {
	        array[i] = value;
	    }
	}
	exports.fill = fill;
	/**
	 * Create an array of a given size, optionally pre-filled with a specified initial value.
	 *
	 * @param size         the size of the array to create
	 * @param initialValue if specified, the initial will be assigned to each element
	 */
	function ofSize(size, initialValue) {
	    var a = [];
	    a.length = size;
	    if (initialValue !== undefined) {
	        fill(a, initialValue);
	    }
	    return a;
	}
	exports.ofSize = ofSize;


/***/ }),
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(245),
	    baseLodash = __webpack_require__(357);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1579),
	    mapCacheDelete = __webpack_require__(1580),
	    mapCacheGet = __webpack_require__(1581),
	    mapCacheHas = __webpack_require__(1582),
	    mapCacheSet = __webpack_require__(1583);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(242),
	    stackClear = __webpack_require__(1595),
	    stackDelete = __webpack_require__(1596),
	    stackGet = __webpack_require__(1597),
	    stackHas = __webpack_require__(1598),
	    stackSet = __webpack_require__(1599);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1515),
	    createBaseEach = __webpack_require__(1546);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1528),
	    baseMatchesProperty = __webpack_require__(1529),
	    identity = __webpack_require__(188),
	    isArray = __webpack_require__(39),
	    property = __webpack_require__(1630);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(555);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(570),
	    createBind = __webpack_require__(1548),
	    createCurry = __webpack_require__(1549),
	    createHybrid = __webpack_require__(575),
	    createPartial = __webpack_require__(1550),
	    getData = __webpack_require__(581),
	    mergeData = __webpack_require__(1586),
	    setData = __webpack_require__(589),
	    setWrapToString = __webpack_require__(590),
	    toInteger = __webpack_require__(600);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(587);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(353),
	    stubArray = __webpack_require__(599);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(39),
	    isSymbol = __webpack_require__(190);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(579);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194)(module)))

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1532),
	    shortOut = __webpack_require__(591);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var baseConvert = __webpack_require__(1613),
	    util = __webpack_require__(1615);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1518),
	    isObjectLike = __webpack_require__(59);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41),
	    stubFalse = __webpack_require__(1634);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194)(module)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObject = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(557),
	    baseKeysIn = __webpack_require__(1526),
	    isArrayLike = __webpack_require__(189);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getConnector = undefined;
	exports.setLogLevel = setLogLevel;
	exports.setProvider = setProvider;
	
	var _diffusionConnector = __webpack_require__(1813);
	
	var _diffusionConnector2 = _interopRequireDefault(_diffusionConnector);
	
	var _cachedValue = __webpack_require__(152);
	
	var _providers = __webpack_require__(752);
	
	var _logger = __webpack_require__(257);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setLogLevel(logLevel) {
	    (0, _providers.log)(logLevel);
	    (0, _logger.setLevel)(logLevel);
	}
	
	var getConnector = exports.getConnector = (0, _cachedValue.singleValue)(function () {
	    var connectorInstance = (0, _diffusionConnector2.default)((0, _providers.getProvider)());
	    window.addEventListener('beforeunload', connectorInstance.closeSession);
	    return connectorInstance;
	}).getValue;
	
	function setProvider(provider) {
	    getConnector().setProvider(provider);
	}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = get;
	function get(key) {
	    if (!key) {
	        return null;
	    }
	    var escapedKey = encodeURIComponent(key).replace(/[-.+*]/g, '\\$&');
	    var value = document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + escapedKey + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1');
	    return decodeURIComponent(value);
	}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SubscriptionFactory;
	
	var _wildemitter = __webpack_require__(260);
	
	var _wildemitter2 = _interopRequireDefault(_wildemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function streamer(state) {
	    var mainSubscription = void 0;
	
	    var onUpdate = function onUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        state.emit.apply(state, ['update'].concat(args));
	    };
	
	    var onClose = function onClose() {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        state.emit.apply(state, ['close'].concat(args));
	        if (mainSubscription && mainSubscription.off) {
	            mainSubscription.off('close', onClose);
	            mainSubscription.off('update', onUpdate);
	        }
	        mainSubscription = null;
	    };
	
	    return {
	        /**
	         * Subscribes for passed subscription events and transfers them.
	         * [API subscription DOC]{@link http://docs.pushtechnology.com/docs/5.7.5/js/Subscription.html}
	         * @memberOf Subscription
	         * @instance
	         * @param {Subscription} subscription Subscription for wrapping.
	         */
	        subscribe: function subscribe(subscription) {
	            mainSubscription = subscription;
	            subscription.on('close', onClose);
	            subscription.on('update', onUpdate);
	        },
	
	        setSubscription: function setSubscription(subscription) {
	            mainSubscription = subscription;
	        },
	
	        onClose: onClose,
	
	        onUpdate: onUpdate,
	
	        /**
	         * Close the subscription. No further events will be emitted.
	         * Unsubscribe from subscribed events.
	         * @memberOf Subscription
	         * @instance
	         * @throws {Error} Throws if no duffusion sunscription was subscribed.
	         */
	        close: function close() {
	            if (mainSubscription) {
	                var _mainSubscription;
	
	                (_mainSubscription = mainSubscription).close.apply(_mainSubscription, arguments);
	            }
	        },
	        fetch: function fetch() {
	            if (mainSubscription) {
	                var _mainSubscription2;
	
	                (_mainSubscription2 = mainSubscription).fetch.apply(_mainSubscription2, arguments);
	            }
	        }
	    };
	}
	
	/**
	 * Subscription representation.
	 * Wrapper under [diffusion subscription]{@link diffusion.Subscription}
	 * @class Subscription
	 * @extends {Emitter}
	 */
	function SubscriptionFactory() {
	    var state = new _wildemitter2.default();
	    return Object.assign(state, streamer(state));
	}

/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Transform = __webpack_require__(1708);
	
	var binding = __webpack_require__(782);
	var util = __webpack_require__(1875);
	var assert = __webpack_require__(767).ok;
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});
	
	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function(o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function(o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};
	
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');
	
	  var flushFlag = binding.Z_FINISH;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._binding = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);
	
	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};
	
	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);
	
	  if (this._closed)
	    return;
	
	  this._closed = true;
	
	  this._binding.close();
	
	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};
	
	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });
	
	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    this.close();
	
	    return buf;
	  }
	
	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;
	
	      if (!async)
	        return true;
	
	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async)
	      return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer, __webpack_require__(82)))

/***/ }),
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21);
	var toObject = __webpack_require__(50);
	var IndexedObject = __webpack_require__(216);
	var toLength = __webpack_require__(38);
	
	// `Array.prototype.{ reduce, reduceRight }` methods implementation
	var createMethod = function (IS_RIGHT) {
	  return function (that, callbackfn, argumentsLength, memo) {
	    aFunction(callbackfn);
	    var O = toObject(that);
	    var self = IndexedObject(O);
	    var length = toLength(O.length);
	    var index = IS_RIGHT ? length - 1 : 0;
	    var i = IS_RIGHT ? -1 : 1;
	    if (argumentsLength < 2) while (true) {
	      if (index in self) {
	        memo = self[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if (IS_RIGHT ? index < 0 : length <= index) {
	        throw TypeError('Reduce of empty array with no initial value');
	      }
	    }
	    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }
	    return memo;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.reduce` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
	  left: createMethod(false),
	  // `Array.prototype.reduceRight` method
	  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
	  right: createMethod(true)
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	
	// call something on iterator step with safe closing on error
	module.exports = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (error) {
	    var returnMethod = iterator['return'];
	    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
	    throw error;
	  }
	};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_STRING_TAG_SUPPORT = __webpack_require__(318);
	var classofRaw = __webpack_require__(97);
	var wellKnownSymbol = __webpack_require__(35);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	
	// https://github.com/tc39/collection-methods
	module.exports = function (/* ...elements */) {
	  var collection = anObject(this);
	  var remover = aFunction(collection['delete']);
	  var allDeleted = true;
	  var wasDeleted;
	  for (var k = 0, len = arguments.length; k < len; k++) {
	    wasDeleted = remover.call(collection, arguments[k]);
	    allDeleted = allDeleted && wasDeleted;
	  }
	  return !!allDeleted;
	};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var aFunction = __webpack_require__(21);
	var bind = __webpack_require__(32);
	var iterate = __webpack_require__(16);
	
	module.exports = function from(source /* , mapFn, thisArg */) {
	  var length = arguments.length;
	  var mapFn = length > 1 ? arguments[1] : undefined;
	  var mapping, A, n, boundFunction;
	  aFunction(this);
	  mapping = mapFn !== undefined;
	  if (mapping) aFunction(mapFn);
	  if (source == undefined) return new this();
	  A = [];
	  if (mapping) {
	    n = 0;
	    boundFunction = bind(mapFn, length > 2 ? arguments[2] : undefined, 2);
	    iterate(source, function (nextItem) {
	      A.push(boundFunction(nextItem, n++));
	    });
	  } else {
	    iterate(source, A.push, A);
	  }
	  return new this(A);
	};


/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	module.exports = function of() {
	  var length = arguments.length;
	  var A = new Array(length);
	  while (length--) A[length] = arguments[length];
	  return new this(A);
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var defineProperty = __webpack_require__(49).f;
	var create = __webpack_require__(169);
	var redefineAll = __webpack_require__(482);
	var bind = __webpack_require__(32);
	var anInstance = __webpack_require__(302);
	var iterate = __webpack_require__(16);
	var defineIterator = __webpack_require__(305);
	var setSpecies = __webpack_require__(315);
	var DESCRIPTORS = __webpack_require__(48);
	var fastKey = __webpack_require__(469).fastKey;
	var InternalStateModule = __webpack_require__(143);
	
	var setInternalState = InternalStateModule.set;
	var internalStateGetterFor = InternalStateModule.getterFor;
	
	module.exports = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, CONSTRUCTOR_NAME);
	      setInternalState(that, {
	        type: CONSTRUCTOR_NAME,
	        index: create(null),
	        first: undefined,
	        last: undefined,
	        size: 0
	      });
	      if (!DESCRIPTORS) that.size = 0;
	      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
	    });
	
	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
	
	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var entry = getEntry(that, key);
	      var previous, index;
	      // change existing entry
	      if (entry) {
	        entry.value = value;
	      // create new entry
	      } else {
	        state.last = entry = {
	          index: index = fastKey(key, true),
	          key: key,
	          value: value,
	          previous: previous = state.last,
	          next: undefined,
	          removed: false
	        };
	        if (!state.first) state.first = entry;
	        if (previous) previous.next = entry;
	        if (DESCRIPTORS) state.size++;
	        else that.size++;
	        // add to index
	        if (index !== 'F') state.index[index] = entry;
	      } return that;
	    };
	
	    var getEntry = function (that, key) {
	      var state = getInternalState(that);
	      // fast case
	      var index = fastKey(key);
	      var entry;
	      if (index !== 'F') return state.index[index];
	      // frozen object case
	      for (entry = state.first; entry; entry = entry.next) {
	        if (entry.key == key) return entry;
	      }
	    };
	
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        var that = this;
	        var state = getInternalState(that);
	        var data = state.index;
	        var entry = state.first;
	        while (entry) {
	          entry.removed = true;
	          if (entry.previous) entry.previous = entry.previous.next = undefined;
	          delete data[entry.index];
	          entry = entry.next;
	        }
	        state.first = state.last = undefined;
	        if (DESCRIPTORS) state.size = 0;
	        else that.size = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.next;
	          var prev = entry.previous;
	          delete state.index[entry.index];
	          entry.removed = true;
	          if (prev) prev.next = next;
	          if (next) next.previous = prev;
	          if (state.first == entry) state.first = next;
	          if (state.last == entry) state.last = prev;
	          if (DESCRIPTORS) state.size--;
	          else that.size--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        var state = getInternalState(this);
	        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.next : state.first) {
	          boundFunction(entry.value, entry.key, this);
	          // revert to the last existing entry
	          while (entry && entry.removed) entry = entry.previous;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(this, key);
	      }
	    });
	
	    redefineAll(C.prototype, IS_MAP ? {
	      // 23.1.3.6 Map.prototype.get(key)
	      get: function get(key) {
	        var entry = getEntry(this, key);
	        return entry && entry.value;
	      },
	      // 23.1.3.9 Map.prototype.set(key, value)
	      set: function set(key, value) {
	        return define(this, key === 0 ? 0 : key, value);
	      }
	    } : {
	      // 23.2.3.1 Set.prototype.add(value)
	      add: function add(value) {
	        return define(this, value = value === 0 ? 0 : value, value);
	      }
	    });
	    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
	      get: function () {
	        return getInternalState(this).size;
	      }
	    });
	    return C;
	  },
	  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
	    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
	    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
	    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
	      setInternalState(this, {
	        type: ITERATOR_NAME,
	        target: iterated,
	        state: getInternalCollectionState(iterated),
	        kind: kind,
	        last: undefined
	      });
	    }, function () {
	      var state = getInternalIteratorState(this);
	      var kind = state.kind;
	      var entry = state.last;
	      // revert to the last existing entry
	      while (entry && entry.removed) entry = entry.previous;
	      // get next entry
	      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
	        // or finish the iteration
	        state.target = undefined;
	        return { value: undefined, done: true };
	      }
	      // return step by kind
	      if (kind == 'keys') return { value: entry.key, done: false };
	      if (kind == 'values') return { value: entry.value, done: false };
	      return { value: [entry.key, entry.value], done: false };
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(CONSTRUCTOR_NAME);
	  }
	};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var global = __webpack_require__(27);
	var isForced = __webpack_require__(217);
	var redefine = __webpack_require__(99);
	var InternalMetadataModule = __webpack_require__(469);
	var iterate = __webpack_require__(16);
	var anInstance = __webpack_require__(302);
	var isObject = __webpack_require__(43);
	var fails = __webpack_require__(31);
	var checkCorrectnessOfIteration = __webpack_require__(304);
	var setToStringTag = __webpack_require__(220);
	var inheritIfRequired = __webpack_require__(468);
	
	module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
	  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
	  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var NativeConstructor = global[CONSTRUCTOR_NAME];
	  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
	  var Constructor = NativeConstructor;
	  var exported = {};
	
	  var fixMethod = function (KEY) {
	    var nativeMethod = NativePrototype[KEY];
	    redefine(NativePrototype, KEY,
	      KEY == 'add' ? function add(value) {
	        nativeMethod.call(this, value === 0 ? 0 : value);
	        return this;
	      } : KEY == 'delete' ? function (key) {
	        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
	      } : KEY == 'get' ? function get(key) {
	        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
	      } : KEY == 'has' ? function has(key) {
	        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
	      } : function set(key, value) {
	        nativeMethod.call(this, key === 0 ? 0 : key, value);
	        return this;
	      }
	    );
	  };
	
	  // eslint-disable-next-line max-len
	  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
	    new NativeConstructor().entries().next();
	  })))) {
	    // create collection constructor
	    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
	    InternalMetadataModule.REQUIRED = true;
	  } else if (isForced(CONSTRUCTOR_NAME, true)) {
	    var instance = new Constructor();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    // eslint-disable-next-line no-new
	    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new NativeConstructor();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	
	    if (!ACCEPT_ITERABLES) {
	      Constructor = wrapper(function (dummy, iterable) {
	        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
	        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
	        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
	        return that;
	      });
	      Constructor.prototype = NativePrototype;
	      NativePrototype.constructor = Constructor;
	    }
	
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	
	    // weak collections should not contains .clear method
	    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
	  }
	
	  exported[CONSTRUCTOR_NAME] = Constructor;
	  $({ global: true, forced: Constructor != NativeConstructor }, exported);
	
	  setToStringTag(Constructor, CONSTRUCTOR_NAME);
	
	  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
	
	  return Constructor;
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var userAgent = __webpack_require__(464);
	
	module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var getBuiltIn = __webpack_require__(34);
	
	module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(121);
	var toLength = __webpack_require__(38);
	var bind = __webpack_require__(32);
	
	// `FlattenIntoArray` abstract operation
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
	  var element;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      if (depth > 0 && isArray(element)) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	};
	
	module.exports = flattenIntoArray;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var getBuiltIn = __webpack_require__(34);
	
	module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var fails = __webpack_require__(31);
	var createElement = __webpack_require__(306);
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !DESCRIPTORS && !fails(function () {
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	var setPrototypeOf = __webpack_require__(313);
	
	// makes subclassing work correct for wrapped built-ins
	module.exports = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	    // it can work only with native `setPrototypeOf`
	    setPrototypeOf &&
	    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	    typeof (NewTarget = dummy.constructor) == 'function' &&
	    NewTarget !== Wrapper &&
	    isObject(NewTargetPrototype = NewTarget.prototype) &&
	    NewTargetPrototype !== Wrapper.prototype
	  ) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var hiddenKeys = __webpack_require__(215);
	var isObject = __webpack_require__(43);
	var has = __webpack_require__(58);
	var defineProperty = __webpack_require__(49).f;
	var uid = __webpack_require__(319);
	var FREEZING = __webpack_require__(1052);
	
	var METADATA = uid('meta');
	var id = 0;
	
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	
	var setMetadata = function (it) {
	  defineProperty(it, METADATA, { value: {
	    objectID: 'O' + ++id, // object ID
	    weakData: {}          // weak collections IDs
	  } });
	};
	
	var fastKey = function (it, create) {
	  // return a primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMetadata(it);
	  // return object ID
	  } return it[METADATA].objectID;
	};
	
	var getWeakData = function (it, create) {
	  if (!has(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMetadata(it);
	  // return the store of weak collections IDs
	  } return it[METADATA].weakData;
	};
	
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
	  return it;
	};
	
	var meta = module.exports = {
	  REQUIRED: false,
	  fastKey: fastKey,
	  getWeakData: getWeakData,
	  onFreeze: onFreeze
	};
	
	hiddenKeys[METADATA] = true;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var wellKnownSymbol = __webpack_require__(35);
	var Iterators = __webpack_require__(167);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype;
	
	// check on default Array iterator
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
	};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	var floor = Math.floor;
	
	// `Number.isInteger` method implementation
	// https://tc39.github.io/ecma262/#sec-number.isinteger
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getPrototypeOf = __webpack_require__(312);
	var createNonEnumerableProperty = __webpack_require__(98);
	var has = __webpack_require__(58);
	var wellKnownSymbol = __webpack_require__(35);
	var IS_PURE = __webpack_require__(14);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;
	
	var returnThis = function () { return this; };
	
	// `%IteratorPrototype%` object
	// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
	
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}
	
	if (IteratorPrototype == undefined) IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
	  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
	}
	
	module.exports = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(13);
	
	// `Map.prototype.upsert` method
	// https://github.com/thumbsupep/proposal-upsert
	module.exports = function upsert(key, updateFn /* , insertFn */) {
	  var map = anObject(this);
	  var insertFn = arguments.length > 2 ? arguments[2] : undefined;
	  var value;
	  if (typeof updateFn != 'function' && typeof insertFn != 'function') {
	    throw TypeError('At least one callback required');
	  }
	  if (map.has(key)) {
	    value = map.get(key);
	    if (typeof updateFn == 'function') {
	      value = updateFn(value);
	      map.set(key, value);
	    }
	  } else if (typeof insertFn == 'function') {
	    value = insertFn();
	    map.set(key, value);
	  } return value;
	};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	
	module.exports = global.Promise;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	
	module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
	  // Chrome 38 Symbol has incorrect toString conversion
	  // eslint-disable-next-line no-undef
	  return !String(Symbol());
	});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var trim = __webpack_require__(317).trim;
	var whitespaces = __webpack_require__(320);
	
	var $parseInt = global.parseInt;
	var hex = /^[+-]?0[Xx]/;
	var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;
	
	// `parseInt` method
	// https://tc39.github.io/ecma262/#sec-parseint-string-radix
	module.exports = FORCED ? function parseInt(string, radix) {
	  var S = trim(String(string));
	  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var internalObjectKeys = __webpack_require__(478);
	var enumBugKeys = __webpack_require__(308);
	
	var hiddenKeys = enumBugKeys.concat('length', 'prototype');
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toIndexedObject = __webpack_require__(100);
	var indexOf = __webpack_require__(303).indexOf;
	var hiddenKeys = __webpack_require__(215);
	
	module.exports = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~indexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var internalObjectKeys = __webpack_require__(478);
	var enumBugKeys = __webpack_require__(308);
	
	// `Object.keys` method
	// https://tc39.github.io/ecma262/#sec-object.keys
	module.exports = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	'use strict';
	var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
	
	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
	exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : nativePropertyIsEnumerable;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(13);
	var isObject = __webpack_require__(43);
	var newPromiseCapability = __webpack_require__(168);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(99);
	
	module.exports = function (target, src, options) {
	  for (var key in src) redefine(target, key, src[key], options);
	  return target;
	};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var setGlobal = __webpack_require__(314);
	
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || setGlobal(SHARED, {});
	
	module.exports = store;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var IS_PURE = __webpack_require__(14);
	var store = __webpack_require__(483);
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.6.5',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var fails = __webpack_require__(31);
	var classof = __webpack_require__(97);
	var bind = __webpack_require__(32);
	var html = __webpack_require__(466);
	var createElement = __webpack_require__(306);
	var IS_IOS = __webpack_require__(463);
	
	var location = global.location;
	var set = global.setImmediate;
	var clear = global.clearImmediate;
	var process = global.process;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	
	var run = function (id) {
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	
	var runner = function (id) {
	  return function () {
	    run(id);
	  };
	};
	
	var listener = function (event) {
	  run(event.data);
	};
	
	var post = function (id) {
	  // old engines have not location.origin
	  global.postMessage(id + '', location.protocol + '//' + location.host);
	};
	
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!set || !clear) {
	  set = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clear = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (classof(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(runner(id));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(runner(id));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  // except iOS - https://github.com/zloirock/core-js/issues/624
	  } else if (MessageChannel && !IS_IOS) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = bind(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (
	    global.addEventListener &&
	    typeof postMessage == 'function' &&
	    !global.importScripts &&
	    !fails(post) &&
	    location.protocol !== 'file:'
	  ) {
	    defer = post;
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in createElement('script')) {
	    defer = function (id) {
	      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(runner(id), 0);
	    };
	  }
	}
	
	module.exports = {
	  set: set,
	  clear: clear
	};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(97);
	
	// `thisNumberValue` abstract operation
	// https://tc39.github.io/ecma262/#sec-thisnumbervalue
	module.exports = function (value) {
	  if (typeof value != 'number' && classof(value) != 'Number') {
	    throw TypeError('Incorrect invocation');
	  }
	  return +value;
	};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(100);
	var addToUnscopables = __webpack_require__(76);
	var Iterators = __webpack_require__(167);
	var InternalStateModule = __webpack_require__(143);
	var defineIterator = __webpack_require__(305);
	
	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
	
	// `Array.prototype.entries` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.github.io/ecma262/#sec-createarrayiterator
	module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var kind = state.kind;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return { value: undefined, done: true };
	  }
	  if (kind == 'keys') return { value: index, done: false };
	  if (kind == 'values') return { value: target[index], done: false };
	  return { value: [index, target[index]], done: false };
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
	Iterators.Arguments = Iterators.Array;
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var aFunction = __webpack_require__(21);
	var newPromiseCapabilityModule = __webpack_require__(168);
	var perform = __webpack_require__(219);
	var iterate = __webpack_require__(16);
	
	// `Promise.allSettled` method
	// https://github.com/tc39/proposal-promise-allSettled
	$({ target: 'Promise', stat: true }, {
	  allSettled: function allSettled(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aFunction(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        promiseResolve.call(C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'fulfilled', value: value };
	          --remaining || resolve(values);
	        }, function (e) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'rejected', reason: e };
	          --remaining || resolve(values);
	        });
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.clients
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var close_reason_1 = __webpack_require__(172);
	// tslint:disable-next-line:variable-name
	exports.ClientControlOptions = {
	    /**
	     * Dictionary containing standard session property keys
	     *
	     * **Example:**
	     * ```
	     * // Get the ALL_FIXED_PROPERTIES key
	     * var props = diffusion.clients.PropertyKeys.ALL_FIXED_PROPERTIES;
	     * ```
	     *
	     * **Example:**
	     * ```
	     * // Get all user and fixed properties
	     * var props = diffusion.clients.PropertyKeys.ALL_FIXED_PROPERTIES
	     *      .concat(diffusion.clients.PropertyKeys.ALL_USER_PROPERTIES);
	     * ```
	     *
	     */ // tslint:disable-next-line:variable-name
	    PropertyKeys: Object.freeze({
	        /**
	         * This constant can be used instead of a property key in requests for
	         * session property values to indicate that <b>all</b> fixed session
	         * properties are required.
	         */
	        ALL_FIXED_PROPERTIES: ['*F'],
	        /**
	         * This constant can be used instead of a property key in requests for
	         * session property values to indicate that <b>all</b> user defined session
	         * properties are required.
	         */
	        ALL_USER_PROPERTIES: ['*U'],
	        /**
	         * This constant can be used instead of a property key in requests for
	         * session property values to indicate that <b>all</b> session
	         * properties are required.
	         */
	        ALL_PROPERTIES: ['*F', '*U'],
	        /**
	         * Session property key for session identifier.
	         *
	         * @since 6.2
	         */
	        SESSION_ID: '$SessionId',
	        /**
	         * Session property key for principal.
	         *
	         * @since 6.2
	         */
	        PRINCIPAL: '$Principal',
	        /**
	         * Session property key for connector name.
	         *
	         * @since 6.2
	         */
	        CONNECTOR: '$Connector',
	        /**
	         * Session property key for transport.
	         *
	         * @since 6.2
	         */
	        TRANSPORT: '$Transport',
	        /**
	         * Session property key for client type.
	         *
	         * @since 6.2
	         */
	        CLIENT_TYPE: '$ClientType',
	        /**
	         * Session property key for country code.
	         *
	         * @since 6.2
	         */
	        COUNTRY: '$Country',
	        /**
	         * Session property key for language code.
	         *
	         * @since 6.2
	         */
	        LANGUAGE: '$Language',
	        /**
	         * Session property key for server name.
	         *
	         * @since 6.2
	         */
	        SERVER_NAME: '$ServerName',
	        /**
	         * Session property key for client IP address.
	         *
	         * @since 6.2
	         */
	        CLIENT_IP: '$ClientIP',
	        /**
	         * Session property key for client latitude.
	         *
	         * @since 6.2
	         */
	        LATITUDE: '$Latitude',
	        /**
	         * Session property key for client longitude.
	         *
	         * @since 6.2
	         */
	        LONGITUDE: '$Longitude',
	        /**
	         * Session property key for client start time.
	         *
	         * @since 6.2
	         */
	        START_TIME: '$StartTime',
	        /**
	         * Session property key for session roles.
	         *
	         * @since 6.2
	         */
	        ROLES: '$Roles',
	        /**
	         * Session property key for MQTT client ID.
	         *
	         * @since 6.6
	         */
	        MQTT_CLIENT_ID: '$MQTTClientId',
	        /**
	         * Session property key for Gateway Client type.
	         *
	         * @since 6.6
	         */
	        GATEWAY_TYPE: '$GatewayType',
	        /**
	         * Session property key for Gateway Client identifier.
	         *
	         * @since 6.6
	         */
	        GATEWAY_ID: '$GatewayId'
	    }),
	    /**
	     * Value returned by {@link Session.getPrincipal} if no principal name is
	     * associated with the session.
	     */
	    ANONYMOUS: '',
	    CloseReason: close_reason_1.CloseReasonEnum
	};


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Session.clients
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Event types used within {@link SessionPropertiesListener.onSessionEvent}.
	 *
	 * **Example:**
	 * ```
	 * session.clients.setSessionPropertiesListener(props, {
	 *     // ...
	 *
	 *     onSessionEvent : function(sessionID, event, properties, previous) {
	 *          switch (event) {
	 *              case session.clients.SessionEventType.DISCONNECTED :
	 *                  console.log(sessionID + " has disconnected");
	 *                  break;
	 *              case session.clients.SessionEventType.RECONNECTED :
	 *                  console.log(sessionID + " has reconnected");
	 *                  break;
	 *          }
	 *     }
	 *
	 *     // ...
	 * });
	 * ```
	 */
	var SessionEventType;
	(function (SessionEventType) {
	    /**
	     * One or more relevant session properties have been updated.
	     */
	    SessionEventType[SessionEventType["UPDATED"] = 0] = "UPDATED";
	    /**
	     * A session has reconnected.
	     */
	    SessionEventType[SessionEventType["RECONNECTED"] = 1] = "RECONNECTED";
	    /**
	     * A session has failed over from one server to another in a cluster.
	     */
	    SessionEventType[SessionEventType["FAILED_OVER"] = 2] = "FAILED_OVER";
	    /**
	     * A session has disconnected.
	     */
	    SessionEventType[SessionEventType["DISCONNECTED"] = 3] = "DISCONNECTED";
	})(SessionEventType = exports.SessionEventType || (exports.SessionEventType = {}));


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Defined reason code and message used to report client close conditions.
	 */
	var CloseReasonImpl = /** @class */ (function () {
	    /**
	     * Create a `CloseReason`
	     *
	     * @param  id           the close reason's id
	     * @param  message      the close reason's description
	     * @param  canReconnect whether the session can reconnect from this state
	     */
	    function CloseReasonImpl(id, message, canReconnect) {
	        this.id = id;
	        this.message = message;
	        this.canReconnect = canReconnect;
	    }
	    /**
	     * Convert to string
	     *
	     * @return string representation of the close reason
	     */
	    CloseReasonImpl.prototype.toString = function () {
	        return 'id: ' + this.message;
	    };
	    return CloseReasonImpl;
	}());
	exports.CloseReasonImpl = CloseReasonImpl;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_reason_1 = __webpack_require__(325);
	var conversation_id_1 = __webpack_require__(124);
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var command_header_serialiser_1 = __webpack_require__(512);
	var logger = __webpack_require__(17);
	var message_1 = __webpack_require__(236);
	var error_reason_2 = __webpack_require__(88);
	var log = logger.create('ServiceAdapter');
	/**
	 * A service callback that does nothing
	 */
	var NULL_CALLBACK = {
	    respond: function () {
	        // no-op
	    },
	    fail: function () {
	        // no-op
	    }
	};
	/**
	 * Adaptor to bridge v4-stack components and command services.
	 */
	var ServiceAdapter = /** @class */ (function () {
	    /**
	     * Create a new ServiceAdapter instance
	     *
	     * @param internalSession  the internal session this adapter is bound to
	     * @param sender           the function to enqueue messages
	     */
	    function ServiceAdapter(internalSession, sender) {
	        /**
	         * Listeners that have bee registered for each command service
	         */
	        this.listeners = {};
	        this.internalSession = internalSession;
	        this.sender = sender;
	    }
	    /**
	     * Send a request command message to the server for a given service.
	     *
	     * @param header      the header encapsulating the message's context.
	     * @param command     the command to send.
	     * @param serialiser  the serialiser for the command object.
	     */
	    ServiceAdapter.prototype.sendRequest = function (header, command, serialiser) {
	        var msg = message_1.create({
	            type: message_1.types.SERVICE_REQUEST
	        });
	        var bos = msg.getStream();
	        command_header_serialiser_1.CommandHeaderSerialiser.write(bos, header);
	        serialiser.write(bos, command);
	        log.debug('Sending command request: ' + header, command);
	        this.sender(msg);
	    };
	    /**
	     * Send a response command message to the server for a given service.
	     *
	     * @param header      the header encapsulating the message's context.
	     * @param command     the command to send.
	     * @param serialiser  the serialiser for the command object.
	     */
	    ServiceAdapter.prototype.sendResponse = function (header, command, serialiser) {
	        var msg = message_1.create({
	            type: message_1.types.SERVICE_RESPONSE
	        });
	        var bos = msg.getStream();
	        command_header_serialiser_1.ResponseCommandHeaderSerialiser.write(bos, header);
	        serialiser.write(bos, command);
	        log.debug('Sending command response: ' + header, command);
	        this.sender(msg);
	    };
	    /**
	     * Send an error command message to the server for a given service.
	     *
	     * @param header      the header encapsulating the message's context.
	     * @param command     the command to send.
	     * @param serialiser  the serialiser for the command object.
	     */
	    ServiceAdapter.prototype.sendError = function (header, error, message) {
	        var msg = message_1.create({
	            type: message_1.types.SERVICE_ERROR
	        });
	        var bos = msg.getStream();
	        command_header_serialiser_1.ResponseCommandHeaderSerialiser.write(bos, header);
	        Codec.writeString(bos, message);
	        Codec.writeInt32(bos, error.id);
	        log.debug('Sending command error: ' + error.id, message);
	        this.sender(msg);
	    };
	    /**
	     * Add a service to the adapter, in order to receive requests from the server.
	     *
	     * @param definition  the service definition
	     * @param service     the service implementation
	     */
	    ServiceAdapter.prototype.addService = function (definition, service) {
	        var _this = this;
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.listeners[definition.id] === undefined) {
	            var requestSerialiser_1 = definition.request;
	            var responseSerialiser_1 = definition.response;
	            this.listeners[definition.id] = function (header, input) {
	                var request = requestSerialiser_1.read(input);
	                var callback = header.cid.equals(conversation_id_1.ONEWAY_CID) ? NULL_CALLBACK : {
	                    // respond to the inbound request.
	                    respond: function (response) {
	                        var rHeader = header.createResponseHeader();
	                        _this.sendResponse(rHeader, response, responseSerialiser_1);
	                    },
	                    // return an error to the server.
	                    fail: function (error, message, rethrowError) {
	                        if (rethrowError === void 0) { rethrowError = true; }
	                        var eHeader = header.createErrorHeader();
	                        _this.sendError(eHeader, error, message);
	                        if (rethrowError) {
	                            // rethrow the error so that the registration adapter can unregister the handler
	                            throw error;
	                        }
	                    }
	                };
	                try {
	                    service.onRequest(_this.internalSession, request, callback);
	                }
	                catch (e) {
	                    log.error(e);
	                    throw new Error("Unable to handle request for service " + definition.id);
	                }
	            };
	        }
	        else {
	            throw new Error("Service already exists for service " + definition.id);
	        }
	    };
	    /**
	     * Checks whether a service is already registered.
	     */
	    ServiceAdapter.prototype.isServiceRegistered = function (serviceId) {
	        // tslint:disable-next-line:strict-type-predicates
	        return (this.listeners[serviceId] !== undefined);
	    };
	    /**
	     * Callback function to handle inbound command messages to be routed to appropriate
	     * handlers.
	     *
	     * @param modes  the service message mode.
	     * @param data   the input stream to read from.
	     * @throws       an Error if parsed CommandHeader is invalid
	     */
	    ServiceAdapter.prototype.onMessage = function (modes, data) {
	        switch (modes) {
	            case message_1.types.SERVICE_REQUEST:
	                this.handleRequest(command_header_serialiser_1.CommandHeaderSerialiser.read(data), data);
	                break;
	            case message_1.types.SERVICE_RESPONSE:
	                this.handleResponse(conversation_id_serialiser_1.CIDSerialiser.read(data), data);
	                break;
	            case message_1.types.SERVICE_ERROR:
	                this.handleError(conversation_id_serialiser_1.CIDSerialiser.read(data), data);
	                break;
	            default:
	                throw new Error("Unknown Command Service message " + modes);
	        }
	    };
	    /**
	     * Handle an incoming request
	     *
	     * @param  header  the command header of the request
	     * @param  input   the stream containing the data of the request
	     */
	    ServiceAdapter.prototype.handleRequest = function (header, input) {
	        var listener = this.listeners[header.service];
	        if (listener) {
	            log.debug('Received command request for service: ' + header);
	            listener(header, input);
	        }
	        else {
	            log.error('Received command request for unknown service: ' + header);
	            this.sendError(header.createErrorHeader(), error_reason_2.ErrorReason.COMMUNICATION_FAILURE, "Unknown client service: " + header.service);
	        }
	    };
	    /**
	     * Handle a response coming back from the server
	     *
	     * @param  header  the command header of the response
	     * @param  input   the stream containing the data of the response
	     */
	    ServiceAdapter.prototype.handleResponse = function (cid, input) {
	        log.debug('Received command response: ' + cid);
	        this.internalSession.getConversationSet().respondIfPresent(cid, input);
	    };
	    /**
	     * Handle an error coming back from the server
	     *
	     * @param  header  the command header of the error
	     * @param  input   the stream containing the data of the error
	     */
	    ServiceAdapter.prototype.handleError = function (cid, input) {
	        var description = Codec.readString(input);
	        var code = Codec.readInt32(input);
	        var error = new error_reason_1.ErrorReason(code, description);
	        log.warn('Received command error', error);
	        this.internalSession.getConversationSet().discard(cid, error);
	    };
	    return ServiceAdapter;
	}());
	exports.ServiceAdapter = ServiceAdapter;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Client
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var command_header_1 = __webpack_require__(338);
	var logger = __webpack_require__(17);
	var log = logger.create('ServiceLocator');
	/**
	 * A class allowing to locate services and create {@link ServiceSender}s for them
	 */
	var ServiceLocatorImpl = /** @class */ (function () {
	    /**
	     * Create a new ServiceLocator instance
	     *
	     * @param internalSession  the internal session
	     * @param serialisers      the map of serialisers
	     * @param serviceAdapter   the service adapter
	     */
	    function ServiceLocatorImpl(context, serviceAdapter) {
	        this.context = context;
	        this.serviceAdapter = serviceAdapter;
	    }
	    /**
	     * Obtain a service from a service definition
	     *
	     * @param service  the service definition
	     * @return         a sender that allows to send requests for the service
	     */
	    ServiceLocatorImpl.prototype.obtain = function (service) {
	        var _this = this;
	        var requestSerialiser = service.request;
	        var responseSerialiser = service.response;
	        var reference = {
	            send: function (req, callback) {
	                if (callback === void 0) { callback = function () { }; }
	                return __awaiter(_this, void 0, void 0, function () {
	                    var handler, conversations, conversationId;
	                    var _this = this;
	                    return __generator(this, function (_a) {
	                        switch (_a.label) {
	                            case 0:
	                                handler = {
	                                    onOpen: function (cid) {
	                                        var header = new command_header_1.CommandHeader(service.id, cid);
	                                        try {
	                                            _this.serviceAdapter.sendRequest(header, req, requestSerialiser);
	                                        }
	                                        catch (e) {
	                                            callback(e);
	                                            throw e;
	                                        }
	                                    },
	                                    onResponse: function (cid, input) {
	                                        var response;
	                                        try {
	                                            response = responseSerialiser.read(input);
	                                        }
	                                        catch (e) {
	                                            log.debug("Failed to deserialise response from service " + service.id, e.stack);
	                                            callback(e);
	                                            return true;
	                                        }
	                                        try {
	                                            callback(null, response);
	                                        }
	                                        catch (e) {
	                                            log.debug("Request callback for service '" + service.id + "' threw an error", e.stack);
	                                            try {
	                                                callback(e);
	                                            }
	                                            catch (e) {
	                                                log.debug("Failed to notify callback error for service '" + service.id + "'", e);
	                                            }
	                                        }
	                                        return true;
	                                    },
	                                    onDiscard: function (cid, err) {
	                                        callback(err);
	                                    }
	                                };
	                                conversations = this.context.getConversationSet();
	                                return [4 /*yield*/, conversations.newConversation(handler)];
	                            case 1:
	                                conversationId = _a.sent();
	                                return [2 /*return*/, function () {
	                                        conversations.discard(conversationId, new Error('Cancelled'));
	                                    }];
	                        }
	                    });
	                });
	            }
	        };
	        return reference;
	    };
	    return ServiceLocatorImpl;
	}());
	exports.ServiceLocatorImpl = ServiceLocatorImpl;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_reason_1 = __webpack_require__(88);
	var topic_specification_1 = __webpack_require__(238);
	var topic_type_1 = __webpack_require__(69);
	var topics_1 = __webpack_require__(148);
	var close_reason_1 = __webpack_require__(491);
	var abstract_datatype_1 = __webpack_require__(144);
	var datatypes_1 = __webpack_require__(78);
	var time_series_event_datatype_1 = __webpack_require__(179);
	var topic_selector_parser_1 = __webpack_require__(344);
	/**
	 * The context sharing core datatypes and enums with the features. In the
	 * modular client, this constant is packaged with the core diffusion
	 * package.
	 */
	exports.sessionContext = {
	    ErrorReason: error_reason_1.ErrorReason,
	    TopicTypeEnum: topic_type_1.TopicTypeEnum,
	    TopicAddFailReasonEnum: topics_1.TopicAddFailReasonEnum,
	    TopicSpecification: topic_specification_1.TopicSpecification,
	    TimeSeriesEventDataType: time_series_event_datatype_1.TimeSeriesEventDataType,
	    DataTypes: datatypes_1.DataTypes,
	    AbstractDataType: abstract_datatype_1.AbstractDataType,
	    parseSelector: topic_selector_parser_1.parseSelector,
	    CloseReason: close_reason_1.CloseReasonImpl
	};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Conversation
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var _this = this;
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_1 = __webpack_require__(124);
	var logger = __webpack_require__(17);
	var Long = __webpack_require__(44);
	/**
	 * A generator for creating sequential conversation IDs across an arbitrary
	 * number of conversation sets.
	 */
	var NEXT_CID = (function () {
	    var id = new Long(0);
	    return function () { return __awaiter(_this, void 0, void 0, function () {
	        return __generator(this, function (_a) {
	            id = id.add(1);
	            return [2 /*return*/, new conversation_id_1.ConversationId(id)];
	        });
	    }); };
	})();
	exports.ConversationIdGenerator = NEXT_CID;
	/**
	 * The result code when calling {@link Conversation.respond} indicating
	 * how the response has been handled by the conversation.
	 */
	var Result;
	(function (Result) {
	    Result[Result["ALREADY_FINISHED"] = 0] = "ALREADY_FINISHED";
	    Result[Result["HANDLED_AND_ACTIVE"] = 1] = "HANDLED_AND_ACTIVE";
	    Result[Result["HANDLED_AND_FINISHED"] = 2] = "HANDLED_AND_FINISHED";
	})(Result = exports.Result || (exports.Result = {}));
	var LOG = logger.create('Conversation Set');
	/**
	 * An error thrown when no conversation could be found
	 */
	var NoSuchConversationError = /** @class */ (function (_super) {
	    __extends(NoSuchConversationError, _super);
	    function NoSuchConversationError(message) {
	        var _this = _super.call(this, message) || this;
	        _this.name = 'NoSuchConversationError';
	        return _this;
	    }
	    return NoSuchConversationError;
	}(Error));
	exports.NoSuchConversationError = NoSuchConversationError;
	/**
	 * Internal Conversation implementation. Maintains state for a provided
	 * conversation handler to ensure recursive operations remain in-order.
	 *
	 * @param {Object} handler the conversation handler to dispatch events to.
	 * @constructor
	 */
	var Conversation = /** @class */ (function () {
	    /**
	     * Create a new conversation
	     *
	     * @param handler                 the response handler
	     * @param completedExceptionally  a callback to call when the conversation
	     *                                completed exceptionally
	     */
	    function Conversation(handler, completedExceptionally) {
	        /**
	         * A flag inticating a reserved state to prevent recursive discards
	         */
	        this.reserved = false;
	        /**
	         * A flag indicating that the conversation is closed
	         */
	        this.closed = false;
	        this.handler = handler;
	        this.completedExceptionally = completedExceptionally;
	    }
	    /**
	     * Open the conversation
	     *
	     * @param cid      the conversation ID
	     */
	    Conversation.prototype.open = function (cid) {
	        this.handler.onOpen(cid);
	    };
	    /**
	     * Send a response to the handler.
	     *
	     * @param  cid      the conversation ID
	     * @param  response the response
	     * @return          the result code indicating how the response has been
	     *                  handled
	     */
	    Conversation.prototype.respond = function (cid, response) {
	        if (this.closed) {
	            return Result.ALREADY_FINISHED;
	        }
	        // set as reserved so as to prevent recursive discards
	        var previous = this.reserved;
	        this.reserved = true;
	        var close;
	        try {
	            close = this.handler.onResponse(cid, response);
	        }
	        catch (e) {
	            this.completedExceptionally(cid, this, e);
	            throw e;
	        }
	        if (this.closed) {
	            LOG.debug('Conversation already closed', cid);
	            return Result.HANDLED_AND_FINISHED;
	        }
	        else if (close) {
	            LOG.debug('Response handler closed conversation', cid);
	            this.closed = true;
	            return Result.HANDLED_AND_FINISHED;
	        }
	        else if (this.pendingDiscard) {
	            LOG.debug('Conversation closed with pending reason', cid);
	            this.notifyDiscard(cid, this.pendingDiscard);
	            return Result.HANDLED_AND_FINISHED;
	        }
	        else {
	            this.reserved = previous;
	            return Result.HANDLED_AND_ACTIVE;
	        }
	    };
	    /**
	     * Discard the conversation unless it is already finished.
	     *
	     * @param cid      the conversation ID to discard
	     * @param reason   why the conversation was discarded
	     */
	    Conversation.prototype.discard = function (cid, reason) {
	        if (this.reserved) {
	            this.pendingDiscard = reason;
	        }
	        else {
	            this.notifyDiscard(cid, reason);
	        }
	    };
	    /**
	     * Close the conversation
	     */
	    Conversation.prototype.close = function () {
	        this.closed = true;
	    };
	    /**
	     * Close the conversation and notify the handler
	     *
	     * @param cid      the conversation ID to close
	     * @param reason   why the conversation was closed
	     */
	    Conversation.prototype.notifyDiscard = function (cid, reason) {
	        if (!this.closed) {
	            this.closed = true;
	            try {
	                this.handler.onDiscard(cid, reason);
	            }
	            catch (e) {
	                LOG.error('Application handler threw exception [cid=' + cid + ']', e.stack);
	                throw e;
	            }
	        }
	    };
	    return Conversation;
	}());
	/**
	 * Manage a set of conversations. The conversations usually relate to a single
	 * peer.
	 *
	 * <p>
	 * This class doesn't provide any communication methods itself, it simply tracks
	 * the state associated with a conversation.
	 *
	 * A conversation can be created with {@link newConversation}, which returns a
	 * unique ID that can be serialised, and later used to refer to the
	 * conversation. Each conversation is associated with a caller-supplied
	 * `ResponseHandler`. The `ResponseHandler` receives a sequence of
	 * callbacks for the conversation according to a well-defined life cycle,
	 * allowing it to manage the associated application state.
	 *
	 * If {@link respond} is called with the ID of an active conversation, the
	 * supplied response will be passed to {@link ResponseHandler.onResponse}. For
	 * every conversation, the response handler will receive an initial
	 * {@link ResponseHandler.onOpen} call, followed by one or more
	 * `onResponse` calls. If `onResponse` returns `true`, the
	 * conversation will be closed normally and no further calls will be made to the
	 * handler for that conversation. Returning `true` from `onResponse`
	 * is the only way to close a conversation normally (rather than discard it).
	 * This places the onus on the handler to determine when the conversation
	 * finishes normally, based on the received message and/or its own state.
	 *
	 * A conversation can be 'discarded' to close it in an abnormal fashion.
	 * {@link discardAll} discards all of the conversations owned by
	 * this conversation set. Once called, this conversation set enters a
	 * 'discarded' state, and new conversations will be discarded immediately after
	 * they are opened. Individual conversations can be discarded with
	 * {@link discard}. Whichever method is used to
	 * discard a conversation, {@link ResponseHandler.onDiscard} will be the final
	 * call to the handler for that conversation.
	 *
	 * <p>
	 * Finally, if {@link ResponseHandler.onOpen} or
	 * {@link ResponseHandler.onResponse} throws an exception, the conversation will
	 * complete exceptionally. The exception is logged at debug level and re-thrown.
	 *
	 * <p>
	 * The ways a conversation can close are summarised in the following table.
	 * <table>
	 * <tr>
	 * <th>Cause</th>
	 * <th>Close type</th>
	 * <th>How close is reported</th>
	 * </tr>
	 * <tr>
	 * <td>`ResponseHandler.onResponse()` returns true</td>
	 * <td>Closed normally</td>
	 * <td>Not reported</td>
	 * </tr>
	 * <tr>
	 * <td>`ResponseHandler.onOpen()` throws exception</td>
	 * <td>Closed exceptionally</td>
	 * <td>Exception is re-thrown to caller of `newConversation()`.<br/>
	 * Debug log message</td>
	 * </tr>
	 * <tr>
	 * <td>`ResponseHandler.onResponse()` throws exception</td>
	 * <td>Closed exceptionally</td>
	 * <td>Exception is re-thrown to caller of `respond()`.<br/>
	 * Debug log message</td>
	 * </tr>
	 * <tr>
	 * <td>`discard()`<br/>
	 * `discardAll()`</td>
	 * <td>Discarded</td>
	 * <td>`ResponseHandler.onDiscard()` is called.</td>
	 * </tr>
	 * </table>
	 */
	var ConversationSet = /** @class */ (function () {
	    /**
	     * Create a conversation set
	     *
	     * @param idGenerator  the generator function for conversation ID
	     */
	    function ConversationSet(idGenerator) {
	        this.nextCID = idGenerator;
	        this.conversations = {};
	    }
	    /**
	     *  Complete a conversation exceptionally.
	     *
	     * @param cid          the conversation ID
	     * @param conversation the conversation
	     * @param error        the error that caused the exception
	     */
	    ConversationSet.prototype.completedExceptionally = function (cid, conversation, e) {
	        LOG.debug('Application handler threw exception [cid=' + cid + ']', e.stack);
	        conversation.close();
	        delete this.conversations[cid.toString()];
	    };
	    /**
	     * Open a new conversation.
	     *
	     * @param responseHandler the response handler
	     * @return                the ID that can be used to refer to the
	     *                        conversation.
	     */
	    ConversationSet.prototype.newConversation = function (responseHandler) {
	        return __awaiter(this, void 0, void 0, function () {
	            var conversation, cid;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        conversation = new Conversation(responseHandler, this.completedExceptionally.bind(this));
	                        return [4 /*yield*/, this.nextCID()];
	                    case 1:
	                        cid = _a.sent();
	                        this.conversations[cid.toString()] = conversation;
	                        try {
	                            conversation.open(cid);
	                        }
	                        catch (e) {
	                            this.completedExceptionally(cid, conversation, e);
	                            throw e;
	                        }
	                        if (this.discardReason !== undefined) {
	                            this.discard(cid, this.discardReason);
	                        }
	                        return [2 /*return*/, cid];
	                }
	            });
	        });
	    };
	    /**
	     * Notify the handler of a response.
	     *
	     * @param cid      the conversation ID
	     * @param response the response
	     * @throws an error if the conversation is not found
	     */
	    ConversationSet.prototype.respond = function (cid, response) {
	        var conversation = this.conversations[cid.toString()];
	        /* tslint:disable-next-line:strict-type-predicates */
	        if (conversation === undefined) {
	            LOG.debug("No conversation for cid: " + cid + ", response: ", response);
	            throw new NoSuchConversationError('No such conversation');
	        }
	        var result = conversation.respond(cid, response);
	        switch (result) {
	            case Result.ALREADY_FINISHED:
	                throw new NoSuchConversationError('No such conversation');
	            case Result.HANDLED_AND_ACTIVE:
	                break;
	            default:
	                delete this.conversations[cid.toString()];
	        }
	    };
	    /**
	     * Variant of {@link respond} that does nothing if there is no open
	     * conversation with the given ID.
	     *
	     * @param cid      the conversation ID
	     * @param response the response
	     */
	    ConversationSet.prototype.respondIfPresent = function (cid, response) {
	        try {
	            this.respond(cid, response);
	        }
	        catch (e) {
	            if (e.name !== 'NoSuchConversationError') {
	                throw e;
	            }
	        }
	    };
	    /**
	     * Discard the specified conversation.
	     *
	     * This method will discard the conversation specified by the provided ID,
	     * notifying the corresponding handler's {@link ResponseHandler.onDiscard}
	     * method.
	     *
	     * Subsequent calls to this method have no effect.
	     *
	     * If there is no conversation with the given id, this method has no effect.
	     *
	     * @param cid      the conversation ID to discard
	     * @param reason   why the conversation was discarded
	     */
	    ConversationSet.prototype.discard = function (cid, reason) {
	        var conversation = this.conversations[cid.toString()];
	        delete this.conversations[cid.toString()];
	        if (conversation) {
	            conversation.discard(cid, reason);
	        }
	    };
	    /**
	     * Discard all conversations in this set.
	     *
	     * When this method returns, all current conversations will have been
	     * discarded, notifying their corresponding handlers, and new conversations
	     * will be discarded immediately. Calling {@link newConversation} will
	     * immediately call the supplied handler's
	     * {@link ResponseHandler.onDiscard}.
	     *
	     * Subsequent calls to this method have no effect.
	     * @param reason why the conversation set was discarded
	     */
	    ConversationSet.prototype.discardAll = function (reason) {
	        var e_1, _a;
	        if (this.discardReason !== undefined) {
	            return;
	        }
	        this.discardReason = reason;
	        try {
	            for (var _b = __values(Object.keys(this.conversations)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var cid = _c.value;
	                this.discard(conversation_id_1.ConversationId.fromString(cid), reason);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    /**
	     * Get the size of the conversation set
	     *
	     * @return the number of conversations that have been created
	     *      and not discarded
	     */
	    ConversationSet.prototype.size = function () {
	        return Object.keys(this.conversations).length;
	    };
	    return ConversationSet;
	}());
	exports.ConversationSet = ConversationSet;
	/**
	 * Factory function to create a new conversation set
	 *
	 * @return a new conversation set
	 */
	function create() {
	    return new ConversationSet(NEXT_CID);
	}
	exports.create = create;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var tokeniser_1 = __webpack_require__(324);
	var buffer_slice_1 = __webpack_require__(229);
	/**
	 * Implementation of the {@link BinaryDelta} interface.
	 */
	var BinaryDeltaImpl = /** @class */ (function (_super) {
	    __extends(BinaryDeltaImpl, _super);
	    /**
	     * Create a new BinaryDeltaImpl
	     *
	     * @param  buffer  the buffer that contains the delta as CBOR data
	     * @param  offset  the offset of the data in the buffer representing the delta
	     * @param  length  the number of the data in the buffer representing the delta
	     */
	    function BinaryDeltaImpl(buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        return _super.call(this, buffer, offset, length) || this;
	    }
	    /**
	     * Parse the delta as CBOR tokens and let the visitor handle them
	     *
	     * @param  visitor  the visitor to handle the tokens
	     */
	    BinaryDeltaImpl.prototype.visit = function (visitor) {
	        if (this.hasChanges()) {
	            var tokeniser = new tokeniser_1.Tokeniser(this.$buffer, this.$offset, this.$length);
	            while (tokeniser.hasRemaining()) {
	                var token = tokeniser.nextToken();
	                var isEnd = false;
	                if (Buffer.isBuffer(token.value)) {
	                    isEnd = !visitor.insert(token.value);
	                }
	                else {
	                    var start = token.value;
	                    var end = tokeniser.nextToken().value;
	                    isEnd = !visitor.match(start, end);
	                }
	                if (isEnd) {
	                    visitor.end();
	                    return;
	                }
	            }
	            visitor.end();
	        }
	        else {
	            visitor.noChange();
	        }
	    };
	    /**
	     * Check if the binary delta has any changes
	     *
	     * @return `true` if the binary delta contains any data
	     */
	    BinaryDeltaImpl.prototype.hasChanges = function () {
	        return this.$length !== 1;
	    };
	    return BinaryDeltaImpl;
	}(buffer_slice_1.BufferSlice));
	exports.BinaryDeltaImpl = BinaryDeltaImpl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var binary_delta_type_impl_1 = __webpack_require__(228);
	var bytes_impl_1 = __webpack_require__(102);
	var function_1 = __webpack_require__(89);
	/**
	 * Create a new BinaryImpl object from a buffer or {@link BinaryImpl}. If a
	 * {@link BinaryImpl} is passed as argument it is simply returned.
	 *
	 * @param  value  the object to create a record from
	 * @return        the record created
	 * @throws        an error if an incompatible datatype was supplied
	 */
	function fromValue(value) {
	    // tslint:disable-next-line:no-use-before-declare
	    if (value instanceof BinaryImpl) {
	        return value;
	    }
	    else if (Buffer.isBuffer(value)) {
	        // tslint:disable-next-line:no-use-before-declare
	        return new BinaryImpl(value);
	    }
	    else {
	        throw new Error("Unable to read Binary value from: " + value);
	    }
	}
	/**
	 * Implementation of {@link Binary}
	 */
	var BinaryImpl = /** @class */ (function (_super) {
	    __extends(BinaryImpl, _super);
	    /**
	     * Create a new BinaryImpl instance
	     *
	     * @param  buffer  the internal buffer
	     * @param  offset  the offset of the slice
	     * @param  length  the number of bytes in the slice
	     */
	    function BinaryImpl(buffer, offset, length) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        return _super.call(this, buffer, offset, length) || this;
	    }
	    /**
	     * Return the name of the data type
	     *
	     * @return `BinaryImpl`
	     */
	    BinaryImpl.toString = function () {
	        return 'BinaryImpl';
	    };
	    /**
	     * Create a new BinaryImpl object from a buffer or {@link BinaryImpl}. If a
	     * {@link BinaryImpl} is passed as argument it is simply returned.
	     *
	     * @param  value  the object to create a record from
	     * @return        the record created
	     * @throws        an error if an incompatible datatype was supplied
	     */
	    BinaryImpl.from = function (value) {
	        return fromValue(value);
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryImpl.prototype.get = function () {
	        return this.asBuffer();
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryImpl.prototype.diff = function (original, type) {
	        // tslint:disable-next-line:no-use-before-declare
	        return BINARY_DELTA_TYPE.diff(original, this);
	    };
	    /**
	     * @inheritdoc
	     */
	    BinaryImpl.prototype.apply = function (delta) {
	        // tslint:disable-next-line:no-use-before-declare
	        return BINARY_DELTA_TYPE.apply(this, delta);
	    };
	    /**
	     * Convert the objet to a string
	     *
	     * @return  a string representation of the BinaryImpl
	     */
	    BinaryImpl.prototype.toString = function () {
	        return "Binary <" + this.$length + " bytes> " + this.get().toString();
	    };
	    return BinaryImpl;
	}(bytes_impl_1.BytesImpl));
	exports.BinaryImpl = BinaryImpl;
	/**
	 * A unique binary delta type instance to calculate deltas of {@link BinaryImpl}
	 */
	var BINARY_DELTA_TYPE = new binary_delta_type_impl_1.BinaryDeltaTypeImpl(BinaryImpl, fromValue, function_1.identity);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RecordV2Writer = __webpack_require__(500);
	/**
	 * Get the absolute index of a record in the schema
	 *
	 * @param  record  the record to inspect
	 * @param  records the array of records that contains the record
	 * @param  index   an index offset
	 * @return         the absolute index of the record in the schema
	 * @throws         a error if the index is not found
	 */
	function resolveRecordIndex(record, records, index) {
	    var actualIndex = record.getAbsoluteIndex(index);
	    if (actualIndex > records.length - 1) {
	        throw new Error("Index '" + index + "' does not have a matching entry for variable occurrence record: '" + record.name + "'");
	    }
	    return actualIndex;
	}
	exports.resolveRecordIndex = resolveRecordIndex;
	/**
	 * Get the absolute index of a field in the schema
	 *
	 * @param  field   the field to inspect
	 * @param  fields  the array of field that contains the record
	 * @param  index   an index offset
	 * @return         the absolute index of the field in the schema
	 * @throws         a error if the index is not found
	 */
	function resolveFieldIndex(field, fields, index) {
	    var actualIndex = field.getAbsoluteIndex(index);
	    if (actualIndex > fields.length - 1) {
	        throw new Error("Index '" + index + "' does not have a matching entry for variable occurrence field: '" + field.name + "'");
	    }
	    return actualIndex;
	}
	exports.resolveFieldIndex = resolveFieldIndex;
	/**
	 * Abstract base class for {@link RecordModelImpl} and {@link
	 * MutableRecordModelImpl}.
	 *
	 * This class implements all methods of the {@link RecordModel} interface but
	 * introduces the abstract {@link AbstractRecordModel.model model} method. *
	 */
	var AbstractRecordModel = /** @class */ (function () {
	    /**
	     * Create an AbstractRecordModel
	     *
	     * @param recordV2Constructor  a constructor function for creating {@link RecordV2} implementations
	     * @param schema               the schema that this model corresponds to
	     */
	    function AbstractRecordModel(recordV2Constructor, schema) {
	        this.recordV2Constructor = recordV2Constructor;
	        this.modelSchema = schema;
	    }
	    /**
	     * Get the schema that this model corresponds to
	     */
	    AbstractRecordModel.prototype.schema = function () {
	        return this.modelSchema;
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractRecordModel.prototype.asValue = function () {
	        return new this.recordV2Constructor(RecordV2Writer.toBuffer(this.model()));
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractRecordModel.prototype.get = function (recordName, recordIndexOrFieldName, fieldNameOrFieldIndex, fieldIndex) {
	        if (recordIndexOrFieldName === void 0) { recordIndexOrFieldName = 0; }
	        if (fieldIndex === void 0) { fieldIndex = 0; }
	        var fieldName;
	        var recordIndex;
	        switch (arguments.length) {
	            case 1:
	                var key = this.parseKey(recordName);
	                recordName = key.recordName;
	                recordIndex = key.recordIndex;
	                fieldName = key.fieldName;
	                fieldIndex = key.fieldIndex;
	                break;
	            case 2:
	                fieldName = recordIndexOrFieldName;
	                recordIndex = 0;
	                break;
	            default:
	                fieldName = fieldNameOrFieldIndex;
	                recordIndex = recordIndexOrFieldName;
	        }
	        var schemaRecord = this.modelSchema.getRecord(recordName);
	        var schemaField = schemaRecord.getField(fieldName);
	        var record = this.getRecord(schemaRecord, recordIndex);
	        return record[resolveFieldIndex(schemaField, record, fieldIndex)];
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractRecordModel.prototype.recordCount = function (recordName) {
	        var schemaRecord = this.modelSchema.getRecord(recordName);
	        if (schemaRecord.isVariable) {
	            return this.model().length - schemaRecord.getIndex();
	        }
	        else {
	            return schemaRecord.min;
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    AbstractRecordModel.prototype.fieldCount = function (recordName, recordIndex, fieldName) {
	        var schemaRecord = this.modelSchema.getRecord(recordName);
	        var schemaField = schemaRecord.getField(fieldName);
	        if (schemaField.isVariable) {
	            var record = this.getRecord(schemaRecord, recordIndex);
	            return record.length - schemaField.getIndex();
	        }
	        else {
	            return schemaField.min;
	        }
	    };
	    /**
	     * Get the model data for a record
	     *
	     * @param schemaRecord  the record for which to get the data
	     * @param index         the index of the record
	     * @return              model data of the record
	     */
	    AbstractRecordModel.prototype.getRecord = function (schemaRecord, index) {
	        var model = this.model();
	        return model[resolveRecordIndex(schemaRecord, model, index)];
	    };
	    /**
	     * Convert a textual representation of a record entry to a record key
	     *
	     * @param key  the key string
	     * @return     the parsed record key
	     */
	    AbstractRecordModel.prototype.parseKey = function (key) {
	        var parts = key.split('.', 2);
	        var recordName;
	        var recordIndex;
	        var fieldKey;
	        if (parts.length === 1) {
	            recordName = this.modelSchema.firstRecord().name;
	            recordIndex = 0;
	            fieldKey = parts[0];
	        }
	        else {
	            var recordKeyParts = this.parseKeyPart(parts[0].trim());
	            recordName = recordKeyParts[0];
	            recordIndex = recordKeyParts[1];
	            fieldKey = parts[1];
	        }
	        var keyParts = this.parseKeyPart(fieldKey);
	        return {
	            recordName: recordName,
	            recordIndex: recordIndex,
	            fieldName: keyParts[0],
	            fieldIndex: keyParts[1]
	        };
	    };
	    /**
	     * Parse the field name and index part of a record key
	     *
	     * @param  keyPart  the part of the key containing the field name and index
	     * @return          an array containing the field name and the field index
	     */
	    AbstractRecordModel.prototype.parseKeyPart = function (keyPart) {
	        if (keyPart.length === 0) {
	            throw new Error('No name specified');
	        }
	        var openIndex = keyPart.indexOf('(');
	        if (openIndex === -1) {
	            return [keyPart, 0];
	        }
	        if (openIndex === 0) {
	            throw new Error('No name specified');
	        }
	        var closeIndex = keyPart.indexOf(')');
	        if (closeIndex === -1 || closeIndex < openIndex) {
	            throw new Error('\'(\' found without closing \')');
	        }
	        if (closeIndex < keyPart.length - 1) {
	            throw new Error('Characters found after closing \')');
	        }
	        return [keyPart.substring(0, openIndex), parseInt(keyPart.substring(openIndex + 1, closeIndex), 10)];
	    };
	    return AbstractRecordModel;
	}());
	exports.AbstractRecordModel = AbstractRecordModel;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var recordv2_utils_1 = __webpack_require__(231);
	/**
	 * Parse a buffer of Record V2 data and split it into records and fields
	 *
	 * @param  bytes   the buffer to parse
	 * @param  offset  the starting position in the buffer
	 * @param  length  the number of bytes to convert
	 * @return         an array of records, each containing an array of fields
	 */
	function parse(bytes, offset, length) {
	    if (offset === void 0) { offset = 0; }
	    if (length === void 0) { length = bytes.length; }
	    // empty bytes returns empty record list
	    if (length === 0) {
	        return [];
	    }
	    // record MU returns single empty record
	    if (length === 1 && bytes[offset] === recordv2_utils_1.RECORD_MU) {
	        return [[]];
	    }
	    // process all records
	    var records = [];
	    var fields = [];
	    var pos = offset;
	    for (var i = offset; i < length; ++i) {
	        if (bytes[i] === recordv2_utils_1.RECORD_DELIMITER) {
	            processRecordDelimiter(bytes, records, pos, i, fields);
	            pos = i + 1;
	        }
	        else if (bytes[i] === recordv2_utils_1.FIELD_DELIMITER) {
	            addField(bytes, records, pos, i, fields);
	            pos = i + 1;
	        }
	    }
	    processEnd(bytes, records, pos, length, fields);
	    return records;
	}
	exports.parse = parse;
	/**
	 * Process a record delimiter
	 *
	 * @param  bytes     the buffer to parse
	 * @param  records   a reference to the records that will be constructed. A
	 *                   new record will be added to this array.
	 * @param  startPos  the start position in the buffer of the last field
	 * @param  endPos    the end position in the buffer of the last field
	 * @param  field     a reference to the fields that are being constructed for
	 *                   this record. A new field will be added to this array before
	 *                   this array will be added to the records.
	 */
	function processRecordDelimiter(bytes, records, startPos, endPos, fields) {
	    var written = false;
	    // if we have a field add it to list
	    if (startPos < endPos) {
	        written = addField(bytes, records, startPos, endPos, fields);
	    }
	    else {
	        // buf if we're not at the start of content && the last delimiter was for a field
	        // it implies an empty field
	        if (startPos > 0 && bytes[startPos - 1] === recordv2_utils_1.FIELD_DELIMITER) {
	            fields.push('');
	        }
	    }
	    if (!written) {
	        records.push(Array.from(fields));
	    }
	    // clear fields array
	    fields.length = 0;
	}
	/**
	 * Process the end of the record data
	 *
	 * @param  bytes     the buffer to parse
	 * @param  records   a reference to the records that will be constructed. A
	 *                   new record will be added to this array.
	 * @param  startPos  the start position in the buffer of the last field
	 * @param  endPos    the end position in the buffer of the last field
	 * @param  field     a reference to the fields that are being constructed for
	 *                   this record. A new field will be added to this array before
	 *                   this array will be added to the records.
	 */
	function processEnd(bytes, records, startPos, endPos, fields) {
	    // if we have read something then add to fields
	    if (endPos > startPos) {
	        addField(bytes, records, startPos, endPos, fields);
	    }
	    else {
	        // nothing at end so process possible final delimiter
	        var endByte = bytes[endPos - 1];
	        if (endByte === recordv2_utils_1.RECORD_DELIMITER) {
	            // a record delimiter at the end implies a final empty record
	            records.push([]);
	        }
	        else if (endByte === recordv2_utils_1.FIELD_DELIMITER) {
	            // a field delimiter implies an empty field
	            fields.push('');
	        }
	    }
	    // if we have some fields add record. This is not the case if
	    // the last thing read was a record delimiter or start of content
	    if (fields.length) {
	        records.push(Array.from(fields));
	    }
	}
	/**
	 * Add a field to the array of fields
	 *
	 * @param  bytes     the buffer to parse
	 * @param  records   a reference to the records that will be constructed.
	 * @param  startPos  the start position in the buffer of the last field
	 * @param  endPos    the end position in the buffer of the last field
	 * @param  field     a reference to the fields that are being constructed for
	 *                   this record. A new field will be added to this array.
	 * @return           `true` if the fields have been added to the records.
	 */
	function addField(bytes, records, startPos, endPos, fields) {
	    var len = endPos - startPos;
	    if (fields.length === 0 && len === 1 && bytes[startPos] === recordv2_utils_1.FIELD_MU) {
	        records.push(['']);
	        return true;
	    }
	    else {
	        fields.push(bytes.toString('utf8', startPos, endPos));
	    }
	    return false;
	}


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var recordv2_utils_1 = __webpack_require__(231);
	var buffer_output_stream_1 = __webpack_require__(80);
	/**
	 * Write record data to an output stream
	 *
	 * @param  records  the records to write
	 * @param  out      the output stream to write into
	 */
	function write(records, out) {
	    if (records.length === 0) {
	        return;
	    }
	    if (records.length === 1 && records[0].length === 0) {
	        out.write(recordv2_utils_1.RECORD_MU);
	        return;
	    }
	    var mustWriteRecordDelimiter = false;
	    records.forEach(function (record) {
	        if (mustWriteRecordDelimiter) {
	            out.write(recordv2_utils_1.RECORD_DELIMITER);
	        }
	        else {
	            mustWriteRecordDelimiter = true;
	        }
	        if (record.length === 1 && record[0] === '') {
	            out.write(recordv2_utils_1.FIELD_MU);
	        }
	        else {
	            var mustWriteFieldDelimiter_1 = false;
	            record.forEach(function (field) {
	                if (mustWriteFieldDelimiter_1) {
	                    out.write(recordv2_utils_1.FIELD_DELIMITER);
	                }
	                else {
	                    mustWriteFieldDelimiter_1 = true;
	                }
	                /* tslint:disable-next-line:strict-type-predicates */
	                if (field !== undefined && field !== null) {
	                    out.writeMany(Buffer.from(field));
	                }
	            });
	        }
	    });
	}
	exports.write = write;
	/**
	 * Write record data to a buffer
	 *
	 * @param  records  the records to write
	 * @return          the buffer containing the serialised data
	 */
	function toBuffer(records) {
	    var bos = new buffer_output_stream_1.BufferOutputStream();
	    write(records, bos);
	    return bos.getBuffer();
	}
	exports.toBuffer = toBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A Record V2 record schema entry
	 */
	var RecordImpl = /** @class */ (function () {
	    /**
	     * Create a new record
	     *
	     * @param  name    the name of the record
	     * @param  min     the minimum index that this record can assume
	     * @param  max     the maximum index that this record can assume
	     * @param  index   the index of the record
	     * @param  fields  an array of fields contained in this record
	     */
	    function RecordImpl(name, min, max, index, fields) {
	        var _this = this;
	        this.name = name;
	        this.min = min;
	        this.max = max;
	        this.index = index;
	        this.isVariable = min !== max;
	        this.fields = fields;
	        this.fieldsMap = {};
	        fields.forEach(function (field) {
	            _this.fieldsMap[field.name] = field;
	        });
	    }
	    /**
	     * Get a copy of the internal fields array
	     *
	     * @return an array of fields
	     */
	    RecordImpl.prototype.getFields = function () {
	        return [].concat(this.fields);
	    };
	    /**
	     * Get a field by its name
	     *
	     * @param fieldName  the name of the field to get
	     * @return           the field with the given name
	     * @throws           an error if no field with that name exists
	     */
	    RecordImpl.prototype.getField = function (fieldName) {
	        var field = this.fieldsMap[fieldName];
	        if (field) {
	            return field;
	        }
	        throw new Error("Record '" + this.name + "' has no field named '" + fieldName + "'");
	    };
	    /**
	     * Get the last field in the array
	     *
	     * @return the field with the last index in the fields array
	     */
	    RecordImpl.prototype.lastField = function () {
	        return this.fields[this.fields.length - 1];
	    };
	    /**
	     * Create a model representation of this record schema.
	     *
	     * @return  an array of model string representations for each field in the record
	     */
	    RecordImpl.prototype.createModel = function () {
	        var fields = [];
	        this.fields.forEach(function (field) {
	            for (var i = 0; i < field.min; ++i) {
	                fields.push(field.modelValue());
	            }
	        });
	        return fields;
	    };
	    /**
	     * Calculate the absolute index of the record
	     *
	     * @param  index  the index offset
	     * @return        the absolute index
	     * @throws        an error if the index offset is out of range
	     */
	    RecordImpl.prototype.getAbsoluteIndex = function (index) {
	        if (index < 0 || this.max !== -1 && index > this.max - 1) {
	            throw new Error("Invalid index '" + index + "' for record '" + this.name + "'");
	        }
	        return this.index + index;
	    };
	    /**
	     * Convert the record schema to a string
	     *
	     * @return  a string representation of the field
	     */
	    RecordImpl.prototype.toString = function () {
	        var ret = "Name=" + this.name;
	        if (this.min === this.max) {
	            ret += ", Occurs=" + this.min;
	        }
	        else {
	            ret += ", Min=" + this.min + ", Max=";
	            if (this.max === -1) {
	                ret += 'Unlimited';
	            }
	            else {
	                ret += this.max;
	            }
	        }
	        ret += ", Fields=" + this.fields;
	        return "Record [" + ret + "]";
	    };
	    return RecordImpl;
	}());
	exports.RecordImpl = RecordImpl;
	/**
	 * Convert the record schema to a raw data object
	 *
	 * @return        a data object that can be serialised with using JSON
	 */
	function toJSON(record) {
	    return {
	        fields: record.fields.map(function (f) { return f.toJSON(); }),
	        name: record.name,
	        min: record.min,
	        max: record.max
	    };
	}
	exports.toJSON = toJSON;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var field_impl_1 = __webpack_require__(331);
	var record_impl_1 = __webpack_require__(501);
	var schema_impl_1 = __webpack_require__(1184);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Check if `min` and `max` values specify a valid multiplicity
	 *
	 * @param  name  the name of the Field or Record to check
	 * @param  min   the minimum number of times the field should occur within the record
	 * @param  max   the maximum number of times the field should occur within the record
	 * @throws       an error if `min` and `max` values specify an invalid multiplicity
	 */
	function checkMultiplicity(name, min, max) {
	    if (min < 0) {
	        throw new Error("'" + name + "' has invalid 'min' value '" + min + "'");
	    }
	    if (max !== -1 && (max < 1 || max < min)) {
	        throw new Error("'" + name + "' has invalid 'max' value '" + max + "'");
	    }
	}
	/**
	 * Check if `scale` values specify a valid multiplicity
	 *
	 * @param  name  the name of the Field
	 * @param  scale the scale of the field (number of decimal places). This must be positive.
	 * @throws       an error if `scale<1`
	 */
	function checkScale(name, scale) {
	    if (scale < 1) {
	        throw new Error("'" + name + "' has invalid 'scale' value '" + scale + "'");
	    }
	}
	/**
	 * Implementation of the {@link SchemaBuilder} interface
	 */
	var SchemaBuilderImpl = /** @class */ (function () {
	    /**
	     * Create a SchemaBuilderImpl
	     *
	     * @param recordV2Constructor  a constructor function for creating {@link RecordV2} implementations
	     */
	    function SchemaBuilderImpl(recordV2Constructor) {
	        /**
	         * The records that have been added to the schema
	         */
	        this.records = [];
	        this.recordV2Constructor = recordV2Constructor;
	    }
	    /**
	     * @inheritdoc
	     */
	    SchemaBuilderImpl.prototype.record = function (name, min, max) {
	        if (min === void 0) { min = 1; }
	        if (max === void 0) { max = min; }
	        checkMultiplicity(name, min, max);
	        this.checkRecord(name);
	        if (this.currentFields !== undefined) {
	            this.addRecord();
	        }
	        this.currentName = name;
	        this.currentMin = min;
	        this.currentMax = max;
	        this.currentFields = [];
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaBuilderImpl.prototype.string = function (name, min, max) {
	        if (min === void 0) { min = 1; }
	        if (max === void 0) { max = min; }
	        checkMultiplicity(name, min, max);
	        this.checkField(name);
	        this.currentFields.push(new field_impl_1.FieldImpl(name, field_impl_1.Type.STRING, min, max, this.fieldIndex()));
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaBuilderImpl.prototype.integer = function (name, min, max) {
	        if (min === void 0) { min = 1; }
	        if (max === void 0) { max = min; }
	        checkMultiplicity(name, min, max);
	        this.checkField(name);
	        this.currentFields.push(new field_impl_1.FieldImpl(name, field_impl_1.Type.INTEGER, min, max, this.fieldIndex()));
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaBuilderImpl.prototype.decimal = function (name, scale, min, max) {
	        if (min === void 0) { min = 1; }
	        if (max === void 0) { max = min; }
	        checkMultiplicity(name, min, max);
	        checkScale(name, scale);
	        this.checkField(name);
	        this.currentFields.push(new field_impl_1.FieldImpl(name, field_impl_1.Type.DECIMAL, min, max, this.fieldIndex(), scale));
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaBuilderImpl.prototype.build = function () {
	        if (this.currentFields !== undefined) {
	            this.addRecord();
	        }
	        if (this.records.length === 0) {
	            throw new Error('Schema has no records');
	        }
	        return new schema_impl_1.SchemaImpl(this.recordV2Constructor, this.records);
	    };
	    /**
	     * Get the index of the next field to be added
	     *
	     * @return  the current field index plus the current multiplicity
	     */
	    SchemaBuilderImpl.prototype.fieldIndex = function () {
	        var currentFields = this.currentFields;
	        if (currentFields.length === 0) {
	            return 0;
	        }
	        var lastField = currentFields[currentFields.length - 1];
	        return lastField.index + lastField.max;
	    };
	    /**
	     * Add the current record to the {@link SchemaBuilderImpl.records records} array
	     *
	     * @throws  an error if the current record contains no fields
	     */
	    SchemaBuilderImpl.prototype.addRecord = function () {
	        var currentFields = this.currentFields;
	        if (currentFields.length === 0) {
	            throw new Error("No fields specified for record: '" + this.currentName + "'");
	        }
	        var index;
	        if (this.records.length === 0) {
	            index = 0;
	        }
	        else {
	            var lastRecord = this.records[this.records.length - 1];
	            index = lastRecord.index + lastRecord.max;
	        }
	        this.records.push(new record_impl_1.RecordImpl(this.currentName, this.currentMin, this.currentMax, index, currentFields));
	    };
	    /**
	     * Check for duplicate record names or a record after a variable multiplicity record
	     *
	     * @param name  the record name
	     * @throws      an error if a record with that name cannot be added
	     */
	    SchemaBuilderImpl.prototype.checkRecord = function (name) {
	        var e_1, _a;
	        require_non_null_1.requireNonNull(name, 'name');
	        if (name === this.currentName) {
	            throw new Error("Duplicate record name: '" + name + "'");
	        }
	        if (this.records.length) {
	            try {
	                for (var _b = __values(this.records), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var record = _c.value;
	                    if (name === record.name) {
	                        throw new Error("Duplicate record name: '" + name + "'");
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        if (this.currentFields !== undefined && this.currentMin !== this.currentMax) {
	            throw new Error("Record '" + name + "' not allowed after variable multiplicity record: '" + this.currentName + "'");
	        }
	    };
	    /**
	     * Check for duplicate field names or a field after a variable multiplicity field
	     *
	     * @param name  the field name
	     * @throws      an error if a field with that name cannot be added
	     */
	    SchemaBuilderImpl.prototype.checkField = function (name) {
	        var e_2, _a;
	        require_non_null_1.requireNonNull(name, 'name');
	        if (this.currentFields === undefined) {
	            throw new Error("Cannot add field '" + name + "' as there is no current record");
	        }
	        if (this.currentFields.length) {
	            try {
	                for (var _b = __values(this.currentFields), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var field = _c.value;
	                    if (name === field.name) {
	                        throw new Error("Duplicate field name: '" + name + "'");
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	            var lastField = this.currentFields[this.currentFields.length - 1];
	            if (lastField.isVariable) {
	                throw new Error("Field '" + name + "' is not allowed after variable multiplicity field '" + lastField.name + "'");
	            }
	        }
	    };
	    return SchemaBuilderImpl;
	}());
	exports.SchemaBuilderImpl = SchemaBuilderImpl;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of {@link SessionPropertyValidation}
	 *
	 * @inheritdoc
	 */
	var SessionPropertyValidationImpl = /** @class */ (function () {
	    /**
	     * Create a SessionPropertyValidationImpl instance
	     *
	     * @param  type   the type of validation
	     */
	    function SessionPropertyValidationImpl(type) {
	        this.type = type;
	    }
	    return SessionPropertyValidationImpl;
	}());
	exports.SessionPropertyValidationImpl = SessionPropertyValidationImpl;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Quote any necessary characters within a string
	 *
	 * @param str  the string to escape
	 * @return     a quoted and escaped string
	 */
	function quoteAndEscape(str) {
	    var e_1, _a;
	    var escaped = '';
	    if (str.indexOf('\'') < 0 && str.indexOf('\\') < 0) {
	        escaped += str;
	    }
	    else {
	        try {
	            for (var str_1 = __values(str), str_1_1 = str_1.next(); !str_1_1.done; str_1_1 = str_1.next()) {
	                var c = str_1_1.value;
	                if (c === '\'' || c === '\\') {
	                    escaped += '\\';
	                }
	                escaped += c;
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (str_1_1 && !str_1_1.done && (_a = str_1.return)) _a.call(str_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	    return "'" + escaped + "'";
	}
	exports.quoteAndEscape = quoteAndEscape;
	/**
	 * Convert an array of strings to a single formatted string
	 *
	 * @param  stringSet  an array of strings
	 * @return        a string containing each string in quotes, concatenated and
	 *                surrounded by brackets
	 */
	function setToString(stringSet) {
	    return '[' + stringSet.map(quoteAndEscape).join(' ') + ']';
	}
	exports.setToString = setToString;
	/**
	 * Convert an array of permissions to a single formatted string
	 *
	 * @param  permissions  an array of permissions
	 * @return        a string containing the concatenated permissions,
	 *                surrounded by brackets
	 */
	function permissionsToString(permissions) {
	    return '[' + permissions.join(' ') + ']';
	}
	exports.permissionsToString = permissionsToString;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of {@link BranchMappingTable}.
	 */
	var BranchMappingTableImpl = /** @class */ (function () {
	    /**
	     * Constructor
	     *
	     * @param sessionTreeBranch the branch of the session tree to which this table is bound
	     * @param branchMappings the branch mappings
	     */
	    function BranchMappingTableImpl(sessionTreeBranch, branchMappings) {
	        this.sessionTreeBranch = sessionTreeBranch;
	        this.branchMappings = branchMappings;
	    }
	    /**
	     * @inheritdoc
	     */
	    BranchMappingTableImpl.prototype.getSessionTreeBranch = function () {
	        return this.sessionTreeBranch;
	    };
	    /**
	     * @inheritdoc
	     */
	    BranchMappingTableImpl.prototype.getBranchMappings = function () {
	        return this.branchMappings;
	    };
	    return BranchMappingTableImpl;
	}());
	exports.BranchMappingTableImpl = BranchMappingTableImpl;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var enumerize_1 = __webpack_require__(103);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Require that a number is defined and is not negative
	 *
	 * @param  i     the number to check
	 * @param  what  a description of the number to check
	 * @return       the number
	 * @throws       an error if the number is not defined or negative
	 */
	function requireNonNegative(i, what) {
	    if (i === undefined || i === null || i < 0) {
	        throw new Error(what + " is negative: " + i);
	    }
	    return i;
	}
	/**
	 * A point type
	 */
	var Type = /** @class */ (function () {
	    /**
	     * Create a Point Type
	     *
	     * @param   id              the type id
	     * @param   anchorOperator  a string describing where the point is anchored
	     * @param   spanOperator    a string describing the span of the point
	     * @param   unitsSuffix     the unit suffix
	     */
	    function Type(id, anchorOperator, spanOperator, unitsSuffix) {
	        this.id = id;
	        this.anchorOperator = anchorOperator;
	        this.spanOperator = spanOperator;
	        this.unitsSuffix = unitsSuffix;
	    }
	    return Type;
	}());
	exports.Type = Type;
	/**
	 * Enum like object of point types
	 */ // tslint:disable-next-line:variable-name
	exports.Types = {
	    ABSOLUTE_START: new Type(0, 'fromStart', 'toStart', ''),
	    ABSOLUTE_SEQUENCE: new Type(1, 'from', 'to', ''),
	    ABSOLUTE_TIME: new Type(2, 'from', 'to', ' ms'),
	    OFFSET_SEQUENCE: new Type(3, 'fromLast', 'untilLast', ''),
	    OFFSET_TIME: new Type(4, 'fromLast', 'untilLast', ' ms'),
	    NEXT_COUNT: new Type(5, null, 'next', ''),
	    NEXT_TIME: new Type(6, null, 'next', ' ms'),
	    PREVIOUS_COUNT: new Type(7, null, 'previous', ''),
	    PREVIOUS_TIME: new Type(8, null, 'previous', ' ms')
	};
	enumerize_1.enumerize(exports.Types);
	/**
	 * A point in a time series, either specified by the event number or a time
	 */
	var Point = /** @class */ (function () {
	    /**
	     * Create a Point instance
	     *
	     * @param  value  the point value
	     * @param  type   the point type
	     */
	    function Point(value, type) {
	        this.value = value;
	        this.type = type;
	    }
	    /**
	     * Create a new point that is anchored at an absolute position.
	     *
	     * @param sequence  the date or number at which the point is anchored
	     * @return          a new point
	     */
	    Point.at = function (sequence) {
	        if (sequence instanceof Date) {
	            return new Point(require_non_null_1.requireNonNull(sequence, 'Date').getTime(), exports.Types.ABSOLUTE_TIME);
	        }
	        return new Point(requireNonNegative(sequence, 'Sequence'), exports.Types.ABSOLUTE_SEQUENCE);
	    };
	    /**
	     * Get a start point
	     *
	     * @return  a unique instance of the start point
	     */
	    Point.atStart = function () {
	        /* tslint:disable-next-line:no-use-before-declare */
	        return START_POINT;
	    };
	    /**
	     * Create a point with a sequence offset. The point refers to a position
	     * `count` events before the end of the sequence
	     *
	     * @oaram count  the sequence offset
	     * @return       a new point
	     */
	    Point.offset = function (count) {
	        return new Point(requireNonNegative(count, 'Count'), exports.Types.OFFSET_SEQUENCE);
	    };
	    /**
	     * Create a point with a time offset. The point refers to a position
	     * `timespan` milliseconds before the end of the sequence.
	     *
	     * @oaram count  the time offset in milliseconds
	     * @return       a new point
	     */
	    Point.offsetMillis = function (timespan) {
	        return new Point(requireNonNegative(timespan, 'Timespan'), exports.Types.OFFSET_TIME);
	    };
	    /**
	     * Create a point following a previous point by a number of events
	     *
	     * @oaram count  the number of events
	     * @return       a new point
	     */
	    Point.next = function (count) {
	        return new Point(requireNonNegative(count, 'Count'), exports.Types.NEXT_COUNT);
	    };
	    /**
	     * Create a point following a previous point by a time span
	     *
	     * @oaram timespan  the number of milliseconds
	     * @return          a new point
	     */
	    Point.nextMillis = function (timespan) {
	        return new Point(requireNonNegative(timespan, 'Timespan'), exports.Types.NEXT_TIME);
	    };
	    /**
	     * Create a point preceding another point by a number of events
	     *
	     * @oaram count  the number of events
	     * @return       a new point
	     */
	    Point.previous = function (count) {
	        return new Point(requireNonNegative(count, 'Count'), exports.Types.PREVIOUS_COUNT);
	    };
	    /**
	     * Create a point preceding another point by a time span
	     *
	     * @oaram timespan  the number of milliseconds
	     * @return          a new point
	     */
	    Point.previousMillis = function (timespan) {
	        return new Point(requireNonNegative(timespan, 'Timespan'), exports.Types.PREVIOUS_TIME);
	    };
	    /**
	     * Check if the Point is equal to another object
	     *
	     * @param  other the other object
	     * @return       `true` if the other object is a Point and is equal
	     */
	    Point.prototype.equals = function (other) {
	        if (other && other instanceof Point) {
	            return this.value === other.value &&
	                this.type === other.type;
	        }
	        return false;
	    };
	    return Point;
	}());
	exports.Point = Point;
	/**
	 * A unique start point
	 */
	var START_POINT = new Point(0, exports.Types.ABSOLUTE_START);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Protocol
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var buffer_input_stream_1 = __webpack_require__(125);
	var consts_1 = __webpack_require__(336);
	var response_code_1 = __webpack_require__(177);
	var BEES = __webpack_require__(25);
	var session_id_1 = __webpack_require__(127);
	var session_token_deserialiser_1 = __webpack_require__(1440);
	var logger_1 = __webpack_require__(17);
	var log = logger_1.create('Cascading');
	/**
	 * The reason for throwing an error when deserialising the connection response header
	 */
	var DeserialisationErrorReason;
	(function (DeserialisationErrorReason) {
	    /**
	     * The protocol byte was not recognised
	     */
	    DeserialisationErrorReason[DeserialisationErrorReason["UNRECOGNISED_PROTOCOL_BYTE"] = 0] = "UNRECOGNISED_PROTOCOL_BYTE";
	    /**
	     * The protocol versions do not match
	     */
	    DeserialisationErrorReason[DeserialisationErrorReason["PROTOCOL_VERSION_MISMATCH"] = 1] = "PROTOCOL_VERSION_MISMATCH";
	})(DeserialisationErrorReason = exports.DeserialisationErrorReason || (exports.DeserialisationErrorReason = {}));
	/**
	 * An error that is thrown when there was a problem deserialising the connection
	 * response header
	 */
	var DeserialisationError = /** @class */ (function (_super) {
	    __extends(DeserialisationError, _super);
	    /**
	     * Create the error
	     *
	     * @param  message  the error message
	     * @param  reason   the reason for the error
	     */
	    function DeserialisationError(message, reason) {
	        var _this = _super.call(this, message) || this;
	        _this.reason = reason;
	        return _this;
	    }
	    return DeserialisationError;
	}(Error));
	exports.DeserialisationError = DeserialisationError;
	/**
	 * Deserialise connection responses according to the V5 protocol.
	 *
	 * @param buffer  the Buffer to deserialise
	 */
	function deserialise(buffer) {
	    var input = new buffer_input_stream_1.BufferInputStream(buffer);
	    var protocol = input.read();
	    if (protocol !== consts_1.PROTOCOL.PROTOCOL_BYTE) {
	        throw new DeserialisationError('Unrecognised protocol byte: ' + protocol, DeserialisationErrorReason.UNRECOGNISED_PROTOCOL_BYTE);
	    }
	    var version = input.read();
	    if (version !== consts_1.PROTOCOL.CURRENT_VERSION) {
	        log.debug("Server responded with protocol version " + version + ". Client version is " + consts_1.PROTOCOL.CURRENT_VERSION + ".");
	        if (version < consts_1.PROTOCOL.CURRENT_VERSION) {
	            throw new DeserialisationError('Unrecognised protocol version: ' + version, DeserialisationErrorReason.PROTOCOL_VERSION_MISMATCH);
	        }
	        else if (version > consts_1.PROTOCOL.CURRENT_VERSION) {
	            throw new DeserialisationError('Unsupported protocol version: ' + version, DeserialisationErrorReason.PROTOCOL_VERSION_MISMATCH);
	        }
	    }
	    var responseCode = BEES.read(input, response_code_1.responseCodes);
	    if (response_code_1.isSuccess(responseCode)) {
	        // for some reason we serialise session ids as unsigned longs here
	        var sessionID = new session_id_1.SessionId(input.readUInt64(), input.readUInt64());
	        var sessionToken = session_token_deserialiser_1.readSessionToken(input);
	        var systemPingPeriod = input.readInt64();
	        var recoverySequence = 0;
	        var maximumMessageSize = -1;
	        if (responseCode === response_code_1.responseCodes.RECONNECTED) {
	            recoverySequence = input.readInt32();
	        }
	        else {
	            maximumMessageSize = input.readInt32();
	        }
	        return {
	            response: responseCode,
	            identity: sessionID,
	            token: sessionToken,
	            systemPingPeriod: systemPingPeriod,
	            version: version,
	            success: true,
	            sequence: recoverySequence,
	            maximumMessageSize: maximumMessageSize
	        };
	    }
	    else {
	        return {
	            response: responseCode,
	            version: version,
	            identity: null,
	            token: null,
	            systemPingPeriod: null,
	            success: false,
	            sequence: 0,
	            maximumMessageSize: -1
	        };
	    }
	}
	exports.deserialise = deserialise;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var buffer_slice_1 = __webpack_require__(229);
	var topic_cache_entry_1 = __webpack_require__(509);
	/**
	 * Implementation of {@link TopicCacheEntry} for topics with a given datatype
	 */
	var DatatypeCacheEntry = /** @class */ (function (_super) {
	    __extends(DatatypeCacheEntry, _super);
	    /**
	     * Create a new DatatypeCacheEntry instance
	     *
	     * @param streams        the stream adapters
	     * @param path           the topic path
	     * @param specification  the topic specification
	     * @param datatype       the data type of the entry
	     */
	    function DatatypeCacheEntry(streams, path, specification, datatype) {
	        var _this = _super.call(this, streams, path, specification) || this;
	        _this.datatype = datatype;
	        if (specification.properties) {
	            if (specification.properties.DONT_RETAIN_VALUE) {
	                _this.dontRetainValue = JSON.parse(specification.properties.DONT_RETAIN_VALUE);
	            }
	        }
	        return _this;
	    }
	    /**
	     * Handle a value
	     *
	     * Reads a value of the entry's data type and caches it. The calls {@link
	     * notifyValue}
	     *
	     * @param received      the content as a Buffer
	     * @param registry      the stream registry
	     * @param errorHandler  an error handler that will be called if an error occurs
	     */
	    DatatypeCacheEntry.prototype.handleValue = function (received, registry, errorHandler) {
	        var oldValue = this.value;
	        var oldContent = this.buffer || null;
	        try {
	            var newValue = this.datatype.readValue(received);
	            this.notifyValue(oldContent, received, oldValue, newValue, registry);
	            if (!this.dontRetainValue) {
	                this.value = newValue;
	                this.buffer = received;
	            }
	        }
	        catch (e) {
	            errorHandler(e);
	        }
	    };
	    /**
	     * Handle a delta
	     *
	     * Reads the delta of the entry's data type and caches it. The calls {@link
	     * notifyValue}
	     *
	     * @param received     the content as a Buffer
	     * @param registry     the stream registry
	     * @param notifyDelta  an error handler that will be called if an error occurs
	     */
	    DatatypeCacheEntry.prototype.handleDelta = function (received, registry, errorHandler) {
	        var oldValue = this.value;
	        var oldContent = this.buffer || null;
	        try {
	            var deltaType = this.datatype.deltaType('binary');
	            var delta = deltaType.readDelta(received);
	            var _a = deltaType.applyImpl(oldValue, delta, this.buffer ? new buffer_slice_1.BufferSlice(this.buffer) : undefined), value = _a.value, cbor = _a.cbor;
	            this.value = value;
	            this.buffer = cbor.$buffer;
	            this.notifyDelta(oldContent, cbor.$buffer, delta, oldValue, this.value, registry);
	        }
	        catch (e) {
	            errorHandler(e);
	        }
	    };
	    /**
	     * Notify a new stream of the cached value
	     *
	     * @param path           the topic path
	     * @param specification  the topic specification
	     * @param stream         the stream to notify
	     */
	    DatatypeCacheEntry.prototype.notifyValueToNewStream = function (path, specification, stream) {
	        if (this.buffer) {
	            stream.onValue(path, specification, null, this.buffer, null, this.value);
	        }
	    };
	    return DatatypeCacheEntry;
	}(topic_cache_entry_1.TopicCacheEntry));
	exports.DatatypeCacheEntry = DatatypeCacheEntry;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Arrays = __webpack_require__(345);
	var topics_1 = __webpack_require__(148);
	/**
	 * An entry for the topic cache
	 */
	var TopicCacheEntry = /** @class */ (function () {
	    /**
	     * Create a new TopicCacheEntry instance
	     *
	     * @param streams        the stream adapters
	     * @param path           the topic path
	     * @param specification  the topic specification
	     */
	    function TopicCacheEntry(streams, path, specification) {
	        this.streams = streams;
	        this.path = path;
	        this.specification = specification;
	    }
	    /**
	     * Get the stream adapters
	     *
	     * If there are no streams in this entry, this will return the fallback streams
	     * that match the topic details
	     *
	     * @param specification   the topic specficiation
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.proxies = function (specification, registry) {
	        return (this.streams.length === 0)
	            ? registry.getFallbacks(specification).map(function (stream) {
	                return stream.adapter ? stream.adapter(specification) : stream;
	            })
	            : this.streams;
	    };
	    /**
	     * Get the topic path
	     *
	     * @return  the topic path
	     */
	    TopicCacheEntry.prototype.getTopicPath = function () {
	        return this.path;
	    };
	    /**
	     * Get the topic specification
	     *
	     * @return  the topic specification
	     */
	    TopicCacheEntry.prototype.getTopicSpecification = function () {
	        return this.specification;
	    };
	    /**
	     * Notify all streams of the initial subscription
	     *
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.notifyInitialSubscription = function (registry) {
	        var _this = this;
	        this.proxies(this.specification, registry).forEach(function (proxy) {
	            proxy.onSubscription(_this.path, _this.specification);
	        });
	    };
	    /**
	     * Notify a stream of a new subscription
	     *
	     * @param stream  the stream to notify
	     */
	    TopicCacheEntry.prototype.notifySubscription = function (stream) {
	        stream.onSubscription(this.path, this.specification);
	        this.notifyValueToNewStream(this.path, this.specification, stream);
	    };
	    /**
	     * Notify all streams of an unsubscription
	     *
	     * @param reason  the reason for unsubscribing
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.notifyUnsubscription = function (reason, registry) {
	        var _this = this;
	        this.proxies(this.specification, registry).forEach(function (proxy) {
	            proxy.onUnsubscription(_this.path, _this.specification, reason);
	        });
	    };
	    /**
	     * Notify a stream of a new value
	     *
	     * @param oldContent  the buffer containing the old content
	     * @param content   the content as a Buffer
	     * @param oldValue  the old value of the topic
	     * @param newValue  the new value of the topic
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.notifyValue = function (oldContent, content, oldValue, newValue, registry) {
	        var _this = this;
	        this.proxies(this.specification, registry).forEach(function (proxy) {
	            proxy.onValue(_this.path, _this.specification, oldContent, content, oldValue, newValue);
	        });
	    };
	    /**
	     * Notify a stream of a delta event
	     *
	     * @param oldContent  the buffer containing the old content
	     * @param content   the content as a Buffer
	     * @param delta     the binary delta
	     * @param oldValue  the old value of the topic
	     * @param newValue  the new value of the topic
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.notifyDelta = function (oldContent, content, delta, oldValue, newValue, registry) {
	        var _this = this;
	        this.proxies(this.specification, registry).forEach(function (proxy) {
	            proxy.onDelta(_this.path, _this.specification, oldContent, content, delta, oldValue, newValue);
	        });
	    };
	    /**
	     * Add a new stream
	     *
	     * If this is the first stream, any fallback streams will be notified of an
	     * unsubscription and will not receive any more updates
	     *
	     * @param stream    the stream to add
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.addStream = function (stream, registry) {
	        var _this = this;
	        if (this.streams.length === 0) {
	            registry.getFallbacks(this.specification).forEach(function (fallback) {
	                fallback.onUnsubscription(_this.path, _this.specification, topics_1.UnsubscribeReasonEnum.STREAM_CHANGE);
	            });
	        }
	        if (this.streams.indexOf(stream) < 0) {
	            this.streams.push(stream);
	            this.notifySubscription(stream);
	        }
	    };
	    /**
	     * Remove a stream
	     *
	     * If this was the last stream in the entry, any fallback streams will be notified of a
	     * subscription and will receive value and delta updates.
	     *
	     * @param stream    the stream to remove
	     * @param registry  the stream registry
	     */
	    TopicCacheEntry.prototype.removeStream = function (stream, registry) {
	        var _this = this;
	        Arrays.remove(this.streams, stream);
	        if (this.streams.length === 0) {
	            registry.getFallbacks(this.specification).forEach(function (fallback) {
	                _this.notifySubscription(fallback);
	            });
	        }
	    };
	    /**
	     * Remove all streams
	     *
	     * No notifications will be sent
	     */
	    TopicCacheEntry.prototype.removeAllStreams = function () {
	        this.streams.length = 0;
	    };
	    return TopicCacheEntry;
	}());
	exports.TopicCacheEntry = TopicCacheEntry;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Wrapper for a security store update script. Required to provide a unique type
	 * to act as a serialisation key.
	 */
	var SecurityCommandScript = /** @class */ (function () {
	    /**
	     * Create a new SecurityCommandScript
	     *
	     * @param script  the script
	     */
	    function SecurityCommandScript(script) {
	        this.script = require_non_null_1.requireNonNull(script, 'script');
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the object
	     */
	    SecurityCommandScript.prototype.toString = function () {
	        return 'SecurityCommandScript [' + this.script + ']';
	    };
	    return SecurityCommandScript;
	}());
	exports.SecurityCommandScript = SecurityCommandScript;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var string_serialiser_1 = __webpack_require__(145);
	var service_definition_1 = __webpack_require__(51);
	var client_filter_subscribe_request_serialiser_1 = __webpack_require__(1241);
	var client_filter_subscribe_response_serialiser_1 = __webpack_require__(1243);
	var client_subscribe_request_serialiser_1 = __webpack_require__(1245);
	var change_authorisation_roles_filter_request_serialiser_1 = __webpack_require__(1247);
	var change_authorisation_roles_request_serialiser_1 = __webpack_require__(1249);
	var close_client_request_serialiser_1 = __webpack_require__(1251);
	var get_session_properties_request_serialiser_1 = __webpack_require__(1254);
	var get_session_properties_response_serialiser_1 = __webpack_require__(1255);
	var session_properties_event_batch_serialiser_1 = __webpack_require__(1270);
	var set_client_conflation_filter_request_serialiser_1 = __webpack_require__(1274);
	var set_client_conflation_request_serialiser_1 = __webpack_require__(1276);
	var set_session_properties_filter_request_serialiser_1 = __webpack_require__(1278);
	var set_session_properties_listener_serialiser_1 = __webpack_require__(1280);
	var set_session_properties_request_serialiser_1 = __webpack_require__(1281);
	var set_session_properties_result_serialiser_1 = __webpack_require__(1282);
	var count_or_parser_errors_serialiser_1 = __webpack_require__(1285);
	var session_fetch_query_result_serialiser_1 = __webpack_require__(1369);
	var session_fetch_query_serialiser_1 = __webpack_require__(1371);
	exports.SUBSCRIBE_CLIENT = {
	    id: 10,
	    request: client_subscribe_request_serialiser_1.ClientSubscribeRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.UNSUBSCRIBE_CLIENT = {
	    id: 11,
	    request: client_subscribe_request_serialiser_1.ClientSubscribeRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.CLOSE_CLIENT = {
	    id: 14,
	    request: close_client_request_serialiser_1.CloseClientRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.SET_CLIENT_CONFLATION = {
	    id: 15,
	    request: set_client_conflation_request_serialiser_1.SetClientConflationRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.FILTER_SUBSCRIBE = {
	    id: 65,
	    request: client_filter_subscribe_request_serialiser_1.ClientFilterSubscribeRequestSerialiser,
	    response: client_filter_subscribe_response_serialiser_1.ClientFilterSubscribeResponseSerialiser
	};
	exports.FILTER_UNSUBSCRIBE = {
	    id: 66,
	    request: client_filter_subscribe_request_serialiser_1.ClientFilterSubscribeRequestSerialiser,
	    response: client_filter_subscribe_response_serialiser_1.ClientFilterSubscribeResponseSerialiser
	};
	exports.GET_SESSION_PROPERTIES = {
	    id: 67,
	    request: get_session_properties_request_serialiser_1.GetSessionPropertiesRequestSerialiser,
	    response: get_session_properties_response_serialiser_1.GetSessionPropertiesResponseSerialiser
	};
	exports.SESSION_PROPERTIES_REGISTRATION_2 = {
	    id: 81,
	    request: set_session_properties_listener_serialiser_1.SetSessionPropertiesListenerSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.SESSION_PROPERTIES_EVENT_2 = {
	    id: 82,
	    request: session_properties_event_batch_serialiser_1.SessionPropertiesEventBatchSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.SET_SESSION_PROPERTIES = {
	    id: 105,
	    request: set_session_properties_request_serialiser_1.SetSessionPropertiesRequestSerialiser,
	    response: set_session_properties_result_serialiser_1.SetSessionPropertiesResultSerialiser
	};
	exports.SET_SESSION_PROPERTIES_FILTER = {
	    id: 106,
	    request: set_session_properties_filter_request_serialiser_1.SetSessionPropertiesFilterRequestSerialiser,
	    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
	};
	exports.CHANGE_AUTHORISATION_ROLES = {
	    id: 123,
	    request: change_authorisation_roles_request_serialiser_1.ChangeAuthorisationRolesRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.CHANGE_AUTHORISATION_ROLES_FILTER = {
	    id: 124,
	    request: change_authorisation_roles_filter_request_serialiser_1.ChangeAuthorisationRolesFilterRequestSerialiser,
	    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
	};
	exports.CLOSE_CLIENT_FILTER = {
	    id: 162,
	    request: string_serialiser_1.StringSerialiser,
	    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
	};
	exports.SET_CLIENT_CONFLATION_FILTER = {
	    id: 163,
	    request: set_client_conflation_filter_request_serialiser_1.SetClientConflationFilterRequestSerialiser,
	    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
	};
	exports.SESSION_FETCH = {
	    id: 168,
	    request: session_fetch_query_serialiser_1.SessionFetchQuerySerialiser,
	    response: session_fetch_query_result_serialiser_1.SessionFetchQueryResultSerialiser
	};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var command_header_1 = __webpack_require__(338);
	/**
	 * Serialiser for {@link CommandHeader}
	 */
	var CommandHeaderSerialiserClass = /** @class */ (function (_super) {
	    __extends(CommandHeaderSerialiserClass, _super);
	    function CommandHeaderSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link CommandHeader} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link CommandHeader} that was read
	     */
	    CommandHeaderSerialiserClass.prototype.read = function (bis) {
	        var service = Codec.readInt32(bis);
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        return new command_header_1.CommandHeader(service, cid);
	    };
	    /**
	     * Write a {@link CommandHeader} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link CommandHeader} to be written
	     */
	    CommandHeaderSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.service);
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return CommandHeaderSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CommandHeaderSerialiserClass = CommandHeaderSerialiserClass;
	/**
	 * Serialiser for a response {@link CommandHeader}
	 */
	var ResponseCommandHeaderSerialiserClass = /** @class */ (function (_super) {
	    __extends(ResponseCommandHeaderSerialiserClass, _super);
	    function ResponseCommandHeaderSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a response {@link CommandHeader} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link CommandHeader} to be written
	     */
	    ResponseCommandHeaderSerialiserClass.prototype.write = function (bos, value) {
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    /**
	     * Read a response {@link CommandHeader} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link CommandHeader} that was read
	     */
	    ResponseCommandHeaderSerialiserClass.prototype.read = function (bis) {
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        return new command_header_1.CommandHeader(0, cid);
	    };
	    return ResponseCommandHeaderSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ResponseCommandHeaderSerialiserClass = ResponseCommandHeaderSerialiserClass;
	/**
	 * The {@link CommandHeaderSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CommandHeaderSerialiser = new CommandHeaderSerialiserClass();
	/**
	 * The {@link ResponseCommandHeaderSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ResponseCommandHeaderSerialiser = new ResponseCommandHeaderSerialiserClass();


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for Control Registration Parameters
	 */
	var ControlRegistrationParams = /** @class */ (function () {
	    /**
	     * Create a new ControlRegistrationParams instance
	     *
	     * @param definition  the service definition
	     * @param group  the control group
	     */
	    function ControlRegistrationParams(definition, group) {
	        this.definition = definition;
	        this.group = group;
	    }
	    return ControlRegistrationParams;
	}());
	exports.ControlRegistrationParams = ControlRegistrationParams;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var control_group_serialiser_1 = __webpack_require__(327);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link MessageReceiverControlRegistrationParams}
	 */
	var MessageReceiverControlRegistrationParamsSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessageReceiverControlRegistrationParamsSerialiserClass, _super);
	    function MessageReceiverControlRegistrationParamsSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link MessageReceiverControlRegistrationParams} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MessageReceiverControlRegistrationParams} to be written
	     */
	    MessageReceiverControlRegistrationParamsSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.definition.id);
	        control_group_serialiser_1.ControlGroupSerialiser.write(bos, value.group);
	        Codec.writeString(bos, value.path);
	        Codec.writeCollection(bos, value.keys, Codec.writeString);
	    };
	    return MessageReceiverControlRegistrationParamsSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessageReceiverControlRegistrationParamsSerialiserClass = MessageReceiverControlRegistrationParamsSerialiserClass;
	/**
	 * The {@link MessageReceiverControlRegistrationParamsSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessageReceiverControlRegistrationParamsSerialiser = new MessageReceiverControlRegistrationParamsSerialiserClass();


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var messaging_response_1 = __webpack_require__(1266);
	/**
	 * Serialiser for {@link MessagingResponse}
	 */
	var MessagingResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingResponseSerialiserClass, _super);
	    function MessagingResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MessagingResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link MessagingResponse} that was read
	     */
	    MessagingResponseSerialiserClass.prototype.read = function (bis) {
	        var responseDataType = Codec.readString(bis);
	        var data = Codec.readBytes(bis);
	        return new messaging_response_1.MessagingResponse(responseDataType, data);
	    };
	    /**
	     * Write a {@link MessagingResponse} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MessagingResponse} to be written
	     */
	    MessagingResponseSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.responseDataType);
	        Codec.writeBytes(bos, value.data);
	    };
	    return MessagingResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingResponseSerialiserClass = MessagingResponseSerialiserClass;
	/**
	 * The {@link MessagingResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingResponseSerialiser = new MessagingResponseSerialiserClass();


/***/ }),
/* 516 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An enum containing the type of a session properties event.
	 */
	var SessionPropertiesEventType;
	(function (SessionPropertiesEventType) {
	    SessionPropertiesEventType[SessionPropertiesEventType["OPEN"] = 0] = "OPEN";
	    SessionPropertiesEventType[SessionPropertiesEventType["UPDATE"] = 1] = "UPDATE";
	    SessionPropertiesEventType[SessionPropertiesEventType["CLOSE"] = 2] = "CLOSE";
	})(SessionPropertiesEventType = exports.SessionPropertiesEventType || (exports.SessionPropertiesEventType = {}));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var control_group_serialiser_1 = __webpack_require__(327);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link TopicControlRegistrationParams}
	 */
	var TopicControlRegistrationParamsSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicControlRegistrationParamsSerialiserClass, _super);
	    function TopicControlRegistrationParamsSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TopicControlRegistrationParams} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicControlRegistrationParams} to be written
	     */
	    TopicControlRegistrationParamsSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.definition.id);
	        control_group_serialiser_1.ControlGroupSerialiser.write(bos, value.group);
	        Codec.writeString(bos, value.path);
	    };
	    return TopicControlRegistrationParamsSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicControlRegistrationParamsSerialiserClass = TopicControlRegistrationParamsSerialiserClass;
	/**
	 * The {@link TopicControlRegistrationParamsSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicControlRegistrationParamsSerialiser = new TopicControlRegistrationParamsSerialiserClass();


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_reason_1 = __webpack_require__(325);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link ErrorReason}
	 */
	var ErrorReasonSerialiserClass = /** @class */ (function (_super) {
	    __extends(ErrorReasonSerialiserClass, _super);
	    function ErrorReasonSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read an error reason from the stream
	     *
	     * @param bis the input stream
	     * @return    the error report that was read
	     */
	    ErrorReasonSerialiserClass.prototype.read = function (input) {
	        var code = Codec.readInt32(input);
	        var description = Codec.readString(input);
	        return new error_reason_1.ErrorReason(code, description);
	    };
	    /**
	     * Write an error reason to the stream
	     *
	     * @param bis   the input stream
	     * @param value the error report to be written
	     */
	    ErrorReasonSerialiserClass.prototype.write = function (output, reason) {
	        Codec.writeInt32(output, reason.id);
	        Codec.writeString(output, reason.reason);
	    };
	    return ErrorReasonSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ErrorReasonSerialiserClass = ErrorReasonSerialiserClass;
	/**
	 * The {@link ErrorReasonSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ErrorReasonSerialiser = new ErrorReasonSerialiserClass();


/***/ }),
/* 519 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.FetchJMXValues
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A list of JMX object names.
	 */
	var JMXFetchRequest = /** @class */ (function () {
	    /**
	     * Create a new JMXFetchRequest instance
	     *
	     * @param names the names
	     */
	    function JMXFetchRequest(names, isClustered) {
	        this.names = names;
	        this.isClustered = isClustered;
	    }
	    return JMXFetchRequest;
	}());
	exports.JMXFetchRequest = JMXFetchRequest;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link GatewayClientKey}
	 */
	var GatewayClientKeySerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayClientKeySerialiserClass, _super);
	    function GatewayClientKeySerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayClientKey} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayClientKey} that was read
	     */
	    GatewayClientKeySerialiserClass.prototype.read = function (bis) {
	        var type = Codec.readString(bis);
	        var id = Codec.readString(bis);
	        return {
	            type: type,
	            id: id
	        };
	    };
	    /**
	     * Write a {@link GatewayClientKey} from the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GatewayClientKey} to write
	     */
	    GatewayClientKeySerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.type);
	        Codec.writeString(bos, value.id);
	    };
	    return GatewayClientKeySerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayClientKeySerialiserClass = GatewayClientKeySerialiserClass;
	/**
	 * The {@link GatewayClientKeySerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayClientKeySerialiser = new GatewayClientKeySerialiserClass();


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var codec_1 = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	var service_id_serialiser_1 = __webpack_require__(523);
	var session_id_serialiser_1 = __webpack_require__(67);
	var service_detail_serialiser_1 = __webpack_require__(522);
	var UnknownGatewayRequestTypeError = /** @class */ (function (_super) {
	    __extends(UnknownGatewayRequestTypeError, _super);
	    function UnknownGatewayRequestTypeError(request) {
	        return _super.call(this, "Cannot serialise unknown gateway request type: " + request.type) || this;
	    }
	    return UnknownGatewayRequestTypeError;
	}(Error));
	exports.UnknownGatewayRequestTypeError = UnknownGatewayRequestTypeError;
	/**
	 * Serialiser for {@link GatewayClientRequestSerialiser}
	 */
	var GatewayClientRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayClientRequestSerialiserClass, _super);
	    function GatewayClientRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link GatewayClientRequest} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GatewayClientRequest} to be written
	     */
	    GatewayClientRequestSerialiserClass.prototype.write = function (bos, value) {
	        if (value.type in gateway_request_type_1.GatewayRequestType) {
	            // Only write headers for known types
	            session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionId);
	            BEES.write(bos, value.type);
	            if (value instanceof base_gateway_service_request_1.BaseGatewayServiceRequest) {
	                service_id_serialiser_1.GatewayServiceIdSerialiser.write(bos, value.serviceId);
	            }
	        }
	        switch (value.type) {
	            case gateway_request_type_1.GatewayRequestType.GET_CONFIGURATION:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_CONFIGURATION:
	            case gateway_request_type_1.GatewayRequestType.GET_STATUS:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_STATUS:
	            case gateway_request_type_1.GatewayRequestType.GET_OPERATIONS:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATIONS:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICES:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_TYPES:
	                // These requests don't have parameters other than the target client/service.
	                break;
	            case gateway_request_type_1.GatewayRequestType.ADD_SERVICE:
	            case gateway_request_type_1.GatewayRequestType.UPDATE_SERVICE:
	                service_detail_serialiser_1.GatewayServiceSerialiser.write(bos, value.serviceDetails);
	                break;
	            case gateway_request_type_1.GatewayRequestType.REMOVE_SERVICE:
	                service_id_serialiser_1.GatewayServiceIdSerialiser.write(bos, value.serviceId);
	                break;
	            case gateway_request_type_1.GatewayRequestType.GET_OPERATION_DETAIL:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATION_DETAIL:
	                codec_1.writeString(bos, value.operationName);
	                break;
	            case gateway_request_type_1.GatewayRequestType.INVOKE_OPERATION:
	            case gateway_request_type_1.GatewayRequestType.INVOKE_SERVICE_OPERATION:
	                codec_1.writeString(bos, value.operationName);
	                // tslint:disable-next-line:strict-type-predicates
	                if (value.input === null || value.input === undefined) {
	                    codec_1.writeByte(bos, 0);
	                }
	                else {
	                    codec_1.writeByte(bos, 1);
	                    codec_1.writeString(bos, value.input);
	                }
	                break;
	            default:
	                // Compile time completeness check and run time exception
	                throw new UnknownGatewayRequestTypeError(value);
	        }
	    };
	    return GatewayClientRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayClientRequestSerialiserClass = GatewayClientRequestSerialiserClass;
	/**
	 * The {@link GatewayClientRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayClientRequestSerialiser = new GatewayClientRequestSerialiserClass();


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var service_id_serialiser_1 = __webpack_require__(523);
	/**
	 * Serialiser for {@link GatewayServiceId}
	 */
	var GatewayServiceSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayServiceSerialiserClass, _super);
	    function GatewayServiceSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayService} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayService} that was read
	     */
	    GatewayServiceSerialiserClass.prototype.read = function (bis) {
	        var id = service_id_serialiser_1.GatewayServiceIdSerialiser.read(bis);
	        var desc = Codec.readByte(bis) ? Codec.readString(bis) : undefined;
	        var config = Codec.readByte(bis) ? Codec.readString(bis) : undefined;
	        return {
	            id: id,
	            description: desc,
	            configuration: config
	        };
	    };
	    /**
	     * Write a {@link GatewayService} from the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GatewayService} to write
	     */
	    GatewayServiceSerialiserClass.prototype.write = function (bos, value) {
	        service_id_serialiser_1.GatewayServiceIdSerialiser.write(bos, value.id);
	        // tslint:disable-next-line: strict-type-predicates
	        if (value.description !== undefined && value.description !== null) {
	            Codec.writeByte(bos, 1);
	            Codec.writeString(bos, value.description);
	        }
	        else {
	            Codec.writeByte(bos, 0);
	        }
	        // tslint:disable-next-line: strict-type-predicates
	        if (value.configuration !== undefined && value.configuration !== null) {
	            Codec.writeByte(bos, 1);
	            Codec.writeString(bos, value.configuration);
	        }
	        else {
	            Codec.writeByte(bos, 0);
	        }
	    };
	    return GatewayServiceSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayServiceSerialiserClass = GatewayServiceSerialiserClass;
	/**
	 * The {@link GatewayServiceSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayServiceSerialiser = new GatewayServiceSerialiserClass();


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link GatewayServiceId}
	 */
	var GatewayServiceIdSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayServiceIdSerialiserClass, _super);
	    function GatewayServiceIdSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayServiceId} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayServiceId} that was read
	     */
	    GatewayServiceIdSerialiserClass.prototype.read = function (bis) {
	        var type = Codec.readString(bis);
	        var name = Codec.readString(bis);
	        return {
	            type: type,
	            name: name
	        };
	    };
	    /**
	     * Write a {@link GatewayServiceId} from the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GatewayServiceId} to write
	     */
	    GatewayServiceIdSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.type);
	        Codec.writeString(bos, value.name);
	    };
	    return GatewayServiceIdSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayServiceIdSerialiserClass = GatewayServiceIdSerialiserClass;
	/**
	 * The {@link GatewayServiceIdSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayServiceIdSerialiser = new GatewayServiceIdSerialiserClass();


/***/ }),
/* 524 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.LogRetrieval
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a FETCH_LOG_ENTRIES_SERVICE request.
	 */
	var EntriesFetchRequest = /** @class */ (function () {
	    /**
	     * Create a new EntriesFetchRequest instance
	     *
	     * @param firstEntry  the first log entry to fetch
	     * @param entryCount  the number of log entries to fetch
	     */
	    function EntriesFetchRequest(firstEntry, entryCount) {
	        this.firstEntry = firstEntry;
	        this.entryCount = entryCount;
	    }
	    return EntriesFetchRequest;
	}());
	exports.EntriesFetchRequest = EntriesFetchRequest;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @module Services.MetricCollectors
	 */
	/**
	 * A session metric collector.
	 */
	var AbstractMetricCollector = /** @class */ (function () {
	    /**
	     * Constructor.
	     *
	     * @param name                       identity
	     * @param exportToPrometheus         whether to expose the collector through the Prometheus gateway
	     */
	    function AbstractMetricCollector(name, exportToPrometheus) {
	        this.name = name;
	        this.exportToPrometheus = exportToPrometheus;
	    }
	    return AbstractMetricCollector;
	}());
	exports.AbstractMetricCollector = AbstractMetricCollector;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_metric_collector_1 = __webpack_require__(527);
	/**
	 * Serialiser for {@link SessionMetricCollector}
	 */
	var SessionMetricCollectorSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionMetricCollectorSerialiserClass, _super);
	    function SessionMetricCollectorSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionMetricCollector} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionMetricCollector} that was read
	     */
	    SessionMetricCollectorSerialiserClass.prototype.read = function (bis) {
	        var name = Codec.readString(bis);
	        var exportToPrometheus = Codec.readBoolean(bis);
	        var removeMetricsWithNoMatches = Codec.readBoolean(bis);
	        var sessionFilter = Codec.readString(bis);
	        var groupByProperties = Codec.readCollection(bis, Codec.readString);
	        return new session_metric_collector_1.SessionMetricCollectorImpl(name, exportToPrometheus, removeMetricsWithNoMatches, sessionFilter, groupByProperties);
	    };
	    /**
	     * Write a {@link SessionMetricCollector} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SessionMetricCollector} to be written
	     */
	    SessionMetricCollectorSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeBoolean(bos, value.exportToPrometheus);
	        Codec.writeBoolean(bos, value.removeMetricsWithNoMatches);
	        Codec.writeString(bos, value.sessionFilter);
	        Codec.writeCollection(bos, value.groupByProperties, Codec.writeString);
	    };
	    return SessionMetricCollectorSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionMetricCollectorSerialiserClass = SessionMetricCollectorSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionMetricCollectorSerialiser = new SessionMetricCollectorSerialiserClass();


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_metric_collector_1 = __webpack_require__(525);
	/**
	 * A session metric collector.
	 */
	var SessionMetricCollectorImpl = /** @class */ (function (_super) {
	    __extends(SessionMetricCollectorImpl, _super);
	    /**
	     * Create a new SessionMetricCollector instance
	     *
	     * @param name                       identity
	     * @param exportToPrometheus         whether to expose the collector through the Prometheus gateway
	     * @param removeMetricsWithNoMatches whether to remove metrics when there are no longer matching sessions
	     * @param sessionFilter              identifies the target sessions
	     * @param groupByProperties          session property keys that define the groupBy dimensions for this collector;
	     *                                   may be empty
	     */
	    function SessionMetricCollectorImpl(name, exportToPrometheus, removeMetricsWithNoMatches, sessionFilter, groupByProperties) {
	        var _this = _super.call(this, name, exportToPrometheus) || this;
	        _this.sessionFilter = sessionFilter;
	        _this.groupByProperties = groupByProperties;
	        _this.removeMetricsWithNoMatches = removeMetricsWithNoMatches;
	        return _this;
	    }
	    return SessionMetricCollectorImpl;
	}(abstract_metric_collector_1.AbstractMetricCollector));
	exports.SessionMetricCollectorImpl = SessionMetricCollectorImpl;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_metric_collector_1 = __webpack_require__(529);
	/**
	 * Serialiser for {@link SessionMetricCollector}
	 */
	var TopicMetricCollectorSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicMetricCollectorSerialiserClass, _super);
	    function TopicMetricCollectorSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link TopicMetricCollector} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the instance that was read
	     */
	    TopicMetricCollectorSerialiserClass.prototype.read = function (bis) {
	        var name = Codec.readString(bis);
	        var exportToPrometheus = Codec.readBoolean(bis);
	        var topicSelector = Codec.readString(bis);
	        var groupByTopicType = Codec.readBoolean(bis);
	        return new topic_metric_collector_1.TopicMetricCollectorImpl(name, exportToPrometheus, topicSelector, groupByTopicType);
	    };
	    /**
	     * Write a {@link TopicMetricCollector} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the instance to be written
	     */
	    TopicMetricCollectorSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeBoolean(bos, value.exportToPrometheus);
	        Codec.writeString(bos, value.topicSelector);
	        Codec.writeBoolean(bos, value.groupByTopicType);
	    };
	    return TopicMetricCollectorSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicMetricCollectorSerialiserClass = TopicMetricCollectorSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicMetricCollectorSerialiser = new TopicMetricCollectorSerialiserClass();


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_metric_collector_1 = __webpack_require__(525);
	/**
	 * A topic metric collector.
	 */
	var TopicMetricCollectorImpl = /** @class */ (function (_super) {
	    __extends(TopicMetricCollectorImpl, _super);
	    /**
	     * Create a new TopicMetricCollector instance
	     *
	     * @param name                       identity
	     * @param exportToPrometheus         whether to expose the collector through the Prometheus gateway
	     * @param topicSelector              identifies the target topics
	     * @param groupByTopicType           whether to group the results by topic type
	     */
	    function TopicMetricCollectorImpl(name, exportToPrometheus, topicSelector, groupByTopicType) {
	        var _this = _super.call(this, name, exportToPrometheus) || this;
	        _this.topicSelector = topicSelector;
	        _this.groupByTopicType = groupByTopicType;
	        return _this;
	    }
	    return TopicMetricCollectorImpl;
	}(abstract_metric_collector_1.AbstractMetricCollector));
	exports.TopicMetricCollectorImpl = TopicMetricCollectorImpl;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Metrics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A request for entity metrics from a certain server of the cluster.
	 */
	var MeasuredEntityClassRequest = /** @class */ (function () {
	    function MeasuredEntityClassRequest(entityClass, serverName) {
	        this.entityClass = entityClass;
	        this.serverName = serverName;
	    }
	    return MeasuredEntityClassRequest;
	}());
	exports.MeasuredEntityClassRequest = MeasuredEntityClassRequest;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var service_definition_1 = __webpack_require__(51);
	exports.SYSTEM_PING = {
	    id: 55,
	    request: service_definition_1.NullSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.USER_PING = {
	    id: 56,
	    request: service_definition_1.NullSerialiser,
	    response: service_definition_1.NullSerialiser
	};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var remote_servers_1 = __webpack_require__(323);
	var BEES = __webpack_require__(25);
	/**
	 * Read a remote server from the stream
	 *
	 * @param bis  the input stream
	 * @return     the {@link RemoteServer} that was read
	 */
	function readRemoteServer(bis) {
	    var name = Codec.readString(bis);
	    var url = Codec.readString(bis);
	    var principal = Codec.readString(bis);
	    var connectionOptions = Codec.readObject(bis, function (s) { return BEES.read(s, remote_servers_1.ConnectionOption); }, Codec.readString);
	    var missingTopicNotificationFilter = Codec.readString(bis);
	    return {
	        name: name,
	        url: url,
	        principal: principal,
	        connectionOptions: connectionOptions,
	        missingTopicNotificationFilter: missingTopicNotificationFilter !== ''
	            ? missingTopicNotificationFilter
	            : undefined
	    };
	}
	exports.readRemoteServer = readRemoteServer;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The request of RemoteServers CREATE_REMOTE_SERVER service
	 */
	var RemoteServerDefinitionImpl = /** @class */ (function () {
	    /**
	     * Create a new NamedRemoteServerSpecification instance
	     *
	     * @param name              the remote server name
	     * @param url               the remote server url
	     * @param principal         the principal used for connection to the remote server
	     * @param credentials       the credentials used for connection to the remote server
	     * @param connectionOptions the options used for connection to the remote server
	     */
	    function RemoteServerDefinitionImpl(
	    /** The name of the remote server. */
	    name, 
	    /** The url used for connection to the remote server. */
	    url, 
	    /** The principal used for connection to the remote server. */
	    principal, 
	    /** The credentials used for connection to the remote server. */
	    credentials, 
	    /** Options used for connection to the remote server. */
	    connectionOptions, 
	    /** The missing topic notification filter. */
	    missingTopicNotificationFilter) {
	        this.name = name;
	        this.url = url;
	        this.principal = principal;
	        this.credentials = credentials;
	        this.connectionOptions = connectionOptions;
	        this.missingTopicNotificationFilter = missingTopicNotificationFilter;
	    }
	    return RemoteServerDefinitionImpl;
	}());
	exports.RemoteServerDefinitionImpl = RemoteServerDefinitionImpl;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var control_registration_params_serialiser_1 = __webpack_require__(1253);
	var authenticator_registration_parameters_1 = __webpack_require__(1356);
	/**
	 * Serialiser for {@link AuthenticatorRegistrationParameters}
	 */
	var AuthenticatorRegistrationParametersSerialiserClass = /** @class */ (function (_super) {
	    __extends(AuthenticatorRegistrationParametersSerialiserClass, _super);
	    function AuthenticatorRegistrationParametersSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AuthenticatorRegistrationParameters} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link AuthenticatorRegistrationParameters} that was read
	     */
	    AuthenticatorRegistrationParametersSerialiserClass.prototype.read = function (bis) {
	        var params = control_registration_params_serialiser_1.ControlRegistrationParamsSerialiser.read(bis);
	        var name = Codec.readString(bis);
	        return new authenticator_registration_parameters_1.AuthenticatorRegistrationParameters(name, params.definition, params.group);
	    };
	    /**
	     * Write a {@link AuthenticatorRegistrationParameters} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link AuthenticatorRegistrationParameters} to be written
	     */
	    AuthenticatorRegistrationParametersSerialiserClass.prototype.write = function (bos, value) {
	        control_registration_params_serialiser_1.ControlRegistrationParamsSerialiser.write(bos, value);
	        Codec.writeString(bos, value.name);
	    };
	    return AuthenticatorRegistrationParametersSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.AuthenticatorRegistrationParametersSerialiserClass = AuthenticatorRegistrationParametersSerialiserClass;
	/**
	 * The {@link AuthenticatorRegistrationParametersSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.AuthenticatorRegistrationParametersSerialiser = new AuthenticatorRegistrationParametersSerialiserClass();


/***/ }),
/* 535 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Authenticator response type
	 */
	var TypeCode;
	(function (TypeCode) {
	    TypeCode[TypeCode["DENY"] = 0] = "DENY";
	    TypeCode[TypeCode["ABSTAIN"] = 1] = "ABSTAIN";
	    TypeCode[TypeCode["ALLOW"] = 2] = "ALLOW";
	})(TypeCode = exports.TypeCode || (exports.TypeCode = {}));
	/**
	 * Server response from a AUTHENTICATION request.
	 */
	var AuthenticatorResponse = /** @class */ (function () {
	    /**
	     * Create a new AuthenticatorResponse instance
	     *
	     * @param type  the authenticator response type
	     * @param properties  the session properties
	     */
	    function AuthenticatorResponse(type, properties) {
	        this.type = type;
	        this.properties = properties;
	    }
	    return AuthenticatorResponse;
	}());
	exports.AuthenticatorResponse = AuthenticatorResponse;
	/**
	 * An AuthenticatorResponse that denies authenticator
	 */
	exports.DENY = Object.freeze(new AuthenticatorResponse(TypeCode.DENY));
	/**
	 * An AuthenticatorResponse that abstains
	 */
	exports.ABSTAIN = Object.freeze(new AuthenticatorResponse(TypeCode.ABSTAIN));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var time_series_event_metadata_1 = __webpack_require__(537);
	/**
	 * Serialiser for {@link EventMetadataImpl}
	 */
	var EventMetadataImplSerialiserClass = /** @class */ (function (_super) {
	    __extends(EventMetadataImplSerialiserClass, _super);
	    function EventMetadataImplSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link EventMetadataImpl} from the stream
	     *
	     * @param input the input stream
	     * @return      the {@link EventMetadataImpl} that was read
	     */
	    EventMetadataImplSerialiserClass.prototype.read = function (input) {
	        var sequence = Codec.readInt64(input);
	        var timestamp = Codec.readInt64(input);
	        var author = Codec.readString(input);
	        return new time_series_event_metadata_1.EventMetadataImpl(sequence.toNumber(), timestamp.toNumber(), author);
	    };
	    /**
	     * Write a {@link EventMetadataImpl} to the stream
	     *
	     * @param output  the input stream
	     * @param value   the {@link EventMetadataImpl} to be written
	     */
	    EventMetadataImplSerialiserClass.prototype.write = function (output, metadata) {
	        Codec.writeInt64(output, metadata.sequence);
	        Codec.writeInt64(output, metadata.timestamp);
	        Codec.writeString(output, metadata.author);
	    };
	    return EventMetadataImplSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.EventMetadataImplSerialiserClass = EventMetadataImplSerialiserClass;
	/**
	 * The {@link EventMetadataImplSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.EventMetadataImplSerialiser = new EventMetadataImplSerialiserClass();


/***/ }),
/* 537 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Metadata for a time series event
	 */
	var EventMetadataImpl = /** @class */ (function () {
	    /**
	     * Create a new EventMetadataImpl instance
	     *
	     * @param  sequence   the event sequence number
	     * @param  timestamp  the event timestamp
	     * @param  author     the event author
	     */
	    function EventMetadataImpl(sequence, timestamp, author) {
	        this.sequence = sequence;
	        this.timestamp = timestamp;
	        this.author = author;
	    }
	    /**
	     * Check if the EventMetadataImpl is equal to another object
	     *
	     * @param  other the other object
	     * @return       `true` if the other object is a EventMetadataImpl and is equal
	     */
	    EventMetadataImpl.prototype.equals = function (other) {
	        if (other && other instanceof EventMetadataImpl) {
	            return this.sequence === other.sequence &&
	                this.timestamp === other.timestamp &&
	                this.author === other.author;
	        }
	        return false;
	    };
	    return EventMetadataImpl;
	}());
	exports.EventMetadataImpl = EventMetadataImpl;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicAdd
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Response code returned by the server for a TOPIC_ADD request
	 */
	var TopicAddResponseStatus;
	(function (TopicAddResponseStatus) {
	    TopicAddResponseStatus[TopicAddResponseStatus["OK"] = 0] = "OK";
	    TopicAddResponseStatus[TopicAddResponseStatus["EXISTS"] = 1] = "EXISTS";
	})(TopicAddResponseStatus = exports.TopicAddResponseStatus || (exports.TopicAddResponseStatus = {}));
	/**
	 * Server response from a TOPIC_ADD request.
	 */
	var TopicAddResponse = /** @class */ (function () {
	    /**
	     * Create a new TopicAddResponse instance
	     *
	     * @param status  the status of the add topic request
	     * @param reason  if the request has failed, this contains the reason
	     */
	    function TopicAddResponse(status) {
	        this.status = status;
	    }
	    return TopicAddResponse;
	}());
	exports.TopicAddResponse = TopicAddResponse;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var topic_update_1 = __webpack_require__(90);
	var add_topic_result_1 = __webpack_require__(1406);
	/**
	 * Server response code when adding a topic
	 */
	var AddTopicResultCode;
	(function (AddTopicResultCode) {
	    AddTopicResultCode[AddTopicResultCode["CREATED"] = 0] = "CREATED";
	    AddTopicResultCode[AddTopicResultCode["EXISTS"] = 1] = "EXISTS";
	})(AddTopicResultCode || (AddTopicResultCode = {}));
	/**
	 * Serialiser for {@link AddTopicResult}
	 */
	var AddTopicResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(AddTopicResultSerialiserClass, _super);
	    function AddTopicResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AddTopicResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link AddTopicResult} that was read
	     */
	    AddTopicResultSerialiserClass.prototype.read = function (bis) {
	        var addTopicResult = BEES.read(bis, AddTopicResultCode);
	        var result = (addTopicResult === AddTopicResultCode.CREATED)
	            ? topic_update_1.TopicCreationResult.CREATED
	            : topic_update_1.TopicCreationResult.EXISTS;
	        return new add_topic_result_1.AddTopicResult(result);
	    };
	    return AddTopicResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.AddTopicResultSerialiserClass = AddTopicResultSerialiserClass;
	/**
	 * The {@link AddTopicResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.AddTopicResultSerialiser = new AddTopicResultSerialiserClass();


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicViews
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Read a topic view from the stream
	 *
	 * @param bis  the input stream
	 * @return     the {@link TopicView} that was read
	 */
	function readTopicView(bis) {
	    var name = Codec.readString(bis);
	    var specification = Codec.readString(bis);
	    var roles = new Set(Codec.readCollection(bis, Codec.readString));
	    return {
	        name: name,
	        specification: specification,
	        roles: roles
	    };
	}
	exports.readTopicView = readTopicView;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var service_definition_1 = __webpack_require__(51);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	var fetch_query_result_serialiser_1 = __webpack_require__(1292);
	var fetch_query_serialiser_1 = __webpack_require__(1294);
	exports.SUBSCRIBE = {
	    id: 3,
	    request: topic_selector_serialiser_1.TopicSelectorSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.UNSUBSCRIBE = {
	    id: 4,
	    request: topic_selector_serialiser_1.TopicSelectorSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.FETCH_QUERY = {
	    id: 117,
	    request: fetch_query_serialiser_1.FetchQuerySerialiser,
	    response: fetch_query_result_serialiser_1.FetchQueryResultSerialiser
	};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable-next-line:strict-type-predicates
	var DEFAULT_HOST = (typeof window !== 'undefined' && window.location.hostname)
	    ? window.location.hostname
	    : 'localhost';
	// tslint:disable-next-line:strict-type-predicates
	var DEFAULT_PORT = (typeof window !== 'undefined'
	    && window.location.protocol === 'http:'
	    && window.location.port)
	    ? parseInt(window.location.port, 10)
	    : 80;
	// tslint:disable-next-line:strict-type-predicates
	var DEFAULT_SECURE_PORT = (typeof window !== 'undefined'
	    && window.location.protocol === 'https:'
	    && window.location.port)
	    ? parseInt(window.location.port, 10)
	    : 443;
	// tslint:disable-next-line:strict-type-predicates
	var DEFAULT_SECURE = typeof window === 'undefined' || window.location.protocol !== 'http:';
	var DEFAULT_PATH = '/diffusion';
	/**
	 * The amount of time waiting for a connection to occur.
	 */
	var DEFAULT_CONNECT_TIMEOUT = global.DIFFUSION_CONNECT_TIMEOUT || 10000;
	var DEFAULT_RECONNECT_TIMEOUT = 60000;
	var DEFAULT_RECONNECT_STRATEGY = function (start) {
	    setTimeout(start, 5000);
	};
	var DEFAULT_ABORT_STRATEGY = function (start, abort) {
	    abort();
	};
	var DEFAULT_PRINCIPAL = '';
	var DEFAULT_PASSWORD = '';
	var DEFAULT_ACTIVITY_MONITOR = true;
	// tslint:disable-next-line:strict-type-predicates
	var DEFAULT_TRANSPORTS = typeof window === 'undefined' ? ['WEBSOCKET'] : ['WEBSOCKET', 'XHR'];
	var DEFAULT_MAX_MESSAGE_SIZE = 2147483647;
	var MIN_MAX_MESSAGE_SIZE = 1024;
	/**
	 * Implementation of the {@link Options} interface.
	 *
	 * @inheritdoc
	 */
	var OptionsImpl = /** @class */ (function () {
	    /**
	     * Create a new OptionsImpl instance
	     *
	     * The constructor takes a partially defined Options object and sets all
	     * undefined properties with their default values.
	     *
	     * @param  options  the options to create the instance from
	     */ // tslint:disable-next-line:cyclomatic-complexity
	    function OptionsImpl(options) {
	        if (options === void 0) { options = {}; }
	        // override options.host and options.port if supplied together
	        // in options.host.
	        if (options.host === undefined) {
	            options.host = DEFAULT_HOST;
	        }
	        else if ((options.host.match(/:/g) || []).length === 1
	            || options.host.match(/^\[[^\]]*\]:\d+$/)) {
	            var portSep = options.host.lastIndexOf(':');
	            if (options.port === undefined) {
	                options.port = parseInt(options.host.substr(portSep + 1), 10);
	            }
	            options.host = options.host.substr(0, portSep);
	        }
	        // wrap IPv6 host in brackets
	        if (options.host.indexOf(':') > -1 && !options.host.match(/^\[/)) {
	            options.host = "[" + options.host + "]";
	        }
	        if (options.path === undefined) {
	            options.path = DEFAULT_PATH;
	        }
	        else {
	            if (options.path[0] !== '/') {
	                options.path = '/' + options.path;
	            }
	            // assert that the path ends with '/diffusion'
	            if (options.path.substring(options.path.length - DEFAULT_PATH.length) !== DEFAULT_PATH) {
	                if (options.path[options.path.length - 1] === '/') {
	                    options.path = options.path.substring(0, options.path.length - 1);
	                }
	                options.path = options.path + DEFAULT_PATH;
	            }
	        }
	        if (options.port !== undefined) {
	            if (typeof options.port === 'string') {
	                if (isNaN(parseInt(options.port, 10))) {
	                    // set to undefined in order to let us derive 'secure' option correctly
	                    options.port = undefined;
	                }
	                else {
	                    options.port = parseInt(options.port, 10);
	                }
	            }
	        }
	        if (options.secure === undefined) {
	            if (options.port === undefined) { // default to secure on secure port.
	                options.secure = DEFAULT_SECURE;
	            }
	            else { // if specified port 80, default to insecure else secure.
	                options.secure = options.port === DEFAULT_SECURE_PORT ? true : false;
	            }
	        }
	        if (options.port === undefined) {
	            // security specified but not port, choose 443 or 80?
	            options.port = options.secure ? DEFAULT_SECURE_PORT : DEFAULT_PORT;
	        }
	        this.host = options.host;
	        this.port = options.port;
	        this.path = options.path;
	        this.secure = options.secure;
	        this.connectionTimeout = options.connectionTimeout !== undefined
	            ? options.connectionTimeout
	            : DEFAULT_CONNECT_TIMEOUT;
	        if (options.reconnect === undefined || (typeof options.reconnect === 'boolean') && options.reconnect) {
	            this.reconnect = {
	                timeout: DEFAULT_RECONNECT_TIMEOUT,
	                strategy: DEFAULT_RECONNECT_STRATEGY
	            };
	        }
	        else if (typeof options.reconnect === 'number') {
	            this.reconnect = {
	                timeout: options.reconnect,
	                strategy: DEFAULT_RECONNECT_STRATEGY
	            };
	        }
	        else if (typeof options.reconnect === 'function') {
	            this.reconnect = {
	                timeout: DEFAULT_RECONNECT_TIMEOUT,
	                strategy: options.reconnect
	            };
	        }
	        else if (typeof options.reconnect === 'object') {
	            this.reconnect = {
	                // tslint:disable-next-line:strict-type-predicates
	                timeout: options.reconnect.timeout === undefined
	                    ? DEFAULT_RECONNECT_TIMEOUT
	                    : options.reconnect.timeout,
	                strategy: options.reconnect.strategy || DEFAULT_RECONNECT_STRATEGY
	            };
	        }
	        else {
	            this.reconnect = {
	                timeout: 0,
	                strategy: DEFAULT_ABORT_STRATEGY
	            };
	        }
	        if (options.principal !== undefined) {
	            this.principal = options.principal || DEFAULT_PRINCIPAL;
	            if (typeof options.credentials === 'string') {
	                this.credentials = options.credentials;
	            }
	            else if (isTypedArray(options.credentials)) {
	                this.credentials = Buffer.from(options.credentials.buffer);
	            }
	            else if (Array.isArray(options.credentials)) {
	                ensureOctetArray(options.credentials);
	                this.credentials = Buffer.from(options.credentials);
	            }
	            else {
	                this.credentials = DEFAULT_PASSWORD;
	            }
	        }
	        if (typeof options.transports === 'string') {
	            this.transports = [options.transports];
	        }
	        else if (typeof options.transports === 'object' &&
	            options.transports instanceof Array &&
	            options.transports.length > 0) {
	            this.transports = options.transports.slice();
	        }
	        else {
	            this.transports = DEFAULT_TRANSPORTS.slice();
	        }
	        this.transports = this.transports.slice().map(function (t) {
	            return t.toUpperCase();
	        });
	        var mms = (options.maxMessageSize && options.maxMessageSize > MIN_MAX_MESSAGE_SIZE)
	            ? options.maxMessageSize
	            : DEFAULT_MAX_MESSAGE_SIZE;
	        this.maxMessageSize = mms;
	        // tslint:disable-next-line:strict-type-predicates
	        this.activityMonitor = (options.activityMonitor !== undefined)
	            ? options.activityMonitor
	            : DEFAULT_ACTIVITY_MONITOR;
	        if (options.properties !== undefined) {
	            var properties_1 = {};
	            Object.getOwnPropertyNames(options.properties).forEach(function (key) {
	                properties_1[key] = options.properties[key].toString();
	            });
	            this.properties = properties_1;
	        }
	        this.httpProxyAgent = options.httpProxyAgent;
	    }
	    /**
	     * Create a new Options object containing the union of this with additional
	     * options.
	     *
	     * @param  options  options to merge
	     * @returns         the new options
	     */
	    OptionsImpl.prototype.with = function (options) {
	        var e_1, _a, e_2, _b;
	        var o = {};
	        var k;
	        try {
	            for (var _c = __values(Object.getOwnPropertyNames(this)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                k = _d.value;
	                o[k] = this[k];
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        try {
	            for (var _e = __values(Object.getOwnPropertyNames(options)), _f = _e.next(); !_f.done; _f = _e.next()) {
	                k = _f.value;
	                o[k] = options[k];
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return new OptionsImpl(o);
	    };
	    return OptionsImpl;
	}());
	exports.OptionsImpl = OptionsImpl;
	/**
	 * Ensure that the array contains only octet numbers
	 *
	 * @param  value  the array to check
	 * @throws        an error if any entry in the array is not a number or out of
	 *                range
	 */
	function ensureOctetArray(value) {
	    value.forEach(function (element) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (typeof element !== 'number' || element > 127 || element < -128) {
	            throw new Error('Custom credentials invalid. Element must be octet.');
	        }
	    });
	}
	/**
	 * Check if the argument is a typed array
	 *
	 * @param  obj  the object to check
	 * @return      `true` if the object is an instance of a typed array
	 */
	function isTypedArray(obj) {
	    return (obj instanceof Int8Array ||
	        obj instanceof Int16Array ||
	        obj instanceof Int32Array ||
	        obj instanceof Uint8Array ||
	        obj instanceof Uint8ClampedArray ||
	        obj instanceof Uint16Array ||
	        obj instanceof Uint32Array ||
	        obj instanceof Float32Array ||
	        obj instanceof Float64Array);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19).Buffer))

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An update stream delegate that is used after the update stream has encountered
	 * an invalid operation and a value was not set.
	 */
	var InvalidUnsetStream = /** @class */ (function () {
	    /**
	     * Create a new InvalidUnsetStream instance
	     *
	     * @param err    the error that occurred
	     */
	    function InvalidUnsetStream(err) {
	        this.err = err;
	    }
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.set = function () {
	        return Promise.reject(this.err);
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.get = function () {
	        throw new Error('No value has been set');
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.validate = function () {
	        return Promise.reject(this.err);
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.onSetComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.onSetFailed = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.onValidateComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    InvalidUnsetStream.prototype.onValidateFailed = function () {
	        // no-op
	    };
	    return InvalidUnsetStream;
	}());
	exports.InvalidUnsetStream = InvalidUnsetStream;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var update_stream_request_1 = __webpack_require__(235);
	var invalid_set_stream_1 = __webpack_require__(341);
	var set_stream_1 = __webpack_require__(342);
	var topic_update_1 = __webpack_require__(90);
	/**
	 * An update stream delegate that is used when a {@link set} operation is called
	 * on a new stream. The server has not yet responded to the initial set
	 * operation.
	 */
	var PendingSetStream = /** @class */ (function () {
	    /**
	     * Create a new PendingSetStream instance
	     *
	     * @param streamServices  the stream services
	     * @param options         the update stream options
	     * @param stream          the stream that using this stream as a delegate
	     * @param pendingResult   the pending result
	     * @param value           the value of the pending set operation
	     */
	    function PendingSetStream(streamServices, options, stream, pendingResult, value) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.pendingResult = pendingResult;
	        this.deferredResolvers = [];
	        this.value = value;
	        this.nextValue = value;
	    }
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        this.nextValue = value;
	        return new Promise(function (resolve, reject) {
	            _this.deferredResolvers.push({ value: value, resolve: resolve, reject: reject });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.get = function () {
	        return this.nextValue;
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.validate = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.pendingResult.then(function (r) {
	                resolve(topic_update_1.TopicCreationResult.EXISTS);
	                return r;
	            }, function (err) {
	                reject(err);
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.onSetComplete = function (streamId, retainsValue, supportsConflation) {
	        var _this = this;
	        this.options.retainsValue = retainsValue;
	        this.options.supportsConflation = supportsConflation;
	        if (!retainsValue) {
	            this.options.toBuffer = function (oldValue, newValue) {
	                return _this.options.dataType.toBytes(newValue).asBuffer();
	            };
	            this.options.deltaService = this.streamServices.STREAM_SET_TOPIC_SERVICE;
	        }
	        this.stream.setDelegate(new set_stream_1.SetStream(this.streamServices, this.options, this.stream, streamId, this.nextValue));
	        if (retainsValue && supportsConflation) {
	            this.processPendingUpdatesRetainsValue(streamId);
	        }
	        else {
	            this.processPendingUpdatesDoesntRetainValue(streamId);
	        }
	    };
	    PendingSetStream.prototype.processPendingUpdatesRetainsValue = function (streamId) {
	        var _this = this;
	        var buffer = this.options.dataType.toBytes(this.value).asBuffer();
	        var nextBuffer = this.options.dataType.toBytes(this.nextValue).asBuffer();
	        if (Buffer.compare(buffer, nextBuffer) !== 0) {
	            var diffBuffer = this.options.toBuffer(this.value, this.nextValue);
	            this.options.deltaService.send(new update_stream_request_1.UpdateStreamRequest(streamId, diffBuffer), function (err) {
	                if (err) {
	                    _this.deferredResolvers.forEach(function (resolver) {
	                        resolver.reject(err);
	                    });
	                }
	                else {
	                    _this.deferredResolvers.forEach(function (resolver) {
	                        resolver.resolve();
	                    });
	                }
	            });
	        }
	        else {
	            this.deferredResolvers.forEach(function (resolver) {
	                resolver.resolve();
	            });
	        }
	    };
	    PendingSetStream.prototype.processPendingUpdatesDoesntRetainValue = function (streamId) {
	        var _this = this;
	        var value = this.value;
	        this.deferredResolvers.forEach(function (resolver) {
	            var diffBuffer = _this.options.toBuffer(value, resolver.value);
	            value = resolver.value;
	            _this.options.deltaService.send(new update_stream_request_1.UpdateStreamRequest(streamId, diffBuffer), function (err) {
	                if (err) {
	                    resolver.reject(err);
	                }
	                else {
	                    resolver.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.onSetFailed = function (err) {
	        this.stream.setDelegate(new invalid_set_stream_1.InvalidSetStream(err, this.nextValue));
	        this.deferredResolvers.forEach(function (resolver) {
	            resolver.reject(err);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.onValidateComplete = function () {
	        throw new Error('No validate request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingSetStream.prototype.onValidateFailed = function () {
	        throw new Error('No validate request has been sent');
	    };
	    return PendingSetStream;
	}());
	exports.PendingSetStream = PendingSetStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var invalid_unset_stream_1 = __webpack_require__(543);
	var pending_validate_and_set_stream_1 = __webpack_require__(1444);
	var validated_stream_1 = __webpack_require__(1448);
	var topic_update_1 = __webpack_require__(90);
	/**
	 * An update stream delegate that is used when a {@link validate} operation is called
	 * on a new stream. The server has not yet responded to the initial validate
	 * operation.
	 */
	var PendingValidateStream = /** @class */ (function () {
	    /**
	     * Create a new PendingValidateStream instance
	     *
	     * @param streamServices   the stream services
	     * @param options          the update stream options
	     * @param stream           the stream that using this stream as a delegate
	     * @param pendingResult    the pending result
	     */
	    function PendingValidateStream(streamServices, options, stream, pendingResult) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.pendingResult = pendingResult;
	    }
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        return new Promise(function (resolve, reject) {
	            _this.stream.setDelegate(new pending_validate_and_set_stream_1.PendingValidateAndSetStream(_this.streamServices, _this.options, _this.stream, _this.pendingResult, { value: value, resolve: resolve, reject: reject }, value));
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.get = function () {
	        throw new Error('The set method has not been called');
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.validate = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.pendingResult.then(function (r) {
	                resolve(topic_update_1.TopicCreationResult.EXISTS);
	                return r;
	            }, function (err) {
	                reject(err);
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.onSetComplete = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.onSetFailed = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.onValidateComplete = function (streamId, retainsValue, supportsConflation) {
	        var _this = this;
	        this.options.retainsValue = retainsValue;
	        this.options.supportsConflation = supportsConflation;
	        if (!retainsValue) {
	            this.options.toBuffer = function (oldValue, newValue) {
	                return _this.options.dataType.toBytes(newValue).asBuffer();
	            };
	            this.options.deltaService = this.streamServices.STREAM_SET_TOPIC_SERVICE;
	        }
	        this.stream.setDelegate(new validated_stream_1.ValidatedStream(this.streamServices, this.options, this.stream, streamId));
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateStream.prototype.onValidateFailed = function (err) {
	        this.stream.setDelegate(new invalid_unset_stream_1.InvalidUnsetStream(err));
	    };
	    return PendingValidateStream;
	}());
	exports.PendingValidateStream = PendingValidateStream;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(104);
	var abstract_topic_selector_1 = __webpack_require__(180);
	var utils = __webpack_require__(128);
	var topic_selector_1 = __webpack_require__(181);
	exports.DELIMITER = '////';
	/**
	 * Extract the longest common prefix from a set of topic selectors
	 *
	 * @param  selectors  the topic selectors
	 * @return            the longest common prefix
	 */
	function extractCommonPrefix(selectors) {
	    var e_1, _a;
	    if (selectors.length === 0) {
	        return '';
	    }
	    // set initial value to Integer.MAX_VALUE
	    var minimum = math_1.MAX_INT32;
	    var prefixes = [];
	    selectors.forEach(function (selector, i) {
	        var part = utils.split(selector.prefix);
	        minimum = Math.min(minimum, part.length);
	        prefixes[i] = part;
	    });
	    var composite = [];
	    assembly: for (var j = 0; j < minimum; ++j) {
	        var part = prefixes[0][j];
	        try {
	            for (var prefixes_1 = __values(prefixes), prefixes_1_1 = prefixes_1.next(); !prefixes_1_1.done; prefixes_1_1 = prefixes_1.next()) {
	                var prefix = prefixes_1_1.value;
	                if (part !== prefix[j]) {
	                    break assembly;
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (prefixes_1_1 && !prefixes_1_1.done && (_a = prefixes_1.return)) _a.call(prefixes_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        composite.push(part);
	        composite.push(utils.PATH_SEPARATOR);
	    }
	    return utils.canonicalise(composite.join(''));
	}
	/**
	 * Implementation of {@link AbstractTopicSelector} for selector sets
	 */
	var SelectorSet = /** @class */ (function (_super) {
	    __extends(SelectorSet, _super);
	    /**
	     * Create a new SelectorSet instance
	     *
	     * @param  selectors  the topic selectors in the set
	     */
	    function SelectorSet(selectors) {
	        var _this = this;
	        var expanded = [];
	        selectors.forEach(function (selector) {
	            if (selector instanceof SelectorSet) {
	                selector.selectors.forEach(function (nested) {
	                    expanded.push(nested);
	                });
	            }
	            else {
	                expanded.push(selector);
	            }
	        });
	        var remainder = expanded.join(exports.DELIMITER);
	        var prefix = extractCommonPrefix(expanded);
	        _this = _super.call(this, topic_selector_1.Type.SELECTOR_SET, prefix, topic_selector_1.Prefix.SELECTOR_SET + remainder) || this;
	        _this.selectors = expanded;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    SelectorSet.prototype.selects = function (topicPath) {
	        var e_2, _a;
	        try {
	            for (var _b = __values(this.selectors), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var selector = _c.value;
	                if (selector.selects(topicPath)) {
	                    return true;
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return false;
	    };
	    /**
	     * @inheritdoc
	     */
	    SelectorSet.prototype.doSelects = function (canonical) {
	        return this.selects(canonical);
	    };
	    return SelectorSet;
	}(abstract_topic_selector_1.AbstractTopicSelector));
	exports.SelectorSet = SelectorSet;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Util.FSM
	 *
	 * @brief A miniman finite state machine
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable-next-line:variable-name no-var-requires */
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	/**
	 * Minimal finite state machine implementation. Allows directed transitions
	 * between states.
	 *
	 * States are provided as an object, with each key being single distinct state.
	 * Each state's value within the object should be an array of strings, which
	 * dictates the available states that are legal to transition to.
	 *
	 * If a state may transition to any other state, the string `'*'`
	 * may be provided instead of an array.
	 *
	 * If a state is terminal, it should simply provide an empty array.
	 *
	 * **Example:**
	 * ```
	 * // Create a state machine with three states:
	 * // 'a' may transition to 'b' or 'c'
	 * // 'b' is a terminal state
	 * // 'c' may transition to any state
	 *
	 * var states = {
	 *     a : ['b', 'c'],
	 *     b : [],
	 *     c : '*'
	 * };
	 *
	 * var fsm = new FSM('a', states);
	 *
	 * states.change('c'); // => true
	 * states.change('a'); // => true
	 * states.change('b'); // => true
	 * states.change('c'); // => false
	 * states.change('a'); // => false
	 * ```
	 */
	var FSM = /** @class */ (function (_super) {
	    __extends(FSM, _super);
	    /**
	     * Create a new finite state machine
	     *
	     * @param initial the initial state that this FSM should be in
	     * @param states  the set of possible states to transition between
	     */
	    function FSM(initial, states) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.states = states;
	        _this.current = states[initial];
	        _this.state = initial;
	        return _this;
	    }
	    /**
	     * Change the state. Will return whether the transition was allowed or not.
	     *
	     * @param state the new state
	     * @return      `true` is the change of state was successful
	     */
	    FSM.prototype.change = function (state) {
	        if (this.state === state) {
	            return true;
	        }
	        if (this.states[state] && (this.current === '*' || this.current.indexOf(state) > -1)) {
	            this.emitter.emit('change', this.state, state);
	            this.current = this.states[state];
	            this.state = state;
	            return true;
	        }
	        return false;
	    };
	    return FSM;
	}(stream_1.StreamImpl));
	exports.FSM = FSM;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.RegEx
	 *
	 * @brief Utility functions for regular expressions
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Create a regex matcher function for a given regex expression, with an
	 * optional context for RegEx construction error messages.
	 *
	 * The returned function will evaluate the generated regex across the entire
	 * region of the given input. This is equivalent to Matcher.matches in Java.
	 *
	 * @param s       the regular expression
	 * @param context the optional context message
	 * @returns       the tester function
	 * @throws        an error if the regex couldn't be created
	 */
	function regex(s, context) {
	    if (context === void 0) { context = ''; }
	    if (s === '') {
	        throw new Error('Empty regular expression [' + context + ']');
	    }
	    try {
	        var r_1 = new RegExp(s);
	        return function (test) {
	            // because JS regex will match any part of the test string,
	            // we have to verify the results to ensure the entire part matches
	            var m = r_1.exec(test);
	            return m && m[0] === test;
	        };
	    }
	    catch (e) {
	        throw new Error('Bad regular expression [' + e.message + ', ' + context + ']');
	    }
	}
	exports.regex = regex;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.String
	 *
	 * @brief Utility functions for string manipulation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Split a string around a given delimiter.
	 *
	 * This differs from String.split in two ways:
	 *
	 * - If the input string is empty, this function will return an empty array,
	 *   not a  single-element array containing an empty string.
	 * - The string will be split into substrings that terminate with the specified
	 *   delimiter, rather than splitting immediately when a delimiter is found.
	 *
	 * **Example:**
	 * ```
	 * split("foo/bar/", "/"); // Returns ["foo", "bar"];
	 * ```
	 *
	 * **Example:**
	 * ```
	 * split("foo///", "//"); // Returns ["foo/"];
	 * ```
	 *
	 * @param str   the value to split
	 * @param delim the delimiter to split on
	 * @returns     the split parts
	 */
	function split(str, delim) {
	    if (str === '') {
	        return [];
	    }
	    var parts = [];
	    var l = delim.length;
	    var i = str.lastIndexOf(delim);
	    while (i > -1) {
	        parts.push(str.substring(i + l, str.length));
	        str = str.substring(0, i);
	        i = str.lastIndexOf(delim);
	    }
	    parts.push(str);
	    return parts.reverse();
	}
	exports.split = split;
	/**
	 * check if the string is a quote mark
	 *
	 * @param  c the string to check
	 * @return   `true` if the string is either a single ' or double " quote
	 */
	function isQuote(c) {
	    return c === '\'' || c === '"';
	}
	/**
	 * Converts a formatted multi value property to an array.
	 *
	 * Unescapes any escaped characters in the string.
	 *
	 * @param stringValue the string with quoted substrings separated by whitespace or
	 *                    commas
	 * @return            array of strings
	 */
	function stringToArray(stringValue) {
	    var arr = [];
	    var part = '';
	    var pos = 0;
	    var escaped = false;
	    OUTER_LOOP: for (; pos < stringValue.length; pos++) {
	        var c = stringValue[pos];
	        if (isQuote(c)) {
	            pos++;
	            part = '';
	            escaped = false;
	            for (; pos < stringValue.length; pos++) {
	                var vc = stringValue[pos];
	                if (escaped) {
	                    part += vc;
	                    escaped = false;
	                }
	                else if (vc === '\\') {
	                    escaped = true;
	                }
	                else if (vc === c) {
	                    arr.push(part);
	                    continue OUTER_LOOP;
	                }
	                else {
	                    part += vc;
	                }
	            }
	            throw new Error('Mis-quoted input');
	        }
	    }
	    return arr;
	}
	exports.stringToArray = stringToArray;
	/**
	 * Inserts an escape character '\' before any of the special characters ' "
	 * or \.
	 * @param s the string to be escaped
	 * @returns {String} the string value with escape characters inserted as appropriate
	 */
	function escape(s) {
	    for (var i = 0; i < s.length; i++) {
	        var ci = s.charAt(i);
	        if (ci === '"' || ci === '\\' || ci === '\'') {
	            var sb = '';
	            for (var j = 0; j < s.length; j++) {
	                var cj = s.charAt(j);
	                switch (cj) {
	                    case '\\':
	                        sb += '\\\\';
	                        break;
	                    case '"':
	                        sb += '\\"';
	                        break;
	                    case '\'':
	                        sb += '\\\'';
	                        break;
	                    default:
	                        sb += cj;
	                        break;
	                }
	            }
	            return sb;
	        }
	    }
	    return s;
	}
	exports.escape = escape;
	/**
	 * Converts a formatted multi value property to an immutable set.
	 *
	 * Unescapes any escaped characters in the string.
	 * @param stringValue the string with quoted substrings separated by whitespace or
	 *                    commas
	 * @return            set of strings
	 */
	function stringToSet(stringValue) {
	    return new Set(stringToArray(stringValue));
	}
	exports.stringToSet = stringToSet;
	/**
	 * Converts a set of values to a canonicalised property string
	 * representation, escaping as required.
	 *
	 * Uses comma separators and single quotes.
	 *
	 * @param values a set of strings
	 * @return       a string with each of the members escaped, quoted and concatenated
	 */
	function collectionToString(values) {
	    var arr = [];
	    values.forEach(function (s) {
	        arr.push('\"' + escape(s) + '\"');
	    });
	    return arr.join(',');
	}
	exports.collectionToString = collectionToString;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module V4Stack
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var buffer_input_stream_1 = __webpack_require__(125);
	var buffer_output_stream_1 = __webpack_require__(80);
	var credentials_serialiser_1 = __webpack_require__(232);
	/**
	 * Tunnel a V5 credentials object as an encoded string within v4 password.
	 *
	 * Currently only supports an empty or string password.
	 *
	 * This implementation encapsulates code from both V4CredentialsTunnel and
	 * CredentialsSerialiser in the Java client.
	 *
	 * @param password  the password to tunnel
	 * @return          an encoded password
	 */
	function encodeAsString(password) {
	    var bos = new buffer_output_stream_1.BufferOutputStream();
	    credentials_serialiser_1.write(bos, password);
	    return bos.getBase64();
	}
	exports.encodeAsString = encodeAsString;
	/**
	 * Unpack V5 credentials from a string.
	 *
	 * @param s  the string
	 * @return  the v5 credentials
	 */
	function decodeAsString(s) {
	    if (s) {
	        var bis = new buffer_input_stream_1.BufferInputStream(Buffer.from(s, 'base64'));
	        return credentials_serialiser_1.read(bis);
	    }
	    else {
	        return null;
	    }
	}
	exports.decodeAsString = decodeAsString;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_type_1 = __webpack_require__(69);
	/**
	 * A parameterised query that can be used to search the topic tree.
	 *
	 * A new request can be created using the {@link Session.fetchRequest fetchRequest}
	 * method and modified to specify a range of topics and/or
	 * various levels of detail. The request can then be issued to the server
	 * using the {@link FetchRequest.fetch fetch} method
	 * supplying a topic selector which specifies the selection of topics.
	 * The results are returned via a {@link Result}.
	 *
	 * As a minimum, the path and type of each selected topic will be returned.
	 * It is also possible to request that the topic {@link withValues values}
	 * and/or {@link withProperties properties} are returned.
	 *
	 * If values are selected then the topic types selected are naturally
	 * constrained by the provided `dataType` argument. So if
	 * {@link DataTypes.string} is specified, only {@link TopicTypeEnum.STRING
	 * STRING} topics will be selected. However, if {@link DataTypes.json} is
	 * specified, all types compatible with {@link JSON} will be selected
	 * including {@link TopicTypeEnum.STRING STRING}, {@link TopicTypeEnum.INT64 INT64}
	 * and {@link TopicTypeEnum.DOUBLE DOUBLE}. See
	 * {@link DataType.canReadAs} for the class hierarchy of types.
	 *
	 * To select topic types when
	 * values are not required, or to further constrain the selection when
	 * values are required, it is also possible to specify exactly which
	 * {@link TopicTypeEnum topic types} to select.
	 *
	 * The topics selected by the topic selector can be further restricted by
	 * range. A range is defined by a start path and an end path, and contains
	 * all paths in-between in path order. Given a topic tree containing the
	 * topics:
	 *
	 * ```
	 * a, a/b, a/c, a/c/x, a/c/y, a/d, a/e, b, b/a/x, b/b/x, c
	 * ```
	 *
	 * The range from `a/c/y` to `b/a/x` includes the topics with paths:
	 *
	 * ```
	 * a/c/x, a/c/y, a/d, a/e, b, b/a/x
	 * ```
	 *
	 * The start point of a range can be specified using {@link from} or
	 * {@link after} and an end point using {@link to} or
	 * {@link before}. {@link from} and {@link to} include any
	 * topic with the specified path in the selection, whereas {@link after}
	 * and {@link before} are non-inclusive and useful for paging
	 * through a potentially large range of topics. If no start point is
	 * specified, the start point is assumed to be the first topic of the topic
	 * tree, ordered by path name. Similarly, if no end point is specified, the
	 * end point is the last topic of the topic tree.
	 *
	 * A limit on the number of results returned can be specified using
	 * {@link first}. This is advisable if the result set could
	 * potentially be large. The number of results returned is also limited by
	 * the session's maximum message size – see {@link maximumResultSize}. The
	 * result indicates whether the results have been limited via the
	 * {@link FetchResult.hasMore hasMore} method. If `hasMore()`
	 * returns `true`, further results can be retrieved by modifying the original
	 * query to request results {@link after} the last path received.
	 *
	 * By default, results are returned in path order, earliest path first,
	 * starting from the beginning of any range specified. It is also possible
	 * to request results from the end of the range indicated by specifying a
	 * limit to the number of results using {@link last}. This method
	 * complements {@link first}, returning up to the specified number of
	 * results from the end of the range, but in reverse path order. This is
	 * useful for paging backwards through a range of topics.
	 *
	 * It can be useful to explore an unknown topic tree in a breadth-first
	 * manner rather than the path order. This can be achieved using
	 * {@link limitDeepBranches}.
	 *
	 * {@link TopicTypeEnum.ROUTING Routing} topics are deprecated and <b>not</b>
	 * supported, and if encountered will be ignored (i.e. treated as if they did
	 * not exist).
	 *
	 * FetchRequest instances are immutable and can be safely shared and reused.
	 *
	 * @since 6.2
	 */
	var FetchRequest = /** @class */ (function () {
	    function FetchRequest() {
	    }
	    /**
	     * Return a set of all topic types that can be fetched.
	     *
	     * @returns  the topic types that can be fetched by a FetchRequest
	     */
	    FetchRequest.getAllTypes = function () {
	        return new Set([
	            topic_type_1.TopicTypeEnum.JSON,
	            topic_type_1.TopicTypeEnum.BINARY,
	            topic_type_1.TopicTypeEnum.RECORD_V2,
	            topic_type_1.TopicTypeEnum.DOUBLE,
	            topic_type_1.TopicTypeEnum.INT64,
	            topic_type_1.TopicTypeEnum.STRING,
	            topic_type_1.TopicTypeEnum.TIME_SERIES
	        ]);
	    };
	    return FetchRequest;
	}());
	exports.FetchRequest = FetchRequest;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(245),
	    baseLodash = __webpack_require__(357);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(571),
	    isArguments = __webpack_require__(370),
	    isArray = __webpack_require__(39),
	    isBuffer = __webpack_require__(371),
	    isIndex = __webpack_require__(362),
	    isTypedArray = __webpack_require__(597);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(560),
	    eq = __webpack_require__(368);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(247),
	    keys = __webpack_require__(191);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(577);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(351),
	    arrayEach = __webpack_require__(243),
	    assignValue = __webpack_require__(558),
	    baseAssign = __webpack_require__(559),
	    baseAssignIn = __webpack_require__(1511),
	    cloneBuffer = __webpack_require__(1537),
	    copyArray = __webpack_require__(185),
	    copySymbols = __webpack_require__(1542),
	    copySymbolsIn = __webpack_require__(1543),
	    getAllKeys = __webpack_require__(580),
	    getAllKeysIn = __webpack_require__(1554),
	    getTag = __webpack_require__(186),
	    initCloneArray = __webpack_require__(1566),
	    initCloneByTag = __webpack_require__(1567),
	    initCloneObject = __webpack_require__(1568),
	    isArray = __webpack_require__(39),
	    isBuffer = __webpack_require__(371),
	    isMap = __webpack_require__(1621),
	    isObject = __webpack_require__(91),
	    isSet = __webpack_require__(1622),
	    keys = __webpack_require__(191),
	    keysIn = __webpack_require__(374);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(354),
	    isFlattenable = __webpack_require__(1570);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(572),
	    toKey = __webpack_require__(187);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(354),
	    isArray = __webpack_require__(39);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1513),
	    baseIsNaN = __webpack_require__(1522),
	    strictIndexOf = __webpack_require__(1600);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1519),
	    isObjectLike = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(364),
	    nativeKeys = __webpack_require__(1587);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(188),
	    overRest = __webpack_require__(588),
	    setToString = __webpack_require__(367);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(188),
	    metaMap = __webpack_require__(586);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(39),
	    isKey = __webpack_require__(363),
	    stringToPath = __webpack_require__(592),
	    toString = __webpack_require__(602);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 573 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(573),
	    composeArgsRight = __webpack_require__(574),
	    countHolders = __webpack_require__(1545),
	    createCtor = __webpack_require__(248),
	    createRecurry = __webpack_require__(576),
	    getHolder = __webpack_require__(582),
	    reorder = __webpack_require__(1591),
	    replaceHolders = __webpack_require__(366),
	    root = __webpack_require__(41);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(1572),
	    setData = __webpack_require__(589),
	    setWrapToString = __webpack_require__(590);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1508),
	    arraySome = __webpack_require__(1510),
	    cacheHas = __webpack_require__(1535);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(564),
	    getSymbols = __webpack_require__(361),
	    keys = __webpack_require__(191);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(586),
	    noop = __webpack_require__(1628);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(354),
	    getPrototype = __webpack_require__(360),
	    getSymbols = __webpack_require__(361),
	    stubArray = __webpack_require__(599);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(556);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(352);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(570),
	    shortOut = __webpack_require__(591);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(1559),
	    insertWrapDetails = __webpack_require__(1569),
	    setToString = __webpack_require__(367),
	    updateWrapDetails = __webpack_require__(1602);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1585);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(369),
	    func = convert('filter', __webpack_require__(1609));
	
	func.placeholder = __webpack_require__(251);
	module.exports = func;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(369),
	    func = convert('forEach', __webpack_require__(1612));
	
	func.placeholder = __webpack_require__(251);
	module.exports = func;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    getPrototype = __webpack_require__(360),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1525),
	    baseUnary = __webpack_require__(246),
	    nodeUtil = __webpack_require__(365);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 598 */,
/* 599 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1635);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1534),
	    isObject = __webpack_require__(91),
	    isSymbol = __webpack_require__(190);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1533);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STORAGE_ITEM_NAME = exports.STORAGE_ITEM_NAME = 'rp-userPreference';
	var UPDATE_TARGETING = exports.UPDATE_TARGETING = 'updateTargeting';
	
	var HIDE_OFFER_CLASS = exports.HIDE_OFFER_CLASS = 'hideOfferComponent';
	var BETTING_SPECIAL_OFFER_CLASS = exports.BETTING_SPECIAL_OFFER_CLASS = '.rp-resultsBettingsOffer';

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(253);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(1704);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(552).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(736);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(259).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(162);
	util.inherits = __webpack_require__(149);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1878);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1706);
	var destroyImpl = __webpack_require__(735);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(151);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(737).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(151);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(737).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)))

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(151);
	
	/*<replacement>*/
	var util = __webpack_require__(162);
	util.inherits = __webpack_require__(149);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(253);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(162);
	util.inherits = __webpack_require__(149);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1873)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(736);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(259).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(735);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(151);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(151);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82), __webpack_require__(763).setImmediate, (function() { return this; }())))

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(253);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(552).EventEmitter;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(259).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 742 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = createStrategy;
	var CONFIGURATION_DOM_SELECTOR = '.js-diffusionTopicSettings';
	var CONFIGURATION_API_URL_PROPERTY = 'data-diffusion-stub-url';
	var CONFIGURATION_HOST_PROPERTY = 'data-diffusion-host';
	var CONFIGURATION_PORT_PROPERTY = 'data-diffusion-port';
	var CONFIGURATION_SECURE_PROPERTY = 'data-diffusion-secure';
	var CONFIGURATION_PRINCIPAL_PROPERTY = 'data-diffusion-principal';
	var CONFIGURATION_CREDENTIALS_PROPERTY = 'data-diffusion-credentials';
	
	function createStrategy() {
	    return {
	        getConfig: function getConfig() {
	            var diffusionServerConfig = global.document.querySelector(CONFIGURATION_DOM_SELECTOR);
	
	            if (!diffusionServerConfig) {
	                throw new Error('There is no diffusion configuration node');
	            }
	
	            var host = diffusionServerConfig.getAttribute(CONFIGURATION_HOST_PROPERTY);
	            var port = diffusionServerConfig.getAttribute(CONFIGURATION_PORT_PROPERTY);
	            var secure = diffusionServerConfig.getAttribute(CONFIGURATION_SECURE_PROPERTY);
	            var principal = diffusionServerConfig.getAttribute(CONFIGURATION_PRINCIPAL_PROPERTY);
	            var credentials = diffusionServerConfig.getAttribute(CONFIGURATION_CREDENTIALS_PROPERTY);
	
	            return {
	                host: host,
	                port: Number(port),
	                secure: secure === 'true', // we are taking it as a string, but we need boolean
	                principal: principal,
	                credentials: credentials
	            };
	        },
	        getStubConfig: function getStubConfig() {
	            var diffusionServerConfig = global.document.querySelector(CONFIGURATION_DOM_SELECTOR);
	            var url = diffusionServerConfig ? diffusionServerConfig.getAttribute(CONFIGURATION_API_URL_PROPERTY) + 'api/' : null;
	            return {
	                url: url
	            };
	        }
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getProvider = getProvider;
	exports.log = log;
	exports.getStub = getStub;
	
	var _diffusion = __webpack_require__(1818);
	
	var _diffusion2 = _interopRequireDefault(_diffusion);
	
	var _stub = __webpack_require__(1822);
	
	var _stub2 = _interopRequireDefault(_stub);
	
	var _cookie = __webpack_require__(382);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stubImplementation = (0, _stub2.default)();
	var diffusionImplementation = (0, _diffusion2.default)();
	function getImplementation() {
	    var diffusionStubEnabled = (0, _cookie2.default)('DiffusionStubEnable') === 'true';
	    var apiStubsEnabled = Boolean((0, _cookie2.default)('apiStubs'));
	
	    return diffusionStubEnabled || apiStubsEnabled ? stubImplementation : diffusionImplementation;
	}
	
	function getProvider() {
	    return getImplementation().provider;
	}
	
	function log() {
	    var _getImplementation;
	
	    (_getImplementation = getImplementation()).log.apply(_getImplementation, arguments);
	}
	
	function getStub() {
	    return stubImplementation;
	}

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */
/***/ (function(module, exports) {

	/*
	 * angular-elastic v2.5.1
	 * (c) 2014 Monospaced http://monospaced.com
	 * License: MIT
	 */
	
	if (typeof module !== 'undefined' &&
	    typeof exports !== 'undefined' &&
	    module.exports === exports){
	  module.exports = 'monospaced.elastic';
	}
	
	angular.module('monospaced.elastic', [])
	
	  .constant('msdElasticConfig', {
	    append: ''
	  })
	
	  .directive('msdElastic', [
	    '$timeout', '$window', 'msdElasticConfig',
	    function($timeout, $window, config) {
	      'use strict';
	
	      return {
	        require: 'ngModel',
	        restrict: 'A, C',
	        link: function(scope, element, attrs, ngModel) {
	
	          // cache a reference to the DOM element
	          var ta = element[0],
	              $ta = element;
	
	          // ensure the element is a textarea, and browser is capable
	          if (ta.nodeName !== 'TEXTAREA' || !$window.getComputedStyle) {
	            return;
	          }
	
	          // set these properties before measuring dimensions
	          $ta.css({
	            'overflow': 'hidden',
	            'overflow-y': 'hidden',
	            'word-wrap': 'break-word'
	          });
	
	          // force text reflow
	          var text = ta.value;
	          ta.value = '';
	          ta.value = text;
	
	          var append = attrs.msdElastic ? attrs.msdElastic.replace(/\\n/g, '\n') : config.append,
	              $win = angular.element($window),
	              mirrorInitStyle = 'position: absolute; top: -999px; right: auto; bottom: auto;' +
	                                'left: 0; overflow: hidden; -webkit-box-sizing: content-box;' +
	                                '-moz-box-sizing: content-box; box-sizing: content-box;' +
	                                'min-height: 0 !important; height: 0 !important; padding: 0;' +
	                                'word-wrap: break-word; border: 0;',
	              $mirror = angular.element('<textarea aria-hidden="true" tabindex="-1" ' +
	                                        'style="' + mirrorInitStyle + '"/>').data('elastic', true),
	              mirror = $mirror[0],
	              taStyle = getComputedStyle(ta),
	              resize = taStyle.getPropertyValue('resize'),
	              borderBox = taStyle.getPropertyValue('box-sizing') === 'border-box' ||
	                          taStyle.getPropertyValue('-moz-box-sizing') === 'border-box' ||
	                          taStyle.getPropertyValue('-webkit-box-sizing') === 'border-box',
	              boxOuter = !borderBox ? {width: 0, height: 0} : {
	                            width:  parseInt(taStyle.getPropertyValue('border-right-width'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-right'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-left'), 10) +
	                                    parseInt(taStyle.getPropertyValue('border-left-width'), 10),
	                            height: parseInt(taStyle.getPropertyValue('border-top-width'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-top'), 10) +
	                                    parseInt(taStyle.getPropertyValue('padding-bottom'), 10) +
	                                    parseInt(taStyle.getPropertyValue('border-bottom-width'), 10)
	                          },
	              minHeightValue = parseInt(taStyle.getPropertyValue('min-height'), 10),
	              heightValue = parseInt(taStyle.getPropertyValue('height'), 10),
	              minHeight = Math.max(minHeightValue, heightValue) - boxOuter.height,
	              maxHeight = parseInt(taStyle.getPropertyValue('max-height'), 10),
	              mirrored,
	              active,
	              copyStyle = ['font-family',
	                           'font-size',
	                           'font-weight',
	                           'font-style',
	                           'letter-spacing',
	                           'line-height',
	                           'text-transform',
	                           'word-spacing',
	                           'text-indent'];
	
	          // exit if elastic already applied (or is the mirror element)
	          if ($ta.data('elastic')) {
	            return;
	          }
	
	          // Opera returns max-height of -1 if not set
	          maxHeight = maxHeight && maxHeight > 0 ? maxHeight : 9e4;
	
	          // append mirror to the DOM
	          if (mirror.parentNode !== document.body) {
	            angular.element(document.body).append(mirror);
	          }
	
	          // set resize and apply elastic
	          $ta.css({
	            'resize': (resize === 'none' || resize === 'vertical') ? 'none' : 'horizontal'
	          }).data('elastic', true);
	
	          /*
	           * methods
	           */
	
	          function initMirror() {
	            var mirrorStyle = mirrorInitStyle;
	
	            mirrored = ta;
	            // copy the essential styles from the textarea to the mirror
	            taStyle = getComputedStyle(ta);
	            angular.forEach(copyStyle, function(val) {
	              mirrorStyle += val + ':' + taStyle.getPropertyValue(val) + ';';
	            });
	            mirror.setAttribute('style', mirrorStyle);
	          }
	
	          function adjust() {
	            var taHeight,
	                taComputedStyleWidth,
	                mirrorHeight,
	                width,
	                overflow;
	
	            if (mirrored !== ta) {
	              initMirror();
	            }
	
	            // active flag prevents actions in function from calling adjust again
	            if (!active) {
	              active = true;
	
	              mirror.value = ta.value + append; // optional whitespace to improve animation
	              mirror.style.overflowY = ta.style.overflowY;
	
	              taHeight = ta.style.height === '' ? 'auto' : parseInt(ta.style.height, 10);
	
	              taComputedStyleWidth = getComputedStyle(ta).getPropertyValue('width');
	
	              // ensure getComputedStyle has returned a readable 'used value' pixel width
	              if (taComputedStyleWidth.substr(taComputedStyleWidth.length - 2, 2) === 'px') {
	                // update mirror width in case the textarea width has changed
	                width = parseInt(taComputedStyleWidth, 10) - boxOuter.width;
	                mirror.style.width = width + 'px';
	              }
	
	              mirrorHeight = mirror.scrollHeight;
	
	              if (mirrorHeight > maxHeight) {
	                mirrorHeight = maxHeight;
	                overflow = 'scroll';
	              } else if (mirrorHeight < minHeight) {
	                mirrorHeight = minHeight;
	              }
	              mirrorHeight += boxOuter.height;
	              ta.style.overflowY = overflow || 'hidden';
	
	              if (taHeight !== mirrorHeight) {
	                scope.$emit('elastic:resize', $ta, taHeight, mirrorHeight);
	                ta.style.height = mirrorHeight + 'px';
	              }
	
	              // small delay to prevent an infinite loop
	              $timeout(function() {
	                active = false;
	              }, 1, false);
	
	            }
	          }
	
	          function forceAdjust() {
	            active = false;
	            adjust();
	          }
	
	          /*
	           * initialise
	           */
	
	          // listen
	          if ('onpropertychange' in ta && 'oninput' in ta) {
	            // IE9
	            ta['oninput'] = ta.onkeyup = adjust;
	          } else {
	            ta['oninput'] = adjust;
	          }
	
	          $win.bind('resize', forceAdjust);
	
	          scope.$watch(function() {
	            return ngModel.$modelValue;
	          }, function(newValue) {
	            forceAdjust();
	          });
	
	          scope.$on('elastic:adjust', function() {
	            initMirror();
	            forceAdjust();
	          });
	
	          $timeout(adjust, 0, false);
	
	          /*
	           * destroy
	           */
	
	          scope.$on('$destroy', function() {
	            $mirror.remove();
	            $win.unbind('resize', forceAdjust);
	          });
	        }
	      };
	    }
	  ]);


/***/ }),
/* 766 */,
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(770);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 768 */
149,
/* 769 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(769);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(768);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)))

/***/ }),
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(743);
	var zstream = __webpack_require__(1720);
	var zlib_deflate = __webpack_require__(1715);
	var zlib_inflate = __webpack_require__(1717);
	var constants = __webpack_require__(1714);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}
	
	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};
	
	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};
	
	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};
	
	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}
	
	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};
	
	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};
	
	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};
	
	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};
	
	exports.Zlib = Zlib;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82), __webpack_require__(19).Buffer))

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(222);
	__webpack_require__(1077);
	__webpack_require__(1080);
	__webpack_require__(1084);
	__webpack_require__(1067);
	__webpack_require__(1068);
	__webpack_require__(1069);
	__webpack_require__(1070);
	__webpack_require__(1071);
	__webpack_require__(1073);
	__webpack_require__(1072);
	__webpack_require__(1075);
	__webpack_require__(1074);
	__webpack_require__(1076);
	__webpack_require__(1078);
	__webpack_require__(1079);
	__webpack_require__(487);
	__webpack_require__(1081);
	__webpack_require__(1082);
	__webpack_require__(1083);
	__webpack_require__(1086);
	__webpack_require__(1085);
	__webpack_require__(1087);
	__webpack_require__(1088);
	__webpack_require__(1089);
	__webpack_require__(1090);
	__webpack_require__(1091);
	__webpack_require__(1092);
	__webpack_require__(1094);
	__webpack_require__(1093);
	var path = __webpack_require__(122);
	
	module.exports = path.Array;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1095);
	__webpack_require__(321);
	__webpack_require__(222);
	__webpack_require__(322);
	var path = __webpack_require__(122);
	
	module.exports = path.Map;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1096);
	__webpack_require__(1097);
	__webpack_require__(1098);
	__webpack_require__(1099);
	__webpack_require__(1100);
	__webpack_require__(1101);
	__webpack_require__(1102);
	__webpack_require__(1103);
	__webpack_require__(1104);
	__webpack_require__(1105);
	__webpack_require__(1106);
	__webpack_require__(1107);
	var path = __webpack_require__(122);
	
	module.exports = path.Number;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1108);
	var path = __webpack_require__(122);
	
	module.exports = path.Object.values;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(321);
	__webpack_require__(222);
	__webpack_require__(322);
	__webpack_require__(1110);
	__webpack_require__(488);
	__webpack_require__(1109);
	var path = __webpack_require__(122);
	
	module.exports = path.Promise;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1111);
	__webpack_require__(321);
	__webpack_require__(222);
	__webpack_require__(322);
	var path = __webpack_require__(122);
	
	module.exports = path.Set;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	var parent = __webpack_require__(1029);
	__webpack_require__(1113);
	__webpack_require__(1115);
	__webpack_require__(1114);
	
	module.exports = parent;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var parent = __webpack_require__(1030);
	__webpack_require__(1121);
	__webpack_require__(1129);
	__webpack_require__(1116);
	__webpack_require__(1117);
	__webpack_require__(1118);
	__webpack_require__(1120);
	__webpack_require__(1119);
	__webpack_require__(1122);
	__webpack_require__(1123);
	__webpack_require__(1124);
	__webpack_require__(1125);
	__webpack_require__(1126);
	__webpack_require__(1127);
	__webpack_require__(1128);
	__webpack_require__(1130);
	__webpack_require__(1131);
	__webpack_require__(1133);
	__webpack_require__(1134);
	// TODO: remove from `core-js@4`
	__webpack_require__(1132);
	
	module.exports = parent;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	var parent = __webpack_require__(1031);
	
	module.exports = parent;
	
	__webpack_require__(1135);


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var parent = __webpack_require__(1032);
	
	module.exports = parent;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var parent = __webpack_require__(1033);
	__webpack_require__(1112);
	// TODO: Remove from `core-js@4`
	__webpack_require__(1136);
	__webpack_require__(1138);
	__webpack_require__(1137);
	
	module.exports = parent;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	var parent = __webpack_require__(1034);
	__webpack_require__(1145);
	__webpack_require__(1152);
	__webpack_require__(1139);
	__webpack_require__(1140);
	__webpack_require__(1142);
	__webpack_require__(1141);
	__webpack_require__(1143);
	__webpack_require__(1144);
	__webpack_require__(1146);
	__webpack_require__(1147);
	__webpack_require__(1148);
	__webpack_require__(1149);
	__webpack_require__(1150);
	__webpack_require__(1151);
	__webpack_require__(1153);
	__webpack_require__(1154);
	__webpack_require__(1155);
	__webpack_require__(1156);
	
	module.exports = parent;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(43);
	
	module.exports = function (it) {
	  if (!isObject(it) && it !== null) {
	    throw TypeError("Can't set " + String(it) + ' as a prototype');
	  } return it;
	};


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toObject = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(171);
	var toLength = __webpack_require__(38);
	
	var min = Math.min;
	
	// `Array.prototype.copyWithin` method implementation
	// https://tc39.github.io/ecma262/#sec-array.prototype.copywithin
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toObject = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(171);
	var toLength = __webpack_require__(38);
	
	// `Array.prototype.fill` method implementation
	// https://tc39.github.io/ecma262/#sec-array.prototype.fill
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var argumentsLength = arguments.length;
	  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
	  var end = argumentsLength > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $forEach = __webpack_require__(119).forEach;
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var STRICT_METHOD = arrayMethodIsStrict('forEach');
	var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');
	
	// `Array.prototype.forEach` method implementation
	// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
	module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
	  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	} : [].forEach;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(32);
	var toObject = __webpack_require__(50);
	var callWithSafeIterationClosing = __webpack_require__(456);
	var isArrayIteratorMethod = __webpack_require__(470);
	var toLength = __webpack_require__(38);
	var createProperty = __webpack_require__(166);
	var getIteratorMethod = __webpack_require__(309);
	
	// `Array.from` method implementation
	// https://tc39.github.io/ecma262/#sec-array.from
	module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	  var O = toObject(arrayLike);
	  var C = typeof this == 'function' ? this : Array;
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  var iteratorMethod = getIteratorMethod(O);
	  var index = 0;
	  var length, result, step, iterator, next, value;
	  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
	  // if the target is not iterable or it's an array with the default iterator - use a simple case
	  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
	    iterator = iteratorMethod.call(O);
	    next = iterator.next;
	    result = new C();
	    for (;!(step = next.call(iterator)).done; index++) {
	      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
	      createProperty(result, index, value);
	    }
	  } else {
	    length = toLength(O.length);
	    result = new C(length);
	    for (;length > index; index++) {
	      value = mapping ? mapfn(O[index], index) : O[index];
	      createProperty(result, index, value);
	    }
	  }
	  result.length = index;
	  return result;
	};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(100);
	var toInteger = __webpack_require__(87);
	var toLength = __webpack_require__(38);
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var min = Math.min;
	var nativeLastIndexOf = [].lastIndexOf;
	var NEGATIVE_ZERO = !!nativeLastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
	var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
	// For preventing possible almost infinite loop in non-standard implementations, test the forward version of the method
	var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });
	var FORCED = NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH;
	
	// `Array.prototype.lastIndexOf` method implementation
	// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
	module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	  // convert -0 to +0
	  if (NEGATIVE_ZERO) return nativeLastIndexOf.apply(this, arguments) || 0;
	  var O = toIndexedObject(this);
	  var length = toLength(O.length);
	  var index = length - 1;
	  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
	  if (index < 0) index = length + index;
	  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
	  return -1;
	} : nativeLastIndexOf;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	
	// https://github.com/tc39/collection-methods
	module.exports = function (/* ...elements */) {
	  var set = anObject(this);
	  var adder = aFunction(set.add);
	  for (var k = 0, len = arguments.length; k < len; k++) {
	    adder.call(set, arguments[k]);
	  }
	  return set;
	};


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var ownKeys = __webpack_require__(1062);
	var getOwnPropertyDescriptorModule = __webpack_require__(218);
	var definePropertyModule = __webpack_require__(49);
	
	module.exports = function (target, source) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	  }
	};


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	
	module.exports = !fails(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var IteratorPrototype = __webpack_require__(472).IteratorPrototype;
	var create = __webpack_require__(169);
	var createPropertyDescriptor = __webpack_require__(165);
	var setToStringTag = __webpack_require__(220);
	var Iterators = __webpack_require__(167);
	
	var returnThis = function () { return this; };
	
	module.exports = function (IteratorConstructor, NAME, next) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};


/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	module.exports = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(31);
	
	module.exports = !fails(function () {
	  return Object.isExtensible(Object.preventExtensions({}));
	});


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	
	module.exports = function (a, b) {
	  var console = global.console;
	  if (console && console.error) {
	    arguments.length === 1 ? console.error(a) : console.error(a, b);
	  }
	};


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var getOwnPropertyDescriptor = __webpack_require__(218).f;
	var classof = __webpack_require__(97);
	var macrotask = __webpack_require__(485).set;
	var IS_IOS = __webpack_require__(463);
	
	var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var IS_NODE = classof(process) == 'process';
	// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
	var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
	var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
	
	var flush, head, last, notify, toggle, node, promise, then;
	
	// modern engines have queueMicrotask method
	if (!queueMicrotask) {
	  flush = function () {
	    var parent, fn;
	    if (IS_NODE && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (error) {
	        if (head) notify();
	        else last = undefined;
	        throw error;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (IS_NODE) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
	  } else if (MutationObserver && !IS_IOS) {
	    toggle = true;
	    node = document.createTextNode('');
	    new MutationObserver(flush).observe(node, { characterData: true });
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    promise = Promise.resolve(undefined);
	    then = promise.then;
	    notify = function () {
	      then.call(promise, flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	}
	
	module.exports = queueMicrotask || function (fn) {
	  var task = { fn: fn, next: undefined };
	  if (last) last.next = task;
	  if (!head) {
	    head = task;
	    notify();
	  } last = task;
	};


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var inspectSource = __webpack_require__(311);
	
	var WeakMap = global.WeakMap;
	
	module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	
	var globalIsFinite = global.isFinite;
	
	// `Number.isFinite` method
	// https://tc39.github.io/ecma262/#sec-number.isfinite
	module.exports = Number.isFinite || function isFinite(it) {
	  return typeof it == 'number' && globalIsFinite(it);
	};


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(27);
	var trim = __webpack_require__(317).trim;
	var whitespaces = __webpack_require__(320);
	
	var $parseFloat = global.parseFloat;
	var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;
	
	// `parseFloat` method
	// https://tc39.github.io/ecma262/#sec-parsefloat-string
	module.exports = FORCED ? function parseFloat(string) {
	  var trimmedString = trim(String(string));
	  var result = $parseFloat(trimmedString);
	  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var definePropertyModule = __webpack_require__(49);
	var anObject = __webpack_require__(13);
	var objectKeys = __webpack_require__(479);
	
	// `Object.defineProperties` method
	// https://tc39.github.io/ecma262/#sec-object.defineproperties
	module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
	  return O;
	};


/***/ }),
/* 1059 */
207,
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(48);
	var objectKeys = __webpack_require__(479);
	var toIndexedObject = __webpack_require__(100);
	var propertyIsEnumerable = __webpack_require__(480).f;
	
	// `Object.{ entries, values }` methods implementation
	var createMethod = function (TO_ENTRIES) {
	  return function (it) {
	    var O = toIndexedObject(it);
	    var keys = objectKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
	        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};
	
	module.exports = {
	  // `Object.entries` method
	  // https://tc39.github.io/ecma262/#sec-object.entries
	  entries: createMethod(true),
	  // `Object.values` method
	  // https://tc39.github.io/ecma262/#sec-object.values
	  values: createMethod(false)
	};


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(318);
	var classof = __webpack_require__(457);
	
	// `Object.prototype.toString` method implementation
	// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
	module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	var getBuiltIn = __webpack_require__(34);
	var getOwnPropertyNamesModule = __webpack_require__(477);
	var getOwnPropertySymbolsModule = __webpack_require__(1059);
	var anObject = __webpack_require__(13);
	
	// all object keys, includes non-enumerable and symbols
	module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
	};


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	// `SameValueZero` abstract operation
	// https://tc39.github.io/ecma262/#sec-samevaluezero
	module.exports = function (x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y || x != x && y != y;
	};


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(87);
	var requireObjectCoercible = __webpack_require__(170);
	
	// `String.prototype.{ codePointAt, at }` methods implementation
	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = String(requireObjectCoercible($this));
	    var position = toInteger(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = S.charCodeAt(position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING ? S.charAt(position) : first
	        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};
	
	module.exports = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(87);
	var requireObjectCoercible = __webpack_require__(170);
	
	// `String.prototype.repeat` method implementation
	// https://tc39.github.io/ecma262/#sec-string.prototype.repeat
	module.exports = ''.repeat || function repeat(count) {
	  var str = String(requireObjectCoercible(this));
	  var result = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
	  return result;
	};


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	var NATIVE_SYMBOL = __webpack_require__(475);
	
	module.exports = NATIVE_SYMBOL
	  // eslint-disable-next-line no-undef
	  && !Symbol.sham
	  // eslint-disable-next-line no-undef
	  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var fails = __webpack_require__(31);
	var isArray = __webpack_require__(121);
	var isObject = __webpack_require__(43);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(38);
	var createProperty = __webpack_require__(166);
	var arraySpeciesCreate = __webpack_require__(164);
	var arrayMethodHasSpeciesSupport = __webpack_require__(163);
	var wellKnownSymbol = __webpack_require__(35);
	var V8_VERSION = __webpack_require__(307);
	
	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
	var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
	
	// We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679
	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	
	var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');
	
	var isConcatSpreadable = function (O) {
	  if (!isObject(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray(O);
	};
	
	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
	
	// `Array.prototype.concat` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  concat: function concat(arg) { // eslint-disable-line no-unused-vars
	    var O = toObject(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;
	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];
	      if (isConcatSpreadable(E)) {
	        len = toLength(E.length);
	        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
	        createProperty(A, n++, E);
	      }
	    }
	    A.length = n;
	    return A;
	  }
	});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var copyWithin = __webpack_require__(1042);
	var addToUnscopables = __webpack_require__(76);
	
	// `Array.prototype.copyWithin` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.copywithin
	$({ target: 'Array', proto: true }, {
	  copyWithin: copyWithin
	});
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('copyWithin');


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $every = __webpack_require__(119).every;
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var STRICT_METHOD = arrayMethodIsStrict('every');
	var USES_TO_LENGTH = arrayMethodUsesToLength('every');
	
	// `Array.prototype.every` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.every
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var fill = __webpack_require__(1043);
	var addToUnscopables = __webpack_require__(76);
	
	// `Array.prototype.fill` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.fill
	$({ target: 'Array', proto: true }, {
	  fill: fill
	});
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('fill');


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $filter = __webpack_require__(119).filter;
	var arrayMethodHasSpeciesSupport = __webpack_require__(163);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
	// Edge 14- issue
	var USES_TO_LENGTH = arrayMethodUsesToLength('filter');
	
	// `Array.prototype.filter` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.filter
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $findIndex = __webpack_require__(119).findIndex;
	var addToUnscopables = __webpack_require__(76);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var FIND_INDEX = 'findIndex';
	var SKIPS_HOLES = true;
	
	var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);
	
	// Shouldn't skip holes
	if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.findIndex` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND_INDEX);


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $find = __webpack_require__(119).find;
	var addToUnscopables = __webpack_require__(76);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var FIND = 'find';
	var SKIPS_HOLES = true;
	
	var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);
	
	// Shouldn't skip holes
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.find` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.find
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND);


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var flattenIntoArray = __webpack_require__(465);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(38);
	var aFunction = __webpack_require__(21);
	var arraySpeciesCreate = __webpack_require__(164);
	
	// `Array.prototype.flatMap` method
	// https://github.com/tc39/proposal-flatMap
	$({ target: 'Array', proto: true }, {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A;
	    aFunction(callbackfn);
	    A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return A;
	  }
	});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var flattenIntoArray = __webpack_require__(465);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(38);
	var toInteger = __webpack_require__(87);
	var arraySpeciesCreate = __webpack_require__(164);
	
	// `Array.prototype.flat` method
	// https://github.com/tc39/proposal-flatMap
	$({ target: 'Array', proto: true }, {
	  flat: function flat(/* depthArg = 1 */) {
	    var depthArg = arguments.length ? arguments[0] : undefined;
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var forEach = __webpack_require__(1044);
	
	// `Array.prototype.forEach` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
	$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
	  forEach: forEach
	});


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var from = __webpack_require__(1045);
	var checkCorrectnessOfIteration = __webpack_require__(304);
	
	var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
	  Array.from(iterable);
	});
	
	// `Array.from` method
	// https://tc39.github.io/ecma262/#sec-array.from
	$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
	  from: from
	});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $includes = __webpack_require__(303).includes;
	var addToUnscopables = __webpack_require__(76);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });
	
	// `Array.prototype.includes` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('includes');


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $indexOf = __webpack_require__(303).indexOf;
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var nativeIndexOf = [].indexOf;
	
	var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
	var STRICT_METHOD = arrayMethodIsStrict('indexOf');
	var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });
	
	// `Array.prototype.indexOf` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
	$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? nativeIndexOf.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var isArray = __webpack_require__(121);
	
	// `Array.isArray` method
	// https://tc39.github.io/ecma262/#sec-array.isarray
	$({ target: 'Array', stat: true }, {
	  isArray: isArray
	});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IndexedObject = __webpack_require__(216);
	var toIndexedObject = __webpack_require__(100);
	var arrayMethodIsStrict = __webpack_require__(86);
	
	var nativeJoin = [].join;
	
	var ES3_STRINGS = IndexedObject != Object;
	var STRICT_METHOD = arrayMethodIsStrict('join', ',');
	
	// `Array.prototype.join` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.join
	$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
	  join: function join(separator) {
	    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var lastIndexOf = __webpack_require__(1046);
	
	// `Array.prototype.lastIndexOf` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.lastindexof
	$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
	  lastIndexOf: lastIndexOf
	});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $map = __webpack_require__(119).map;
	var arrayMethodHasSpeciesSupport = __webpack_require__(163);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
	// FF49- issue
	var USES_TO_LENGTH = arrayMethodUsesToLength('map');
	
	// `Array.prototype.map` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.map
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var fails = __webpack_require__(31);
	var createProperty = __webpack_require__(166);
	
	var ISNT_GENERIC = fails(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	});
	
	// `Array.of` method
	// https://tc39.github.io/ecma262/#sec-array.of
	// WebKit Array.of isn't generic
	$({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
	  of: function of(/* ...args */) {
	    var index = 0;
	    var argumentsLength = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(argumentsLength);
	    while (argumentsLength > index) createProperty(result, index, arguments[index++]);
	    result.length = argumentsLength;
	    return result;
	  }
	});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $reduceRight = __webpack_require__(455).right;
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var STRICT_METHOD = arrayMethodIsStrict('reduceRight');
	// For preventing possible almost infinite loop in non-standard implementations, test the forward version of the method
	var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });
	
	// `Array.prototype.reduceRight` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $reduce = __webpack_require__(455).left;
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var STRICT_METHOD = arrayMethodIsStrict('reduce');
	var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });
	
	// `Array.prototype.reduce` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var isArray = __webpack_require__(121);
	
	var nativeReverse = [].reverse;
	var test = [1, 2];
	
	// `Array.prototype.reverse` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.reverse
	// fix for Safari 12.0 bug
	// https://bugs.webkit.org/show_bug.cgi?id=188794
	$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
	  reverse: function reverse() {
	    // eslint-disable-next-line no-self-assign
	    if (isArray(this)) this.length = this.length;
	    return nativeReverse.call(this);
	  }
	});


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var isObject = __webpack_require__(43);
	var isArray = __webpack_require__(121);
	var toAbsoluteIndex = __webpack_require__(171);
	var toLength = __webpack_require__(38);
	var toIndexedObject = __webpack_require__(100);
	var createProperty = __webpack_require__(166);
	var wellKnownSymbol = __webpack_require__(35);
	var arrayMethodHasSpeciesSupport = __webpack_require__(163);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });
	
	var SPECIES = wellKnownSymbol('species');
	var nativeSlice = [].slice;
	var max = Math.max;
	
	// `Array.prototype.slice` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject(this);
	    var length = toLength(O.length);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
	    var Constructor, result, n;
	    if (isArray(O)) {
	      Constructor = O.constructor;
	      // cross-realm fallback
	      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject(Constructor)) {
	        Constructor = Constructor[SPECIES];
	        if (Constructor === null) Constructor = undefined;
	      }
	      if (Constructor === Array || Constructor === undefined) {
	        return nativeSlice.call(O, k, fin);
	      }
	    }
	    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
	    result.length = n;
	    return result;
	  }
	});


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var $some = __webpack_require__(119).some;
	var arrayMethodIsStrict = __webpack_require__(86);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var STRICT_METHOD = arrayMethodIsStrict('some');
	var USES_TO_LENGTH = arrayMethodUsesToLength('some');
	
	// `Array.prototype.some` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.some
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var aFunction = __webpack_require__(21);
	var toObject = __webpack_require__(50);
	var fails = __webpack_require__(31);
	var arrayMethodIsStrict = __webpack_require__(86);
	
	var test = [];
	var nativeSort = test.sort;
	
	// IE8-
	var FAILS_ON_UNDEFINED = fails(function () {
	  test.sort(undefined);
	});
	// V8 bug
	var FAILS_ON_NULL = fails(function () {
	  test.sort(null);
	});
	// Old WebKit
	var STRICT_METHOD = arrayMethodIsStrict('sort');
	
	var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD;
	
	// `Array.prototype.sort` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.sort
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? nativeSort.call(toObject(this))
	      : nativeSort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	var setSpecies = __webpack_require__(315);
	
	// `Array[@@species]` getter
	// https://tc39.github.io/ecma262/#sec-get-array-@@species
	setSpecies('Array');


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var toAbsoluteIndex = __webpack_require__(171);
	var toInteger = __webpack_require__(87);
	var toLength = __webpack_require__(38);
	var toObject = __webpack_require__(50);
	var arraySpeciesCreate = __webpack_require__(164);
	var createProperty = __webpack_require__(166);
	var arrayMethodHasSpeciesSupport = __webpack_require__(163);
	var arrayMethodUsesToLength = __webpack_require__(42);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
	var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });
	
	var max = Math.max;
	var min = Math.min;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
	var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';
	
	// `Array.prototype.splice` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.splice
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
	  splice: function splice(start, deleteCount /* , ...items */) {
	    var O = toObject(this);
	    var len = toLength(O.length);
	    var actualStart = toAbsoluteIndex(start, len);
	    var argumentsLength = arguments.length;
	    var insertCount, actualDeleteCount, A, k, from, to;
	    if (argumentsLength === 0) {
	      insertCount = actualDeleteCount = 0;
	    } else if (argumentsLength === 1) {
	      insertCount = 0;
	      actualDeleteCount = len - actualStart;
	    } else {
	      insertCount = argumentsLength - 2;
	      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
	    }
	    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
	      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
	    }
	    A = arraySpeciesCreate(O, actualDeleteCount);
	    for (k = 0; k < actualDeleteCount; k++) {
	      from = actualStart + k;
	      if (from in O) createProperty(A, k, O[from]);
	    }
	    A.length = actualDeleteCount;
	    if (insertCount < actualDeleteCount) {
	      for (k = actualStart; k < len - actualDeleteCount; k++) {
	        from = k + actualDeleteCount;
	        to = k + insertCount;
	        if (from in O) O[to] = O[from];
	        else delete O[to];
	      }
	      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
	    } else if (insertCount > actualDeleteCount) {
	      for (k = len - actualDeleteCount; k > actualStart; k--) {
	        from = k + actualDeleteCount - 1;
	        to = k + insertCount - 1;
	        if (from in O) O[to] = O[from];
	        else delete O[to];
	      }
	    }
	    for (k = 0; k < insertCount; k++) {
	      O[k + actualStart] = arguments[k + 2];
	    }
	    O.length = len - actualDeleteCount + insertCount;
	    return A;
	  }
	});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	// this method was added to unscopables after implementation
	// in popular engines, so it's moved to a separate module
	var addToUnscopables = __webpack_require__(76);
	
	addToUnscopables('flatMap');


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	// this method was added to unscopables after implementation
	// in popular engines, so it's moved to a separate module
	var addToUnscopables = __webpack_require__(76);
	
	addToUnscopables('flat');


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(462);
	var collectionStrong = __webpack_require__(461);
	
	// `Map` constructor
	// https://tc39.github.io/ecma262/#sec-map-objects
	module.exports = collection('Map', function (init) {
	  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(48);
	var global = __webpack_require__(27);
	var isForced = __webpack_require__(217);
	var redefine = __webpack_require__(99);
	var has = __webpack_require__(58);
	var classof = __webpack_require__(97);
	var inheritIfRequired = __webpack_require__(468);
	var toPrimitive = __webpack_require__(221);
	var fails = __webpack_require__(31);
	var create = __webpack_require__(169);
	var getOwnPropertyNames = __webpack_require__(477).f;
	var getOwnPropertyDescriptor = __webpack_require__(218).f;
	var defineProperty = __webpack_require__(49).f;
	var trim = __webpack_require__(317).trim;
	
	var NUMBER = 'Number';
	var NativeNumber = global[NUMBER];
	var NumberPrototype = NativeNumber.prototype;
	
	// Opera ~12 has broken Object#toString
	var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;
	
	// `ToNumber` abstract operation
	// https://tc39.github.io/ecma262/#sec-tonumber
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  var first, third, radix, maxCode, digits, length, index, code;
	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = it.charCodeAt(0);
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
	        default: return +it;
	      }
	      digits = it.slice(2);
	      length = digits.length;
	      for (index = 0; index < length; index++) {
	        code = digits.charCodeAt(index);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	// `Number` constructor
	// https://tc39.github.io/ecma262/#sec-number-constructor
	if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
	  var NumberWrapper = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var dummy = this;
	    return dummy instanceof NumberWrapper
	      // check on 1..constructor(foo) case
	      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
	        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
	  };
	  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES2015 (in case, if modules with ES2015 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
	      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
	    }
	  }
	  NumberWrapper.prototype = NumberPrototype;
	  NumberPrototype.constructor = NumberWrapper;
	  redefine(global, NUMBER, NumberWrapper);
	}


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	
	// `Number.EPSILON` constant
	// https://tc39.github.io/ecma262/#sec-number.epsilon
	$({ target: 'Number', stat: true }, {
	  EPSILON: Math.pow(2, -52)
	});


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var numberIsFinite = __webpack_require__(1056);
	
	// `Number.isFinite` method
	// https://tc39.github.io/ecma262/#sec-number.isfinite
	$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var isInteger = __webpack_require__(471);
	
	// `Number.isInteger` method
	// https://tc39.github.io/ecma262/#sec-number.isinteger
	$({ target: 'Number', stat: true }, {
	  isInteger: isInteger
	});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	
	// `Number.isNaN` method
	// https://tc39.github.io/ecma262/#sec-number.isnan
	$({ target: 'Number', stat: true }, {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var isInteger = __webpack_require__(471);
	
	var abs = Math.abs;
	
	// `Number.isSafeInteger` method
	// https://tc39.github.io/ecma262/#sec-number.issafeinteger
	$({ target: 'Number', stat: true }, {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
	  }
	});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	
	// `Number.MAX_SAFE_INTEGER` constant
	// https://tc39.github.io/ecma262/#sec-number.max_safe_integer
	$({ target: 'Number', stat: true }, {
	  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
	});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	
	// `Number.MIN_SAFE_INTEGER` constant
	// https://tc39.github.io/ecma262/#sec-number.min_safe_integer
	$({ target: 'Number', stat: true }, {
	  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
	});


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var parseFloat = __webpack_require__(1057);
	
	// `Number.parseFloat` method
	// https://tc39.github.io/ecma262/#sec-number.parseFloat
	$({ target: 'Number', stat: true, forced: Number.parseFloat != parseFloat }, {
	  parseFloat: parseFloat
	});


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var parseInt = __webpack_require__(476);
	
	// `Number.parseInt` method
	// https://tc39.github.io/ecma262/#sec-number.parseint
	$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
	  parseInt: parseInt
	});


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var toInteger = __webpack_require__(87);
	var thisNumberValue = __webpack_require__(486);
	var repeat = __webpack_require__(1065);
	var fails = __webpack_require__(31);
	
	var nativeToFixed = 1.0.toFixed;
	var floor = Math.floor;
	
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	var FORCED = nativeToFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToFixed.call({});
	});
	
	// `Number.prototype.toFixed` method
	// https://tc39.github.io/ecma262/#sec-number.prototype.tofixed
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  // eslint-disable-next-line max-statements
	  toFixed: function toFixed(fractionDigits) {
	    var number = thisNumberValue(this);
	    var fractDigits = toInteger(fractionDigits);
	    var data = [0, 0, 0, 0, 0, 0];
	    var sign = '';
	    var result = '0';
	    var e, z, j, k;
	
	    var multiply = function (n, c) {
	      var index = -1;
	      var c2 = c;
	      while (++index < 6) {
	        c2 += n * data[index];
	        data[index] = c2 % 1e7;
	        c2 = floor(c2 / 1e7);
	      }
	    };
	
	    var divide = function (n) {
	      var index = 6;
	      var c = 0;
	      while (--index >= 0) {
	        c += data[index];
	        data[index] = floor(c / n);
	        c = (c % n) * 1e7;
	      }
	    };
	
	    var dataToString = function () {
	      var index = 6;
	      var s = '';
	      while (--index >= 0) {
	        if (s !== '' || index === 0 || data[index] !== 0) {
	          var t = String(data[index]);
	          s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
	        }
	      } return s;
	    };
	
	    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
	    // eslint-disable-next-line no-self-compare
	    if (number != number) return 'NaN';
	    if (number <= -1e21 || number >= 1e21) return String(number);
	    if (number < 0) {
	      sign = '-';
	      number = -number;
	    }
	    if (number > 1e-21) {
	      e = log(number * pow(2, 69, 1)) - 69;
	      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = fractDigits;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        result = dataToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        result = dataToString() + repeat.call('0', fractDigits);
	      }
	    }
	    if (fractDigits > 0) {
	      k = result.length;
	      result = sign + (k <= fractDigits
	        ? '0.' + repeat.call('0', fractDigits - k) + result
	        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
	    } else {
	      result = sign + result;
	    } return result;
	  }
	});


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var fails = __webpack_require__(31);
	var thisNumberValue = __webpack_require__(486);
	
	var nativeToPrecision = 1.0.toPrecision;
	
	var FORCED = fails(function () {
	  // IE7-
	  return nativeToPrecision.call(1, undefined) !== '1';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToPrecision.call({});
	});
	
	// `Number.prototype.toPrecision` method
	// https://tc39.github.io/ecma262/#sec-number.prototype.toprecision
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toPrecision: function toPrecision(precision) {
	    return precision === undefined
	      ? nativeToPrecision.call(thisNumberValue(this))
	      : nativeToPrecision.call(thisNumberValue(this), precision);
	  }
	});


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var $values = __webpack_require__(1060).values;
	
	// `Object.values` method
	// https://tc39.github.io/ecma262/#sec-object.values
	$({ target: 'Object', stat: true }, {
	  values: function values(O) {
	    return $values(O);
	  }
	});


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var NativePromise = __webpack_require__(474);
	var fails = __webpack_require__(31);
	var getBuiltIn = __webpack_require__(34);
	var speciesConstructor = __webpack_require__(65);
	var promiseResolve = __webpack_require__(481);
	var redefine = __webpack_require__(99);
	
	// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
	var NON_GENERIC = !!NativePromise && fails(function () {
	  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
	});
	
	// `Promise.prototype.finally` method
	// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
	$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
	  'finally': function (onFinally) {
	    var C = speciesConstructor(this, getBuiltIn('Promise'));
	    var isFunction = typeof onFinally == 'function';
	    return this.then(
	      isFunction ? function (x) {
	        return promiseResolve(C, onFinally()).then(function () { return x; });
	      } : onFinally,
	      isFunction ? function (e) {
	        return promiseResolve(C, onFinally()).then(function () { throw e; });
	      } : onFinally
	    );
	  }
	});
	
	// patch native Promise.prototype for native async functions
	if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
	  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
	}


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var global = __webpack_require__(27);
	var getBuiltIn = __webpack_require__(34);
	var NativePromise = __webpack_require__(474);
	var redefine = __webpack_require__(99);
	var redefineAll = __webpack_require__(482);
	var setToStringTag = __webpack_require__(220);
	var setSpecies = __webpack_require__(315);
	var isObject = __webpack_require__(43);
	var aFunction = __webpack_require__(21);
	var anInstance = __webpack_require__(302);
	var classof = __webpack_require__(97);
	var inspectSource = __webpack_require__(311);
	var iterate = __webpack_require__(16);
	var checkCorrectnessOfIteration = __webpack_require__(304);
	var speciesConstructor = __webpack_require__(65);
	var task = __webpack_require__(485).set;
	var microtask = __webpack_require__(1054);
	var promiseResolve = __webpack_require__(481);
	var hostReportErrors = __webpack_require__(1053);
	var newPromiseCapabilityModule = __webpack_require__(168);
	var perform = __webpack_require__(219);
	var InternalStateModule = __webpack_require__(143);
	var isForced = __webpack_require__(217);
	var wellKnownSymbol = __webpack_require__(35);
	var V8_VERSION = __webpack_require__(307);
	
	var SPECIES = wellKnownSymbol('species');
	var PROMISE = 'Promise';
	var getInternalState = InternalStateModule.get;
	var setInternalState = InternalStateModule.set;
	var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
	var PromiseConstructor = NativePromise;
	var TypeError = global.TypeError;
	var document = global.document;
	var process = global.process;
	var $fetch = getBuiltIn('fetch');
	var newPromiseCapability = newPromiseCapabilityModule.f;
	var newGenericPromiseCapability = newPromiseCapability;
	var IS_NODE = classof(process) == 'process';
	var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
	var UNHANDLED_REJECTION = 'unhandledrejection';
	var REJECTION_HANDLED = 'rejectionhandled';
	var PENDING = 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	var HANDLED = 1;
	var UNHANDLED = 2;
	var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
	
	var FORCED = isForced(PROMISE, function () {
	  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
	  if (!GLOBAL_CORE_JS_PROMISE) {
	    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	    // We can't detect it synchronously, so just check versions
	    if (V8_VERSION === 66) return true;
	    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
	  }
	  // We need Promise#finally in the pure version for preventing prototype pollution
	  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
	  // We can't use @@species feature detection in V8 since it causes
	  // deoptimization and performance degradation
	  // https://github.com/zloirock/core-js/issues/679
	  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
	  // Detect correctness of subclassing with @@species support
	  var promise = PromiseConstructor.resolve(1);
	  var FakePromise = function (exec) {
	    exec(function () { /* empty */ }, function () { /* empty */ });
	  };
	  var constructor = promise.constructor = {};
	  constructor[SPECIES] = FakePromise;
	  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
	});
	
	var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
	  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
	});
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	
	var notify = function (promise, state, isReject) {
	  if (state.notified) return;
	  state.notified = true;
	  var chain = state.reactions;
	  microtask(function () {
	    var value = state.value;
	    var ok = state.state == FULFILLED;
	    var index = 0;
	    // variable length - can't use forEach
	    while (chain.length > index) {
	      var reaction = chain[index++];
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
	            state.rejection = HANDLED;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // can throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (error) {
	        if (domain && !exited) domain.exit();
	        reject(error);
	      }
	    }
	    state.reactions = [];
	    state.notified = false;
	    if (isReject && !state.rejection) onUnhandled(promise, state);
	  });
	};
	
	var dispatchEvent = function (name, promise, reason) {
	  var event, handler;
	  if (DISPATCH_EVENT) {
	    event = document.createEvent('Event');
	    event.promise = promise;
	    event.reason = reason;
	    event.initEvent(name, false, true);
	    global.dispatchEvent(event);
	  } else event = { promise: promise, reason: reason };
	  if (handler = global['on' + name]) handler(event);
	  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
	};
	
	var onUnhandled = function (promise, state) {
	  task.call(global, function () {
	    var value = state.value;
	    var IS_UNHANDLED = isUnhandled(state);
	    var result;
	    if (IS_UNHANDLED) {
	      result = perform(function () {
	        if (IS_NODE) {
	          process.emit('unhandledRejection', value, promise);
	        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
	      if (result.error) throw result.value;
	    }
	  });
	};
	
	var isUnhandled = function (state) {
	  return state.rejection !== HANDLED && !state.parent;
	};
	
	var onHandleUnhandled = function (promise, state) {
	  task.call(global, function () {
	    if (IS_NODE) {
	      process.emit('rejectionHandled', promise);
	    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
	  });
	};
	
	var bind = function (fn, promise, state, unwrap) {
	  return function (value) {
	    fn(promise, state, value, unwrap);
	  };
	};
	
	var internalReject = function (promise, state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  state.value = value;
	  state.state = REJECTED;
	  notify(promise, state, true);
	};
	
	var internalResolve = function (promise, state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    var then = isThenable(value);
	    if (then) {
	      microtask(function () {
	        var wrapper = { done: false };
	        try {
	          then.call(value,
	            bind(internalResolve, promise, wrapper, state),
	            bind(internalReject, promise, wrapper, state)
	          );
	        } catch (error) {
	          internalReject(promise, wrapper, error, state);
	        }
	      });
	    } else {
	      state.value = value;
	      state.state = FULFILLED;
	      notify(promise, state, false);
	    }
	  } catch (error) {
	    internalReject(promise, { done: false }, error, state);
	  }
	};
	
	// constructor polyfill
	if (FORCED) {
	  // 25.4.3.1 Promise(executor)
	  PromiseConstructor = function Promise(executor) {
	    anInstance(this, PromiseConstructor, PROMISE);
	    aFunction(executor);
	    Internal.call(this);
	    var state = getInternalState(this);
	    try {
	      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
	    } catch (error) {
	      internalReject(this, state, error);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    setInternalState(this, {
	      type: PROMISE,
	      done: false,
	      notified: false,
	      parent: false,
	      reactions: [],
	      rejection: false,
	      state: PENDING,
	      value: undefined
	    });
	  };
	  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
	    // `Promise.prototype.then` method
	    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
	    then: function then(onFulfilled, onRejected) {
	      var state = getInternalPromiseState(this);
	      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = IS_NODE ? process.domain : undefined;
	      state.parent = true;
	      state.reactions.push(reaction);
	      if (state.state != PENDING) notify(this, state, false);
	      return reaction.promise;
	    },
	    // `Promise.prototype.catch` method
	    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    var state = getInternalState(promise);
	    this.promise = promise;
	    this.resolve = bind(internalResolve, promise, state);
	    this.reject = bind(internalReject, promise, state);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === PromiseConstructor || C === PromiseWrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	
	  if (!IS_PURE && typeof NativePromise == 'function') {
	    nativeThen = NativePromise.prototype.then;
	
	    // wrap native Promise#then for native async functions
	    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
	      var that = this;
	      return new PromiseConstructor(function (resolve, reject) {
	        nativeThen.call(that, resolve, reject);
	      }).then(onFulfilled, onRejected);
	    // https://github.com/zloirock/core-js/issues/640
	    }, { unsafe: true });
	
	    // wrap fetch result
	    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
	      // eslint-disable-next-line no-unused-vars
	      fetch: function fetch(input /* , init */) {
	        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
	      }
	    });
	  }
	}
	
	$({ global: true, wrap: true, forced: FORCED }, {
	  Promise: PromiseConstructor
	});
	
	setToStringTag(PromiseConstructor, PROMISE, false, true);
	setSpecies(PROMISE);
	
	PromiseWrapper = getBuiltIn(PROMISE);
	
	// statics
	$({ target: PROMISE, stat: true, forced: FORCED }, {
	  // `Promise.reject` method
	  // https://tc39.github.io/ecma262/#sec-promise.reject
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    capability.reject.call(undefined, r);
	    return capability.promise;
	  }
	});
	
	$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
	  // `Promise.resolve` method
	  // https://tc39.github.io/ecma262/#sec-promise.resolve
	  resolve: function resolve(x) {
	    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
	  }
	});
	
	$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
	  // `Promise.all` method
	  // https://tc39.github.io/ecma262/#sec-promise.all
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aFunction(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        $promiseResolve.call(C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  },
	  // `Promise.race` method
	  // https://tc39.github.io/ecma262/#sec-promise.race
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aFunction(C.resolve);
	      iterate(iterable, function (promise) {
	        $promiseResolve.call(C, promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(462);
	var collectionStrong = __webpack_require__(461);
	
	// `Set` constructor
	// https://tc39.github.io/ecma262/#sec-set-objects
	module.exports = collection('Set', function (init) {
	  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(48);
	var getPrototypeOf = __webpack_require__(312);
	var setPrototypeOf = __webpack_require__(313);
	var create = __webpack_require__(169);
	var defineProperty = __webpack_require__(49);
	var createPropertyDescriptor = __webpack_require__(165);
	var iterate = __webpack_require__(16);
	var createNonEnumerableProperty = __webpack_require__(98);
	var InternalStateModule = __webpack_require__(143);
	
	var setInternalState = InternalStateModule.set;
	var getInternalAggregateErrorState = InternalStateModule.getterFor('AggregateError');
	
	var $AggregateError = function AggregateError(errors, message) {
	  var that = this;
	  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
	  if (setPrototypeOf) {
	    that = setPrototypeOf(new Error(message), getPrototypeOf(that));
	  }
	  var errorsArray = [];
	  iterate(errors, errorsArray.push, errorsArray);
	  if (DESCRIPTORS) setInternalState(that, { errors: errorsArray, type: 'AggregateError' });
	  else that.errors = errorsArray;
	  if (message !== undefined) createNonEnumerableProperty(that, 'message', String(message));
	  return that;
	};
	
	$AggregateError.prototype = create(Error.prototype, {
	  constructor: createPropertyDescriptor(5, $AggregateError),
	  message: createPropertyDescriptor(5, ''),
	  name: createPropertyDescriptor(5, 'AggregateError')
	});
	
	if (DESCRIPTORS) defineProperty.f($AggregateError.prototype, 'errors', {
	  get: function () {
	    return getInternalAggregateErrorState(this).errors;
	  },
	  configurable: true
	});
	
	$({ global: true }, {
	  AggregateError: $AggregateError
	});


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var isArray = __webpack_require__(121);
	
	var isFrozen = Object.isFrozen;
	
	var isFrozenStringArray = function (array, allowUndefined) {
	  if (!isFrozen || !isArray(array) || !isFrozen(array)) return false;
	  var index = 0;
	  var length = array.length;
	  var element;
	  while (index < length) {
	    element = array[index++];
	    if (!(typeof element === 'string' || (allowUndefined && typeof element === 'undefined'))) {
	      return false;
	    }
	  } return length !== 0;
	};
	
	// `Array.isTemplateObject` method
	// https://github.com/tc39/proposal-array-is-template-object
	$({ target: 'Array', stat: true }, {
	  isTemplateObject: function isTemplateObject(value) {
	    if (!isFrozenStringArray(value, true)) return false;
	    var raw = value.raw;
	    if (raw.length !== value.length || !isFrozenStringArray(raw, false)) return false;
	    return true;
	  }
	});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(48);
	var addToUnscopables = __webpack_require__(76);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(38);
	var defineProperty = __webpack_require__(49).f;
	
	// `Array.prototype.lastIndex` getter
	// https://github.com/keithamus/proposal-array-last
	if (DESCRIPTORS && !('lastIndex' in [])) {
	  defineProperty(Array.prototype, 'lastIndex', {
	    configurable: true,
	    get: function lastIndex() {
	      var O = toObject(this);
	      var len = toLength(O.length);
	      return len == 0 ? 0 : len - 1;
	    }
	  });
	
	  addToUnscopables('lastIndex');
	}


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(48);
	var addToUnscopables = __webpack_require__(76);
	var toObject = __webpack_require__(50);
	var toLength = __webpack_require__(38);
	var defineProperty = __webpack_require__(49).f;
	
	// `Array.prototype.lastIndex` accessor
	// https://github.com/keithamus/proposal-array-last
	if (DESCRIPTORS && !('lastItem' in [])) {
	  defineProperty(Array.prototype, 'lastItem', {
	    configurable: true,
	    get: function lastItem() {
	      var O = toObject(this);
	      var len = toLength(O.length);
	      return len == 0 ? undefined : O[len - 1];
	    },
	    set: function lastItem(value) {
	      var O = toObject(this);
	      var len = toLength(O.length);
	      return O[len == 0 ? 0 : len - 1] = value;
	    }
	  });
	
	  addToUnscopables('lastItem');
	}


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var collectionDeleteAll = __webpack_require__(458);
	
	// `Map.prototype.deleteAll` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  deleteAll: function deleteAll(/* ...elements */) {
	    return collectionDeleteAll.apply(this, arguments);
	  }
	});


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.every` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  every: function every(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return !iterate(iterator, function (key, value) {
	      if (!boundFunction(value, key, map)) return iterate.stop();
	    }, undefined, true, true).stopped;
	  }
	});


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var bind = __webpack_require__(32);
	var speciesConstructor = __webpack_require__(65);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.filter` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
	    var setter = aFunction(newMap.set);
	    iterate(iterator, function (key, value) {
	      if (boundFunction(value, key, map)) setter.call(newMap, key, value);
	    }, undefined, true, true);
	    return newMap;
	  }
	});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.findKey` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  findKey: function findKey(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return iterate(iterator, function (key, value) {
	      if (boundFunction(value, key, map)) return iterate.stop(key);
	    }, undefined, true, true).result;
	  }
	});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.find` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  find: function find(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return iterate(iterator, function (key, value) {
	      if (boundFunction(value, key, map)) return iterate.stop(value);
	    }, undefined, true, true).result;
	  }
	});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var from = __webpack_require__(459);
	
	// `Map.from` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	$({ target: 'Map', stat: true }, {
	  from: from
	});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var iterate = __webpack_require__(16);
	var aFunction = __webpack_require__(21);
	
	// `Map.groupBy` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', stat: true }, {
	  groupBy: function groupBy(iterable, keyDerivative) {
	    var newMap = new this();
	    aFunction(keyDerivative);
	    var has = aFunction(newMap.has);
	    var get = aFunction(newMap.get);
	    var set = aFunction(newMap.set);
	    iterate(iterable, function (element) {
	      var derivedKey = keyDerivative(element);
	      if (!has.call(newMap, derivedKey)) set.call(newMap, derivedKey, [element]);
	      else get.call(newMap, derivedKey).push(element);
	    });
	    return newMap;
	  }
	});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var getMapIterator = __webpack_require__(77);
	var sameValueZero = __webpack_require__(1063);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.includes` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  includes: function includes(searchElement) {
	    return iterate(getMapIterator(anObject(this)), function (key, value) {
	      if (sameValueZero(value, searchElement)) return iterate.stop();
	    }, undefined, true, true).stopped;
	  }
	});


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var iterate = __webpack_require__(16);
	var aFunction = __webpack_require__(21);
	
	// `Map.keyBy` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', stat: true }, {
	  keyBy: function keyBy(iterable, keyDerivative) {
	    var newMap = new this();
	    aFunction(keyDerivative);
	    var setter = aFunction(newMap.set);
	    iterate(iterable, function (element) {
	      setter.call(newMap, keyDerivative(element), element);
	    });
	    return newMap;
	  }
	});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.includes` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  keyOf: function keyOf(searchElement) {
	    return iterate(getMapIterator(anObject(this)), function (key, value) {
	      if (value === searchElement) return iterate.stop(key);
	    }, undefined, true, true).result;
	  }
	});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var bind = __webpack_require__(32);
	var speciesConstructor = __webpack_require__(65);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.mapKeys` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  mapKeys: function mapKeys(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
	    var setter = aFunction(newMap.set);
	    iterate(iterator, function (key, value) {
	      setter.call(newMap, boundFunction(value, key, map), value);
	    }, undefined, true, true);
	    return newMap;
	  }
	});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var bind = __webpack_require__(32);
	var speciesConstructor = __webpack_require__(65);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.mapValues` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  mapValues: function mapValues(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
	    var setter = aFunction(newMap.set);
	    iterate(iterator, function (key, value) {
	      setter.call(newMap, key, boundFunction(value, key, map));
	    }, undefined, true, true);
	    return newMap;
	  }
	});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.merge` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  // eslint-disable-next-line no-unused-vars
	  merge: function merge(iterable /* ...iterbles */) {
	    var map = anObject(this);
	    var setter = aFunction(map.set);
	    var i = 0;
	    while (i < arguments.length) {
	      iterate(arguments[i++], setter, map, true);
	    }
	    return map;
	  }
	});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var of = __webpack_require__(460);
	
	// `Map.of` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	$({ target: 'Map', stat: true }, {
	  of: of
	});


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Map.prototype.reduce` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    aFunction(callbackfn);
	    iterate(iterator, function (key, value) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = callbackfn(accumulator, value, key, map);
	      }
	    }, undefined, true, true);
	    if (noInitial) throw TypeError('Reduce of empty map with no initial value');
	    return accumulator;
	  }
	});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getMapIterator = __webpack_require__(77);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.some` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  some: function some(callbackfn /* , thisArg */) {
	    var map = anObject(this);
	    var iterator = getMapIterator(map);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return iterate(iterator, function (key, value) {
	      if (boundFunction(value, key, map)) return iterate.stop();
	    }, undefined, true, true).stopped;
	  }
	});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: remove from `core-js@4`
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var $upsert = __webpack_require__(473);
	
	// `Map.prototype.updateOrInsert` method (replaced by `Map.prototype.upsert`)
	// https://github.com/thumbsupep/proposal-upsert
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  updateOrInsert: $upsert
	});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	
	// `Set.prototype.update` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  update: function update(key, callback /* , thunk */) {
	    var map = anObject(this);
	    var length = arguments.length;
	    aFunction(callback);
	    var isPresentInMap = map.has(key);
	    if (!isPresentInMap && length < 3) {
	      throw TypeError('Updating absent value');
	    }
	    var value = isPresentInMap ? map.get(key) : aFunction(length > 2 ? arguments[2] : undefined)(key, map);
	    map.set(key, callback(value, key, map));
	    return map;
	  }
	});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var $upsert = __webpack_require__(473);
	
	// `Map.prototype.upsert` method
	// https://github.com/thumbsupep/proposal-upsert
	$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
	  upsert: $upsert
	});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var toInteger = __webpack_require__(87);
	var parseInt = __webpack_require__(476);
	
	var INVALID_NUMBER_REPRESENTATION = 'Invalid number representation';
	var INVALID_RADIX = 'Invalid radix';
	var valid = /^[\da-z]+$/;
	
	// `Number.fromString` method
	// https://github.com/tc39/proposal-number-fromstring
	$({ target: 'Number', stat: true }, {
	  fromString: function fromString(string, radix) {
	    var sign = 1;
	    var R, mathNum;
	    if (typeof string != 'string') throw TypeError(INVALID_NUMBER_REPRESENTATION);
	    if (!string.length) throw SyntaxError(INVALID_NUMBER_REPRESENTATION);
	    if (string.charAt(0) == '-') {
	      sign = -1;
	      string = string.slice(1);
	      if (!string.length) throw SyntaxError(INVALID_NUMBER_REPRESENTATION);
	    }
	    R = radix === undefined ? 10 : toInteger(radix);
	    if (R < 2 || R > 36) throw RangeError(INVALID_RADIX);
	    if (!valid.test(string) || (mathNum = parseInt(string, R)).toString(R) !== string) {
	      throw SyntaxError(INVALID_NUMBER_REPRESENTATION);
	    }
	    return sign * mathNum;
	  }
	});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	// TODO: Remove from `core-js@4`
	__webpack_require__(488);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var aFunction = __webpack_require__(21);
	var getBuiltIn = __webpack_require__(34);
	var newPromiseCapabilityModule = __webpack_require__(168);
	var perform = __webpack_require__(219);
	var iterate = __webpack_require__(16);
	
	var PROMISE_ANY_ERROR = 'No one promise resolved';
	
	// `Promise.any` method
	// https://github.com/tc39/proposal-promise-any
	$({ target: 'Promise', stat: true }, {
	  any: function any(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aFunction(C.resolve);
	      var errors = [];
	      var counter = 0;
	      var remaining = 1;
	      var alreadyResolved = false;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyRejected = false;
	        errors.push(undefined);
	        remaining++;
	        promiseResolve.call(C, promise).then(function (value) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyResolved = true;
	          resolve(value);
	        }, function (e) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyRejected = true;
	          errors[index] = e;
	          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
	        });
	      });
	      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var newPromiseCapabilityModule = __webpack_require__(168);
	var perform = __webpack_require__(219);
	
	// `Promise.try` method
	// https://github.com/tc39/proposal-promise-try
	$({ target: 'Promise', stat: true }, {
	  'try': function (callbackfn) {
	    var promiseCapability = newPromiseCapabilityModule.f(this);
	    var result = perform(callbackfn);
	    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
	    return promiseCapability.promise;
	  }
	});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var collectionAddAll = __webpack_require__(1047);
	
	// `Set.prototype.addAll` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  addAll: function addAll(/* ...elements */) {
	    return collectionAddAll.apply(this, arguments);
	  }
	});


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var collectionDeleteAll = __webpack_require__(458);
	
	// `Set.prototype.deleteAll` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  deleteAll: function deleteAll(/* ...elements */) {
	    return collectionDeleteAll.apply(this, arguments);
	  }
	});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var speciesConstructor = __webpack_require__(65);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  difference: function difference(iterable) {
	    var set = anObject(this);
	    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
	    var remover = aFunction(newSet['delete']);
	    iterate(iterable, function (value) {
	      remover.call(newSet, value);
	    });
	    return newSet;
	  }
	});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.every` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  every: function every(callbackfn /* , thisArg */) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return !iterate(iterator, function (value) {
	      if (!boundFunction(value, value, set)) return iterate.stop();
	    }, undefined, false, true).stopped;
	  }
	});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var bind = __webpack_require__(32);
	var speciesConstructor = __webpack_require__(65);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.filter` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
	    var adder = aFunction(newSet.add);
	    iterate(iterator, function (value) {
	      if (boundFunction(value, value, set)) adder.call(newSet, value);
	    }, undefined, false, true);
	    return newSet;
	  }
	});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.find` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  find: function find(callbackfn /* , thisArg */) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return iterate(iterator, function (value) {
	      if (boundFunction(value, value, set)) return iterate.stop(value);
	    }, undefined, false, true).result;
	  }
	});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var from = __webpack_require__(459);
	
	// `Set.from` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	$({ target: 'Set', stat: true }, {
	  from: from
	});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var speciesConstructor = __webpack_require__(65);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  intersection: function intersection(iterable) {
	    var set = anObject(this);
	    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
	    var hasCheck = aFunction(set.has);
	    var adder = aFunction(newSet.add);
	    iterate(iterable, function (value) {
	      if (hasCheck.call(set, value)) adder.call(newSet, value);
	    });
	    return newSet;
	  }
	});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.isDisjointFrom` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  isDisjointFrom: function isDisjointFrom(iterable) {
	    var set = anObject(this);
	    var hasCheck = aFunction(set.has);
	    return !iterate(iterable, function (value) {
	      if (hasCheck.call(set, value) === true) return iterate.stop();
	    }).stopped;
	  }
	});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var getIterator = __webpack_require__(310);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.isSubsetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  isSubsetOf: function isSubsetOf(iterable) {
	    var iterator = getIterator(this);
	    var otherSet = anObject(iterable);
	    var hasCheck = otherSet.has;
	    if (typeof hasCheck != 'function') {
	      otherSet = new (getBuiltIn('Set'))(iterable);
	      hasCheck = aFunction(otherSet.has);
	    }
	    return !iterate(iterator, function (value) {
	      if (hasCheck.call(otherSet, value) === false) return iterate.stop();
	    }, undefined, false, true).stopped;
	  }
	});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.isSupersetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  isSupersetOf: function isSupersetOf(iterable) {
	    var set = anObject(this);
	    var hasCheck = aFunction(set.has);
	    return !iterate(iterable, function (value) {
	      if (hasCheck.call(set, value) === false) return iterate.stop();
	    }).stopped;
	  }
	});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.join` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  join: function join(separator) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var sep = separator === undefined ? ',' : String(separator);
	    var result = [];
	    iterate(iterator, result.push, result, false, true);
	    return result.join(sep);
	  }
	});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var bind = __webpack_require__(32);
	var speciesConstructor = __webpack_require__(65);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.map` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  map: function map(callbackfn /* , thisArg */) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
	    var adder = aFunction(newSet.add);
	    iterate(iterator, function (value) {
	      adder.call(newSet, boundFunction(value, value, set));
	    }, undefined, false, true);
	    return newSet;
	  }
	});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(5);
	var of = __webpack_require__(460);
	
	// `Set.of` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	$({ target: 'Set', stat: true }, {
	  of: of
	});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.reduce` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    aFunction(callbackfn);
	    iterate(iterator, function (value) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = callbackfn(accumulator, value, value, set);
	      }
	    }, undefined, false, true);
	    if (noInitial) throw TypeError('Reduce of empty set with no initial value');
	    return accumulator;
	  }
	});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var anObject = __webpack_require__(13);
	var bind = __webpack_require__(32);
	var getSetIterator = __webpack_require__(120);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.some` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  some: function some(callbackfn /* , thisArg */) {
	    var set = anObject(this);
	    var iterator = getSetIterator(set);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	    return iterate(iterator, function (value) {
	      if (boundFunction(value, value, set)) return iterate.stop();
	    }, undefined, false, true).stopped;
	  }
	});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var speciesConstructor = __webpack_require__(65);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  symmetricDifference: function symmetricDifference(iterable) {
	    var set = anObject(this);
	    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
	    var remover = aFunction(newSet['delete']);
	    var adder = aFunction(newSet.add);
	    iterate(iterable, function (value) {
	      remover.call(newSet, value) || adder.call(newSet, value);
	    });
	    return newSet;
	  }
	});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(5);
	var IS_PURE = __webpack_require__(14);
	var getBuiltIn = __webpack_require__(34);
	var anObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var speciesConstructor = __webpack_require__(65);
	var iterate = __webpack_require__(16);
	
	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
	  union: function union(iterable) {
	    var set = anObject(this);
	    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
	    iterate(iterable, aFunction(newSet.add), newSet);
	    return newSet;
	  }
	});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* loglevel - https://github.com/pimterry/loglevel
	*
	* Copyright (c) 2013 Tim Perry
	* Licensed under the MIT license.
	*/
	(function (root, definition) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(this, function () {
	    "use strict";
	
	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	
	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	
	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	
	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	
	    // These private functions always need `this` to be set properly
	
	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	
	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }
	
	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	
	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      var storageKey = "loglevel";
	      if (name) {
	        storageKey += ":" + name;
	      }
	
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	
	          if (typeof window === undefinedType) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	
	      function getPersistedLevel() {
	          var storedLevel;
	
	          if (typeof window === undefinedType) return;
	
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	
	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	
	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	
	          return storedLevel;
	      }
	
	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */
	
	      self.name = name;
	
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	
	      self.methodFactory = factory || defaultMethodFactory;
	
	      self.getLevel = function () {
	          return currentLevel;
	      };
	
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	
	      self.setDefaultLevel = function (level) {
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	
	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	
	    /*
	     *
	     * Top-level API
	     *
	     */
	
	    var defaultLogger = new Logger();
	
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if (typeof name !== "string" || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	
	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	
	        return defaultLogger;
	    };
	
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	
	    return defaultLogger;
	}));


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(1035);
	__webpack_require__(1036);
	__webpack_require__(1037);
	__webpack_require__(1038);
	__webpack_require__(1039);
	__webpack_require__(1040);
	var InternalSessionFactory = __webpack_require__(1163);
	var datatypes_1 = __webpack_require__(78);
	var DiffusionGlobals = __webpack_require__(1186);
	var session_impl_1 = __webpack_require__(1439);
	var update_constraint_factory_1 = __webpack_require__(1445);
	var logger = __webpack_require__(17);
	var error_reason_1 = __webpack_require__(88);
	var client_control_options_1 = __webpack_require__(489);
	var security_1 = __webpack_require__(101);
	var session_lock_options_1 = __webpack_require__(173);
	var topic_selectors_1 = __webpack_require__(1474);
	var topic_update_1 = __webpack_require__(90);
	var topics_1 = __webpack_require__(148);
	logger.setLevel('warn');
	/**
	 * The top-level Diffusion API.
	 *
	 * Provides access to Session connections and global namespaces.
	 */ // export namespace diffusion {
	/**
	 * The version of this client library in the form major.minor.patch
	 */
	exports.version = '6.7.4';
	/**
	 * The build version of this client library
	 */
	exports.build = '20b9a1c6';
	/**
	 * Set the level of logging used by Diffusion. This will default to silent.
	 * Log levels are strings that represent different degrees of information to
	 * be logged. Available options are:
	 *
	 * * silent
	 * * error
	 * * warn
	 * * info
	 * * debug
	 * * trace
	 *
	 * @param level  the log level to use
	 */
	function log(level) {
	    // keyof typeof works only because LogLevel maps the keys onto themselves
	    logger.setLevel(level);
	}
	exports.log = log;
	/**
	 * Connect to a specified Diffusion server. This will return a {@link
	 * Result} that will complete successfully if a session can be connected, or
	 * fail if an error was encountered.
	 *
	 * If the result is successful, the fulfilled handler will be called with a
	 * {@link Session} instance. This session will be in a connected state and
	 * may be used for subsequent API calls.
	 *
	 * If the result fails, the rejected handler will be called with an error
	 * reason.
	 *
	 * If `sessionName` and `workerJs` is supplied, then the call will create a
	 * shared session inside a shared WebWorker. If a shared session with that name
	 * already exists, this function will return an instance of the existing
	 * session. Shared sessions can only be created when running in a browser
	 * environment that supports the SharedWorker. For more information regarding
	 * shared sessions, see {@link connectShared}.
	 *
	 * **Example:**
	 * ```
	 * diffusion.connect('example.server.com').then((session) => {
	 *     // Connected with a session
	 *     console.log('Connected!', session);
	 * }).catch((error) => {
	 *     // Connection failed
	 *     console.log('Failed to connect', error);
	 * });
	 * ```
	 *
	 * @param options      the options to construct the session with. If a string is
	 *                     supplied, it will be interpreted as the `host` option.
	 * @param sessionName  the name of the shared session
	 * @param workerJs     the location of the diffusion worker script
	 * @returns            a {@link Result} for this operation
	 */
	function connect(options, sessionName, workerJs) {
	    return session_impl_1.SessionImpl.create(InternalSessionFactory.create(sessionName, workerJs), options);
	}
	exports.connect = connect;
	/**
	 * Connect to a specified Diffusion server using a shared WebWorker session.
	 * This will return a {@link Result} that will complete successfully if a
	 * session can be connected, or fail if an error was encountered. Shared
	 * sessions can only be created when running in a browser environment that
	 * supports the SharedWorker.
	 *
	 * Shared sessions are identified by a name. If a shared session with that name
	 * already exists, this function will return an instance of the existing
	 * session. Otherwise the call will fail. Sessions can only be shared across
	 * scripts originating from a single domain. Otherwise the browser will create
	 * independent shared workers resulting in one shared session for each domain.
	 *
	 * The shared session will stay alive as long as there is an open browser tab
	 * that initiated a connection through the shared session. When the last tab is
	 * closed the shared worker holding the shared session will be terminated. The
	 * shared session is also expected to be terminated when the only tab holding a
	 * reference to the session is reloaded or experiences a page navigation. The
	 * exact behavior may be browser dependent.
	 *
	 * The `workerJs` argument must be set to the URL of the `diffusion-worker.js`
	 * supplied with the JavaScript distribution. The same-origin policy of
	 * the shared worker requires the calling script and the `diffusion-worker.js`
	 * to reside on the same domain.
	 *
	 * If the result is successful, the fulfilled handler will be called with a
	 * {@link Session} instance. This session will be in a connected state and
	 * may be used for subsequent API calls.
	 *
	 * If the result fails, the rejected handler will be called with an error
	 * reason.
	 *
	 * **Example:**
	 * ```
	 * const options = {
	 *     host : 'localhost',
	 *     port : '8080',
	 *     principal : 'admin',
	 *     credentials : 'password'
	 * };
	 *
	 * diffusion.connect(options, 'some-session', 'diffusion-worker.js').then((session) => {
	 *     console.log('Connected creating new shared session', session);
	 * }).catch((error) => {
	 *     console.log('Failed to connect', error);
	 * });
	 *
	 * diffusion.connectShared('some-session', 'diffusion-worker.js').then((session) => {
	 *     console.log('Connected to existing shared session', session);
	 * }.catch((error) => {
	 *     console.log('Failed to connect shared', error);
	 * });
	 * ```
	 *
	 * @param sessionName  the name of the shared session
	 * @param workerJs     the location of the diffusion worker script
	 * @returns            a {@link Result} for this operation
	 */
	function connectShared(sessionName, workerJs) {
	    return session_impl_1.SessionImpl.create(InternalSessionFactory.createShared(sessionName, workerJs), undefined);
	}
	exports.connectShared = connectShared;
	/**
	 * Escapes special characters in a string that is to be used within a topic
	 * property or a session filter.
	 * <P>
	 * This is a convenience method which inserts an escape character '\' before
	 * any of the special characters ' " or \.
	 *
	 * @param s  the string to be escaped
	 * @returns  the string value with escape characters inserted as appropriate
	 *
	 * @since 6.1
	 */
	function escape(s) {
	    return DiffusionGlobals.escape(s);
	}
	exports.escape = escape;
	/**
	 * Utility method which converts a string of the format required by the
	 * {@link PropertyKeys.ROLES $Roles} session property into a mutable set of
	 * strings.
	 *
	 * @param s  the string with quoted roles separated by whitespace or
	 *           commas
	 *
	 * @return   set of roles
	 *
	 * @since 6.2
	 */
	function stringToRoles(s) {
	    return DiffusionGlobals.stringToRoles(s);
	}
	exports.stringToRoles = stringToRoles;
	/**
	 * Utility method which converts a set of authorisation roles to the string
	 * format required by the {@link PropertyKeys.ROLES $Roles} session property.
	 *
	 * @param roles  a set of roles
	 * @return       a string representing the supplied roles, formatted as
	 *               required by the {@link PropertyKeys.ROLES $Roles} session
	 *               property
	 *
	 * @since 6.2
	 */
	function rolesToString(roles) {
	    return DiffusionGlobals.rolesToString(roles);
	}
	exports.rolesToString = rolesToString;
	/**
	 * Returns an update constraint factory.
	 *
	 * @function diffusion#updateConstraints
	 * @return {diffusion.topicUpdate.UpdateConstraintFactory} update constraint
	 *         factory
	 * @since 6.2
	 */
	function updateConstraints() {
	    return update_constraint_factory_1.updateConstraintFactory;
	}
	exports.updateConstraints = updateConstraints;
	/**
	 * Create a new {@link BranchMappingTableBuilder}.
	 *
	 * @since 6.7
	 * @see SessionTrees
	 */
	function newBranchMappingTableBuilder() {
	    return DiffusionGlobals.newBranchMappingTableBuilder();
	}
	exports.newBranchMappingTableBuilder = newBranchMappingTableBuilder;
	/**
	 * Create a new {@link SessionMetricCollectorBuilder}.
	 *
	 * @since 6.7
	 */
	function newSessionMetricCollectorBuilder() {
	    return DiffusionGlobals.newSessionMetricCollectorBuilder();
	}
	exports.newSessionMetricCollectorBuilder = newSessionMetricCollectorBuilder;
	/**
	 * Create a new {@link TopicMetricCollectorBuilder}.
	 *
	 * @since 6.7
	 */
	function newTopicMetricCollectorBuilder() {
	    return DiffusionGlobals.newTopicMetricCollectorBuilder();
	}
	exports.newTopicMetricCollectorBuilder = newTopicMetricCollectorBuilder;
	/**
	 * Access to the selectors namespace
	 */
	exports.selectors = new topic_selectors_1.TopicSelectors();
	/**
	 * Create a new {@link RemoteServerBuilder}.
	 *
	 * @since 6.7
	 */
	function newRemoteServerBuilder() {
	    return DiffusionGlobals.newRemoteServerBuilder(exports.selectors);
	}
	exports.newRemoteServerBuilder = newRemoteServerBuilder;
	/**
	 * Access to the datatypes namespace
	 */
	exports.datatypes = datatypes_1.DataTypes;
	/**
	 * Access to the topics namespace
	 */
	exports.topics = topics_1.topicsNamespace;
	/**
	 * Access to the topicUpdate namespace
	 */
	exports.topicUpdate = topic_update_1.TopicUpdateNamespace;
	/**
	 * The ErrorReason enum
	 */
	exports.errors = error_reason_1.ErrorReason;
	/**
	 * Access to PropertyKeys
	 */
	exports.clients = client_control_options_1.ClientControlOptions;
	/**
	 * Access to the locks namespace
	 */
	exports.locks = session_lock_options_1.SessionLockOptions;
	var close_reason_1 = __webpack_require__(172);
	exports.CloseReasonEnum = close_reason_1.CloseReasonEnum;
	var client_control_1 = __webpack_require__(490);
	exports.SessionEventType = client_control_1.SessionEventType;
	var remote_servers_1 = __webpack_require__(323);
	exports.ConnectionOption = remote_servers_1.ConnectionOption;
	exports.ConnectionState = remote_servers_1.ConnectionState;
	var security_2 = __webpack_require__(101);
	exports.GlobalPermission = security_2.GlobalPermission;
	exports.PathPermission = security_2.PathPermission;
	exports.ValidationType = security_2.ValidationType;
	var session_lock_options_2 = __webpack_require__(173);
	exports.SessionLockScope = session_lock_options_2.SessionLockScope;
	var topic_notifications_1 = __webpack_require__(223);
	exports.TopicNotificationType = topic_notifications_1.TopicNotificationType;
	var topic_selector_1 = __webpack_require__(181);
	exports.Prefix = topic_selector_1.Prefix;
	exports.Type = topic_selector_1.Type;
	var topic_update_2 = __webpack_require__(90);
	exports.TopicCreationResult = topic_update_2.TopicCreationResult;
	var logger_1 = __webpack_require__(1475);
	exports.LogLevel = logger_1.LogLevel;
	var gateway_control_1 = __webpack_require__(332);
	exports.StatusLevel = gateway_control_1.StatusLevel;
	/**
	 * Permissions that are applied on a path
	 * @deprecated since 6.5
	 * Replaced by {@link PathPermission}
	 */ // tslint:disable-next-line:variable-name
	exports.TopicPermission = security_1.PathPermission;
	/**
	 * Access to the Buffer API that is packaged with diffusion.
	 *
	 * This can be used in browsers that don't have a native Buffer class. It allows
	 * the creation of buffers for use with {@link BinaryDataType binary} datatypes.
	 *
	 * @example
	 * ```
	 * const buf = diffusion.buffer.from('Hello World', 'utf8')
	 * ```
	 */
	exports.buffer = Buffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Activity
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var connection_activity_monitor_1 = __webpack_require__(1160);
	/**
	 * The client will wait a maximum of two system ping periods for a ping from the
	 * server before declaring the connection idle and closing it.
	 */
	var pingTimeoutFactor = 2;
	/**
	 * A {@link ConnectionActivityMonitor} that does nothing
	 */
	var noop = {
	    onSystemPing: function () { },
	    shutdown: function () { }
	};
	/**
	 * Factory for connection activity monitors.
	 *
	 * @param connection the connection to be monitored
	 * @param response   the new connection response
	 */
	function connectionActivityMonitorFactory(connection, response) {
	    if (!response.systemPingPeriod) {
	        return noop;
	    }
	    var systemPingPeriod = response.systemPingPeriod.toNumber();
	    if (systemPingPeriod > 0) {
	        var pingTimeout = systemPingPeriod * pingTimeoutFactor;
	        return new connection_activity_monitor_1.ConnectionActivityMonitorImpl(pingTimeout, connection);
	    }
	    else {
	        return noop;
	    }
	}
	exports.connectionActivityMonitorFactory = connectionActivityMonitorFactory;


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of {@link ConnectionActivityMonitor}
	 */
	var ConnectionActivityMonitorImpl = /** @class */ (function () {
	    /**
	     * Create a new ConnectionActivityMonitor instance
	     *
	     * @param  pingTimeout  timeout for pings in milliseconds
	     * @param  connection   the connection being monitored
	     */
	    function ConnectionActivityMonitorImpl(pingTimeout, connection) {
	        /**
	         * The handle to the current timeout callback
	         */
	        this.currentTimeout = null;
	        this.pingTimeout = pingTimeout;
	        this.connection = connection;
	        this.currentTimeout = setTimeout(connection.closeIdleConnection.bind(connection), pingTimeout);
	    }
	    /**
	     * @inheritdoc
	     */
	    ConnectionActivityMonitorImpl.prototype.onSystemPing = function () {
	        var _this = this;
	        if (this.currentTimeout !== null) {
	            clearTimeout(this.currentTimeout);
	            this.currentTimeout = setTimeout(function () {
	                _this.connection.closeIdleConnection();
	            }, this.pingTimeout);
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    ConnectionActivityMonitorImpl.prototype.shutdown = function () {
	        if (this.currentTimeout !== null) {
	            clearTimeout(this.currentTimeout);
	            this.currentTimeout = null;
	        }
	    };
	    return ConnectionActivityMonitorImpl;
	}());
	exports.ConnectionActivityMonitorImpl = ConnectionActivityMonitorImpl;


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Activity
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of {@link SessionActivityMonitor}
	 */
	var SessionActivityMonitorImpl = /** @class */ (function () {
	    /**
	     * Construct a new SessionActivityMonitorImpl instance
	     *
	     * @param connectionActivityMonitorFactory Factory for connection activity monitors
	     */
	    function SessionActivityMonitorImpl(factory) {
	        this.factory = factory;
	    }
	    /**
	     * @inheritdoc
	     */
	    SessionActivityMonitorImpl.prototype.onNewConnection = function (connection, response) {
	        this.currentConnectionMonitor = this.factory(connection, response);
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionActivityMonitorImpl.prototype.onConnectionClosed = function () {
	        if (this.currentConnectionMonitor !== undefined) {
	            this.currentConnectionMonitor.shutdown();
	            this.currentConnectionMonitor = undefined;
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionActivityMonitorImpl.prototype.onSystemPing = function () {
	        if (this.currentConnectionMonitor !== undefined) {
	            this.currentConnectionMonitor.onSystemPing();
	        }
	    };
	    return SessionActivityMonitorImpl;
	}());
	exports.sessionActivityMonitorFactory = {
	    NOOP: {
	        onNewConnection: function () { },
	        onConnectionClosed: function () { },
	        onSystemPing: function () { }
	    },
	    create: function (factory) {
	        return new SessionActivityMonitorImpl(factory);
	    }
	};


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module CBOR
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A CBOR token context type
	 */
	var TokenContextType;
	(function (TokenContextType) {
	    /**
	     * the type given to the root context
	     */
	    TokenContextType[TokenContextType["root"] = 0] = "root";
	    /**
	     * the token context when reading string
	     */
	    TokenContextType[TokenContextType["string"] = 1] = "string";
	    /**
	     * the token context when reading an array
	     */
	    TokenContextType[TokenContextType["array"] = 2] = "array";
	    /**
	     * the token context when reading an object
	     */
	    TokenContextType[TokenContextType["object"] = 3] = "object";
	})(TokenContextType = exports.TokenContextType || (exports.TokenContextType = {}));
	/**
	 * Maintain recursive parsing context on a stack.
	 */
	var Context = /** @class */ (function () {
	    function Context() {
	        /**
	         * the root context
	         */
	        this.ROOT = { length: -1, type: TokenContextType.root, read: 0 };
	        /**
	         * the context stack
	         */
	        this.stack = [];
	        /**
	         * the current context
	         */
	        this.tail = this.ROOT;
	    }
	    /**
	     * Get the context type
	     *
	     * @returns the type of the current token context
	     */
	    Context.prototype.type = function () {
	        return this.tail.type;
	    };
	    /**
	     * Get the number of read tokens
	     *
	     * @returns the number of tokens that have been read in the current token context
	     */
	    Context.prototype.read = function () {
	        return this.tail.read;
	    };
	    /**
	     * Get the number of tokens that are expected in this context
	     *
	     * @returns the length of the current token context
	     */
	    Context.prototype.expected = function () {
	        return this.tail.length;
	    };
	    /**
	     * Add a new context
	     *
	     * @param type of the token context
	     * @param the number of tokens are expected the new token context
	     */
	    Context.prototype.push = function (type, length) {
	        if (length === void 0) { length = -1; }
	        this.tail = {
	            length: length,
	            type: type,
	            read: 0
	        };
	        this.stack.push(this.tail);
	    };
	    /**
	     * Pop the current context
	     *
	     * @returns the previous tail on the context stack
	     */
	    Context.prototype.pop = function () {
	        var prev = this.stack.pop();
	        if (this.stack.length) {
	            this.tail = this.stack[this.stack.length - 1];
	        }
	        else {
	            this.tail = this.ROOT;
	        }
	        return prev;
	    };
	    /**
	     * Progress through the current context's expected value count
	     */
	    Context.prototype.next = function () {
	        if (this.hasRemaining()) {
	            this.tail.read++;
	        }
	        else {
	            throw new Error('Exceeded expected collection limit');
	        }
	    };
	    /**
	     * Ends this current context.
	     */
	    Context.prototype.break = function () {
	        if (this.acceptsBreakMarker()) {
	            this.tail.length = 0;
	            this.tail.read = 0;
	        }
	    };
	    /**
	     * Check if the current context has token remaining to be read
	     *
	     * @returns `true` if there are more tokens expected in this context
	     */
	    Context.prototype.hasRemaining = function () {
	        return (this.tail.length === -1) || (this.tail.length > this.tail.read);
	    };
	    /**
	     * Check if the current context can accept a break marker
	     *
	     * @returns whether the current context accepts break marker tokens
	     */
	    Context.prototype.acceptsBreakMarker = function () {
	        return this.tail !== this.ROOT && this.tail.length === -1;
	    };
	    return Context;
	}());
	exports.Context = Context;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_session_impl_1 = __webpack_require__(1164);
	var service_registry_1 = __webpack_require__(1165);
	var monitored_ping_service_1 = __webpack_require__(1166);
	var notify_subscription_service_1 = __webpack_require__(1167);
	var notify_unsubscription_service_1 = __webpack_require__(1168);
	var ping_service_1 = __webpack_require__(1169);
	var ConversationSet = __webpack_require__(495);
	var ping_services_1 = __webpack_require__(531);
	var Services = __webpack_require__(339);
	var require_non_null_1 = __webpack_require__(22);
	var ConnectionFactory = __webpack_require__(1465);
	var internal_session_webworker_proxy_1 = __webpack_require__(1470);
	var shared_workers_1 = __webpack_require__(1471);
	/**
	 * Create a new internal session
	 *
	 * @param options  the options passed to the session
	 * @return         a new internal session
	 */
	function createInternal(options) {
	    options = require_non_null_1.requireNonNull(options, 'options');
	    var serviceRegistry = new service_registry_1.ServiceRegistryImpl();
	    // assign default service implementations
	    serviceRegistry.add(ping_services_1.USER_PING, ping_service_1.pingService);
	    serviceRegistry.add(ping_services_1.SYSTEM_PING, monitored_ping_service_1.monitoredPingService);
	    serviceRegistry.add(Services.NOTIFY_SUBSCRIPTION, notify_subscription_service_1.notifySubscriptionService);
	    serviceRegistry.add(Services.UNSUBSCRIPTION_NOTIFICATION, notify_unsubscription_service_1.notifyUnsubscriptionService);
	    return new internal_session_impl_1.InternalSessionImpl(ConversationSet.create, serviceRegistry, ConnectionFactory.create, options);
	}
	exports.createInternal = createInternal;
	/**
	 * Create a new internal session factory that connects to a shared session in a webworker
	 *
	 * @param options  the options passed to the session
	 * @return         a new internal session
	 */
	function createShared(name, workerJs) {
	    var serviceRegistry = new service_registry_1.ServiceRegistryImpl();
	    var connector = new shared_workers_1.SharedSessionConnector(name, workerJs);
	    var conversationSetFactory = shared_workers_1.getSharedConversationSetFactory(connector);
	    return function (options) {
	        return new internal_session_webworker_proxy_1.InternalSessionWebworkerProxy(conversationSetFactory, serviceRegistry, connector, options);
	    };
	}
	exports.createShared = createShared;
	/**
	 * Create a new internal session factory
	 *
	 * @param options  the options passed to the session
	 * @return         a new internal session
	 */
	function create(name, workerJs) {
	    if (name === undefined && workerJs === undefined) {
	        return createInternal;
	    }
	    else if (name !== undefined && workerJs !== undefined) {
	        return createShared(name, workerJs);
	    }
	    else {
	        throw new Error('Missing parameter "name" or "workerJs" when creating a shared session');
	    }
	}
	exports.create = create;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Client
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var connection_activity_monitor_factory_1 = __webpack_require__(1159);
	var session_activity_monitor_1 = __webpack_require__(1161);
	var internal_session_1 = __webpack_require__(326);
	var service_adapter_1 = __webpack_require__(492);
	var service_locator_1 = __webpack_require__(493);
	var session_context_impl_1 = __webpack_require__(494);
	var datatypes_1 = __webpack_require__(78);
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var session_lock_1 = __webpack_require__(1207);
	var ConnectionRequest = __webpack_require__(1226);
	var response_code_1 = __webpack_require__(177);
	var stream_registry_1 = __webpack_require__(1227);
	var topic_cache_1 = __webpack_require__(1230);
	var topic_routing_1 = __webpack_require__(1231);
	var transports_1 = __webpack_require__(1457);
	var fsm_1 = __webpack_require__(547);
	var logger = __webpack_require__(17);
	var version_1 = __webpack_require__(1468);
	var close_reason_1 = __webpack_require__(172);
	var INITIALISING = internal_session_1.InternalSessionState.INITIALISING, CONNECTING = internal_session_1.InternalSessionState.CONNECTING, CONNECTED = internal_session_1.InternalSessionState.CONNECTED, DISCONNECTED = internal_session_1.InternalSessionState.DISCONNECTED, RECONNECTING = internal_session_1.InternalSessionState.RECONNECTING, CLOSING = internal_session_1.InternalSessionState.CLOSING, CLOSED = internal_session_1.InternalSessionState.CLOSED;
	var log = logger.create('Internal Session');
	/**
	 * Internal session implementation
	 */
	var InternalSessionImpl = /** @class */ (function (_super) {
	    __extends(InternalSessionImpl, _super);
	    /**
	     * Create a new InternalSessionImpl instance
	     *
	     * @param conversationSetFactory  the factory for generating conversation sets
	     * @param serviceRegistry         the service registry
	     * @param connectionFactory       a factory for creating the connection
	     * @param opts                    the session options
	     */
	    function InternalSessionImpl(conversationSetFactory, serviceRegistry, connectionFactory, opts, sessnActivityMonitorFactory) {
	        var _a;
	        if (sessnActivityMonitorFactory === void 0) { sessnActivityMonitorFactory = session_activity_monitor_1.sessionActivityMonitorFactory; }
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.version = version_1.version;
	        _this.principal = '';
	        _this.conversationSetFactory = conversationSetFactory;
	        _this.conversationSet = conversationSetFactory();
	        _this.serviceRegistry = serviceRegistry;
	        _this.opts = opts;
	        _this.sessionActivityMonitorFactory = sessnActivityMonitorFactory;
	        _this.fsm = new fsm_1.FSM(INITIALISING, (_a = {},
	            _a[INITIALISING] = [CONNECTING],
	            _a[CONNECTING] = [CONNECTED, CLOSING],
	            _a[CONNECTED] = [
	                DISCONNECTED,
	                CLOSING,
	                CLOSED
	            ],
	            _a[DISCONNECTED] = [RECONNECTING, CLOSING],
	            _a[RECONNECTING] = [CONNECTED, CLOSING],
	            _a[CLOSING] = [CLOSED],
	            _a[CLOSED] = [],
	            _a));
	        _this.fsm.on('change', function (previous, current) {
	            log.debug('State changed: ' + previous + ' -> ' + current);
	        });
	        _this.transports = transports_1.Transports.create();
	        // forward cascading notification events
	        _this.transports.on({
	            'transport-selected': function (name) {
	                _this.emitter.emit('transport-selected', name);
	            },
	            'cascade': function () {
	                _this.emitter.emit('cascade');
	            }
	        });
	        _this.connection = connectionFactory(_this.transports, _this.opts.reconnect.timeout, 256);
	        _this.serviceAdapter = new service_adapter_1.ServiceAdapter(_this, function (msg) { _this.connection.send(msg); });
	        _this.serviceLocator = new service_locator_1.ServiceLocatorImpl(_this, _this.serviceAdapter);
	        _this.topicCache = new topic_cache_1.TopicCache(datatypes_1.DataTypes);
	        _this.topicStreamRegistry = new stream_registry_1.StreamRegistryImpl(_this.topicCache);
	        _this.topicRouting = new topic_routing_1.TopicRouting(_this, _this.serviceAdapter, _this.conversationSet, _this.topicCache, _this.topicStreamRegistry);
	        _this.serviceRegistry.addListener(_this.serviceAdapter.addService.bind(_this.serviceAdapter));
	        // tslint:disable-next-line:strict-type-predicates
	        if (session_lock_1.InternalSessionLocks !== undefined) {
	            _this.sessionLocksFeature = new session_lock_1.InternalSessionLocks(_this, _this.fsm);
	        }
	        _this.attempts = 0;
	        return _this;
	    }
	    Object.defineProperty(InternalSessionImpl.prototype, "sessionLocks", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.sessionLocksFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (session_lock_1.InternalSessionLocks !== undefined) {
	                    this.sessionLocksFeature = new session_lock_1.InternalSessionLocks(this, this.fsm);
	                }
	                else {
	                    throw new Error('Session Locks feature has not been loaded');
	                }
	            }
	            return this.sessionLocksFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Get the session's options
	     *
	     * @return  the options
	     */
	    InternalSessionImpl.prototype.getOptions = function () {
	        return this.opts;
	    };
	    /**
	     * Get the current state
	     *
	     * @return  the state of the finite state machine
	     */
	    InternalSessionImpl.prototype.getState = function () {
	        return this.fsm.state;
	    };
	    /**
	     * Add a callback that will be called when the session state changes
	     *
	     * @param callback  the function to call when the session state changes
	     */
	    InternalSessionImpl.prototype.onStateChange = function (callback) {
	        this.fsm.on('change', callback);
	    };
	    /**
	     * Get the conversation set
	     *
	     * @return  a reference to the conversation set
	     */
	    InternalSessionImpl.prototype.getConversationSet = function () {
	        return this.conversationSet;
	    };
	    /**
	     * Query if the session is connected
	     *
	     * @return  `true` if the finite state machine is in the `connected` state
	     */
	    InternalSessionImpl.prototype.isConnected = function () {
	        return this.fsm.state === CONNECTED;
	    };
	    /**
	     * Get the service registry
	     *
	     * @return  a reference to the service registry
	     */
	    InternalSessionImpl.prototype.getServiceRegistry = function () {
	        return this.serviceRegistry;
	    };
	    /**
	     * Get the session ID
	     *
	     * @return the session ID
	     */
	    InternalSessionImpl.prototype.getSessionId = function () {
	        return this.sessionID;
	    };
	    /**
	     * Get the server's maximum message size.
	     */
	    InternalSessionImpl.prototype.getServerMaximumMessageSize = function () {
	        return this.serverMaximumMessageSize;
	    };
	    /**
	     * Check if the session is connected
	     *
	     * If the session is not connected an error will be emitted on the session's stream
	     *
	     * @return  `true` if the finite state machine is in the `connected` state
	     */
	    InternalSessionImpl.prototype.checkConnected = function (reject) {
	        if (this.isConnected()) {
	            return true;
	        }
	        else {
	            reject(new Error('The session is not connected. Operations are not possible at this time.'));
	            return false;
	        }
	    };
	    /**
	     * Close the session
	     *
	     * This will close all topic streams, discard all conversations and emit a
	     * `close` event on the session's stream
	     *
	     * @param reason  the reason for closing the session. This will be passed on to
	     *                the stream `close` event.
	     */
	    InternalSessionImpl.prototype.internalClose = function (reason) {
	        if (this.fsm.change(CLOSED)) {
	            this.topicStreamRegistry.close();
	            this.conversationSet.discardAll(reason);
	            this.emitter.close(reason);
	        }
	        else {
	            log.debug('Unable to handle session close, session state: ', this.fsm.state);
	        }
	    };
	    /**
	     * Attempt to reconnect after disconnecting
	     *
	     * @param opts   the session options
	     * @param token  the token of the session when it was connected
	     */
	    InternalSessionImpl.prototype.reconnect = function (opts, token) {
	        if (this.fsm.change(RECONNECTING)) {
	            log.info('Reconnect attempt (' + (++this.attempts) + ')');
	            var request = ConnectionRequest.reconnect(token, this.connection.getAvailableSequence(), this.connection.lastReceivedSequence);
	            this.connection.connect(request, opts, opts.reconnect.timeout);
	        }
	        else {
	            log.debug('Unable to attempt reconnect, session state: ', this.fsm.state);
	        }
	    };
	    /**
	     * Cancel a reconnect event
	     *
	     * @param reason  the reason for closing
	     */
	    InternalSessionImpl.prototype.abort = function (reason) {
	        if (reason === void 0) { reason = close_reason_1.CloseReasonEnum.RECONNECT_ABORTED; }
	        if (this.fsm.change(CLOSING)) {
	            log.debug('Aborting reconnect');
	            this.internalClose(reason);
	        }
	        else {
	            log.debug('Unable to abort reconnect, session state: ', this.fsm.state);
	        }
	    };
	    /**
	     * Replace the conversation set with a new one.
	     *
	     * @param err  the error that caused the message loss
	     */
	    InternalSessionImpl.prototype.replaceConversationSet = function (err) {
	        var oldConversationSet = this.conversationSet;
	        this.conversationSet = this.conversationSetFactory();
	        oldConversationSet.discardAll(err);
	        log.debug('Replaced conversation set', err);
	    };
	    /**
	     * Attempt to connect to the server
	     */
	    InternalSessionImpl.prototype.connect = function () {
	        var _this = this;
	        if (this.fsm.change(CONNECTING)) {
	            // timeout applied for reconnect attempts from initial disconnect
	            var reconnectTimeout_1;
	            // construct a creation request
	            var request = ConnectionRequest.connect();
	            // handle messages from connection
	            this.connection.on('data', this.topicRouting.route.bind(this.topicRouting));
	            // close events are terminal
	            this.connection.on('close', this.internalClose.bind(this));
	            this.sessionActivityMonitor = this.opts.activityMonitor ?
	                this.sessionActivityMonitorFactory.create(connection_activity_monitor_factory_1.connectionActivityMonitorFactory) :
	                this.sessionActivityMonitorFactory.NOOP;
	            // handle connection disconnections
	            this.connection.on('disconnect', function (reason) {
	                log.debug('Connection disconnected, reason: ', reason);
	                if (_this.fsm.change(DISCONNECTED) ||
	                    _this.fsm.state === RECONNECTING) {
	                    _this.sessionActivityMonitor.onConnectionClosed();
	                    // call reconnect if applicable
	                    if (_this.opts.reconnect.timeout > 0 && reason.canReconnect) {
	                        // only emit the disconnect state once
	                        if (_this.fsm.state === DISCONNECTED) {
	                            _this.emitter.emit('disconnect', reason);
	                            reconnectTimeout_1 = setTimeout(function () {
	                                if (_this.fsm.state !== CONNECTED) {
	                                    _this.abort(close_reason_1.CloseReasonEnum.CONNECTION_TIMEOUT);
	                                }
	                            }, _this.opts.reconnect.timeout);
	                        }
	                        _this.opts.reconnect.strategy(_this.reconnect.bind(_this, _this.opts, _this.token), _this.abort.bind(_this), reason);
	                    }
	                    else {
	                        _this.abort(reason);
	                    }
	                }
	                else if (_this.fsm.change(CLOSING)) {
	                    _this.internalClose(reason);
	                }
	                else {
	                    _this.sessionActivityMonitor.onConnectionClosed();
	                    log.debug('Unable to handle session disconnect, session state: ', _this.fsm.state);
	                }
	            });
	            // handle connect response
	            this.connection.on('connect', function (response) {
	                if (_this.fsm.change(CONNECTED)) {
	                    _this.token = response.token;
	                    if (response.response === response_code_1.responseCodes.OK) {
	                        _this.sessionID = response.identity;
	                        _this.serverMaximumMessageSize = response.maximumMessageSize;
	                        _this.sessionActivityMonitor.onNewConnection(_this.connection, response);
	                        _this.emitter.emit('connect', response.identity);
	                    }
	                    else if (response.response === response_code_1.responseCodes.RECONNECTED ||
	                        response.response === response_code_1.responseCodes.RECONNECTED_WITH_MESSAGE_LOSS) {
	                        _this.attempts = 0;
	                        clearTimeout(reconnectTimeout_1);
	                        if (response.response === response_code_1.responseCodes.RECONNECTED_WITH_MESSAGE_LOSS) {
	                            _this.connection.resetSequences();
	                            _this.replaceConversationSet(new Error('Peer is disconnected'));
	                            _this.topicCache.notifyUnsubscriptionOfAllTopics(_this.topicStreamRegistry);
	                            log.info('Reconnected session, but messages may have been lost');
	                        }
	                        else {
	                            log.info('Reconnected session');
	                        }
	                        _this.sessionActivityMonitor.onNewConnection(_this.connection, response);
	                        _this.emitter.emit('reconnect');
	                    }
	                }
	                else {
	                    log.trace('Unknown connection response: ', response);
	                }
	            });
	            log.debug('Connecting with options:', this.opts);
	            log.trace('Connecting with request:', request);
	            try {
	                this.connection.connect(request, this.opts, this.opts.connectionTimeout);
	            }
	            catch (e) {
	                log.warn('Connection error', e);
	                this.emitter.emit('error', e);
	                if (this.fsm.change(CLOSING)) {
	                    this.internalClose(close_reason_1.CloseReasonEnum.CONNECTION_ERROR);
	                }
	            }
	            if (this.opts.principal) {
	                this.principal = this.opts.principal;
	            }
	        }
	        else {
	            log.warn('Unable to connect, session state: ', this.fsm.state);
	            this.emitter.emit('error', new Error('Unable to connect, session state: ' + this.fsm.state));
	        }
	    };
	    /**
	     * Manually close the session
	     */
	    InternalSessionImpl.prototype.close = function () {
	        if (this.fsm.change(CLOSING)) {
	            this.sessionActivityMonitor.onConnectionClosed();
	            this.connection.close(close_reason_1.CloseReasonEnum.CLOSED_BY_CLIENT);
	        }
	        else {
	            log.debug('Unable to close, session state: ', this.fsm.state);
	        }
	        return this;
	    };
	    /**
	     * Get the error handler
	     *
	     * @return  a handler that logs the error in the error logs
	     */
	    InternalSessionImpl.prototype.getErrorHandler = function () {
	        return function (error) {
	            log.error('Session error:', error.message);
	        };
	    };
	    /**
	     * Get the service locator
	     *
	     * @return  the service locator
	     */
	    InternalSessionImpl.prototype.getServiceLocator = function () {
	        return this.serviceLocator;
	    };
	    /**
	     * Get the service adapter
	     *
	     * @return  the service adapter
	     */
	    InternalSessionImpl.prototype.getServiceAdapter = function () {
	        return this.serviceAdapter;
	    };
	    /**
	     * Get the session principal
	     *
	     * @return  the session principal
	     */
	    InternalSessionImpl.prototype.getPrincipal = function () {
	        return this.principal;
	    };
	    /**
	     * Set the principal of the session
	     *
	     * @param newPrincipal  the new principal
	     */
	    InternalSessionImpl.prototype.setPrincipal = function (newPrincipal) {
	        this.principal = newPrincipal;
	    };
	    /**
	     * Get the stream registry
	     *
	     * @return  the stream registry
	     */
	    InternalSessionImpl.prototype.getStreamRegistry = function () {
	        return this.topicStreamRegistry;
	    };
	    /**
	     * Get the topic router
	     *
	     * @return  the topic router
	     */
	    InternalSessionImpl.prototype.getRouting = function () {
	        return this.topicRouting;
	    };
	    /**
	     * System ping handler
	     *
	     * Forwards the call to the activity monitor
	     */
	    InternalSessionImpl.prototype.onSystemPing = function () {
	        this.sessionActivityMonitor.onSystemPing();
	    };
	    /**
	     * Request a session lock
	     *
	     * @param lockName  the lock name
	     * @param scope     the lock scope
	     * @return          a {@link Result} that resolves with the acquired session lock
	     */
	    InternalSessionImpl.prototype.lock = function (lockName, scope, handler) {
	        return this.sessionLocks.lock(lockName, scope, handler);
	    };
	    /**
	     * Unlock a session lock by acquisision
	     *
	     * @param  acquisition  the session lock acquisition
	     * @return              a {@link Result} that completes when the lock is released
	     */
	    InternalSessionImpl.prototype.unlock = function (acquisition) {
	        return this.sessionLocks.unlock(acquisition);
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionImpl.prototype.isShared = function () {
	        return false;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionImpl.prototype.getContext = function () {
	        return session_context_impl_1.sessionContext;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionImpl.prototype.updateFeatures = function () {
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.sessionLocks === undefined && session_lock_1.InternalSessionLocks !== undefined) {
	            this.sessionLocks = new session_lock_1.InternalSessionLocks(this, this.fsm);
	        }
	    };
	    return InternalSessionImpl;
	}(stream_1.StreamImpl));
	exports.InternalSessionImpl = InternalSessionImpl;


/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Mutable registry of service implementations, bound to a service definitions.
	 */
	var ServiceRegistryImpl = /** @class */ (function () {
	    function ServiceRegistryImpl() {
	        /**
	         * The map of services indexed by their service definition
	         */
	        this.services = new Map();
	        /**
	         *  Listeners, to be notified whenever a new service implementation is added
	         */
	        this.listeners = [];
	    }
	    /**
	     * Add a new service implementation to the registry. Only one service
	     * may be bound to a given definition.
	     *
	     * When a new service is added, any listeners will be notified.
	     *
	     * @param definition  the service definition
	     * @param service     the service implementation
	     * @throws            an error if another service is already bound to the same definition.
	     */
	    ServiceRegistryImpl.prototype.add = function (definition, service) {
	        if (this.services.has(definition)) {
	            throw new Error("Service already exists for " + definition);
	        }
	        this.services.set(definition, service);
	        this.listeners.forEach(function (listener) {
	            listener(definition, service);
	        });
	    };
	    /**
	     * Add a listener, to be notified whenever a new service implementation is added.
	     *
	     * When a listener is added, it will immediately be called with all existing
	     * services in the registry.
	     *
	     * @param listener  the registry listener
	     */
	    ServiceRegistryImpl.prototype.addListener = function (listener) {
	        this.listeners.push(listener);
	        this.services.forEach(function (service, definition) {
	            listener(definition, service);
	        });
	    };
	    return ServiceRegistryImpl;
	}());
	exports.ServiceRegistryImpl = ServiceRegistryImpl;


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client.Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Service implementation to provide Ping functionality.
	 *
	 * Intended to provide basic Ping functionality by immediately responding to a
	 * received request, by which the round-trip latency between the sender and
	 * receiver may be ascertained.
	 *
	 * This implementation is monitored. It notifies the session activity monitor
	 * of the ping.
	 */
	exports.monitoredPingService = {
	    /**
	     * Handle an inbound request.
	     *
	     * @param internal  the internal session instance
	     * @param request   the inbound ping request
	     * @param callback  a service callback to handle the response
	     */
	    onRequest: function (internal, request, callback) {
	        callback.respond();
	        internal.onSystemPing();
	    }
	};


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client.Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Notify subscriptions
	 */
	exports.notifySubscriptionService = {
	    /**
	     * Handle an inbound request.
	     *
	     * @param internal      the internal session instance
	     * @param notification  the inbound notification
	     * @param callback      the service reference callback
	     */
	    onRequest: function (internal, request, callback) {
	        callback.respond();
	        internal.getRouting().subscribe(request);
	    }
	};


/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client.Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Notification of unsubscription,
	 */
	exports.notifyUnsubscriptionService = {
	    /**
	     * Handle an inbound request.
	     *
	     * @param internal      the internal session instance
	     * @param notification  the inbound notification
	     * @param callback      the service reference callback
	     */
	    onRequest: function (internal, notification, callback) {
	        callback.respond();
	        internal.getRouting().unsubscribe(notification.id, notification.reason);
	    }
	};


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Client.Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Service implementation to provide Ping functionality.
	 *
	 * Intended to provide basic Ping functionality by immediately responding to a
	 * received request, by which the round-trip latency between the sender and
	 * receiver may be ascertained.
	 */
	exports.pingService = {
	    /**
	     * Handle an inbound request
	     *
	     * @param internal  the internal session instance
	     * @param ping      the inbound ping request
	     * @param callback  the service reference callback
	     */
	    onRequest: function (internal, ping, callback) {
	        callback.respond();
	    }
	};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_datatype_1 = __webpack_require__(144);
	var binary_impl_1 = __webpack_require__(497);
	var function_1 = __webpack_require__(89);
	/**
	 * A data type for binary data
	 */
	var BinaryDataTypeImpl = /** @class */ (function (_super) {
	    __extends(BinaryDataTypeImpl, _super);
	    /**
	     * Create a new BinaryDataTypeImpl instance
	     */
	    function BinaryDataTypeImpl() {
	        var _this = _super.call(this, 'binary', binary_impl_1.BinaryImpl, binary_impl_1.BinaryImpl, binary_impl_1.BinaryImpl.from, function_1.identity, [], true) || this;
	        /**
	         * The implementation of the underlying value type
	         */ // tslint:disable-next-line:variable-name
	        _this.Binary = binary_impl_1.BinaryImpl;
	        return _this;
	    }
	    /**
	     * Create a new Binary instance from data
	     *
	     * @param value  the CBOR data containing the record
	     * @return       a new Binary instance
	     */
	    BinaryDataTypeImpl.prototype.from = function (buffer) {
	        return binary_impl_1.BinaryImpl.from(buffer);
	    };
	    BinaryDataTypeImpl.prototype.validate = function () {
	        // no-op. This data type validates on read.
	    };
	    return BinaryDataTypeImpl;
	}(abstract_datatype_1.AbstractDataType));
	exports.BinaryDataTypeImpl = BinaryDataTypeImpl;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:completed-docs comment-format */
	var math_1 = __webpack_require__(104);
	var BAIL_OUT_FACTOR = 10000;
	var MAXIMUM_STORAGE = 0x7fffffff;
	// Constant result codes
	exports.SUCCESS = 0;
	exports.REPLACE = 1;
	exports.NO_CHANGE = 2;
	var Storage = /** @class */ (function () {
	    function Storage(max) {
	        this.maximumD = (max - 3) / 4;
	        this.vectorLength = 0;
	        this.vector = [];
	    }
	    Storage.prototype.fill = function (start) {
	        for (var i = start; i < this.vectorLength + 4; i += 4) {
	            this.vector[i + 0] = -1;
	            this.vector[i + 1] = -1;
	            this.vector[i + 2] = 0x7fffffff;
	            this.vector[i + 3] = 0x7fffffff;
	        }
	    };
	    Storage.prototype.ensure = function (d) {
	        this.vectorLength = 4 * (d + 1) + 3;
	    };
	    Storage.prototype.initialise = function (d) {
	        this.ensure(d);
	        this.fill(3);
	        return this.vector;
	    };
	    Storage.prototype.extend = function (d) {
	        if (d > this.maximumD) {
	            return null;
	        }
	        var originalLength = this.vectorLength;
	        this.ensure(d);
	        this.fill(originalLength);
	        return this.vector;
	    };
	    return Storage;
	}());
	exports.Storage = Storage;
	// Forward key
	function keyF(k) {
	    return k < 0 ? -4 * k - 1 : 4 * k;
	}
	exports.keyF = keyF;
	// Reverse key
	function keyR(k) {
	    return keyF(k) + 2;
	}
	exports.keyR = keyR;
	// Get forward
	function getF(v, k) {
	    var i = v[keyF(k)];
	    /* tslint:disable-next-line:strict-type-predicates */
	    return i === undefined ? 0 : i;
	}
	exports.getF = getF;
	// Get reverse
	function getR(v, k) {
	    var i = v[keyR(k)];
	    /* tslint:disable-next-line:strict-type-predicates */
	    return i === undefined ? 0 : i;
	}
	exports.getR = getR;
	// Set forward
	function setF(v, k, i) {
	    v[keyF(k)] = i;
	}
	exports.setF = setF;
	// Set reverse
	function setR(v, k, i) {
	    var key = keyR(k);
	    v[key] = i;
	}
	exports.setR = setR;
	// Next forward
	function nextF(v, k) {
	    var left = getF(v, k + 1);
	    var right = getF(v, k - 1);
	    return left < right ? right : left + 1;
	}
	exports.nextF = nextF;
	// Next reverse
	function nextR(v, k) {
	    var left = getR(v, k + 1);
	    var right = getR(v, k - 1);
	    return left < right ? left : right - 1;
	}
	exports.nextR = nextR;
	/**
	 * Limit a diagonal by the length of an input.
	 *
	 * If d is greater than the length, return the diagonal to use instead. This
	 * is used to constrain the forward vector entries to an (n+1) * (m+1)
	 * rectangle, and the reverse vector entries to an (m+1) * (n+1) rectangle.
	 */
	function corner(d, length) {
	    if (d <= length) {
	        return d;
	    }
	    else {
	        return 2 * length - d;
	    }
	}
	exports.corner = corner;
	function checkBounds(buffer, offset, length) {
	    if (offset < 0) {
	        throw new Error("offset " + offset + " < 0");
	    }
	    if (length < 0) {
	        throw new Error("length " + length + " < 0");
	    }
	    if (offset + length > buffer.length || offset + length < 0) {
	        throw new Error("offset " + offset + " + " + length + " > " + buffer.length);
	    }
	}
	exports.checkBounds = checkBounds;
	var Execution = /** @class */ (function () {
	    function Execution(storage, a, b, script, bailOutFactor) {
	        this.storage = storage;
	        this.a = a;
	        this.b = b;
	        this.script = script;
	        this.bailOutFactor = bailOutFactor;
	    }
	    Execution.prototype.diff = function (aOffset, aLength, bOffset, bLength, limit) {
	        if (limit === void 0) { limit = this.bailOutFactor; }
	        checkBounds(this.a, aOffset, aLength);
	        checkBounds(this.b, bOffset, bLength);
	        // trim common prefix and suffix.
	        // middleSnake() relies on this to avoid searching the
	        // initial diagonal.
	        var p = this.afterCommonPrefix(aOffset, aLength, bOffset, bLength);
	        var u = this.beforeCommonSuffix(aOffset, aLength, bOffset, bLength, p);
	        var v = u + bLength - aLength;
	        // add the common prefix to the script
	        if (!this.script.match(aOffset, p) /* prefix */) {
	            return false;
	        }
	        var result;
	        if (p === u) {
	            result = this.script.insert(bOffset + p, v - p);
	        }
	        else if (p === v) {
	            result = this.script.delete();
	        }
	        else {
	            result = this.middleSnake(aOffset + p, u - p, bOffset + p, v - p, limit);
	        }
	        return result && this.script.match(aOffset + u, aLength - u); // Suffix
	    };
	    /**
	     * Search for the first mismatch between the buffers `a` and `b`.
	     *
	     * @param  aoff  the offset in buffer `a` to start from
	     * @param  n     the maximum number of bytes to search in `a`
	     * @param  boff  the offset in buffer `b` to start from
	     * @param  m     the maximum number of bytes to search in `b`
	     * @return       the first position of the mismatch counted from the offsets
	     */
	    Execution.prototype.afterCommonPrefix = function (aoff, n, boff, m) {
	        var end = Math.min(n, m);
	        for (var p = 0; p < end; ++p) {
	            if (this.a[aoff + p] !== this.b[boff + p]) {
	                return p;
	            }
	        }
	        return Math.max(0, end);
	    };
	    /**
	     * Search for the first mismatch between the buffers `a` and `b` starting
	     * from the back.
	     *
	     * @param  aoff  the offset in buffer `a` to start from
	     * @param  n     the maximum number of bytes to search in `a`
	     * @param  boff  the offset in buffer `b` to start from
	     * @param  m     the maximum number of bytes to search in `b`
	     * @return       the first position of the mismatch counted from the offsets
	     */
	    Execution.prototype.beforeCommonSuffix = function (aoff, aLength, boff, bLength, limit) {
	        var end = Math.max(0, aLength - bLength) + limit;
	        for (var u = aLength; u > end; --u) {
	            if (this.a[aoff + u - 1] !== this.b[boff + u + bLength - aLength - 1]) {
	                return u;
	            }
	        }
	        return Math.min(aLength, end);
	    };
	    /**
	     * Variant of {@link Execution.diff} used when there is known to be no common
	     * prefix.
	     */
	    Execution.prototype.diffNoPrefix = function (aoff, aLength, boff, bLength, limit) {
	        if (limit === void 0) { limit = this.bailOutFactor; }
	        var u = this.beforeCommonSuffix(aoff, aLength, boff, bLength, 0);
	        var v = u + bLength - aLength;
	        var r;
	        if (0 === u) {
	            r = this.script.insert(boff, v);
	        }
	        else if (0 === v) {
	            r = this.script.delete();
	        }
	        else {
	            r = this.middleSnake(aoff, u, boff, v, limit);
	        }
	        return r && this.script.match(aoff + u, aLength - u); // suffix
	    };
	    /**
	     * Variant of {@link Execution.diff} used when there is known to be no common
	     * suffix.
	     */
	    Execution.prototype.diffNoSuffix = function (aoff, aLength, boff, bLength, limit) {
	        if (limit === void 0) { limit = this.bailOutFactor; }
	        var p = this.afterCommonPrefix(aoff, aLength, boff, bLength);
	        if (!this.script.match(aoff, p) /* prefix */) {
	            // Possible if the edit script fails to return SUCCESS for the
	            // pending operation.
	            return false;
	        }
	        if (p === aLength) {
	            return this.script.insert(boff + p, bLength - p);
	        }
	        else if (p === bLength) {
	            return this.script.delete();
	        }
	        else {
	            return this.middleSnake(aoff + p, aLength - p, boff + p, bLength - p, limit);
	        }
	    };
	    /* tslint:disable-next-line:cyclomatic-complexity */
	    Execution.prototype.middleSnake = function (aOffset, aLength, bOffset, bLength, initialLimit) {
	        var delta = aLength - bLength;
	        /* tslint:disable-next-line:no-bitwise */
	        var odd = delta & 1;
	        var vec = this.storage.initialise(1);
	        setF(vec, 0, 0);
	        setR(vec, 0, aLength);
	        var d = 1;
	        var limit = initialLimit;
	        do {
	            var cornerA = corner(d, aLength);
	            var cornerB = corner(d, bLength);
	            for (var k1 = -cornerA; k1 <= cornerB; k1 += 2) {
	                var x1 = nextF(vec, k1);
	                var u1 = x1 + this.afterCommonPrefix(aOffset + x1, aLength - x1, bOffset + x1 + k1, bLength - k1 - x1);
	                if (odd && Math.abs(k1 + delta) <= d - 1 && u1 >= getR(vec, k1 + delta)) {
	                    return this.recurse(aOffset, aLength, bOffset, bLength, x1, u1, k1);
	                }
	                setF(vec, k1, u1);
	            }
	            for (var k2 = -cornerB; k2 <= cornerA; k2 += 2) {
	                var u2 = nextR(vec, k2);
	                var kd = k2 - delta;
	                var x2 = this.beforeCommonSuffix(aOffset, u2, bOffset, kd + u2, 0);
	                if (!odd && Math.abs(kd) <= d && x2 <= getF(vec, kd)) {
	                    return this.recurse(aOffset, aLength, bOffset, bLength, x2, u2, kd);
	                }
	                setR(vec, k2, x2);
	            }
	            // Constant soup ahead. The following values were found to
	            // work well be experiment. The exact values are not too
	            // critical, but don't change them without measuring
	            // significant benefits in the (cost, delta size) and
	            // the bail out responsiveness.
	            // 1. We check progress every 64 diagonals ...
	            /* tslint:disable-next-line:no-bitwise */
	            if ((d & 0x3f) === 0 && this.slowProgress(vec, aLength, bLength, cornerA, cornerB, d)) {
	                // 2 ... and on finding slow progress, reduce the limit.
	                // Periodic checking balances the cost of the check against
	                // earlier detection, and avoids progress checking for small
	                // search spaces.
	                // The reduction of the limit by a proportion the period is
	                // key to bailing out fast without collapsing. So the value
	                // it needs to be high enough, but not equal to the period.
	                limit -= 0x30;
	            }
	            else if (d > Math.max(4, limit)) {
	                // 3. We must iterate a minimum number of times to avoid the
	                // possibility of stack overflow through low-progress recursion.
	                return this.bail(vec, aOffset, aLength, bOffset, bLength, cornerA, cornerB, Math.trunc(limit / 2));
	            }
	            ++d;
	            vec = this.storage.extend(d);
	        } while (vec !== null);
	        return false;
	    };
	    Execution.prototype.slowProgress = function (vec, aLength, bLength, cornerA, cornerB, d) {
	        var _a = __read(this.bestForward(vec, aLength, bLength, cornerA, cornerB), 2), xforward = _a[0], yforward = _a[1];
	        var _b = __read(this.bestReverse(vec, aLength, bLength, cornerA, cornerB), 2), xreverse = _b[0], yreverse = _b[1];
	        var fbest = xforward + yforward;
	        var rbest = aLength + bLength - xreverse - yreverse;
	        var progress = fbest + rbest;
	        // It's time for some serious hand waving.
	        // progress >= 2d.
	        // The cost of continuing an iteration is O(d^2).
	        // But this is a sampling approach and there may good progress to
	        // be made later. So let's pick a function that lies in between.
	        return progress < math_1.approximateSquareRoot(d) * d;
	    };
	    Execution.prototype.bestForward = function (vec, aLength, bLength, cornerA, cornerB) {
	        var xforward = 0;
	        var yforward = 0;
	        for (var k = -cornerA; k <= cornerB; k += 2) {
	            // Forward x values can exceed n because we don't constrain
	            // FORWARD.getNext(). Similarly y values can exceed n. Detect
	            // and slide back within the square.
	            var x = Math.min(getF(vec, k), aLength, bLength - k);
	            var y = x + k;
	            if (x + y > xforward + yforward) {
	                xforward = x;
	                yforward = y;
	            }
	        }
	        return [xforward, yforward];
	    };
	    Execution.prototype.bestReverse = function (vec, aLength, bLength, cornerA, cornerB) {
	        var xreverse = aLength;
	        var yreverse = bLength;
	        for (var k = -cornerB; k <= cornerA; k += 2) {
	            // Similarly reverse x and y values can be less than 0.
	            var kd = k - (aLength - bLength);
	            var x = Math.max(getR(vec, k), 0, -kd);
	            var y = x + kd;
	            if (x + y < xreverse + yreverse) {
	                xreverse = x;
	                yreverse = y;
	            }
	        }
	        return [xreverse, yreverse];
	    };
	    Execution.prototype.recurse = function (aOffset, aLength, bOffset, bLength, x, u, k) {
	        return this.diffNoPrefix(aOffset, x, bOffset, x + k)
	            && this.script.match(aOffset + x, u - x)
	            && this.diffNoSuffix(aOffset + u, aLength - u, bOffset + u + k, bLength - u - k);
	    };
	    Execution.prototype.bail = function (vec, aOffset, aLength, bOffset, bLength, cornerA, cornerB, limit) {
	        var _a = __read(this.bestForward(vec, aLength, bLength, cornerA, cornerB), 2), xforward = _a[0], yforward = _a[1];
	        var _b = __read(this.bestReverse(vec, aLength, bLength, cornerA, cornerB), 2), xreverse = _b[0], yreverse = _b[1];
	        if (xforward >= xreverse || yforward >= yreverse) {
	            // Best forward and reverse searches overlap, use the one
	            // with the most progress to split space into two parts.
	            if (aLength + bLength - xreverse - yreverse > xforward + yforward) {
	                return this.splitDiff(aOffset, xreverse, aLength, bOffset, yreverse, bLength);
	            }
	            else {
	                return this.splitDiff(aOffset, xforward, aLength, bOffset, yforward, bLength);
	            }
	        }
	        else {
	            // Best forward and reverse searches don't overlap. Split
	            // into three parts.
	            return this.diffNoPrefix(aOffset, xforward, bOffset, yforward)
	                // Use boundedDiff for the unexplored territory.
	                && this.boundedDiff(aOffset + xforward, xreverse - xforward, bOffset + yforward, yreverse - yforward, aLength, bLength, limit)
	                && this.diffNoSuffix(aOffset + xreverse, aLength - xreverse, bOffset + yreverse, bLength - yreverse);
	        }
	    };
	    /*
	     * Variant of #diff used by #bail to ensure we are dividing the problem space
	     * sufficiently to prevent stack overflow
	     */
	    Execution.prototype.boundedDiff = function (aOffset, aLength, bOffset, bLength, totalN, totalM, limit) {
	        var totalSpace = totalN * totalM;
	        var nm = aLength * bLength;
	        // We use Math.floor here instead of a bitwise op as totalSpace may be an integer larger than 32 bits
	        /* tslint:disable-next-line:no-bitwise */
	        var threshold = Math.floor((1 << 24) + totalSpace / 2);
	        if (nm >= threshold) {
	            if (limit <= 0) {
	                // OK, let's *really* slam the breaks on.
	                // Don't do any further analysis on the first and last
	                // quarter of the unexplored space.
	                var n0 = Math.trunc(aLength / 4);
	                var n1 = n0 + Math.trunc(aLength / 2);
	                var m0 = Math.trunc(bLength / 4);
	                var m1 = m0 + Math.trunc(bLength / 2);
	                return this.noDiff(bOffset, m0) &&
	                    this.diff(aOffset + n0, n1 - n0, bOffset + m0, m1 - m0, limit) &&
	                    this.noDiff(bOffset + m1, bLength - m1);
	            }
	            var x = Math.trunc(aLength / 2);
	            var y = Math.trunc(bLength / 2);
	            return this.splitDiff(aOffset, x, aLength, bOffset, y, bLength, limit);
	        }
	        else {
	            return this.middleSnake(aOffset, aLength, bOffset, bLength, limit);
	        }
	    };
	    Execution.prototype.splitDiff = function (aOffset, n1, n2, bOffset, m1, m2, limit) {
	        return this.diffNoPrefix(aOffset, n1, bOffset, m1, limit)
	            && this.diffNoSuffix(aOffset + n1, n2 - n1, bOffset + m1, m2 - m1, limit);
	    };
	    Execution.prototype.noDiff = function (bOffset, bLength) {
	        return this.script.insert(bOffset, bLength) && this.script.delete();
	    };
	    return Execution;
	}());
	exports.Execution = Execution;
	// Diff operations
	function INSERT(script, start, length) {
	    return script.insert(start, length);
	}
	exports.INSERT = INSERT;
	function MATCH(script, start, length) {
	    return script.match(start, length);
	}
	exports.MATCH = MATCH;
	function NOOP() {
	    return true;
	}
	exports.NOOP = NOOP;
	function coalesce(delegate, aOffset, bOffset) {
	    var neverFlushed = true;
	    var pendingLength = 0;
	    var pendingStart = 0;
	    var pending = NOOP;
	    function flushPending() {
	        neverFlushed = neverFlushed && (pending === NOOP);
	        return pending(delegate, pendingStart, pendingLength);
	    }
	    function process(op, start, length) {
	        if (length > 0) {
	            if (pending !== op) {
	                if (!flushPending()) {
	                    return false;
	                }
	                pending = op;
	                pendingStart = start;
	                pendingLength = length;
	            }
	            else {
	                pendingLength += length;
	            }
	        }
	        return true;
	    }
	    return {
	        insert: function (bStart, length) {
	            return process(INSERT, bStart - bOffset, length);
	        },
	        match: function (aStart, length) {
	            return process(MATCH, aStart - aOffset, length);
	        },
	        delete: function (aStart, length) {
	            // We discard all deletes, but must flush pending matches.
	            // INSERT,DELETE,INSERT can be coalesced to drop the DELETE;
	            // MATCH,DELETE,MATCH cannot.
	            if (pending === INSERT) {
	                return true;
	            }
	            var r = flushPending();
	            pending = NOOP;
	            return r;
	        },
	        close: function (aLength, bLength) {
	            if (neverFlushed) {
	                if (pending === INSERT) {
	                    return exports.REPLACE;
	                }
	                else if (pendingStart === 0 && pendingLength === aLength) {
	                    return exports.NO_CHANGE;
	                }
	            }
	            return flushPending() && delegate.close() ? exports.SUCCESS : exports.REPLACE;
	        }
	    };
	}
	exports.coalesce = coalesce;
	/**
	 * Implementation of Myer's diff with the linear space refinement.
	 *
	 * Diff the subset of two buffers, as specified by offset/length parameters,
	 * with differences written to the provided script.
	 *
	 * See E. Myers (1986). "An O(ND) Difference Algorithm and Its Variations".
	 * Algorithmica 1 (2): 251–266.
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
	 *
	 * For more documentation, refer to the Java implementation.
	 *
	 * The bail out factor determines when to give up in middlesnake and produce a
	 * more approximate result. Larger values increase the precision at the cost of
	 * increased CPU.
	 *
	 * The number of diagonals to search in each middleSnake call is bounded by
	 * max(256, bailOutFactor/100 * totalLength)
	 *
	 * For inputs with a lot of small differences, a smaller bailOutFactor often
	 * has a beneficial effect of moderately reducing the size of the result.
	 * But it can also increase the size, occasionally dramatically.
	 * Additionally, the reduced precision affects the quality of JSON
	 * structural deltas. YMMV, as they say.
	 */
	var MyersBinaryDiff = /** @class */ (function () {
	    /**
	     * Create a MyersBinaryDiff object
	     *
	     * @param maximumStorage  maximum storage limit
	     * @param bailOutFactor   bail-out limit factor
	     */
	    function MyersBinaryDiff(maximumStorage, bailOutFactor) {
	        if (maximumStorage === void 0) { maximumStorage = MAXIMUM_STORAGE; }
	        if (bailOutFactor === void 0) { bailOutFactor = BAIL_OUT_FACTOR; }
	        this.bailOutFactor = bailOutFactor;
	        this.storage = new Storage(maximumStorage);
	    }
	    /**
	     * @param a           source data
	     * @param aOffset     start of source data
	     * @param aLength     length of source data
	     * @param b           target data
	     * @param bOffset     start of target data
	     * @param bLength     length of target data
	     * @param editScript  the edit script
	     */
	    MyersBinaryDiff.prototype.diff = function (a, aOffset, aLength, b, bOffset, bLength, editScript) {
	        var script = coalesce(editScript, aOffset, bOffset);
	        var execution = new Execution(this.storage, a, b, script, this.bailOutFactor);
	        if (!execution.diff(aOffset, aLength, bOffset, bLength)) {
	            return exports.REPLACE;
	        }
	        return script.close(aLength, bLength);
	    };
	    return MyersBinaryDiff;
	}());
	exports.MyersBinaryDiff = MyersBinaryDiff;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_datatype_1 = __webpack_require__(144);
	var json_impl_1 = __webpack_require__(328);
	var function_1 = __webpack_require__(89);
	/**
	 * A data type for JSON values
	 */
	var JSONDataTypeImpl = /** @class */ (function (_super) {
	    __extends(JSONDataTypeImpl, _super);
	    /**
	     * Create a new JSONDataTypeImpl instance
	     */
	    function JSONDataTypeImpl() {
	        var _this = _super.call(this, 'json', json_impl_1.JSONImpl, json_impl_1.JSONImpl, json_impl_1.JSONImpl.from, function_1.identity, [], true) || this;
	        /**
	         * The implementation of the underlying value type
	         */ // tslint:disable-next-line:variable-name
	        _this.JSON = json_impl_1.JSONImpl;
	        return _this;
	    }
	    JSONDataTypeImpl.prototype.fromJsonString = function (value) {
	        return json_impl_1.JSONImpl.from(JSON.parse(value));
	    };
	    /**
	     * Create a new JSON instance from data
	     *
	     * @param value  the CBOR data containing the record
	     * @return       a new JSON instance
	     */
	    JSONDataTypeImpl.prototype.from = function (object) {
	        return json_impl_1.JSONImpl.from(object);
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONDataTypeImpl.prototype.validate = function () {
	        // no-op. This data type validates on read.
	    };
	    return JSONDataTypeImpl;
	}(abstract_datatype_1.AbstractDataType));
	exports.JSONDataTypeImpl = JSONDataTypeImpl;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var json_pointer_1 = __webpack_require__(230);
	var json_pointer_map_1 = __webpack_require__(1174);
	var span_parser_1 = __webpack_require__(1175);
	/**
	 * A consumer for the span parser that handles any match and only holds on to
	 * the last pointer
	 */
	var LastResult = /** @class */ (function () {
	    /**
	     * Create a LastResult consumer
	     *
	     * @param splitStructures  a pointer map that will be filled with any split
	     *                         structures found in the matching data
	     */
	    function LastResult(splitStructures) {
	        this.splitStructures = splitStructures;
	    }
	    /**
	     * Accept a JSON pointer found
	     *
	     * @param pointer  the JSON pointer
	     * @param start    the starting position in the buffer
	     * @param length   the number of bytes in the buffer
	     */
	    LastResult.prototype.accept = function (pointer, start, length) {
	        this.last = pointer;
	        this.lastStart = start;
	        this.lastLength = length;
	    };
	    /**
	     * Check if a last pointer has been found
	     *
	     * @return `true` if {@link accept} has been called with a JSON pointer
	     */
	    LastResult.prototype.foundLast = function () {
	        /* tslint:disable-next-line:strict-type-predicates */
	        return this.last !== undefined;
	    };
	    /**
	     * Pass the last pointer to the delegate consumer
	     *
	     * @param  delegate  the delegate consumer
	     */
	    LastResult.prototype.consumeLast = function (delegate) {
	        delegate.accept(this.last, this.lastStart, this.lastLength);
	    };
	    /**
	     * Signal the end of a split structure
	     *
	     * @param pointer  the JSON pointer
	     * @param count    the number of tokens in the split structure
	     * @param start    the starting position in the buffer
	     * @param length   the number of bytes in the buffer
	     */
	    LastResult.prototype.splitStructureEnd = function (pointer, count, start, length) {
	        this.splitStructures.put(pointer, {
	            start: start,
	            length: length,
	            elements: count
	        });
	    };
	    return LastResult;
	}());
	/**
	 * Check if a {@link BufferSlice} contains the same bytes as the original {@link Bytes}
	 *
	 * @param  original the original bytes
	 * @param  other    the buffer to compare to
	 * @param  start    the offset of the first byte to compare in the buffer
	 * @param  length   the number of bytes to compare
	 * @return          `true` if the slice of the `other` buffer is equal to the
	 *                  bytes contained in `original`
	 */
	function isPartOf(original, other, start, length) {
	    return original.equalBytes(other.$buffer, other.$offset + start, length);
	}
	/**
	 * Incrementally parse the binary delta to calculate a structural delta.
	 *
	 * The result reports all differences, but is not necessarily minimal. In
	 * particular there are occasional 'false positive' REMOVE/INSERT pairs.
	 *
	 * ## The Algorithm
	 *
	 * We re-constitute the match and insert visitor callbacks into a sequence
	 * of delete, insert, and match edits. The binary delta format guarantees
	 * there will not be consecutive callbacks of the same type, and that match
	 * callbacks are presented in order with no overlaps. Delete and match
	 * edits will be contiguous with no gap between the end of one edit and
	 * the start of the next.
	 *
	 * The processing uses two SpanParsers, one for the old token stream and one
	 * for the new token streams. We move forward along each parser driven by
	 * the binary delta edits, skipping old values covered by a match, adding a
	 * REMOVE change for each old value covered by a delete, and adding an
	 * INSERT change for each new value covered by an insert.
	 *
	 * The SpanParsers calculate the appropriate JSON pointers to return for a
	 * span. A span finishes at the end of the first token found after the
	 * target offset, with these exceptions:
	 *
	 * # If a split is found in a field name, the span continues until the
	 *   first pointer is found in the value, potentially consuming one or more
	 *   structure start tokens. The reporting of a change that affects a field
	 *   does not distinguish between the field name and its value, except if the
	 *   value is a structure and the change only affects part of the structure.
	 * # End structure tokens are eagerly consumed. This has two benefits.
	 *   First, it collapses empty structures to the appropriate parent pointer.
	 *   Second, the closing tokens of non-empty structures are associated with
	 *   the last pointer, which simplifies boundary detection.
	 *
	 * The implementation relies on the SpanParser not consuming start structure
	 * tokens eagerly at a split unless instructed to do so (see
	 * {@link SpanParser.spanToNext}). This provides a tighter alignment
	 * between the detected binary differences and the token parsers, allowing a
	 * simpler pairing of tokens between the two streams. I'm not certain there
	 * aren't additional edge cases introduced by the eager consumption of
	 * structure tokens for field names.
	 *
	 * The two token streams are treated symmetrically. Each SpanParser is only
	 * moved in a forward direction; there is no backtracking. We maintain the
	 * current byte position in each binary value as {@link DeltaVisitor.oldOffset} and
	 * {@link DeltaVisitor.newOffset}. After each edit is processed,
	 * `oldParser.nextByte() >= oldOffset` and
	 * `newParser.nextByte() >= newOffset`.
	 *
	 * The fun happens at the edges, specifically where a token covers one or
	 * more binary edits. We call such a misaligned edge a 'split'.
	 *
	 * ### Splits
	 *
	 * The appropriate processing of a split depends on the type of edit in
	 * which it is found. For all edit types, we detect and process
	 * _trailing edge_ splits; i.e. splits detected at the end of a span
	 * because the end of the last parsed token is after the end edge. It turns
	 * out we must also consider _leading edge_ splits for match edits.
	 *
	 * #### insert edits
	 *
	 * We insert everything in the span. If a trailing edge split is detected,
	 * we do one of two things.
	 * * If the old stream parser is at a split, there is nothing to do.
	 *   The split will have been considered and processed for an earlier edit.
	 * * If the old stream parser is at `oldOffset` (i.e. is not at a
	 *   split token), we consume and add a REMOVE change for the next pointer in
	 *   the old stream. The old stream is otherwise unaffected by the insert
	 *   edit, so `oldOffset` is the start of the next delete or match
	 *   edit. Consuming the token might move it further into other delete or
	 *   match edits. In all cases, correct handling of the insert split requires
	 *   adding a REMOVE change for the first pointer found.
	 *
	 * Further split detection is required to detect differences that only
	 * affect the CBOR structure. If the parser structure depth is different at
	 * the end of the span than it was at start, the last token is treated in
	 * the same manner as a trailing edge split. Otherwise comparing 'b' with
	 * `['a', 'b', 'c']` incorrectly generates
	 * `INSERT /0,INSERT /2` rather than
	 * `INSERT /0,REMOVE /1,INSERT /1,INSERT /2`.
	 *
	 * #### delete edits
	 *
	 * The processing of splits for delete edits is the inverse of that for
	 * insert edits. (Swap INSERT and REMOVE, old stream and new stream).
	 *
	 * #### match edits
	 *
	 * When processing match edits we move both parsers. Either or both can
	 * have a trailing edge split. If both are split, the corresponding pointers
	 * are used for the REMOVE/INSERT pair. If neither are split, or if only one
	 * is split, we do nothing. As far as I can tell, there can only be a single
	 * split if the match ends with a start structure token (`{` or
	 * `[`), so differences in the structure content will be detected
	 * by later edits.
	 *
	 * I haven't fully convinced myself that it is correct to do nothing in all
	 * single split cases, but it appears to work. I've experimented with a
	 * variant where a single split matches the next pointer eagerly consumed
	 * from the opposite stream, similar to the approach taken for
	 * insert/delete. This produces less satisfactory matching between
	 * structures. E.g. for `[]` with `['a' 'b']` it produces
	 * `REMOVE /0,INSERT /0/0,INSERT/0/1` where the current
	 * implementation produces `INSERT/0/0,INSERT/0/1`. It may be
	 * worth revisiting this in conjunction with the post-processing fix to
	 * collapse complete spans into the parent.
	 *
	 * Consideration of parser depth is unnecessary for match trailing edge
	 * splits. A difference in structure depth must correspond to a binary
	 * difference covering structure delimiters, which will be handled by insert
	 * or delete processing.
	 *
	 * There is a further complication to deal with for matches. A token in one
	 * stream can match the end and start of two tokens in the other stream. We
	 * deal with that by checking for a leading edge split. If the new stream
	 * parser is at the expected offset, and the old stream parser isn't, we've
	 * found a token spanning across two matches in the old stream. The previous
	 * insert edit will have inserted the first pointer for the new stream. We
	 * add the next found in the new stream in the match span (if any). Similar
	 * processing is performed if the old stream parser is at the expected
	 * offset, but the new stream parser is not.
	 *
	 * ### Heuristic clean up
	 *
	 * The basic approach of using the binary delta to identify splits and
	 * matching the splits to the appropriate tokens produces a reasonable but
	 * imperfect result. Further processing is performed to improve the output.
	 *
	 * False positives (redundant REMOVE/INSERT pairs) occur reasonably
	 * frequently in the raw results. These are identified and removed by
	 * comparing each potential REMOVE with the previous INSERT, and each
	 * potential INSERT with the previous REMOVE. If the associated values are
	 * equal, and the pointers are compatible, both changes are dropped.
	 *
	 * The raw results might contain pointers to the entire contents of a
	 * structure. These are replaced with a single pointer to the structure.
	 */
	var DeltaVisitor = /** @class */ (function () {
	    /**
	     * Construct a DeltaVisitor
	     *
	     * @param oldValue    the old value
	     * @param newValue    the new value
	     * @param inserted    the parts of the second JSON value not found in the
	     *                    first JSON value. This map should be empty. It will be
	     *                    filled by the DeltaVisitor.
	     * @param removed     the parts of the first JSON value not found in the
	     *                    second JSON value. This map should be empty. It will be
	     *                    filled by the DeltaVisitor.
	     * @param partOf      a function to return a {@link JSON} object from a part
	     *                    of a {@link BufferSlice}.
	     * @param copyPartOf  a function to return a {@link JSON} object from a copy
	     *                    of part  of a {@link BufferSlice}.
	     */
	    function DeltaVisitor(oldValue, newValue, inserted, removed, partOf, copyPartOf) {
	        var _this = this;
	        /**
	         * The split structures that are part of the old JSON value not found in the new JSON value
	         */
	        this.removedSplitStructures = new json_pointer_map_1.JSONPointerMap();
	        /**
	         * The split structures that are part of the new JSON value not found in the old JSON value
	         */
	        this.insertedSplitStructures = new json_pointer_map_1.JSONPointerMap();
	        /**
	         * The end of the last match edit. After each edit is processed,
	         * `oldParser.nextByte() >= oldOffset`.
	         */
	        this.oldOffset = 0;
	        /**
	         * The newParser position where the next match or insert will start,
	         * which is the cumulative length of the match and insert edits. May be
	         * less than or greater than oldOffset. After each edit is processed,
	         * `newParser.nextByte() >= newOffset`.
	         */
	        this.newOffset = 0;
	        /**
	         * A JSON pointer that is part of the old value but hasn't yet been found
	         * in the new value.
	         */
	        this.pendingRemove = null;
	        /**
	         * A JSON pointer that is part of the new value but hasn't yet been found
	         * in the old value.
	         */
	        this.pendingInsert = null;
	        /**
	         * A consumer for the span parser that inserts values
	         */
	        this.inserter = {
	            /**
	             * Accept a JSON pointer found in the new value
	             *
	             * @param pointer  the JSON pointer of the inserted value
	             * @param start    the starting position in the {@link newValue} buffer
	             * @param length   the number of bytes in the {@link newValue} buffer
	             */
	            accept: function (pointer, start, length) {
	                if (_this.pendingRemove !== null &&
	                    _this.pendingRemove.equalIgnoringIndexes(pointer) &&
	                    isPartOf(_this.pendingRemoveValue, _this.newValue, start, length)) {
	                    // value to insert is equal to the pending removed value
	                    // and their pointers are sufficiently similar. Treat as a
	                    // false positive and discard both.
	                    _this.pendingRemove = null;
	                    _this.pendingRemoveValue = null;
	                }
	                else {
	                    // share the underlying bytes to avoid copying at the
	                    // expense of pinning a potentially large array in memory. We
	                    // expect the user to be using the structural delta to
	                    // decide whether to take action, then throwing everything
	                    // away if not. If it turns out that users often keep the
	                    // structural delta but not the value it might be worth
	                    // providing API control.
	                    _this.addInsert(pointer, _this.partOf(_this.newValue, start, length));
	                    // flush pending remove. Subsequent inserts are less likely
	                    // to match it.
	                    _this.addRemove(null, null);
	                }
	            },
	            /**
	             * Signal the end of a split structure
	             *
	             * @param pointer  the JSON pointer of the inserted value
	             * @param count    the number of tokens in the split structure
	             * @param start    the starting position in the {@link newValue} buffer
	             * @param length   the number of bytes in the {@link newValue} buffer
	             */
	            splitStructureEnd: function (pointer, count, start, length) {
	                _this.insertedSplitStructures.put(pointer, {
	                    start: start,
	                    length: length,
	                    elements: count
	                });
	            }
	        };
	        /**
	         * A consumer for the span parser that removes values
	         */
	        this.remover = {
	            /**
	             * Accept a JSON pointer found in the old value
	             *
	             * @param pointer  the JSON pointer of the removed value
	             * @param start    the starting position in the {@link oldValue} buffer
	             * @param length   the number of bytes in the {@link oldValue} buffer
	             */
	            accept: function (pointer, start, length) {
	                if (_this.pendingInsert !== null &&
	                    _this.pendingInsert.equalIgnoringIndexes(pointer) &&
	                    isPartOf(_this.pendingInsertValue, _this.oldValue, start, length)) {
	                    // value to remove is equal to the pending inserted value
	                    // and their pointers are sufficiently similar. Treat as a
	                    // false positive and discard both.
	                    _this.pendingInsert = null;
	                    _this.pendingInsertValue = null;
	                }
	                else {
	                    // in contrast to the insert consumer, we copy byte ranges
	                    // to avoid pinning the entire old byte array in memory.
	                    _this.addRemove(pointer, _this.copyPartOf(_this.oldValue, start, length));
	                    // flush pending insert. Subsequent removes are less likely
	                    // to match it.
	                    _this.addInsert(null, null);
	                }
	            },
	            /**
	             * Signal the end of a split structure
	             *
	             * @param pointer  the JSON pointer of the inserted value
	             * @param count    the number of tokens in the split structure
	             * @param start    the starting position in the {@link newValue} buffer
	             * @param length   the number of bytes in the {@link newValue} buffer
	             */
	            splitStructureEnd: function (pointer, count, start, length) {
	                _this.removedSplitStructures.put(pointer, {
	                    start: start,
	                    length: length,
	                    elements: count
	                });
	            }
	        };
	        this.oldParser = new span_parser_1.SpanParser(oldValue);
	        this.newParser = new span_parser_1.SpanParser(newValue);
	        this.oldValue = oldValue;
	        this.newValue = newValue;
	        this.inserted = inserted;
	        this.removed = removed;
	        this.partOf = partOf;
	        this.copyPartOf = copyPartOf;
	    }
	    /**
	     * Called by the {@link BinaryDelta} when a match of binary data has been
	     * found.
	     *
	     * @param start   the starting position in the old buffer
	     * @param length  the number of matching bytes
	     * @return        `true`
	     */
	    DeltaVisitor.prototype.match = function (start, length) {
	        this.handleDelete(this.oldOffset, start - this.oldOffset);
	        this.handleMatch(start, length);
	        return true;
	    };
	    /**
	     * Handle deleted binary data
	     *
	     * @param start   the starting position of the deleted data in the old buffer
	     * @param length  the number of deleted bytes
	     */
	    DeltaVisitor.prototype.handleDelete = function (start, length) {
	        this.checkInvariants();
	        var end = start + length;
	        if (this.oldParser.nextByte() < end &&
	            (this.oldParser.spanTo(end, this.remover) !== 0 || this.oldParser.nextByte() > end)) {
	            // the end is split, If newParser is not split, insert the
	            // next pointer found. This will process at most one pointer
	            // because newParser.nextByte() >= newOffset, so we can use
	            // the stateless insert consumer.
	            this.newParser.spanToNext(this.newOffset + 1, this.inserter);
	        }
	    };
	    /**
	     * Handle a match of binary data
	     *
	     * @param start   the starting position in the old buffer
	     * @param length  the number of matching bytes
	     */
	    DeltaVisitor.prototype.handleMatch = function (start, length) {
	        this.checkInvariants();
	        var newStart = this.newOffset;
	        var end = start + length;
	        this.newOffset += length;
	        this.oldOffset = end;
	        var oldNextByte = this.oldParser.nextByte();
	        var newNextByte = this.newParser.nextByte();
	        if (newNextByte > newStart && oldNextByte === start) {
	            // new stream split affects two tokens in old stream. Remove
	            // the second. This will remove exactly one pointer.
	            this.oldParser.spanToNext(start + 1, this.remover);
	        }
	        else if (oldNextByte > start && newNextByte === newStart) {
	            // old stream split affects two tokens in new stream. Insert
	            // the second. This will insert exactly one pointer.
	            this.newParser.spanToNext(newStart + 1, this.inserter);
	        }
	        var lastOld = new LastResult(this.removedSplitStructures);
	        var lastNew = new LastResult(this.insertedSplitStructures);
	        this.oldParser.spanTo(end, lastOld);
	        this.newParser.spanTo(this.newOffset, lastNew);
	        var oldSplit = lastOld.foundLast() && this.oldParser.nextByte() > end;
	        var newSplit = lastNew.foundLast() && this.newParser.nextByte() > this.newOffset;
	        if (oldSplit && newSplit) {
	            lastOld.consumeLast(this.remover);
	            lastNew.consumeLast(this.inserter);
	        }
	    };
	    /**
	     * Called by the {@link BinaryDelta} when a inserted binary data has been
	     * found.
	     *
	     * @param bytes   the inserted data
	     * @return        `true`
	     */
	    DeltaVisitor.prototype.insert = function (bytes) {
	        this.checkInvariants();
	        this.newOffset += bytes.length;
	        if (this.newParser.nextByte() < this.newOffset &&
	            (this.newParser.spanTo(this.newOffset, this.inserter) !== 0
	                || this.newParser.nextByte() > this.newOffset)) {
	            // the end is split. Iff oldParser is not split, remove the
	            // next pointer found. This will process at most one pointer
	            // because/ oldParser.nextByte() >= oldOffset, so we
	            // can use the stateless remove consumer.
	            this.oldParser.spanToNext(this.oldOffset + 1, this.remover);
	        }
	        return true;
	    };
	    /**
	     * Called by the {@link BinaryDelta} when the end of the buffer has been found.
	     */
	    DeltaVisitor.prototype.end = function () {
	        this.handleDelete(this.oldOffset, this.oldValue.$length - this.oldOffset);
	        this.addInsert(null, null);
	        this.addRemove(null, null);
	        this.replaceFullRemovedStructures();
	        this.replaceFullInsertedStructures();
	    };
	    /**
	     * Add an JSON pointer that is pending an insert. Any previous pending
	     * insert is confirmed and placed into the {@link inserted} map.
	     *
	     * @param  nextPointer  the next pointer pending an insert
	     * @param  nextValue    the data associated with the insert
	     */
	    DeltaVisitor.prototype.addInsert = function (nextPointer, nextValue) {
	        if (this.pendingInsert !== null) {
	            this.inserted.put(this.pendingInsert, this.pendingInsertValue);
	        }
	        this.pendingInsert = nextPointer;
	        this.pendingInsertValue = nextValue;
	    };
	    /**
	     * Add an JSON pointer that is pending a remove. Any previous pending
	     * remove is confirmed and placed into the {@link removed} map.
	     *
	     * @param  nextPointer  the next pointer pending a remove
	     * @param  nextValue    the data associated with the remove
	     */
	    DeltaVisitor.prototype.addRemove = function (nextPointer, nextValue) {
	        if (this.pendingRemove !== null) {
	            this.removed.put(this.pendingRemove, this.pendingRemoveValue);
	        }
	        this.pendingRemove = nextPointer;
	        this.pendingRemoveValue = nextValue;
	    };
	    /**
	     * No change
	     */
	    DeltaVisitor.prototype.noChange = function () {
	        // no-op
	    };
	    /**
	     * Check if an invalid state has occurred
	     *
	     * @throws  an error if either buffer contains invalid binary data
	     */
	    DeltaVisitor.prototype.checkInvariants = function () {
	        if (this.oldParser.nextByte() < this.oldOffset ||
	            this.newParser.nextByte() < this.newOffset) {
	            throw new Error('Invalid binary delta');
	        }
	    };
	    /**
	     * Heuristic post-processing: replace split structures for which removed
	     * includes every entry with a single pointer.
	     */
	    DeltaVisitor.prototype.replaceFullRemovedStructures = function () {
	        var i = this.removedSplitStructures.postOrder();
	        while (i.hasNext()) {
	            var s = i.next();
	            var split = s.value;
	            var entry = this.removed.getEntry(s.pointer);
	            if (entry !== null && entry.numberOfChildren() === split.elements) {
	                entry.setValue(this.copyPartOf(this.oldValue, split.start, split.length));
	                entry.removeDescendants();
	            }
	        }
	    };
	    /**
	     * Heuristic post-processing: replace split structures for which
	     * inserted includes every entry with a single pointer.
	     */
	    DeltaVisitor.prototype.replaceFullInsertedStructures = function () {
	        var i = this.insertedSplitStructures.postOrder();
	        while (i.hasNext()) {
	            var s = i.next();
	            var split = s.value;
	            var entry = this.inserted.getEntry(s.pointer);
	            if (entry !== null && entry.numberOfChildren() === split.elements) {
	                entry.setValue(this.partOf(this.newValue, split.start, split.length));
	                entry.removeDescendants();
	            }
	        }
	    };
	    return DeltaVisitor;
	}());
	/**
	 * Implementation of the change map
	 *
	 * @inheritdoc
	 */
	var ChangeMapImpl = /** @class */ (function () {
	    /**
	     * Create a ChangeMapImpl
	     *
	     * @param parts the JSON pointers contained in the change
	     */
	    function ChangeMapImpl(parts) {
	        /**
	         * The array of key-value pairs contained in the change map
	         */
	        this.entries = [];
	        this.parts = parts;
	        var i = parts.iterator();
	        while (i.hasNext()) {
	            var n = i.next();
	            this.entries.push({
	                key: n.pointer.toString(),
	                value: n.value.get()
	            });
	        }
	        this.length = this.entries.length;
	    }
	    /**
	     * @inheritdoc
	     */
	    ChangeMapImpl.prototype.get = function (key) {
	        return this.parts.get(json_pointer_1.JSONPointer.parse(key)).get();
	    };
	    /**
	     * @inheritdoc
	     */
	    ChangeMapImpl.prototype.entrySet = function () {
	        return this.entries;
	    };
	    /**
	     * @inheritdoc
	     */
	    ChangeMapImpl.prototype.containsKey = function (key) {
	        return this.parts.contains(json_pointer_1.JSONPointer.parse(key));
	    };
	    /**
	     * @inheritdoc
	     */
	    ChangeMapImpl.prototype.descendants = function (pointer) {
	        return new ChangeMapImpl(this.parts.descendants(json_pointer_1.JSONPointer.parse(pointer)));
	    };
	    /**
	     * @inheritdoc
	     */
	    ChangeMapImpl.prototype.intersection = function (pointer) {
	        return new ChangeMapImpl(this.parts.intersection(json_pointer_1.JSONPointer.parse(pointer)));
	    };
	    return ChangeMapImpl;
	}());
	/**
	 * Implementation of {@link JSONDelta}.
	 *
	 * @inheritdoc
	 */
	var JSONDeltaImpl = /** @class */ (function () {
	    /**
	     * Create a new JSONDeltaImpl
	     *
	     * @param factory      constructor function for creating {@link JSON} objects
	     * @param original     the original JSON data
	     * @param newValue     the modified JSON data
	     * @param binaryDelta  the binary delta between the original and the modified
	     *                     data. If no binary delta is provided the JSON delta
	     *                     will assume that all old JSON data is removed and
	     *                     replaced by the new JSON data.
	     */
	    function JSONDeltaImpl(factory, original, newValue, binaryDelta) {
	        /**
	         * The parts of the second JSON value not found in the first JSON value.
	         */
	        this.insertedMap = new json_pointer_map_1.JSONPointerMap();
	        /**
	         * The parts of the first JSON value not found in the second JSON value.
	         */
	        this.removedMap = new json_pointer_map_1.JSONPointerMap();
	        this.factory = factory;
	        if (binaryDelta !== undefined) {
	            binaryDelta.visit(new DeltaVisitor(original, newValue, this.insertedMap, this.removedMap, this.partOf.bind(this), this.copyPartOf.bind(this)));
	        }
	        else {
	            this.insertedMap.put(json_pointer_1.ROOT, original);
	            this.removedMap.put(json_pointer_1.ROOT, newValue);
	        }
	    }
	    /**
	     * Return a {@link JSON} object from a part of a {@link BufferSlice}.
	     *
	     * @param value   the buffer slice to construct the JSON from
	     * @param start   the offset in the buffer slice
	     * @param length  the number of bytes to use from the buffer slice
	     * @return        a JSON object constructed from the part of the buffer slice
	     */
	    JSONDeltaImpl.prototype.partOf = function (value, start, length) {
	        return new this.factory(value.$buffer, value.$offset + start, length);
	    };
	    /**
	     * Return a {@link JSON} object from a part of a {@link BufferSlice}. The
	     * buffer is copied before being passed to the JSON constructor.
	     *
	     * @param value   the buffer slice to construct the JSON from
	     * @param start   the offset in the buffer slice
	     * @param length  the number of bytes to use from the buffer slice
	     * @return        a JSON object constructed from the part of the buffer slice
	     */
	    JSONDeltaImpl.prototype.copyPartOf = function (value, start, length) {
	        var offsetStart = value.$offset + start;
	        var buffer = Buffer.alloc(length);
	        value.$buffer.copy(buffer, 0, offsetStart, offsetStart + length);
	        return new this.factory(buffer, 0, length);
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONDeltaImpl.prototype.removed = function () {
	        return new ChangeMapImpl(this.removedMap);
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONDeltaImpl.prototype.inserted = function () {
	        return new ChangeMapImpl(this.insertedMap);
	    };
	    /**
	     * @inheritdoc
	     */
	    JSONDeltaImpl.prototype.hasChanges = function () {
	        return this.removedMap.size !== 0 || this.insertedMap.size !== 0;
	    };
	    /**
	     * Convert the JSON delta to a string
	     *
	     * @returns  a string representation of the JSON delta
	     */
	    JSONDeltaImpl.prototype.toString = function () {
	        return ['REMOVE ', this.removedMap, ' INSERT ', this.insertedMap].join('');
	    };
	    return JSONDeltaImpl;
	}());
	exports.JSONDeltaImpl = JSONDeltaImpl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var json_pointer_1 = __webpack_require__(230);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Returned through {@link JSONPointerMap.getEntry} and iterators.
	 *
	 * Following a sequence of put operations, all entries will have a value, or
	 * children, or both. Through the {@link Entry.removeDescendants()} method,
	 * it is possible for an entry to have neither a value nor children.
	 */
	var Entry = /** @class */ (function () {
	    /**
	     *
	     *
	     * @param  segment the segment of the entry, `null` if the entry is the root entry
	     * @param  pointer the pointer to the location if the entry
	     * @param  context the map that this entry belongs to
	     */
	    function Entry(segment, pointer, context) {
	        this.segment = segment;
	        this.pointer = pointer;
	        this.children = [];
	        this.value = null;
	        this.context = context;
	    }
	    /**
	     * Recursively count the number of entries in the tree
	     *
	     * @return the number of entries that contain a value
	     */
	    Entry.prototype.count = function () {
	        var e_1, _a;
	        var result = this.value ? 1 : 0;
	        try {
	            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var child = _c.value;
	                result += child.count();
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return result;
	    };
	    /**
	     * Add a child entry
	     *
	     * @param  s  the segment of the new entry, relative to this entry's segment
	     * @return    the newly created child
	     */
	    Entry.prototype.addChild = function (s) {
	        var c = new Entry(s, this.pointer.withSegment(s), this.context);
	        this.children.push(c);
	        return c;
	    };
	    /**
	     * Find an immediate child by the segment
	     *
	     * @param s  the segment to search for
	     * @return   the child that matches the segment, `null` if not child was found
	     */
	    Entry.prototype.findChild = function (s) {
	        var e_2, _a;
	        try {
	            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var child = _c.value;
	                if (s.equals(child.segment)) {
	                    return child;
	                }
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	        return null;
	    };
	    /**
	     * Set the value of the entry
	     *
	     * @param  newValue  the new value of the entry
	     * @return           the old value of the entry
	     */
	    Entry.prototype.setValue = function (newValue) {
	        var previous = this.value;
	        if (previous === null) {
	            this.context.size++;
	        }
	        this.value = newValue;
	        return previous;
	    };
	    /**
	     * Remove all descendants of the entry
	     *
	     * @return  the total number of removed descendants that contained a value
	     */
	    Entry.prototype.removeDescendants = function () {
	        var e_3, _a;
	        var removed = 0;
	        try {
	            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var child = _c.value;
	                removed += child.count();
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        this.children = [];
	        this.context.size -= removed;
	        return removed;
	    };
	    /**
	     * Calculate the number of direct children that contain a value
	     *
	     * @return the number of children with a value
	     */
	    Entry.prototype.numberOfChildren = function () {
	        var e_4, _a;
	        var result = 0;
	        try {
	            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var child = _c.value;
	                result += (child.value ? 1 : 0);
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return result;
	    };
	    /**
	     * Convert the entry to a string
	     *
	     * @returns  a string representation of the entry
	     */
	    Entry.prototype.toString = function () {
	        return this.pointer + '=' + this.value;
	    };
	    return Entry;
	}());
	exports.Entry = Entry;
	/**
	 * A state for the post-order iterator over {@link JSONPointerMap} entries.
	 */
	var PostOrderState = /** @class */ (function () {
	    /**
	     * Create a post-order iterator state with the current map entry
	     *
	     * @param  node  the current map entry
	     */
	    function PostOrderState(node) {
	        /**
	         * The next child index to return
	         */
	        this.nextChildIndex = 0;
	        this.node = node;
	    }
	    /**
	     * Get the next child
	     *
	     * @return  the next child, `null` if there are no more children
	     */
	    PostOrderState.prototype.nextChild = function () {
	        var children = this.node.children;
	        if (this.nextChildIndex >= children.length) {
	            return null;
	        }
	        return children[this.nextChildIndex++];
	    };
	    return PostOrderState;
	}());
	/**
	 * An iterator over {@link JSONPointerMap} entries
	 */
	var EntryIterator = /** @class */ (function () {
	    /**
	     * Create an entry iterator
	     *
	     * @param  nextWithValue  a function that returns the next entry with a value
	     */
	    function EntryIterator(nextWithValue) {
	        this.nextEntry = nextWithValue();
	        this.nextWithValue = nextWithValue;
	    }
	    /**
	     * Check if there is another entry
	     *
	     * @return `true` if the iterator can return a non-null next entry
	     */
	    EntryIterator.prototype.hasNext = function () {
	        return this.nextEntry !== null;
	    };
	    /**
	     * Get the next entry
	     *
	     * @return  the next entry
	     * @throws  an error if no next entry exists
	     */
	    EntryIterator.prototype.next = function () {
	        if (this.nextEntry === null) {
	            throw new Error('No such element');
	        }
	        var result = this.nextEntry;
	        this.nextEntry = this.nextWithValue();
	        return result;
	    };
	    return EntryIterator;
	}());
	exports.EntryIterator = EntryIterator;
	/**
	 * A hierarchical map of {@link JSONPointer}s.
	 */
	var JSONPointerMap = /** @class */ (function () {
	    function JSONPointerMap() {
	        /**
	         * The root pointer
	         */
	        this.root = new Entry(null, json_pointer_1.ROOT, this);
	        /**
	         * The number of entries, not counting the root
	         */
	        this.size = 0;
	    }
	    /**
	     * Add an entry.
	     *
	     * By design, no constraints are applied to the supplied pointer. E.g. it is
	     * possible to add 'x/foo' followed by 'x/1', even though these
	     * cannot be valid paths in a single document. This supports the structural
	     * diff use case where we might 'add('x/foo', REMOVE)', then 'add('x/1', INSERT)'.
	     *
	     * @param pointer the pointer to the location that the value is stored
	     * @param value   may not be null
	     * @returns       the previous value
	     */
	    JSONPointerMap.prototype.put = function (pointer, value) {
	        require_non_null_1.requireNonNull(value, 'value');
	        var node = this.root;
	        var i = 0;
	        for (; i < pointer.segments.length;) {
	            var s = pointer.segments[i++];
	            var c = node.findChild(s);
	            if (c === null) {
	                node = node.addChild(s);
	                break;
	            }
	            node = c;
	        }
	        for (; i < pointer.segments.length; i++) {
	            node = node.addChild(pointer.segments[i]);
	        }
	        return node.setValue(value);
	    };
	    /**
	     * Check if the map contains value for a given pointer
	     *
	     * @param pointer the pointer to check
	     * @returns       `true` if this map has a value for pointer
	     */
	    JSONPointerMap.prototype.contains = function (pointer) {
	        return this.get(pointer) !== null;
	    };
	    /**
	     * Get the value at a given position
	     *
	     * @param pointer the pointer to the location that the value is stored
	     * @returns       the element for pointer, or null if there is no value;
	     */
	    JSONPointerMap.prototype.get = function (pointer) {
	        var entry = this.getEntry(pointer);
	        if (entry) {
	            return entry.value;
	        }
	        return null;
	    };
	    /**
	     * Returns the entry for pointer. Entries reflect the tree structure, and might not have a value.
	     *
	     * @param pointer the pointer to the location that the entry is stored
	     * @returns       the entry for pointer, or null if there is no entry
	     */
	    JSONPointerMap.prototype.getEntry = function (pointer) {
	        var e_5, _a;
	        var result = this.root;
	        try {
	            for (var _b = __values(pointer.segments), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var segment = _c.value;
	                result = result.findChild(segment);
	                if (result === null) {
	                    return null;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return result;
	    };
	    /**
	     * Get the descendants of a given location.
	     *
	     * The resulting map contains only the path segments of the `pointer`
	     * together with all direct and indirect descendant entries of the
	     * `pointer`'s last segment.
	     *
	     * @param pointer the pointer to check
	     * @returns       a pointer map containing only the descendant nodes
	     */
	    JSONPointerMap.prototype.descendants = function (pointer) {
	        var result = new JSONPointerMap();
	        var thisNode = this.root;
	        var resultNode = result.root;
	        var segments = pointer.segments;
	        var length = segments.length;
	        if (length === 0) {
	            return this;
	        }
	        for (var i = 0; i < length - 1; ++i) {
	            var s = segments[i];
	            thisNode = thisNode.findChild(s);
	            if (thisNode === null) {
	                /* tslint:disable-next-line:no-use-before-declare */
	                return EMPTY;
	            }
	            resultNode = resultNode.addChild(s);
	        }
	        var last = thisNode.findChild(segments[length - 1]);
	        if (last === null) {
	            /* tslint:disable-next-line:no-use-before-declare */
	            return EMPTY;
	        }
	        resultNode.children.push(last);
	        result.size = last.count();
	        return result;
	    };
	    /**
	     * Get the intersection of the pointer map with a given pointer
	     *
	     * @param pointer the pointer to check
	     * @returns       a pointer map containing only the nodes along the segments
	     *                specified by the argument
	     */
	    JSONPointerMap.prototype.intersection = function (pointer) {
	        var result = new JSONPointerMap();
	        var thisNode = this.root;
	        var resultNode = result.root;
	        var segments = pointer.segments;
	        var length = segments.length;
	        if (length === 0) {
	            return this;
	        }
	        if (thisNode.value !== null) {
	            resultNode.setValue(thisNode.value);
	        }
	        for (var i = 0; i < length - 1; ++i) {
	            var s = segments[i];
	            thisNode = thisNode.findChild(s);
	            if (thisNode === null) {
	                return result;
	            }
	            resultNode = resultNode.addChild(s);
	            if (thisNode.value !== null) {
	                resultNode.setValue(thisNode.value);
	            }
	        }
	        var last = thisNode.findChild(segments[length - 1]);
	        if (last === null) {
	            return result;
	        }
	        resultNode.children.push(last);
	        result.size += last.count();
	        return result;
	    };
	    /**
	     * Return a pre-order iterator over the entries
	     *
	     * @return a pre-order {@link EntryIterator} over the map's entries
	     */
	    JSONPointerMap.prototype.iterator = function () {
	        var stack = [this.root];
	        return new EntryIterator(function () {
	            for (;;) {
	                var r = stack.shift();
	                if (r === undefined) {
	                    return null;
	                }
	                var n = r.children.length;
	                for (; n > 0; --n) {
	                    stack.unshift(r.children[n - 1]);
	                }
	                if (r.value !== null) {
	                    return r;
	                }
	            }
	        });
	    };
	    /**
	     * Return a post-order iterator over the entries
	     *
	     * @return a post-order {@link EntryIterator} over the map's entries
	     */
	    JSONPointerMap.prototype.postOrder = function () {
	        var stack = [new PostOrderState(this.root)];
	        return new EntryIterator(function () {
	            for (;;) {
	                var r = stack[0];
	                /* tslint:disable-next-line:strict-type-predicates  */
	                if (r === undefined) {
	                    return null;
	                }
	                var c = r.nextChild();
	                if (c === null) {
	                    stack.shift();
	                    if (r.node.value !== null) {
	                        return r.node;
	                    }
	                }
	                else if (c.children.length === 0) {
	                    return c;
	                }
	                else {
	                    stack.unshift(new PostOrderState(c));
	                }
	            }
	        });
	    };
	    /**
	     * Convert the JSON pointer map to a string
	     *
	     * @returns  a string representation of the pointer map
	     */
	    JSONPointerMap.prototype.toString = function () {
	        var parts = ['{'];
	        var iter = this.iterator();
	        while (iter.hasNext()) {
	            if (parts.length > 1) {
	                parts.push(', ');
	            }
	            parts.push(iter.next());
	        }
	        parts.push('}');
	        return parts.join('');
	    };
	    return JSONPointerMap;
	}());
	exports.JSONPointerMap = JSONPointerMap;
	/**
	 * An empty {@link JSONPointerMap}
	 */
	var EMPTY = new JSONPointerMap();


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts = __webpack_require__(174);
	var tokeniser_1 = __webpack_require__(324);
	var json_pointer_1 = __webpack_require__(230);
	/**
	 * An abstract accumulator that accumulates JSON values from tokens and passes
	 * the result to a {@link SpanParserConsumer}.
	 */
	var AbstractAccumulator = /** @class */ (function () {
	    /**
	     * Create an AbstractAccumulator
	     *
	     * @param  tokeniser  the CBOR tokeniser
	     * @param  base       the base JSON pointer to accumulate from
	     * @param  start      the offset of the start token
	     * @param  next       the index of the next token
	     */
	    function AbstractAccumulator(tokeniser, base, start, next) {
	        /**
	         * The token ranges of the accumulated tokens
	         */
	        this.tokenRange = [];
	        /**
	         * The number of accumulated tokens
	         */
	        this.accumulatedTokens = 0;
	        /**
	         * The total number of tokens encountered
	         */
	        this.totalTokens = 0;
	        this.tokeniser = tokeniser;
	        this.base = base;
	        this.startOffset = start;
	        this.nextOffset = next;
	    }
	    /**
	     * Get the total number of tokens encountered
	     *
	     * @return the total number of tokens encountered
	     */
	    AbstractAccumulator.prototype.total = function () {
	        return this.totalTokens;
	    };
	    /**
	     * Get the number of accumulated tokens
	     *
	     * @return the number of accumulated tokens
	     */
	    AbstractAccumulator.prototype.accumulated = function () {
	        return this.accumulatedTokens;
	    };
	    /**
	     * Create a new {@link ArrayAccumulator} from the current token position
	     *
	     * @param  start  the offset of the start token
	     * @param  next   the index of the next token
	     * @return        a new array accumulator
	     */
	    AbstractAccumulator.prototype.newArray = function (start, next) {
	        /* tslint:disable-next-line:no-use-before-declare */
	        return new ArrayAccumulator(this.tokeniser, this.currentPointer(this.base, this.totalTokens), start, next);
	    };
	    /**
	     * Create a new {@link ObjectAccumulator} from the current token position
	     *
	     * @param  start  the offset of the start token
	     * @param  next   the index of the next token
	     * @return        a new object accumulator
	     */
	    AbstractAccumulator.prototype.newObject = function (start, next) {
	        /* tslint:disable-next-line:no-use-before-declare */
	        return new ObjectAccumulator(this.tokeniser, this.currentPointer(this.base, this.totalTokens), start, next);
	    };
	    /**
	     * Check if the offset splits the accumulator content
	     *
	     * @param  offset  the offset to check
	     * @return         `true` if the accumulator has encountered any tokens and
	     *                 the offset is greater than the starting offset
	     */
	    AbstractAccumulator.prototype.notEmptyAndSplitBy = function (offset) {
	        return this.startOffset < offset && this.totalTokens !== 0;
	    };
	    /**
	     * Add tokens to the accumulator
	     *
	     * @param  next  the next offset up to which to add tokens
	     * @return       `false`
	     */
	    AbstractAccumulator.prototype.add = function (next) {
	        this.tokenRange[this.accumulatedTokens] = [this.nextOffset, next];
	        this.nextOffset = next;
	        ++this.accumulatedTokens;
	        ++this.totalTokens;
	        return false;
	    };
	    /**
	     * Increase the next offset without adding tokens
	     *
	     * @param  next  the new next offset
	     */
	    AbstractAccumulator.prototype.setNextStart = function (offset) {
	        this.nextOffset = offset;
	    };
	    /**
	     * Skip one token
	     */
	    AbstractAccumulator.prototype.skip = function () {
	        ++this.totalTokens;
	        this.accumulatedTokens = 0;
	    };
	    /**
	     * Take all tokens. Passes all accumulated tokens to the abstract {@link take}
	     * method.
	     *
	     * @param  consumer  the consumer that will receive the tokens
	     */
	    AbstractAccumulator.prototype.takeAll = function (consumer) {
	        var next = this.totalTokens;
	        var begin = next - this.accumulatedTokens;
	        for (var i = 0; i < this.accumulatedTokens; ++i) {
	            var range = this.tokenRange[i];
	            var start = range[0];
	            var end = range[1];
	            this.take(consumer, this.base, begin, begin + i, start, end - start);
	        }
	        this.accumulatedTokens = 0;
	    };
	    /**
	     * Signal the end of a split structure
	     */
	    AbstractAccumulator.prototype.splitStructureEnd = function (consumer) {
	        consumer.splitStructureEnd(this.base, this.totalTokens, this.startOffset, this.nextOffset + 1 - this.startOffset);
	    };
	    /**
	     * Convert the accumulator to a string
	     *
	     * @returns  a string representation of the accumulator
	     */
	    AbstractAccumulator.prototype.toString = function () {
	        return this.base.toString();
	    };
	    return AbstractAccumulator;
	}());
	/**
	 * An implementation of the {@link AbstractAccumulator} that accumulates array
	 * values
	 */
	var ArrayAccumulator = /** @class */ (function (_super) {
	    __extends(ArrayAccumulator, _super);
	    /**
	     * Create an ArrayAccumulator
	     *
	     * @param  tokeniser  the CBOR tokeniser
	     * @param  base       the base JSON pointer to accumulate from
	     * @param  start      the offset of the start token
	     * @param  next       the index of the next token
	     */
	    function ArrayAccumulator(tokeniser, base, start, next) {
	        return _super.call(this, tokeniser, base, start, next) || this;
	    }
	    /**
	     * @inheritdoc
	     */
	    ArrayAccumulator.prototype.take = function (consumer, base, firstAccumulatedIndex, index, start, length) {
	        consumer.accept(base.withIndex(index), start, length);
	    };
	    /**
	     * @inheritdoc
	     */
	    ArrayAccumulator.prototype.currentPointer = function (base, total) {
	        return base.withIndex(total);
	    };
	    return ArrayAccumulator;
	}(AbstractAccumulator));
	/**
	 * An implementation of the {@link AbstractAccumulator} that accumulates object
	 * values
	 */
	var ObjectAccumulator = /** @class */ (function (_super) {
	    __extends(ObjectAccumulator, _super);
	    /**
	     * Create an ObjectAccumulator
	     *
	     * @param  tokeniser  the CBOR tokeniser
	     * @param  base       the base JSON pointer to accumulate from
	     * @param  start      the offset of the start token
	     * @param  next       the index of the next token
	     */
	    function ObjectAccumulator(tokeniser, base, start, next) {
	        var _this = _super.call(this, tokeniser, base, start, next) || this;
	        /**
	         * The pending object key
	         */
	        _this.pendingKeyName = '';
	        /**
	         * Flag indicating that there is a pending key
	         */
	        _this.pendingKey = true;
	        /**
	         * An array of object keys
	         */
	        _this.keys = [];
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    ObjectAccumulator.prototype.add = function (tokenEnd) {
	        if (this.pendingKey) {
	            this.setNextStart(tokenEnd);
	            this.pendingKeyName = this.tokeniser.getToken().value;
	            this.pendingKey = false;
	        }
	        else {
	            this.keys[this.accumulated()] = this.pendingKeyName;
	            this.pendingKey = true;
	            _super.prototype.add.call(this, tokenEnd);
	        }
	        return !this.pendingKey;
	    };
	    /**
	     * @inheritdoc
	     */
	    ObjectAccumulator.prototype.take = function (consumer, base, firstAccumulatedIndex, index, start, length) {
	        consumer.accept(base.withKey(this.keys[index - firstAccumulatedIndex]), start, length);
	    };
	    /**
	     * @inheritdoc
	     */
	    ObjectAccumulator.prototype.currentPointer = function (base) {
	        return base.withKey(this.pendingKeyName);
	    };
	    return ObjectAccumulator;
	}(AbstractAccumulator));
	/**
	 * An implementation of the {@link AbstractAccumulator} that accumulates the
	 * JSON root value
	 */
	var RootAccumulator = /** @class */ (function (_super) {
	    __extends(RootAccumulator, _super);
	    /**
	     * Create an RootAccumulator
	     *
	     * @param  tokeniser  the CBOR tokeniser
	     */
	    function RootAccumulator(tokeniser) {
	        return _super.call(this, tokeniser, json_pointer_1.ROOT, -1, 0) || this;
	    }
	    /**
	     * @inheritdoc
	     */
	    RootAccumulator.prototype.take = function (consumer, base, firstAccumulatedIndex, index, start, length) {
	        if (this.total() > 1) {
	            throw new Error('Invalid JSON: multiple values found');
	        }
	        consumer.accept(base, start, length);
	    };
	    /**
	     * @inheritdoc
	     */
	    RootAccumulator.prototype.currentPointer = function (base) {
	        return base;
	    };
	    return RootAccumulator;
	}(AbstractAccumulator));
	/**
	 * A SpanParser calculates JSON pointers for processing {@JSONDelta}.
	 * See {@link DeltaVisitor} for a more detailed discussion.
	 */
	var SpanParser = /** @class */ (function () {
	    /**
	     * Create a span parser using the JSON data
	     *
	     * @param  the buffer containing the JSON data
	     */
	    function SpanParser(json) {
	        /**
	         * The current stack of accumulators for {@link JSONPointer}s
	         */
	        this.parentStack = [];
	        this.tokeniser = new tokeniser_1.Tokeniser(json.$buffer, json.$offset, json.$length);
	        this.structure = new RootAccumulator(this.tokeniser);
	        this.startOffset = this.tokeniser.offset();
	        this.json = json;
	    }
	    /**
	     * Parse the JSON data up to a given offset position. If the current reading
	     * position is less than the offset, this is guaranteed to read at least one
	     * value.
	     *
	     * @param  offset  the position up to which to read
	     * @param  result  the consumer that records the JSON pointers
	     * @return         the change in the height of the parent stack
	     */
	    SpanParser.prototype.spanToNext = function (offset, result) {
	        return this.spanTo(offset, result, true);
	    };
	    /**
	     * Parse the JSON data up to a given offset position.
	     *
	     * @param  offset      the position up to which to read
	     * @param  result      the consumer that records the JSON pointers
	     * @param  atLeastOne  if `true` and if the current reading position is less
	     *                     than the offset, this is guaranteed to read at least
	     *                     one value
	     * @return             the change in the height of the parent stack
	     */ // tslint:disable-next-line:cyclomatic-complexity
	    SpanParser.prototype.spanTo = function (offset, result, atLeastOne) {
	        if (atLeastOne === void 0) { atLeastOne = false; }
	        var e_1, _a;
	        var start = this.nextByte();
	        if (start >= offset) {
	            return 0;
	        }
	        var lastHeight = this.parentStack.length;
	        var consumeFirstValue = atLeastOne;
	        var next = start;
	        var t;
	        do {
	            t = this.tokeniser.nextToken();
	            var tokenStart = next;
	            next = this.nextByte();
	            if (t === null) {
	                if (this.parentStack.length !== 0) {
	                    throw new Error('Invalid structure');
	                }
	                break;
	            }
	            else if (t.type === consts.tokens.VALUE) {
	                consumeFirstValue = this.structure.add(next);
	            }
	            else if (t.type === consts.tokens.ARRAY_START) {
	                this.parentStack.push(this.structure);
	                this.structure = this.structure.newArray(tokenStart, next);
	            }
	            else if (t.type === consts.tokens.MAP_START) {
	                this.parentStack.push(this.structure);
	                this.structure = this.structure.newObject(tokenStart, next);
	            }
	            else if (consts.isStructEnd(t.type)) {
	                var parent_1 = this.parentStack.pop();
	                if (this.structure.notEmptyAndSplitBy(start)) {
	                    this.structure.takeAll(result);
	                    this.structure.splitStructureEnd(result);
	                    parent_1.skip();
	                    parent_1.setNextStart(next);
	                }
	                else {
	                    parent_1.add(next);
	                }
	                this.structure = parent_1;
	                consumeFirstValue = false;
	            }
	        } while (consumeFirstValue || next < offset || this.nextTokenIsStructEnd(t, next));
	        try {
	            for (var _b = __values(this.parentStack), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var accumulator = _c.value;
	                accumulator.takeAll(result);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        this.structure.takeAll(result);
	        return this.parentStack.length - lastHeight;
	    };
	    /**
	     * Determine if the next token ends an array, map, or string
	     *
	     * @param  t     the current token
	     * @param  next  the current reading position
	     * @return       `true` if the next token ends a structure
	     */
	    SpanParser.prototype.nextTokenIsStructEnd = function (t, next) {
	        var context = this.tokeniser.getContext();
	        if (consts.isStructStart(t.type)) {
	            return context.expected() === 0;
	        }
	        return context.acceptsBreakMarker() &&
	            next < this.json.$length &&
	            this.json.$buffer[this.json.$offset + next] === consts.BYTE_BREAK ||
	            !context.hasRemaining();
	    };
	    /**
	     * Get the position of the next byte
	     *
	     * @return the position of the next byte
	     */
	    SpanParser.prototype.nextByte = function () {
	        return this.tokeniser.offset() - this.startOffset;
	    };
	    /**
	     * Convert the span parser to a string
	     *
	     * @returns  a string representation of the span parser
	     */
	    SpanParser.prototype.toString = function () {
	        var parts = ['SpanParser', ' next=', this.nextByte().toString(), ' ['];
	        this.parentStack.forEach(function (x) {
	            parts.push(x.toString());
	            parts.push(', ');
	        });
	        parts.push(this.structure.toString());
	        parts.push(']');
	        return parts.join('');
	    };
	    return SpanParser;
	}());
	exports.SpanParser = SpanParser;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var decoder_1 = __webpack_require__(123);
	var primitive_datatype_1 = __webpack_require__(329);
	/**
	 * Serialise an double value into a CBOR encoder
	 *
	 * @param value    the value to serialise
	 * @param encoder  the encoder
	 */ // tslint:disable-next-line:ban-types
	function serialise(value, encoder) {
	    if (value === null || value === undefined) {
	        encoder.encode(null);
	    }
	    else {
	        encoder.writeDouble(value);
	    }
	}
	/**
	 * A data type for double values
	 */ // tslint:disable-next-line:ban-types
	var DoubleDataTypeImpl = /** @class */ (function (_super) {
	    __extends(DoubleDataTypeImpl, _super);
	    /**
	     * Create a new DoubleDataType instance
	     */
	    function DoubleDataTypeImpl() {
	        return _super.call(this, 'double', Number, serialise, decoder_1.isDouble, false) || this;
	    }
	    return DoubleDataTypeImpl;
	}(primitive_datatype_1.PrimitiveDataType));
	exports.DoubleDataTypeImpl = DoubleDataTypeImpl;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var decoder_1 = __webpack_require__(123);
	var int64_impl_1 = __webpack_require__(176);
	var primitive_datatype_1 = __webpack_require__(329);
	/**
	 * Serialise an Int64 value into a CBOR encoder
	 *
	 * @param value    the value to serialise
	 * @param encoder  the encoder
	 */
	function serialise(value, encoder) {
	    if (value === null || value === undefined) {
	        encoder.encode(null);
	    }
	    else {
	        encoder.writeInt64(new int64_impl_1.Int64Impl(value));
	    }
	}
	/**
	 * A data type for Int64 values
	 */
	var Int64DataTypeImpl = /** @class */ (function (_super) {
	    __extends(Int64DataTypeImpl, _super);
	    /**
	     * Create a new Int64DataTypeImpl instance
	     */
	    function Int64DataTypeImpl() {
	        var _this = _super.call(this, 'int64', int64_impl_1.Int64Impl, serialise, decoder_1.isInt64, false) || this;
	        /**
	         * The implementation of the underlying value type
	         */ // tslint:disable-next-line:variable-name
	        _this.Int64 = int64_impl_1.Int64Impl;
	        return _this;
	    }
	    return Int64DataTypeImpl;
	}(primitive_datatype_1.PrimitiveDataType));
	exports.Int64DataTypeImpl = Int64DataTypeImpl;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var decoder_1 = __webpack_require__(123);
	var primitive_datatype_1 = __webpack_require__(329);
	/**
	 * Serialise a string value into a CBOR encoder
	 *
	 * @param value    the value to serialise
	 * @param encoder  the encoder
	 */
	function serialise(v, encoder) {
	    if (v === null || v === undefined) {
	        encoder.encode(null);
	    }
	    else {
	        encoder.encode(v.toString());
	    }
	}
	/**
	 * A data type for string values
	 */ // tslint:disable-next-line:ban-types
	var StringDataTypeImpl = /** @class */ (function (_super) {
	    __extends(StringDataTypeImpl, _super);
	    /**
	     * Create a new StringDataTypeImpl instance
	     */
	    function StringDataTypeImpl() {
	        return _super.call(this, 'string', String, serialise, decoder_1.isString, true) || this;
	    }
	    return StringDataTypeImpl;
	}(primitive_datatype_1.PrimitiveDataType));
	exports.StringDataTypeImpl = StringDataTypeImpl;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_record_model_1 = __webpack_require__(498);
	var field_impl_1 = __webpack_require__(331);
	/**
	 * Implementation of {@link MutableRecordModel}
	 */
	var MutableRecordModelImpl = /** @class */ (function (_super) {
	    __extends(MutableRecordModelImpl, _super);
	    /**
	     * Create a MutableRecordModelImpl
	     *
	     * @param recordV2Constructor  a constructor function for creating {@link RecordV2} implementations
	     * @param schema               the schema that this model corresponds to
	     */
	    function MutableRecordModelImpl(recordV2Constructor, schema) {
	        var _this = _super.call(this, recordV2Constructor, schema) || this;
	        _this.recordData = schema.createModel();
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    MutableRecordModelImpl.prototype.model = function () {
	        return this.recordData;
	    };
	    /**
	     * @inheritdoc
	     */
	    MutableRecordModelImpl.prototype.set = function (recordName, recordIndexOrFieldNameOrValue, fieldNameOrValue, fieldIndex, value) {
	        if (fieldIndex === void 0) { fieldIndex = 0; }
	        var recordIndex;
	        var fieldName;
	        switch (arguments.length) {
	            case 2:
	                value = recordIndexOrFieldNameOrValue;
	                var key = this.parseKey(recordName);
	                recordName = key.recordName;
	                recordIndex = key.recordIndex;
	                fieldName = key.fieldName;
	                fieldIndex = key.fieldIndex;
	                break;
	            case 3:
	                value = fieldNameOrValue;
	                fieldName = recordIndexOrFieldNameOrValue;
	                recordIndex = 0;
	                break;
	            case 5:
	                recordIndex = recordIndexOrFieldNameOrValue;
	                fieldName = fieldNameOrValue;
	                break;
	            default:
	                recordIndex = 0;
	                fieldName = '';
	        }
	        var schemaRecord = this.schema().getRecord(recordName);
	        var record = this.getRecord(schemaRecord, recordIndex);
	        var schemaField = schemaRecord.getField(fieldName);
	        record[abstract_record_model_1.resolveFieldIndex(schemaField, record, fieldIndex)] = field_impl_1.normalise(schemaField, value);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    MutableRecordModelImpl.prototype.add = function (recordName, recordIndexOrValue) {
	        var values = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            values[_i - 2] = arguments[_i];
	        }
	        var schemaRecord;
	        var record;
	        var recordIndex;
	        if (arguments.length > 2 && typeof recordIndexOrValue === 'number') {
	            recordIndex = recordIndexOrValue;
	            values = values.slice(2);
	            schemaRecord = this.schema().getRecord(recordName);
	            record = this.getRecord(schemaRecord, recordIndex);
	        }
	        else {
	            schemaRecord = this.schema().lastRecord();
	            if (this.recordData.length > schemaRecord.index) {
	                record = this.recordData[this.recordData.length - 1];
	            }
	            else {
	                throw new Error("Variable record '" + schemaRecord.name + "' has no occurrences to add a field to");
	            }
	        }
	        this.addValuesToRecord(schemaRecord, record, values);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    MutableRecordModelImpl.prototype.addRecord = function () {
	        var schemaRecord = this.schema().lastRecord();
	        if (!schemaRecord.isVariable) {
	            throw new Error("Record '" + schemaRecord.name + "' is not variable");
	        }
	        var max = schemaRecord.max;
	        if (max !== -1 && this.recordData.length - schemaRecord.index >= max) {
	            throw new Error("Record '" + schemaRecord.name + "' already has maximum number of occurrences");
	        }
	        this.recordData.push(schemaRecord.createModel());
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    MutableRecordModelImpl.prototype.removeRecord = function (index) {
	        var schemaRecord = this.schema().lastRecord();
	        if (!schemaRecord.isVariable) {
	            throw new Error("Record '" + schemaRecord.name + "' is not variable");
	        }
	        var actualIndex = abstract_record_model_1.resolveRecordIndex(schemaRecord, this.recordData, index);
	        if (this.recordData.length - schemaRecord.index - 1 < schemaRecord.min) {
	            throw new Error("Removing an occurrence of record '" + schemaRecord.name + "' would "
	                + "violate the minimum number of occurrences");
	        }
	        this.recordData.splice(actualIndex, 1);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    MutableRecordModelImpl.prototype.removeField = function (recordName, recordIndex, fieldIndex) {
	        var schemaRecord = this.schema().getRecord(recordName);
	        var record = this.getRecord(schemaRecord, recordIndex);
	        var schemaField = schemaRecord.lastField();
	        if (!schemaField.isVariable) {
	            throw new Error("Field '" + schemaField.name + "' is not a variable field");
	        }
	        var actualFieldIndex = abstract_record_model_1.resolveFieldIndex(schemaField, record, fieldIndex);
	        if (record.length - schemaField.index - 1 < schemaField.min) {
	            throw new Error("Removing an occurrence of field '" + schemaField.name + "' would "
	                + "violate the minimum number of occurrences");
	        }
	        record.splice(actualFieldIndex, 1);
	        return this;
	    };
	    /**
	     * Add values to the last field in a record. Values can only be added if the
	     * record is variable
	     *
	     * @param  schemaRecord  the schema of the record
	     * @param  record        the record's model data
	     * @param  values        the values to add
	     * @throws               an error if the record is not variable
	     */
	    MutableRecordModelImpl.prototype.addValuesToRecord = function (schemaRecord, record, values) {
	        var schemaField = schemaRecord.lastField();
	        if (!schemaField.isVariable) {
	            throw new Error("Final field of record '" + schemaRecord.name + "' is not variable");
	        }
	        var max = schemaField.max;
	        if (max !== -1) {
	            var current = record.length - schemaField.index;
	            if (current + values.length > max) {
	                throw new Error('Adding values would exceed maximum number of field occurrences');
	            }
	        }
	        values.forEach(function (value) {
	            record.push(field_impl_1.normalise(schemaField, value));
	        });
	    };
	    return MutableRecordModelImpl;
	}(abstract_record_model_1.AbstractRecordModel));
	exports.MutableRecordModelImpl = MutableRecordModelImpl;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_record_model_1 = __webpack_require__(498);
	var field_impl_1 = __webpack_require__(331);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Validate Record V2 model data against a schema
	 *
	 * @param schema  the schema to validate against
	 * @param model   the record data
	 * @throws        an error if the model data is found to be invalid
	 */
	function validateModel(schema, model) {
	    var e_1, _a;
	    var modelSize = model.length;
	    var lastRecord = schema.lastRecord();
	    var lastIndex = lastRecord.index;
	    var lastMax = lastRecord.max;
	    if (lastMax !== -1 && modelSize > lastIndex + lastMax) {
	        throw new Error("Too many occurrences of record '" + lastRecord.name + "'");
	    }
	    if (modelSize < lastIndex + lastRecord.min) {
	        throw new Error('Too few record occurrences');
	    }
	    var schemaRecords = schema.records();
	    try {
	        for (var schemaRecords_1 = __values(schemaRecords), schemaRecords_1_1 = schemaRecords_1.next(); !schemaRecords_1_1.done; schemaRecords_1_1 = schemaRecords_1.next()) {
	            var schemaRecord = schemaRecords_1_1.value;
	            var startIndex = schemaRecord.index;
	            var min = schemaRecord.min;
	            for (var i = startIndex; i < startIndex + min; ++i) {
	                validateRecord(schemaRecord, i - startIndex, model[i]);
	            }
	            // process variable records to the end
	            if (schemaRecord.isVariable) {
	                for (var i = startIndex + min; i < modelSize; ++i) {
	                    var index = i - startIndex;
	                    validateRecord(schemaRecord, index, model[i]);
	                }
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (schemaRecords_1_1 && !schemaRecords_1_1.done && (_a = schemaRecords_1.return)) _a.call(schemaRecords_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/**
	 * Validate Record V2 model data of a single record against the schema record
	 *
	 * @param schemaRecord  the record schema to validate against
	 * @param recordIndex   the record index
	 * @param record        the individual record data
	 * @throws              an error if the model data is found to be invalid
	 */
	function validateRecord(schemaRecord, recordIndex, record) {
	    var e_2, _a;
	    var recordSize = record.length;
	    var lastField = schemaRecord.lastField();
	    var lastMax = lastField.max;
	    var lastIndex = lastField.index;
	    if (lastMax !== -1 && recordSize > lastIndex + lastMax) {
	        throw new Error("Too many occurrences of field '" + schemaRecord.name + "(" + recordIndex + ")." + lastField.name + "'");
	    }
	    if (recordSize < lastIndex + lastField.min) {
	        throw new Error("Too few field occurrences in record '" + schemaRecord.name + "(" + recordIndex + ")'");
	    }
	    try {
	        for (var _b = __values(schemaRecord.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var schemaField = _c.value;
	            var startIndex = schemaField.index;
	            var min = schemaField.min;
	            for (var i = startIndex; i < startIndex + min; ++i) {
	                validateField(schemaRecord, recordIndex, schemaField, i - startIndex, record[i]);
	            }
	            if (schemaField.isVariable) {
	                for (var i = startIndex + min; i < recordSize; i++) {
	                    var index = i - startIndex;
	                    validateField(schemaRecord, recordIndex, schemaField, index, record[i]);
	                }
	            }
	        }
	    }
	    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_2) throw e_2.error; }
	    }
	}
	/**
	 * Validate Record V2 model data of a single field against the schema field
	 *
	 * @param schemaRecord  the record schema to validate against
	 * @param recordIndex   the record index
	 * @param schemaRecord  the field schema to validate against
	 * @param index         the field index
	 * @param value         the field model data
	 * @throws              an error if the model data is found to be invalid
	 */
	function validateField(schemaRecord, recordIndex, schemaField, index, value) {
	    try {
	        field_impl_1.normalise(schemaField, require_non_null_1.requireNonNull(value, 'FieldData'));
	    }
	    catch (e) {
	        throw new Error("Invalid value for field '" + schemaRecord.name + "(" + recordIndex + ")." + schemaField.name + "(" + index + ")");
	    }
	}
	/**
	 * Implementation of {@link AbstractRecordModel} for an immutable record model
	 */
	var RecordModelImpl = /** @class */ (function (_super) {
	    __extends(RecordModelImpl, _super);
	    /**
	     * Create a RecordModelImpl
	     *
	     * @param recordV2Constructor  a constructor function for creating {@link RecordV2} implementations
	     * @param schema               the schema that this model corresponds to
	     * @param recordData           the record data
	     * @param validate             a flag indicating whether to validate the record data against the schema
	     *
	     * @throws                     an error if `validate==true` and the model data is found to be invalid
	     */
	    function RecordModelImpl(recordV2Constructor, schema, recordData, validate) {
	        var _this = _super.call(this, recordV2Constructor, schema) || this;
	        if (validate) {
	            validateModel(schema, recordData);
	        }
	        _this.recordData = recordData;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    RecordModelImpl.prototype.model = function () {
	        return Array.from(this.recordData);
	    };
	    return RecordModelImpl;
	}(abstract_record_model_1.AbstractRecordModel));
	exports.RecordModelImpl = RecordModelImpl;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var recordv2_impl_1 = __webpack_require__(330);
	var RecordV2Writer = __webpack_require__(500);
	/**
	 * Implementation of {@link RecordV2Builder}
	 */
	var RecordV2BuilderImpl = /** @class */ (function () {
	    function RecordV2BuilderImpl() {
	        /**
	         * The record data
	         */
	        this.records = [];
	    }
	    /**
	     * @inheritdoc
	     */
	    RecordV2BuilderImpl.prototype.addFields = function (field) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        if (arguments.length > 1) {
	            fields.unshift(field);
	        }
	        else {
	            fields = field;
	        }
	        if (fields) {
	            var current = this.records.length ? this.records[this.records.length - 1] : [];
	            this.records[Math.max(this.records.length - 1, 0)] = current.concat(fields);
	        }
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2BuilderImpl.prototype.addRecord = function (field) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        if (arguments.length > 1) {
	            fields.unshift(field);
	        }
	        else {
	            fields = field;
	        }
	        if (fields) {
	            this.records.push([].concat(fields));
	        }
	        else {
	            this.records.push([]);
	        }
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2BuilderImpl.prototype.clear = function () {
	        this.records = [];
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    RecordV2BuilderImpl.prototype.build = function () {
	        return new recordv2_impl_1.RecordV2Impl(RecordV2Writer.toBuffer(this.records));
	    };
	    return RecordV2BuilderImpl;
	}());
	exports.RecordV2BuilderImpl = RecordV2BuilderImpl;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_datatype_1 = __webpack_require__(144);
	var recordv2_builder_impl_1 = __webpack_require__(1181);
	var recordv2_impl_1 = __webpack_require__(330);
	var schema_builder_impl_1 = __webpack_require__(502);
	var schema_parser_1 = __webpack_require__(1185);
	var function_1 = __webpack_require__(89);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * A validator that doesn't validate
	 */
	function defaultValidator() {
	    // no-op
	}
	/**
	 * A data type for {@link RecordV2} values
	 */
	var RecordV2DataTypeImpl = /** @class */ (function (_super) {
	    __extends(RecordV2DataTypeImpl, _super);
	    /**
	     * Create a new RecordV2DataTypeImpl instance
	     *
	     * @param validator  a validator for validating RecordV2 instances
	     */
	    function RecordV2DataTypeImpl(validator) {
	        if (validator === void 0) { validator = defaultValidator; }
	        var _this = _super.call(this, 'record_v2', recordv2_impl_1.RecordV2Impl, recordv2_impl_1.RecordV2Impl, recordv2_impl_1.RecordV2Impl.from, function_1.identity, [], true) || this;
	        /**
	         * The implementation of the underlying value type
	         */ // tslint:disable-next-line:variable-name
	        _this.RecordV2 = recordv2_impl_1.RecordV2Impl;
	        _this.validator = validator;
	        return _this;
	    }
	    /**
	     * Create a new RecordV2 instance from data
	     *
	     * @param value  the CBOR data containing the record
	     * @return       a new RecordV2 instance
	     */
	    RecordV2DataTypeImpl.prototype.from = function (value) {
	        return recordv2_impl_1.RecordV2Impl.from(value);
	    };
	    /**
	     * Validate a RecordV2 object
	     *
	     * @inheritdoc
	     */
	    RecordV2DataTypeImpl.prototype.validate = function (value) {
	        this.validator(require_non_null_1.requireNonNull(value, 'RecordV2 instance'));
	    };
	    /**
	     * Parse a JSON string into a RecordV2 schema
	     *
	     * @param json  the JSON string
	     * @parame      the schema parsed from the JSON string
	     */
	    RecordV2DataTypeImpl.prototype.parseSchema = function (json) {
	        return new schema_parser_1.SchemaParser(recordv2_impl_1.RecordV2Impl).parse(json);
	    };
	    /**
	     * Create a new schema builder
	     *
	     * @return  a schema builder
	     */
	    RecordV2DataTypeImpl.prototype.schemaBuilder = function () {
	        return new schema_builder_impl_1.SchemaBuilderImpl(recordv2_impl_1.RecordV2Impl);
	    };
	    /**
	     * Create a new value builder that can be used to build a RecordV2
	     * value
	     *
	     * @return  a new value builder
	     */
	    RecordV2DataTypeImpl.prototype.valueBuilder = function () {
	        return new recordv2_builder_impl_1.RecordV2BuilderImpl();
	    };
	    /**
	     * Create a new RecordV2DataTypeImpl with a schema.
	     *
	     * @param schema  the schema to validate against
	     * @return        a new RecordV2 Data Type
	     */
	    RecordV2DataTypeImpl.prototype.withSchema = function (schema) {
	        return new RecordV2DataTypeImpl(function (value) {
	            return value.asValidatedModel(schema);
	        });
	    };
	    return RecordV2DataTypeImpl;
	}(abstract_datatype_1.AbstractDataType));
	exports.RecordV2DataTypeImpl = RecordV2DataTypeImpl;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var bytes_impl_1 = __webpack_require__(102);
	var recordv2_parser_1 = __webpack_require__(499);
	var recordv2_utils_1 = __webpack_require__(231);
	/**
	 * A {@link RecordV2Delta} that indicates no change between two {@link
	 * diffusion.datatypes.RecordV2} values
	 */
	var NoChange = /** @class */ (function (_super) {
	    __extends(NoChange, _super);
	    /**
	     * Create a NoChange instance
	     */
	    function NoChange() {
	        return _super.call(this, Buffer.from([])) || this;
	    }
	    /**
	     * Returns a list of the changes.
	     *
	     * @return an empty change list
	     */
	    NoChange.prototype.changes = function () {
	        return [];
	    };
	    return NoChange;
	}(bytes_impl_1.BytesImpl));
	exports.NoChange = NoChange;
	/**
	 * Instance of the {@link NoChange} RecordV2 delta
	 */
	exports.NO_CHANGE = new NoChange();
	/**
	 * An enum indicating the type of a change
	 */
	var Type;
	(function (Type) {
	    Type["FIELD_CHANGED"] = "FIELD_CHANGED";
	    Type["FIELDS_ADDED"] = "FIELDS_ADDED";
	    Type["FIELDS_REMOVED"] = "FIELDS_REMOVED";
	    Type["RECORDS_ADDED"] = "RECORDS_ADDED";
	    Type["RECORDS_REMOVED"] = "RECORDS_REMOVED";
	})(Type = exports.Type || (exports.Type = {}));
	/**
	 * Implementation of the {@link Change} interface representing a single change
	 * to a Record value
	 */
	var ChangeImpl = /** @class */ (function () {
	    /**
	     * Create a ChangeImpl instance
	     *
	     * @param  type         string denoting the type of change that this represents
	     * @param  recordName   the name of the affected record
	     * @param  recordIndex  the index of the affected record
	     * @param  fieldName    the name of the affected field
	     * @param  fieldIndex   the index of the affected field
	     */
	    function ChangeImpl(type, recordName, recordIndex, fieldName, fieldIndex) {
	        this.type = type;
	        this.recordName = recordName;
	        this.recordIndex = recordIndex;
	        this.fieldName = fieldName;
	        this.fieldIndex = fieldIndex;
	        var key = recordName + "(" + recordIndex + ")";
	        if (type !== Type.RECORDS_REMOVED && type !== Type.RECORDS_ADDED) {
	            key += "." + fieldName + "(" + fieldIndex + ")";
	        }
	        this.key = key;
	    }
	    ChangeImpl.prototype.toString = function () {
	        return this.type + " " + this.key;
	    };
	    return ChangeImpl;
	}());
	exports.ChangeImpl = ChangeImpl;
	/**
	 * Implementation of {@link RecordV2Delta}
	 */
	var RecordV2DeltaImpl = /** @class */ (function (_super) {
	    __extends(RecordV2DeltaImpl, _super);
	    /**
	     * Create a RecordV2DeltaImpl instance
	     *
	     * @param  buffer  the internal buffer
	     * @param  offset  the offset of the slice
	     * @param  length  the number of bytes in the slice
	     * @param  recordChanges  an array containing a record index at position 0
	     *                        and a boolean at position 1 indicating if a record
	     *                        has changed
	     * @param  fieldChanges   an array of arrays containing a field index at
	     *                        position 0 and a boolean at position 1 indicating
	     *                        which fields have changed
	     */
	    function RecordV2DeltaImpl(buffer, offset, length, recordChanges, fieldChanges) {
	        if (offset === void 0) { offset = 0; }
	        if (length === void 0) { length = buffer.length; }
	        var _this = _super.call(this, buffer, offset, length) || this;
	        _this.recordChanges = recordChanges;
	        _this.fieldChanges = fieldChanges;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    RecordV2DeltaImpl.prototype.changes = function (schema) {
	        var _this = this;
	        var data = recordv2_parser_1.parse(this.$buffer, this.$offset, this.$length);
	        var recordIndex = 0;
	        var changes = [];
	        schema.records().forEach(function (schemaRecord) {
	            if (data.length < recordIndex + schemaRecord.min) {
	                throw new Error("Insufficient records of type " + schemaRecord.name + " in delta for schema");
	            }
	            if (schemaRecord.isVariable) {
	                recordIndex = _this.processVariableRecordChanges(schemaRecord, recordIndex, data, changes);
	            }
	            else {
	                recordIndex = _this.processFixedRecordChanges(schemaRecord, recordIndex, data, changes);
	            }
	        });
	        return changes;
	    };
	    /**
	     * Process changes in a fixed multiplicity record
	     *
	     * @param  schemaRecord  the schema definition of the record
	     * @param  startIndex    the start index of the record to process
	     * @param  data          the record data
	     * @param  changes       the change list in which to record the changes
	     * @return               the next record index to process
	     */
	    RecordV2DeltaImpl.prototype.processFixedRecordChanges = function (schemaRecord, startIndex, data, changes) {
	        var recordIndex = startIndex;
	        for (var i = 0; i < schemaRecord.min; ++i) {
	            this.processRecordChanges(recordIndex, schemaRecord, i, data[recordIndex], changes);
	            recordIndex++;
	        }
	        return recordIndex;
	    };
	    /**
	     * Process changes in a variable multiplicity record
	     *
	     * @param  schemaRecord  the schema definition of the record
	     * @param  startIndex    the start index of the record to process
	     * @param  data          the record data
	     * @param  changes       the change list in which to record the changes
	     * @return               the next record index to process
	     */
	    RecordV2DeltaImpl.prototype.processVariableRecordChanges = function (schemaRecord, startIndex, data, changes) {
	        var numberOfNewRecords = data.length;
	        var maxAllowed = schemaRecord.max;
	        if (maxAllowed !== -1 && numberOfNewRecords > startIndex + maxAllowed) {
	            throw new Error("Too many records of type " + schemaRecord.name + " in delta for schema");
	        }
	        var recordIndex = startIndex;
	        var matchRecordCount = (this.recordChanges && this.recordChanges[0])
	            ? this.recordChanges[1]
	            : numberOfNewRecords;
	        for (var varIndex = 0; recordIndex < matchRecordCount; recordIndex++, varIndex++) {
	            this.processRecordChanges(recordIndex, schemaRecord, varIndex, data[recordIndex], changes);
	        }
	        if (this.recordChanges) {
	            changes.push(new ChangeImpl(this.recordChanges[0] ? Type.RECORDS_ADDED : Type.RECORDS_REMOVED, schemaRecord.name, this.recordChanges[1] - startIndex, '', 0));
	        }
	        return recordIndex;
	    };
	    /**
	     * Process changes in a single record entry
	     *
	     * @param  dataRecordIndex  the global index of the record to process
	     * @param  schemaRecord     the schema definition of the record
	     * @param  recordIndex      the local index of the record to process
	     * @param  data             the record data
	     * @param  changes          the change list in which to record the changes
	     */
	    RecordV2DeltaImpl.prototype.processRecordChanges = function (dataRecordIndex, record, recordIndex, data, changes) {
	        var _this = this;
	        var fieldIndex = 0;
	        record.fields.forEach(function (field) {
	            if (field.isVariable) {
	                fieldIndex = _this.processVariableFieldChanges(record, recordIndex, dataRecordIndex, field, fieldIndex, data, changes);
	            }
	            else {
	                fieldIndex = _this.processFixedFieldChanges(record, recordIndex, field, fieldIndex, data, changes);
	            }
	        });
	    };
	    /**
	     * Process changes in a fixed multiplicity field
	     *
	     * @param  record       the schema definition of the record
	     * @param  recordIndex  the local index of the record to process
	     * @param  field        the schema definition of the field
	     * @param  startIndex   the start index of the field to process
	     * @param  data         the record data
	     * @param  changes      the change list in which to record the changes
	     * @return              the next field index to process
	     */
	    RecordV2DeltaImpl.prototype.processFixedFieldChanges = function (record, recordIndex, field, startIndex, data, changes) {
	        var numberOfFields = data.length;
	        var fieldIndex = startIndex;
	        for (var i = 0; i < field.min; ++i) {
	            if (fieldIndex >= numberOfFields) {
	                throw new Error("Insufficient fields of type " + field.name + " in delta for schema record " + record.name);
	            }
	            if (data[fieldIndex] !== '') {
	                changes.push(new ChangeImpl(Type.FIELD_CHANGED, record.name, recordIndex, field.name, i));
	            }
	            fieldIndex++;
	        }
	        return fieldIndex;
	    };
	    /**
	     * Process changes in a varable multiplicity field
	     *
	     * @param  record           the schema definition of the record
	     * @param  recordIndex      the local index of the record to process
	     * @param  dataRecordIndex  the global index of the record to process
	     * @param  field            the schema definition of the field
	     * @param  startIndex       the start index of the field to process
	     * @param  data             the record data
	     * @param  changes          the change list in which to record the changes
	     * @return                  the next field index to process
	     */
	    RecordV2DeltaImpl.prototype.processVariableFieldChanges = function (record, recordIndex, dataRecordIndex, field, startIndex, data, changes) {
	        var numberOfFields = data.length;
	        var fieldIndex = startIndex;
	        if (numberOfFields < fieldIndex + field.min) {
	            throw new Error("Insufficient fields of type " + field.name + " in delta for schema record " + record.name);
	        }
	        var fChanges = this.fieldChanges[dataRecordIndex];
	        var matchingFieldCount = fChanges ? fChanges[1] : numberOfFields;
	        for (var varIndex = 0; fieldIndex < matchingFieldCount; fieldIndex++, varIndex++) {
	            if (data[fieldIndex] !== '') {
	                changes.push(new ChangeImpl(Type.FIELD_CHANGED, record.name, recordIndex, field.name, varIndex));
	            }
	        }
	        if (fChanges) {
	            changes.push(new ChangeImpl(fChanges[0] ? Type.FIELDS_ADDED : Type.FIELDS_REMOVED, record.name, recordIndex, field.name, fChanges[1]));
	        }
	        return fieldIndex;
	    };
	    /**
	     * Convert the RecordV2DeltaImpl to a string
	     *
	     * @return  a string representation of the buffer data
	     */
	    RecordV2DeltaImpl.prototype.toString = function () {
	        return recordv2_utils_1.bytesToString(this.$buffer, this.$offset, this.$length);
	    };
	    return RecordV2DeltaImpl;
	}(bytes_impl_1.BytesImpl));
	exports.RecordV2DeltaImpl = RecordV2DeltaImpl;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var mutable_record_model_impl_1 = __webpack_require__(1179);
	var record_impl_1 = __webpack_require__(501);
	/**
	 * Implementation of {@link ConcreteSchema} which extends the Record V2
	 * {@link Schema} interface
	 */
	var SchemaImpl = /** @class */ (function () {
	    /**
	     * Create a new Schema
	     *
	     * @param recordV2Constructor  a constructor function for creating {@link RecordV2} implementations
	     * @param records              an array of record schema
	     */
	    function SchemaImpl(recordV2Constructor, records) {
	        var _this = this;
	        /**
	         * The record schema indexed by name
	         */
	        this.recordsMap = {};
	        this.recordV2Constructor = recordV2Constructor;
	        this.recordsArray = records;
	        records.forEach(function (record) {
	            _this.recordsMap[record.name] = record;
	        });
	    }
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.getRecord = function (name) {
	        var record = this.recordsMap[name];
	        if (record) {
	            return record;
	        }
	        throw new Error("Record '" + name + "' is not known");
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.getRecords = function () {
	        return [].concat(this.recordsArray);
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.records = function () {
	        return this.recordsArray;
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.firstRecord = function () {
	        return this.recordsArray[0];
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.lastRecord = function () {
	        return this.recordsArray[this.recordsArray.length - 1];
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.createMutableModel = function () {
	        return new mutable_record_model_impl_1.MutableRecordModelImpl(this.recordV2Constructor, this);
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.createModel = function () {
	        var model = [];
	        this.recordsArray.forEach(function (record) {
	            var recordValue = record.createModel();
	            if (record.min > 0) {
	                for (var i = 0; i < record.min; ++i) {
	                    model.push([].concat(recordValue));
	                }
	            }
	        });
	        return model;
	    };
	    /**
	     * @inheritdoc
	     */
	    SchemaImpl.prototype.asJSON = function () {
	        return JSON.stringify({ records: this.recordsArray.map(record_impl_1.toJSON) });
	    };
	    /**
	     * Convert the schema to a string
	     *
	     * @return  a string representation of the schema
	     */
	    SchemaImpl.prototype.toString = function () {
	        return "Schema [Records=" + this.recordsArray + "]";
	    };
	    return SchemaImpl;
	}());
	exports.SchemaImpl = SchemaImpl;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.datatypes.RecordV2
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var schema_builder_impl_1 = __webpack_require__(502);
	/**
	 * A parser that can parse a JSON string and create a {@link SchemaImpl}
	 */
	var SchemaParser = /** @class */ (function () {
	    /**
	     * Create a SchemaParser
	     *
	     * @param recordV2Constructor  a constructor function for creating
	     *                             {@link RecordV2} implementations
	     */
	    function SchemaParser(recordV2Constructor) {
	        this.recordV2Constructor = recordV2Constructor;
	    }
	    /**
	     * Parse a JSON string
	     *
	     * @param jsonString  the JSON string
	     * @return            a schema object
	     * @throws            an error if the JSON string could not be converted into
	     *                    a schema
	     */
	    SchemaParser.prototype.parse = function (jsonString) {
	        var builder = new schema_builder_impl_1.SchemaBuilderImpl(this.recordV2Constructor);
	        var json;
	        try {
	            json = JSON.parse(jsonString);
	        }
	        catch (e) {
	            throw new Error('Invalid Schema JSON string');
	        }
	        if (json.records === undefined) {
	            throw new Error('Schema has no records');
	        }
	        json.records.forEach(function (record) {
	            if (record.occurs !== undefined) {
	                builder.record(record.name, record.occurs);
	            }
	            else {
	                builder.record(record.name, record.min, record.max);
	            }
	            if (record.fields) {
	                record.fields.forEach(function (field) {
	                    var min;
	                    var max;
	                    if (field.occurs !== undefined) {
	                        min = field.occurs;
	                        max = field.occurs;
	                    }
	                    else {
	                        min = field.min;
	                        max = field.max;
	                    }
	                    var type = field.type || 'STRING';
	                    switch (type.toUpperCase()) {
	                        case 'STRING':
	                            builder.string(field.name, min, max);
	                            break;
	                        case 'INTEGER':
	                            builder.integer(field.name, min, max);
	                            break;
	                        case 'DECIMAL':
	                            var scale = field.scale || 2;
	                            builder.decimal(field.name, scale, min, max);
	                            break;
	                        default:
	                            throw new Error("Invalid field type value '" + type + "'");
	                    }
	                });
	            }
	        });
	        return builder.build();
	    };
	    return SchemaParser;
	}());
	exports.SchemaParser = SchemaParser;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Diffusion
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var session_metric_collector_builder_1 = __webpack_require__(1193);
	var topic_metric_collector_builder_1 = __webpack_require__(1194);
	var remote_server_builder_1 = __webpack_require__(1197);
	var branch_mapping_table_builder_1 = __webpack_require__(1209);
	var require_non_null_1 = __webpack_require__(22);
	var util = __webpack_require__(549);
	/**
	 * Inserts an escape character '\' before any of the special characters ' "
	 * or \. Additionally checks that the string is defined.
	 *
	 * @param s  the string to be escaped
	 * @returns  the string value with escape characters inserted as appropriate
	 * @throws   an error if the argument is `null` or `undefined`
	 */
	function escape(s) {
	    return util.escape(require_non_null_1.requireNonNull(s, 'string'));
	}
	exports.escape = escape;
	/**
	 * Converts a formatted multi value property to a set of roles.
	 * Additionally checks that the string is defined.
	 *
	 * Unescapes any escaped characters in the string.
	 * @param s  the string with quoted substrings separated by whitespace or
	 *           commas
	 * @return   set of strings
	 * @throws   an error if the argument is `null` or `undefined`
	 */
	function stringToRoles(s) {
	    return util.stringToSet(require_non_null_1.requireNonNull(s, 'string'));
	}
	exports.stringToRoles = stringToRoles;
	/**
	 * Converts a set of roles to a canonicalised property string
	 * representation, escaping as required.
	 *
	 * Uses comma separators and single quotes.
	 *
	 * @param roles  a set of strings
	 * @return       a string with each of the members escaped, quoted and concatenated
	 * @throws       an error if the argument is `null` or `undefined`
	 */
	function rolesToString(roles) {
	    return util.collectionToString(require_non_null_1.requireNonNull(roles, 'roles'));
	}
	exports.rolesToString = rolesToString;
	/**
	 * Create a new {@link BranchMappingTableBuilder}.
	 *
	 * @since 6.7
	 */
	function newBranchMappingTableBuilder() {
	    return new branch_mapping_table_builder_1.BranchMappingTableBuilderImpl();
	}
	exports.newBranchMappingTableBuilder = newBranchMappingTableBuilder;
	/**
	 * Create a new {@link SessionMetricCollectorBuilder}.
	 *
	 * @since 6.7
	 */
	function newSessionMetricCollectorBuilder() {
	    return new session_metric_collector_builder_1.SessionMetricCollectorBuilderImpl();
	}
	exports.newSessionMetricCollectorBuilder = newSessionMetricCollectorBuilder;
	/**
	 * Create a new {@link TopicMetricCollectorBuilder}.
	 *
	 * @since 6.7
	 */
	function newTopicMetricCollectorBuilder() {
	    return new topic_metric_collector_builder_1.TopicMetricCollectorBuilderImpl();
	}
	exports.newTopicMetricCollectorBuilder = newTopicMetricCollectorBuilder;
	/**
	 * Create a new {@link RemoteServerBuilder}.
	 *
	 * @since 6.7
	 */
	function newRemoteServerBuilder(selectors) {
	    return new remote_server_builder_1.RemoteServerBuilderImpl(selectors);
	}
	exports.newRemoteServerBuilder = newRemoteServerBuilder;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module ClientControl
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var registration_1 = __webpack_require__(175);
	var session_fetch_request_1 = __webpack_require__(1188);
	var Services = __webpack_require__(511);
	var change_authorisation_roles_filter_request_1 = __webpack_require__(1248);
	var change_authorisation_roles_request_1 = __webpack_require__(1250);
	var session_properties_event_type_1 = __webpack_require__(516);
	var set_client_conflation_filter_request_1 = __webpack_require__(1275);
	var set_client_conflation_request_1 = __webpack_require__(1277);
	var set_session_properties_filter_request_1 = __webpack_require__(1279);
	var session_id_1 = __webpack_require__(127);
	var logger = __webpack_require__(17);
	var require_non_null_1 = __webpack_require__(22);
	var response_success_1 = __webpack_require__(68);
	var client_control_1 = __webpack_require__(490);
	var log = logger.create('Session.Clients');
	/**
	 * Implementation of the {@link ClientControl} feature
	 */
	var ClientControlImpl = /** @class */ (function () {
	    /**
	     * Create a new ClientControlImpl instance
	     *
	     * @param internal  the internal session
	     */
	    function ClientControlImpl(internal) {
	        /**
	         * Exporting the {@link SessionEventType}
	         */
	        this.SessionEventType = client_control_1.SessionEventType;
	        this.internal = internal;
	        this.serviceLocator = internal.getServiceLocator();
	        this.SET_CLIENT_CONFLATION = this.serviceLocator.obtain(Services.SET_CLIENT_CONFLATION);
	        this.SET_CLIENT_CONFLATION_FILTER = this.serviceLocator.obtain(Services.SET_CLIENT_CONFLATION_FILTER);
	        this.GET_SESSION_PROPERTIES = this.serviceLocator.obtain(Services.GET_SESSION_PROPERTIES);
	        this.SESSION_PROPERTIES_REGISTRATION = this.serviceLocator.obtain(Services.SESSION_PROPERTIES_REGISTRATION_2);
	        this.CHANGE_AUTHORISATION_ROLES = this.serviceLocator.obtain(Services.CHANGE_AUTHORISATION_ROLES);
	        this.CHANGE_AUTHORISATION_ROLES_FILTER = this.serviceLocator.obtain(Services.CHANGE_AUTHORISATION_ROLES_FILTER);
	        this.SET_SESSION_PROPERTIES_FILTER = this.serviceLocator.obtain(Services.SET_SESSION_PROPERTIES_FILTER);
	        this.internal.getServiceRegistry().add(Services.SESSION_PROPERTIES_EVENT_2, {
	            onRequest: function (internalSession, message, callback) {
	                internalSession.getConversationSet().respondIfPresent(message.cid, message);
	                callback.respond();
	            }
	        });
	    }
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.close = function (sessions) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            try {
	                require_non_null_1.requireNonNull(sessions, 'sessions');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var sessionID = session_id_1.SessionId.validate(sessions);
	                if (sessionID) {
	                    _this.serviceLocator.obtain(Services.CLOSE_CLIENT).send({
	                        sessionID: sessionID
	                    }, function (err, response) {
	                        if (err) {
	                            reject(err);
	                        }
	                        else {
	                            resolve(1);
	                        }
	                    });
	                }
	                else if (typeof sessions === 'string') {
	                    _this.serviceLocator.obtain(Services.CLOSE_CLIENT_FILTER).send(sessions, function (err, response) {
	                        if (!response_success_1.responseSuccess(err, response)) {
	                            reject(err);
	                        }
	                        else if (response.errors.length > 0) {
	                            reject(response.errors);
	                        }
	                        else {
	                            resolve(response.count);
	                        }
	                    });
	                }
	                else {
	                    reject(new Error("Invalid SessionID: " + sessions));
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.subscribe = function (session, path) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            try {
	                session = require_non_null_1.requireNonNull(session, 'SessionID or Session Filter');
	                path = require_non_null_1.requireNonNull(path, 'Topic Selector');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var selector = void 0;
	                try {
	                    selector = _this.internal.getContext().parseSelector(path);
	                }
	                catch (e) {
	                    reject(e);
	                    return;
	                }
	                var sessionID = session_id_1.SessionId.validate(session);
	                if (sessionID) {
	                    _this.serviceLocator.obtain(Services.SUBSCRIBE_CLIENT).send({
	                        sessionID: sessionID,
	                        selector: selector
	                    }, function (err) {
	                        if (err) {
	                            reject(err);
	                        }
	                        else {
	                            resolve();
	                        }
	                    });
	                }
	                else {
	                    _this.serviceLocator.obtain(Services.FILTER_SUBSCRIBE).send({
	                        filter: session,
	                        selector: selector
	                    }, function (err, response) {
	                        if (!response_success_1.responseSuccess(err, response)) {
	                            reject(err);
	                        }
	                        else if (response.isSuccess()) {
	                            resolve(response.selected);
	                        }
	                        else {
	                            reject(response.errors);
	                        }
	                    });
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.unsubscribe = function (session, path) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            try {
	                require_non_null_1.requireNonNull(session, 'SessionID or Session Filter');
	                require_non_null_1.requireNonNull(path, 'Topic Selector');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var selector = void 0;
	                try {
	                    selector = _this.internal.getContext().parseSelector(path);
	                }
	                catch (e) {
	                    reject(e);
	                    return;
	                }
	                var sessionID = session_id_1.SessionId.validate(session);
	                if (sessionID) {
	                    _this.serviceLocator.obtain(Services.UNSUBSCRIBE_CLIENT).send({
	                        sessionID: sessionID,
	                        selector: selector
	                    }, function (err) {
	                        if (err) {
	                            reject(err);
	                        }
	                        else {
	                            resolve();
	                        }
	                    });
	                }
	                else {
	                    _this.serviceLocator.obtain(Services.FILTER_UNSUBSCRIBE).send({
	                        filter: session,
	                        selector: selector
	                    }, function (err, response) {
	                        if (!response_success_1.responseSuccess(err, response)) {
	                            reject(err);
	                        }
	                        else if (response.isSuccess()) {
	                            resolve(response.selected);
	                        }
	                        else {
	                            reject(response.errors);
	                        }
	                    });
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.getSessionProperties = function (sid, propertyKeys) {
	        var _this = this;
	        if (propertyKeys === void 0) { propertyKeys = []; }
	        return new Promise(function (resolve, reject) {
	            if (typeof sid === 'string') {
	                sid = session_id_1.SessionId.fromString(sid);
	            }
	            if (_this.internal.checkConnected(reject)) {
	                _this.GET_SESSION_PROPERTIES.send({
	                    sessionID: sid,
	                    propertyKeys: propertyKeys
	                }, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                    }
	                    else {
	                        if (response === null) {
	                            reject(new Error('Invalid session ID'));
	                        }
	                        else {
	                            resolve(response.properties);
	                        }
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.setSessionProperties = function (sessionId, sessionProperties) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            try {
	                require_non_null_1.requireNonNull(sessionId, 'sessionId');
	                require_non_null_1.requireNonNull(sessionProperties, 'properties');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (typeof sessionId === 'string') {
	                sessionId = session_id_1.SessionId.fromString(sessionId);
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var overwriteProperties = {};
	                var removeProperties = [];
	                _this.extractOverwriteAndRemoveProperties(overwriteProperties, removeProperties, sessionProperties);
	                _this.serviceLocator.obtain(Services.SET_SESSION_PROPERTIES).send({
	                    sessionID: sessionId,
	                    overwriteProperties: overwriteProperties,
	                    removeProperties: removeProperties
	                }, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response.properties);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * Place a property into the overwrite object or the remove array, depending
	     * on the property value
	     *
	     * @param overwriteProperties  the key-value object that will contain the
	     *                             properties to modify
	     * @param removeProperties     the array will contain the list of properties
	     *                             that should be removed
	     * @param key                  the property name
	     * @param property             the property value
	     */
	    ClientControlImpl.prototype.setOverwriteOrRemoveProperty = function (overwriteProperties, removeProperties, key, property) {
	        if (property === null) {
	            removeProperties.push(key);
	        }
	        else {
	            overwriteProperties[key] = property;
	        }
	    };
	    /**
	     * Extract the properties that should be modified and those that should be
	     * removed and place them into separate data structures.
	     *
	     * @param overwriteProperties  the key-value object that will contain the
	     *                             properties to modify
	     * @param removeProperties     the array will contain the list of properties
	     *                             that should be removed
	     * @param sessionProperties    the user supplied session properties
	     */
	    ClientControlImpl.prototype.extractOverwriteAndRemoveProperties = function (overwriteProperties, removeProperties, sessionProperties) {
	        var _this = this;
	        var e_1, _a;
	        if (sessionProperties.forEach instanceof Function) {
	            sessionProperties.forEach(function (key, property) {
	                _this.setOverwriteOrRemoveProperty(overwriteProperties, removeProperties, key, property);
	            });
	        }
	        else {
	            try {
	                for (var _b = __values(Object.getOwnPropertyNames(sessionProperties)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var key = _c.value;
	                    this.setOverwriteOrRemoveProperty(overwriteProperties, removeProperties, key, sessionProperties[key]);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.setSessionPropertiesByFilter = function (filter, sessionProperties) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            try {
	                require_non_null_1.requireNonNull(filter, 'filter');
	                require_non_null_1.requireNonNull(sessionProperties, 'properties');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var overwriteProperties = {};
	                var removeProperties = [];
	                var request = new set_session_properties_filter_request_1.SetSessionPropertiesFilterRequest(filter, overwriteProperties, removeProperties);
	                _this.extractOverwriteAndRemoveProperties(overwriteProperties, removeProperties, sessionProperties);
	                _this.SET_SESSION_PROPERTIES_FILTER.send(request, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                    }
	                    else if (response.errors.length > 0) {
	                        reject(response.errors);
	                    }
	                    else {
	                        resolve(response.count);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.setSessionPropertiesListener = function (requiredProperties, handler) {
	        var _this = this;
	        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
	            var adapter, conversationSet, cid;
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!handler) {
	                            reject(new Error('Session Properties listener is null or undefined'));
	                        }
	                        if (!this.internal.checkConnected(reject)) return [3 /*break*/, 2];
	                        log.debug('Adding Session Properties Listener');
	                        adapter = {
	                            active: function (close) {
	                                log.debug('Session Properties Listener active');
	                                handler.onActive(close);
	                            },
	                            respond: function (message) {
	                                var e_2, _a;
	                                try {
	                                    for (var _b = __values(message.events), _c = _b.next(); !_c.done; _c = _b.next()) {
	                                        var event_1 = _c.value;
	                                        switch (event_1.type) {
	                                            case session_properties_event_type_1.SessionPropertiesEventType.OPEN:
	                                                handler.onSessionOpen(event_1.sessionId, event_1.oldProperties);
	                                                break;
	                                            case session_properties_event_type_1.SessionPropertiesEventType.UPDATE:
	                                                handler.onSessionEvent(event_1.sessionId, event_1.updateType, event_1.newProperties, event_1.oldProperties);
	                                                break;
	                                            case session_properties_event_type_1.SessionPropertiesEventType.CLOSE:
	                                                handler.onSessionClose(event_1.sessionId, event_1.oldProperties, event_1.closeReason);
	                                                break;
	                                            default:
	                                                log.debug('Unknown event type received for session properties listener', event_1.type);
	                                        }
	                                    }
	                                }
	                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                                finally {
	                                    try {
	                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                                    }
	                                    finally { if (e_2) throw e_2.error; }
	                                }
	                                return false;
	                            },
	                            close: function (err) {
	                                log.debug('Session Properties Listener closed');
	                                if (err) {
	                                    handler.onError(err);
	                                }
	                                else {
	                                    handler.onClose();
	                                }
	                            }
	                        };
	                        conversationSet = this.internal.getConversationSet();
	                        return [4 /*yield*/, conversationSet.newConversation(registration_1.responseHandler(this.internal, adapter, function (conversationId, callback) {
	                                _this.SESSION_PROPERTIES_REGISTRATION.send({ cid: conversationId }, callback);
	                            }))];
	                    case 1:
	                        cid = _a.sent();
	                        this.SESSION_PROPERTIES_REGISTRATION.send({ cid: cid, properties: requiredProperties }, registration_1.registrationCallback(conversationSet, cid, resolve, reject));
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        }); });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.changeRoles = function (sessions, rolesToRemove, rolesToAdd) {
	        var _this = this;
	        var rolesToRemoveArray = Array.isArray(rolesToRemove) ? rolesToRemove : __spread(rolesToRemove);
	        var rolesToAddArray = Array.isArray(rolesToAdd) ? rolesToAdd : __spread(rolesToAdd);
	        if (rolesToRemoveArray.length === 0 && rolesToAddArray.length === 0) {
	            throw new Error('rolesToRemove and rolesToAdd cannot both be empty');
	        }
	        var sessionId = session_id_1.SessionId.validate(sessions);
	        return new Promise(function (resolve, reject) {
	            try {
	                require_non_null_1.requireNonNull(sessions, 'sessions');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                if (sessionId === false) {
	                    var request = new change_authorisation_roles_filter_request_1.ChangeAuthorisationRolesFilterRequest(sessions, rolesToRemoveArray, rolesToAddArray);
	                    _this.CHANGE_AUTHORISATION_ROLES_FILTER.send(request, function (err, response) {
	                        if (err) {
	                            reject(err);
	                        }
	                        else if (response.errors.length > 0) {
	                            reject(response.errors);
	                        }
	                        else {
	                            resolve(response.count);
	                        }
	                    });
	                }
	                else {
	                    var request = new change_authorisation_roles_request_1.ChangeAuthorisationRolesRequest(sessionId, rolesToRemoveArray, rolesToAddArray);
	                    _this.CHANGE_AUTHORISATION_ROLES.send(request, function (err) {
	                        if (err) {
	                            reject(err);
	                        }
	                        else {
	                            resolve(1);
	                        }
	                    });
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.setConflated = function (sessions, conflated) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            try {
	                require_non_null_1.requireNonNull(sessions, 'sessions');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var sessionID = session_id_1.SessionId.validate(sessions);
	                if (sessionID) {
	                    var request = new set_client_conflation_request_1.SetClientConflationRequest(sessionID, conflated);
	                    _this.SET_CLIENT_CONFLATION.send(request, function (err) {
	                        if (err) {
	                            reject(err);
	                        }
	                        else {
	                            resolve(1);
	                        }
	                    });
	                }
	                else if (typeof sessions === 'string') {
	                    var request = new set_client_conflation_filter_request_1.SetClientConflationFilterRequest(sessions, conflated);
	                    _this.SET_CLIENT_CONFLATION_FILTER.send(request, function (err, response) {
	                        if (!response_success_1.responseSuccess(err, response)) {
	                            reject(err);
	                        }
	                        else if (response.errors.length > 0) {
	                            reject(response.errors);
	                        }
	                        else {
	                            resolve(response.count);
	                        }
	                    });
	                }
	                else {
	                    reject(new Error("Invalid SessionID: " + sessions));
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ClientControlImpl.prototype.fetchRequest = function () {
	        return new session_fetch_request_1.SessionFetchRequestImpl(this.internal);
	    };
	    return ClientControlImpl;
	}());
	exports.ClientControlImpl = ClientControlImpl;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module SessionFetchRequest
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Long = __webpack_require__(44);
	var session_fetch_result_1 = __webpack_require__(1189);
	var Services = __webpack_require__(511);
	var session_fetch_query_1 = __webpack_require__(1372);
	var logger = __webpack_require__(17);
	var math_1 = __webpack_require__(104);
	var response_success_1 = __webpack_require__(68);
	var client_control_options_1 = __webpack_require__(489);
	var log = logger.create('Session Fetch Request');
	/**
	 * A session fetch request range
	 */
	var SessionFetchRange = /** @class */ (function () {
	    /**
	     * Create a new SessionFetchRange instance
	     *
	     * @param  from  the lower limit of the range
	     * @param  to    the upper limit of the range
	     */
	    function SessionFetchRange(from, to) {
	        this.from = from;
	        this.to = to;
	    }
	    /**
	     * Check if the range is unbounded
	     *
	     * @return  `true` if no limits are set
	     */
	    SessionFetchRange.prototype.isUnbounded = function () {
	        return this.from === undefined && this.to === undefined;
	    };
	    return SessionFetchRange;
	}());
	exports.SessionFetchRange = SessionFetchRange;
	function requireNonNegative(n, parameter) {
	    if (!Number.isInteger(n) || n < 0) {
	        throw new Error("Invalid argument '" + parameter + "': " + n);
	    }
	    return n;
	}
	function requireNonNegativeLong(n, parameter) {
	    if (n instanceof Long && n.gte(0)) {
	        return n;
	    }
	    else if (typeof n === 'number' && Number.isInteger(n) && n >= 0) {
	        return Long.fromNumber(n);
	    }
	    throw new Error("Invalid argument '" + parameter + "': " + n);
	}
	/**
	 * Implementation of the {@link SessionFetchRequest} builder interface
	 */
	var SessionFetchRequestImpl = /** @class */ (function () {
	    /**
	     * Create a new {@link SessionFetchRequestImpl} instance
	     *
	     * @param internal  the internal session
	     * @param opts      the internal options specifying what to fetch
	     */
	    function SessionFetchRequestImpl(internal, opts) {
	        var defaultOptions = {
	            range: new SessionFetchRange(),
	            filter: 'all',
	            withProperties: null,
	            limit: math_1.MAX_INT32,
	            maximumResultSize: internal.getOptions().maxMessageSize
	        };
	        this.internal = internal;
	        this.options = Object.assign(defaultOptions, opts);
	    }
	    /**
	     * Deep copy the options into a new {@link SessionFetchRequestOptions} instance
	     *
	     * @return  the new options instance
	     */
	    SessionFetchRequestImpl.prototype.copyOptions = function () {
	        return {
	            range: new SessionFetchRange(this.options.range.from, this.options.range.to),
	            filter: this.options.filter,
	            withProperties: this.options.withProperties,
	            limit: this.options.limit,
	            maximumResultSize: this.options.maximumResultSize
	        };
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.from = function (time) {
	        var limit = requireNonNegativeLong(time, 'time');
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { range: new SessionFetchRange(limit, this.options.range.to) }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.to = function (time) {
	        var limit = requireNonNegativeLong(time, 'time');
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { range: new SessionFetchRange(this.options.range.from, limit) }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.withProperties = function (properties) {
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { withProperties: properties }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.first = function (count) {
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { limit: requireNonNegative(count, 'count') }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.last = function (count) {
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { limit: 0 - requireNonNegative(count, 'count') }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.maximumResultSize = function (maximumSize) {
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), {
	            maximumResultSize: Math.min(requireNonNegative(maximumSize, 'maximumSize'), this.internal.getOptions().maxMessageSize)
	        }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.filter = function (filter) {
	        return new SessionFetchRequestImpl(this.internal, Object.assign(this.copyOptions(), {
	            filter: filter
	        }));
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchRequestImpl.prototype.fetch = function () {
	        var serviceLocator = this.internal.getServiceLocator();
	        var SESSION_FETCH = serviceLocator.obtain(Services.SESSION_FETCH);
	        var propertySet = this.options.withProperties && new Set(this.options.withProperties);
	        var requiresStartTime = !propertySet
	            || propertySet.has(client_control_options_1.ClientControlOptions.PropertyKeys.START_TIME)
	            || propertySet.has(client_control_options_1.ClientControlOptions.PropertyKeys.ALL_FIXED_PROPERTIES[0]);
	        var query = new session_fetch_query_1.SessionFetchQuery(this.options.filter, this.options.range, propertySet, this.options.limit, this.options.maximumResultSize, requiresStartTime);
	        return new Promise(function (resolve, reject) {
	            SESSION_FETCH.send(query, function (err, fetchQueryResult) {
	                if (!response_success_1.responseSuccess(err, fetchQueryResult)) {
	                    log.debug('Session fetch query failed');
	                    reject(err);
	                }
	                else if (fetchQueryResult.errors) {
	                    log.debug('Session fetch query failed');
	                    reject(fetchQueryResult.errors.errors);
	                }
	                else {
	                    resolve(new session_fetch_result_1.SessionFetchResultImpl(fetchQueryResult.results || [], fetchQueryResult.totalCount || 0));
	                }
	            });
	        });
	    };
	    return SessionFetchRequestImpl;
	}());
	exports.SessionFetchRequestImpl = SessionFetchRequestImpl;


/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module SessionFetchRequest
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of the SessionFetchResultImpl interface
	 */
	var SessionFetchResultImpl = /** @class */ (function () {
	    /**
	     * Create a new SessionFetchResultImpl instance
	     *
	     * @param result    the results
	     */
	    function SessionFetchResultImpl(results, totalSelected) {
	        this.resultList = results;
	        this.totalSelectedCount = totalSelected;
	        this.hasMoreFlag = results.length < totalSelected;
	    }
	    /**
	     * @inheritdoc
	     */
	    SessionFetchResultImpl.prototype.results = function () {
	        return this.resultList;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchResultImpl.prototype.hasMore = function () {
	        return this.hasMoreFlag;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchResultImpl.prototype.size = function () {
	        return this.resultList.length;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchResultImpl.prototype.totalSelected = function () {
	        return this.totalSelectedCount;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionFetchResultImpl.prototype.isEmpty = function () {
	        return this.resultList.length === 0;
	    };
	    return SessionFetchResultImpl;
	}());
	exports.SessionFetchResultImpl = SessionFetchResultImpl;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module LogRetrieval
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(1326);
	var entries_fetch_request_1 = __webpack_require__(524);
	/**
	 * Internal feature for fetching log entries from the server
	 */
	var LogRetrieval = /** @class */ (function () {
	    /**
	     * Create a new LogRetrieval instance
	     *
	     * @param internal  the internal session
	     */
	    function LogRetrieval(internal) {
	        this.internal = internal;
	        this.FETCH_LOG_ENTRIES_SERVICE = internal.getServiceLocator().obtain(Services.FETCH_LOG_ENTRIES_SERVICE);
	    }
	    /**
	     * Fetch log entries
	     *
	     * @param firstEntry  the index of the first entry to fetch
	     * @param entryCount  the number of entries to fetch
	     * @return            a result that resolves with the fetched log entries
	     */
	    LogRetrieval.prototype.fetchEntries = function (firstEntry, entryCount) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.FETCH_LOG_ENTRIES_SERVICE.send(new entries_fetch_request_1.EntriesFetchRequest(firstEntry, entryCount), function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    return LogRetrieval;
	}());
	exports.LogRetrieval = LogRetrieval;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Messages
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var command_service_1 = __webpack_require__(225);
	var ControlGroup = __webpack_require__(226);
	var registration_1 = __webpack_require__(175);
	var Services = __webpack_require__(1330);
	var services_1 = __webpack_require__(339);
	var session_id_1 = __webpack_require__(127);
	var logger = __webpack_require__(17);
	var require_non_null_1 = __webpack_require__(22);
	var response_success_1 = __webpack_require__(68);
	var error_reason_1 = __webpack_require__(88);
	var log = logger.create('Session.Messages');
	/**
	 * A request stream proxy
	 */
	var RequestStreamProxy = /** @class */ (function () {
	    /**
	     * Create a new RequestStreamProxy instance
	     *
	     * @param reqType  the request data type
	     * @param resType  the response data type
	     * @param stream   the request stream
	     */
	    function RequestStreamProxy(reqType, resType, stream) {
	        this.reqType = reqType;
	        this.resType = resType;
	        this.stream = stream;
	    }
	    return RequestStreamProxy;
	}());
	/**
	 * A responder to message requests
	 */
	var RequestResponder = /** @class */ (function () {
	    /**
	     * Create a new RequestResponder instance
	     *
	     * @param callback      the command service callback to send the response to
	     * @param responseType  the response data type
	     */
	    function RequestResponder(callback, context, responseType) {
	        this.callback = callback;
	        this.context = context;
	        this.responseType = responseType;
	    }
	    /**
	     * Respond to the message with a response
	     *
	     * @param response  the response
	     */
	    RequestResponder.prototype.respond = function (response) {
	        var DataTypes = this.context.DataTypes;
	        if (arguments.length === 0) {
	            throw new Error('No argument provided to the responder');
	        }
	        if ((response === null || response === undefined) && !this.responseType) {
	            throw new Error('No response type has been provided and the value provided is null. ' +
	                'Unable to determine the response type.');
	        }
	        var dataType = this.responseType
	            ? DataTypes.getChecked(this.responseType)
	            : DataTypes.getByValue(response);
	        if (dataType === undefined) {
	            throw new Error('Unable to determine the response type.');
	        }
	        var responseData = dataType.writeValue(response);
	        this.callback.respond({
	            responseDataType: dataType.name(),
	            data: responseData
	        });
	    };
	    /**
	     * Reject a message
	     *
	     * @param message  the message indicating the failure
	     */
	    RequestResponder.prototype.reject = function (message) {
	        this.callback.fail(error_reason_1.ErrorReason.REJECTED_REQUEST, message);
	    };
	    return RequestResponder;
	}());
	/**
	 * Returns a session ID if parseable, else false.
	 *
	 * @param str  the string containing the session ID
	 * @return     the session ID or `false`
	 */
	function parseSessionId(str) {
	    try {
	        return session_id_1.SessionId.fromString(str);
	    }
	    catch (err) {
	        return false;
	    }
	}
	/**
	 * Implementation of the {@link Messages} feature
	 */
	var MessagesImpl = /** @class */ (function () {
	    /**
	     * Create a new MessagesImpl instance
	     *
	     * @param internal  the internal session
	     */
	    function MessagesImpl(internal) {
	        var _this = this;
	        /**
	         * The streams registered for the request-response service
	         */
	        this.requestStreams = {};
	        this.internal = internal;
	        var DataTypes = this.internal.getContext().DataTypes;
	        var serviceLocator = internal.getServiceLocator();
	        this.MESSAGING_SEND = serviceLocator.obtain(Services.MESSAGING_SEND);
	        this.MESSAGING_FILTER_SEND = serviceLocator.obtain(Services.MESSAGING_FILTER_SEND);
	        this.MESSAGING_RECEIVER_SERVER = serviceLocator.obtain(Services.MESSAGING_RECEIVER_SERVER);
	        this.deregisterRequestHandler = serviceLocator.obtain(services_1.MESSAGING_RECEIVER_CONTROL_DEREGISTRATION);
	        var serviceRegistry = internal.getServiceRegistry();
	        var formatNoStreamForPath = function (sessionID, path) {
	            return "Session " + sessionID + " has no registered streams for message sent to path '" + path + "'";
	        };
	        serviceRegistry.add(Services.MESSAGING_SEND, command_service_1.create(function (session, request, callback) {
	            var proxy = _this.requestStreams[request.path];
	            // tslint:disable-next-line:strict-type-predicates
	            if (proxy === undefined) {
	                callback.fail(error_reason_1.ErrorReason.UNHANDLED_MESSAGE, formatNoStreamForPath(session.getSessionId(), request.path));
	                return;
	            }
	            var responder = new RequestResponder(callback, internal.getContext(), proxy.resType);
	            var requestDataType = DataTypes.get(request.dataType);
	            var requestType = proxy.reqType ? proxy.reqType : requestDataType.valueClass;
	            if (requestDataType.canReadAs(requestType)) {
	                var requestData = void 0;
	                try {
	                    requestData = requestDataType.readAs(requestType, request.request);
	                }
	                catch (e) {
	                    log.error("Failed to convert " + requestDataType.name() + " datatype to " + requestType);
	                    proxy.stream.onError(error_reason_1.ErrorReason.INVALID_DATA);
	                    delete _this.requestStreams[request.path];
	                    return;
	                }
	                try {
	                    proxy.stream.onRequest(request.path, requestData, responder);
	                }
	                catch (e) {
	                    log.error('Messaging request stream threw an error', e);
	                    callback.fail(error_reason_1.ErrorReason.CALLBACK_EXCEPTION, e.stack);
	                }
	            }
	            else {
	                var message = "Messaging request for path " + request.path + " with " + requestDataType.name() +
	                    ("datatype is incompatible for stream (" + requestType + ")");
	                log.debug(message);
	                callback.fail(error_reason_1.ErrorReason.INCOMPATIBLE_DATATYPE, message);
	            }
	        }));
	        serviceRegistry.add(Services.FILTER_RESPONSE, command_service_1.create(function (session, request, callback) {
	            callback.respond();
	            session.getConversationSet().respondIfPresent(request.cid, request);
	        }));
	        serviceRegistry.add(Services.MESSAGING_RECEIVER_CLIENT, command_service_1.create(function (session, request, callback) {
	            session.getConversationSet().respondIfPresent(request.cid, {
	                request: request,
	                callback: callback.respond,
	                fail: callback.fail
	            });
	        }));
	    }
	    /**
	     * @inheritdoc
	     */
	    MessagesImpl.prototype.addRequestHandler = function (path, handler, keys, requestType) {
	        var _this = this;
	        var DataTypes = this.internal.getContext().DataTypes;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                try {
	                    require_non_null_1.requireNonNull(path, 'Message path');
	                    require_non_null_1.requireNonNull(handler, 'Request handler');
	                }
	                catch (e) {
	                    reject(e);
	                    return;
	                }
	                log.debug('Adding request handler', path);
	                var params_1 = {
	                    definition: Services.MESSAGING_RECEIVER_CLIENT,
	                    group: ControlGroup.DEFAULT,
	                    path: path,
	                    keys: keys !== undefined ? keys : []
	                };
	                var adapter = {
	                    active: function (close, cid) {
	                        log.debug('Request handler active', path);
	                        var registration = {
	                            close: function () {
	                                return new Promise(function (resolveRegistration) {
	                                    _this.deregisterRequestHandler.send(params_1, function (err, response) {
	                                        if (err) {
	                                            _this.internal.getConversationSet().discard(cid, err);
	                                            log.debug('Error with request handler deregistration: ', err);
	                                        }
	                                        else {
	                                            handler.onClose();
	                                            _this.internal.getConversationSet().respondIfPresent(cid, response);
	                                        }
	                                        resolveRegistration();
	                                    });
	                                });
	                            }
	                        };
	                        resolve(registration);
	                    },
	                    respond: function (pair) {
	                        log.debug('Request handler pair.request', path);
	                        var context = {
	                            sessionId: pair.request.sessionID,
	                            path: pair.request.path,
	                            properties: pair.request.properties
	                        };
	                        try {
	                            var requestDatatype = requestType
	                                ? requestType
	                                : DataTypes.getChecked(pair.request.dataType);
	                            var request = requestDatatype.readValue(pair.request.content);
	                            var responder = {
	                                respond: function (response, respType) {
	                                    var responseType = DataTypes.getChecked(respType !== undefined ? respType : response);
	                                    pair.callback({
	                                        responseDataType: responseType.name(),
	                                        data: responseType.writeValue(response)
	                                    });
	                                },
	                                reject: function (message) {
	                                    pair.fail(error_reason_1.ErrorReason.REJECTED_REQUEST, message, false);
	                                }
	                            };
	                            handler.onRequest(request, context, responder);
	                            return false;
	                        }
	                        catch (err) {
	                            log.info('An exception has occurred whilst processing the request:', err);
	                            handler.onError(err);
	                            pair.fail(error_reason_1.ErrorReason.CALLBACK_EXCEPTION, err && err.message);
	                            return false;
	                        }
	                    },
	                    close: function () {
	                        log.debug('Request handler closed', path);
	                        handler.onClose();
	                    }
	                };
	                registration_1.registerRequestHandler(_this.internal, params_1, adapter).then(undefined, function (err) {
	                    reject(err);
	                });
	            }
	        });
	    };
	    /**
	     * Send a request to the controller
	     *
	     * This is called by {@link sendRequest} when no session was specified
	     *
	     * @param resolve       a callback to resolve the request
	     * @param reject        a callback to signal an error
	     * @param path          the path to send the request to
	     * @param request       the request to send
	     * @param requestType   an optional request {@link DataType DataType}
	     * @param responseType  an optional response {@link DataType DataType}
	     */
	    MessagesImpl.prototype.sendRequestToController = function (resolve, reject, path, request, reqType, respType) {
	        var DataTypes = this.internal.getContext().DataTypes;
	        try {
	            require_non_null_1.requireNonNull(path, 'Message path');
	            require_non_null_1.requireNonNull(request, 'Request');
	        }
	        catch (e) {
	            reject(e);
	            return;
	        }
	        var requestType;
	        try {
	            requestType = reqType ? DataTypes.getChecked(reqType) : DataTypes.getByValue(request);
	        }
	        catch (e) {
	            reject(e);
	            return;
	        }
	        if (requestType === undefined) {
	            throw new Error('Could not determine request type');
	        }
	        log.debug('Sending request to server', request);
	        this.MESSAGING_SEND.send({
	            path: path,
	            dataType: requestType.name(),
	            request: requestType.writeValue(request)
	        }, function (err, response) {
	            var responseType;
	            if (!response_success_1.responseSuccess(err, response)) {
	                log.debug('Request failed', path);
	                reject(err);
	            }
	            else {
	                log.debug('Request complete', path);
	                try {
	                    responseType = DataTypes.getChecked(respType ? respType : response.responseDataType);
	                }
	                catch (e) {
	                    reject(e);
	                    return;
	                }
	                resolve(responseType.readValue(response.data));
	            }
	        });
	    };
	    /**
	     * Send a request to a specific session
	     *
	     * This is called by {@link sendRequest} when a session was specified
	     *
	     * @param resolve       a callback to resolve the request
	     * @param reject        a callback to signal an error
	     * @param path          the path to send the request to
	     * @param request       the request to send
	     * @param sessionId     the target recipient's session ID
	     * @param requestType   an optional request {@link DataType DataType}
	     * @param responseType  an optional response {@link DataType DataType}
	     */
	    MessagesImpl.prototype.sendRequestToSession = function (resolve, reject, path, request, sessionId, reqType, respType) {
	        var DataTypes = this.internal.getContext().DataTypes;
	        try {
	            require_non_null_1.requireNonNull(sessionId, 'Session ID');
	            require_non_null_1.requireNonNull(path, 'Message path');
	            require_non_null_1.requireNonNull(request, 'Request');
	        }
	        catch (e) {
	            reject(e);
	            return;
	        }
	        var requestType;
	        try {
	            requestType = reqType ? DataTypes.getChecked(reqType) : DataTypes.getByValue(request);
	        }
	        catch (e) {
	            reject(e);
	            return;
	        }
	        if (requestType === undefined) {
	            throw new Error('Could not determine request type');
	        }
	        log.debug('Sending request to session', sessionId, request);
	        this.MESSAGING_RECEIVER_SERVER.send({
	            sessionId: sessionId,
	            path: path,
	            dataType: requestType.name(),
	            request: requestType.writeValue(request)
	        }, function (err, response) {
	            var responseType;
	            if (!response_success_1.responseSuccess(err, response)) {
	                log.debug('Request failed', path);
	                reject(err);
	            }
	            else {
	                log.debug('Request complete', path);
	                try {
	                    responseType = DataTypes.getChecked(respType ? respType : response.responseDataType);
	                }
	                catch (e) {
	                    reject(e);
	                    return;
	                }
	                resolve(responseType.readValue(response.data));
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    MessagesImpl.prototype.sendRequest = function (path, request, sessionIdOrRequestType, requestTypeOrResponseType, responseType) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                if (sessionIdOrRequestType instanceof session_id_1.SessionId) {
	                    _this.sendRequestToSession(resolve, reject, path, request, sessionIdOrRequestType, requestTypeOrResponseType, responseType);
	                }
	                else if (typeof sessionIdOrRequestType === 'string') {
	                    var sessionId = parseSessionId(sessionIdOrRequestType);
	                    if (sessionId) {
	                        _this.sendRequestToSession(resolve, reject, path, request, sessionId, requestTypeOrResponseType, responseType);
	                    }
	                    else {
	                        _this.sendRequestToController(resolve, reject, path, request, sessionIdOrRequestType, requestTypeOrResponseType);
	                    }
	                }
	                else {
	                    _this.sendRequestToController(resolve, reject, path, request, sessionIdOrRequestType, requestTypeOrResponseType);
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    MessagesImpl.prototype.sendRequestToFilter = function (filter, path, request, callback, reqType, respType) {
	        var _this = this;
	        var DataTypes = this.internal.getContext().DataTypes;
	        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
	            var requestType, count_1, expected_1, isDone_1, cid_1;
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.internal.checkConnected(reject)) return [3 /*break*/, 2];
	                        try {
	                            require_non_null_1.requireNonNull(path, 'Message path');
	                            require_non_null_1.requireNonNull(filter, 'Session filter');
	                            require_non_null_1.requireNonNull(request, 'Request');
	                            require_non_null_1.requireNonNull(callback, 'Response callback');
	                        }
	                        catch (e) {
	                            reject(e);
	                            return [2 /*return*/];
	                        }
	                        requestType = void 0;
	                        try {
	                            requestType = reqType ? DataTypes.getChecked(reqType) : DataTypes.getByValue(request);
	                        }
	                        catch (e) {
	                            reject(e);
	                            return [2 /*return*/];
	                        }
	                        if (requestType === undefined) {
	                            throw new Error('Could not determine request type');
	                        }
	                        count_1 = 0;
	                        expected_1 = -1;
	                        isDone_1 = function () {
	                            return (count_1 >= expected_1 && expected_1 !== -1) || expected_1 === 0;
	                        };
	                        return [4 /*yield*/, this.internal.getConversationSet().newConversation({
	                                onOpen: function () {
	                                    // no-op
	                                },
	                                onResponse: function (conversationId, response) {
	                                    if (response === null) {
	                                        return true;
	                                    }
	                                    if (typeof response === 'number') {
	                                        expected_1 = response;
	                                        return isDone_1();
	                                    }
	                                    var sessionID = response.sessionID;
	                                    count_1++;
	                                    if (response.errorReason) {
	                                        callback.onResponseError(sessionID, response.errorReason);
	                                    }
	                                    else {
	                                        var responseDataType = DataTypes.getByName(response.response.responseDataType);
	                                        var responseType = void 0;
	                                        try {
	                                            responseType = DataTypes.getChecked(respType ? respType : response.response.responseDataType);
	                                        }
	                                        catch (e) {
	                                            reject(e);
	                                            return isDone_1();
	                                        }
	                                        if (responseDataType.canReadAs(responseType.valueClass)) {
	                                            var value = void 0;
	                                            try {
	                                                value = responseDataType.readAs(responseType.valueClass, response.response.data);
	                                            }
	                                            catch (e) {
	                                                callback.onResponseError(sessionID, e);
	                                                return isDone_1();
	                                            }
	                                            try {
	                                                callback.onResponse(sessionID, value);
	                                            }
	                                            catch (e) {
	                                                log.error('Exception within messaging filter callback', e);
	                                            }
	                                        }
	                                        else {
	                                            callback.onResponseError(sessionID, new Error("The received response was a " + responseDataType + ",'\n                                        + ' which cannot be read as: " + responseType));
	                                        }
	                                    }
	                                    return isDone_1();
	                                },
	                                onDiscard: function () {
	                                    // no-op
	                                }
	                            })];
	                    case 1:
	                        cid_1 = _a.sent();
	                        log.debug('Sending filter request to server', request);
	                        this.MESSAGING_FILTER_SEND.send({
	                            cid: cid_1,
	                            path: path,
	                            filter: filter,
	                            dataType: requestType,
	                            request: requestType.writeValue(request)
	                        }, function (err, response) {
	                            if (!response_success_1.responseSuccess(err, response)) {
	                                log.debug('Request failed', path);
	                                _this.internal.getConversationSet().respondIfPresent(cid_1, null);
	                                reject(err);
	                            }
	                            else if (response.isSuccess) {
	                                log.debug('Request complete', path);
	                                _this.internal.getConversationSet().respondIfPresent(cid_1, response.numberSent);
	                                resolve(response.numberSent);
	                            }
	                            else {
	                                log.debug('Request failed', path);
	                                _this.internal.getConversationSet().respondIfPresent(cid_1, null);
	                                reject(response.errors);
	                            }
	                        });
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        }); });
	    };
	    /**
	     * @inheritdoc
	     */
	    MessagesImpl.prototype.setRequestStream = function (path, stream, reqType, resType) {
	        var DataTypes = this.internal.getContext().DataTypes;
	        var proxy = new RequestStreamProxy(reqType ? DataTypes.getValueClassChecked(reqType) : undefined, resType ? DataTypes.getValueClassChecked(resType) : undefined, stream);
	        var old = this.requestStreams[path];
	        this.requestStreams[path] = proxy;
	        if (old) {
	            return old.stream;
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    MessagesImpl.prototype.removeRequestStream = function (path) {
	        var proxy = this.requestStreams[path];
	        delete this.requestStreams[path];
	        if (proxy) {
	            return proxy.stream;
	        }
	    };
	    return MessagesImpl;
	}());
	exports.MessagesImpl = MessagesImpl;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Features
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_reason_1 = __webpack_require__(88);
	var jmx_fetch_request_1 = __webpack_require__(519);
	var Services = __webpack_require__(1335);
	var measured_entity_class_request_1 = __webpack_require__(530);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Internal metrics feature.
	 *
	 * <p>Also provides access to JMX MBean values.
	 */
	var MetricsImpl = /** @class */ (function () {
	    function MetricsImpl(internal) {
	        this.internal = internal;
	    }
	    /**
	     * Resolve and invoke a service.
	     */
	    MetricsImpl.prototype.callService = function (serviceDefinition, request) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                var service = _this.internal.getServiceLocator().obtain(serviceDefinition);
	                service.send(request, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        // tslint:disable-next-line:strict-type-predicates
	                        resolve((response === null ? undefined : response));
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * Add a new session metric collector, removing any with the same name.
	     */
	    MetricsImpl.prototype.putSessionMetricCollector = function (sessionMetricCollector) {
	        return __awaiter(this, void 0, void 0, function () {
	            var errors;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        require_non_null_1.requireNonNull(sessionMetricCollector, 'sessionMetricCollector');
	                        return [4 /*yield*/, this.callService(Services.PUT_SESSION_METRIC_COLLECTOR, sessionMetricCollector)];
	                    case 1:
	                        errors = _a.sent();
	                        if (errors.errors.length !== 0) {
	                            throw new Error("Invalid filter: " + errors.toString());
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Remove any session metric collector with the given name.
	     */
	    MetricsImpl.prototype.removeSessionMetricCollector = function (sessionMetricCollectorName) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                require_non_null_1.requireNonNull(sessionMetricCollectorName, 'sessionMetricCollectorName');
	                return [2 /*return*/, this.callService(Services.REMOVE_SESSION_METRIC_COLLECTOR, sessionMetricCollectorName)];
	            });
	        });
	    };
	    /**
	     * Retrieve all session metric collectors.
	     */
	    MetricsImpl.prototype.listSessionMetricCollectors = function () {
	        return this.callService(Services.LIST_SESSION_METRIC_COLLECTORS, null);
	    };
	    /**
	     * Add a new topic metric collector, removing any with the same name.
	     */
	    MetricsImpl.prototype.putTopicMetricCollector = function (topicMetricCollector) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                require_non_null_1.requireNonNull(topicMetricCollector, 'topicMetricCollector');
	                return [2 /*return*/, this.callService(Services.PUT_TOPIC_METRIC_COLLECTOR, topicMetricCollector)];
	            });
	        });
	    };
	    /**
	     * Remove any topic metric collector with the given name.
	     */
	    MetricsImpl.prototype.removeTopicMetricCollector = function (topicMetricCollectorName) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                require_non_null_1.requireNonNull(topicMetricCollectorName, 'topicMetricCollectorName');
	                return [2 /*return*/, this.callService(Services.REMOVE_TOPIC_METRIC_COLLECTOR, topicMetricCollectorName)];
	            });
	        });
	    };
	    /**
	     * Retrieve all topic metric collectors.
	     */
	    MetricsImpl.prototype.listTopicMetricCollectors = function () {
	        return this.callService(Services.LIST_TOPIC_METRIC_COLLECTORS, null);
	    };
	    /**
	     * Get the server-scope metrics.
	     */
	    MetricsImpl.prototype.getServerMetrics = function () {
	        return this.callService(Services.GET_SERVER_METRICS, null);
	    };
	    /**
	     * Get all metrics for a measured entity class. Optionally, a server can be specified.
	     *
	     * @param measuredEntityClassName e.g. "sessions", "topics"
	     */
	    MetricsImpl.prototype.getMeasuredEntityClassMetrics = function (entityClass, serverName) {
	        return this.callService(Services.GET_MEASURED_ENTITY_CLASS_METRICS, new measured_entity_class_request_1.MeasuredEntityClassRequest(entityClass, serverName));
	    };
	    /**
	     * Get connected server MBean values.
	     *
	     * @param JMX object names
	     */
	    MetricsImpl.prototype.fetchJMXValues = function (objectNames) {
	        var resultMap = this.callService(Services.FETCH_JMX_VALUES, new jmx_fetch_request_1.JMXFetchRequest(objectNames, false));
	        return resultMap.then(function (m) {
	            var _a = __read(Object.keys(m)), first = _a[0], more = _a.slice(1);
	            var firstResult = m[first];
	            if (!more.length && !('reason' in firstResult)) {
	                return firstResult;
	            }
	            throw error_reason_1.ErrorReason.INVALID_DATA;
	        });
	    };
	    /**
	     * Get map of server name(s) -> MBean values.
	     *
	     * @param JMX object names
	     */
	    MetricsImpl.prototype.fetchClusterJMXValues = function (objectNames) {
	        return this.callService(Services.FETCH_JMX_VALUES, new jmx_fetch_request_1.JMXFetchRequest(objectNames, true));
	    };
	    return MetricsImpl;
	}());
	exports.MetricsImpl = MetricsImpl;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var session_metric_collector_1 = __webpack_require__(527);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementations of {@link SessionMetricCollectorBuilder}
	 */
	var SessionMetricCollectorBuilderImpl = /** @class */ (function () {
	    function SessionMetricCollectorBuilderImpl() {
	        this.reset();
	    }
	    /**
	     * @inheritdoc
	     */
	    SessionMetricCollectorBuilderImpl.prototype.reset = function () {
	        this.exportToPrometheusProp = false;
	        this.groupByPropertiesProp = [];
	        this.removesMetricsWithNoMatchesProp = false;
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionMetricCollectorBuilderImpl.prototype.exportToPrometheus = function (exportMetrics) {
	        this.exportToPrometheusProp = exportMetrics;
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionMetricCollectorBuilderImpl.prototype.groupByProperty = function (propertyName) {
	        this.groupByPropertiesProp.push(require_non_null_1.requireNonNull(propertyName, 'propertyName is null'));
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionMetricCollectorBuilderImpl.prototype.groupByProperties = function (propertyNames) {
	        this.groupByPropertiesProp = require_non_null_1.requireNonNull(propertyNames, 'propertyNames is null');
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionMetricCollectorBuilderImpl.prototype.removeMetricsWithNoMatches = function (remove) {
	        this.removesMetricsWithNoMatchesProp = remove;
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionMetricCollectorBuilderImpl.prototype.create = function (name, sessionFilter) {
	        return new session_metric_collector_1.SessionMetricCollectorImpl(require_non_null_1.requireNonNull(name, 'name is null'), this.exportToPrometheusProp, this.removesMetricsWithNoMatchesProp, require_non_null_1.requireNonNull(sessionFilter, 'sessionFilter is null'), this.groupByPropertiesProp);
	    };
	    return SessionMetricCollectorBuilderImpl;
	}());
	exports.SessionMetricCollectorBuilderImpl = SessionMetricCollectorBuilderImpl;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_metric_collector_1 = __webpack_require__(529);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of {@link TopicMetricCollectorBuilder}.
	 */
	var TopicMetricCollectorBuilderImpl = /** @class */ (function () {
	    function TopicMetricCollectorBuilderImpl() {
	        this.exportToPrometheusProp = false;
	        this.groupByTopicTypeProp = false;
	        this.reset();
	    }
	    /**
	     * @inheritdoc
	     */
	    TopicMetricCollectorBuilderImpl.prototype.reset = function () {
	        this.exportToPrometheusProp = false;
	        this.groupByTopicTypeProp = false;
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicMetricCollectorBuilderImpl.prototype.exportToPrometheus = function (exportMetrics) {
	        this.exportToPrometheusProp = exportMetrics;
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicMetricCollectorBuilderImpl.prototype.groupByTopicType = function (group) {
	        this.groupByTopicTypeProp = group;
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicMetricCollectorBuilderImpl.prototype.create = function (name, topicSelector) {
	        return new topic_metric_collector_1.TopicMetricCollectorImpl(require_non_null_1.requireNonNull(name, 'name is null'), this.exportToPrometheusProp, typeof topicSelector === 'string' ? topicSelector : topicSelector.expression, this.groupByTopicTypeProp);
	    };
	    return TopicMetricCollectorBuilderImpl;
	}());
	exports.TopicMetricCollectorBuilderImpl = TopicMetricCollectorBuilderImpl;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Ping
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(531);
	/**
	 * Implements the {@link Ping} feature
	 */
	var PingImpl = /** @class */ (function () {
	    /**
	     * Create a new PingImpl instance
	     *
	     * @param internal     the internal session
	     * @param currentTime  a function returning the current time in milliseconds.
	     *                     Only used for testing
	     */
	    function PingImpl(internal, currentTime) {
	        if (currentTime === void 0) { currentTime = Date.now; }
	        /**
	         * A function returning the current time in milliseconds
	         *
	         * Only used for testing. Otherwise always `Date.now`
	         */
	        this.currentTime = Date.now;
	        this.internal = internal;
	        this.currentTime = currentTime;
	        this.ping = internal.getServiceLocator().obtain(Services.USER_PING);
	    }
	    /**
	     * @inheritdoc
	     */
	    PingImpl.prototype.pingServer = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                var start_1 = _this.currentTime();
	                _this.ping.send(null, function (err) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        var elapsed = _this.currentTime() - start_1;
	                        resolve({
	                            timestamp: start_1,
	                            rtt: elapsed
	                        });
	                    }
	                });
	            }
	        });
	    };
	    return PingImpl;
	}());
	exports.PingImpl = PingImpl;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(1342);
	var remote_server_definition_1 = __webpack_require__(533);
	var logger = __webpack_require__(17);
	var require_non_null_1 = __webpack_require__(22);
	var response_success_1 = __webpack_require__(68);
	var log = logger.create('RemoteServers');
	/**
	 * Implementation of the {@link RemoteServers} feature
	 */
	var RemoteServersImpl = /** @class */ (function () {
	    /**
	     * Create a new instance of the RemoteServers feature
	     *
	     * @param internal  the internal session
	     */
	    function RemoteServersImpl(internal) {
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.CREATE_REMOTE_SERVER = serviceLocator.obtain(Services.CREATE_REMOTE_SERVER);
	        this.LIST_REMOTE_SERVERS = serviceLocator.obtain(Services.LIST_REMOTE_SERVERS);
	        this.CHECK_REMOTE_SERVER = serviceLocator.obtain(Services.CHECK_REMOTE_SERVER);
	        this.REMOVE_REMOTE_SERVER = serviceLocator.obtain(Services.REMOVE_REMOTE_SERVER);
	    }
	    /**
	     * @inheritdoc
	     */
	    RemoteServersImpl.prototype.createRemoteServer = function (nameOrRemoteServer, url, principal, credentials, connectionOptions) {
	        var _this = this;
	        if (typeof nameOrRemoteServer === 'string') {
	            return new Promise(function (resolve, reject) {
	                if (require_non_null_1.requireNonNull(nameOrRemoteServer, 'name').length === 0) {
	                    throw new Error("Remote server name cannot be empty");
	                }
	                if (_this.internal.checkConnected(reject)) {
	                    var spec = new remote_server_definition_1.RemoteServerDefinitionImpl(nameOrRemoteServer, require_non_null_1.requireNonNull(url, 'url'), require_non_null_1.requireNonNull(principal, 'principal'), require_non_null_1.requireNonNull(credentials, 'credentials'), connectionOptions || {});
	                    _this.CREATE_REMOTE_SERVER.send(spec, function (err, response) {
	                        if (!response_success_1.responseSuccess(err, response)) {
	                            reject(err);
	                            log.debug('Create remote server failed');
	                        }
	                        else if (response.errors) {
	                            reject(response.errors.errors);
	                            log.debug('Create remote server failed');
	                        }
	                        else {
	                            resolve(response.server);
	                        }
	                    });
	                }
	            });
	        }
	        else {
	            return new Promise(function (resolve, reject) {
	                require_non_null_1.requireNonNull(nameOrRemoteServer, 'remoteServer');
	                if (_this.internal.checkConnected(reject)) {
	                    var spec = nameOrRemoteServer;
	                    _this.CREATE_REMOTE_SERVER.send(spec, function (err, response) {
	                        if (!response_success_1.responseSuccess(err, response)) {
	                            reject(err);
	                            log.debug('Create remote server failed');
	                        }
	                        else if (response.errors) {
	                            reject(response.errors.errors);
	                            log.debug('Create remote server failed');
	                        }
	                        else {
	                            resolve(response.server);
	                        }
	                    });
	                }
	            });
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    RemoteServersImpl.prototype.checkRemoteServer = function (name) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.CHECK_REMOTE_SERVER.send(require_non_null_1.requireNonNull(name, 'name'), function (err, response) {
	                    if (err) {
	                        reject(err);
	                        log.debug('Check remote server failed');
	                    }
	                    else {
	                        resolve(response.status);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RemoteServersImpl.prototype.listRemoteServers = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.LIST_REMOTE_SERVERS.send(null, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                        log.debug('List remote servers failed');
	                    }
	                    else {
	                        resolve(response.result);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RemoteServersImpl.prototype.removeRemoteServer = function (name) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.REMOVE_REMOTE_SERVER.send(require_non_null_1.requireNonNull(name, 'name'), function (err) {
	                    if (err) {
	                        reject(err);
	                        log.debug('Remove remote server failed');
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            }
	        });
	    };
	    return RemoteServersImpl;
	}());
	exports.RemoteServersImpl = RemoteServersImpl;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var remote_server_definition_1 = __webpack_require__(533);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of {@link RemoteServersBuilder}.
	 *
	 * @since 6.7
	 */
	var RemoteServerBuilderImpl = /** @class */ (function () {
	    /**
	     * Constructor.
	     */
	    function RemoteServerBuilderImpl(topicSelectors) {
	        this.thePrincipal = '';
	        this.theCredentials = undefined;
	        this.theConnectionOptions = {};
	        this.theMissingTopicNotificationFilter = undefined;
	        this.theTopicSelectors = topicSelectors;
	    }
	    RemoteServerBuilderImpl.prototype.principal = function (principal) {
	        this.thePrincipal = require_non_null_1.requireNonNull(principal, 'principal');
	        return this;
	    };
	    RemoteServerBuilderImpl.prototype.credentials = function (credentials) {
	        this.theCredentials = credentials;
	        return this;
	    };
	    RemoteServerBuilderImpl.prototype.connectionOptions = function (connectionOptions) {
	        require_non_null_1.requireNonNull(connectionOptions, 'connectionOptions');
	        this.theConnectionOptions = __assign({}, connectionOptions);
	        return this;
	    };
	    RemoteServerBuilderImpl.prototype.connectionOption = function (connectionOption, value) {
	        if (value === null || value === undefined) {
	            delete this.theConnectionOptions[require_non_null_1.requireNonNull(connectionOption, 'connectionOption')];
	        }
	        else {
	            this.theConnectionOptions[require_non_null_1.requireNonNull(connectionOption, 'connectionOption')] = value;
	        }
	        return this;
	    };
	    RemoteServerBuilderImpl.prototype.missingTopicNotificationFilter = function (filter) {
	        if (filter !== null) {
	            try {
	                this.theTopicSelectors.parse(filter);
	            }
	            catch (err) {
	                throw new Error("filter is invalid: " + err);
	            }
	        }
	        this.theMissingTopicNotificationFilter = filter === null ? undefined : filter;
	        return this;
	    };
	    RemoteServerBuilderImpl.prototype.reset = function () {
	        this.thePrincipal = '';
	        this.theCredentials = undefined;
	        this.theConnectionOptions = {};
	        this.theMissingTopicNotificationFilter = undefined;
	        return this;
	    };
	    RemoteServerBuilderImpl.prototype.create = function (name, url) {
	        var trimmedName = require_non_null_1.requireNonNull(name, 'name').trim();
	        if (trimmedName.length === 0) {
	            throw new Error('Non whitespace name must be supplied');
	        }
	        var trimmedUrl = require_non_null_1.requireNonNull(url, 'url').trim();
	        if (trimmedUrl.length === 0) {
	            throw new Error('Non whitespace url must be supplied');
	        }
	        return new remote_server_definition_1.RemoteServerDefinitionImpl(trimmedName, trimmedUrl, this.thePrincipal, this.theCredentials, this.theConnectionOptions, this.theMissingTopicNotificationFilter);
	    };
	    return RemoteServerBuilderImpl;
	}());
	exports.RemoteServerBuilderImpl = RemoteServerBuilderImpl;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module LicenceUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(1354);
	var LicenceUpdater = /** @class */ (function () {
	    function LicenceUpdater(internal) {
	        this.LICENCE_UPDATE = internal.getServiceLocator().obtain(Services.UPDATE_LICENSE);
	    }
	    /**
	     * Sends a byte array containing a license to the Diffusion server for verification. Takes an ArrayBuffer.
	     * @param arrayBufferedFile the license to be uploaded in buffer form
	     * @returns       the success of the operation
	     */
	    LicenceUpdater.prototype.updateLicence = function (arrayBufferedFile) {
	        var _this = this;
	        var bufferedFile = Buffer.from(arrayBufferedFile);
	        return new Promise(function (resolve, reject) {
	            _this.LICENCE_UPDATE.send(bufferedFile, function (err, response) {
	                if (err) {
	                    reject(err);
	                }
	                else {
	                    resolve(response);
	                }
	            });
	        });
	    };
	    return LicenceUpdater;
	}());
	exports.LicenceUpdater = LicenceUpdater;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Security
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var CommandService = __webpack_require__(225);
	var control_group_1 = __webpack_require__(226);
	var registration_1 = __webpack_require__(175);
	var security_script_builder_1 = __webpack_require__(1202);
	var system_authentication_script_builder_1 = __webpack_require__(1203);
	var security_command_script_1 = __webpack_require__(510);
	var Services = __webpack_require__(1355);
	var authenticator_response_1 = __webpack_require__(535);
	var logger = __webpack_require__(17);
	var require_non_null_1 = __webpack_require__(22);
	var error_reason_1 = __webpack_require__(88);
	var security_1 = __webpack_require__(101);
	var log = logger.create('Session.Security');
	/**
	 * Implementation of the {@link Security} feature
	 */
	var SecurityImpl = /** @class */ (function () {
	    function SecurityImpl(internal) {
	        /**
	         * The global permission enum
	         */ // tslint:disable-next-line:variable-name
	        this.GlobalPermission = security_1.GlobalPermission;
	        /**
	         * The path permission enum
	         */ // tslint:disable-next-line:variable-name
	        this.PathPermission = security_1.PathPermission;
	        /**
	         * The topic permission enum
	         * @deprecated since 6.5
	         * Replaced by PathPermission
	         */ // tslint:disable-next-line:variable-name
	        this.TopicPermission = security_1.PathPermission;
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.CHANGE_PRINCIPAL = serviceLocator.obtain(Services.CHANGE_PRINCIPAL);
	        this.GET_SECURITY_CONFIGURATION = serviceLocator.obtain(Services.GET_SECURITY_CONFIGURATION);
	        this.GET_SYSTEM_AUTHENTICATION = serviceLocator.obtain(Services.GET_SYSTEM_AUTHENTICATION);
	        this.UPDATE_SECURITY_CONFIGURATION = serviceLocator.obtain(Services.UPDATE_SECURITY_CONFIGURATION);
	        this.UPDATE_SYSTEM_AUTHENTICATION = serviceLocator.obtain(Services.UPDATE_SYSTEM_AUTHENTICATION);
	        this.AUTHENTICATOR_DEREGISTRATION = serviceLocator.obtain(Services.AUTHENTICATOR_DEREGISTRATION);
	        this.LIST_GLOBAL_PERMISSIONS = serviceLocator.obtain(Services.LIST_GLOBAL_PERMISSIONS);
	        this.LIST_PATH_PERMISSIONS = serviceLocator.obtain(Services.LIST_PATH_PERMISSIONS);
	        internal.getServiceRegistry().add(Services.AUTHENTICATOR, CommandService.create(function (internalSession, req, callback) {
	            internalSession.getConversationSet().respondIfPresent(req.cid, { req: req, callback: callback });
	        }));
	    }
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.getPrincipal = function () {
	        return this.internal.getPrincipal();
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.changePrincipal = function (principal, credentials) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Changing principal', principal);
	                _this.CHANGE_PRINCIPAL.send({
	                    principal: principal,
	                    credentials: credentials
	                }, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        if (response) {
	                            _this.internal.setPrincipal(principal);
	                            resolve();
	                        }
	                        else {
	                            reject(new Error('Unable to change principal due to authentication failure'));
	                        }
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.getSecurityConfiguration = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Getting security configuration');
	                _this.GET_SECURITY_CONFIGURATION.send(null, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.getSystemAuthenticationConfiguration = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Getting system authentication');
	                _this.GET_SYSTEM_AUTHENTICATION.send(null, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.setAuthenticator = function (handlerName, authenticator) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var closingRegistration = false;
	            if (_this.internal.checkConnected(reject)) {
	                try {
	                    require_non_null_1.requireNonNull(handlerName, 'handlerName');
	                    require_non_null_1.requireNonNull(authenticator, 'authenticator');
	                }
	                catch (e) {
	                    reject(e);
	                    return;
	                }
	                // tslint:disable:strict-type-predicates
	                if (typeof authenticator.authenticate !== 'function'
	                    || typeof authenticator.onError !== 'function'
	                    || typeof authenticator.onClose !== 'function') {
	                    // tslint:enable:strict-type-predicates
	                    reject(new Error('authenticator does not implement the Authenticator interface'));
	                }
	                log.debug('Adding authenticator', handlerName);
	                var params_1 = {
	                    name: handlerName,
	                    definition: Services.AUTHENTICATOR,
	                    group: control_group_1.DEFAULT
	                };
	                var adapter = {
	                    active: function (close, cid) {
	                        log.debug('Authenticator active', handlerName);
	                        var registration = {
	                            close: function () {
	                                return new Promise(function (resolveRegistration) {
	                                    closingRegistration = true;
	                                    _this.AUTHENTICATOR_DEREGISTRATION.send(params_1, function (err, response) {
	                                        if (err) {
	                                            _this.internal.getConversationSet().discard(cid, err);
	                                            log.debug('Error with authenticator deregistration: ', err);
	                                        }
	                                        else {
	                                            _this.internal.getConversationSet().respondIfPresent(cid, response);
	                                            authenticator.onClose();
	                                        }
	                                        resolveRegistration();
	                                    });
	                                });
	                            }
	                        };
	                        resolve(registration);
	                    },
	                    respond: function (msg) {
	                        if (closingRegistration) {
	                            return true;
	                        }
	                        var req = msg.req;
	                        var callback = msg.callback;
	                        try {
	                            authenticator.authenticate(req.principal, req.credentials, req.sessionProperties, req.proposedProperties, {
	                                allow: function (properties) {
	                                    var e_1, _a;
	                                    if (properties) {
	                                        properties = Object.assign({}, properties);
	                                        try {
	                                            for (var _b = __values(Object.getOwnPropertyNames(req.sessionProperties)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                                                var key = _c.value;
	                                                if (properties[key] === req.sessionProperties[key]) {
	                                                    delete properties[key];
	                                                }
	                                            }
	                                        }
	                                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                                        finally {
	                                            try {
	                                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                                            }
	                                            finally { if (e_1) throw e_1.error; }
	                                        }
	                                    }
	                                    callback.respond(new authenticator_response_1.AuthenticatorResponse(authenticator_response_1.TypeCode.ALLOW, properties));
	                                },
	                                abstain: function () {
	                                    callback.respond(authenticator_response_1.ABSTAIN);
	                                },
	                                deny: function () {
	                                    callback.respond(authenticator_response_1.DENY);
	                                }
	                            });
	                        }
	                        catch (err) {
	                            authenticator.onError(err);
	                            callback.fail(error_reason_1.ErrorReason.CALLBACK_EXCEPTION, err && err.message);
	                            // rethrow so that the conversation can be discarded
	                            throw err;
	                        }
	                        return false;
	                    },
	                    close: function (err) {
	                        if (err) {
	                            log.debug("'Authenticator closed with error for \"" + handlerName + "\"'");
	                            authenticator.onError(err);
	                        }
	                        else {
	                            log.debug("'Authentication Handler closed for \"" + handlerName + "\"'");
	                            authenticator.onClose();
	                        }
	                    }
	                };
	                registration_1.registerHandler(_this.internal, params_1, adapter, Services.AUTHENTICATOR_REGISTRATION, Services.AUTHENTICATOR_DEREGISTRATION).then(undefined, function (err) {
	                    reject(err);
	                });
	            }
	        });
	    };
	    /**
	     * Callback for processing the server response from a command script request.
	     *
	     * @param err       any errors from the server
	     * @param response  the response from the server
	     * @param resolve   a callback to resolve the request
	     * @param reject    a callback to signal an error
	     */
	    SecurityImpl.prototype.updateStoreCallback = function (err, response, resolve, reject) {
	        if (err) {
	            reject(err);
	        }
	        else if (response.errors.length > 0) {
	            reject(response.errors);
	        }
	        else {
	            resolve();
	        }
	    };
	    /**
	     * Send a command script to the server and process the result
	     *
	     * @param  updater  the command service to send the script to
	     * @param  script   the command script
	     * @return          the {@link Result} that resolves when the operation
	     *                  completes successfully
	     */
	    SecurityImpl.prototype.updateStore = function (updater, script) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (script === '') {
	                resolve();
	                // tslint:disable-next-line:strict-type-predicates
	            }
	            else if (!script || typeof script !== 'string') {
	                reject(new Error("Invalid argument for script: " + script));
	            }
	            else if (_this.internal.checkConnected(reject)) {
	                updater.send(new security_command_script_1.SecurityCommandScript(script), function (err, response) {
	                    _this.updateStoreCallback(err, response, resolve, reject);
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.updateSecurityStore = function (script) {
	        log.debug('Updating security store');
	        return this.updateStore(this.UPDATE_SECURITY_CONFIGURATION, script);
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.updateAuthenticationStore = function (script) {
	        log.debug('Updating authentication store');
	        return this.updateStore(this.UPDATE_SYSTEM_AUTHENTICATION, script);
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.securityScriptBuilder = function () {
	        return new security_script_builder_1.SecurityScriptBuilderImpl();
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.authenticationScriptBuilder = function () {
	        return new system_authentication_script_builder_1.SystemAuthenticationScriptBuilderImpl();
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.getGlobalPermissions = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Getting global permissions');
	                _this.LIST_GLOBAL_PERMISSIONS.send(null, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response.permissions);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityImpl.prototype.getPathPermissions = function (path) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Getting path permissions');
	                _this.LIST_PATH_PERMISSIONS.send(path, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response.permissions);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    // tslint:disable-next-line:deprecation
	    SecurityImpl.prototype.getTopicPermissions = function (path) {
	        var _this = this;
	        // tslint:disable-next-line:deprecation
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Getting path permissions');
	                _this.LIST_PATH_PERMISSIONS.send(path, function (err, response) {
	                    if (err) {
	                        reject(err);
	                    }
	                    else {
	                        resolve(response.permissions);
	                    }
	                });
	            }
	        });
	    };
	    return SecurityImpl;
	}());
	exports.SecurityImpl = SecurityImpl;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var session_property_validation_1 = __webpack_require__(503);
	var security_1 = __webpack_require__(101);
	/**
	 * Implementation of {@link MatchesSessionPropertyValidation}
	 *
	 * @inheritdoc
	 */
	var MatchesSessionPropertyValidationImpl = /** @class */ (function (_super) {
	    __extends(MatchesSessionPropertyValidationImpl, _super);
	    /**
	     * Create a MatchesSessionPropertyValidationImpl instance
	     *
	     * @param  regex   the regular expression
	     */
	    function MatchesSessionPropertyValidationImpl(regex) {
	        var _this = _super.call(this, security_1.ValidationType.REGEX) || this;
	        _this.regex = regex;
	        return _this;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the MatchesSessionPropertyValidationImpl
	     */
	    MatchesSessionPropertyValidationImpl.prototype.toString = function () {
	        return "SessionPropertyValidation [type=" + this.type + ", regex=" + this.regex + "]";
	    };
	    return MatchesSessionPropertyValidationImpl;
	}(session_property_validation_1.SessionPropertyValidationImpl));
	exports.MatchesSessionPropertyValidationImpl = MatchesSessionPropertyValidationImpl;


/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of {@link SystemPrincipal}
	 *
	 * @inheritdoc
	 */
	var SecurityConfigurationImpl = /** @class */ (function () {
	    /**
	     * Create a SecurityConfigurationImpl instance
	     *
	     * @param  anonymous  the list of default roles for anonymous sessions
	     * @param  named      the list of default roles for named sessions
	     * @param  roles      the list of all defined roles
	     * @param  isolatedPaths  the list of isolated paths
	     */
	    function SecurityConfigurationImpl(anonymous, named, roles, isolatedPaths) {
	        this.anonymous = anonymous;
	        this.named = named;
	        this.roles = roles;
	        this.isolatedPaths = isolatedPaths;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the SecurityConfiguration
	     *
	     * tslint:disable-next-line:max-line-length
	     */
	    SecurityConfigurationImpl.prototype.toString = function () {
	        // tslint:disable-next-line:max-line-length
	        return 'SecurityConfiguration [anonymous=${this.anonymous}, named=${this.named}, roles=${this.roles}, isolatedPaths=${this.isolatedPaths}]';
	    };
	    return SecurityConfigurationImpl;
	}());
	exports.SecurityConfigurationImpl = SecurityConfigurationImpl;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(504);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of the {@link SecurityScriptBuilder} interface
	 */
	var SecurityScriptBuilderImpl = /** @class */ (function () {
	    function SecurityScriptBuilderImpl() {
	        /**
	         * The security script built so far
	         */
	        this.commands = '';
	        /**
	         * @inheritdoc
	         * @deprecated since 6.5
	         * replaced by {@link setDefaultPathPermissions}
	         */
	        this.setDefaultTopicPermissions = this.setDefaultPathPermissions.bind(this);
	    }
	    /**
	     * Utility function that appends a new line
	     * if commands already has lines
	     */
	    SecurityScriptBuilderImpl.prototype.maybeApppendNewLine = function () {
	        if (this.commands.length > 0) {
	            this.commands += '\n';
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.build = function () {
	        return this.commands;
	    };
	    /**
	     * Convert the security script builder to a string
	     *
	     * @return  a string representation on this object
	     */
	    SecurityScriptBuilderImpl.prototype.toString = function () {
	        return "ConfigurationScriptBuilder [" + this.commands + "]";
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setRolesForAnonymousSessions = function (roles) {
	        var nonNullRoles = require_non_null_1.requireNonNull(roles, 'roles');
	        this.maybeApppendNewLine();
	        this.commands += 'set roles for anonymous sessions ';
	        this.commands += util_1.setToString(nonNullRoles);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setRolesForNamedSessions = function (roles) {
	        var nonNullRoles = require_non_null_1.requireNonNull(roles, 'roles');
	        this.maybeApppendNewLine();
	        this.commands += 'set roles for named sessions ';
	        this.commands += util_1.setToString(nonNullRoles);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setGlobalPermissions = function (role, permissions) {
	        var nonNullRole = require_non_null_1.requireNonNull(role, 'role');
	        var nonNullPermissions = require_non_null_1.requireNonNull(permissions, 'permissions');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'set ' +
	                util_1.quoteAndEscape(nonNullRole) +
	                ' permissions ';
	        this.commands += util_1.permissionsToString(nonNullPermissions);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setDefaultPathPermissions = function (role, permissions) {
	        var nonNullRole = require_non_null_1.requireNonNull(role, 'role');
	        var nonNullPermissions = require_non_null_1.requireNonNull(permissions, 'permissions');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'set ' +
	                util_1.quoteAndEscape(nonNullRole) +
	                ' default path permissions ';
	        this.commands += util_1.permissionsToString(nonNullPermissions);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     * @deprecated since 6.5
	     * replaced by {@link removePathPermissions}
	     */
	    SecurityScriptBuilderImpl.prototype.removeTopicPermissions = function (role, path) {
	        return this.removePathPermissions(role, path);
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.removePathPermissions = function (role, path) {
	        var nonNullRole = require_non_null_1.requireNonNull(role, 'role');
	        var nonNullPath = require_non_null_1.requireNonNull(path, 'path');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'remove ' +
	                util_1.quoteAndEscape(nonNullRole) +
	                ' permissions for path ' +
	                util_1.quoteAndEscape(nonNullPath);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     * @deprecated since 6.5
	     * replaced by {@link setPathPermissions}
	     */
	    SecurityScriptBuilderImpl.prototype.setTopicPermissions = function (role, path, permissions) {
	        return this.setPathPermissions(role, path, permissions);
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setPathPermissions = function (role, path, permissions) {
	        var nonNullRole = require_non_null_1.requireNonNull(role, 'role');
	        var nonNullPath = require_non_null_1.requireNonNull(path, 'path');
	        var nonNullPermissions = require_non_null_1.requireNonNull(permissions, 'permissions');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'set ' +
	                util_1.quoteAndEscape(nonNullRole) +
	                ' path ' +
	                util_1.quoteAndEscape(nonNullPath) +
	                ' permissions ';
	        this.commands += util_1.permissionsToString(nonNullPermissions);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setRoleIncludes = function (role, included) {
	        var nonNullRole = require_non_null_1.requireNonNull(role, 'role');
	        var nonNullIncludedRoles = require_non_null_1.requireNonNull(included, 'includedRoles');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'set ' +
	                util_1.quoteAndEscape(nonNullRole) +
	                ' includes ';
	        this.commands += util_1.setToString(nonNullIncludedRoles);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.setRoleLockedByPrincipal = function (role, lockingPrincipal) {
	        var nonNullRole = require_non_null_1.requireNonNull(role, 'role');
	        var nonNullPrincipal = require_non_null_1.requireNonNull(lockingPrincipal, 'lockingPrincipal');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'set role ' +
	                util_1.quoteAndEscape(nonNullRole) +
	                ' locked by principal ' +
	                util_1.quoteAndEscape(nonNullPrincipal);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.isolatePath = function (path) {
	        var nonNullPath = require_non_null_1.requireNonNull(path, 'path');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'isolate path ' +
	                util_1.quoteAndEscape(nonNullPath);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SecurityScriptBuilderImpl.prototype.deisolatePath = function (path) {
	        var nonNullPath = require_non_null_1.requireNonNull(path, 'path');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'deisolate path ' +
	                util_1.quoteAndEscape(nonNullPath);
	        return this;
	    };
	    return SecurityScriptBuilderImpl;
	}());
	exports.SecurityScriptBuilderImpl = SecurityScriptBuilderImpl;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(504);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of the {@link SystemAuthenticationScriptBuilder} interface
	 */
	var SystemAuthenticationScriptBuilderImpl = /** @class */ (function () {
	    function SystemAuthenticationScriptBuilderImpl() {
	        /**
	         * The security script built so far
	         */
	        this.commands = '';
	    }
	    /**
	     * Utility function that appends a new line
	     * if commands already has lines
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.maybeApppendNewLine = function () {
	        if (this.commands.length > 0) {
	            this.commands += '\n';
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.build = function () {
	        return this.commands;
	    };
	    /**
	     * Convert the system authentication script builder to a string
	     *
	     * @return  a string representation on this object
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.toString = function () {
	        return "SystemAuthenticationScriptBuilder [" + this.commands + "]";
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.assignRoles = function (principal, roles) {
	        var nonNullRoles = require_non_null_1.requireNonNull(roles, 'roles');
	        var nonNullPrincipal = require_non_null_1.requireNonNull(principal, 'principal');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'assign roles ' +
	                util_1.quoteAndEscape(nonNullPrincipal) +
	                ' ';
	        this.commands += util_1.setToString(nonNullRoles);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.addPrincipal = function (principal, password, roles, lockingPrincipal) {
	        if (roles === void 0) { roles = []; }
	        var nonNullRoles = require_non_null_1.requireNonNull(roles, 'roles');
	        var nonNullPrincipal = require_non_null_1.requireNonNull(principal, 'principal');
	        var nonNullPassword = require_non_null_1.requireNonNull(password, 'password');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'add principal ' +
	                util_1.quoteAndEscape(nonNullPrincipal) +
	                ' ' +
	                util_1.quoteAndEscape(nonNullPassword);
	        if (nonNullRoles.length) {
	            this.commands += ' ';
	            this.commands += util_1.setToString(nonNullRoles);
	        }
	        if (lockingPrincipal) {
	            this.commands +=
	                ' locked by ' +
	                    util_1.quoteAndEscape(lockingPrincipal);
	        }
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.setPassword = function (principal, password) {
	        var nonNullPrincipal = require_non_null_1.requireNonNull(principal, 'principal');
	        var nonNullPassword = require_non_null_1.requireNonNull(password, 'password');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'set password ' +
	                util_1.quoteAndEscape(nonNullPrincipal) +
	                ' ' +
	                util_1.quoteAndEscape(nonNullPassword);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.verifyPassword = function (principal, password) {
	        var nonNullPrincipal = require_non_null_1.requireNonNull(principal, 'principal');
	        var nonNullPassword = require_non_null_1.requireNonNull(password, 'password');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'verify password ' +
	                util_1.quoteAndEscape(nonNullPrincipal) +
	                ' ' +
	                util_1.quoteAndEscape(nonNullPassword);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.removePrincipal = function (principal) {
	        var nonNullPrincipal = require_non_null_1.requireNonNull(principal, 'principal');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'remove principal ' +
	                util_1.quoteAndEscape(nonNullPrincipal);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.allowAnonymousConnections = function (roles) {
	        var nonNullRoles = require_non_null_1.requireNonNull(roles, 'roles');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'allow anonymous connections' + (roles ? ' ' : '');
	        this.commands += util_1.setToString(nonNullRoles);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.denyAnonymousConnections = function () {
	        this.maybeApppendNewLine();
	        this.commands +=
	            'deny anonymous connections';
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.abstainAnonymousConnections = function () {
	        this.maybeApppendNewLine();
	        this.commands +=
	            'abstain anonymous connections';
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.trustClientProposedPropertyIn = function (propertyName, allowedValues) {
	        var nonNullPropertyName = require_non_null_1.requireNonNull(propertyName, 'propertyName');
	        var nonNullAllowedValues = require_non_null_1.requireNonNull(allowedValues, 'allowedValues');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'trust client proposed property ' +
	                util_1.quoteAndEscape(nonNullPropertyName) +
	                ' if value in ';
	        this.commands += util_1.setToString(nonNullAllowedValues);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.trustClientProposedPropertyMatches = function (propertyName, regex) {
	        var nonNullPropertyName = require_non_null_1.requireNonNull(propertyName, 'propertyName');
	        var nonNullRegex = require_non_null_1.requireNonNull(regex, 'regex');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'trust client proposed property ' +
	                util_1.quoteAndEscape(nonNullPropertyName) +
	                ' if value matches ' +
	                util_1.quoteAndEscape(nonNullRegex);
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SystemAuthenticationScriptBuilderImpl.prototype.ignoreClientProposedProperty = function (propertyName) {
	        var nonNullPropertyName = require_non_null_1.requireNonNull(propertyName, 'propertyName');
	        this.maybeApppendNewLine();
	        this.commands +=
	            'ignore client proposed property ' +
	                util_1.quoteAndEscape(nonNullPropertyName);
	        return this;
	    };
	    return SystemAuthenticationScriptBuilderImpl;
	}());
	exports.SystemAuthenticationScriptBuilderImpl = SystemAuthenticationScriptBuilderImpl;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enumerize_1 = __webpack_require__(103);
	/**
	 * Implementation of {@link SystemAuthenticationConfiguration}
	 *
	 * @inheritdoc
	 */
	var SystemAuthentication = /** @class */ (function () {
	    function SystemAuthentication(principals, action, roles, properties) {
	        if (principals === void 0) { principals = []; }
	        if (roles === void 0) { roles = []; }
	        if (properties === void 0) { properties = {}; }
	        this.principals = principals;
	        this.anonymous = {
	            action: action,
	            roles: roles
	        };
	        this.trustedClientProposedProperties = properties;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the SystemAuthentication
	     */
	    SystemAuthentication.prototype.toString = function () {
	        return "SystemAuthenticationConfiguration [principals=" + this.principals + ", anonymous=" + this.anonymous + "]";
	    };
	    return SystemAuthentication;
	}());
	exports.SystemAuthentication = SystemAuthentication;
	/**
	 * An enum-like object containing all possible connection actions
	 */
	exports.CONNECTION_ACTION = {
	    ALLOW: { id: 0, value: 'allow' },
	    DENY: { id: 1, value: 'deny' },
	    ABSTAIN: { id: 2, value: 'abstain' },
	};
	enumerize_1.enumerize(exports.CONNECTION_ACTION);
	/**
	 * Get a connection action from a string
	 *
	 * @param  val  the string
	 * @return      a connection action obtained from the string
	 */
	function connectionActionFromString(val) {
	    return exports.CONNECTION_ACTION[val.toUpperCase()];
	}
	exports.connectionActionFromString = connectionActionFromString;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of {@link SystemPrincipal}
	 *
	 * @inheritdoc
	 */
	var SystemPrincipalImpl = /** @class */ (function () {
	    /**
	     * Create a SystemPrincipalImpl instance
	     *
	     * @param  name   the principal name
	     * @param  roles  the principal's assigned roles
	     */
	    function SystemPrincipalImpl(name, roles, lockingPrincipal) {
	        this.name = require_non_null_1.requireNonNull(name, 'name');
	        this.roles = roles || [];
	        this.lockingPrincipal = lockingPrincipal;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the SystemPrincipalImpl
	     */
	    SystemPrincipalImpl.prototype.toString = function () {
	        return "SystemPrincipal [" + this.name + ", " + this.roles + "]";
	    };
	    return SystemPrincipalImpl;
	}());
	exports.SystemPrincipalImpl = SystemPrincipalImpl;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Features.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var session_property_validation_1 = __webpack_require__(503);
	var security_1 = __webpack_require__(101);
	/**
	 * Implementation of {@link ValuesSessionPropertyValidation}
	 *
	 * @inheritdoc
	 */
	var ValuesSessionPropertyValidationImpl = /** @class */ (function (_super) {
	    __extends(ValuesSessionPropertyValidationImpl, _super);
	    /**
	     * Create a ValuesSessionPropertyValidationImpl instance
	     *
	     * @param  values   the permitted values
	     */
	    function ValuesSessionPropertyValidationImpl(values) {
	        var _this = _super.call(this, security_1.ValidationType.VALUES) || this;
	        _this.values = values;
	        return _this;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the ValuesSessionPropertyValidationImpl
	     */
	    ValuesSessionPropertyValidationImpl.prototype.toString = function () {
	        return "SessionPropertyValidation [type=" + this.type + ", values=" + this.values + "]";
	    };
	    return ValuesSessionPropertyValidationImpl;
	}(session_property_validation_1.SessionPropertyValidationImpl));
	exports.ValuesSessionPropertyValidationImpl = ValuesSessionPropertyValidationImpl;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Session.locks
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_session_1 = __webpack_require__(326);
	var Services = __webpack_require__(1373);
	var logger = __webpack_require__(17);
	var response_success_1 = __webpack_require__(68);
	var session_lock_options_1 = __webpack_require__(173);
	var log = logger.create('diffusion.locks.SessionLocks');
	/**
	 * Implementation of the {@link SessionLock} interface
	 */
	var SessionLockImpl = /** @class */ (function () {
	    /**
	     * Create a new SessionLockImpl instance
	     *
	     * @param acquisition        the session lock acquisition
	     * @param ownedSetter        the setter that will be initialised to allow
	     *                           access to the `owned` property
	     * @param unlockSessionLock  a callback that will unlock the session lock
	     */
	    function SessionLockImpl(acquisition, ownedSetter, unlockSessionLock) {
	        var _this = this;
	        /**
	         * Flag indicating if the session lock is owned
	         */
	        this.owned = true;
	        this.acquisition = acquisition;
	        this.unlockSessionLock = unlockSessionLock;
	        ownedSetter.setOwned = function (newOwned) {
	            _this.owned = newOwned;
	        };
	    }
	    /**
	     * Convert the SessionLockImpl to a string
	     *
	     * @return  the string representation of the session lock
	     */
	    SessionLockImpl.prototype.toString = function () {
	        return "SessionLock [name=" + this.acquisition.lockName + ", sequence=" + this.acquisition.sequence + ", "
	            + ("scope=" + this.acquisition.scope + ", owned=" + this.owned + "]");
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockImpl.prototype.getName = function () {
	        return this.acquisition.lockName;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockImpl.prototype.getSequence = function () {
	        return this.acquisition.sequence;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockImpl.prototype.isOwned = function () {
	        return this.owned;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockImpl.prototype.getScope = function () {
	        return this.acquisition.scope;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockImpl.prototype.unlock = function () {
	        if (this.owned) {
	            this.owned = false;
	            return this.unlockSessionLock(this.acquisition);
	        }
	        else {
	            return Promise.resolve(false);
	        }
	    };
	    return SessionLockImpl;
	}());
	exports.SessionLockImpl = SessionLockImpl;
	/**
	 * The internal session lock feature
	 */
	var InternalSessionLocks = /** @class */ (function () {
	    /**
	     * Create a new InternalSessionLocks implementation
	     *
	     * @param internal     the internal session
	     * @param internalFsm  the finite state machine of the internal session
	     */
	    function InternalSessionLocks(internal, internalFsm) {
	        var _this = this;
	        /**
	         * The map of locks indexed by their name
	         */
	        this.locks = {};
	        /**
	         * The next request id
	         */
	        this.nextRequestId = 0;
	        this.serviceLocator = internal.getServiceLocator();
	        // at the moment we do not implement cancellation of session locks
	        // in the JavaScript api
	        this.ACQUIRE_SESSION_LOCK = this.serviceLocator.obtain(Services.ACQUIRE_SESSION_LOCK);
	        this.RELEASE_SESSION_LOCK = this.serviceLocator.obtain(Services.RELEASE_SESSION_LOCK);
	        internalFsm.on('change', function (previous, current) { return __awaiter(_this, void 0, void 0, function () {
	            var failoverDetectionCid, releaseLock;
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        failoverDetectionCid = null;
	                        releaseLock = function (v) {
	                            v.ownedSetter.setOwned(false);
	                            v.onRemoveLock();
	                        };
	                        if (!(current === internal_session_1.InternalSessionState.DISCONNECTED)) return [3 /*break*/, 2];
	                        // this client has detected connection loss
	                        Object.values(this.locks)
	                            .filter(function (v) { return (v.lock.getScope() === session_lock_options_1.SessionLockScope.UNLOCK_ON_CONNECTION_LOSS); })
	                            .forEach(releaseLock);
	                        return [4 /*yield*/, internal.getConversationSet().newConversation({
	                                onOpen: function () {
	                                    // no-op
	                                },
	                                onResponse: function () {
	                                    // called on successful connection. Close this conversation.
	                                    return true;
	                                },
	                                onDiscard: function () {
	                                    // called on failover. We've lost all of the locks.
	                                    Object.values(_this.locks).forEach(releaseLock);
	                                    _this.locks = {};
	                                }
	                            })];
	                    case 1:
	                        // there could be pending duplicate acquisitions
	                        // that will arrive after reconnection. We leave
	                        // lock in locks so we can filter these when they
	                        // arrive.
	                        // abuse a conversation set to detect failover and release the locks.
	                        // relies on the RECONNECTED_WITH_MESSAGE_LOSS handling to discard all current conversations.
	                        failoverDetectionCid = _a.sent();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        if (current === internal_session_1.InternalSessionState.CONNECTED) {
	                            // tslint:disable-next-line:strict-type-predicates
	                            if (failoverDetectionCid !== null) {
	                                internal.getConversationSet().respondIfPresent(failoverDetectionCid, null);
	                                failoverDetectionCid = null;
	                            }
	                        }
	                        else if (current === internal_session_1.InternalSessionState.CLOSED) {
	                            Object.values(this.locks).forEach(releaseLock);
	                            this.locks = {};
	                        }
	                        _a.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        }); });
	    }
	    /**
	     * Handle a lock acquisition
	     *
	     * @param  lockName     the acquired lock name
	     * @param  acquisition  the acquisition data sent by the server
	     * @return              the new session lock
	     */
	    InternalSessionLocks.prototype.handleAcquisistion = function (lockName, acquisition, handler) {
	        var oldLock = this.locks[lockName];
	        var sessionLock;
	        // tslint:disable-next-line:strict-type-predicates
	        if (oldLock !== undefined) {
	            if (!oldLock.lock.getSequence().equals(acquisition.sequence)) {
	                // access the session locks owned member through
	                oldLock.ownedSetter.setOwned(false);
	                sessionLock = this.createLock(lockName, acquisition, handler);
	            }
	            else {
	                sessionLock = oldLock.lock;
	            }
	        }
	        else {
	            sessionLock = this.createLock(lockName, acquisition, handler);
	        }
	        return sessionLock;
	    };
	    InternalSessionLocks.prototype.createLock = function (lockName, acquisition, handler) {
	        var sessionLockOwnedSetter = {
	            setOwned: function () {
	                throw Error('Session lock ownedSetter must be implemented');
	            }
	        };
	        var sessionLock = new SessionLockImpl(acquisition, sessionLockOwnedSetter, this.unlock.bind(this));
	        var lockInfo = handler
	            ? {
	                lock: sessionLock,
	                ownedSetter: {
	                    setOwned: function (newOwned) {
	                        sessionLockOwnedSetter.setOwned(newOwned);
	                        handler.onOwned(newOwned);
	                    }
	                },
	                onRemoveLock: function () {
	                    handler.onRemoveLock();
	                }
	            }
	            : {
	                lock: sessionLock,
	                ownedSetter: sessionLockOwnedSetter,
	                onRemoveLock: function () { }
	            };
	        this.locks[lockName] = lockInfo;
	        return sessionLock;
	    };
	    /**
	     * Unlock a session lock identified by the acquisition details
	     *
	     * @param acquisition the lock acquisition details
	     */
	    InternalSessionLocks.prototype.unlock = function (acquisition) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.RELEASE_SESSION_LOCK.send(acquisition, function (err, response) {
	                if (err) {
	                    log.debug('Release session lock failed');
	                    reject(err);
	                }
	                else {
	                    // tslint:disable-next-line:strict-type-predicates
	                    if (_this.locks[acquisition.lockName] !== undefined
	                        && _this.locks[acquisition.lockName].lock.getSequence().toString(10)
	                            === acquisition.sequence.toString(10)) {
	                        delete _this.locks[acquisition.lockName];
	                    }
	                    resolve(response);
	                }
	            });
	        });
	    };
	    /**
	     * Attempt to acquire a lock
	     *
	     * If a lock with the name is already owned by the session, the existing
	     * lock will be returned. Otherwise a request will be sent to the server
	     *
	     * @param lockName  the lock name
	     * @param scope     the lock scope
	     * @return          a {@link Result} that resolves with the acquired session lock
	     */
	    InternalSessionLocks.prototype.lock = function (lockName, scope, handler) {
	        var _this = this;
	        if (scope === void 0) { scope = session_lock_options_1.SessionLockScope.UNLOCK_ON_SESSION_LOSS; }
	        return new Promise(function (resolve, reject) {
	            // tslint:disable-next-line:strict-type-predicates
	            if (_this.locks[lockName] !== undefined && _this.locks[lockName].lock.isOwned()) {
	                if (handler) {
	                    reject(new Error('Cannot register the same lock in different shared sessions'));
	                }
	                else {
	                    resolve(_this.locks[lockName].lock);
	                }
	            }
	            else {
	                var requestId = _this.nextRequestId++;
	                _this.ACQUIRE_SESSION_LOCK.send({
	                    lockName: lockName, requestId: requestId, scope: scope
	                }, function (err, acquisition) {
	                    if (!response_success_1.responseSuccess(err, acquisition)) {
	                        log.debug('Acquire session lock failed');
	                        reject(err);
	                    }
	                    else {
	                        var newLock = _this.handleAcquisistion(lockName, acquisition, handler);
	                        resolve(newLock);
	                    }
	                });
	            }
	        });
	    };
	    return InternalSessionLocks;
	}());
	exports.InternalSessionLocks = InternalSessionLocks;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module SessionTrees
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(1377);
	var logger = __webpack_require__(17);
	var require_non_null_1 = __webpack_require__(22);
	var response_success_1 = __webpack_require__(68);
	var log = logger.create('SessionTrees');
	/**
	 * Implementation of the {@link SessionTrees} feature
	 */
	var SessionTreesImpl = /** @class */ (function () {
	    /**
	     * Create a new instance of the SessionTrees feature
	     *
	     * @param internal  the internal session
	     */
	    function SessionTreesImpl(internal) {
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.PUT_BRANCH_MAPPING_TABLE = serviceLocator.obtain(Services.PUT_BRANCH_MAPPING_TABLE);
	        this.GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS
	            = serviceLocator.obtain(Services.GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS);
	        this.GET_BRANCH_MAPPING_TABLE = serviceLocator.obtain(Services.GET_BRANCH_MAPPING_TABLE);
	    }
	    /**
	     * @inheritdoc
	     */
	    SessionTreesImpl.prototype.putBranchMappingTable = function (branchMappingTable) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            require_non_null_1.requireNonNull(branchMappingTable, 'branchMappingTable');
	            if (_this.internal.checkConnected(reject)) {
	                _this.PUT_BRANCH_MAPPING_TABLE.send(branchMappingTable, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                        log.debug('Put branch mapping table failed');
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionTreesImpl.prototype.getSessionTreeBranchesWithMappings = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS.send(null, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                        log.debug('Get session tree branches with mappings failed');
	                    }
	                    else {
	                        resolve(response.paths);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionTreesImpl.prototype.getBranchMappingTable = function (sessionTreeBranch) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            require_non_null_1.requireNonNull(sessionTreeBranch, 'sessionTreeBranch');
	            if (_this.internal.checkConnected(reject)) {
	                _this.GET_BRANCH_MAPPING_TABLE.send(sessionTreeBranch, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                        log.debug('Get branch mapping table failed');
	                    }
	                    else {
	                        resolve(response);
	                    }
	                });
	            }
	        });
	    };
	    return SessionTreesImpl;
	}());
	exports.SessionTreesImpl = SessionTreesImpl;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var branch_mapping_table_1 = __webpack_require__(505);
	/**
	 * BranchMappingTable builder implementation.
	 *
	 * @since 6.7
	 */
	var BranchMappingTableBuilderImpl = /** @class */ (function () {
	    function BranchMappingTableBuilderImpl() {
	        /**
	         * the branch mappings
	         */
	        this.mappings = [];
	    }
	    /**
	     * @inheritdoc
	     */
	    BranchMappingTableBuilderImpl.prototype.reset = function () {
	        this.mappings = [];
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    BranchMappingTableBuilderImpl.prototype.addBranchMapping = function (sessionFilter, topicTreeBranch) {
	        this.mappings.push({
	            sessionFilter: sessionFilter,
	            topicTreeBranch: topicTreeBranch
	        });
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    BranchMappingTableBuilderImpl.prototype.create = function (sessionTreeBranch) {
	        return new branch_mapping_table_1.BranchMappingTableImpl(sessionTreeBranch, __spread(this.mappings));
	    };
	    return BranchMappingTableBuilderImpl;
	}());
	exports.BranchMappingTableBuilderImpl = BranchMappingTableBuilderImpl;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var range_query_parameters_1 = __webpack_require__(334);
	var Long = __webpack_require__(44);
	/**
	 * Check is a value is not `null` or `undefined`
	 *
	 * @param  e  the value to check
	 * @return    `true` if the value is truthy
	 */
	function nonNull(e) {
	    return !!e;
	}
	/**
	 * Compare two {@link Event}s by their sequence numbers
	 *
	 * Sorts first by `originalEvent.sequence`. Events with equal
	 * `originalEvent.sequence` are sorted according to their `sequence` field.
	 *
	 * @param  e1  the first event to compare
	 * @param  e2  the second event to compare
	 * @return     `+1` if the first event has a larger sequence number than the
	 *             second event, `-1` otherwise
	 */
	function comparingSequenceNumbers(e1, e2) {
	    return e1.originalEvent.sequence !== e2.originalEvent.sequence
	        ? e1.originalEvent.sequence - e2.originalEvent.sequence
	        : e1.sequence - e2.sequence;
	}
	/**
	 * Get a function that replaces an {@link Event} with the latest event in the
	 * same sequence.
	 *
	 * @param  allEvents  an array of events to act as original events in the sequence
	 * @return            a function that replaces events
	 */
	function replaceWithLatest(allEvents) {
	    var latestByOriginalSequence = {};
	    allEvents.forEach(function (e) {
	        var k = e.originalEvent.sequence.toString(10);
	        if (!latestByOriginalSequence[k]
	            || (latestByOriginalSequence[k].sequence < e.sequence)) {
	            latestByOriginalSequence[k] = e;
	        }
	    });
	    return function (e) {
	        var originalSequence = e.originalEvent.sequence.toString(10);
	        var latest = latestByOriginalSequence[originalSequence];
	        if (!latest) {
	            return null;
	        }
	        if (!e.isEditEvent) {
	            delete latestByOriginalSequence[originalSequence];
	            return latest;
	        }
	        else if (e.sequence.equals(latest.sequence)) {
	            delete latestByOriginalSequence[originalSequence];
	            return e;
	        }
	        else {
	            return null;
	        }
	    };
	}
	/**
	 * A timeseries query result
	 */
	var QueryResultImpl = /** @class */ (function () {
	    /**
	     * Create a new QueryResult instance
	     *
	     * @param selectedCount    the number of selected events
	     * @param eventCount       the number of events
	     * @param streamStructure  the stream structure of the result
	     * @param events           the timeseries events returned
	     */
	    function QueryResultImpl(selectedCount, eventCount, streamStructure, events) {
	        this.events = events;
	        this.selectedCount = selectedCount.toNumber();
	        this.isComplete = (selectedCount.equals(eventCount));
	        this.streamStructure = streamStructure;
	    }
	    /**
	     * Merge a QueryResult with another result
	     *
	     * @param  other  another query result
	     * @return        a merged query result
	     */
	    QueryResultImpl.prototype.merge = function (other) {
	        var merged = this.events.concat(other.events)
	            .sort(comparingSequenceNumbers)
	            .map(replaceWithLatest(this.events.concat(other.events)))
	            .filter(nonNull);
	        var count = Long.fromNumber(merged.length);
	        return new QueryResultImpl(count, count, range_query_parameters_1.StreamStructures.VALUE_EVENT_STREAM, merged);
	    };
	    return QueryResultImpl;
	}());
	exports.QueryResultImpl = QueryResultImpl;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bytes_impl_1 = __webpack_require__(102);
	var range_1 = __webpack_require__(335);
	var range_query_parameters_1 = __webpack_require__(334);
	var response_success_1 = __webpack_require__(68);
	/**
	 * Create range query parameters with a modified view range
	 *
	 * @param original  the original range query parameters
	 * @param op        a modifier that is used to modify the {@link
	 *                  RangeQueryParameters.viewRange}
	 * @return          new range query parameters
	 */
	function VIEW_RANGE(original, op) {
	    return original.withViewRange(op(original.viewRange));
	}
	/**
	 * Create range query parameters with a modified edit range
	 *
	 * @param original  the original range query parameters
	 * @param op        a modifier that is used to modify the {@link
	 *                  RangeQueryParameters.editRange}
	 * @return          new range query parameters
	 */
	function EDIT_RANGE(original, op) {
	    return original.withEditRange(op(original.editRange));
	}
	/**
	 * Implementation of the {@link RangeQuery} interface
	 */
	var RangeQueryImpl = /** @class */ (function () {
	    /**
	     * Create a new RangeQueryImpl instance
	     *
	     * @param context     the command service for sending the range query to the server
	     * @param valueType   the data value type
	     * @param parameters  the range query parameters
	     * @param mode        the current mode of the range query
	     */
	    function RangeQueryImpl(context, valueType, parameters, mode) {
	        this.context = context;
	        this.valueType = valueType;
	        this.parameters = parameters;
	        this.mode = mode;
	    }
	    /**
	     * Create a new range query with a modified range
	     *
	     * The current {@link mode} determined whether the view range or edit range
	     * are modified.
	     *
	     * @param op  the operator that will modify the range
	     * @return    a new RangeQuery with a modified range
	     */
	    RangeQueryImpl.prototype.withCurrentRange = function (op) {
	        return new RangeQueryImpl(this.context, this.valueType, this.mode(this.parameters, op), this.mode);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.selectFrom = function (topicPath) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (!topicPath) {
	                reject(new Error('Topic path is null'));
	                return;
	            }
	            var request = {
	                topicPath: topicPath,
	                parameters: _this.parameters
	            };
	            _this.context.send(request, function (err, response) {
	                if (!response_success_1.responseSuccess(err, response)) {
	                    reject(err);
	                }
	                else {
	                    resolve(response.createQueryResult(_this.valueType, _this.parameters.queryType.streamStructure));
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.forValues = function () {
	        return new RangeQueryImpl(this.context, this.valueType, this.parameters.withQueryType(range_query_parameters_1.QueryTypes.VALUES).withViewRange(range_1.DEFAULT_RANGE), VIEW_RANGE);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.forEdits = function () {
	        return new RangeQueryImpl(this.context, this.valueType, this.parameters.withQueryType(range_query_parameters_1.QueryTypes.ALL_EDITS).withViewRange(range_1.DEFAULT_RANGE), VIEW_RANGE);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.editRange = function () {
	        if (this.parameters.queryType !== range_query_parameters_1.QueryTypes.VALUES) {
	            throw new Error('.editRange() cannot be applied to this edit range query');
	        }
	        return new RangeQueryImpl(this.context, this.valueType, this.parameters, EDIT_RANGE);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.allEdits = function () {
	        if (this.parameters.queryType === range_query_parameters_1.QueryTypes.VALUES) {
	            throw new Error('.allEdits() cannot be applied to this value range query');
	        }
	        return new RangeQueryImpl(this.context, this.valueType, this.parameters.withQueryType(range_query_parameters_1.QueryTypes.ALL_EDITS), EDIT_RANGE);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.latestEdits = function () {
	        if (this.parameters.queryType === range_query_parameters_1.QueryTypes.VALUES) {
	            throw new Error('.latestEdits() cannot be applied to this value range query');
	        }
	        return new RangeQueryImpl(this.context, this.valueType, this.parameters.withQueryType(range_query_parameters_1.QueryTypes.LATEST_EDITS), EDIT_RANGE);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.limit = function (count) {
	        return new RangeQueryImpl(this.context, this.valueType, this.parameters.withLimit(count), this.mode);
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.as = function (newValueType) {
	        // allow datatypes to be provided
	        if (newValueType && newValueType.valueClass) {
	            return new RangeQueryImpl(this.context, newValueType.valueClass, this.parameters, this.mode);
	        }
	        else if (newValueType instanceof Function) {
	            return new RangeQueryImpl(this.context, newValueType, this.parameters, this.mode);
	        }
	        else {
	            throw new Error("Invalid value type: " + newValueType);
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.from = function (sequence) {
	        return this.withCurrentRange(function (r) {
	            return r.from(sequence);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.fromStart = function () {
	        return this.withCurrentRange(function (r) {
	            return r.fromStart();
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.fromLast = function (count) {
	        return this.withCurrentRange(function (r) {
	            return r.fromLast(count);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.fromLastMillis = function (timespan) {
	        return this.withCurrentRange(function (r) {
	            return r.fromLastMillis(timespan);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.to = function (sequence) {
	        return this.withCurrentRange(function (r) {
	            return r.to(sequence);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.toStart = function () {
	        return this.withCurrentRange(function (r) {
	            return r.toStart();
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.untilLast = function (count) {
	        return this.withCurrentRange(function (r) {
	            return r.untilLast(count);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.untilLastMillis = function (timespan) {
	        return this.withCurrentRange(function (r) {
	            return r.untilLastMillis(timespan);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.next = function (count) {
	        return this.withCurrentRange(function (r) {
	            return r.next(count);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.nextMillis = function (timespan) {
	        return this.withCurrentRange(function (r) {
	            return r.nextMillis(timespan);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.previous = function (count) {
	        return this.withCurrentRange(function (r) {
	            return r.previous(count);
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    RangeQueryImpl.prototype.previousMillis = function (timespan) {
	        return this.withCurrentRange(function (r) {
	            return r.previousMillis(timespan);
	        });
	    };
	    /**
	     * Create a default range query
	     *
	     * @param context  the command service for sending the range query to the server
	     * @return         a range query with default parameters
	     */
	    RangeQueryImpl.createDefault = function (context) {
	        return new RangeQueryImpl(context, bytes_impl_1.BytesImpl, range_query_parameters_1.DEFAULT_RANGE_QUERY, VIEW_RANGE);
	    };
	    /**
	     * Check if the range query is equal to another object
	     *
	     * @param  other  the other object
	     * @return        `true` if the other object is a `RangeQueryImpl` and the
	     *                parameters are equal
	     */
	    RangeQueryImpl.prototype.equals = function (other) {
	        if (other && other instanceof RangeQueryImpl) {
	            return this.parameters.equals(other.parameters);
	        }
	        return false;
	    };
	    /**
	     * Convert the range query to a string
	     *
	     * @return  a string representation of the parameters
	     */
	    RangeQueryImpl.prototype.toString = function () {
	        return this.parameters.toString();
	    };
	    return RangeQueryImpl;
	}());
	exports.RangeQueryImpl = RangeQueryImpl;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var range_query_impl_1 = __webpack_require__(1211);
	var Services = __webpack_require__(1381);
	var time_series_append_request_1 = __webpack_require__(1388);
	var time_series_timestamp_append_request_1 = __webpack_require__(1391);
	var require_non_null_1 = __webpack_require__(22);
	var Long = __webpack_require__(44);
	/**
	 * Implementation of the time series feature
	 */
	var TimeSeriesImpl = /** @class */ (function () {
	    /**
	     * Create a new TimeSeriesImpl instance
	     *
	     * @param internal  the internal session
	     */
	    function TimeSeriesImpl(internal) {
	        this.internal = internal;
	        var locator = internal.getServiceLocator();
	        this.defaultRangeQuery = range_query_impl_1.RangeQueryImpl.createDefault(locator.obtain(Services.rangeQueryFactory(internal.getContext().DataTypes)));
	        this.appendService = locator.obtain(Services.TIME_SERIES_APPEND);
	        this.appendTimestampService = locator.obtain(Services.TIME_SERIES_TIMESTAMP_APPEND);
	        this.editService = locator.obtain(Services.TIME_SERIES_EDIT);
	    }
	    /**
	     * @inheritdoc
	     */
	    TimeSeriesImpl.prototype.rangeQuery = function () {
	        return this.defaultRangeQuery;
	    };
	    /**
	     * @inheritdoc
	     */
	    TimeSeriesImpl.prototype.edit = function (path, sequence, value, valueType) {
	        var _this = this;
	        var DataTypes = this.internal.getContext().DataTypes;
	        return new Promise(function (resolve, reject) {
	            var datatype;
	            try {
	                if (valueType instanceof _this.internal.getContext().AbstractDataType) {
	                    datatype = valueType;
	                }
	                else if (valueType) {
	                    datatype = DataTypes.getByClass(valueType);
	                }
	                else {
	                    datatype = DataTypes.getByValue(value);
	                }
	                require_non_null_1.requireNonNull(path, 'Path');
	                require_non_null_1.requireNonNull(value, 'Value');
	                require_non_null_1.requireNonNull(sequence, 'Sequence');
	                datatype = require_non_null_1.requireNonNull(datatype, 'Data type');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            _this.editService.send({
	                path: path,
	                sequence: sequence,
	                dataType: datatype,
	                value: datatype.writeValue(value)
	            }, function (err, metadata) {
	                if (err) {
	                    reject(err);
	                }
	                else {
	                    resolve(metadata);
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TimeSeriesImpl.prototype.append = function (path, value, valueType, timestamp) {
	        var _this = this;
	        var DataTypes = this.internal.getContext().DataTypes;
	        return new Promise(function (resolve, reject) {
	            var datatype;
	            try {
	                if (valueType instanceof _this.internal.getContext().AbstractDataType) {
	                    datatype = valueType;
	                }
	                else if (valueType) {
	                    datatype = DataTypes.getByClass(valueType);
	                }
	                else {
	                    datatype = DataTypes.getByValue(value);
	                }
	                require_non_null_1.requireNonNull(path, 'Path');
	                require_non_null_1.requireNonNull(value, 'Value');
	                datatype = require_non_null_1.requireNonNull(datatype, 'Data type');
	            }
	            catch (e) {
	                reject(e);
	                return;
	            }
	            var responseCallback = function (err, metadata) {
	                if (err) {
	                    reject(err);
	                }
	                else {
	                    resolve(metadata);
	                }
	            };
	            if (timestamp === undefined) {
	                _this.appendService.send(new time_series_append_request_1.TimeSeriesAppendRequest(path, datatype, datatype.writeValue(value)), responseCallback);
	            }
	            else {
	                _this.appendTimestampService.send(new time_series_timestamp_append_request_1.TimeSeriesTimestampAppendRequest(path, datatype, datatype.writeValue(value), typeof timestamp === 'number' ? Long.fromNumber(timestamp) : timestamp), responseCallback);
	            }
	        });
	    };
	    return TimeSeriesImpl;
	}());
	exports.TimeSeriesImpl = TimeSeriesImpl;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var CommandService = __webpack_require__(225);
	var control_group_1 = __webpack_require__(226);
	var registration_1 = __webpack_require__(175);
	var value_cache_1 = __webpack_require__(1214);
	var topic_add_response_1 = __webpack_require__(538);
	var Services = __webpack_require__(1394);
	var session_id_1 = __webpack_require__(127);
	var logger = __webpack_require__(17);
	var error_reason_1 = __webpack_require__(88);
	var log = logger.create('Session.Topics');
	/**
	 * Implementation of the {@link TopicControl} feature
	 */
	var TopicControlImpl = /** @class */ (function () {
	    /**
	     * Create a new TopicControlImpl instance
	     *
	     * @param internal  the internal session
	     */
	    function TopicControlImpl(internal) {
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.TOPIC_ADD_SERVICE = serviceLocator.obtain(Services.TOPIC_ADD);
	        this.TOPIC_REMOVAL = serviceLocator.obtain(Services.TOPIC_REMOVAL);
	        var TopicAddFailReasonEnum = internal.getContext().TopicAddFailReasonEnum;
	        // see ErrorReasonException.java
	        this.errorReasonIdToAddFailReason = {
	            103: TopicAddFailReasonEnum.PERMISSIONS_FAILURE,
	            110: TopicAddFailReasonEnum.CLUSTER_REPARTITION,
	            9004: TopicAddFailReasonEnum.EXISTS_MISMATCH,
	            9005: TopicAddFailReasonEnum.INVALID_NAME,
	            9006: TopicAddFailReasonEnum.INVALID_DETAILS,
	            9007: TopicAddFailReasonEnum.EXCEEDED_LICENSE_LIMIT,
	            9008: TopicAddFailReasonEnum.INCOMPATIBLE_PARENT,
	            9010: TopicAddFailReasonEnum.EXISTS_INCOMPATIBLE,
	            9011: TopicAddFailReasonEnum.UNEXPECTED_ERROR
	        };
	        this.valueCache = new value_cache_1.ValueCache();
	        // Updater state service
	        var serviceRegistry = internal.getServiceRegistry();
	        serviceRegistry.add(Services.MISSING_TOPIC, CommandService.create(function (internalSession, request, callback) {
	            callback.respond(true);
	            internalSession.getConversationSet().respondIfPresent(request.cid, {
	                request: request,
	                callback: callback
	            });
	        }));
	    }
	    /**
	     * Check if the supplied topic type is supported
	     *
	     * @param type  the topic type or specification
	     * @return      `true` if the type is one of the supported topic types
	     */
	    TopicControlImpl.prototype.isSupportedTopicType = function (type) {
	        var TopicTypeEnum = this.internal.getContext().TopicTypeEnum;
	        return Object.keys(TopicTypeEnum).some(function (t) { return (TopicTypeEnum[t] === type); });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicControlImpl.prototype.add = function (path, specification) {
	        var _this = this;
	        var topicSpecificationType = this.internal.getContext().TopicSpecification;
	        return new Promise(function (resolve, reject) {
	            if (!path) {
	                reject({
	                    id: 0,
	                    reason: 'Path cannot be empty or null'
	                });
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Adding topic', path);
	                var topicSpecification = _this.isSupportedTopicType(specification)
	                    ? new topicSpecificationType(specification)
	                    : specification;
	                if (!(topicSpecification instanceof topicSpecificationType)) {
	                    throw new Error('Invalid topic specification or type');
	                }
	                // use Protocol 13 - TopicAdd service
	                _this.TOPIC_ADD_SERVICE.send({
	                    path: path, specification: topicSpecification
	                }, function (err, response) {
	                    if (err) {
	                        reject(_this.errorReasonIdToAddFailReason[err.id]);
	                    }
	                    else {
	                        _this.valueCache.put(path, undefined);
	                        resolve({
	                            topic: path,
	                            added: response.status === topic_add_response_1.TopicAddResponseStatus.OK
	                        });
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicControlImpl.prototype.remove = function (expression) {
	        var _this = this;
	        var selectors = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            selectors[_i - 1] = arguments[_i];
	        }
	        var args = arguments;
	        var parseSelector = this.internal.getContext().parseSelector;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                log.debug('Removing topics', expression);
	                try {
	                    _this.TOPIC_REMOVAL.send({
	                        selector: (args.length > 1)
	                            ? parseSelector(Array.prototype.slice.call(args))
	                            : parseSelector(expression)
	                    }, function (err, response) {
	                        if (err) {
	                            log.debug('Topic removal failed', expression);
	                            reject(err);
	                        }
	                        else {
	                            log.debug('Topic removal complete', expression);
	                            resolve({ removedCount: response });
	                        }
	                    });
	                }
	                catch (err) {
	                    log.debug('Error parsing selector', expression);
	                    reject(err);
	                }
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicControlImpl.prototype.addMissingTopicHandler = function (path, handler) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (!handler) {
	                reject(new Error('Missing Topic handler is null or undefined'));
	                return;
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var adapter = {
	                    active: function (close) {
	                        log.debug('Missing Topic Handler registered for ' + path);
	                        handler.onRegister(path, close);
	                        resolve();
	                    },
	                    respond: function (response) {
	                        var callback = response.callback;
	                        log.debug('Missing Topic Handler notification for ' +
	                            response.request.sessionID +
	                            ' using ' +
	                            response.request.selector);
	                        try {
	                            var request = response.request;
	                            handler.onMissingTopic({
	                                path: request.selector.prefix,
	                                selector: request.selector,
	                                // tslint:disable-next-line:no-string-literal
	                                sessionID: session_id_1.SessionId.fromString(request.sessionProperties['$SessionId']),
	                                sessionProperties: request.sessionProperties,
	                                serverNames: request.serverNames,
	                                proceed: function () { },
	                                cancel: function () { }
	                            });
	                        }
	                        catch (err) {
	                            handler.onError(path, err);
	                            callback.fail(error_reason_1.ErrorReason.CALLBACK_EXCEPTION, err && err.message);
	                            // rethrow so that the conversation can be discarded
	                            throw err;
	                        }
	                        return false;
	                    },
	                    close: function (err) {
	                        log.debug('Missing Topic Handler closed for ' + path);
	                        if (err) {
	                            handler.onError(path, err);
	                        }
	                        else {
	                            handler.onClose(path);
	                        }
	                    }
	                };
	                var params = {
	                    definition: Services.MISSING_TOPIC,
	                    group: control_group_1.DEFAULT,
	                    path: path
	                };
	                resolve(registration_1.registerTopicHandler(_this.internal, params, adapter));
	            }
	        });
	    };
	    return TopicControlImpl;
	}());
	exports.TopicControlImpl = TopicControlImpl;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_path_utils_1 = __webpack_require__(128);
	/**
	 * A cache for topic values that can be accessed by topic path
	 */
	var ValueCache = /** @class */ (function () {
	    function ValueCache() {
	        /**
	         * The cache object
	         */
	        this.cache = {};
	    }
	    /**
	     * Get a value for a topic path
	     *
	     * @param path  the topic path
	     * @return      the value or `undefined` if no value was stored
	     */
	    ValueCache.prototype.get = function (path) {
	        return this.cache[topic_path_utils_1.canonicalise(path)];
	    };
	    /**
	     * Put a value in the cache
	     *
	     * @param  path   the topic path
	     * @param  value  the value to put
	     */
	    ValueCache.prototype.put = function (path, value) {
	        this.cache[topic_path_utils_1.canonicalise(path)] = value;
	    };
	    /**
	     * Remove the values for all topics that match a topic selector
	     *
	     * @param selector  the topic selector
	     */
	    ValueCache.prototype.remove = function (selector) {
	        var e_1, _a;
	        try {
	            for (var _b = __values(Object.getOwnPropertyNames(this.cache)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var k = _c.value;
	                if (selector.selects(k)) {
	                    delete this.cache[k];
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    return ValueCache;
	}());
	exports.ValueCache = ValueCache;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicNotifications
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var CommandService = __webpack_require__(225);
	var registration_1 = __webpack_require__(175);
	var Services = __webpack_require__(1395);
	var logger = __webpack_require__(17);
	var topic_notifications_1 = __webpack_require__(223);
	var log = logger.create('Session.Notifications');
	/**
	 * Implementation of the {@link TopicNotifications} feature
	 */
	var TopicNotificationsImpl = /** @class */ (function () {
	    /**
	     * Create a new TopicNotificationsImpl instance
	     *
	     * @param internal  the internal session
	     */
	    function TopicNotificationsImpl(internal) {
	        /**
	         * Exporting the {@link Session.notifications.TopicNotificationType}
	         */
	        this.TopicNotificationType = topic_notifications_1.TopicNotificationType;
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.conversationSet = internal.getConversationSet();
	        this.TOPIC_NOTIFICATION_SELECTION = serviceLocator.obtain(Services.TOPIC_NOTIFICATION_SELECTION);
	        this.TOPIC_NOTIFICATION_DESELECTION = serviceLocator.obtain(Services.TOPIC_NOTIFICATION_DESELECTION);
	        this.TOPIC_NOTIFICATION_DEREGISTRATION = serviceLocator.obtain(Services.TOPIC_NOTIFICATION_DEREGISTRATION);
	        var serviceRegistry = internal.getServiceRegistry();
	        var eventService = CommandService.create(function (internalSession, request, callback) {
	            callback.respond();
	            internalSession.getConversationSet().respond(request.cid, request);
	        });
	        serviceRegistry.add(Services.TOPIC_NOTIFICATION_EVENTS, eventService);
	        serviceRegistry.add(Services.TOPIC_DESCENDANT_EVENTS, eventService);
	    }
	    /**
	     * @inheritdoc
	     */
	    TopicNotificationsImpl.prototype.addListener = function (listener) {
	        var _this = this;
	        var parseSelector = this.internal.getContext().parseSelector;
	        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
	            var adapter, conversationId;
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!listener) {
	                            reject(new Error('Topic Notification Listener is null or undefined'));
	                            return [2 /*return*/];
	                        }
	                        if (!this.internal.checkConnected(reject)) return [3 /*break*/, 2];
	                        log.debug('Adding Topic Notification Listener');
	                        adapter = {
	                            active: function (close, cid) {
	                                log.debug('Topic Notification Listener active');
	                                var topicNotificationRegistration = {
	                                    select: function (topicSelector) {
	                                        var args = [];
	                                        for (var _i = 1; _i < arguments.length; _i++) {
	                                            args[_i - 1] = arguments[_i];
	                                        }
	                                        return new Promise(function (selectResolve, selectReject) {
	                                            if (!topicSelector) {
	                                                selectReject(new Error('No topic selector provided'));
	                                                return;
	                                            }
	                                            try {
	                                                var selector = (args.length > 0)
	                                                    ? parseSelector([topicSelector].concat(args))
	                                                    : parseSelector(topicSelector);
	                                                _this.TOPIC_NOTIFICATION_SELECTION.send({ cid: cid, selector: selector }, function (err) {
	                                                    if (err) {
	                                                        _this.conversationSet.discard(cid, err);
	                                                        selectReject(err);
	                                                    }
	                                                    else {
	                                                        selectResolve();
	                                                    }
	                                                });
	                                            }
	                                            catch (err) {
	                                                selectReject(err);
	                                            }
	                                        });
	                                    },
	                                    deselect: function (topicSelector) {
	                                        var args = [];
	                                        for (var _i = 1; _i < arguments.length; _i++) {
	                                            args[_i - 1] = arguments[_i];
	                                        }
	                                        return new Promise(function (deselectResolve, deselectReject) {
	                                            if (!topicSelector) {
	                                                deselectReject(new Error('No topic selector provided'));
	                                                return;
	                                            }
	                                            try {
	                                                var selector = (args.length > 0)
	                                                    ? parseSelector([topicSelector].concat(args))
	                                                    : parseSelector(topicSelector);
	                                                _this.TOPIC_NOTIFICATION_DESELECTION.send({ cid: cid, selector: selector }, function (err) {
	                                                    if (err) {
	                                                        _this.conversationSet.discard(cid, err);
	                                                        deselectReject(err);
	                                                    }
	                                                    else {
	                                                        deselectResolve();
	                                                    }
	                                                });
	                                            }
	                                            catch (err) {
	                                                deselectReject(err);
	                                            }
	                                        });
	                                    },
	                                    close: function () {
	                                        _this.TOPIC_NOTIFICATION_DEREGISTRATION.send({ cid: cid }, function (err, response) {
	                                            if (err) {
	                                                _this.conversationSet.discard(cid, err);
	                                                log.debug('Error with topic notification deregistration: ', err);
	                                            }
	                                            else {
	                                                listener.onClose();
	                                                _this.conversationSet.respondIfPresent(cid, response);
	                                            }
	                                        });
	                                    }
	                                };
	                                resolve(topicNotificationRegistration);
	                            },
	                            respond: function (message) {
	                                if (message.isDescendantEvent) {
	                                    listener.onDescendantNotification(message.path, message.type);
	                                }
	                                else {
	                                    listener.onTopicNotification(message.path, message.specification, message.type);
	                                }
	                                return false;
	                            },
	                            close: function (err) {
	                                log.debug('Topic Notification Listener closed');
	                                if (err) {
	                                    listener.onError(err);
	                                }
	                                else {
	                                    listener.onClose();
	                                }
	                            }
	                        };
	                        return [4 /*yield*/, this.conversationSet.newConversation(registration_1.responseHandler(this.internal, adapter, function (cid, callback) {
	                                _this.TOPIC_NOTIFICATION_DEREGISTRATION.send({ cid: cid }, callback);
	                            }))];
	                    case 1:
	                        conversationId = _a.sent();
	                        registration_1.registrationCallback(this.conversationSet, conversationId, function () { }, function () { })(undefined);
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        }); });
	    };
	    return TopicNotificationsImpl;
	}());
	exports.TopicNotificationsImpl = TopicNotificationsImpl;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Session.topicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(1403);
	var update_constraint_1 = __webpack_require__(343);
	var update_stream_factory_1 = __webpack_require__(1446);
	var logger = __webpack_require__(17);
	var log = logger.create('Session.TopicUpdate');
	/**
	 * An unconstrained topic constraint that is sent to the server when no other
	 * constraint has been specified.
	 */
	var unconstrained = new update_constraint_1.Unconstrained();
	/**
	 * The implementation of the {@link TopicUpdate} feature
	 */
	var TopicUpdateImpl = /** @class */ (function () {
	    /**
	     * Create a new instance of the TopicUpdate feature
	     *
	     * @param internal  the internal session
	     */
	    function TopicUpdateImpl(internal) {
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.SET_TOPIC = serviceLocator.obtain(Services.SET_TOPIC);
	        this.ADD_AND_SET_TOPIC = serviceLocator.obtain(Services.ADD_AND_SET_TOPIC);
	        this.APPLY_JSON_PATCH = serviceLocator.obtain(Services.APPLY_JSON_PATCH);
	        var streamServices = {
	            CREATE_UPDATE_STREAM: serviceLocator.obtain(Services.CREATE_UPDATE_STREAM),
	            CREATE_UPDATE_STREAM_AND_SET: serviceLocator.obtain(Services.CREATE_UPDATE_STREAM_AND_SET),
	            CHECK_UPDATE_STREAM: serviceLocator.obtain(Services.CHECK_UPDATE_STREAM),
	            STREAM_SET_TOPIC_SERVICE: serviceLocator.obtain(Services.STREAM_SET_TOPIC_SERVICE),
	            STREAM_APPLY_DELTA_SERVICE: serviceLocator.obtain(Services.STREAM_APPLY_DELTA_SERVICE),
	            STREAM_ADD_TOPIC_SERVICE: serviceLocator.obtain(Services.STREAM_ADD_TOPIC_SERVICE),
	            STREAM_ADD_AND_SET_TOPIC_SERVICE: serviceLocator.obtain(Services.STREAM_ADD_AND_SET_TOPIC_SERVICE)
	        };
	        this.updateStreamFactory = new update_stream_factory_1.UpdateStreamFactory(streamServices, internal.getContext());
	    }
	    /**
	     * Set topic value for an existing topic
	     *
	     * @param path        the path of the topic
	     * @param dataType    the type of the values
	     * @param value       the value. String, int64, and double topics accept
	     *                    `null`  or `undefined` , as described above.
	     *                    Using `null`   or `undefined`  with other
	     *                    topic types is an error and will throw an `Error` .
	     * @param constraint  the topic update constraint
	     * @return            a result that completes when the operation succeeds
	     */
	    TopicUpdateImpl.prototype.setTopic = function (path, dataType, value, constraint) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var TopicTypeEnum = _this.internal.getContext().TopicTypeEnum;
	            _this.SET_TOPIC.send({
	                path: path,
	                topicType: TopicTypeEnum[dataType.name().toUpperCase()],
	                value: dataType.toBytes(value).asBuffer(),
	                constraint: constraint
	            }, function (err) {
	                if (err) {
	                    log.debug('Set topic failed');
	                    reject(err);
	                }
	                else {
	                    resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Add a topic and set the topic value
	     *
	     * @param path           the path of the topic
	     * @param specification  the topic specification
	     * @param dataType       the type of the values
	     * @param value          the value. String, int64, and double topics accept
	     *                      `null`  or `undefined` , as described above.
	     *                       Using `null`   or `undefined`  with other
	     *                       topic types is an error and will throw an `Error` .
	     * @param constraint     the topic update constraint
	     * @return               a result that completes with the topic creation result
	     *                       when the operation succeeds
	     */
	    TopicUpdateImpl.prototype.addAndSetTopic = function (path, specification, dataType, value, constraint) {
	        var _this = this;
	        var TopicTypeEnum = this.internal.getContext().TopicTypeEnum;
	        if (specification.type !== TopicTypeEnum[dataType.name().toUpperCase()]
	            && specification.type !== TopicTypeEnum.TIME_SERIES) {
	            throw new Error('The specification and value have different data types');
	        }
	        var requestValue = dataType.toBytes(value).asBuffer();
	        return new Promise(function (resolve, reject) {
	            _this.ADD_AND_SET_TOPIC.send({
	                path: path,
	                topicSpecification: specification,
	                value: requestValue,
	                constraint: constraint
	            }, function (err, response) {
	                if (err) {
	                    log.debug('Add and set topic failed');
	                    reject(err);
	                }
	                else {
	                    resolve(response.result);
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicUpdateImpl.prototype.set = function (path, dataType, value, options) {
	        var constraint = (options !== undefined && options.constraint !== undefined)
	            ? options.constraint
	            : unconstrained;
	        if (options !== undefined && options.specification !== undefined) {
	            return this.addAndSetTopic(path, options.specification, dataType, value, constraint);
	        }
	        else {
	            return this.setTopic(path, dataType, value, constraint);
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicUpdateImpl.prototype.createUpdateStream = function (path, dataType, options) {
	        var constraint = (options !== undefined && options.constraint !== undefined)
	            ? options.constraint
	            : unconstrained;
	        if (options !== undefined && options.specification !== undefined) {
	            return this.updateStreamFactory.createUpdateStreamThatAddsTopic(path, options.specification, dataType, constraint);
	        }
	        else {
	            return this.updateStreamFactory.createUpdateStream(path, dataType, constraint);
	        }
	    };
	    TopicUpdateImpl.prototype.applyJsonPatch = function (path, patch, constraint) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.APPLY_JSON_PATCH.send({
	                path: path,
	                patch: typeof patch === 'string' ? patch : JSON.stringify(patch),
	                constraint: constraint ? constraint : unconstrained
	            }, function (err, response) {
	                if (err) {
	                    log.debug('Apply JSON patch failed');
	                    reject(err);
	                }
	                else {
	                    resolve(response);
	                }
	            });
	        });
	    };
	    return TopicUpdateImpl;
	}());
	exports.TopicUpdateImpl = TopicUpdateImpl;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicViews
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Services = __webpack_require__(1430);
	var named_topic_view_specification_1 = __webpack_require__(1436);
	var logger = __webpack_require__(17);
	var require_non_null_1 = __webpack_require__(22);
	var response_success_1 = __webpack_require__(68);
	var log = logger.create('TopicViews');
	/**
	 * Implementation of the {@link TopicView} feature
	 */
	var TopicViewsImpl = /** @class */ (function () {
	    /**
	     * Create a new instance of the TopicView feature
	     *
	     * @param internal  the internal session
	     */
	    function TopicViewsImpl(internal) {
	        this.internal = internal;
	        var serviceLocator = internal.getServiceLocator();
	        this.CREATE_TOPIC_VIEW = serviceLocator.obtain(Services.CREATE_TOPIC_VIEW);
	        this.LIST_TOPIC_VIEWS = serviceLocator.obtain(Services.LIST_TOPIC_VIEWS);
	        this.REMOVE_TOPIC_VIEW = serviceLocator.obtain(Services.REMOVE_TOPIC_VIEW);
	    }
	    /**
	     * @inheritdoc
	     */
	    TopicViewsImpl.prototype.createTopicView = function (name, specification) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (require_non_null_1.requireNonNull(name, 'name').length === 0) {
	                throw new Error("Topic View name cannot be empty");
	            }
	            if (_this.internal.checkConnected(reject)) {
	                var spec = new named_topic_view_specification_1.NamedTopicViewSpecification(name, require_non_null_1.requireNonNull(specification, 'specification'));
	                _this.CREATE_TOPIC_VIEW.send(spec, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                        log.debug('Create topic view failed');
	                    }
	                    else if (response.errors) {
	                        reject(response.errors.errors);
	                        log.debug('Create topic view failed');
	                    }
	                    else {
	                        resolve(response.view);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicViewsImpl.prototype.listTopicViews = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.LIST_TOPIC_VIEWS.send(null, function (err, response) {
	                    if (!response_success_1.responseSuccess(err, response)) {
	                        reject(err);
	                        log.debug('List topic views failed');
	                    }
	                    else {
	                        resolve(response.result);
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicViewsImpl.prototype.removeTopicView = function (name) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (_this.internal.checkConnected(reject)) {
	                _this.REMOVE_TOPIC_VIEW.send(require_non_null_1.requireNonNull(name, 'name'), function (err) {
	                    if (err) {
	                        reject(err);
	                        log.debug('Remove topic view failed');
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            }
	        });
	    };
	    return TopicViewsImpl;
	}());
	exports.TopicViewsImpl = TopicViewsImpl;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var datatypes_1 = __webpack_require__(78);
	var stream_1 = __webpack_require__(66);
	var fetch_request_1 = __webpack_require__(1219);
	var ValueStreamProxy = __webpack_require__(1223);
	var Services = __webpack_require__(541);
	var logger = __webpack_require__(17);
	var log = logger.create('Session');
	/**
	 * Implementation of the {@link Topics} feature
	 *
	 * {@link TopicsImpl} extends {@link StreamImpl} so that {@link SessionImpl}
	 * can extend directly from {@link TopicsImpl} without the need for multiple
	 * inheritance.
	 */
	var TopicsImpl = /** @class */ (function (_super) {
	    __extends(TopicsImpl, _super);
	    /**
	     * Create a new TopicsImpl instance
	     *
	     * @param internal  the internal session
	     */
	    function TopicsImpl(internal, helper, events) {
	        var _this = _super.call(this, helper, events) || this;
	        _this.internal = internal;
	        _this.UNSUBSCRIBE = internal.getServiceLocator().obtain(Services.UNSUBSCRIBE);
	        _this.SUBSCRIBE = internal.getServiceLocator().obtain(Services.SUBSCRIBE);
	        _this.streamRegistry = internal.getStreamRegistry();
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    TopicsImpl.prototype.unsubscribe = function (topic) {
	        var _this = this;
	        var selectors = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            selectors[_i - 1] = arguments[_i];
	        }
	        var args = arguments;
	        var parseSelector = this.internal.getContext().parseSelector;
	        return new Promise(function (resolve, reject) {
	            try {
	                var selector = (args.length > 1)
	                    ? parseSelector(Array.prototype.slice.call(args))
	                    : parseSelector(topic);
	                if (_this.internal.checkConnected(reject)) {
	                    var unsubscribeCallback = function (err) {
	                        if (err) {
	                            log.debug('Unsubscribe failed', topic);
	                            reject(err);
	                        }
	                        else {
	                            log.debug('Unsubscribe complete', topic);
	                            resolve();
	                        }
	                    };
	                    log.debug('Unsubscribing', topic);
	                    _this.UNSUBSCRIBE.send(selector, unsubscribeCallback);
	                }
	            }
	            catch (err) {
	                reject(err);
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicsImpl.prototype.fetchRequest = function () {
	        return new fetch_request_1.FetchRequestImpl(this.internal);
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicsImpl.prototype.select = function (topic) {
	        var _this = this;
	        var selectors = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            selectors[_i - 1] = arguments[_i];
	        }
	        var args = arguments;
	        var parseSelector = this.internal.getContext().parseSelector;
	        return new Promise(function (resolve, reject) {
	            log.debug('Subscribing', topic);
	            try {
	                var selector = (args.length > 1)
	                    ? parseSelector(Array.prototype.slice.call(args))
	                    : parseSelector(topic);
	                if (_this.internal.checkConnected(reject)) {
	                    _this.SUBSCRIBE.send(selector, function (err) {
	                        if (!err) {
	                            resolve();
	                        }
	                        else {
	                            reject(err);
	                        }
	                    });
	                }
	            }
	            catch (err) {
	                reject(err);
	            }
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicsImpl.prototype.addStream = function (topic, datatype) {
	        if (arguments.length !== 2) {
	            throw new Error('Both topic selector and value type are needed');
	        }
	        if (!datatype || datatypes_1.DataTypes.get(datatype)) {
	            throw new Error('Data type required');
	        }
	        var selector = this.internal.getContext().parseSelector(topic);
	        return ValueStreamProxy.create(this.streamRegistry, datatype, false, selector);
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicsImpl.prototype.addFallbackStream = function (datatype) {
	        if (!datatype || datatypes_1.DataTypes.get(datatype)) {
	            throw new Error('Data type required');
	        }
	        return ValueStreamProxy.create(this.streamRegistry, datatype, true);
	    };
	    return TopicsImpl;
	}(stream_1.StreamImpl));
	exports.TopicsImpl = TopicsImpl;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module FetchRequest
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var fetch_request_1 = __webpack_require__(551);
	var topic_type_1 = __webpack_require__(69);
	var any_datatype_1 = __webpack_require__(227);
	var fetch_result_1 = __webpack_require__(1220);
	var fetch_query_1 = __webpack_require__(1295);
	var Services = __webpack_require__(541);
	var logger = __webpack_require__(17);
	var math_1 = __webpack_require__(104);
	var response_success_1 = __webpack_require__(68);
	var log = logger.create('Fetch Request');
	/**
	 * A fetch range limit
	 */
	var Limit = /** @class */ (function () {
	    /**
	     * Create a new Limit instance
	     *
	     * @param  path          the limiting path
	     * @param  includesPath  a flag indicating whether the limiting path is
	     *                       included in the range
	     */
	    function Limit(path, includesPath) {
	        this.path = path;
	        this.includesPath = includesPath;
	    }
	    return Limit;
	}());
	exports.Limit = Limit;
	/**
	 * A fetch request topic range
	 */
	var FetchRange = /** @class */ (function () {
	    /**
	     * Create a new FetchRange instance
	     *
	     * @param  from  the lower limit of the range
	     * @param  to    the upper limit of the range
	     */
	    function FetchRange(from, to) {
	        this.from = from;
	        this.to = to;
	    }
	    /**
	     * Check if the range is unbounded
	     *
	     * @return  `true` if no limits are set
	     */
	    FetchRange.prototype.isUnbounded = function () {
	        return this.from === undefined && this.to === undefined;
	    };
	    return FetchRange;
	}());
	exports.FetchRange = FetchRange;
	/**
	 * Indicates whether a specified topic type can be read as a specified
	 * data type.
	 *
	 * @param topicType the topic type
	 * @param dataType the data type
	 *
	 * @returns true if the topic type can be read as the data type
	 */
	function canReadAs(dataTypes, topicType, dataType) {
	    if (topicType === topic_type_1.TopicTypeEnum.TIME_SERIES) {
	        return fetch_result_1.TIME_SERIES_DATA_TYPE.canReadAs(dataType);
	    }
	    else {
	        var topicDataType = dataTypes.getByValue(topicType);
	        // tslint:disable-next-line:strict-type-predicates
	        return topicDataType !== null && dataType.valueClass !== undefined
	            && topicDataType.canReadAs(dataType.valueClass);
	    }
	}
	function requireNonNegative(n, parameter) {
	    if (!Number.isInteger(n) || n < 0) {
	        throw new Error("Invalid argument " + parameter + ": " + n);
	    }
	    return n;
	}
	/**
	 * Implementation of the {@link FetchRequest} builder interface
	 */
	var FetchRequestImpl = /** @class */ (function (_super) {
	    __extends(FetchRequestImpl, _super);
	    /**
	     * Create a new FetchRequestImpl instance
	     *
	     * @param internal  the internal session
	     * @param opts      the internal options specifying what to fetch
	     */
	    function FetchRequestImpl(internal, opts) {
	        var _this = _super.call(this) || this;
	        var defaultOptions = {
	            range: new FetchRange(),
	            topicTypes: fetch_request_1.FetchRequest.getAllTypes(),
	            dataType: undefined,
	            withProperties: false,
	            limit: math_1.MAX_INT32,
	            maximumResultSize: internal.getOptions().maxMessageSize,
	            deepBranchDepth: math_1.MAX_INT32,
	            deepBranchLimit: math_1.MAX_INT32,
	            withUnpublishedDelayedTopics: false
	        };
	        _this.internal = internal;
	        _this.options = Object.assign(defaultOptions, opts);
	        return _this;
	    }
	    /**
	     * Deep copy the options into a new {@link FetchRequestOptions} instance
	     *
	     * @return  the new options instance
	     */
	    FetchRequestImpl.prototype.copyOptions = function () {
	        return {
	            range: new FetchRange(this.options.range.from, this.options.range.to),
	            topicTypes: new Set(this.options.topicTypes),
	            dataType: this.options.dataType,
	            withProperties: this.options.withProperties,
	            limit: this.options.limit,
	            maximumResultSize: this.options.maximumResultSize,
	            deepBranchDepth: this.options.deepBranchDepth,
	            deepBranchLimit: this.options.deepBranchLimit,
	            withUnpublishedDelayedTopics: this.options.withUnpublishedDelayedTopics
	        };
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.from = function (topicPath) {
	        var limit = new Limit(topicPath, true);
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { range: new FetchRange(limit, this.options.range.to) }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.after = function (topicPath) {
	        var limit = new Limit(topicPath, false);
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { range: new FetchRange(limit, this.options.range.to) }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.to = function (topicPath) {
	        var limit = new Limit(topicPath, true);
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { range: new FetchRange(this.options.range.from, limit) }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.before = function (topicPath) {
	        var limit = new Limit(topicPath, false);
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { range: new FetchRange(this.options.range.from, limit) }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.topicTypes = function (topicTypes) {
	        var _this = this;
	        if (Array.isArray(topicTypes)) {
	            topicTypes = new Set(topicTypes);
	        }
	        if (topicTypes.size === 0) {
	            throw new Error('No types specified');
	        }
	        var allTypes = fetch_request_1.FetchRequest.getAllTypes();
	        var context = this.internal.getContext();
	        // ensure that those supplied are valid and if there is a value
	        // class that the types can be read as the value class.
	        topicTypes.forEach(function (topicType) {
	            if (!allTypes.has(topicType)) {
	                // tslint:disable-next-line:deprecation
	                throw new Error("Invalid topic type " + topicType.id);
	            }
	            if (_this.options.dataType !== undefined
	                && !canReadAs(context.DataTypes, topicType, _this.options.dataType)
	                && topicType !== context.TopicTypeEnum.TIME_SERIES) {
	                // tslint:disable-next-line:deprecation
	                throw new Error("Topic type " + topicType.id + " cannot be read as " + _this.options.dataType);
	            }
	        });
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { topicTypes: topicTypes }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.withValues = function (dataType) {
	        var _this = this;
	        var selectedTopicTypes;
	        if (dataType !== undefined && !(dataType instanceof any_datatype_1.AnyDataTypeImpl)) {
	            selectedTopicTypes = new Set(this.options.topicTypes);
	            this.options.topicTypes.forEach(function (topicType) {
	                if (!canReadAs(_this.internal.getContext().DataTypes, topicType, dataType)) {
	                    selectedTopicTypes.delete(topicType);
	                }
	            });
	            if (selectedTopicTypes.size === 0) {
	                throw new Error("No selected topic types can be read as " + dataType);
	            }
	        }
	        else {
	            selectedTopicTypes = this.options.topicTypes;
	        }
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { topicTypes: selectedTopicTypes, dataType: dataType }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.withProperties = function () {
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { withProperties: true }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.first = function (count) {
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { limit: requireNonNegative(count, 'count') }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.last = function (count) {
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { limit: 0 - requireNonNegative(count, 'count') }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.maximumResultSize = function (maximumSize) {
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), {
	            maximumResultSize: Math.min(requireNonNegative(maximumSize, 'maximumSize'), this.internal.getOptions().maxMessageSize)
	        }));
	    };
	    FetchRequestImpl.prototype.limitDeepBranches = function (deepBranchDepth, deepBranchLimit) {
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), {
	            deepBranchDepth: requireNonNegative(deepBranchDepth, 'deepBranchDepth'),
	            deepBranchLimit: requireNonNegative(deepBranchLimit, 'deepBranchLimit'),
	        }));
	    };
	    FetchRequestImpl.prototype.withUnpublishedDelayedTopics = function () {
	        return new FetchRequestImpl(this.internal, Object.assign(this.copyOptions(), { withUnpublishedDelayedTopics: true }));
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchRequestImpl.prototype.fetch = function (topics) {
	        var _this = this;
	        var extraTopics = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            extraTopics[_i - 1] = arguments[_i];
	        }
	        var parseSelector = this.internal.getContext().parseSelector;
	        var serviceLocator = this.internal.getServiceLocator();
	        var FETCH_QUERY = serviceLocator.obtain(Services.FETCH_QUERY);
	        var selector = (arguments.length > 1)
	            ? parseSelector(Array.prototype.slice.call(arguments))
	            : parseSelector(topics);
	        var query = new fetch_query_1.FetchQuery(selector, this.options.range, this.options.topicTypes, this.options.dataType !== undefined, this.options.withProperties, this.options.limit, this.options.maximumResultSize, this.options.deepBranchDepth, this.options.deepBranchLimit, this.options.withUnpublishedDelayedTopics);
	        return new Promise(function (resolve, reject) {
	            FETCH_QUERY.send(query, function (err, fetchQueryResult) {
	                if (!response_success_1.responseSuccess(err, fetchQueryResult)) {
	                    log.debug('Fetch query failed');
	                    reject(err);
	                }
	                else {
	                    var fetchResult = new fetch_result_1.FetchResultImpl(_this.options.dataType, fetchQueryResult, _this.internal.getContext());
	                    resolve(fetchResult);
	                }
	            });
	        });
	    };
	    return FetchRequestImpl;
	}(fetch_request_1.FetchRequest));
	exports.FetchRequestImpl = FetchRequestImpl;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module FetchRequest
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var any_datatype_1 = __webpack_require__(227);
	var topic_result_1 = __webpack_require__(1221);
	var time_series_event_datatype_1 = __webpack_require__(179);
	exports.TIME_SERIES_DATA_TYPE = time_series_event_datatype_1.TimeSeriesEventDataType.create({
	    name: function () { return 'event data type'; },
	    readValue: function (buffer) { return buffer; },
	    toBytes: function (val) { return val; }
	});
	/**
	 * Implementation of the FetchResult interface
	 */
	var FetchResultImpl = /** @class */ (function () {
	    /**
	     * Create a new FetchResultImpl instance
	     *
	     * @param dataType  the datatype of the results
	     * @param result    the results
	     */
	    function FetchResultImpl(dataType, result, context) {
	        this.resultList = result.results.map(function (topicResult) {
	            var value;
	            // only set a value if there is one in the FetchTopicResult
	            if (topicResult.value !== undefined) {
	                if (topicResult.type === context.TopicTypeEnum.TIME_SERIES) {
	                    var event_1 = exports.TIME_SERIES_DATA_TYPE.readAs(exports.TIME_SERIES_DATA_TYPE.valueClass, topicResult.value);
	                    if (dataType instanceof context.TimeSeriesEventDataType || dataType instanceof any_datatype_1.AnyDataTypeImpl) {
	                        value = event_1;
	                    }
	                    else {
	                        value = dataType.readAs(dataType.valueClass, event_1.value);
	                    }
	                }
	                else {
	                    var topicDataType = context.DataTypes.get(topicResult.type);
	                    value = topicDataType.readAs(dataType.valueClass, topicResult.value);
	                }
	            }
	            return new topic_result_1.TopicResultImpl(topicResult.path, topicResult.type, value, result.properties.length === 0 ? {} :
	                result.properties[topicResult.propertiesIndex]);
	        });
	        this.hasMoreFlag = result.hasMore;
	    }
	    /**
	     * @inheritdoc
	     */
	    FetchResultImpl.prototype.results = function () {
	        return this.resultList;
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchResultImpl.prototype.hasMore = function () {
	        return this.hasMoreFlag;
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchResultImpl.prototype.size = function () {
	        return this.resultList.length;
	    };
	    /**
	     * @inheritdoc
	     */
	    FetchResultImpl.prototype.isEmpty = function () {
	        return this.resultList.length === 0;
	    };
	    return FetchResultImpl;
	}());
	exports.FetchResultImpl = FetchResultImpl;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module FetchRequest
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_specification_1 = __webpack_require__(238);
	/**
	 * Implementation of the TopicResult interface
	 */
	var TopicResultImpl = /** @class */ (function () {
	    /**
	     * Create a new TopicResultImpl instance
	     *
	     * @param path        the topic path
	     * @param type        the topic type
	     * @param value       the value if one was requested
	     * @param properties  the topic properties
	     */
	    function TopicResultImpl(path, type, value, properties) {
	        this.mPath = path;
	        this.mType = type;
	        this.mValue = value;
	        this.mProperties = properties;
	    }
	    /**
	     * @inheritdoc
	     */
	    TopicResultImpl.prototype.path = function () {
	        return this.mPath;
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicResultImpl.prototype.type = function () {
	        return this.mType;
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicResultImpl.prototype.value = function () {
	        return this.mValue;
	    };
	    /**
	     * @inheritdoc
	     */
	    TopicResultImpl.prototype.specification = function () {
	        return new topic_specification_1.TopicSpecification(this.mType, this.mProperties);
	    };
	    return TopicResultImpl;
	}());
	exports.TopicResultImpl = TopicResultImpl;


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module ValueStream
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var datatypes_1 = __webpack_require__(78);
	var time_series_event_1 = __webpack_require__(340);
	/**
	 * Adapter for transforming the type of the emitted value to the datatype of
	 * the ValueStream.
	 */
	var ValueStreamAdapterBase = /** @class */ (function () {
	    /**
	     * Create a new ValueStreamAdapter instance
	     *
	     * @param stream        the stream that is wrapped
	     * @param datatype      the data type of the value stream
	     * @param topictype     the topic type
	     */
	    function ValueStreamAdapterBase(stream, datatype, topicSpec) {
	        this.stream = stream;
	        this.datatype = datatype;
	        this.sourceDatatype = this.getSourceDataType(topicSpec);
	    }
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.selects = function (specification) {
	        return this.stream.selects(specification);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.onOpen = function () {
	        return this.stream.onOpen();
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.onDelta = function (path, specification, oldContent, content, delta, oldValue, newValue) {
	        return this.stream.onDelta(path, specification, oldContent, content, delta, (oldContent !== null) ? this.readAsDataType(oldContent, oldValue) : null, this.readAsDataType(content, newValue));
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.onValue = function (path, specification, oldContent, content, oldValue, newValue) {
	        return this.stream.onValue(path, specification, oldContent, content, (oldContent !== null) ? this.readAsDataType(oldContent, oldValue) : null, this.readAsDataType(content, newValue));
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.onSubscription = function (path, specification) {
	        return this.stream.onSubscription(path, specification);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.onUnsubscription = function (path, specification, reason) {
	        return this.stream.onUnsubscription(path, specification, reason);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapterBase.prototype.onSubscriptionError = function (error) {
	        return this.stream.onSubscriptionError(error);
	    };
	    return ValueStreamAdapterBase;
	}());
	exports.ValueStreamAdapterBase = ValueStreamAdapterBase;
	/**
	 * Adapter for transforming the type of the emitted value to the datatype of
	 * the ValueStream.
	 */
	var ValueStreamAdapter = /** @class */ (function (_super) {
	    __extends(ValueStreamAdapter, _super);
	    /**
	     * Create a new ValueStreamAdapter instance
	     *
	     * @param stream        the stream that is wrapped
	     * @param datatype      the data type of the value stream
	     * @param topicSpec     the topic type information
	     */
	    function ValueStreamAdapter(stream, datatype, topicSpec) {
	        return _super.call(this, stream, datatype, topicSpec) || this;
	    }
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapter.prototype.getSourceDataType = function (topicSpec) {
	        return datatypes_1.DataTypes.getByValue(topicSpec.type);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamAdapter.prototype.readAsDataType = function (buffer) {
	        return this.sourceDatatype.readAs(this.datatype.valueClass, buffer);
	    };
	    return ValueStreamAdapter;
	}(ValueStreamAdapterBase));
	exports.ValueStreamAdapter = ValueStreamAdapter;
	var ValueStreamTimeseriesAdapter = /** @class */ (function (_super) {
	    __extends(ValueStreamTimeseriesAdapter, _super);
	    /**
	     * Create a new ValueStreamTimeseriesAdapter instance
	     *
	     * @param stream        the stream that is wrapped
	     * @param datatype      the data type of the value stream
	     * @param topicSpec     the topic type information
	     */
	    function ValueStreamTimeseriesAdapter(stream, datatype, topicSpec) {
	        var _this = _super.call(this, stream, datatype, topicSpec) || this;
	        _this.sourceValuetype = datatypes_1.DataTypes.getByName(_this.sourceDatatype.valueTypeName);
	        _this.destValuetype = datatypes_1.DataTypes.getByName(_this.datatype.valueTypeName);
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    ValueStreamTimeseriesAdapter.prototype.getSourceDataType = function (topicSpec) {
	        return datatypes_1.DataTypes.timeseries(datatypes_1.DataTypes.getByName(topicSpec.properties.TIME_SERIES_EVENT_VALUE_TYPE));
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamTimeseriesAdapter.prototype.readAsDataType = function (buffer, sourceEvent) {
	        var destValue = this.sourceValuetype.readAs(this.destValuetype.valueClass, this.sourceValuetype.writeValue(sourceEvent.value));
	        return new time_series_event_1.EventImpl(sourceEvent.metadata, sourceEvent.originalEvent, destValue);
	    };
	    return ValueStreamTimeseriesAdapter;
	}(ValueStreamAdapterBase));
	exports.ValueStreamTimeseriesAdapter = ValueStreamTimeseriesAdapter;
	var ValueStreamTimeseriesToPrimitiveAdapter = /** @class */ (function (_super) {
	    __extends(ValueStreamTimeseriesToPrimitiveAdapter, _super);
	    /**
	     * Create a new ValueStreamTimeseriesAdapter instance
	     *
	     * @param stream        the stream that is wrapped
	     * @param datatype      the data type of the value stream
	     * @param topicSpec     the topic type information
	     */
	    function ValueStreamTimeseriesToPrimitiveAdapter(stream, datatype, topicSpec) {
	        var _this = _super.call(this, stream, datatype, topicSpec) || this;
	        _this.sourceValuetype = datatypes_1.DataTypes.getByName(_this.sourceDatatype.valueTypeName);
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    ValueStreamTimeseriesToPrimitiveAdapter.prototype.getSourceDataType = function (topicSpec) {
	        return datatypes_1.DataTypes.timeseries(datatypes_1.DataTypes.getByName(topicSpec.properties.TIME_SERIES_EVENT_VALUE_TYPE));
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamTimeseriesToPrimitiveAdapter.prototype.readAsDataType = function (buffer, sourceEvent) {
	        return this.sourceValuetype.readAs(this.datatype.valueClass, this.sourceValuetype.writeValue(sourceEvent.value));
	    };
	    return ValueStreamTimeseriesToPrimitiveAdapter;
	}(ValueStreamAdapterBase));
	exports.ValueStreamTimeseriesToPrimitiveAdapter = ValueStreamTimeseriesToPrimitiveAdapter;


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module ValueStream
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var datatypes_1 = __webpack_require__(78);
	var emitter_1 = __webpack_require__(79);
	var value_stream_1 = __webpack_require__(1224);
	var value_stream_adapter_1 = __webpack_require__(1222);
	var time_series_event_datatype_1 = __webpack_require__(179);
	var selector_set_1 = __webpack_require__(546);
	var topic_type_1 = __webpack_require__(69);
	/**
	 * Internal proxy for Subscriptions with an underlying datatype.
	 */
	var ValueStreamProxy = /** @class */ (function () {
	    /**
	     * Create a new ValueStreamProxy interface
	     *
	     * @param registry  the stream registry
	     * @param selector  the topic selector
	     * @param datatype  the data type of the value stream
	     * @param fallback  whether this is a fallback stream or not
	     */
	    function ValueStreamProxy(registry, selector, datatype, fallback, subscriptionFactory, adapterFactory) {
	        var _this = this;
	        /**
	         * Flag indicating that the stream has not yet been added to the stream registry
	         */
	        this.pending = true;
	        var factory = emitter_1.Emitter.create();
	        this.subscription = subscriptionFactory(factory, selector);
	        this.emitter = factory.emitter(this.subscription);
	        this.subscription.on('close', function () {
	            registry.remove(_this);
	        });
	        this.adapterFactory = adapterFactory;
	        this.datatype = datatype;
	        this.registry = registry;
	        var onEvent = this.subscription.on.bind(this.subscription);
	        // monkey-patch so that we will only register this stream if it is subsequently used
	        this.subscription.on = function (event, fn) {
	            var stream = onEvent(event, fn);
	            if (_this.pending) {
	                if (fallback) {
	                    registry.addFallback(_this, datatype);
	                }
	                else {
	                    registry.add(selector, _this, datatype);
	                }
	                _this.pending = false;
	            }
	            return stream;
	        };
	    }
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.selects = function (specification) {
	        if (specification) {
	            if (specification.type === topic_type_1.TopicTypeEnum.TIME_SERIES) {
	                var eventType = datatypes_1.DataTypes.get(specification.properties.TIME_SERIES_EVENT_VALUE_TYPE);
	                var dataType = this.datatype instanceof time_series_event_datatype_1.TimeSeriesEventDataType
	                    ? datatypes_1.DataTypes.get(this.datatype.valueTypeName)
	                    : this.datatype;
	                return !!eventType && eventType.canReadAs(dataType.valueClass);
	            }
	            else {
	                return datatypes_1.DataTypes.getByValue(specification.type)
	                    .canReadAs(this.datatype.valueClass);
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.adapter = function (specification) {
	        if ((specification.type === topic_type_1.TopicTypeEnum.TIME_SERIES
	            && this.datatype.valueTypeName === specification.properties.TIME_SERIES_EVENT_VALUE_TYPE)
	            || specification.type === topic_type_1.TopicTypeEnum[this.datatype.name().toUpperCase()]
	            || this.datatype.name() === 'any') {
	            return this;
	        }
	        else {
	            return this.adapterFactory(this, this.datatype, specification);
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.onOpen = function () {
	        this.emitter.emit('open', this.subscription);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.onDelta = function (path, specification, oldContent, content, delta, oldValue, newValue) {
	        this.emitter.emit('value', path, specification, newValue, oldValue);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.onValue = function (path, specification, oldContent, content, oldValue, newValue) {
	        this.emitter.emit('value', path, specification, newValue, oldValue);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.onSubscription = function (path, specification) {
	        this.emitter.emit('subscribe', path, specification);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.onUnsubscription = function (path, specification, reason) {
	        this.emitter.emit('unsubscribe', path, specification, reason);
	    };
	    /**
	     * @inheritdoc
	     */
	    ValueStreamProxy.prototype.onSubscriptionError = function (error) {
	        this.emitter.error(error);
	        this.registry.remove(this);
	    };
	    return ValueStreamProxy;
	}());
	exports.ValueStreamProxy = ValueStreamProxy;
	var FALLBACK_SELECTOR = new selector_set_1.SelectorSet([]);
	/**
	 * Factory function for creating a new ValueStreamProxy interface
	 *
	 * @param registry  the stream registry
	 * @param selector  the topic selector
	 * @param datatype  the data type of the value stream
	 * @param fallback  whether this is a fallback stream or not
	 */
	function create(registry, datatype, fallback, selector) {
	    if (selector === void 0) { selector = FALLBACK_SELECTOR; }
	    var proxy = new ValueStreamProxy(registry, selector, datatype, fallback, function (factory, topicSelector) {
	        return new value_stream_1.ValueStreamImpl(factory, topicSelector);
	    }, function (stream, streamDatatype, topicSpec) { return (datatype instanceof time_series_event_datatype_1.TimeSeriesEventDataType
	        ? new value_stream_adapter_1.ValueStreamTimeseriesAdapter(stream, streamDatatype, topicSpec)
	        : topicSpec.type === topic_type_1.TopicTypeEnum.TIME_SERIES
	            ? new value_stream_adapter_1.ValueStreamTimeseriesToPrimitiveAdapter(stream, streamDatatype, topicSpec)
	            : new value_stream_adapter_1.ValueStreamAdapter(stream, streamDatatype, topicSpec)); });
	    return proxy.subscription;
	}
	exports.create = create;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module ValueStream
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var stream_1 = __webpack_require__(66);
	/**
	 * Implementation of a value stream
	 */
	var ValueStreamImpl = /** @class */ (function (_super) {
	    __extends(ValueStreamImpl, _super);
	    /**
	     * Create a new ValueStreamImpl instance
	     *
	     * @param emitterFactory  an emitter factory. Events are emitted on the stream
	     *                        by the {@link ValueStreamProxy}
	     * @param selector        the topic selector
	     */
	    function ValueStreamImpl(emitterFactory, selector) {
	        var _this = _super.call(this, emitterFactory) || this;
	        _this.selector = selector;
	        return _this;
	    }
	    return ValueStreamImpl;
	}(stream_1.StreamImpl));
	exports.ValueStreamImpl = ValueStreamImpl;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module MessageQueue
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var array_1 = __webpack_require__(345);
	var function_1 = __webpack_require__(89);
	var math_1 = __webpack_require__(104);
	/**
	 * How many bits of a timestamp to discard. The default rounds to approximately 1 second.
	 *
	 * @see {@link roundTimeStamp}
	 */
	var TIMESTAMP_ROUNDING = 10;
	/**
	 * Reduce the accuracy of a timestamp
	 *
	 * @param  timestamp  the time stamp to round
	 * @return            the reduced accuracy time stamp
	 */
	function roundTimeStamp(timestamp) {
	    /* tslint:disable-next-line:no-bitwise */
	    return timestamp >> TIMESTAMP_ROUNDING;
	}
	/**
	 * Apply a bitmask to a number to calculate the modulo of a power of two. This
	 * is used to determine the position in a circular buffer
	 *
	 * @param  p        the number to mask
	 * @param  capacity the capacity, must be a power of two
	 * @return          the reduced value
	 */
	function mask(p, capacity) {
	    /* tslint:disable-next-line:no-bitwise */
	    return p & capacity - 1;
	}
	/**
	 * Port of the Java RecoveryBuffer implementation, with a bounded number of entries.
	 *
	 * Timestamps are recorded in a timestamp index. The timestamp index also has a
	 * fixed upper size bound.
	 *
	 * This implementation expects timestamp parameters in milliseconds. It rounds
	 * timestamps to reduce the required index size and the number of index updates.
	 *
	 * The recovery buffer is implemented as a bounded circular buffer of
	 * (timestamp, messages index) pairs. Each entry states that messages with
	 * earlier indexes than its index were added at its timestamp or earlier. This
	 * serves to timestamp ranges of {@link .messages}, allowing us to flush stale
	 * entries.
	 *
	 * Each call to markTime adds an entry, possibly evicting messages referred to
	 * by an older entry for which there is no longer room.
	 *
	 *
	 * Some invariants:
	 * * Valid entries have a pair of values at the same index in the timestamps &
	 *   indicies arrays. The index is in the range `[timesHead, timesTail)`.
	 * * `indices[timesHead] == -1` <=> the timestamp index is empty.
	 * * `timesHead == timesTail` <=> either the timestamp index is empty, or
	 *   `indices[timesHead] >= 0` and the timestamp index isfull.
	 * * `size == 0` => the timestamp index is empty.
	 * * For each valid entry at index `i`, `indices[i] >= 0` and is either equal to
	 *   tail or points to a non-null entry in messages.
	 * * No entry points to the head of messages, i.e. the message at tail - size.
	 * * Later entries have a messages index that is at least as great (modulo
	 *   messages.length) as earlier entries.
	 *
	 * @author Peter Hughes
	 * @since 5.8
	 */
	var RecoveryBuffer = /** @class */ (function () {
	    /**
	     * Create a RecoveryBuffer
	     *
	     * @param  minimumMessages   the minimum number of messages
	     * @param  minimumTimeIndex  the minimum number of time indices
	     */
	    function RecoveryBuffer(minimumMessages, minimumTimeIndex) {
	        this.messagesLength = math_1.findNextPowerOfTwo(minimumMessages);
	        this.indexCapacity = math_1.findNextPowerOfTwo(minimumTimeIndex);
	        this.messagesMask = function_1.curryR(mask, this.messagesLength);
	        this.indexMask = function_1.curryR(mask, this.indexCapacity);
	        this.messages = array_1.ofSize(this.messagesLength);
	        this.indices = array_1.ofSize(this.indexCapacity, -1);
	        this.times = array_1.ofSize(this.indexCapacity);
	        this.timesHead = 0;
	        this.timesTail = 0;
	        this.messagesTail = this.messagesMask(0);
	        this.messagesSize = 0;
	    }
	    /**
	     * Get the number of messages
	     *
	     * @return  the number of messages that can be recovered
	     */
	    RecoveryBuffer.prototype.size = function () {
	        return this.messagesSize;
	    };
	    /**
	     * Add a message to the buffer. If the buffer is full, the oldest message is discarded
	     *
	     * @param message  the message
	     */
	    RecoveryBuffer.prototype.put = function (message) {
	        this.messages[this.messagesTail] = message;
	        this.messagesTail = this.messagesMask(this.messagesTail + 1);
	        if (this.messagesSize < this.messagesLength) {
	            this.messagesSize = this.messagesSize + 1;
	        }
	        else {
	            while (this.indices[this.timesHead] === this.messagesTail) {
	                this.indices[this.timesHead] = -1;
	                this.timesHead = this.indexMask(this.timesHead + 1);
	            }
	        }
	    };
	    /**
	     * If there are at least N messages in the buffer, pass the N most recent
	     * messages to the consumer function and return true. Otherwise return
	     * false.
	     *
	     * This is a non-destructive operation.
	     *
	     * @param n        the number of messages to recover
	     * @param consumer the consumer function to be called with recovered messages (in order)
	     * @returns        `false` if there are not N messages, in which case consumer will not be called.
	     */
	    RecoveryBuffer.prototype.recover = function (n, consumer) {
	        if (n < 0 || n > this.messagesSize) {
	            return false;
	        }
	        // this differs from the Java implementation, since we want to return messages in the order they were added
	        for (var i = n; i >= 1; --i) {
	            consumer(this.messages[this.messagesMask(this.messagesTail - i)]);
	        }
	        return true;
	    };
	    /**
	     * Clears this buffer
	     */
	    RecoveryBuffer.prototype.clear = function () {
	        array_1.fill(this.messages, null);
	        array_1.fill(this.indices, -1);
	        this.timesHead = 0;
	        this.timesTail = 0;
	        this.messagesSize = 0;
	    };
	    /**
	     * Remove elements from the buffer
	     *
	     * @param the new index of the messages head in the circular buffer
	     */
	    RecoveryBuffer.prototype.removeElements = function (newElementsHead) {
	        var messagesHead = this.messagesMask(this.messagesTail - this.messagesSize);
	        var newSize;
	        if (messagesHead < newElementsHead) {
	            array_1.fill(this.messages, null, messagesHead, newElementsHead);
	            newSize = this.messagesSize - newElementsHead + messagesHead;
	        }
	        else if (messagesHead > newElementsHead) {
	            array_1.fill(this.messages, null, messagesHead, this.messagesLength);
	            array_1.fill(this.messages, null, 0, newElementsHead);
	            newSize = this.messagesSize - messagesHead + newElementsHead;
	        }
	        else {
	            array_1.fill(this.messages, null);
	            newSize = 0;
	        }
	        this.messagesSize = newSize;
	    };
	    /**
	     * Inform this recovery buffer of the current timestamp. Subsequent messages
	     * put in the buffer are recorded as older than this timestamp.
	     *
	     * @param newElementsHead a timestamp, typically "unix time".
	     *                        Larger values are later. The value does not
	     *                        matter, so long as the sequence is consistently
	     *                        used in calls to markTime and flush.
	     */
	    RecoveryBuffer.prototype.markTime = function (timestamp) {
	        if (this.messagesSize > 0) {
	            var h = this.timesHead;
	            var t = this.timesTail;
	            var firstIndex = this.indices[h];
	            var roundedTimestamp = roundTimeStamp(timestamp);
	            if (firstIndex >= 0) {
	                var indexLast = this.indexMask(t - 1);
	                if (this.indices[indexLast] === this.messagesTail) {
	                    return;
	                }
	                if (this.times[indexLast] === roundedTimestamp) {
	                    this.indices[indexLast] = this.messagesTail;
	                    return;
	                }
	            }
	            this.timesTail = this.indexMask(t + 1);
	            this.times[t] = roundedTimestamp;
	            this.indices[t] = this.messagesTail;
	            if (h === t && firstIndex >= 0) {
	                this.removeElements(firstIndex);
	                this.timesHead = this.timesTail;
	            }
	        }
	    };
	    /**
	     * Remove all elements added at or before the timestamp.
	     *
	     * @param timestamp the timestamp. Follows the same properties as used in
	     *                  RecoveryBuffer#markTime
	     */
	    RecoveryBuffer.prototype.flush = function (timestamp) {
	        // due to time adjustments, there is no guarantee that a timestamp
	        // supplied to markTime is later than a previous value. Treat
	        // a more recently supplied timestamp as more accurate, iterate
	        // from the tail of the index until we cross the threshold, and
	        // flush everything else.
	        if (this.messagesSize === 0 || this.indices[this.timesHead] < 0) {
	            return;
	        }
	        var i = this.timesTail;
	        var roundedTimestamp = roundTimeStamp(timestamp);
	        do {
	            var previousI = i;
	            i = this.indexMask(i - 1);
	            if (this.times[i] <= roundedTimestamp) {
	                this.removeElements(this.indices[i]);
	                if (this.timesHead <= previousI) {
	                    array_1.fill(this.indices, -1, this.timesHead, previousI);
	                }
	                else {
	                    array_1.fill(this.indices, -1, this.timesHead, this.indexCapacity);
	                    array_1.fill(this.indices, -1, 0, previousI);
	                }
	                this.timesHead = previousI;
	                return;
	            }
	        } while (i !== this.timesHead);
	    };
	    return RecoveryBuffer;
	}());
	exports.RecoveryBuffer = RecoveryBuffer;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Protocol
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(336);
	/**
	 * Create a connection request with provided options
	 */
	function connect() {
	    return {
	        type: consts_1.PROTOCOL.TYPE,
	        version: consts_1.PROTOCOL.CURRENT_VERSION,
	        capabilities: consts_1.PROTOCOL.CAPABILITIES
	    };
	}
	exports.connect = connect;
	/**
	 * Create a reconnection request with provided options
	 *
	 * @param  token                    the session token
	 * @param  availableClientSequence  the available client sequence number
	 * @param  lastServerSequence       the last server sequence number
	 * @return                          a new reconnection request
	 */
	function reconnect(token, availableClientSequence, lastServerSequence) {
	    return Object.assign(connect(), {
	        token: token,
	        availableClientSequence: availableClientSequence,
	        lastServerSequence: lastServerSequence
	    });
	}
	exports.reconnect = reconnect;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Arrays = __webpack_require__(345);
	var error_reason_1 = __webpack_require__(88);
	/**
	 * Internal registry for Subscription streams.
	 */
	var StreamRegistryImpl = /** @class */ (function () {
	    /**
	     * Create a new StreamRegistry instance
	     *
	     * @param topicCache  the topic cache
	     */
	    function StreamRegistryImpl(topicCache) {
	        /**
	         * The stream adapters organised by the topic selector
	         */
	        this.streams = new Map();
	        /**
	         * The fallback stream adapters
	         */
	        this.fallbacks = [];
	        this.topicCache = topicCache;
	    }
	    /**
	     * Add a stream to the registry
	     *
	     * @param selector  the topic selector
	     * @param stream    the stream adapter to add
	     */
	    StreamRegistryImpl.prototype.add = function (selector, stream) {
	        var existing = this.streams.get(selector);
	        if (existing) {
	            existing.push(stream);
	        }
	        else {
	            this.streams.set(selector, [stream]);
	        }
	        this.topicCache.newStream(selector, stream, this);
	        stream.onOpen();
	    };
	    /**
	     * Add a fallback stream to the registry
	     *
	     * @param stream    the stream adapter to add
	     */
	    StreamRegistryImpl.prototype.addFallback = function (stream) {
	        this.fallbacks.push(stream);
	    };
	    /**
	     * Get the fallback stream for a given topic specification
	     *
	     * @param  specification  the topic specification
	     * @return                an array of stream adapters that select the topic
	     *                        specification
	     */
	    StreamRegistryImpl.prototype.getFallbacks = function (specification) {
	        return this.fallbacks.filter(function (fallback) {
	            return fallback.selects(specification);
	        });
	    };
	    /**
	     * Remove a stream from the registry
	     *
	     * @param stream    the stream adapter to remove
	     */
	    StreamRegistryImpl.prototype.remove = function (stream) {
	        var _this = this;
	        Arrays.remove(this.fallbacks, stream);
	        this.streams.forEach(function (existing, selector) {
	            if (Arrays.remove(existing, stream)) {
	                _this.topicCache.removeStream(stream, _this);
	            }
	            if (existing.length === 0) {
	                _this.streams.delete(selector);
	            }
	        });
	    };
	    /**
	     * Get the streams for a topic path that match a topic specification
	     *
	     * @param  topic          the topic path
	     * @param  specification  the topic specification
	     * @return                an array of stream adapters that select the topic
	     *                        specification
	     */
	    StreamRegistryImpl.prototype.streamsFor = function (topic, specification) {
	        var combined = [];
	        this.streams.forEach(function (existing, selector) {
	            if (selector.selects(topic)) {
	                combined = combined.concat(existing
	                    .filter(function (stream) {
	                    return stream.selects(specification);
	                }).map(function (stream) {
	                    return stream.adapter ? stream.adapter(specification) : stream;
	                }));
	            }
	        });
	        return combined;
	    };
	    /**
	     * Close the stream registry
	     *
	     * All streams will receive an {@link ErrorReason.SESSION_CLOSED SESSION_CLOSED}
	     * subscription error. No further values will be emitted.
	     */
	    StreamRegistryImpl.prototype.close = function () {
	        // session is closing down, don't notify fallback streams of any subscription
	        // from other value streams.
	        this.topicCache.clear();
	        this.streams.forEach(function (streamArray) {
	            streamArray.forEach(function (stream) {
	                stream.onSubscriptionError(error_reason_1.ErrorReason.SESSION_CLOSED);
	            });
	        });
	        this.fallbacks.forEach(function (stream) {
	            stream.onSubscriptionError(error_reason_1.ErrorReason.SESSION_CLOSED);
	        });
	    };
	    return StreamRegistryImpl;
	}());
	exports.StreamRegistryImpl = StreamRegistryImpl;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_cache_entry_1 = __webpack_require__(509);
	/**
	 * Implementation of {@link TopicCacheEntry} that doesn't cache a value
	 */
	var NoValueEntry = /** @class */ (function (_super) {
	    __extends(NoValueEntry, _super);
	    /**
	     * Create a new NoValueEntry instance
	     *
	     * @param streams        the stream adapters
	     * @param path           the topic path
	     * @param specification  the topic specification
	     */
	    function NoValueEntry(streams, path, specification) {
	        return _super.call(this, streams, path, specification) || this;
	    }
	    /**
	     * Handle a value
	     *
	     * Notifies the streams with the raw CBOR data. No old value is passed on.
	     *
	     * @param oldContent    the buffer containing the old content
	     * @param received      the content as a Buffer
	     * @param registry      the stream registry
	     * @param errorHandler  an error handler that will be called if an error occurs
	     */
	    NoValueEntry.prototype.handleValue = function (received, registry) {
	        this.notifyValue(null, received, null, received, registry);
	    };
	    /**
	     * Handle a value
	     *
	     * Notifies the streams with the raw CBOR data containing the delta. No new
	     * or old values are passed on.
	     *
	     * @param received      the content as a Buffer
	     * @param registry      the stream registry
	     * @param errorHandler  an error handler that will be called if an error occurs
	     */
	    NoValueEntry.prototype.handleDelta = function (received, registry) {
	        this.notifyDelta(null, received, null, null, received, registry);
	    };
	    /**
	     * Does not notify the streams because we don't have a cached value
	     */
	    NoValueEntry.prototype.notifyValueToNewStream = function () {
	        // no value
	    };
	    return NoValueEntry;
	}(topic_cache_entry_1.TopicCacheEntry));
	exports.NoValueEntry = NoValueEntry;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_cache_datatype_entry_1 = __webpack_require__(508);
	var time_series_event_datatype_1 = __webpack_require__(179);
	/**
	 * Extends {@link DatatypeCacheEntry} to handle time series events with a given
	 * data type
	 */
	var TimeSeriesCacheEntry = /** @class */ (function (_super) {
	    __extends(TimeSeriesCacheEntry, _super);
	    /**
	     * Create a new TimeSeriesCacheEntry instance
	     *
	     * @param streams        the stream adapters
	     * @param path           the topic path
	     * @param specification  the topic specification
	     * @param datatype       the data type of the entry
	     */
	    function TimeSeriesCacheEntry(streams, path, specification, datatype) {
	        return _super.call(this, streams, path, specification, time_series_event_datatype_1.TimeSeriesEventDataType.create(datatype)) || this;
	    }
	    return TimeSeriesCacheEntry;
	}(topic_cache_datatype_entry_1.DatatypeCacheEntry));
	exports.TimeSeriesCacheEntry = TimeSeriesCacheEntry;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_cache_datatype_entry_1 = __webpack_require__(508);
	var topic_cache_no_value_entry_1 = __webpack_require__(1228);
	var topic_cache_time_series_entry_1 = __webpack_require__(1229);
	var topic_type_1 = __webpack_require__(69);
	var topics_1 = __webpack_require__(148);
	/**
	 * The topic cache used by the internal session to cache all topic values that
	 * the session subscribes to.
	 */
	var TopicCache = /** @class */ (function () {
	    /**
	     * Create a new TopicCache instance
	     *
	     * @param datatypes  the data types
	     */
	    function TopicCache(datatypes) {
	        /**
	         * All the topic cache entries by their topic path
	         */
	        this.byPath = {};
	        /**
	         * All the topic cache entries by their ID
	         */
	        this.byId = {};
	        this.datatypes = datatypes;
	    }
	    /**
	     * Handle a subscription to a new topic
	     *
	     * This is called by the internal session when the client subscribes to a
	     * new topic. A new entry {@link TopicCacheEntry} is created and all streams
	     * in the stream registry that select the subscribed path will be added to
	     * that entry.
	     *
	     * The entry will then be notified of the initial subscription.
	     *
	     * @param info      the information about the new topic
	     * @param registry  the stream registry
	     */
	    TopicCache.prototype.handleSubscription = function (info, registry) {
	        var path = info.path;
	        var streams = registry.streamsFor(path, info.specification);
	        var entry;
	        switch (info.specification.type) {
	            case topic_type_1.TopicTypeEnum.JSON:
	            case topic_type_1.TopicTypeEnum.BINARY:
	            case topic_type_1.TopicTypeEnum.STRING:
	            case topic_type_1.TopicTypeEnum.DOUBLE:
	            case topic_type_1.TopicTypeEnum.INT64:
	            case topic_type_1.TopicTypeEnum.RECORD_V2:
	                var datatype = this.datatypes.get(info.specification.type);
	                if (datatype === null) {
	                    throw new Error('Invalid topic type');
	                }
	                entry = new topic_cache_datatype_entry_1.DatatypeCacheEntry(streams, path, info.specification, datatype);
	                break;
	            case topic_type_1.TopicTypeEnum.TIME_SERIES:
	                var eventType = this.datatypes.get(info.specification.properties.TIME_SERIES_EVENT_VALUE_TYPE);
	                if (eventType === null) {
	                    throw new Error('Invalid timeseries event type');
	                }
	                entry = new topic_cache_time_series_entry_1.TimeSeriesCacheEntry(streams, path, info.specification, eventType);
	                break;
	            default:
	                entry = new topic_cache_no_value_entry_1.NoValueEntry(streams, path, info.specification);
	        }
	        var oldByPath = this.byPath[path];
	        this.byPath[path] = entry;
	        if (oldByPath) {
	            throw new Error("Existing cache entry for " + path);
	        }
	        var oldById = this.byId[info.id];
	        this.byId[info.id] = entry;
	        if (oldById) {
	            throw new Error("Existing cache entry for " + info.id);
	        }
	        entry.notifyInitialSubscription(registry);
	    };
	    /**
	     * Clear the topic cache and notify all entries of an unsubscription
	     *
	     * @param registry  the stream registry
	     */
	    TopicCache.prototype.notifyUnsubscriptionOfAllTopics = function (registry) {
	        // tslint:disable-next-line:forin
	        for (var id in this.byId) {
	            this.byId[id].notifyUnsubscription(topics_1.UnsubscribeReasonEnum.SUBSCRIPTION_REFRESH, registry);
	        }
	        this.byPath = {};
	        this.byId = {};
	    };
	    /**
	     * Handle a value on a given topic ID
	     *
	     * @param  id        the topic ID
	     * @param  content   the new content
	     * @param  registry  the stream registry
	     * @param  handler   an error handler
	     */
	    TopicCache.prototype.handleValue = function (id, content, registry, handler) {
	        var errorHandler = handler.getErrorHandler();
	        var entry = this.byId[id];
	        if (entry) {
	            entry.handleValue(content, registry, errorHandler);
	        }
	        else {
	            errorHandler(new Error("Data loss on topic with ID: " + id + " - possibly due to reconnection"));
	        }
	    };
	    /**
	     * Handle a delta on a given topic ID
	     *
	     * @param  id        the topic ID
	     * @param  delta     the delta content
	     * @param  registry  the stream registry
	     * @param  handler   an error handler
	     */
	    TopicCache.prototype.handleDelta = function (id, delta, registry, handler) {
	        var errorHandler = handler.getErrorHandler();
	        var entry = this.byId[id];
	        if (entry) {
	            entry.handleDelta(delta, registry, errorHandler);
	        }
	        else {
	            errorHandler(new Error("Data loss on topic with ID: " + id + " - possibly due to reconnection"));
	        }
	    };
	    /**
	     * Handle an unsubscription event on a given topic ID
	     *
	     * @param  id        the topic ID
	     * @param  reason    reason for unsubscribing
	     * @param  registry  the stream registry
	     */
	    TopicCache.prototype.handleUnsubscription = function (id, reason, registry) {
	        var entry = this.byId[id];
	        delete this.byId[id];
	        if (entry) {
	            var path = entry.getTopicPath();
	            delete this.byPath[path];
	            entry.notifyUnsubscription(reason, registry);
	        }
	    };
	    /**
	     * Add a new stream to the cache
	     *
	     * The stream will be added to all current entries that the stream selects.
	     *
	     * @param selector  the topic selector of the topics that the stream should
	     *                  receive events for
	     * @param stream    the stream adapter to add
	     * @param registry  the stream registry
	     */
	    TopicCache.prototype.newStream = function (selector, stream, registry) {
	        for (var path in this.byPath) {
	            if (this.byPath.hasOwnProperty(path)) {
	                var entry = this.byPath[path];
	                var specification = entry.getTopicSpecification();
	                if (selector.selects(path) && stream.selects(specification)) {
	                    entry.addStream(stream.adapter ? stream.adapter(specification) : stream, registry);
	                }
	            }
	        }
	    };
	    /**
	     * Remove a stream from the cache
	     *
	     * Removes the stream from all entries that contain it.
	     *
	     * @param stream    the stream adapter to remove
	     * @param registry  the stream registry
	     */
	    TopicCache.prototype.removeStream = function (stream, registry) {
	        for (var path in this.byPath) {
	            if (this.byPath.hasOwnProperty(path)) {
	                this.byPath[path].removeStream(stream, registry);
	            }
	        }
	    };
	    /**
	     * Remove all streams from the cache
	     *
	     * Removes all streams from all entries without removing the entries themselves
	     */
	    TopicCache.prototype.removeAllStreams = function () {
	        var e_1, _a;
	        try {
	            for (var _b = __values(Object.getOwnPropertyNames(this.byPath)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var path = _c.value;
	                this.byPath[path].removeAllStreams();
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    /**
	     * Removes all topic cache entries
	     */
	    TopicCache.prototype.clear = function () {
	        this.byPath = {};
	        this.byId = {};
	    };
	    return TopicCache;
	}());
	exports.TopicCache = TopicCache;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Routing
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger = __webpack_require__(17);
	var headers_tunnel_1 = __webpack_require__(1467);
	var message_1 = __webpack_require__(236);
	var log = logger.create('V4 Client Routing');
	/**
	 * Routing the incoming messages to the correct handler
	 */
	var TopicRouting = /** @class */ (function () {
	    /**
	     * Create a new TopicRouting instance
	     *
	     * @param errorHandler     the error handler
	     * @param serviceAdapter   the service adapter that will receive service
	     *                         requests, responses and errors
	     * @param conversationSet  the conversation set that handles fetch replies
	     * @param cache            the topic cache that handles topic values and deltas
	     * @param registry         the stream registry that is passed on to the topic
	     *                         {@link cache}
	     */
	    function TopicRouting(errorHandler, serviceAdapter, conversationSet, cache, registry) {
	        this.errorHandler = errorHandler;
	        this.serviceAdapter = serviceAdapter;
	        this.conversationSet = conversationSet;
	        this.cache = cache;
	        this.registry = registry;
	    }
	    /**
	     * Route a message to the correct handler
	     *
	     * @param message  the incoming message that needs to be handled
	     */
	    TopicRouting.prototype.route = function (message) {
	        switch (message.type) {
	            case message_1.types.FETCH_REPLY:
	                var cid = headers_tunnel_1.cidFromHeaders(message.headers);
	                this.conversationSet.respondIfPresent(cid, message);
	                break;
	            case message_1.types.SERVICE_REQUEST:
	            case message_1.types.SERVICE_RESPONSE:
	            case message_1.types.SERVICE_ERROR:
	                this.serviceAdapter.onMessage(message.type, message.getInputStream());
	                break;
	            case message_1.types.TOPIC_VALUE:
	                this.cache.handleValue(message.id, message.data, this.registry, this.errorHandler);
	                break;
	            case message_1.types.TOPIC_DELTA:
	                this.cache.handleDelta(message.id, message.data, this.registry, this.errorHandler);
	                break;
	            default:
	                log.debug('Unhandled V4 message: ' + message.type, message);
	        }
	    };
	    /**
	     * Subscribe to a new topic
	     *
	     * @param info  the topic info
	     */
	    TopicRouting.prototype.subscribe = function (info) {
	        this.cache.handleSubscription(info, this.registry);
	    };
	    /**
	     * Unsubscribe from a topic
	     *
	     * @param id      the topic id to unsubscribe from
	     * @param reason  the reason for unsubscribing
	     */
	    TopicRouting.prototype.unsubscribe = function (id, reason) {
	        this.cache.handleUnsubscription(id, reason, this.registry);
	    };
	    return TopicRouting;
	}());
	exports.TopicRouting = TopicRouting;


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A Serialiser for buffers values
	 */
	var BufferSerialiserClass = /** @class */ (function () {
	    function BufferSerialiserClass() {
	    }
	    /**
	     * @inheritdoc
	     *
	     * Assumes that the remainder of the input stream should be read
	     * This does not store the length of the buffer, so beware
	     */
	    BufferSerialiserClass.prototype.read = function (bis) {
	        return bis.readMany(bis.count - bis.pos);
	    };
	    /**
	     * @inheritdoc
	     */
	    BufferSerialiserClass.prototype.write = function (bos, val) {
	        bos.writeMany(val);
	    };
	    return BufferSerialiserClass;
	}());
	exports.BufferSerialiserClass = BufferSerialiserClass;
	/**
	 * The {@link BufferSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.BufferSerialiser = new BufferSerialiserClass();


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BytesSerialiserClass = /** @class */ (function () {
	    function BytesSerialiserClass() {
	    }
	    /**
	     * Read a Buffer stream
	     *
	     * @param  output    the stream from which to read
	     * @return           the value read from the stream if it is a valid enum value
	     *
	     * @throws an error if the value read is not a valid enum value
	     */
	    BytesSerialiserClass.prototype.read = function (output) {
	        return Codec.readBytes(output);
	    };
	    /**
	     * Write an enum to a Buffer stream
	     *
	     * @param  input  the stream to which to write
	     * @param  buffer the buffer of which is written
	     */
	    BytesSerialiserClass.prototype.write = function (input, buffer) {
	        Codec.writeBytes(input, buffer);
	    };
	    return BytesSerialiserClass;
	}());
	exports.BytesSerialiserClass = BytesSerialiserClass;
	/**
	 * The {@link BytesSerialiserClass} singleton
	 */
	// tslint:disable-next-line:variable-name
	exports.BytesSerialiser = new BytesSerialiserClass();


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * A Serialiser for 32 bit integer values.
	 *
	 * This corresponds to :integer in the protocol definition.
	 */
	var IntegerSerialiserClass = /** @class */ (function () {
	    function IntegerSerialiserClass() {
	    }
	    /**
	     * @inheritdoc
	     */
	    IntegerSerialiserClass.prototype.read = function (bis) {
	        return Codec.readInt32(bis);
	    };
	    /**
	     * @inheritdoc
	     */
	    IntegerSerialiserClass.prototype.write = function (bos, val) {
	        Codec.writeInt32(bos, val);
	    };
	    return IntegerSerialiserClass;
	}());
	exports.IntegerSerialiserClass = IntegerSerialiserClass;
	/**
	 * The {@link IntegerSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.IntegerSerialiser = new IntegerSerialiserClass();


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Serialisers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var Long = __webpack_require__(44);
	/**
	 * Read and decodes a set of enums from a bitset stored in a 64 bit integer
	 *
	 * The enum values must all lie between 0 and 63 inclusive.
	 *
	 * @param bis       the buffer input stream
	 * @param enumType  the enum type
	 * @returns         a Set containing the enums stored in the input stream
	 */
	function read(bis, enumType) {
	    var enums = new Set();
	    var bitmap = Codec.readInt64(bis);
	    var shift = 0;
	    var enumReader = {
	        read: function () {
	            return shift;
	        }
	    };
	    while (!bitmap.isZero()) {
	        if (!bitmap.and(1).isZero()) {
	            enums.add(BEES.read(enumReader, enumType));
	        }
	        bitmap = bitmap.shiftRight(1);
	        shift++;
	    }
	    return enums;
	}
	exports.read = read;
	/** Writes an enum set to a buffer output stream
	 *
	 * @param bos      the buffer output stream
	 * @param enumSet  the set of enums stored in an array or set.
	 *                 The only requirement is the presence of a forEach method. *
	 *                 All enum values stored in the set must lie between 0 and 63
	 *                 inclusive.
	 */
	function write(bos, enumSet) {
	    var bitmap = Long.UZERO;
	    var enumWriter = {
	        write: function (val) {
	            if (val >= 64) {
	                throw new Error("Cannot encode enum in long, " + val + " >= 64'");
	            }
	            bitmap = bitmap.or(Long.ONE.shiftLeft(val));
	        }
	    };
	    enumSet.forEach(function (e) {
	        BEES.write(enumWriter, e);
	    });
	    Codec.writeInt64(bos, bitmap);
	}
	exports.write = write;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var security_command_script_1 = __webpack_require__(510);
	/**
	 * Serialiser for {@link SecurityCommandScript}
	 */
	var SecurityCommandScriptSerialiserClass = /** @class */ (function (_super) {
	    __extends(SecurityCommandScriptSerialiserClass, _super);
	    function SecurityCommandScriptSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SecurityCommandScript} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link SecurityCommandScript} that was read
	     */
	    SecurityCommandScriptSerialiserClass.prototype.read = function (input) {
	        var script = Codec.readString(input);
	        return new security_command_script_1.SecurityCommandScript(script);
	    };
	    /**
	     * Write a {@link SecurityCommandScript} to the stream
	     *
	     * @param bis   the input stream
	     * @param value the {@link SecurityCommandScript} to be written
	     */
	    SecurityCommandScriptSerialiserClass.prototype.write = function (output, value) {
	        Codec.writeString(output, value.script);
	    };
	    return SecurityCommandScriptSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SecurityCommandScriptSerialiserClass = SecurityCommandScriptSerialiserClass;
	/**
	 * The {@link SecurityCommandScriptSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SecurityCommandScriptSerialiser = new SecurityCommandScriptSerialiserClass();


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var matches_property_validation_1 = __webpack_require__(1200);
	var values_property_validation_1 = __webpack_require__(1206);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var security_1 = __webpack_require__(101);
	/**
	 * Serialiser for {@link SessionPropertyValidation}
	 */
	var SessionPropertyValidationSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionPropertyValidationSerialiserClass, _super);
	    function SessionPropertyValidationSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionPropertyValidation} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link SessionPropertyValidation} that was read
	     */
	    SessionPropertyValidationSerialiserClass.prototype.read = function (bis) {
	        var type = BEES.read(bis, security_1.ValidationType);
	        if (type === security_1.ValidationType.REGEX) {
	            return new matches_property_validation_1.MatchesSessionPropertyValidationImpl(Codec.readString(bis));
	        }
	        var values = Codec.readCollection(bis, Codec.readString);
	        return new values_property_validation_1.ValuesSessionPropertyValidationImpl(values);
	    };
	    /**
	     * Write a {@link SessionPropertyValidation} to the stream
	     *
	     * @param bis   the input stream
	     * @param value the {@link SessionPropertyValidation} to be written
	     */
	    SessionPropertyValidationSerialiserClass.prototype.write = function (bos, value) {
	        var type = value.type;
	        Codec.writeByte(bos, type);
	        if (type === security_1.ValidationType.REGEX) {
	            var regexValidation = value;
	            Codec.writeString(bos, regexValidation.regex);
	        }
	        else {
	            var valuesValidation = value;
	            Codec.writeCollection(bos, valuesValidation.values, Codec.writeString);
	        }
	    };
	    return SessionPropertyValidationSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionPropertyValidationSerialiserClass = SessionPropertyValidationSerialiserClass;
	/**
	 * The {@link SessionPropertyValidationSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionPropertyValidationSerialiser = new SessionPropertyValidationSerialiserClass();


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var system_authentication_1 = __webpack_require__(1204);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var session_property_validation_serialiser_1 = __webpack_require__(1237);
	var system_principal_serialiser_1 = __webpack_require__(1239);
	/**
	 * Serialiser for {@link SystemAuthentication}
	 */
	var SystemAuthenticationConfigurationSerialiserClass = /** @class */ (function (_super) {
	    __extends(SystemAuthenticationConfigurationSerialiserClass, _super);
	    function SystemAuthenticationConfigurationSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SystemAuthentication} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link SystemAuthentication} that was read
	     */
	    SystemAuthenticationConfigurationSerialiserClass.prototype.read = function (bis) {
	        var principals = Codec.readCollection(bis, system_principal_serialiser_1.SystemPrincipalSerialiser.read);
	        var action = BEES.read(bis, system_authentication_1.CONNECTION_ACTION);
	        var roles = Codec.readCollection(bis, Codec.readString);
	        var properties = Codec.readDictionary(bis, session_property_validation_serialiser_1.SessionPropertyValidationSerialiser.read);
	        return new system_authentication_1.SystemAuthentication(principals, action.value, roles, properties);
	    };
	    /**
	     * Write a {@link SystemAuthentication} to the stream
	     *
	     * @param bis   the input stream
	     * @param value the {@link SystemAuthentication} to be written
	     */
	    SystemAuthenticationConfigurationSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeCollection(bos, value.principals, system_principal_serialiser_1.SystemPrincipalSerialiser.write);
	        var action = system_authentication_1.connectionActionFromString(value.anonymous.action);
	        Codec.writeByte(bos, action.id);
	        Codec.writeCollection(bos, value.anonymous.roles, Codec.writeString);
	        Codec.writeDictionary(bos, value.trustedClientProposedProperties, session_property_validation_serialiser_1.SessionPropertyValidationSerialiser.write);
	    };
	    return SystemAuthenticationConfigurationSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SystemAuthenticationConfigurationSerialiserClass = SystemAuthenticationConfigurationSerialiserClass;
	/**
	 * The {@link SystemAuthenticationConfigurationSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SystemAuthenticationConfigurationSerialiser = new SystemAuthenticationConfigurationSerialiserClass();


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var system_principal_1 = __webpack_require__(1205);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link SystemPrincipal}
	 */
	var SystemPrincipalSerialiserClass = /** @class */ (function (_super) {
	    __extends(SystemPrincipalSerialiserClass, _super);
	    function SystemPrincipalSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SystemPrincipal} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link SystemPrincipal} that was read
	     */
	    SystemPrincipalSerialiserClass.prototype.read = function (bis) {
	        var name = Codec.readString(bis);
	        var roles = Codec.readCollection(bis, Codec.readString);
	        var lockingPrincipal = Codec.readBoolean(bis) ? Codec.readString(bis) : undefined;
	        return new system_principal_1.SystemPrincipalImpl(name, roles, lockingPrincipal);
	    };
	    /**
	     * Write a {@link SystemPrincipal} to the stream
	     *
	     * @param bis   the input stream
	     * @param value the {@link SystemPrincipal} to be written
	     */
	    SystemPrincipalSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeCollection(bos, value.roles, Codec.writeString);
	        Codec.writeBoolean(bos, !!value.lockingPrincipal);
	        if (value.lockingPrincipal) {
	            Codec.writeString(bos, value.lockingPrincipal);
	        }
	    };
	    return SystemPrincipalSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SystemPrincipalSerialiserClass = SystemPrincipalSerialiserClass;
	/**
	 * The {@link SystemPrincipalSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SystemPrincipalSerialiser = new SystemPrincipalSerialiserClass();


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Authentication
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var CredentialsSerialiser = __webpack_require__(232);
	/**
	 * Serialiser for {@link SecurityCommandScript}
	 */
	var ChangePrincipalRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(ChangePrincipalRequestSerialiserClass, _super);
	    function ChangePrincipalRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SecurityCommandScript} to the stream
	     *
	     * @param bis   the input stream
	     * @param value the {@link SecurityCommandScript} to be written
	     */
	    ChangePrincipalRequestSerialiserClass.prototype.write = function (output, req) {
	        Codec.writeString(output, req.principal);
	        CredentialsSerialiser.write(output, req.credentials);
	    };
	    return ChangePrincipalRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ChangePrincipalRequestSerialiserClass = ChangePrincipalRequestSerialiserClass;
	/**
	 * The {@link ChangePrincipalRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ChangePrincipalRequestSerialiser = new ChangePrincipalRequestSerialiserClass();


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.ControlClient
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	var client_filter_subscribe_request_1 = __webpack_require__(1242);
	/**
	 * Serialiser for {@link ClientFilterSubscribeRequest}
	 */
	var ClientFilterSubscribeRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(ClientFilterSubscribeRequestSerialiserClass, _super);
	    function ClientFilterSubscribeRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ClientFilterSubscribeRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ClientFilterSubscribeRequest} that was read
	     */
	    ClientFilterSubscribeRequestSerialiserClass.prototype.read = function (bis) {
	        var filter = Codec.readString(bis);
	        var selector = topic_selector_serialiser_1.TopicSelectorSerialiser.read(bis);
	        return new client_filter_subscribe_request_1.ClientFilterSubscribeRequest(filter, selector);
	    };
	    /**
	     * Write a {@link ClientFilterSubscribeRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ClientFilterSubscribeRequest} to be written
	     */
	    ClientFilterSubscribeRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.filter);
	        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
	    };
	    return ClientFilterSubscribeRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ClientFilterSubscribeRequestSerialiserClass = ClientFilterSubscribeRequestSerialiserClass;
	/**
	 * The {@link ClientFilterSubscribeRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ClientFilterSubscribeRequestSerialiser = new ClientFilterSubscribeRequestSerialiserClass();


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.ControlClient
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a FILTER_SUBSCRIBE and FILTER_UNSUBSCRIBE request.
	 */
	var ClientFilterSubscribeRequest = /** @class */ (function () {
	    /**
	     * Create a new ClientFilterSubscribeRequest instance
	     *
	     * @param filter  the filter
	     * @param selector  the topic selector
	     */
	    function ClientFilterSubscribeRequest(filter, selector) {
	        this.filter = filter;
	        this.selector = selector;
	    }
	    return ClientFilterSubscribeRequest;
	}());
	exports.ClientFilterSubscribeRequest = ClientFilterSubscribeRequest;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.ControlClient
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_serialiser_1 = __webpack_require__(233);
	var client_filter_subscribe_response_1 = __webpack_require__(1244);
	/**
	 * Serialiser for {@link ClientFilterSubscribeResponse}
	 */
	var ClientFilterSubscribeResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(ClientFilterSubscribeResponseSerialiserClass, _super);
	    function ClientFilterSubscribeResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ClientFilterSubscribeResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ClientFilterSubscribeResponse} that was read
	     */
	    ClientFilterSubscribeResponseSerialiserClass.prototype.read = function (bis) {
	        var error = Codec.readByte(bis);
	        if (error) {
	            var errors = Codec.readCollection(bis, error_report_serialiser_1.ErrorReportSerialiser.read);
	            return new client_filter_subscribe_response_1.ClientFilterSubscribeResponse(0, errors);
	        }
	        else {
	            var numSelected = Codec.readInt32(bis);
	            return new client_filter_subscribe_response_1.ClientFilterSubscribeResponse(numSelected, []);
	        }
	    };
	    /**
	     * Write a {@link ClientFilterSubscribeResponse} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ClientFilterSubscribeResponse} to be written
	     */
	    ClientFilterSubscribeResponseSerialiserClass.prototype.write = function (bos, value) {
	        if (value.isSuccess()) {
	            Codec.writeByte(bos, 0);
	            Codec.writeInt32(bos, value.selected);
	        }
	        else {
	            Codec.writeByte(bos, 1);
	            Codec.writeCollection(bos, value.errors, error_report_serialiser_1.ErrorReportSerialiser.write);
	        }
	    };
	    return ClientFilterSubscribeResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ClientFilterSubscribeResponseSerialiserClass = ClientFilterSubscribeResponseSerialiserClass;
	/**
	 * The {@link ClientFilterSubscribeResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ClientFilterSubscribeResponseSerialiser = new ClientFilterSubscribeResponseSerialiserClass();


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.ControlClient
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server response from a FILTER_SUBSCRIBE and FILTER_UNSUBSCRIBE request.
	 */
	var ClientFilterSubscribeResponse = /** @class */ (function () {
	    /**
	     * Create a new ClientFilterSubscribeRequest instance
	     *
	     * @param filter  the number of clients selected by the request
	     * @param selector  any errors that occurred
	     */
	    function ClientFilterSubscribeResponse(selected, errors) {
	        this.selected = selected;
	        this.errors = errors;
	    }
	    /**
	     * Check if the response indicates a success
	     *
	     * @return  `true` if there were no errors
	     */
	    ClientFilterSubscribeResponse.prototype.isSuccess = function () {
	        return this.errors.length === 0;
	    };
	    return ClientFilterSubscribeResponse;
	}());
	exports.ClientFilterSubscribeResponse = ClientFilterSubscribeResponse;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.ControlClient
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	var client_subscribe_request_1 = __webpack_require__(1246);
	/**
	 * Serialiser for {@link ClientSubscribeRequest}
	 */
	var ClientSubscribeRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(ClientSubscribeRequestSerialiserClass, _super);
	    function ClientSubscribeRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ClientSubscribeRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ClientSubscribeRequest} that was read
	     */
	    ClientSubscribeRequestSerialiserClass.prototype.read = function (bis) {
	        var sessionID = session_id_serialiser_1.SessionIdSerialiser.read(bis);
	        var selector = topic_selector_serialiser_1.TopicSelectorSerialiser.read(bis);
	        return new client_subscribe_request_1.ClientSubscribeRequest(sessionID, selector);
	    };
	    /**
	     * Write a {@link ClientSubscribeRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ClientSubscribeRequest} to be written
	     */
	    ClientSubscribeRequestSerialiserClass.prototype.write = function (bos, value) {
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
	        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
	    };
	    return ClientSubscribeRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ClientSubscribeRequestSerialiserClass = ClientSubscribeRequestSerialiserClass;
	/**
	 * The {@link ClientSubscribeRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ClientSubscribeRequestSerialiser = new ClientSubscribeRequestSerialiserClass();


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.ControlClient
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SUBSCRIBE_CLIENT and UNSUBSCRIBE_CLIENT request.
	 */
	var ClientSubscribeRequest = /** @class */ (function () {
	    /**
	     * Create a new ClientSubscribeRequest instance
	     *
	     * @param sessionID  the session ID
	     * @param selector  the topic selector
	     */
	    function ClientSubscribeRequest(sessionID, selector) {
	        this.sessionID = sessionID;
	        this.selector = selector;
	    }
	    return ClientSubscribeRequest;
	}());
	exports.ClientSubscribeRequest = ClientSubscribeRequest;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link ChangeAuthorisationRolesFilterRequest}
	 */
	var ChangeAuthorisationRolesFilterRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(ChangeAuthorisationRolesFilterRequestSerialiserClass, _super);
	    function ChangeAuthorisationRolesFilterRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link ChangeAuthorisationRolesFilterRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ChangeAuthorisationRolesFilterRequest} to be written
	     */
	    ChangeAuthorisationRolesFilterRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.filter);
	        Codec.writeCollection(bos, value.rolesToRemove, Codec.writeString);
	        Codec.writeCollection(bos, value.rolesToAdd, Codec.writeString);
	    };
	    return ChangeAuthorisationRolesFilterRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ChangeAuthorisationRolesFilterRequestSerialiserClass = ChangeAuthorisationRolesFilterRequestSerialiserClass;
	/**
	 * The {@link ChangeAuthorisationRolesFilterRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ChangeAuthorisationRolesFilterRequestSerialiser = new ChangeAuthorisationRolesFilterRequestSerialiserClass();


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a CHANGE_AUTHORISATION_ROLES_FILTER request.
	 */
	var ChangeAuthorisationRolesFilterRequest = /** @class */ (function () {
	    /**
	     * Create a new ChangeAuthorisationRolesFilterRequest instance
	     *
	     * @param sessionID         the filter specifying the sessions on which the roles should be changed
	     * @param rolesToRemove     the roles to remove
	     * @param removeProperties  the roles to add
	     */
	    function ChangeAuthorisationRolesFilterRequest(filter, rolesToRemove, rolesToAdd) {
	        this.filter = filter;
	        this.rolesToRemove = rolesToRemove;
	        this.rolesToAdd = rolesToAdd;
	    }
	    return ChangeAuthorisationRolesFilterRequest;
	}());
	exports.ChangeAuthorisationRolesFilterRequest = ChangeAuthorisationRolesFilterRequest;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	/**
	 * Serialiser for {@link ChangeAuthorisationRolesRequest}
	 */
	var ChangeAuthorisationRolesRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(ChangeAuthorisationRolesRequestSerialiserClass, _super);
	    function ChangeAuthorisationRolesRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link ChangeAuthorisationRolesRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ChangeAuthorisationRolesRequest} to be written
	     */
	    ChangeAuthorisationRolesRequestSerialiserClass.prototype.write = function (bos, value) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (value.sessionID === undefined || value.sessionID === null) {
	            throw new Error('Session ID is null or undefined');
	        }
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
	        Codec.writeCollection(bos, value.rolesToRemove, Codec.writeString);
	        Codec.writeCollection(bos, value.rolesToAdd, Codec.writeString);
	    };
	    return ChangeAuthorisationRolesRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ChangeAuthorisationRolesRequestSerialiserClass = ChangeAuthorisationRolesRequestSerialiserClass;
	/**
	 * The {@link ChangeAuthorisationRolesRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ChangeAuthorisationRolesRequestSerialiser = new ChangeAuthorisationRolesRequestSerialiserClass();


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a CHANGE_AUTHORISATION_ROLES request.
	 */
	var ChangeAuthorisationRolesRequest = /** @class */ (function () {
	    /**
	     * Create a new ChangeAuthorisationRolesRequest instance
	     *
	     * @param sessionID         the session ID
	     * @param rolesToRemove     the roles to remove
	     * @param removeProperties  the roles to add
	     */
	    function ChangeAuthorisationRolesRequest(sessionID, rolesToRemove, rolesToAdd) {
	        this.sessionID = sessionID;
	        this.rolesToRemove = rolesToRemove;
	        this.rolesToAdd = rolesToAdd;
	    }
	    return ChangeAuthorisationRolesRequest;
	}());
	exports.ChangeAuthorisationRolesRequest = ChangeAuthorisationRolesRequest;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	var close_client_request_1 = __webpack_require__(1252);
	/**
	 * Serialiser for {@link CloseClientRequest}
	 */
	var CloseClientRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(CloseClientRequestSerialiserClass, _super);
	    function CloseClientRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link CloseClientRequest} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link CloseClientRequest} that was read
	     */
	    CloseClientRequestSerialiserClass.prototype.read = function (bis) {
	        var sessionID = session_id_serialiser_1.SessionIdSerialiser.read(bis);
	        return new close_client_request_1.CloseClientRequest(sessionID);
	    };
	    /**
	     * Write a {@link CloseClientRequest} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link CloseClientRequest} to be written
	     */
	    CloseClientRequestSerialiserClass.prototype.write = function (bos, value) {
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
	    };
	    return CloseClientRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CloseClientRequestSerialiserClass = CloseClientRequestSerialiserClass;
	/**
	 * The {@link SecurityCommandScriptResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CloseClientRequestSerialiser = new CloseClientRequestSerialiserClass();


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a CLOSE_CLIENT request.
	 */
	var CloseClientRequest = /** @class */ (function () {
	    /**
	     * Create a new CloseClientRequest instance
	     *
	     * @param sessionID a session ID
	     */
	    function CloseClientRequest(sessionID) {
	        this.sessionID = sessionID;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the CloseClientRequest
	     */
	    CloseClientRequest.prototype.toString = function () {
	        return 'CloseClientRequest [' + this.sessionID + ']';
	    };
	    return CloseClientRequest;
	}());
	exports.CloseClientRequest = CloseClientRequest;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var control_group_serialiser_1 = __webpack_require__(327);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var control_registration_params_1 = __webpack_require__(513);
	/**
	 * Serialiser for {@link ControlRegistrationParams}
	 */
	var ControlRegistrationParamsSerialiserClass = /** @class */ (function (_super) {
	    __extends(ControlRegistrationParamsSerialiserClass, _super);
	    function ControlRegistrationParamsSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AuthenticatorRegistrationRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link AuthenticatorRegistrationRequest} that was read
	     */
	    ControlRegistrationParamsSerialiserClass.prototype.read = function (bis) {
	        var definitionId = Codec.readInt32(bis);
	        var group = control_group_serialiser_1.ControlGroupSerialiser.read(bis);
	        return new control_registration_params_1.ControlRegistrationParams({ id: definitionId }, group);
	    };
	    /**
	     * Write a {@link ControlRegistrationParams} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ControlRegistrationParams} to be written
	     */
	    ControlRegistrationParamsSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.definition.id);
	        control_group_serialiser_1.ControlGroupSerialiser.write(bos, value.group);
	    };
	    return ControlRegistrationParamsSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ControlRegistrationParamsSerialiserClass = ControlRegistrationParamsSerialiserClass;
	/**
	 * The {@link ControlRegistrationParamsSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ControlRegistrationParamsSerialiser = new ControlRegistrationParamsSerialiserClass();


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	/**
	 * Serialiser for {@link GetSessionPropertiesRequestSerialiser}
	 */
	var GetSessionPropertiesRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(GetSessionPropertiesRequestSerialiserClass, _super);
	    function GetSessionPropertiesRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link GetSessionPropertiesRequestSerialiser} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GetSessionPropertiesRequest} to be written
	     */
	    GetSessionPropertiesRequestSerialiserClass.prototype.write = function (bos, value) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (value.sessionID === undefined || value.sessionID === null) {
	            throw new Error('session ID is null or undefined');
	        }
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
	        // tslint:disable-next-line:strict-type-predicates
	        if (value.propertyKeys !== undefined && value.propertyKeys !== null) {
	            Codec.writeCollection(bos, value.propertyKeys, Codec.writeString);
	        }
	        else {
	            Codec.writeCollection(bos, [], Codec.writeString);
	        }
	    };
	    return GetSessionPropertiesRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GetSessionPropertiesRequestSerialiserClass = GetSessionPropertiesRequestSerialiserClass;
	/**
	 * The {@link GetSessionPropertiesRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GetSessionPropertiesRequestSerialiser = new GetSessionPropertiesRequestSerialiserClass();


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var get_session_properties_response_1 = __webpack_require__(1256);
	/**
	 * Serialiser for {@link GetSessionProperties}
	 */
	var GetSessionPropertiesResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(GetSessionPropertiesResponseSerialiserClass, _super);
	    function GetSessionPropertiesResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GetSessionProperties} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GetSessionProperties} that was read
	     */
	    GetSessionPropertiesResponseSerialiserClass.prototype.read = function (bis) {
	        if (Codec.readBoolean(bis)) {
	            return new get_session_properties_response_1.GetSessionPropertiesResponse(Codec.readDictionary(bis, Codec.readString));
	        }
	        else {
	            return null;
	        }
	    };
	    return GetSessionPropertiesResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GetSessionPropertiesResponseSerialiserClass = GetSessionPropertiesResponseSerialiserClass;
	/**
	 * The {@link GetSessionPropertiesResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GetSessionPropertiesResponseSerialiser = new GetSessionPropertiesResponseSerialiserClass();


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server response from a GET_SESSION_PROPERTIES request.
	 */
	var GetSessionPropertiesResponse = /** @class */ (function () {
	    /**
	     * Create a new GetSessionPropertiesResponse instance
	     *
	     * @param properties  the session properties
	     */
	    function GetSessionPropertiesResponse(properties) {
	        this.properties = properties;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return  a string representation of the GetSessionPropertiesResponse object
	     */
	    GetSessionPropertiesResponse.prototype.toString = function () {
	        return 'GetSessionPropertiesResponse []';
	    };
	    return GetSessionPropertiesResponse;
	}());
	exports.GetSessionPropertiesResponse = GetSessionPropertiesResponse;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:max-line-length */
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var serialiser_1 = __webpack_require__(4);
	var message_receiver_control_registration_params_serialiser_1 = __webpack_require__(514);
	/**
	 * Serialiser for {@link MessageReceiverControlRegistrationRequest}
	 */
	var MessageReceiverControlRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessageReceiverControlRegistrationRequestSerialiserClass, _super);
	    function MessageReceiverControlRegistrationRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link MessageReceiverControlRegistrationRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MessageReceiverControlRegistrationRequest} to be written
	     */
	    MessageReceiverControlRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
	        message_receiver_control_registration_params_serialiser_1.MessageReceiverControlRegistrationParamsSerialiser.write(bos, value.params);
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return MessageReceiverControlRegistrationRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessageReceiverControlRegistrationRequestSerialiserClass = MessageReceiverControlRegistrationRequestSerialiserClass;
	/**
	 * The {@link MessageReceiverControlRegistrationRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessageReceiverControlRegistrationRequestSerialiser = new MessageReceiverControlRegistrationRequestSerialiserClass();


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	var messaging_client_forward_send_request_1 = __webpack_require__(1259);
	/**
	 * Serialiser for {@link MessagingClientForwardSendRequest}
	 */
	var MessagingClientForwardSendRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingClientForwardSendRequestSerialiserClass, _super);
	    function MessagingClientForwardSendRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MessagingClientForwardSendRequest} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link MessagingClientForwardSendRequest} that was read
	     */
	    MessagingClientForwardSendRequestSerialiserClass.prototype.read = function (bis) {
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        var sessionID = session_id_serialiser_1.SessionIdSerialiser.read(bis);
	        var path = Codec.readString(bis);
	        var sessionProperties = Codec.readDictionary(bis, Codec.readString);
	        var dataType = Codec.readString(bis);
	        var content = Codec.readBytes(bis);
	        return new messaging_client_forward_send_request_1.MessagingClientForwardSendRequest(cid, sessionID, path, sessionProperties, dataType, content);
	    };
	    return MessagingClientForwardSendRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingClientForwardSendRequestSerialiserClass = MessagingClientForwardSendRequestSerialiserClass;
	/**
	 * The {@link MessagingClientForwardSendRequest} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingClientForwardSendRequestSerialiser = new MessagingClientForwardSendRequestSerialiserClass();


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a MESSAGING_RECEIVER_CLIENT request.
	 */
	var MessagingClientForwardSendRequest = /** @class */ (function () {
	    /**
	     * Create a new MessagingClientForwardSendRequest instance
	     *
	     */
	    function MessagingClientForwardSendRequest(cid, sessionID, path, properties, dataType, content) {
	        this.cid = cid;
	        this.sessionID = sessionID;
	        this.path = path;
	        this.properties = properties;
	        this.dataType = dataType;
	        this.content = content;
	    }
	    return MessagingClientForwardSendRequest;
	}());
	exports.MessagingClientForwardSendRequest = MessagingClientForwardSendRequest;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	/**
	 * Serialiser for {@link MessagingClientSendRequest}
	 */
	var MessagingClientSendRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingClientSendRequestSerialiserClass, _super);
	    function MessagingClientSendRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link MessagingClientSendRequest} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link MessagingClientSendRequest} to be written
	     */
	    MessagingClientSendRequestSerialiserClass.prototype.write = function (bos, value) {
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionId);
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.dataType);
	        Codec.writeBytes(bos, value.request);
	    };
	    return MessagingClientSendRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingClientSendRequestSerialiserClass = MessagingClientSendRequestSerialiserClass;
	/**
	 * The {@link MessagingClientSendRequest} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingClientSendRequestSerialiser = new MessagingClientSendRequestSerialiserClass();


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var messaging_filter_response_1 = __webpack_require__(1262);
	var messaging_response_serialiser_1 = __webpack_require__(515);
	var error_reason_serialiser_1 = __webpack_require__(518);
	var session_id_serialiser_1 = __webpack_require__(67);
	/**
	 * Serialiser for {@link MessagingFilterResponse}
	 */
	var MessagingFilterResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingFilterResponseSerialiserClass, _super);
	    function MessagingFilterResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MessagingFilterResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link MessagingFilterResponse} that was read
	     */
	    MessagingFilterResponseSerialiserClass.prototype.read = function (bis) {
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        var sessionID = session_id_serialiser_1.SessionIdSerialiser.read(bis);
	        switch (Codec.readByte(bis)) {
	            case 0:
	                var response = messaging_response_serialiser_1.MessagingResponseSerialiser.read(bis);
	                return new messaging_filter_response_1.MessagingFilterResponse(cid, sessionID, response);
	            default:
	                var errorReason = error_reason_serialiser_1.ErrorReasonSerialiser.read(bis);
	                return new messaging_filter_response_1.MessagingFilterResponse(cid, sessionID, null, errorReason);
	        }
	    };
	    return MessagingFilterResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingFilterResponseSerialiserClass = MessagingFilterResponseSerialiserClass;
	/**
	 * The {@link MessagingFilterResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingFilterResponseSerialiser = new MessagingFilterResponseSerialiserClass();


/***/ }),
/* 1262 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a FILTER_RESPONSE request.
	 */
	var MessagingFilterResponse = /** @class */ (function () {
	    /**
	     * Create a new MessagingFilterResponse instance
	     *
	     * @param cid          the conversation ID
	     * @param sessionID    the session ID
	     * @param response     the messaging response
	     * @param errorReason  a possible error reason
	     */
	    function MessagingFilterResponse(cid, sessionID, response, errorReason) {
	        this.cid = cid;
	        this.sessionID = sessionID;
	        this.response = response;
	        this.errorReason = errorReason;
	    }
	    return MessagingFilterResponse;
	}());
	exports.MessagingFilterResponse = MessagingFilterResponse;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link MessagingFilterSendRequest}
	 */
	var MessagingFilterSendRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingFilterSendRequestSerialiserClass, _super);
	    function MessagingFilterSendRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link MessagingFilterSendRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MessagingFilterSendRequest} to be written
	     */
	    MessagingFilterSendRequestSerialiserClass.prototype.write = function (bos, value) {
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	        Codec.writeString(bos, value.filter);
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.dataType.name());
	        Codec.writeBytes(bos, value.request);
	    };
	    return MessagingFilterSendRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingFilterSendRequestSerialiserClass = MessagingFilterSendRequestSerialiserClass;
	/**
	 * The {@link MessagingFilterSendRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingFilterSendRequestSerialiser = new MessagingFilterSendRequestSerialiserClass();


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_serialiser_1 = __webpack_require__(233);
	var messaging_filter_send_response_1 = __webpack_require__(1265);
	/**
	 * Serialiser for {@link MessagingFilterSendResponse}
	 */
	var MessagingFilterSendResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingFilterSendResponseSerialiserClass, _super);
	    function MessagingFilterSendResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MessagingFilterSendResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link MessagingFilterSendResponse} that was read
	     */
	    MessagingFilterSendResponseSerialiserClass.prototype.read = function (bis) {
	        var code = Codec.readByte(bis);
	        if (code === 0) {
	            var numberSent = Codec.readInt32(bis);
	            return new messaging_filter_send_response_1.MessagingFilterSendResponse(numberSent, []);
	        }
	        else {
	            var errors = Codec.readCollection(bis, error_report_serialiser_1.ErrorReportSerialiser.read);
	            return new messaging_filter_send_response_1.MessagingFilterSendResponse(0, errors);
	        }
	    };
	    return MessagingFilterSendResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingFilterSendResponseSerialiserClass = MessagingFilterSendResponseSerialiserClass;
	/**
	 * The {@link MessagingFilterSendResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingFilterSendResponseSerialiser = new MessagingFilterSendResponseSerialiserClass();


/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server result of from a ... request.
	 */
	var MessagingFilterSendResponse = /** @class */ (function () {
	    /**
	     * Create a new MessagingFilterSendResponse instance
	     *
	     * @param numberSent  the number of sessions the request was sent to
	     * @param errors      any errors that occurred
	     */
	    function MessagingFilterSendResponse(numberSent, errors) {
	        this.numberSent = numberSent;
	        this.errors = errors;
	        this.isSuccess = (errors.length === 0);
	    }
	    return MessagingFilterSendResponse;
	}());
	exports.MessagingFilterSendResponse = MessagingFilterSendResponse;


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server result from a messaging request.
	 */
	var MessagingResponse = /** @class */ (function () {
	    /**
	     * Create a new MessagingResponse instance
	     *
	     * @param responseDataType  the response data type
	     * @param data  the the buffer containing the data
	     */
	    function MessagingResponse(responseDataType, data) {
	        this.responseDataType = responseDataType;
	        this.data = data;
	    }
	    return MessagingResponse;
	}());
	exports.MessagingResponse = MessagingResponse;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var messaging_send_request_1 = __webpack_require__(1268);
	/**
	 * Serialiser for {@link MessagingSendRequest}
	 */
	var MessagingSendRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MessagingSendRequestSerialiserClass, _super);
	    function MessagingSendRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MessagingSendRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link MessagingSendRequest} that was read
	     */
	    MessagingSendRequestSerialiserClass.prototype.read = function (bis) {
	        var path = Codec.readString(bis);
	        var dataType = Codec.readString(bis);
	        var request = Codec.readBytes(bis);
	        return new messaging_send_request_1.MessagingSendRequest(path, dataType, request);
	    };
	    /**
	     * Write a {@link MessagingSendRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MessagingSendRequest} to be written
	     */
	    MessagingSendRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.dataType);
	        Codec.writeBytes(bos, value.request);
	    };
	    return MessagingSendRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MessagingSendRequestSerialiserClass = MessagingSendRequestSerialiserClass;
	/**
	 * The {@link MessagingSendRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MessagingSendRequestSerialiser = new MessagingSendRequestSerialiserClass();


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a MESSAGING_SEND request.
	 */
	var MessagingSendRequest = /** @class */ (function () {
	    /**
	     * Create a new MessagingSendRequest instance
	     *
	     * @param path  the message path
	     * @param dataType  the datatype of the message
	     * @param request  the message data
	     */
	    function MessagingSendRequest(path, dataType, request) {
	        this.path = path;
	        this.dataType = dataType;
	        this.request = request;
	    }
	    return MessagingSendRequest;
	}());
	exports.MessagingSendRequest = MessagingSendRequest;


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A reason for closing the session
	 */
	var SessionCloseReason;
	(function (SessionCloseReason) {
	    SessionCloseReason[SessionCloseReason["CONNECTION_LOST"] = 0] = "CONNECTION_LOST";
	    SessionCloseReason[SessionCloseReason["IO_EXCEPTION"] = 1] = "IO_EXCEPTION";
	    SessionCloseReason[SessionCloseReason["CLIENT_UNRESPONSIVE"] = 2] = "CLIENT_UNRESPONSIVE";
	    SessionCloseReason[SessionCloseReason["MESSAGE_QUEUE_LIMIT_REACHED"] = 3] = "MESSAGE_QUEUE_LIMIT_REACHED";
	    SessionCloseReason[SessionCloseReason["CLOSED_BY_CLIENT"] = 4] = "CLOSED_BY_CLIENT";
	    SessionCloseReason[SessionCloseReason["MESSAGE_TOO_LARGE"] = 5] = "MESSAGE_TOO_LARGE";
	    SessionCloseReason[SessionCloseReason["INTERNAL_ERROR"] = 6] = "INTERNAL_ERROR";
	    SessionCloseReason[SessionCloseReason["INVALID_INBOUND_MESSAGE"] = 7] = "INVALID_INBOUND_MESSAGE";
	    SessionCloseReason[SessionCloseReason["ABORT"] = 8] = "ABORT";
	    SessionCloseReason[SessionCloseReason["LOST_MESSAGES"] = 9] = "LOST_MESSAGES";
	    SessionCloseReason[SessionCloseReason["SERVER_CLOSING"] = 10] = "SERVER_CLOSING";
	    SessionCloseReason[SessionCloseReason["CLOSED_BY_CONTROLLER"] = 11] = "CLOSED_BY_CONTROLLER";
	})(SessionCloseReason = exports.SessionCloseReason || (exports.SessionCloseReason = {}));


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_properties_event_serialiser_1 = __webpack_require__(1272);
	var session_properties_event_batch_1 = __webpack_require__(1271);
	/**
	 * Serialiser for {@link SessionPropertiesEventBatch}
	 */
	var SessionPropertiesEventBatchSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionPropertiesEventBatchSerialiserClass, _super);
	    function SessionPropertiesEventBatchSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionPropertiesEventBatch} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionPropertiesEventBatch} that was read
	     */
	    SessionPropertiesEventBatchSerialiserClass.prototype.read = function (bis) {
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        var events = Codec.readCollection(bis, session_properties_event_serialiser_1.SessionPropertiesEventSerialiser.read);
	        return new session_properties_event_batch_1.SessionPropertiesEventBatch(cid, events);
	    };
	    return SessionPropertiesEventBatchSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionPropertiesEventBatchSerialiserClass = SessionPropertiesEventBatchSerialiserClass;
	/**
	 * The {@link SessionPropertiesEventBatchSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionPropertiesEventBatchSerialiser = new SessionPropertiesEventBatchSerialiserClass();


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SESSION_PROPERTIES_EVENT_2 request.
	 */
	var SessionPropertiesEventBatch = /** @class */ (function () {
	    /**
	     * Create a new SessionPropertiesEventBatch instance
	     *
	     * @param cid  the conversation ID
	     * @param events  the session property events
	     */
	    function SessionPropertiesEventBatch(cid, events) {
	        this.cid = cid;
	        this.events = events;
	    }
	    return SessionPropertiesEventBatch;
	}());
	exports.SessionPropertiesEventBatch = SessionPropertiesEventBatch;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var session_close_reason_1 = __webpack_require__(1269);
	var session_id_serialiser_1 = __webpack_require__(67);
	var session_properties_event_1 = __webpack_require__(1273);
	var session_properties_event_type_1 = __webpack_require__(516);
	var UpdateEntryType;
	(function (UpdateEntryType) {
	    /**
	     * Indicates a new property.
	     *
	     * Will be followed by the new value.
	     */
	    UpdateEntryType[UpdateEntryType["NEW"] = 1] = "NEW";
	    /**
	     * Indicates a changed property.
	     *
	     * Will be followed by the old value and the new value.
	     */
	    UpdateEntryType[UpdateEntryType["CHANGE"] = 2] = "CHANGE";
	    /**
	     * Indicates a removed property.
	     *
	     * Will be followed by the old value.
	     */
	    UpdateEntryType[UpdateEntryType["REMOVE"] = 3] = "REMOVE";
	    /**
	     * Indicate no change.
	     *
	     * Will be followed by the current value.
	     */
	    UpdateEntryType[UpdateEntryType["SAME"] = 4] = "SAME";
	})(UpdateEntryType || (UpdateEntryType = {}));
	function completeReadUpdateEvent(bis, sessionId) {
	    var updateType = Codec.readByte(bis);
	    var oldProperties = {};
	    var newProperties = {};
	    var size = Codec.readInt32(bis);
	    for (var i = 0; i < size; ++i) {
	        var key = Codec.readString(bis);
	        var type = BEES.read(bis, UpdateEntryType);
	        switch (type) {
	            case UpdateEntryType.NEW:
	                oldProperties[key] = null;
	                newProperties[key] = Codec.readString(bis);
	                break;
	            case UpdateEntryType.CHANGE:
	                oldProperties[key] = Codec.readString(bis);
	                newProperties[key] = Codec.readString(bis);
	                break;
	            case UpdateEntryType.REMOVE:
	                oldProperties[key] = Codec.readString(bis);
	                break;
	            case UpdateEntryType.SAME:
	                newProperties[key] = Codec.readString(bis);
	                break;
	            default:
	                throw new Error("Invalid update entry type: type");
	        }
	    }
	    return new session_properties_event_1.SessionPropertiesEvent(sessionId, session_properties_event_type_1.SessionPropertiesEventType.UPDATE, updateType, oldProperties, newProperties);
	}
	/**
	 * Serialiser for {@link SessionPropertiesEvent}
	 */
	var SessionPropertiesEventSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionPropertiesEventSerialiserClass, _super);
	    function SessionPropertiesEventSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionPropertiesEvent} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionPropertiesEvent} that was read
	     */
	    SessionPropertiesEventSerialiserClass.prototype.read = function (bis) {
	        var sessionId = session_id_serialiser_1.SessionIdSerialiser.read(bis);
	        var type = BEES.read(bis, session_properties_event_type_1.SessionPropertiesEventType);
	        switch (type) {
	            case session_properties_event_type_1.SessionPropertiesEventType.OPEN:
	                var oldPropertiesOpen = Codec.readDictionary(bis, Codec.readString);
	                return new session_properties_event_1.SessionPropertiesEvent(sessionId, type, undefined, oldPropertiesOpen);
	            case session_properties_event_type_1.SessionPropertiesEventType.UPDATE:
	                return completeReadUpdateEvent(bis, sessionId);
	            case session_properties_event_type_1.SessionPropertiesEventType.CLOSE:
	                var closeReason = BEES.read(bis, session_close_reason_1.SessionCloseReason);
	                var oldPropertiesClose = Codec.readDictionary(bis, Codec.readString);
	                return new session_properties_event_1.SessionPropertiesEvent(sessionId, type, undefined, oldPropertiesClose, undefined, closeReason);
	            default:
	                throw new Error('Unknown session properties event type: ' + type);
	        }
	    };
	    return SessionPropertiesEventSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionPropertiesEventSerialiserClass = SessionPropertiesEventSerialiserClass;
	/**
	 * The {@link SessionPropertiesEventSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionPropertiesEventSerialiser = new SessionPropertiesEventSerialiserClass();


/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SESSION_PROPERTIES_EVENT request.
	 */
	var SessionPropertiesEvent = /** @class */ (function () {
	    /**
	     * Create a new SessionPropertiesEvent instance
	     *
	     * @param sessionId      the target session ID
	     * @param type           the type of the event
	     * @param updateType     in case of an UPDATE event, the type of the update
	     * @param oldProperties  the old session properties
	     * @param newProperties  the new session properties
	     * @param closeReason    the reason for closing the session
	     */
	    function SessionPropertiesEvent(sessionId, type, updateType, oldProperties, newProperties, closeReason) {
	        this.sessionId = sessionId;
	        this.type = type;
	        this.updateType = updateType;
	        this.oldProperties = oldProperties;
	        this.newProperties = newProperties;
	        this.closeReason = closeReason;
	    }
	    return SessionPropertiesEvent;
	}());
	exports.SessionPropertiesEvent = SessionPropertiesEvent;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link SetClientConflationFilterRequest}
	 */
	var SetClientConflationFilterRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetClientConflationFilterRequestSerialiserClass, _super);
	    function SetClientConflationFilterRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SetClientConflationFilterRequest} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link SetClientConflationFilterRequest} to be written
	     */
	    SetClientConflationFilterRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.filter);
	        Codec.writeBoolean(bos, value.conflate);
	    };
	    return SetClientConflationFilterRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetClientConflationFilterRequestSerialiserClass = SetClientConflationFilterRequestSerialiserClass;
	/**
	 * The {@link SetClientConflationFilterRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetClientConflationFilterRequestSerialiser = new SetClientConflationFilterRequestSerialiserClass();


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SET_CLIENT_CONFLATION_FILTER request.
	 */
	var SetClientConflationFilterRequest = /** @class */ (function () {
	    /**
	     * Create a new SetClientConflationFilterRequest instance
	     *
	     * @param filter    a session filter
	     * @param conflate  enable or disable conflation
	     */
	    function SetClientConflationFilterRequest(filter, conflate) {
	        this.filter = filter;
	        this.conflate = conflate;
	    }
	    return SetClientConflationFilterRequest;
	}());
	exports.SetClientConflationFilterRequest = SetClientConflationFilterRequest;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	/**
	 * Serialiser for {@link SetClientConflationRequest}
	 */
	var SetClientConflationRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetClientConflationRequestSerialiserClass, _super);
	    function SetClientConflationRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SetClientConflationRequest} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link SetClientConflationRequest} to be written
	     */
	    SetClientConflationRequestSerialiserClass.prototype.write = function (bos, value) {
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
	        Codec.writeBoolean(bos, value.conflate);
	    };
	    return SetClientConflationRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetClientConflationRequestSerialiserClass = SetClientConflationRequestSerialiserClass;
	/**
	 * The {@link SetClientConflationRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetClientConflationRequestSerialiser = new SetClientConflationRequestSerialiserClass();


/***/ }),
/* 1277 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SET_CLIENT_CONFLATION request.
	 */
	var SetClientConflationRequest = /** @class */ (function () {
	    /**
	     * Create a new SetClientConflationRequest instance
	     *
	     * @param sessionID a session ID
	     * @param conflate  enable or disable conflation
	     */
	    function SetClientConflationRequest(sessionID, conflate) {
	        this.sessionID = sessionID;
	        this.conflate = conflate;
	    }
	    return SetClientConflationRequest;
	}());
	exports.SetClientConflationRequest = SetClientConflationRequest;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link SetSessionPropertiesFilterRequest}
	 */
	var SetSessionPropertiesFilterRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetSessionPropertiesFilterRequestSerialiserClass, _super);
	    function SetSessionPropertiesFilterRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SetSessionPropertiesFilterRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SetSessionPropertiesFilterRequest} to be written
	     */
	    SetSessionPropertiesFilterRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.filter);
	        if (Object.keys(value.overwriteProperties).length === 0) {
	            Codec.writeByte(bos, 0);
	        }
	        else {
	            Codec.writeByte(bos, 1);
	            Codec.writeDictionary(bos, value.overwriteProperties, Codec.writeString);
	        }
	        if (Object.keys(value.removeProperties).length === 0) {
	            Codec.writeByte(bos, 0);
	        }
	        else {
	            Codec.writeByte(bos, 1);
	            Codec.writeCollection(bos, value.removeProperties, Codec.writeString);
	        }
	    };
	    return SetSessionPropertiesFilterRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetSessionPropertiesFilterRequestSerialiserClass = SetSessionPropertiesFilterRequestSerialiserClass;
	/**
	 * The {@link SetSessionPropertiesFilterRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetSessionPropertiesFilterRequestSerialiser = new SetSessionPropertiesFilterRequestSerialiserClass();


/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SET_SESSION_PROPERTIES_FILTER request.
	 */
	var SetSessionPropertiesFilterRequest = /** @class */ (function () {
	    /**
	     * Create a new SetSessionPropertiesFilterRequest instance
	     *
	     * @param filter  the filter
	     * @param overwriteProperties  the properties to modify
	     * @param removeProperties  the properties to remove
	     */
	    function SetSessionPropertiesFilterRequest(filter, overwriteProperties, removeProperties) {
	        this.filter = filter;
	        this.overwriteProperties = overwriteProperties;
	        this.removeProperties = removeProperties;
	    }
	    return SetSessionPropertiesFilterRequest;
	}());
	exports.SetSessionPropertiesFilterRequest = SetSessionPropertiesFilterRequest;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link SetSessionPropertiesListener}
	 */
	var SetSessionPropertiesListenerSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetSessionPropertiesListenerSerialiserClass, _super);
	    function SetSessionPropertiesListenerSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SetSessionPropertiesListener} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SetSessionPropertiesListener} to be written
	     */
	    SetSessionPropertiesListenerSerialiserClass.prototype.write = function (bos, value) {
	        if (value.properties) {
	            Codec.writeInt32(bos, 0);
	            Codec.writeCollection(bos, value.properties, Codec.writeString);
	        }
	        else {
	            Codec.writeInt32(bos, 1);
	        }
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return SetSessionPropertiesListenerSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetSessionPropertiesListenerSerialiserClass = SetSessionPropertiesListenerSerialiserClass;
	/**
	 * The {@link SetSessionPropertiesListenerSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetSessionPropertiesListenerSerialiser = new SetSessionPropertiesListenerSerialiserClass();


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_id_serialiser_1 = __webpack_require__(67);
	/**
	 * Serialiser for {@link SetSessionPropertiesRequest}
	 */
	var SetSessionPropertiesRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetSessionPropertiesRequestSerialiserClass, _super);
	    function SetSessionPropertiesRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SetSessionPropertiesRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SetSessionPropertiesRequest} to be written
	     */
	    SetSessionPropertiesRequestSerialiserClass.prototype.write = function (bos, value) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (value.sessionID === undefined || value.sessionID === null) {
	            throw new Error('Session ID is null or undefined');
	        }
	        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
	        if (Object.keys(value.overwriteProperties).length === 0) {
	            Codec.writeByte(bos, 0);
	        }
	        else {
	            Codec.writeByte(bos, 1);
	            Codec.writeDictionary(bos, value.overwriteProperties, Codec.writeString);
	        }
	        if (Object.keys(value.removeProperties).length === 0) {
	            Codec.writeByte(bos, 0);
	        }
	        else {
	            Codec.writeByte(bos, 1);
	            Codec.writeCollection(bos, value.removeProperties, Codec.writeString);
	        }
	    };
	    return SetSessionPropertiesRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetSessionPropertiesRequestSerialiserClass = SetSessionPropertiesRequestSerialiserClass;
	/**
	 * The {@link SetSessionPropertiesRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetSessionPropertiesRequestSerialiser = new SetSessionPropertiesRequestSerialiserClass();


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var set_session_properties_result_1 = __webpack_require__(1283);
	/**
	 * Serialiser for {@link SetSessionPropertiesResult}
	 */
	var SetSessionPropertiesResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetSessionPropertiesResultSerialiserClass, _super);
	    function SetSessionPropertiesResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SetSessionPropertiesResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SetSessionPropertiesResult} that was read
	     */
	    SetSessionPropertiesResultSerialiserClass.prototype.read = function (bis) {
	        var changedProperties;
	        var newProperties;
	        var mapOption = Codec.readByte(bis);
	        if (mapOption === 0) {
	            changedProperties = {};
	        }
	        else {
	            changedProperties = Codec.readDictionary(bis, Codec.readString);
	        }
	        var listOption = Codec.readByte(bis);
	        if (listOption === 0) {
	            newProperties = [];
	        }
	        else {
	            newProperties = Codec.readCollection(bis, Codec.readString);
	        }
	        return new set_session_properties_result_1.SetSessionPropertiesResult(changedProperties, newProperties);
	    };
	    return SetSessionPropertiesResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetSessionPropertiesResultSerialiserClass = SetSessionPropertiesResultSerialiserClass;
	/**
	 * The {@link SetSessionPropertiesResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetSessionPropertiesResultSerialiser = new SetSessionPropertiesResultSerialiserClass();


/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server result of from a SET_SESSION_PROPERTIES request.
	 */
	var SetSessionPropertiesResult = /** @class */ (function () {
	    /**
	     * Create a new SetSessionPropertiesResult instance
	     *
	     * @param changedProperties  the properties that have changed
	     * @param newProperties      the properties that have been added
	     */
	    function SetSessionPropertiesResult(changedProperties, newProperties) {
	        var e_1, _a, e_2, _b;
	        this.properties = {};
	        try {
	            for (var _c = __values(Object.getOwnPropertyNames(changedProperties)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var k = _d.value;
	                this.properties[k] = changedProperties[k];
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        try {
	            for (var newProperties_1 = __values(newProperties), newProperties_1_1 = newProperties_1.next(); !newProperties_1_1.done; newProperties_1_1 = newProperties_1.next()) {
	                var p = newProperties_1_1.value;
	                this.properties[p] = null;
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (newProperties_1_1 && !newProperties_1_1.done && (_b = newProperties_1.return)) _b.call(newProperties_1);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	    }
	    return SetSessionPropertiesResult;
	}());
	exports.SetSessionPropertiesResult = SetSessionPropertiesResult;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Control
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var serialiser_1 = __webpack_require__(4);
	var topic_control_registration_params_serialiser_1 = __webpack_require__(517);
	/**
	 * Serialiser for {@link TopicControlRegistrationRequest}
	 */
	var TopicControlRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicControlRegistrationRequestSerialiserClass, _super);
	    function TopicControlRegistrationRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TopicControlRegistrationRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicControlRegistrationRequest} to be written
	     */
	    TopicControlRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
	        topic_control_registration_params_serialiser_1.TopicControlRegistrationParamsSerialiser.write(bos, value.params);
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return TopicControlRegistrationRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicControlRegistrationRequestSerialiserClass = TopicControlRegistrationRequestSerialiserClass;
	/**
	 * The {@link TopicControlRegistrationRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicControlRegistrationRequestSerialiser = new TopicControlRegistrationRequestSerialiserClass();


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Send
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var count_or_parser_errors_1 = __webpack_require__(1286);
	var error_report_serialiser_1 = __webpack_require__(233);
	/**
	 * Serialiser for {@link CountOrParserErrors}.
	 */
	var CountOrParserErrorsSerialiserClass = /** @class */ (function (_super) {
	    __extends(CountOrParserErrorsSerialiserClass, _super);
	    function CountOrParserErrorsSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link CountOrParserErrors} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link CountOrParserErrors} that was read
	     */
	    CountOrParserErrorsSerialiserClass.prototype.read = function (bis) {
	        var count = Codec.readInt32(bis);
	        var errors = Codec.readCollection(bis, error_report_serialiser_1.ErrorReportSerialiser.read);
	        return new count_or_parser_errors_1.CountOrParserErrors(count, errors);
	    };
	    /**
	     * Write a {@link CountOrParserErrors} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link CountOrParserErrors} to be written
	     */
	    CountOrParserErrorsSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.count);
	        Codec.writeCollection(bos, value.errors, error_report_serialiser_1.ErrorReportSerialiser.write);
	    };
	    return CountOrParserErrorsSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CountOrParserErrorsSerialiserClass = CountOrParserErrorsSerialiserClass;
	/**
	 * The {@link CountOrParserErrorsSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CountOrParserErrorsSerialiser = new CountOrParserErrorsSerialiserClass();


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Send
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Response from service that provides a count or a list of errors.
	 */
	var CountOrParserErrors = /** @class */ (function () {
	    /**
	     * Create a new CountOrParserErrors instance.
	     *
	     * @param sent  the number of sessions that the message was sent to
	     * @param errors  any errors that occurred
	     */
	    function CountOrParserErrors(count, errors) {
	        this.count = require_non_null_1.requireNonNull(count, 'count');
	        this.errors = require_non_null_1.requireNonNull(errors, 'errors');
	    }
	    return CountOrParserErrors;
	}());
	exports.CountOrParserErrors = CountOrParserErrors;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Result that either succeed or fail with parser errors.
	 */
	var ErrorReportList = /** @class */ (function () {
	    /**
	     * Create a new ErrorReportList
	     *
	     * @param errors a list of error reports; empty if successful
	     */
	    function ErrorReportList(errors) {
	        this.errors = require_non_null_1.requireNonNull(errors, 'errors');
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the object
	     */
	    ErrorReportList.prototype.toString = function () {
	        return 'ErrorReportList [' + this.errors + ']';
	    };
	    return ErrorReportList;
	}());
	exports.ErrorReportList = ErrorReportList;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of {@link ErrorReport}
	 */
	var ErrorReportImpl = /** @class */ (function () {
	    /**
	     * Create an error report
	     *
	     * @param  message  the error message
	     * @param  line     the line at which the problem was found
	     * @param  column   the column at which the problem was found
	     */
	    function ErrorReportImpl(message, line, column) {
	        this.message = require_non_null_1.requireNonNull(message, 'message');
	        this.line = line || 0;
	        this.column = column || 0;
	    }
	    /**
	     * Convert object to string
	     *
	     * @return a string representation of the object
	     */
	    ErrorReportImpl.prototype.toString = function () {
	        return "ErrorReport [" + this.message + " at [" + this.line + ":" + this.column + "]]";
	    };
	    return ErrorReportImpl;
	}());
	exports.ErrorReportImpl = ErrorReportImpl;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.FetchJMXValues
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var jmx_fetch_request_1 = __webpack_require__(519);
	/**
	 * Serialiser for {@link JMXFetchRequest}
	 */
	var JMXFetchRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(JMXFetchRequestSerialiserClass, _super);
	    function JMXFetchRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link JMXFetchRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link JMXFetchRequest} that was read
	     */
	    JMXFetchRequestSerialiserClass.prototype.read = function (bis) {
	        var names = Codec.readCollection(bis, Codec.readString);
	        var isClustered = Codec.readBoolean(bis);
	        return new jmx_fetch_request_1.JMXFetchRequest(names, isClustered);
	    };
	    /**
	     * Write a {@link JMXFetchRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link JMXFetchRequest} to be written
	     */
	    JMXFetchRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeCollection(bos, value.names, Codec.writeString);
	        Codec.writeBoolean(bos, value.isClustered);
	    };
	    return JMXFetchRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.JMXFetchRequestSerialiserClass = JMXFetchRequestSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.JMXFetchRequestSerialiser = new JMXFetchRequestSerialiserClass();


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.FetchJMXValues
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_reason_serialiser_1 = __webpack_require__(518);
	var mbean_values_serialiser_1 = __webpack_require__(1291);
	/**
	 * Serialiser for {@link JMXFetchResponse}
	 */
	var JMXFetchResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(JMXFetchResponseSerialiserClass, _super);
	    function JMXFetchResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link JMXFetchResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link JMXFetchResponse} that was read
	     */
	    JMXFetchResponseSerialiserClass.prototype.read = function (bis) {
	        return Codec.readDictionary(bis, this.readWrapper);
	    };
	    /**
	     * Write a {@link JMXFetchResponse} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link JMXFetchResponse} to be written
	     */
	    JMXFetchResponseSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeDictionary(bos, value, this.writeWrapper);
	    };
	    JMXFetchResponseSerialiserClass.prototype.readWrapper = function (bis) {
	        switch (Codec.readByte(bis)) {
	            case 0:
	                return mbean_values_serialiser_1.MBeanValuesSerialiser.read(bis);
	            default:
	            case 1:
	                return error_reason_serialiser_1.ErrorReasonSerialiser.read(bis);
	        }
	    };
	    JMXFetchResponseSerialiserClass.prototype.writeWrapper = function (bos, value) {
	        if (this.isErrorReason(value)) {
	            Codec.writeByte(bos, 1);
	            error_reason_serialiser_1.ErrorReasonSerialiser.write(bos, value);
	        }
	        else {
	            Codec.writeByte(bos, 0);
	            mbean_values_serialiser_1.MBeanValuesSerialiser.write(bos, value);
	        }
	    };
	    JMXFetchResponseSerialiserClass.prototype.isErrorReason = function (input) {
	        return 'reason' in input;
	    };
	    return JMXFetchResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.JMXFetchResponseSerialiserClass = JMXFetchResponseSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.JMXFetchResponseSerialiser = new JMXFetchResponseSerialiserClass();


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.FetchJMXValues
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var consts_1 = __webpack_require__(174);
	var decoder_1 = __webpack_require__(123);
	var encoder_1 = __webpack_require__(224);
	var encoder = new encoder_1.Encoder();
	/**
	 * Serialiser for {@link MBeanValues}
	 */
	var MBeanValuesSerialiserClass = /** @class */ (function (_super) {
	    __extends(MBeanValuesSerialiserClass, _super);
	    function MBeanValuesSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MBeanValues} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link MBeanValues} that was read
	     */
	    MBeanValuesSerialiserClass.prototype.read = function (bis) {
	        var buffer = Codec.readBytes(bis);
	        var decoder = new decoder_1.Decoder(buffer);
	        var parsed = decoder.nextValueExpecting(function (type) { return type === consts_1.types.MAP; });
	        return parsed; // there must be a better way to apply this constraint on the parsed value
	    };
	    /**
	     * Write a {@link MBeanValues} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MBeanValues} to be written
	     */
	    MBeanValuesSerialiserClass.prototype.write = function (bos, value) {
	        encoder.encode(value);
	        Codec.writeBytes(bos, encoder.flush());
	    };
	    return MBeanValuesSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MBeanValuesSerialiserClass = MBeanValuesSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MBeanValuesSerialiser = new MBeanValuesSerialiserClass();


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.FetchQuery
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var fetch_topic_result_1 = __webpack_require__(1296);
	var topic_type_1 = __webpack_require__(69);
	var fetch_query_result_1 = __webpack_require__(1293);
	/**
	 * Read a property map from the stream
	 *
	 * @param bis  the input stream
	 * @return     the property map that was read
	 */
	function readProperties(bis) {
	    return Codec.readDictionary(bis, Codec.readString);
	}
	/**
	 * Read a {@link FetchTopicResult} from the stream
	 *
	 * @param bis  the input stream
	 * @return     the {@link FetchTopicResult} that was read
	 */
	function readFetchTopicResult(bis) {
	    var path = Codec.readString(bis);
	    var type = BEES.read(bis, topic_type_1.TopicTypeEnum);
	    var valueOption = Codec.readByte(bis);
	    var value = (valueOption !== 0) ? Codec.readBytes(bis) : undefined;
	    var propertiesIndex = Codec.readInt32(bis);
	    return new fetch_topic_result_1.FetchTopicResult(path, type, propertiesIndex, value);
	}
	/**
	 * Serialiser for {@link FetchQueryResult}
	 */
	var FetchQueryResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(FetchQueryResultSerialiserClass, _super);
	    function FetchQueryResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link FetchQueryResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link FetchQueryResult} that was read
	     */
	    FetchQueryResultSerialiserClass.prototype.read = function (bis) {
	        var properties = Codec.readCollection(bis, readProperties);
	        var results = Codec.readCollection(bis, readFetchTopicResult);
	        var hasMore = Codec.readBoolean(bis);
	        return new fetch_query_result_1.FetchQueryResult(properties, results, hasMore);
	    };
	    return FetchQueryResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.FetchQueryResultSerialiserClass = FetchQueryResultSerialiserClass;
	/**
	 * The {@link FetchQueryResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.FetchQueryResultSerialiser = new FetchQueryResultSerialiserClass();


/***/ }),
/* 1293 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.FetchQuery
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server result from a FETCH_QUERY request.
	 */
	var FetchQueryResult = /** @class */ (function () {
	    /**
	     * Create a new FetchQueryResult instance
	     *
	     * @param properties  the topic specification properties
	     * @param results  the topics that have been fetched
	     * @param hasMore  s flag indicating that there are more topics that can be fetched
	     */
	    function FetchQueryResult(properties, results, hasMore) {
	        this.properties = properties;
	        this.results = results;
	        this.hasMore = hasMore;
	    }
	    return FetchQueryResult;
	}());
	exports.FetchQueryResult = FetchQueryResult;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.FetchQuery
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var LEESS = __webpack_require__(1235);
	var serialiser_1 = __webpack_require__(4);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	/**
	 * Write a {@link Limit} to the stream
	 *
	 * @param bos    the output stream
	 * @param value  the {@link Limit} to be written
	 */
	function writeLimit(bos, limit) {
	    if (limit === undefined) {
	        Codec.writeByte(bos, 0);
	    }
	    else {
	        Codec.writeByte(bos, 1);
	        Codec.writeString(bos, limit.path);
	        Codec.writeBoolean(bos, limit.includesPath);
	    }
	}
	/**
	 * Write a {@link FetchRange} to the stream
	 *
	 * @param bos    the output stream
	 * @param value  the {@link FetchRange} to be written
	 */
	function writeRange(bos, range) {
	    writeLimit(bos, range.from);
	    writeLimit(bos, range.to);
	}
	/**
	 * Serialiser for {@link FetchQuery}
	 */
	var FetchQuerySerialiserClass = /** @class */ (function (_super) {
	    __extends(FetchQuerySerialiserClass, _super);
	    function FetchQuerySerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link FetchQuery} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link FetchQuery} to be written
	     */
	    FetchQuerySerialiserClass.prototype.write = function (bos, value) {
	        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
	        writeRange(bos, value.range);
	        LEESS.write(bos, value.topicTypes);
	        Codec.writeBoolean(bos, value.withValues);
	        Codec.writeBoolean(bos, value.withProperties);
	        Codec.writeInt32(bos, value.limit);
	        Codec.writeInt32(bos, value.maximumResultSize);
	        Codec.writeInt32(bos, value.deepBranchDepth);
	        Codec.writeInt32(bos, value.deepBranchLimit);
	        Codec.writeBoolean(bos, value.withUnpublishedDelayedTopics);
	    };
	    return FetchQuerySerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.FetchQuerySerialiserClass = FetchQuerySerialiserClass;
	/**
	 * The {@link FetchRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.FetchQuerySerialiser = new FetchQuerySerialiserClass();


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.FetchQuery
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Data type for a FETCH_QUERY request.
	 */
	var FetchQuery = /** @class */ (function () {
	    /**
	     * Create a new FetchQueryResult instance
	     *
	     * @param selector  the topic selector
	     * @param range  the fetch range
	     * @param topicTypes  the topic types to include in the fetch request
	     * @param withValues  whether to fetch topic values
	     * @param withProperties  whether to fetch topic properties
	     * @param limit  the limit on the number of results returned
	     * @param maximumResultSize  the maximum result size
	     * @param deepBranchDepth  the minimum number of parts in a path that belongs to a "deep" branch
	     * @param deepBranchLimit  the maximum number of paths to return for each deep branch
	     * @param withUnpublishedDelayedTopics whether unpublished delayed topics should be included in the results
	     */
	    function FetchQuery(selector, range, topicTypes, withValues, withProperties, limit, maximumResultSize, deepBranchDepth, deepBranchLimit, withUnpublishedDelayedTopics) {
	        this.selector = require_non_null_1.requireNonNull(selector, 'FetchQuery.selector');
	        this.range = range;
	        this.topicTypes = require_non_null_1.requireNonNull(topicTypes, 'FetchQuery.topicTypes');
	        this.withValues = withValues;
	        this.withProperties = withProperties;
	        this.limit = limit;
	        this.maximumResultSize = maximumResultSize;
	        this.deepBranchDepth = deepBranchDepth;
	        this.deepBranchLimit = deepBranchLimit;
	        this.withUnpublishedDelayedTopics = withUnpublishedDelayedTopics;
	    }
	    return FetchQuery;
	}());
	exports.FetchQuery = FetchQuery;


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.FetchQuery
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type contained in the {@link FetchQueryResult} response.
	 */
	var FetchTopicResult = /** @class */ (function () {
	    /**
	     * Create a new FetchTopicResult instance
	     *
	     * @param path  the topic path
	     * @param type  the topic type
	     * @param value  the value of the topic in case it was requested
	     * @param propertiesIndex  the properties index
	     */
	    function FetchTopicResult(path, type, propertiesIndex, value) {
	        this.path = path;
	        this.type = type;
	        this.value = value;
	        this.propertiesIndex = propertiesIndex;
	    }
	    return FetchTopicResult;
	}());
	exports.FetchTopicResult = FetchTopicResult;


/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gateway response from either adding or updating a service.
	 */
	var AddUpdateServiceResponse = /** @class */ (function () {
	    /**
	     * Create a new AddUpdateServiceResponse instance
	     * @param type the response type
	     * @param service the returned service
	     */
	    function AddUpdateServiceResponse(type, service) {
	        this.type = type;
	        this.service = service;
	    }
	    return AddUpdateServiceResponse;
	}());
	exports.AddUpdateServiceResponse = AddUpdateServiceResponse;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST add service request.
	 */
	var GatewayClientAddServiceRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientAddServiceRequest, _super);
	    /**
	     * Create a new GatewayClientAddServiceRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceDetails  details for gateway service to create
	     */
	    function GatewayClientAddServiceRequest(sessionId, serviceDetails) {
	        var _this = _super.call(this, sessionId) || this;
	        /**
	         * The request type
	         */
	        _this.type = gateway_request_type_1.GatewayRequestType.ADD_SERVICE;
	        _this.serviceDetails = serviceDetails;
	        return _this;
	    }
	    return GatewayClientAddServiceRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientAddServiceRequest = GatewayClientAddServiceRequest;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST get configuration request.
	 */
	var GatewayClientGetConfigurationRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientGetConfigurationRequest, _super);
	    /**
	     * Create a new GatewayClientGetConfigurationRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     */
	    function GatewayClientGetConfigurationRequest(sessionId) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_CONFIGURATION;
	        return _this;
	    }
	    return GatewayClientGetConfigurationRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientGetConfigurationRequest = GatewayClientGetConfigurationRequest;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST get services request.
	 */
	var GatewayClientGetServiceTypesRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientGetServiceTypesRequest, _super);
	    /**
	     * Create a new GatewayClientGetServiceTypesRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     */
	    function GatewayClientGetServiceTypesRequest(sessionId) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_TYPES;
	        return _this;
	    }
	    return GatewayClientGetServiceTypesRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientGetServiceTypesRequest = GatewayClientGetServiceTypesRequest;


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST get services request.
	 */
	var GatewayClientGetServicesRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientGetServicesRequest, _super);
	    /**
	     * Create a new GatewayClientGetServicesRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     */
	    function GatewayClientGetServicesRequest(sessionId) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICES;
	        return _this;
	    }
	    return GatewayClientGetServicesRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientGetServicesRequest = GatewayClientGetServicesRequest;


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST get status request.
	 */
	var GatewayClientGetStatusRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientGetStatusRequest, _super);
	    /**
	     * Create a new GatewayClientGetStatusRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     */
	    function GatewayClientGetStatusRequest(sessionId) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_STATUS;
	        return _this;
	    }
	    return GatewayClientGetStatusRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientGetStatusRequest = GatewayClientGetStatusRequest;


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var gateway_client_key_serialiser_1 = __webpack_require__(520);
	/**
	 * Serialiser for {@link GatewayClientList}
	 */
	var GatewayClientListSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayClientListSerialiserClass, _super);
	    function GatewayClientListSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayClientList} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayClientList} that was read
	     */
	    GatewayClientListSerialiserClass.prototype.read = function (bis) {
	        return {
	            clients: Codec.readCollection(bis, gateway_client_key_serialiser_1.GatewayClientKeySerialiser.read)
	        };
	    };
	    return GatewayClientListSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayClientListSerialiserClass = GatewayClientListSerialiserClass;
	/**
	 * The {@link GatewayClientListSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayClientListSerialiser = new GatewayClientListSerialiserClass();


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST update service request.
	 */
	var GatewayClientUpdateServiceRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientUpdateServiceRequest, _super);
	    /**
	     * Create a new GatewayClientUpdateServiceRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceDetails  updated service details
	     */
	    function GatewayClientUpdateServiceRequest(sessionId, serviceDetails) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.UPDATE_SERVICE;
	        _this.serviceDetails = serviceDetails;
	        return _this;
	    }
	    return GatewayClientUpdateServiceRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientUpdateServiceRequest = GatewayClientUpdateServiceRequest;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var gateway_request_type_1 = __webpack_require__(33);
	var get_configuration_response_1 = __webpack_require__(1306);
	var get_status_response_1 = __webpack_require__(1309);
	var get_operation_detail_response_1 = __webpack_require__(1313);
	var get_operations_response_1 = __webpack_require__(1314);
	var invoke_operation_response_1 = __webpack_require__(1315);
	var operation_serialiser_1 = __webpack_require__(1316);
	var status_item_serialiser_1 = __webpack_require__(1324);
	var add_update_service_response_1 = __webpack_require__(1297);
	var gateway_client_request_serialiser_1 = __webpack_require__(521);
	var get_service_types_response_1 = __webpack_require__(1307);
	var get_services_response_1 = __webpack_require__(1308);
	var service_detail_serialiser_1 = __webpack_require__(522);
	var service_type_serialiser_1 = __webpack_require__(1323);
	/**
	 * Serialiser for {@link GatewayResponse}
	 */
	var GatewayResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayResponseSerialiserClass, _super);
	    function GatewayResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayResponse} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayResponse} that was read
	     */
	    // tslint:disable-next-line: cyclomatic-complexity
	    GatewayResponseSerialiserClass.prototype.read = function (bis) {
	        var type = BEES.read(bis, gateway_request_type_1.GatewayRequestType);
	        switch (type) {
	            case gateway_request_type_1.GatewayRequestType.GET_CONFIGURATION:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_CONFIGURATION:
	                return new get_configuration_response_1.GetConfigurationResponse(type, Codec.readByte(bis), Codec.readString(bis), Codec.readString(bis));
	            case gateway_request_type_1.GatewayRequestType.GET_STATUS:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_STATUS:
	                return new get_status_response_1.GetStatusResponse(type, Codec.readCollection(bis, status_item_serialiser_1.StatusItemSerialiser.read));
	            case gateway_request_type_1.GatewayRequestType.GET_OPERATIONS:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATIONS:
	                return new get_operations_response_1.GetOperationsResponse(type, Codec.readCollection(bis, operation_serialiser_1.GatewayOperationSerialiser.read));
	            case gateway_request_type_1.GatewayRequestType.GET_OPERATION_DETAIL:
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATION_DETAIL:
	                return new get_operation_detail_response_1.GetOperationDetailResponse(type, Codec.readString(bis), Codec.readByte(bis) ? Codec.readString(bis) : undefined, Codec.readByte(bis) ? Codec.readString(bis) : undefined);
	            case gateway_request_type_1.GatewayRequestType.INVOKE_OPERATION:
	            case gateway_request_type_1.GatewayRequestType.INVOKE_SERVICE_OPERATION:
	                return new invoke_operation_response_1.InvokeOperationResponse(type, Codec.readByte(bis) ? Codec.readString(bis) : undefined);
	            case gateway_request_type_1.GatewayRequestType.ADD_SERVICE:
	            case gateway_request_type_1.GatewayRequestType.UPDATE_SERVICE:
	                return new add_update_service_response_1.AddUpdateServiceResponse(type, service_detail_serialiser_1.GatewayServiceSerialiser.read(bis));
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICES:
	                return new get_services_response_1.GetServicesResponse(Codec.readCollection(bis, service_detail_serialiser_1.GatewayServiceSerialiser.read));
	            case gateway_request_type_1.GatewayRequestType.GET_SERVICE_TYPES:
	                return new get_service_types_response_1.GetServiceTypesResponse(Codec.readCollection(bis, service_type_serialiser_1.GatewayServiceTypeSerialiser.read));
	            case gateway_request_type_1.GatewayRequestType.REMOVE_SERVICE:
	                // Requests which only return an acknoledgement
	                return { type: type };
	            default:
	                throw new gateway_client_request_serialiser_1.UnknownGatewayRequestTypeError(type);
	        }
	    };
	    return GatewayResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayResponseSerialiserClass = GatewayResponseSerialiserClass;
	/**
	 * The {@link GatewayResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayResponseSerialiser = new GatewayResponseSerialiserClass();


/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gateway response from a get configuration request.
	 */
	var GetConfigurationResponse = /** @class */ (function () {
	    /**
	     * Create a new GetConfigurationResponse instance
	     * @param type response type
	     * @param schemaType the type of the schema (not currently used)
	     * @param schema the schema data
	     * @param config the config data
	     */
	    function GetConfigurationResponse(type, schemaType, schema, config) {
	        this.type = type;
	        this.config = config;
	        this.schemaType = schemaType;
	        this.schema = schema;
	    }
	    return GetConfigurationResponse;
	}());
	exports.GetConfigurationResponse = GetConfigurationResponse;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Gateway response from a get service types request.
	 */
	var GetServiceTypesResponse = /** @class */ (function () {
	    /**
	     * Create a new GetOperationsResponse instance
	     *
	     * @param serviceTypes the service types
	     */
	    function GetServiceTypesResponse(serviceTypes) {
	        /**
	         * Required for round-trip serialiser tests.
	         */
	        this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_TYPES;
	        this.serviceTypes = serviceTypes;
	    }
	    return GetServiceTypesResponse;
	}());
	exports.GetServiceTypesResponse = GetServiceTypesResponse;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Gateway response from a get services request.
	 */
	var GetServicesResponse = /** @class */ (function () {
	    /**
	     * Create a new GetOperationsResponse instance
	     *
	     * @param services the services
	     */
	    function GetServicesResponse(services) {
	        /**
	         * Required for round-trip serialiser tests.
	         */
	        this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICES;
	        this.services = services;
	    }
	    return GetServicesResponse;
	}());
	exports.GetServicesResponse = GetServicesResponse;


/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gateway client instance response from a get status request.
	 */
	var GetStatusResponse = /** @class */ (function () {
	    /**
	     * Create a new GetStatusResponse instance
	     *
	     * @param type response type
	     * @param items the items
	     */
	    function GetStatusResponse(type, items) {
	        this.type = type;
	        this.items = items;
	    }
	    return GetStatusResponse;
	}());
	exports.GetStatusResponse = GetStatusResponse;


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST get operation detail request.
	 */
	var GatewayClientGetOperationDetailRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientGetOperationDetailRequest, _super);
	    /**
	     * Create a new GatewayClientGetOperationDetailRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param operationName  the name of the operation to get details for
	     */
	    function GatewayClientGetOperationDetailRequest(sessionId, operationName) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_OPERATION_DETAIL;
	        _this.operationName = operationName;
	        return _this;
	    }
	    return GatewayClientGetOperationDetailRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientGetOperationDetailRequest = GatewayClientGetOperationDetailRequest;


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST get operations request.
	 */
	var GatewayClientGetOperationsRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientGetOperationsRequest, _super);
	    /**
	     * Create a new GatewayClientGetOperationsRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     */
	    function GatewayClientGetOperationsRequest(sessionId) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_OPERATIONS;
	        return _this;
	    }
	    return GatewayClientGetOperationsRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientGetOperationsRequest = GatewayClientGetOperationsRequest;


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var base_gateway_client_request_1 = __webpack_require__(81);
	var gateway_request_type_1 = __webpack_require__(33);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST invoke operation request.
	 */
	var GatewayClientInvokeOperationRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientInvokeOperationRequest, _super);
	    /**
	     * Create a new GatewayClientInvokeOperationRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param operationName  the name of the operation to invoke
	     * @param input  optional input data in the form of a JSON string
	     */
	    function GatewayClientInvokeOperationRequest(sessionId, operationName, input) {
	        var _this = _super.call(this, sessionId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.INVOKE_OPERATION;
	        _this.operationName = operationName;
	        _this.input = input;
	        return _this;
	    }
	    return GatewayClientInvokeOperationRequest;
	}(base_gateway_client_request_1.BaseGatewayClientRequest));
	exports.GatewayClientInvokeOperationRequest = GatewayClientInvokeOperationRequest;


/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gateway response from a get operation detail request.
	 */
	var GetOperationDetailResponse = /** @class */ (function () {
	    /**
	     * Create a new GetOperationDetailResponse instance
	     *
	     * @param type response type
	     * @param description a detailed description of the operation
	     * @param inputSchema JSON schema for the input of the operation (optional)
	     * @param outputSchema JSOn schema for the output of the operation (optional)
	     */
	    function GetOperationDetailResponse(type, description, inputSchema, outputSchema) {
	        this.type = type;
	        this.description = description;
	        this.inputSchema = inputSchema;
	        this.outputSchema = outputSchema;
	    }
	    return GetOperationDetailResponse;
	}());
	exports.GetOperationDetailResponse = GetOperationDetailResponse;


/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gateway response from a get operations request.
	 */
	var GetOperationsResponse = /** @class */ (function () {
	    /**
	     * Create a new GetOperationsResponse instance
	     *
	     * @param type response type
	     * @param operations the operations
	     */
	    function GetOperationsResponse(type, operations) {
	        this.type = type;
	        this.operations = operations;
	    }
	    return GetOperationsResponse;
	}());
	exports.GetOperationsResponse = GetOperationsResponse;


/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gateway response following invocation of an operation.
	 */
	var InvokeOperationResponse = /** @class */ (function () {
	    /**
	     * Create a new InvokeOperationResponse instance
	     * @param type response type
	     * @param output the output of the operation, if there was any.
	     */
	    function InvokeOperationResponse(type, output) {
	        this.type = type;
	        this.output = output;
	    }
	    return InvokeOperationResponse;
	}());
	exports.InvokeOperationResponse = InvokeOperationResponse;


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link GatewayOperation} (non-detailed).
	 */
	var GatewayOperationSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayOperationSerialiserClass, _super);
	    function GatewayOperationSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayOperation} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayOperation} that was read
	     */
	    GatewayOperationSerialiserClass.prototype.read = function (bis) {
	        var name = Codec.readString(bis);
	        var summary = Codec.readString(bis);
	        return {
	            name: name,
	            summary: summary
	        };
	    };
	    /**
	     * Write a {@link GatewayOperation} from the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GatewayOperation} to write
	     */
	    GatewayOperationSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeString(bos, value.summary);
	    };
	    return GatewayOperationSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayOperationSerialiserClass = GatewayOperationSerialiserClass;
	/**
	 * The {@link GatewayOperationSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayOperationSerialiser = new GatewayOperationSerialiserClass();


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST remove service request.
	 */
	var GatewayClientRemoveServiceRequest = /** @class */ (function (_super) {
	    __extends(GatewayClientRemoveServiceRequest, _super);
	    /**
	     * Create a new GatewayClientRemoveServiceRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceId  the gateway service id
	     */
	    function GatewayClientRemoveServiceRequest(sessionId, serviceId) {
	        var _this = _super.call(this, sessionId, serviceId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.REMOVE_SERVICE;
	        return _this;
	    }
	    return GatewayClientRemoveServiceRequest;
	}(base_gateway_service_request_1.BaseGatewayServiceRequest));
	exports.GatewayClientRemoveServiceRequest = GatewayClientRemoveServiceRequest;


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted get configuration request.
	 */
	var GatewayServiceGetConfigurationRequest = /** @class */ (function (_super) {
	    __extends(GatewayServiceGetConfigurationRequest, _super);
	    /**
	     * Create a new GatewayServiceGetConfigurationRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceId  the targeted service id
	     */
	    function GatewayServiceGetConfigurationRequest(sessionId, serviceId) {
	        var _this = _super.call(this, sessionId, serviceId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_CONFIGURATION;
	        return _this;
	    }
	    return GatewayServiceGetConfigurationRequest;
	}(base_gateway_service_request_1.BaseGatewayServiceRequest));
	exports.GatewayServiceGetConfigurationRequest = GatewayServiceGetConfigurationRequest;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted get operation detail request.
	 */
	var GatewayServiceGetOperationDetailRequest = /** @class */ (function (_super) {
	    __extends(GatewayServiceGetOperationDetailRequest, _super);
	    /**
	     * Create a new GatewayServiceGetOperationDetailRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceId  the service id
	     * @param operationName  the name of the operation to get details for
	     */
	    function GatewayServiceGetOperationDetailRequest(sessionId, serviceId, operationName) {
	        var _this = _super.call(this, sessionId, serviceId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATION_DETAIL;
	        _this.operationName = operationName;
	        return _this;
	    }
	    return GatewayServiceGetOperationDetailRequest;
	}(base_gateway_service_request_1.BaseGatewayServiceRequest));
	exports.GatewayServiceGetOperationDetailRequest = GatewayServiceGetOperationDetailRequest;


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted get operations request.
	 */
	var GatewayServiceGetOperationsRequest = /** @class */ (function (_super) {
	    __extends(GatewayServiceGetOperationsRequest, _super);
	    /**
	     * Create a new GatewayServiceGetOperationsRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceId  the targeted service id
	     */
	    function GatewayServiceGetOperationsRequest(sessionId, serviceId) {
	        var _this = _super.call(this, sessionId, serviceId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATIONS;
	        return _this;
	    }
	    return GatewayServiceGetOperationsRequest;
	}(base_gateway_service_request_1.BaseGatewayServiceRequest));
	exports.GatewayServiceGetOperationsRequest = GatewayServiceGetOperationsRequest;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted get status request.
	 */
	var GatewayServiceGetStatusRequest = /** @class */ (function (_super) {
	    __extends(GatewayServiceGetStatusRequest, _super);
	    /**
	     * Create a new GatewayServiceGetStatusRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceId  the targeted service id
	     */
	    function GatewayServiceGetStatusRequest(sessionId, serviceId) {
	        var _this = _super.call(this, sessionId, serviceId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_STATUS;
	        return _this;
	    }
	    return GatewayServiceGetStatusRequest;
	}(base_gateway_service_request_1.BaseGatewayServiceRequest));
	exports.GatewayServiceGetStatusRequest = GatewayServiceGetStatusRequest;


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_request_type_1 = __webpack_require__(33);
	var base_gateway_service_request_1 = __webpack_require__(126);
	/**
	 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted invoke operation request.
	 */
	var GatewayServiceInvokeOperationRequest = /** @class */ (function (_super) {
	    __extends(GatewayServiceInvokeOperationRequest, _super);
	    /**
	     * Create a new GatewayServiceInvokeOperationRequest instance
	     *
	     * @param sessionId  the gateway client session id
	     * @param serviceId  the service id
	     * @param operationName  the name of the operation to invoke
	     * @param input  optional input data in the form of a JSON string
	     */
	    function GatewayServiceInvokeOperationRequest(sessionId, serviceId, operationName, input) {
	        var _this = _super.call(this, sessionId, serviceId) || this;
	        _this.type = gateway_request_type_1.GatewayRequestType.INVOKE_SERVICE_OPERATION;
	        _this.operationName = operationName;
	        _this.input = input;
	        return _this;
	    }
	    return GatewayServiceInvokeOperationRequest;
	}(base_gateway_service_request_1.BaseGatewayServiceRequest));
	exports.GatewayServiceInvokeOperationRequest = GatewayServiceInvokeOperationRequest;


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link GatewayServiceType}
	 */
	var GatewayServiceTypeSerialiserClass = /** @class */ (function (_super) {
	    __extends(GatewayServiceTypeSerialiserClass, _super);
	    function GatewayServiceTypeSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link GatewayServiceType} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link GatewayServiceType} that was read
	     */
	    GatewayServiceTypeSerialiserClass.prototype.read = function (bis) {
	        var name = Codec.readString(bis);
	        var desc = Codec.readString(bis);
	        var schema = Codec.readString(bis);
	        return {
	            name: name,
	            description: desc,
	            schema: schema
	        };
	    };
	    /**
	     * Write a {@link GatewayServiceId} from the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link GatewayServiceId} to write
	     */
	    GatewayServiceTypeSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeString(bos, value.description);
	        Codec.writeString(bos, value.schema);
	    };
	    return GatewayServiceTypeSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.GatewayServiceTypeSerialiserClass = GatewayServiceTypeSerialiserClass;
	/**
	 * The {@link GatewayServiceTypeSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.GatewayServiceTypeSerialiser = new GatewayServiceTypeSerialiserClass();


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.GatewayControl
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_control_1 = __webpack_require__(332);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link StatusItem}
	 */
	var StatusItemSerialiserClass = /** @class */ (function (_super) {
	    __extends(StatusItemSerialiserClass, _super);
	    function StatusItemSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link StatusItem} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link StatusItem} that was read
	     */
	    StatusItemSerialiserClass.prototype.read = function (bis) {
	        var level = BEES.read(bis, gateway_control_1.StatusLevel);
	        var timestamp = Codec.readInt64(bis);
	        var title = Codec.readString(bis);
	        var description = Codec.readString(bis);
	        return {
	            level: level,
	            timestamp: timestamp,
	            title: title,
	            description: description
	        };
	    };
	    return StatusItemSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.StatusItemSerialiserClass = StatusItemSerialiserClass;
	/**
	 * The {@link StatusItemSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.StatusItemSerialiser = new StatusItemSerialiserClass();


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var gateway_client_key_serialiser_1 = __webpack_require__(520);
	var gateway_client_list_serialiser_1 = __webpack_require__(1303);
	var gateway_client_request_serialiser_1 = __webpack_require__(521);
	var gateway_response_serialiser_1 = __webpack_require__(1305);
	var service_definition_1 = __webpack_require__(51);
	exports.GATEWAY_CLIENT_REQUEST = {
	    id: 170,
	    request: gateway_client_request_serialiser_1.GatewayClientRequestSerialiser,
	    response: gateway_response_serialiser_1.GatewayResponseSerialiser
	};
	exports.REGISTER_GATEWAY_CLIENT = {
	    id: 173,
	    request: gateway_client_key_serialiser_1.GatewayClientKeySerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.REMOVE_GATEWAY_CLIENT = {
	    id: 174,
	    request: gateway_client_key_serialiser_1.GatewayClientKeySerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.GET_GATEWAY_CLIENTS = {
	    id: 175,
	    request: service_definition_1.NullSerialiser,
	    response: gateway_client_list_serialiser_1.GatewayClientListSerialiser
	};


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var entries_fetch_request_serialiser_1 = __webpack_require__(1327);
	var entries_fetch_response_serialiser_1 = __webpack_require__(1328);
	exports.FETCH_LOG_ENTRIES_SERVICE = {
	    id: 132,
	    request: entries_fetch_request_serialiser_1.EntriesFetchRequestSerialiser,
	    response: entries_fetch_response_serialiser_1.EntriesFetchResponseSerialiser
	};


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.LogRetrieval
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var entries_fetch_request_1 = __webpack_require__(524);
	/**
	 * Serialiser for {@link EntriesFetchRequest}
	 */
	var EntriesFetchRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(EntriesFetchRequestSerialiserClass, _super);
	    function EntriesFetchRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link EntriesFetchRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link EntriesFetchRequest} that was read
	     */
	    EntriesFetchRequestSerialiserClass.prototype.read = function (bis) {
	        var firstEntry = Codec.readInt64(bis);
	        var entryCount = Codec.readInt64(bis);
	        return new entries_fetch_request_1.EntriesFetchRequest(firstEntry, entryCount);
	    };
	    /**
	     * Write a {@link EntriesFetchRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link EntriesFetchRequest} to be written
	     */
	    EntriesFetchRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt64(bos, value.firstEntry);
	        Codec.writeInt64(bos, value.entryCount);
	    };
	    return EntriesFetchRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.EntriesFetchRequestSerialiserClass = EntriesFetchRequestSerialiserClass;
	/**
	 * The {@link EntriesFetchRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.EntriesFetchRequestSerialiser = new EntriesFetchRequestSerialiserClass();


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.LogRetrieval
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var entries_fetch_response_1 = __webpack_require__(1329);
	/**
	 * Serialiser for {@link EntriesFetchResponse}
	 */
	var EntriesFetchResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(EntriesFetchResponseSerialiserClass, _super);
	    function EntriesFetchResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link EntriesFetchResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link EntriesFetchResponse} that was read
	     */
	    EntriesFetchResponseSerialiserClass.prototype.read = function (bis) {
	        var firstEntry = Codec.readInt64(bis);
	        var entryCount = Codec.readInt64(bis);
	        var maxEntriesAvailable = Codec.readInt64(bis);
	        var firstLineNumber = Codec.readInt64(bis);
	        var entries = Codec.readBytes(bis);
	        var fileId = Codec.readInt64(bis);
	        return new entries_fetch_response_1.EntriesFetchResponse(firstEntry, entryCount, fileId, maxEntriesAvailable, firstLineNumber, entries);
	    };
	    /**
	     * Write a {@link EntriesFetchResponse} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link EntriesFetchResponse} to be written
	     */
	    EntriesFetchResponseSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt64(bos, value.firstEntry);
	        Codec.writeInt64(bos, value.entryCount);
	        Codec.writeInt64(bos, value.maxEntriesAvailable);
	        Codec.writeInt64(bos, value.firstLineNumber);
	        Codec.writeBytes(bos, value.entries);
	        Codec.writeInt64(bos, value.fileId);
	    };
	    return EntriesFetchResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.EntriesFetchResponseSerialiserClass = EntriesFetchResponseSerialiserClass;
	/**
	 * The {@link EntriesFetchResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.EntriesFetchResponseSerialiser = new EntriesFetchResponseSerialiserClass();


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.LogRetrieval
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server response from a FETCH_LOG_ENTRIES_SERVICE request.
	 */
	var EntriesFetchResponse = /** @class */ (function () {
	    /**
	     * Create a new EntriesFetchResponse instance
	     *
	     * @param firstEntry  the index of the first entry
	     * @param entryCount  the number of entries that were fetched
	     * @param fileId  the iteration of the data available from the provider
	     * @param maxEntriesAvailable  the maximum available number of entries
	     * @param firstLineNumber  the first line number
	     * @param entries  the entries
	     */
	    function EntriesFetchResponse(firstEntry, entryCount, fileId, maxEntriesAvailable, firstLineNumber, entries) {
	        this.firstEntry = firstEntry;
	        this.entryCount = entryCount;
	        this.fileId = fileId;
	        this.maxEntriesAvailable = maxEntriesAvailable;
	        this.firstLineNumber = firstLineNumber;
	        this.entries = entries;
	    }
	    return EntriesFetchResponse;
	}());
	exports.EntriesFetchResponse = EntriesFetchResponse;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var service_definition_1 = __webpack_require__(51);
	var messaging_client_forward_send_request_serialiser_1 = __webpack_require__(1258);
	var messaging_client_send_request_serialiser_1 = __webpack_require__(1260);
	var messaging_filter_response_serialiser_1 = __webpack_require__(1261);
	var messaging_filter_send_request_serialiser_1 = __webpack_require__(1263);
	var messaging_filter_send_response_serialiser_1 = __webpack_require__(1264);
	var messaging_response_serialiser_1 = __webpack_require__(515);
	var messaging_send_request_serialiser_1 = __webpack_require__(1267);
	exports.MESSAGING_SEND = {
	    id: 85,
	    request: messaging_send_request_serialiser_1.MessagingSendRequestSerialiser,
	    response: messaging_response_serialiser_1.MessagingResponseSerialiser
	};
	exports.MESSAGING_RECEIVER_SERVER = {
	    id: 86,
	    request: messaging_client_send_request_serialiser_1.MessagingClientSendRequestSerialiser,
	    response: messaging_response_serialiser_1.MessagingResponseSerialiser
	};
	exports.MESSAGING_RECEIVER_CLIENT = {
	    id: 88,
	    request: messaging_client_forward_send_request_serialiser_1.MessagingClientForwardSendRequestSerialiser,
	    response: messaging_response_serialiser_1.MessagingResponseSerialiser
	};
	exports.MESSAGING_FILTER_SEND = {
	    id: 102,
	    request: messaging_filter_send_request_serialiser_1.MessagingFilterSendRequestSerialiser,
	    response: messaging_filter_send_response_serialiser_1.MessagingFilterSendResponseSerialiser
	};
	exports.FILTER_RESPONSE = {
	    id: 103,
	    request: messaging_filter_response_serialiser_1.MessagingFilterResponseSerialiser,
	    response: service_definition_1.NullSerialiser
	};


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_metric_collector_list_1 = __webpack_require__(1332);
	var session_metric_collector_serialiser_1 = __webpack_require__(526);
	/**
	 * Serialiser for {@link SessionMetricCollectorList}
	 */
	var SessionMetricCollectorListSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionMetricCollectorListSerialiserClass, _super);
	    function SessionMetricCollectorListSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionMetricCollector} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionMetricCollectorList} that was read
	     */
	    SessionMetricCollectorListSerialiserClass.prototype.read = function (bis) {
	        var collectors = Codec.readCollection(bis, session_metric_collector_serialiser_1.SessionMetricCollectorSerialiser.read);
	        return new session_metric_collector_list_1.SessionMetricCollectorListImpl(collectors);
	    };
	    /**
	     * Write a {@link SessionMetricCollector} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SessionMetricCollectorList} to be written
	     */
	    SessionMetricCollectorListSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeCollection(bos, value.collectors, session_metric_collector_serialiser_1.SessionMetricCollectorSerialiser.write);
	    };
	    return SessionMetricCollectorListSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionMetricCollectorListSerialiserClass = SessionMetricCollectorListSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionMetricCollectorListSerialiser = new SessionMetricCollectorListSerialiserClass();


/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A list of session metric collectors.
	 */
	var SessionMetricCollectorListImpl = /** @class */ (function () {
	    /**
	     * Create a new SessionMetricCollector instance
	     *
	     * @param collectors the collectors
	     */
	    function SessionMetricCollectorListImpl(collectors) {
	        this.collectors = collectors;
	    }
	    return SessionMetricCollectorListImpl;
	}());
	exports.SessionMetricCollectorListImpl = SessionMetricCollectorListImpl;


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_metric_collector_list_1 = __webpack_require__(1334);
	var topic_metric_collector_serialiser_1 = __webpack_require__(528);
	/**
	 * Serialiser for {@link TopicMetricCollectorList}
	 */
	var TopicMetricCollectorListSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicMetricCollectorListSerialiserClass, _super);
	    function TopicMetricCollectorListSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link TopicMetricCollector} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the instance that was read
	     */
	    TopicMetricCollectorListSerialiserClass.prototype.read = function (bis) {
	        var collectors = Codec.readCollection(bis, topic_metric_collector_serialiser_1.TopicMetricCollectorSerialiser.read);
	        return new topic_metric_collector_list_1.TopicMetricCollectorListImpl(collectors);
	    };
	    /**
	     * Write a {@link TopicMetricCollector} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the instance to be written
	     */
	    TopicMetricCollectorListSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeCollection(bos, value.collectors, topic_metric_collector_serialiser_1.TopicMetricCollectorSerialiser.write);
	    };
	    return TopicMetricCollectorListSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicMetricCollectorListSerialiserClass = TopicMetricCollectorListSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicMetricCollectorListSerialiser = new TopicMetricCollectorListSerialiserClass();


/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.MetricCollectors
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A list of topic metric collectors.
	 */
	var TopicMetricCollectorListImpl = /** @class */ (function () {
	    /**
	     * Create a new TopicMetricCollector instance
	     *
	     * @param collectors the collectors
	     */
	    function TopicMetricCollectorListImpl(collectors) {
	        this.collectors = collectors;
	    }
	    return TopicMetricCollectorListImpl;
	}());
	exports.TopicMetricCollectorListImpl = TopicMetricCollectorListImpl;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var string_serialiser_1 = __webpack_require__(145);
	var error_report_list_serialiser_1 = __webpack_require__(178);
	var service_definition_1 = __webpack_require__(51);
	var jmx_fetch_request_serialiser_1 = __webpack_require__(1289);
	var jmx_fetch_response_serialiser_1 = __webpack_require__(1290);
	var session_metric_collector_list_serialiser_1 = __webpack_require__(1331);
	var session_metric_collector_serialiser_1 = __webpack_require__(526);
	var topic_metric_collector_list_serialiser_1 = __webpack_require__(1333);
	var topic_metric_collector_serialiser_1 = __webpack_require__(528);
	var measured_entity_class_metrics_serialiser_1 = __webpack_require__(1336);
	var measured_entity_class_request_serialiser_1 = __webpack_require__(1338);
	var server_metrics_serialiser_1 = __webpack_require__(1339);
	exports.PUT_SESSION_METRIC_COLLECTOR = {
	    id: 135,
	    request: session_metric_collector_serialiser_1.SessionMetricCollectorSerialiser,
	    response: error_report_list_serialiser_1.ErrorReportListSerialiser
	};
	exports.REMOVE_SESSION_METRIC_COLLECTOR = {
	    id: 136,
	    request: string_serialiser_1.StringSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.LIST_SESSION_METRIC_COLLECTORS = {
	    id: 137,
	    request: service_definition_1.NullSerialiser,
	    response: session_metric_collector_list_serialiser_1.SessionMetricCollectorListSerialiser
	};
	exports.GET_SERVER_METRICS = {
	    id: 142,
	    request: service_definition_1.NullSerialiser,
	    response: server_metrics_serialiser_1.ServerMetricsSerialiser
	};
	exports.GET_MEASURED_ENTITY_CLASS_METRICS = {
	    id: 145,
	    request: measured_entity_class_request_serialiser_1.MeasuredEntityClassRequestSerialiser,
	    response: measured_entity_class_metrics_serialiser_1.MeasuredEntityClassMetricsSerialiser
	};
	exports.PUT_TOPIC_METRIC_COLLECTOR = {
	    id: 146,
	    request: topic_metric_collector_serialiser_1.TopicMetricCollectorSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.REMOVE_TOPIC_METRIC_COLLECTOR = {
	    id: 147,
	    request: string_serialiser_1.StringSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.LIST_TOPIC_METRIC_COLLECTORS = {
	    id: 148,
	    request: service_definition_1.NullSerialiser,
	    response: topic_metric_collector_list_serialiser_1.TopicMetricCollectorListSerialiser
	};
	exports.FETCH_JMX_VALUES = {
	    id: 149,
	    request: jmx_fetch_request_serialiser_1.JMXFetchRequestSerialiser,
	    response: jmx_fetch_response_serialiser_1.JMXFetchResponseSerialiser
	};


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Metrics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var measured_entity_class_metrics_1 = __webpack_require__(1337);
	function readStringArrayMap(bis, valueReader) {
	    return Codec.readMap(bis, function (i) { return Codec.readCollection(i, Codec.readString); }, valueReader);
	}
	function writeStringArrayMap(bos, value, valueWriter) {
	    Codec.writeMap(bos, value, function (o, k) { return Codec.writeCollection(o, k, Codec.writeString); }, valueWriter);
	}
	/**
	 * Serialiser for {@link MeasuredEntityClassMetrics}
	 */
	var MeasuredEntityClassMetricsSerialiserClass = /** @class */ (function (_super) {
	    __extends(MeasuredEntityClassMetricsSerialiserClass, _super);
	    function MeasuredEntityClassMetricsSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MeasuredEntityClassMetrics} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the instance that was read
	     */
	    MeasuredEntityClassMetricsSerialiserClass.prototype.read = function (bis) {
	        var metricNames = Codec.readCollection(bis, Codec.readString);
	        var values = readStringArrayMap(bis, function (i) { return readStringArrayMap(i, function (i2) { return Codec.readCollection(i2, Codec.readInt64); }); });
	        return new measured_entity_class_metrics_1.MeasuredEntityClassMetrics(metricNames, values);
	    };
	    /**
	     * Write a {@link MeasuredEntityClassMetrics} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the instance to be written
	     */
	    MeasuredEntityClassMetricsSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeCollection(bos, value.metricNames, Codec.writeString);
	        writeStringArrayMap(bos, value.values, function (o, v) { return writeStringArrayMap(o, v, function (o2, v2) { return Codec.writeCollection(o2, v2, Codec.writeInt64); }); });
	    };
	    return MeasuredEntityClassMetricsSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MeasuredEntityClassMetricsSerialiserClass = MeasuredEntityClassMetricsSerialiserClass;
	/**
	 * The singleton
	 */
	// tslint:disable-next-line:variable-name
	exports.MeasuredEntityClassMetricsSerialiser = new MeasuredEntityClassMetricsSerialiserClass();


/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Metrics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A snapshot of all metrics for a measured entity class.
	 */
	var MeasuredEntityClassMetrics = /** @class */ (function () {
	    function MeasuredEntityClassMetrics(metricNames, values) {
	        this.metricNames = metricNames;
	        this.values = values;
	    }
	    return MeasuredEntityClassMetrics;
	}());
	exports.MeasuredEntityClassMetrics = MeasuredEntityClassMetrics;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Metrics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var measured_entity_class_request_1 = __webpack_require__(530);
	/**
	 * Serialiser for {@link MeasuredEntityClassRequest}
	 */
	var MeasuredEntityClassRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MeasuredEntityClassRequestSerialiserClass, _super);
	    function MeasuredEntityClassRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MeasuredEntityClassRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the instance that was read
	     */
	    MeasuredEntityClassRequestSerialiserClass.prototype.read = function (bis) {
	        var entityClass = Codec.readString(bis);
	        var serverName = Codec.readByte(bis) === 1 ? Codec.readString(bis) : undefined;
	        return new measured_entity_class_request_1.MeasuredEntityClassRequest(entityClass, serverName);
	    };
	    /**
	     * Write a {@link MeasuredEntityClassRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the instance to be written
	     */
	    MeasuredEntityClassRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.entityClass);
	        if (value.serverName !== undefined) {
	            Codec.writeByte(bos, 1);
	            Codec.writeString(bos, value.serverName);
	        }
	        else {
	            Codec.writeByte(bos, 0);
	        }
	    };
	    return MeasuredEntityClassRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MeasuredEntityClassRequestSerialiserClass = MeasuredEntityClassRequestSerialiserClass;
	/**
	 * The singleton
	 */
	// tslint:disable-next-line:variable-name
	exports.MeasuredEntityClassRequestSerialiser = new MeasuredEntityClassRequestSerialiserClass();


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Metrics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link ServerMetrics}
	 */
	var ServerMetricsSerialiserClass = /** @class */ (function (_super) {
	    __extends(ServerMetricsSerialiserClass, _super);
	    function ServerMetricsSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ServerMetrics} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the instance that was read
	     */
	    ServerMetricsSerialiserClass.prototype.read = function (bis) {
	        return Codec.readDictionary(bis, function (i) { return Codec.readDictionary(i, Codec.readInt64); });
	    };
	    /**
	     * Write a {@link ServerMetrics} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the instance to be written
	     */
	    ServerMetricsSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeDictionary(bos, value, function (o, v) { return Codec.writeDictionary(o, v, Codec.writeInt64); });
	    };
	    return ServerMetricsSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ServerMetricsSerialiserClass = ServerMetricsSerialiserClass;
	/**
	 * The singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ServerMetricsSerialiser = new ServerMetricsSerialiserClass();


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.MissingTopic
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	var missing_topic_request_1 = __webpack_require__(1341);
	/**
	 * Serialiser for {@link MissingTopicRequest}
	 */
	var MissingTopicRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(MissingTopicRequestSerialiserClass, _super);
	    function MissingTopicRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link MissingTopicRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link MissingTopicRequest} that was read
	     */
	    MissingTopicRequestSerialiserClass.prototype.read = function (bis) {
	        var selector = topic_selector_serialiser_1.TopicSelectorSerialiser.read(bis);
	        var properties = Codec.readDictionary(bis, Codec.readString);
	        var serverNames = Codec.readCollection(bis, Codec.readString);
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        return new missing_topic_request_1.MissingTopicRequest(selector, properties, serverNames, cid);
	    };
	    /**
	     * Write a {@link MissingTopicRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link MissingTopicRequest} to be written
	     */
	    MissingTopicRequestSerialiserClass.prototype.write = function (bos, value) {
	        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
	        Codec.writeDictionary(bos, value.sessionProperties, Codec.writeString);
	        Codec.writeCollection(bos, value.serverNames, Codec.writeString);
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return MissingTopicRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.MissingTopicRequestSerialiserClass = MissingTopicRequestSerialiserClass;
	/**
	 * The {@link MissingTopicRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.MissingTopicRequestSerialiser = new MissingTopicRequestSerialiserClass();


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.MissingTopic
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a MISSING_TOPIC request.
	 */
	var MissingTopicRequest = /** @class */ (function () {
	    /**
	     * Create a new MissingTopicRequest instance
	     *
	     * @param sessionID  the session ID
	     * @param selector  the topic selector
	     * @param cid  the conversation ID
	     */
	    function MissingTopicRequest(selector, sessionProperties, serverNames, cid) {
	        this.selector = selector;
	        this.sessionProperties = sessionProperties;
	        this.serverNames = serverNames;
	        this.cid = cid;
	    }
	    return MissingTopicRequest;
	}());
	exports.MissingTopicRequest = MissingTopicRequest;


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var string_serialiser_1 = __webpack_require__(145);
	var service_definition_1 = __webpack_require__(51);
	var check_remote_server_result_serialiser_1 = __webpack_require__(1343);
	var create_remote_server_result_serialiser_1 = __webpack_require__(1345);
	var list_remote_servers_result_serialiser_1 = __webpack_require__(1347);
	var remote_server_definition_serialiser_1 = __webpack_require__(1350);
	exports.CREATE_REMOTE_SERVER = {
	    id: 157,
	    request: remote_server_definition_serialiser_1.RemoteServerDefinitionSerialiser,
	    response: create_remote_server_result_serialiser_1.CreateRemoteServerResultSerialiser
	};
	exports.REMOVE_REMOTE_SERVER = {
	    id: 158,
	    request: string_serialiser_1.StringSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.LIST_REMOTE_SERVERS = {
	    id: 164,
	    request: service_definition_1.NullSerialiser,
	    response: list_remote_servers_result_serialiser_1.ListRemoteServersResultSerialiser
	};
	exports.CHECK_REMOTE_SERVER = {
	    id: 165,
	    request: string_serialiser_1.StringSerialiser,
	    response: check_remote_server_result_serialiser_1.CheckRemoteServerResultSerialiser
	};


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var serialiser_1 = __webpack_require__(4);
	var check_remote_server_result_1 = __webpack_require__(1344);
	var read_remote_server_status_1 = __webpack_require__(1349);
	/**
	 * Serialiser for {@link CheckRemoteServerResult}
	 */
	var CheckRemoteServerResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(CheckRemoteServerResultSerialiserClass, _super);
	    function CheckRemoteServerResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ListRemoteServersResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ListRemoteServersResult} that was read
	     */
	    CheckRemoteServerResultSerialiserClass.prototype.read = function (bis) {
	        var status = read_remote_server_status_1.readRemoteServerStatus(bis);
	        return new check_remote_server_result_1.CheckRemoteServerResult(status);
	    };
	    return CheckRemoteServerResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CheckRemoteServerResultSerialiserClass = CheckRemoteServerResultSerialiserClass;
	/**
	 * The {@link CheckRemoteServerResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CheckRemoteServerResultSerialiser = new CheckRemoteServerResultSerialiserClass();


/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The response of RemoteServers CHECK_REMOTE_SERVER service
	 */
	var CheckRemoteServerResult = /** @class */ (function () {
	    /**
	     * Create a new CheckRemoteServerResult instance
	     *
	     * @param status  the remote server status
	     */
	    function CheckRemoteServerResult(status) {
	        this.status = status;
	    }
	    return CheckRemoteServerResult;
	}());
	exports.CheckRemoteServerResult = CheckRemoteServerResult;


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_list_serialiser_1 = __webpack_require__(178);
	var read_remote_server_1 = __webpack_require__(532);
	var create_remote_server_result_1 = __webpack_require__(1346);
	/**
	 * Serialiser for {@link CreateRemoteServerResult}
	 */
	var CreateRemoteServerResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(CreateRemoteServerResultSerialiserClass, _super);
	    function CreateRemoteServerResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ListRemoteServersResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ListRemoteServersResult} that was read
	     */
	    CreateRemoteServerResultSerialiserClass.prototype.read = function (bis) {
	        if (bis.peek() === 0) {
	            // consume the zero from the input stream
	            Codec.readByte(bis);
	            var server = read_remote_server_1.readRemoteServer(bis);
	            return new create_remote_server_result_1.CreateRemoteServerResult(server);
	        }
	        else {
	            var errors = error_report_list_serialiser_1.ErrorReportListSerialiser.read(bis);
	            return new create_remote_server_result_1.CreateRemoteServerResult(undefined, errors);
	        }
	    };
	    return CreateRemoteServerResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CreateRemoteServerResultSerialiserClass = CreateRemoteServerResultSerialiserClass;
	/**
	 * The {@link CreateRemoteServerResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CreateRemoteServerResultSerialiser = new CreateRemoteServerResultSerialiserClass();


/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The response of RemoteServers CREATE_REMOTE_SERVER service
	 */
	var CreateRemoteServerResult = /** @class */ (function () {
	    /**
	     * Create a new CreateRemoteServerResult instance
	     *
	     * @param server  the remote server
	     * @param errors  any errors that might have occurred
	     */
	    function CreateRemoteServerResult(server, errors) {
	        this.server = server;
	        this.errors = errors;
	    }
	    return CreateRemoteServerResult;
	}());
	exports.CreateRemoteServerResult = CreateRemoteServerResult;


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var list_remote_servers_result_1 = __webpack_require__(1348);
	var read_remote_server_1 = __webpack_require__(532);
	/**
	 * Serialiser for {@link ListRemoteServersResult}
	 */
	var ListRemoteServersResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(ListRemoteServersResultSerialiserClass, _super);
	    function ListRemoteServersResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ListRemoteServersResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ListRemoteServersResult} that was read
	     */
	    ListRemoteServersResultSerialiserClass.prototype.read = function (bis) {
	        var result = Codec.readCollection(bis, read_remote_server_1.readRemoteServer);
	        return new list_remote_servers_result_1.ListRemoteServersResult(result);
	    };
	    return ListRemoteServersResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ListRemoteServersResultSerialiserClass = ListRemoteServersResultSerialiserClass;
	/**
	 * The {@link ListRemoteServersResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ListRemoteServersResultSerialiser = new ListRemoteServersResultSerialiserClass();


/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The result type of of RemoteServers LIST_REMOTE_SERVERS service
	 */
	var ListRemoteServersResult = /** @class */ (function () {
	    /**
	     * Create a new ListRemoteServersResult instance
	     *
	     * @param result  the array of remote servers
	     */
	    function ListRemoteServersResult(result) {
	        this.result = result;
	    }
	    return ListRemoteServersResult;
	}());
	exports.ListRemoteServersResult = ListRemoteServersResult;


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.RemoteServers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var remote_servers_1 = __webpack_require__(323);
	var BEES = __webpack_require__(25);
	/**
	 * Read a remote server status from the stream
	 *
	 * @param bis  the input stream
	 * @return     the {@link RemoteServerStatus} that was read
	 */
	function readRemoteServerStatus(bis) {
	    var connectionState = BEES.read(bis, remote_servers_1.ConnectionState);
	    var failureMessage = Codec.readString(bis);
	    return {
	        connectionState: connectionState,
	        failureMessage: failureMessage
	    };
	}
	exports.readRemoteServerStatus = readRemoteServerStatus;


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var CredentialsSerialiser = __webpack_require__(232);
	var writeByteViaString = function (bos, sb) { return Codec.writeByte(bos, parseInt(sb, 10)); };
	/**
	 * Serialiser for {@link RemoteServerDefinition}
	 */
	var RemoteServerDefinitionSerialiserClass = /** @class */ (function (_super) {
	    __extends(RemoteServerDefinitionSerialiserClass, _super);
	    function RemoteServerDefinitionSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link RemoteServerDefinition} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link RemoteServerDefinition} to be written
	     */
	    RemoteServerDefinitionSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeString(bos, value.url);
	        Codec.writeString(bos, value.principal);
	        Codec.writeObject(bos, value.connectionOptions, writeByteViaString, Codec.writeString);
	        Codec.writeString(bos, value.missingTopicNotificationFilter !== undefined
	            ? value.missingTopicNotificationFilter
	            : '');
	        CredentialsSerialiser.write(bos, value.credentials);
	    };
	    return RemoteServerDefinitionSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.RemoteServerDefinitionSerialiserClass = RemoteServerDefinitionSerialiserClass;
	/**
	 * The {@link RemoteServerDefinitionSerialiserClass} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.RemoteServerDefinitionSerialiser = new RemoteServerDefinitionSerialiserClass();


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.RemoveTopic
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link RemoveTopic}
	 */
	var RemoveTopicSerialiserClass = /** @class */ (function (_super) {
	    __extends(RemoveTopicSerialiserClass, _super);
	    function RemoveTopicSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link RemoveTopic} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link RemoveTopic} to be written
	     */
	    RemoveTopicSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.selector.expression);
	    };
	    return RemoveTopicSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.RemoveTopicSerialiserClass = RemoveTopicSerialiserClass;
	/**
	 * The {@link RemoveTopicSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.RemoveTopicSerialiser = new RemoveTopicSerialiserClass();


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.ReplaceLicence
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var replace_licence_response_1 = __webpack_require__(1353);
	/**
	 * Serialiser for {@link ReplaceLicenceResponse}
	 */
	var ReplaceLicenceResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(ReplaceLicenceResponseSerialiserClass, _super);
	    function ReplaceLicenceResponseSerialiserClass() {
	        var _this = _super.call(this) || this;
	        _this.responseCode = [];
	        _this.responseCode[0] = 'The license was replaced successfully.';
	        _this.responseCode[1] = 'The provided license does not match this version of Diffusion.';
	        _this.responseCode[2] = 'Diffusion was unable to find the IP address provided within the license.';
	        _this.responseCode[3] = 'The provided license has expired.';
	        _this.responseCode[4] = 'The date on the provided license is not valid.';
	        _this.responseCode[5] = 'The license file is missing.'
	            + 'Please check the read / write permissions of your Diffusion server.';
	        _this.responseCode[6] = 'The licencing service has encountered an unknown error.';
	        _this.responseCode[7] = 'The provided license is not valid for the given IP address(es).';
	        _this.responseCode[8] = 'The provided license is not valid for the given MAC address(es).';
	        _this.responseCode[9] = 'The license file provided cannot be read, and may be corrupt.';
	        _this.responseCode[10] = 'The new license has an non-matching feature set to the current license.\n'
	            + 'Please shut down the server and replace the license manually.';
	        return _this;
	    }
	    ReplaceLicenceResponseSerialiserClass.prototype.read = function (bis) {
	        var result = Codec.readByte(bis);
	        var resString = result in this.responseCode
	            ? this.responseCode[result]
	            : 'An unknown response was received from the server.';
	        return new replace_licence_response_1.ReplaceLicenceResponse(result, resString);
	    };
	    return ReplaceLicenceResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ReplaceLicenceResponseSerialiserClass = ReplaceLicenceResponseSerialiserClass;
	/**
	 * The {@link ReplaceLicenceResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ReplaceLicenceResponseSerialiser = new ReplaceLicenceResponseSerialiserClass();


/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.ReplaceLicence
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a UPDATE_LICENCE response.
	 */
	var ReplaceLicenceResponse = /** @class */ (function () {
	    /**
	     * Create a new ReplaceLicence instance
	     *
	     * @param type  the byte ID of the response
	     * @param resString  the string response of the licence update
	     */
	    function ReplaceLicenceResponse(type, resString) {
	        this.type = type;
	        this.resString = resString;
	    }
	    return ReplaceLicenceResponse;
	}());
	exports.ReplaceLicenceResponse = ReplaceLicenceResponse;


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bytes_serialiser_1 = __webpack_require__(1233);
	var replace_licence_response_serialiser_1 = __webpack_require__(1352);
	exports.UPDATE_LICENSE = {
	    id: 159,
	    request: bytes_serialiser_1.BytesSerialiser,
	    response: replace_licence_response_serialiser_1.ReplaceLicenceResponseSerialiser
	};


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var boolean_serialiser_1 = __webpack_require__(337);
	var string_serialiser_1 = __webpack_require__(145);
	var error_report_list_serialiser_1 = __webpack_require__(178);
	var service_definition_1 = __webpack_require__(51);
	var security_command_script_serialiser_1 = __webpack_require__(1236);
	var system_authentication_configuration_serialiser_1 = __webpack_require__(1238);
	var change_principal_request_serialiser_1 = __webpack_require__(1240);
	var authenticator_registration_parameters_serialiser_1 = __webpack_require__(534);
	var authenticator_registration_request_serialiser_1 = __webpack_require__(1357);
	var authenticator_request_serialiser_1 = __webpack_require__(1359);
	var authenticator_response_serialiser_1 = __webpack_require__(1361);
	var list_global_permissions_result_serialiser_1 = __webpack_require__(1362);
	var list_path_permissions_result_serialiser_1 = __webpack_require__(1364);
	var security_configuration_serialiser_1 = __webpack_require__(1368);
	exports.CHANGE_PRINCIPAL = {
	    id: 5,
	    request: change_principal_request_serialiser_1.ChangePrincipalRequestSerialiser,
	    response: boolean_serialiser_1.BooleanSerialiser
	};
	exports.GET_SYSTEM_AUTHENTICATION = {
	    id: 57,
	    request: service_definition_1.NullSerialiser,
	    response: system_authentication_configuration_serialiser_1.SystemAuthenticationConfigurationSerialiser
	};
	exports.UPDATE_SYSTEM_AUTHENTICATION = {
	    id: 58,
	    request: security_command_script_serialiser_1.SecurityCommandScriptSerialiser,
	    response: error_report_list_serialiser_1.ErrorReportListSerialiser
	};
	exports.GET_SECURITY_CONFIGURATION = {
	    id: 59,
	    request: service_definition_1.NullSerialiser,
	    response: security_configuration_serialiser_1.SecurityConfigurationSerialiser
	};
	exports.UPDATE_SECURITY_CONFIGURATION = {
	    id: 60,
	    request: security_command_script_serialiser_1.SecurityCommandScriptSerialiser,
	    response: error_report_list_serialiser_1.ErrorReportListSerialiser
	};
	exports.AUTHENTICATOR_REGISTRATION = {
	    id: 119,
	    request: authenticator_registration_request_serialiser_1.AuthenticatorRegistrationRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.AUTHENTICATOR = {
	    id: 120,
	    request: authenticator_request_serialiser_1.AuthenticatorRequestSerialiser,
	    response: authenticator_response_serialiser_1.AuthenticatorResponseSerialiser
	};
	exports.AUTHENTICATOR_DEREGISTRATION = {
	    id: 121,
	    request: authenticator_registration_parameters_serialiser_1.AuthenticatorRegistrationParametersSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.LIST_GLOBAL_PERMISSIONS = {
	    id: 143,
	    request: service_definition_1.NullSerialiser,
	    response: list_global_permissions_result_serialiser_1.ListGlobalPermissionsResultSerialiser
	};
	exports.LIST_PATH_PERMISSIONS = {
	    id: 144,
	    request: string_serialiser_1.StringSerialiser,
	    response: list_path_permissions_result_serialiser_1.ListPathPermissionsResultSerialiser
	};


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var control_registration_params_1 = __webpack_require__(513);
	/**
	 * Data type for a AUTHENTICATOR_REGISTRATION request.
	 */
	var AuthenticatorRegistrationParameters = /** @class */ (function (_super) {
	    __extends(AuthenticatorRegistrationParameters, _super);
	    /**
	     * Create a new AuthenticatorRegistrationParameters instance
	     *
	     * @param name        the name of the authenticator handler
	     * @param definition  the service definition
	     * @param group       the control group
	     */
	    function AuthenticatorRegistrationParameters(name, definition, group) {
	        var _this = _super.call(this, definition, group) || this;
	        _this.name = name;
	        return _this;
	    }
	    return AuthenticatorRegistrationParameters;
	}(control_registration_params_1.ControlRegistrationParams));
	exports.AuthenticatorRegistrationParameters = AuthenticatorRegistrationParameters;


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:max-line-length */
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var serialiser_1 = __webpack_require__(4);
	var authenticator_registration_parameters_serialiser_1 = __webpack_require__(534);
	var authenticator_registration_request_1 = __webpack_require__(1358);
	/**
	 * Serialiser for {@link AuthenticatorRegistrationRequest}
	 */
	var AuthenticatorRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(AuthenticatorRegistrationRequestSerialiserClass, _super);
	    function AuthenticatorRegistrationRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AuthenticatorRegistrationRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link AuthenticatorRegistrationRequest} that was read
	     */
	    AuthenticatorRegistrationRequestSerialiserClass.prototype.read = function (bis) {
	        var params = authenticator_registration_parameters_serialiser_1.AuthenticatorRegistrationParametersSerialiser.read(bis);
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        return new authenticator_registration_request_1.AuthenticatorRegistrationRequest(params, cid);
	    };
	    /**
	     * Write a {@link AuthenticatorRegistrationRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link AuthenticatorRegistrationRequest} to be written
	     */
	    AuthenticatorRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
	        authenticator_registration_parameters_serialiser_1.AuthenticatorRegistrationParametersSerialiser.write(bos, value.params);
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return AuthenticatorRegistrationRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.AuthenticatorRegistrationRequestSerialiserClass = AuthenticatorRegistrationRequestSerialiserClass;
	/**
	 * The {@link AuthenticatorRegistrationRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.AuthenticatorRegistrationRequestSerialiser = new AuthenticatorRegistrationRequestSerialiserClass();


/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a AUTHENTICATOR_REGISTRATION request.
	 */
	var AuthenticatorRegistrationRequest = /** @class */ (function () {
	    /**
	     * Create a new AuthenticatorRegistrationRequest instance
	     *
	     * @param params  the authentication control registration parameters
	     * @param cid     the conversation ID
	     */
	    function AuthenticatorRegistrationRequest(params, cid) {
	        this.params = params;
	        this.cid = cid;
	    }
	    return AuthenticatorRegistrationRequest;
	}());
	exports.AuthenticatorRegistrationRequest = AuthenticatorRegistrationRequest;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var CredentialsSerialiser = __webpack_require__(232);
	var authenticator_request_1 = __webpack_require__(1360);
	/**
	 * Serialiser for {@link AuthenticatorRequest}
	 */
	var AuthenticatorRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(AuthenticatorRequestSerialiserClass, _super);
	    function AuthenticatorRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AuthenticatorRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link AuthenticatorRequest} that was read
	     */
	    AuthenticatorRequestSerialiserClass.prototype.read = function (bis) {
	        var principal = Codec.readString(bis);
	        var credentials = CredentialsSerialiser.read(bis);
	        var sessionProperties = Codec.readDictionary(bis, Codec.readString);
	        var proposedProperties = Codec.readDictionary(bis, Codec.readString);
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        return new authenticator_request_1.AuthenticatorRequest(principal, credentials, sessionProperties, proposedProperties, cid);
	    };
	    return AuthenticatorRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.AuthenticatorRequestSerialiserClass = AuthenticatorRequestSerialiserClass;
	/**
	 * The {@link AuthenticatorRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.AuthenticatorRequestSerialiser = new AuthenticatorRequestSerialiserClass();


/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a AUTHENTICATOR request.
	 */
	var AuthenticatorRequest = /** @class */ (function () {
	    /**
	     * Create a new AuthenticationRequest instance
	     *
	     * @param principal  the session principal
	     * @param credentials  the credentials
	     * @param sessionProperties  the current session properties
	     * @param proposedProperties  the proposed session properties
	     * @param cid  the conversation ID
	     */
	    function AuthenticatorRequest(principal, credentials, sessionProperties, proposedProperties, cid) {
	        this.principal = principal;
	        this.credentials = credentials;
	        this.sessionProperties = sessionProperties;
	        this.proposedProperties = proposedProperties;
	        this.cid = cid;
	    }
	    return AuthenticatorRequest;
	}());
	exports.AuthenticatorRequest = AuthenticatorRequest;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var authenticator_response_1 = __webpack_require__(535);
	/**
	 * Serialiser for {@link AuthenticatorResponse}
	 */
	var AuthenticatorResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(AuthenticatorResponseSerialiserClass, _super);
	    function AuthenticatorResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link AuthenticatorResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link AuthenticatorResponse} that was read
	     */
	    AuthenticatorResponseSerialiserClass.prototype.read = function (bis) {
	        var type = BEES.read(bis, authenticator_response_1.TypeCode);
	        switch (type) {
	            case authenticator_response_1.TypeCode.ABSTAIN:
	                return authenticator_response_1.ABSTAIN;
	            case authenticator_response_1.TypeCode.ALLOW:
	                var properties = Codec.readDictionary(bis, Codec.readString);
	                return new authenticator_response_1.AuthenticatorResponse(authenticator_response_1.TypeCode.ALLOW, properties);
	            default:
	                return authenticator_response_1.DENY;
	        }
	    };
	    /**
	     * Write a {@link AuthenticatorResponse} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link AuthenticatorResponse} to be written
	     */
	    AuthenticatorResponseSerialiserClass.prototype.write = function (bos, value) {
	        BEES.write(bos, value.type);
	        if (value.type === authenticator_response_1.TypeCode.ALLOW) {
	            Codec.writeDictionary(bos, value.properties || {}, Codec.writeString);
	        }
	    };
	    return AuthenticatorResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.AuthenticatorResponseSerialiserClass = AuthenticatorResponseSerialiserClass;
	/**
	 * The {@link AuthenticatorResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.AuthenticatorResponseSerialiser = new AuthenticatorResponseSerialiserClass();


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var permission_1 = __webpack_require__(333);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var list_global_permissions_result_1 = __webpack_require__(1363);
	var security_1 = __webpack_require__(101);
	/**
	 * Serialiser for {@link ListGlobalPermissionsResult}
	 */
	var ListGlobalPermissionsResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(ListGlobalPermissionsResultSerialiserClass, _super);
	    function ListGlobalPermissionsResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ListGlobalPermissionsResultSerialiserClass.prototype.read = function (bis) {
	        return new list_global_permissions_result_1.ListGlobalPermissionsResult(Codec.readCollection(bis, function () {
	            var k = permission_1.GlobalPermissionCode[bis.read()];
	            return security_1.GlobalPermission[k];
	        }));
	    };
	    return ListGlobalPermissionsResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ListGlobalPermissionsResultSerialiserClass = ListGlobalPermissionsResultSerialiserClass;
	/**
	 * The {@link ListGlobalPermissionsResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ListGlobalPermissionsResultSerialiser = new ListGlobalPermissionsResultSerialiserClass();


/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server response from GET_GLOBAL_PERMISSION_SERVICE request
	 */
	var ListGlobalPermissionsResult = /** @class */ (function () {
	    /**
	     * Create a new ListGlobalPermissionsResult instance.
	     * @param permissions the set of global permissions
	     */
	    function ListGlobalPermissionsResult(permissions) {
	        this.permissions = permissions;
	    }
	    return ListGlobalPermissionsResult;
	}());
	exports.ListGlobalPermissionsResult = ListGlobalPermissionsResult;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var permission_1 = __webpack_require__(333);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var list_path_permissions_result_1 = __webpack_require__(1365);
	var security_1 = __webpack_require__(101);
	/**
	 * Serialiser for {@link ListPathPermissionsResult}
	 */
	var ListPathPermissionsResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(ListPathPermissionsResultSerialiserClass, _super);
	    function ListPathPermissionsResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ListPathPermissionsResultSerialiserClass.prototype.read = function (bis) {
	        return new list_path_permissions_result_1.ListPathPermissionsResult(Codec.readCollection(bis, function () {
	            var k = permission_1.PathPermissionCode[bis.read()];
	            return security_1.PathPermission[k];
	        }));
	    };
	    return ListPathPermissionsResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ListPathPermissionsResultSerialiserClass = ListPathPermissionsResultSerialiserClass;
	/**
	 * The {@link ListPathPermissionsResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ListPathPermissionsResultSerialiser = new ListPathPermissionsResultSerialiserClass();


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @module Services.Security
	 */
	/**
	 * Server response from GET_GLOBAL_PERMISSION_SERVICE request
	 */
	var ListPathPermissionsResult = /** @class */ (function () {
	    /**
	     * Create a new ListGlobalPermissionsResult instance.
	     * @param permissions the set of global permissions
	     */
	    function ListPathPermissionsResult(permissions) {
	        this.permissions = permissions;
	    }
	    return ListPathPermissionsResult;
	}());
	exports.ListPathPermissionsResult = ListPathPermissionsResult;


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var permission_1 = __webpack_require__(333);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var role_1 = __webpack_require__(1367);
	/**
	 * Read a {@link Role} from the stream
	 *
	 * @param bis  the input stream
	 * @return     the {@link Role} that was read
	 */
	function read(bis) {
	    var name = Codec.readString(bis);
	    var global = Codec.readCollection(bis, function () { return (BEES.read(bis, permission_1.GlobalPermissionCode)); })
	        // map the codes to the string values that the user is expecting
	        .map(function (code) { return permission_1.GlobalPermissionCode[code]; });
	    var defaultPermissions = Codec.readCollection(bis, function () { return (BEES.read(bis, permission_1.PathPermissionCode)); })
	        // map the codes to the string values that the user is expecting
	        .map(function (code) { return permission_1.PathPermissionCode[code]; });
	    var topic = Codec.readDictionary(bis, function () {
	        return Codec.readCollection(bis, function () { return (BEES.read(bis, permission_1.PathPermissionCode)); })
	            // map the codes to the string values that the user is expecting
	            .map(function (code) { return permission_1.PathPermissionCode[code]; });
	    });
	    var roles = Codec.readCollection(bis, Codec.readString);
	    var lockingPrincipal = Codec.readBoolean(bis) ? Codec.readString(bis) : undefined;
	    return new role_1.RoleImpl(name, global, defaultPermissions, topic, roles, lockingPrincipal);
	}
	exports.read = read;


/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A security role
	 */
	var RoleImpl = /** @class */ (function () {
	    /**
	     * Create a new Role instance
	     *
	     * @param name  the name of the role
	     * @param global  the global permissions of the role
	     * @param defaultPermissions  the default path permissions of the role
	     * @param path  the path permissions indexed by topic path
	     * @param roles  additional roles
	     */
	    function RoleImpl(name, global, defaultPermissions, path, roles, lockingPrincipal) {
	        this.name = name;
	        this.global = global;
	        this.default = defaultPermissions;
	        this.topic = path;
	        this.roles = roles;
	        this.lockingPrincipal = lockingPrincipal;
	    }
	    return RoleImpl;
	}());
	exports.RoleImpl = RoleImpl;


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Security
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var security_configuration_1 = __webpack_require__(1201);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var RoleSerialiser = __webpack_require__(1366);
	/**
	 * Serialiser for {@link SecurityConfigurationImpl}
	 */
	var SecurityConfigurationSerialiserClass = /** @class */ (function (_super) {
	    __extends(SecurityConfigurationSerialiserClass, _super);
	    function SecurityConfigurationSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SecurityConfigurationImpl} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link SecurityConfigurationImpl} that was read
	     */
	    SecurityConfigurationSerialiserClass.prototype.read = function (bis) {
	        var anonymous = Codec.readCollection(bis, Codec.readString);
	        var named = Codec.readCollection(bis, Codec.readString);
	        var roles = Codec.readCollection(bis, RoleSerialiser.read);
	        var isolatedPaths = Codec.readCollection(bis, Codec.readString);
	        return new security_configuration_1.SecurityConfigurationImpl(anonymous, named, roles, isolatedPaths);
	    };
	    return SecurityConfigurationSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SecurityConfigurationSerialiserClass = SecurityConfigurationSerialiserClass;
	/**
	 * The {@link SecurityConfigurationSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SecurityConfigurationSerialiser = new SecurityConfigurationSerialiserClass();


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.SessionFetchQuery
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_list_serialiser_1 = __webpack_require__(178);
	var session_fetch_query_result_1 = __webpack_require__(1370);
	/**
	 * Read a session property map from the stream
	 *
	 * @param bis  the input stream
	 * @return     the property map that was read
	 */
	function readSession(bis) {
	    var startTime = null;
	    if (Codec.readByte(bis) === 1) {
	        startTime = Codec.readInt64(bis);
	    }
	    var properties = Codec.readDictionary(bis, Codec.readString);
	    if (startTime) {
	        properties.$StartTime = startTime.toString();
	    }
	    return properties;
	}
	/**
	 * Serialiser for {@link SessionFetchQueryResult}
	 */
	var SessionFetchQueryResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionFetchQueryResultSerialiserClass, _super);
	    function SessionFetchQueryResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionFetchQueryResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionFetchQueryResult} that was read
	     */
	    SessionFetchQueryResultSerialiserClass.prototype.read = function (bis) {
	        if (Codec.readByte(bis) === 0) {
	            var sessions = Codec.readCollection(bis, readSession);
	            var totalSelected = Codec.readInt32(bis);
	            return new session_fetch_query_result_1.SessionFetchQueryResult(sessions, totalSelected);
	        }
	        else {
	            var errors = error_report_list_serialiser_1.ErrorReportListSerialiser.read(bis);
	            return new session_fetch_query_result_1.SessionFetchQueryResult(undefined, undefined, errors);
	        }
	    };
	    return SessionFetchQueryResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionFetchQueryResultSerialiserClass = SessionFetchQueryResultSerialiserClass;
	/**
	 * The {@link SessionFetchQueryResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionFetchQueryResultSerialiser = new SessionFetchQueryResultSerialiserClass();


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.SessionFetchQuery
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server result from a SESSION_FETCH_QUERY request.
	 */
	var SessionFetchQueryResult = /** @class */ (function () {
	    /**
	     * Create a new SessionFetchQueryResult instance
	     *
	     * @param results       the sessions that have been fetched
	     * @param totalCount    the total number of matched sessions for the filter
	     */
	    function SessionFetchQueryResult(results, totalCount, errors) {
	        this.results = results;
	        this.totalCount = totalCount;
	        this.errors = errors;
	    }
	    return SessionFetchQueryResult;
	}());
	exports.SessionFetchQueryResult = SessionFetchQueryResult;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.SessionFetchQuery
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(104);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Write an optional range limit to the stream
	 *
	 * @param bos    the output stream
	 * @param value  the limit to be written
	 */
	function writeRangeLimit(bos, limit) {
	    if (limit === undefined) {
	        Codec.writeByte(bos, 0);
	    }
	    else {
	        Codec.writeByte(bos, 1);
	        Codec.writeInt64(bos, limit);
	    }
	}
	/**
	 * Write a {@link SessionFetchRange} to the stream
	 *
	 * @param bos    the output stream
	 * @param value  the {@link SessionFetchRange} to be written
	 */
	function writeRange(bos, range) {
	    writeRangeLimit(bos, range.from);
	    writeRangeLimit(bos, range.to);
	}
	/**
	 * Write the result limit to the stream, if required
	 * @param bos   the output stream
	 * @param limit the result limit
	 */
	function writeLimit(bos, limit) {
	    if (limit === math_1.MAX_INT32) {
	        Codec.writeByte(bos, 0);
	    }
	    else {
	        Codec.writeByte(bos, 1);
	        Codec.writeInt32(bos, limit);
	    }
	}
	/**
	 * Write the list of requested session properties
	 *
	 * @param bos           the output stream
	 * @param properties    the session properties set to include
	 */
	function writeProperties(bos, properties) {
	    if (properties === null) {
	        Codec.writeByte(bos, 0);
	    }
	    else {
	        Codec.writeByte(bos, 1);
	        Codec.writeCollection(bos, __spread(properties), Codec.writeString);
	    }
	}
	/**
	 * Serialiser for {@link SessionFetchQuery}
	 */
	var SessionFetchQuerySerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionFetchQuerySerialiserClass, _super);
	    function SessionFetchQuerySerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SessionFetchQuery} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SessionFetchQuery} to be written
	     */
	    SessionFetchQuerySerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.filter);
	        writeProperties(bos, value.withProperties);
	        writeRange(bos, value.range);
	        writeLimit(bos, value.limit);
	        Codec.writeInt32(bos, value.maximumResultSize);
	        Codec.writeBoolean(bos, value.requiresStartTime);
	    };
	    return SessionFetchQuerySerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionFetchQuerySerialiserClass = SessionFetchQuerySerialiserClass;
	/**
	 * The {@link SessionFetchQuerySerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionFetchQuerySerialiser = new SessionFetchQuerySerialiserClass();


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.SessionFetchQuery
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a SESSION_FETCH_QUERY request.
	 */
	var SessionFetchQuery = /** @class */ (function () {
	    /**
	     * Create a new SessionFetchQueryResult instance
	     *
	     * @param filter  the session filter
	     * @param range  the fetch range
	     * @param withProperties  which session properties to return
	     * @param limit  the limit on the number of results returned
	     * @param maximumResultSize  the maximum result size
	     */
	    function SessionFetchQuery(filter, range, withProperties, limit, maximumResultSize, requiresStartTime) {
	        this.filter = filter;
	        this.range = range;
	        this.withProperties = withProperties;
	        this.limit = limit;
	        this.maximumResultSize = maximumResultSize;
	        this.requiresStartTime = requiresStartTime;
	    }
	    return SessionFetchQuery;
	}());
	exports.SessionFetchQuery = SessionFetchQuery;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var boolean_serialiser_1 = __webpack_require__(337);
	var session_lock_acquisition_serialiser_1 = __webpack_require__(1374);
	var session_lock_request_serialiser_1 = __webpack_require__(1376);
	exports.ACQUIRE_SESSION_LOCK = {
	    id: 114,
	    request: session_lock_request_serialiser_1.SessionLockRequestSerialiser,
	    response: session_lock_acquisition_serialiser_1.SessionLockAcquisitionSerialiser
	};
	exports.RELEASE_SESSION_LOCK = {
	    id: 116,
	    request: session_lock_acquisition_serialiser_1.SessionLockAcquisitionSerialiser,
	    response: boolean_serialiser_1.BooleanSerialiser
	};


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.SessionLock
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var session_lock_options_1 = __webpack_require__(173);
	var session_lock_acquisition_1 = __webpack_require__(1375);
	/**
	 * Serialiser for {@link SessionLockAcquisition}
	 */
	var SessionLockAcquisitionSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionLockAcquisitionSerialiserClass, _super);
	    function SessionLockAcquisitionSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionLockAcquisition} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionLockAcquisition} that was read
	     */
	    SessionLockAcquisitionSerialiserClass.prototype.read = function (bis) {
	        var lockName = Codec.readString(bis);
	        var sequence = Codec.readInt64(bis);
	        var scope = BEES.read(bis, session_lock_options_1.SessionLockScope);
	        return new session_lock_acquisition_1.SessionLockAcquisition(lockName, sequence, scope);
	    };
	    /**
	     * Write a {@link SessionLockAcquisition} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SessionLockAcquisition} to be written
	     */
	    SessionLockAcquisitionSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.lockName);
	        Codec.writeInt64(bos, value.sequence);
	        BEES.write(bos, value.scope);
	    };
	    return SessionLockAcquisitionSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionLockAcquisitionSerialiserClass = SessionLockAcquisitionSerialiserClass;
	/**
	 * The {@link SessionLockAcquisitionSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionLockAcquisitionSerialiser = new SessionLockAcquisitionSerialiserClass();


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.SessionLock
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for the ACQUIRE_SESSION_LOCK and RELEASE_SESSION_LOCK requests.
	 */
	var SessionLockAcquisition = /** @class */ (function () {
	    /**
	     * Create a new SessionLockAcquisition instance
	     *
	     * @param lockName  the lock name
	     * @param sequence  the session lock sequence number
	     * @param scope  the lock scope
	     */
	    function SessionLockAcquisition(lockName, sequence, scope) {
	        this.lockName = lockName;
	        this.sequence = sequence;
	        this.scope = scope;
	    }
	    return SessionLockAcquisition;
	}());
	exports.SessionLockAcquisition = SessionLockAcquisition;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.SessionLock
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link SessionLockRequest}
	 */
	var SessionLockRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionLockRequestSerialiserClass, _super);
	    function SessionLockRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SessionLockRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SessionLockRequest} to be written
	     */
	    SessionLockRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.lockName);
	        Codec.writeInt64(bos, value.requestId);
	        BEES.write(bos, value.scope);
	    };
	    return SessionLockRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionLockRequestSerialiserClass = SessionLockRequestSerialiserClass;
	/**
	 * The {@link SessionLockRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionLockRequestSerialiser = new SessionLockRequestSerialiserClass();


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var string_serialiser_1 = __webpack_require__(145);
	var service_definition_1 = __webpack_require__(51);
	var branch_mapping_table_serialiser_1 = __webpack_require__(1378);
	var session_tree_branch_list_serialiser_1 = __webpack_require__(1379);
	exports.PUT_BRANCH_MAPPING_TABLE = {
	    id: 176,
	    request: branch_mapping_table_serialiser_1.BranchMappingTableSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS = {
	    id: 177,
	    request: service_definition_1.NullSerialiser,
	    response: session_tree_branch_list_serialiser_1.SessionTreeBranchListSerialiser
	};
	exports.GET_BRANCH_MAPPING_TABLE = {
	    id: 178,
	    request: string_serialiser_1.StringSerialiser,
	    response: branch_mapping_table_serialiser_1.BranchMappingTableSerialiser
	};


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.SessionTrees
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var branch_mapping_table_1 = __webpack_require__(505);
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	function writeBranchMapping(bos, branchMapping) {
	    Codec.writeString(bos, branchMapping.sessionFilter);
	    Codec.writeString(bos, branchMapping.topicTreeBranch);
	}
	function readBranchMapping(bis) {
	    var sessionFilter = Codec.readString(bis);
	    var topicTreeBranch = Codec.readString(bis);
	    return {
	        sessionFilter: sessionFilter,
	        topicTreeBranch: topicTreeBranch
	    };
	}
	/**
	 * Serialiser for {@link BranchMappingTable}
	 */
	var BranchMappingTableSerialiserClass = /** @class */ (function (_super) {
	    __extends(BranchMappingTableSerialiserClass, _super);
	    function BranchMappingTableSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link BranchMappingTable} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link BranchMappingTable} that was read
	     */
	    BranchMappingTableSerialiserClass.prototype.read = function (bis) {
	        var sessionTreeBranch = Codec.readString(bis);
	        var branchMappings = Codec.readCollection(bis, readBranchMapping);
	        return new branch_mapping_table_1.BranchMappingTableImpl(sessionTreeBranch, branchMappings);
	    };
	    /**
	     * Write a {@link BranchMappingTable} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link BranchMappingTable} to be written
	     */
	    BranchMappingTableSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.getSessionTreeBranch());
	        Codec.writeCollection(bos, value.getBranchMappings(), writeBranchMapping);
	    };
	    return BranchMappingTableSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.BranchMappingTableSerialiserClass = BranchMappingTableSerialiserClass;
	/**
	 * The {@link BranchMappingTableSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.BranchMappingTableSerialiser = new BranchMappingTableSerialiserClass();


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.SessionTrees
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var session_tree_branch_list_1 = __webpack_require__(1380);
	/**
	 * Serialiser for {@link SessionTreeBranchList}
	 */
	var SessionTreeBranchListSerialiserClass = /** @class */ (function (_super) {
	    __extends(SessionTreeBranchListSerialiserClass, _super);
	    function SessionTreeBranchListSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link SessionTreeBranchList} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link SessionTreeBranchList} that was read
	     */
	    SessionTreeBranchListSerialiserClass.prototype.read = function (bis) {
	        var paths = Codec.readCollection(bis, Codec.readString);
	        return new session_tree_branch_list_1.SessionTreeBranchList(paths);
	    };
	    return SessionTreeBranchListSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SessionTreeBranchListSerialiserClass = SessionTreeBranchListSerialiserClass;
	/**
	 * The {@link SessionTreeBranchListSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SessionTreeBranchListSerialiser = new SessionTreeBranchListSerialiserClass();


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.SessionTrees
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The response of the GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS service
	 */
	var SessionTreeBranchList = /** @class */ (function () {
	    /**
	     * Create a new SessionTreeBranchList instance
	     *
	     * @param paths  the source branches
	     */
	    function SessionTreeBranchList(paths) {
	        this.paths = paths;
	    }
	    return SessionTreeBranchList;
	}());
	exports.SessionTreeBranchList = SessionTreeBranchList;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var range_query_request_serialiser_1 = __webpack_require__(1383);
	var range_query_result_serialiser_1 = __webpack_require__(1385);
	var time_series_append_request_serialiser_1 = __webpack_require__(1387);
	var time_series_edit_request_serialiser_1 = __webpack_require__(1389);
	var time_series_event_metadata_serialiser_1 = __webpack_require__(536);
	var time_series_timestamp_append_request_serialiser_1 = __webpack_require__(1390);
	/**
	 * Create the RANGE_QUERY service definition
	 */
	function rangeQueryFactory(datatypes) {
	    return {
	        id: 84,
	        request: range_query_request_serialiser_1.RangeQueryRequestSerialiser,
	        response: new range_query_result_serialiser_1.RangeQueryResultSerialiserClass(datatypes)
	    };
	}
	exports.rangeQueryFactory = rangeQueryFactory;
	exports.TIME_SERIES_APPEND = {
	    id: 99,
	    request: time_series_append_request_serialiser_1.TimeSeriesAppendRequestSerialiser,
	    response: time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser
	};
	exports.TIME_SERIES_EDIT = {
	    id: 100,
	    request: time_series_edit_request_serialiser_1.TimeSeriesEditRequestSerialiser,
	    response: time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser
	};
	exports.TIME_SERIES_TIMESTAMP_APPEND = {
	    id: 166,
	    request: time_series_timestamp_append_request_serialiser_1.TimeSeriesTimestampAppendRequestSerialiser,
	    response: time_series_event_metadata_serialiser_1.EventMetadataImplSerialiser
	};


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var point_1 = __webpack_require__(506);
	var range_1 = __webpack_require__(335);
	var range_query_parameters_1 = __webpack_require__(334);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	/**
	 * Read a {@link Point} from the stream
	 *
	 * @param bis the input stream
	 * @return    the {@link Point} that was read
	 */
	function readPoint(bis) {
	    var value = Codec.readInt64(bis);
	    var type = BEES.read(bis, point_1.Types);
	    return new point_1.Point(value, type);
	}
	/**
	 * Read a {@link Range} from the stream
	 *
	 * @param bis the input stream
	 * @return    the {@link Range} that was read
	 */
	function readRange(bis) {
	    var anchor = readPoint(bis);
	    var span = readPoint(bis);
	    return new range_1.Range(anchor, span);
	}
	/**
	 * Write a {@link Point} to the stream
	 *
	 * @param bos   the output stream
	 * @param value the {@link Point} to be written
	 */
	function writePoint(bos, point) {
	    Codec.writeInt64(bos, point.value);
	    BEES.write(bos, point.type);
	}
	/**
	 * Write a {@link Range} to the stream
	 *
	 * @param bos   the output stream
	 * @param value the {@link Range} to be written
	 */
	function writeRange(bos, range) {
	    writePoint(bos, range.anchor);
	    writePoint(bos, range.span);
	}
	/**
	 * Read a {@link RangeQueryParameters} object from the stream
	 *
	 * @param bis the input stream
	 * @return    the {@link RangeQueryParameters} that were read
	 */
	function read(bis) {
	    var queryType = BEES.read(bis, range_query_parameters_1.QueryTypes);
	    var viewRange = readRange(bis);
	    var editRange = readRange(bis);
	    var limit = Codec.readInt64(bis);
	    return new range_query_parameters_1.RangeQueryParameters(queryType, viewRange, editRange, limit);
	}
	exports.read = read;
	/**
	 * Write a {@link RangeQueryParameters} object to the stream
	 *
	 * @param bos   the output stream
	 * @param value the {@link RangeQueryParameters} to be written
	 */
	function write(bos, value) {
	    BEES.write(bos, value.queryType);
	    writeRange(bos, value.viewRange);
	    writeRange(bos, value.editRange);
	    Codec.writeInt64(bos, value.limit);
	}
	exports.write = write;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var RangeQueryParametersSerialiser = __webpack_require__(1382);
	var range_query_request_1 = __webpack_require__(1384);
	/**
	 * Serialiser for {@link RangeQueryRequest}
	 */
	var RangeQueryRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(RangeQueryRequestSerialiserClass, _super);
	    function RangeQueryRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link RangeQueryRequest} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link RangeQueryRequest} that was read
	     */
	    RangeQueryRequestSerialiserClass.prototype.read = function (bis) {
	        var topicPath = Codec.readString(bis);
	        var parameters = RangeQueryParametersSerialiser.read(bis);
	        return new range_query_request_1.RangeQueryRequest(topicPath, parameters);
	    };
	    /**
	     * Write a {@link RangeQueryRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link RangeQueryRequest} to be written
	     */
	    RangeQueryRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.topicPath);
	        RangeQueryParametersSerialiser.write(bos, value.parameters);
	    };
	    return RangeQueryRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.RangeQueryRequestSerialiserClass = RangeQueryRequestSerialiserClass;
	/**
	 * The {@link RangeQueryRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.RangeQueryRequestSerialiser = new RangeQueryRequestSerialiserClass();


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a RANGE_QUERY request.
	 */
	var RangeQueryRequest = /** @class */ (function () {
	    /**
	     * Create a new RangeQueryRequest instance
	     *
	     * @param topicPath  the topic path
	     * @param parameters  the range query parameters
	     */
	    function RangeQueryRequest(topicPath, parameters) {
	        this.topicPath = topicPath;
	        this.parameters = parameters;
	    }
	    return RangeQueryRequest;
	}());
	exports.RangeQueryRequest = RangeQueryRequest;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var Long = __webpack_require__(44);
	var range_query_result_1 = __webpack_require__(1386);
	var time_series_event_1 = __webpack_require__(340);
	var time_series_event_metadata_1 = __webpack_require__(537);
	var ORIGINAL_EVENT = 0;
	var EDIT_EVENT = 1;
	var METADATA_OFFSETS = 2;
	var AUTHOR_ENCODING = 3;
	/**
	 * Offsets of a range query result in the time series
	 */
	var Offsets = /** @class */ (function () {
	    /**
	     * Create a new Offsets instance
	     *
	     * @param  sequence   the sequence number offset
	     * @param  timestamp  the time offset
	     */
	    function Offsets(sequence, timestamp) {
	        this.sequence = sequence;
	        this.timestamp = timestamp;
	    }
	    return Offsets;
	}());
	/**
	 * Read event metadata
	 *
	 * @param bis           the input stream
	 * @param offsets       the offsets of the range in the result
	 * @param codeToAuthor  a mapping between author codes and authors
	 * @return              the metadata that was read
	 */
	function readMetadata(input, offsets, codeToAuthor) {
	    var sequence = Codec.readInt64(input).add(offsets.sequence);
	    var timestamp = Codec.readInt64(input).add(offsets.timestamp);
	    var code = Codec.readBytes(input);
	    var decoded = codeToAuthor[code.toString()];
	    var author = decoded ? decoded : code.toString('utf-8');
	    return new time_series_event_metadata_1.EventMetadataImpl(sequence.toNumber(), timestamp.toNumber(), author);
	}
	/**
	 * Read an original event
	 *
	 * @param bis           the input stream
	 * @param offsets       the offsets of the range in the result
	 * @param codeToAuthor  a mapping between author codes and authors
	 * @return              the original event that was read
	 */
	function readOriginalEvent(bis, offsets, codeToAuthor) {
	    var metadata = readMetadata(bis, offsets, codeToAuthor);
	    return time_series_event_1.EventImpl.create(metadata, metadata, Codec.readBytes(bis));
	}
	/**
	 * Read an edit event
	 *
	 * @param bis           the input stream
	 * @param offsets       the offsets of the range in the result
	 * @param codeToAuthor  a mapping between author codes and authors
	 * @return              the edit event that was read
	 */
	function readEditEvent(bis, offsets, codeToAuthor) {
	    var originalEvent = readMetadata(bis, offsets, codeToAuthor);
	    var metadata = readMetadata(bis, offsets, codeToAuthor);
	    return time_series_event_1.EventImpl.create(metadata, originalEvent, Codec.readBytes(bis));
	}
	/**
	 * Read time series offsets
	 *
	 * @param bis  the input stream
	 * @return     the offsets of the range in the result that were read
	 */
	function readMetadataOffsets(bis) {
	    return new Offsets(Codec.readInt64(bis), Codec.readInt64(bis));
	}
	/**
	 * Read the author encoding an store it in the `codeToAuthor` map
	 *
	 * @param bis           the input stream
	 * @param codeToAuthor  a mapping between author codes and authors
	 */
	function readAuthorEncoding(bis, codeToAuthor) {
	    var code = Codec.readBytes(bis);
	    codeToAuthor[code.toString()] = Codec.readString(bis);
	}
	/**
	 * Serialiser for {@link RangeQueryResult}
	 */
	var RangeQueryResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(RangeQueryResultSerialiserClass, _super);
	    function RangeQueryResultSerialiserClass(datatypes) {
	        var _this = _super.call(this) || this;
	        _this.datatypes = datatypes;
	        return _this;
	    }
	    /**
	     * Read a {@link RangeQueryResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link RangeQueryResult} that was read
	     */
	    RangeQueryResultSerialiserClass.prototype.read = function (input) {
	        var dataType = this.datatypes.get(Codec.readString(input));
	        if (dataType === null) {
	            throw new Error('Received unexpected data type');
	        }
	        var selectedCount = Codec.readInt64(input);
	        var offsets = new Offsets(Long.ZERO, Long.ZERO);
	        var codeToAuthor = {};
	        var events = [];
	        var limit = Codec.readInt32(input);
	        for (var i = 0; i < limit; ++i) {
	            switch (Codec.readByte(input)) {
	                case ORIGINAL_EVENT:
	                    events.push(readOriginalEvent(input, offsets, codeToAuthor));
	                    break;
	                case EDIT_EVENT:
	                    events.push(readEditEvent(input, offsets, codeToAuthor));
	                    break;
	                case METADATA_OFFSETS:
	                    offsets = readMetadataOffsets(input);
	                    break;
	                case AUTHOR_ENCODING:
	                    readAuthorEncoding(input, codeToAuthor);
	                    break;
	                default:
	                    readAuthorEncoding(input, codeToAuthor);
	            }
	        }
	        return new range_query_result_1.RangeQueryResult(dataType, selectedCount, events);
	    };
	    return RangeQueryResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.RangeQueryResultSerialiserClass = RangeQueryResultSerialiserClass;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var query_result_1 = __webpack_require__(1210);
	var Long = __webpack_require__(44);
	/**
	 * Server response from a RANGE_QUERY request.
	 */
	var RangeQueryResult = /** @class */ (function () {
	    /**
	     * Create a new RangeQueryResult instance
	     *
	     * @param  valueDataType  the value data type
	     * @param  selectedCount  the number of selected events
	     * @param  events         the time series events returned in the result
	     */
	    function RangeQueryResult(valueDataType, selectedCount, events) {
	        this.valueDataType = valueDataType;
	        this.selectedCount = selectedCount;
	        this.events = events;
	    }
	    /**
	     * Create a new {@link QueryResult} with a given value type and stream structure
	     *
	     * @param  queryValueType   the value type
	     * @param  streamStructure  the stream structure
	     * @return                  a new query result constructed from the range query result
	     */
	    RangeQueryResult.prototype.createQueryResult = function (queryValueType, streamStructure) {
	        var _this = this;
	        if (!this.valueDataType.canReadAs(queryValueType)) {
	            throw new Error("Time series topic has an incompatible event data type: " + this.valueDataType);
	        }
	        return new query_result_1.QueryResultImpl(this.selectedCount, Long.fromNumber(this.events.length), streamStructure, this.events.map(function (raw) {
	            return raw.withValue(_this.valueDataType.readAs(queryValueType, raw.value));
	        }));
	    };
	    return RangeQueryResult;
	}());
	exports.RangeQueryResult = RangeQueryResult;


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link TimeSeriesAppendRequest}
	 */
	var TimeSeriesAppendRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(TimeSeriesAppendRequestSerialiserClass, _super);
	    function TimeSeriesAppendRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TimeSeriesAppendRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TimeSeriesAppendRequest} to be written
	     */
	    TimeSeriesAppendRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.dataType.name());
	        Codec.writeBytes(bos, value.value);
	    };
	    return TimeSeriesAppendRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TimeSeriesAppendRequestSerialiserClass = TimeSeriesAppendRequestSerialiserClass;
	/**
	 * The {@link TimeSeriesAppendRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TimeSeriesAppendRequestSerialiser = new TimeSeriesAppendRequestSerialiserClass();


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a TIME_SERIES_APPEND request.
	 */
	var TimeSeriesAppendRequest = /** @class */ (function () {
	    /**
	     * Create a new TimeSeriesAppendRequest instance
	     *
	     * @param path  the path of the timeseries topic
	     * @param dataType  the data type to append
	     * @param value  the value to append
	     */
	    function TimeSeriesAppendRequest(path, dataType, value) {
	        this.path = path;
	        this.dataType = dataType;
	        this.value = value;
	    }
	    return TimeSeriesAppendRequest;
	}());
	exports.TimeSeriesAppendRequest = TimeSeriesAppendRequest;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link TimeSeriesEditRequest}
	 */
	var TimeSeriesEditRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(TimeSeriesEditRequestSerialiserClass, _super);
	    function TimeSeriesEditRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TimeSeriesEditRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TimeSeriesEditRequest} to be written
	     */
	    TimeSeriesEditRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.dataType.name());
	        Codec.writeInt64(bos, value.sequence);
	        Codec.writeBytes(bos, value.value);
	    };
	    return TimeSeriesEditRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TimeSeriesEditRequestSerialiserClass = TimeSeriesEditRequestSerialiserClass;
	/**
	 * The {@link TimeSeriesEditRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TimeSeriesEditRequestSerialiser = new TimeSeriesEditRequestSerialiserClass();


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link TimeSeriesTimestampAppendRequest}
	 */
	var TimeSeriesTimestampAppendRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(TimeSeriesTimestampAppendRequestSerialiserClass, _super);
	    function TimeSeriesTimestampAppendRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TimeSeriesTimestampAppendRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TimeSeriesTimestampAppendRequest} to be written
	     */
	    TimeSeriesTimestampAppendRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.dataType.name());
	        Codec.writeBytes(bos, value.value);
	        Codec.writeInt64(bos, value.timestamp);
	    };
	    return TimeSeriesTimestampAppendRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TimeSeriesTimestampAppendRequestSerialiserClass = TimeSeriesTimestampAppendRequestSerialiserClass;
	/**
	 * The {@link TimeSeriesTimestampAppendRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TimeSeriesTimestampAppendRequestSerialiser = new TimeSeriesTimestampAppendRequestSerialiserClass();


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.Timeseries
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a TIME_SERIES_TIMESTAMP_APPEND request.
	 */
	var TimeSeriesTimestampAppendRequest = /** @class */ (function () {
	    /**
	     * Create a new TimeSeriesAppendRequest instance
	     *
	     * @param path  the path of the timeseries topic
	     * @param dataType  the data type to append
	     * @param value  the value to append
	     */
	    function TimeSeriesTimestampAppendRequest(path, dataType, value, timestamp) {
	        this.path = path;
	        this.dataType = dataType;
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return TimeSeriesTimestampAppendRequest;
	}());
	exports.TimeSeriesTimestampAppendRequest = TimeSeriesTimestampAppendRequest;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicAdd
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var TopicSpecificationSerialiser = __webpack_require__(147);
	/**
	 * Serialiser for {@link TopicAddRequest}
	 */
	var TopicAddRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicAddRequestSerialiserClass, _super);
	    function TopicAddRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TopicAddRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicAddRequest} to be written
	     */
	    TopicAddRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        TopicSpecificationSerialiser.write(bos, value.specification);
	    };
	    return TopicAddRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicAddRequestSerialiserClass = TopicAddRequestSerialiserClass;
	/**
	 * The {@link TopicAddRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicAddRequestSerialiser = new TopicAddRequestSerialiserClass();


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicAdd
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_add_response_1 = __webpack_require__(538);
	/**
	 * Serialiser for {@link TopicAddResponse}
	 */
	var TopicAddResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicAddResponseSerialiserClass, _super);
	    function TopicAddResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link TopicAdd} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link TopicAdd} that was read
	     */
	    TopicAddResponseSerialiserClass.prototype.read = function (bis) {
	        var status = Codec.readByte(bis);
	        return new topic_add_response_1.TopicAddResponse(status);
	    };
	    return TopicAddResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicAddResponseSerialiserClass = TopicAddResponseSerialiserClass;
	/**
	 * The {@link TopicAddResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicAddResponseSerialiser = new TopicAddResponseSerialiserClass();


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var boolean_serialiser_1 = __webpack_require__(337);
	var integer_serialiser_1 = __webpack_require__(1234);
	var missing_topic_request_serialiser_1 = __webpack_require__(1340);
	var remove_topic_serialiser_1 = __webpack_require__(1351);
	var topic_add_request_serialiser_1 = __webpack_require__(1392);
	var topic_add_response_serialiser_1 = __webpack_require__(1393);
	exports.MISSING_TOPIC = {
	    id: 50,
	    request: missing_topic_request_serialiser_1.MissingTopicRequestSerialiser,
	    response: boolean_serialiser_1.BooleanSerialiser
	};
	exports.TOPIC_REMOVAL = {
	    id: 83,
	    request: remove_topic_serialiser_1.RemoveTopicSerialiser,
	    response: integer_serialiser_1.IntegerSerialiser
	};
	exports.TOPIC_ADD = {
	    id: 112,
	    request: topic_add_request_serialiser_1.TopicAddRequestSerialiser,
	    response: topic_add_response_serialiser_1.TopicAddResponseSerialiser
	};


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var service_definition_1 = __webpack_require__(51);
	var topic_notification_deregistration_request_serialiser_1 = __webpack_require__(1396);
	var topic_notification_descendant_event_serialiser_1 = __webpack_require__(1397);
	var topic_notification_deselection_serialiser_1 = __webpack_require__(1399);
	var topic_notification_event_serialiser_1 = __webpack_require__(1400);
	var topic_notification_selection_serialiser_1 = __webpack_require__(1402);
	exports.TOPIC_NOTIFICATION_DEREGISTRATION = {
	    id: 91,
	    request: topic_notification_deregistration_request_serialiser_1.TopicNotificationDeregistrationRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.TOPIC_NOTIFICATION_EVENTS = {
	    id: 92,
	    request: topic_notification_event_serialiser_1.TopicNotificationEventSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.TOPIC_DESCENDANT_EVENTS = {
	    id: 93,
	    request: topic_notification_descendant_event_serialiser_1.TopicNotificationDescendantEventSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.TOPIC_NOTIFICATION_SELECTION = {
	    id: 94,
	    request: topic_notification_selection_serialiser_1.TopicNotificationSelectionSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.TOPIC_NOTIFICATION_DESELECTION = {
	    id: 95,
	    request: topic_notification_deselection_serialiser_1.TopicNotificationDeselectionSerialiser,
	    response: service_definition_1.NullSerialiser
	};


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link TopicNotificationDeregistrationRequest}
	 */
	var TopicNotificationDeregistrationRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicNotificationDeregistrationRequestSerialiserClass, _super);
	    function TopicNotificationDeregistrationRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TopicNotificationDeregistrationRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicNotificationDeregistrationRequest} to be written
	     */
	    TopicNotificationDeregistrationRequestSerialiserClass.prototype.write = function (bos, value) {
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	    };
	    return TopicNotificationDeregistrationRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicNotificationDeregistrationRequestSerialiserClass = TopicNotificationDeregistrationRequestSerialiserClass;
	/**
	 * The {@link TopicNotificationDeregistrationRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicNotificationDeregistrationRequestSerialiser = new TopicNotificationDeregistrationRequestSerialiserClass();


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var topic_notifications_1 = __webpack_require__(223);
	var topic_notification_descendant_event_1 = __webpack_require__(1398);
	/**
	 * Serialiser for {@link TopicNotificationDescendantEvent}
	 */
	var TopicNotificationDescendantEventSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicNotificationDescendantEventSerialiserClass, _super);
	    function TopicNotificationDescendantEventSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link TopicNotificationDescendantEvent} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link TopicNotificationDescendantEvent} that was read
	     */
	    TopicNotificationDescendantEventSerialiserClass.prototype.read = function (bis) {
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        var topicPath = Codec.readString(bis);
	        var type = BEES.read(bis, topic_notifications_1.TopicNotificationType);
	        return new topic_notification_descendant_event_1.TopicNotificationDescendantEvent(cid, topicPath, type);
	    };
	    return TopicNotificationDescendantEventSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicNotificationDescendantEventSerialiserClass = TopicNotificationDescendantEventSerialiserClass;
	/**
	 * The {@link TopicNotificationDescendantEventSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicNotificationDescendantEventSerialiser = new TopicNotificationDescendantEventSerialiserClass();


/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a TOPIC_DESCENDANT_EVENTS request.
	 */
	var TopicNotificationDescendantEvent = /** @class */ (function () {
	    /**
	     * Create a new TopicNotificationDescendantEvent instance
	     *
	     * @param cid   the conversation ID
	     * @param path  the path that the topic notification refers to
	     * @param type  the notification type
	     */
	    function TopicNotificationDescendantEvent(cid, path, type) {
	        this.cid = cid;
	        this.path = path;
	        this.type = type;
	        this.isDescendantEvent = true;
	    }
	    return TopicNotificationDescendantEvent;
	}());
	exports.TopicNotificationDescendantEvent = TopicNotificationDescendantEvent;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var serialiser_1 = __webpack_require__(4);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	/**
	 * Serialiser for {@link TopicNotificationDeselection}
	 */
	var TopicNotificationDeselectionSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicNotificationDeselectionSerialiserClass, _super);
	    function TopicNotificationDeselectionSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TopicNotificationDeselection} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicNotificationDeselection} to be written
	     */
	    TopicNotificationDeselectionSerialiserClass.prototype.write = function (bos, value) {
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
	    };
	    return TopicNotificationDeselectionSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicNotificationDeselectionSerialiserClass = TopicNotificationDeselectionSerialiserClass;
	/**
	 * The {@link TopicNotificationDeselectionSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicNotificationDeselectionSerialiser = new TopicNotificationDeselectionSerialiserClass();


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var TopicSpecificationSerialiser = __webpack_require__(147);
	var topic_notifications_1 = __webpack_require__(223);
	var topic_notification_event_1 = __webpack_require__(1401);
	/**
	 * Serialiser for {@link TopicNotificationEvent}
	 */
	var TopicNotificationEventSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicNotificationEventSerialiserClass, _super);
	    function TopicNotificationEventSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link TopicNotificationEvent} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link TopicNotificationEvent} that was read
	     */
	    TopicNotificationEventSerialiserClass.prototype.read = function (bis) {
	        var cid = conversation_id_serialiser_1.CIDSerialiser.read(bis);
	        var topicPath = Codec.readString(bis);
	        var type = BEES.read(bis, topic_notifications_1.TopicNotificationType);
	        var specification = TopicSpecificationSerialiser.read(bis);
	        return new topic_notification_event_1.TopicNotificationEvent(cid, topicPath, type, specification);
	    };
	    return TopicNotificationEventSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicNotificationEventSerialiserClass = TopicNotificationEventSerialiserClass;
	/**
	 * The {@link TopicNotificationEventSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicNotificationEventSerialiser = new TopicNotificationEventSerialiserClass();


/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a TOPIC_NOTIFICATION_EVENTS request.
	 */
	var TopicNotificationEvent = /** @class */ (function () {
	    /**
	     * Create a new TopicNotificationEvent instance
	     *
	     * @param cid            the conversation ID
	     * @param path           the path that the topic notification refers to
	     * @param type           the notification type
	     * @param specification  the topic specification
	     */
	    function TopicNotificationEvent(cid, path, type, specification) {
	        this.cid = cid;
	        this.path = path;
	        this.type = type;
	        this.specification = specification;
	        this.isDescendantEvent = false;
	    }
	    return TopicNotificationEvent;
	}());
	exports.TopicNotificationEvent = TopicNotificationEvent;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicNotifications
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_serialiser_1 = __webpack_require__(36);
	var serialiser_1 = __webpack_require__(4);
	var topic_selector_serialiser_1 = __webpack_require__(129);
	/**
	 * Serialiser for {@link TopicNotificationSelection}
	 */
	var TopicNotificationSelectionSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicNotificationSelectionSerialiserClass, _super);
	    function TopicNotificationSelectionSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link TopicNotificationSelection} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link TopicNotificationSelection} to be written
	     */
	    TopicNotificationSelectionSerialiserClass.prototype.write = function (bos, value) {
	        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
	        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
	    };
	    return TopicNotificationSelectionSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicNotificationSelectionSerialiserClass = TopicNotificationSelectionSerialiserClass;
	/**
	 * The {@link TopicNotificationSelectionSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicNotificationSelectionSerialiser = new TopicNotificationSelectionSerialiserClass();


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var service_definition_1 = __webpack_require__(51);
	var add_and_set_topic_request_serialiser_1 = __webpack_require__(1404);
	var add_topic_result_serialiser_1 = __webpack_require__(539);
	var apply_json_patch_request_serialiser_1 = __webpack_require__(1407);
	var create_update_stream_and_set_request_serialiser_1 = __webpack_require__(1410);
	var create_update_stream_request_serialiser_1 = __webpack_require__(1412);
	var create_update_stream_response_serialiser_1 = __webpack_require__(1414);
	var json_patch_result_serialiser_1 = __webpack_require__(1416);
	var set_topic_request_serialiser_1 = __webpack_require__(1422);
	var update_stream_add_topic_request_serialiser_1 = __webpack_require__(1424);
	var update_stream_add_topic_response_serialiser_1 = __webpack_require__(1426);
	var update_stream_id_serialiser_1 = __webpack_require__(234);
	var update_stream_request_serialiser_1 = __webpack_require__(1429);
	exports.SET_TOPIC = {
	    id: 118,
	    request: set_topic_request_serialiser_1.SetTopicRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.ADD_AND_SET_TOPIC = {
	    id: 122,
	    request: add_and_set_topic_request_serialiser_1.AddAndSetTopicRequestSerialiser,
	    response: add_topic_result_serialiser_1.AddTopicResultSerialiser
	};
	exports.APPLY_JSON_PATCH = {
	    id: 151,
	    request: apply_json_patch_request_serialiser_1.ApplyJsonPatchRequestSerialiser,
	    response: json_patch_result_serialiser_1.JsonPatchResultSerialiser
	};
	exports.CREATE_UPDATE_STREAM = {
	    id: 125,
	    request: create_update_stream_request_serialiser_1.CreateUpdateStreamRequestSerialiser,
	    response: create_update_stream_response_serialiser_1.CreateUpdateStreamResponseSerialiser
	};
	exports.CREATE_UPDATE_STREAM_AND_SET = {
	    id: 126,
	    request: create_update_stream_and_set_request_serialiser_1.CreateUpdateStreamAndSetRequestSerialiser,
	    response: create_update_stream_response_serialiser_1.CreateUpdateStreamResponseSerialiser
	};
	exports.CHECK_UPDATE_STREAM = {
	    id: 127,
	    request: update_stream_id_serialiser_1.UpdateStreamIdSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.STREAM_SET_TOPIC_SERVICE = {
	    id: 128,
	    request: update_stream_request_serialiser_1.UpdateStreamRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.STREAM_APPLY_DELTA_SERVICE = {
	    id: 129,
	    request: update_stream_request_serialiser_1.UpdateStreamRequestSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.STREAM_ADD_TOPIC_SERVICE = {
	    id: 130,
	    request: update_stream_add_topic_request_serialiser_1.UpdateStreamAddTopicRequestSerialiser,
	    response: update_stream_add_topic_response_serialiser_1.UpdateStreamAddTopicResponseSerialiser
	};
	exports.STREAM_ADD_AND_SET_TOPIC_SERVICE = {
	    id: 131,
	    request: add_and_set_topic_request_serialiser_1.AddAndSetTopicRequestSerialiser,
	    response: update_stream_add_topic_response_serialiser_1.UpdateStreamAddTopicResponseSerialiser
	};


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var TopicSpecificationSerialiser = __webpack_require__(147);
	var UpdateConstraintSerialiser = __webpack_require__(146);
	/**
	 * Serialiser for {@link AddAndSetTopicRequest}
	 */
	var AddAndSetTopicRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(AddAndSetTopicRequestSerialiserClass, _super);
	    function AddAndSetTopicRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link AddAndSetTopicRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link AddAndSetTopicRequest} to be written
	     */
	    AddAndSetTopicRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        TopicSpecificationSerialiser.write(bos, value.topicSpecification);
	        Codec.writeBytes(bos, value.value);
	        UpdateConstraintSerialiser.write(bos, value.constraint);
	    };
	    return AddAndSetTopicRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.AddAndSetTopicRequestSerialiserClass = AddAndSetTopicRequestSerialiserClass;
	/**
	 * The {@link AddAndSetTopicRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.AddAndSetTopicRequestSerialiser = new AddAndSetTopicRequestSerialiserClass();


/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for the ADD_AND_SET_TOPIC_SERVICE and STREAM_ADD_AND_SET_TOPIC_SERVICE requests.
	 */
	var AddAndSetTopicRequest = /** @class */ (function () {
	    /**
	     * Create a new AddAndSetTopicRequest instance
	     *
	     * @param path  the topic path
	     * @param topicSpecification  the topic specification
	     * @param value  the value to set the topic to
	     * @param constraint  the update constraint
	     */
	    function AddAndSetTopicRequest(path, topicSpecification, value, constraint) {
	        this.path = path;
	        this.topicSpecification = topicSpecification;
	        this.value = value;
	        this.constraint = constraint;
	    }
	    return AddAndSetTopicRequest;
	}());
	exports.AddAndSetTopicRequest = AddAndSetTopicRequest;


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The response of TopicUpdate ADD_AND_SET_TOPIC service
	 */
	var AddTopicResult = /** @class */ (function () {
	    /**
	     * Create a new AddAndSetTopicRequest instance
	     *
	     * @param result  topic creation result
	     */
	    function AddTopicResult(result) {
	        this.result = result;
	    }
	    return AddTopicResult;
	}());
	exports.AddTopicResult = AddTopicResult;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var UpdateConstraintSerialiser = __webpack_require__(146);
	/**
	 * Serialiser for {@link ApplyJsonPatchRequest}
	 */
	var ApplyJsonPatchRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(ApplyJsonPatchRequestSerialiserClass, _super);
	    function ApplyJsonPatchRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link ApplyJsonPatchRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link ApplyJsonPatchRequest} to be written
	     */
	    ApplyJsonPatchRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        Codec.writeString(bos, value.patch);
	        UpdateConstraintSerialiser.write(bos, value.constraint);
	    };
	    return ApplyJsonPatchRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ApplyJsonPatchRequestSerialiserClass = ApplyJsonPatchRequestSerialiserClass;
	/**
	 * The {@link ApplyJsonPatchRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ApplyJsonPatchRequestSerialiser = new ApplyJsonPatchRequestSerialiserClass();


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Write a {@link BinaryValue} update constraint to the stream
	 */
	function write(bos, value) {
	    Codec.writeBytes(bos, value.getBytes().asBuffer());
	}
	exports.write = write;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Write a {@link Conjunction} update constraint to the stream
	 */
	function write(bos, value, writer) {
	    Codec.writeCollection(bos, value.getConstraints(), writer);
	}
	exports.write = write;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var UpdateConstraintSerialiser = __webpack_require__(146);
	/**
	 * Serialiser for {@link CreateUpdateStreamAndSetRequest}
	 */
	var CreateUpdateStreamAndSetRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(CreateUpdateStreamAndSetRequestSerialiserClass, _super);
	    function CreateUpdateStreamAndSetRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link CreateUpdateStreamAndSetRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link CreateUpdateStreamAndSetRequest} to be written
	     */
	    CreateUpdateStreamAndSetRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        BEES.write(bos, value.topicType);
	        Codec.writeBytes(bos, value.value);
	        UpdateConstraintSerialiser.write(bos, value.constraint);
	    };
	    return CreateUpdateStreamAndSetRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CreateUpdateStreamAndSetRequestSerialiserClass = CreateUpdateStreamAndSetRequestSerialiserClass;
	/**
	 * The {@link CreateUpdateStreamAndSetRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CreateUpdateStreamAndSetRequestSerialiser = new CreateUpdateStreamAndSetRequestSerialiserClass();


/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a CREATE_UPDATE_STREAM_AND_SET request.
	 */
	var CreateUpdateStreamAndSetRequest = /** @class */ (function () {
	    /**
	     * Create a new CreateUpdateStreamAndSetRequest instance
	     *
	     * @param path  the topic path
	     * @param topicType  the topic type
	     * @param value  the value to set the topic to
	     * @param constraint  the update constraint
	     */
	    function CreateUpdateStreamAndSetRequest(path, topicType, value, constraint) {
	        this.path = path;
	        this.topicType = topicType;
	        this.value = value;
	        this.constraint = constraint;
	    }
	    return CreateUpdateStreamAndSetRequest;
	}());
	exports.CreateUpdateStreamAndSetRequest = CreateUpdateStreamAndSetRequest;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var UpdateConstraintSerialiser = __webpack_require__(146);
	/**
	 * Serialiser for {@link CreateUpdateStreamRequest}
	 */
	var CreateUpdateStreamRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(CreateUpdateStreamRequestSerialiserClass, _super);
	    function CreateUpdateStreamRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link CreateUpdateStreamRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link CreateUpdateStreamRequest} to be written
	     */
	    CreateUpdateStreamRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        BEES.write(bos, value.topicType);
	        UpdateConstraintSerialiser.write(bos, value.constraint);
	    };
	    return CreateUpdateStreamRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CreateUpdateStreamRequestSerialiserClass = CreateUpdateStreamRequestSerialiserClass;
	/**
	 * The {@link CreateUpdateStreamRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CreateUpdateStreamRequestSerialiser = new CreateUpdateStreamRequestSerialiserClass();


/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a CREATE_UPDATE_STREAM request.
	 */
	var CreateUpdateStreamRequest = /** @class */ (function () {
	    /**
	     * Create a new CreateUpdateStreamRequest instance
	     *
	     * @param path  the topic path
	     * @param topicType  the topic type
	     * @param constraint  the update constraint
	     */
	    function CreateUpdateStreamRequest(path, topicType, constraint) {
	        this.path = path;
	        this.topicType = topicType;
	        this.constraint = constraint;
	    }
	    return CreateUpdateStreamRequest;
	}());
	exports.CreateUpdateStreamRequest = CreateUpdateStreamRequest;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var create_update_stream_response_1 = __webpack_require__(1415);
	var update_stream_id_serialiser_1 = __webpack_require__(234);
	/**
	 * Serialiser for {@link CreateUpdateStreamResponse}
	 */
	var CreateUpdateStreamResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(CreateUpdateStreamResponseSerialiserClass, _super);
	    function CreateUpdateStreamResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link CreateUpdateStreamResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link CreateUpdateStreamResponse} that was read
	     */
	    CreateUpdateStreamResponseSerialiserClass.prototype.read = function (bis) {
	        var streamId = update_stream_id_serialiser_1.UpdateStreamIdSerialiser.read(bis);
	        var flags = Codec.readByte(bis);
	        // tslint:disable-next-line:no-bitwise
	        var retainsValue = (flags & 1) > 0;
	        // tslint:disable-next-line:no-bitwise
	        var supportsConflation = (flags & 2) > 0;
	        return new create_update_stream_response_1.CreateUpdateStreamResponse(streamId, retainsValue, supportsConflation);
	    };
	    return CreateUpdateStreamResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CreateUpdateStreamResponseSerialiserClass = CreateUpdateStreamResponseSerialiserClass;
	/**
	 * The {@link CreateUpdateStreamResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CreateUpdateStreamResponseSerialiser = new CreateUpdateStreamResponseSerialiserClass();


/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server response from a CREATE_UPDATE_STREAM or CREATE_UPDATE_STREAM_AND_SET request.
	 */
	var CreateUpdateStreamResponse = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamAddTopicResponse instance
	     *
	     * @param streamId  the update-stream ID
	     * @param retainsValue  indicates if the topic retains a value
	     * @param supportsConflation  indicates if the topic supports conflation
	     */
	    function CreateUpdateStreamResponse(streamId, retainsValue, supportsConflation) {
	        this.streamId = streamId;
	        this.retainsValue = retainsValue;
	        this.supportsConflation = supportsConflation;
	    }
	    return CreateUpdateStreamResponse;
	}());
	exports.CreateUpdateStreamResponse = CreateUpdateStreamResponse;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var json_patch_result_1 = __webpack_require__(1417);
	/**
	 * Serialiser for {@link JsonPatchResult}
	 */
	var JsonPatchResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(JsonPatchResultSerialiserClass, _super);
	    function JsonPatchResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link JsonPatchResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link JsonPatchResult} that was read
	     */
	    JsonPatchResultSerialiserClass.prototype.read = function (bis) {
	        var failedOperation = Codec.readInt32(bis);
	        return new json_patch_result_1.JsonPatchResult(failedOperation);
	    };
	    return JsonPatchResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.JsonPatchResultSerialiserClass = JsonPatchResultSerialiserClass;
	/**
	 * The {@link JsonPatchResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.JsonPatchResultSerialiser = new JsonPatchResultSerialiserClass();


/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The response of TopicUpdate ADD_AND_SET_TOPIC service
	 */
	var JsonPatchResult = /** @class */ (function () {
	    /**
	     * Create a new AddAndSetTopicRequest instance
	     *
	     * @param result  topic creation result
	     */
	    function JsonPatchResult(failedOperation) {
	        this.failedOperation = failedOperation < 0 ? undefined : failedOperation;
	    }
	    return JsonPatchResult;
	}());
	exports.JsonPatchResult = JsonPatchResult;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Write a {@link Locked} update constraint to the stream
	 */
	function write(bos, value) {
	    Codec.writeString(bos, value.getLockName());
	    Codec.writeInt64(bos, value.getSequence());
	}
	exports.write = write;


/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Write a {@link NoTopic} update constraint to the stream
	 */
	function write() {
	    // no-op, write nothing
	}
	exports.write = write;


/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @module Services.TopicUpdate
	 */
	/**
	 * Write a {@link NoValue} update constraint to the stream
	 */
	function write() {
	    // no-op, write nothing
	}
	exports.write = write;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Write a {@link PartialJSONImpl} update constraint to the stream
	 */
	function write(bos, value) {
	    Codec.writeObject(bos, value.getWithValues(), Codec.writeString, function (o, bytes) {
	        Codec.writeBytes(o, bytes.asBuffer());
	    });
	    Codec.writeCollection(bos, Array.from(value.getWithoutValues()), Codec.writeString);
	}
	exports.write = write;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var UpdateConstraintSerialiser = __webpack_require__(146);
	/**
	 * Serialiser for {@link SetTopicRequest}
	 */
	var SetTopicRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(SetTopicRequestSerialiserClass, _super);
	    function SetTopicRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link SetTopicRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link SetTopicRequest} to be written
	     */
	    SetTopicRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        BEES.write(bos, value.topicType);
	        Codec.writeBytes(bos, value.value);
	        UpdateConstraintSerialiser.write(bos, value.constraint);
	    };
	    return SetTopicRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.SetTopicRequestSerialiserClass = SetTopicRequestSerialiserClass;
	/**
	 * The {@link SetTopicRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.SetTopicRequestSerialiser = new SetTopicRequestSerialiserClass();


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Write a {@link Unconstrained} update constraint to the stream
	 */
	function write() {
	    // no-op, write nothing
	}
	exports.write = write;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var TopicSpecificationSerialiser = __webpack_require__(147);
	var UpdateConstraintSerialiser = __webpack_require__(146);
	/**
	 * Serialiser for {@link UpdateStreamAddTopicRequest}
	 */
	var UpdateStreamAddTopicRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(UpdateStreamAddTopicRequestSerialiserClass, _super);
	    function UpdateStreamAddTopicRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link UpdateStreamAddTopicRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link UpdateStreamAddTopicRequest} to be written
	     */
	    UpdateStreamAddTopicRequestSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.path);
	        TopicSpecificationSerialiser.write(bos, value.topicSpecification);
	        UpdateConstraintSerialiser.write(bos, value.constraint);
	    };
	    return UpdateStreamAddTopicRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.UpdateStreamAddTopicRequestSerialiserClass = UpdateStreamAddTopicRequestSerialiserClass;
	/**
	 * The {@link UpdateStreamAddTopicRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.UpdateStreamAddTopicRequestSerialiser = new UpdateStreamAddTopicRequestSerialiserClass();


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a STREAM_ADD_TOPIC_SERVICE request.
	 */
	var UpdateStreamAddTopicRequest = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamAddTopicRequest instance
	     *
	     * @param path  the topic path
	     * @param topicSpecification  the topic specification
	     * @param constraint  the update constraint
	     */
	    function UpdateStreamAddTopicRequest(path, topicSpecification, constraint) {
	        this.path = path;
	        this.topicSpecification = topicSpecification;
	        this.constraint = constraint;
	    }
	    return UpdateStreamAddTopicRequest;
	}());
	exports.UpdateStreamAddTopicRequest = UpdateStreamAddTopicRequest;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var add_topic_result_serialiser_1 = __webpack_require__(539);
	var update_stream_add_topic_response_1 = __webpack_require__(1427);
	var update_stream_id_serialiser_1 = __webpack_require__(234);
	/**
	 * Serialiser for {@link UpdateStreamAddTopicResponse}
	 */
	var UpdateStreamAddTopicResponseSerialiserClass = /** @class */ (function (_super) {
	    __extends(UpdateStreamAddTopicResponseSerialiserClass, _super);
	    function UpdateStreamAddTopicResponseSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link UpdateStreamAddTopicResponse} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link UpdateStreamAddTopicResponse} that was read
	     */
	    UpdateStreamAddTopicResponseSerialiserClass.prototype.read = function (bis) {
	        var creationResult = add_topic_result_serialiser_1.AddTopicResultSerialiser.read(bis);
	        var streamId = update_stream_id_serialiser_1.UpdateStreamIdSerialiser.read(bis);
	        var flags = Codec.readByte(bis);
	        // tslint:disable-next-line:no-bitwise
	        var retainsValue = (flags & 1) > 0;
	        // tslint:disable-next-line:no-bitwise
	        var supportsConflation = (flags & 2) > 0;
	        return new update_stream_add_topic_response_1.UpdateStreamAddTopicResponse(creationResult.result, streamId, retainsValue, supportsConflation);
	    };
	    return UpdateStreamAddTopicResponseSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.UpdateStreamAddTopicResponseSerialiserClass = UpdateStreamAddTopicResponseSerialiserClass;
	/**
	 * The {@link UpdateStreamAddTopicResponseSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.UpdateStreamAddTopicResponseSerialiser = new UpdateStreamAddTopicResponseSerialiserClass();


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Server response from a STREAM_ADD_TOPIC_SERVICE or STREAM_ADD_AND_SET_TOPIC_SERVICE request.
	 */
	var UpdateStreamAddTopicResponse = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamAddTopicResponse instance
	     *
	     * @param creationResult  the creation result
	     * @param streamId  the update-stream ID
	     * @param retainsValue  indicates if the topic retains a value
	     * @param supportsConflation  indicates if the topic supports conflation
	     */
	    function UpdateStreamAddTopicResponse(creationResult, streamId, retainsValue, supportsConflation) {
	        this.creationResult = creationResult;
	        this.streamId = streamId;
	        this.retainsValue = retainsValue;
	        this.supportsConflation = supportsConflation;
	    }
	    return UpdateStreamAddTopicResponse;
	}());
	exports.UpdateStreamAddTopicResponse = UpdateStreamAddTopicResponse;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for various Topic Update requests and responses.
	 */
	var UpdateStreamId = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamId instance
	     *
	     * @param topicId  the topic ID
	     * @param instanceId  the instance ID
	     * @param clustered  if the update stream Id belongs to a replicated topic
	     * @param partitionId  the  partition ID
	     * @param generationId  the generation ID
	     */
	    function UpdateStreamId(topicId, instanceId, clustered, partitionId, generationId) {
	        this.topicId = topicId;
	        this.instanceId = instanceId;
	        this.clustered = clustered;
	        this.partitionId = partitionId;
	        this.generationId = generationId;
	    }
	    return UpdateStreamId;
	}());
	exports.UpdateStreamId = UpdateStreamId;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var update_stream_id_serialiser_1 = __webpack_require__(234);
	/**
	 * Serialiser for {@link UpdateStreamRequest}
	 */
	var UpdateStreamRequestSerialiserClass = /** @class */ (function (_super) {
	    __extends(UpdateStreamRequestSerialiserClass, _super);
	    function UpdateStreamRequestSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link UpdateStreamRequest} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link UpdateStreamRequest} to be written
	     */
	    UpdateStreamRequestSerialiserClass.prototype.write = function (bos, value) {
	        update_stream_id_serialiser_1.UpdateStreamIdSerialiser.write(bos, value.streamId);
	        Codec.writeBytes(bos, value.update);
	    };
	    return UpdateStreamRequestSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.UpdateStreamRequestSerialiserClass = UpdateStreamRequestSerialiserClass;
	/**
	 * The {@link UpdateStreamRequestSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.UpdateStreamRequestSerialiser = new UpdateStreamRequestSerialiserClass();


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var string_serialiser_1 = __webpack_require__(145);
	var service_definition_1 = __webpack_require__(51);
	var create_topic_view_result_serialiser_1 = __webpack_require__(1431);
	var list_topic_views_result_serialiser_1 = __webpack_require__(1433);
	var named_topic_view_specification_serialiser_1 = __webpack_require__(1435);
	exports.CREATE_TOPIC_VIEW = {
	    id: 138,
	    request: named_topic_view_specification_serialiser_1.NamedTopicViewSpecificationSerialiser,
	    response: create_topic_view_result_serialiser_1.CreateTopicViewResultSerialiser
	};
	exports.REMOVE_TOPIC_VIEW = {
	    id: 139,
	    request: string_serialiser_1.StringSerialiser,
	    response: service_definition_1.NullSerialiser
	};
	exports.LIST_TOPIC_VIEWS = {
	    id: 141,
	    request: service_definition_1.NullSerialiser,
	    response: list_topic_views_result_serialiser_1.ListTopicViewsResultSerialiser
	};


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var error_report_list_serialiser_1 = __webpack_require__(178);
	var create_topic_view_result_1 = __webpack_require__(1432);
	var read_topic_view_1 = __webpack_require__(540);
	/**
	 * Serialiser for {@link CreateTopicViewResult}
	 */
	var CreateTopicViewResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(CreateTopicViewResultSerialiserClass, _super);
	    function CreateTopicViewResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ListTopicViewsResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ListTopicViewsResult} that was read
	     */
	    CreateTopicViewResultSerialiserClass.prototype.read = function (bis) {
	        if (bis.peek() === 0) {
	            // consume the zero from the input stream
	            Codec.readByte(bis);
	            var topicView = read_topic_view_1.readTopicView(bis);
	            return new create_topic_view_result_1.CreateTopicViewResult(topicView);
	        }
	        else {
	            var errors = error_report_list_serialiser_1.ErrorReportListSerialiser.read(bis);
	            return new create_topic_view_result_1.CreateTopicViewResult(undefined, errors);
	        }
	    };
	    return CreateTopicViewResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.CreateTopicViewResultSerialiserClass = CreateTopicViewResultSerialiserClass;
	/**
	 * The {@link CreateTopicViewResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.CreateTopicViewResultSerialiser = new CreateTopicViewResultSerialiserClass();


/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicViews
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The response of TopicViews CREATE_TOPIC_VIEW service
	 */
	var CreateTopicViewResult = /** @class */ (function () {
	    /**
	     * Create a new CreateTopicViewResult instance
	     *
	     * @param view    the topic view
	     * @param errors  any errors that might have occurred
	     */
	    function CreateTopicViewResult(view, errors) {
	        this.view = view;
	        this.errors = errors;
	    }
	    return CreateTopicViewResult;
	}());
	exports.CreateTopicViewResult = CreateTopicViewResult;


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var list_topic_views_result_1 = __webpack_require__(1434);
	var read_topic_view_1 = __webpack_require__(540);
	/**
	 * Serialiser for {@link ListTopicViewsResult}
	 */
	var ListTopicViewsResultSerialiserClass = /** @class */ (function (_super) {
	    __extends(ListTopicViewsResultSerialiserClass, _super);
	    function ListTopicViewsResultSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link ListTopicViewsResult} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link ListTopicViewsResult} that was read
	     */
	    ListTopicViewsResultSerialiserClass.prototype.read = function (bis) {
	        var result = Codec.readCollection(bis, read_topic_view_1.readTopicView);
	        return new list_topic_views_result_1.ListTopicViewsResult(result);
	    };
	    return ListTopicViewsResultSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.ListTopicViewsResultSerialiserClass = ListTopicViewsResultSerialiserClass;
	/**
	 * The {@link ListTopicViewsResultSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.ListTopicViewsResultSerialiser = new ListTopicViewsResultSerialiserClass();


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicViews
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The result type of of TopicViews LIST_TOPIC_VIEWS service
	 */
	var ListTopicViewsResult = /** @class */ (function () {
	    /**
	     * Create a new ListTopicViewsResult instance
	     *
	     * @param result  the array of topic views
	     */
	    function ListTopicViewsResult(result) {
	        this.result = result;
	    }
	    return ListTopicViewsResult;
	}());
	exports.ListTopicViewsResult = ListTopicViewsResult;


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.TopicUpdate
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	/**
	 * Serialiser for {@link NamedTopicViewSpecification}
	 */
	var NamedTopicViewSpecificationSerialiserClass = /** @class */ (function (_super) {
	    __extends(NamedTopicViewSpecificationSerialiserClass, _super);
	    function NamedTopicViewSpecificationSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Write a {@link NamedTopicViewSpecification} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link NamedTopicViewSpecification} to be written
	     */
	    NamedTopicViewSpecificationSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeString(bos, value.name);
	        Codec.writeString(bos, value.specification);
	    };
	    return NamedTopicViewSpecificationSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.NamedTopicViewSpecificationSerialiserClass = NamedTopicViewSpecificationSerialiserClass;
	/**
	 * The {@link NamedTopicViewSpecificationSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.NamedTopicViewSpecificationSerialiser = new NamedTopicViewSpecificationSerialiserClass();


/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.TopicViews
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The request of TopicViews CREATE_TOPIC_VIEW service
	 */
	var NamedTopicViewSpecification = /** @class */ (function () {
	    /**
	     * Create a new NamedTopicViewSpecification instance
	     *
	     * @param name           the topic view name
	     * @param specification  the topic view specification
	     */
	    function NamedTopicViewSpecification(name, specification) {
	        this.name = name;
	        this.specification = specification;
	    }
	    return NamedTopicViewSpecification;
	}());
	exports.NamedTopicViewSpecification = NamedTopicViewSpecification;


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Services.UnsubscriptionNotification
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var BEES = __webpack_require__(25);
	var serialiser_1 = __webpack_require__(4);
	var TopicIdSerialiser = __webpack_require__(1449);
	var topics_1 = __webpack_require__(148);
	var unsubscription_notification_1 = __webpack_require__(1438);
	/**
	 * Serialiser for {@link UnsubscriptionNotification}
	 */
	var UnsubscriptionNotificationSerialiserClass = /** @class */ (function (_super) {
	    __extends(UnsubscriptionNotificationSerialiserClass, _super);
	    function UnsubscriptionNotificationSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link UnsubscriptionNotification} from the stream
	     *
	     * @param bis  the input stream
	     * @return     the {@link UnsubscriptionNotification} that was read
	     */
	    UnsubscriptionNotificationSerialiserClass.prototype.read = function (bis) {
	        var id = TopicIdSerialiser.read(bis);
	        var reason = BEES.read(bis, topics_1.UnsubscribeReasonEnum);
	        return new unsubscription_notification_1.UnsubscriptionNotification(id, reason);
	    };
	    /**
	     * Write a {@link UnsubscriptionNotification} to the stream
	     *
	     * @param bos    the output stream
	     * @param value  the {@link UnsubscriptionNotification} to be written
	     */
	    UnsubscriptionNotificationSerialiserClass.prototype.write = function (bos, value) {
	        TopicIdSerialiser.write(bos, value.id);
	        if (value.reason.id === undefined) {
	            throw new Error('Cannot serialise UnsubscribeReason ${value.reason.reason}');
	        }
	        BEES.write(bos, value.reason);
	    };
	    return UnsubscriptionNotificationSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.UnsubscriptionNotificationSerialiserClass = UnsubscriptionNotificationSerialiserClass;
	/**
	 * The {@link UnsubscriptionNotificationSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.UnsubscriptionNotificationSerialiser = new UnsubscriptionNotificationSerialiserClass();


/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Services.UnsubscriptionNotification
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a UNSUBSCRIPTION_NOTIFICATION request.
	 */
	var UnsubscriptionNotification = /** @class */ (function () {
	    /**
	     * Create a new UnsubscriptionNotification instance
	     *
	     * @param id  the topic ID
	     * @param reason  the reason for unsubscribing
	     */
	    function UnsubscriptionNotification(id, reason) {
	        this.id = id;
	        this.reason = reason;
	    }
	    return UnsubscriptionNotification;
	}());
	exports.UnsubscriptionNotification = UnsubscriptionNotification;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Session
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var emitter_1 = __webpack_require__(79);
	var client_control_1 = __webpack_require__(1187);
	var gateway_control_1 = __webpack_require__(332);
	var log_retrieval_1 = __webpack_require__(1190);
	var messages_1 = __webpack_require__(1191);
	var metrics_1 = __webpack_require__(1192);
	var ping_1 = __webpack_require__(1195);
	var remote_servers_1 = __webpack_require__(1196);
	var replace_license_1 = __webpack_require__(1198);
	var security_1 = __webpack_require__(1199);
	var session_trees_1 = __webpack_require__(1208);
	var time_series_1 = __webpack_require__(1212);
	var topic_control_1 = __webpack_require__(1213);
	var topic_notifications_1 = __webpack_require__(1215);
	var topic_update_1 = __webpack_require__(1216);
	var topic_views_1 = __webpack_require__(1217);
	var topics_1 = __webpack_require__(1218);
	var options_impl_1 = __webpack_require__(542);
	var session_lock_options_1 = __webpack_require__(173);
	/**
	 * Immplementation of the {@link Session} interface
	 */
	var SessionImpl = /** @class */ (function (_super) {
	    __extends(SessionImpl, _super);
	    /**
	     * Create a new SessionImpl instance
	     *
	     * @param sessionID        the session ID
	     * @param options          the session options
	     * @param internalSession  the internal session
	     */ // tslint:disable-next-line:cyclomatic-complexity
	    function SessionImpl(sessionId, options, internalSession) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, internalSession, factory) || this;
	        var emitter = factory.emitter(_this);
	        // re-emit internal session events
	        internalSession.on({
	            reconnect: function () {
	                emitter.emit('reconnect');
	            },
	            disconnect: function (reason) {
	                emitter.emit('disconnect', reason);
	            },
	            error: function (err) {
	                emitter.emit('error', err);
	            },
	            close: function (reason) {
	                emitter.emit('close', reason);
	            }
	        });
	        _this.sessionId = sessionId;
	        _this.sessionID = sessionId.toString();
	        // tslint:disable-next-line:strict-type-predicates
	        if (topic_control_1.TopicControlImpl !== undefined) {
	            _this.topicsFeature = new topic_control_1.TopicControlImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (client_control_1.ClientControlImpl !== undefined) {
	            _this.clientsFeature = new client_control_1.ClientControlImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (gateway_control_1.GatewayControlImpl !== undefined) {
	            _this.gatewaysFeature = new gateway_control_1.GatewayControlImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (messages_1.MessagesImpl !== undefined) {
	            _this.messagesFeature = new messages_1.MessagesImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (topic_notifications_1.TopicNotificationsImpl !== undefined) {
	            _this.notificationsFeature = new topic_notifications_1.TopicNotificationsImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (remote_servers_1.RemoteServersImpl !== undefined) {
	            _this.remoteServersFeature = new remote_servers_1.RemoteServersImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (security_1.SecurityImpl !== undefined) {
	            _this.securityFeature = new security_1.SecurityImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (session_trees_1.SessionTreesImpl !== undefined) {
	            _this.sessionTreesFeature = new session_trees_1.SessionTreesImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (time_series_1.TimeSeriesImpl !== undefined) {
	            _this.timeseriesFeature = new time_series_1.TimeSeriesImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (topic_update_1.TopicUpdateImpl !== undefined) {
	            _this.topicUpdateFeature = new topic_update_1.TopicUpdateImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (topic_views_1.TopicViewsImpl !== undefined) {
	            _this.topicViewsFeature = new topic_views_1.TopicViewsImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (log_retrieval_1.LogRetrieval !== undefined) {
	            _this.logRetrievalFeature = new log_retrieval_1.LogRetrieval(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (metrics_1.MetricsImpl !== undefined) {
	            _this.metricsFeature = new metrics_1.MetricsImpl(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (replace_license_1.LicenceUpdater !== undefined) {
	            _this.licenceUpdaterFeature = new replace_license_1.LicenceUpdater(internalSession);
	        }
	        // tslint:disable-next-line:strict-type-predicates
	        if (ping_1.PingImpl !== undefined) {
	            _this.pingFeature = new ping_1.PingImpl(internalSession);
	        }
	        // remove credentials to prevent 3rd party access
	        _this.options = options !== undefined
	            ? options.with({
	                credentials: undefined
	            })
	            : {};
	        return _this;
	    }
	    Object.defineProperty(SessionImpl.prototype, "topics", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.topicsFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (topic_control_1.TopicControlImpl !== undefined) {
	                    this.topicsFeature = new topic_control_1.TopicControlImpl(this.internal);
	                }
	                else {
	                    throw new Error('Topic Control feature has not been loaded');
	                }
	            }
	            return this.topicsFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "clients", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.clientsFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (client_control_1.ClientControlImpl !== undefined) {
	                    this.clientsFeature = new client_control_1.ClientControlImpl(this.internal);
	                }
	                else {
	                    throw new Error('Client Control feature has not been loaded');
	                }
	            }
	            return this.clientsFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "messages", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.messagesFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (messages_1.MessagesImpl !== undefined) {
	                    this.messagesFeature = new messages_1.MessagesImpl(this.internal);
	                }
	                else {
	                    throw new Error('Messages feature has not been loaded');
	                }
	            }
	            return this.messagesFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "notifications", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.notificationsFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (topic_notifications_1.TopicNotificationsImpl !== undefined) {
	                    this.notificationsFeature = new topic_notifications_1.TopicNotificationsImpl(this.internal);
	                }
	                else {
	                    throw new Error('Topic Notifications feature has not been loaded');
	                }
	            }
	            return this.notificationsFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "security", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.securityFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (security_1.SecurityImpl !== undefined) {
	                    this.securityFeature = new security_1.SecurityImpl(this.internal);
	                }
	                else {
	                    throw new Error('Security feature has not been loaded');
	                }
	            }
	            return this.securityFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "sessionTrees", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.sessionTreesFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (session_trees_1.SessionTreesImpl !== undefined) {
	                    this.sessionTreesFeature = new session_trees_1.SessionTreesImpl(this.internal);
	                }
	                else {
	                    throw new Error('Session Trees feature has not been loaded');
	                }
	            }
	            return this.sessionTreesFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "timeseries", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.timeseriesFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (time_series_1.TimeSeriesImpl !== undefined) {
	                    this.timeseriesFeature = new time_series_1.TimeSeriesImpl(this.internal);
	                }
	                else {
	                    throw new Error('Timeseries feature has not been loaded');
	                }
	            }
	            return this.timeseriesFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "topicUpdate", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.topicUpdateFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (topic_update_1.TopicUpdateImpl !== undefined) {
	                    this.topicUpdateFeature = new topic_update_1.TopicUpdateImpl(this.internal);
	                }
	                else {
	                    throw new Error('Topic Update feature has not been loaded');
	                }
	            }
	            return this.topicUpdateFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "topicViews", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.topicViewsFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (topic_views_1.TopicViewsImpl !== undefined) {
	                    this.topicViewsFeature = new topic_views_1.TopicViewsImpl(this.internal);
	                }
	                else {
	                    throw new Error('Topic Views feature has not been loaded');
	                }
	            }
	            return this.topicViewsFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "remoteServers", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.remoteServersFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (remote_servers_1.RemoteServersImpl !== undefined) {
	                    this.remoteServersFeature = new remote_servers_1.RemoteServersImpl(this.internal);
	                }
	                else {
	                    throw new Error('Remote Servers feature has not been loaded');
	                }
	            }
	            return this.remoteServersFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "logRetrieval", {
	        /**
	         * Internal log retrieval capabilities via {@link SessionImpl.logRetrieval}
	         */
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.logRetrievalFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (log_retrieval_1.LogRetrieval !== undefined) {
	                    this.logRetrievalFeature = new log_retrieval_1.LogRetrieval(this.internal);
	                }
	                else {
	                    throw new Error('Log Retrieval feature has not been loaded');
	                }
	            }
	            return this.logRetrievalFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "metrics", {
	        /**
	         * Internal metrics capabilities via {@link SessionImpl.metrics}
	         */
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.metricsFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (metrics_1.MetricsImpl !== undefined) {
	                    this.metricsFeature = new metrics_1.MetricsImpl(this.internal);
	                }
	                else {
	                    throw new Error('Metrics feature has not been loaded');
	                }
	            }
	            return this.metricsFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "licenceUpdater", {
	        /**
	         * The Licence updating service
	         */
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.licenceUpdaterFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (replace_license_1.LicenceUpdater !== undefined) {
	                    this.licenceUpdaterFeature = new replace_license_1.LicenceUpdater(this.internal);
	                }
	                else {
	                    throw new Error('Licence Updater feature has not been loaded');
	                }
	            }
	            return this.licenceUpdaterFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "gateways", {
	        /**
	         * Internal gateway control capabilities via {@link SessionImpl.gateways}
	         */
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.gatewaysFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (gateway_control_1.GatewayControlImpl !== undefined) {
	                    this.gatewaysFeature = new gateway_control_1.GatewayControlImpl(this.internal);
	                }
	                else {
	                    throw new Error('Gateway Control feature has not been loaded');
	                }
	            }
	            return this.gatewaysFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SessionImpl.prototype, "ping", {
	        get: function () {
	            // tslint:disable-next-line:strict-type-predicates
	            if (this.pingFeature === undefined) {
	                // tslint:disable-next-line:strict-type-predicates
	                if (ping_1.PingImpl !== undefined) {
	                    this.pingFeature = new ping_1.PingImpl(this.internal);
	                }
	                else {
	                    throw new Error('Ping feature has not been loaded');
	                }
	            }
	            return this.pingFeature;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Updates the session with missing features that may have been loaded
	     * asynchronously. This method only has an effect when running the client
	     * as a modular client in the browser.
	     *
	     */ // tslint:disable-next-line:cyclomatic-complexity
	    SessionImpl.prototype.updateFeatures = function () {
	        this.internal.updateFeatures();
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.close = function () {
	        this.internal.close();
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.closeSession = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.on('close', resolve);
	            _this.close();
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.isClosed = function () {
	        var state = this.internal.getState();
	        return state === 'closing' || state === 'closed';
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.isConnected = function () {
	        return this.internal.isConnected();
	    };
	    SessionImpl.prototype.toString = function () {
	        return "Session<" + this.sessionId + " " + this.internal.getState() + ">";
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.getPrincipal = function () {
	        return this.options.principal || '';
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.lock = function (lockName, scope) {
	        if (scope === void 0) { scope = session_lock_options_1.SessionLockScope.UNLOCK_ON_SESSION_LOSS; }
	        return this.internal.lock(lockName, scope);
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionImpl.prototype.pingServer = function () {
	        return this.ping.pingServer();
	    };
	    /**
	     * Get the server's maximum message size.
	     *
	     * <p>Not exposed through the API.
	     */
	    SessionImpl.prototype.getServerMaximumMessageSize = function () {
	        return this.internal.getServerMaximumMessageSize();
	    };
	    /**
	     * Create a new session object
	     *
	     * @param internalSessionFactory  a factory function for creating new internal
	     *                                sessions
	     * @param options                 the user supplied options, may be undefined
	     *                                when connecting to a shared sesssion
	     * @returns                       a result that resolves with the new session
	     */
	    SessionImpl.create = function (internalSessionFactory, options) {
	        // merge defaults if options argument is defined
	        var optionsImpl;
	        if (options !== undefined) {
	            optionsImpl = (typeof options === 'string')
	                ? new options_impl_1.OptionsImpl({ host: options })
	                : new options_impl_1.OptionsImpl(options);
	        }
	        // connection promise
	        return new Promise(function (resolve, reject) {
	            var internalSession = internalSessionFactory(optionsImpl);
	            function onConnect(sessionId, opts) {
	                internalSession.off('connect', onConnect);
	                internalSession.off('close', onError);
	                internalSession.off('error', onError);
	                resolve(new SessionImpl(sessionId, opts || optionsImpl, internalSession));
	            }
	            function onError(err) {
	                internalSession.off('connect', onConnect);
	                internalSession.off('close', onError);
	                internalSession.off('error', onError);
	                reject(err);
	            }
	            internalSession.on('connect', onConnect);
	            internalSession.on('close', onError);
	            internalSession.on('error', onError);
	            internalSession.connect();
	        });
	    };
	    return SessionImpl;
	}(topics_1.TopicsImpl));
	exports.SessionImpl = SessionImpl;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Session
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var session_token_1 = __webpack_require__(1441);
	/**
	 * Read a {@link SessionToken}
	 *
	 * @param  input  the input stream to read from
	 * @return        a new session token
	 */
	function readSessionToken(input) {
	    return new session_token_1.SessionToken(input.readMany(session_token_1.TOKEN_LENGTH));
	}
	exports.readSessionToken = readSessionToken;


/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Session
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The buffer length os a session token
	 */
	exports.TOKEN_LENGTH = 24;
	/**
	 * A session token
	 */
	var SessionToken = /** @class */ (function () {
	    /**
	     * Create
	     *
	     * @param  {type} external: Buffer description
	     * @return {type}                  description
	     */
	    function SessionToken(external) {
	        this.external = external;
	    }
	    /**
	     * Convert the token to a string
	     *
	     * @return the string representation of the token
	     */
	    SessionToken.prototype.toString = function () {
	        return this.external.toString('ascii');
	    };
	    return SessionToken;
	}());
	exports.SessionToken = SessionToken;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var add_and_set_topic_request_1 = __webpack_require__(1405);
	var update_stream_add_topic_request_1 = __webpack_require__(1425);
	var pending_set_stream_1 = __webpack_require__(544);
	var pending_validate_stream_1 = __webpack_require__(545);
	var logger = __webpack_require__(17);
	var response_success_1 = __webpack_require__(68);
	var log = logger.create('diffusion.TopicUpdate');
	/**
	 * An update stream delegate that is used when a new stream is created that
	 * should add a topic. No calls to {@link set} or {@link validate} have been
	 * made yet.
	 */
	var NewAddTopicAndUpdateStream = /** @class */ (function () {
	    /**
	     * Create a new NewAddTopicAndUpdateStream instance
	     *
	     * @param streamServices  the stream services
	     * @param options         the update stream options
	     * @param stream          the stream that using this stream as a delegate
	     * @param path            the topic path to add and update
	     * @param specification   the topic specification of the topic to add
	     * @param constraint      the topic update constraint
	     */
	    function NewAddTopicAndUpdateStream(streamServices, options, stream, path, specification, constraint) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.path = path;
	        this.specification = specification;
	        this.constraint = constraint;
	    }
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        var result = new Promise(function (resolve, reject) {
	            var buffer = _this.options.dataType.toBytes(value).asBuffer();
	            _this.streamServices.STREAM_ADD_AND_SET_TOPIC_SERVICE.send(new add_and_set_topic_request_1.AddAndSetTopicRequest(_this.path, _this.specification, buffer, _this.constraint), function (err, response) {
	                if (!response_success_1.responseSuccess(err, response)) {
	                    log.debug('Stream add and set topic failed');
	                    _this.stream.onSetFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onSetComplete(response.streamId, response.retainsValue, response.supportsConflation);
	                    resolve(response.creationResult);
	                }
	            });
	        });
	        this.stream.setDelegate(new pending_set_stream_1.PendingSetStream(this.streamServices, this.options, this.stream, result, value));
	        return result;
	    };
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.get = function () {
	        throw new Error('The set method has not been called');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.validate = function () {
	        var _this = this;
	        var result = new Promise(function (resolve, reject) {
	            _this.streamServices.STREAM_ADD_TOPIC_SERVICE.send(new update_stream_add_topic_request_1.UpdateStreamAddTopicRequest(_this.path, _this.specification, _this.constraint), function (err, response) {
	                if (!response_success_1.responseSuccess(err, response)) {
	                    log.debug('Stream add topic failed');
	                    _this.stream.onValidateFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onValidateComplete(response.streamId, response.retainsValue, response.supportsConflation);
	                    resolve(response.creationResult);
	                }
	            });
	        });
	        this.stream.setDelegate(new pending_validate_stream_1.PendingValidateStream(this.streamServices, this.options, this.stream, result));
	        return result;
	    };
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.onSetComplete = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.onSetFailed = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.onValidateComplete = function () {
	        throw new Error('No validate request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewAddTopicAndUpdateStream.prototype.onValidateFailed = function () {
	        throw new Error('No validate request has been sent');
	    };
	    return NewAddTopicAndUpdateStream;
	}());
	exports.NewAddTopicAndUpdateStream = NewAddTopicAndUpdateStream;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var create_update_stream_and_set_request_1 = __webpack_require__(1411);
	var create_update_stream_request_1 = __webpack_require__(1413);
	var pending_set_stream_1 = __webpack_require__(544);
	var pending_validate_stream_1 = __webpack_require__(545);
	var logger = __webpack_require__(17);
	var response_success_1 = __webpack_require__(68);
	var topic_update_1 = __webpack_require__(90);
	var log = logger.create('diffusion.TopicUpdate');
	/**
	 * An update stream delegate that is used when a new stream is created that
	 * should not add a topic. No calls to {@link set} or {@link validate} have been
	 * made yet.
	 */
	var NewUpdateStream = /** @class */ (function () {
	    /**
	     * Create a new NewUpdateStream instance
	     *
	     * @param streamServices  the stream services
	     * @param options         the update stream options
	     * @param stream          the stream that using this stream as a delegate
	     * @param path            the topic path to add and update
	     * @param topicType       the topic type
	     * @param constraint      the topic update constraint
	     */
	    function NewUpdateStream(streamServices, options, stream, path, topicType, constraint) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.path = path;
	        this.topicType = topicType;
	        this.constraint = constraint;
	    }
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        var result = new Promise(function (resolve, reject) {
	            var buffer = _this.options.dataType.toBytes(value).asBuffer();
	            _this.streamServices.CREATE_UPDATE_STREAM_AND_SET.send(new create_update_stream_and_set_request_1.CreateUpdateStreamAndSetRequest(_this.path, _this.topicType, buffer, _this.constraint), function (err, response) {
	                if (!response_success_1.responseSuccess(err, response)) {
	                    log.debug('Failed to create update stream and set');
	                    _this.stream.onSetFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onSetComplete(response.streamId, response.retainsValue, response.supportsConflation);
	                    resolve(topic_update_1.TopicCreationResult.EXISTS);
	                }
	            });
	        });
	        this.stream.setDelegate(new pending_set_stream_1.PendingSetStream(this.streamServices, this.options, this.stream, result, value));
	        return result;
	    };
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.get = function () {
	        throw new Error('The set method has not been called');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.validate = function () {
	        var _this = this;
	        var result = new Promise(function (resolve, reject) {
	            _this.streamServices.CREATE_UPDATE_STREAM.send(new create_update_stream_request_1.CreateUpdateStreamRequest(_this.path, _this.topicType, _this.constraint), function (err, response) {
	                if (!response_success_1.responseSuccess(err, response)) {
	                    log.debug('Create update stream failed');
	                    _this.stream.onValidateFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onValidateComplete(response.streamId, response.retainsValue, response.supportsConflation);
	                    resolve(topic_update_1.TopicCreationResult.EXISTS);
	                }
	            });
	        });
	        this.stream.setDelegate(new pending_validate_stream_1.PendingValidateStream(this.streamServices, this.options, this.stream, result));
	        return result;
	    };
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.onSetComplete = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.onSetFailed = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.onValidateComplete = function () {
	        throw new Error('No validate request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    NewUpdateStream.prototype.onValidateFailed = function () {
	        throw new Error('No validate request has been sent');
	    };
	    return NewUpdateStream;
	}());
	exports.NewUpdateStream = NewUpdateStream;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var update_stream_request_1 = __webpack_require__(235);
	var invalid_set_stream_1 = __webpack_require__(341);
	var set_stream_1 = __webpack_require__(342);
	var topic_update_1 = __webpack_require__(90);
	/**
	 * An update stream delegate that is used when first a {@link validate}
	 * operation and then a {@link set} operation is called on a new stream. The
	 * server has not yet responded to the initial validate operation.
	 */
	var PendingValidateAndSetStream = /** @class */ (function () {
	    /**
	     * Create a new PendingValidateAndSetStream instance
	     *
	     * @param streamServices   the stream services
	     * @param options          the update stream options
	     * @param stream           the stream that using this stream as a delegate
	     * @param pendingResult    the pending result
	     * @param deferredEmitter  the deferred emitter that should be emitted once
	     *                         the pending result completes
	     * @param value            the value of the pending set operation
	     */
	    function PendingValidateAndSetStream(streamServices, options, stream, pendingResult, deferredEmitter, value) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.pendingResult = pendingResult;
	        this.deferredResolvers = [deferredEmitter];
	        this.nextValue = value;
	    }
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        this.nextValue = value;
	        return new Promise(function (resolve, reject) {
	            _this.deferredResolvers.push({ value: value, resolve: resolve, reject: reject });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.get = function () {
	        return this.nextValue;
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.validate = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.pendingResult.then(function (r) {
	                resolve(topic_update_1.TopicCreationResult.EXISTS);
	                return r;
	            }, function (err) {
	                reject(err);
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.onSetComplete = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.onSetFailed = function () {
	        throw new Error('No set request has been sent');
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.onValidateComplete = function (streamId, retainsValue, supportsConflation) {
	        var _this = this;
	        this.options.retainsValue = retainsValue;
	        this.options.supportsConflation = supportsConflation;
	        if (!retainsValue) {
	            this.options.toBuffer = function (oldValue, newValue) {
	                return _this.options.dataType.toBytes(newValue).asBuffer();
	            };
	            this.options.deltaService = this.streamServices.STREAM_SET_TOPIC_SERVICE;
	        }
	        this.stream.setDelegate(new set_stream_1.SetStream(this.streamServices, this.options, this.stream, streamId, this.nextValue));
	        if (retainsValue && supportsConflation) {
	            this.processPendingUpdatesRetainsValue(streamId);
	        }
	        else {
	            this.processPendingUpdatesDoesntRetainValue(streamId);
	        }
	    };
	    PendingValidateAndSetStream.prototype.processPendingUpdatesRetainsValue = function (streamId) {
	        var _this = this;
	        var buffer = this.options.dataType.toBytes(this.nextValue).asBuffer();
	        this.streamServices.STREAM_SET_TOPIC_SERVICE.send(new update_stream_request_1.UpdateStreamRequest(streamId, buffer), function (err) {
	            if (err) {
	                _this.deferredResolvers.forEach(function (resolver) {
	                    resolver.reject(err);
	                });
	            }
	            else {
	                _this.deferredResolvers.forEach(function (resolver) {
	                    resolver.resolve();
	                });
	            }
	        });
	    };
	    PendingValidateAndSetStream.prototype.processPendingUpdatesDoesntRetainValue = function (streamId) {
	        var _this = this;
	        this.deferredResolvers.forEach(function (resolver) {
	            var buffer = _this.options.dataType.toBytes(resolver.value).asBuffer();
	            _this.streamServices.STREAM_SET_TOPIC_SERVICE.send(new update_stream_request_1.UpdateStreamRequest(streamId, buffer), function (err) {
	                if (err) {
	                    resolver.reject(err);
	                }
	                else {
	                    resolver.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    PendingValidateAndSetStream.prototype.onValidateFailed = function (err) {
	        this.stream.setDelegate(new invalid_set_stream_1.InvalidSetStream(err, this.nextValue));
	        this.deferredResolvers.forEach(function (resolver) {
	            resolver.reject(err);
	        });
	    };
	    return PendingValidateAndSetStream;
	}());
	exports.PendingValidateAndSetStream = PendingValidateAndSetStream;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var datatypes_1 = __webpack_require__(78);
	var update_constraint_1 = __webpack_require__(343);
	var require_non_null_1 = __webpack_require__(22);
	/**
	 * Implementation of {@link UpdateConstraintFactory}
	 */
	var UpdateConstraintFactoryImpl = /** @class */ (function () {
	    function UpdateConstraintFactoryImpl() {
	    }
	    /**
	     * @inheritdoc
	     */
	    UpdateConstraintFactoryImpl.prototype.locked = function (lock) {
	        return new update_constraint_1.Locked(lock);
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateConstraintFactoryImpl.prototype.value = function (value, dataType) {
	        require_non_null_1.requireNonNull(value, 'value');
	        var valueType = ((dataType !== undefined)
	            ? dataType
	            : datatypes_1.DataTypes.getByValue(value));
	        if (valueType === undefined) {
	            throw new Error('Datatype invalid or could not be inferred');
	        }
	        return new update_constraint_1.BinaryValue(valueType.toBytes(value));
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateConstraintFactoryImpl.prototype.noValue = function () {
	        return new update_constraint_1.NoValue();
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateConstraintFactoryImpl.prototype.noTopic = function () {
	        return new update_constraint_1.NoTopic();
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateConstraintFactoryImpl.prototype.jsonValue = function () {
	        return new update_constraint_1.PartialJSONImpl();
	    };
	    return UpdateConstraintFactoryImpl;
	}());
	exports.UpdateConstraintFactoryImpl = UpdateConstraintFactoryImpl;
	/**
	 * The UpdateConstraintFactory singleton instance
	 */
	var updateConstraintFactory = Object.freeze(new UpdateConstraintFactoryImpl());
	exports.updateConstraintFactory = updateConstraintFactory;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var new_add_topic_and_update_stream_1 = __webpack_require__(1442);
	var new_update_stream_1 = __webpack_require__(1443);
	var update_stream_1 = __webpack_require__(1447);
	var require_non_null_1 = __webpack_require__(22);
	var topic_type_1 = __webpack_require__(69);
	/**
	 * A factory for creating {@link UpdateStream}s
	 */
	var UpdateStreamFactory = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamFactory
	     *
	     * @param streamServices  the stream services
	     */
	    function UpdateStreamFactory(streamServices, context) {
	        this.context = context;
	        this.streamServices = streamServices;
	    }
	    /**
	     * Create a function that validates a value
	     *
	     * @param  dataType  the data type of the topic
	     * @return           a callback that checks a value
	     */
	    UpdateStreamFactory.prototype.getValueCheckOperation = function (dataType) {
	        switch (dataType.name()) {
	            case 'int64':
	            case 'double':
	            case 'string':
	                return function () { };
	            default:
	                return function (value) {
	                    require_non_null_1.requireNonNull(value, 'null can only be passed for int64, double or string topics');
	                };
	        }
	    };
	    /**
	     * Get the command service that can be sent to indicate a change in value
	     *
	     * @param deltaType  the delta type
	     * @return           a {@link ServiceSender} that sends a change in value
	     */
	    UpdateStreamFactory.prototype.getChangeService = function (deltaType) {
	        return (deltaType === undefined)
	            ? this.streamServices.STREAM_SET_TOPIC_SERVICE
	            : this.streamServices.STREAM_APPLY_DELTA_SERVICE;
	    };
	    /**
	     * Get a function that converts a change in value to a Buffer
	     *
	     * @param dataType   the data type
	     * @param deltaType  the binary delta type if it exists
	     * @return           a function for converting values to binary data
	     */
	    UpdateStreamFactory.prototype.getToBytesFunction = function (dataType, deltaType) {
	        if (deltaType === undefined) {
	            return function (oldValue, newValue) {
	                return dataType.toBytes(newValue).asBuffer();
	            };
	        }
	        else {
	            return function (oldValue, newValue) {
	                var delta = deltaType.diff(oldValue, newValue);
	                return delta.$buffer.slice(delta.$offset, delta.$offset + delta.$length);
	            };
	        }
	    };
	    /**
	     * Get the binary delta type for a given data type
	     *
	     * @param dataType  the data type
	     * @return          the corresponding binary delta type if it exists
	     */
	    UpdateStreamFactory.prototype.binaryDeltaType = function (dataType) {
	        try {
	            return dataType.binaryDeltaType();
	        }
	        catch (e) {
	            // catch the error and return undefined to signal that no delta type is available
	            return undefined;
	        }
	    };
	    /**
	     * Create an update stream
	     *
	     * This creates an {@link UpdateStreamImpl} whose delegate has been set to
	     * a {@link NewUpdateStream}
	     *
	     * @param path            the topic path to add and update
	     * @param dataType        the data type of the values to update
	     * @param constraint      the topic update constraint
	     * @return                a new update stream
	     */
	    UpdateStreamFactory.prototype.createUpdateStream = function (path, dataType, constraint) {
	        var _this = this;
	        var deltaType = this.binaryDeltaType(dataType);
	        var options = {
	            dataType: dataType,
	            retainsValue: true,
	            supportsConflation: true,
	            checkOperation: this.getValueCheckOperation(dataType),
	            toBuffer: this.getToBytesFunction(dataType, deltaType),
	            deltaService: this.getChangeService(deltaType)
	        };
	        var topicType = topic_type_1.TopicTypeEnum[dataType.name().toUpperCase()];
	        return new update_stream_1.UpdateStreamImpl(function (updateStreamImpl) {
	            return new new_update_stream_1.NewUpdateStream(_this.streamServices, options, updateStreamImpl, path, topicType, constraint);
	        });
	    };
	    /**
	     * Create an update stream that adds a topic
	     *
	     * This creates an {@link UpdateStreamImpl} whose delegate has been set to
	     * a {@link NewAddTopicAndUpdateStream}
	     *
	     * @param path            the topic path to add and update
	     * @param specification   the topic specification of the topic to add
	     * @param dataType        the data type of the values to update
	     * @param constraint      the topic update constraint
	     * @return                a new update stream
	     */
	    UpdateStreamFactory.prototype.createUpdateStreamThatAddsTopic = function (path, specification, dataType, constraint) {
	        var _this = this;
	        if (specification.type === topic_type_1.TopicTypeEnum.TIME_SERIES) {
	            var eventType = specification.properties.TIME_SERIES_EVENT_VALUE_TYPE;
	            // tslint:disable-next-line:strict-type-predicates
	            if (eventType === null || eventType === undefined) {
	                throw new Error('The specification for time-series topics requires an event type.');
	            }
	            else if (eventType.toLowerCase() !== dataType.name().toLowerCase()) {
	                throw new Error('The time-series event and value have different data types.');
	            }
	        }
	        else if (dataType !== this.context.DataTypes.getByValue(specification.type)) {
	            throw new Error('The specification and value have different data types');
	        }
	        var deltaType = this.binaryDeltaType(dataType);
	        var options = {
	            dataType: dataType,
	            retainsValue: true,
	            supportsConflation: true,
	            checkOperation: this.getValueCheckOperation(dataType),
	            toBuffer: this.getToBytesFunction(dataType, deltaType),
	            deltaService: this.getChangeService(deltaType)
	        };
	        return new update_stream_1.UpdateStreamImpl(function (updateStreamImpl) {
	            return new new_add_topic_and_update_stream_1.NewAddTopicAndUpdateStream(_this.streamServices, options, updateStreamImpl, path, specification, constraint);
	        });
	    };
	    return UpdateStreamFactory;
	}());
	exports.UpdateStreamFactory = UpdateStreamFactory;


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of the {@link InternalUpdateStream}
	 *
	 * This implementation holds a delegate that can be exchanged depending on the
	 * state of the stream
	 */
	var UpdateStreamImpl = /** @class */ (function () {
	    /**
	     * Create a new UpdateStreamImpl instance
	     *
	     * @param internalStreamFactory  the factory function that creates the
	     *                               initial delegate
	     */
	    function UpdateStreamImpl(internalStreamFactory) {
	        this.delegate = internalStreamFactory(this);
	    }
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.set = function (value) {
	        return this.delegate.set(value);
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.get = function () {
	        return this.delegate.get();
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.validate = function () {
	        return this.delegate.validate();
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.onSetComplete = function (streamId, retainsValue, supportsConflation) {
	        this.delegate.onSetComplete(streamId, retainsValue, supportsConflation);
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.onSetFailed = function (err) {
	        this.delegate.onSetFailed(err);
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.onValidateComplete = function (streamId, retainsValue, supportsConflation) {
	        this.delegate.onValidateComplete(streamId, retainsValue, supportsConflation);
	    };
	    /**
	     * @inheritdoc
	     */
	    UpdateStreamImpl.prototype.onValidateFailed = function (err) {
	        this.delegate.onValidateFailed(err);
	    };
	    /**
	     * Set the delegate stream
	     *
	     * This is usually called by the current delegate in response of a change of
	     * the internal state.
	     */
	    UpdateStreamImpl.prototype.setDelegate = function (newDelegate) {
	        this.delegate = newDelegate;
	    };
	    return UpdateStreamImpl;
	}());
	exports.UpdateStreamImpl = UpdateStreamImpl;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module TopicUpdate
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var update_stream_request_1 = __webpack_require__(235);
	var invalid_unset_stream_1 = __webpack_require__(543);
	var set_stream_1 = __webpack_require__(342);
	var logger = __webpack_require__(17);
	var topic_update_1 = __webpack_require__(90);
	var log = logger.create('diffusion.TopicUpdate');
	/**
	 * An update stream delegate that is used when a {@link validate} operation has
	 * completed successfully but no {@link set} operation has yet been requested.
	 */
	var ValidatedStream = /** @class */ (function () {
	    /**
	     * Create a new SetStream instance
	     *
	     * @param streamServices   the stream services
	     * @param options          the update stream options
	     * @param stream           the stream that using this stream as a delegate
	     * @param streamId         the stream ID
	     */
	    function ValidatedStream(streamServices, options, stream, streamId) {
	        this.streamServices = streamServices;
	        this.options = options;
	        this.stream = stream;
	        this.streamId = streamId;
	    }
	    ValidatedStream.prototype.set = function (value) {
	        var _this = this;
	        this.options.checkOperation(value);
	        return new Promise(function (resolve, reject) {
	            _this.stream.setDelegate(new set_stream_1.SetStream(_this.streamServices, _this.options, _this.stream, _this.streamId, value));
	            var buffer = _this.options.dataType.toBytes(value).asBuffer();
	            _this.streamServices.STREAM_SET_TOPIC_SERVICE.send(new update_stream_request_1.UpdateStreamRequest(_this.streamId, buffer), function (err) {
	                if (err) {
	                    log.debug('Stream set topic failed');
	                    _this.stream.onSetFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onSetComplete(_this.streamId, _this.options.retainsValue, _this.options.supportsConflation);
	                    resolve();
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ValidatedStream.prototype.get = function () {
	        throw new Error('The set method has not been called');
	    };
	    /**
	     * @inheritdoc
	     */
	    ValidatedStream.prototype.validate = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.streamServices.CHECK_UPDATE_STREAM.send(_this.streamId, function (err) {
	                if (err) {
	                    log.debug('Validate update stream failed');
	                    _this.stream.onValidateFailed(err);
	                    reject(err);
	                }
	                else {
	                    _this.stream.onValidateComplete(_this.streamId, _this.options.retainsValue, _this.options.supportsConflation);
	                    resolve(topic_update_1.TopicCreationResult.EXISTS);
	                }
	            });
	        });
	    };
	    /**
	     * @inheritdoc
	     */
	    ValidatedStream.prototype.onSetComplete = function () {
	        throw new Error('The set method has not been called');
	    };
	    /**
	     * @inheritdoc
	     */
	    ValidatedStream.prototype.onSetFailed = function () {
	        throw new Error('The set method has not been called');
	    };
	    /**
	     * @inheritdoc
	     */
	    ValidatedStream.prototype.onValidateComplete = function () {
	        // no-op
	    };
	    /**
	     * @inheritdoc
	     */
	    ValidatedStream.prototype.onValidateFailed = function (err) {
	        this.stream.setDelegate(new invalid_unset_stream_1.InvalidUnsetStream(err));
	    };
	    return ValidatedStream;
	}());
	exports.ValidatedStream = ValidatedStream;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	/**
	 * Read a Topic ID from the stream
	 *
	 * @param bis the input stream
	 * @return    the Topic ID that was read
	 */
	function read(bis) {
	    return Codec.readInt32(bis);
	}
	exports.read = read;
	/**
	 * Write a Topic ID to the stream
	 *
	 * @param bos   the output stream
	 * @param value the Topic ID to be written
	 */
	function write(bos, value) {
	    Codec.writeInt32(bos, value);
	}
	exports.write = write;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Codec = __webpack_require__(3);
	var serialiser_1 = __webpack_require__(4);
	var topic_specification_info_1 = __webpack_require__(1451);
	var TopicSpecificationSerialiser = __webpack_require__(147);
	/**
	 * Serialiser for {@link TopicSpecificationInfo}
	 */
	var TopicSpecificationInfoSerialiserClass = /** @class */ (function (_super) {
	    __extends(TopicSpecificationInfoSerialiserClass, _super);
	    function TopicSpecificationInfoSerialiserClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Read a {@link TopicSpecificationInfo} from the stream
	     *
	     * @param bis the input stream
	     * @return    the {@link TopicSpecificationInfo} that was read
	     */
	    TopicSpecificationInfoSerialiserClass.prototype.read = function (bis) {
	        var topicId = Codec.readInt32(bis);
	        var path = Codec.readString(bis);
	        var spec = TopicSpecificationSerialiser.read(bis);
	        return new topic_specification_info_1.TopicSpecificationInfo(topicId, path, spec);
	    };
	    /**
	     * Write a {@link TopicSpecificationInfo} to the stream
	     *
	     * @param bos   the output stream
	     * @param value the {@link TopicSpecificationInfo} to be written
	     */
	    TopicSpecificationInfoSerialiserClass.prototype.write = function (bos, value) {
	        Codec.writeInt32(bos, value.id);
	        Codec.writeString(bos, value.path);
	        TopicSpecificationSerialiser.write(bos, value.specification);
	    };
	    return TopicSpecificationInfoSerialiserClass;
	}(serialiser_1.AbstractSerialiser));
	exports.TopicSpecificationInfoSerialiserClass = TopicSpecificationInfoSerialiserClass;
	/**
	 * The {@link TopicSpecificationInfoSerialiser} singleton
	 */ // tslint:disable-next-line:variable-name
	exports.TopicSpecificationInfoSerialiser = new TopicSpecificationInfoSerialiserClass();


/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Topics
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Data type for a NOTIFY_SUBSCRIPTION request.
	 */
	var TopicSpecificationInfo = /** @class */ (function () {
	    /**
	     * Create a new TopicSpecificationInfo instance
	     *
	     * @param id            the topic ID
	     * @param path          the topic path
	     * @param specification the topic specification
	     */
	    function TopicSpecificationInfo(id, path, specification) {
	        this.id = id;
	        this.path = path;
	        this.specification = specification;
	    }
	    return TopicSpecificationInfo;
	}());
	exports.TopicSpecificationInfo = TopicSpecificationInfo;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_topic_selector_1 = __webpack_require__(180);
	var topic_path_utils_1 = __webpack_require__(128);
	var regex_1 = __webpack_require__(548);
	/**
	 * Implementation of {@link AbstractTopicSelector} for full path selectors
	 */
	var FullPathSelector = /** @class */ (function (_super) {
	    __extends(FullPathSelector, _super);
	    /**
	     * Create a new FullPathSelector instance
	     *
	     * @param  components  the path components as created by the parser
	     */
	    function FullPathSelector(components) {
	        var _this = _super.call(this, components.type, components.prefix, components.expression) || this;
	        /**
	         * A regular expression matcher that checks if a canonical path selects this
	         * path
	         */
	        _this.pattern = undefined;
	        _this.qualifier = components.qualifier;
	        if (!components.base) {
	            throw new Error('Invalid full-path selector');
	        }
	        _this.base = components.base;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    FullPathSelector.prototype.doSelects = function (topicPath) {
	        if (!this.pattern) {
	            switch (this.qualifier) {
	                case topic_path_utils_1.DescendantQualifier.DESCENDANTS_OF_MATCH:
	                    this.pattern = regex_1.regex(this.base + "/.+");
	                    break;
	                case topic_path_utils_1.DescendantQualifier.MATCH_AND_DESCENDANTS:
	                    this.pattern = regex_1.regex(this.base + "(?:$|/.+)");
	                    break;
	                default:
	                case topic_path_utils_1.DescendantQualifier.MATCH:
	                    this.pattern = regex_1.regex(this.base);
	                    break;
	            }
	        }
	        return this.pattern(topicPath) === true;
	    };
	    return FullPathSelector;
	}(abstract_topic_selector_1.AbstractTopicSelector));
	exports.FullPathSelector = FullPathSelector;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_topic_selector_1 = __webpack_require__(180);
	var topic_path_utils_1 = __webpack_require__(128);
	var topic_selector_1 = __webpack_require__(181);
	/**
	 * Implementation of {@link AbstractTopicSelector} for a topic path
	 */
	var PathSelector = /** @class */ (function (_super) {
	    __extends(PathSelector, _super);
	    /**
	     * Create a new PathSelector instance
	     *
	     * @param  components  the path components as created by the parser
	     */
	    function PathSelector(components) {
	        var _this = this;
	        var remainder = components.remainder;
	        if (components.type === topic_selector_1.Type.PATH) {
	            if (components.prefix === '') {
	                throw new Error("Topic path must have at least one part: " + remainder);
	            }
	            if (components.prefix.indexOf('//') > -1) {
	                throw new Error("Topic path contains empty part: " + remainder);
	            }
	        }
	        _this = _super.call(this, components.type, components.prefix, components.expression) || this;
	        _this.qualifier = components.qualifier;
	        _this.path = components.prefix;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    PathSelector.prototype.doSelects = function (topicPath) {
	        var match = this.path === topicPath;
	        var descendants = topicPath.indexOf(this.path + '/') === 0;
	        switch (this.qualifier) {
	            case topic_path_utils_1.DescendantQualifier.MATCH:
	                return match;
	            case topic_path_utils_1.DescendantQualifier.DESCENDANTS_OF_MATCH:
	                return descendants;
	            case topic_path_utils_1.DescendantQualifier.MATCH_AND_DESCENDANTS:
	                return match || descendants;
	            default:
	                return false;
	        }
	    };
	    return PathSelector;
	}(abstract_topic_selector_1.AbstractTopicSelector));
	exports.PathSelector = PathSelector;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Topics
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var abstract_topic_selector_1 = __webpack_require__(180);
	var topic_path_utils_1 = __webpack_require__(128);
	var regex_1 = __webpack_require__(548);
	/**
	 * Implementation of {@link AbstractTopicSelector} for split path selectors
	 */
	var SplitPathSelector = /** @class */ (function (_super) {
	    __extends(SplitPathSelector, _super);
	    /**
	     * Create a new SplitPathSelector instance
	     *
	     * @param  components  the path components as created by the parser
	     */
	    function SplitPathSelector(components) {
	        var _this = _super.call(this, components.type, components.prefix, components.expression) || this;
	        /**
	         * An array of regular expression matchers, one for each part of the path
	         */
	        _this.patterns = undefined;
	        _this.qualifier = components.qualifier;
	        _this.parts = topic_path_utils_1.split(components.base);
	        _this.parts.forEach(function (part) {
	            if (!part) {
	                throw new Error('Invalid split-path selector');
	            }
	        });
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    SplitPathSelector.prototype.doSelects = function (topicPath) {
	        if (!this.patterns) {
	            this.patterns = this.parts.map(function (p) { return regex_1.regex(p); });
	        }
	        var length = this.patterns.length;
	        var parts = topicPath.split(topic_path_utils_1.PATH_SEPARATOR);
	        switch (this.qualifier) {
	            case topic_path_utils_1.DescendantQualifier.MATCH:
	                if (parts.length !== length) {
	                    return false;
	                }
	                break;
	            case topic_path_utils_1.DescendantQualifier.DESCENDANTS_OF_MATCH:
	                if (parts.length <= length) {
	                    return false;
	                }
	                break;
	            case topic_path_utils_1.DescendantQualifier.MATCH_AND_DESCENDANTS:
	                if (parts.length < length) {
	                    return false;
	                }
	                break;
	        }
	        for (var i = 0; i < length; ++i) {
	            if (!this.patterns[i](parts[i])) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return SplitPathSelector;
	}(abstract_topic_selector_1.AbstractTopicSelector));
	exports.SplitPathSelector = SplitPathSelector;


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Transport
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var connection_response_deserialiser_1 = __webpack_require__(507);
	var logger_1 = __webpack_require__(17);
	var log = logger_1.create('Parsing');
	/**
	 * Connection response parser. Wraps the connection response deserialiser and takes callbacks for successful and failed
	 * parsing of the buffer.
	 *
	 * @param  onHandshakeSuccess  on success callback
	 * @param  onHandshakeError    on failure callback
	 * @param  message             the buffer to parse
	 * @return                     the parsed response or null if parsing failed
	 */
	function connectionResponse(onHandshakeSuccess, onHandshakeError, message) {
	    log.trace('Received connection handshake response');
	    try {
	        return onHandshakeSuccess(connection_response_deserialiser_1.deserialise(message));
	    }
	    catch (e) {
	        onHandshakeError(e);
	        return null;
	    }
	}
	exports.connectionResponse = connectionResponse;


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Transport
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable-next-line:variable-name no-var-requires
	var NodeWebSocket = __webpack_require__(1877);
	var logger_1 = __webpack_require__(17);
	var log = logger_1.create('Transports');
	/**
	 * Optionally environment specific websockets.
	 */
	function websocketSubTransportFactoryProvider() {
	    // tslint:disable-next-line:strict-type-predicates
	    if (typeof WebSocket === 'function') {
	        log.debug('Using native websocket');
	        return {
	            factory: WebSocket,
	            enabled: true,
	            allowsOptions: false
	        };
	    }
	    else if (typeof NodeWebSocket === 'function') {
	        // browser version does not include 'ws' lib; use native impl
	        log.debug('Using Node WS library');
	        return {
	            factory: NodeWebSocket,
	            enabled: true,
	            allowsOptions: true
	        };
	    }
	    else {
	        log.debug('Websocket transport not available');
	        return {
	            enabled: false,
	            allowsOptions: false
	        };
	    }
	}
	/**
	 * Optionally provide environment specific XHR.
	 */
	function xhrSubTransportFactoryProvider() {
	    // tslint:disable-next-line:strict-type-predicates
	    if (typeof XMLHttpRequest === 'function') {
	        log.debug('Using native XHR');
	        return {
	            factory: XMLHttpRequest,
	            enabled: true,
	            allowsOptions: false
	        };
	    }
	    else {
	        log.debug('XHR transport not available');
	        return {
	            enabled: false,
	            allowsOptions: false
	        };
	    }
	}
	/**
	 * Support the detection and creation of WebSocket and XmlHttpRequest objects
	 * in an environment independent way. Each subtransport object provides an
	 * enabled field that indicates if the subtransport works and if it works the
	 * environment specific constructor for the object.
	 *
	 * The subtransports will be looked up by transport name.
	 */ // tslint:disable-next-line:variable-name
	exports.Subtransports = Object.freeze({
	    /**
	     * WebSocket subtransport. Supports detection of availability and construction when available.
	     */
	    WS: websocketSubTransportFactoryProvider(),
	    /**
	     * HTTP polling subtransport. Supports detection of availability and construction when available.
	     */
	    XHR: xhrSubTransportFactoryProvider(),
	    /**
	     * WebSocket subtransport. Supports detection of availability and construction when available.
	     */
	    WEBSOCKET: websocketSubTransportFactoryProvider(),
	    /**
	     * HTTP polling subtransport. Supports detection of availability and construction when available.
	     */
	    HTTP_POLLING: xhrSubTransportFactoryProvider()
	});


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Transport
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var response_code_1 = __webpack_require__(177);
	var parsing = __webpack_require__(1455);
	var subtransports_1 = __webpack_require__(1456);
	var ws_1 = __webpack_require__(1458);
	var xhr_1 = __webpack_require__(1459);
	var logger_1 = __webpack_require__(17);
	var log = logger_1.create('Cascading');
	/**
	 * The known transports. Will be looked up by name.
	 */
	var knownTransports = Object.freeze({
	    WS: ws_1.WSTransport,
	    XHR: xhr_1.XHRTransport,
	    WEBSOCKET: ws_1.WSTransport,
	    HTTP_POLLING: xhr_1.XHRTransport
	});
	/**
	 * Filter a list of transport names, removing any unknown or disabled transports.
	 *
	 * @param requestedTransports  array of transport names
	 * @param subtransports        the available subtransports
	 * @return                     the filtered array of transport names
	 */
	function filterTransports(requestedTransports, subtransports) {
	    return requestedTransports.filter(function (name) {
	        return name && knownTransports.hasOwnProperty(name) && subtransports[name].enabled;
	    });
	}
	/**
	 * Check if a response code indicates that the client should attempt to cascade
	 *
	 * @param response  the response code
	 * @returns         `true` if the client should attempt to cascade on receiving a response
	 */
	function isCascadableResponse(response) {
	    return response === response_code_1.responseCodes.ERROR;
	}
	/**
	 * Create the selected transport if enabled.
	 *
	 * @param subtransports  the subtransports that can be made
	 * @param options        the options used to connect
	 * @param name           the name of the subtransport to use
	 * @returns              an available transport if enabled
	 */
	function createTransport(subtransports, options, name) {
	    var transport = knownTransports[name];
	    var subtransport = subtransports[name];
	    if (transport && subtransport && subtransport.enabled) {
	        return new transport(options, subtransport.factory, subtransport.allowsOptions);
	    }
	    else {
	        // any unknown transports should have been filtered out by the
	        // filterTransports function
	        throw new Error('Unknown transport name: ' + name);
	    }
	}
	/**
	 * Encapsulate the set of available transport mechanisms and expose them in an
	 * implementation independent manner.
	 */
	var CascadeDriver = /** @class */ (function (_super) {
	    __extends(CascadeDriver, _super);
	    /**
	     * Create a new CascadeDriver instance
	     *
	     * @param subtransports        the available subtransports
	     * @param opts                 the connection options
	     * @param transports           a list of available transport names
	     * @param cascadeNotifications an emitter for emitting events on the {@link Transports} stream
	     */
	    function CascadeDriver(subtransports, opts, transports, cascadeNotifications) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.transports = transports;
	        _this.cascadeNotifications = cascadeNotifications;
	        _this.name = null;
	        _this.req = null;
	        _this.responseReceived = false;
	        _this.transportFactory = createTransport.bind(null, subtransports, opts);
	        _this.transport = _this.selectTransport();
	        // bind this to the event handlers so that we can pass them to the stream's
	        // on and off functions
	        _this.onData = _this.onData.bind(_this);
	        _this.onClose = _this.onClose.bind(_this);
	        _this.onError = _this.onError.bind(_this);
	        _this.onConnectionResponse = _this.onConnectionResponse.bind(_this);
	        _this.onParsingError = _this.onParsingError.bind(_this);
	        return _this;
	    }
	    /**
	     * Called when the transport emits a `data` event.
	     *
	     * Forwards the data and emits a `data` on this stream
	     *
	     * @param data  the message data
	     */
	    CascadeDriver.prototype.onData = function (data) {
	        this.emitter.immediate('data', data);
	    };
	    /**
	     * Called when the transport emits a `close` event.
	     *
	     * Only emits a `close` event on this stream if it can't cascade further
	     *
	     * @param reason  the reason for closing
	     */
	    CascadeDriver.prototype.onClose = function (reason) {
	        if (!this.responseReceived && this.cascade(true)) {
	            // attempting to cascade
	            return;
	        }
	        // transport closed without receiving any response
	        // close event suppressed to prevent reentering this handler
	        this.emitter.emit('close', reason);
	    };
	    /**
	     * Called when the transport emits an `error` event.
	     *
	     * Forwards the data and emits a `error` on this stream
	     *
	     * @param error  the error that occurred
	     */
	    CascadeDriver.prototype.onError = function (error) {
	        this.emitter.emit('error', error);
	    };
	    /**
	     * Called when the connection response is received.
	     *
	     * @param response  the connection response from the server
	     */
	    CascadeDriver.prototype.onConnectionResponse = function (response) {
	        this.responseReceived = true;
	        if (isCascadableResponse(response.response)) {
	            if (this.cascade()) {
	                // attempting to cascade
	                return null;
	            }
	            // transport closed and close event emitted
	        }
	        return this.onHandshakeSuccess(response);
	    };
	    /**
	     * Called when the connection response cannot be parsed.
	     *
	     * @param error  the error that occurred
	     */
	    CascadeDriver.prototype.onParsingError = function (error) {
	        this.responseReceived = true;
	        if (!this.cascade()) {
	            // transports exhausted
	            return this.onHandshakeError(error);
	        }
	    };
	    /**
	     * Close the current transport quietly, without generating any events.
	     */
	    CascadeDriver.prototype.closeQuietly = function () {
	        if (this.transport) {
	            this.transport.off('data', this.onData);
	            this.transport.off('close', this.onClose);
	            this.transport.off('error', this.onError);
	            this.transport.close();
	            this.transport = null;
	        }
	    };
	    /**
	     * Select and create the next enabled transport.
	     *
	     * If there are no more transports then a `close` event may be emitted on
	     * this stream and a `transports-exhausted` event is emitted on the {@link
	     * Transports} stream.
	     *
	     * @param suppressClose  a flag indicating whether a `close` event should be
	     *                       suppressed
	     * @return               the selected transport
	     */
	    CascadeDriver.prototype.selectTransport = function (suppressClose) {
	        if (suppressClose === void 0) { suppressClose = false; }
	        if (this.transports.length === 0) {
	            this.name = null;
	            this.transport = null;
	            log.debug('Transports exhausted');
	            this.cascadeNotifications.emit('transports-exhausted');
	            if (!suppressClose) {
	                this.emitter.emit('close');
	            }
	            return null;
	        }
	        this.name = this.transports.shift();
	        this.transport = this.transportFactory(this.name);
	        log.debug('Selecting transport', this.name);
	        this.cascadeNotifications.emit('transport-selected', this.name);
	        return this.transport;
	    };
	    /**
	     * Connect to the current transport
	     *
	     * A `cascading-connect` event is emitted on the {@link Transports} stream.
	     *
	     * @returns true if attempting to connect
	     */
	    CascadeDriver.prototype.internalConnect = function () {
	        if (this.transport === null) {
	            throw new Error('Unable to connect when no transport is set');
	        }
	        this.responseReceived = false;
	        log.debug('Attempting to connect');
	        this.cascadeNotifications.emit('cascading-connect');
	        this.transport.on('data', this.onData);
	        this.transport.on('close', this.onClose);
	        this.transport.on('error', this.onError);
	        try {
	            this.transport.connect(this.req, parsing.connectionResponse.bind(null, this.onConnectionResponse, this.onParsingError));
	        }
	        catch (e) {
	            if (!this.cascade()) {
	                // transports exhausted
	                throw e;
	            }
	        }
	        return true;
	    };
	    /**
	     * Cascade to the next available transport
	     *
	     * A `close` event may be emitted on this stream and a `cascade` event is
	     * emitted on the {@link Transports} stream.
	     *
	     * @param suppressClose  a flag indicating whether a `close` event should be
	     *                       suppressed
	     * @returns true if attempting to connect, false if transports exhausted
	     */
	    CascadeDriver.prototype.cascade = function (suppressClose) {
	        this.closeQuietly();
	        if (!this.selectTransport(suppressClose)) {
	            return false;
	        }
	        this.cascadeNotifications.emit('cascade');
	        return this.internalConnect();
	    };
	    /**
	     * Connect using the available transports
	     *
	     * @param request         the connection request.
	     * @param handshake       the handshake handler
	     * @param handshakeError  the handshake error handler
	     */
	    CascadeDriver.prototype.connect = function (request, handshake, handshakeError) {
	        this.req = request;
	        this.onHandshakeSuccess = handshake;
	        this.onHandshakeError = handshakeError;
	        this.internalConnect();
	    };
	    /**
	     * Send a binary message to the server.
	     *
	     * @param message  the message to send
	     */
	    CascadeDriver.prototype.dispatch = function (message) {
	        if (this.transport === null) {
	            throw new Error('Unable to send message when no transport is set');
	        }
	        this.transport.dispatch(message);
	    };
	    /**
	     * Close the transport
	     *
	     * @return this stream
	     */
	    CascadeDriver.prototype.close = function () {
	        if (this.transport !== null) {
	            this.responseReceived = true; // to prevent cascading on connection timeout
	            // a close event will be emitted by the transport after the close is complete
	            this.transport.close();
	            this.transport = null;
	        }
	        return this;
	    };
	    return CascadeDriver;
	}(stream_1.StreamImpl));
	exports.CascadeDriver = CascadeDriver;
	/**
	 * Encapsulate the set of available transport mechanisms and expose them in an
	 * implementation independent manner.
	 */
	var Transports = /** @class */ (function (_super) {
	    __extends(Transports, _super);
	    /**
	     * Create a new Transports instance
	     *
	     * @param subtransports the available subtransports
	     */
	    function Transports(subtransports) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.subtransports = subtransports;
	        return _this;
	    }
	    /**
	     * Create a new Transports object.
	     *
	     * @param subtransports  allows specifying the available subtransports for
	     *                       testing. If not specified, the {@link
	     *                       Subtransports} *  will be used.
	     */
	    Transports.create = function (subtransports) {
	        if (subtransports) {
	            return new Transports(subtransports);
	        }
	        else {
	            return new Transports(subtransports_1.Subtransports);
	        }
	    };
	    /**
	     * Get a new {@link CascadeDriver} with a given set of options
	     *
	     * @param options  the options from which to create a driver.
	     * @return         the cascade driver if the `options` contain valid
	     *                 transports, otherwise `null`
	     */
	    Transports.prototype.get = function (options) {
	        var validTransports = filterTransports(options.transports, this.subtransports);
	        if (validTransports.length === 0) {
	            log.warn('No valid transports found');
	            return null;
	        }
	        return new CascadeDriver(this.subtransports, options, validTransports, this.emitter);
	    };
	    return Transports;
	}(stream_1.StreamImpl));
	exports.Transports = Transports;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module Transport
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var logger_1 = __webpack_require__(17);
	var credential_tunnel_1 = __webpack_require__(550);
	var log = logger_1.create('Websocket transport');
	/**
	 * Construct a valid websocket URI from the given options.
	 *
	 * @param req   the connection request.
	 * @param opts  the connection options.
	 * @returns     the connection URI
	 */
	function constructURI(req, opts) {
	    var scheme = opts.secure ? 'wss' : 'ws';
	    var uri = scheme + "://" + opts.host + ":" + opts.port + opts.path;
	    uri += '?ty=' + req.type;
	    uri += '&v=' + req.version;
	    uri += '&ca=' + req.capabilities;
	    uri += '&r=' + opts.reconnect.timeout;
	    if (req.token) {
	        uri += '&c=' + encodeURIComponent(req.token);
	        uri += '&cs=' + req.availableClientSequence;
	        uri += '&ss=' + req.lastServerSequence;
	    }
	    if (opts.properties) {
	        uri += '&sp=' + encodeURIComponent(JSON.stringify(opts.properties));
	    }
	    if (opts.principal) {
	        uri += '&username=' + encodeURIComponent(opts.principal);
	        uri += '&password=' + encodeURIComponent(credential_tunnel_1.encodeAsString(opts.credentials));
	    }
	    return uri;
	}
	/**
	 * The implementation of the {@link Transport} interface using Web Sockets
	 */
	var WSTransport = /** @class */ (function (_super) {
	    __extends(WSTransport, _super);
	    /**
	     * Construct a new WSTransport instance
	     *
	     * @param opts  the connection options
	     * @param ws    the transport constructor function
	     */
	    function WSTransport(opts, ws, allowsOptions) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.opts = opts;
	        _this.ws = ws;
	        _this.allowsOptions = allowsOptions;
	        return _this;
	    }
	    /**
	     * Handler function for the WebSocket's `onmessage` event.
	     *
	     * @param message  the message that was received
	     */
	    WSTransport.prototype.handler = function (message) {
	        if (message.data.length > this.opts.maxMessageSize) {
	            this.emitter.error(new Error("Received message of size: " + message.data.length + ", "
	                + ("exceeding max message size: " + this.opts.maxMessageSize)));
	        }
	        else {
	            this.emitter.immediate('data', Buffer.from(message.data));
	        }
	    };
	    /**
	     * Establish a websocket connection, with provided connection options and
	     * callback functions.
	     *
	     * @param req        the connection request
	     * @param handshake  a handshake deserialiser
	     */
	    WSTransport.prototype.connect = function (req, handshake) {
	        var _this = this;
	        if (this.opts.httpProxyAgent !== undefined && !this.allowsOptions) {
	            throw new Error('httpProxyAgent option is not allowed');
	        }
	        try {
	            var uri = constructURI(req, this.opts);
	            this.socket = (this.opts.httpProxyAgent === undefined)
	                ? new this.ws(uri)
	                : new this.ws(uri, { agent: this.opts.httpProxyAgent });
	            log.debug('Created websocket', uri);
	        }
	        catch (error) {
	            throw new Error("Unable to construct WebSocket " + error);
	        }
	        this.socket.binaryType = 'arraybuffer';
	        this.socket.onmessage = function (msg) {
	            _this.socket.onmessage = _this.handler.bind(_this);
	            _this.socket.onerror = function (err) {
	                _this.emitter.error(err);
	            };
	            handshake(Buffer.from(msg.data));
	        };
	        this.socket.onclose = function (reason) {
	            _this.emitter.close(reason);
	        };
	        this.socket.onerror = function (err) {
	            _this.emitter.close(err);
	        };
	    };
	    /**
	     * Send a binary message to the server.
	     *
	     * @param message  the message to send
	     * @return         `true` if the message was sent successfully
	     */
	    WSTransport.prototype.dispatch = function (message) {
	        log.debug('Sending websocket message', message);
	        try {
	            this.socket.send(message);
	            return true;
	        }
	        catch (err) {
	            log.error('Websocket send error', err);
	            return false;
	        }
	    };
	    /**
	     * Directly close the websocket connection.
	     */
	    WSTransport.prototype.close = function () {
	        log.debug('Closing websocket');
	        if (this.socket !== undefined) {
	            this.socket.close(1000);
	        }
	        return this;
	    };
	    return WSTransport;
	}(stream_1.StreamImpl));
	exports.WSTransport = WSTransport;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @module Transport
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var buffer_input_stream_1 = __webpack_require__(125);
	var buffer_output_stream_1 = __webpack_require__(80);
	var response_code_1 = __webpack_require__(177);
	var logger_1 = __webpack_require__(17);
	var queue_1 = __webpack_require__(1463);
	var credential_tunnel_1 = __webpack_require__(550);
	var log = logger_1.create('XHR transport');
	/**
	 * Construct a valid  URI from the given options.
	 *
	 * @param req   the connection request.
	 * @param opts  the connection options.
	 * @returns     an object containing the connection URI and the headers
	 */
	function constructURI(req, opts) {
	    var scheme = opts.secure ? 'https' : 'http';
	    var uri = scheme + "://" + opts.host + ":" + opts.port + opts.path;
	    var headers = {
	        m: '0',
	        ty: 'B',
	        ca: req.capabilities,
	        r: opts.reconnect.timeout,
	        v: req.version
	    };
	    // tslint:disable-next-line:strict-type-predicates
	    if (req.token !== undefined) {
	        headers.c = req.token;
	        headers.cs = req.availableClientSequence;
	        headers.ss = req.lastServerSequence;
	    }
	    if (opts.properties) {
	        headers.sp = encodeURIComponent(JSON.stringify(opts.properties));
	    }
	    if (opts.principal) {
	        headers.username = encodeURIComponent(opts.principal);
	        headers.password = credential_tunnel_1.encodeAsString(opts.credentials);
	    }
	    return { uri: uri, headers: headers };
	}
	/**
	 * The implementation of the {@link Transport} interface for XHR polling
	 */
	var XHRTransport = /** @class */ (function (_super) {
	    __extends(XHRTransport, _super);
	    /**
	     * Construct a new XHRTransport instance
	     *
	     * @param opts  the connection options
	     * @param xhr   the transport constructor function
	     */
	    function XHRTransport(opts, xhr) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.opts = opts;
	        _this.protocolVersion = null;
	        _this.pollSequence = 0;
	        _this.pingSequence = 0;
	        _this.pollRequest = null;
	        _this.aborted = false;
	        _this.isSending = false;
	        // message message-queue
	        _this.queue = new queue_1.Queue();
	        _this.xhr = xhr;
	        return _this;
	    }
	    /**
	     * Establish a polling connection with the server.
	     *
	     * @param req        the connection request
	     * @param handshake  a handshake deserialiser
	     */
	    XHRTransport.prototype.connect = function (req, handshake) {
	        var _this = this;
	        try {
	            var url = constructURI(req, this.opts);
	            this.protocolVersion = url.headers.v;
	            this.URI = url.uri;
	            var request_1 = this.createRequest(url.headers, url.uri);
	            log.debug('Created XHR', url.uri);
	            request_1.onreadystatechange = function () {
	                if (request_1.readyState === 4) {
	                    if (request_1.status === 200) {
	                        var handShakeData = request_1.responseText;
	                        // the initial connection is in plain-text no need for base64 encoding/decoding.
	                        var serverResponse = handshake(Buffer.from(handShakeData, 'binary'));
	                        if (!serverResponse) {
	                            // if the handshake could not be parsed or there was some sort of error return
	                            // the transport will be closed by the error handler
	                            return;
	                        }
	                        _this.token = serverResponse.token;
	                        var responseCode = serverResponse.response;
	                        var isSuccesss = response_code_1.isSuccess(responseCode);
	                        if (isSuccesss) {
	                            _this.poll();
	                        }
	                        else {
	                            log.debug(responseCode.id + ' - ' + responseCode.message);
	                            _this.emitter.close();
	                        }
	                    }
	                    else {
	                        _this.emitter.close();
	                    }
	                }
	            };
	            request_1.send(null);
	        }
	        catch (error) {
	            throw new Error("Unable to create polling transport " + error);
	        }
	    };
	    /**
	     * Aborting any opening poll request.
	     *
	     * @return this instance
	     */
	    XHRTransport.prototype.close = function () {
	        log.trace('Closing XHR transport');
	        if (this.pollRequest) {
	            this.aborted = true;
	            this.pollRequest.abort();
	        }
	        // clear any pending messages
	        this.queue = new queue_1.Queue();
	        this.emitter.close();
	        return this;
	    };
	    /**
	     * This is the generic method to send data to the server
	     *
	     * @param headers the headers to send to the server
	     * @param uri     the URI to connect to
	     */
	    XHRTransport.prototype.createRequest = function (headers, uri) {
	        var e_1, _a;
	        var request = new this.xhr();
	        request.open('POST', uri, true);
	        request.overrideMimeType('text\/plain; charset=x-user-defined');
	        try {
	            for (var _b = __values(Object.getOwnPropertyNames(headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var header = _c.value;
	                try {
	                    request.setRequestHeader(header, headers[header]);
	                }
	                catch (e) {
	                    log.warn("Can't set header " + header + ":" + headers.join(':'));
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return request;
	    };
	    /**
	     * Send a poll request to the server.
	     */
	    XHRTransport.prototype.poll = function () {
	        var _this = this;
	        var request = this.createRequest({
	            m: '1',
	            c: this.token,
	            s: this.pollSequence++,
	            v: this.protocolVersion
	        }, this.URI);
	        request.onreadystatechange = function () {
	            if (request.readyState === 4) {
	                // from protocol 9+, the client should send a reconnect request when instructed by the server
	                if (request.getResponseHeader('diffusion-connection') === 'reconnect') {
	                    _this.emitter.close();
	                }
	                else if (request.status === 200) {
	                    if (!_this.aborted) {
	                        _this.poll();
	                    }
	                    var data = request.responseText;
	                    var bis = new buffer_input_stream_1.BufferInputStream(Buffer.from(data, 'base64'));
	                    while (bis.pos !== bis.count) {
	                        var length_1 = bis.readInt32();
	                        if (length_1 > _this.opts.maxMessageSize) {
	                            _this.emitter.error(new Error("Received message of size: " + length_1 + ", "
	                                + ("exceeding max message size: " + _this.opts.maxMessageSize)));
	                            return;
	                        }
	                        var typeAndEncoding = bis.read();
	                        var body = bis.readMany(length_1);
	                        var payload = Buffer.alloc(body.length + 1); // +1 for message type and encoding byte.
	                        payload.writeUInt8(typeAndEncoding, 0);
	                        body.copy(payload, 1);
	                        _this.emitter.emit('data', payload);
	                    }
	                }
	                else {
	                    _this.emitter.close();
	                }
	            }
	        };
	        this.pollRequest = request;
	        request.send(null);
	    };
	    /**
	     * Queue message to be sent to the message message-queue.
	     *
	     * Delegate the actual request sending to #flush().
	     *
	     * @param  message to be queued
	     */
	    XHRTransport.prototype.dispatch = function (message) {
	        if (this.aborted) {
	            return false;
	        }
	        this.queue.add(message);
	        if (this.isSending) {
	            return true;
	        }
	        this.flush();
	    };
	    /**
	     * Flush all pending messages from the message-queue and send upstream.
	     */
	    XHRTransport.prototype.flush = function () {
	        var _this = this;
	        if (this.queue.isEmpty()) {
	            return;
	        }
	        var buffer = drainToBuffer(this.queue.drain());
	        var request = this.createRequest({
	            m: '2',
	            c: this.token,
	            s: this.pingSequence++,
	            v: this.protocolVersion
	        }, this.URI);
	        request.onreadystatechange = function () {
	            if (request.readyState === 4) {
	                // from protocol 9+, the client should send a reconnect request when instructed by the server
	                if (request.getResponseHeader('diffusion-connection') === 'reconnect') {
	                    _this.emitter.close();
	                }
	                else if (request.status === 200) {
	                    _this.isSending = false;
	                    _this.flush();
	                }
	                else {
	                    _this.emitter.close();
	                }
	            }
	        };
	        this.isSending = true;
	        request.send(buffer.toString('base64'));
	    };
	    return XHRTransport;
	}(stream_1.StreamImpl));
	exports.XHRTransport = XHRTransport;
	/**
	 * Create a single buffer containing multiple messages
	 *
	 * @param  messages  the messages to conflate
	 * @return           a single buffer containing all messages
	 */
	function drainToBuffer(messages) {
	    var e_2, _a;
	    var messagesBOS = new buffer_output_stream_1.BufferOutputStream();
	    try {
	        for (var messages_1 = __values(messages), messages_1_1 = messages_1.next(); !messages_1_1.done; messages_1_1 = messages_1.next()) {
	            var msg = messages_1_1.value;
	            messagesBOS.writeInt32(msg.length - 1); // skip the message type byte.
	            messagesBOS.writeMany(msg, 0, msg.length);
	        }
	    }
	    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	    finally {
	        try {
	            if (messages_1_1 && !messages_1_1.done && (_a = messages_1.return)) _a.call(messages_1);
	        }
	        finally { if (e_2) throw e_2.error; }
	    }
	    return messagesBOS.getBuffer();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Util.Function
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var function_1 = __webpack_require__(89);
	/**
	 * Wrap a function with an automatic memoization layer.
	 *
	 * @param function the function to cache results for.
	 * @param cache    the internal cache to use.
	 * @param matcher  the matcher function to return a cache key from an array of arguments
	 *
	 * @returns        the memoized function
	 */
	function memoize(f, cache, matcher) {
	    if (cache === void 0) { cache = {}; }
	    if (matcher === void 0) { matcher = function_1.identity; }
	    var c = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var a = matcher(args);
	        var r = cache[a];
	        if (r) {
	            return r;
	        }
	        else {
	            r = f.apply(f, args);
	        }
	        cache[a] = r;
	        return r;
	    };
	    // this is only used for unit testing to gain access to the uncached function
	    c._uncached = f;
	    return c;
	}
	exports.memoize = memoize;


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.MessageEncoding
	 *
	 * @brief Utility functions for encoding messages
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Bitmask for the message type
	 */
	var MESSAGE_TYPE_MASK = 0xA7D8C0;
	/**
	 * A flag indicating a zlib compressed message
	 */
	var ZLIB_TYPE_FLAGS = 0x80;
	/**
	 * The _message type flags_ allow a subset of MessageEncodings to be encoded
	 * in the upper two bits of the message type byte. Only NO_ENCODING and
	 * ZLIB are supported.
	 */
	var MessageEncoding = /** @class */ (function () {
	    /**
	     * Create a new message encoding object
	     *
	     * @param encodingByte     the encoding byte
	     * @param messageTypeFlags bit flags
	     */
	    function MessageEncoding(encodingByte, messageTypeFlags) {
	        this.encodingByte = encodingByte;
	        this.messageTypeFlags = messageTypeFlags;
	    }
	    /**
	     * Decode the message type from a byte combining the message type and flags.
	     *
	     * @param typeAndEncoding the encoding byte and message type flags
	     * @return                the message type flags
	     */
	    MessageEncoding.extractMessageType = function (typeAndEncoding) {
	        /* tslint:disable-next-line:no-bitwise */
	        return typeAndEncoding & ~MESSAGE_TYPE_MASK;
	    };
	    /**
	     * Decode the message encoding from a byte combining the message type and flags.
	     *
	     * @param typeAndEncoding the encoding byte and message type flags
	     * @return                the message encoding
	     */
	    MessageEncoding.extractMessageEncoding = function (typeAndEncoding) {
	        /* tslint:disable-next-line:no-bitwise */
	        var encoding = typeAndEncoding & MESSAGE_TYPE_MASK;
	        /* tslint:disable-next-line:no-use-before-declare */
	        return (encoding === ZLIB_TYPE_FLAGS) ? exports.EncodingType.ZLIB : exports.EncodingType.NO_ENCODING;
	    };
	    return MessageEncoding;
	}());
	exports.MessageEncoding = MessageEncoding;
	/* tslint:disable-next-line:variable-name */
	exports.EncodingType = {
	    NO_ENCODING: new MessageEncoding(0x00, 0x00),
	    ZLIB: new MessageEncoding(0x12, 0x01)
	};


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Object
	 *
	 * @brief Utility functions for objects and object types
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Cheap type guard for a specific type
	 *
	 * Check is a variable is an object and assume that it is of a given type
	 *
	 * @param  o    the object to check
	 * @param  <T>  the type that is assumed if `o` is an object
	 * @return      `true` if `o` is an object
	 */
	function isObjectAs(o) {
	    return (o instanceof Object);
	}
	exports.isObjectAs = isObjectAs;


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module Util.Queue
	 *
	 * @brief A simple queue implementation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This class represent a message queue where messages can be added, removed and
	 * can query the state of the queue i.e. if the queue is currently empty or not.
	 */
	var Queue = /** @class */ (function () {
	    function Queue() {
	        /**
	         * The array storing the elements in the queue
	         */
	        this.messages = [];
	    }
	    /**
	     * Get the length of the quque
	     *
	     * @returns number of queued items
	     */
	    Queue.prototype.length = function () {
	        return this.messages.length;
	    };
	    /**
	     * Add a message to the messages queue.
	     *
	     * @param message the message to be added
	     */
	    Queue.prototype.add = function (message) {
	        this.messages.push(message);
	    };
	    /**
	     * Removes then returns all messages from the queue as an array.
	     *
	     * @returns an array of removed messages
	     */
	    Queue.prototype.drain = function () {
	        return this.messages.splice(0, this.messages.length);
	    };
	    /**
	     * Check if there are no more items in the queue
	     *
	     * @returns `true` if the queue is empty
	     */
	    Queue.prototype.isEmpty = function () {
	        return this.messages.length === 0;
	    };
	    return Queue;
	}());
	exports.Queue = Queue;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module Util.Zlib
	 *
	 * @brief Utility functions for zlib compression/decompression
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var zlib_1 = __webpack_require__(390);
	/**
	 * Thin wrapper around `zlib.inflateSync`
	 *
	 * @param  input the compressed input
	 * @return       the decompressed output
	 */
	function decompressSync(input) {
	    return zlib_1.inflateSync(input);
	}
	exports.decompressSync = decompressSync;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module V4Stack
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var connection_1 = __webpack_require__(1466);
	/**
	 * Provide a factory for creating connections with provided Transport instances
	 *
	 * @param  transports          the transports that can be used for the connecttion
	 * @param  reconnectTimeout    a reconnection timeout
	 * @param  recoveryBufferSize  size of the recovery buffer
	 *
	 * @return                     a new {@link Connection}
	 */
	function create(transports, reconnectTimeout, recoveryBufferSize) {
	    return new connection_1.Connection(transports, reconnectTimeout, recoveryBufferSize);
	}
	exports.create = create;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * @module V4Stack
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var buffer_output_stream_1 = __webpack_require__(80);
	var recovery_buffer_1 = __webpack_require__(1225);
	var connection_response_deserialiser_1 = __webpack_require__(507);
	var response_code_1 = __webpack_require__(177);
	var fsm_1 = __webpack_require__(547);
	var Logger = __webpack_require__(17);
	var Message = __webpack_require__(236);
	var close_reason_1 = __webpack_require__(172);
	var logger = Logger.create('Connection');
	/**
	 * The amount of time to wait for the server to close the connection after a req is sent.
	 */
	var CLOSE_TIMEOUT = global.DIFFUSION_CLOSE_TIMEOUT || 1000;
	/**
	 * The default recovery buffer index size
	 */
	var RECOVERY_BUFFER_INDEX_SIZE = global.DIFFUSION_RECOVERY_BUFFER_INDEX_SIZE || 8;
	/**
	 * The layer that abstracts across transports and handles the connection-level
	 * protocol. The externally exposed events from a connection are `connect`,
	 * `disconnect` and `error`. A connection only cares about whether it is connected or not.
	 *
	 * Higher level semantics such as reconnect or session close, are determined by
	 * the consumer of this connection's events, i.e the internal session.
	 *
	 * The following events are emitted by the connection are
	 *
	 * Event        |  Argument
	 * ------------ | ------------
	 * `connect`    | the handshake response
	 * `data`       | {@link Message}
	 * `disconnect` | {@link CloseReason}
	 * `close`      | {@link CloseReason}
	 * `error`      | Error
	 *
	 * TODO FB19940 update documentation to reflect the type of the handshake response
	 */
	var Connection = /** @class */ (function (_super) {
	    __extends(Connection, _super);
	    /**
	     * Create a new connection
	     *
	     * @param  transports          the transports that can be used for the connecttion
	     * @param  reconnectTimeout    a reconnection timeout
	     * @param  recoveryBufferSize  size of the recovery buffer
	     */
	    function Connection(transports, reconnectTimeout, recoveryBufferSize) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.fsm = new fsm_1.FSM('disconnected', {
	            connecting: ['connected', 'disconnected', 'closed'],
	            connected: ['disconnecting', 'disconnected', 'closed'],
	            disconnecting: ['disconnected'],
	            disconnected: ['connecting', 'closed'],
	            closed: []
	        });
	        _this.transports = transports;
	        _this.reconnectTimeout = reconnectTimeout;
	        _this.lastSentSequence = 0;
	        _this.lastReceivedSequence = 0;
	        _this.recoveryBuffer = new recovery_buffer_1.RecoveryBuffer(recoveryBufferSize, RECOVERY_BUFFER_INDEX_SIZE);
	        _this.fsm.on('change', function (previous, current) {
	            logger.debug("State changed: " + previous + " -> " + current);
	        });
	        return _this;
	    }
	    /**
	     * Parse {@link Message} from data and emit the `data` event.
	     *
	     * If the message could not be parsed, the connection will be cloed with
	     * {@link CloseReasonEnum.CONNECTION_ERROR}
	     *
	     * @param  data  the raw message data
	     */
	    Connection.prototype.onData = function (data) {
	        var _this = this;
	        logger.debug('Received message from transport', data);
	        Message.parse(data, function (err, message) {
	            if (!err && message) {
	                if (message.type === Message.types.ABORT_NOTIFICATION) {
	                    if (_this.fsm.state !== 'disconnecting') {
	                        _this.closeReason = close_reason_1.CloseReasonEnum.CLOSED_BY_SERVER;
	                    }
	                    _this.transport.close();
	                    return;
	                }
	                _this.lastReceivedSequence++;
	                _this.emitter.emit('data', message);
	            }
	            else {
	                logger.warn('Unable to parse message', err);
	                if (_this.fsm.change('closed')) {
	                    // should this be TRANSPORT_ERROR?
	                    _this.closeReason = close_reason_1.CloseReasonEnum.CONNECTION_ERROR;
	                    _this.transport.close();
	                }
	            }
	        });
	    };
	    /**
	     * Close the connection and emit a `close` event. If the connection was in
	     * a `disconnected` state, then a `disconnect` event is emitted instead.
	     */
	    Connection.prototype.onClose = function () {
	        if (this.fsm.change('disconnected') || this.fsm.change('closed')) {
	            clearInterval(this.scheduledRecoveryBufferTrim);
	            clearTimeout(this.scheduledClose);
	            logger.trace('Transport closed: ', this.closeReason);
	            if (this.fsm.state === 'disconnected') {
	                this.emitter.emit('disconnect', this.closeReason);
	            }
	            else {
	                this.emitter.close(this.closeReason);
	            }
	        }
	        else {
	            logger.debug('Unable to disconnect, current state: ', this.fsm.state);
	        }
	    };
	    /**
	     * Handle an error
	     *
	     * Closes the connection with {@link CloseReasonEnum.TRANSPORT_ERROR}
	     *
	     * @param err   the error that occured
	     */
	    Connection.prototype.onError = function (err) {
	        logger.error('Error from transport', err);
	        if (this.fsm.change('closed')) {
	            this.closeReason = close_reason_1.CloseReasonEnum.TRANSPORT_ERROR;
	            this.transport.close();
	        }
	    };
	    /**
	     * Handle connection responses.
	     *
	     * @param response  parsed connection response
	     */
	    Connection.prototype.onHandshakeSuccess = function (response) {
	        if (response.response === response_code_1.responseCodes.RECONNECTED) {
	            var messageDelta = this.lastSentSequence - response.sequence + 1;
	            if (this.recoveryBuffer.recover(messageDelta, this.dispatch.bind(this))) {
	                this.recoveryBuffer.clear();
	                this.lastSentSequence = response.sequence - 1;
	            }
	            else {
	                var outboundLoss = this.lastSentSequence - this.recoveryBuffer.size() - response.sequence + 1;
	                logger.warn("Unable to reconnect due to lost messages (" + outboundLoss + ")");
	                if (this.fsm.change('disconnected')) {
	                    this.closeReason = close_reason_1.CloseReasonEnum.LOST_MESSAGES;
	                    this.transport.close();
	                }
	                return response;
	            }
	        }
	        if (response.success && this.fsm.change('connected')) {
	            logger.trace('Connection response: ', response.response);
	            this.closeReason = close_reason_1.CloseReasonEnum.TRANSPORT_ERROR;
	            this.emitter.emit('connect', response);
	        }
	        else {
	            logger.error('Connection failed: ', response.response);
	            switch (response.response) {
	                case response_code_1.responseCodes.AUTHENTICATION_FAILED:
	                    this.closeReason = close_reason_1.CloseReasonEnum.ACCESS_DENIED;
	                    break;
	                case response_code_1.responseCodes.LICENSE_EXCEEDED:
	                    this.closeReason = close_reason_1.CloseReasonEnum.LICENSE_EXCEEDED;
	                    break;
	                case response_code_1.responseCodes.DOWNGRADE:
	                    this.closeReason = close_reason_1.CloseReasonEnum.PROTOCOL_VERSION_MISMATCH;
	                    break;
	                default:
	                    this.closeReason = close_reason_1.CloseReasonEnum.HANDSHAKE_REJECTED;
	                    break;
	            }
	            this.transport.close();
	        }
	        clearTimeout(this.scheduledClose);
	        return response;
	    };
	    /**
	     * Handle connection response parsing errors.
	     *
	     * @param error error thrown parsing the response
	     */
	    Connection.prototype.onHandshakeError = function (error) {
	        if (error.reason === connection_response_deserialiser_1.DeserialisationErrorReason.PROTOCOL_VERSION_MISMATCH) {
	            this.closeReason = close_reason_1.CloseReasonEnum.PROTOCOL_VERSION_MISMATCH;
	        }
	        else {
	            this.closeReason = close_reason_1.CloseReasonEnum.HANDSHAKE_ERROR;
	        }
	        // transport closed and close event emitted
	        clearTimeout(this.scheduledClose);
	        logger.trace('Unable to deserialise handshake response', error);
	        return;
	    };
	    /**
	     * Establish a connection with a provided connection request and connection options.
	     *
	     * @param request  the connection request
	     * @param opts     options passed to the transports
	     * @param timeout  a timeout after which the connection will be closed
	     */
	    Connection.prototype.connect = function (request, opts, timeout) {
	        var _this = this;
	        if (this.fsm.state !== 'disconnected') {
	            logger.warn('Cannot connect, current state: ', this.fsm.state);
	            return;
	        }
	        if (this.fsm.change('connecting')) {
	            this.closeReason = close_reason_1.CloseReasonEnum.CONNECTION_ERROR;
	            // begin a connection cycle with a transport
	            this.transport = this.transports.get(opts);
	            /* tslint:disable-next-line:strict-type-predicates */
	            if (this.transport === null) {
	                throw new Error('No valid transports requested');
	            }
	            this.transport.on('data', this.onData.bind(this));
	            this.transport.on('close', this.onClose.bind(this));
	            this.transport.on('error', this.onError.bind(this));
	            // attempt to connect the transport
	            this.transport.connect(request, this.onHandshakeSuccess.bind(this), this.onHandshakeError.bind(this));
	            // ensure we will emit a close reason if we're unable to connect within a timeout
	            this.scheduledClose = setTimeout(function () {
	                logger.debug("Timed out connection attempt after " + timeout);
	                _this.closeReason = close_reason_1.CloseReasonEnum.CONNECTION_TIMEOUT;
	                _this.transport.close();
	            }, timeout);
	            this.scheduledRecoveryBufferTrim = setInterval(function () {
	                if (_this.fsm.state === 'connected') {
	                    _this.recoveryBuffer.flush(Date.now() - _this.reconnectTimeout);
	                }
	            }, this.reconnectTimeout);
	        }
	    };
	    /**
	     * Reset the recovery buffer and message sequence numbers
	     */
	    Connection.prototype.resetSequences = function () {
	        this.recoveryBuffer.clear();
	        this.lastSentSequence = 0;
	        this.lastReceivedSequence = 0;
	    };
	    /**
	     * Get the sequence number of the oldest message in the recovery buffer
	     *
	     * @return  the oldest sequence number
	     */
	    Connection.prototype.getAvailableSequence = function () {
	        return this.lastSentSequence + 1 - this.recoveryBuffer.size();
	    };
	    /**
	     * Internal dispatch method for converting a message into a buffer and
	     * dispatching it through the active transport.
	     *
	     * The message is added to the recovery buffer
	     *
	     * @param message  the message that should be dispatched
	     */
	    Connection.prototype.dispatch = function (message) {
	        var bos = new buffer_output_stream_1.BufferOutputStream();
	        Message.writeToBuffer(message, bos);
	        this.lastSentSequence += 1;
	        this.recoveryBuffer.put(message);
	        this.recoveryBuffer.markTime(Date.now());
	        this.transport.dispatch(bos.getBuffer());
	    };
	    /**
	     * Send a message.
	     *
	     * Sending messages is only valid in a 'connected' state. This method will
	     * return false otherwise.
	     *
	     * @param message  the message that should be dispatched
	     * @return         `true` if the message was succesfully enqueued
	     *                  on the transport.
	     */
	    Connection.prototype.send = function (message) {
	        if (this.fsm.state === 'connected') {
	            this.dispatch(message);
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Close the connection. When the connection has been closed, it will emit a
	     * `disconnected` event.
	     *
	     * @param reason  the close reason
	     */
	    Connection.prototype.close = function (reason) {
	        this.closeReason = reason;
	        if (this.fsm.state === 'disconnected') {
	            // transport is already closed and the event isn't emitted again so the callback is called directly
	            this.onClose();
	        }
	        else if (this.fsm.change('disconnecting')) {
	            // we allow the server a grace period to close the transport connection
	            this.dispatch(Message.create(Message.types.CLOSE_REQUEST));
	            // explicitly close the transport if a given timeout elapses.
	            this.scheduledClose = setTimeout(this.transport.close.bind(this.transport), CLOSE_TIMEOUT);
	        }
	        return this;
	    };
	    /**
	     * Close the connection when it is idling
	     */
	    Connection.prototype.closeIdleConnection = function () {
	        if (this.fsm.change('disconnecting')) {
	            logger.debug('Connection detected as idle');
	            this.closeReason = close_reason_1.CloseReasonEnum.IDLE_CONNECTION;
	            this.transport.close();
	        }
	    };
	    /**
	     * Get the current state of the connection.
	     */
	    Connection.prototype.getState = function () {
	        return this.fsm.state;
	    };
	    return Connection;
	}(stream_1.StreamImpl));
	exports.Connection = Connection;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module V4Stack
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_1 = __webpack_require__(124);
	/**
	 * Get the conversation id from the message headers
	 *
	 * @param  headers  the message headers
	 * @return          the conversation ID
	 */
	function cidFromHeaders(headers) {
	    if (!headers || headers.length === 0) {
	        throw new Error('Empty headers, expected at least 1');
	    }
	    return conversation_id_1.ConversationId.fromString(headers[headers.length - 1]);
	}
	exports.cidFromHeaders = cidFromHeaders;


/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.version = '6.7.4';


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var logger = __webpack_require__(17);
	var worker_command_1 = __webpack_require__(237);
	var Long = __webpack_require__(44);
	var log = logger.create('InternalSessionLocksProxy');
	/**
	 * A SessionLock implementation for shared sessions
	 */
	var SessionLockProxy = /** @class */ (function () {
	    function SessionLockProxy(name, sequence, scope, ownedSetter, releaseLock) {
	        var _this = this;
	        this.owned = true;
	        this.name = name;
	        this.sequence = sequence;
	        this.scope = scope;
	        this.releaseLock = releaseLock;
	        ownedSetter.setOwned = function (newOwned) {
	            _this.owned = newOwned;
	        };
	    }
	    /**
	     * @inheritdoc
	     */
	    SessionLockProxy.prototype.getName = function () {
	        return this.name;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockProxy.prototype.getSequence = function () {
	        return this.sequence;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockProxy.prototype.isOwned = function () {
	        return this.owned;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockProxy.prototype.getScope = function () {
	        return this.scope;
	    };
	    /**
	     * @inheritdoc
	     */
	    SessionLockProxy.prototype.unlock = function () {
	        if (this.owned) {
	            this.owned = false;
	            return this.releaseLock(this);
	        }
	        else {
	            return Promise.resolve(false);
	        }
	    };
	    return SessionLockProxy;
	}());
	exports.SessionLockProxy = SessionLockProxy;
	/**
	 * A proxy class that replaces InternalSessionLocks when accessing a shared
	 * session
	 */
	var InternalSessionLocksProxy = /** @class */ (function () {
	    function InternalSessionLocksProxy(connector) {
	        var _this = this;
	        /**
	         * Map of pending acquisition requests
	         */
	        this.activeRequests = {};
	        /**
	         * Map of pending release requests
	         */
	        this.releaseRequests = {};
	        /**
	         * The map of locks indexed by their name
	         */
	        this.locks = {};
	        /**
	         * The next request id
	         */
	        this.nextRequestId = 0;
	        this.connector = connector;
	        this.connector.on('lock_event', function (eventArgs) {
	            var _a = __read(eventArgs, 3), lockName = _a[0], action = _a[1], data = _a[2];
	            switch (action) {
	                case worker_command_1.WorkerSessionLockCommand.ACQUIRED:
	                    _this.onLockAcquired(lockName, data);
	                    break;
	                case worker_command_1.WorkerSessionLockCommand.ACQUIRE_ERROR:
	                    _this.onLockAcquireError(lockName, data);
	                    break;
	                case worker_command_1.WorkerSessionLockCommand.OWNED:
	                    _this.onLockOwned(lockName, data);
	                    break;
	                case worker_command_1.WorkerSessionLockCommand.REMOVED:
	                    _this.onLockRemoved(lockName);
	                    break;
	                case worker_command_1.WorkerSessionLockCommand.RELEASED:
	                    _this.onLockReleased(data);
	                    break;
	                case worker_command_1.WorkerSessionLockCommand.RELEASE_ERROR:
	                    _this.onLockReleaseError(data);
	                    break;
	                default:
	                    log.error("Unrecognised lock_event " + action);
	            }
	        });
	    }
	    InternalSessionLocksProxy.prototype.onLockAcquired = function (lockName, data) {
	        var _a = __read(data, 3), requestId = _a[0], sequence = _a[1], scope = _a[2];
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.activeRequests[requestId] !== undefined) {
	            this.activeRequests[requestId](undefined, lockName, Long.fromString(sequence, 10), scope);
	            delete this.activeRequests[requestId];
	        }
	    };
	    InternalSessionLocksProxy.prototype.onLockAcquireError = function (lockName, data) {
	        var _a = __read(data, 2), requestId = _a[0], error = _a[1];
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.activeRequests[requestId] !== undefined) {
	            this.activeRequests[requestId](error, lockName);
	            delete this.activeRequests[requestId];
	        }
	    };
	    InternalSessionLocksProxy.prototype.onLockOwned = function (lockName, newOwned) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.locks[lockName] !== undefined) {
	            this.locks[lockName].ownedSetter.setOwned(newOwned);
	        }
	    };
	    InternalSessionLocksProxy.prototype.onLockRemoved = function (lockName) {
	        delete this.locks[lockName];
	    };
	    InternalSessionLocksProxy.prototype.onLockReleased = function (data) {
	        var _a = __read(data, 2), requestId = _a[0], success = _a[1];
	        this.releaseRequests[requestId](undefined, success);
	    };
	    InternalSessionLocksProxy.prototype.onLockReleaseError = function (data) {
	        var _a = __read(data, 2), requestId = _a[0], error = _a[1];
	        this.releaseRequests[requestId](error);
	    };
	    InternalSessionLocksProxy.prototype.handleAcquisition = function (lockName, sequence, scope) {
	        var oldLock = this.locks[lockName];
	        // tslint:disable-next-line:strict-type-predicates
	        if (oldLock !== undefined && oldLock.lock.getSequence().equals(sequence)) {
	            return oldLock.lock;
	        }
	        var sessionLockOwnedSetter = {
	            setOwned: function () {
	                throw Error('Session lock ownedSetter must be implemented');
	            }
	        };
	        var sessionLock = new SessionLockProxy(lockName, sequence, scope, sessionLockOwnedSetter, this.releaseLock.bind(this));
	        this.locks[lockName] = { lock: sessionLock, ownedSetter: sessionLockOwnedSetter };
	        return sessionLock;
	    };
	    InternalSessionLocksProxy.prototype.releaseLock = function (sessionLock) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var requestId = _this.nextRequestId++;
	            _this.releaseRequests[requestId] = function (err, success) {
	                delete _this.releaseRequests[requestId];
	                if (err) {
	                    log.debug('Release shared-session lock failed');
	                    reject(err);
	                }
	                else {
	                    resolve(success);
	                }
	            };
	            _this.connector.send(worker_command_1.WorkerCommand.LOCK, JSON.stringify({
	                action: 'release',
	                requestId: requestId,
	                name: sessionLock.getName(),
	                sequence: sessionLock.getSequence().toString(10),
	                scope: sessionLock.getScope()
	            }));
	        });
	    };
	    /**
	     * Request a session lock
	     *
	     * @param lockName  the lock name
	     * @param scope     the lock scope
	     * @return          a {@link Result} that resolves with the acquired session lock
	     */
	    InternalSessionLocksProxy.prototype.lock = function (lockName, scope) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            // tslint:disable-next-line:strict-type-predicates
	            if (_this.locks[lockName] !== undefined && _this.locks[lockName].lock.isOwned()) {
	                resolve(_this.locks[lockName].lock);
	            }
	            else {
	                var requestId_1 = _this.nextRequestId++;
	                _this.activeRequests[requestId_1] = function (err, name, sequence, responseScope) {
	                    delete _this.activeRequests[requestId_1];
	                    if (err) {
	                        log.debug('Acquire shared-session lock failed');
	                        reject(err);
	                    }
	                    else {
	                        resolve(_this.handleAcquisition(name, sequence, responseScope));
	                    }
	                };
	                _this.connector.send(worker_command_1.WorkerCommand.LOCK, JSON.stringify({
	                    action: 'acquire',
	                    requestId: requestId_1,
	                    name: lockName,
	                    scope: scope
	                }));
	            }
	        });
	    };
	    return InternalSessionLocksProxy;
	}());
	exports.InternalSessionLocksProxy = InternalSessionLocksProxy;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_session_1 = __webpack_require__(326);
	var service_adapter_1 = __webpack_require__(492);
	var service_locator_1 = __webpack_require__(493);
	var session_context_impl_1 = __webpack_require__(494);
	var conversation_id_1 = __webpack_require__(124);
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var buffer_input_stream_1 = __webpack_require__(125);
	var buffer_output_stream_1 = __webpack_require__(80);
	var buffer_serialiser_1 = __webpack_require__(1232);
	var command_header_1 = __webpack_require__(338);
	var command_header_serialiser_1 = __webpack_require__(512);
	var options_impl_1 = __webpack_require__(542);
	var session_id_1 = __webpack_require__(127);
	var logger = __webpack_require__(17);
	var message_1 = __webpack_require__(236);
	var internal_session_locks_proxy_1 = __webpack_require__(1469);
	var stream_registry_web_worker_proxy_1 = __webpack_require__(1472);
	var worker_command_1 = __webpack_require__(237);
	var close_reason_1 = __webpack_require__(172);
	var log = logger.create('InternalSessionWebworkerProxy');
	/**
	 * Internal session implementation
	 */
	var InternalSessionWebworkerProxy = /** @class */ (function (_super) {
	    __extends(InternalSessionWebworkerProxy, _super);
	    /**
	     * Create a new InternalSessionWebworkerProxy instance
	     *
	     * @param serviceRegistry         the service registry
	     * @param connectionFactory       a factory for creating the connection
	     * @param opts                    the session options
	     */
	    function InternalSessionWebworkerProxy(conversationSetFactory, serviceRegistry, connector, opts) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.connector = connector;
	        _this.opts = opts;
	        _this.connected = false;
	        _this.state = internal_session_1.InternalSessionState.INITIALISING;
	        _this.connector.on({
	            connect_event: function (connectArgs) {
	                var _a = __read(connectArgs, 3), sessionID = _a[0], options = _a[1], serverMaximumMessageSize = _a[2];
	                _this.sessionID = session_id_1.SessionId.fromString(sessionID);
	                _this.connected = true;
	                try {
	                    _this.serverMaximumMessageSize = parseInt(serverMaximumMessageSize, 10);
	                    _this.opts = JSON.parse(options);
	                    _this.emitter.emit('connect', _this.sessionID, new options_impl_1.OptionsImpl(_this.opts));
	                }
	                catch (err) {
	                    log.error('Unable to parse options from shared session', err);
	                    _this.emitter.emit('error', new Error('Unable to parse options from shared session'));
	                }
	            },
	            connect_error: function (error) {
	                _this.connector.disconnect();
	                _this.emitter.emit('error', close_reason_1.CloseReasonEnum[error] || new Error(error));
	            },
	            reconnect_event: function () {
	                _this.connected = true;
	                _this.emitter.emit('reconnect');
	            },
	            disconnect_event: function (reason) {
	                _this.connected = false;
	                var reasonKey = close_reason_1.CloseReasonEnum[reason];
	                _this.emitter.emit('disconnect', close_reason_1.CloseReasonEnum[reasonKey]);
	            },
	            close_event: function (reason) {
	                _this.connector.disconnect();
	                _this.connected = false;
	                var reasonKey = close_reason_1.CloseReasonEnum[reason];
	                _this.emitter.close(close_reason_1.CloseReasonEnum[reasonKey]);
	            },
	            error_event: function (err) {
	                _this.connector.disconnect();
	                _this.connected = false;
	                _this.emitter.emit('error', new Error(err));
	            },
	            command_response: function (responseArgs) {
	                var _a = __read(responseArgs, 2), cidStr = _a[0], inputStr = _a[1];
	                var cid = conversation_id_1.ConversationId.fromString(cidStr);
	                var input = new buffer_input_stream_1.BufferInputStream(Buffer.from(inputStr, 'base64'));
	                _this.conversationSet.respondIfPresent(cid, input);
	            },
	            command_error: function (responseArgs) {
	                var _a = __read(responseArgs, 2), cidStr = _a[0], errorStr = _a[1];
	                var cid = conversation_id_1.ConversationId.fromString(cidStr);
	                var error;
	                try {
	                    error = JSON.parse(errorStr);
	                }
	                catch (err) {
	                    error = new Error('Could not parse error response');
	                }
	                _this.conversationSet.discard(cid, error);
	            },
	            service_request: function (requestArgs) {
	                var _a = __read(requestArgs, 3), serviceIdStr = _a[0], ridStr = _a[1], inputStr = _a[2];
	                var rid = conversation_id_1.ConversationId.fromString(ridStr);
	                var bos = new buffer_output_stream_1.BufferOutputStream();
	                command_header_serialiser_1.CommandHeaderSerialiser.write(bos, new command_header_1.CommandHeader(parseInt(serviceIdStr, 10), rid));
	                buffer_serialiser_1.BufferSerialiser.write(bos, Buffer.from(inputStr, 'base64'));
	                var input = new buffer_input_stream_1.BufferInputStream(bos.getBuffer());
	                _this.serviceAdapter.onMessage(message_1.types.SERVICE_REQUEST, input);
	            },
	            state_change: function (newState) {
	                _this.state = newState;
	            },
	        });
	        _this.serviceAdapter = new service_adapter_1.ServiceAdapter(_this, function (msg) { _this.connector.sendMessage(msg); });
	        _this.serviceLocator = new service_locator_1.ServiceLocatorImpl(_this, _this.serviceAdapter);
	        _this.serviceRegistry = serviceRegistry;
	        _this.serviceRegistry.addListener(_this.serviceAdapter.addService.bind(_this.serviceAdapter));
	        _this.serviceRegistry.addListener(function (definition) {
	            _this.connector.send(worker_command_1.WorkerCommand.SERVICE, JSON.stringify({
	                action: 'add',
	                serviceId: definition.id
	            }));
	        });
	        _this.topicStreamRegistry = new stream_registry_web_worker_proxy_1.StreamRegistryWebworkerProxy(_this.connector);
	        _this.conversationSet = conversationSetFactory();
	        _this.sessionLocks = new internal_session_locks_proxy_1.InternalSessionLocksProxy(_this.connector);
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.connect = function () {
	        if (this.opts) {
	            var _a = this.opts, credentials = _a.credentials, reconnect = _a.reconnect, opts = __rest(_a, ["credentials", "reconnect"]);
	            var isCredentialsBuffer = credentials instanceof Buffer;
	            var credentialsStr = isCredentialsBuffer ? credentials.toString('base64') : credentials;
	            opts.reconnect = reconnect.timeout;
	            this.connector.send(worker_command_1.WorkerCommand.CONNECT, JSON.stringify([opts, isCredentialsBuffer, credentialsStr]));
	        }
	        else {
	            this.connector.send(worker_command_1.WorkerCommand.CONNECT_EXISTING);
	        }
	    };
	    InternalSessionWebworkerProxy.prototype.close = function () {
	        if (this.state !== internal_session_1.InternalSessionState.CLOSED) {
	            this.connector.send(worker_command_1.WorkerCommand.CLOSE);
	        }
	        return this;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.isConnected = function () {
	        return this.connected;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.checkConnected = function (reject) {
	        if (this.isConnected()) {
	            return true;
	        }
	        else {
	            reject(new Error('The session is not connected. Operations are not possible at this time.'));
	            return false;
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getSessionId = function () {
	        return this.sessionID;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getPrincipal = function () {
	        if (this.opts === undefined) {
	            throw new Error('Shared session is not connected');
	        }
	        return this.opts.principal || '';
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.setPrincipal = function (newPrincipal) {
	        if (this.opts === undefined) {
	            throw new Error('Shared session is not connected');
	        }
	        this.opts.principal = newPrincipal;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getOptions = function () {
	        if (this.opts === undefined) {
	            throw new Error('Shared session is not connected');
	        }
	        return this.opts;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getState = function () {
	        return this.state;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getServerMaximumMessageSize = function () {
	        return this.serverMaximumMessageSize;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.lock = function (lockName, scope) {
	        return this.sessionLocks.lock(lockName, scope);
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.onSystemPing = function () {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getStreamRegistry = function () {
	        return this.topicStreamRegistry;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getServiceRegistry = function () {
	        return this.serviceRegistry;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getRouting = function () {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getServiceLocator = function () {
	        return this.serviceLocator;
	    };
	    /**
	     * Get the conversation set
	     *
	     * @return  a reference to the conversation set
	     */
	    InternalSessionWebworkerProxy.prototype.getConversationSet = function () {
	        return this.conversationSet;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.isShared = function () {
	        return true;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.getContext = function () {
	        return session_context_impl_1.sessionContext;
	    };
	    /**
	     * @inheritdoc
	     */
	    InternalSessionWebworkerProxy.prototype.updateFeatures = function () {
	        // no-op
	    };
	    return InternalSessionWebworkerProxy;
	}(stream_1.StreamImpl));
	exports.InternalSessionWebworkerProxy = InternalSessionWebworkerProxy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_1 = __webpack_require__(124);
	var conversation_set_1 = __webpack_require__(495);
	var emitter_1 = __webpack_require__(79);
	var stream_1 = __webpack_require__(66);
	var worker_command_1 = __webpack_require__(237);
	var Long = __webpack_require__(44);
	/**
	 * A message router is responsible for receiving messages from a shared worker
	 * and passing them on to the correct connectors. Each named client session will
	 * register one connector.
	 */
	var SharedWorkerMessageRouter = /** @class */ (function () {
	    function SharedWorkerMessageRouter(workerJs) {
	        var _this = this;
	        /**
	         * The listeners indexed by the session name.
	         */
	        this.listeners = {};
	        this.worker = new SharedWorker(workerJs);
	        this.worker.port.onmessage = function (message) {
	            var e_1, _a;
	            var sessionName = message.data[0];
	            // tslint:disable-next-line:strict-type-predicates
	            if (_this.listeners[sessionName] !== undefined) {
	                try {
	                    for (var _b = __values(_this.listeners[sessionName]), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var listener = _c.value;
	                        listener.apply(void 0, __spread([message.data[1]], message.data.slice(2)));
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            }
	        };
	    }
	    /**
	     * Get the underlying shared worker
	     *
	     * @return  the shared worker
	     */
	    SharedWorkerMessageRouter.prototype.getWorker = function () {
	        return this.worker;
	    };
	    /**
	     * Add a listener callback to messages coming from a named shared session.
	     *
	     * @param sessionName  the name of the shared session
	     * @param listener     the callback function
	     */
	    SharedWorkerMessageRouter.prototype.addListener = function (sessionName, listener) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.listeners[sessionName] === undefined) {
	            this.listeners[sessionName] = [listener];
	        }
	        else {
	            this.listeners[sessionName].push(listener);
	        }
	    };
	    /**
	     * Remove a listener
	     *
	     * @param sessionName  the name of the shared session
	     * @param listenerId   the id assigned to the listener
	     */
	    SharedWorkerMessageRouter.prototype.removeListener = function (sessionName, listener) {
	        // tslint:disable-next-line:strict-type-predicates
	        if (this.listeners[sessionName] !== undefined) {
	            this.listeners[sessionName] = this.listeners[sessionName].filter(function (l) { return l !== listener; });
	        }
	    };
	    return SharedWorkerMessageRouter;
	}());
	exports.SharedWorkerMessageRouter = SharedWorkerMessageRouter;
	/**
	 * The SharedWorker message routers indexed by the URL of the worker JS file
	 */
	var sharedWorkers = {};
	/**
	 * Get a shared worker message router
	 *
	 * @param  workerJs  the JS file name that contains the worker code, should
	 *                   contain  the path to the `diffusion-worker.js` file.
	 * @return           An interface to the shared worker that allows communicating
	 *                   with named shared sessions
	 */
	function getSharedWorker(workerJs) {
	    if (!window || !window.SharedWorker) {
	        throw new Error('SharedWorker could not be found!');
	    }
	    // tslint:disable-next-line:strict-type-predicates
	    if (sharedWorkers[workerJs] === undefined) {
	        sharedWorkers[workerJs] = new SharedWorkerMessageRouter(workerJs);
	    }
	    return sharedWorkers[workerJs];
	}
	exports.getSharedWorker = getSharedWorker;
	/**
	 * A connector to a shared session running inside a web worker
	 *
	 * The messages coming from the shared worker be emitted as events on the
	 * stream.
	 *
	 * ## Events emitted
	 *
	 * `connect_event` the internal session's `connect` event
	 *
	 * `reconnect_event` the internal session's `reconnect` event
	 *
	 * `disconnect_event` the internal session's `disconnect` event
	 *
	 * `close_event` the internal session's `close` event
	 *
	 * `error_event` the internal session's `error` event
	 *
	 * `command_response` a response from a command request has been received
	 *
	 */
	var SharedSessionConnector = /** @class */ (function (_super) {
	    __extends(SharedSessionConnector, _super);
	    function SharedSessionConnector(sessionName, workerJs) {
	        var _this = this;
	        var factory = emitter_1.Emitter.create();
	        _this = _super.call(this, factory) || this;
	        _this.emitter = factory.emitter(_this);
	        _this.sessionName = sessionName;
	        _this.router = getSharedWorker(workerJs);
	        _this.worker = _this.router.getWorker();
	        _this.listener = function (command) {
	            var messages = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                messages[_i - 1] = arguments[_i];
	            }
	            if (messages.length < 2) {
	                _this.emitter.emit(command, messages[0]);
	            }
	            else {
	                _this.emitter.emit(command, messages);
	            }
	        };
	        _this.router.addListener(sessionName, _this.listener);
	        return _this;
	    }
	    /**
	     * Send a message to the shared session inside the web worker
	     */
	    SharedSessionConnector.prototype.send = function (command, message) {
	        this.worker.port.postMessage([this.sessionName, command, message]);
	    };
	    /**
	     * Send a message to the shared session
	     */
	    SharedSessionConnector.prototype.sendMessage = function (msg) {
	        var msgData = {
	            type: msg.type,
	            encoding: msg.encoding,
	            data: msg.data.toString('base64'),
	            stream: msg.getBuffer().toString('base64'),
	            headers: msg.headers,
	            id: msg.id,
	            topic: msg.topic
	        };
	        this.send(worker_command_1.WorkerCommand.MESSAGE, JSON.stringify(msgData));
	    };
	    /**
	     * Disconnect any listeners from the shared session
	     */
	    SharedSessionConnector.prototype.disconnect = function () {
	        this.router.removeListener(this.sessionName, this.listener);
	    };
	    return SharedSessionConnector;
	}(stream_1.StreamImpl));
	exports.SharedSessionConnector = SharedSessionConnector;
	/**
	 * A factory for conversation sets with conversation IDs obtained from the
	 * shared session.
	 *
	 * @param connector  the shared session connector
	 */
	function getSharedConversationSetFactory(connector) {
	    var pendingCidRequests = [];
	    function nextCid() {
	        return new Promise(function (resolve) {
	            pendingCidRequests.push(resolve);
	            connector.send(worker_command_1.WorkerCommand.CID);
	        });
	    }
	    connector.on('cid_event', function (cidStr) {
	        if (pendingCidRequests.length > 0) {
	            var resolve = pendingCidRequests.shift();
	            resolve(new conversation_id_1.ConversationId(Long.fromString(cidStr)));
	        }
	    });
	    return function () {
	        return new conversation_set_1.ConversationSet(nextCid);
	    };
	}
	exports.getSharedConversationSetFactory = getSharedConversationSetFactory;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __values = (this && this.__values) || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var conversation_id_1 = __webpack_require__(124);
	var value_stream_worker_receiver_1 = __webpack_require__(1473);
	var worker_command_1 = __webpack_require__(237);
	var Long = __webpack_require__(44);
	/**
	 * A generator for creating sequential adapter IDs across an arbitrary
	 * number of stream registries.
	 */
	var NEXT_ADAPTER_ID = (function () {
	    var id = new Long(0);
	    return function () {
	        id = id.add(1);
	        return new conversation_id_1.ConversationId(id);
	    };
	})();
	/**
	 * Internal registry for Subscription streams.
	 */
	var StreamRegistryWebworkerProxy = /** @class */ (function () {
	    function StreamRegistryWebworkerProxy(connector) {
	        var _this = this;
	        this.connector = connector;
	        this.adapters = {};
	        this.connector.on({
	            stream_event: function (eventArgs) {
	                var _a = __read(eventArgs, 4), adapterId = _a[0], event = _a[1], error = _a[2], response = _a[3];
	                var adapter = _this.adapters[adapterId];
	                if (adapter) {
	                    switch (event) {
	                        case worker_command_1.WorkerStreamCommand.OPEN:
	                            adapter.onOpen();
	                            break;
	                        case worker_command_1.WorkerStreamCommand.VALUE:
	                            adapter.onValue(response);
	                            break;
	                        case worker_command_1.WorkerStreamCommand.SUBSCRIPTION:
	                            adapter.onSubscription(response);
	                            break;
	                        case worker_command_1.WorkerStreamCommand.UNSUBSCRIPTION:
	                            adapter.onUnsubscription(response);
	                            break;
	                        case worker_command_1.WorkerStreamCommand.SUBSCRIPTION_ERROR:
	                            adapter.onSubscriptionError(error);
	                            break;
	                    }
	                }
	            }
	        });
	    }
	    /**
	     * @inheritdoc
	     */
	    StreamRegistryWebworkerProxy.prototype.add = function (selector, stream, datatype) {
	        var adapterId = NEXT_ADAPTER_ID();
	        this.adapters[adapterId.toString()] = new value_stream_worker_receiver_1.ValueStreamWorkerReceiver(stream, datatype);
	        var streamData = {
	            action: 'add',
	            adapterId: adapterId.toString(),
	            topic: selector.expression,
	            datatype: datatype.name()
	        };
	        this.connector.send(worker_command_1.WorkerCommand.STREAM, JSON.stringify(streamData));
	    };
	    /**
	     * @inheritdoc
	     */
	    StreamRegistryWebworkerProxy.prototype.addFallback = function (stream, datatype) {
	        var adapterId = NEXT_ADAPTER_ID();
	        this.adapters[adapterId.toString()] = new value_stream_worker_receiver_1.ValueStreamWorkerReceiver(stream, datatype);
	        var streamData = {
	            action: 'add_fallback',
	            adapterId: adapterId.toString(),
	            datatype: datatype.name()
	        };
	        this.connector.send(worker_command_1.WorkerCommand.STREAM, JSON.stringify(streamData));
	    };
	    /**
	     * @inheritdoc
	     */
	    StreamRegistryWebworkerProxy.prototype.remove = function (stream) {
	        var e_1, _a;
	        try {
	            for (var _b = __values(Object.getOwnPropertyNames(this.adapters)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var adapterId = _c.value;
	                if (this.adapters[adapterId].stream === stream) {
	                    var streamData = {
	                        action: 'remove',
	                        adapterId: adapterId.toString()
	                    };
	                    this.connector.send(worker_command_1.WorkerCommand.STREAM, JSON.stringify(streamData));
	                    delete this.adapters[adapterId];
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    /**
	     * @inheritdoc
	     */
	    StreamRegistryWebworkerProxy.prototype.close = function () {
	        var streamData = {
	            action: 'close_registry'
	        };
	        this.connector.send(worker_command_1.WorkerCommand.STREAM, JSON.stringify(streamData));
	    };
	    return StreamRegistryWebworkerProxy;
	}());
	exports.StreamRegistryWebworkerProxy = StreamRegistryWebworkerProxy;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var datatypes_1 = __webpack_require__(78);
	var buffer_input_stream_1 = __webpack_require__(125);
	var TopicSpecificationSerialiser = __webpack_require__(147);
	var error_reason_1 = __webpack_require__(88);
	var topic_type_1 = __webpack_require__(69);
	var topics_1 = __webpack_require__(148);
	function deserialiseTopicSpecification(specification) {
	    var bis = new buffer_input_stream_1.BufferInputStream(Buffer.from(specification, 'base64'));
	    return TopicSpecificationSerialiser.read(bis);
	}
	function deserialiseValue(value, streamDatatype, specification) {
	    if (!value) {
	        return null;
	    }
	    if (streamDatatype.name() === 'any') {
	        var datatype = (specification.type === topic_type_1.TopicTypeEnum.TIME_SERIES)
	            ? datatypes_1.DataTypes.timeseries(datatypes_1.DataTypes.get(specification.properties.TIME_SERIES_EVENT_VALUE_TYPE))
	            : datatypes_1.DataTypes.get(specification.type);
	        return datatype.readValue(value);
	    }
	    return streamDatatype.readValue(value);
	}
	/**
	 * A wrapper around a StreamAdapter that receives and deserialises data from the
	 * shared session running on the shared worker.
	 */
	var ValueStreamWorkerReceiver = /** @class */ (function () {
	    function ValueStreamWorkerReceiver(stream, datatype) {
	        this.stream = stream;
	        this.datatype = datatype;
	    }
	    /**
	     * Handle open event
	     */
	    ValueStreamWorkerReceiver.prototype.onOpen = function () {
	        this.stream.onOpen();
	    };
	    /**
	     * Handle a value event
	     *
	     * @param data the JSON serialised data from the worker
	     */
	    ValueStreamWorkerReceiver.prototype.onValue = function (data) {
	        var response = JSON.parse(data);
	        var specification = deserialiseTopicSpecification(response.specification);
	        var oldContent = response.oldValue ? Buffer.from(response.oldValue, 'base64') : null;
	        var newContent = Buffer.from(response.newValue, 'base64');
	        this.stream.onValue(response.path, specification, oldContent, newContent, deserialiseValue(oldContent, this.datatype, specification), deserialiseValue(newContent, this.datatype, specification));
	    };
	    /**
	     * Handle a subscription event
	     *
	     * @param path           the topic path
	     * @param specification  the topic specification
	     */
	    ValueStreamWorkerReceiver.prototype.onSubscription = function (data) {
	        var response = JSON.parse(data);
	        this.stream.onSubscription(response.path, deserialiseTopicSpecification(response.specification));
	    };
	    /**
	     * Handle a subscription event
	     *
	     * @param path           the topic path
	     * @param specification  the topic specification
	     * @param reason         the reason for unsubscribing
	     */
	    ValueStreamWorkerReceiver.prototype.onUnsubscription = function (data) {
	        var response = JSON.parse(data);
	        var reason = response.reason !== undefined
	            ? topics_1.UnsubscribeReasonEnum[topics_1.UnsubscribeReasonEnum[response.reason]]
	            : topics_1.UnsubscribeReasonEnum.UNKNOWN_UNSUBSCRIBE_REASON;
	        this.stream.onUnsubscription(response.path, deserialiseTopicSpecification(response.specification), reason);
	    };
	    /**
	     * Handle a subscription error
	     *
	     * @param error  the error
	     */
	    ValueStreamWorkerReceiver.prototype.onSubscriptionError = function (error) {
	        this.stream.onSubscriptionError(error_reason_1.ErrorReason[error_reason_1.ErrorReason[parseInt(error, 10)]]);
	    };
	    return ValueStreamWorkerReceiver;
	}());
	exports.ValueStreamWorkerReceiver = ValueStreamWorkerReceiver;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @module diffusion.selectors
	 */
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __spread = (this && this.__spread) || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var topic_selector_parser_1 = __webpack_require__(344);
	var topic_selector_1 = __webpack_require__(181);
	/**
	 * Create {@link TopicSelector} instances for use with other API methods.
	 *
	 * Selectors are evaluated against topic paths. A topic path is a '/'
	 * separated string of parts, which map to the topic hierarchy. Each part is
	 * formed of one or more UTF characters, except '/'. Topic paths are absolute,
	 * and evaluated from the root of the current domain.
	 *
	 * **Example:**
	 * ```
	 * // Create a topic selector
	 * var selector = diffusion.selectors.parse('?foo/bar/.*');
	 * ```
	 */
	var TopicSelectors = /** @class */ (function () {
	    function TopicSelectors() {
	        /**
	         * The Prefix enum
	         */ // tslint:disable-next-line:variable-name
	        this.Prefix = topic_selector_1.Prefix;
	        /**
	         * The Type enum
	         */ // tslint:disable-next-line:variable-name
	        this.Type = topic_selector_1.Type;
	    }
	    /**
	     * Parse an expression to create a selector.
	     *
	     * This function can take any number of arguments. Each argument can be a string
	     * or a {@link TopicSelector}. Alternatively, an array of strings and
	     * {@link TopicSelector}s can be passed as a single argument.
	     *
	     * The following types of expression are supported. The type is determined
	     * by the first character of the expression.
	     *
	     * <dl>
	     * <dt>Path
	     * <dd>Path expressions begin with the character <code>></code>. The remainder of
	     * the expression must be a valid topic path. A topic path is a '/'
	     * separated string of parts. Each part is formed of one or more UTF
	     * characters, except '/'.
	     *
	     * A {@link Type.PATH PATH} selector is returned that only
	     * selects the topic with the given path.
	     *
	     * <h4>Abbreviated Path Expressions</h4>
	     *
	     * In Diffusion 5.2, an alternative syntax for path expressions was added.
	     * An <em>abbreviated path expression</em> is any valid topic path (see
	     * above) that begins with a character other than one of <code>#</code>,
	     * <code>?</code>, <code>></code>, <code>*</code>, <code>$</code>,
	     * <code>%</code>, <code>&</code>, or <code><</code>.
	     * This syntax allows most topic paths to be used directly as selector
	     * expressions which appears more natural.
	     *
	     * This method converts abbreviated path expressions to standard path
	     * expressions by prepending the <code>></code> character. Thus <code>a/b</code> is
	     * interpreted as <code>>a/b</code>.
	     *
	     * <code>parse("a/b").expression</code> will return <code>">a/b"</code>.
	     *
	     * <dt>Split-path pattern
	     * <dd>Split-path pattern expressions begin with the character <code>?</code>.
	     * The remainder of the expression is split into a list of regular
	     * expressions using the <code>/</code> character as a separator.
	     *
	     * A {@link Type.SPLIT_PATH_PATTERN SPLIT_PATH_PATTERN}
	     * selector is returned that selects topics for which each regular
	     * expression matches each part of the topic path at the corresponding
	     * level.
	     *
	     * <dt>Full-path pattern
	     * <dd>Full-path pattern expressions begin with the character <code>*</code>. The
	     * remainder of the pattern is a regular expression.
	     *
	     * A {@link Type.FULL_PATH_PATTERN FULL_PATH_PATTERN} selector
	     * is returned that selects topics for which the regular expression matches
	     * the complete topic path.
	     *
	     * Full-path patterns provide a lot of expressive power but should be used
	     * sparingly since the server can evaluate split-path patterns more
	     * efficiently.
	     *
	     * Selector sets are the preferred way to combine expressions.
	     * <code>parse("a", "b")</code> is equivalent to the full-path expression "
	     * <code>*[a|b]</code>", but can be evaluated more efficiently by the
	     * server.
	     *
	     * <dt>Selector set
	     * <dd>Selector set expressions begin with the character <code>#</code>. The
	     * remainder of the expression is a list of contained selectors, formatted
	     * as described below.
	     *
	     * A {@link Type.SELECTOR_SET SELECTOR_SET} selector is
	     * returned that selects topics that match any of the contained selectors.
	     *
	     * The contained selectors are formatted as follows. First, any selector
	     * sets are expanded to produce a full list of non-selector set expressions.
	     * Then the selector expressions are concatenated, separated by the
	     * separator <code>////</code>. This separator has been chosen as it is not
	     * valid in a path, and is not a useful sequence in a pattern.
	     * </dl>
	     *
	     * <h2>Descendant pattern qualifiers</h2>
	     *
	     * Split-path and full-path pattern expressions can be further modified by
	     * appending `/` or `//`. These control the behaviour of the
	     * selector with respect to the descendants of the topics that match the
	     * pattern.
	     *
	     * <ul>
	     *
	     * <li>
	     * If the expression does not end with `/` or `//`, it selects
	     * only the topics that match the pattern.</li>
	     *
	     * <li>
	     * If the expression ends with `/`, it selects only the descendants of
	     * the matching topics, excluding the matching topics.</li>
	     *
	     * <li>
	     * If the expression ends with `//`, it selects the matching topics
	     * and all of their descendants.</li>
	     * </ul>
	     * </p>
	     *
	     * <h2>Regular expressions</h2>
	     *
	     * Any Java-style regular expression can be used in split-path and full-path
	     * patterns, with the following restrictions:
	     *
	     * * A regular expression may not be empty.
	     * * A regular expression used in split-path patterns may not contain the
	     *   path separator `/`.
	     * * A regular expression used in full-path patterns may not contain the
	     *   selector set separator `////`.
	     *
	     * Regular expressions that break any of these restrictions would never
	     * match a topic path, so they make no practical difference.
	     *
	     * <h2>Examples</h2>
	     *
	     * <h3>Path expressions</h3>
	     *
	     *  Path         |  Matches `alpha/beta`? | Matches `alpha/beta/gamma`?
	     * ------------- | ---------------------- | ---------------------------
	     * `>alpha/beta`       | yes | no
	     * `>alpha/beta/gamma` | no  | yes
	     * `>beta`             | no  | no
	     * `>.*``/.*`          | no  | no
	     * `>/alpha/beta/`     | yes | no
	     *
	     * <h3>Abbreviated path expressions</h3>
	     *
	     *  Path         |  Matches `alpha/beta`? | Matches `alpha/beta/gamma`?
	     * ------------- | ---------------------- | ---------------------------
	     * `alpha/beta`        | yes | no
	     * `alpha/beta/gamma`  | no  | yes
	     * `beta`              | no  | no
	     * `/alpha/beta/`      | yes | no
	     *
	     * <h3>Split-path pattern expressions</h3>
	     *
	     *  Path         |  Matches `alpha/beta`? | Matches `alpha/beta/gamma`?
	     * ------------- | ---------------------- | ---------------------------
	     * `?alpha/beta`       | yes | no
	     * `?alpha/beta/gamma` | no  | yes
	     * `?beta`             | no  | no
	     * `?.*`               | no  | no
	     * `?.*``/.*`          | yes | no
	     * `?alpha/beta/`      | no  | yes
	     * `?alpha/beta//`     | yes | yes
	     * `?alpha/.*``//`     | yes | yes
	     *
	     * <h3>Full-path pattern expressions</h3>
	     *
	     *  Path         |  Matches `alpha/beta`? | Matches `alpha/beta/gamma`?
	     * ------------- | ---------------------- | ---------------------------
	     * `*alpha/beta`       | yes | no
	     * `*alpha/beta/gamma` | no  | yes
	     * `*beta`             | no  | no
	     * `*.*beta`           | yes | no
	     * `*.*`               | yes | yes
	     * `*alpha/beta/`      | no  | yes
	     * `*alpha/beta//`     | yes | yes
	     *
	     * **Example:**
	     * ```
	     * // Simple selector
	     * var selector = diffusion.selectors.parse(">a/b");
	     * ```
	     *
	     * **Example:**
	     * ```
	     * // Creating a selector set
	     * var selectorSet = diffusion.selectors.parse(">a", ">b");
	     * ```
	     *
	     * @param expression  the pattern expression(s). At least one
	     *                    valid selector has to be specified.
	     * @param args        additional pattern expressions
	     * @return            the topic selector. If multiple expressions are provided,
	     *                    this will return a `SELECTOR_SET` that will match if
	     *                    any of the * provided `selectors` match.
	     */
	    TopicSelectors.prototype.parse = function (expression) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return topic_selector_parser_1.parseSelector.apply(void 0, __spread([expression], args));
	    };
	    return TopicSelectors;
	}());
	exports.TopicSelectors = TopicSelectors;


/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @module diffusion
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An enum for the available log levels
	 *
	 * Accessible through `diffusion.LogLevel`.
	 */
	var LogLevel;
	(function (LogLevel) {
	    LogLevel["trace"] = "trace";
	    LogLevel["debug"] = "debug";
	    LogLevel["info"] = "info";
	    LogLevel["warn"] = "warn";
	    LogLevel["error"] = "error";
	    LogLevel["silent"] = "silent";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));


/***/ }),
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["rpDiffusion"] = __webpack_require__(1817);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Hls"] = factory();
		else
			root["Hls"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enableLogs; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logger; });
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function noop() {}
	
	var fakeLogger = {
	  trace: noop,
	  debug: noop,
	  log: noop,
	  warn: noop,
	  info: noop,
	  error: noop
	};
	
	var exportedLogger = fakeLogger;
	
	/*globals self: false */
	
	//let lastCallTime;
	// function formatMsgWithTimeInfo(type, msg) {
	//   const now = Date.now();
	//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
	//   lastCallTime = now;
	//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
	//   return msg;
	// }
	
	function formatMsg(type, msg) {
	  msg = '[' + type + '] > ' + msg;
	  return msg;
	}
	
	function consolePrintFn(type) {
	  var func = self.console[type];
	  if (func) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (args[0]) {
	        args[0] = formatMsg(type, args[0]);
	      }
	      func.apply(self.console, args);
	    };
	  }
	  return noop;
	}
	
	function exportLoggerFunctions(debugConfig) {
	  for (var _len2 = arguments.length, functions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    functions[_key2 - 1] = arguments[_key2];
	  }
	
	  functions.forEach(function (type) {
	    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
	  });
	}
	
	var enableLogs = function enableLogs(debugConfig) {
	  if (debugConfig === true || (typeof debugConfig === 'undefined' ? 'undefined' : _typeof(debugConfig)) === 'object') {
	    exportLoggerFunctions(debugConfig,
	    // Remove out from list here to hard-disable a log-level
	    //'trace',
	    'debug', 'log', 'info', 'warn', 'error');
	    // Some browsers don't allow to use bind on console object anyway
	    // fallback to default if needed
	    try {
	      exportedLogger.log();
	    } catch (e) {
	      exportedLogger = fakeLogger;
	    }
	  } else {
	    exportedLogger = fakeLogger;
	  }
	};
	
	var logger = exportedLogger;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony default export */ __webpack_exports__["a"] = ({
	  // fired before MediaSource is attaching to media element - data: { media }
	  MEDIA_ATTACHING: 'hlsMediaAttaching',
	  // fired when MediaSource has been succesfully attached to media element - data: { }
	  MEDIA_ATTACHED: 'hlsMediaAttached',
	  // fired before detaching MediaSource from media element - data: { }
	  MEDIA_DETACHING: 'hlsMediaDetaching',
	  // fired when MediaSource has been detached from media element - data: { }
	  MEDIA_DETACHED: 'hlsMediaDetached',
	  // fired when we buffer is going to be reset - data: { }
	  BUFFER_RESET: 'hlsBufferReset',
	  // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
	  BUFFER_CODECS: 'hlsBufferCodecs',
	  // fired when sourcebuffers have been created - data: { tracks : tracks }
	  BUFFER_CREATED: 'hlsBufferCreated',
	  // fired when we append a segment to the buffer - data: { segment: segment object }
	  BUFFER_APPENDING: 'hlsBufferAppending',
	  // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
	  BUFFER_APPENDED: 'hlsBufferAppended',
	  // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
	  BUFFER_EOS: 'hlsBufferEos',
	  // fired when the media buffer should be flushed - data { startOffset, endOffset }
	  BUFFER_FLUSHING: 'hlsBufferFlushing',
	  // fired when the media buffer has been flushed - data: { }
	  BUFFER_FLUSHED: 'hlsBufferFlushed',
	  // fired to signal that a manifest loading starts - data: { url : manifestURL}
	  MANIFEST_LOADING: 'hlsManifestLoading',
	  // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
	  MANIFEST_LOADED: 'hlsManifestLoaded',
	  // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
	  MANIFEST_PARSED: 'hlsManifestParsed',
	  // fired when a level switch is requested - data: { level : id of new level } // deprecated in favor LEVEL_SWITCHING
	  LEVEL_SWITCH: 'hlsLevelSwitch',
	  // fired when a level switch is requested - data: { level : id of new level }
	  LEVEL_SWITCHING: 'hlsLevelSwitching',
	  // fired when a level switch is effective - data: { level : id of new level }
	  LEVEL_SWITCHED: 'hlsLevelSwitched',
	  // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
	  LEVEL_LOADING: 'hlsLevelLoading',
	  // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
	  LEVEL_LOADED: 'hlsLevelLoaded',
	  // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
	  LEVEL_UPDATED: 'hlsLevelUpdated',
	  // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
	  LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
	  // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
	  AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
	  // fired when an audio track switch occurs - data: { id : audio track id } // deprecated in favor AUDIO_TRACK_SWITCHING
	  AUDIO_TRACK_SWITCH: 'hlsAudioTrackSwitch',
	  // fired when an audio track switching is requested - data: { id : audio track id }
	  AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
	  // fired when an audio track switch actually occurs - data: { id : audio track id }
	  AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
	  // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
	  AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
	  // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
	  AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
	  // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
	  SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
	  // fired when an subtitle track switch occurs - data: { id : subtitle track id }
	  SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
	  // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
	  SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
	  // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
	  SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
	  // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
	  SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
	  // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
	  INIT_PTS_FOUND: 'hlsInitPtsFound',
	  // fired when a fragment loading starts - data: { frag : fragment object }
	  FRAG_LOADING: 'hlsFragLoading',
	  // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
	  FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
	  // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
	  FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
	  // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
	  FRAG_LOADED: 'hlsFragLoaded',
	  // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
	  FRAG_DECRYPTED: 'hlsFragDecrypted',
	  // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
	  FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
	  // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
	  FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
	  // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
	  FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
	  // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
	  FRAG_PARSING_DATA: 'hlsFragParsingData',
	  // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
	  FRAG_PARSED: 'hlsFragParsed',
	  // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
	  FRAG_BUFFERED: 'hlsFragBuffered',
	  // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
	  FRAG_CHANGED: 'hlsFragChanged',
	  // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
	  FPS_DROP: 'hlsFpsDrop',
	  //triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
	  FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
	  // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
	  ERROR: 'hlsError',
	  // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
	  DESTROYING: 'hlsDestroying',
	  // fired when a decrypt key loading starts - data: { frag : fragment object }
	  KEY_LOADING: 'hlsKeyLoading',
	  // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
	  KEY_LOADED: 'hlsKeyLoaded',
	  // fired upon stream controller state transitions - data: { previousState, nextState }
	  STREAM_STATE_TRANSITION: 'hlsStreamStateTransition'
	});
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorTypes; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorDetails; });
	var ErrorTypes = {
	  // Identifier for a network error (loading error / timeout ...)
	  NETWORK_ERROR: 'networkError',
	  // Identifier for a media Error (video/parsing/mediasource error)
	  MEDIA_ERROR: 'mediaError',
	  // Identifier for a mux Error (demuxing/remuxing)
	  MUX_ERROR: 'muxError',
	  // Identifier for all other errors
	  OTHER_ERROR: 'otherError'
	};
	
	var ErrorDetails = {
	  // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
	  MANIFEST_LOAD_ERROR: 'manifestLoadError',
	  // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
	  MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
	  // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
	  MANIFEST_PARSING_ERROR: 'manifestParsingError',
	  // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
	  MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
	  // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
	  LEVEL_LOAD_ERROR: 'levelLoadError',
	  // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
	  LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
	  // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
	  LEVEL_SWITCH_ERROR: 'levelSwitchError',
	  // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
	  AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
	  // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
	  AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
	  // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
	  FRAG_LOAD_ERROR: 'fragLoadError',
	  // Identifier for fragment loop loading error - data: { frag : fragment object}
	  FRAG_LOOP_LOADING_ERROR: 'fragLoopLoadingError',
	  // Identifier for fragment load timeout error - data: { frag : fragment object}
	  FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
	  // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
	  FRAG_DECRYPT_ERROR: 'fragDecryptError',
	  // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
	  // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
	  FRAG_PARSING_ERROR: 'fragParsingError',
	  // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
	  REMUX_ALLOC_ERROR: 'remuxAllocError',
	  // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
	  KEY_LOAD_ERROR: 'keyLoadError',
	  // Identifier for decrypt key load timeout error - data: { frag : fragment object}
	  KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
	  // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
	  BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
	  // Identifier for a buffer append error - data: append error description
	  BUFFER_APPEND_ERROR: 'bufferAppendError',
	  // Identifier for a buffer appending error event - data: appending error description
	  BUFFER_APPENDING_ERROR: 'bufferAppendingError',
	  // Identifier for a buffer stalled error event
	  BUFFER_STALLED_ERROR: 'bufferStalledError',
	  // Identifier for a buffer full event
	  BUFFER_FULL_ERROR: 'bufferFullError',
	  // Identifier for a buffer seek over hole event
	  BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
	  // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
	  BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
	  // Identifier for an internal exception happening inside hls.js while handling an event
	  INTERNAL_EXCEPTION: 'internalException'
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utf8ArrayToStr; });
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ID3 parser
	 */
	var ID3 = function () {
	  function ID3() {
	    _classCallCheck(this, ID3);
	  }
	
	  /**
	   * Returns true if an ID3 header can be found at offset in data
	   * @param {Uint8Array} data - The data to search in
	   * @param {number} offset - The offset at which to start searching
	   * @return {boolean} - True if an ID3 header is found
	   */
	  ID3.isHeader = function isHeader(data, offset) {
	    /*
	    * http://id3.org/id3v2.3.0
	    * [0]     = 'I'
	    * [1]     = 'D'
	    * [2]     = '3'
	    * [3,4]   = {Version}
	    * [5]     = {Flags}
	    * [6-9]   = {ID3 Size}
	    *
	    * An ID3v2 tag can be detected with the following pattern:
	    *  $49 44 33 yy yy xx zz zz zz zz
	    * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
	    */
	    if (offset + 10 <= data.length) {
	      //look for 'ID3' identifier
	      if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
	        //check version is within range
	        if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
	          //check size is within range
	          if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
	            return true;
	          }
	        }
	      }
	    }
	
	    return false;
	  };
	
	  /**
	   * Returns true if an ID3 footer can be found at offset in data
	   * @param {Uint8Array} data - The data to search in
	   * @param {number} offset - The offset at which to start searching
	   * @return {boolean} - True if an ID3 footer is found
	   */
	
	
	  ID3.isFooter = function isFooter(data, offset) {
	    /*
	    * The footer is a copy of the header, but with a different identifier
	    */
	    if (offset + 10 <= data.length) {
	      //look for '3DI' identifier
	      if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
	        //check version is within range
	        if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
	          //check size is within range
	          if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
	            return true;
	          }
	        }
	      }
	    }
	
	    return false;
	  };
	
	  /**
	   * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
	   * @param {Uint8Array} data - The data to search in
	   * @param {number} offset - The offset at which to start searching
	   * @return {Uint8Array} - The block of data containing any ID3 tags found
	   */
	
	
	  ID3.getID3Data = function getID3Data(data, offset) {
	    var front = offset;
	    var length = 0;
	
	    while (ID3.isHeader(data, offset)) {
	      //ID3 header is 10 bytes
	      length += 10;
	
	      var size = ID3._readSize(data, offset + 6);
	      length += size;
	
	      if (ID3.isFooter(data, offset + 10)) {
	        //ID3 footer is 10 bytes
	        length += 10;
	      }
	
	      offset += length;
	    }
	
	    if (length > 0) {
	      return data.subarray(front, front + length);
	    }
	
	    return undefined;
	  };
	
	  ID3._readSize = function _readSize(data, offset) {
	    var size = 0;
	    size = (data[offset] & 0x7f) << 21;
	    size |= (data[offset + 1] & 0x7f) << 14;
	    size |= (data[offset + 2] & 0x7f) << 7;
	    size |= data[offset + 3] & 0x7f;
	    return size;
	  };
	
	  /**
	   * Searches for the Elementary Stream timestamp found in the ID3 data chunk
	   * @param {Uint8Array} data - Block of data containing one or more ID3 tags
	   * @return {number} - The timestamp
	   */
	
	
	  ID3.getTimeStamp = function getTimeStamp(data) {
	    var frames = ID3.getID3Frames(data);
	    for (var i = 0; i < frames.length; i++) {
	      var frame = frames[i];
	      if (ID3.isTimeStampFrame(frame)) {
	        return ID3._readTimeStamp(frame);
	      }
	    }
	
	    return undefined;
	  };
	
	  /**
	   * Returns true if the ID3 frame is an Elementary Stream timestamp frame
	   * @param {ID3 frame} frame
	   */
	
	
	  ID3.isTimeStampFrame = function isTimeStampFrame(frame) {
	    return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
	  };
	
	  ID3._getFrameData = function _getFrameData(data) {
	    /*
	    Frame ID       $xx xx xx xx (four characters)
	    Size           $xx xx xx xx
	    Flags          $xx xx
	    */
	    var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
	    var size = ID3._readSize(data, 4);
	
	    //skip frame id, size, and flags
	    var offset = 10;
	
	    return { type: type, size: size, data: data.subarray(offset, offset + size) };
	  };
	
	  /**
	   * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
	   * @param {Uint8Array} id3Data - The ID3 data containing one or more ID3 tags
	   * @return {ID3 frame[]} - Array of ID3 frame objects
	   */
	
	
	  ID3.getID3Frames = function getID3Frames(id3Data) {
	    var offset = 0;
	    var frames = [];
	
	    while (ID3.isHeader(id3Data, offset)) {
	      var size = ID3._readSize(id3Data, offset + 6);
	      //skip past ID3 header
	      offset += 10;
	      var end = offset + size;
	      //loop through frames in the ID3 tag
	      while (offset + 8 < end) {
	        var frameData = ID3._getFrameData(id3Data.subarray(offset));
	        var frame = ID3._decodeFrame(frameData);
	        if (frame) {
	          frames.push(frame);
	        }
	        //skip frame header and frame data
	        offset += frameData.size + 10;
	      }
	
	      if (ID3.isFooter(id3Data, offset)) {
	        offset += 10;
	      }
	    }
	
	    return frames;
	  };
	
	  ID3._decodeFrame = function _decodeFrame(frame) {
	    if (frame.type === 'PRIV') {
	      return ID3._decodePrivFrame(frame);
	    } else if (frame.type[0] === 'T') {
	      return ID3._decodeTextFrame(frame);
	    } else if (frame.type[0] === 'W') {
	      return ID3._decodeURLFrame(frame);
	    }
	
	    return undefined;
	  };
	
	  ID3._readTimeStamp = function _readTimeStamp(timeStampFrame) {
	    if (timeStampFrame.data.byteLength === 8) {
	      var data = new Uint8Array(timeStampFrame.data);
	      // timestamp is 33 bit expressed as a big-endian eight-octet number,
	      // with the upper 31 bits set to zero.
	      var pts33Bit = data[3] & 0x1;
	      var timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
	      timestamp /= 45;
	
	      if (pts33Bit) {
	        timestamp += 47721858.84; // 2^32 / 90
	      }
	
	      return Math.round(timestamp);
	    }
	
	    return undefined;
	  };
	
	  ID3._decodePrivFrame = function _decodePrivFrame(frame) {
	    /*
	    Format: <text string>\0<binary data>
	    */
	    if (frame.size < 2) {
	      return undefined;
	    }
	
	    var owner = ID3._utf8ArrayToStr(frame.data, true);
	    var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
	
	    return { key: frame.type, info: owner, data: privateData.buffer };
	  };
	
	  ID3._decodeTextFrame = function _decodeTextFrame(frame) {
	    if (frame.size < 2) {
	      return undefined;
	    }
	
	    if (frame.type === 'TXXX') {
	      /*
	      Format:
	      [0]   = {Text Encoding}
	      [1-?] = {Description}\0{Value}
	      */
	      var index = 1;
	      var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
	
	      index += description.length + 1;
	      var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
	
	      return { key: frame.type, info: description, data: value };
	    } else {
	      /*
	      Format:
	      [0]   = {Text Encoding}
	      [1-?] = {Value}
	      */
	      var text = ID3._utf8ArrayToStr(frame.data.subarray(1));
	      return { key: frame.type, data: text };
	    }
	  };
	
	  ID3._decodeURLFrame = function _decodeURLFrame(frame) {
	    if (frame.type === 'WXXX') {
	      /*
	      Format:
	      [0]   = {Text Encoding}
	      [1-?] = {Description}\0{URL}
	      */
	      if (frame.size < 2) {
	        return undefined;
	      }
	
	      var index = 1;
	      var description = ID3._utf8ArrayToStr(frame.data.subarray(index));
	
	      index += description.length + 1;
	      var value = ID3._utf8ArrayToStr(frame.data.subarray(index));
	
	      return { key: frame.type, info: description, data: value };
	    } else {
	      /*
	      Format:
	      [0-?] = {URL}
	      */
	      var url = ID3._utf8ArrayToStr(frame.data);
	      return { key: frame.type, data: url };
	    }
	  };
	
	  // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
	  // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
	  /* utf.js - UTF-8 <=> UTF-16 convertion
	   *
	   * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
	   * Version: 1.0
	   * LastModified: Dec 25 1999
	   * This library is free.  You can redistribute it and/or modify it.
	   */
	
	
	  ID3._utf8ArrayToStr = function _utf8ArrayToStr(array) {
	    var exitOnNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	
	    var len = array.length;
	    var c = void 0;
	    var char2 = void 0;
	    var char3 = void 0;
	    var out = '';
	    var i = 0;
	    while (i < len) {
	      c = array[i++];
	      if (c === 0x00 && exitOnNull) {
	        return out;
	      } else if (c === 0x00 || c === 0x03) {
	        // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
	        continue;
	      }
	      switch (c >> 4) {
	        case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:
	          // 0xxxxxxx
	          out += String.fromCharCode(c);
	          break;
	        case 12:case 13:
	          // 110x xxxx   10xx xxxx
	          char2 = array[i++];
	          out += String.fromCharCode((c & 0x1F) << 6 | char2 & 0x3F);
	          break;
	        case 14:
	          // 1110 xxxx  10xx xxxx  10xx xxxx
	          char2 = array[i++];
	          char3 = array[i++];
	          out += String.fromCharCode((c & 0x0F) << 12 | (char2 & 0x3F) << 6 | (char3 & 0x3F) << 0);
	          break;
	        default:
	      }
	    }
	    return out;
	  };
	
	  return ID3;
	}();
	
	var utf8ArrayToStr = ID3._utf8ArrayToStr;
	
	/* harmony default export */ __webpack_exports__["a"] = (ID3);
	
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./src/crypt/aes-crypto.js
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AESCrypto = function () {
	  function AESCrypto(subtle, iv) {
	    _classCallCheck(this, AESCrypto);
	
	    this.subtle = subtle;
	    this.aesIV = iv;
	  }
	
	  AESCrypto.prototype.decrypt = function decrypt(data, key) {
	    return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, key, data);
	  };
	
	  return AESCrypto;
	}();
	
	/* harmony default export */ var aes_crypto = (AESCrypto);
	// CONCATENATED MODULE: ./src/crypt/fast-aes-key.js
	function fast_aes_key__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FastAESKey = function () {
	  function FastAESKey(subtle, key) {
	    fast_aes_key__classCallCheck(this, FastAESKey);
	
	    this.subtle = subtle;
	    this.key = key;
	  }
	
	  FastAESKey.prototype.expandKey = function expandKey() {
	    return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
	  };
	
	  return FastAESKey;
	}();
	
	/* harmony default export */ var fast_aes_key = (FastAESKey);
	// CONCATENATED MODULE: ./src/crypt/aes-decryptor.js
	function aes_decryptor__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AESDecryptor = function () {
	  function AESDecryptor() {
	    aes_decryptor__classCallCheck(this, AESDecryptor);
	
	    // Static after running initTable
	    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
	    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
	    this.sBox = new Uint32Array(256);
	    this.invSBox = new Uint32Array(256);
	
	    // Changes during runtime
	    this.key = new Uint32Array(0);
	
	    this.initTable();
	  }
	
	  // Using view.getUint32() also swaps the byte order.
	
	
	  AESDecryptor.prototype.uint8ArrayToUint32Array_ = function uint8ArrayToUint32Array_(arrayBuffer) {
	    var view = new DataView(arrayBuffer);
	    var newArray = new Uint32Array(4);
	    for (var i = 0; i < 4; i++) {
	      newArray[i] = view.getUint32(i * 4);
	    }
	    return newArray;
	  };
	
	  AESDecryptor.prototype.initTable = function initTable() {
	    var sBox = this.sBox;
	    var invSBox = this.invSBox;
	    var subMix = this.subMix;
	    var subMix0 = subMix[0];
	    var subMix1 = subMix[1];
	    var subMix2 = subMix[2];
	    var subMix3 = subMix[3];
	    var invSubMix = this.invSubMix;
	    var invSubMix0 = invSubMix[0];
	    var invSubMix1 = invSubMix[1];
	    var invSubMix2 = invSubMix[2];
	    var invSubMix3 = invSubMix[3];
	
	    var d = new Uint32Array(256);
	    var x = 0;
	    var xi = 0;
	    var i = 0;
	    for (i = 0; i < 256; i++) {
	      if (i < 128) {
	        d[i] = i << 1;
	      } else {
	        d[i] = i << 1 ^ 0x11b;
	      }
	    }
	
	    for (i = 0; i < 256; i++) {
	      var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
	      sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
	      sBox[x] = sx;
	      invSBox[sx] = x;
	
	      // Compute multiplication
	      var x2 = d[x];
	      var x4 = d[x2];
	      var x8 = d[x4];
	
	      // Compute sub/invSub bytes, mix columns tables
	      var t = d[sx] * 0x101 ^ sx * 0x1010100;
	      subMix0[x] = t << 24 | t >>> 8;
	      subMix1[x] = t << 16 | t >>> 16;
	      subMix2[x] = t << 8 | t >>> 24;
	      subMix3[x] = t;
	
	      // Compute inv sub bytes, inv mix columns tables
	      t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	      invSubMix0[sx] = t << 24 | t >>> 8;
	      invSubMix1[sx] = t << 16 | t >>> 16;
	      invSubMix2[sx] = t << 8 | t >>> 24;
	      invSubMix3[sx] = t;
	
	      // Compute next counter
	      if (!x) {
	        x = xi = 1;
	      } else {
	        x = x2 ^ d[d[d[x8 ^ x2]]];
	        xi ^= d[d[xi]];
	      }
	    }
	  };
	
	  AESDecryptor.prototype.expandKey = function expandKey(keyBuffer) {
	    // convert keyBuffer to Uint32Array
	    var key = this.uint8ArrayToUint32Array_(keyBuffer);
	    var sameKey = true;
	    var offset = 0;
	
	    while (offset < key.length && sameKey) {
	      sameKey = key[offset] === this.key[offset];
	      offset++;
	    }
	
	    if (sameKey) {
	      return;
	    }
	
	    this.key = key;
	    var keySize = this.keySize = key.length;
	
	    if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
	      throw new Error('Invalid aes key size=' + keySize);
	    }
	
	    var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
	    var ksRow = void 0;
	    var invKsRow = void 0;
	
	    var keySchedule = this.keySchedule = new Uint32Array(ksRows);
	    var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
	    var sbox = this.sBox;
	    var rcon = this.rcon;
	
	    var invSubMix = this.invSubMix;
	    var invSubMix0 = invSubMix[0];
	    var invSubMix1 = invSubMix[1];
	    var invSubMix2 = invSubMix[2];
	    var invSubMix3 = invSubMix[3];
	
	    var prev = void 0;
	    var t = void 0;
	
	    for (ksRow = 0; ksRow < ksRows; ksRow++) {
	      if (ksRow < keySize) {
	        prev = keySchedule[ksRow] = key[ksRow];
	        continue;
	      }
	      t = prev;
	
	      if (ksRow % keySize === 0) {
	        // Rot word
	        t = t << 8 | t >>> 24;
	
	        // Sub word
	        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
	
	        // Mix Rcon
	        t ^= rcon[ksRow / keySize | 0] << 24;
	      } else if (keySize > 6 && ksRow % keySize === 4) {
	        // Sub word
	        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
	      }
	
	      keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
	    }
	
	    for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	      ksRow = ksRows - invKsRow;
	      if (invKsRow & 3) {
	        t = keySchedule[ksRow];
	      } else {
	        t = keySchedule[ksRow - 4];
	      }
	
	      if (invKsRow < 4 || ksRow <= 4) {
	        invKeySchedule[invKsRow] = t;
	      } else {
	        invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
	      }
	
	      invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
	    }
	  };
	
	  // Adding this as a method greatly improves performance.
	
	
	  AESDecryptor.prototype.networkToHostOrderSwap = function networkToHostOrderSwap(word) {
	    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	  };
	
	  AESDecryptor.prototype.decrypt = function decrypt(inputArrayBuffer, offset, aesIV) {
	    var nRounds = this.keySize + 6;
	    var invKeySchedule = this.invKeySchedule;
	    var invSBOX = this.invSBox;
	
	    var invSubMix = this.invSubMix;
	    var invSubMix0 = invSubMix[0];
	    var invSubMix1 = invSubMix[1];
	    var invSubMix2 = invSubMix[2];
	    var invSubMix3 = invSubMix[3];
	
	    var initVector = this.uint8ArrayToUint32Array_(aesIV);
	    var initVector0 = initVector[0];
	    var initVector1 = initVector[1];
	    var initVector2 = initVector[2];
	    var initVector3 = initVector[3];
	
	    var inputInt32 = new Int32Array(inputArrayBuffer);
	    var outputInt32 = new Int32Array(inputInt32.length);
	
	    var t0 = void 0,
	        t1 = void 0,
	        t2 = void 0,
	        t3 = void 0;
	    var s0 = void 0,
	        s1 = void 0,
	        s2 = void 0,
	        s3 = void 0;
	    var inputWords0 = void 0,
	        inputWords1 = void 0,
	        inputWords2 = void 0,
	        inputWords3 = void 0;
	
	    var ksRow, i;
	    var swapWord = this.networkToHostOrderSwap;
	
	    while (offset < inputInt32.length) {
	      inputWords0 = swapWord(inputInt32[offset]);
	      inputWords1 = swapWord(inputInt32[offset + 1]);
	      inputWords2 = swapWord(inputInt32[offset + 2]);
	      inputWords3 = swapWord(inputInt32[offset + 3]);
	
	      s0 = inputWords0 ^ invKeySchedule[0];
	      s1 = inputWords3 ^ invKeySchedule[1];
	      s2 = inputWords2 ^ invKeySchedule[2];
	      s3 = inputWords1 ^ invKeySchedule[3];
	
	      ksRow = 4;
	
	      // Iterate through the rounds of decryption
	      for (i = 1; i < nRounds; i++) {
	        t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
	        t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
	        t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
	        t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
	        // Update state
	        s0 = t0;
	        s1 = t1;
	        s2 = t2;
	        s3 = t3;
	
	        ksRow = ksRow + 4;
	      }
	
	      // Shift rows, sub bytes, add round key
	      t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
	      t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
	      t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
	      t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
	      ksRow = ksRow + 3;
	
	      // Write
	      outputInt32[offset] = swapWord(t0 ^ initVector0);
	      outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
	      outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
	      outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
	
	      // reset initVector to last 4 unsigned int
	      initVector0 = inputWords0;
	      initVector1 = inputWords1;
	      initVector2 = inputWords2;
	      initVector3 = inputWords3;
	
	      offset = offset + 4;
	    }
	
	    return outputInt32.buffer;
	  };
	
	  AESDecryptor.prototype.destroy = function destroy() {
	    this.key = undefined;
	    this.keySize = undefined;
	    this.ksRows = undefined;
	
	    this.sBox = undefined;
	    this.invSBox = undefined;
	    this.subMix = undefined;
	    this.invSubMix = undefined;
	    this.keySchedule = undefined;
	    this.invKeySchedule = undefined;
	
	    this.rcon = undefined;
	  };
	
	  return AESDecryptor;
	}();
	
	/* harmony default export */ var aes_decryptor = (AESDecryptor);
	// EXTERNAL MODULE: ./src/errors.js
	var errors = __webpack_require__(2);
	
	// EXTERNAL MODULE: ./src/utils/logger.js
	var logger = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./src/crypt/decrypter.js
	function decrypter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	
	
	
	/*globals self: false */
	
	var decrypter_Decrypter = function () {
	  function Decrypter(observer, config) {
	    decrypter__classCallCheck(this, Decrypter);
	
	    this.observer = observer;
	    this.config = config;
	    this.logEnabled = true;
	    try {
	      var browserCrypto = crypto ? crypto : self.crypto;
	      this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
	    } catch (e) {}
	    this.disableWebCrypto = !this.subtle;
	  }
	
	  Decrypter.prototype.isSync = function isSync() {
	    return this.disableWebCrypto && this.config.enableSoftwareAES;
	  };
	
	  Decrypter.prototype.decrypt = function decrypt(data, key, iv, callback) {
	    var _this = this;
	
	    if (this.disableWebCrypto && this.config.enableSoftwareAES) {
	      if (this.logEnabled) {
	        logger["b" /* logger */].log('JS AES decrypt');
	        this.logEnabled = false;
	      }
	      var decryptor = this.decryptor;
	      if (!decryptor) {
	        this.decryptor = decryptor = new aes_decryptor();
	      }
	      decryptor.expandKey(key);
	      callback(decryptor.decrypt(data, 0, iv));
	    } else {
	      if (this.logEnabled) {
	        logger["b" /* logger */].log('WebCrypto AES decrypt');
	        this.logEnabled = false;
	      }
	      var subtle = this.subtle;
	      if (this.key !== key) {
	        this.key = key;
	        this.fastAesKey = new fast_aes_key(subtle, key);
	      }
	
	      this.fastAesKey.expandKey().then(function (aesKey) {
	        // decrypt using web crypto
	        var crypto = new aes_crypto(subtle, iv);
	        crypto.decrypt(data, aesKey).catch(function (err) {
	          _this.onWebCryptoError(err, data, key, iv, callback);
	        }).then(function (result) {
	          callback(result);
	        });
	      }).catch(function (err) {
	        _this.onWebCryptoError(err, data, key, iv, callback);
	      });
	    }
	  };
	
	  Decrypter.prototype.onWebCryptoError = function onWebCryptoError(err, data, key, iv, callback) {
	    if (this.config.enableSoftwareAES) {
	      logger["b" /* logger */].log('WebCrypto Error, disable WebCrypto API');
	      this.disableWebCrypto = true;
	      this.logEnabled = true;
	      this.decrypt(data, key, iv, callback);
	    } else {
	      logger["b" /* logger */].error('decrypting error : ' + err.message);
	      this.observer.trigger(Event.ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_DECRYPT_ERROR, fatal: true, reason: err.message });
	    }
	  };
	
	  Decrypter.prototype.destroy = function destroy() {
	    var decryptor = this.decryptor;
	    if (decryptor) {
	      decryptor.destroy();
	      this.decryptor = undefined;
	    }
	  };
	
	  return Decrypter;
	}();
	
	/* harmony default export */ var decrypter = __webpack_exports__["a"] = (decrypter_Decrypter);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// see https://tools.ietf.org/html/rfc1808
	
	/* jshint ignore:start */
	(function(root) { 
	/* jshint ignore:end */
	
	  var URL_REGEX = /^((?:[^\/;?#]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
	  var FIRST_SEGMENT_REGEX = /^([^\/;?#]*)(.*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;
	
	  var URLToolkit = { // jshint ignore:line
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (default, not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = this.parseURL(baseURL);
	        if (!baseParts) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = this.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = this.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function(url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || ''
	      };
	    },
	    normalizePath: function(path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function(parts) {
	      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
	    }
	  };
	
	/* jshint ignore:start */
	  if(true)
	    module.exports = URLToolkit;
	  else if(typeof define === 'function' && define.amd)
	    define([], function() { return URLToolkit; });
	  else if(typeof exports === 'object')
	    exports["URLToolkit"] = URLToolkit;
	  else
	    root["URLToolkit"] = URLToolkit;
	})(this);
	/* jshint ignore:end */
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// EXTERNAL MODULE: ./src/events.js
	var events = __webpack_require__(1);
	
	// EXTERNAL MODULE: ./src/errors.js
	var errors = __webpack_require__(2);
	
	// EXTERNAL MODULE: ./src/crypt/decrypter.js + 3 modules
	var crypt_decrypter = __webpack_require__(4);
	
	// EXTERNAL MODULE: ./src/utils/logger.js
	var logger = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./src/demux/adts.js
	/**
	 *  ADTS parser helper
	 */
	
	
	
	function getAudioConfig(observer, data, offset, audioCodec) {
	  var adtsObjectType,
	      // :int
	  adtsSampleingIndex,
	      // :int
	  adtsExtensionSampleingIndex,
	      // :int
	  adtsChanelConfig,
	      // :int
	  config,
	      userAgent = navigator.userAgent.toLowerCase(),
	      manifestCodec = audioCodec,
	      adtsSampleingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	  // byte 2
	  adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
	  adtsSampleingIndex = (data[offset + 2] & 0x3C) >>> 2;
	  if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
	    observer.trigger(Event.ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: true, reason: 'invalid ADTS sampling index:' + adtsSampleingIndex });
	    return;
	  }
	  adtsChanelConfig = (data[offset + 2] & 0x01) << 2;
	  // byte 3
	  adtsChanelConfig |= (data[offset + 3] & 0xC0) >>> 6;
	  logger["b" /* logger */].log('manifest codec:' + audioCodec + ',ADTS data:type:' + adtsObjectType + ',sampleingIndex:' + adtsSampleingIndex + '[' + adtsSampleingRates[adtsSampleingIndex] + 'Hz],channelConfig:' + adtsChanelConfig);
	  // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
	  if (/firefox/i.test(userAgent)) {
	    if (adtsSampleingIndex >= 6) {
	      adtsObjectType = 5;
	      config = new Array(4);
	      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
	      // there is a factor 2 between frame sample rate and output sample rate
	      // multiply frequency by 2 (see table below, equivalent to substract 3)
	      adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
	    } else {
	      adtsObjectType = 2;
	      config = new Array(2);
	      adtsExtensionSampleingIndex = adtsSampleingIndex;
	    }
	    // Android : always use AAC
	  } else if (userAgent.indexOf('android') !== -1) {
	    adtsObjectType = 2;
	    config = new Array(2);
	    adtsExtensionSampleingIndex = adtsSampleingIndex;
	  } else {
	    /*  for other browsers (Chrome/Vivaldi/Opera ...)
	        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
	    */
	    adtsObjectType = 5;
	    config = new Array(4);
	    // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
	    if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSampleingIndex >= 6) {
	      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
	      // there is a factor 2 between frame sample rate and output sample rate
	      // multiply frequency by 2 (see table below, equivalent to substract 3)
	      adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
	    } else {
	      // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
	      // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
	      if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSampleingIndex >= 6 && adtsChanelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChanelConfig === 1) {
	        adtsObjectType = 2;
	        config = new Array(2);
	      }
	      adtsExtensionSampleingIndex = adtsSampleingIndex;
	    }
	  }
	  /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
	      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
	    Audio Profile / Audio Object Type
	    0: Null
	    1: AAC Main
	    2: AAC LC (Low Complexity)
	    3: AAC SSR (Scalable Sample Rate)
	    4: AAC LTP (Long Term Prediction)
	    5: SBR (Spectral Band Replication)
	    6: AAC Scalable
	   sampling freq
	    0: 96000 Hz
	    1: 88200 Hz
	    2: 64000 Hz
	    3: 48000 Hz
	    4: 44100 Hz
	    5: 32000 Hz
	    6: 24000 Hz
	    7: 22050 Hz
	    8: 16000 Hz
	    9: 12000 Hz
	    10: 11025 Hz
	    11: 8000 Hz
	    12: 7350 Hz
	    13: Reserved
	    14: Reserved
	    15: frequency is written explictly
	    Channel Configurations
	    These are the channel configurations:
	    0: Defined in AOT Specifc Config
	    1: 1 channel: front-center
	    2: 2 channels: front-left, front-right
	  */
	  // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
	  config[0] = adtsObjectType << 3;
	  // samplingFrequencyIndex
	  config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
	  config[1] |= (adtsSampleingIndex & 0x01) << 7;
	  // channelConfiguration
	  config[1] |= adtsChanelConfig << 3;
	  if (adtsObjectType === 5) {
	    // adtsExtensionSampleingIndex
	    config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
	    config[2] = (adtsExtensionSampleingIndex & 0x01) << 7;
	    // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
	    //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
	    config[2] |= 2 << 2;
	    config[3] = 0;
	  }
	  return { config: config, samplerate: adtsSampleingRates[adtsSampleingIndex], channelCount: adtsChanelConfig, codec: 'mp4a.40.' + adtsObjectType, manifestCodec: manifestCodec };
	}
	
	function isHeaderPattern(data, offset) {
	  return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
	}
	
	function getHeaderLength(data, offset) {
	  return !!(data[offset + 1] & 0x01) ? 7 : 9;
	}
	
	function getFullFrameLength(data, offset) {
	  return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xE0) >>> 5;
	}
	
	function isHeader(data, offset) {
	  // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
	  // Layer bits (position 14 and 15) in header should be always 0 for ADTS
	  // More info https://wiki.multimedia.cx/index.php?title=ADTS
	  if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
	    return true;
	  }
	  return false;
	}
	
	function adts_probe(data, offset) {
	  // same as isHeader but we also check that ADTS frame follows last ADTS frame
	  // or end of data is reached
	  if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
	    // ADTS header Length
	    var headerLength = getHeaderLength(data, offset);
	    // ADTS frame Length
	    var frameLength = headerLength;
	    if (offset + 5 < data.length) {
	      frameLength = getFullFrameLength(data, offset);
	    }
	    var newOffset = offset + frameLength;
	    if (newOffset === data.length || newOffset + 1 < data.length && isHeaderPattern(data, newOffset)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function initTrackConfig(track, observer, data, offset, audioCodec) {
	  if (!track.samplerate) {
	    var config = getAudioConfig(observer, data, offset, audioCodec);
	    track.config = config.config;
	    track.samplerate = config.samplerate;
	    track.channelCount = config.channelCount;
	    track.codec = config.codec;
	    track.manifestCodec = config.manifestCodec;
	    logger["b" /* logger */].log('parsed codec:' + track.codec + ',rate:' + config.samplerate + ',nb channel:' + config.channelCount);
	  }
	}
	
	function getFrameDuration(samplerate) {
	  return 1024 * 90000 / samplerate;
	}
	
	function parseFrameHeader(data, offset, pts, frameIndex, frameDuration) {
	  var headerLength, frameLength, stamp;
	  var length = data.length;
	
	  // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
	  headerLength = getHeaderLength(data, offset);
	  // retrieve frame size
	  frameLength = getFullFrameLength(data, offset);
	  frameLength -= headerLength;
	
	  if (frameLength > 0 && offset + headerLength + frameLength <= length) {
	    stamp = pts + frameIndex * frameDuration;
	    //logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
	    return { headerLength: headerLength, frameLength: frameLength, stamp: stamp };
	  }
	
	  return undefined;
	}
	
	function appendFrame(track, data, offset, pts, frameIndex) {
	  var frameDuration = getFrameDuration(track.samplerate);
	  var header = parseFrameHeader(data, offset, pts, frameIndex, frameDuration);
	  if (header) {
	    var stamp = header.stamp;
	    var headerLength = header.headerLength;
	    var frameLength = header.frameLength;
	
	    //logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
	    var aacSample = {
	      unit: data.subarray(offset + headerLength, offset + headerLength + frameLength),
	      pts: stamp,
	      dts: stamp
	    };
	
	    track.samples.push(aacSample);
	    track.len += frameLength;
	
	    return { sample: aacSample, length: frameLength + headerLength };
	  }
	
	  return undefined;
	}
	// EXTERNAL MODULE: ./src/demux/id3.js
	var id3 = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./src/demux/aacdemuxer.js
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * AAC demuxer
	 */
	
	
	
	
	var aacdemuxer_AACDemuxer = function () {
	  function AACDemuxer(observer, remuxer, config) {
	    _classCallCheck(this, AACDemuxer);
	
	    this.observer = observer;
	    this.config = config;
	    this.remuxer = remuxer;
	  }
	
	  AACDemuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
	    this._audioTrack = { container: 'audio/adts', type: 'audio', id: 0, sequenceNumber: 0, isAAC: true, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
	  };
	
	  AACDemuxer.prototype.resetTimeStamp = function resetTimeStamp() {};
	
	  AACDemuxer.probe = function probe(data) {
	    if (!data) {
	      return false;
	    }
	    // Check for the ADTS sync word
	    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
	    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
	    // More info https://wiki.multimedia.cx/index.php?title=ADTS
	    var id3Data = id3["a" /* default */].getID3Data(data, 0) || [];
	    var offset = id3Data.length;
	
	    for (var length = data.length; offset < length; offset++) {
	      if (adts_probe(data, offset)) {
	        logger["b" /* logger */].log('ADTS sync word found !');
	        return true;
	      }
	    }
	    return false;
	  };
	
	  // feed incoming data to the front of the parsing pipeline
	
	
	  AACDemuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
	    var track = this._audioTrack;
	    var id3Data = id3["a" /* default */].getID3Data(data, 0) || [];
	    var timestamp = id3["a" /* default */].getTimeStamp(id3Data);
	    var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
	    var frameIndex = 0;
	    var stamp = pts;
	    var length = data.length;
	    var offset = id3Data.length;
	
	    var id3Samples = [{ pts: stamp, dts: stamp, data: id3Data }];
	
	    while (offset < length - 1) {
	      if (isHeader(data, offset) && offset + 5 < length) {
	        initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
	        var frame = appendFrame(track, data, offset, pts, frameIndex);
	        if (frame) {
	          offset += frame.length;
	          stamp = frame.sample.pts;
	          frameIndex++;
	        } else {
	          logger["b" /* logger */].log('Unable to parse AAC frame');
	          break;
	        }
	      } else if (id3["a" /* default */].isHeader(data, offset)) {
	        id3Data = id3["a" /* default */].getID3Data(data, offset);
	        id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
	        offset += id3Data.length;
	      } else {
	        //nothing found, keep looking
	        offset++;
	      }
	    }
	
	    this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
	  };
	
	  AACDemuxer.prototype.destroy = function destroy() {};
	
	  return AACDemuxer;
	}();
	
	/* harmony default export */ var aacdemuxer = (aacdemuxer_AACDemuxer);
	// CONCATENATED MODULE: ./src/demux/mp4demuxer.js
	function mp4demuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * MP4 demuxer
	 */
	
	
	
	var UINT32_MAX = Math.pow(2, 32) - 1;
	
	var mp4demuxer_MP4Demuxer = function () {
	  function MP4Demuxer(observer, remuxer) {
	    mp4demuxer__classCallCheck(this, MP4Demuxer);
	
	    this.observer = observer;
	    this.remuxer = remuxer;
	  }
	
	  MP4Demuxer.prototype.resetTimeStamp = function resetTimeStamp(initPTS) {
	    this.initPTS = initPTS;
	  };
	
	  MP4Demuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
	    //jshint unused:false
	    if (initSegment && initSegment.byteLength) {
	      var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment);
	
	      // default audio codec if nothing specified
	      // TODO : extract that from initsegment
	      if (audioCodec == null) {
	        audioCodec = 'mp4a.40.5';
	      }
	      if (videoCodec == null) {
	        videoCodec = 'avc1.42e01e';
	      }
	      var tracks = {};
	      if (initData.audio && initData.video) {
	        tracks.audiovideo = { container: 'video/mp4', codec: audioCodec + ',' + videoCodec, initSegment: duration ? initSegment : null };
	      } else {
	        if (initData.audio) {
	          tracks.audio = { container: 'audio/mp4', codec: audioCodec, initSegment: duration ? initSegment : null };
	        }
	        if (initData.video) {
	          tracks.video = { container: 'video/mp4', codec: videoCodec, initSegment: duration ? initSegment : null };
	        }
	      }
	      this.observer.trigger(events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, { tracks: tracks });
	    } else {
	      if (audioCodec) {
	        this.audioCodec = audioCodec;
	      }
	      if (videoCodec) {
	        this.videoCodec = videoCodec;
	      }
	    }
	  };
	
	  MP4Demuxer.probe = function probe(data) {
	    // ensure we find a moof box in the first 16 kB
	    return MP4Demuxer.findBox({ data: data, start: 0, end: Math.min(data.length, 16384) }, ['moof']).length > 0;
	  };
	
	  MP4Demuxer.bin2str = function bin2str(buffer) {
	    return String.fromCharCode.apply(null, buffer);
	  };
	
	  MP4Demuxer.readUint32 = function readUint32(buffer, offset) {
	    if (buffer.data) {
	      offset += buffer.start;
	      buffer = buffer.data;
	    }
	
	    var val = buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
	    return val < 0 ? 4294967296 + val : val;
	  };
	
	  MP4Demuxer.writeUint32 = function writeUint32(buffer, offset, value) {
	    if (buffer.data) {
	      offset += buffer.start;
	      buffer = buffer.data;
	    }
	    buffer[offset] = value >> 24;
	    buffer[offset + 1] = value >> 16 & 0xff;
	    buffer[offset + 2] = value >> 8 & 0xff;
	    buffer[offset + 3] = value & 0xff;
	  };
	
	  // Find the data for a box specified by its path
	
	
	  MP4Demuxer.findBox = function findBox(data, path) {
	    var results = [],
	        i,
	        size,
	        type,
	        end,
	        subresults,
	        start,
	        endbox;
	
	    if (data.data) {
	      start = data.start;
	      end = data.end;
	      data = data.data;
	    } else {
	      start = 0;
	      end = data.byteLength;
	    }
	
	    if (!path.length) {
	      // short-circuit the search for empty paths
	      return null;
	    }
	
	    for (i = start; i < end;) {
	      size = MP4Demuxer.readUint32(data, i);
	      type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));
	      endbox = size > 1 ? i + size : end;
	
	      if (type === path[0]) {
	
	        if (path.length === 1) {
	          // this is the end of the path and we've found the box we were
	          // looking for
	          results.push({ data: data, start: i + 8, end: endbox });
	        } else {
	          // recursively search for the next box along the path
	          subresults = MP4Demuxer.findBox({ data: data, start: i + 8, end: endbox }, path.slice(1));
	          if (subresults.length) {
	            results = results.concat(subresults);
	          }
	        }
	      }
	      i = endbox;
	    }
	
	    // we've finished searching all of data
	    return results;
	  };
	
	  /**
	   * Parses an MP4 initialization segment and extracts stream type and
	   * timescale values for any declared tracks. Timescale values indicate the
	   * number of clock ticks per second to assume for time-based values
	   * elsewhere in the MP4.
	   *
	   * To determine the start time of an MP4, you need two pieces of
	   * information: the timescale unit and the earliest base media decode
	   * time. Multiple timescales can be specified within an MP4 but the
	   * base media decode time is always expressed in the timescale from
	   * the media header box for the track:
	   * ```
	   * moov > trak > mdia > mdhd.timescale
	   * moov > trak > mdia > hdlr
	   * ```
	   * @param init {Uint8Array} the bytes of the init segment
	   * @return {object} a hash of track type to timescale values or null if
	   * the init segment is malformed.
	   */
	
	
	  MP4Demuxer.parseInitSegment = function parseInitSegment(initSegment) {
	    var result = [];
	    var traks = MP4Demuxer.findBox(initSegment, ['moov', 'trak']);
	
	    traks.forEach(function (trak) {
	      var tkhd = MP4Demuxer.findBox(trak, ['tkhd'])[0];
	      if (tkhd) {
	        var version = tkhd.data[tkhd.start];
	        var index = version === 0 ? 12 : 20;
	        var trackId = MP4Demuxer.readUint32(tkhd, index);
	
	        var mdhd = MP4Demuxer.findBox(trak, ['mdia', 'mdhd'])[0];
	        if (mdhd) {
	          version = mdhd.data[mdhd.start];
	          index = version === 0 ? 12 : 20;
	          var timescale = MP4Demuxer.readUint32(mdhd, index);
	
	          var hdlr = MP4Demuxer.findBox(trak, ['mdia', 'hdlr'])[0];
	          if (hdlr) {
	            var hdlrType = MP4Demuxer.bin2str(hdlr.data.subarray(hdlr.start + 8, hdlr.start + 12));
	            var type = { 'soun': 'audio', 'vide': 'video' }[hdlrType];
	            if (type) {
	              // extract codec info. TODO : parse codec details to be able to build MIME type
	              var codecBox = MP4Demuxer.findBox(trak, ['mdia', 'minf', 'stbl', 'stsd']);
	              if (codecBox.length) {
	                codecBox = codecBox[0];
	                var codecType = MP4Demuxer.bin2str(codecBox.data.subarray(codecBox.start + 12, codecBox.start + 16));
	                logger["b" /* logger */].log('MP4Demuxer:' + type + ':' + codecType + ' found');
	              }
	              result[trackId] = { timescale: timescale, type: type };
	              result[type] = { timescale: timescale, id: trackId };
	            }
	          }
	        }
	      }
	    });
	    return result;
	  };
	
	  /**
	   * Determine the base media decode start time, in seconds, for an MP4
	   * fragment. If multiple fragments are specified, the earliest time is
	   * returned.
	   *
	   * The base media decode time can be parsed from track fragment
	   * metadata:
	   * ```
	   * moof > traf > tfdt.baseMediaDecodeTime
	   * ```
	   * It requires the timescale value from the mdhd to interpret.
	   *
	   * @param timescale {object} a hash of track ids to timescale values.
	   * @return {number} the earliest base media decode start time for the
	   * fragment, in seconds
	   */
	
	
	  MP4Demuxer.getStartDTS = function getStartDTS(initData, fragment) {
	    var trafs, baseTimes, result;
	
	    // we need info from two childrend of each track fragment box
	    trafs = MP4Demuxer.findBox(fragment, ['moof', 'traf']);
	
	    // determine the start times for each track
	    baseTimes = [].concat.apply([], trafs.map(function (traf) {
	      return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
	        var id, scale, baseTime;
	
	        // get the track id from the tfhd
	        id = MP4Demuxer.readUint32(tfhd, 4);
	        // assume a 90kHz clock if no timescale was specified
	        scale = initData[id].timescale || 90e3;
	
	        // get the base media decode time from the tfdt
	        baseTime = MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
	          var version, result;
	
	          version = tfdt.data[tfdt.start];
	          result = MP4Demuxer.readUint32(tfdt, 4);
	          if (version === 1) {
	            result *= Math.pow(2, 32);
	
	            result += MP4Demuxer.readUint32(tfdt, 8);
	          }
	          return result;
	        })[0];
	        // convert base time to seconds
	        return baseTime / scale;
	      });
	    }));
	
	    // return the minimum
	    result = Math.min.apply(null, baseTimes);
	    return isFinite(result) ? result : 0;
	  };
	
	  MP4Demuxer.offsetStartDTS = function offsetStartDTS(initData, fragment, timeOffset) {
	    MP4Demuxer.findBox(fragment, ['moof', 'traf']).map(function (traf) {
	      return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
	        // get the track id from the tfhd
	        var id = MP4Demuxer.readUint32(tfhd, 4);
	        // assume a 90kHz clock if no timescale was specified
	        var timescale = initData[id].timescale || 90e3;
	
	        // get the base media decode time from the tfdt
	        MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
	          var version = tfdt.data[tfdt.start];
	          var baseMediaDecodeTime = MP4Demuxer.readUint32(tfdt, 4);
	          if (version === 0) {
	            MP4Demuxer.writeUint32(tfdt, 4, baseMediaDecodeTime - timeOffset * timescale);
	          } else {
	            baseMediaDecodeTime *= Math.pow(2, 32);
	            baseMediaDecodeTime += MP4Demuxer.readUint32(tfdt, 8);
	            baseMediaDecodeTime -= timeOffset * timescale;
	            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
	            var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
	            var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
	            MP4Demuxer.writeUint32(tfdt, 4, upper);
	            MP4Demuxer.writeUint32(tfdt, 8, lower);
	          }
	        });
	      });
	    });
	  };
	
	  // feed incoming data to the front of the parsing pipeline
	
	
	  MP4Demuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
	    var initData = this.initData;
	    if (!initData) {
	      this.resetInitSegment(data, this.audioCodec, this.videoCodec);
	      initData = this.initData;
	    }
	    var startDTS = void 0,
	        initPTS = this.initPTS;
	    if (initPTS === undefined) {
	      var _startDTS = MP4Demuxer.getStartDTS(initData, data);
	      this.initPTS = initPTS = _startDTS - timeOffset;
	      this.observer.trigger(events["a" /* default */].INIT_PTS_FOUND, { initPTS: initPTS });
	    }
	    MP4Demuxer.offsetStartDTS(initData, data, initPTS);
	    startDTS = MP4Demuxer.getStartDTS(initData, data);
	    this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
	  };
	
	  MP4Demuxer.prototype.destroy = function destroy() {};
	
	  return MP4Demuxer;
	}();
	
	/* harmony default export */ var mp4demuxer = (mp4demuxer_MP4Demuxer);
	// CONCATENATED MODULE: ./src/demux/mpegaudio.js
	/**
	 *  MPEG parser helper
	 */
	
	var MpegAudio = {
	
	    BitratesMap: [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],
	
	    SamplingRateMap: [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000],
	
	    SamplesCoefficients: [
	    // MPEG 2.5
	    [0, // Reserved
	    72, // Layer3
	    144, // Layer2
	    12 // Layer1
	    ],
	    // Reserved
	    [0, // Reserved
	    0, // Layer3
	    0, // Layer2
	    0 // Layer1
	    ],
	    // MPEG 2
	    [0, // Reserved
	    72, // Layer3
	    144, // Layer2
	    12 // Layer1
	    ],
	    // MPEG 1
	    [0, // Reserved
	    144, // Layer3
	    144, // Layer2
	    12 // Layer1
	    ]],
	
	    BytesInSlot: [0, // Reserved
	    1, // Layer3
	    1, // Layer2
	    4 // Layer1
	    ],
	
	    appendFrame: function appendFrame(track, data, offset, pts, frameIndex) {
	        // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
	        if (offset + 24 > data.length) {
	            return undefined;
	        }
	
	        var header = this.parseHeader(data, offset);
	        if (header && offset + header.frameLength <= data.length) {
	            var frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
	            var stamp = pts + frameIndex * frameDuration;
	            var sample = { unit: data.subarray(offset, offset + header.frameLength), pts: stamp, dts: stamp };
	
	            track.config = [];
	            track.channelCount = header.channelCount;
	            track.samplerate = header.sampleRate;
	            track.samples.push(sample);
	            track.len += header.frameLength;
	
	            return { sample: sample, length: header.frameLength };
	        }
	
	        return undefined;
	    },
	
	    parseHeader: function parseHeader(data, offset) {
	        var headerB = data[offset + 1] >> 3 & 3;
	        var headerC = data[offset + 1] >> 1 & 3;
	        var headerE = data[offset + 2] >> 4 & 15;
	        var headerF = data[offset + 2] >> 2 & 3;
	        var headerG = data[offset + 2] >> 1 & 1;
	        if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
	            var columnInBitrates = headerB === 3 ? 3 - headerC : headerC === 3 ? 3 : 4;
	            var bitRate = MpegAudio.BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
	            var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
	            var sampleRate = MpegAudio.SamplingRateMap[columnInSampleRates * 3 + headerF];
	            var channelCount = data[offset + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
	            var sampleCoefficient = MpegAudio.SamplesCoefficients[headerB][headerC];
	            var bytesInSlot = MpegAudio.BytesInSlot[headerC];
	            var samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
	            var frameLength = parseInt(sampleCoefficient * bitRate / sampleRate + headerG, 10) * bytesInSlot;
	
	            return { sampleRate: sampleRate, channelCount: channelCount, frameLength: frameLength, samplesPerFrame: samplesPerFrame };
	        }
	
	        return undefined;
	    },
	
	    isHeaderPattern: function isHeaderPattern(data, offset) {
	        return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
	    },
	
	    isHeader: function isHeader(data, offset) {
	        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
	        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
	        // More info http://www.mp3-tech.org/programmer/frame_header.html
	        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
	            return true;
	        }
	        return false;
	    },
	
	    probe: function probe(data, offset) {
	        // same as isHeader but we also check that MPEG frame follows last MPEG frame
	        // or end of data is reached
	        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
	            // MPEG header Length
	            var headerLength = 4;
	            // MPEG frame Length
	            var header = this.parseHeader(data, offset);
	            var frameLength = headerLength;
	            if (header && header.frameLength) {
	                frameLength = header.frameLength;
	            }
	            var newOffset = offset + frameLength;
	            if (newOffset === data.length || newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset)) {
	                return true;
	            }
	        }
	        return false;
	    }
	};
	
	/* harmony default export */ var mpegaudio = (MpegAudio);
	// CONCATENATED MODULE: ./src/demux/exp-golomb.js
	function exp_golomb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
	*/
	
	
	
	var exp_golomb_ExpGolomb = function () {
	  function ExpGolomb(data) {
	    exp_golomb__classCallCheck(this, ExpGolomb);
	
	    this.data = data;
	    // the number of bytes left to examine in this.data
	    this.bytesAvailable = data.byteLength;
	    // the current word being examined
	    this.word = 0; // :uint
	    // the number of bits left to examine in the current word
	    this.bitsAvailable = 0; // :uint
	  }
	
	  // ():void
	
	
	  ExpGolomb.prototype.loadWord = function loadWord() {
	    var data = this.data,
	        bytesAvailable = this.bytesAvailable,
	        position = data.byteLength - bytesAvailable,
	        workingBytes = new Uint8Array(4),
	        availableBytes = Math.min(4, bytesAvailable);
	    if (availableBytes === 0) {
	      throw new Error('no bytes available');
	    }
	    workingBytes.set(data.subarray(position, position + availableBytes));
	    this.word = new DataView(workingBytes.buffer).getUint32(0);
	    // track the amount of this.data that has been processed
	    this.bitsAvailable = availableBytes * 8;
	    this.bytesAvailable -= availableBytes;
	  };
	
	  // (count:int):void
	
	
	  ExpGolomb.prototype.skipBits = function skipBits(count) {
	    var skipBytes; // :int
	    if (this.bitsAvailable > count) {
	      this.word <<= count;
	      this.bitsAvailable -= count;
	    } else {
	      count -= this.bitsAvailable;
	      skipBytes = count >> 3;
	      count -= skipBytes >> 3;
	      this.bytesAvailable -= skipBytes;
	      this.loadWord();
	      this.word <<= count;
	      this.bitsAvailable -= count;
	    }
	  };
	
	  // (size:int):uint
	
	
	  ExpGolomb.prototype.readBits = function readBits(size) {
	    var bits = Math.min(this.bitsAvailable, size),
	        // :uint
	    valu = this.word >>> 32 - bits; // :uint
	    if (size > 32) {
	      logger["b" /* logger */].error('Cannot read more than 32 bits at a time');
	    }
	    this.bitsAvailable -= bits;
	    if (this.bitsAvailable > 0) {
	      this.word <<= bits;
	    } else if (this.bytesAvailable > 0) {
	      this.loadWord();
	    }
	    bits = size - bits;
	    if (bits > 0 && this.bitsAvailable) {
	      return valu << bits | this.readBits(bits);
	    } else {
	      return valu;
	    }
	  };
	
	  // ():uint
	
	
	  ExpGolomb.prototype.skipLZ = function skipLZ() {
	    var leadingZeroCount; // :uint
	    for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
	      if (0 !== (this.word & 0x80000000 >>> leadingZeroCount)) {
	        // the first bit of working word is 1
	        this.word <<= leadingZeroCount;
	        this.bitsAvailable -= leadingZeroCount;
	        return leadingZeroCount;
	      }
	    }
	    // we exhausted word and still have not found a 1
	    this.loadWord();
	    return leadingZeroCount + this.skipLZ();
	  };
	
	  // ():void
	
	
	  ExpGolomb.prototype.skipUEG = function skipUEG() {
	    this.skipBits(1 + this.skipLZ());
	  };
	
	  // ():void
	
	
	  ExpGolomb.prototype.skipEG = function skipEG() {
	    this.skipBits(1 + this.skipLZ());
	  };
	
	  // ():uint
	
	
	  ExpGolomb.prototype.readUEG = function readUEG() {
	    var clz = this.skipLZ(); // :uint
	    return this.readBits(clz + 1) - 1;
	  };
	
	  // ():int
	
	
	  ExpGolomb.prototype.readEG = function readEG() {
	    var valu = this.readUEG(); // :int
	    if (0x01 & valu) {
	      // the number is odd if the low order bit is set
	      return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
	    } else {
	      return -1 * (valu >>> 1); // divide by two then make it negative
	    }
	  };
	
	  // Some convenience functions
	  // :Boolean
	
	
	  ExpGolomb.prototype.readBoolean = function readBoolean() {
	    return 1 === this.readBits(1);
	  };
	
	  // ():int
	
	
	  ExpGolomb.prototype.readUByte = function readUByte() {
	    return this.readBits(8);
	  };
	
	  // ():int
	
	
	  ExpGolomb.prototype.readUShort = function readUShort() {
	    return this.readBits(16);
	  };
	  // ():int
	
	
	  ExpGolomb.prototype.readUInt = function readUInt() {
	    return this.readBits(32);
	  };
	
	  /**
	   * Advance the ExpGolomb decoder past a scaling list. The scaling
	   * list is optionally transmitted as part of a sequence parameter
	   * set and is not relevant to transmuxing.
	   * @param count {number} the number of entries in this scaling list
	   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	   */
	
	
	  ExpGolomb.prototype.skipScalingList = function skipScalingList(count) {
	    var lastScale = 8,
	        nextScale = 8,
	        j,
	        deltaScale;
	    for (j = 0; j < count; j++) {
	      if (nextScale !== 0) {
	        deltaScale = this.readEG();
	        nextScale = (lastScale + deltaScale + 256) % 256;
	      }
	      lastScale = nextScale === 0 ? lastScale : nextScale;
	    }
	  };
	
	  /**
	   * Read a sequence parameter set and return some interesting video
	   * properties. A sequence parameter set is the H264 metadata that
	   * describes the properties of upcoming video frames.
	   * @param data {Uint8Array} the bytes of a sequence parameter set
	   * @return {object} an object with configuration parsed from the
	   * sequence parameter set, including the dimensions of the
	   * associated video frames.
	   */
	
	
	  ExpGolomb.prototype.readSPS = function readSPS() {
	    var frameCropLeftOffset = 0,
	        frameCropRightOffset = 0,
	        frameCropTopOffset = 0,
	        frameCropBottomOffset = 0,
	        profileIdc,
	        profileCompat,
	        levelIdc,
	        numRefFramesInPicOrderCntCycle,
	        picWidthInMbsMinus1,
	        picHeightInMapUnitsMinus1,
	        frameMbsOnlyFlag,
	        scalingListCount,
	        i,
	        readUByte = this.readUByte.bind(this),
	        readBits = this.readBits.bind(this),
	        readUEG = this.readUEG.bind(this),
	        readBoolean = this.readBoolean.bind(this),
	        skipBits = this.skipBits.bind(this),
	        skipEG = this.skipEG.bind(this),
	        skipUEG = this.skipUEG.bind(this),
	        skipScalingList = this.skipScalingList.bind(this);
	
	    readUByte();
	    profileIdc = readUByte(); // profile_idc
	    profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
	    skipBits(3); // reserved_zero_3bits u(3),
	    levelIdc = readUByte(); //level_idc u(8)
	    skipUEG(); // seq_parameter_set_id
	    // some profiles have more optional data we don't need
	    if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
	      var chromaFormatIdc = readUEG();
	      if (chromaFormatIdc === 3) {
	        skipBits(1); // separate_colour_plane_flag
	      }
	      skipUEG(); // bit_depth_luma_minus8
	      skipUEG(); // bit_depth_chroma_minus8
	      skipBits(1); // qpprime_y_zero_transform_bypass_flag
	      if (readBoolean()) {
	        // seq_scaling_matrix_present_flag
	        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
	        for (i = 0; i < scalingListCount; i++) {
	          if (readBoolean()) {
	            // seq_scaling_list_present_flag[ i ]
	            if (i < 6) {
	              skipScalingList(16);
	            } else {
	              skipScalingList(64);
	            }
	          }
	        }
	      }
	    }
	    skipUEG(); // log2_max_frame_num_minus4
	    var picOrderCntType = readUEG();
	    if (picOrderCntType === 0) {
	      readUEG(); //log2_max_pic_order_cnt_lsb_minus4
	    } else if (picOrderCntType === 1) {
	      skipBits(1); // delta_pic_order_always_zero_flag
	      skipEG(); // offset_for_non_ref_pic
	      skipEG(); // offset_for_top_to_bottom_field
	      numRefFramesInPicOrderCntCycle = readUEG();
	      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	        skipEG(); // offset_for_ref_frame[ i ]
	      }
	    }
	    skipUEG(); // max_num_ref_frames
	    skipBits(1); // gaps_in_frame_num_value_allowed_flag
	    picWidthInMbsMinus1 = readUEG();
	    picHeightInMapUnitsMinus1 = readUEG();
	    frameMbsOnlyFlag = readBits(1);
	    if (frameMbsOnlyFlag === 0) {
	      skipBits(1); // mb_adaptive_frame_field_flag
	    }
	    skipBits(1); // direct_8x8_inference_flag
	    if (readBoolean()) {
	      // frame_cropping_flag
	      frameCropLeftOffset = readUEG();
	      frameCropRightOffset = readUEG();
	      frameCropTopOffset = readUEG();
	      frameCropBottomOffset = readUEG();
	    }
	    var pixelRatio = [1, 1];
	    if (readBoolean()) {
	      // vui_parameters_present_flag
	      if (readBoolean()) {
	        // aspect_ratio_info_present_flag
	        var aspectRatioIdc = readUByte();
	        switch (aspectRatioIdc) {
	          case 1:
	            pixelRatio = [1, 1];break;
	          case 2:
	            pixelRatio = [12, 11];break;
	          case 3:
	            pixelRatio = [10, 11];break;
	          case 4:
	            pixelRatio = [16, 11];break;
	          case 5:
	            pixelRatio = [40, 33];break;
	          case 6:
	            pixelRatio = [24, 11];break;
	          case 7:
	            pixelRatio = [20, 11];break;
	          case 8:
	            pixelRatio = [32, 11];break;
	          case 9:
	            pixelRatio = [80, 33];break;
	          case 10:
	            pixelRatio = [18, 11];break;
	          case 11:
	            pixelRatio = [15, 11];break;
	          case 12:
	            pixelRatio = [64, 33];break;
	          case 13:
	            pixelRatio = [160, 99];break;
	          case 14:
	            pixelRatio = [4, 3];break;
	          case 15:
	            pixelRatio = [3, 2];break;
	          case 16:
	            pixelRatio = [2, 1];break;
	          case 255:
	            {
	              pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
	              break;
	            }
	        }
	      }
	    }
	    return {
	      width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
	      height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
	      pixelRatio: pixelRatio
	    };
	  };
	
	  ExpGolomb.prototype.readSliceType = function readSliceType() {
	    // skip NALu type
	    this.readUByte();
	    // discard first_mb_in_slice
	    this.readUEG();
	    // return slice_type
	    return this.readUEG();
	  };
	
	  return ExpGolomb;
	}();
	
	/* harmony default export */ var exp_golomb = (exp_golomb_ExpGolomb);
	// CONCATENATED MODULE: ./src/demux/sample-aes.js
	function sample_aes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * SAMPLE-AES decrypter
	*/
	
	
	
	var sample_aes_SampleAesDecrypter = function () {
	  function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
	    sample_aes__classCallCheck(this, SampleAesDecrypter);
	
	    this.decryptdata = decryptdata;
	    this.discardEPB = discardEPB;
	    this.decrypter = new crypt_decrypter["a" /* default */](observer, config);
	  }
	
	  SampleAesDecrypter.prototype.decryptBuffer = function decryptBuffer(encryptedData, callback) {
	    this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
	  };
	
	  // AAC - encrypt all full 16 bytes blocks starting from offset 16
	
	
	  SampleAesDecrypter.prototype.decryptAacSample = function decryptAacSample(samples, sampleIndex, callback, sync) {
	    var curUnit = samples[sampleIndex].unit;
	    var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
	    var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
	
	    var localthis = this;
	    this.decryptBuffer(encryptedBuffer, function (decryptedData) {
	      decryptedData = new Uint8Array(decryptedData);
	      curUnit.set(decryptedData, 16);
	
	      if (!sync) {
	        localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
	      }
	    });
	  };
	
	  SampleAesDecrypter.prototype.decryptAacSamples = function decryptAacSamples(samples, sampleIndex, callback) {
	    for (;; sampleIndex++) {
	      if (sampleIndex >= samples.length) {
	        callback();
	        return;
	      }
	
	      if (samples[sampleIndex].unit.length < 32) {
	        continue;
	      }
	
	      var sync = this.decrypter.isSync();
	
	      this.decryptAacSample(samples, sampleIndex, callback, sync);
	
	      if (!sync) {
	        return;
	      }
	    }
	  };
	
	  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
	
	
	  SampleAesDecrypter.prototype.getAvcEncryptedData = function getAvcEncryptedData(decodedData) {
	    var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
	    var encryptedData = new Int8Array(encryptedDataLen);
	    var outputPos = 0;
	    for (var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16) {
	      encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
	    }
	    return encryptedData;
	  };
	
	  SampleAesDecrypter.prototype.getAvcDecryptedUnit = function getAvcDecryptedUnit(decodedData, decryptedData) {
	    decryptedData = new Uint8Array(decryptedData);
	    var inputPos = 0;
	    for (var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16) {
	      decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
	    }
	    return decodedData;
	  };
	
	  SampleAesDecrypter.prototype.decryptAvcSample = function decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync) {
	    var decodedData = this.discardEPB(curUnit.data);
	    var encryptedData = this.getAvcEncryptedData(decodedData);
	    var localthis = this;
	
	    this.decryptBuffer(encryptedData.buffer, function (decryptedData) {
	      curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);
	
	      if (!sync) {
	        localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
	      }
	    });
	  };
	
	  SampleAesDecrypter.prototype.decryptAvcSamples = function decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
	    for (;; sampleIndex++, unitIndex = 0) {
	      if (sampleIndex >= samples.length) {
	        callback();
	        return;
	      }
	
	      var curUnits = samples[sampleIndex].units;
	      for (;; unitIndex++) {
	        if (unitIndex >= curUnits.length) {
	          break;
	        }
	
	        var curUnit = curUnits[unitIndex];
	        if (curUnit.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
	          continue;
	        }
	
	        var sync = this.decrypter.isSync();
	
	        this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);
	
	        if (!sync) {
	          return;
	        }
	      }
	    }
	  };
	
	  return SampleAesDecrypter;
	}();
	
	/* harmony default export */ var sample_aes = (sample_aes_SampleAesDecrypter);
	// CONCATENATED MODULE: ./src/demux/tsdemuxer.js
	function tsdemuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * highly optimized TS demuxer:
	 * parse PAT, PMT
	 * extract PES packet from audio and video PIDs
	 * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
	 * trigger the remuxer upon parsing completion
	 * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
	 * it also controls the remuxing process :
	 * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
	*/
	
	
	
	
	
	
	// import Hex from '../utils/hex';
	
	
	
	// We are using fixed track IDs for driving the MP4 remuxer
	// instead of following the TS PIDs.
	// There is no reason not to do this and some browsers/SourceBuffer-demuxers
	// may not like if there are TrackID "switches"
	// See https://github.com/video-dev/hls.js/issues/1331
	// Here we are mapping our internal track types to constant MP4 track IDs
	// With MSE currently one can only have one track of each, and we are muxing
	// whatever video/audio rendition in them.
	var RemuxerTrackIdConfig = {
	  video: 0,
	  audio: 1,
	  id3: 2,
	  text: 3
	};
	
	var tsdemuxer_TSDemuxer = function () {
	  function TSDemuxer(observer, remuxer, config, typeSupported) {
	    tsdemuxer__classCallCheck(this, TSDemuxer);
	
	    this.observer = observer;
	    this.config = config;
	    this.typeSupported = typeSupported;
	    this.remuxer = remuxer;
	    this.sampleAes = null;
	  }
	
	  TSDemuxer.prototype.setDecryptData = function setDecryptData(decryptdata) {
	    if (decryptdata != null && decryptdata.key != null && decryptdata.method === 'SAMPLE-AES') {
	      this.sampleAes = new sample_aes(this.observer, this.config, decryptdata, this.discardEPB);
	    } else {
	      this.sampleAes = null;
	    }
	  };
	
	  TSDemuxer.probe = function probe(data) {
	    var syncOffset = TSDemuxer._syncOffset(data);
	    if (syncOffset < 0) {
	      return false;
	    } else {
	      if (syncOffset) {
	        logger["b" /* logger */].warn('MPEG2-TS detected but first sync word found @ offset ' + syncOffset + ', junk ahead ?');
	      }
	      return true;
	    }
	  };
	
	  TSDemuxer._syncOffset = function _syncOffset(data) {
	    // scan 1000 first bytes
	    var scanwindow = Math.min(1000, data.length - 3 * 188);
	    var i = 0;
	    while (i < scanwindow) {
	      // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
	      if (data[i] === 0x47 && data[i + 188] === 0x47 && data[i + 2 * 188] === 0x47) {
	        return i;
	      } else {
	        i++;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * Creates a track model internal to demuxer used to drive remuxing input
	   *
	   * @param {string} type 'audio' | 'video' | 'id3' | 'text'
	   * @param {number} duration
	   * @return {object} TSDemuxer's internal track model
	   */
	
	
	  TSDemuxer.createTrack = function createTrack(type, duration) {
	    return {
	      container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
	      type: type,
	      id: RemuxerTrackIdConfig[type],
	      pid: -1,
	      inputTimeScale: 90000,
	      sequenceNumber: 0,
	      samples: [],
	      len: 0,
	      dropped: type === 'video' ? 0 : undefined,
	      isAAC: type === 'audio' ? true : undefined,
	      duration: type === 'audio' ? duration : undefined
	    };
	  };
	
	  /**
	   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start) 
	   * Resets all internal track instances of the demuxer.
	   *
	   * @override Implements generic demuxing/remuxing interface (see DemuxerInline)
	   * @param {object} initSegment
	   * @param {string} audioCodec
	   * @param {string} videoCodec
	   * @param {number} duration (in TS timescale = 90kHz)
	   */
	
	
	  TSDemuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
	    this.pmtParsed = false;
	    this._pmtId = -1;
	
	    this._avcTrack = TSDemuxer.createTrack('video', duration);
	    this._audioTrack = TSDemuxer.createTrack('audio', duration);
	    this._id3Track = TSDemuxer.createTrack('id3', duration);
	    this._txtTrack = TSDemuxer.createTrack('text', duration);
	
	    // flush any partial content
	    this.aacOverFlow = null;
	    this.aacLastPTS = null;
	    this.avcSample = null;
	    this.audioCodec = audioCodec;
	    this.videoCodec = videoCodec;
	    this._duration = duration;
	  };
	
	  /**
	   * 
	   * @override
	   */
	
	
	  TSDemuxer.prototype.resetTimeStamp = function resetTimeStamp() {};
	
	  // feed incoming data to the front of the parsing pipeline
	
	
	  TSDemuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
	    var start,
	        len = data.length,
	        stt,
	        pid,
	        atf,
	        offset,
	        pes,
	        unknownPIDs = false;
	    this.contiguous = contiguous;
	    var pmtParsed = this.pmtParsed,
	        avcTrack = this._avcTrack,
	        audioTrack = this._audioTrack,
	        id3Track = this._id3Track,
	        avcId = avcTrack.pid,
	        audioId = audioTrack.pid,
	        id3Id = id3Track.pid,
	        pmtId = this._pmtId,
	        avcData = avcTrack.pesData,
	        audioData = audioTrack.pesData,
	        id3Data = id3Track.pesData,
	        parsePAT = this._parsePAT,
	        parsePMT = this._parsePMT,
	        parsePES = this._parsePES,
	        parseAVCPES = this._parseAVCPES.bind(this),
	        parseAACPES = this._parseAACPES.bind(this),
	        parseMPEGPES = this._parseMPEGPES.bind(this),
	        parseID3PES = this._parseID3PES.bind(this);
	
	    var syncOffset = TSDemuxer._syncOffset(data);
	
	    // don't parse last TS packet if incomplete
	    len -= (len + syncOffset) % 188;
	
	    // loop through TS packets
	    for (start = syncOffset; start < len; start += 188) {
	      if (data[start] === 0x47) {
	        stt = !!(data[start + 1] & 0x40);
	        // pid is a 13-bit field starting at the last bit of TS[1]
	        pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
	        atf = (data[start + 3] & 0x30) >> 4;
	        // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
	        if (atf > 1) {
	          offset = start + 5 + data[start + 4];
	          // continue if there is only adaptation field
	          if (offset === start + 188) {
	            continue;
	          }
	        } else {
	          offset = start + 4;
	        }
	        switch (pid) {
	          case avcId:
	            if (stt) {
	              if (avcData && (pes = parsePES(avcData))) {
	                parseAVCPES(pes, false);
	              }
	              avcData = { data: [], size: 0 };
	            }
	            if (avcData) {
	              avcData.data.push(data.subarray(offset, start + 188));
	              avcData.size += start + 188 - offset;
	            }
	            break;
	          case audioId:
	            if (stt) {
	              if (audioData && (pes = parsePES(audioData))) {
	                if (audioTrack.isAAC) {
	                  parseAACPES(pes);
	                } else {
	                  parseMPEGPES(pes);
	                }
	              }
	              audioData = { data: [], size: 0 };
	            }
	            if (audioData) {
	              audioData.data.push(data.subarray(offset, start + 188));
	              audioData.size += start + 188 - offset;
	            }
	            break;
	          case id3Id:
	            if (stt) {
	              if (id3Data && (pes = parsePES(id3Data))) {
	                parseID3PES(pes);
	              }
	              id3Data = { data: [], size: 0 };
	            }
	            if (id3Data) {
	              id3Data.data.push(data.subarray(offset, start + 188));
	              id3Data.size += start + 188 - offset;
	            }
	            break;
	          case 0:
	            if (stt) {
	              offset += data[offset] + 1;
	            }
	            pmtId = this._pmtId = parsePAT(data, offset);
	            break;
	          case pmtId:
	            if (stt) {
	              offset += data[offset] + 1;
	            }
	            var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null);
	
	            // only update track id if track PID found while parsing PMT
	            // this is to avoid resetting the PID to -1 in case
	            // track PID transiently disappears from the stream
	            // this could happen in case of transient missing audio samples for example
	            // NOTE this is only the PID of the track as found in TS,
	            // but we are not using this for MP4 track IDs.
	            avcId = parsedPIDs.avc;
	            if (avcId > 0) {
	              avcTrack.pid = avcId;
	            }
	            audioId = parsedPIDs.audio;
	            if (audioId > 0) {
	              audioTrack.pid = audioId;
	              audioTrack.isAAC = parsedPIDs.isAAC;
	            }
	            id3Id = parsedPIDs.id3;
	            if (id3Id > 0) {
	              id3Track.pid = id3Id;
	            }
	            if (unknownPIDs && !pmtParsed) {
	              logger["b" /* logger */].log('reparse from beginning');
	              unknownPIDs = false;
	              // we set it to -188, the += 188 in the for loop will reset start to 0
	              start = syncOffset - 188;
	            }
	            pmtParsed = this.pmtParsed = true;
	            break;
	          case 17:
	          case 0x1fff:
	            break;
	          default:
	            unknownPIDs = true;
	            break;
	        }
	      } else {
	        this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: false, reason: 'TS packet did not start with 0x47' });
	      }
	    }
	    // try to parse last PES packets
	    if (avcData && (pes = parsePES(avcData))) {
	      parseAVCPES(pes, true);
	      avcTrack.pesData = null;
	    } else {
	      // either avcData null or PES truncated, keep it for next frag parsing
	      avcTrack.pesData = avcData;
	    }
	
	    if (audioData && (pes = parsePES(audioData))) {
	      if (audioTrack.isAAC) {
	        parseAACPES(pes);
	      } else {
	        parseMPEGPES(pes);
	      }
	      audioTrack.pesData = null;
	    } else {
	      if (audioData && audioData.size) {
	        logger["b" /* logger */].log('last AAC PES packet truncated,might overlap between fragments');
	      }
	      // either audioData null or PES truncated, keep it for next frag parsing
	      audioTrack.pesData = audioData;
	    }
	
	    if (id3Data && (pes = parsePES(id3Data))) {
	      parseID3PES(pes);
	      id3Track.pesData = null;
	    } else {
	      // either id3Data null or PES truncated, keep it for next frag parsing
	      id3Track.pesData = id3Data;
	    }
	
	    if (this.sampleAes == null) {
	      this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
	    } else {
	      this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
	    }
	  };
	
	  TSDemuxer.prototype.decryptAndRemux = function decryptAndRemux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
	    if (audioTrack.samples && audioTrack.isAAC) {
	      var localthis = this;
	      this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
	        localthis.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
	      });
	    } else {
	      this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
	    }
	  };
	
	  TSDemuxer.prototype.decryptAndRemuxAvc = function decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
	    if (videoTrack.samples) {
	      var localthis = this;
	      this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
	        localthis.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
	      });
	    } else {
	      this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
	    }
	  };
	
	  TSDemuxer.prototype.destroy = function destroy() {
	    this._initPTS = this._initDTS = undefined;
	    this._duration = 0;
	  };
	
	  TSDemuxer.prototype._parsePAT = function _parsePAT(data, offset) {
	    // skip the PSI header and parse the first PMT entry
	    return (data[offset + 10] & 0x1F) << 8 | data[offset + 11];
	    //logger.log('PMT PID:'  + this._pmtId);
	  };
	
	  TSDemuxer.prototype._parsePMT = function _parsePMT(data, offset, mpegSupported, isSampleAes) {
	    var sectionLength,
	        tableEnd,
	        programInfoLength,
	        pid,
	        result = { audio: -1, avc: -1, id3: -1, isAAC: true };
	    sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
	    tableEnd = offset + 3 + sectionLength - 4;
	    // to determine where the table is, we have to figure out how
	    // long the program info descriptors are
	    programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
	    // advance the offset to the first entry in the mapping table
	    offset += 12 + programInfoLength;
	    while (offset < tableEnd) {
	      pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
	      switch (data[offset]) {
	        case 0xcf:
	          // SAMPLE-AES AAC
	          if (!isSampleAes) {
	            logger["b" /* logger */].log('unkown stream type:' + data[offset]);
	            break;
	          }
	        /* falls through */
	
	        // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
	        case 0x0f:
	          //logger.log('AAC PID:'  + pid);
	          if (result.audio === -1) {
	            result.audio = pid;
	          }
	          break;
	
	        // Packetized metadata (ID3)
	        case 0x15:
	          //logger.log('ID3 PID:'  + pid);
	          if (result.id3 === -1) {
	            result.id3 = pid;
	          }
	          break;
	
	        case 0xdb:
	          // SAMPLE-AES AVC
	          if (!isSampleAes) {
	            logger["b" /* logger */].log('unkown stream type:' + data[offset]);
	            break;
	          }
	        /* falls through */
	
	        // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
	        case 0x1b:
	          //logger.log('AVC PID:'  + pid);
	          if (result.avc === -1) {
	            result.avc = pid;
	          }
	          break;
	
	        // ISO/IEC 11172-3 (MPEG-1 audio)
	        // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
	        case 0x03:
	        case 0x04:
	          //logger.log('MPEG PID:'  + pid);
	          if (!mpegSupported) {
	            logger["b" /* logger */].log('MPEG audio found, not supported in this browser for now');
	          } else if (result.audio === -1) {
	            result.audio = pid;
	            result.isAAC = false;
	          }
	          break;
	
	        case 0x24:
	          logger["b" /* logger */].warn('HEVC stream type found, not supported for now');
	          break;
	
	        default:
	          logger["b" /* logger */].log('unkown stream type:' + data[offset]);
	          break;
	      }
	      // move to the next table entry
	      // skip past the elementary stream descriptors, if present
	      offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
	    }
	    return result;
	  };
	
	  TSDemuxer.prototype._parsePES = function _parsePES(stream) {
	    var i = 0,
	        frag,
	        pesFlags,
	        pesPrefix,
	        pesLen,
	        pesHdrLen,
	        pesData,
	        pesPts,
	        pesDts,
	        payloadStartOffset,
	        data = stream.data;
	    // safety check
	    if (!stream || stream.size === 0) {
	      return null;
	    }
	
	    // we might need up to 19 bytes to read PES header
	    // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
	    // usually only one merge is needed (and this is rare ...)
	    while (data[0].length < 19 && data.length > 1) {
	      var newData = new Uint8Array(data[0].length + data[1].length);
	      newData.set(data[0]);
	      newData.set(data[1], data[0].length);
	      data[0] = newData;
	      data.splice(1, 1);
	    }
	    //retrieve PTS/DTS from first fragment
	    frag = data[0];
	    pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
	    if (pesPrefix === 1) {
	      pesLen = (frag[4] << 8) + frag[5];
	      // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
	      // minus 6 : PES header size
	      if (pesLen && pesLen > stream.size - 6) {
	        return null;
	      }
	      pesFlags = frag[7];
	      if (pesFlags & 0xC0) {
	        /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	            as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
	            as Bitwise operators treat their operands as a sequence of 32 bits */
	        pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
	        (frag[10] & 0xFF) * 4194304 + // 1 << 22
	        (frag[11] & 0xFE) * 16384 + // 1 << 14
	        (frag[12] & 0xFF) * 128 + // 1 << 7
	        (frag[13] & 0xFE) / 2;
	        // check if greater than 2^32 -1
	        if (pesPts > 4294967295) {
	          // decrement 2^33
	          pesPts -= 8589934592;
	        }
	        if (pesFlags & 0x40) {
	          pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
	          (frag[15] & 0xFF) * 4194304 + // 1 << 22
	          (frag[16] & 0xFE) * 16384 + // 1 << 14
	          (frag[17] & 0xFF) * 128 + // 1 << 7
	          (frag[18] & 0xFE) / 2;
	          // check if greater than 2^32 -1
	          if (pesDts > 4294967295) {
	            // decrement 2^33
	            pesDts -= 8589934592;
	          }
	          if (pesPts - pesDts > 60 * 90000) {
	            logger["b" /* logger */].warn(Math.round((pesPts - pesDts) / 90000) + 's delta between PTS and DTS, align them');
	            pesPts = pesDts;
	          }
	        } else {
	          pesDts = pesPts;
	        }
	      }
	      pesHdrLen = frag[8];
	      // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
	      payloadStartOffset = pesHdrLen + 9;
	
	      stream.size -= payloadStartOffset;
	      //reassemble PES packet
	      pesData = new Uint8Array(stream.size);
	      for (var j = 0, dataLen = data.length; j < dataLen; j++) {
	        frag = data[j];
	        var len = frag.byteLength;
	        if (payloadStartOffset) {
	          if (payloadStartOffset > len) {
	            // trim full frag if PES header bigger than frag
	            payloadStartOffset -= len;
	            continue;
	          } else {
	            // trim partial frag if PES header smaller than frag
	            frag = frag.subarray(payloadStartOffset);
	            len -= payloadStartOffset;
	            payloadStartOffset = 0;
	          }
	        }
	        pesData.set(frag, i);
	        i += len;
	      }
	      if (pesLen) {
	        // payload size : remove PES header + PES extension
	        pesLen -= pesHdrLen + 3;
	      }
	      return { data: pesData, pts: pesPts, dts: pesDts, len: pesLen };
	    } else {
	      return null;
	    }
	  };
	
	  TSDemuxer.prototype.pushAccesUnit = function pushAccesUnit(avcSample, avcTrack) {
	    if (avcSample.units.length && avcSample.frame) {
	      var samples = avcTrack.samples;
	      var nbSamples = samples.length;
	      // only push AVC sample if starting with a keyframe is not mandatory OR
	      //    if keyframe already found in this fragment OR
	      //       keyframe found in last fragment (track.sps) AND
	      //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
	      if (!this.config.forceKeyFrameOnDiscontinuity || avcSample.key === true || avcTrack.sps && (nbSamples || this.contiguous)) {
	        avcSample.id = nbSamples;
	        samples.push(avcSample);
	      } else {
	        // dropped samples, track it
	        avcTrack.dropped++;
	      }
	    }
	    if (avcSample.debug.length) {
	      logger["b" /* logger */].log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
	    }
	  };
	
	  TSDemuxer.prototype._parseAVCPES = function _parseAVCPES(pes, last) {
	    var _this = this;
	
	    //logger.log('parse new PES');
	    var track = this._avcTrack,
	        units = this._parseAVCNALu(pes.data),
	        debug = false,
	        expGolombDecoder,
	        avcSample = this.avcSample,
	        push,
	        spsfound = false,
	        i,
	        pushAccesUnit = this.pushAccesUnit.bind(this),
	        createAVCSample = function createAVCSample(key, pts, dts, debug) {
	      return { key: key, pts: pts, dts: dts, units: [], debug: debug };
	    };
	    //free pes.data to save up some memory
	    pes.data = null;
	
	    // if new NAL units found and last sample still there, let's push ...
	    // this helps parsing streams with missing AUD (only do this if AUD never found)
	    if (avcSample && units.length && !track.audFound) {
	      pushAccesUnit(avcSample, track);
	      avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
	    }
	
	    units.forEach(function (unit) {
	      switch (unit.type) {
	        //NDR
	        case 1:
	          push = true;
	          if (!avcSample) {
	            avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
	          }
	          if (debug) {
	            avcSample.debug += 'NDR ';
	          }
	          avcSample.frame = true;
	          var data = unit.data;
	          // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
	          if (spsfound && data.length > 4) {
	            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
	            var sliceType = new exp_golomb(data).readSliceType();
	            // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
	            // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
	            // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
	            // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
	            //if (sliceType === 2 || sliceType === 7) {
	            if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
	              avcSample.key = true;
	            }
	          }
	          break;
	        //IDR
	        case 5:
	          push = true;
	          // handle PES not starting with AUD
	          if (!avcSample) {
	            avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
	          }
	          if (debug) {
	            avcSample.debug += 'IDR ';
	          }
	          avcSample.key = true;
	          avcSample.frame = true;
	          break;
	        //SEI
	        case 6:
	          push = true;
	          if (debug && avcSample) {
	            avcSample.debug += 'SEI ';
	          }
	          expGolombDecoder = new exp_golomb(_this.discardEPB(unit.data));
	
	          // skip frameType
	          expGolombDecoder.readUByte();
	
	          var payloadType = 0;
	          var payloadSize = 0;
	          var endOfCaptions = false;
	          var b = 0;
	
	          while (!endOfCaptions && expGolombDecoder.bytesAvailable > 1) {
	            payloadType = 0;
	            do {
	              b = expGolombDecoder.readUByte();
	              payloadType += b;
	            } while (b === 0xFF);
	
	            // Parse payload size.
	            payloadSize = 0;
	            do {
	              b = expGolombDecoder.readUByte();
	              payloadSize += b;
	            } while (b === 0xFF);
	
	            // TODO: there can be more than one payload in an SEI packet...
	            // TODO: need to read type and size in a while loop to get them all
	            if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {
	
	              endOfCaptions = true;
	
	              var countryCode = expGolombDecoder.readUByte();
	
	              if (countryCode === 181) {
	                var providerCode = expGolombDecoder.readUShort();
	
	                if (providerCode === 49) {
	                  var userStructure = expGolombDecoder.readUInt();
	
	                  if (userStructure === 0x47413934) {
	                    var userDataType = expGolombDecoder.readUByte();
	
	                    // Raw CEA-608 bytes wrapped in CEA-708 packet
	                    if (userDataType === 3) {
	                      var firstByte = expGolombDecoder.readUByte();
	                      var secondByte = expGolombDecoder.readUByte();
	
	                      var totalCCs = 31 & firstByte;
	                      var byteArray = [firstByte, secondByte];
	
	                      for (i = 0; i < totalCCs; i++) {
	                        // 3 bytes per CC
	                        byteArray.push(expGolombDecoder.readUByte());
	                        byteArray.push(expGolombDecoder.readUByte());
	                        byteArray.push(expGolombDecoder.readUByte());
	                      }
	
	                      _this._insertSampleInOrder(_this._txtTrack.samples, { type: 3, pts: pes.pts, bytes: byteArray });
	                    }
	                  }
	                }
	              }
	            } else if (payloadSize < expGolombDecoder.bytesAvailable) {
	              for (i = 0; i < payloadSize; i++) {
	                expGolombDecoder.readUByte();
	              }
	            }
	          }
	          break;
	        //SPS
	        case 7:
	          push = true;
	          spsfound = true;
	          if (debug && avcSample) {
	            avcSample.debug += 'SPS ';
	          }
	          if (!track.sps) {
	            expGolombDecoder = new exp_golomb(unit.data);
	            var config = expGolombDecoder.readSPS();
	            track.width = config.width;
	            track.height = config.height;
	            track.pixelRatio = config.pixelRatio;
	            track.sps = [unit.data];
	            track.duration = _this._duration;
	            var codecarray = unit.data.subarray(1, 4);
	            var codecstring = 'avc1.';
	            for (i = 0; i < 3; i++) {
	              var h = codecarray[i].toString(16);
	              if (h.length < 2) {
	                h = '0' + h;
	              }
	              codecstring += h;
	            }
	            track.codec = codecstring;
	          }
	          break;
	        //PPS
	        case 8:
	          push = true;
	          if (debug && avcSample) {
	            avcSample.debug += 'PPS ';
	          }
	          if (!track.pps) {
	            track.pps = [unit.data];
	          }
	          break;
	        // AUD
	        case 9:
	          push = false;
	          track.audFound = true;
	          if (avcSample) {
	            pushAccesUnit(avcSample, track);
	          }
	          avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, debug ? 'AUD ' : '');
	          break;
	        // Filler Data
	        case 12:
	          push = false;
	          break;
	        default:
	          push = false;
	          if (avcSample) {
	            avcSample.debug += 'unknown NAL ' + unit.type + ' ';
	          }
	          break;
	      }
	      if (avcSample && push) {
	        var _units = avcSample.units;
	        _units.push(unit);
	      }
	    });
	    // if last PES packet, push samples
	    if (last && avcSample) {
	      pushAccesUnit(avcSample, track);
	      this.avcSample = null;
	    }
	  };
	
	  TSDemuxer.prototype._insertSampleInOrder = function _insertSampleInOrder(arr, data) {
	    var len = arr.length;
	    if (len > 0) {
	      if (data.pts >= arr[len - 1].pts) {
	        arr.push(data);
	      } else {
	        for (var pos = len - 1; pos >= 0; pos--) {
	          if (data.pts < arr[pos].pts) {
	            arr.splice(pos, 0, data);
	            break;
	          }
	        }
	      }
	    } else {
	      arr.push(data);
	    }
	  };
	
	  TSDemuxer.prototype._getLastNalUnit = function _getLastNalUnit() {
	    var avcSample = this.avcSample,
	        lastUnit = void 0;
	    // try to fallback to previous sample if current one is empty
	    if (!avcSample || avcSample.units.length === 0) {
	      var track = this._avcTrack,
	          samples = track.samples;
	      avcSample = samples[samples.length - 1];
	    }
	    if (avcSample) {
	      var units = avcSample.units;
	      lastUnit = units[units.length - 1];
	    }
	    return lastUnit;
	  };
	
	  TSDemuxer.prototype._parseAVCNALu = function _parseAVCNALu(array) {
	    var i = 0,
	        len = array.byteLength,
	        value,
	        overflow,
	        track = this._avcTrack,
	        state = track.naluState || 0,
	        lastState = state;
	    var units = [],
	        unit,
	        unitType,
	        lastUnitStart = -1,
	        lastUnitType;
	    //logger.log('PES:' + Hex.hexDump(array));
	
	    if (state === -1) {
	      // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
	      lastUnitStart = 0;
	      // NALu type is value read from offset 0
	      lastUnitType = array[0] & 0x1f;
	      state = 0;
	      i = 1;
	    }
	
	    while (i < len) {
	      value = array[i++];
	      // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
	      if (!state) {
	        state = value ? 0 : 1;
	        continue;
	      }
	      if (state === 1) {
	        state = value ? 0 : 2;
	        continue;
	      }
	      // here we have state either equal to 2 or 3
	      if (!value) {
	        state = 3;
	      } else if (value === 1) {
	        if (lastUnitStart >= 0) {
	          unit = { data: array.subarray(lastUnitStart, i - state - 1), type: lastUnitType };
	          //logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
	          units.push(unit);
	        } else {
	          // lastUnitStart is undefined => this is the first start code found in this PES packet
	          // first check if start code delimiter is overlapping between 2 PES packets,
	          // ie it started in last packet (lastState not zero)
	          // and ended at the beginning of this PES packet (i <= 4 - lastState)
	          var lastUnit = this._getLastNalUnit();
	          if (lastUnit) {
	            if (lastState && i <= 4 - lastState) {
	              // start delimiter overlapping between PES packets
	              // strip start delimiter bytes from the end of last NAL unit
	              // check if lastUnit had a state different from zero
	              if (lastUnit.state) {
	                // strip last bytes
	                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
	              }
	            }
	            // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
	            overflow = i - state - 1;
	            if (overflow > 0) {
	              //logger.log('first NALU found with overflow:' + overflow);
	              var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
	              tmp.set(lastUnit.data, 0);
	              tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
	              lastUnit.data = tmp;
	            }
	          }
	        }
	        // check if we can read unit type
	        if (i < len) {
	          unitType = array[i] & 0x1f;
	          //logger.log('find NALU @ offset:' + i + ',type:' + unitType);
	          lastUnitStart = i;
	          lastUnitType = unitType;
	          state = 0;
	        } else {
	          // not enough byte to read unit type. let's read it on next PES parsing
	          state = -1;
	        }
	      } else {
	        state = 0;
	      }
	    }
	    if (lastUnitStart >= 0 && state >= 0) {
	      unit = { data: array.subarray(lastUnitStart, len), type: lastUnitType, state: state };
	      units.push(unit);
	      //logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
	    }
	    // no NALu found
	    if (units.length === 0) {
	      // append pes.data to previous NAL unit
	      var _lastUnit = this._getLastNalUnit();
	      if (_lastUnit) {
	        var _tmp = new Uint8Array(_lastUnit.data.byteLength + array.byteLength);
	        _tmp.set(_lastUnit.data, 0);
	        _tmp.set(array, _lastUnit.data.byteLength);
	        _lastUnit.data = _tmp;
	      }
	    }
	    track.naluState = state;
	    return units;
	  };
	
	  /**
	   * remove Emulation Prevention bytes from a RBSP
	   */
	
	
	  TSDemuxer.prototype.discardEPB = function discardEPB(data) {
	    var length = data.byteLength,
	        EPBPositions = [],
	        i = 1,
	        newLength,
	        newData;
	
	    // Find all `Emulation Prevention Bytes`
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        EPBPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    }
	
	    // If no Emulation Prevention Bytes were found just return the original
	    // array
	    if (EPBPositions.length === 0) {
	      return data;
	    }
	
	    // Create a new array to hold the NAL unit data
	    newLength = length - EPBPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === EPBPositions[0]) {
	        // Skip this byte
	        sourceIndex++;
	        // Remove this position index
	        EPBPositions.shift();
	      }
	      newData[i] = data[sourceIndex];
	    }
	    return newData;
	  };
	
	  TSDemuxer.prototype._parseAACPES = function _parseAACPES(pes) {
	    var track = this._audioTrack,
	        data = pes.data,
	        pts = pes.pts,
	        startOffset = 0,
	        aacOverFlow = this.aacOverFlow,
	        aacLastPTS = this.aacLastPTS,
	        frameDuration,
	        frameIndex,
	        offset,
	        stamp,
	        len;
	    if (aacOverFlow) {
	      var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
	      tmp.set(aacOverFlow, 0);
	      tmp.set(data, aacOverFlow.byteLength);
	      //logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
	      data = tmp;
	    }
	    // look for ADTS header (0xFFFx)
	    for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
	      if (isHeader(data, offset)) {
	        break;
	      }
	    }
	    // if ADTS header does not start straight from the beginning of the PES payload, raise an error
	    if (offset) {
	      var reason, fatal;
	      if (offset < len - 1) {
	        reason = 'AAC PES did not start with ADTS header,offset:' + offset;
	        fatal = false;
	      } else {
	        reason = 'no ADTS header found in AAC PES';
	        fatal = true;
	      }
	      logger["b" /* logger */].warn('parsing error:' + reason);
	      this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: fatal, reason: reason });
	      if (fatal) {
	        return;
	      }
	    }
	
	    initTrackConfig(track, this.observer, data, offset, this.audioCodec);
	    frameIndex = 0;
	    frameDuration = getFrameDuration(track.samplerate);
	
	    // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
	    // first sample PTS should be equal to last sample PTS + frameDuration
	    if (aacOverFlow && aacLastPTS) {
	      var newPTS = aacLastPTS + frameDuration;
	      if (Math.abs(newPTS - pts) > 1) {
	        logger["b" /* logger */].log('AAC: align PTS for overlapping frames by ' + Math.round((newPTS - pts) / 90));
	        pts = newPTS;
	      }
	    }
	
	    //scan for aac samples
	    while (offset < len) {
	      if (isHeader(data, offset) && offset + 5 < len) {
	        var frame = appendFrame(track, data, offset, pts, frameIndex);
	        if (frame) {
	          //logger.log(`${Math.round(frame.sample.pts)} : AAC`);
	          offset += frame.length;
	          stamp = frame.sample.pts;
	          frameIndex++;
	        } else {
	          //logger.log('Unable to parse AAC frame');
	          break;
	        }
	      } else {
	        //nothing found, keep looking
	        offset++;
	      }
	    }
	
	    if (offset < len) {
	      aacOverFlow = data.subarray(offset, len);
	      //logger.log(`AAC: overflow detected:${len-offset}`);
	    } else {
	      aacOverFlow = null;
	    }
	    this.aacOverFlow = aacOverFlow;
	    this.aacLastPTS = stamp;
	  };
	
	  TSDemuxer.prototype._parseMPEGPES = function _parseMPEGPES(pes) {
	    var data = pes.data;
	    var length = data.length;
	    var frameIndex = 0;
	    var offset = 0;
	    var pts = pes.pts;
	
	    while (offset < length) {
	      if (mpegaudio.isHeader(data, offset)) {
	        var frame = mpegaudio.appendFrame(this._audioTrack, data, offset, pts, frameIndex);
	        if (frame) {
	          offset += frame.length;
	          frameIndex++;
	        } else {
	          //logger.log('Unable to parse Mpeg audio frame');
	          break;
	        }
	      } else {
	        //nothing found, keep looking
	        offset++;
	      }
	    }
	  };
	
	  TSDemuxer.prototype._parseID3PES = function _parseID3PES(pes) {
	    this._id3Track.samples.push(pes);
	  };
	
	  return TSDemuxer;
	}();
	
	/* harmony default export */ var tsdemuxer = (tsdemuxer_TSDemuxer);
	// CONCATENATED MODULE: ./src/demux/mp3demuxer.js
	function mp3demuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * MP3 demuxer
	 */
	
	
	
	
	var mp3demuxer_MP3Demuxer = function () {
	  function MP3Demuxer(observer, remuxer, config) {
	    mp3demuxer__classCallCheck(this, MP3Demuxer);
	
	    this.observer = observer;
	    this.config = config;
	    this.remuxer = remuxer;
	  }
	
	  MP3Demuxer.prototype.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
	    this._audioTrack = { container: 'audio/mpeg', type: 'audio', id: -1, sequenceNumber: 0, isAAC: false, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
	  };
	
	  MP3Demuxer.prototype.resetTimeStamp = function resetTimeStamp() {};
	
	  MP3Demuxer.probe = function probe(data) {
	    // check if data contains ID3 timestamp and MPEG sync word
	    var offset, length;
	    var id3Data = id3["a" /* default */].getID3Data(data, 0);
	    if (id3Data && id3["a" /* default */].getTimeStamp(id3Data) !== undefined) {
	      // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
	      // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
	      // More info http://www.mp3-tech.org/programmer/frame_header.html
	      for (offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
	        if (mpegaudio.probe(data, offset)) {
	          logger["b" /* logger */].log('MPEG Audio sync word found !');
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  // feed incoming data to the front of the parsing pipeline
	
	
	  MP3Demuxer.prototype.append = function append(data, timeOffset, contiguous, accurateTimeOffset) {
	    var id3Data = id3["a" /* default */].getID3Data(data, 0);
	    var timestamp = id3["a" /* default */].getTimeStamp(id3Data);
	    var pts = timestamp ? 90 * timestamp : timeOffset * 90000;
	    var offset = id3Data.length;
	    var length = data.length;
	    var frameIndex = 0,
	        stamp = 0;
	    var track = this._audioTrack;
	
	    var id3Samples = [{ pts: pts, dts: pts, data: id3Data }];
	
	    while (offset < length) {
	      if (mpegaudio.isHeader(data, offset)) {
	        var frame = mpegaudio.appendFrame(track, data, offset, pts, frameIndex);
	        if (frame) {
	          offset += frame.length;
	          stamp = frame.sample.pts;
	          frameIndex++;
	        } else {
	          //logger.log('Unable to parse Mpeg audio frame');
	          break;
	        }
	      } else if (id3["a" /* default */].isHeader(data, offset)) {
	        id3Data = id3["a" /* default */].getID3Data(data, offset);
	        id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
	        offset += id3Data.length;
	      } else {
	        //nothing found, keep looking
	        offset++;
	      }
	    }
	
	    this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
	  };
	
	  MP3Demuxer.prototype.destroy = function destroy() {};
	
	  return MP3Demuxer;
	}();
	
	/* harmony default export */ var mp3demuxer = (mp3demuxer_MP3Demuxer);
	// CONCATENATED MODULE: ./src/helper/aac.js
	function aac__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 *  AAC helper
	 */
	
	var AAC = function () {
	  function AAC() {
	    aac__classCallCheck(this, AAC);
	  }
	
	  AAC.getSilentFrame = function getSilentFrame(codec, channelCount) {
	    switch (codec) {
	      case 'mp4a.40.2':
	        if (channelCount === 1) {
	          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
	        } else if (channelCount === 2) {
	          return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
	        } else if (channelCount === 3) {
	          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
	        } else if (channelCount === 4) {
	          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
	        } else if (channelCount === 5) {
	          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
	        } else if (channelCount === 6) {
	          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
	        }
	        break;
	      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
	      default:
	        if (channelCount === 1) {
	          // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
	          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
	        } else if (channelCount === 2) {
	          // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
	          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
	        } else if (channelCount === 3) {
	          // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
	          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
	        }
	        break;
	    }
	    return null;
	  };
	
	  return AAC;
	}();
	
	/* harmony default export */ var aac = (AAC);
	// CONCATENATED MODULE: ./src/remux/mp4-generator.js
	function mp4_generator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Generate MP4 Box
	*/
	
	//import Hex from '../utils/hex';
	
	var mp4_generator_UINT32_MAX = Math.pow(2, 32) - 1;
	
	var MP4 = function () {
	  function MP4() {
	    mp4_generator__classCallCheck(this, MP4);
	  }
	
	  MP4.init = function init() {
	    MP4.types = {
	      avc1: [], // codingname
	      avcC: [],
	      btrt: [],
	      dinf: [],
	      dref: [],
	      esds: [],
	      ftyp: [],
	      hdlr: [],
	      mdat: [],
	      mdhd: [],
	      mdia: [],
	      mfhd: [],
	      minf: [],
	      moof: [],
	      moov: [],
	      mp4a: [],
	      '.mp3': [],
	      mvex: [],
	      mvhd: [],
	      pasp: [],
	      sdtp: [],
	      stbl: [],
	      stco: [],
	      stsc: [],
	      stsd: [],
	      stsz: [],
	      stts: [],
	      tfdt: [],
	      tfhd: [],
	      traf: [],
	      trak: [],
	      trun: [],
	      trex: [],
	      tkhd: [],
	      vmhd: [],
	      smhd: []
	    };
	
	    var i;
	    for (i in MP4.types) {
	      if (MP4.types.hasOwnProperty(i)) {
	        MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
	      }
	    }
	
	    var videoHdlr = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	    ]);
	
	    var audioHdlr = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	    ]);
	
	    MP4.HDLR_TYPES = {
	      'video': videoHdlr,
	      'audio': audioHdlr
	    };
	
	    var dref = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // entry_count
	    0x00, 0x00, 0x00, 0x0c, // entry_size
	    0x75, 0x72, 0x6c, 0x20, // 'url' type
	    0x00, // version 0
	    0x00, 0x00, 0x01 // entry_flags
	    ]);
	
	    var stco = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00 // entry_count
	    ]);
	
	    MP4.STTS = MP4.STSC = MP4.STCO = stco;
	
	    MP4.STSZ = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // sample_size
	    0x00, 0x00, 0x00, 0x00]);
	    MP4.VMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x01, // flags
	    0x00, 0x00, // graphicsmode
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
	    ]);
	    MP4.SMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, // balance
	    0x00, 0x00 // reserved
	    ]);
	
	    MP4.STSD = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01]); // entry_count
	
	    var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
	    var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
	    var minorVersion = new Uint8Array([0, 0, 0, 1]);
	
	    MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
	    MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
	  };
	
	  MP4.box = function box(type) {
	    var payload = Array.prototype.slice.call(arguments, 1),
	        size = 8,
	        i = payload.length,
	        len = i,
	        result;
	    // calculate the total size we need to allocate
	    while (i--) {
	      size += payload[i].byteLength;
	    }
	    result = new Uint8Array(size);
	    result[0] = size >> 24 & 0xff;
	    result[1] = size >> 16 & 0xff;
	    result[2] = size >> 8 & 0xff;
	    result[3] = size & 0xff;
	    result.set(type, 4);
	    // copy the payload into the result
	    for (i = 0, size = 8; i < len; i++) {
	      // copy payload[i] array @ offset size
	      result.set(payload[i], size);
	      size += payload[i].byteLength;
	    }
	    return result;
	  };
	
	  MP4.hdlr = function hdlr(type) {
	    return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
	  };
	
	  MP4.mdat = function mdat(data) {
	    return MP4.box(MP4.types.mdat, data);
	  };
	
	  MP4.mdhd = function mdhd(timescale, duration) {
	    duration *= timescale;
	    var upperWordDuration = Math.floor(duration / (mp4_generator_UINT32_MAX + 1));
	    var lowerWordDuration = Math.floor(duration % (mp4_generator_UINT32_MAX + 1));
	    return MP4.box(MP4.types.mdhd, new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
	    timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
	    upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x55, 0xc4, // 'und' language (undetermined)
	    0x00, 0x00]));
	  };
	
	  MP4.mdia = function mdia(track) {
	    return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
	  };
	
	  MP4.mfhd = function mfhd(sequenceNumber) {
	    return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
	    sequenceNumber >> 24, sequenceNumber >> 16 & 0xFF, sequenceNumber >> 8 & 0xFF, sequenceNumber & 0xFF]) // sequence_number
	    );
	  };
	
	  MP4.minf = function minf(track) {
	    if (track.type === 'audio') {
	      return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
	    } else {
	      return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
	    }
	  };
	
	  MP4.moof = function moof(sn, baseMediaDecodeTime, track) {
	    return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
	  };
	  /**
	   * @param tracks... (optional) {array} the tracks associated with this movie
	   */
	
	
	  MP4.moov = function moov(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = MP4.trak(tracks[i]);
	    }
	
	    return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
	  };
	
	  MP4.mvex = function mvex(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = MP4.trex(tracks[i]);
	    }
	    return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
	  };
	
	  MP4.mvhd = function mvhd(timescale, duration) {
	    duration *= timescale;
	    var upperWordDuration = Math.floor(duration / (mp4_generator_UINT32_MAX + 1));
	    var lowerWordDuration = Math.floor(duration % (mp4_generator_UINT32_MAX + 1));
	    var bytes = new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
	    timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
	    upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x01, 0x00, 0x00, // 1.0 rate
	    0x01, 0x00, // 1.0 volume
	    0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	    0xff, 0xff, 0xff, 0xff // next_track_ID
	    ]);
	    return MP4.box(MP4.types.mvhd, bytes);
	  };
	
	  MP4.sdtp = function sdtp(track) {
	    var samples = track.samples || [],
	        bytes = new Uint8Array(4 + samples.length),
	        flags,
	        i;
	    // leave the full box header (4 bytes) all zero
	    // write the sample table
	    for (i = 0; i < samples.length; i++) {
	      flags = samples[i].flags;
	      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
	    }
	
	    return MP4.box(MP4.types.sdtp, bytes);
	  };
	
	  MP4.stbl = function stbl(track) {
	    return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
	  };
	
	  MP4.avc1 = function avc1(track) {
	    var sps = [],
	        pps = [],
	        i,
	        data,
	        len;
	    // assemble the SPSs
	
	    for (i = 0; i < track.sps.length; i++) {
	      data = track.sps[i];
	      len = data.byteLength;
	      sps.push(len >>> 8 & 0xFF);
	      sps.push(len & 0xFF);
	      sps = sps.concat(Array.prototype.slice.call(data)); // SPS
	    }
	
	    // assemble the PPSs
	    for (i = 0; i < track.pps.length; i++) {
	      data = track.pps[i];
	      len = data.byteLength;
	      pps.push(len >>> 8 & 0xFF);
	      pps.push(len & 0xFF);
	      pps = pps.concat(Array.prototype.slice.call(data));
	    }
	
	    var avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01, // version
	    sps[3], // profile
	    sps[4], // profile compat
	    sps[5], // level
	    0xfc | 3, // lengthSizeMinusOne, hard-coded to 4 bytes
	    0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
	    ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
	    ]).concat(pps))),
	        // "PPS"
	    width = track.width,
	        height = track.height,
	        hSpacing = track.pixelRatio[0],
	        vSpacing = track.pixelRatio[1];
	    //console.log('avcc:' + Hex.hexDump(avcc));
	    return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // data_reference_index
	    0x00, 0x00, // pre_defined
	    0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	    width >> 8 & 0xFF, width & 0xff, // width
	    height >> 8 & 0xFF, height & 0xff, // height
	    0x00, 0x48, 0x00, 0x00, // horizresolution
	    0x00, 0x48, 0x00, 0x00, // vertresolution
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // frame_count
	    0x12, 0x64, 0x61, 0x69, 0x6C, //dailymotion/hls.js
	    0x79, 0x6D, 0x6F, 0x74, 0x69, 0x6F, 0x6E, 0x2F, 0x68, 0x6C, 0x73, 0x2E, 0x6A, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
	    0x00, 0x18, // depth = 24
	    0x11, 0x11]), // pre_defined = -1
	    avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	    0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	    0x00, 0x2d, 0xc6, 0xc0])), // avgBitrate
	    MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24, // hSpacing
	    hSpacing >> 16 & 0xFF, hSpacing >> 8 & 0xFF, hSpacing & 0xFF, vSpacing >> 24, // vSpacing
	    vSpacing >> 16 & 0xFF, vSpacing >> 8 & 0xFF, vSpacing & 0xFF])));
	  };
	
	  MP4.esds = function esds(track) {
	    var configlen = track.config.length;
	    return new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	
	    0x03, // descriptor_type
	    0x17 + configlen, // length
	    0x00, 0x01, //es_id
	    0x00, // stream_priority
	
	    0x04, // descriptor_type
	    0x0f + configlen, // length
	    0x40, //codec : mpeg4_audio
	    0x15, // stream_type
	    0x00, 0x00, 0x00, // buffer_size
	    0x00, 0x00, 0x00, 0x00, // maxBitrate
	    0x00, 0x00, 0x00, 0x00, // avgBitrate
	
	    0x05 // descriptor_type
	    ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
	  };
	
	  MP4.mp4a = function mp4a(track) {
	    var samplerate = track.samplerate;
	    return MP4.box(MP4.types.mp4a, new Uint8Array([0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // data_reference_index
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, track.channelCount, // channelcount
	    0x00, 0x10, // sampleSize:16bits
	    0x00, 0x00, 0x00, 0x00, // reserved2
	    samplerate >> 8 & 0xFF, samplerate & 0xff, //
	    0x00, 0x00]), MP4.box(MP4.types.esds, MP4.esds(track)));
	  };
	
	  MP4.mp3 = function mp3(track) {
	    var samplerate = track.samplerate;
	    return MP4.box(MP4.types['.mp3'], new Uint8Array([0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // data_reference_index
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, track.channelCount, // channelcount
	    0x00, 0x10, // sampleSize:16bits
	    0x00, 0x00, 0x00, 0x00, // reserved2
	    samplerate >> 8 & 0xFF, samplerate & 0xff, //
	    0x00, 0x00]));
	  };
	
	  MP4.stsd = function stsd(track) {
	    if (track.type === 'audio') {
	      if (!track.isAAC && track.codec === 'mp3') {
	        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
	      }
	      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
	    } else {
	      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
	    }
	  };
	
	  MP4.tkhd = function tkhd(track) {
	    var id = track.id,
	        duration = track.duration * track.timescale,
	        width = track.width,
	        height = track.height,
	        upperWordDuration = Math.floor(duration / (mp4_generator_UINT32_MAX + 1)),
	        lowerWordDuration = Math.floor(duration % (mp4_generator_UINT32_MAX + 1));
	    return MP4.box(MP4.types.tkhd, new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x07, // flags
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
	    id >> 24 & 0xFF, id >> 16 & 0xFF, id >> 8 & 0xFF, id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x00, // reserved
	    upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, // layer
	    0x00, 0x00, // alternate_group
	    0x00, 0x00, // non-audio track volume
	    0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    width >> 8 & 0xFF, width & 0xFF, 0x00, 0x00, // width
	    height >> 8 & 0xFF, height & 0xFF, 0x00, 0x00 // height
	    ]));
	  };
	
	  MP4.traf = function traf(track, baseMediaDecodeTime) {
	    var sampleDependencyTable = MP4.sdtp(track),
	        id = track.id,
	        upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (mp4_generator_UINT32_MAX + 1)),
	        lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (mp4_generator_UINT32_MAX + 1));
	    return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF]) // track_ID
	    ), MP4.box(MP4.types.tfdt, new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0XFF, upperWordBaseMediaDecodeTime >> 8 & 0XFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0XFF, lowerWordBaseMediaDecodeTime >> 8 & 0XFF, lowerWordBaseMediaDecodeTime & 0xFF])), MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
	    20 + // tfdt
	    8 + // traf header
	    16 + // mfhd
	    8 + // moof header
	    8), // mdat header
	    sampleDependencyTable);
	  };
	
	  /**
	   * Generate a track box.
	   * @param track {object} a track definition
	   * @return {Uint8Array} the track box
	   */
	
	
	  MP4.trak = function trak(track) {
	    track.duration = track.duration || 0xffffffff;
	    return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
	  };
	
	  MP4.trex = function trex(track) {
	    var id = track.id;
	    return MP4.box(MP4.types.trex, new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x01, 0x00, 0x01 // default_sample_flags
	    ]));
	  };
	
	  MP4.trun = function trun(track, offset) {
	    var samples = track.samples || [],
	        len = samples.length,
	        arraylen = 12 + 16 * len,
	        array = new Uint8Array(arraylen),
	        i,
	        sample,
	        duration,
	        size,
	        flags,
	        cts;
	    offset += 8 + arraylen;
	    array.set([0x00, // version 0
	    0x00, 0x0f, 0x01, // flags
	    len >>> 24 & 0xFF, len >>> 16 & 0xFF, len >>> 8 & 0xFF, len & 0xFF, // sample_count
	    offset >>> 24 & 0xFF, offset >>> 16 & 0xFF, offset >>> 8 & 0xFF, offset & 0xFF // data_offset
	    ], 0);
	    for (i = 0; i < len; i++) {
	      sample = samples[i];
	      duration = sample.duration;
	      size = sample.size;
	      flags = sample.flags;
	      cts = sample.cts;
	      array.set([duration >>> 24 & 0xFF, duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, // sample_duration
	      size >>> 24 & 0xFF, size >>> 16 & 0xFF, size >>> 8 & 0xFF, size & 0xFF, // sample_size
	      flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xF0 << 8, flags.degradPrio & 0x0F, // sample_flags
	      cts >>> 24 & 0xFF, cts >>> 16 & 0xFF, cts >>> 8 & 0xFF, cts & 0xFF // sample_composition_time_offset
	      ], 12 + 16 * i);
	    }
	    return MP4.box(MP4.types.trun, array);
	  };
	
	  MP4.initSegment = function initSegment(tracks) {
	    if (!MP4.types) {
	      MP4.init();
	    }
	    var movie = MP4.moov(tracks),
	        result;
	    result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
	    result.set(MP4.FTYP);
	    result.set(movie, MP4.FTYP.byteLength);
	    return result;
	  };
	
	  return MP4;
	}();
	
	/* harmony default export */ var mp4_generator = (MP4);
	// CONCATENATED MODULE: ./src/remux/mp4-remuxer.js
	function mp4_remuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* fMP4 remuxer
	*/
	
	
	
	
	
	
	
	// 10 seconds
	var MAX_SILENT_FRAME_DURATION = 10 * 1000;
	
	var mp4_remuxer_MP4Remuxer = function () {
	  function MP4Remuxer(observer, config, typeSupported, vendor) {
	    mp4_remuxer__classCallCheck(this, MP4Remuxer);
	
	    this.observer = observer;
	    this.config = config;
	    this.typeSupported = typeSupported;
	    var userAgent = navigator.userAgent;
	    this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
	    this.ISGenerated = false;
	  }
	
	  MP4Remuxer.prototype.destroy = function destroy() {};
	
	  MP4Remuxer.prototype.resetTimeStamp = function resetTimeStamp(defaultTimeStamp) {
	    this._initPTS = this._initDTS = defaultTimeStamp;
	  };
	
	  MP4Remuxer.prototype.resetInitSegment = function resetInitSegment() {
	    this.ISGenerated = false;
	  };
	
	  MP4Remuxer.prototype.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
	    // generate Init Segment if needed
	    if (!this.ISGenerated) {
	      this.generateIS(audioTrack, videoTrack, timeOffset);
	    }
	
	    if (this.ISGenerated) {
	      var nbAudioSamples = audioTrack.samples.length;
	      var nbVideoSamples = videoTrack.samples.length;
	      var audioTimeOffset = timeOffset;
	      var videoTimeOffset = timeOffset;
	      if (nbAudioSamples && nbVideoSamples) {
	        // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
	        // if first audio DTS is not aligned with first video DTS then we need to take that into account
	        // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
	        // drift between audio and video streams
	        var audiovideoDeltaDts = (audioTrack.samples[0].dts - videoTrack.samples[0].dts) / videoTrack.inputTimeScale;
	        audioTimeOffset += Math.max(0, audiovideoDeltaDts);
	        videoTimeOffset += Math.max(0, -audiovideoDeltaDts);
	      }
	      // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
	      // calculated in remuxAudio.
	      //logger.log('nb AAC samples:' + audioTrack.samples.length);
	      if (nbAudioSamples) {
	        // if initSegment was generated without video samples, regenerate it again
	        if (!audioTrack.timescale) {
	          logger["b" /* logger */].warn('regenerate InitSegment as audio detected');
	          this.generateIS(audioTrack, videoTrack, timeOffset);
	        }
	        var audioData = this.remuxAudio(audioTrack, audioTimeOffset, contiguous, accurateTimeOffset);
	        //logger.log('nb AVC samples:' + videoTrack.samples.length);
	        if (nbVideoSamples) {
	          var audioTrackLength = void 0;
	          if (audioData) {
	            audioTrackLength = audioData.endPTS - audioData.startPTS;
	          }
	          // if initSegment was generated without video samples, regenerate it again
	          if (!videoTrack.timescale) {
	            logger["b" /* logger */].warn('regenerate InitSegment as video detected');
	            this.generateIS(audioTrack, videoTrack, timeOffset);
	          }
	          this.remuxVideo(videoTrack, videoTimeOffset, contiguous, audioTrackLength, accurateTimeOffset);
	        }
	      } else {
	        var videoData = void 0;
	        //logger.log('nb AVC samples:' + videoTrack.samples.length);
	        if (nbVideoSamples) {
	          videoData = this.remuxVideo(videoTrack, videoTimeOffset, contiguous, accurateTimeOffset);
	        }
	        if (videoData && audioTrack.codec) {
	          this.remuxEmptyAudio(audioTrack, audioTimeOffset, contiguous, videoData);
	        }
	      }
	    }
	    //logger.log('nb ID3 samples:' + audioTrack.samples.length);
	    if (id3Track.samples.length) {
	      this.remuxID3(id3Track, timeOffset);
	    }
	    //logger.log('nb ID3 samples:' + audioTrack.samples.length);
	    if (textTrack.samples.length) {
	      this.remuxText(textTrack, timeOffset);
	    }
	    //notify end of parsing
	    this.observer.trigger(events["a" /* default */].FRAG_PARSED);
	  };
	
	  MP4Remuxer.prototype.generateIS = function generateIS(audioTrack, videoTrack, timeOffset) {
	    var observer = this.observer,
	        audioSamples = audioTrack.samples,
	        videoSamples = videoTrack.samples,
	        typeSupported = this.typeSupported,
	        container = 'audio/mp4',
	        tracks = {},
	        data = { tracks: tracks },
	        computePTSDTS = this._initPTS === undefined,
	        initPTS,
	        initDTS;
	
	    if (computePTSDTS) {
	      initPTS = initDTS = Infinity;
	    }
	    if (audioTrack.config && audioSamples.length) {
	      // let's use audio sampling rate as MP4 time scale.
	      // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
	      // using audio sampling rate here helps having an integer MP4 frame duration
	      // this avoids potential rounding issue and AV sync issue
	      audioTrack.timescale = audioTrack.samplerate;
	      logger["b" /* logger */].log('audio sampling rate : ' + audioTrack.samplerate);
	      if (!audioTrack.isAAC) {
	        if (typeSupported.mpeg) {
	          // Chrome and Safari
	          container = 'audio/mpeg';
	          audioTrack.codec = '';
	        } else if (typeSupported.mp3) {
	          // Firefox
	          audioTrack.codec = 'mp3';
	        }
	      }
	      tracks.audio = {
	        container: container,
	        codec: audioTrack.codec,
	        initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : mp4_generator.initSegment([audioTrack]),
	        metadata: {
	          channelCount: audioTrack.channelCount
	        }
	      };
	      if (computePTSDTS) {
	        // remember first PTS of this demuxing context. for audio, PTS = DTS
	        initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
	      }
	    }
	
	    if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
	      // let's use input time scale as MP4 video timescale
	      // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
	      var inputTimeScale = videoTrack.inputTimeScale;
	      videoTrack.timescale = inputTimeScale;
	      tracks.video = {
	        container: 'video/mp4',
	        codec: videoTrack.codec,
	        initSegment: mp4_generator.initSegment([videoTrack]),
	        metadata: {
	          width: videoTrack.width,
	          height: videoTrack.height
	        }
	      };
	      if (computePTSDTS) {
	        initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
	        initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
	        this.observer.trigger(events["a" /* default */].INIT_PTS_FOUND, { initPTS: initPTS });
	      }
	    }
	
	    if (Object.keys(tracks).length) {
	      observer.trigger(events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, data);
	      this.ISGenerated = true;
	      if (computePTSDTS) {
	        this._initPTS = initPTS;
	        this._initDTS = initDTS;
	      }
	    } else {
	      observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: false, reason: 'no audio/video samples found' });
	    }
	  };
	
	  MP4Remuxer.prototype.remuxVideo = function remuxVideo(track, timeOffset, contiguous, audioTrackLength, accurateTimeOffset) {
	    var offset = 8,
	        timeScale = track.timescale,
	        mp4SampleDuration,
	        mdat,
	        moof,
	        firstPTS,
	        firstDTS,
	        nextDTS,
	        lastPTS,
	        lastDTS,
	        inputSamples = track.samples,
	        outputSamples = [],
	        nbSamples = inputSamples.length,
	        ptsNormalize = this._PTSNormalize,
	        initDTS = this._initDTS;
	
	    // for (let i = 0; i < track.samples.length; i++) {
	    //   let avcSample = track.samples[i];
	    //   let units = avcSample.units;
	    //   let unitsString = '';
	    //   for (let j = 0; j < units.length ; j++) {
	    //     unitsString += units[j].type + ',';
	    //     if (units[j].data.length < 500) {
	    //       unitsString += Hex.hexDump(units[j].data);
	    //     }
	    //   }
	    //   logger.log(avcSample.pts + '/' + avcSample.dts + ',' + unitsString + avcSample.units.length);
	    // }
	
	    // if parsed fragment is contiguous with last one, let's use last DTS value as reference
	    var nextAvcDts = this.nextAvcDts;
	
	    var isSafari = this.isSafari;
	
	    // Safari does not like overlapping DTS on consecutive fragments. let's use nextAvcDts to overcome this if fragments are consecutive
	    if (isSafari) {
	      // also consider consecutive fragments as being contiguous (even if a level switch occurs),
	      // for sake of clarity:
	      // consecutive fragments are frags with
	      //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
	      //  - less than 200 ms PTS gaps (timeScale/5)
	      contiguous |= inputSamples.length && nextAvcDts && (accurateTimeOffset && Math.abs(timeOffset - nextAvcDts / timeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAvcDts - initDTS) < timeScale / 5);
	    }
	
	    if (!contiguous) {
	      // if not contiguous, let's use target timeOffset
	      nextAvcDts = timeOffset * timeScale;
	    }
	
	    // PTS is coded on 33bits, and can loop from -2^32 to 2^32
	    // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
	    inputSamples.forEach(function (sample) {
	      sample.pts = ptsNormalize(sample.pts - initDTS, nextAvcDts);
	      sample.dts = ptsNormalize(sample.dts - initDTS, nextAvcDts);
	    });
	
	    // sort video samples by DTS then PTS then demux id order
	    inputSamples.sort(function (a, b) {
	      var deltadts = a.dts - b.dts;
	      var deltapts = a.pts - b.pts;
	      return deltadts ? deltadts : deltapts ? deltapts : a.id - b.id;
	    });
	
	    // handle broken streams with PTS < DTS, tolerance up 200ms (18000 in 90kHz timescale)
	    var PTSDTSshift = inputSamples.reduce(function (prev, curr) {
	      return Math.max(Math.min(prev, curr.pts - curr.dts), -18000);
	    }, 0);
	    if (PTSDTSshift < 0) {
	      logger["b" /* logger */].warn('PTS < DTS detected in video samples, shifting DTS by ' + Math.round(PTSDTSshift / 90) + ' ms to overcome this issue');
	      for (var i = 0; i < inputSamples.length; i++) {
	        inputSamples[i].dts += PTSDTSshift;
	      }
	    }
	
	    // compute first DTS and last DTS, normalize them against reference value
	    var sample = inputSamples[0];
	    firstDTS = Math.max(sample.dts, 0);
	    firstPTS = Math.max(sample.pts, 0);
	
	    // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
	    var delta = Math.round((firstDTS - nextAvcDts) / 90);
	    // if fragment are contiguous, detect hole/overlapping between fragments
	    if (contiguous) {
	      if (delta) {
	        if (delta > 1) {
	          logger["b" /* logger */].log('AVC:' + delta + ' ms hole between fragments detected,filling it');
	        } else if (delta < -1) {
	          logger["b" /* logger */].log('AVC:' + -delta + ' ms overlapping between fragments detected');
	        }
	        // remove hole/gap : set DTS to next expected DTS
	        firstDTS = nextAvcDts;
	        inputSamples[0].dts = firstDTS;
	        // offset PTS as well, ensure that PTS is smaller or equal than new DTS
	        firstPTS = Math.max(firstPTS - delta, nextAvcDts);
	        inputSamples[0].pts = firstPTS;
	        logger["b" /* logger */].log('Video/PTS/DTS adjusted: ' + Math.round(firstPTS / 90) + '/' + Math.round(firstDTS / 90) + ',delta:' + delta + ' ms');
	      }
	    }
	    nextDTS = firstDTS;
	
	    // compute lastPTS/lastDTS
	    sample = inputSamples[inputSamples.length - 1];
	    lastDTS = Math.max(sample.dts, 0);
	    lastPTS = Math.max(sample.pts, 0, lastDTS);
	
	    // on Safari let's signal the same sample duration for all samples
	    // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
	    // set this constant duration as being the avg delta between consecutive DTS.
	    if (isSafari) {
	      mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));
	    }
	
	    var nbNalu = 0,
	        naluLen = 0;
	    for (var _i = 0; _i < nbSamples; _i++) {
	      // compute total/avc sample length and nb of NAL units
	      var _sample = inputSamples[_i],
	          units = _sample.units,
	          nbUnits = units.length,
	          sampleLen = 0;
	      for (var j = 0; j < nbUnits; j++) {
	        sampleLen += units[j].data.length;
	      }
	      naluLen += sampleLen;
	      nbNalu += nbUnits;
	      _sample.length = sampleLen;
	
	      // normalize PTS/DTS
	      if (isSafari) {
	        // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
	        _sample.dts = firstDTS + _i * mp4SampleDuration;
	      } else {
	        // ensure sample monotonic DTS
	        _sample.dts = Math.max(_sample.dts, firstDTS);
	      }
	      // ensure that computed value is greater or equal than sample DTS
	      _sample.pts = Math.max(_sample.pts, _sample.dts);
	    }
	
	    /* concatenate the video data and construct the mdat in place
	      (need 8 more bytes to fill length and mpdat type) */
	    var mdatSize = naluLen + 4 * nbNalu + 8;
	    try {
	      mdat = new Uint8Array(mdatSize);
	    } catch (err) {
	      this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MUX_ERROR, details: errors["a" /* ErrorDetails */].REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating video mdat ' + mdatSize });
	      return;
	    }
	    var view = new DataView(mdat.buffer);
	    view.setUint32(0, mdatSize);
	    mdat.set(mp4_generator.types.mdat, 4);
	
	    for (var _i2 = 0; _i2 < nbSamples; _i2++) {
	      var avcSample = inputSamples[_i2],
	          avcSampleUnits = avcSample.units,
	          mp4SampleLength = 0,
	          compositionTimeOffset = void 0;
	      // convert NALU bitstream to MP4 format (prepend NALU with size field)
	      for (var _j = 0, _nbUnits = avcSampleUnits.length; _j < _nbUnits; _j++) {
	        var unit = avcSampleUnits[_j],
	            unitData = unit.data,
	            unitDataLen = unit.data.byteLength;
	        view.setUint32(offset, unitDataLen);
	        offset += 4;
	        mdat.set(unitData, offset);
	        offset += unitDataLen;
	        mp4SampleLength += 4 + unitDataLen;
	      }
	
	      if (!isSafari) {
	        // expected sample duration is the Decoding Timestamp diff of consecutive samples
	        if (_i2 < nbSamples - 1) {
	          mp4SampleDuration = inputSamples[_i2 + 1].dts - avcSample.dts;
	        } else {
	          var config = this.config,
	              lastFrameDuration = avcSample.dts - inputSamples[_i2 > 0 ? _i2 - 1 : _i2].dts;
	          if (config.stretchShortVideoTrack) {
	            // In some cases, a segment's audio track duration may exceed the video track duration.
	            // Since we've already remuxed audio, and we know how long the audio track is, we look to
	            // see if the delta to the next segment is longer than the minimum of maxBufferHole and
	            // maxSeekHole. If so, playback would potentially get stuck, so we artificially inflate
	            // the duration of the last frame to minimize any potential gap between segments.
	            var maxBufferHole = config.maxBufferHole,
	                maxSeekHole = config.maxSeekHole,
	                gapTolerance = Math.floor(Math.min(maxBufferHole, maxSeekHole) * timeScale),
	                deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
	            if (deltaToFrameEnd > gapTolerance) {
	              // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
	              // frame overlap. maxBufferHole/maxSeekHole should be >> lastFrameDuration anyway.
	              mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
	              if (mp4SampleDuration < 0) {
	                mp4SampleDuration = lastFrameDuration;
	              }
	              logger["b" /* logger */].log('It is approximately ' + deltaToFrameEnd / 90 + ' ms to the next segment; using duration ' + mp4SampleDuration / 90 + ' ms for the last video frame.');
	            } else {
	              mp4SampleDuration = lastFrameDuration;
	            }
	          } else {
	            mp4SampleDuration = lastFrameDuration;
	          }
	        }
	        compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
	      } else {
	        compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
	      }
	
	      //console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
	      outputSamples.push({
	        size: mp4SampleLength,
	        // constant duration
	        duration: mp4SampleDuration,
	        cts: compositionTimeOffset,
	        flags: {
	          isLeading: 0,
	          isDependedOn: 0,
	          hasRedundancy: 0,
	          degradPrio: 0,
	          dependsOn: avcSample.key ? 2 : 1,
	          isNonSync: avcSample.key ? 0 : 1
	        }
	      });
	    }
	    // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
	    this.nextAvcDts = lastDTS + mp4SampleDuration;
	    var dropped = track.dropped;
	    track.len = 0;
	    track.nbNalu = 0;
	    track.dropped = 0;
	    if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	      var flags = outputSamples[0].flags;
	      // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
	      // https://code.google.com/p/chromium/issues/detail?id=229412
	      flags.dependsOn = 2;
	      flags.isNonSync = 0;
	    }
	    track.samples = outputSamples;
	    moof = mp4_generator.moof(track.sequenceNumber++, firstDTS, track);
	    track.samples = [];
	
	    var data = {
	      data1: moof,
	      data2: mdat,
	      startPTS: firstPTS / timeScale,
	      endPTS: (lastPTS + mp4SampleDuration) / timeScale,
	      startDTS: firstDTS / timeScale,
	      endDTS: this.nextAvcDts / timeScale,
	      type: 'video',
	      nb: outputSamples.length,
	      dropped: dropped
	    };
	    this.observer.trigger(events["a" /* default */].FRAG_PARSING_DATA, data);
	    return data;
	  };
	
	  MP4Remuxer.prototype.remuxAudio = function remuxAudio(track, timeOffset, contiguous, accurateTimeOffset) {
	    var inputTimeScale = track.inputTimeScale,
	        mp4timeScale = track.timescale,
	        scaleFactor = inputTimeScale / mp4timeScale,
	        mp4SampleDuration = track.isAAC ? 1024 : 1152,
	        inputSampleDuration = mp4SampleDuration * scaleFactor,
	        ptsNormalize = this._PTSNormalize,
	        initDTS = this._initDTS,
	        rawMPEG = !track.isAAC && this.typeSupported.mpeg;
	
	    var offset,
	        mp4Sample,
	        fillFrame,
	        mdat,
	        moof,
	        firstPTS,
	        lastPTS,
	        inputSamples = track.samples,
	        outputSamples = [],
	        nextAudioPts = this.nextAudioPts;
	
	    // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
	    // for sake of clarity:
	    // consecutive fragments are frags with
	    //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
	    //  - less than 20 audio frames distance
	    // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
	    // this helps ensuring audio continuity
	    // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
	    contiguous |= inputSamples.length && nextAudioPts && (accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAudioPts - initDTS) < 20 * inputSampleDuration);
	
	    // compute normalized PTS
	    inputSamples.forEach(function (sample) {
	      sample.pts = sample.dts = ptsNormalize(sample.pts - initDTS, timeOffset * inputTimeScale);
	    });
	
	    // filter out sample with negative PTS that are not playable anyway
	    // if we don't remove these negative samples, they will shift all audio samples forward.
	    // leading to audio overlap between current / next fragment
	    inputSamples = inputSamples.filter(function (sample) {
	      return sample.pts >= 0;
	    });
	
	    // in case all samples have negative PTS, and have been filtered out, return now
	    if (inputSamples.length === 0) {
	      return;
	    }
	
	    if (!contiguous) {
	      if (!accurateTimeOffset) {
	        // if frag are mot contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
	        nextAudioPts = inputSamples[0].pts;
	      } else {
	        // if timeOffset is accurate, let's use it as predicted next audio PTS
	        nextAudioPts = timeOffset * inputTimeScale;
	      }
	    }
	
	    // If the audio track is missing samples, the frames seem to get "left-shifted" within the
	    // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
	    // In an effort to prevent this from happening, we inject frames here where there are gaps.
	    // When possible, we inject a silent frame; when that's not possible, we duplicate the last
	    // frame.
	
	    if (track.isAAC) {
	      var maxAudioFramesDrift = this.config.maxAudioFramesDrift;
	      for (var i = 0, nextPts = nextAudioPts; i < inputSamples.length;) {
	        // First, let's see how far off this frame is from where we expect it to be
	        var sample = inputSamples[i],
	            delta;
	        var pts = sample.pts;
	        delta = pts - nextPts;
	
	        //console.log(Math.round(pts) + '/' + Math.round(nextPts) + '/' + Math.round(delta));
	        var duration = Math.abs(1000 * delta / inputTimeScale);
	
	        // If we're overlapping by more than a duration, drop this sample
	        if (delta <= -maxAudioFramesDrift * inputSampleDuration) {
	          logger["b" /* logger */].warn('Dropping 1 audio frame @ ' + (nextPts / inputTimeScale).toFixed(3) + 's due to ' + Math.round(duration) + ' ms overlap.');
	          inputSamples.splice(i, 1);
	          track.len -= sample.unit.length;
	          // Don't touch nextPtsNorm or i
	        }
	
	        // Insert missing frames if:
	        // 1: We're more than maxAudioFramesDrift frame away
	        // 2: Not more than MAX_SILENT_FRAME_DURATION away
	        // 3: currentTime (aka nextPtsNorm) is not 0
	        else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && nextPts) {
	            var missing = Math.round(delta / inputSampleDuration);
	            logger["b" /* logger */].warn('Injecting ' + missing + ' audio frame @ ' + (nextPts / inputTimeScale).toFixed(3) + 's due to ' + Math.round(1000 * delta / inputTimeScale) + ' ms gap.');
	            for (var j = 0; j < missing; j++) {
	              var newStamp = Math.max(nextPts, 0);
	              fillFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
	              if (!fillFrame) {
	                logger["b" /* logger */].log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
	                fillFrame = sample.unit.subarray();
	              }
	              inputSamples.splice(i, 0, { unit: fillFrame, pts: newStamp, dts: newStamp });
	              track.len += fillFrame.length;
	              nextPts += inputSampleDuration;
	              i++;
	            }
	
	            // Adjust sample to next expected pts
	            sample.pts = sample.dts = nextPts;
	            nextPts += inputSampleDuration;
	            i++;
	          } else {
	            // Otherwise, just adjust pts
	            if (Math.abs(delta) > 0.1 * inputSampleDuration) {
	              //logger.log(`Invalid frame delta ${Math.round(delta + inputSampleDuration)} at PTS ${Math.round(pts / 90)} (should be ${Math.round(inputSampleDuration)}).`);
	            }
	            sample.pts = sample.dts = nextPts;
	            nextPts += inputSampleDuration;
	            i++;
	          }
	      }
	    }
	
	    for (var _j2 = 0, _nbSamples = inputSamples.length; _j2 < _nbSamples; _j2++) {
	      var audioSample = inputSamples[_j2];
	      var unit = audioSample.unit;
	      var _pts = audioSample.pts;
	      //logger.log(`Audio/PTS:${Math.round(pts/90)}`);
	      // if not first sample
	      if (lastPTS !== undefined) {
	        mp4Sample.duration = Math.round((_pts - lastPTS) / scaleFactor);
	      } else {
	        var _delta = Math.round(1000 * (_pts - nextAudioPts) / inputTimeScale),
	            numMissingFrames = 0;
	        // if fragment are contiguous, detect hole/overlapping between fragments
	        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
	        if (contiguous && track.isAAC) {
	          // log delta
	          if (_delta) {
	            if (_delta > 0 && _delta < MAX_SILENT_FRAME_DURATION) {
	              numMissingFrames = Math.round((_pts - nextAudioPts) / inputSampleDuration);
	              logger["b" /* logger */].log(_delta + ' ms hole between AAC samples detected,filling it');
	              if (numMissingFrames > 0) {
	                fillFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
	                if (!fillFrame) {
	                  fillFrame = unit.subarray();
	                }
	                track.len += numMissingFrames * fillFrame.length;
	              }
	              // if we have frame overlap, overlapping for more than half a frame duraion
	            } else if (_delta < -12) {
	              // drop overlapping audio frames... browser will deal with it
	              logger["b" /* logger */].log('drop overlapping AAC sample, expected/parsed/delta:' + (nextAudioPts / inputTimeScale).toFixed(3) + 's/' + (_pts / inputTimeScale).toFixed(3) + 's/' + -_delta + 'ms');
	              track.len -= unit.byteLength;
	              continue;
	            }
	            // set PTS/DTS to expected PTS/DTS
	            _pts = nextAudioPts;
	          }
	        }
	        // remember first PTS of our audioSamples
	        firstPTS = _pts;
	        if (track.len > 0) {
	          /* concatenate the audio data and construct the mdat in place
	            (need 8 more bytes to fill length and mdat type) */
	          var mdatSize = rawMPEG ? track.len : track.len + 8;
	          offset = rawMPEG ? 0 : 8;
	          try {
	            mdat = new Uint8Array(mdatSize);
	          } catch (err) {
	            this.observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MUX_ERROR, details: errors["a" /* ErrorDetails */].REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating audio mdat ' + mdatSize });
	            return;
	          }
	          if (!rawMPEG) {
	            var view = new DataView(mdat.buffer);
	            view.setUint32(0, mdatSize);
	            mdat.set(mp4_generator.types.mdat, 4);
	          }
	        } else {
	          // no audio samples
	          return;
	        }
	        for (var _i3 = 0; _i3 < numMissingFrames; _i3++) {
	          fillFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
	          if (!fillFrame) {
	            logger["b" /* logger */].log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
	            fillFrame = unit.subarray();
	          }
	          mdat.set(fillFrame, offset);
	          offset += fillFrame.byteLength;
	          mp4Sample = {
	            size: fillFrame.byteLength,
	            cts: 0,
	            duration: 1024,
	            flags: {
	              isLeading: 0,
	              isDependedOn: 0,
	              hasRedundancy: 0,
	              degradPrio: 0,
	              dependsOn: 1
	            }
	          };
	          outputSamples.push(mp4Sample);
	        }
	      }
	      mdat.set(unit, offset);
	      var unitLen = unit.byteLength;
	      offset += unitLen;
	      //console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
	      mp4Sample = {
	        size: unitLen,
	        cts: 0,
	        duration: 0,
	        flags: {
	          isLeading: 0,
	          isDependedOn: 0,
	          hasRedundancy: 0,
	          degradPrio: 0,
	          dependsOn: 1
	        }
	      };
	      outputSamples.push(mp4Sample);
	      lastPTS = _pts;
	    }
	    var lastSampleDuration = 0;
	    var nbSamples = outputSamples.length;
	    //set last sample duration as being identical to previous sample
	    if (nbSamples >= 2) {
	      lastSampleDuration = outputSamples[nbSamples - 2].duration;
	      mp4Sample.duration = lastSampleDuration;
	    }
	    if (nbSamples) {
	      // next audio sample PTS should be equal to last sample PTS + duration
	      this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSampleDuration;
	      //logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
	      track.len = 0;
	      track.samples = outputSamples;
	      if (rawMPEG) {
	        moof = new Uint8Array();
	      } else {
	        moof = mp4_generator.moof(track.sequenceNumber++, firstPTS / scaleFactor, track);
	      }
	      track.samples = [];
	      var start = firstPTS / inputTimeScale;
	      var end = nextAudioPts / inputTimeScale;
	      var audioData = {
	        data1: moof,
	        data2: mdat,
	        startPTS: start,
	        endPTS: end,
	        startDTS: start,
	        endDTS: end,
	        type: 'audio',
	        nb: nbSamples
	      };
	      this.observer.trigger(events["a" /* default */].FRAG_PARSING_DATA, audioData);
	      return audioData;
	    }
	    return null;
	  };
	
	  MP4Remuxer.prototype.remuxEmptyAudio = function remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
	    var inputTimeScale = track.inputTimeScale,
	        mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale,
	        scaleFactor = inputTimeScale / mp4timeScale,
	        nextAudioPts = this.nextAudioPts,
	
	
	    // sync with video's timestamp
	    startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS,
	        endDTS = videoData.endDTS * inputTimeScale + this._initDTS,
	
	    // one sample's duration value
	    sampleDuration = 1024,
	        frameDuration = scaleFactor * sampleDuration,
	
	
	    // samples count of this segment's duration
	    nbSamples = Math.ceil((endDTS - startDTS) / frameDuration),
	
	
	    // silent frame
	    silentFrame = aac.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
	
	    logger["b" /* logger */].warn('remux empty Audio');
	    // Can't remux if we can't generate a silent frame...
	    if (!silentFrame) {
	      logger["b" /* logger */].trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
	      return;
	    }
	
	    var samples = [];
	    for (var i = 0; i < nbSamples; i++) {
	      var stamp = startDTS + i * frameDuration;
	      samples.push({ unit: silentFrame, pts: stamp, dts: stamp });
	      track.len += silentFrame.length;
	    }
	    track.samples = samples;
	
	    this.remuxAudio(track, timeOffset, contiguous);
	  };
	
	  MP4Remuxer.prototype.remuxID3 = function remuxID3(track, timeOffset) {
	    var length = track.samples.length,
	        sample;
	    var inputTimeScale = track.inputTimeScale;
	    var initPTS = this._initPTS;
	    var initDTS = this._initDTS;
	    // consume samples
	    if (length) {
	      for (var index = 0; index < length; index++) {
	        sample = track.samples[index];
	        // setting id3 pts, dts to relative time
	        // using this._initPTS and this._initDTS to calculate relative time
	        sample.pts = (sample.pts - initPTS) / inputTimeScale;
	        sample.dts = (sample.dts - initDTS) / inputTimeScale;
	      }
	      this.observer.trigger(events["a" /* default */].FRAG_PARSING_METADATA, {
	        samples: track.samples
	      });
	    }
	
	    track.samples = [];
	    timeOffset = timeOffset;
	  };
	
	  MP4Remuxer.prototype.remuxText = function remuxText(track, timeOffset) {
	    track.samples.sort(function (a, b) {
	      return a.pts - b.pts;
	    });
	
	    var length = track.samples.length,
	        sample;
	    var inputTimeScale = track.inputTimeScale;
	    var initPTS = this._initPTS;
	    // consume samples
	    if (length) {
	      for (var index = 0; index < length; index++) {
	        sample = track.samples[index];
	        // setting text pts, dts to relative time
	        // using this._initPTS and this._initDTS to calculate relative time
	        sample.pts = (sample.pts - initPTS) / inputTimeScale;
	      }
	      this.observer.trigger(events["a" /* default */].FRAG_PARSING_USERDATA, {
	        samples: track.samples
	      });
	    }
	
	    track.samples = [];
	    timeOffset = timeOffset;
	  };
	
	  MP4Remuxer.prototype._PTSNormalize = function _PTSNormalize(value, reference) {
	    var offset;
	    if (reference === undefined) {
	      return value;
	    }
	    if (reference < value) {
	      // - 2^33
	      offset = -8589934592;
	    } else {
	      // + 2^33
	      offset = 8589934592;
	    }
	    /* PTS is 33bit (from 0 to 2^33 -1)
	      if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
	      PTS looping occured. fill the gap */
	    while (Math.abs(value - reference) > 4294967296) {
	      value += offset;
	    }
	    return value;
	  };
	
	  return MP4Remuxer;
	}();
	
	/* harmony default export */ var mp4_remuxer = (mp4_remuxer_MP4Remuxer);
	// CONCATENATED MODULE: ./src/remux/passthrough-remuxer.js
	function passthrough_remuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * passthrough remuxer
	*/
	
	
	var passthrough_remuxer_PassThroughRemuxer = function () {
	  function PassThroughRemuxer(observer) {
	    passthrough_remuxer__classCallCheck(this, PassThroughRemuxer);
	
	    this.observer = observer;
	  }
	
	  PassThroughRemuxer.prototype.destroy = function destroy() {};
	
	  PassThroughRemuxer.prototype.resetTimeStamp = function resetTimeStamp() {};
	
	  PassThroughRemuxer.prototype.resetInitSegment = function resetInitSegment() {};
	
	  PassThroughRemuxer.prototype.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
	    var observer = this.observer;
	    var streamType = '';
	    if (audioTrack) {
	      streamType += 'audio';
	    }
	    if (videoTrack) {
	      streamType += 'video';
	    }
	    observer.trigger(events["a" /* default */].FRAG_PARSING_DATA, {
	      data1: rawData,
	      startPTS: timeOffset,
	      startDTS: timeOffset,
	      type: streamType,
	      nb: 1,
	      dropped: 0
	    });
	    //notify end of parsing
	    observer.trigger(events["a" /* default */].FRAG_PARSED);
	  };
	
	  return PassThroughRemuxer;
	}();
	
	/* harmony default export */ var passthrough_remuxer = (passthrough_remuxer_PassThroughRemuxer);
	// CONCATENATED MODULE: ./src/demux/demuxer-inline.js
	function demuxer_inline__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*  inline demuxer.
	 *   probe fragments and instantiate appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
	 */
	
	
	
	
	
	
	
	
	
	
	
	var demuxer_inline_DemuxerInline = function () {
	  function DemuxerInline(observer, typeSupported, config, vendor) {
	    demuxer_inline__classCallCheck(this, DemuxerInline);
	
	    this.observer = observer;
	    this.typeSupported = typeSupported;
	    this.config = config;
	    this.vendor = vendor;
	  }
	
	  DemuxerInline.prototype.destroy = function destroy() {
	    var demuxer = this.demuxer;
	    if (demuxer) {
	      demuxer.destroy();
	    }
	  };
	
	  DemuxerInline.prototype.push = function push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
	    if (data.byteLength > 0 && decryptdata != null && decryptdata.key != null && decryptdata.method === 'AES-128') {
	      var decrypter = this.decrypter;
	      if (decrypter == null) {
	        decrypter = this.decrypter = new crypt_decrypter["a" /* default */](this.observer, this.config);
	      }
	      var localthis = this;
	      // performance.now() not available on WebWorker, at least on Safari Desktop
	      var startTime;
	      try {
	        startTime = performance.now();
	      } catch (error) {
	        startTime = Date.now();
	      }
	      decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
	        var endTime;
	        try {
	          endTime = performance.now();
	        } catch (error) {
	          endTime = Date.now();
	        }
	        localthis.observer.trigger(events["a" /* default */].FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
	        localthis.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
	      });
	    } else {
	      this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
	    }
	  };
	
	  DemuxerInline.prototype.pushDecrypted = function pushDecrypted(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
	    var demuxer = this.demuxer;
	    if (!demuxer ||
	    // in case of continuity change, we might switch from content type (AAC container to TS container for example)
	    // so let's check that current demuxer is still valid
	    discontinuity && !this.probe(data)) {
	      var observer = this.observer;
	      var typeSupported = this.typeSupported;
	      var config = this.config;
	      // probing order is TS/AAC/MP3/MP4
	      var muxConfig = [{ demux: tsdemuxer, remux: mp4_remuxer }, { demux: mp4demuxer, remux: passthrough_remuxer }, { demux: aacdemuxer, remux: mp4_remuxer }, { demux: mp3demuxer, remux: mp4_remuxer }];
	
	      // probe for content type
	      for (var i = 0, len = muxConfig.length; i < len; i++) {
	        var mux = muxConfig[i];
	        var probe = mux.demux.probe;
	        if (probe(data)) {
	          var _remuxer = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
	          demuxer = new mux.demux(observer, _remuxer, config, typeSupported);
	          this.probe = probe;
	          break;
	        }
	      }
	      if (!demuxer) {
	        observer.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_PARSING_ERROR, fatal: true, reason: 'no demux matching with content found' });
	        return;
	      }
	      this.demuxer = demuxer;
	    }
	    var remuxer = this.remuxer;
	
	    if (discontinuity || trackSwitch) {
	      demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
	      remuxer.resetInitSegment();
	    }
	    if (discontinuity) {
	      demuxer.resetTimeStamp(defaultInitPTS);
	      remuxer.resetTimeStamp(defaultInitPTS);
	    }
	    if (typeof demuxer.setDecryptData === 'function') {
	      demuxer.setDecryptData(decryptdata);
	    }
	    demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
	  };
	
	  return DemuxerInline;
	}();
	
	/* harmony default export */ var demuxer_inline = __webpack_exports__["a"] = (demuxer_inline_DemuxerInline);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	var cues_namespaceObject = {};
	__webpack_require__.d(cues_namespaceObject, "newCue", function() { return newCue; });
	
	// EXTERNAL MODULE: ./node_modules/url-toolkit/src/url-toolkit.js
	var url_toolkit = __webpack_require__(6);
	var url_toolkit_default = /*#__PURE__*/__webpack_require__.n(url_toolkit);
	
	// EXTERNAL MODULE: ./src/events.js
	var events = __webpack_require__(1);
	
	// EXTERNAL MODULE: ./src/errors.js
	var errors = __webpack_require__(2);
	
	// EXTERNAL MODULE: ./src/utils/logger.js
	var logger = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./src/event-handler.js
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	*
	* All objects in the event handling chain should inherit from this class
	*
	*/
	
	
	
	
	
	var event_handler_EventHandler = function () {
	  function EventHandler(hls) {
	    _classCallCheck(this, EventHandler);
	
	    this.hls = hls;
	    this.onEvent = this.onEvent.bind(this);
	
	    for (var _len = arguments.length, events = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      events[_key - 1] = arguments[_key];
	    }
	
	    this.handledEvents = events;
	    this.useGenericHandler = true;
	
	    this.registerListeners();
	  }
	
	  EventHandler.prototype.destroy = function destroy() {
	    this.unregisterListeners();
	  };
	
	  EventHandler.prototype.isEventHandler = function isEventHandler() {
	    return _typeof(this.handledEvents) === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
	  };
	
	  EventHandler.prototype.registerListeners = function registerListeners() {
	    if (this.isEventHandler()) {
	      this.handledEvents.forEach(function (event) {
	        if (event === 'hlsEventGeneric') {
	          throw new Error('Forbidden event name: ' + event);
	        }
	        this.hls.on(event, this.onEvent);
	      }, this);
	    }
	  };
	
	  EventHandler.prototype.unregisterListeners = function unregisterListeners() {
	    if (this.isEventHandler()) {
	      this.handledEvents.forEach(function (event) {
	        this.hls.off(event, this.onEvent);
	      }, this);
	    }
	  };
	
	  /**
	   * arguments: event (string), data (any)
	   */
	
	
	  EventHandler.prototype.onEvent = function onEvent(event, data) {
	    this.onEventGeneric(event, data);
	  };
	
	  EventHandler.prototype.onEventGeneric = function onEventGeneric(event, data) {
	    var eventToFunction = function eventToFunction(event, data) {
	      var funcName = 'on' + event.replace('hls', '');
	      if (typeof this[funcName] !== 'function') {
	        throw new Error('Event ' + event + ' has no generic handler in this ' + this.constructor.name + ' class (tried ' + funcName + ')');
	      }
	      return this[funcName].bind(this, data);
	    };
	    try {
	      eventToFunction.call(this, event, data).call();
	    } catch (err) {
	      logger["b" /* logger */].error('internal error happened while processing ' + event + ':' + err.message);
	      this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].OTHER_ERROR, details: errors["a" /* ErrorDetails */].INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
	    }
	  };
	
	  return EventHandler;
	}();
	
	/* harmony default export */ var event_handler = (event_handler_EventHandler);
	// CONCATENATED MODULE: ./src/utils/attr-list.js
	function attr_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
	var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g;
	
	// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
	
	var AttrList = function () {
	  function AttrList(attrs) {
	    attr_list__classCallCheck(this, AttrList);
	
	    if (typeof attrs === 'string') {
	      attrs = AttrList.parseAttrList(attrs);
	    }
	    for (var attr in attrs) {
	      if (attrs.hasOwnProperty(attr)) {
	        this[attr] = attrs[attr];
	      }
	    }
	  }
	
	  AttrList.prototype.decimalInteger = function decimalInteger(attrName) {
	    var intValue = parseInt(this[attrName], 10);
	    if (intValue > Number.MAX_SAFE_INTEGER) {
	      return Infinity;
	    }
	    return intValue;
	  };
	
	  AttrList.prototype.hexadecimalInteger = function hexadecimalInteger(attrName) {
	    if (this[attrName]) {
	      var stringValue = (this[attrName] || '0x').slice(2);
	      stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
	
	      var value = new Uint8Array(stringValue.length / 2);
	      for (var i = 0; i < stringValue.length / 2; i++) {
	        value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
	      }
	      return value;
	    } else {
	      return null;
	    }
	  };
	
	  AttrList.prototype.hexadecimalIntegerAsNumber = function hexadecimalIntegerAsNumber(attrName) {
	    var intValue = parseInt(this[attrName], 16);
	    if (intValue > Number.MAX_SAFE_INTEGER) {
	      return Infinity;
	    }
	    return intValue;
	  };
	
	  AttrList.prototype.decimalFloatingPoint = function decimalFloatingPoint(attrName) {
	    return parseFloat(this[attrName]);
	  };
	
	  AttrList.prototype.enumeratedString = function enumeratedString(attrName) {
	    return this[attrName];
	  };
	
	  AttrList.prototype.decimalResolution = function decimalResolution(attrName) {
	    var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
	    if (res === null) {
	      return undefined;
	    }
	    return {
	      width: parseInt(res[1], 10),
	      height: parseInt(res[2], 10)
	    };
	  };
	
	  AttrList.parseAttrList = function parseAttrList(input) {
	    var match,
	        attrs = {};
	    ATTR_LIST_REGEX.lastIndex = 0;
	    while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
	      var value = match[2],
	          quote = '"';
	
	      if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
	        value = value.slice(1, -1);
	      }
	      attrs[match[1]] = value;
	    }
	    return attrs;
	  };
	
	  return AttrList;
	}();
	
	/* harmony default export */ var attr_list = (AttrList);
	// CONCATENATED MODULE: ./src/utils/codecs.js
	// from http://mp4ra.org/codecs.html
	var sampleEntryCodesISO = {
	    audio: {
	        'a3ds': true,
	        'ac-3': true,
	        'ac-4': true,
	        'alac': true,
	        'alaw': true,
	        'dra1': true,
	        'dts+': true,
	        'dts-': true,
	        'dtsc': true,
	        'dtse': true,
	        'dtsh': true,
	        'ec-3': true,
	        'enca': true,
	        'g719': true,
	        'g726': true,
	        'm4ae': true,
	        'mha1': true,
	        'mha2': true,
	        'mhm1': true,
	        'mhm2': true,
	        'mlpa': true,
	        'mp4a': true,
	        'raw ': true,
	        'Opus': true,
	        'samr': true,
	        'sawb': true,
	        'sawp': true,
	        'sevc': true,
	        'sqcp': true,
	        'ssmv': true,
	        'twos': true,
	        'ulaw': true
	    },
	    video: {
	        'avc1': true,
	        'avc2': true,
	        'avc3': true,
	        'avc4': true,
	        'avcp': true,
	        'drac': true,
	        'dvav': true,
	        'dvhe': true,
	        'encv': true,
	        'hev1': true,
	        'hvc1': true,
	        'mjp2': true,
	        'mp4v': true,
	        'mvc1': true,
	        'mvc2': true,
	        'mvc3': true,
	        'mvc4': true,
	        'resv': true,
	        'rv60': true,
	        's263': true,
	        'svc1': true,
	        'svc2': true,
	        'vc-1': true,
	        'vp08': true,
	        'vp09': true
	    }
	};
	
	function isCodecType(codec, type) {
	    var typeCodes = sampleEntryCodesISO[type];
	    return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
	}
	
	function isCodecSupportedInMp4(codec, type) {
	    return MediaSource.isTypeSupported((type || 'video') + '/mp4;codecs="' + codec + '"');
	}
	
	
	// CONCATENATED MODULE: ./src/loader/playlist-loader.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function playlist_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Playlist Loader
	*/
	
	
	
	
	
	
	
	
	
	// https://regex101.com is your friend
	var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
	var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
	
	var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source, // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
	/|(?!#)(\S+)/.source, // segment URI, group 3 => the URI (note newline is not eaten)
	/|#EXT-X-BYTERANGE:*(.+)/.source, // next segment's byterange, group 4 => range spec (x@y)
	/|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source, // next segment's program date/time group 5 => the datetime spec
	/|#.*/.source // All other non-segment oriented tags will match with all groups empty
	].join(''), 'g');
	
	var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;
	
	var playlist_loader_LevelKey = function () {
	  function LevelKey() {
	    playlist_loader__classCallCheck(this, LevelKey);
	
	    this.method = null;
	    this.key = null;
	    this.iv = null;
	    this._uri = null;
	  }
	
	  _createClass(LevelKey, [{
	    key: 'uri',
	    get: function get() {
	      if (!this._uri && this.reluri) {
	        this._uri = url_toolkit_default.a.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
	      }
	      return this._uri;
	    }
	  }]);
	
	  return LevelKey;
	}();
	
	var playlist_loader_Fragment = function () {
	  function Fragment() {
	    playlist_loader__classCallCheck(this, Fragment);
	
	    this._url = null;
	    this._byteRange = null;
	    this._decryptdata = null;
	    this.tagList = [];
	  }
	
	  /**
	   * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
	   * @returns {Uint8Array}
	   */
	  Fragment.prototype.createInitializationVector = function createInitializationVector(segmentNumber) {
	    var uint8View = new Uint8Array(16);
	
	    for (var i = 12; i < 16; i++) {
	      uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
	    }
	
	    return uint8View;
	  };
	
	  /**
	   * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
	   * @param levelkey - a playlist's encryption info
	   * @param segmentNumber - the fragment's segment number
	   * @returns {*} - an object to be applied as a fragment's decryptdata
	   */
	
	
	  Fragment.prototype.fragmentDecryptdataFromLevelkey = function fragmentDecryptdataFromLevelkey(levelkey, segmentNumber) {
	    var decryptdata = levelkey;
	
	    if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
	      decryptdata = new playlist_loader_LevelKey();
	      decryptdata.method = levelkey.method;
	      decryptdata.baseuri = levelkey.baseuri;
	      decryptdata.reluri = levelkey.reluri;
	      decryptdata.iv = this.createInitializationVector(segmentNumber);
	    }
	
	    return decryptdata;
	  };
	
	  Fragment.prototype.cloneObj = function cloneObj(obj) {
	    return JSON.parse(JSON.stringify(obj));
	  };
	
	  _createClass(Fragment, [{
	    key: 'url',
	    get: function get() {
	      if (!this._url && this.relurl) {
	        this._url = url_toolkit_default.a.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
	      }
	      return this._url;
	    },
	    set: function set(value) {
	      this._url = value;
	    }
	  }, {
	    key: 'programDateTime',
	    get: function get() {
	      if (!this._programDateTime && this.rawProgramDateTime) {
	        this._programDateTime = new Date(Date.parse(this.rawProgramDateTime));
	      }
	      return this._programDateTime;
	    }
	  }, {
	    key: 'byteRange',
	    get: function get() {
	      if (!this._byteRange) {
	        var byteRange = this._byteRange = [];
	        if (this.rawByteRange) {
	          var params = this.rawByteRange.split('@', 2);
	          if (params.length === 1) {
	            var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
	            byteRange[0] = lastByteRangeEndOffset ? lastByteRangeEndOffset : 0;
	          } else {
	            byteRange[0] = parseInt(params[1]);
	          }
	          byteRange[1] = parseInt(params[0]) + byteRange[0];
	        }
	      }
	      return this._byteRange;
	    }
	  }, {
	    key: 'byteRangeStartOffset',
	    get: function get() {
	      return this.byteRange[0];
	    }
	  }, {
	    key: 'byteRangeEndOffset',
	    get: function get() {
	      return this.byteRange[1];
	    }
	  }, {
	    key: 'decryptdata',
	    get: function get() {
	      if (!this._decryptdata) {
	        this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
	      }
	      return this._decryptdata;
	    }
	  }]);
	
	  return Fragment;
	}();
	
	function findGroup(groups, mediaGroupId) {
	  if (!groups) {
	    return null;
	  }
	
	  var matchingGroup = null;
	
	  for (var i = 0; i < groups.length; i++) {
	    var group = groups[i];
	    if (group.id === mediaGroupId) {
	      matchingGroup = group;
	    }
	  }
	
	  return matchingGroup;
	}
	
	var playlist_loader_PlaylistLoader = function (_EventHandler) {
	  _inherits(PlaylistLoader, _EventHandler);
	
	  function PlaylistLoader(hls) {
	    playlist_loader__classCallCheck(this, PlaylistLoader);
	
	    var _this = _possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].LEVEL_LOADING, events["a" /* default */].AUDIO_TRACK_LOADING, events["a" /* default */].SUBTITLE_TRACK_LOADING));
	
	    _this.loaders = {};
	    return _this;
	  }
	
	  PlaylistLoader.prototype.destroy = function destroy() {
	    for (var loaderName in this.loaders) {
	      var loader = this.loaders[loaderName];
	      if (loader) {
	        loader.destroy();
	      }
	    }
	    this.loaders = {};
	    event_handler.prototype.destroy.call(this);
	  };
	
	  PlaylistLoader.prototype.onManifestLoading = function onManifestLoading(data) {
	    this.load(data.url, { type: 'manifest' });
	  };
	
	  PlaylistLoader.prototype.onLevelLoading = function onLevelLoading(data) {
	    this.load(data.url, { type: 'level', level: data.level, id: data.id });
	  };
	
	  PlaylistLoader.prototype.onAudioTrackLoading = function onAudioTrackLoading(data) {
	    this.load(data.url, { type: 'audioTrack', id: data.id });
	  };
	
	  PlaylistLoader.prototype.onSubtitleTrackLoading = function onSubtitleTrackLoading(data) {
	    this.load(data.url, { type: 'subtitleTrack', id: data.id });
	  };
	
	  PlaylistLoader.prototype.load = function load(url, context) {
	    var loader = this.loaders[context.type];
	    if (loader !== undefined) {
	      var loaderContext = loader.context;
	      if (loaderContext && loaderContext.url === url) {
	        logger["b" /* logger */].trace('playlist request ongoing');
	        return;
	      } else {
	        logger["b" /* logger */].warn('abort previous loader for type:' + context.type);
	        loader.abort();
	      }
	    }
	    var config = this.hls.config,
	        maxRetry = void 0,
	        timeout = void 0,
	        retryDelay = void 0,
	        maxRetryDelay = void 0;
	    if (context.type === 'manifest') {
	      maxRetry = config.manifestLoadingMaxRetry;
	      timeout = config.manifestLoadingTimeOut;
	      retryDelay = config.manifestLoadingRetryDelay;
	      maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
	    } else if (context.type === 'level') {
	      // Disable internal loader retry logic, since we are managing retries in Level Controller
	      maxRetry = 0;
	      timeout = config.levelLoadingTimeOut;
	    } else {
	      // TODO Introduce retry settings for audio-track and subtitle-track, it should not use level retry config
	      maxRetry = config.levelLoadingMaxRetry;
	      timeout = config.levelLoadingTimeOut;
	      retryDelay = config.levelLoadingRetryDelay;
	      maxRetryDelay = config.levelLoadingMaxRetryTimeout;
	      logger["b" /* logger */].log('loading playlist for ' + context.type + ' ' + (context.level || context.id));
	    }
	    loader = this.loaders[context.type] = context.loader = typeof config.pLoader !== 'undefined' ? new config.pLoader(config) : new config.loader(config);
	    context.url = url;
	    context.responseType = '';
	
	    var loaderConfig = void 0,
	        loaderCallbacks = void 0;
	    loaderConfig = { timeout: timeout, maxRetry: maxRetry, retryDelay: retryDelay, maxRetryDelay: maxRetryDelay };
	    loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
	    loader.load(context, loaderConfig, loaderCallbacks);
	  };
	
	  PlaylistLoader.prototype.resolve = function resolve(url, baseUrl) {
	    return url_toolkit_default.a.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
	  };
	
	  PlaylistLoader.prototype.parseMasterPlaylist = function parseMasterPlaylist(string, baseurl) {
	    var levels = [],
	        result = void 0;
	    MASTER_PLAYLIST_REGEX.lastIndex = 0;
	
	    function setCodecs(codecs, level) {
	      ['video', 'audio'].forEach(function (type) {
	        var filtered = codecs.filter(function (codec) {
	          return isCodecType(codec, type);
	        });
	        if (filtered.length) {
	          var preferred = filtered.filter(function (codec) {
	            return codec.lastIndexOf('avc1', 0) === 0 || codec.lastIndexOf('mp4a', 0) === 0;
	          });
	          level[type + 'Codec'] = preferred.length > 0 ? preferred[0] : filtered[0];
	
	          // remove from list
	          codecs = codecs.filter(function (codec) {
	            return filtered.indexOf(codec) === -1;
	          });
	        }
	      });
	
	      level.unknownCodecs = codecs;
	    }
	
	    while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
	      var level = {};
	
	      var attrs = level.attrs = new attr_list(result[1]);
	      level.url = this.resolve(result[2], baseurl);
	
	      var resolution = attrs.decimalResolution('RESOLUTION');
	      if (resolution) {
	        level.width = resolution.width;
	        level.height = resolution.height;
	      }
	      level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
	      level.name = attrs.NAME;
	
	      setCodecs([].concat((attrs.CODECS || '').split(/[ ,]+/)), level);
	
	      if (level.videoCodec && level.videoCodec.indexOf('avc1') !== -1) {
	        level.videoCodec = this.avc1toavcoti(level.videoCodec);
	      }
	
	      levels.push(level);
	    }
	    return levels;
	  };
	
	  PlaylistLoader.prototype.parseMasterPlaylistMedia = function parseMasterPlaylistMedia(string, baseurl, type) {
	    var audioGroups = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	    var result = void 0;
	    var medias = [];
	    var id = 0;
	    MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
	    while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
	      var media = {};
	      var attrs = new attr_list(result[1]);
	      if (attrs.TYPE === type) {
	        media.groupId = attrs['GROUP-ID'];
	        media.name = attrs.NAME;
	        media.type = type;
	        media.default = attrs.DEFAULT === 'YES';
	        media.autoselect = attrs.AUTOSELECT === 'YES';
	        media.forced = attrs.FORCED === 'YES';
	        if (attrs.URI) {
	          media.url = this.resolve(attrs.URI, baseurl);
	        }
	        media.lang = attrs.LANGUAGE;
	        if (!media.name) {
	          media.name = media.lang;
	        }
	        if (audioGroups.length) {
	          var groupCodec = findGroup(audioGroups, media.groupId);
	          media.audioCodec = groupCodec ? groupCodec.codec : audioGroups[0].codec;
	        }
	        media.id = id++;
	        medias.push(media);
	      }
	    }
	    return medias;
	  };
	
	  PlaylistLoader.prototype.avc1toavcoti = function avc1toavcoti(codec) {
	    var result,
	        avcdata = codec.split('.');
	    if (avcdata.length > 2) {
	      result = avcdata.shift() + '.';
	      result += parseInt(avcdata.shift()).toString(16);
	      result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
	    } else {
	      result = codec;
	    }
	    return result;
	  };
	
	  PlaylistLoader.prototype.parseLevelPlaylist = function parseLevelPlaylist(string, baseurl, id, type) {
	    var currentSN = 0,
	        totalduration = 0,
	        level = { type: null, version: null, url: baseurl, fragments: [], live: true, startSN: 0 },
	        levelkey = new playlist_loader_LevelKey(),
	        cc = 0,
	        prevFrag = null,
	        frag = new playlist_loader_Fragment(),
	        result,
	        i;
	
	    LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
	
	    while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
	      var duration = result[1];
	      if (duration) {
	        // INF
	        frag.duration = parseFloat(duration);
	        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
	        var title = (' ' + result[2]).slice(1);
	        frag.title = title ? title : null;
	        frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
	      } else if (result[3]) {
	        // url
	        if (!isNaN(frag.duration)) {
	          var sn = currentSN++;
	          frag.type = type;
	          frag.start = totalduration;
	          frag.levelkey = levelkey;
	          frag.sn = sn;
	          frag.level = id;
	          frag.cc = cc;
	          frag.baseurl = baseurl;
	          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
	          frag.relurl = (' ' + result[3]).slice(1);
	
	          level.fragments.push(frag);
	          prevFrag = frag;
	          totalduration += frag.duration;
	
	          frag = new playlist_loader_Fragment();
	        }
	      } else if (result[4]) {
	        // X-BYTERANGE
	        frag.rawByteRange = (' ' + result[4]).slice(1);
	        if (prevFrag) {
	          var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
	          if (lastByteRangeEndOffset) {
	            frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
	          }
	        }
	      } else if (result[5]) {
	        // PROGRAM-DATE-TIME
	        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
	        frag.rawProgramDateTime = (' ' + result[5]).slice(1);
	        frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
	        if (level.programDateTime === undefined) {
	          level.programDateTime = new Date(new Date(Date.parse(result[5])) - 1000 * totalduration);
	        }
	      } else {
	        result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
	        for (i = 1; i < result.length; i++) {
	          if (result[i] !== undefined) {
	            break;
	          }
	        }
	
	        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
	        var value1 = (' ' + result[i + 1]).slice(1);
	        var value2 = (' ' + result[i + 2]).slice(1);
	
	        switch (result[i]) {
	          case '#':
	            frag.tagList.push(value2 ? [value1, value2] : [value1]);
	            break;
	          case 'PLAYLIST-TYPE':
	            level.type = value1.toUpperCase();
	            break;
	          case 'MEDIA-SEQUENCE':
	            currentSN = level.startSN = parseInt(value1);
	            break;
	          case 'TARGETDURATION':
	            level.targetduration = parseFloat(value1);
	            break;
	          case 'VERSION':
	            level.version = parseInt(value1);
	            break;
	          case 'EXTM3U':
	            break;
	          case 'ENDLIST':
	            level.live = false;
	            break;
	          case 'DIS':
	            cc++;
	            frag.tagList.push(['DIS']);
	            break;
	          case 'DISCONTINUITY-SEQ':
	            cc = parseInt(value1);
	            break;
	          case 'KEY':
	            // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
	            var decryptparams = value1;
	            var keyAttrs = new attr_list(decryptparams);
	            var decryptmethod = keyAttrs.enumeratedString('METHOD'),
	                decrypturi = keyAttrs.URI,
	                decryptiv = keyAttrs.hexadecimalInteger('IV');
	            if (decryptmethod) {
	              levelkey = new playlist_loader_LevelKey();
	              if (decrypturi && ['AES-128', 'SAMPLE-AES'].indexOf(decryptmethod) >= 0) {
	                levelkey.method = decryptmethod;
	                // URI to get the key
	                levelkey.baseuri = baseurl;
	                levelkey.reluri = decrypturi;
	                levelkey.key = null;
	                // Initialization Vector (IV)
	                levelkey.iv = decryptiv;
	              }
	            }
	            break;
	          case 'START':
	            var startParams = value1;
	            var startAttrs = new attr_list(startParams);
	            var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
	            //TIME-OFFSET can be 0
	            if (!isNaN(startTimeOffset)) {
	              level.startTimeOffset = startTimeOffset;
	            }
	            break;
	          case 'MAP':
	            var mapAttrs = new attr_list(value1);
	            frag.relurl = mapAttrs.URI;
	            frag.rawByteRange = mapAttrs.BYTERANGE;
	            frag.baseurl = baseurl;
	            frag.level = id;
	            frag.type = type;
	            frag.sn = 'initSegment';
	            level.initSegment = frag;
	            frag = new playlist_loader_Fragment();
	            break;
	          default:
	            logger["b" /* logger */].warn('line parsed but not handled: ' + result);
	            break;
	        }
	      }
	    }
	    frag = prevFrag;
	    //logger.log('found ' + level.fragments.length + ' fragments');
	    if (frag && !frag.relurl) {
	      level.fragments.pop();
	      totalduration -= frag.duration;
	    }
	    level.totalduration = totalduration;
	    level.averagetargetduration = totalduration / level.fragments.length;
	    level.endSN = currentSN - 1;
	    level.startCC = level.fragments[0] ? level.fragments[0].cc : 0;
	    level.endCC = cc;
	    return level;
	  };
	
	  PlaylistLoader.prototype.loadsuccess = function loadsuccess(response, stats, context) {
	    var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    var string = response.data,
	        url = response.url,
	        type = context.type,
	        id = context.id,
	        level = context.level,
	        hls = this.hls;
	
	    this.loaders[type] = undefined;
	    // responseURL not supported on some browsers (it is used to detect URL redirection)
	    // data-uri mode also not supported (but no need to detect redirection)
	    if (url === undefined || url.indexOf('data:') === 0) {
	      // fallback to initial URL
	      url = context.url;
	    }
	    stats.tload = performance.now();
	    //stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
	    if (string.indexOf('#EXTM3U') === 0) {
	      if (string.indexOf('#EXTINF:') > 0) {
	        var isLevel = type !== 'audioTrack' && type !== 'subtitleTrack',
	            levelId = !isNaN(level) ? level : !isNaN(id) ? id : 0,
	            levelDetails = this.parseLevelPlaylist(string, url, levelId, type === 'audioTrack' ? 'audio' : type === 'subtitleTrack' ? 'subtitle' : 'main');
	        levelDetails.tload = stats.tload;
	        if (type === 'manifest') {
	          // first request, stream manifest (no master playlist), fire manifest loaded event with level details
	          hls.trigger(events["a" /* default */].MANIFEST_LOADED, { levels: [{ url: url, details: levelDetails }], audioTracks: [], url: url, stats: stats, networkDetails: networkDetails });
	        }
	        stats.tparsed = performance.now();
	        if (levelDetails.targetduration) {
	          if (isLevel) {
	            hls.trigger(events["a" /* default */].LEVEL_LOADED, { details: levelDetails, level: level || 0, id: id || 0, stats: stats, networkDetails: networkDetails });
	          } else {
	            if (type === 'audioTrack') {
	              hls.trigger(events["a" /* default */].AUDIO_TRACK_LOADED, { details: levelDetails, id: id, stats: stats, networkDetails: networkDetails });
	            } else if (type === 'subtitleTrack') {
	              hls.trigger(events["a" /* default */].SUBTITLE_TRACK_LOADED, { details: levelDetails, id: id, stats: stats, networkDetails: networkDetails });
	            }
	          }
	        } else {
	          hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'invalid targetduration', networkDetails: networkDetails });
	        }
	      } else {
	        var levels = this.parseMasterPlaylist(string, url);
	        // multi level playlist, parse level info
	        if (levels.length) {
	          var audioGroups = levels.map(function (l) {
	            return { id: l.attrs.AUDIO, codec: l.audioCodec };
	          });
	          var audioTracks = this.parseMasterPlaylistMedia(string, url, 'AUDIO', audioGroups);
	          var subtitles = this.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
	          if (audioTracks.length) {
	            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
	            var embeddedAudioFound = false;
	            audioTracks.forEach(function (audioTrack) {
	              if (!audioTrack.url) {
	                embeddedAudioFound = true;
	              }
	            });
	            // if no embedded audio track defined, but audio codec signaled in quality level, we need to signal this main audio track
	            // this could happen with playlists with alt audio rendition in which quality levels (main) contains both audio+video. but with mixed audio track not signaled
	            if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
	              logger["b" /* logger */].log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
	              audioTracks.unshift({ type: 'main', name: 'main' });
	            }
	          }
	          hls.trigger(events["a" /* default */].MANIFEST_LOADED, { levels: levels, audioTracks: audioTracks, subtitles: subtitles, url: url, stats: stats, networkDetails: networkDetails });
	        } else {
	          hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'no level found in manifest', networkDetails: networkDetails });
	        }
	      }
	    } else {
	      hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'no EXTM3U delimiter', networkDetails: networkDetails });
	    }
	  };
	
	  PlaylistLoader.prototype.loaderror = function loaderror(response, context) {
	    var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var details,
	        fatal,
	        loader = context.loader;
	    switch (context.type) {
	      case 'manifest':
	        details = errors["a" /* ErrorDetails */].MANIFEST_LOAD_ERROR;
	        fatal = true;
	        break;
	      case 'level':
	        details = errors["a" /* ErrorDetails */].LEVEL_LOAD_ERROR;
	        fatal = false;
	        break;
	      case 'audioTrack':
	        details = errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_ERROR;
	        fatal = false;
	        break;
	    }
	    if (loader) {
	      loader.abort();
	      this.loaders[context.type] = undefined;
	    }
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, response: response, context: context, networkDetails: networkDetails });
	  };
	
	  PlaylistLoader.prototype.loadtimeout = function loadtimeout(stats, context) {
	    var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var details,
	        fatal,
	        loader = context.loader;
	    switch (context.type) {
	      case 'manifest':
	        details = errors["a" /* ErrorDetails */].MANIFEST_LOAD_TIMEOUT;
	        fatal = true;
	        break;
	      case 'level':
	        details = errors["a" /* ErrorDetails */].LEVEL_LOAD_TIMEOUT;
	        fatal = false;
	        break;
	      case 'audioTrack':
	        details = errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_TIMEOUT;
	        fatal = false;
	        break;
	    }
	    if (loader) {
	      loader.abort();
	      this.loaders[context.type] = undefined;
	    }
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, context: context, networkDetails: networkDetails });
	  };
	
	  return PlaylistLoader;
	}(event_handler);
	
	/* harmony default export */ var playlist_loader = (playlist_loader_PlaylistLoader);
	// CONCATENATED MODULE: ./src/loader/fragment-loader.js
	function fragment_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function fragment_loader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function fragment_loader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Fragment Loader
	*/
	
	
	
	
	
	
	var fragment_loader_FragmentLoader = function (_EventHandler) {
	  fragment_loader__inherits(FragmentLoader, _EventHandler);
	
	  function FragmentLoader(hls) {
	    fragment_loader__classCallCheck(this, FragmentLoader);
	
	    var _this = fragment_loader__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].FRAG_LOADING));
	
	    _this.loaders = {};
	    return _this;
	  }
	
	  FragmentLoader.prototype.destroy = function destroy() {
	    var loaders = this.loaders;
	    for (var loaderName in loaders) {
	      var loader = loaders[loaderName];
	      if (loader) {
	        loader.destroy();
	      }
	    }
	    this.loaders = {};
	    event_handler.prototype.destroy.call(this);
	  };
	
	  FragmentLoader.prototype.onFragLoading = function onFragLoading(data) {
	    var frag = data.frag,
	        type = frag.type,
	        loader = this.loaders[type],
	        config = this.hls.config;
	
	    frag.loaded = 0;
	    if (loader) {
	      logger["b" /* logger */].warn('abort previous fragment loader for type:' + type);
	      loader.abort();
	    }
	    loader = this.loaders[type] = frag.loader = typeof config.fLoader !== 'undefined' ? new config.fLoader(config) : new config.loader(config);
	
	    var loaderContext = void 0,
	        loaderConfig = void 0,
	        loaderCallbacks = void 0;
	    loaderContext = { url: frag.url, frag: frag, responseType: 'arraybuffer', progressData: false };
	    var start = frag.byteRangeStartOffset,
	        end = frag.byteRangeEndOffset;
	    if (!isNaN(start) && !isNaN(end)) {
	      loaderContext.rangeStart = start;
	      loaderContext.rangeEnd = end;
	    }
	    loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: 0, retryDelay: 0, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
	    loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this), onProgress: this.loadprogress.bind(this) };
	    loader.load(loaderContext, loaderConfig, loaderCallbacks);
	  };
	
	  FragmentLoader.prototype.loadsuccess = function loadsuccess(response, stats, context) {
	    var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    var payload = response.data,
	        frag = context.frag;
	    // detach fragment loader on load success
	    frag.loader = undefined;
	    this.loaders[frag.type] = undefined;
	    this.hls.trigger(events["a" /* default */].FRAG_LOADED, { payload: payload, frag: frag, stats: stats, networkDetails: networkDetails });
	  };
	
	  FragmentLoader.prototype.loaderror = function loaderror(response, context) {
	    var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var loader = context.loader;
	    if (loader) {
	      loader.abort();
	    }
	    this.loaders[context.type] = undefined;
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR, fatal: false, frag: context.frag, response: response, networkDetails: networkDetails });
	  };
	
	  FragmentLoader.prototype.loadtimeout = function loadtimeout(stats, context) {
	    var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var loader = context.loader;
	    if (loader) {
	      loader.abort();
	    }
	    this.loaders[context.type] = undefined;
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag, networkDetails: networkDetails });
	  };
	
	  // data will be used for progressive parsing
	
	
	  FragmentLoader.prototype.loadprogress = function loadprogress(stats, context, data) {
	    var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	    // jshint ignore:line
	    var frag = context.frag;
	    frag.loaded = stats.loaded;
	    this.hls.trigger(events["a" /* default */].FRAG_LOAD_PROGRESS, { frag: frag, stats: stats, networkDetails: networkDetails });
	  };
	
	  return FragmentLoader;
	}(event_handler);
	
	/* harmony default export */ var fragment_loader = (fragment_loader_FragmentLoader);
	// CONCATENATED MODULE: ./src/loader/key-loader.js
	function key_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function key_loader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function key_loader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Decrypt key Loader
	*/
	
	
	
	
	
	
	var key_loader_KeyLoader = function (_EventHandler) {
	  key_loader__inherits(KeyLoader, _EventHandler);
	
	  function KeyLoader(hls) {
	    key_loader__classCallCheck(this, KeyLoader);
	
	    var _this = key_loader__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].KEY_LOADING));
	
	    _this.loaders = {};
	    _this.decryptkey = null;
	    _this.decrypturl = null;
	    return _this;
	  }
	
	  KeyLoader.prototype.destroy = function destroy() {
	    for (var loaderName in this.loaders) {
	      var loader = this.loaders[loaderName];
	      if (loader) {
	        loader.destroy();
	      }
	    }
	    this.loaders = {};
	    event_handler.prototype.destroy.call(this);
	  };
	
	  KeyLoader.prototype.onKeyLoading = function onKeyLoading(data) {
	    var frag = data.frag,
	        type = frag.type,
	        loader = this.loaders[type],
	        decryptdata = frag.decryptdata,
	        uri = decryptdata.uri;
	    // if uri is different from previous one or if decrypt key not retrieved yet
	    if (uri !== this.decrypturl || this.decryptkey === null) {
	      var config = this.hls.config;
	
	      if (loader) {
	        logger["b" /* logger */].warn('abort previous key loader for type:' + type);
	        loader.abort();
	      }
	      frag.loader = this.loaders[type] = new config.loader(config);
	      this.decrypturl = uri;
	      this.decryptkey = null;
	
	      var loaderContext = void 0,
	          loaderConfig = void 0,
	          loaderCallbacks = void 0;
	      loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer' };
	      loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: config.fragLoadingMaxRetry, retryDelay: config.fragLoadingRetryDelay, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
	      loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
	      frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
	    } else if (this.decryptkey) {
	      // we already loaded this key, return it
	      decryptdata.key = this.decryptkey;
	      this.hls.trigger(events["a" /* default */].KEY_LOADED, { frag: frag });
	    }
	  };
	
	  KeyLoader.prototype.loadsuccess = function loadsuccess(response, stats, context) {
	    var frag = context.frag;
	    this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
	    // detach fragment loader on load success
	    frag.loader = undefined;
	    this.loaders[frag.type] = undefined;
	    this.hls.trigger(events["a" /* default */].KEY_LOADED, { frag: frag });
	  };
	
	  KeyLoader.prototype.loaderror = function loaderror(response, context) {
	    var frag = context.frag,
	        loader = frag.loader;
	    if (loader) {
	      loader.abort();
	    }
	    this.loaders[context.type] = undefined;
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
	  };
	
	  KeyLoader.prototype.loadtimeout = function loadtimeout(stats, context) {
	    var frag = context.frag,
	        loader = frag.loader;
	    if (loader) {
	      loader.abort();
	    }
	    this.loaders[context.type] = undefined;
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].NETWORK_ERROR, details: errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
	  };
	
	  return KeyLoader;
	}(event_handler);
	
	/* harmony default export */ var key_loader = (key_loader_KeyLoader);
	// CONCATENATED MODULE: ./src/utils/binary-search.js
	var BinarySearch = {
	    /**
	     * Searches for an item in an array which matches a certain condition.
	     * This requires the condition to only match one item in the array,
	     * and for the array to be ordered.
	     *
	     * @param {Array} list The array to search.
	     * @param {Function} comparisonFunction
	     *      Called and provided a candidate item as the first argument.
	     *      Should return:
	     *          > -1 if the item should be located at a lower index than the provided item.
	     *          > 1 if the item should be located at a higher index than the provided item.
	     *          > 0 if the item is the item you're looking for.
	     *
	     * @return {*} The object if it is found or null otherwise.
	     */
	    search: function search(list, comparisonFunction) {
	        var minIndex = 0;
	        var maxIndex = list.length - 1;
	        var currentIndex = null;
	        var currentElement = null;
	
	        while (minIndex <= maxIndex) {
	            currentIndex = (minIndex + maxIndex) / 2 | 0;
	            currentElement = list[currentIndex];
	
	            var comparisonResult = comparisonFunction(currentElement);
	            if (comparisonResult > 0) {
	                minIndex = currentIndex + 1;
	            } else if (comparisonResult < 0) {
	                maxIndex = currentIndex - 1;
	            } else {
	                return currentElement;
	            }
	        }
	
	        return null;
	    }
	};
	
	/* harmony default export */ var binary_search = (BinarySearch);
	// CONCATENATED MODULE: ./src/helper/buffer-helper.js
	/**
	 * Buffer Helper utils, providing methods dealing buffer length retrieval
	*/
	
	var BufferHelper = {
	  isBuffered: function isBuffered(media, position) {
	    try {
	      if (media) {
	        var buffered = media.buffered;
	        for (var i = 0; i < buffered.length; i++) {
	          if (position >= buffered.start(i) && position <= buffered.end(i)) {
	            return true;
	          }
	        }
	      }
	    } catch (error) {
	      // this is to catch
	      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
	      // This SourceBuffer has been removed from the parent media source
	    }
	    return false;
	  },
	
	  bufferInfo: function bufferInfo(media, pos, maxHoleDuration) {
	    try {
	      if (media) {
	        var vbuffered = media.buffered,
	            buffered = [],
	            i;
	        for (i = 0; i < vbuffered.length; i++) {
	          buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
	        }
	        return this.bufferedInfo(buffered, pos, maxHoleDuration);
	      }
	    } catch (error) {
	      // this is to catch
	      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
	      // This SourceBuffer has been removed from the parent media source
	    }
	    return { len: 0, start: pos, end: pos, nextStart: undefined };
	  },
	
	  bufferedInfo: function bufferedInfo(buffered, pos, maxHoleDuration) {
	    var buffered2 = [],
	
	    // bufferStart and bufferEnd are buffer boundaries around current video position
	    bufferLen,
	        bufferStart,
	        bufferEnd,
	        bufferStartNext,
	        i;
	    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
	    buffered.sort(function (a, b) {
	      var diff = a.start - b.start;
	      if (diff) {
	        return diff;
	      } else {
	        return b.end - a.end;
	      }
	    });
	    // there might be some small holes between buffer time range
	    // consider that holes smaller than maxHoleDuration are irrelevant and build another
	    // buffer time range representations that discards those holes
	    for (i = 0; i < buffered.length; i++) {
	      var buf2len = buffered2.length;
	      if (buf2len) {
	        var buf2end = buffered2[buf2len - 1].end;
	        // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
	        if (buffered[i].start - buf2end < maxHoleDuration) {
	          // merge overlapping time ranges
	          // update lastRange.end only if smaller than item.end
	          // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
	          // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
	          if (buffered[i].end > buf2end) {
	            buffered2[buf2len - 1].end = buffered[i].end;
	          }
	        } else {
	          // big hole
	          buffered2.push(buffered[i]);
	        }
	      } else {
	        // first value
	        buffered2.push(buffered[i]);
	      }
	    }
	    for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
	      var start = buffered2[i].start,
	          end = buffered2[i].end;
	      //logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
	      if (pos + maxHoleDuration >= start && pos < end) {
	        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
	        bufferStart = start;
	        bufferEnd = end;
	        bufferLen = bufferEnd - pos;
	      } else if (pos + maxHoleDuration < start) {
	        bufferStartNext = start;
	        break;
	      }
	    }
	    return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
	  }
	};
	
	/* harmony default export */ var buffer_helper = (BufferHelper);
	// EXTERNAL MODULE: ./src/demux/demuxer-inline.js + 12 modules
	var demuxer_inline = __webpack_require__(7);
	
	// EXTERNAL MODULE: ./node_modules/events/events.js
	var events_events = __webpack_require__(5);
	var events_default = /*#__PURE__*/__webpack_require__.n(events_events);
	
	// EXTERNAL MODULE: ./node_modules/webworkify-webpack/index.js
	var webworkify_webpack = __webpack_require__(9);
	var webworkify_webpack_default = /*#__PURE__*/__webpack_require__.n(webworkify_webpack);
	
	// CONCATENATED MODULE: ./src/helper/mediasource-helper.js
	/**
	 * MediaSource helper
	 */
	
	function getMediaSource() {
	  if (typeof window !== 'undefined') {
	    return window.MediaSource || window.WebKitMediaSource;
	  }
	}
	// CONCATENATED MODULE: ./src/demux/demuxer.js
	function demuxer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	
	
	
	
	var demuxer_MediaSource = getMediaSource();
	
	var demuxer_Demuxer = function () {
	  function Demuxer(hls, id) {
	    demuxer__classCallCheck(this, Demuxer);
	
	    this.hls = hls;
	    this.id = id;
	    // observer setup
	    var observer = this.observer = new events_default.a();
	    var config = hls.config;
	    observer.trigger = function trigger(event) {
	      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        data[_key - 1] = arguments[_key];
	      }
	
	      observer.emit.apply(observer, [event, event].concat(data));
	    };
	
	    observer.off = function off(event) {
	      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        data[_key2 - 1] = arguments[_key2];
	      }
	
	      observer.removeListener.apply(observer, [event].concat(data));
	    };
	
	    var forwardMessage = function (ev, data) {
	      data = data || {};
	      data.frag = this.frag;
	      data.id = this.id;
	      hls.trigger(ev, data);
	    }.bind(this);
	
	    // forward events to main thread
	    observer.on(events["a" /* default */].FRAG_DECRYPTED, forwardMessage);
	    observer.on(events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, forwardMessage);
	    observer.on(events["a" /* default */].FRAG_PARSING_DATA, forwardMessage);
	    observer.on(events["a" /* default */].FRAG_PARSED, forwardMessage);
	    observer.on(events["a" /* default */].ERROR, forwardMessage);
	    observer.on(events["a" /* default */].FRAG_PARSING_METADATA, forwardMessage);
	    observer.on(events["a" /* default */].FRAG_PARSING_USERDATA, forwardMessage);
	    observer.on(events["a" /* default */].INIT_PTS_FOUND, forwardMessage);
	
	    var typeSupported = {
	      mp4: demuxer_MediaSource.isTypeSupported('video/mp4'),
	      mpeg: demuxer_MediaSource.isTypeSupported('audio/mpeg'),
	      mp3: demuxer_MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
	    };
	    // navigator.vendor is not always available in Web Worker
	    // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
	    var vendor = navigator.vendor;
	    if (config.enableWorker && typeof Worker !== 'undefined') {
	      logger["b" /* logger */].log('demuxing in webworker');
	      var w = void 0;
	      try {
	        w = this.w = webworkify_webpack_default()(/*require.resolve*/(10));
	        this.onwmsg = this.onWorkerMessage.bind(this);
	        w.addEventListener('message', this.onwmsg);
	        w.onerror = function (event) {
	          hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].OTHER_ERROR, details: errors["a" /* ErrorDetails */].INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
	        };
	        w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
	      } catch (err) {
	        logger["b" /* logger */].error('error while initializing DemuxerWorker, fallback on DemuxerInline');
	        if (w) {
	          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
	          URL.revokeObjectURL(w.objectURL);
	        }
	        this.demuxer = new demuxer_inline["a" /* default */](observer, typeSupported, config, vendor);
	        this.w = undefined;
	      }
	    } else {
	      this.demuxer = new demuxer_inline["a" /* default */](observer, typeSupported, config, vendor);
	    }
	  }
	
	  Demuxer.prototype.destroy = function destroy() {
	    var w = this.w;
	    if (w) {
	      w.removeEventListener('message', this.onwmsg);
	      w.terminate();
	      this.w = null;
	    } else {
	      var demuxer = this.demuxer;
	      if (demuxer) {
	        demuxer.destroy();
	        this.demuxer = null;
	      }
	    }
	    var observer = this.observer;
	    if (observer) {
	      observer.removeAllListeners();
	      this.observer = null;
	    }
	  };
	
	  Demuxer.prototype.push = function push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
	    var w = this.w;
	    var timeOffset = !isNaN(frag.startDTS) ? frag.startDTS : frag.start;
	    var decryptdata = frag.decryptdata;
	    var lastFrag = this.frag;
	    var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
	    var trackSwitch = !(lastFrag && frag.level === lastFrag.level);
	    var nextSN = lastFrag && frag.sn === lastFrag.sn + 1;
	    var contiguous = !trackSwitch && nextSN;
	    if (discontinuity) {
	      logger["b" /* logger */].log(this.id + ':discontinuity detected');
	    }
	    if (trackSwitch) {
	      logger["b" /* logger */].log(this.id + ':switch detected');
	    }
	    this.frag = frag;
	    if (w) {
	      // post fragment payload as transferable objects for ArrayBuffer (no copy)
	      w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, defaultInitPTS: defaultInitPTS }, data instanceof ArrayBuffer ? [data] : []);
	    } else {
	      var demuxer = this.demuxer;
	      if (demuxer) {
	        demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
	      }
	    }
	  };
	
	  Demuxer.prototype.onWorkerMessage = function onWorkerMessage(ev) {
	    var data = ev.data,
	        hls = this.hls;
	    //console.log('onWorkerMessage:' + data.event);
	    switch (data.event) {
	      case 'init':
	        // revoke the Object URL that was used to create demuxer worker, so as not to leak it
	        URL.revokeObjectURL(this.w.objectURL);
	        break;
	      // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
	      case events["a" /* default */].FRAG_PARSING_DATA:
	        data.data.data1 = new Uint8Array(data.data1);
	        if (data.data2) {
	          data.data.data2 = new Uint8Array(data.data2);
	        }
	      /* falls through */
	      default:
	        data.data = data.data || {};
	        data.data.frag = this.frag;
	        data.data.id = this.id;
	        hls.trigger(data.event, data.data);
	        break;
	    }
	  };
	
	  return Demuxer;
	}();
	
	/* harmony default export */ var demux_demuxer = (demuxer_Demuxer);
	// CONCATENATED MODULE: ./src/helper/level-helper.js
	/**
	 * Level Helper class, providing methods dealing with playlist sliding and drift
	*/
	
	
	
	function updatePTS(fragments, fromIdx, toIdx) {
	  var fragFrom = fragments[fromIdx],
	      fragTo = fragments[toIdx],
	      fragToPTS = fragTo.startPTS;
	  // if we know startPTS[toIdx]
	  if (!isNaN(fragToPTS)) {
	    // update fragment duration.
	    // it helps to fix drifts between playlist reported duration and fragment real duration
	    if (toIdx > fromIdx) {
	      fragFrom.duration = fragToPTS - fragFrom.start;
	      if (fragFrom.duration < 0) {
	        logger["b" /* logger */].warn('negative duration computed for frag ' + fragFrom.sn + ',level ' + fragFrom.level + ', there should be some duration drift between playlist and fragment!');
	      }
	    } else {
	      fragTo.duration = fragFrom.start - fragToPTS;
	      if (fragTo.duration < 0) {
	        logger["b" /* logger */].warn('negative duration computed for frag ' + fragTo.sn + ',level ' + fragTo.level + ', there should be some duration drift between playlist and fragment!');
	      }
	    }
	  } else {
	    // we dont know startPTS[toIdx]
	    if (toIdx > fromIdx) {
	      fragTo.start = fragFrom.start + fragFrom.duration;
	    } else {
	      fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
	    }
	  }
	}
	
	function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
	  // update frag PTS/DTS
	  var maxStartPTS = startPTS;
	  if (!isNaN(frag.startPTS)) {
	    // delta PTS between audio and video
	    var deltaPTS = Math.abs(frag.startPTS - startPTS);
	    if (isNaN(frag.deltaPTS)) {
	      frag.deltaPTS = deltaPTS;
	    } else {
	      frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
	    }
	    maxStartPTS = Math.max(startPTS, frag.startPTS);
	    startPTS = Math.min(startPTS, frag.startPTS);
	    endPTS = Math.max(endPTS, frag.endPTS);
	    startDTS = Math.min(startDTS, frag.startDTS);
	    endDTS = Math.max(endDTS, frag.endDTS);
	  }
	
	  var drift = startPTS - frag.start;
	  frag.start = frag.startPTS = startPTS;
	  frag.maxStartPTS = maxStartPTS;
	  frag.endPTS = endPTS;
	  frag.startDTS = startDTS;
	  frag.endDTS = endDTS;
	  frag.duration = endPTS - startPTS;
	
	  var sn = frag.sn;
	  // exit if sn out of range
	  if (!details || sn < details.startSN || sn > details.endSN) {
	    return 0;
	  }
	  var fragIdx, fragments, i;
	  fragIdx = sn - details.startSN;
	  fragments = details.fragments;
	  // update frag reference in fragments array
	  // rationale is that fragments array might not contain this frag object.
	  // this will happpen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
	  // if we don't update frag, we won't be able to propagate PTS info on the playlist
	  // resulting in invalid sliding computation
	  fragments[fragIdx] = frag;
	  // adjust fragment PTS/duration from seqnum-1 to frag 0
	  for (i = fragIdx; i > 0; i--) {
	    updatePTS(fragments, i, i - 1);
	  }
	
	  // adjust fragment PTS/duration from seqnum to last frag
	  for (i = fragIdx; i < fragments.length - 1; i++) {
	    updatePTS(fragments, i, i + 1);
	  }
	  details.PTSKnown = true;
	  //logger.log(`                                            frag start/end:${startPTS.toFixed(3)}/${endPTS.toFixed(3)}`);
	
	  return drift;
	}
	
	function mergeDetails(oldDetails, newDetails) {
	  var start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN,
	      end = Math.min(oldDetails.endSN, newDetails.endSN) - newDetails.startSN,
	      delta = newDetails.startSN - oldDetails.startSN,
	      oldfragments = oldDetails.fragments,
	      newfragments = newDetails.fragments,
	      ccOffset = 0,
	      PTSFrag;
	
	  // check if old/new playlists have fragments in common
	  if (end < start) {
	    newDetails.PTSKnown = false;
	    return;
	  }
	  // loop through overlapping SN and update startPTS , cc, and duration if any found
	  for (var i = start; i <= end; i++) {
	    var oldFrag = oldfragments[delta + i],
	        newFrag = newfragments[i];
	    if (newFrag && oldFrag) {
	      ccOffset = oldFrag.cc - newFrag.cc;
	      if (!isNaN(oldFrag.startPTS)) {
	        newFrag.start = newFrag.startPTS = oldFrag.startPTS;
	        newFrag.endPTS = oldFrag.endPTS;
	        newFrag.duration = oldFrag.duration;
	        newFrag.backtracked = oldFrag.backtracked;
	        newFrag.dropped = oldFrag.dropped;
	        PTSFrag = newFrag;
	      }
	    }
	  }
	
	  if (ccOffset) {
	    logger["b" /* logger */].log('discontinuity sliding from playlist, take drift into account');
	    for (i = 0; i < newfragments.length; i++) {
	      newfragments[i].cc += ccOffset;
	    }
	  }
	
	  // if at least one fragment contains PTS info, recompute PTS information for all fragments
	  if (PTSFrag) {
	    updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
	  } else {
	    // ensure that delta is within oldfragments range
	    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
	    // in that case we also need to adjust start offset of all fragments
	    if (delta >= 0 && delta < oldfragments.length) {
	      // adjust start by sliding offset
	      var sliding = oldfragments[delta].start;
	      for (i = 0; i < newfragments.length; i++) {
	        newfragments[i].start += sliding;
	      }
	    }
	  }
	  // if we are here, it means we have fragments overlapping between
	  // old and new level. reliable PTS info is thus relying on old level
	  newDetails.PTSKnown = oldDetails.PTSKnown;
	}
	// CONCATENATED MODULE: ./src/utils/timeRanges.js
	/**
	 *  TimeRanges to string helper
	 */
	
	var TimeRanges = {
	  toString: function toString(r) {
	    var log = '',
	        len = r.length;
	    for (var i = 0; i < len; i++) {
	      log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
	    }
	    return log;
	  }
	};
	
	/* harmony default export */ var timeRanges = (TimeRanges);
	// CONCATENATED MODULE: ./src/utils/discontinuities.js
	
	
	
	function findFirstFragWithCC(fragments, cc) {
	  var firstFrag = null;
	
	  for (var i = 0; i < fragments.length; i += 1) {
	    var currentFrag = fragments[i];
	    if (currentFrag && currentFrag.cc === cc) {
	      firstFrag = currentFrag;
	      break;
	    }
	  }
	
	  return firstFrag;
	}
	
	function findFragWithCC(fragments, CC) {
	  return binary_search.search(fragments, function (candidate) {
	    if (candidate.cc < CC) {
	      return 1;
	    } else if (candidate.cc > CC) {
	      return -1;
	    } else {
	      return 0;
	    }
	  });
	}
	
	function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
	  var shouldAlign = false;
	  if (lastLevel && lastLevel.details && details) {
	    if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) {
	      shouldAlign = true;
	    }
	  }
	  return shouldAlign;
	}
	
	// Find the first frag in the previous level which matches the CC of the first frag of the new level
	function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
	  var prevFrags = prevDetails.fragments;
	  var curFrags = curDetails.fragments;
	
	  if (!curFrags.length || !prevFrags.length) {
	    logger["b" /* logger */].log('No fragments to align');
	    return;
	  }
	
	  var prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
	
	  if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
	    logger["b" /* logger */].log('No frag in previous level to align on');
	    return;
	  }
	
	  return prevStartFrag;
	}
	
	function adjustPts(sliding, details) {
	  details.fragments.forEach(function (frag) {
	    if (frag) {
	      var start = frag.start + sliding;
	      frag.start = frag.startPTS = start;
	      frag.endPTS = start + frag.duration;
	    }
	  });
	  details.PTSKnown = true;
	}
	
	// If a change in CC is detected, the PTS can no longer be relied upon
	// Attempt to align the level by using the last level - find the last frag matching the current CC and use it's PTS
	// as a reference
	function alignDiscontinuities(lastFrag, lastLevel, details) {
	  if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
	    var referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
	    if (referenceFrag) {
	      logger["b" /* logger */].log('Adjusting PTS using last level due to CC increase within current level');
	      adjustPts(referenceFrag.start, details);
	    }
	  }
	  // try to align using programDateTime attribute (if available)
	  if (details.PTSKnown === false && lastLevel && lastLevel.details) {
	    // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
	    // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
	    // then we can deduce that playlist B sliding is 1000+8 = 1008s
	    var lastPDT = lastLevel.details.programDateTime;
	    var newPDT = details.programDateTime;
	    // date diff is in ms. frag.start is in seconds
	    var sliding = (newPDT - lastPDT) / 1000 + lastLevel.details.fragments[0].start;
	    if (!isNaN(sliding)) {
	      logger["b" /* logger */].log('adjusting PTS using programDateTime delta, sliding:' + sliding.toFixed(3));
	      adjustPts(sliding, details);
	    }
	  }
	}
	// CONCATENATED MODULE: ./src/controller/stream-controller.js
	var stream_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function stream_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function stream_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function stream_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Stream Controller
	*/
	
	
	
	
	
	
	
	
	
	
	
	
	var State = {
	  STOPPED: 'STOPPED',
	  IDLE: 'IDLE',
	  KEY_LOADING: 'KEY_LOADING',
	  FRAG_LOADING: 'FRAG_LOADING',
	  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
	  WAITING_LEVEL: 'WAITING_LEVEL',
	  PARSING: 'PARSING',
	  PARSED: 'PARSED',
	  BUFFER_FLUSHING: 'BUFFER_FLUSHING',
	  ENDED: 'ENDED',
	  ERROR: 'ERROR'
	};
	
	var stream_controller_StreamController = function (_EventHandler) {
	  stream_controller__inherits(StreamController, _EventHandler);
	
	  function StreamController(hls) {
	    stream_controller__classCallCheck(this, StreamController);
	
	    var _this = stream_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_PARSED, events["a" /* default */].LEVEL_LOADED, events["a" /* default */].KEY_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].FRAG_LOAD_EMERGENCY_ABORTED, events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, events["a" /* default */].FRAG_PARSING_DATA, events["a" /* default */].FRAG_PARSED, events["a" /* default */].ERROR, events["a" /* default */].AUDIO_TRACK_SWITCHING, events["a" /* default */].AUDIO_TRACK_SWITCHED, events["a" /* default */].BUFFER_CREATED, events["a" /* default */].BUFFER_APPENDED, events["a" /* default */].BUFFER_FLUSHED));
	
	    _this.config = hls.config;
	    _this.audioCodecSwap = false;
	    _this.ticks = 0;
	    _this._state = State.STOPPED;
	    _this.ontick = _this.tick.bind(_this);
	    return _this;
	  }
	
	  StreamController.prototype.destroy = function destroy() {
	    this.stopLoad();
	    if (this.timer) {
	      clearInterval(this.timer);
	      this.timer = null;
	    }
	    event_handler.prototype.destroy.call(this);
	    this.state = State.STOPPED;
	  };
	
	  StreamController.prototype.startLoad = function startLoad(startPosition) {
	    if (this.levels) {
	      var lastCurrentTime = this.lastCurrentTime,
	          hls = this.hls;
	      this.stopLoad();
	      if (!this.timer) {
	        this.timer = setInterval(this.ontick, 100);
	      }
	      this.level = -1;
	      this.fragLoadError = 0;
	      if (!this.startFragRequested) {
	        // determine load level
	        var startLevel = hls.startLevel;
	        if (startLevel === -1) {
	          // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
	          startLevel = 0;
	          this.bitrateTest = true;
	        }
	        // set new level to playlist loader : this will trigger start level load
	        // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
	        this.level = hls.nextLoadLevel = startLevel;
	        this.loadedmetadata = false;
	      }
	      // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
	      if (lastCurrentTime > 0 && startPosition === -1) {
	        logger["b" /* logger */].log('override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
	        startPosition = lastCurrentTime;
	      }
	      this.state = State.IDLE;
	      this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
	      this.tick();
	    } else {
	      this.forceStartLoad = true;
	      this.state = State.STOPPED;
	    }
	  };
	
	  StreamController.prototype.stopLoad = function stopLoad() {
	    var frag = this.fragCurrent;
	    if (frag) {
	      if (frag.loader) {
	        frag.loader.abort();
	      }
	      this.fragCurrent = null;
	    }
	    this.fragPrevious = null;
	    if (this.demuxer) {
	      this.demuxer.destroy();
	      this.demuxer = null;
	    }
	    this.state = State.STOPPED;
	    this.forceStartLoad = false;
	  };
	
	  StreamController.prototype.tick = function tick() {
	    this.ticks++;
	    if (this.ticks === 1) {
	      this.doTick();
	      if (this.ticks > 1) {
	        setTimeout(this.tick, 1);
	      }
	      this.ticks = 0;
	    }
	  };
	
	  StreamController.prototype.doTick = function doTick() {
	    switch (this.state) {
	      case State.ERROR:
	        //don't do anything in error state to avoid breaking further ...
	        break;
	      case State.BUFFER_FLUSHING:
	        // in buffer flushing state, reset fragLoadError counter
	        this.fragLoadError = 0;
	        break;
	      case State.IDLE:
	        this._doTickIdle();
	        break;
	      case State.WAITING_LEVEL:
	        var level = this.levels[this.level];
	        // check if playlist is already loaded
	        if (level && level.details) {
	          this.state = State.IDLE;
	        }
	        break;
	      case State.FRAG_LOADING_WAITING_RETRY:
	        var now = performance.now();
	        var retryDate = this.retryDate;
	        // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
	        if (!retryDate || now >= retryDate || this.media && this.media.seeking) {
	          logger["b" /* logger */].log('mediaController: retryDate reached, switch back to IDLE state');
	          this.state = State.IDLE;
	        }
	        break;
	      case State.ERROR:
	      case State.STOPPED:
	      case State.FRAG_LOADING:
	      case State.PARSING:
	      case State.PARSED:
	      case State.ENDED:
	        break;
	      default:
	        break;
	    }
	    // check buffer
	    this._checkBuffer();
	    // check/update current fragment
	    this._checkFragmentChanged();
	  };
	
	  // Ironically the "idle" state is the on we do the most logic in it seems ....
	  // NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
	  //       played segment, or on pause/play/seek instead of naively checking every 100ms?
	
	
	  StreamController.prototype._doTickIdle = function _doTickIdle() {
	    var hls = this.hls,
	        config = hls.config,
	        media = this.media;
	
	    // if start level not parsed yet OR
	    // if video not attached AND start fragment already requested OR start frag prefetch disable
	    // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
	    if (this.levelLastLoaded === undefined || !media && (this.startFragRequested || !config.startFragPrefetch)) {
	      return;
	    }
	
	    // if we have not yet loaded any fragment, start loading from start position
	    var pos = void 0;
	    if (this.loadedmetadata) {
	      pos = media.currentTime;
	    } else {
	      pos = this.nextLoadPosition;
	    }
	    // determine next load level
	    var level = hls.nextLoadLevel,
	        levelInfo = this.levels[level];
	
	    if (!levelInfo) {
	      return;
	    }
	
	    var levelBitrate = levelInfo.bitrate,
	        maxBufLen = void 0;
	
	    // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
	    if (levelBitrate) {
	      maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
	    } else {
	      maxBufLen = config.maxBufferLength;
	    }
	    maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);
	
	    // determine next candidate fragment to be loaded, based on current position and end of buffer position
	    // ensure up to `config.maxMaxBufferLength` of buffer upfront
	
	    var bufferInfo = buffer_helper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole),
	        bufferLen = bufferInfo.len;
	    // Stay idle if we are still with buffer margins
	    if (bufferLen >= maxBufLen) {
	      return;
	    }
	
	    // if buffer length is less than maxBufLen try to load a new fragment ...
	    logger["b" /* logger */].trace('buffer length of ' + bufferLen.toFixed(3) + ' is below max of ' + maxBufLen.toFixed(3) + '. checking for more payload ...');
	
	    // set next load level : this will trigger a playlist load if needed
	    this.level = hls.nextLoadLevel = level;
	
	    var levelDetails = levelInfo.details;
	    // if level info not retrieved yet, switch state and wait for level retrieval
	    // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
	    // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
	    if (levelDetails === undefined || levelDetails.live === true && this.levelLastLoaded !== level) {
	      this.state = State.WAITING_LEVEL;
	      return;
	    }
	
	    // we just got done loading the final fragment and there is no other buffered range after ...
	    // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
	    // so we should not switch to ENDED in that case, to be able to buffer them
	    // dont switch to ENDED if we need to backtrack last fragment
	    var fragPrevious = this.fragPrevious;
	    if (!levelDetails.live && fragPrevious && !fragPrevious.backtracked && fragPrevious.sn === levelDetails.endSN && !bufferInfo.nextStart) {
	      // fragPrevious is last fragment. retrieve level duration using last frag start offset + duration
	      // real duration might be lower than initial duration if there are drifts between real frag duration and playlist signaling
	      var duration = Math.min(media.duration, fragPrevious.start + fragPrevious.duration);
	      // if everything (almost) til the end is buffered, let's signal eos
	      // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference (audio/video offsets...)
	      // tolerate up to one frag duration to cope with these cases.
	      // also cope with almost zero last frag duration (max last frag duration with 200ms) refer to https://github.com/video-dev/hls.js/pull/657
	      if (duration - Math.max(bufferInfo.end, fragPrevious.start) <= Math.max(0.2, fragPrevious.duration)) {
	        // Finalize the media stream
	        var data = {};
	        if (this.altAudio) {
	          data.type = 'video';
	        }
	        this.hls.trigger(events["a" /* default */].BUFFER_EOS, data);
	        this.state = State.ENDED;
	        return;
	      }
	    }
	
	    // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
	    this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
	  };
	
	  StreamController.prototype._fetchPayloadOrEos = function _fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
	    var fragPrevious = this.fragPrevious,
	        level = this.level,
	        fragments = levelDetails.fragments,
	        fragLen = fragments.length;
	
	    // empty playlist
	    if (fragLen === 0) {
	      return;
	    }
	
	    // find fragment index, contiguous with end of buffer position
	    var start = fragments[0].start,
	        end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
	        bufferEnd = bufferInfo.end,
	        frag = void 0;
	
	    if (levelDetails.initSegment && !levelDetails.initSegment.data) {
	      frag = levelDetails.initSegment;
	    } else {
	      // in case of live playlist we need to ensure that requested position is not located before playlist start
	      if (levelDetails.live) {
	        var initialLiveManifestSize = this.config.initialLiveManifestSize;
	        if (fragLen < initialLiveManifestSize) {
	          logger["b" /* logger */].warn('Can not start playback of a level, reason: not enough fragments ' + fragLen + ' < ' + initialLiveManifestSize);
	          return;
	        }
	
	        frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
	        // if it explicitely returns null don't load any fragment and exit function now
	        if (frag === null) {
	          return;
	        }
	      } else {
	        // VoD playlist: if bufferEnd before start of playlist, load first fragment
	        if (bufferEnd < start) {
	          frag = fragments[0];
	        }
	      }
	    }
	    if (!frag) {
	      frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);
	    }
	    if (frag) {
	      this._loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd);
	    }
	    return;
	  };
	
	  StreamController.prototype._ensureFragmentAtLivePoint = function _ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
	    var config = this.hls.config,
	        media = this.media;
	
	    var frag = void 0;
	
	    // check if requested position is within seekable boundaries :
	    //logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
	    var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
	
	    if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
	      var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
	      logger["b" /* logger */].log('buffer end: ' + bufferEnd.toFixed(3) + ' is located too far from the end of live sliding playlist, reset currentTime to : ' + liveSyncPosition.toFixed(3));
	      bufferEnd = liveSyncPosition;
	      if (media && media.readyState && media.duration > liveSyncPosition) {
	        media.currentTime = liveSyncPosition;
	      }
	      this.nextLoadPosition = liveSyncPosition;
	    }
	
	    // if end of buffer greater than live edge, don't load any fragment
	    // this could happen if live playlist intermittently slides in the past.
	    // level 1 loaded [182580161,182580167]
	    // level 1 loaded [182580162,182580169]
	    // Loading 182580168 of [182580162 ,182580169],level 1 ..
	    // Loading 182580169 of [182580162 ,182580169],level 1 ..
	    // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
	    // level 1 loaded [182580164,182580171]
	    //
	    // don't return null in case media not loaded yet (readystate === 0)
	    if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
	      return null;
	    }
	
	    if (this.startFragRequested && !levelDetails.PTSKnown) {
	      /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
	         try to load frag matching with next SN.
	         even if SN are not synchronized between playlists, loading this frag will help us
	         compute playlist sliding and find the right one after in case it was not the right consecutive one */
	      if (fragPrevious) {
	        var targetSN = fragPrevious.sn + 1;
	        if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
	          var fragNext = fragments[targetSN - levelDetails.startSN];
	          if (fragPrevious.cc === fragNext.cc) {
	            frag = fragNext;
	            logger["b" /* logger */].log('live playlist, switching playlist, load frag with next SN: ' + frag.sn);
	          }
	        }
	        // next frag SN not available (or not with same continuity counter)
	        // look for a frag sharing the same CC
	        if (!frag) {
	          frag = binary_search.search(fragments, function (frag) {
	            return fragPrevious.cc - frag.cc;
	          });
	          if (frag) {
	            logger["b" /* logger */].log('live playlist, switching playlist, load frag with same CC: ' + frag.sn);
	          }
	        }
	      }
	      if (!frag) {
	        /* we have no idea about which fragment should be loaded.
	           so let's load mid fragment. it will help computing playlist sliding and find the right one
	        */
	        frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
	        logger["b" /* logger */].log('live playlist, switching playlist, unknown, load middle frag : ' + frag.sn);
	      }
	    }
	    return frag;
	  };
	
	  StreamController.prototype._findFragment = function _findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails) {
	    var config = this.hls.config;
	    var frag = void 0;
	    var foundFrag = void 0;
	    var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
	    var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
	    var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
	      // offset should be within fragment boundary - config.maxFragLookUpTolerance
	      // this is to cope with situations like
	      // bufferEnd = 9.991
	      // frag[Ø] : [0,10]
	      // frag[1] : [10,20]
	      // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
	      //              frag start               frag start+duration
	      //                  |-----------------------------|
	      //              <--->                         <--->
	      //  ...--------><-----------------------------><---------....
	      // previous frag         matching fragment         next frag
	      //  return -1             return 0                 return 1
	      //logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
	      // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
	      var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
	      if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
	        return 1;
	      } // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
	      else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
	          return -1;
	        }
	      return 0;
	    };
	
	    if (bufferEnd < end) {
	      if (bufferEnd > end - maxFragLookUpTolerance) {
	        maxFragLookUpTolerance = 0;
	      }
	      // Prefer the next fragment if it's within tolerance
	      if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
	        foundFrag = fragNext;
	      } else {
	        foundFrag = binary_search.search(fragments, fragmentWithinToleranceTest);
	      }
	    } else {
	      // reach end of playlist
	      foundFrag = fragments[fragLen - 1];
	    }
	    if (foundFrag) {
	      frag = foundFrag;
	      var curSNIdx = frag.sn - levelDetails.startSN;
	      var sameLevel = fragPrevious && frag.level === fragPrevious.level;
	      var prevFrag = fragments[curSNIdx - 1];
	      var nextFrag = fragments[curSNIdx + 1];
	      //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
	      if (fragPrevious && frag.sn === fragPrevious.sn) {
	        if (sameLevel && !frag.backtracked) {
	          if (frag.sn < levelDetails.endSN) {
	            var deltaPTS = fragPrevious.deltaPTS;
	            // if there is a significant delta between audio and video, larger than max allowed hole,
	            // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
	            // let's try to load previous fragment again to get last keyframe
	            // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
	            if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
	              frag = prevFrag;
	              logger["b" /* logger */].warn('SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this');
	              // decrement previous frag load counter to avoid frag loop loading error when next fragment will get reloaded
	              fragPrevious.loadCounter--;
	            } else {
	              frag = nextFrag;
	              logger["b" /* logger */].log('SN just loaded, load next one: ' + frag.sn);
	            }
	          } else {
	            frag = null;
	          }
	        } else if (frag.backtracked) {
	          // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
	          if (nextFrag && nextFrag.backtracked) {
	            logger["b" /* logger */].warn('Already backtracked from fragment ' + nextFrag.sn + ', will not backtrack to fragment ' + frag.sn + '. Loading fragment ' + nextFrag.sn);
	            frag = nextFrag;
	          } else {
	            // If a fragment has dropped frames and it's in a same level/sequence, load the previous fragment to try and find the keyframe
	            // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
	            logger["b" /* logger */].warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
	            frag.dropped = 0;
	            if (prevFrag) {
	              if (prevFrag.loadCounter) {
	                prevFrag.loadCounter--;
	              }
	              frag = prevFrag;
	              frag.backtracked = true;
	            } else if (curSNIdx) {
	              // can't backtrack on very first fragment
	              frag = null;
	            }
	          }
	        }
	      }
	    }
	    return frag;
	  };
	
	  StreamController.prototype._loadFragmentOrKey = function _loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd) {
	    var hls = this.hls,
	        config = hls.config;
	
	    //logger.log('loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
	    if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
	      logger["b" /* logger */].log('Loading key for ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level);
	      this.state = State.KEY_LOADING;
	      hls.trigger(events["a" /* default */].KEY_LOADING, { frag: frag });
	    } else {
	      logger["b" /* logger */].log('Loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', currentTime:' + pos.toFixed(3) + ',bufferEnd:' + bufferEnd.toFixed(3));
	      // ensure that we are not reloading the same fragments in loop ...
	      if (this.fragLoadIdx !== undefined) {
	        this.fragLoadIdx++;
	      } else {
	        this.fragLoadIdx = 0;
	      }
	      if (frag.loadCounter) {
	        frag.loadCounter++;
	        var maxThreshold = config.fragLoadingLoopThreshold;
	        // if this frag has already been loaded 3 times, and if it has been reloaded recently
	        if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
	          hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
	          return;
	        }
	      } else {
	        frag.loadCounter = 1;
	      }
	      frag.loadIdx = this.fragLoadIdx;
	      frag.autoLevel = hls.autoLevelEnabled;
	      frag.bitrateTest = this.bitrateTest;
	
	      this.fragCurrent = frag;
	      this.startFragRequested = true;
	      // Don't update nextLoadPosition for fragments which are not buffered
	      if (!isNaN(frag.sn) && !frag.bitrateTest) {
	        this.nextLoadPosition = frag.start + frag.duration;
	      }
	      hls.trigger(events["a" /* default */].FRAG_LOADING, { frag: frag });
	      // lazy demuxer init, as this could take some time ... do it during frag loading
	      if (!this.demuxer) {
	        this.demuxer = new demux_demuxer(hls, 'main');
	      }
	      this.state = State.FRAG_LOADING;
	      return;
	    }
	  };
	
	  StreamController.prototype.getBufferedFrag = function getBufferedFrag(position) {
	    return binary_search.search(this._bufferedFrags, function (frag) {
	      if (position < frag.startPTS) {
	        return -1;
	      } else if (position > frag.endPTS) {
	        return 1;
	      }
	      return 0;
	    });
	  };
	
	  StreamController.prototype.followingBufferedFrag = function followingBufferedFrag(frag) {
	    if (frag) {
	      // try to get range of next fragment (500ms after this range)
	      return this.getBufferedFrag(frag.endPTS + 0.5);
	    }
	    return null;
	  };
	
	  StreamController.prototype._checkFragmentChanged = function _checkFragmentChanged() {
	    var fragPlayingCurrent,
	        currentTime,
	        video = this.media;
	    if (video && video.readyState && video.seeking === false) {
	      currentTime = video.currentTime;
	      /* if video element is in seeked state, currentTime can only increase.
	        (assuming that playback rate is positive ...)
	        As sometimes currentTime jumps back to zero after a
	        media decode error, check this, to avoid seeking back to
	        wrong position after a media decode error
	      */
	      if (currentTime > video.playbackRate * this.lastCurrentTime) {
	        this.lastCurrentTime = currentTime;
	      }
	      if (buffer_helper.isBuffered(video, currentTime)) {
	        fragPlayingCurrent = this.getBufferedFrag(currentTime);
	      } else if (buffer_helper.isBuffered(video, currentTime + 0.1)) {
	        /* ensure that FRAG_CHANGED event is triggered at startup,
	          when first video frame is displayed and playback is paused.
	          add a tolerance of 100ms, in case current position is not buffered,
	          check if current pos+100ms is buffered and use that buffer range
	          for FRAG_CHANGED event reporting */
	        fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
	      }
	      if (fragPlayingCurrent) {
	        var fragPlaying = fragPlayingCurrent;
	        if (fragPlaying !== this.fragPlaying) {
	          this.hls.trigger(events["a" /* default */].FRAG_CHANGED, { frag: fragPlaying });
	          var fragPlayingLevel = fragPlaying.level;
	          if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) {
	            this.hls.trigger(events["a" /* default */].LEVEL_SWITCHED, { level: fragPlayingLevel });
	          }
	          this.fragPlaying = fragPlaying;
	        }
	      }
	    }
	  };
	
	  /*
	    on immediate level switch :
	     - pause playback if playing
	     - cancel any pending load request
	     - and trigger a buffer flush
	  */
	
	
	  StreamController.prototype.immediateLevelSwitch = function immediateLevelSwitch() {
	    logger["b" /* logger */].log('immediateLevelSwitch');
	    if (!this.immediateSwitch) {
	      this.immediateSwitch = true;
	      var media = this.media,
	          previouslyPaused = void 0;
	      if (media) {
	        previouslyPaused = media.paused;
	        media.pause();
	      } else {
	        // don't restart playback after instant level switch in case media not attached
	        previouslyPaused = true;
	      }
	      this.previouslyPaused = previouslyPaused;
	    }
	    var fragCurrent = this.fragCurrent;
	    if (fragCurrent && fragCurrent.loader) {
	      fragCurrent.loader.abort();
	    }
	    this.fragCurrent = null;
	    // increase fragment load Index to avoid frag loop loading error after buffer flush
	    if (this.fragLoadIdx !== undefined) {
	      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	    }
	    // flush everything
	    this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
	  };
	
	  /*
	     on immediate level switch end, after new fragment has been buffered :
	      - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
	      - resume the playback if needed
	  */
	
	
	  StreamController.prototype.immediateLevelSwitchEnd = function immediateLevelSwitchEnd() {
	    var media = this.media;
	    if (media && media.buffered.length) {
	      this.immediateSwitch = false;
	      if (buffer_helper.isBuffered(media, media.currentTime)) {
	        // only nudge if currentTime is buffered
	        media.currentTime -= 0.0001;
	      }
	      if (!this.previouslyPaused) {
	        media.play();
	      }
	    }
	  };
	
	  StreamController.prototype.nextLevelSwitch = function nextLevelSwitch() {
	    /* try to switch ASAP without breaking video playback :
	       in order to ensure smooth but quick level switching,
	      we need to find the next flushable buffer range
	      we should take into account new segment fetch time
	    */
	    var media = this.media;
	    // ensure that media is defined and that metadata are available (to retrieve currentTime)
	    if (media && media.readyState) {
	      var fetchdelay = void 0,
	          fragPlayingCurrent = void 0,
	          nextBufferedFrag = void 0;
	      if (this.fragLoadIdx !== undefined) {
	        // increase fragment load Index to avoid frag loop loading error after buffer flush
	        this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	      }
	      fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
	      if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
	        // flush buffer preceding current fragment (flush until current fragment start offset)
	        // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
	        this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
	      }
	      if (!media.paused) {
	        // add a safety delay of 1s
	        var nextLevelId = this.hls.nextLoadLevel,
	            nextLevel = this.levels[nextLevelId],
	            fragLastKbps = this.fragLastKbps;
	        if (fragLastKbps && this.fragCurrent) {
	          fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
	        } else {
	          fetchdelay = 0;
	        }
	      } else {
	        fetchdelay = 0;
	      }
	      //logger.log('fetchdelay:'+fetchdelay);
	      // find buffer range that will be reached once new fragment will be fetched
	      nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
	      if (nextBufferedFrag) {
	        // we can flush buffer range following this one without stalling playback
	        nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
	        if (nextBufferedFrag) {
	          // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
	          var fragCurrent = this.fragCurrent;
	          if (fragCurrent && fragCurrent.loader) {
	            fragCurrent.loader.abort();
	          }
	          this.fragCurrent = null;
	          // start flush position is the start PTS of next buffered frag.
	          // we use frag.naxStartPTS which is max(audio startPTS, video startPTS).
	          // in case there is a small PTS Delta between audio and video, using maxStartPTS avoids flushing last samples from current fragment
	          this.flushMainBuffer(nextBufferedFrag.maxStartPTS, Number.POSITIVE_INFINITY);
	        }
	      }
	    }
	  };
	
	  StreamController.prototype.flushMainBuffer = function flushMainBuffer(startOffset, endOffset) {
	    this.state = State.BUFFER_FLUSHING;
	    var flushScope = { startOffset: startOffset, endOffset: endOffset };
	    // if alternate audio tracks are used, only flush video, otherwise flush everything
	    if (this.altAudio) {
	      flushScope.type = 'video';
	    }
	    this.hls.trigger(events["a" /* default */].BUFFER_FLUSHING, flushScope);
	  };
	
	  StreamController.prototype.onMediaAttached = function onMediaAttached(data) {
	    var media = this.media = this.mediaBuffer = data.media;
	    this.onvseeking = this.onMediaSeeking.bind(this);
	    this.onvseeked = this.onMediaSeeked.bind(this);
	    this.onvended = this.onMediaEnded.bind(this);
	    media.addEventListener('seeking', this.onvseeking);
	    media.addEventListener('seeked', this.onvseeked);
	    media.addEventListener('ended', this.onvended);
	    var config = this.config;
	    if (this.levels && config.autoStartLoad) {
	      this.hls.startLoad(config.startPosition);
	    }
	  };
	
	  StreamController.prototype.onMediaDetaching = function onMediaDetaching() {
	    var media = this.media;
	    if (media && media.ended) {
	      logger["b" /* logger */].log('MSE detaching and video ended, reset startPosition');
	      this.startPosition = this.lastCurrentTime = 0;
	    }
	
	    // reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
	    var levels = this.levels;
	    if (levels) {
	      // reset fragment load counter
	      levels.forEach(function (level) {
	        if (level.details) {
	          level.details.fragments.forEach(function (fragment) {
	            fragment.loadCounter = undefined;
	            fragment.backtracked = undefined;
	          });
	        }
	      });
	    }
	    // remove video listeners
	    if (media) {
	      media.removeEventListener('seeking', this.onvseeking);
	      media.removeEventListener('seeked', this.onvseeked);
	      media.removeEventListener('ended', this.onvended);
	      this.onvseeking = this.onvseeked = this.onvended = null;
	    }
	    this.media = this.mediaBuffer = null;
	    this.loadedmetadata = false;
	    this.stopLoad();
	  };
	
	  StreamController.prototype.onMediaSeeking = function onMediaSeeking() {
	    var media = this.media,
	        currentTime = media ? media.currentTime : undefined,
	        config = this.config;
	    if (!isNaN(currentTime)) {
	      logger["b" /* logger */].log('media seeking to ' + currentTime.toFixed(3));
	    }
	    var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
	    var bufferInfo = buffer_helper.bufferInfo(mediaBuffer, currentTime, this.config.maxBufferHole);
	    if (this.state === State.FRAG_LOADING) {
	      var fragCurrent = this.fragCurrent;
	      // check if we are seeking to a unbuffered area AND if frag loading is in progress
	      if (bufferInfo.len === 0 && fragCurrent) {
	        var tolerance = config.maxFragLookUpTolerance,
	            fragStartOffset = fragCurrent.start - tolerance,
	            fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
	        // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
	        if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
	          if (fragCurrent.loader) {
	            logger["b" /* logger */].log('seeking outside of buffer while fragment load in progress, cancel fragment load');
	            fragCurrent.loader.abort();
	          }
	          this.fragCurrent = null;
	          this.fragPrevious = null;
	          // switch to IDLE state to load new fragment
	          this.state = State.IDLE;
	        } else {
	          logger["b" /* logger */].log('seeking outside of buffer but within currently loaded fragment range');
	        }
	      }
	    } else if (this.state === State.ENDED) {
	      // if seeking to unbuffered area, clean up fragPrevious
	      if (bufferInfo.len === 0) {
	        this.fragPrevious = 0;
	      }
	      // switch to IDLE state to check for potential new fragment
	      this.state = State.IDLE;
	    }
	    if (media) {
	      this.lastCurrentTime = currentTime;
	    }
	    // avoid reporting fragment loop loading error in case user is seeking several times on same position
	    if (this.state !== State.FRAG_LOADING && this.fragLoadIdx !== undefined) {
	      this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
	    }
	    // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
	    if (!this.loadedmetadata) {
	      this.nextLoadPosition = this.startPosition = currentTime;
	    }
	    // tick to speed up processing
	    this.tick();
	  };
	
	  StreamController.prototype.onMediaSeeked = function onMediaSeeked() {
	    var media = this.media,
	        currentTime = media ? media.currentTime : undefined;
	    if (!isNaN(currentTime)) {
	      logger["b" /* logger */].log('media seeked to ' + currentTime.toFixed(3));
	    }
	    // tick to speed up FRAGMENT_PLAYING triggering
	    this.tick();
	  };
	
	  StreamController.prototype.onMediaEnded = function onMediaEnded() {
	    logger["b" /* logger */].log('media ended');
	    // reset startPosition and lastCurrentTime to restart playback @ stream beginning
	    this.startPosition = this.lastCurrentTime = 0;
	  };
	
	  StreamController.prototype.onManifestLoading = function onManifestLoading() {
	    // reset buffer on manifest loading
	    logger["b" /* logger */].log('trigger BUFFER_RESET');
	    this.hls.trigger(events["a" /* default */].BUFFER_RESET);
	    this._bufferedFrags = [];
	    this.stalled = false;
	    this.startPosition = this.lastCurrentTime = 0;
	  };
	
	  StreamController.prototype.onManifestParsed = function onManifestParsed(data) {
	    var aac = false,
	        heaac = false,
	        codec;
	    data.levels.forEach(function (level) {
	      // detect if we have different kind of audio codecs used amongst playlists
	      codec = level.audioCodec;
	      if (codec) {
	        if (codec.indexOf('mp4a.40.2') !== -1) {
	          aac = true;
	        }
	        if (codec.indexOf('mp4a.40.5') !== -1) {
	          heaac = true;
	        }
	      }
	    });
	    this.audioCodecSwitch = aac && heaac;
	    if (this.audioCodecSwitch) {
	      logger["b" /* logger */].log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
	    }
	    this.levels = data.levels;
	    this.startFragRequested = false;
	    var config = this.config;
	    if (config.autoStartLoad || this.forceStartLoad) {
	      this.hls.startLoad(config.startPosition);
	    }
	  };
	
	  StreamController.prototype.onLevelLoaded = function onLevelLoaded(data) {
	    var newDetails = data.details;
	    var newLevelId = data.level;
	    var lastLevel = this.levels[this.levelLastLoaded];
	    var curLevel = this.levels[newLevelId];
	    var duration = newDetails.totalduration;
	    var sliding = 0;
	
	    logger["b" /* logger */].log('level ' + newLevelId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);
	
	    if (newDetails.live) {
	      var curDetails = curLevel.details;
	      if (curDetails && newDetails.fragments.length > 0) {
	        // we already have details for that level, merge them
	        mergeDetails(curDetails, newDetails);
	        sliding = newDetails.fragments[0].start;
	        this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
	        if (newDetails.PTSKnown && !isNaN(sliding)) {
	          logger["b" /* logger */].log('live playlist sliding:' + sliding.toFixed(3));
	        } else {
	          logger["b" /* logger */].log('live playlist - outdated PTS, unknown sliding');
	          alignDiscontinuities(this.fragPrevious, lastLevel, newDetails);
	        }
	      } else {
	        logger["b" /* logger */].log('live playlist - first load, unknown sliding');
	        newDetails.PTSKnown = false;
	        alignDiscontinuities(this.fragPrevious, lastLevel, newDetails);
	      }
	    } else {
	      newDetails.PTSKnown = false;
	    }
	    // override level info
	    curLevel.details = newDetails;
	    this.levelLastLoaded = newLevelId;
	    this.hls.trigger(events["a" /* default */].LEVEL_UPDATED, { details: newDetails, level: newLevelId });
	
	    if (this.startFragRequested === false) {
	      // compute start position if set to -1. use it straight away if value is defined
	      if (this.startPosition === -1 || this.lastCurrentTime === -1) {
	        // first, check if start time offset has been set in playlist, if yes, use this value
	        var startTimeOffset = newDetails.startTimeOffset;
	        if (!isNaN(startTimeOffset)) {
	          if (startTimeOffset < 0) {
	            logger["b" /* logger */].log('negative start time offset ' + startTimeOffset + ', count from end of last fragment');
	            startTimeOffset = sliding + duration + startTimeOffset;
	          }
	          logger["b" /* logger */].log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
	          this.startPosition = startTimeOffset;
	        } else {
	          // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
	          if (newDetails.live) {
	            this.startPosition = this.computeLivePosition(sliding, newDetails);
	            logger["b" /* logger */].log('configure startPosition to ' + this.startPosition);
	          } else {
	            this.startPosition = 0;
	          }
	        }
	        this.lastCurrentTime = this.startPosition;
	      }
	      this.nextLoadPosition = this.startPosition;
	    }
	    // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
	    if (this.state === State.WAITING_LEVEL) {
	      this.state = State.IDLE;
	    }
	    //trigger handler right now
	    this.tick();
	  };
	
	  StreamController.prototype.onKeyLoaded = function onKeyLoaded() {
	    if (this.state === State.KEY_LOADING) {
	      this.state = State.IDLE;
	      this.tick();
	    }
	  };
	
	  StreamController.prototype.onFragLoaded = function onFragLoaded(data) {
	    var fragCurrent = this.fragCurrent,
	        fragLoaded = data.frag;
	    if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'main' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
	      var stats = data.stats,
	          currentLevel = this.levels[fragCurrent.level],
	          details = currentLevel.details;
	      logger["b" /* logger */].log('Loaded  ' + fragCurrent.sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + fragCurrent.level);
	      // reset frag bitrate test in any case after frag loaded event
	      this.bitrateTest = false;
	      this.stats = stats;
	      // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
	      // then this means that we should be able to load a fragment at a higher quality level
	      if (fragLoaded.bitrateTest === true && this.hls.nextLoadLevel) {
	        // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
	        this.state = State.IDLE;
	        this.startFragRequested = false;
	        stats.tparsed = stats.tbuffered = performance.now();
	        this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
	        this.tick();
	      } else if (fragLoaded.sn === 'initSegment') {
	        this.state = State.IDLE;
	        stats.tparsed = stats.tbuffered = performance.now();
	        details.initSegment.data = data.payload;
	        this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
	        this.tick();
	      } else {
	        this.state = State.PARSING;
	        // transmux the MPEG-TS data to ISO-BMFF segments
	        var duration = details.totalduration,
	            level = fragCurrent.level,
	            sn = fragCurrent.sn,
	            audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
	        if (this.audioCodecSwap) {
	          logger["b" /* logger */].log('swapping playlist audio codec');
	          if (audioCodec === undefined) {
	            audioCodec = this.lastAudioCodec;
	          }
	          if (audioCodec) {
	            if (audioCodec.indexOf('mp4a.40.5') !== -1) {
	              audioCodec = 'mp4a.40.2';
	            } else {
	              audioCodec = 'mp4a.40.5';
	            }
	          }
	        }
	        this.pendingBuffering = true;
	        this.appended = false;
	        logger["b" /* logger */].log('Parsing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + level + ', cc ' + fragCurrent.cc);
	        var demuxer = this.demuxer;
	        if (!demuxer) {
	          demuxer = this.demuxer = new demux_demuxer(this.hls, 'main');
	        }
	        // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
	        var media = this.media;
	        var mediaSeeking = media && media.seeking;
	        var accurateTimeOffset = !mediaSeeking && (details.PTSKnown || !details.live);
	        var initSegmentData = details.initSegment ? details.initSegment.data : [];
	        demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, duration, accurateTimeOffset, undefined);
	      }
	    }
	    this.fragLoadError = 0;
	  };
	
	  StreamController.prototype.onFragParsingInitSegment = function onFragParsingInitSegment(data) {
	    var fragCurrent = this.fragCurrent;
	    var fragNew = data.frag;
	    if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
	      var tracks = data.tracks,
	          trackName,
	          track;
	
	      // if audio track is expected to come from audio stream controller, discard any coming from main
	      if (tracks.audio && this.altAudio) {
	        delete tracks.audio;
	      }
	      // include levelCodec in audio and video tracks
	      track = tracks.audio;
	      if (track) {
	        var audioCodec = this.levels[this.level].audioCodec,
	            ua = navigator.userAgent.toLowerCase();
	        if (audioCodec && this.audioCodecSwap) {
	          logger["b" /* logger */].log('swapping playlist audio codec');
	          if (audioCodec.indexOf('mp4a.40.5') !== -1) {
	            audioCodec = 'mp4a.40.2';
	          } else {
	            audioCodec = 'mp4a.40.5';
	          }
	        }
	        // in case AAC and HE-AAC audio codecs are signalled in manifest
	        // force HE-AAC , as it seems that most browsers prefers that way,
	        // except for mono streams OR on FF
	        // these conditions might need to be reviewed ...
	        if (this.audioCodecSwitch) {
	          // don't force HE-AAC if mono stream
	          if (track.metadata.channelCount !== 1 &&
	          // don't force HE-AAC if firefox
	          ua.indexOf('firefox') === -1) {
	            audioCodec = 'mp4a.40.5';
	          }
	        }
	        // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
	        if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') {
	          // Exclude mpeg audio
	          audioCodec = 'mp4a.40.2';
	          logger["b" /* logger */].log('Android: force audio codec to ' + audioCodec);
	        }
	        track.levelCodec = audioCodec;
	        track.id = data.id;
	      }
	      track = tracks.video;
	      if (track) {
	        track.levelCodec = this.levels[this.level].videoCodec;
	        track.id = data.id;
	      }
	      this.hls.trigger(events["a" /* default */].BUFFER_CODECS, tracks);
	      // loop through tracks that are going to be provided to bufferController
	      for (trackName in tracks) {
	        track = tracks[trackName];
	        logger["b" /* logger */].log('main track:' + trackName + ',container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
	        var initSegment = track.initSegment;
	        if (initSegment) {
	          this.appended = true;
	          // arm pending Buffering flag before appending a segment
	          this.pendingBuffering = true;
	          this.hls.trigger(events["a" /* default */].BUFFER_APPENDING, { type: trackName, data: initSegment, parent: 'main', content: 'initSegment' });
	        }
	      }
	      //trigger handler right now
	      this.tick();
	    }
	  };
	
	  StreamController.prototype.onFragParsingData = function onFragParsingData(data) {
	    var _this2 = this;
	
	    var fragCurrent = this.fragCurrent;
	    var fragNew = data.frag;
	    if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
	    this.state === State.PARSING) {
	      var level = this.levels[this.level],
	          frag = fragCurrent;
	      if (isNaN(data.endPTS)) {
	        data.endPTS = data.startPTS + fragCurrent.duration;
	        data.endDTS = data.startDTS + fragCurrent.duration;
	      }
	
	      logger["b" /* logger */].log('Parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb + ',dropped:' + (data.dropped || 0));
	
	      // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
	      if (data.type === 'video') {
	        frag.dropped = data.dropped;
	        if (frag.dropped) {
	          if (!frag.backtracked) {
	            var levelDetails = level.details;
	            if (levelDetails && frag.sn === levelDetails.startSN) {
	              logger["b" /* logger */].warn('missing video frame(s) on first frag, appending with gap');
	            } else {
	              logger["b" /* logger */].warn('missing video frame(s), backtracking fragment');
	              // Return back to the IDLE state without appending to buffer
	              // Causes findFragments to backtrack a segment and find the keyframe
	              // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
	              frag.backtracked = true;
	              this.nextLoadPosition = data.startPTS;
	              this.state = State.IDLE;
	              this.fragPrevious = frag;
	              this.tick();
	              return;
	            }
	          } else {
	            logger["b" /* logger */].warn('Already backtracked on this fragment, appending with the gap');
	          }
	        } else {
	          // Only reset the backtracked flag if we've loaded the frag without any dropped frames
	          frag.backtracked = false;
	        }
	      }
	
	      var drift = updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS),
	          hls = this.hls;
	      hls.trigger(events["a" /* default */].LEVEL_PTS_UPDATED, { details: level.details, level: this.level, drift: drift, type: data.type, start: data.startPTS, end: data.endPTS });
	
	      // has remuxer dropped video frames located before first keyframe ?
	      [data.data1, data.data2].forEach(function (buffer) {
	        // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
	        // in that case it is useless to append following segments
	        if (buffer && buffer.length && _this2.state === State.PARSING) {
	          _this2.appended = true;
	          // arm pending Buffering flag before appending a segment
	          _this2.pendingBuffering = true;
	          hls.trigger(events["a" /* default */].BUFFER_APPENDING, { type: data.type, data: buffer, parent: 'main', content: 'data' });
	        }
	      });
	      //trigger handler right now
	      this.tick();
	    }
	  };
	
	  StreamController.prototype.onFragParsed = function onFragParsed(data) {
	    var fragCurrent = this.fragCurrent;
	    var fragNew = data.frag;
	    if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
	      this.stats.tparsed = performance.now();
	      this.state = State.PARSED;
	      this._checkAppendedParsed();
	    }
	  };
	
	  StreamController.prototype.onAudioTrackSwitching = function onAudioTrackSwitching(data) {
	    // if any URL found on new audio track, it is an alternate audio track
	    var altAudio = !!data.url,
	        trackId = data.id;
	    // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
	    // don't do anything if we switch to alt audio: audio stream controller is handling it.
	    // we will just have to change buffer scheduling on audioTrackSwitched
	    if (!altAudio) {
	      if (this.mediaBuffer !== this.media) {
	        logger["b" /* logger */].log('switching on main audio, use media.buffered to schedule main fragment loading');
	        this.mediaBuffer = this.media;
	        var fragCurrent = this.fragCurrent;
	        // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
	        if (fragCurrent.loader) {
	          logger["b" /* logger */].log('switching to main audio track, cancel main fragment load');
	          fragCurrent.loader.abort();
	        }
	        this.fragCurrent = null;
	        this.fragPrevious = null;
	        // destroy demuxer to force init segment generation (following audio switch)
	        if (this.demuxer) {
	          this.demuxer.destroy();
	          this.demuxer = null;
	        }
	        // switch to IDLE state to load new fragment
	        this.state = State.IDLE;
	      }
	      var hls = this.hls;
	      // switching to main audio, flush all audio and trigger track switched
	      hls.trigger(events["a" /* default */].BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
	      hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: trackId });
	      this.altAudio = false;
	    }
	  };
	
	  StreamController.prototype.onAudioTrackSwitched = function onAudioTrackSwitched(data) {
	    var trackId = data.id,
	        altAudio = !!this.hls.audioTracks[trackId].url;
	    if (altAudio) {
	      var videoBuffer = this.videoBuffer;
	      // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
	      if (videoBuffer && this.mediaBuffer !== videoBuffer) {
	        logger["b" /* logger */].log('switching on alternate audio, use video.buffered to schedule main fragment loading');
	        this.mediaBuffer = videoBuffer;
	      }
	    }
	    this.altAudio = altAudio;
	    this.tick();
	  };
	
	  StreamController.prototype.onBufferCreated = function onBufferCreated(data) {
	    var tracks = data.tracks,
	        mediaTrack = void 0,
	        name = void 0,
	        alternate = false;
	    for (var type in tracks) {
	      var track = tracks[type];
	      if (track.id === 'main') {
	        name = type;
	        mediaTrack = track;
	        // keep video source buffer reference
	        if (type === 'video') {
	          this.videoBuffer = tracks[type].buffer;
	        }
	      } else {
	        alternate = true;
	      }
	    }
	    if (alternate && mediaTrack) {
	      logger["b" /* logger */].log('alternate track found, use ' + name + '.buffered to schedule main fragment loading');
	      this.mediaBuffer = mediaTrack.buffer;
	    } else {
	      this.mediaBuffer = this.media;
	    }
	  };
	
	  StreamController.prototype.onBufferAppended = function onBufferAppended(data) {
	    if (data.parent === 'main') {
	      var state = this.state;
	      if (state === State.PARSING || state === State.PARSED) {
	        // check if all buffers have been appended
	        this.pendingBuffering = data.pending > 0;
	        this._checkAppendedParsed();
	      }
	    }
	  };
	
	  StreamController.prototype._checkAppendedParsed = function _checkAppendedParsed() {
	    //trigger handler right now
	    if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
	      var frag = this.fragCurrent;
	      if (frag) {
	        var media = this.mediaBuffer ? this.mediaBuffer : this.media;
	        logger["b" /* logger */].log('main buffered : ' + timeRanges.toString(media.buffered));
	        // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
	        var bufferedFrags = this._bufferedFrags.filter(function (frag) {
	          return buffer_helper.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
	        });
	        // push new range
	        bufferedFrags.push(frag);
	        // sort frags, as we use BinarySearch for lookup in getBufferedFrag ...
	        this._bufferedFrags = bufferedFrags.sort(function (a, b) {
	          return a.startPTS - b.startPTS;
	        });
	        this.fragPrevious = frag;
	        var stats = this.stats;
	        stats.tbuffered = performance.now();
	        // we should get rid of this.fragLastKbps
	        this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
	        this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
	        this.state = State.IDLE;
	      }
	      this.tick();
	    }
	  };
	
	  StreamController.prototype.onError = function onError(data) {
	    var frag = data.frag || this.fragCurrent;
	    // don't handle frag error not related to main fragment
	    if (frag && frag.type !== 'main') {
	      return;
	    }
	    // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
	    var mediaBuffered = !!this.media && buffer_helper.isBuffered(this.media, this.media.currentTime) && buffer_helper.isBuffered(this.media, this.media.currentTime + 0.5);
	
	    switch (data.details) {
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
	      case errors["a" /* ErrorDetails */].KEY_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT:
	        if (!data.fatal) {
	          // keep retrying until the limit will be reached
	          if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
	            // exponential backoff capped to config.fragLoadingMaxRetryTimeout
	            var delay = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
	            // reset load counter to avoid frag loop loading error
	            frag.loadCounter = 0;
	            logger["b" /* logger */].warn('mediaController: frag loading failed, retry in ' + delay + ' ms');
	            this.retryDate = performance.now() + delay;
	            // retry loading state
	            // if loadedmetadata is not set, it means that we are emergency switch down on first frag
	            // in that case, reset startFragRequested flag
	            if (!this.loadedmetadata) {
	              this.startFragRequested = false;
	              this.nextLoadPosition = this.startPosition;
	            }
	            this.fragLoadError++;
	            this.state = State.FRAG_LOADING_WAITING_RETRY;
	          } else {
	            logger["b" /* logger */].error('mediaController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
	            // switch error to fatal
	            data.fatal = true;
	            this.state = State.ERROR;
	          }
	        }
	        break;
	      case errors["a" /* ErrorDetails */].FRAG_LOOP_LOADING_ERROR:
	        if (!data.fatal) {
	          // if buffer is not empty
	          if (mediaBuffered) {
	            // try to reduce max buffer length : rationale is that we could get
	            // frag loop loading error because of buffer eviction
	            this._reduceMaxBufferLength(frag.duration);
	            this.state = State.IDLE;
	          } else {
	            // buffer empty. report as fatal if in manual mode or if lowest level.
	            // level controller takes care of emergency switch down logic
	            if (!frag.autoLevel || frag.level === 0) {
	              // switch error to fatal
	              data.fatal = true;
	              this.state = State.ERROR;
	            }
	          }
	        }
	        break;
	      case errors["a" /* ErrorDetails */].LEVEL_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].LEVEL_LOAD_TIMEOUT:
	        if (this.state !== State.ERROR) {
	          if (data.fatal) {
	            // if fatal error, stop processing
	            this.state = State.ERROR;
	            logger["b" /* logger */].warn('streamController: ' + data.details + ',switch to ' + this.state + ' state ...');
	          } else {
	            // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
	            if (!data.levelRetry && this.state === State.WAITING_LEVEL) {
	              this.state = State.IDLE;
	            }
	          }
	        }
	        break;
	      case errors["a" /* ErrorDetails */].BUFFER_FULL_ERROR:
	        // if in appending state
	        if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
	          // reduce max buf len if current position is buffered
	          if (mediaBuffered) {
	            this._reduceMaxBufferLength(this.config.maxBufferLength);
	            this.state = State.IDLE;
	          } else {
	            // current position is not buffered, but browser is still complaining about buffer full error
	            // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
	            // in that case flush the whole buffer to recover
	            logger["b" /* logger */].warn('buffer full error also media.currentTime is not buffered, flush everything');
	            this.fragCurrent = null;
	            // flush everything
	            this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
	          }
	        }
	        break;
	      default:
	        break;
	    }
	  };
	
	  StreamController.prototype._reduceMaxBufferLength = function _reduceMaxBufferLength(minLength) {
	    var config = this.config;
	    if (config.maxMaxBufferLength >= minLength) {
	      // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
	      config.maxMaxBufferLength /= 2;
	      logger["b" /* logger */].warn('main:reduce max buffer length to ' + config.maxMaxBufferLength + 's');
	      if (this.fragLoadIdx !== undefined) {
	        // increase fragment load Index to avoid frag loop loading error after buffer flush
	        this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
	      }
	    }
	  };
	
	  StreamController.prototype._checkBuffer = function _checkBuffer() {
	    var media = this.media,
	        config = this.config;
	    // if ready state different from HAVE_NOTHING (numeric value 0), we are allowed to seek
	    if (media && media.readyState) {
	      var currentTime = media.currentTime,
	          mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media,
	          buffered = mediaBuffer.buffered;
	      // adjust currentTime to start position on loaded metadata
	      if (!this.loadedmetadata && buffered.length) {
	        this.loadedmetadata = true;
	        // only adjust currentTime if different from startPosition or if startPosition not buffered
	        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
	        var startPosition = media.seeking ? currentTime : this.startPosition,
	            startPositionBuffered = buffer_helper.isBuffered(mediaBuffer, startPosition),
	            firstbufferedPosition = buffered.start(0),
	            startNotBufferedButClose = !startPositionBuffered && Math.abs(startPosition - firstbufferedPosition) < config.maxSeekHole;
	        // if currentTime not matching with expected startPosition or startPosition not buffered but close to first buffered
	        if (currentTime !== startPosition || startNotBufferedButClose) {
	          logger["b" /* logger */].log('target start position:' + startPosition);
	          // if startPosition not buffered, let's seek to buffered.start(0)
	          if (startNotBufferedButClose) {
	            startPosition = firstbufferedPosition;
	            logger["b" /* logger */].log('target start position not buffered, seek to buffered.start(0) ' + startPosition);
	          }
	          logger["b" /* logger */].log('adjust currentTime from ' + currentTime + ' to ' + startPosition);
	          media.currentTime = startPosition;
	        }
	      } else if (this.immediateSwitch) {
	        this.immediateLevelSwitchEnd();
	      } else {
	        var bufferInfo = buffer_helper.bufferInfo(media, currentTime, 0),
	            expectedPlaying = !(media.paused || // not playing when media is paused
	        media.ended || // not playing when media is ended
	        media.buffered.length === 0),
	            // not playing if nothing buffered
	        jumpThreshold = 0.5,
	            // tolerance needed as some browsers stalls playback before reaching buffered range end
	        playheadMoving = currentTime !== this.lastCurrentTime;
	
	        if (playheadMoving) {
	          // played moving, but was previously stalled => now not stuck anymore
	          if (this.stallReported) {
	            logger["b" /* logger */].warn('playback not stuck anymore @' + currentTime + ', after ' + Math.round(performance.now() - this.stalled) + 'ms');
	            this.stallReported = false;
	          }
	          this.stalled = undefined;
	          this.nudgeRetry = 0;
	        } else {
	          // playhead not moving
	          if (expectedPlaying) {
	            // playhead not moving BUT media expected to play
	            var tnow = performance.now();
	            var hls = this.hls;
	            if (!this.stalled) {
	              // stall just detected, store current time
	              this.stalled = tnow;
	              this.stallReported = false;
	            } else {
	              // playback already stalled, check stalling duration
	              // if stalling for more than a given threshold, let's try to recover
	              var stalledDuration = tnow - this.stalled;
	              var bufferLen = bufferInfo.len;
	              var nudgeRetry = this.nudgeRetry || 0;
	              // have we reached stall deadline ?
	              if (bufferLen <= jumpThreshold && stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
	                // report stalled error once
	                if (!this.stallReported) {
	                  this.stallReported = true;
	                  logger["b" /* logger */].warn('playback stalling in low buffer @' + currentTime);
	                  hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
	                }
	                // if buffer len is below threshold, try to jump to start of next buffer range if close
	                // no buffer available @ currentTime, check if next buffer is close (within a config.maxSeekHole second range)
	                var nextBufferStart = bufferInfo.nextStart,
	                    delta = nextBufferStart - currentTime;
	                if (nextBufferStart && delta < config.maxSeekHole && delta > 0) {
	                  this.nudgeRetry = ++nudgeRetry;
	                  var nudgeOffset = nudgeRetry * config.nudgeOffset;
	                  // next buffer is close ! adjust currentTime to nextBufferStart
	                  // this will ensure effective video decoding
	                  logger["b" /* logger */].log('adjust currentTime from ' + media.currentTime + ' to next buffered @ ' + nextBufferStart + ' + nudge ' + nudgeOffset);
	                  media.currentTime = nextBufferStart + nudgeOffset;
	                  // reset stalled so to rearm watchdog timer
	                  this.stalled = undefined;
	                  hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_SEEK_OVER_HOLE, fatal: false, hole: nextBufferStart + nudgeOffset - currentTime });
	                }
	              } else if (bufferLen > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
	                // report stalled error once
	                if (!this.stallReported) {
	                  this.stallReported = true;
	                  logger["b" /* logger */].warn('playback stalling in high buffer @' + currentTime);
	                  hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
	                }
	                // reset stalled so to rearm watchdog timer
	                this.stalled = undefined;
	                this.nudgeRetry = ++nudgeRetry;
	                if (nudgeRetry < config.nudgeMaxRetry) {
	                  var _currentTime = media.currentTime;
	                  var targetTime = _currentTime + nudgeRetry * config.nudgeOffset;
	                  logger["b" /* logger */].log('adjust currentTime from ' + _currentTime + ' to ' + targetTime);
	                  // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
	                  media.currentTime = targetTime;
	                  hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_NUDGE_ON_STALL, fatal: false });
	                } else {
	                  logger["b" /* logger */].error('still stuck in high buffer @' + currentTime + ' after ' + config.nudgeMaxRetry + ', raise fatal error');
	                  hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_STALLED_ERROR, fatal: true });
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	  };
	
	  StreamController.prototype.onFragLoadEmergencyAborted = function onFragLoadEmergencyAborted() {
	    this.state = State.IDLE;
	    // if loadedmetadata is not set, it means that we are emergency switch down on first frag
	    // in that case, reset startFragRequested flag
	    if (!this.loadedmetadata) {
	      this.startFragRequested = false;
	      this.nextLoadPosition = this.startPosition;
	    }
	    this.tick();
	  };
	
	  StreamController.prototype.onBufferFlushed = function onBufferFlushed() {
	    /* after successful buffer flushing, filter flushed fragments from bufferedFrags
	      use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
	    */
	    var media = this.mediaBuffer ? this.mediaBuffer : this.media;
	    this._bufferedFrags = this._bufferedFrags.filter(function (frag) {
	      return buffer_helper.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
	    });
	
	    if (this.fragLoadIdx !== undefined) {
	      // increase fragment load Index to avoid frag loop loading error after buffer flush
	      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	    }
	    // move to IDLE once flush complete. this should trigger new fragment loading
	    this.state = State.IDLE;
	    // reset reference to frag
	    this.fragPrevious = null;
	  };
	
	  StreamController.prototype.swapAudioCodec = function swapAudioCodec() {
	    this.audioCodecSwap = !this.audioCodecSwap;
	  };
	
	  StreamController.prototype.computeLivePosition = function computeLivePosition(sliding, levelDetails) {
	    var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
	    return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
	  };
	
	  stream_controller__createClass(StreamController, [{
	    key: 'state',
	    set: function set(nextState) {
	      if (this.state !== nextState) {
	        var previousState = this.state;
	        this._state = nextState;
	        logger["b" /* logger */].log('main stream:' + previousState + '->' + nextState);
	        this.hls.trigger(events["a" /* default */].STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
	      }
	    },
	    get: function get() {
	      return this._state;
	    }
	  }, {
	    key: 'currentLevel',
	    get: function get() {
	      var media = this.media;
	      if (media) {
	        var frag = this.getBufferedFrag(media.currentTime);
	        if (frag) {
	          return frag.level;
	        }
	      }
	      return -1;
	    }
	  }, {
	    key: 'nextBufferedFrag',
	    get: function get() {
	      var media = this.media;
	      if (media) {
	        // first get end range of current fragment
	        return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'nextLevel',
	    get: function get() {
	      var frag = this.nextBufferedFrag;
	      if (frag) {
	        return frag.level;
	      } else {
	        return -1;
	      }
	    }
	  }, {
	    key: 'liveSyncPosition',
	    get: function get() {
	      return this._liveSyncPosition;
	    },
	    set: function set(value) {
	      this._liveSyncPosition = value;
	    }
	  }]);
	
	  return StreamController;
	}(event_handler);
	
	/* harmony default export */ var stream_controller = (stream_controller_StreamController);
	// CONCATENATED MODULE: ./src/controller/level-controller.js
	var level_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function level_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function level_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function level_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Level Controller
	*/
	
	
	
	
	
	
	
	var level_controller_LevelController = function (_EventHandler) {
	  level_controller__inherits(LevelController, _EventHandler);
	
	  function LevelController(hls) {
	    level_controller__classCallCheck(this, LevelController);
	
	    var _this = level_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MANIFEST_LOADED, events["a" /* default */].LEVEL_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].ERROR));
	
	    _this.canload = false;
	    _this.currentLevelIndex = null;
	    _this.manualLevelIndex = -1;
	    _this.timer = null;
	    return _this;
	  }
	
	  LevelController.prototype.destroy = function destroy() {
	    this.cleanTimer();
	    this.manualLevelIndex = -1;
	  };
	
	  LevelController.prototype.cleanTimer = function cleanTimer() {
	    if (this.timer !== null) {
	      clearTimeout(this.timer);
	      this.timer = null;
	    }
	  };
	
	  LevelController.prototype.startLoad = function startLoad() {
	    var levels = this._levels;
	
	    this.canload = true;
	    this.levelRetryCount = 0;
	
	    // clean up live level details to force reload them, and reset load errors
	    if (levels) {
	      levels.forEach(function (level) {
	        level.loadError = 0;
	        var levelDetails = level.details;
	        if (levelDetails && levelDetails.live) {
	          level.details = undefined;
	        }
	      });
	    }
	    // speed up live playlist refresh if timer exists
	    if (this.timer !== null) {
	      this.loadLevel();
	    }
	  };
	
	  LevelController.prototype.stopLoad = function stopLoad() {
	    this.canload = false;
	  };
	
	  LevelController.prototype.onManifestLoaded = function onManifestLoaded(data) {
	    var levels = [];
	    var bitrateStart = void 0;
	    var levelSet = {};
	    var levelFromSet = null;
	    var videoCodecFound = false;
	    var audioCodecFound = false;
	    var chromeOrFirefox = /chrome|firefox/.test(navigator.userAgent.toLowerCase());
	    var audioTracks = [];
	
	    // regroup redundant levels together
	    data.levels.forEach(function (level) {
	      level.loadError = 0;
	      level.fragmentError = false;
	
	      videoCodecFound = videoCodecFound || !!level.videoCodec;
	      audioCodecFound = audioCodecFound || !!level.audioCodec || !!(level.attrs && level.attrs.AUDIO);
	
	      // erase audio codec info if browser does not support mp4a.40.34.
	      // demuxer will autodetect codec and fallback to mpeg/audio
	      if (chromeOrFirefox === true && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) {
	        level.audioCodec = undefined;
	      }
	
	      levelFromSet = levelSet[level.bitrate];
	
	      if (levelFromSet === undefined) {
	        level.url = [level.url];
	        level.urlId = 0;
	        levelSet[level.bitrate] = level;
	        levels.push(level);
	      } else {
	        levelFromSet.url.push(level.url);
	      }
	    });
	
	    // remove audio-only level if we also have levels with audio+video codecs signalled
	    if (videoCodecFound === true && audioCodecFound === true) {
	      levels = levels.filter(function (_ref) {
	        var videoCodec = _ref.videoCodec;
	        return !!videoCodec;
	      });
	    }
	
	    // only keep levels with supported audio/video codecs
	    levels = levels.filter(function (_ref2) {
	      var audioCodec = _ref2.audioCodec,
	          videoCodec = _ref2.videoCodec;
	
	      return (!audioCodec || isCodecSupportedInMp4(audioCodec)) && (!videoCodec || isCodecSupportedInMp4(videoCodec));
	    });
	
	    if (data.audioTracks) {
	      audioTracks = data.audioTracks.filter(function (track) {
	        return !track.audioCodec || isCodecSupportedInMp4(track.audioCodec, 'audio');
	      });
	    }
	
	    if (levels.length > 0) {
	      // start bitrate is the first bitrate of the manifest
	      bitrateStart = levels[0].bitrate;
	      // sort level on bitrate
	      levels.sort(function (a, b) {
	        return a.bitrate - b.bitrate;
	      });
	      this._levels = levels;
	      // find index of first level in sorted levels
	      for (var i = 0; i < levels.length; i++) {
	        if (levels[i].bitrate === bitrateStart) {
	          this._firstLevel = i;
	          logger["b" /* logger */].log('manifest loaded,' + levels.length + ' level(s) found, first bitrate:' + bitrateStart);
	          break;
	        }
	      }
	      this.hls.trigger(events["a" /* default */].MANIFEST_PARSED, {
	        levels: levels,
	        audioTracks: audioTracks,
	        firstLevel: this._firstLevel,
	        stats: data.stats,
	        audio: audioCodecFound,
	        video: videoCodecFound,
	        altAudio: audioTracks.length > 0
	      });
	    } else {
	      this.hls.trigger(events["a" /* default */].ERROR, {
	        type: errors["b" /* ErrorTypes */].MEDIA_ERROR,
	        details: errors["a" /* ErrorDetails */].MANIFEST_INCOMPATIBLE_CODECS_ERROR,
	        fatal: true,
	        url: this.hls.url,
	        reason: 'no level with compatible codecs found in manifest'
	      });
	    }
	  };
	
	  LevelController.prototype.setLevelInternal = function setLevelInternal(newLevel) {
	    var levels = this._levels;
	    var hls = this.hls;
	    // check if level idx is valid
	    if (newLevel >= 0 && newLevel < levels.length) {
	      // stopping live reloading timer if any
	      this.cleanTimer();
	      if (this.currentLevelIndex !== newLevel) {
	        logger["b" /* logger */].log('switching to level ' + newLevel);
	        this.currentLevelIndex = newLevel;
	        var levelProperties = levels[newLevel];
	        levelProperties.level = newLevel;
	        // LEVEL_SWITCH to be deprecated in next major release
	        hls.trigger(events["a" /* default */].LEVEL_SWITCH, levelProperties);
	        hls.trigger(events["a" /* default */].LEVEL_SWITCHING, levelProperties);
	      }
	      var level = levels[newLevel],
	          levelDetails = level.details;
	      // check if we need to load playlist for this level
	      if (!levelDetails || levelDetails.live === true) {
	        // level not retrieved yet, or live playlist we need to (re)load it
	        var urlId = level.urlId;
	        hls.trigger(events["a" /* default */].LEVEL_LOADING, { url: level.url[urlId], level: newLevel, id: urlId });
	      }
	    } else {
	      // invalid level id given, trigger error
	      hls.trigger(events["a" /* default */].ERROR, {
	        type: errors["b" /* ErrorTypes */].OTHER_ERROR,
	        details: errors["a" /* ErrorDetails */].LEVEL_SWITCH_ERROR,
	        level: newLevel,
	        fatal: false,
	        reason: 'invalid level idx'
	      });
	    }
	  };
	
	  LevelController.prototype.onError = function onError(data) {
	    if (data.fatal === true) {
	      if (data.type === errors["b" /* ErrorTypes */].NETWORK_ERROR) {
	        this.cleanTimer();
	      }
	      return;
	    }
	
	    var levelError = false,
	        fragmentError = false;
	    var levelIndex = void 0;
	
	    // try to recover not fatal errors
	    switch (data.details) {
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
	      case errors["a" /* ErrorDetails */].FRAG_LOOP_LOADING_ERROR:
	      case errors["a" /* ErrorDetails */].KEY_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT:
	        levelIndex = data.frag.level;
	        fragmentError = true;
	        break;
	      case errors["a" /* ErrorDetails */].LEVEL_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].LEVEL_LOAD_TIMEOUT:
	        levelIndex = data.context.level;
	        levelError = true;
	        break;
	      case errors["a" /* ErrorDetails */].REMUX_ALLOC_ERROR:
	        levelIndex = data.level;
	        levelError = true;
	        break;
	    }
	
	    if (levelIndex !== undefined) {
	      this.recoverLevel(data, levelIndex, levelError, fragmentError);
	    }
	  };
	
	  /**
	   * Switch to a redundant stream if any available.
	   * If redundant stream is not available, emergency switch down if ABR mode is enabled.
	   *
	   * @param {Object} errorEvent
	   * @param {Number} levelIndex current level index
	   * @param {Boolean} levelError
	   * @param {Boolean} fragmentError
	   */
	  // FIXME Find a better abstraction where fragment/level retry management is well decoupled
	
	
	  LevelController.prototype.recoverLevel = function recoverLevel(errorEvent, levelIndex, levelError, fragmentError) {
	    var _this2 = this;
	
	    var config = this.hls.config;
	    var errorDetails = errorEvent.details;
	
	    var level = this._levels[levelIndex];
	    var redundantLevels = void 0,
	        delay = void 0,
	        nextLevel = void 0;
	
	    level.loadError++;
	    level.fragmentError = fragmentError;
	
	    if (levelError === true) {
	      if (this.levelRetryCount + 1 <= config.levelLoadingMaxRetry) {
	        // exponential backoff capped to max retry timeout
	        delay = Math.min(Math.pow(2, this.levelRetryCount) * config.levelLoadingRetryDelay, config.levelLoadingMaxRetryTimeout);
	        // Schedule level reload
	        this.timer = setTimeout(function () {
	          return _this2.loadLevel();
	        }, delay);
	        // boolean used to inform stream controller not to switch back to IDLE on non fatal error
	        errorEvent.levelRetry = true;
	        this.levelRetryCount++;
	        logger["b" /* logger */].warn('level controller, ' + errorDetails + ', retry in ' + delay + ' ms, current retry count is ' + this.levelRetryCount);
	      } else {
	        logger["b" /* logger */].error('level controller, cannot recover from ' + errorDetails + ' error');
	        this.currentLevelIndex = null;
	        // stopping live reloading timer if any
	        this.cleanTimer();
	        // switch error to fatal
	        errorEvent.fatal = true;
	        return;
	      }
	    }
	
	    // Try any redundant streams if available for both errors: level and fragment
	    // If level.loadError reaches redundantLevels it means that we tried them all, no hope  => let's switch down
	    if (levelError === true || fragmentError === true) {
	      redundantLevels = level.url.length;
	
	      if (redundantLevels > 1 && level.loadError < redundantLevels) {
	        logger["b" /* logger */].warn('level controller, ' + errorDetails + ' for level ' + levelIndex + ': switching to redundant stream id ' + level.urlId);
	        level.urlId = (level.urlId + 1) % redundantLevels;
	        level.details = undefined;
	      } else {
	        // Search for available level
	        if (this.manualLevelIndex === -1) {
	          // When lowest level has been reached, let's start hunt from the top
	          nextLevel = levelIndex === 0 ? this._levels.length - 1 : levelIndex - 1;
	          logger["b" /* logger */].warn('level controller, ' + errorDetails + ': switch to ' + nextLevel);
	          this.hls.nextAutoLevel = this.currentLevelIndex = nextLevel;
	        } else if (fragmentError === true) {
	          // Allow fragment retry as long as configuration allows.
	          // reset this._level so that another call to set level() will trigger again a frag load
	          logger["b" /* logger */].warn('level controller, ' + errorDetails + ': reload a fragment');
	          this.currentLevelIndex = null;
	        }
	      }
	    }
	  };
	
	  // reset errors on the successful load of a fragment
	
	
	  LevelController.prototype.onFragLoaded = function onFragLoaded(_ref3) {
	    var frag = _ref3.frag;
	
	    if (frag !== undefined && frag.type === 'main') {
	      var level = this._levels[frag.level];
	      if (level !== undefined) {
	        level.fragmentError = false;
	        level.loadError = 0;
	        this.levelRetryCount = 0;
	      }
	    }
	  };
	
	  LevelController.prototype.onLevelLoaded = function onLevelLoaded(data) {
	    var _this3 = this;
	
	    var levelId = data.level;
	    // only process level loaded events matching with expected level
	    if (levelId === this.currentLevelIndex) {
	      var curLevel = this._levels[levelId];
	      // reset level load error counter on successful level loaded only if there is no issues with fragments
	      if (curLevel.fragmentError === false) {
	        curLevel.loadError = 0;
	        this.levelRetryCount = 0;
	      }
	      var newDetails = data.details;
	      // if current playlist is a live playlist, arm a timer to reload it
	      if (newDetails.live) {
	        var reloadInterval = 1000 * (newDetails.averagetargetduration ? newDetails.averagetargetduration : newDetails.targetduration),
	            curDetails = curLevel.details;
	        if (curDetails && newDetails.endSN === curDetails.endSN) {
	          // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
	          // changed then it MUST wait for a period of one-half the target
	          // duration before retrying.
	          reloadInterval /= 2;
	          logger["b" /* logger */].log('same live playlist, reload twice faster');
	        }
	        // decrement reloadInterval with level loading delay
	        reloadInterval -= performance.now() - data.stats.trequest;
	        // in any case, don't reload more than every second
	        reloadInterval = Math.max(1000, Math.round(reloadInterval));
	        logger["b" /* logger */].log('live playlist, reload in ' + reloadInterval + ' ms');
	        this.timer = setTimeout(function () {
	          return _this3.loadLevel();
	        }, reloadInterval);
	      } else {
	        this.cleanTimer();
	      }
	    }
	  };
	
	  LevelController.prototype.loadLevel = function loadLevel() {
	    var level = void 0,
	        urlIndex = void 0;
	
	    if (this.currentLevelIndex !== null && this.canload === true) {
	      level = this._levels[this.currentLevelIndex];
	      if (level !== undefined && level.url.length > 0) {
	        urlIndex = level.urlId;
	        this.hls.trigger(events["a" /* default */].LEVEL_LOADING, { url: level.url[urlIndex], level: this.currentLevelIndex, id: urlIndex });
	      }
	    }
	  };
	
	  level_controller__createClass(LevelController, [{
	    key: 'levels',
	    get: function get() {
	      return this._levels;
	    }
	  }, {
	    key: 'level',
	    get: function get() {
	      return this.currentLevelIndex;
	    },
	    set: function set(newLevel) {
	      var levels = this._levels;
	      if (levels) {
	        newLevel = Math.min(newLevel, levels.length - 1);
	        if (this.currentLevelIndex !== newLevel || levels[newLevel].details === undefined) {
	          this.setLevelInternal(newLevel);
	        }
	      }
	    }
	  }, {
	    key: 'manualLevel',
	    get: function get() {
	      return this.manualLevelIndex;
	    },
	    set: function set(newLevel) {
	      this.manualLevelIndex = newLevel;
	      if (this._startLevel === undefined) {
	        this._startLevel = newLevel;
	      }
	      if (newLevel !== -1) {
	        this.level = newLevel;
	      }
	    }
	  }, {
	    key: 'firstLevel',
	    get: function get() {
	      return this._firstLevel;
	    },
	    set: function set(newLevel) {
	      this._firstLevel = newLevel;
	    }
	  }, {
	    key: 'startLevel',
	    get: function get() {
	      // hls.startLevel takes precedence over config.startLevel
	      // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
	      if (this._startLevel === undefined) {
	        var configStartLevel = this.hls.config.startLevel;
	        if (configStartLevel !== undefined) {
	          return configStartLevel;
	        } else {
	          return this._firstLevel;
	        }
	      } else {
	        return this._startLevel;
	      }
	    },
	    set: function set(newLevel) {
	      this._startLevel = newLevel;
	    }
	  }, {
	    key: 'nextLoadLevel',
	    get: function get() {
	      if (this.manualLevelIndex !== -1) {
	        return this.manualLevelIndex;
	      } else {
	        return this.hls.nextAutoLevel;
	      }
	    },
	    set: function set(nextLevel) {
	      this.level = nextLevel;
	      if (this.manualLevelIndex === -1) {
	        this.hls.nextAutoLevel = nextLevel;
	      }
	    }
	  }]);
	
	  return LevelController;
	}(event_handler);
	
	/* harmony default export */ var level_controller = (level_controller_LevelController);
	// EXTERNAL MODULE: ./src/demux/id3.js
	var id3 = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./src/controller/id3-track-controller.js
	function id3_track_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function id3_track_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function id3_track_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * id3 metadata track controller
	*/
	
	
	
	
	
	var id3_track_controller_ID3TrackController = function (_EventHandler) {
	  id3_track_controller__inherits(ID3TrackController, _EventHandler);
	
	  function ID3TrackController(hls) {
	    id3_track_controller__classCallCheck(this, ID3TrackController);
	
	    var _this = id3_track_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].FRAG_PARSING_METADATA));
	
	    _this.id3Track = undefined;
	    _this.media = undefined;
	    return _this;
	  }
	
	  ID3TrackController.prototype.destroy = function destroy() {
	    event_handler.prototype.destroy.call(this);
	  };
	
	  // Add ID3 metatadata text track.
	
	
	  ID3TrackController.prototype.onMediaAttached = function onMediaAttached(data) {
	    this.media = data.media;
	    if (!this.media) {
	      return;
	    }
	  };
	
	  ID3TrackController.prototype.onMediaDetaching = function onMediaDetaching() {
	    this.media = undefined;
	  };
	
	  ID3TrackController.prototype.onFragParsingMetadata = function onFragParsingMetadata(data) {
	    var fragment = data.frag;
	    var samples = data.samples;
	
	    // create track dynamically
	    if (!this.id3Track) {
	      this.id3Track = this.media.addTextTrack('metadata', 'id3');
	      this.id3Track.mode = 'hidden';
	    }
	
	    // Attempt to recreate Safari functionality by creating
	    // WebKitDataCue objects when available and store the decoded
	    // ID3 data in the value property of the cue
	    var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;
	
	    for (var i = 0; i < samples.length; i++) {
	      var frames = id3["a" /* default */].getID3Frames(samples[i].data);
	      if (frames) {
	        var startTime = samples[i].pts;
	        var endTime = i < samples.length - 1 ? samples[i + 1].pts : fragment.endPTS;
	
	        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
	        if (startTime === endTime) {
	          endTime += 0.0001;
	        }
	
	        for (var j = 0; j < frames.length; j++) {
	          var frame = frames[j];
	          // Safari doesn't put the timestamp frame in the TextTrack
	          if (!id3["a" /* default */].isTimeStampFrame(frame)) {
	            var cue = new Cue(startTime, endTime, '');
	            cue.value = frame;
	            this.id3Track.addCue(cue);
	          }
	        }
	      }
	    }
	  };
	
	  return ID3TrackController;
	}(event_handler);
	
	/* harmony default export */ var id3_track_controller = (id3_track_controller_ID3TrackController);
	// CONCATENATED MODULE: ./src/helper/is-supported.js
	
	
	function is_supported_isSupported() {
	  var mediaSource = getMediaSource();
	  var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
	  var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
	
	  // if SourceBuffer is exposed ensure its API is valid
	  // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
	  var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
	  return !!isTypeSupported && !!sourceBufferValidAPI;
	}
	// CONCATENATED MODULE: ./src/utils/ewma.js
	function ewma__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * compute an Exponential Weighted moving average
	 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
	 *  - heavily inspired from shaka-player
	 */
	
	var EWMA = function () {
	
	  //  About half of the estimated value will be from the last |halfLife| samples by weight.
	  function EWMA(halfLife) {
	    ewma__classCallCheck(this, EWMA);
	
	    // Larger values of alpha expire historical data more slowly.
	    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
	    this.estimate_ = 0;
	    this.totalWeight_ = 0;
	  }
	
	  EWMA.prototype.sample = function sample(weight, value) {
	    var adjAlpha = Math.pow(this.alpha_, weight);
	    this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
	    this.totalWeight_ += weight;
	  };
	
	  EWMA.prototype.getTotalWeight = function getTotalWeight() {
	    return this.totalWeight_;
	  };
	
	  EWMA.prototype.getEstimate = function getEstimate() {
	    if (this.alpha_) {
	      var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
	      return this.estimate_ / zeroFactor;
	    } else {
	      return this.estimate_;
	    }
	  };
	
	  return EWMA;
	}();
	
	/* harmony default export */ var ewma = (EWMA);
	// CONCATENATED MODULE: ./src/utils/ewma-bandwidth-estimator.js
	function ewma_bandwidth_estimator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * EWMA Bandwidth Estimator
	 *  - heavily inspired from shaka-player
	 * Tracks bandwidth samples and estimates available bandwidth.
	 * Based on the minimum of two exponentially-weighted moving averages with
	 * different half-lives.
	 */
	
	
	
	var ewma_bandwidth_estimator_EwmaBandWidthEstimator = function () {
	  function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
	    ewma_bandwidth_estimator__classCallCheck(this, EwmaBandWidthEstimator);
	
	    this.hls = hls;
	    this.defaultEstimate_ = defaultEstimate;
	    this.minWeight_ = 0.001;
	    this.minDelayMs_ = 50;
	    this.slow_ = new ewma(slow);
	    this.fast_ = new ewma(fast);
	  }
	
	  EwmaBandWidthEstimator.prototype.sample = function sample(durationMs, numBytes) {
	    durationMs = Math.max(durationMs, this.minDelayMs_);
	    var bandwidth = 8000 * numBytes / durationMs,
	
	    //console.log('instant bw:'+ Math.round(bandwidth));
	    // we weight sample using loading duration....
	    weight = durationMs / 1000;
	    this.fast_.sample(weight, bandwidth);
	    this.slow_.sample(weight, bandwidth);
	  };
	
	  EwmaBandWidthEstimator.prototype.canEstimate = function canEstimate() {
	    var fast = this.fast_;
	    return fast && fast.getTotalWeight() >= this.minWeight_;
	  };
	
	  EwmaBandWidthEstimator.prototype.getEstimate = function getEstimate() {
	    if (this.canEstimate()) {
	      //console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
	      //console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
	      // Take the minimum of these two estimates.  This should have the effect of
	      // adapting down quickly, but up more slowly.
	      return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
	    } else {
	      return this.defaultEstimate_;
	    }
	  };
	
	  EwmaBandWidthEstimator.prototype.destroy = function destroy() {};
	
	  return EwmaBandWidthEstimator;
	}();
	
	/* harmony default export */ var ewma_bandwidth_estimator = (ewma_bandwidth_estimator_EwmaBandWidthEstimator);
	// CONCATENATED MODULE: ./src/controller/abr-controller.js
	var abr_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function abr_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function abr_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function abr_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * simple ABR Controller
	 *  - compute next level based on last fragment bw heuristics
	 *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
	 */
	
	
	
	
	
	
	
	
	var abr_controller_AbrController = function (_EventHandler) {
	  abr_controller__inherits(AbrController, _EventHandler);
	
	  function AbrController(hls) {
	    abr_controller__classCallCheck(this, AbrController);
	
	    var _this = abr_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].FRAG_LOADING, events["a" /* default */].FRAG_LOADED, events["a" /* default */].FRAG_BUFFERED, events["a" /* default */].ERROR));
	
	    _this.lastLoadedFragLevel = 0;
	    _this._nextAutoLevel = -1;
	    _this.hls = hls;
	    _this.timer = null;
	    _this._bwEstimator = null;
	    _this.onCheck = _this._abandonRulesCheck.bind(_this);
	    return _this;
	  }
	
	  AbrController.prototype.destroy = function destroy() {
	    this.clearTimer();
	    event_handler.prototype.destroy.call(this);
	  };
	
	  AbrController.prototype.onFragLoading = function onFragLoading(data) {
	    var frag = data.frag;
	    if (frag.type === 'main') {
	      if (!this.timer) {
	        this.timer = setInterval(this.onCheck, 100);
	      }
	      // lazy init of bw Estimator, rationale is that we use different params for Live/VoD
	      // so we need to wait for stream manifest / playlist type to instantiate it.
	      if (!this._bwEstimator) {
	        var hls = this.hls,
	            level = data.frag.level,
	            isLive = hls.levels[level].details.live,
	            config = hls.config,
	            ewmaFast = void 0,
	            ewmaSlow = void 0;
	
	        if (isLive) {
	          ewmaFast = config.abrEwmaFastLive;
	          ewmaSlow = config.abrEwmaSlowLive;
	        } else {
	          ewmaFast = config.abrEwmaFastVoD;
	          ewmaSlow = config.abrEwmaSlowVoD;
	        }
	        this._bwEstimator = new ewma_bandwidth_estimator(hls, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
	      }
	      this.fragCurrent = frag;
	    }
	  };
	
	  AbrController.prototype._abandonRulesCheck = function _abandonRulesCheck() {
	    /*
	      monitor fragment retrieval time...
	      we compute expected time of arrival of the complete fragment.
	      we compare it to expected time of buffer starvation
	    */
	    var hls = this.hls,
	        v = hls.media,
	        frag = this.fragCurrent,
	        loader = frag.loader,
	        minAutoLevel = hls.minAutoLevel;
	
	    // if loader has been destroyed or loading has been aborted, stop timer and return
	    if (!loader || loader.stats && loader.stats.aborted) {
	      logger["b" /* logger */].warn('frag loader destroy or aborted, disarm abandonRules');
	      this.clearTimer();
	      // reset forced auto level value so that next level will be selected
	      this._nextAutoLevel = -1;
	      return;
	    }
	    var stats = loader.stats;
	    /* only monitor frag retrieval time if
	    (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */
	    if (v && stats && (!v.paused && v.playbackRate !== 0 || !v.readyState) && frag.autoLevel && frag.level) {
	      var requestDelay = performance.now() - stats.trequest,
	          playbackRate = Math.abs(v.playbackRate);
	      // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
	      if (requestDelay > 500 * frag.duration / playbackRate) {
	        var levels = hls.levels,
	            loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay),
	            // byte/s; at least 1 byte/s to avoid division by zero
	        // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
	        level = levels[frag.level],
	            levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate,
	            expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)),
	            pos = v.currentTime,
	            fragLoadedDelay = (expectedLen - stats.loaded) / loadRate,
	            bufferStarvationDelay = (buffer_helper.bufferInfo(v, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
	        // consider emergency switch down only if we have less than 2 frag buffered AND
	        // time to finish loading current fragment is bigger than buffer starvation delay
	        // ie if we risk buffer starvation if bw does not increase quickly
	        if (bufferStarvationDelay < 2 * frag.duration / playbackRate && fragLoadedDelay > bufferStarvationDelay) {
	          var fragLevelNextLoadedDelay = void 0,
	              nextLoadLevel = void 0;
	          // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
	          // we start from current level - 1 and we step down , until we find a matching level
	          for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
	            // compute time to load next fragment at lower level
	            // 0.8 : consider only 80% of current bw to be conservative
	            // 8 = bits per byte (bps/Bps)
	            var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
	            fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (8 * 0.8 * loadRate);
	            if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
	              // we found a lower level that be rebuffering free with current estimated bw !
	              break;
	            }
	          }
	          // only emergency switch down if it takes less time to load new fragment at lowest level instead
	          // of finishing loading current one ...
	          if (fragLevelNextLoadedDelay < fragLoadedDelay) {
	            logger["b" /* logger */].warn('loading too slow, abort fragment loading and switch to level ' + nextLoadLevel + ':fragLoadedDelay[' + nextLoadLevel + ']<fragLoadedDelay[' + (frag.level - 1) + '];bufferStarvationDelay:' + fragLevelNextLoadedDelay.toFixed(1) + '<' + fragLoadedDelay.toFixed(1) + ':' + bufferStarvationDelay.toFixed(1));
	            // force next load level in auto mode
	            hls.nextLoadLevel = nextLoadLevel;
	            // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
	            this._bwEstimator.sample(requestDelay, stats.loaded);
	            //abort fragment loading
	            loader.abort();
	            // stop abandon rules timer
	            this.clearTimer();
	            hls.trigger(events["a" /* default */].FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
	          }
	        }
	      }
	    }
	  };
	
	  AbrController.prototype.onFragLoaded = function onFragLoaded(data) {
	    var frag = data.frag;
	    if (frag.type === 'main' && !isNaN(frag.sn)) {
	      // stop monitoring bw once frag loaded
	      this.clearTimer();
	      // store level id after successful fragment load
	      this.lastLoadedFragLevel = frag.level;
	      // reset forced auto level value so that next level will be selected
	      this._nextAutoLevel = -1;
	
	      // compute level average bitrate
	      if (this.hls.config.abrMaxWithRealBitrate) {
	        var level = this.hls.levels[frag.level];
	        var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
	        var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
	        level.loaded = { bytes: loadedBytes, duration: loadedDuration };
	        level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
	      }
	      // if fragment has been loaded to perform a bitrate test,
	      if (data.frag.bitrateTest) {
	        var stats = data.stats;
	        stats.tparsed = stats.tbuffered = stats.tload;
	        this.onFragBuffered(data);
	      }
	    }
	  };
	
	  AbrController.prototype.onFragBuffered = function onFragBuffered(data) {
	    var stats = data.stats,
	        frag = data.frag;
	    // only update stats on first frag buffering
	    // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
	    // and leading to wrong bw estimation
	    // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
	    if (stats.aborted !== true && frag.loadCounter === 1 && frag.type === 'main' && !isNaN(frag.sn) && (!frag.bitrateTest || stats.tload === stats.tbuffered)) {
	      // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
	      // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
	      // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
	      var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
	      logger["b" /* logger */].log('latency/loading/parsing/append/kbps:' + Math.round(stats.tfirst - stats.trequest) + '/' + Math.round(stats.tload - stats.tfirst) + '/' + Math.round(stats.tparsed - stats.tload) + '/' + Math.round(stats.tbuffered - stats.tparsed) + '/' + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
	      this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
	      stats.bwEstimate = this._bwEstimator.getEstimate();
	      // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
	      if (frag.bitrateTest) {
	        this.bitrateTestDelay = fragLoadingProcessingMs / 1000;
	      } else {
	        this.bitrateTestDelay = 0;
	      }
	    }
	  };
	
	  AbrController.prototype.onError = function onError(data) {
	    // stop timer in case of frag loading error
	    switch (data.details) {
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
	        this.clearTimer();
	        break;
	      default:
	        break;
	    }
	  };
	
	  AbrController.prototype.clearTimer = function clearTimer() {
	    clearInterval(this.timer);
	    this.timer = null;
	  };
	
	  // return next auto level
	
	
	  AbrController.prototype._findBestLevel = function _findBestLevel(currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
	    for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
	      var levelInfo = levels[i],
	          levelDetails = levelInfo.details,
	          avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration,
	          live = levelDetails ? levelDetails.live : false,
	          adjustedbw = void 0;
	      // follow algorithm captured from stagefright :
	      // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
	      // Pick the highest bandwidth stream below or equal to estimated bandwidth.
	      // consider only 80% of the available bandwidth, but if we are switching up,
	      // be even more conservative (70%) to avoid overestimating and immediately
	      // switching back.
	      if (i <= currentLevel) {
	        adjustedbw = bwFactor * currentBw;
	      } else {
	        adjustedbw = bwUpFactor * currentBw;
	      }
	      var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate,
	          fetchDuration = bitrate * avgDuration / adjustedbw;
	
	      logger["b" /* logger */].trace('level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: ' + i + '/' + Math.round(adjustedbw) + '/' + bitrate + '/' + avgDuration + '/' + maxFetchDuration + '/' + fetchDuration);
	      // if adjusted bw is greater than level bitrate AND
	      if (adjustedbw > bitrate && (
	      // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
	      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
	      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
	      !fetchDuration || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) {
	        // as we are looping from highest to lowest, this will return the best achievable quality level
	        return i;
	      }
	    }
	    // not enough time budget even with quality level 0 ... rebuffering might happen
	    return -1;
	  };
	
	  abr_controller__createClass(AbrController, [{
	    key: 'nextAutoLevel',
	    get: function get() {
	      var forcedAutoLevel = this._nextAutoLevel;
	      var bwEstimator = this._bwEstimator;
	      // in case next auto level has been forced, and bw not available or not reliable, return forced value
	      if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) {
	        return forcedAutoLevel;
	      }
	      // compute next level using ABR logic
	      var nextABRAutoLevel = this._nextABRAutoLevel;
	      // if forced auto level has been defined, use it to cap ABR computed quality level
	      if (forcedAutoLevel !== -1) {
	        nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
	      }
	      return nextABRAutoLevel;
	    },
	    set: function set(nextLevel) {
	      this._nextAutoLevel = nextLevel;
	    }
	  }, {
	    key: '_nextABRAutoLevel',
	    get: function get() {
	      var hls = this.hls,
	          maxAutoLevel = hls.maxAutoLevel,
	          levels = hls.levels,
	          config = hls.config,
	          minAutoLevel = hls.minAutoLevel;
	      var v = hls.media,
	          currentLevel = this.lastLoadedFragLevel,
	          currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0,
	          pos = v ? v.currentTime : 0,
	
	      // playbackRate is the absolute value of the playback rate; if v.playbackRate is 0, we use 1 to load as
	      // if we're playing back at the normal rate.
	      playbackRate = v && v.playbackRate !== 0 ? Math.abs(v.playbackRate) : 1.0,
	          avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate,
	
	      // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
	      bufferStarvationDelay = (buffer_helper.bufferInfo(v, pos, config.maxBufferHole).end - pos) / playbackRate;
	
	      // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
	      var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
	      if (bestLevel >= 0) {
	        return bestLevel;
	      } else {
	        logger["b" /* logger */].trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
	        // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
	        // if no matching level found, logic will return 0
	        var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay,
	            bwFactor = config.abrBandWidthFactor,
	            bwUpFactor = config.abrBandWidthUpFactor;
	        if (bufferStarvationDelay === 0) {
	          // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
	          var bitrateTestDelay = this.bitrateTestDelay;
	          if (bitrateTestDelay) {
	            // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
	            // max video loading delay used in  automatic start level selection :
	            // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
	            // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
	            // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
	            var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
	            maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
	            logger["b" /* logger */].trace('bitrate test took ' + Math.round(1000 * bitrateTestDelay) + 'ms, set first fragment max fetchDuration to ' + Math.round(1000 * maxStarvationDelay) + ' ms');
	            // don't use conservative factor on bitrate test
	            bwFactor = bwUpFactor = 1;
	          }
	        }
	        bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
	        return Math.max(bestLevel, 0);
	      }
	    }
	  }]);
	
	  return AbrController;
	}(event_handler);
	
	/* harmony default export */ var abr_controller = (abr_controller_AbrController);
	// CONCATENATED MODULE: ./src/controller/buffer-controller.js
	function buffer_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function buffer_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function buffer_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Buffer Controller
	*/
	
	
	
	
	
	
	
	var buffer_controller_MediaSource = getMediaSource();
	
	var buffer_controller_BufferController = function (_EventHandler) {
	  buffer_controller__inherits(BufferController, _EventHandler);
	
	  function BufferController(hls) {
	    buffer_controller__classCallCheck(this, BufferController);
	
	    // the value that we have set mediasource.duration to
	    // (the actual duration may be tweaked slighly by the browser)
	    var _this = buffer_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHING, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].MANIFEST_PARSED, events["a" /* default */].BUFFER_RESET, events["a" /* default */].BUFFER_APPENDING, events["a" /* default */].BUFFER_CODECS, events["a" /* default */].BUFFER_EOS, events["a" /* default */].BUFFER_FLUSHING, events["a" /* default */].LEVEL_PTS_UPDATED, events["a" /* default */].LEVEL_UPDATED));
	
	    _this._msDuration = null;
	    // the value that we want to set mediaSource.duration to
	    _this._levelDuration = null;
	    // current stream state: true - for live broadcast, false - for VoD content
	    _this._live = null;
	    // cache the self generated object url to detect hijack of video tag
	    _this._objectUrl = null;
	
	    // Source Buffer listeners
	    _this.onsbue = _this.onSBUpdateEnd.bind(_this);
	    _this.onsbe = _this.onSBUpdateError.bind(_this);
	    _this.pendingTracks = {};
	    _this.tracks = {};
	    return _this;
	  }
	
	  BufferController.prototype.destroy = function destroy() {
	    event_handler.prototype.destroy.call(this);
	  };
	
	  BufferController.prototype.onLevelPtsUpdated = function onLevelPtsUpdated(data) {
	    var type = data.type;
	    var audioTrack = this.tracks.audio;
	
	    // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
	    // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
	    // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
	    // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
	    // event if SB is in updating state.
	    // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
	
	    if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') {
	      // Chrome audio mp3 track
	      var audioBuffer = this.sourceBuffer.audio;
	      var delta = Math.abs(audioBuffer.timestampOffset - data.start);
	
	      // adjust timestamp offset if time delta is greater than 100ms
	      if (delta > 0.1) {
	        var updating = audioBuffer.updating;
	
	        try {
	          audioBuffer.abort();
	        } catch (err) {
	          updating = true;
	          logger["b" /* logger */].warn('can not abort audio buffer: ' + err);
	        }
	
	        if (!updating) {
	          logger["b" /* logger */].warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
	          audioBuffer.timestampOffset = data.start;
	        } else {
	          this.audioTimestampOffset = data.start;
	        }
	      }
	    }
	  };
	
	  BufferController.prototype.onManifestParsed = function onManifestParsed(data) {
	    var audioExpected = data.audio,
	        videoExpected = data.video || data.levels.length && data.audio,
	        sourceBufferNb = 0;
	    // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
	    // sourcebuffers will be created all at once when the expected nb of tracks will be reached
	    // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
	    // it will contain the expected nb of source buffers, no need to compute it
	    if (data.altAudio && (audioExpected || videoExpected)) {
	      sourceBufferNb = (audioExpected ? 1 : 0) + (videoExpected ? 1 : 0);
	      logger["b" /* logger */].log(sourceBufferNb + ' sourceBuffer(s) expected');
	    }
	    this.sourceBufferNb = sourceBufferNb;
	  };
	
	  BufferController.prototype.onMediaAttaching = function onMediaAttaching(data) {
	    var media = this.media = data.media;
	    if (media) {
	      // setup the media source
	      var ms = this.mediaSource = new buffer_controller_MediaSource();
	      //Media Source listeners
	      this.onmso = this.onMediaSourceOpen.bind(this);
	      this.onmse = this.onMediaSourceEnded.bind(this);
	      this.onmsc = this.onMediaSourceClose.bind(this);
	      ms.addEventListener('sourceopen', this.onmso);
	      ms.addEventListener('sourceended', this.onmse);
	      ms.addEventListener('sourceclose', this.onmsc);
	      // link video and media Source
	      media.src = URL.createObjectURL(ms);
	      // cache the locally generated object url
	      this._objectUrl = media.src;
	    }
	  };
	
	  BufferController.prototype.onMediaDetaching = function onMediaDetaching() {
	    logger["b" /* logger */].log('media source detaching');
	    var ms = this.mediaSource;
	    if (ms) {
	      if (ms.readyState === 'open') {
	        try {
	          // endOfStream could trigger exception if any sourcebuffer is in updating state
	          // we don't really care about checking sourcebuffer state here,
	          // as we are anyway detaching the MediaSource
	          // let's just avoid this exception to propagate
	          ms.endOfStream();
	        } catch (err) {
	          logger["b" /* logger */].warn('onMediaDetaching:' + err.message + ' while calling endOfStream');
	        }
	      }
	      ms.removeEventListener('sourceopen', this.onmso);
	      ms.removeEventListener('sourceended', this.onmse);
	      ms.removeEventListener('sourceclose', this.onmsc);
	
	      // Detach properly the MediaSource from the HTMLMediaElement as
	      // suggested in https://github.com/w3c/media-source/issues/53.
	      if (this.media) {
	        URL.revokeObjectURL(this._objectUrl);
	
	        // clean up video tag src only if it's our own url. some external libraries might
	        // hijack the video tag and change its 'src' without destroying the Hls instance first
	        if (this.media.src === this._objectUrl) {
	          this.media.removeAttribute('src');
	          this.media.load();
	        } else {
	          logger["b" /* logger */].warn('media.src was changed by a third party - skip cleanup');
	        }
	      }
	
	      this.mediaSource = null;
	      this.media = null;
	      this._objectUrl = null;
	      this.pendingTracks = {};
	      this.tracks = {};
	      this.sourceBuffer = {};
	      this.flushRange = [];
	      this.segments = [];
	      this.appended = 0;
	    }
	    this.onmso = this.onmse = this.onmsc = null;
	    this.hls.trigger(events["a" /* default */].MEDIA_DETACHED);
	  };
	
	  BufferController.prototype.onMediaSourceOpen = function onMediaSourceOpen() {
	    logger["b" /* logger */].log('media source opened');
	    this.hls.trigger(events["a" /* default */].MEDIA_ATTACHED, { media: this.media });
	    var mediaSource = this.mediaSource;
	    if (mediaSource) {
	      // once received, don't listen anymore to sourceopen event
	      mediaSource.removeEventListener('sourceopen', this.onmso);
	    }
	    this.checkPendingTracks();
	  };
	
	  BufferController.prototype.checkPendingTracks = function checkPendingTracks() {
	    // if any buffer codecs pending, check if we have enough to create sourceBuffers
	    var pendingTracks = this.pendingTracks,
	        pendingTracksNb = Object.keys(pendingTracks).length;
	    // if any pending tracks and (if nb of pending tracks gt or equal than expected nb or if unknown expected nb)
	    if (pendingTracksNb && (this.sourceBufferNb <= pendingTracksNb || this.sourceBufferNb === 0)) {
	      // ok, let's create them now !
	      this.createSourceBuffers(pendingTracks);
	      this.pendingTracks = {};
	      // append any pending segments now !
	      this.doAppending();
	    }
	  };
	
	  BufferController.prototype.onMediaSourceClose = function onMediaSourceClose() {
	    logger["b" /* logger */].log('media source closed');
	  };
	
	  BufferController.prototype.onMediaSourceEnded = function onMediaSourceEnded() {
	    logger["b" /* logger */].log('media source ended');
	  };
	
	  BufferController.prototype.onSBUpdateEnd = function onSBUpdateEnd() {
	    // update timestampOffset
	    if (this.audioTimestampOffset) {
	      var audioBuffer = this.sourceBuffer.audio;
	      logger["b" /* logger */].warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + this.audioTimestampOffset);
	      audioBuffer.timestampOffset = this.audioTimestampOffset;
	      delete this.audioTimestampOffset;
	    }
	
	    if (this._needsFlush) {
	      this.doFlush();
	    }
	
	    if (this._needsEos) {
	      this.checkEos();
	    }
	    this.appending = false;
	    var parent = this.parent;
	    // count nb of pending segments waiting for appending on this sourcebuffer
	    var pending = this.segments.reduce(function (counter, segment) {
	      return segment.parent === parent ? counter + 1 : counter;
	    }, 0);
	    this.hls.trigger(events["a" /* default */].BUFFER_APPENDED, { parent: parent, pending: pending });
	
	    // don't append in flushing mode
	    if (!this._needsFlush) {
	      this.doAppending();
	    }
	
	    this.updateMediaElementDuration();
	  };
	
	  BufferController.prototype.onSBUpdateError = function onSBUpdateError(event) {
	    logger["b" /* logger */].error('sourceBuffer error:', event);
	    // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
	    // this error might not always be fatal (it is fatal if decode error is set, in that case
	    // it will be followed by a mediaElement error ...)
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_APPENDING_ERROR, fatal: false });
	    // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
	  };
	
	  BufferController.prototype.onBufferReset = function onBufferReset() {
	    var sourceBuffer = this.sourceBuffer;
	    for (var type in sourceBuffer) {
	      var sb = sourceBuffer[type];
	      try {
	        this.mediaSource.removeSourceBuffer(sb);
	        sb.removeEventListener('updateend', this.onsbue);
	        sb.removeEventListener('error', this.onsbe);
	      } catch (err) {}
	    }
	    this.sourceBuffer = {};
	    this.flushRange = [];
	    this.segments = [];
	    this.appended = 0;
	  };
	
	  BufferController.prototype.onBufferCodecs = function onBufferCodecs(tracks) {
	    // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
	    // if sourcebuffers already created, do nothing ...
	    if (Object.keys(this.sourceBuffer).length === 0) {
	      for (var trackName in tracks) {
	        this.pendingTracks[trackName] = tracks[trackName];
	      }
	      var mediaSource = this.mediaSource;
	      if (mediaSource && mediaSource.readyState === 'open') {
	        // try to create sourcebuffers if mediasource opened
	        this.checkPendingTracks();
	      }
	    }
	  };
	
	  BufferController.prototype.createSourceBuffers = function createSourceBuffers(tracks) {
	    var sourceBuffer = this.sourceBuffer,
	        mediaSource = this.mediaSource;
	
	    for (var trackName in tracks) {
	      if (!sourceBuffer[trackName]) {
	        var track = tracks[trackName];
	        // use levelCodec as first priority
	        var codec = track.levelCodec || track.codec;
	        var mimeType = track.container + ';codecs=' + codec;
	        logger["b" /* logger */].log('creating sourceBuffer(' + mimeType + ')');
	        try {
	          var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
	          sb.addEventListener('updateend', this.onsbue);
	          sb.addEventListener('error', this.onsbe);
	          this.tracks[trackName] = { codec: codec, container: track.container };
	          track.buffer = sb;
	        } catch (err) {
	          logger["b" /* logger */].error('error while trying to add sourceBuffer:' + err.message);
	          this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_ADD_CODEC_ERROR, fatal: false, err: err, mimeType: mimeType });
	        }
	      }
	    }
	    this.hls.trigger(events["a" /* default */].BUFFER_CREATED, { tracks: tracks });
	  };
	
	  BufferController.prototype.onBufferAppending = function onBufferAppending(data) {
	    if (!this._needsFlush) {
	      if (!this.segments) {
	        this.segments = [data];
	      } else {
	        this.segments.push(data);
	      }
	      this.doAppending();
	    }
	  };
	
	  BufferController.prototype.onBufferAppendFail = function onBufferAppendFail(data) {
	    logger["b" /* logger */].error('sourceBuffer error:', data.event);
	    // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
	    // this error might not always be fatal (it is fatal if decode error is set, in that case
	    // it will be followed by a mediaElement error ...)
	    this.hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].BUFFER_APPENDING_ERROR, fatal: false });
	  };
	
	  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
	
	
	  BufferController.prototype.onBufferEos = function onBufferEos(data) {
	    var sb = this.sourceBuffer;
	    var dataType = data.type;
	    for (var type in sb) {
	      if (!dataType || type === dataType) {
	        if (!sb[type].ended) {
	          sb[type].ended = true;
	          logger["b" /* logger */].log(type + ' sourceBuffer now EOS');
	        }
	      }
	    }
	    this.checkEos();
	  };
	
	  // if all source buffers are marked as ended, signal endOfStream() to MediaSource.
	
	
	  BufferController.prototype.checkEos = function checkEos() {
	    var sb = this.sourceBuffer,
	        mediaSource = this.mediaSource;
	    if (!mediaSource || mediaSource.readyState !== 'open') {
	      this._needsEos = false;
	      return;
	    }
	    for (var type in sb) {
	      var sbobj = sb[type];
	      if (!sbobj.ended) {
	        return;
	      }
	      if (sbobj.updating) {
	        this._needsEos = true;
	        return;
	      }
	    }
	    logger["b" /* logger */].log('all media data available, signal endOfStream() to MediaSource and stop loading fragment');
	    //Notify the media element that it now has all of the media data
	    try {
	      mediaSource.endOfStream();
	    } catch (e) {
	      logger["b" /* logger */].warn('exception while calling mediaSource.endOfStream()');
	    }
	    this._needsEos = false;
	  };
	
	  BufferController.prototype.onBufferFlushing = function onBufferFlushing(data) {
	    this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
	    // attempt flush immediately
	    this.flushBufferCounter = 0;
	    this.doFlush();
	  };
	
	  BufferController.prototype.onLevelUpdated = function onLevelUpdated(_ref) {
	    var details = _ref.details;
	
	    if (details.fragments.length > 0) {
	      this._levelDuration = details.totalduration + details.fragments[0].start;
	      this._live = details.live;
	      this.updateMediaElementDuration();
	    }
	  };
	
	  /**
	   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
	   * 'liveDurationInfinity` is set to `true`
	   * More details: https://github.com/video-dev/hls.js/issues/355
	   */
	
	
	  BufferController.prototype.updateMediaElementDuration = function updateMediaElementDuration() {
	    var config = this.hls.config;
	
	    var duration = void 0;
	
	    if (this._levelDuration === null || !this.media || !this.mediaSource || !this.sourceBuffer || this.media.readyState === 0 || this.mediaSource.readyState !== 'open') {
	      return;
	    }
	
	    for (var type in this.sourceBuffer) {
	      if (this.sourceBuffer[type].updating === true) {
	        // can't set duration whilst a buffer is updating
	        return;
	      }
	    }
	
	    duration = this.media.duration;
	    // initialise to the value that the media source is reporting
	    if (this._msDuration === null) {
	      this._msDuration = this.mediaSource.duration;
	    }
	
	    if (this._live === true && config.liveDurationInfinity === true) {
	      // Override duration to Infinity
	      logger["b" /* logger */].log('Media Source duration is set to Infinity');
	      this._msDuration = this.mediaSource.duration = Infinity;
	    } else if (this._levelDuration > this._msDuration && this._levelDuration > duration || duration === Infinity || isNaN(duration)) {
	      // levelDuration was the last value we set.
	      // not using mediaSource.duration as the browser may tweak this value
	      // only update Media Source duration if its value increase, this is to avoid
	      // flushing already buffered portion when switching between quality level
	      logger["b" /* logger */].log('Updating Media Source duration to ' + this._levelDuration.toFixed(3));
	      this._msDuration = this.mediaSource.duration = this._levelDuration;
	    }
	  };
	
	  BufferController.prototype.doFlush = function doFlush() {
	    // loop through all buffer ranges to flush
	    while (this.flushRange.length) {
	      var range = this.flushRange[0];
	      // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
	      if (this.flushBuffer(range.start, range.end, range.type)) {
	        // range flushed, remove from flush array
	        this.flushRange.shift();
	        this.flushBufferCounter = 0;
	      } else {
	        this._needsFlush = true;
	        // avoid looping, wait for SB update end to retrigger a flush
	        return;
	      }
	    }
	    if (this.flushRange.length === 0) {
	      // everything flushed
	      this._needsFlush = false;
	
	      // let's recompute this.appended, which is used to avoid flush looping
	      var appended = 0;
	      var sourceBuffer = this.sourceBuffer;
	      try {
	        for (var type in sourceBuffer) {
	          appended += sourceBuffer[type].buffered.length;
	        }
	      } catch (error) {
	        // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
	        // this is harmess at this stage, catch this to avoid reporting an internal exception
	        logger["b" /* logger */].error('error while accessing sourceBuffer.buffered');
	      }
	      this.appended = appended;
	      this.hls.trigger(events["a" /* default */].BUFFER_FLUSHED);
	    }
	  };
	
	  BufferController.prototype.doAppending = function doAppending() {
	    var hls = this.hls,
	        sourceBuffer = this.sourceBuffer,
	        segments = this.segments;
	    if (Object.keys(sourceBuffer).length) {
	      if (this.media.error) {
	        this.segments = [];
	        logger["b" /* logger */].error('trying to append although a media error occured, flush segment and abort');
	        return;
	      }
	      if (this.appending) {
	        //logger.log(`sb appending in progress`);
	        return;
	      }
	      if (segments && segments.length) {
	        var segment = segments.shift();
	        try {
	          var type = segment.type,
	              sb = sourceBuffer[type];
	          if (sb) {
	            if (!sb.updating) {
	              // reset sourceBuffer ended flag before appending segment
	              sb.ended = false;
	              //logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
	              this.parent = segment.parent;
	              sb.appendBuffer(segment.data);
	              this.appendError = 0;
	              this.appended++;
	              this.appending = true;
	            } else {
	              segments.unshift(segment);
	            }
	          } else {
	            // in case we don't have any source buffer matching with this segment type,
	            // it means that Mediasource fails to create sourcebuffer
	            // discard this segment, and trigger update end
	            this.onSBUpdateEnd();
	          }
	        } catch (err) {
	          // in case any error occured while appending, put back segment in segments table
	          logger["b" /* logger */].error('error while trying to append buffer:' + err.message);
	          segments.unshift(segment);
	          var event = { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, parent: segment.parent };
	          if (err.code !== 22) {
	            if (this.appendError) {
	              this.appendError++;
	            } else {
	              this.appendError = 1;
	            }
	            event.details = errors["a" /* ErrorDetails */].BUFFER_APPEND_ERROR;
	            /* with UHD content, we could get loop of quota exceeded error until
	              browser is able to evict some data from sourcebuffer. retrying help recovering this
	            */
	            if (this.appendError > hls.config.appendErrorMaxRetry) {
	              logger["b" /* logger */].log('fail ' + hls.config.appendErrorMaxRetry + ' times to append segment in sourceBuffer');
	              segments = [];
	              event.fatal = true;
	              hls.trigger(events["a" /* default */].ERROR, event);
	              return;
	            } else {
	              event.fatal = false;
	              hls.trigger(events["a" /* default */].ERROR, event);
	            }
	          } else {
	            // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
	            // let's stop appending any segments, and report BUFFER_FULL_ERROR error
	            this.segments = [];
	            event.details = errors["a" /* ErrorDetails */].BUFFER_FULL_ERROR;
	            event.fatal = false;
	            hls.trigger(events["a" /* default */].ERROR, event);
	            return;
	          }
	        }
	      }
	    }
	  };
	
	  /*
	    flush specified buffered range,
	    return true once range has been flushed.
	    as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
	  */
	
	
	  BufferController.prototype.flushBuffer = function flushBuffer(startOffset, endOffset, typeIn) {
	    var sb,
	        i,
	        bufStart,
	        bufEnd,
	        flushStart,
	        flushEnd,
	        sourceBuffer = this.sourceBuffer;
	    if (Object.keys(sourceBuffer).length) {
	      logger["b" /* logger */].log('flushBuffer,pos/start/end: ' + this.media.currentTime.toFixed(3) + '/' + startOffset + '/' + endOffset);
	      // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
	      if (this.flushBufferCounter < this.appended) {
	        for (var type in sourceBuffer) {
	          // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
	          // if no, let's flush all sourcebuffers
	          if (typeIn && type !== typeIn) {
	            continue;
	          }
	          sb = sourceBuffer[type];
	          // we are going to flush buffer, mark source buffer as 'not ended'
	          sb.ended = false;
	          if (!sb.updating) {
	            try {
	              for (i = 0; i < sb.buffered.length; i++) {
	                bufStart = sb.buffered.start(i);
	                bufEnd = sb.buffered.end(i);
	                // workaround firefox not able to properly flush multiple buffered range.
	                if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && endOffset === Number.POSITIVE_INFINITY) {
	                  flushStart = startOffset;
	                  flushEnd = endOffset;
	                } else {
	                  flushStart = Math.max(bufStart, startOffset);
	                  flushEnd = Math.min(bufEnd, endOffset);
	                }
	                /* sometimes sourcebuffer.remove() does not flush
	                   the exact expected time range.
	                   to avoid rounding issues/infinite loop,
	                   only flush buffer range of length greater than 500ms.
	                */
	                if (Math.min(flushEnd, bufEnd) - flushStart > 0.5) {
	                  this.flushBufferCounter++;
	                  logger["b" /* logger */].log('flush ' + type + ' [' + flushStart + ',' + flushEnd + '], of [' + bufStart + ',' + bufEnd + '], pos:' + this.media.currentTime);
	                  sb.remove(flushStart, flushEnd);
	                  return false;
	                }
	              }
	            } catch (e) {
	              logger["b" /* logger */].warn('exception while accessing sourcebuffer, it might have been removed from MediaSource');
	            }
	          } else {
	            //logger.log('abort ' + type + ' append in progress');
	            // this will abort any appending in progress
	            //sb.abort();
	            logger["b" /* logger */].warn('cannot flush, sb updating in progress');
	            return false;
	          }
	        }
	      } else {
	        logger["b" /* logger */].warn('abort flushing too many retries');
	      }
	      logger["b" /* logger */].log('buffer flushed');
	    }
	    // everything flushed !
	    return true;
	  };
	
	  return BufferController;
	}(event_handler);
	
	/* harmony default export */ var buffer_controller = (buffer_controller_BufferController);
	// CONCATENATED MODULE: ./src/controller/cap-level-controller.js
	var cap_level_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function cap_level_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function cap_level_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function cap_level_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * cap stream level to media size dimension controller
	*/
	
	
	
	
	var cap_level_controller_CapLevelController = function (_EventHandler) {
	  cap_level_controller__inherits(CapLevelController, _EventHandler);
	
	  function CapLevelController(hls) {
	    cap_level_controller__classCallCheck(this, CapLevelController);
	
	    return cap_level_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].FPS_DROP_LEVEL_CAPPING, events["a" /* default */].MEDIA_ATTACHING, events["a" /* default */].MANIFEST_PARSED));
	  }
	
	  CapLevelController.prototype.destroy = function destroy() {
	    if (this.hls.config.capLevelToPlayerSize) {
	      this.media = this.restrictedLevels = null;
	      this.autoLevelCapping = Number.POSITIVE_INFINITY;
	      if (this.timer) {
	        this.timer = clearInterval(this.timer);
	      }
	    }
	  };
	
	  CapLevelController.prototype.onFpsDropLevelCapping = function onFpsDropLevelCapping(data) {
	    // Don't add a restricted level more than once
	    if (CapLevelController.isLevelAllowed(data.droppedLevel, this.restrictedLevels)) {
	      this.restrictedLevels.push(data.droppedLevel);
	    }
	  };
	
	  CapLevelController.prototype.onMediaAttaching = function onMediaAttaching(data) {
	    this.media = data.media instanceof HTMLVideoElement ? data.media : null;
	  };
	
	  CapLevelController.prototype.onManifestParsed = function onManifestParsed(data) {
	    var hls = this.hls;
	    this.restrictedLevels = [];
	    if (hls.config.capLevelToPlayerSize) {
	      this.autoLevelCapping = Number.POSITIVE_INFINITY;
	      this.levels = data.levels;
	      hls.firstLevel = this.getMaxLevel(data.firstLevel);
	      clearInterval(this.timer);
	      this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
	      this.detectPlayerSize();
	    }
	  };
	
	  CapLevelController.prototype.detectPlayerSize = function detectPlayerSize() {
	    if (this.media) {
	      var levelsLength = this.levels ? this.levels.length : 0;
	      if (levelsLength) {
	        var hls = this.hls;
	        hls.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
	        if (hls.autoLevelCapping > this.autoLevelCapping) {
	          // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
	          // usually happen when the user go to the fullscreen mode.
	          hls.streamController.nextLevelSwitch();
	        }
	        this.autoLevelCapping = hls.autoLevelCapping;
	      }
	    }
	  };
	
	  /*
	  * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
	  */
	
	
	  CapLevelController.prototype.getMaxLevel = function getMaxLevel(capLevelIndex) {
	    var _this2 = this;
	
	    if (!this.levels) {
	      return -1;
	    }
	
	    var validLevels = this.levels.filter(function (level, index) {
	      return CapLevelController.isLevelAllowed(index, _this2.restrictedLevels) && index <= capLevelIndex;
	    });
	
	    return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
	  };
	
	  CapLevelController.isLevelAllowed = function isLevelAllowed(level) {
	    var restrictedLevels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return restrictedLevels.indexOf(level) === -1;
	  };
	
	  CapLevelController.getMaxLevelByMediaSize = function getMaxLevelByMediaSize(levels, width, height) {
	    if (!levels || levels && !levels.length) {
	      return -1;
	    }
	
	    // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
	    // to determine whether we've chosen the greatest bandwidth for the media's dimensions
	    var atGreatestBandiwdth = function atGreatestBandiwdth(curLevel, nextLevel) {
	      if (!nextLevel) {
	        return true;
	      }
	      return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
	    };
	
	    // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
	    // the max level
	    var maxLevelIndex = levels.length - 1;
	
	    for (var i = 0; i < levels.length; i += 1) {
	      var level = levels[i];
	      if ((level.width >= width || level.height >= height) && atGreatestBandiwdth(level, levels[i + 1])) {
	        maxLevelIndex = i;
	        break;
	      }
	    }
	
	    return maxLevelIndex;
	  };
	
	  cap_level_controller__createClass(CapLevelController, [{
	    key: 'mediaWidth',
	    get: function get() {
	      var width = void 0;
	      var media = this.media;
	      if (media) {
	        width = media.width || media.clientWidth || media.offsetWidth;
	        width *= CapLevelController.contentScaleFactor;
	      }
	      return width;
	    }
	  }, {
	    key: 'mediaHeight',
	    get: function get() {
	      var height = void 0;
	      var media = this.media;
	      if (media) {
	        height = media.height || media.clientHeight || media.offsetHeight;
	        height *= CapLevelController.contentScaleFactor;
	      }
	      return height;
	    }
	  }], [{
	    key: 'contentScaleFactor',
	    get: function get() {
	      var pixelRatio = 1;
	      try {
	        pixelRatio = window.devicePixelRatio;
	      } catch (e) {}
	      return pixelRatio;
	    }
	  }]);
	
	  return CapLevelController;
	}(event_handler);
	
	/* harmony default export */ var cap_level_controller = (cap_level_controller_CapLevelController);
	// CONCATENATED MODULE: ./src/controller/fps-controller.js
	function fps_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function fps_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function fps_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * FPS Controller
	*/
	
	
	
	
	
	var fps_controller_FPSController = function (_EventHandler) {
	  fps_controller__inherits(FPSController, _EventHandler);
	
	  function FPSController(hls) {
	    fps_controller__classCallCheck(this, FPSController);
	
	    return fps_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHING));
	  }
	
	  FPSController.prototype.destroy = function destroy() {
	    if (this.timer) {
	      clearInterval(this.timer);
	    }
	    this.isVideoPlaybackQualityAvailable = false;
	  };
	
	  FPSController.prototype.onMediaAttaching = function onMediaAttaching(data) {
	    var config = this.hls.config;
	    if (config.capLevelOnFPSDrop) {
	      var video = this.video = data.media instanceof HTMLVideoElement ? data.media : null;
	      if (typeof video.getVideoPlaybackQuality === 'function') {
	        this.isVideoPlaybackQualityAvailable = true;
	      }
	      clearInterval(this.timer);
	      this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
	    }
	  };
	
	  FPSController.prototype.checkFPS = function checkFPS(video, decodedFrames, droppedFrames) {
	    var currentTime = performance.now();
	    if (decodedFrames) {
	      if (this.lastTime) {
	        var currentPeriod = currentTime - this.lastTime,
	            currentDropped = droppedFrames - this.lastDroppedFrames,
	            currentDecoded = decodedFrames - this.lastDecodedFrames,
	            droppedFPS = 1000 * currentDropped / currentPeriod,
	            hls = this.hls;
	        hls.trigger(events["a" /* default */].FPS_DROP, { currentDropped: currentDropped, currentDecoded: currentDecoded, totalDroppedFrames: droppedFrames });
	        if (droppedFPS > 0) {
	          //logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
	          if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
	            var currentLevel = hls.currentLevel;
	            logger["b" /* logger */].warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
	            if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
	              currentLevel = currentLevel - 1;
	              hls.trigger(events["a" /* default */].FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls.currentLevel });
	              hls.autoLevelCapping = currentLevel;
	              hls.streamController.nextLevelSwitch();
	            }
	          }
	        }
	      }
	      this.lastTime = currentTime;
	      this.lastDroppedFrames = droppedFrames;
	      this.lastDecodedFrames = decodedFrames;
	    }
	  };
	
	  FPSController.prototype.checkFPSInterval = function checkFPSInterval() {
	    var video = this.video;
	    if (video) {
	      if (this.isVideoPlaybackQualityAvailable) {
	        var videoPlaybackQuality = video.getVideoPlaybackQuality();
	        this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
	      } else {
	        this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
	      }
	    }
	  };
	
	  return FPSController;
	}(event_handler);
	
	/* harmony default export */ var fps_controller = (fps_controller_FPSController);
	// CONCATENATED MODULE: ./src/utils/xhr-loader.js
	function xhr_loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * XHR based logger
	*/
	
	
	
	var xhr_loader_XhrLoader = function () {
	  function XhrLoader(config) {
	    xhr_loader__classCallCheck(this, XhrLoader);
	
	    if (config && config.xhrSetup) {
	      this.xhrSetup = config.xhrSetup;
	    }
	  }
	
	  XhrLoader.prototype.destroy = function destroy() {
	    this.abort();
	    this.loader = null;
	  };
	
	  XhrLoader.prototype.abort = function abort() {
	    var loader = this.loader;
	    if (loader && loader.readyState !== 4) {
	      this.stats.aborted = true;
	      loader.abort();
	    }
	
	    window.clearTimeout(this.requestTimeout);
	    this.requestTimeout = null;
	    window.clearTimeout(this.retryTimeout);
	    this.retryTimeout = null;
	  };
	
	  XhrLoader.prototype.load = function load(context, config, callbacks) {
	    this.context = context;
	    this.config = config;
	    this.callbacks = callbacks;
	    this.stats = { trequest: performance.now(), retry: 0 };
	    this.retryDelay = config.retryDelay;
	    this.loadInternal();
	  };
	
	  XhrLoader.prototype.loadInternal = function loadInternal() {
	    var xhr,
	        context = this.context;
	    xhr = this.loader = new XMLHttpRequest();
	
	    var stats = this.stats;
	    stats.tfirst = 0;
	    stats.loaded = 0;
	    var xhrSetup = this.xhrSetup;
	
	    try {
	      if (xhrSetup) {
	        try {
	          xhrSetup(xhr, context.url);
	        } catch (e) {
	          // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
	          // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
	          xhr.open('GET', context.url, true);
	          xhrSetup(xhr, context.url);
	        }
	      }
	      if (!xhr.readyState) {
	        xhr.open('GET', context.url, true);
	      }
	    } catch (e) {
	      // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
	      this.callbacks.onError({ code: xhr.status, text: e.message }, context, xhr);
	      return;
	    }
	
	    if (context.rangeEnd) {
	      xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
	    }
	    xhr.onreadystatechange = this.readystatechange.bind(this);
	    xhr.onprogress = this.loadprogress.bind(this);
	    xhr.responseType = context.responseType;
	
	    // setup timeout before we perform request
	    this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
	    xhr.send();
	  };
	
	  XhrLoader.prototype.readystatechange = function readystatechange(event) {
	    var xhr = event.currentTarget,
	        readyState = xhr.readyState,
	        stats = this.stats,
	        context = this.context,
	        config = this.config;
	
	    // don't proceed if xhr has been aborted
	    if (stats.aborted) {
	      return;
	    }
	
	    // >= HEADERS_RECEIVED
	    if (readyState >= 2) {
	      // clear xhr timeout and rearm it if readyState less than 4
	      window.clearTimeout(this.requestTimeout);
	      if (stats.tfirst === 0) {
	        stats.tfirst = Math.max(performance.now(), stats.trequest);
	      }
	      if (readyState === 4) {
	        var status = xhr.status;
	        // http status between 200 to 299 are all successful
	        if (status >= 200 && status < 300) {
	          stats.tload = Math.max(stats.tfirst, performance.now());
	          var data = void 0,
	              len = void 0;
	          if (context.responseType === 'arraybuffer') {
	            data = xhr.response;
	            len = data.byteLength;
	          } else {
	            data = xhr.responseText;
	            len = data.length;
	          }
	          stats.loaded = stats.total = len;
	          var response = { url: xhr.responseURL, data: data };
	          this.callbacks.onSuccess(response, stats, context, xhr);
	        } else {
	          // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
	          if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
	            logger["b" /* logger */].error(status + ' while loading ' + context.url);
	            this.callbacks.onError({ code: status, text: xhr.statusText }, context, xhr);
	          } else {
	            // retry
	            logger["b" /* logger */].warn(status + ' while loading ' + context.url + ', retrying in ' + this.retryDelay + '...');
	            // aborts and resets internal state
	            this.destroy();
	            // schedule retry
	            this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
	            // set exponential backoff
	            this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
	            stats.retry++;
	          }
	        }
	      } else {
	        // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
	        this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
	      }
	    }
	  };
	
	  XhrLoader.prototype.loadtimeout = function loadtimeout() {
	    logger["b" /* logger */].warn('timeout while loading ' + this.context.url);
	    this.callbacks.onTimeout(this.stats, this.context, null);
	  };
	
	  XhrLoader.prototype.loadprogress = function loadprogress(event) {
	    var xhr = event.currentTarget,
	        stats = this.stats;
	
	    stats.loaded = event.loaded;
	    if (event.lengthComputable) {
	      stats.total = event.total;
	    }
	    var onProgress = this.callbacks.onProgress;
	    if (onProgress) {
	      // third arg is to provide on progress data
	      onProgress(stats, this.context, null, xhr);
	    }
	  };
	
	  return XhrLoader;
	}();
	
	/* harmony default export */ var xhr_loader = (xhr_loader_XhrLoader);
	// CONCATENATED MODULE: ./src/controller/audio-track-controller.js
	var audio_track_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function audio_track_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function audio_track_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function audio_track_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * audio track controller
	*/
	
	
	
	
	
	
	var audio_track_controller_AudioTrackController = function (_EventHandler) {
	  audio_track_controller__inherits(AudioTrackController, _EventHandler);
	
	  function AudioTrackController(hls) {
	    audio_track_controller__classCallCheck(this, AudioTrackController);
	
	    var _this = audio_track_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_PARSED, events["a" /* default */].AUDIO_TRACK_LOADED, events["a" /* default */].ERROR));
	
	    _this.ticks = 0;
	    _this.ontick = _this.tick.bind(_this);
	    return _this;
	  }
	
	  AudioTrackController.prototype.destroy = function destroy() {
	    this.cleanTimer();
	    event_handler.prototype.destroy.call(this);
	  };
	
	  AudioTrackController.prototype.cleanTimer = function cleanTimer() {
	    if (this.timer) {
	      clearTimeout(this.timer);
	      this.timer = null;
	    }
	  };
	
	  AudioTrackController.prototype.tick = function tick() {
	    this.ticks++;
	    if (this.ticks === 1) {
	      this.doTick();
	      if (this.ticks > 1) {
	        setTimeout(this.tick, 1);
	      }
	      this.ticks = 0;
	    }
	  };
	
	  AudioTrackController.prototype.doTick = function doTick() {
	    this.updateTrack(this.trackId);
	  };
	
	  AudioTrackController.prototype.onError = function onError(data) {
	    if (data.fatal && data.type === errors["b" /* ErrorTypes */].NETWORK_ERROR) {
	      this.cleanTimer();
	    }
	  };
	
	  AudioTrackController.prototype.onManifestLoading = function onManifestLoading() {
	    // reset audio tracks on manifest loading
	    this.tracks = [];
	    this.trackId = -1;
	  };
	
	  AudioTrackController.prototype.onManifestParsed = function onManifestParsed(data) {
	    var _this2 = this;
	
	    var tracks = data.audioTracks || [];
	    var defaultFound = false;
	    this.tracks = tracks;
	    this.hls.trigger(events["a" /* default */].AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
	    // loop through available audio tracks and autoselect default if needed
	    var id = 0;
	    tracks.forEach(function (track) {
	      if (track.default && !defaultFound) {
	        _this2.audioTrack = id;
	        defaultFound = true;
	        return;
	      }
	      id++;
	    });
	    if (defaultFound === false && tracks.length) {
	      logger["b" /* logger */].log('no default audio track defined, use first audio track as default');
	      this.audioTrack = 0;
	    }
	  };
	
	  AudioTrackController.prototype.onAudioTrackLoaded = function onAudioTrackLoaded(data) {
	    if (data.id < this.tracks.length) {
	      logger["b" /* logger */].log('audioTrack ' + data.id + ' loaded');
	      this.tracks[data.id].details = data.details;
	      // check if current playlist is a live playlist
	      if (data.details.live && !this.timer) {
	        // if live playlist we will have to reload it periodically
	        // set reload period to playlist target duration
	        this.timer = setInterval(this.ontick, 1000 * data.details.targetduration);
	      }
	      if (!data.details.live && this.timer) {
	        // playlist is not live and timer is armed : stopping it
	        this.cleanTimer();
	      }
	    }
	  };
	
	  /** get alternate audio tracks list from playlist **/
	
	
	  AudioTrackController.prototype.setAudioTrackInternal = function setAudioTrackInternal(newId) {
	    // check if level idx is valid
	    if (newId >= 0 && newId < this.tracks.length) {
	      // stopping live reloading timer if any
	      this.cleanTimer();
	      this.trackId = newId;
	      logger["b" /* logger */].log('switching to audioTrack ' + newId);
	      var audioTrack = this.tracks[newId],
	          hls = this.hls,
	          type = audioTrack.type,
	          url = audioTrack.url,
	          eventObj = { id: newId, type: type, url: url };
	      // keep AUDIO_TRACK_SWITCH for legacy reason
	      hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCH, eventObj);
	      hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHING, eventObj);
	      // check if we need to load playlist for this audio Track
	      var details = audioTrack.details;
	      if (url && (details === undefined || details.live === true)) {
	        // track not retrieved yet, or live playlist we need to (re)load it
	        logger["b" /* logger */].log('(re)loading playlist for audioTrack ' + newId);
	        hls.trigger(events["a" /* default */].AUDIO_TRACK_LOADING, { url: url, id: newId });
	      }
	    }
	  };
	
	  AudioTrackController.prototype.updateTrack = function updateTrack(newId) {
	    // check if level idx is valid
	    if (newId >= 0 && newId < this.tracks.length) {
	      // stopping live reloading timer if any
	      this.cleanTimer();
	      this.trackId = newId;
	      logger["b" /* logger */].log('updating audioTrack ' + newId);
	      var audioTrack = this.tracks[newId],
	          url = audioTrack.url;
	      // check if we need to load playlist for this audio Track
	      var details = audioTrack.details;
	      if (url && (details === undefined || details.live === true)) {
	        // track not retrieved yet, or live playlist we need to (re)load it
	        logger["b" /* logger */].log('(re)loading playlist for audioTrack ' + newId);
	        this.hls.trigger(events["a" /* default */].AUDIO_TRACK_LOADING, { url: url, id: newId });
	      }
	    }
	  };
	
	  audio_track_controller__createClass(AudioTrackController, [{
	    key: 'audioTracks',
	    get: function get() {
	      return this.tracks;
	    }
	
	    /** get index of the selected audio track (index in audio track lists) **/
	
	  }, {
	    key: 'audioTrack',
	    get: function get() {
	      return this.trackId;
	    }
	
	    /** select an audio track, based on its index in audio track lists**/
	    ,
	    set: function set(audioTrackId) {
	      if (this.trackId !== audioTrackId || this.tracks[audioTrackId].details === undefined) {
	        this.setAudioTrackInternal(audioTrackId);
	      }
	    }
	  }]);
	
	  return AudioTrackController;
	}(event_handler);
	
	/* harmony default export */ var audio_track_controller = (audio_track_controller_AudioTrackController);
	// CONCATENATED MODULE: ./src/controller/audio-stream-controller.js
	var audio_stream_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function audio_stream_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function audio_stream_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function audio_stream_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Audio Stream Controller
	*/
	
	
	
	
	
	
	
	
	
	
	
	var audio_stream_controller_State = {
	  STOPPED: 'STOPPED',
	  STARTING: 'STARTING',
	  IDLE: 'IDLE',
	  PAUSED: 'PAUSED',
	  KEY_LOADING: 'KEY_LOADING',
	  FRAG_LOADING: 'FRAG_LOADING',
	  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
	  WAITING_TRACK: 'WAITING_TRACK',
	  PARSING: 'PARSING',
	  PARSED: 'PARSED',
	  BUFFER_FLUSHING: 'BUFFER_FLUSHING',
	  ENDED: 'ENDED',
	  ERROR: 'ERROR',
	  WAITING_INIT_PTS: 'WAITING_INIT_PTS'
	};
	
	var audio_stream_controller_AudioStreamController = function (_EventHandler) {
	  audio_stream_controller__inherits(AudioStreamController, _EventHandler);
	
	  function AudioStreamController(hls) {
	    audio_stream_controller__classCallCheck(this, AudioStreamController);
	
	    var _this = audio_stream_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].AUDIO_TRACKS_UPDATED, events["a" /* default */].AUDIO_TRACK_SWITCHING, events["a" /* default */].AUDIO_TRACK_LOADED, events["a" /* default */].KEY_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].FRAG_PARSING_INIT_SEGMENT, events["a" /* default */].FRAG_PARSING_DATA, events["a" /* default */].FRAG_PARSED, events["a" /* default */].ERROR, events["a" /* default */].BUFFER_RESET, events["a" /* default */].BUFFER_CREATED, events["a" /* default */].BUFFER_APPENDED, events["a" /* default */].BUFFER_FLUSHED, events["a" /* default */].INIT_PTS_FOUND));
	
	    _this.config = hls.config;
	    _this.audioCodecSwap = false;
	    _this.ticks = 0;
	    _this._state = audio_stream_controller_State.STOPPED;
	    _this.ontick = _this.tick.bind(_this);
	    _this.initPTS = [];
	    _this.waitingFragment = null;
	    _this.videoTrackCC = null;
	    return _this;
	  }
	
	  AudioStreamController.prototype.destroy = function destroy() {
	    this.stopLoad();
	    if (this.timer) {
	      clearInterval(this.timer);
	      this.timer = null;
	    }
	    event_handler.prototype.destroy.call(this);
	    this.state = audio_stream_controller_State.STOPPED;
	  };
	
	  //Signal that video PTS was found
	
	
	  AudioStreamController.prototype.onInitPtsFound = function onInitPtsFound(data) {
	    var demuxerId = data.id,
	        cc = data.frag.cc,
	        initPTS = data.initPTS;
	    if (demuxerId === 'main') {
	      //Always update the new INIT PTS
	      //Can change due level switch
	      this.initPTS[cc] = initPTS;
	      this.videoTrackCC = cc;
	      logger["b" /* logger */].log('InitPTS for cc:' + cc + ' found from video track:' + initPTS);
	
	      //If we are waiting we need to demux/remux the waiting frag
	      //With the new initPTS
	      if (this.state === audio_stream_controller_State.WAITING_INIT_PTS) {
	        this.tick();
	      }
	    }
	  };
	
	  AudioStreamController.prototype.startLoad = function startLoad(startPosition) {
	    if (this.tracks) {
	      var lastCurrentTime = this.lastCurrentTime;
	      this.stopLoad();
	      if (!this.timer) {
	        this.timer = setInterval(this.ontick, 100);
	      }
	      this.fragLoadError = 0;
	      if (lastCurrentTime > 0 && startPosition === -1) {
	        logger["b" /* logger */].log('audio:override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
	        this.state = audio_stream_controller_State.IDLE;
	      } else {
	        this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
	        this.state = audio_stream_controller_State.STARTING;
	      }
	      this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
	      this.tick();
	    } else {
	      this.startPosition = startPosition;
	      this.state = audio_stream_controller_State.STOPPED;
	    }
	  };
	
	  AudioStreamController.prototype.stopLoad = function stopLoad() {
	    var frag = this.fragCurrent;
	    if (frag) {
	      if (frag.loader) {
	        frag.loader.abort();
	      }
	      this.fragCurrent = null;
	    }
	    this.fragPrevious = null;
	    if (this.demuxer) {
	      this.demuxer.destroy();
	      this.demuxer = null;
	    }
	    this.state = audio_stream_controller_State.STOPPED;
	  };
	
	  AudioStreamController.prototype.tick = function tick() {
	    this.ticks++;
	    if (this.ticks === 1) {
	      this.doTick();
	      if (this.ticks > 1) {
	        setTimeout(this.tick, 1);
	      }
	      this.ticks = 0;
	    }
	  };
	
	  AudioStreamController.prototype.doTick = function doTick() {
	    var pos,
	        track,
	        trackDetails,
	        hls = this.hls,
	        config = hls.config;
	    //logger.log('audioStream:' + this.state);
	    switch (this.state) {
	      case audio_stream_controller_State.ERROR:
	      //don't do anything in error state to avoid breaking further ...
	      case audio_stream_controller_State.PAUSED:
	      //don't do anything in paused state either ...
	      case audio_stream_controller_State.BUFFER_FLUSHING:
	        break;
	      case audio_stream_controller_State.STARTING:
	        this.state = audio_stream_controller_State.WAITING_TRACK;
	        this.loadedmetadata = false;
	        break;
	      case audio_stream_controller_State.IDLE:
	        var tracks = this.tracks;
	        // audio tracks not received => exit loop
	        if (!tracks) {
	          break;
	        }
	        // if video not attached AND
	        // start fragment already requested OR start frag prefetch disable
	        // exit loop
	        // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
	        if (!this.media && (this.startFragRequested || !config.startFragPrefetch)) {
	          break;
	        }
	        // determine next candidate fragment to be loaded, based on current position and
	        //  end of buffer position
	        // if we have not yet loaded any fragment, start loading from start position
	        if (this.loadedmetadata) {
	          pos = this.media.currentTime;
	        } else {
	          pos = this.nextLoadPosition;
	          if (pos === undefined) {
	            break;
	          }
	        }
	        var media = this.mediaBuffer ? this.mediaBuffer : this.media,
	            videoBuffer = this.videoBuffer ? this.videoBuffer : this.media,
	            bufferInfo = buffer_helper.bufferInfo(media, pos, config.maxBufferHole),
	            mainBufferInfo = buffer_helper.bufferInfo(videoBuffer, pos, config.maxBufferHole),
	            bufferLen = bufferInfo.len,
	            bufferEnd = bufferInfo.end,
	            fragPrevious = this.fragPrevious,
	
	        // ensure we buffer at least config.maxBufferLength (default 30s)
	        // once we reach that threshold, don't buffer more than video (mainBufferInfo.len)
	        maxBufLen = Math.max(config.maxBufferLength, mainBufferInfo.len),
	            audioSwitch = this.audioSwitch,
	            trackId = this.trackId;
	
	        // if buffer length is less than maxBufLen try to load a new fragment
	        if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
	          trackDetails = tracks[trackId].details;
	          // if track info not retrieved yet, switch state and wait for track retrieval
	          if (typeof trackDetails === 'undefined') {
	            this.state = audio_stream_controller_State.WAITING_TRACK;
	            break;
	          }
	
	          // check if we need to finalize media stream
	          // we just got done loading the final fragment and there is no other buffered range after ...
	          // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
	          // so we should not switch to ENDED in that case, to be able to buffer them
	          if (!audioSwitch && !trackDetails.live && fragPrevious && fragPrevious.sn === trackDetails.endSN && !bufferInfo.nextStart) {
	            // if we are not seeking or if we are seeking but everything (almost) til the end is buffered, let's signal eos
	            // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference when switching
	            // between different renditions. using half frag duration should help cope with these cases.
	            if (!this.media.seeking || this.media.duration - bufferEnd < fragPrevious.duration / 2) {
	              // Finalize the media stream
	              this.hls.trigger(events["a" /* default */].BUFFER_EOS, { type: 'audio' });
	              this.state = audio_stream_controller_State.ENDED;
	              break;
	            }
	          }
	
	          // find fragment index, contiguous with end of buffer position
	          var fragments = trackDetails.fragments,
	              fragLen = fragments.length,
	              start = fragments[0].start,
	              end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
	              frag = void 0;
	
	          // When switching audio track, reload audio as close as possible to currentTime
	          if (audioSwitch) {
	            if (trackDetails.live && !trackDetails.PTSKnown) {
	              logger["b" /* logger */].log('switching audiotrack, live stream, unknown PTS,load first fragment');
	              bufferEnd = 0;
	            } else {
	              bufferEnd = pos;
	              // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
	              if (trackDetails.PTSKnown && pos < start) {
	                // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
	                if (bufferInfo.end > start || bufferInfo.nextStart) {
	                  logger["b" /* logger */].log('alt audio track ahead of main track, seek to start of alt audio track');
	                  this.media.currentTime = start + 0.05;
	                } else {
	                  return;
	                }
	              }
	            }
	          }
	          if (trackDetails.initSegment && !trackDetails.initSegment.data) {
	            frag = trackDetails.initSegment;
	          }
	          // if bufferEnd before start of playlist, load first fragment
	          else if (bufferEnd <= start) {
	              frag = fragments[0];
	              if (this.videoTrackCC !== null && frag.cc !== this.videoTrackCC) {
	                // Ensure we find a fragment which matches the continuity of the video track
	                frag = findFragWithCC(fragments, this.videoTrackCC);
	              }
	              if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
	                // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
	                // let's force seek to start
	                var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
	                logger["b" /* logger */].log('no alt audio available @currentTime:' + this.media.currentTime + ', seeking @' + (nextBuffered + 0.05));
	                this.media.currentTime = nextBuffered + 0.05;
	                return;
	              }
	            } else {
	              var foundFrag = void 0;
	              var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
	              var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
	              var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
	                // offset should be within fragment boundary - config.maxFragLookUpTolerance
	                // this is to cope with situations like
	                // bufferEnd = 9.991
	                // frag[Ø] : [0,10]
	                // frag[1] : [10,20]
	                // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
	                //              frag start               frag start+duration
	                //                  |-----------------------------|
	                //              <--->                         <--->
	                //  ...--------><-----------------------------><---------....
	                // previous frag         matching fragment         next frag
	                //  return -1             return 0                 return 1
	                //logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
	                // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
	                var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
	                if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
	                  return 1;
	                } // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
	                else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
	                    return -1;
	                  }
	                return 0;
	              };
	
	              if (bufferEnd < end) {
	                if (bufferEnd > end - maxFragLookUpTolerance) {
	                  maxFragLookUpTolerance = 0;
	                }
	                // Prefer the next fragment if it's within tolerance
	                if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
	                  foundFrag = fragNext;
	                } else {
	                  foundFrag = binary_search.search(fragments, fragmentWithinToleranceTest);
	                }
	              } else {
	                // reach end of playlist
	                foundFrag = fragments[fragLen - 1];
	              }
	              if (foundFrag) {
	                frag = foundFrag;
	                start = foundFrag.start;
	                //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
	                if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
	                  if (frag.sn < trackDetails.endSN) {
	                    frag = fragments[frag.sn + 1 - trackDetails.startSN];
	                    logger["b" /* logger */].log('SN just loaded, load next one: ' + frag.sn);
	                  } else {
	                    frag = null;
	                  }
	                }
	              }
	            }
	          if (frag) {
	            //logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
	            if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
	              logger["b" /* logger */].log('Loading key for ' + frag.sn + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId);
	              this.state = audio_stream_controller_State.KEY_LOADING;
	              hls.trigger(events["a" /* default */].KEY_LOADING, { frag: frag });
	            } else {
	              logger["b" /* logger */].log('Loading ' + frag.sn + ', cc: ' + frag.cc + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId + ', currentTime:' + pos + ',bufferEnd:' + bufferEnd.toFixed(3));
	              // ensure that we are not reloading the same fragments in loop ...
	              if (this.fragLoadIdx !== undefined) {
	                this.fragLoadIdx++;
	              } else {
	                this.fragLoadIdx = 0;
	              }
	              if (frag.loadCounter) {
	                frag.loadCounter++;
	                var maxThreshold = config.fragLoadingLoopThreshold;
	                // if this frag has already been loaded 3 times, and if it has been reloaded recently
	                if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
	                  hls.trigger(events["a" /* default */].ERROR, { type: errors["b" /* ErrorTypes */].MEDIA_ERROR, details: errors["a" /* ErrorDetails */].FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
	                  return;
	                }
	              } else {
	                frag.loadCounter = 1;
	              }
	              frag.loadIdx = this.fragLoadIdx;
	              this.fragCurrent = frag;
	              this.startFragRequested = true;
	              if (!isNaN(frag.sn)) {
	                this.nextLoadPosition = frag.start + frag.duration;
	              }
	              hls.trigger(events["a" /* default */].FRAG_LOADING, { frag: frag });
	              this.state = audio_stream_controller_State.FRAG_LOADING;
	            }
	          }
	        }
	        break;
	      case audio_stream_controller_State.WAITING_TRACK:
	        track = this.tracks[this.trackId];
	        // check if playlist is already loaded
	        if (track && track.details) {
	          this.state = audio_stream_controller_State.IDLE;
	        }
	        break;
	      case audio_stream_controller_State.FRAG_LOADING_WAITING_RETRY:
	        var now = performance.now();
	        var retryDate = this.retryDate;
	        media = this.media;
	        var isSeeking = media && media.seeking;
	        // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
	        if (!retryDate || now >= retryDate || isSeeking) {
	          logger["b" /* logger */].log('audioStreamController: retryDate reached, switch back to IDLE state');
	          this.state = audio_stream_controller_State.IDLE;
	        }
	        break;
	      case audio_stream_controller_State.WAITING_INIT_PTS:
	        var videoTrackCC = this.videoTrackCC;
	        if (this.initPTS[videoTrackCC] === undefined) {
	          break;
	        }
	
	        // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
	        var waitingFrag = this.waitingFragment;
	        if (waitingFrag) {
	          var waitingFragCC = waitingFrag.frag.cc;
	          if (videoTrackCC !== waitingFragCC) {
	            track = this.tracks[this.trackId];
	            if (track.details && track.details.live) {
	              logger["b" /* logger */].warn('Waiting fragment CC (' + waitingFragCC + ') does not match video track CC (' + videoTrackCC + ')');
	              this.waitingFragment = null;
	              this.state = audio_stream_controller_State.IDLE;
	            }
	          } else {
	            this.state = audio_stream_controller_State.FRAG_LOADING;
	            this.onFragLoaded(this.waitingFragment);
	            this.waitingFragment = null;
	          }
	        } else {
	          this.state = audio_stream_controller_State.IDLE;
	        }
	
	        break;
	      case audio_stream_controller_State.STOPPED:
	      case audio_stream_controller_State.FRAG_LOADING:
	      case audio_stream_controller_State.PARSING:
	      case audio_stream_controller_State.PARSED:
	      case audio_stream_controller_State.ENDED:
	        break;
	      default:
	        break;
	    }
	  };
	
	  AudioStreamController.prototype.onMediaAttached = function onMediaAttached(data) {
	    var media = this.media = this.mediaBuffer = data.media;
	    this.onvseeking = this.onMediaSeeking.bind(this);
	    this.onvended = this.onMediaEnded.bind(this);
	    media.addEventListener('seeking', this.onvseeking);
	    media.addEventListener('ended', this.onvended);
	    var config = this.config;
	    if (this.tracks && config.autoStartLoad) {
	      this.startLoad(config.startPosition);
	    }
	  };
	
	  AudioStreamController.prototype.onMediaDetaching = function onMediaDetaching() {
	    var media = this.media;
	    if (media && media.ended) {
	      logger["b" /* logger */].log('MSE detaching and video ended, reset startPosition');
	      this.startPosition = this.lastCurrentTime = 0;
	    }
	
	    // reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
	    var tracks = this.tracks;
	    if (tracks) {
	      // reset fragment load counter
	      tracks.forEach(function (track) {
	        if (track.details) {
	          track.details.fragments.forEach(function (fragment) {
	            fragment.loadCounter = undefined;
	          });
	        }
	      });
	    }
	    // remove video listeners
	    if (media) {
	      media.removeEventListener('seeking', this.onvseeking);
	      media.removeEventListener('ended', this.onvended);
	      this.onvseeking = this.onvseeked = this.onvended = null;
	    }
	    this.media = this.mediaBuffer = this.videoBuffer = null;
	    this.loadedmetadata = false;
	    this.stopLoad();
	  };
	
	  AudioStreamController.prototype.onMediaSeeking = function onMediaSeeking() {
	    if (this.state === audio_stream_controller_State.ENDED) {
	      // switch to IDLE state to check for potential new fragment
	      this.state = audio_stream_controller_State.IDLE;
	    }
	    if (this.media) {
	      this.lastCurrentTime = this.media.currentTime;
	    }
	    // avoid reporting fragment loop loading error in case user is seeking several times on same position
	    if (this.fragLoadIdx !== undefined) {
	      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	    }
	    // tick to speed up processing
	    this.tick();
	  };
	
	  AudioStreamController.prototype.onMediaEnded = function onMediaEnded() {
	    // reset startPosition and lastCurrentTime to restart playback @ stream beginning
	    this.startPosition = this.lastCurrentTime = 0;
	  };
	
	  AudioStreamController.prototype.onAudioTracksUpdated = function onAudioTracksUpdated(data) {
	    logger["b" /* logger */].log('audio tracks updated');
	    this.tracks = data.audioTracks;
	  };
	
	  AudioStreamController.prototype.onAudioTrackSwitching = function onAudioTrackSwitching(data) {
	    // if any URL found on new audio track, it is an alternate audio track
	    var altAudio = !!data.url;
	    this.trackId = data.id;
	
	    this.fragCurrent = null;
	    this.state = audio_stream_controller_State.PAUSED;
	    this.waitingFragment = null;
	    // destroy useless demuxer when switching audio to main
	    if (!altAudio) {
	      if (this.demuxer) {
	        this.demuxer.destroy();
	        this.demuxer = null;
	      }
	    } else {
	      // switching to audio track, start timer if not already started
	      if (!this.timer) {
	        this.timer = setInterval(this.ontick, 100);
	      }
	    }
	
	    //should we switch tracks ?
	    if (altAudio) {
	      this.audioSwitch = true;
	      //main audio track are handled by stream-controller, just do something if switching to alt audio track
	      this.state = audio_stream_controller_State.IDLE;
	      // increase fragment load Index to avoid frag loop loading error after buffer flush
	      if (this.fragLoadIdx !== undefined) {
	        this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	      }
	    }
	    this.tick();
	  };
	
	  AudioStreamController.prototype.onAudioTrackLoaded = function onAudioTrackLoaded(data) {
	    var newDetails = data.details,
	        trackId = data.id,
	        track = this.tracks[trackId],
	        duration = newDetails.totalduration,
	        sliding = 0;
	
	    logger["b" /* logger */].log('track ' + trackId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);
	
	    if (newDetails.live) {
	      var curDetails = track.details;
	      if (curDetails && newDetails.fragments.length > 0) {
	        // we already have details for that level, merge them
	        mergeDetails(curDetails, newDetails);
	        sliding = newDetails.fragments[0].start;
	        // TODO
	        //this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
	        if (newDetails.PTSKnown) {
	          logger["b" /* logger */].log('live audio playlist sliding:' + sliding.toFixed(3));
	        } else {
	          logger["b" /* logger */].log('live audio playlist - outdated PTS, unknown sliding');
	        }
	      } else {
	        newDetails.PTSKnown = false;
	        logger["b" /* logger */].log('live audio playlist - first load, unknown sliding');
	      }
	    } else {
	      newDetails.PTSKnown = false;
	    }
	    track.details = newDetails;
	
	    // compute start position
	    if (!this.startFragRequested) {
	      // compute start position if set to -1. use it straight away if value is defined
	      if (this.startPosition === -1) {
	        // first, check if start time offset has been set in playlist, if yes, use this value
	        var startTimeOffset = newDetails.startTimeOffset;
	        if (!isNaN(startTimeOffset)) {
	          logger["b" /* logger */].log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
	          this.startPosition = startTimeOffset;
	        } else {
	          this.startPosition = 0;
	        }
	      }
	      this.nextLoadPosition = this.startPosition;
	    }
	    // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
	    if (this.state === audio_stream_controller_State.WAITING_TRACK) {
	      this.state = audio_stream_controller_State.IDLE;
	    }
	    //trigger handler right now
	    this.tick();
	  };
	
	  AudioStreamController.prototype.onKeyLoaded = function onKeyLoaded() {
	    if (this.state === audio_stream_controller_State.KEY_LOADING) {
	      this.state = audio_stream_controller_State.IDLE;
	      this.tick();
	    }
	  };
	
	  AudioStreamController.prototype.onFragLoaded = function onFragLoaded(data) {
	    var fragCurrent = this.fragCurrent,
	        fragLoaded = data.frag;
	    if (this.state === audio_stream_controller_State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'audio' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
	      var track = this.tracks[this.trackId],
	          details = track.details,
	          duration = details.totalduration,
	          trackId = fragCurrent.level,
	          sn = fragCurrent.sn,
	          cc = fragCurrent.cc,
	          audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2',
	          stats = this.stats = data.stats;
	      if (sn === 'initSegment') {
	        this.state = audio_stream_controller_State.IDLE;
	
	        stats.tparsed = stats.tbuffered = performance.now();
	        details.initSegment.data = data.payload;
	        this.hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
	        this.tick();
	      } else {
	        this.state = audio_stream_controller_State.PARSING;
	        // transmux the MPEG-TS data to ISO-BMFF segments
	        this.appended = false;
	        if (!this.demuxer) {
	          this.demuxer = new demux_demuxer(this.hls, 'audio');
	        }
	        //Check if we have video initPTS
	        // If not we need to wait for it
	        var initPTS = this.initPTS[cc];
	        var initSegmentData = details.initSegment ? details.initSegment.data : [];
	        if (details.initSegment || initPTS !== undefined) {
	          this.pendingBuffering = true;
	          logger["b" /* logger */].log('Demuxing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
	          // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
	          var accurateTimeOffset = false; //details.PTSKnown || !details.live;
	          this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
	        } else {
	          logger["b" /* logger */].log('unknown video PTS for continuity counter ' + cc + ', waiting for video PTS before demuxing audio frag ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
	          this.waitingFragment = data;
	          this.state = audio_stream_controller_State.WAITING_INIT_PTS;
	        }
	      }
	    }
	    this.fragLoadError = 0;
	  };
	
	  AudioStreamController.prototype.onFragParsingInitSegment = function onFragParsingInitSegment(data) {
	    var fragCurrent = this.fragCurrent;
	    var fragNew = data.frag;
	    if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === audio_stream_controller_State.PARSING) {
	      var tracks = data.tracks,
	          track = void 0;
	
	      // delete any video track found on audio demuxer
	      if (tracks.video) {
	        delete tracks.video;
	      }
	
	      // include levelCodec in audio and video tracks
	      track = tracks.audio;
	      if (track) {
	        track.levelCodec = track.codec;
	        track.id = data.id;
	        this.hls.trigger(events["a" /* default */].BUFFER_CODECS, tracks);
	        logger["b" /* logger */].log('audio track:audio,container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
	        var initSegment = track.initSegment;
	        if (initSegment) {
	          var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment' };
	          if (this.audioSwitch) {
	            this.pendingData = [appendObj];
	          } else {
	            this.appended = true;
	            // arm pending Buffering flag before appending a segment
	            this.pendingBuffering = true;
	            this.hls.trigger(events["a" /* default */].BUFFER_APPENDING, appendObj);
	          }
	        }
	        //trigger handler right now
	        this.tick();
	      }
	    }
	  };
	
	  AudioStreamController.prototype.onFragParsingData = function onFragParsingData(data) {
	    var _this2 = this;
	
	    var fragCurrent = this.fragCurrent;
	    var fragNew = data.frag;
	    if (fragCurrent && data.id === 'audio' && data.type === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === audio_stream_controller_State.PARSING) {
	      var trackId = this.trackId,
	          track = this.tracks[trackId],
	          hls = this.hls;
	
	      if (isNaN(data.endPTS)) {
	        data.endPTS = data.startPTS + fragCurrent.duration;
	        data.endDTS = data.startDTS + fragCurrent.duration;
	      }
	
	      logger["b" /* logger */].log('parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb);
	      updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);
	
	      var audioSwitch = this.audioSwitch,
	          media = this.media,
	          appendOnBufferFlush = false;
	      //Only flush audio from old audio tracks when PTS is known on new audio track
	      if (audioSwitch && media) {
	        if (media.readyState) {
	          var currentTime = media.currentTime;
	          logger["b" /* logger */].log('switching audio track : currentTime:' + currentTime);
	          if (currentTime >= data.startPTS) {
	            logger["b" /* logger */].log('switching audio track : flushing all audio');
	            this.state = audio_stream_controller_State.BUFFER_FLUSHING;
	            hls.trigger(events["a" /* default */].BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
	            appendOnBufferFlush = true;
	            //Lets announce that the initial audio track switch flush occur
	            this.audioSwitch = false;
	            hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: trackId });
	          }
	        } else {
	          //Lets announce that the initial audio track switch flush occur
	          this.audioSwitch = false;
	          hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: trackId });
	        }
	      }
	
	      var pendingData = this.pendingData;
	      if (!this.audioSwitch) {
	        [data.data1, data.data2].forEach(function (buffer) {
	          if (buffer && buffer.length) {
	            pendingData.push({ type: data.type, data: buffer, parent: 'audio', content: 'data' });
	          }
	        });
	        if (!appendOnBufferFlush && pendingData.length) {
	          pendingData.forEach(function (appendObj) {
	            // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
	            // in that case it is useless to append following segments
	            if (_this2.state === audio_stream_controller_State.PARSING) {
	              // arm pending Buffering flag before appending a segment
	              _this2.pendingBuffering = true;
	              _this2.hls.trigger(events["a" /* default */].BUFFER_APPENDING, appendObj);
	            }
	          });
	          this.pendingData = [];
	          this.appended = true;
	        }
	      }
	      //trigger handler right now
	      this.tick();
	    }
	  };
	
	  AudioStreamController.prototype.onFragParsed = function onFragParsed(data) {
	    var fragCurrent = this.fragCurrent;
	    var fragNew = data.frag;
	    if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === audio_stream_controller_State.PARSING) {
	      this.stats.tparsed = performance.now();
	      this.state = audio_stream_controller_State.PARSED;
	      this._checkAppendedParsed();
	    }
	  };
	
	  AudioStreamController.prototype.onBufferReset = function onBufferReset() {
	    // reset reference to sourcebuffers
	    this.mediaBuffer = this.videoBuffer = null;
	    this.loadedmetadata = false;
	  };
	
	  AudioStreamController.prototype.onBufferCreated = function onBufferCreated(data) {
	    var audioTrack = data.tracks.audio;
	    if (audioTrack) {
	      this.mediaBuffer = audioTrack.buffer;
	      this.loadedmetadata = true;
	    }
	    if (data.tracks.video) {
	      this.videoBuffer = data.tracks.video.buffer;
	    }
	  };
	
	  AudioStreamController.prototype.onBufferAppended = function onBufferAppended(data) {
	    if (data.parent === 'audio') {
	      var state = this.state;
	      if (state === audio_stream_controller_State.PARSING || state === audio_stream_controller_State.PARSED) {
	        // check if all buffers have been appended
	        this.pendingBuffering = data.pending > 0;
	        this._checkAppendedParsed();
	      }
	    }
	  };
	
	  AudioStreamController.prototype._checkAppendedParsed = function _checkAppendedParsed() {
	    //trigger handler right now
	    if (this.state === audio_stream_controller_State.PARSED && (!this.appended || !this.pendingBuffering)) {
	      var frag = this.fragCurrent,
	          stats = this.stats,
	          hls = this.hls;
	      if (frag) {
	        this.fragPrevious = frag;
	        stats.tbuffered = performance.now();
	        hls.trigger(events["a" /* default */].FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
	        var media = this.mediaBuffer ? this.mediaBuffer : this.media;
	        logger["b" /* logger */].log('audio buffered : ' + timeRanges.toString(media.buffered));
	        if (this.audioSwitch && this.appended) {
	          this.audioSwitch = false;
	          hls.trigger(events["a" /* default */].AUDIO_TRACK_SWITCHED, { id: this.trackId });
	        }
	        this.state = audio_stream_controller_State.IDLE;
	      }
	      this.tick();
	    }
	  };
	
	  AudioStreamController.prototype.onError = function onError(data) {
	    var frag = data.frag;
	    // don't handle frag error not related to audio fragment
	    if (frag && frag.type !== 'audio') {
	      return;
	    }
	    switch (data.details) {
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].FRAG_LOAD_TIMEOUT:
	        if (!data.fatal) {
	          var loadError = this.fragLoadError;
	          if (loadError) {
	            loadError++;
	          } else {
	            loadError = 1;
	          }
	          var config = this.config;
	          if (loadError <= config.fragLoadingMaxRetry) {
	            this.fragLoadError = loadError;
	            // reset load counter to avoid frag loop loading error
	            frag.loadCounter = 0;
	            // exponential backoff capped to config.fragLoadingMaxRetryTimeout
	            var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
	            logger["b" /* logger */].warn('audioStreamController: frag loading failed, retry in ' + delay + ' ms');
	            this.retryDate = performance.now() + delay;
	            // retry loading state
	            this.state = audio_stream_controller_State.FRAG_LOADING_WAITING_RETRY;
	          } else {
	            logger["b" /* logger */].error('audioStreamController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
	            // switch error to fatal
	            data.fatal = true;
	            this.state = audio_stream_controller_State.ERROR;
	          }
	        }
	        break;
	      case errors["a" /* ErrorDetails */].FRAG_LOOP_LOADING_ERROR:
	      case errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].AUDIO_TRACK_LOAD_TIMEOUT:
	      case errors["a" /* ErrorDetails */].KEY_LOAD_ERROR:
	      case errors["a" /* ErrorDetails */].KEY_LOAD_TIMEOUT:
	        //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
	        if (this.state !== audio_stream_controller_State.ERROR) {
	          // if fatal error, stop processing, otherwise move to IDLE to retry loading
	          this.state = data.fatal ? audio_stream_controller_State.ERROR : audio_stream_controller_State.IDLE;
	          logger["b" /* logger */].warn('audioStreamController: ' + data.details + ' while loading frag,switch to ' + this.state + ' state ...');
	        }
	        break;
	      case errors["a" /* ErrorDetails */].BUFFER_FULL_ERROR:
	        // if in appending state
	        if (data.parent === 'audio' && (this.state === audio_stream_controller_State.PARSING || this.state === audio_stream_controller_State.PARSED)) {
	          var media = this.mediaBuffer,
	              currentTime = this.media.currentTime,
	              mediaBuffered = media && buffer_helper.isBuffered(media, currentTime) && buffer_helper.isBuffered(media, currentTime + 0.5);
	          // reduce max buf len if current position is buffered
	          if (mediaBuffered) {
	            var _config = this.config;
	            if (_config.maxMaxBufferLength >= _config.maxBufferLength) {
	              // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
	              _config.maxMaxBufferLength /= 2;
	              logger["b" /* logger */].warn('audio:reduce max buffer length to ' + _config.maxMaxBufferLength + 's');
	              // increase fragment load Index to avoid frag loop loading error after buffer flush
	              this.fragLoadIdx += 2 * _config.fragLoadingLoopThreshold;
	            }
	            this.state = audio_stream_controller_State.IDLE;
	          } else {
	            // current position is not buffered, but browser is still complaining about buffer full error
	            // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
	            // in that case flush the whole audio buffer to recover
	            logger["b" /* logger */].warn('buffer full error also media.currentTime is not buffered, flush audio buffer');
	            this.fragCurrent = null;
	            // flush everything
	            this.state = audio_stream_controller_State.BUFFER_FLUSHING;
	            this.hls.trigger(events["a" /* default */].BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
	          }
	        }
	        break;
	      default:
	        break;
	    }
	  };
	
	  AudioStreamController.prototype.onBufferFlushed = function onBufferFlushed() {
	    var _this3 = this;
	
	    var pendingData = this.pendingData;
	    if (pendingData && pendingData.length) {
	      logger["b" /* logger */].log('appending pending audio data on Buffer Flushed');
	      pendingData.forEach(function (appendObj) {
	        _this3.hls.trigger(events["a" /* default */].BUFFER_APPENDING, appendObj);
	      });
	      this.appended = true;
	      this.pendingData = [];
	      this.state = audio_stream_controller_State.PARSED;
	    } else {
	      // move to IDLE once flush complete. this should trigger new fragment loading
	      this.state = audio_stream_controller_State.IDLE;
	      // reset reference to frag
	      this.fragPrevious = null;
	      this.tick();
	    }
	  };
	
	  audio_stream_controller__createClass(AudioStreamController, [{
	    key: 'state',
	    set: function set(nextState) {
	      if (this.state !== nextState) {
	        var previousState = this.state;
	        this._state = nextState;
	        logger["b" /* logger */].log('audio stream:' + previousState + '->' + nextState);
	      }
	    },
	    get: function get() {
	      return this._state;
	    }
	  }]);
	
	  return AudioStreamController;
	}(event_handler);
	
	/* harmony default export */ var audio_stream_controller = (audio_stream_controller_AudioStreamController);
	// CONCATENATED MODULE: ./src/utils/vttcue.js
	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* harmony default export */ var vttcue = ((function () {
	  if (typeof window !== 'undefined' && window.VTTCue) {
	    return window.VTTCue;
	  }
	
	  var autoKeyword = 'auto';
	  var directionSetting = {
	    '': true,
	    lr: true,
	    rl: true
	  };
	  var alignSetting = {
	    start: true,
	    middle: true,
	    end: true,
	    left: true,
	    right: true
	  };
	
	  function findDirectionSetting(value) {
	    if (typeof value !== 'string') {
	      return false;
	    }
	    var dir = directionSetting[value.toLowerCase()];
	    return dir ? value.toLowerCase() : false;
	  }
	
	  function findAlignSetting(value) {
	    if (typeof value !== 'string') {
	      return false;
	    }
	    var align = alignSetting[value.toLowerCase()];
	    return align ? value.toLowerCase() : false;
	  }
	
	  function extend(obj) {
	    var i = 1;
	    for (; i < arguments.length; i++) {
	      var cobj = arguments[i];
	      for (var p in cobj) {
	        obj[p] = cobj[p];
	      }
	    }
	
	    return obj;
	  }
	
	  function VTTCue(startTime, endTime, text) {
	    var cue = this;
	    var isIE8 = function () {
	      if (typeof navigator === 'undefined') {
	        return;
	      }
	      return (/MSIE\s8\.0/.test(navigator.userAgent)
	      );
	    }();
	    var baseObj = {};
	
	    if (isIE8) {
	      cue = document.createElement('custom');
	    } else {
	      baseObj.enumerable = true;
	    }
	
	    /**
	     * Shim implementation specific properties. These properties are not in
	     * the spec.
	     */
	
	    // Lets us know when the VTTCue's data has changed in such a way that we need
	    // to recompute its display state. This lets us compute its display state
	    // lazily.
	    cue.hasBeenReset = false;
	
	    /**
	     * VTTCue and TextTrackCue properties
	     * http://dev.w3.org/html5/webvtt/#vttcue-interface
	     */
	
	    var _id = '';
	    var _pauseOnExit = false;
	    var _startTime = startTime;
	    var _endTime = endTime;
	    var _text = text;
	    var _region = null;
	    var _vertical = '';
	    var _snapToLines = true;
	    var _line = 'auto';
	    var _lineAlign = 'start';
	    var _position = 50;
	    var _positionAlign = 'middle';
	    var _size = 50;
	    var _align = 'middle';
	
	    Object.defineProperty(cue, 'id', extend({}, baseObj, {
	      get: function get() {
	        return _id;
	      },
	      set: function set(value) {
	        _id = '' + value;
	      }
	    }));
	
	    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
	      get: function get() {
	        return _pauseOnExit;
	      },
	      set: function set(value) {
	        _pauseOnExit = !!value;
	      }
	    }));
	
	    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
	      get: function get() {
	        return _startTime;
	      },
	      set: function set(value) {
	        if (typeof value !== 'number') {
	          throw new TypeError('Start time must be set to a number.');
	        }
	        _startTime = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
	      get: function get() {
	        return _endTime;
	      },
	      set: function set(value) {
	        if (typeof value !== 'number') {
	          throw new TypeError('End time must be set to a number.');
	        }
	        _endTime = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'text', extend({}, baseObj, {
	      get: function get() {
	        return _text;
	      },
	      set: function set(value) {
	        _text = '' + value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'region', extend({}, baseObj, {
	      get: function get() {
	        return _region;
	      },
	      set: function set(value) {
	        _region = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
	      get: function get() {
	        return _vertical;
	      },
	      set: function set(value) {
	        var setting = findDirectionSetting(value);
	        // Have to check for false because the setting an be an empty string.
	        if (setting === false) {
	          throw new SyntaxError('An invalid or illegal string was specified.');
	        }
	        _vertical = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
	      get: function get() {
	        return _snapToLines;
	      },
	      set: function set(value) {
	        _snapToLines = !!value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'line', extend({}, baseObj, {
	      get: function get() {
	        return _line;
	      },
	      set: function set(value) {
	        if (typeof value !== 'number' && value !== autoKeyword) {
	          throw new SyntaxError('An invalid number or illegal string was specified.');
	        }
	        _line = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
	      get: function get() {
	        return _lineAlign;
	      },
	      set: function set(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError('An invalid or illegal string was specified.');
	        }
	        _lineAlign = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'position', extend({}, baseObj, {
	      get: function get() {
	        return _position;
	      },
	      set: function set(value) {
	        if (value < 0 || value > 100) {
	          throw new Error('Position must be between 0 and 100.');
	        }
	        _position = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
	      get: function get() {
	        return _positionAlign;
	      },
	      set: function set(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError('An invalid or illegal string was specified.');
	        }
	        _positionAlign = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'size', extend({}, baseObj, {
	      get: function get() {
	        return _size;
	      },
	      set: function set(value) {
	        if (value < 0 || value > 100) {
	          throw new Error('Size must be between 0 and 100.');
	        }
	        _size = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    Object.defineProperty(cue, 'align', extend({}, baseObj, {
	      get: function get() {
	        return _align;
	      },
	      set: function set(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError('An invalid or illegal string was specified.');
	        }
	        _align = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	    /**
	     * Other <track> spec defined properties
	     */
	
	    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
	    cue.displayState = undefined;
	
	    if (isIE8) {
	      return cue;
	    }
	  }
	
	  /**
	   * VTTCue methods
	   */
	
	  VTTCue.prototype.getCueAsHTML = function () {
	    // Assume WebVTT.convertCueToDOMTree is on the global.
	    var WebVTT = window.WebVTT;
	    return WebVTT.convertCueToDOMTree(window, this.text);
	  };
	
	  return VTTCue;
	})());
	// CONCATENATED MODULE: ./src/utils/vttparser.js
	/*
	 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
	 */
	
	
	
	var StringDecoder = function StringDecoder() {
	  return {
	    decode: function decode(data) {
	      if (!data) {
	        return '';
	      }
	      if (typeof data !== 'string') {
	        throw new Error('Error - expected string data.');
	      }
	      return decodeURIComponent(encodeURIComponent(data));
	    }
	  };
	};
	
	function VTTParser() {
	  this.window = window;
	  this.state = 'INITIAL';
	  this.buffer = '';
	  this.decoder = new StringDecoder();
	  this.regionList = [];
	}
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
	  function computeSeconds(h, m, s, f) {
	    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
	  }
	
	  var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
	  if (!m) {
	    return null;
	  }
	
	  if (m[3]) {
	    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
	    return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
	  } else if (m[1] > 59) {
	    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
	    // First position is hours as it's over 59.
	    return computeSeconds(m[1], m[2], 0, m[4]);
	  } else {
	    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
	    return computeSeconds(0, m[1], m[2], m[4]);
	  }
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
	  this.values = Object.create(null);
	}
	
	Settings.prototype = {
	  // Only accept the first assignment to any key.
	  set: function set(k, v) {
	    if (!this.get(k) && v !== '') {
	      this.values[k] = v;
	    }
	  },
	  // Return the value for a key, or a default value.
	  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
	  // a number of possible default values as properties where 'defaultKey' is
	  // the key of the property that will be chosen; otherwise it's assumed to be
	  // a single value.
	  get: function get(k, dflt, defaultKey) {
	    if (defaultKey) {
	      return this.has(k) ? this.values[k] : dflt[defaultKey];
	    }
	    return this.has(k) ? this.values[k] : dflt;
	  },
	  // Check whether we have a value for a key.
	  has: function has(k) {
	    return k in this.values;
	  },
	  // Accept a setting if its one of the given alternatives.
	  alt: function alt(k, v, a) {
	    for (var n = 0; n < a.length; ++n) {
	      if (v === a[n]) {
	        this.set(k, v);
	        break;
	      }
	    }
	  },
	  // Accept a setting if its a valid (signed) integer.
	  integer: function integer(k, v) {
	    if (/^-?\d+$/.test(v)) {
	      // integer
	      this.set(k, parseInt(v, 10));
	    }
	  },
	  // Accept a setting if its a valid percentage.
	  percent: function percent(k, v) {
	    var m;
	    if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
	      v = parseFloat(v);
	      if (v >= 0 && v <= 100) {
	        this.set(k, v);
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
	  var groups = groupDelim ? input.split(groupDelim) : [input];
	  for (var i in groups) {
	    if (typeof groups[i] !== 'string') {
	      continue;
	    }
	    var kv = groups[i].split(keyValueDelim);
	    if (kv.length !== 2) {
	      continue;
	    }
	    var k = kv[0];
	    var v = kv[1];
	    callback(k, v);
	  }
	}
	
	var defaults = new vttcue(0, 0, 0);
	// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
	//  Safari doesn't yet support this change, but FF and Chrome do.
	var center = defaults.align === 'middle' ? 'middle' : 'center';
	
	function parseCue(input, cue, regionList) {
	  // Remember the original input if we need to throw an error.
	  var oInput = input;
	  // 4.1 WebVTT timestamp
	  function consumeTimeStamp() {
	    var ts = parseTimeStamp(input);
	    if (ts === null) {
	      throw new Error('Malformed timestamp: ' + oInput);
	    }
	    // Remove time stamp from input.
	    input = input.replace(/^[^\sa-zA-Z-]+/, '');
	    return ts;
	  }
	
	  // 4.4.2 WebVTT cue settings
	  function consumeCueSettings(input, cue) {
	    var settings = new Settings();
	
	    parseOptions(input, function (k, v) {
	      switch (k) {
	        case 'region':
	          // Find the last region we parsed with the same region id.
	          for (var i = regionList.length - 1; i >= 0; i--) {
	            if (regionList[i].id === v) {
	              settings.set(k, regionList[i].region);
	              break;
	            }
	          }
	          break;
	        case 'vertical':
	          settings.alt(k, v, ['rl', 'lr']);
	          break;
	        case 'line':
	          var vals = v.split(','),
	              vals0 = vals[0];
	          settings.integer(k, vals0);
	          if (settings.percent(k, vals0)) {
	            settings.set('snapToLines', false);
	          }
	          settings.alt(k, vals0, ['auto']);
	          if (vals.length === 2) {
	            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
	          }
	          break;
	        case 'position':
	          vals = v.split(',');
	          settings.percent(k, vals[0]);
	          if (vals.length === 2) {
	            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
	          }
	          break;
	        case 'size':
	          settings.percent(k, v);
	          break;
	        case 'align':
	          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
	          break;
	      }
	    }, /:/, /\s/);
	
	    // Apply default values for any missing fields.
	    cue.region = settings.get('region', null);
	    cue.vertical = settings.get('vertical', '');
	    var line = settings.get('line', 'auto');
	    if (line === 'auto' && defaults.line === -1) {
	      // set numeric line number for Safari
	      line = -1;
	    }
	    cue.line = line;
	    cue.lineAlign = settings.get('lineAlign', 'start');
	    cue.snapToLines = settings.get('snapToLines', true);
	    cue.size = settings.get('size', 100);
	    cue.align = settings.get('align', center);
	    var position = settings.get('position', 'auto');
	    if (position === 'auto' && defaults.position === 50) {
	      // set numeric position for Safari
	      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
	    }
	    cue.position = position;
	  }
	
	  function skipWhitespace() {
	    input = input.replace(/^\s+/, '');
	  }
	
	  // 4.1 WebVTT cue timings.
	  skipWhitespace();
	  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
	  skipWhitespace();
	  if (input.substr(0, 3) !== '-->') {
	    // (3) next characters must match '-->'
	    throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' + oInput);
	  }
	  input = input.substr(3);
	  skipWhitespace();
	  cue.endTime = consumeTimeStamp(); // (5) collect cue end time
	
	  // 4.1 WebVTT cue settings list.
	  skipWhitespace();
	  consumeCueSettings(input, cue);
	}
	
	function fixLineBreaks(input) {
	  return input.replace(/<br(?: \/)?>/gi, '\n');
	}
	
	VTTParser.prototype = {
	  parse: function parse(data) {
	    var self = this;
	
	    // If there is no data then we won't decode it, but will just try to parse
	    // whatever is in buffer already. This may occur in circumstances, for
	    // example when flush() is called.
	    if (data) {
	      // Try to decode the data that we received.
	      self.buffer += self.decoder.decode(data, { stream: true });
	    }
	
	    function collectNextLine() {
	      var buffer = self.buffer;
	      var pos = 0;
	
	      buffer = fixLineBreaks(buffer);
	
	      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
	        ++pos;
	      }
	      var line = buffer.substr(0, pos);
	      // Advance the buffer early in case we fail below.
	      if (buffer[pos] === '\r') {
	        ++pos;
	      }
	      if (buffer[pos] === '\n') {
	        ++pos;
	      }
	      self.buffer = buffer.substr(pos);
	      return line;
	    }
	
	    // 3.2 WebVTT metadata header syntax
	    function parseHeader(input) {
	      parseOptions(input, function (k, v) {
	        switch (k) {
	          case 'Region':
	            // 3.3 WebVTT region metadata header syntax
	            console.log('parse region', v);
	            //parseRegion(v);
	            break;
	        }
	      }, /:/);
	    }
	
	    // 5.1 WebVTT file parsing.
	    try {
	      var line;
	      if (self.state === 'INITIAL') {
	        // We can't start parsing until we have the first line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        line = collectNextLine();
	        // strip of UTF-8 BOM if any
	        // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
	        var m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
	        if (!m || !m[0]) {
	          throw new Error('Malformed WebVTT signature.');
	        }
	
	        self.state = 'HEADER';
	      }
	
	      var alreadyCollectedLine = false;
	      while (self.buffer) {
	        // We can't parse a line until we have the full line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        if (!alreadyCollectedLine) {
	          line = collectNextLine();
	        } else {
	          alreadyCollectedLine = false;
	        }
	
	        switch (self.state) {
	          case 'HEADER':
	            // 13-18 - Allow a header (metadata) under the WEBVTT line.
	            if (/:/.test(line)) {
	              parseHeader(line);
	            } else if (!line) {
	              // An empty line terminates the header and starts the body (cues).
	              self.state = 'ID';
	            }
	            continue;
	          case 'NOTE':
	            // Ignore NOTE blocks.
	            if (!line) {
	              self.state = 'ID';
	            }
	            continue;
	          case 'ID':
	            // Check for the start of NOTE blocks.
	            if (/^NOTE($|[ \t])/.test(line)) {
	              self.state = 'NOTE';
	              break;
	            }
	            // 19-29 - Allow any number of line terminators, then initialize new cue values.
	            if (!line) {
	              continue;
	            }
	            self.cue = new vttcue(0, 0, '');
	            self.state = 'CUE';
	            // 30-39 - Check if self line contains an optional identifier or timing data.
	            if (line.indexOf('-->') === -1) {
	              self.cue.id = line;
	              continue;
	            }
	          // Process line as start of a cue.
	          /*falls through*/
	          case 'CUE':
	            // 40 - Collect cue timings and settings.
	            try {
	              parseCue(line, self.cue, self.regionList);
	            } catch (e) {
	              // In case of an error ignore rest of the cue.
	              self.cue = null;
	              self.state = 'BADCUE';
	              continue;
	            }
	            self.state = 'CUETEXT';
	            continue;
	          case 'CUETEXT':
	            var hasSubstring = line.indexOf('-->') !== -1;
	            // 34 - If we have an empty line then report the cue.
	            // 35 - If we have the special substring '-->' then report the cue,
	            // but do not collect the line as we need to process the current
	            // one as a new cue.
	            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
	              // We are done parsing self cue.
	              if (self.oncue) {
	                self.oncue(self.cue);
	              }
	              self.cue = null;
	              self.state = 'ID';
	              continue;
	            }
	            if (self.cue.text) {
	              self.cue.text += '\n';
	            }
	            self.cue.text += line;
	            continue;
	          case 'BADCUE':
	            // BADCUE
	            // 54-62 - Collect and discard the remaining cue.
	            if (!line) {
	              self.state = 'ID';
	            }
	            continue;
	        }
	      }
	    } catch (e) {
	
	      // If we are currently parsing a cue, report what we have.
	      if (self.state === 'CUETEXT' && self.cue && self.oncue) {
	        self.oncue(self.cue);
	      }
	      self.cue = null;
	      // Enter BADWEBVTT state if header was not parsed correctly otherwise
	      // another exception occurred so enter BADCUE state.
	      self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
	    }
	    return this;
	  },
	  flush: function flush() {
	    var self = this;
	    try {
	      // Finish decoding the stream.
	      self.buffer += self.decoder.decode();
	      // Synthesize the end of the current cue or region.
	      if (self.cue || self.state === 'HEADER') {
	        self.buffer += '\n\n';
	        self.parse();
	      }
	      // If we've flushed, parsed, and we're still on the INITIAL state then
	      // that means we don't have enough of the stream to parse the first
	      // line.
	      if (self.state === 'INITIAL') {
	        throw new Error('Malformed WebVTT signature.');
	      }
	    } catch (e) {
	      throw e;
	    }
	    if (self.onflush) {
	      self.onflush();
	    }
	    return this;
	  }
	};
	
	
	
	/* harmony default export */ var vttparser = (VTTParser);
	// CONCATENATED MODULE: ./src/utils/cues.js
	
	
	function newCue(track, startTime, endTime, captionScreen) {
	  var row;
	  var cue;
	  var indenting;
	  var indent;
	  var text;
	  var VTTCue = window.VTTCue || window.TextTrackCue;
	
	  for (var r = 0; r < captionScreen.rows.length; r++) {
	    row = captionScreen.rows[r];
	    indenting = true;
	    indent = 0;
	    text = '';
	
	    if (!row.isEmpty()) {
	      for (var c = 0; c < row.chars.length; c++) {
	        if (row.chars[c].uchar.match(/\s/) && indenting) {
	          indent++;
	        } else {
	          text += row.chars[c].uchar;
	          indenting = false;
	        }
	      }
	      //To be used for cleaning-up orphaned roll-up captions
	      row.cueStartTime = startTime;
	
	      // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
	      if (startTime === endTime) {
	        endTime += 0.0001;
	      }
	
	      cue = new VTTCue(startTime, endTime, fixLineBreaks(text.trim()));
	
	      if (indent >= 16) {
	        indent--;
	      } else {
	        indent++;
	      }
	
	      // VTTCue.line get's flakey when using controls, so let's now include line 13&14
	      // also, drop line 1 since it's to close to the top
	      if (navigator.userAgent.match(/Firefox\//)) {
	        cue.line = r + 1;
	      } else {
	        cue.line = r > 7 ? r - 2 : r + 1;
	      }
	      cue.align = 'left';
	      // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
	      cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0)));
	      track.addCue(cue);
	    }
	  }
	}
	// CONCATENATED MODULE: ./src/utils/cea-608-parser.js
	function cea_608_parser__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 *
	 * This code was ported from the dash.js project at:
	 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
	 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
	 *
	 * The original copyright appears below:
	 *
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2015-2016, DASH Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  1. Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  2. Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */
	/**
	 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
	 */
	
	var specialCea608CharsCodes = {
	    0x2a: 0xe1, // lowercase a, acute accent
	    0x5c: 0xe9, // lowercase e, acute accent
	    0x5e: 0xed, // lowercase i, acute accent
	    0x5f: 0xf3, // lowercase o, acute accent
	    0x60: 0xfa, // lowercase u, acute accent
	    0x7b: 0xe7, // lowercase c with cedilla
	    0x7c: 0xf7, // division symbol
	    0x7d: 0xd1, // uppercase N tilde
	    0x7e: 0xf1, // lowercase n tilde
	    0x7f: 0x2588, // Full block
	    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
	    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
	    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
	    0x80: 0xae, // Registered symbol (R)
	    0x81: 0xb0, // degree sign
	    0x82: 0xbd, // 1/2 symbol
	    0x83: 0xbf, // Inverted (open) question mark
	    0x84: 0x2122, // Trademark symbol (TM)
	    0x85: 0xa2, // Cents symbol
	    0x86: 0xa3, // Pounds sterling
	    0x87: 0x266a, // Music 8'th note
	    0x88: 0xe0, // lowercase a, grave accent
	    0x89: 0x20, // transparent space (regular)
	    0x8a: 0xe8, // lowercase e, grave accent
	    0x8b: 0xe2, // lowercase a, circumflex accent
	    0x8c: 0xea, // lowercase e, circumflex accent
	    0x8d: 0xee, // lowercase i, circumflex accent
	    0x8e: 0xf4, // lowercase o, circumflex accent
	    0x8f: 0xfb, // lowercase u, circumflex accent
	    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
	    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
	    0x90: 0xc1, // capital letter A with acute
	    0x91: 0xc9, // capital letter E with acute
	    0x92: 0xd3, // capital letter O with acute
	    0x93: 0xda, // capital letter U with acute
	    0x94: 0xdc, // capital letter U with diaresis
	    0x95: 0xfc, // lowercase letter U with diaeresis
	    0x96: 0x2018, // opening single quote
	    0x97: 0xa1, // inverted exclamation mark
	    0x98: 0x2a, // asterisk
	    0x99: 0x2019, // closing single quote
	    0x9a: 0x2501, // box drawings heavy horizontal
	    0x9b: 0xa9, // copyright sign
	    0x9c: 0x2120, // Service mark
	    0x9d: 0x2022, // (round) bullet
	    0x9e: 0x201c, // Left double quotation mark
	    0x9f: 0x201d, // Right double quotation mark
	    0xa0: 0xc0, // uppercase A, grave accent
	    0xa1: 0xc2, // uppercase A, circumflex
	    0xa2: 0xc7, // uppercase C with cedilla
	    0xa3: 0xc8, // uppercase E, grave accent
	    0xa4: 0xca, // uppercase E, circumflex
	    0xa5: 0xcb, // capital letter E with diaresis
	    0xa6: 0xeb, // lowercase letter e with diaresis
	    0xa7: 0xce, // uppercase I, circumflex
	    0xa8: 0xcf, // uppercase I, with diaresis
	    0xa9: 0xef, // lowercase i, with diaresis
	    0xaa: 0xd4, // uppercase O, circumflex
	    0xab: 0xd9, // uppercase U, grave accent
	    0xac: 0xf9, // lowercase u, grave accent
	    0xad: 0xdb, // uppercase U, circumflex
	    0xae: 0xab, // left-pointing double angle quotation mark
	    0xaf: 0xbb, // right-pointing double angle quotation mark
	    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
	    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
	    0xb0: 0xc3, // Uppercase A, tilde
	    0xb1: 0xe3, // Lowercase a, tilde
	    0xb2: 0xcd, // Uppercase I, acute accent
	    0xb3: 0xcc, // Uppercase I, grave accent
	    0xb4: 0xec, // Lowercase i, grave accent
	    0xb5: 0xd2, // Uppercase O, grave accent
	    0xb6: 0xf2, // Lowercase o, grave accent
	    0xb7: 0xd5, // Uppercase O, tilde
	    0xb8: 0xf5, // Lowercase o, tilde
	    0xb9: 0x7b, // Open curly brace
	    0xba: 0x7d, // Closing curly brace
	    0xbb: 0x5c, // Backslash
	    0xbc: 0x5e, // Caret
	    0xbd: 0x5f, // Underscore
	    0xbe: 0x7c, // Pipe (vertical line)
	    0xbf: 0x223c, // Tilde operator
	    0xc0: 0xc4, // Uppercase A, umlaut
	    0xc1: 0xe4, // Lowercase A, umlaut
	    0xc2: 0xd6, // Uppercase O, umlaut
	    0xc3: 0xf6, // Lowercase o, umlaut
	    0xc4: 0xdf, // Esszett (sharp S)
	    0xc5: 0xa5, // Yen symbol
	    0xc6: 0xa4, // Generic currency sign
	    0xc7: 0x2503, // Box drawings heavy vertical
	    0xc8: 0xc5, // Uppercase A, ring
	    0xc9: 0xe5, // Lowercase A, ring
	    0xca: 0xd8, // Uppercase O, stroke
	    0xcb: 0xf8, // Lowercase o, strok
	    0xcc: 0x250f, // Box drawings heavy down and right
	    0xcd: 0x2513, // Box drawings heavy down and left
	    0xce: 0x2517, // Box drawings heavy up and right
	    0xcf: 0x251b // Box drawings heavy up and left
	};
	
	/**
	 * Utils
	 */
	var getCharForByte = function getCharForByte(byte) {
	    var charCode = byte;
	    if (specialCea608CharsCodes.hasOwnProperty(byte)) {
	        charCode = specialCea608CharsCodes[byte];
	    }
	    return String.fromCharCode(charCode);
	};
	
	var NR_ROWS = 15,
	    NR_COLS = 100;
	// Tables to look up row from PAC data
	var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
	var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
	var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
	var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };
	
	var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
	
	/**
	 * Simple logger class to be able to write with time-stamps and filter on level.
	 */
	var cea_608_parser_logger = {
	    verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
	    time: null,
	    verboseLevel: 0, // Only write errors
	    setTime: function setTime(newTime) {
	        this.time = newTime;
	    },
	    log: function log(severity, msg) {
	        var minLevel = this.verboseFilter[severity];
	        if (this.verboseLevel >= minLevel) {
	            console.log(this.time + ' [' + severity + '] ' + msg);
	        }
	    }
	};
	
	var numArrayToHexArray = function numArrayToHexArray(numArray) {
	    var hexArray = [];
	    for (var j = 0; j < numArray.length; j++) {
	        hexArray.push(numArray[j].toString(16));
	    }
	    return hexArray;
	};
	
	var PenState = function () {
	    function PenState(foreground, underline, italics, background, flash) {
	        cea_608_parser__classCallCheck(this, PenState);
	
	        this.foreground = foreground || 'white';
	        this.underline = underline || false;
	        this.italics = italics || false;
	        this.background = background || 'black';
	        this.flash = flash || false;
	    }
	
	    PenState.prototype.reset = function reset() {
	        this.foreground = 'white';
	        this.underline = false;
	        this.italics = false;
	        this.background = 'black';
	        this.flash = false;
	    };
	
	    PenState.prototype.setStyles = function setStyles(styles) {
	        var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
	        for (var i = 0; i < attribs.length; i++) {
	            var style = attribs[i];
	            if (styles.hasOwnProperty(style)) {
	                this[style] = styles[style];
	            }
	        }
	    };
	
	    PenState.prototype.isDefault = function isDefault() {
	        return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
	    };
	
	    PenState.prototype.equals = function equals(other) {
	        return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
	    };
	
	    PenState.prototype.copy = function copy(newPenState) {
	        this.foreground = newPenState.foreground;
	        this.underline = newPenState.underline;
	        this.italics = newPenState.italics;
	        this.background = newPenState.background;
	        this.flash = newPenState.flash;
	    };
	
	    PenState.prototype.toString = function toString() {
	        return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
	    };
	
	    return PenState;
	}();
	
	/**
	 * Unicode character with styling and background.
	 * @constructor
	 */
	
	
	var StyledUnicodeChar = function () {
	    function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
	        cea_608_parser__classCallCheck(this, StyledUnicodeChar);
	
	        this.uchar = uchar || ' '; // unicode character
	        this.penState = new PenState(foreground, underline, italics, background, flash);
	    }
	
	    StyledUnicodeChar.prototype.reset = function reset() {
	        this.uchar = ' ';
	        this.penState.reset();
	    };
	
	    StyledUnicodeChar.prototype.setChar = function setChar(uchar, newPenState) {
	        this.uchar = uchar;
	        this.penState.copy(newPenState);
	    };
	
	    StyledUnicodeChar.prototype.setPenState = function setPenState(newPenState) {
	        this.penState.copy(newPenState);
	    };
	
	    StyledUnicodeChar.prototype.equals = function equals(other) {
	        return this.uchar === other.uchar && this.penState.equals(other.penState);
	    };
	
	    StyledUnicodeChar.prototype.copy = function copy(newChar) {
	        this.uchar = newChar.uchar;
	        this.penState.copy(newChar.penState);
	    };
	
	    StyledUnicodeChar.prototype.isEmpty = function isEmpty() {
	        return this.uchar === ' ' && this.penState.isDefault();
	    };
	
	    return StyledUnicodeChar;
	}();
	
	/**
	 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
	 * @constructor
	 */
	
	
	var Row = function () {
	    function Row() {
	        cea_608_parser__classCallCheck(this, Row);
	
	        this.chars = [];
	        for (var i = 0; i < NR_COLS; i++) {
	            this.chars.push(new StyledUnicodeChar());
	        }
	        this.pos = 0;
	        this.currPenState = new PenState();
	    }
	
	    Row.prototype.equals = function equals(other) {
	        var equal = true;
	        for (var i = 0; i < NR_COLS; i++) {
	            if (!this.chars[i].equals(other.chars[i])) {
	                equal = false;
	                break;
	            }
	        }
	        return equal;
	    };
	
	    Row.prototype.copy = function copy(other) {
	        for (var i = 0; i < NR_COLS; i++) {
	            this.chars[i].copy(other.chars[i]);
	        }
	    };
	
	    Row.prototype.isEmpty = function isEmpty() {
	        var empty = true;
	        for (var i = 0; i < NR_COLS; i++) {
	            if (!this.chars[i].isEmpty()) {
	                empty = false;
	                break;
	            }
	        }
	        return empty;
	    };
	
	    /**
	     *  Set the cursor to a valid column.
	     */
	
	
	    Row.prototype.setCursor = function setCursor(absPos) {
	        if (this.pos !== absPos) {
	            this.pos = absPos;
	        }
	        if (this.pos < 0) {
	            cea_608_parser_logger.log('ERROR', 'Negative cursor position ' + this.pos);
	            this.pos = 0;
	        } else if (this.pos > NR_COLS) {
	            cea_608_parser_logger.log('ERROR', 'Too large cursor position ' + this.pos);
	            this.pos = NR_COLS;
	        }
	    };
	
	    /**
	     * Move the cursor relative to current position.
	     */
	
	
	    Row.prototype.moveCursor = function moveCursor(relPos) {
	        var newPos = this.pos + relPos;
	        if (relPos > 1) {
	            for (var i = this.pos + 1; i < newPos + 1; i++) {
	                this.chars[i].setPenState(this.currPenState);
	            }
	        }
	        this.setCursor(newPos);
	    };
	
	    /**
	     * Backspace, move one step back and clear character.
	     */
	
	
	    Row.prototype.backSpace = function backSpace() {
	        this.moveCursor(-1);
	        this.chars[this.pos].setChar(' ', this.currPenState);
	    };
	
	    Row.prototype.insertChar = function insertChar(byte) {
	        if (byte >= 0x90) {
	            //Extended char
	            this.backSpace();
	        }
	        var char = getCharForByte(byte);
	        if (this.pos >= NR_COLS) {
	            cea_608_parser_logger.log('ERROR', 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
	            return;
	        }
	        this.chars[this.pos].setChar(char, this.currPenState);
	        this.moveCursor(1);
	    };
	
	    Row.prototype.clearFromPos = function clearFromPos(startPos) {
	        var i;
	        for (i = startPos; i < NR_COLS; i++) {
	            this.chars[i].reset();
	        }
	    };
	
	    Row.prototype.clear = function clear() {
	        this.clearFromPos(0);
	        this.pos = 0;
	        this.currPenState.reset();
	    };
	
	    Row.prototype.clearToEndOfRow = function clearToEndOfRow() {
	        this.clearFromPos(this.pos);
	    };
	
	    Row.prototype.getTextString = function getTextString() {
	        var chars = [];
	        var empty = true;
	        for (var i = 0; i < NR_COLS; i++) {
	            var char = this.chars[i].uchar;
	            if (char !== ' ') {
	                empty = false;
	            }
	            chars.push(char);
	        }
	        if (empty) {
	            return '';
	        } else {
	            return chars.join('');
	        }
	    };
	
	    Row.prototype.setPenStyles = function setPenStyles(styles) {
	        this.currPenState.setStyles(styles);
	        var currChar = this.chars[this.pos];
	        currChar.setPenState(this.currPenState);
	    };
	
	    return Row;
	}();
	
	/**
	 * Keep a CEA-608 screen of 32x15 styled characters
	 * @constructor
	*/
	
	
	var CaptionScreen = function () {
	    function CaptionScreen() {
	        cea_608_parser__classCallCheck(this, CaptionScreen);
	
	        this.rows = [];
	        for (var i = 0; i < NR_ROWS; i++) {
	            this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
	        }
	        this.currRow = NR_ROWS - 1;
	        this.nrRollUpRows = null;
	        this.reset();
	    }
	
	    CaptionScreen.prototype.reset = function reset() {
	        for (var i = 0; i < NR_ROWS; i++) {
	            this.rows[i].clear();
	        }
	        this.currRow = NR_ROWS - 1;
	    };
	
	    CaptionScreen.prototype.equals = function equals(other) {
	        var equal = true;
	        for (var i = 0; i < NR_ROWS; i++) {
	            if (!this.rows[i].equals(other.rows[i])) {
	                equal = false;
	                break;
	            }
	        }
	        return equal;
	    };
	
	    CaptionScreen.prototype.copy = function copy(other) {
	        for (var i = 0; i < NR_ROWS; i++) {
	            this.rows[i].copy(other.rows[i]);
	        }
	    };
	
	    CaptionScreen.prototype.isEmpty = function isEmpty() {
	        var empty = true;
	        for (var i = 0; i < NR_ROWS; i++) {
	            if (!this.rows[i].isEmpty()) {
	                empty = false;
	                break;
	            }
	        }
	        return empty;
	    };
	
	    CaptionScreen.prototype.backSpace = function backSpace() {
	        var row = this.rows[this.currRow];
	        row.backSpace();
	    };
	
	    CaptionScreen.prototype.clearToEndOfRow = function clearToEndOfRow() {
	        var row = this.rows[this.currRow];
	        row.clearToEndOfRow();
	    };
	
	    /**
	     * Insert a character (without styling) in the current row.
	     */
	
	
	    CaptionScreen.prototype.insertChar = function insertChar(char) {
	        var row = this.rows[this.currRow];
	        row.insertChar(char);
	    };
	
	    CaptionScreen.prototype.setPen = function setPen(styles) {
	        var row = this.rows[this.currRow];
	        row.setPenStyles(styles);
	    };
	
	    CaptionScreen.prototype.moveCursor = function moveCursor(relPos) {
	        var row = this.rows[this.currRow];
	        row.moveCursor(relPos);
	    };
	
	    CaptionScreen.prototype.setCursor = function setCursor(absPos) {
	        cea_608_parser_logger.log('INFO', 'setCursor: ' + absPos);
	        var row = this.rows[this.currRow];
	        row.setCursor(absPos);
	    };
	
	    CaptionScreen.prototype.setPAC = function setPAC(pacData) {
	        cea_608_parser_logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
	        var newRow = pacData.row - 1;
	        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
	            newRow = this.nrRollUpRows - 1;
	        }
	
	        //Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
	        if (this.nrRollUpRows && this.currRow !== newRow) {
	            //clear all rows first
	            for (var i = 0; i < NR_ROWS; i++) {
	                this.rows[i].clear();
	            }
	
	            //Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
	            //topRowIndex - the start of rows to copy (inclusive index)
	            var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
	            //We only copy if the last position was already shown.
	            //We use the cueStartTime value to check this.
	            var lastOutputScreen = this.lastOutputScreen;
	            if (lastOutputScreen) {
	                var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
	                if (prevLineTime && prevLineTime < cea_608_parser_logger.time) {
	                    for (var _i = 0; _i < this.nrRollUpRows; _i++) {
	                        this.rows[newRow - this.nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
	                    }
	                }
	            }
	        }
	
	        this.currRow = newRow;
	        var row = this.rows[this.currRow];
	        if (pacData.indent !== null) {
	            var indent = pacData.indent;
	            var prevPos = Math.max(indent - 1, 0);
	            row.setCursor(pacData.indent);
	            pacData.color = row.chars[prevPos].penState.foreground;
	        }
	        var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
	        this.setPen(styles);
	    };
	
	    /**
	     * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
	     */
	
	
	    CaptionScreen.prototype.setBkgData = function setBkgData(bkgData) {
	
	        cea_608_parser_logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
	        this.backSpace();
	        this.setPen(bkgData);
	        this.insertChar(0x20); //Space
	    };
	
	    CaptionScreen.prototype.setRollUpRows = function setRollUpRows(nrRows) {
	        this.nrRollUpRows = nrRows;
	    };
	
	    CaptionScreen.prototype.rollUp = function rollUp() {
	        if (this.nrRollUpRows === null) {
	            cea_608_parser_logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
	            return; //Not properly setup
	        }
	        cea_608_parser_logger.log('TEXT', this.getDisplayText());
	        var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
	        var topRow = this.rows.splice(topRowIndex, 1)[0];
	        topRow.clear();
	        this.rows.splice(this.currRow, 0, topRow);
	        cea_608_parser_logger.log('INFO', 'Rolling up');
	        //logger.log('TEXT', this.get_display_text())
	    };
	
	    /**
	     * Get all non-empty rows with as unicode text.
	     */
	
	
	    CaptionScreen.prototype.getDisplayText = function getDisplayText(asOneRow) {
	        asOneRow = asOneRow || false;
	        var displayText = [];
	        var text = '';
	        var rowNr = -1;
	        for (var i = 0; i < NR_ROWS; i++) {
	            var rowText = this.rows[i].getTextString();
	            if (rowText) {
	                rowNr = i + 1;
	                if (asOneRow) {
	                    displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
	                } else {
	                    displayText.push(rowText.trim());
	                }
	            }
	        }
	        if (displayText.length > 0) {
	            if (asOneRow) {
	                text = '[' + displayText.join(' | ') + ']';
	            } else {
	                text = displayText.join('\n');
	            }
	        }
	        return text;
	    };
	
	    CaptionScreen.prototype.getTextAndFormat = function getTextAndFormat() {
	        return this.rows;
	    };
	
	    return CaptionScreen;
	}();
	
	//var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
	
	var Cea608Channel = function () {
	    function Cea608Channel(channelNumber, outputFilter) {
	        cea_608_parser__classCallCheck(this, Cea608Channel);
	
	        this.chNr = channelNumber;
	        this.outputFilter = outputFilter;
	        this.mode = null;
	        this.verbose = 0;
	        this.displayedMemory = new CaptionScreen();
	        this.nonDisplayedMemory = new CaptionScreen();
	        this.lastOutputScreen = new CaptionScreen();
	        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
	        this.writeScreen = this.displayedMemory;
	        this.mode = null;
	        this.cueStartTime = null; // Keeps track of where a cue started.
	    }
	
	    Cea608Channel.prototype.reset = function reset() {
	        this.mode = null;
	        this.displayedMemory.reset();
	        this.nonDisplayedMemory.reset();
	        this.lastOutputScreen.reset();
	        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
	        this.writeScreen = this.displayedMemory;
	        this.mode = null;
	        this.cueStartTime = null;
	        this.lastCueEndTime = null;
	    };
	
	    Cea608Channel.prototype.getHandler = function getHandler() {
	        return this.outputFilter;
	    };
	
	    Cea608Channel.prototype.setHandler = function setHandler(newHandler) {
	        this.outputFilter = newHandler;
	    };
	
	    Cea608Channel.prototype.setPAC = function setPAC(pacData) {
	        this.writeScreen.setPAC(pacData);
	    };
	
	    Cea608Channel.prototype.setBkgData = function setBkgData(bkgData) {
	        this.writeScreen.setBkgData(bkgData);
	    };
	
	    Cea608Channel.prototype.setMode = function setMode(newMode) {
	        if (newMode === this.mode) {
	            return;
	        }
	        this.mode = newMode;
	        cea_608_parser_logger.log('INFO', 'MODE=' + newMode);
	        if (this.mode === 'MODE_POP-ON') {
	            this.writeScreen = this.nonDisplayedMemory;
	        } else {
	            this.writeScreen = this.displayedMemory;
	            this.writeScreen.reset();
	        }
	        if (this.mode !== 'MODE_ROLL-UP') {
	            this.displayedMemory.nrRollUpRows = null;
	            this.nonDisplayedMemory.nrRollUpRows = null;
	        }
	        this.mode = newMode;
	    };
	
	    Cea608Channel.prototype.insertChars = function insertChars(chars) {
	        for (var i = 0; i < chars.length; i++) {
	            this.writeScreen.insertChar(chars[i]);
	        }
	        var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
	        cea_608_parser_logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
	        if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
	            cea_608_parser_logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
	            this.outputDataUpdate();
	        }
	    };
	
	    Cea608Channel.prototype.ccRCL = function ccRCL() {
	        // Resume Caption Loading (switch mode to Pop On)
	        cea_608_parser_logger.log('INFO', 'RCL - Resume Caption Loading');
	        this.setMode('MODE_POP-ON');
	    };
	
	    Cea608Channel.prototype.ccBS = function ccBS() {
	        // BackSpace
	        cea_608_parser_logger.log('INFO', 'BS - BackSpace');
	        if (this.mode === 'MODE_TEXT') {
	            return;
	        }
	        this.writeScreen.backSpace();
	        if (this.writeScreen === this.displayedMemory) {
	            this.outputDataUpdate();
	        }
	    };
	
	    Cea608Channel.prototype.ccAOF = function ccAOF() {
	        // Reserved (formerly Alarm Off)
	        return;
	    };
	
	    Cea608Channel.prototype.ccAON = function ccAON() {
	        // Reserved (formerly Alarm On)
	        return;
	    };
	
	    Cea608Channel.prototype.ccDER = function ccDER() {
	        // Delete to End of Row
	        cea_608_parser_logger.log('INFO', 'DER- Delete to End of Row');
	        this.writeScreen.clearToEndOfRow();
	        this.outputDataUpdate();
	    };
	
	    Cea608Channel.prototype.ccRU = function ccRU(nrRows) {
	        //Roll-Up Captions-2,3,or 4 Rows
	        cea_608_parser_logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
	        this.writeScreen = this.displayedMemory;
	        this.setMode('MODE_ROLL-UP');
	        this.writeScreen.setRollUpRows(nrRows);
	    };
	
	    Cea608Channel.prototype.ccFON = function ccFON() {
	        //Flash On
	        cea_608_parser_logger.log('INFO', 'FON - Flash On');
	        this.writeScreen.setPen({ flash: true });
	    };
	
	    Cea608Channel.prototype.ccRDC = function ccRDC() {
	        // Resume Direct Captioning (switch mode to PaintOn)
	        cea_608_parser_logger.log('INFO', 'RDC - Resume Direct Captioning');
	        this.setMode('MODE_PAINT-ON');
	    };
	
	    Cea608Channel.prototype.ccTR = function ccTR() {
	        // Text Restart in text mode (not supported, however)
	        cea_608_parser_logger.log('INFO', 'TR');
	        this.setMode('MODE_TEXT');
	    };
	
	    Cea608Channel.prototype.ccRTD = function ccRTD() {
	        // Resume Text Display in Text mode (not supported, however)
	        cea_608_parser_logger.log('INFO', 'RTD');
	        this.setMode('MODE_TEXT');
	    };
	
	    Cea608Channel.prototype.ccEDM = function ccEDM() {
	        // Erase Displayed Memory
	        cea_608_parser_logger.log('INFO', 'EDM - Erase Displayed Memory');
	        this.displayedMemory.reset();
	        this.outputDataUpdate(true);
	    };
	
	    Cea608Channel.prototype.ccCR = function ccCR() {
	        // Carriage Return
	        cea_608_parser_logger.log('CR - Carriage Return');
	        this.writeScreen.rollUp();
	        this.outputDataUpdate(true);
	    };
	
	    Cea608Channel.prototype.ccENM = function ccENM() {
	        //Erase Non-Displayed Memory
	        cea_608_parser_logger.log('INFO', 'ENM - Erase Non-displayed Memory');
	        this.nonDisplayedMemory.reset();
	    };
	
	    Cea608Channel.prototype.ccEOC = function ccEOC() {
	        //End of Caption (Flip Memories)
	        cea_608_parser_logger.log('INFO', 'EOC - End Of Caption');
	        if (this.mode === 'MODE_POP-ON') {
	            var tmp = this.displayedMemory;
	            this.displayedMemory = this.nonDisplayedMemory;
	            this.nonDisplayedMemory = tmp;
	            this.writeScreen = this.nonDisplayedMemory;
	            cea_608_parser_logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
	        }
	        this.outputDataUpdate(true);
	    };
	
	    Cea608Channel.prototype.ccTO = function ccTO(nrCols) {
	        // Tab Offset 1,2, or 3 columns
	        cea_608_parser_logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
	        this.writeScreen.moveCursor(nrCols);
	    };
	
	    Cea608Channel.prototype.ccMIDROW = function ccMIDROW(secondByte) {
	        // Parse MIDROW command
	        var styles = { flash: false };
	        styles.underline = secondByte % 2 === 1;
	        styles.italics = secondByte >= 0x2e;
	        if (!styles.italics) {
	            var colorIndex = Math.floor(secondByte / 2) - 0x10;
	            var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
	            styles.foreground = colors[colorIndex];
	        } else {
	            styles.foreground = 'white';
	        }
	        cea_608_parser_logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
	        this.writeScreen.setPen(styles);
	    };
	
	    Cea608Channel.prototype.outputDataUpdate = function outputDataUpdate() {
	        var dispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var t = cea_608_parser_logger.time;
	        if (t === null) {
	            return;
	        }
	        if (this.outputFilter) {
	            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
	                // Start of a new cue
	                this.cueStartTime = t;
	            } else {
	                if (!this.displayedMemory.equals(this.lastOutputScreen)) {
	                    if (this.outputFilter.newCue) {
	                        this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
	                        if (dispatch === true && this.outputFilter.dispatchCue) {
	                            this.outputFilter.dispatchCue();
	                        }
	                    }
	                    this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
	                }
	            }
	            this.lastOutputScreen.copy(this.displayedMemory);
	        }
	    };
	
	    Cea608Channel.prototype.cueSplitAtTime = function cueSplitAtTime(t) {
	        if (this.outputFilter) {
	            if (!this.displayedMemory.isEmpty()) {
	                if (this.outputFilter.newCue) {
	                    this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
	                }
	                this.cueStartTime = t;
	            }
	        }
	    };
	
	    return Cea608Channel;
	}();
	
	var Cea608Parser = function () {
	    function Cea608Parser(field, out1, out2) {
	        cea_608_parser__classCallCheck(this, Cea608Parser);
	
	        this.field = field || 1;
	        this.outputs = [out1, out2];
	        this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
	        this.currChNr = -1; // Will be 1 or 2
	        this.lastCmdA = null; // First byte of last command
	        this.lastCmdB = null; // Second byte of last command
	        this.bufferedData = [];
	        this.startTime = null;
	        this.lastTime = null;
	        this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
	    }
	
	    Cea608Parser.prototype.getHandler = function getHandler(index) {
	        return this.channels[index].getHandler();
	    };
	
	    Cea608Parser.prototype.setHandler = function setHandler(index, newHandler) {
	        this.channels[index].setHandler(newHandler);
	    };
	
	    /**
	     * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
	     */
	
	
	    Cea608Parser.prototype.addData = function addData(t, byteList) {
	        var cmdFound,
	            a,
	            b,
	            charsFound = false;
	
	        this.lastTime = t;
	        cea_608_parser_logger.setTime(t);
	
	        for (var i = 0; i < byteList.length; i += 2) {
	            a = byteList[i] & 0x7f;
	            b = byteList[i + 1] & 0x7f;
	            if (a === 0 && b === 0) {
	                this.dataCounters.padding += 2;
	                continue;
	            } else {
	                cea_608_parser_logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
	            }
	            cmdFound = this.parseCmd(a, b);
	            if (!cmdFound) {
	                cmdFound = this.parseMidrow(a, b);
	            }
	            if (!cmdFound) {
	                cmdFound = this.parsePAC(a, b);
	            }
	            if (!cmdFound) {
	                cmdFound = this.parseBackgroundAttributes(a, b);
	            }
	            if (!cmdFound) {
	                charsFound = this.parseChars(a, b);
	                if (charsFound) {
	                    if (this.currChNr && this.currChNr >= 0) {
	                        var channel = this.channels[this.currChNr - 1];
	                        channel.insertChars(charsFound);
	                    } else {
	                        cea_608_parser_logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
	                    }
	                }
	            }
	            if (cmdFound) {
	                this.dataCounters.cmd += 2;
	            } else if (charsFound) {
	                this.dataCounters.char += 2;
	            } else {
	                this.dataCounters.other += 2;
	                cea_608_parser_logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
	            }
	        }
	    };
	
	    /**
	     * Parse Command.
	     * @returns {Boolean} Tells if a command was found
	     */
	
	
	    Cea608Parser.prototype.parseCmd = function parseCmd(a, b) {
	        var chNr = null;
	
	        var cond1 = (a === 0x14 || a === 0x1C) && 0x20 <= b && b <= 0x2F;
	        var cond2 = (a === 0x17 || a === 0x1F) && 0x21 <= b && b <= 0x23;
	        if (!(cond1 || cond2)) {
	            return false;
	        }
	
	        if (a === this.lastCmdA && b === this.lastCmdB) {
	            this.lastCmdA = null;
	            this.lastCmdB = null; // Repeated commands are dropped (once)
	            cea_608_parser_logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
	            return true;
	        }
	
	        if (a === 0x14 || a === 0x17) {
	            chNr = 1;
	        } else {
	            chNr = 2; // (a === 0x1C || a=== 0x1f)
	        }
	
	        var channel = this.channels[chNr - 1];
	
	        if (a === 0x14 || a === 0x1C) {
	            if (b === 0x20) {
	                channel.ccRCL();
	            } else if (b === 0x21) {
	                channel.ccBS();
	            } else if (b === 0x22) {
	                channel.ccAOF();
	            } else if (b === 0x23) {
	                channel.ccAON();
	            } else if (b === 0x24) {
	                channel.ccDER();
	            } else if (b === 0x25) {
	                channel.ccRU(2);
	            } else if (b === 0x26) {
	                channel.ccRU(3);
	            } else if (b === 0x27) {
	                channel.ccRU(4);
	            } else if (b === 0x28) {
	                channel.ccFON();
	            } else if (b === 0x29) {
	                channel.ccRDC();
	            } else if (b === 0x2A) {
	                channel.ccTR();
	            } else if (b === 0x2B) {
	                channel.ccRTD();
	            } else if (b === 0x2C) {
	                channel.ccEDM();
	            } else if (b === 0x2D) {
	                channel.ccCR();
	            } else if (b === 0x2E) {
	                channel.ccENM();
	            } else if (b === 0x2F) {
	                channel.ccEOC();
	            }
	        } else {
	            //a == 0x17 || a == 0x1F
	            channel.ccTO(b - 0x20);
	        }
	        this.lastCmdA = a;
	        this.lastCmdB = b;
	        this.currChNr = chNr;
	        return true;
	    };
	
	    /**
	     * Parse midrow styling command
	     * @returns {Boolean}
	     */
	
	
	    Cea608Parser.prototype.parseMidrow = function parseMidrow(a, b) {
	        var chNr = null;
	
	        if ((a === 0x11 || a === 0x19) && 0x20 <= b && b <= 0x2f) {
	            if (a === 0x11) {
	                chNr = 1;
	            } else {
	                chNr = 2;
	            }
	            if (chNr !== this.currChNr) {
	                cea_608_parser_logger.log('ERROR', 'Mismatch channel in midrow parsing');
	                return false;
	            }
	            var channel = this.channels[chNr - 1];
	            channel.ccMIDROW(b);
	            cea_608_parser_logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Parse Preable Access Codes (Table 53).
	     * @returns {Boolean} Tells if PAC found
	     */
	
	
	    Cea608Parser.prototype.parsePAC = function parsePAC(a, b) {
	
	        var chNr = null;
	        var row = null;
	
	        var case1 = (0x11 <= a && a <= 0x17 || 0x19 <= a && a <= 0x1F) && 0x40 <= b && b <= 0x7F;
	        var case2 = (a === 0x10 || a === 0x18) && 0x40 <= b && b <= 0x5F;
	        if (!(case1 || case2)) {
	            return false;
	        }
	
	        if (a === this.lastCmdA && b === this.lastCmdB) {
	            this.lastCmdA = null;
	            this.lastCmdB = null;
	            return true; // Repeated commands are dropped (once)
	        }
	
	        chNr = a <= 0x17 ? 1 : 2;
	
	        if (0x40 <= b && b <= 0x5F) {
	            row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
	        } else {
	            // 0x60 <= b <= 0x7F
	            row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
	        }
	        var pacData = this.interpretPAC(row, b);
	        var channel = this.channels[chNr - 1];
	        channel.setPAC(pacData);
	        this.lastCmdA = a;
	        this.lastCmdB = b;
	        this.currChNr = chNr;
	        return true;
	    };
	
	    /**
	     * Interpret the second byte of the pac, and return the information.
	     * @returns {Object} pacData with style parameters.
	     */
	
	
	    Cea608Parser.prototype.interpretPAC = function interpretPAC(row, byte) {
	        var pacIndex = byte;
	        var pacData = { color: null, italics: false, indent: null, underline: false, row: row };
	
	        if (byte > 0x5F) {
	            pacIndex = byte - 0x60;
	        } else {
	            pacIndex = byte - 0x40;
	        }
	        pacData.underline = (pacIndex & 1) === 1;
	        if (pacIndex <= 0xd) {
	            pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
	        } else if (pacIndex <= 0xf) {
	            pacData.italics = true;
	            pacData.color = 'white';
	        } else {
	            pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
	        }
	        return pacData; // Note that row has zero offset. The spec uses 1.
	    };
	
	    /**
	     * Parse characters.
	     * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
	     */
	
	
	    Cea608Parser.prototype.parseChars = function parseChars(a, b) {
	
	        var channelNr = null,
	            charCodes = null,
	            charCode1 = null;
	
	        if (a >= 0x19) {
	            channelNr = 2;
	            charCode1 = a - 8;
	        } else {
	            channelNr = 1;
	            charCode1 = a;
	        }
	        if (0x11 <= charCode1 && charCode1 <= 0x13) {
	            // Special character
	            var oneCode = b;
	            if (charCode1 === 0x11) {
	                oneCode = b + 0x50;
	            } else if (charCode1 === 0x12) {
	                oneCode = b + 0x70;
	            } else {
	                oneCode = b + 0x90;
	            }
	            cea_608_parser_logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
	            charCodes = [oneCode];
	        } else if (0x20 <= a && a <= 0x7f) {
	            charCodes = b === 0 ? [a] : [a, b];
	        }
	        if (charCodes) {
	            var hexCodes = numArrayToHexArray(charCodes);
	            cea_608_parser_logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
	            this.lastCmdA = null;
	            this.lastCmdB = null;
	        }
	        return charCodes;
	    };
	
	    /**
	    * Parse extended background attributes as well as new foreground color black.
	    * @returns{Boolean} Tells if background attributes are found
	    */
	
	
	    Cea608Parser.prototype.parseBackgroundAttributes = function parseBackgroundAttributes(a, b) {
	        var bkgData, index, chNr, channel;
	
	        var case1 = (a === 0x10 || a === 0x18) && 0x20 <= b && b <= 0x2f;
	        var case2 = (a === 0x17 || a === 0x1f) && 0x2d <= b && b <= 0x2f;
	        if (!(case1 || case2)) {
	            return false;
	        }
	        bkgData = {};
	        if (a === 0x10 || a === 0x18) {
	            index = Math.floor((b - 0x20) / 2);
	            bkgData.background = backgroundColors[index];
	            if (b % 2 === 1) {
	                bkgData.background = bkgData.background + '_semi';
	            }
	        } else if (b === 0x2d) {
	            bkgData.background = 'transparent';
	        } else {
	            bkgData.foreground = 'black';
	            if (b === 0x2f) {
	                bkgData.underline = true;
	            }
	        }
	        chNr = a < 0x18 ? 1 : 2;
	        channel = this.channels[chNr - 1];
	        channel.setBkgData(bkgData);
	        this.lastCmdA = null;
	        this.lastCmdB = null;
	        return true;
	    };
	
	    /**
	     * Reset state of parser and its channels.
	     */
	
	
	    Cea608Parser.prototype.reset = function reset() {
	        for (var i = 0; i < this.channels.length; i++) {
	            if (this.channels[i]) {
	                this.channels[i].reset();
	            }
	        }
	        this.lastCmdA = null;
	        this.lastCmdB = null;
	    };
	
	    /**
	     * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
	     */
	
	
	    Cea608Parser.prototype.cueSplitAtTime = function cueSplitAtTime(t) {
	        for (var i = 0; i < this.channels.length; i++) {
	            if (this.channels[i]) {
	                this.channels[i].cueSplitAtTime(t);
	            }
	        }
	    };
	
	    return Cea608Parser;
	}();
	
	/* harmony default export */ var cea_608_parser = (Cea608Parser);
	// CONCATENATED MODULE: ./src/utils/output-filter.js
	function output_filter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OutputFilter = function () {
	  function OutputFilter(timelineController, track) {
	    output_filter__classCallCheck(this, OutputFilter);
	
	    this.timelineController = timelineController;
	    this.track = track;
	    this.startTime = null;
	    this.endTime = null;
	    this.screen = null;
	  }
	
	  OutputFilter.prototype.dispatchCue = function dispatchCue() {
	    if (this.startTime === null) {
	      return;
	    }
	    this.timelineController.addCues('textTrack' + this.track, this.startTime, this.endTime, this.screen);
	    this.startTime = null;
	  };
	
	  OutputFilter.prototype.newCue = function newCue(startTime, endTime, screen) {
	    if (this.startTime === null || this.startTime > startTime) {
	      this.startTime = startTime;
	    }
	    this.endTime = endTime;
	    this.screen = screen;
	    this.timelineController.createCaptionsTrack(this.track);
	  };
	
	  return OutputFilter;
	}();
	
	/* harmony default export */ var output_filter = (OutputFilter);
	// CONCATENATED MODULE: ./src/utils/webvtt-parser.js
	
	
	
	// String.prototype.startsWith is not supported in IE11
	var startsWith = function startsWith(inputString, searchString, position) {
	    return inputString.substr(position || 0, searchString.length) === searchString;
	};
	
	var cueString2millis = function cueString2millis(timeString) {
	    var ts = parseInt(timeString.substr(-3));
	    var secs = parseInt(timeString.substr(-6, 2));
	    var mins = parseInt(timeString.substr(-9, 2));
	    var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;
	
	    if (isNaN(ts) || isNaN(secs) || isNaN(mins) || isNaN(hours)) {
	        return -1;
	    }
	
	    ts += 1000 * secs;
	    ts += 60 * 1000 * mins;
	    ts += 60 * 60 * 1000 * hours;
	
	    return ts;
	};
	
	// From https://github.com/darkskyapp/string-hash
	var hash = function hash(text) {
	    var hash = 5381;
	    var i = text.length;
	    while (i) {
	        hash = hash * 33 ^ text.charCodeAt(--i);
	    }
	    return (hash >>> 0).toString();
	};
	
	var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
	    var currCC = vttCCs[cc];
	    var prevCC = vttCCs[currCC.prevCC];
	
	    // This is the first discontinuity or cues have been processed since the last discontinuity
	    // Offset = current discontinuity time
	    if (!prevCC || !prevCC.new && currCC.new) {
	        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
	        currCC.new = false;
	        return;
	    }
	
	    // There have been discontinuities since cues were last parsed.
	    // Offset = time elapsed
	    while (prevCC && prevCC.new) {
	        vttCCs.ccOffset += currCC.start - prevCC.start;
	        currCC.new = false;
	        currCC = prevCC;
	        prevCC = vttCCs[currCC.prevCC];
	    }
	
	    vttCCs.presentationOffset = presentationTime;
	};
	
	var WebVTTParser = {
	    parse: function parse(vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
	        // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
	        var re = /\r\n|\n\r|\n|\r/g;
	        // Uint8Array.prototype.reduce is not implemented in IE11
	        var vttLines = Object(id3["b" /* utf8ArrayToStr */])(new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
	
	        var cueTime = '00:00.000';
	        var mpegTs = 0;
	        var localTime = 0;
	        var presentationTime = 0;
	        var cues = [];
	        var parsingError = void 0;
	        var inHeader = true;
	        // let VTTCue = VTTCue || window.TextTrackCue;
	
	        // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
	        var parser = new vttparser();
	
	        parser.oncue = function (cue) {
	            // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
	            var currCC = vttCCs[cc];
	            var cueOffset = vttCCs.ccOffset;
	
	            // Update offsets for new discontinuities
	            if (currCC && currCC.new) {
	                if (localTime !== undefined) {
	                    // When local time is provided, offset = discontinuity start time - local time
	                    cueOffset = vttCCs.ccOffset = currCC.start;
	                } else {
	                    calculateOffset(vttCCs, cc, presentationTime);
	                }
	            }
	
	            if (presentationTime) {
	                // If we have MPEGTS, offset = presentation time + discontinuity offset
	                cueOffset = presentationTime + vttCCs.ccOffset - vttCCs.presentationOffset;
	            }
	
	            cue.startTime += cueOffset - localTime;
	            cue.endTime += cueOffset - localTime;
	
	            // Create a unique hash id for a cue based on start/end times and text.
	            // This helps timeline-controller to avoid showing repeated captions.
	            cue.id = hash(cue.startTime.toString()) + hash(cue.endTime.toString()) + hash(cue.text);
	
	            // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
	            cue.text = decodeURIComponent(encodeURIComponent(cue.text));
	            if (cue.endTime > 0) {
	                cues.push(cue);
	            }
	        };
	
	        parser.onparsingerror = function (e) {
	            parsingError = e;
	        };
	
	        parser.onflush = function () {
	            if (parsingError && errorCallBack) {
	                errorCallBack(parsingError);
	                return;
	            }
	            callBack(cues);
	        };
	
	        // Go through contents line by line.
	        vttLines.forEach(function (line) {
	            if (inHeader) {
	                // Look for X-TIMESTAMP-MAP in header.
	                if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
	                    // Once found, no more are allowed anyway, so stop searching.
	                    inHeader = false;
	                    // Extract LOCAL and MPEGTS.
	                    line.substr(16).split(',').forEach(function (timestamp) {
	                        if (startsWith(timestamp, 'LOCAL:')) {
	                            cueTime = timestamp.substr(6);
	                        } else if (startsWith(timestamp, 'MPEGTS:')) {
	                            mpegTs = parseInt(timestamp.substr(7));
	                        }
	                    });
	                    try {
	                        // Calculate subtitle offset in milliseconds.
	                        // If sync PTS is less than zero, we have a 33-bit wraparound, which is fixed by adding 2^33 = 8589934592.
	                        syncPTS = syncPTS < 0 ? syncPTS + 8589934592 : syncPTS;
	                        // Adjust MPEGTS by sync PTS.
	                        mpegTs -= syncPTS;
	                        // Convert cue time to seconds
	                        localTime = cueString2millis(cueTime) / 1000;
	                        // Convert MPEGTS to seconds from 90kHz.
	                        presentationTime = mpegTs / 90000;
	
	                        if (localTime === -1) {
	                            parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
	                        }
	                    } catch (e) {
	                        parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
	                    }
	                    // Return without parsing X-TIMESTAMP-MAP line.
	                    return;
	                } else if (line === '') {
	                    inHeader = false;
	                }
	            }
	            // Parse line by default.
	            parser.parse(line + '\n');
	        });
	
	        parser.flush();
	    }
	};
	
	/* harmony default export */ var webvtt_parser = (WebVTTParser);
	// CONCATENATED MODULE: ./src/controller/timeline-controller.js
	function timeline_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function timeline_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function timeline_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Timeline Controller
	*/
	
	
	
	
	
	
	
	
	function clearCurrentCues(track) {
	  if (track && track.cues) {
	    while (track.cues.length > 0) {
	      track.removeCue(track.cues[0]);
	    }
	  }
	}
	
	function reuseVttTextTrack(inUseTrack, manifestTrack) {
	  return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
	}
	
	function intersection(x1, x2, y1, y2) {
	  return Math.min(x2, y2) - Math.max(x1, y1);
	}
	
	var timeline_controller_TimelineController = function (_EventHandler) {
	  timeline_controller__inherits(TimelineController, _EventHandler);
	
	  function TimelineController(hls) {
	    timeline_controller__classCallCheck(this, TimelineController);
	
	    var _this = timeline_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHING, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].FRAG_PARSING_USERDATA, events["a" /* default */].FRAG_DECRYPTED, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].LEVEL_SWITCHING, events["a" /* default */].INIT_PTS_FOUND));
	
	    _this.hls = hls;
	    _this.config = hls.config;
	    _this.enabled = true;
	    _this.Cues = hls.config.cueHandler;
	    _this.textTracks = [];
	    _this.tracks = [];
	    _this.unparsedVttFrags = [];
	    _this.initPTS = undefined;
	    _this.cueRanges = [];
	
	    if (_this.config.enableCEA708Captions) {
	      var channel1 = new output_filter(_this, 1);
	      var channel2 = new output_filter(_this, 2);
	
	      _this.cea608Parser = new cea_608_parser(0, channel1, channel2);
	    }
	    return _this;
	  }
	
	  TimelineController.prototype.addCues = function addCues(channel, startTime, endTime, screen) {
	    // skip cues which overlap more than 50% with previously parsed time ranges
	    var ranges = this.cueRanges;
	    var merged = false;
	    for (var i = ranges.length; i--;) {
	      var cueRange = ranges[i];
	      var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
	      if (overlap >= 0) {
	        cueRange[0] = Math.min(cueRange[0], startTime);
	        cueRange[1] = Math.max(cueRange[1], endTime);
	        merged = true;
	        if (overlap / (endTime - startTime) > 0.5) {
	          return;
	        }
	      }
	    }
	    if (!merged) {
	      ranges.push([startTime, endTime]);
	    }
	    this.Cues.newCue(this[channel], startTime, endTime, screen);
	  };
	
	  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
	
	
	  TimelineController.prototype.onInitPtsFound = function onInitPtsFound(data) {
	    var _this2 = this;
	
	    if (typeof this.initPTS === 'undefined') {
	      this.initPTS = data.initPTS;
	    }
	
	    // Due to asynchrony, initial PTS may arrive later than the first VTT fragments are loaded.
	    // Parse any unparsed fragments upon receiving the initial PTS.
	    if (this.unparsedVttFrags.length) {
	      this.unparsedVttFrags.forEach(function (frag) {
	        _this2.onFragLoaded(frag);
	      });
	      this.unparsedVttFrags = [];
	    }
	  };
	
	  TimelineController.prototype.getExistingTrack = function getExistingTrack(channelNumber) {
	    var media = this.media;
	    if (media) {
	      for (var i = 0; i < media.textTracks.length; i++) {
	        var textTrack = media.textTracks[i];
	        var propName = 'textTrack' + channelNumber;
	        if (textTrack[propName] === true) {
	          return textTrack;
	        }
	      }
	    }
	    return null;
	  };
	
	  TimelineController.prototype.sendAddTrackEvent = function sendAddTrackEvent(track, media) {
	    var e = null;
	    try {
	      e = new window.Event('addtrack');
	    } catch (err) {
	      //for IE11
	      e = document.createEvent('Event');
	      e.initEvent('addtrack', false, false);
	    }
	    e.track = track;
	    media.dispatchEvent(e);
	  };
	
	  TimelineController.prototype.createCaptionsTrack = function createCaptionsTrack(track) {
	    var trackVar = 'textTrack' + track;
	    if (!this[trackVar]) {
	      //Enable reuse of existing text track.
	      var existingTrack = this.getExistingTrack(track);
	      if (!existingTrack) {
	        var textTrack = this.createTextTrack('captions', this.config['captionsTextTrack' + track + 'Label'], this.config.captionsTextTrack1LanguageCode);
	        if (textTrack) {
	          textTrack[trackVar] = true;
	          this[trackVar] = textTrack;
	        }
	      } else {
	        this[trackVar] = existingTrack;
	        clearCurrentCues(this[trackVar]);
	
	        this.sendAddTrackEvent(this[trackVar], this.media);
	      }
	    }
	  };
	
	  TimelineController.prototype.createTextTrack = function createTextTrack(kind, label, lang) {
	    var media = this.media;
	    if (media) {
	      return media.addTextTrack(kind, label, lang);
	    }
	  };
	
	  TimelineController.prototype.destroy = function destroy() {
	    event_handler.prototype.destroy.call(this);
	  };
	
	  TimelineController.prototype.onMediaAttaching = function onMediaAttaching(data) {
	    this.media = data.media;
	    this._cleanTracks();
	  };
	
	  TimelineController.prototype.onMediaDetaching = function onMediaDetaching() {
	    clearCurrentCues(this.textTrack1);
	    clearCurrentCues(this.textTrack2);
	  };
	
	  TimelineController.prototype.onManifestLoading = function onManifestLoading() {
	    this.lastSn = -1; // Detect discontiguity in fragment parsing
	    this.prevCC = -1;
	    this.vttCCs = { ccOffset: 0, presentationOffset: 0 }; // Detect discontinuity in subtitle manifests
	    this._cleanTracks();
	  };
	
	  TimelineController.prototype._cleanTracks = function _cleanTracks() {
	    // clear outdated subtitles
	    var media = this.media;
	    if (media) {
	      var textTracks = media.textTracks;
	      if (textTracks) {
	        for (var i = 0; i < textTracks.length; i++) {
	          clearCurrentCues(textTracks[i]);
	        }
	      }
	    }
	  };
	
	  TimelineController.prototype.onManifestLoaded = function onManifestLoaded(data) {
	    var _this3 = this;
	
	    this.textTracks = [];
	    this.unparsedVttFrags = this.unparsedVttFrags || [];
	    this.initPTS = undefined;
	    this.cueRanges = [];
	
	    if (this.config.enableWebVTT) {
	      this.tracks = data.subtitles || [];
	      var inUseTracks = this.media ? this.media.textTracks : [];
	
	      this.tracks.forEach(function (track, index) {
	        var textTrack = void 0;
	        if (index < inUseTracks.length) {
	          var inUseTrack = inUseTracks[index];
	          // Reuse tracks with the same label, but do not reuse 608/708 tracks
	          if (reuseVttTextTrack(inUseTrack, track)) {
	            textTrack = inUseTrack;
	          }
	        }
	        if (!textTrack) {
	          textTrack = _this3.createTextTrack('subtitles', track.name, track.lang);
	        }
	        textTrack.mode = track.default ? 'showing' : 'hidden';
	        _this3.textTracks.push(textTrack);
	      });
	    }
	  };
	
	  TimelineController.prototype.onLevelSwitching = function onLevelSwitching() {
	    this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
	  };
	
	  TimelineController.prototype.onFragLoaded = function onFragLoaded(data) {
	    var frag = data.frag,
	        payload = data.payload;
	    if (frag.type === 'main') {
	      var sn = frag.sn;
	      // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
	      if (sn !== this.lastSn + 1) {
	        var cea608Parser = this.cea608Parser;
	        if (cea608Parser) {
	          cea608Parser.reset();
	        }
	      }
	      this.lastSn = sn;
	    }
	    // If fragment is subtitle type, parse as WebVTT.
	    else if (frag.type === 'subtitle') {
	        if (payload.byteLength) {
	          // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
	          if (typeof this.initPTS === 'undefined') {
	            this.unparsedVttFrags.push(data);
	            return;
	          }
	
	          var decryptData = frag.decryptdata;
	          // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
	          if (decryptData == null || decryptData.key == null || decryptData.method !== 'AES-128') {
	            this._parseVTTs(frag, payload);
	          }
	        } else {
	          // In case there is no payload, finish unsuccessfully.
	          this.hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
	        }
	      }
	  };
	
	  TimelineController.prototype._parseVTTs = function _parseVTTs(frag, payload) {
	    var vttCCs = this.vttCCs;
	    if (!vttCCs[frag.cc]) {
	      vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
	      this.prevCC = frag.cc;
	    }
	    var textTracks = this.textTracks,
	        hls = this.hls;
	
	    // Parse the WebVTT file contents.
	    webvtt_parser.parse(payload, this.initPTS, vttCCs, frag.cc, function (cues) {
	      var currentTrack = textTracks[frag.trackId];
	      // Add cues and trigger event with success true.
	      cues.forEach(function (cue) {
	        // Sometimes there are cue overlaps on segmented vtts so the same
	        // cue can appear more than once in different vtt files.
	        // This avoid showing duplicated cues with same timecode and text.
	        if (!currentTrack.cues.getCueById(cue.id)) {
	          try {
	            currentTrack.addCue(cue);
	          } catch (err) {
	            var textTrackCue = new window.TextTrackCue(cue.startTime, cue.endTime, cue.text);
	            textTrackCue.id = cue.id;
	            currentTrack.addCue(textTrackCue);
	          }
	        }
	      });
	      hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
	    }, function (e) {
	      // Something went wrong while parsing. Trigger event with success false.
	      logger["b" /* logger */].log('Failed to parse VTT cue: ' + e);
	      hls.trigger(events["a" /* default */].SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
	    });
	  };
	
	  TimelineController.prototype.onFragDecrypted = function onFragDecrypted(data) {
	    var decryptedData = data.payload,
	        frag = data.frag;
	
	    if (frag.type === 'subtitle') {
	      if (typeof this.initPTS === 'undefined') {
	        this.unparsedVttFrags.push(data);
	        return;
	      }
	
	      this._parseVTTs(frag, decryptedData);
	    }
	  };
	
	  TimelineController.prototype.onFragParsingUserdata = function onFragParsingUserdata(data) {
	    // push all of the CEA-708 messages into the interpreter
	    // immediately. It will create the proper timestamps based on our PTS value
	    if (this.enabled && this.config.enableCEA708Captions) {
	      for (var i = 0; i < data.samples.length; i++) {
	        var ccdatas = this.extractCea608Data(data.samples[i].bytes);
	        this.cea608Parser.addData(data.samples[i].pts, ccdatas);
	      }
	    }
	  };
	
	  TimelineController.prototype.extractCea608Data = function extractCea608Data(byteArray) {
	    var count = byteArray[0] & 31;
	    var position = 2;
	    var tmpByte, ccbyte1, ccbyte2, ccValid, ccType;
	    var actualCCBytes = [];
	
	    for (var j = 0; j < count; j++) {
	      tmpByte = byteArray[position++];
	      ccbyte1 = 0x7F & byteArray[position++];
	      ccbyte2 = 0x7F & byteArray[position++];
	      ccValid = (4 & tmpByte) !== 0;
	      ccType = 3 & tmpByte;
	
	      if (ccbyte1 === 0 && ccbyte2 === 0) {
	        continue;
	      }
	
	      if (ccValid) {
	        if (ccType === 0) // || ccType === 1
	          {
	            actualCCBytes.push(ccbyte1);
	            actualCCBytes.push(ccbyte2);
	          }
	      }
	    }
	    return actualCCBytes;
	  };
	
	  return TimelineController;
	}(event_handler);
	
	/* harmony default export */ var timeline_controller = (timeline_controller_TimelineController);
	// CONCATENATED MODULE: ./src/controller/subtitle-track-controller.js
	var subtitle_track_controller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function subtitle_track_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function subtitle_track_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function subtitle_track_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * subtitle track controller
	*/
	
	
	
	
	
	function filterSubtitleTracks(textTrackList) {
	  var tracks = [];
	  for (var i = 0; i < textTrackList.length; i++) {
	    if (textTrackList[i].kind === 'subtitles') {
	      tracks.push(textTrackList[i]);
	    }
	  }
	  return tracks;
	}
	
	var subtitle_track_controller_SubtitleTrackController = function (_EventHandler) {
	  subtitle_track_controller__inherits(SubtitleTrackController, _EventHandler);
	
	  function SubtitleTrackController(hls) {
	    subtitle_track_controller__classCallCheck(this, SubtitleTrackController);
	
	    var _this = subtitle_track_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].MEDIA_DETACHING, events["a" /* default */].MANIFEST_LOADING, events["a" /* default */].MANIFEST_LOADED, events["a" /* default */].SUBTITLE_TRACK_LOADED));
	
	    _this.tracks = [];
	    _this.trackId = -1;
	    _this.media = undefined;
	    _this.subtitleDisplay = false;
	    return _this;
	  }
	
	  SubtitleTrackController.prototype._onTextTracksChanged = function _onTextTracksChanged() {
	    // Media is undefined when switching streams via loadSource()
	    if (!this.media) {
	      return;
	    }
	
	    var trackId = -1;
	    var tracks = filterSubtitleTracks(this.media.textTracks);
	    for (var id = 0; id < tracks.length; id++) {
	      if (tracks[id].mode === 'showing') {
	        trackId = id;
	      }
	    }
	
	    // Setting current subtitleTrack will invoke code.
	    this.subtitleTrack = trackId;
	  };
	
	  SubtitleTrackController.prototype.destroy = function destroy() {
	    event_handler.prototype.destroy.call(this);
	  };
	
	  // Listen for subtitle track change, then extract the current track ID.
	
	
	  SubtitleTrackController.prototype.onMediaAttached = function onMediaAttached(data) {
	    var _this2 = this;
	
	    this.media = data.media;
	    if (!this.media) {
	      return;
	    }
	
	    if (this.queuedDefaultTrack !== undefined) {
	      this.subtitleTrack = this.queuedDefaultTrack;
	      delete this.queuedDefaultTrack;
	    }
	
	    this.trackChangeListener = this._onTextTracksChanged.bind(this);
	
	    this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
	    if (this.useTextTrackPolling) {
	      this.subtitlePollingInterval = setInterval(function () {
	        _this2.trackChangeListener();
	      }, 500);
	    } else {
	      this.media.textTracks.addEventListener('change', this.trackChangeListener);
	    }
	  };
	
	  SubtitleTrackController.prototype.onMediaDetaching = function onMediaDetaching() {
	    if (!this.media) {
	      return;
	    }
	    if (this.useTextTrackPolling) {
	      clearInterval(this.subtitlePollingInterval);
	    } else {
	      this.media.textTracks.removeEventListener('change', this.trackChangeListener);
	    }
	
	    this.media = undefined;
	  };
	
	  // Reset subtitle tracks on manifest loading
	
	
	  SubtitleTrackController.prototype.onManifestLoading = function onManifestLoading() {
	    this.tracks = [];
	    this.trackId = -1;
	  };
	
	  // Fired whenever a new manifest is loaded.
	
	
	  SubtitleTrackController.prototype.onManifestLoaded = function onManifestLoaded(data) {
	    var _this3 = this;
	
	    var tracks = data.subtitles || [];
	    this.tracks = tracks;
	    this.trackId = -1;
	    this.hls.trigger(events["a" /* default */].SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });
	
	    // loop through available subtitle tracks and autoselect default if needed
	    // TODO: improve selection logic to handle forced, etc
	    tracks.forEach(function (track) {
	      if (track.default) {
	        // setting this.subtitleTrack will trigger internal logic
	        // if media has not been attached yet, it will fail
	        // we keep a reference to the default track id
	        // and we'll set subtitleTrack when onMediaAttached is triggered
	        if (_this3.media) {
	          _this3.subtitleTrack = track.id;
	        } else {
	          _this3.queuedDefaultTrack = track.id;
	        }
	      }
	    });
	  };
	
	  // Trigger subtitle track playlist reload.
	
	
	  SubtitleTrackController.prototype.onTick = function onTick() {
	    var trackId = this.trackId;
	    var subtitleTrack = this.tracks[trackId];
	    if (!subtitleTrack) {
	      return;
	    }
	
	    var details = subtitleTrack.details;
	    // check if we need to load playlist for this subtitle Track
	    if (details === undefined || details.live === true) {
	      // track not retrieved yet, or live playlist we need to (re)load it
	      logger["b" /* logger */].log('(re)loading playlist for subtitle track ' + trackId);
	      this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: trackId });
	    }
	  };
	
	  SubtitleTrackController.prototype.onSubtitleTrackLoaded = function onSubtitleTrackLoaded(data) {
	    var _this4 = this;
	
	    if (data.id < this.tracks.length) {
	      logger["b" /* logger */].log('subtitle track ' + data.id + ' loaded');
	      this.tracks[data.id].details = data.details;
	      // check if current playlist is a live playlist
	      if (data.details.live && !this.timer) {
	        // if live playlist we will have to reload it periodically
	        // set reload period to playlist target duration
	        this.timer = setInterval(function () {
	          _this4.onTick();
	        }, 1000 * data.details.targetduration, this);
	      }
	      if (!data.details.live && this.timer) {
	        // playlist is not live and timer is armed : stopping it
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    }
	  };
	
	  /** get alternate subtitle tracks list from playlist **/
	
	
	  SubtitleTrackController.prototype.setSubtitleTrackInternal = function setSubtitleTrackInternal(newId) {
	    // check if level idx is valid
	    if (newId < -1 || newId >= this.tracks.length) {
	      return;
	    }
	
	    // stopping live reloading timer if any
	    if (this.timer) {
	      clearInterval(this.timer);
	      this.timer = null;
	    }
	
	    var textTracks = filterSubtitleTracks(this.media.textTracks);
	
	    // hide currently enabled subtitle track
	    if (this.trackId !== -1 && this.subtitleDisplay) {
	      textTracks[this.trackId].mode = 'hidden';
	    }
	
	    this.trackId = newId;
	    logger["b" /* logger */].log('switching to subtitle track ' + newId);
	    this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_SWITCH, { id: newId });
	
	    if (newId === -1) {
	      return;
	    }
	
	    var subtitleTrack = this.tracks[newId];
	    if (this.subtitleDisplay) {
	      textTracks[newId].mode = 'showing';
	    }
	
	    // check if we need to load playlist for this subtitle Track
	    var details = subtitleTrack.details;
	    if (details === undefined || details.live === true) {
	      // track not retrieved yet, or live playlist we need to (re)load it
	      logger["b" /* logger */].log('(re)loading playlist for subtitle track ' + newId);
	      this.hls.trigger(events["a" /* default */].SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: newId });
	    }
	  };
	
	  subtitle_track_controller__createClass(SubtitleTrackController, [{
	    key: 'subtitleTracks',
	    get: function get() {
	      return this.tracks;
	    }
	
	    /** get index of the selected subtitle track (index in subtitle track lists) **/
	
	  }, {
	    key: 'subtitleTrack',
	    get: function get() {
	      return this.trackId;
	    }
	
	    /** select a subtitle track, based on its index in subtitle track lists**/
	    ,
	    set: function set(subtitleTrackId) {
	      if (this.trackId !== subtitleTrackId) {
	        // || this.tracks[subtitleTrackId].details === undefined) {
	        this.setSubtitleTrackInternal(subtitleTrackId);
	      }
	    }
	  }]);
	
	  return SubtitleTrackController;
	}(event_handler);
	
	/* harmony default export */ var subtitle_track_controller = (subtitle_track_controller_SubtitleTrackController);
	// EXTERNAL MODULE: ./src/crypt/decrypter.js + 3 modules
	var decrypter = __webpack_require__(4);
	
	// CONCATENATED MODULE: ./src/controller/subtitle-stream-controller.js
	function subtitle_stream_controller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function subtitle_stream_controller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function subtitle_stream_controller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Subtitle Stream Controller
	*/
	
	
	
	
	
	
	var subtitle_stream_controller_State = {
	  STOPPED: 'STOPPED',
	  IDLE: 'IDLE',
	  KEY_LOADING: 'KEY_LOADING',
	  FRAG_LOADING: 'FRAG_LOADING'
	};
	
	var subtitle_stream_controller_SubtitleStreamController = function (_EventHandler) {
	  subtitle_stream_controller__inherits(SubtitleStreamController, _EventHandler);
	
	  function SubtitleStreamController(hls) {
	    subtitle_stream_controller__classCallCheck(this, SubtitleStreamController);
	
	    var _this = subtitle_stream_controller__possibleConstructorReturn(this, _EventHandler.call(this, hls, events["a" /* default */].MEDIA_ATTACHED, events["a" /* default */].ERROR, events["a" /* default */].KEY_LOADED, events["a" /* default */].FRAG_LOADED, events["a" /* default */].SUBTITLE_TRACKS_UPDATED, events["a" /* default */].SUBTITLE_TRACK_SWITCH, events["a" /* default */].SUBTITLE_TRACK_LOADED, events["a" /* default */].SUBTITLE_FRAG_PROCESSED));
	
	    _this.config = hls.config;
	    _this.vttFragSNsProcessed = {};
	    _this.vttFragQueues = undefined;
	    _this.currentlyProcessing = null;
	    _this.state = subtitle_stream_controller_State.STOPPED;
	    _this.currentTrackId = -1;
	    _this.ticks = 0;
	    _this.decrypter = new decrypter["a" /* default */](hls.observer, hls.config);
	    return _this;
	  }
	
	  SubtitleStreamController.prototype.destroy = function destroy() {
	    event_handler.prototype.destroy.call(this);
	    this.state = subtitle_stream_controller_State.STOPPED;
	  };
	
	  // Remove all queued items and create a new, empty queue for each track.
	
	
	  SubtitleStreamController.prototype.clearVttFragQueues = function clearVttFragQueues() {
	    var _this2 = this;
	
	    this.vttFragQueues = {};
	    this.tracks.forEach(function (track) {
	      _this2.vttFragQueues[track.id] = [];
	    });
	  };
	
	  // If no frag is being processed and queue isn't empty, initiate processing of next frag in line.
	
	
	  SubtitleStreamController.prototype.nextFrag = function nextFrag() {
	    if (this.currentlyProcessing === null && this.currentTrackId > -1 && this.vttFragQueues[this.currentTrackId].length) {
	      var frag = this.currentlyProcessing = this.vttFragQueues[this.currentTrackId].shift();
	      this.fragCurrent = frag;
	      this.hls.trigger(events["a" /* default */].FRAG_LOADING, { frag: frag });
	      this.state = subtitle_stream_controller_State.FRAG_LOADING;
	    }
	  };
	
	  // When fragment has finished processing, add sn to list of completed if successful.
	
	
	  SubtitleStreamController.prototype.onSubtitleFragProcessed = function onSubtitleFragProcessed(data) {
	    if (data.success) {
	      this.vttFragSNsProcessed[data.frag.trackId].push(data.frag.sn);
	    }
	    this.currentlyProcessing = null;
	    this.state = subtitle_stream_controller_State.IDLE;
	    this.nextFrag();
	  };
	
	  SubtitleStreamController.prototype.onMediaAttached = function onMediaAttached() {
	    this.state = subtitle_stream_controller_State.IDLE;
	  };
	
	  // If something goes wrong, procede to next frag, if we were processing one.
	
	
	  SubtitleStreamController.prototype.onError = function onError(data) {
	    var frag = data.frag;
	    // don't handle frag error not related to subtitle fragment
	    if (frag && frag.type !== 'subtitle') {
	      return;
	    }
	    if (this.currentlyProcessing) {
	      this.currentlyProcessing = null;
	      this.nextFrag();
	    }
	  };
	
	  SubtitleStreamController.prototype.tick = function tick() {
	    var _this3 = this;
	
	    this.ticks++;
	    if (this.ticks === 1) {
	      this.doTick();
	      if (this.ticks > 1) {
	        setTimeout(function () {
	          _this3.tick();
	        }, 1);
	      }
	      this.ticks = 0;
	    }
	  };
	
	  SubtitleStreamController.prototype.doTick = function doTick() {
	    var _this4 = this;
	
	    switch (this.state) {
	      case subtitle_stream_controller_State.IDLE:
	        var tracks = this.tracks;
	        var trackId = this.currentTrackId;
	
	        var processedFragSNs = this.vttFragSNsProcessed[trackId],
	            fragQueue = this.vttFragQueues[trackId],
	            currentFragSN = !!this.currentlyProcessing ? this.currentlyProcessing.sn : -1;
	
	        var alreadyProcessed = function alreadyProcessed(frag) {
	          return processedFragSNs.indexOf(frag.sn) > -1;
	        };
	
	        var alreadyInQueue = function alreadyInQueue(frag) {
	          return fragQueue.some(function (fragInQueue) {
	            return fragInQueue.sn === frag.sn;
	          });
	        };
	
	        // exit if tracks don't exist
	        if (!tracks) {
	          break;
	        }
	        var trackDetails;
	
	        if (trackId < tracks.length) {
	          trackDetails = tracks[trackId].details;
	        }
	
	        if (typeof trackDetails === 'undefined') {
	          break;
	        }
	
	        // Add all fragments that haven't been, aren't currently being and aren't waiting to be processed, to queue.
	        trackDetails.fragments.forEach(function (frag) {
	          if (!(alreadyProcessed(frag) || frag.sn === currentFragSN || alreadyInQueue(frag))) {
	            // Load key if subtitles are encrypted
	            if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
	              logger["b" /* logger */].log('Loading key for ' + frag.sn);
	              _this4.state = subtitle_stream_controller_State.KEY_LOADING;
	              _this4.hls.trigger(events["a" /* default */].KEY_LOADING, { frag: frag });
	            } else {
	              // Frags don't know their subtitle track ID, so let's just add that...
	              frag.trackId = trackId;
	              fragQueue.push(frag);
	              _this4.nextFrag();
	            }
	          }
	        });
	    }
	  };
	
	  // Got all new subtitle tracks.
	
	
	  SubtitleStreamController.prototype.onSubtitleTracksUpdated = function onSubtitleTracksUpdated(data) {
	    var _this5 = this;
	
	    logger["b" /* logger */].log('subtitle tracks updated');
	    this.tracks = data.subtitleTracks;
	    this.clearVttFragQueues();
	    this.vttFragSNsProcessed = {};
	    this.tracks.forEach(function (track) {
	      _this5.vttFragSNsProcessed[track.id] = [];
	    });
	  };
	
	  SubtitleStreamController.prototype.onSubtitleTrackSwitch = function onSubtitleTrackSwitch(data) {
	    this.currentTrackId = data.id;
	    this.clearVttFragQueues();
	  };
	
	  // Got a new set of subtitle fragments.
	
	
	  SubtitleStreamController.prototype.onSubtitleTrackLoaded = function onSubtitleTrackLoaded() {
	    this.tick();
	  };
	
	  SubtitleStreamController.prototype.onKeyLoaded = function onKeyLoaded() {
	    if (this.state === subtitle_stream_controller_State.KEY_LOADING) {
	      this.state = subtitle_stream_controller_State.IDLE;
	      this.tick();
	    }
	  };
	
	  SubtitleStreamController.prototype.onFragLoaded = function onFragLoaded(data) {
	    var fragCurrent = this.fragCurrent,
	        decryptData = data.frag.decryptdata;
	    var fragLoaded = data.frag,
	        hls = this.hls;
	    if (this.state === subtitle_stream_controller_State.FRAG_LOADING && fragCurrent && data.frag.type === 'subtitle' && fragCurrent.sn === data.frag.sn) {
	      // check to see if the payload needs to be decrypted
	      if (data.payload.byteLength > 0 && decryptData != null && decryptData.key != null && decryptData.method === 'AES-128') {
	        var startTime;
	        try {
	          startTime = performance.now();
	        } catch (error) {
	          startTime = Date.now();
	        }
	        // decrypt the subtitles
	        this.decrypter.decrypt(data.payload, decryptData.key.buffer, decryptData.iv.buffer, function (decryptedData) {
	          var endTime;
	          try {
	            endTime = performance.now();
	          } catch (error) {
	            endTime = Date.now();
	          }
	          hls.trigger(events["a" /* default */].FRAG_DECRYPTED, { frag: fragLoaded, payload: decryptedData, stats: { tstart: startTime, tdecrypt: endTime } });
	        });
	      }
	    }
	  };
	
	  return SubtitleStreamController;
	}(event_handler);
	
	/* harmony default export */ var subtitle_stream_controller = (subtitle_stream_controller_SubtitleStreamController);
	// CONCATENATED MODULE: ./src/config.js
	/**
	 * HLS config
	 */
	
	
	
	
	
	
	//import FetchLoader from './utils/fetch-loader';
	
	
	
	
	
	
	
	
	
	var hlsDefaultConfig = {
	  autoStartLoad: true, // used by stream-controller
	  startPosition: -1, // used by stream-controller
	  defaultAudioCodec: undefined, // used by stream-controller
	  debug: false, // used by logger
	  capLevelOnFPSDrop: false, // used by fps-controller
	  capLevelToPlayerSize: false, // used by cap-level-controller
	  initialLiveManifestSize: 1, // used by stream-controller
	  maxBufferLength: 30, // used by stream-controller
	  maxBufferSize: 60 * 1000 * 1000, // used by stream-controller
	  maxBufferHole: 0.5, // used by stream-controller
	  maxSeekHole: 2, // used by stream-controller
	  lowBufferWatchdogPeriod: 0.5, // used by stream-controller
	  highBufferWatchdogPeriod: 3, // used by stream-controller
	  nudgeOffset: 0.1, // used by stream-controller
	  nudgeMaxRetry: 3, // used by stream-controller
	  maxFragLookUpTolerance: 0.25, // used by stream-controller
	  liveSyncDurationCount: 3, // used by stream-controller
	  liveMaxLatencyDurationCount: Infinity, // used by stream-controller
	  liveSyncDuration: undefined, // used by stream-controller
	  liveMaxLatencyDuration: undefined, // used by stream-controller
	  liveDurationInfinity: false, // used by buffer-controller
	  maxMaxBufferLength: 600, // used by stream-controller
	  enableWorker: true, // used by demuxer
	  enableSoftwareAES: true, // used by decrypter
	  manifestLoadingTimeOut: 10000, // used by playlist-loader
	  manifestLoadingMaxRetry: 1, // used by playlist-loader
	  manifestLoadingRetryDelay: 1000, // used by playlist-loader
	  manifestLoadingMaxRetryTimeout: 64000, // used by playlist-loader
	  startLevel: undefined, // used by level-controller
	  levelLoadingTimeOut: 10000, // used by playlist-loader
	  levelLoadingMaxRetry: 4, // used by playlist-loader
	  levelLoadingRetryDelay: 1000, // used by playlist-loader
	  levelLoadingMaxRetryTimeout: 64000, // used by playlist-loader
	  fragLoadingTimeOut: 20000, // used by fragment-loader
	  fragLoadingMaxRetry: 6, // used by fragment-loader
	  fragLoadingRetryDelay: 1000, // used by fragment-loader
	  fragLoadingMaxRetryTimeout: 64000, // used by fragment-loader
	  fragLoadingLoopThreshold: 3, // used by stream-controller
	  startFragPrefetch: false, // used by stream-controller
	  fpsDroppedMonitoringPeriod: 5000, // used by fps-controller
	  fpsDroppedMonitoringThreshold: 0.2, // used by fps-controller
	  appendErrorMaxRetry: 3, // used by buffer-controller
	  loader: xhr_loader,
	  //loader: FetchLoader,
	  fLoader: undefined,
	  pLoader: undefined,
	  xhrSetup: undefined,
	  fetchSetup: undefined,
	  abrController: abr_controller,
	  bufferController: buffer_controller,
	  capLevelController: cap_level_controller,
	  fpsController: fps_controller,
	  stretchShortVideoTrack: false, // used by mp4-remuxer
	  maxAudioFramesDrift: 1, // used by mp4-remuxer
	  forceKeyFrameOnDiscontinuity: true, // used by ts-demuxer
	  abrEwmaFastLive: 3, // used by abr-controller
	  abrEwmaSlowLive: 9, // used by abr-controller
	  abrEwmaFastVoD: 3, // used by abr-controller
	  abrEwmaSlowVoD: 9, // used by abr-controller
	  abrEwmaDefaultEstimate: 5e5, // 500 kbps  // used by abr-controller
	  abrBandWidthFactor: 0.95, // used by abr-controller
	  abrBandWidthUpFactor: 0.7, // used by abr-controller
	  abrMaxWithRealBitrate: false, // used by abr-controller
	  maxStarvationDelay: 4, // used by abr-controller
	  maxLoadingDelay: 4, // used by abr-controller
	  minAutoBitrate: 0 // used by hls
	};
	
	if (true) {
	  hlsDefaultConfig.subtitleStreamController = subtitle_stream_controller;
	  hlsDefaultConfig.subtitleTrackController = subtitle_track_controller;
	  hlsDefaultConfig.timelineController = timeline_controller;
	  hlsDefaultConfig.cueHandler = cues_namespaceObject;
	  hlsDefaultConfig.enableCEA708Captions = true; // used by timeline-controller
	  hlsDefaultConfig.enableWebVTT = true; // used by timeline-controller
	  hlsDefaultConfig.captionsTextTrack1Label = 'English'; // used by timeline-controller
	  hlsDefaultConfig.captionsTextTrack1LanguageCode = 'en'; // used by timeline-controller
	  hlsDefaultConfig.captionsTextTrack2Label = 'Spanish'; // used by timeline-controller
	  hlsDefaultConfig.captionsTextTrack2LanguageCode = 'es'; // used by timeline-controller
	}
	
	if (true) {
	  hlsDefaultConfig.audioStreamController = audio_stream_controller;
	  hlsDefaultConfig.audioTrackController = audio_track_controller;
	}
	// CONCATENATED MODULE: ./src/hls.js
	var hls__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function hls__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * HLS interface
	 */
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var hls_Hls = function () {
	  Hls.isSupported = function isSupported() {
	    return is_supported_isSupported();
	  };
	
	  hls__createClass(Hls, null, [{
	    key: 'version',
	    get: function get() {
	      return "0.8.9";
	    }
	  }, {
	    key: 'Events',
	    get: function get() {
	      return events["a" /* default */];
	    }
	  }, {
	    key: 'ErrorTypes',
	    get: function get() {
	      return errors["b" /* ErrorTypes */];
	    }
	  }, {
	    key: 'ErrorDetails',
	    get: function get() {
	      return errors["a" /* ErrorDetails */];
	    }
	  }, {
	    key: 'DefaultConfig',
	    get: function get() {
	      if (!Hls.defaultConfig) {
	        return hlsDefaultConfig;
	      }
	      return Hls.defaultConfig;
	    },
	    set: function set(defaultConfig) {
	      Hls.defaultConfig = defaultConfig;
	    }
	  }]);
	
	  function Hls() {
	    var _this = this;
	
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    hls__classCallCheck(this, Hls);
	
	    var defaultConfig = Hls.DefaultConfig;
	
	    if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) {
	      throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
	    }
	
	    for (var prop in defaultConfig) {
	      if (prop in config) {
	        continue;
	      }
	      config[prop] = defaultConfig[prop];
	    }
	
	    if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) {
	      throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
	    }
	
	    if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) {
	      throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
	    }
	
	    Object(logger["a" /* enableLogs */])(config.debug);
	    this.config = config;
	    this._autoLevelCapping = -1;
	    // observer setup
	    var observer = this.observer = new events_default.a();
	    observer.trigger = function trigger(event) {
	      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        data[_key - 1] = arguments[_key];
	      }
	
	      observer.emit.apply(observer, [event, event].concat(data));
	    };
	
	    observer.off = function off(event) {
	      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        data[_key2 - 1] = arguments[_key2];
	      }
	
	      observer.removeListener.apply(observer, [event].concat(data));
	    };
	    this.on = observer.on.bind(observer);
	    this.off = observer.off.bind(observer);
	    this.trigger = observer.trigger.bind(observer);
	
	    // core controllers and network loaders
	    var abrController = this.abrController = new config.abrController(this);
	    var bufferController = new config.bufferController(this);
	    var capLevelController = new config.capLevelController(this);
	    var fpsController = new config.fpsController(this);
	    var playListLoader = new playlist_loader(this);
	    var fragmentLoader = new fragment_loader(this);
	    var keyLoader = new key_loader(this);
	    var id3TrackController = new id3_track_controller(this);
	
	    // network controllers
	    var levelController = this.levelController = new level_controller(this);
	    var streamController = this.streamController = new stream_controller(this);
	    var networkControllers = [levelController, streamController];
	
	    // optional audio stream controller
	    var Controller = config.audioStreamController;
	    if (Controller) {
	      networkControllers.push(new Controller(this));
	    }
	    this.networkControllers = networkControllers;
	
	    var coreComponents = [playListLoader, fragmentLoader, keyLoader, abrController, bufferController, capLevelController, fpsController, id3TrackController];
	
	    // optional audio track and subtitle controller
	    Controller = config.audioTrackController;
	    if (Controller) {
	      var audioTrackController = new Controller(this);
	      this.audioTrackController = audioTrackController;
	      coreComponents.push(audioTrackController);
	    }
	
	    Controller = config.subtitleTrackController;
	    if (Controller) {
	      var subtitleTrackController = new Controller(this);
	      this.subtitleTrackController = subtitleTrackController;
	      coreComponents.push(subtitleTrackController);
	    }
	
	    // optional subtitle controller
	    [config.subtitleStreamController, config.timelineController].forEach(function (Controller) {
	      if (Controller) {
	        coreComponents.push(new Controller(_this));
	      }
	    });
	    this.coreComponents = coreComponents;
	  }
	
	  Hls.prototype.destroy = function destroy() {
	    logger["b" /* logger */].log('destroy');
	    this.trigger(events["a" /* default */].DESTROYING);
	    this.detachMedia();
	    this.coreComponents.concat(this.networkControllers).forEach(function (component) {
	      component.destroy();
	    });
	    this.url = null;
	    this.observer.removeAllListeners();
	    this._autoLevelCapping = -1;
	  };
	
	  Hls.prototype.attachMedia = function attachMedia(media) {
	    logger["b" /* logger */].log('attachMedia');
	    this.media = media;
	    this.trigger(events["a" /* default */].MEDIA_ATTACHING, { media: media });
	  };
	
	  Hls.prototype.detachMedia = function detachMedia() {
	    logger["b" /* logger */].log('detachMedia');
	    this.trigger(events["a" /* default */].MEDIA_DETACHING);
	    this.media = null;
	  };
	
	  Hls.prototype.loadSource = function loadSource(url) {
	    url = url_toolkit_default.a.buildAbsoluteURL(window.location.href, url, { alwaysNormalize: true });
	    logger["b" /* logger */].log('loadSource:' + url);
	    this.url = url;
	    // when attaching to a source URL, trigger a playlist load
	    this.trigger(events["a" /* default */].MANIFEST_LOADING, { url: url });
	  };
	
	  Hls.prototype.startLoad = function startLoad() {
	    var startPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	    logger["b" /* logger */].log('startLoad(' + startPosition + ')');
	    this.networkControllers.forEach(function (controller) {
	      controller.startLoad(startPosition);
	    });
	  };
	
	  Hls.prototype.stopLoad = function stopLoad() {
	    logger["b" /* logger */].log('stopLoad');
	    this.networkControllers.forEach(function (controller) {
	      controller.stopLoad();
	    });
	  };
	
	  Hls.prototype.swapAudioCodec = function swapAudioCodec() {
	    logger["b" /* logger */].log('swapAudioCodec');
	    this.streamController.swapAudioCodec();
	  };
	
	  Hls.prototype.recoverMediaError = function recoverMediaError() {
	    logger["b" /* logger */].log('recoverMediaError');
	    var media = this.media;
	    this.detachMedia();
	    this.attachMedia(media);
	  };
	
	  /** Return all quality levels **/
	
	
	  hls__createClass(Hls, [{
	    key: 'levels',
	    get: function get() {
	      return this.levelController.levels;
	    }
	
	    /** Return current playback quality level **/
	
	  }, {
	    key: 'currentLevel',
	    get: function get() {
	      return this.streamController.currentLevel;
	    }
	
	    /* set quality level immediately (-1 for automatic level selection) */
	    ,
	    set: function set(newLevel) {
	      logger["b" /* logger */].log('set currentLevel:' + newLevel);
	      this.loadLevel = newLevel;
	      this.streamController.immediateLevelSwitch();
	    }
	
	    /** Return next playback quality level (quality level of next fragment) **/
	
	  }, {
	    key: 'nextLevel',
	    get: function get() {
	      return this.streamController.nextLevel;
	    }
	
	    /* set quality level for next fragment (-1 for automatic level selection) */
	    ,
	    set: function set(newLevel) {
	      logger["b" /* logger */].log('set nextLevel:' + newLevel);
	      this.levelController.manualLevel = newLevel;
	      this.streamController.nextLevelSwitch();
	    }
	
	    /** Return the quality level of current/last loaded fragment **/
	
	  }, {
	    key: 'loadLevel',
	    get: function get() {
	      return this.levelController.level;
	    }
	
	    /* set quality level for current/next loaded fragment (-1 for automatic level selection) */
	    ,
	    set: function set(newLevel) {
	      logger["b" /* logger */].log('set loadLevel:' + newLevel);
	      this.levelController.manualLevel = newLevel;
	    }
	
	    /** Return the quality level of next loaded fragment **/
	
	  }, {
	    key: 'nextLoadLevel',
	    get: function get() {
	      return this.levelController.nextLoadLevel;
	    }
	
	    /** set quality level of next loaded fragment **/
	    ,
	    set: function set(level) {
	      this.levelController.nextLoadLevel = level;
	    }
	
	    /** Return first level (index of first level referenced in manifest)
	    **/
	
	  }, {
	    key: 'firstLevel',
	    get: function get() {
	      return Math.max(this.levelController.firstLevel, this.minAutoLevel);
	    }
	
	    /** set first level (index of first level referenced in manifest)
	    **/
	    ,
	    set: function set(newLevel) {
	      logger["b" /* logger */].log('set firstLevel:' + newLevel);
	      this.levelController.firstLevel = newLevel;
	    }
	
	    /** Return start level (level of first fragment that will be played back)
	        if not overrided by user, first level appearing in manifest will be used as start level
	        if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
	    **/
	
	  }, {
	    key: 'startLevel',
	    get: function get() {
	      return this.levelController.startLevel;
	    }
	
	    /** set  start level (level of first fragment that will be played back)
	        if not overrided by user, first level appearing in manifest will be used as start level
	        if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
	    **/
	    ,
	    set: function set(newLevel) {
	      logger["b" /* logger */].log('set startLevel:' + newLevel);
	      var hls = this;
	      // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
	      if (newLevel !== -1) {
	        newLevel = Math.max(newLevel, hls.minAutoLevel);
	      }
	      hls.levelController.startLevel = newLevel;
	    }
	
	    /** Return the capping/max level value that could be used by automatic level selection algorithm **/
	
	  }, {
	    key: 'autoLevelCapping',
	    get: function get() {
	      return this._autoLevelCapping;
	    }
	
	    /** set the capping/max level value that could be used by automatic level selection algorithm **/
	    ,
	    set: function set(newLevel) {
	      logger["b" /* logger */].log('set autoLevelCapping:' + newLevel);
	      this._autoLevelCapping = newLevel;
	    }
	
	    /* check if we are in automatic level selection mode */
	
	  }, {
	    key: 'autoLevelEnabled',
	    get: function get() {
	      return this.levelController.manualLevel === -1;
	    }
	
	    /* return manual level */
	
	  }, {
	    key: 'manualLevel',
	    get: function get() {
	      return this.levelController.manualLevel;
	    }
	
	    /* return min level selectable in auto mode according to config.minAutoBitrate */
	
	  }, {
	    key: 'minAutoLevel',
	    get: function get() {
	      var hls = this,
	          levels = hls.levels,
	          minAutoBitrate = hls.config.minAutoBitrate,
	          len = levels ? levels.length : 0;
	      for (var i = 0; i < len; i++) {
	        var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
	        if (levelNextBitrate > minAutoBitrate) {
	          return i;
	        }
	      }
	      return 0;
	    }
	
	    /* return max level selectable in auto mode according to autoLevelCapping */
	
	  }, {
	    key: 'maxAutoLevel',
	    get: function get() {
	      var hls = this;
	      var levels = hls.levels;
	      var autoLevelCapping = hls.autoLevelCapping;
	      var maxAutoLevel = void 0;
	      if (autoLevelCapping === -1 && levels && levels.length) {
	        maxAutoLevel = levels.length - 1;
	      } else {
	        maxAutoLevel = autoLevelCapping;
	      }
	      return maxAutoLevel;
	    }
	
	    // return next auto level
	
	  }, {
	    key: 'nextAutoLevel',
	    get: function get() {
	      var hls = this;
	      // ensure next auto level is between  min and max auto level
	      return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
	    }
	
	    // this setter is used to force next auto level
	    // this is useful to force a switch down in auto mode : in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
	    // forced value is valid for one fragment. upon succesful frag loading at forced level, this value will be resetted to -1 by ABR controller
	    ,
	    set: function set(nextLevel) {
	      var hls = this;
	      hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
	    }
	
	    /** get alternate audio tracks list from playlist **/
	
	  }, {
	    key: 'audioTracks',
	    get: function get() {
	      var audioTrackController = this.audioTrackController;
	      return audioTrackController ? audioTrackController.audioTracks : [];
	    }
	
	    /** get index of the selected audio track (index in audio track lists) **/
	
	  }, {
	    key: 'audioTrack',
	    get: function get() {
	      var audioTrackController = this.audioTrackController;
	      return audioTrackController ? audioTrackController.audioTrack : -1;
	    }
	
	    /** select an audio track, based on its index in audio track lists**/
	    ,
	    set: function set(audioTrackId) {
	      var audioTrackController = this.audioTrackController;
	      if (audioTrackController) {
	        audioTrackController.audioTrack = audioTrackId;
	      }
	    }
	  }, {
	    key: 'liveSyncPosition',
	    get: function get() {
	      return this.streamController.liveSyncPosition;
	    }
	
	    /** get alternate subtitle tracks list from playlist **/
	
	  }, {
	    key: 'subtitleTracks',
	    get: function get() {
	      var subtitleTrackController = this.subtitleTrackController;
	      return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
	    }
	
	    /** get index of the selected subtitle track (index in subtitle track lists) **/
	
	  }, {
	    key: 'subtitleTrack',
	    get: function get() {
	      var subtitleTrackController = this.subtitleTrackController;
	      return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
	    }
	
	    /** select an subtitle track, based on its index in subtitle track lists**/
	    ,
	    set: function set(subtitleTrackId) {
	      var subtitleTrackController = this.subtitleTrackController;
	      if (subtitleTrackController) {
	        subtitleTrackController.subtitleTrack = subtitleTrackId;
	      }
	    }
	  }, {
	    key: 'subtitleDisplay',
	    get: function get() {
	      var subtitleTrackController = this.subtitleTrackController;
	      return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
	    },
	    set: function set(value) {
	      var subtitleTrackController = this.subtitleTrackController;
	      if (subtitleTrackController) {
	        subtitleTrackController.subtitleDisplay = value;
	      }
	    }
	  }]);
	
	  return Hls;
	}();
	
	/* harmony default export */ var src_hls = __webpack_exports__["default"] = (hls_Hls);
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	function webpackBootstrapFunc (modules) {
	/******/  // The module cache
	/******/  var installedModules = {};
	
	/******/  // The require function
	/******/  function __webpack_require__(moduleId) {
	
	/******/    // Check if module is in cache
	/******/    if(installedModules[moduleId])
	/******/      return installedModules[moduleId].exports;
	
	/******/    // Create a new module (and put it into the cache)
	/******/    var module = installedModules[moduleId] = {
	/******/      i: moduleId,
	/******/      l: false,
	/******/      exports: {}
	/******/    };
	
	/******/    // Execute the module function
	/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/    // Flag the module as loaded
	/******/    module.l = true;
	
	/******/    // Return the exports of the module
	/******/    return module.exports;
	/******/  }
	
	/******/  // expose the modules object (__webpack_modules__)
	/******/  __webpack_require__.m = modules;
	
	/******/  // expose the module cache
	/******/  __webpack_require__.c = installedModules;
	
	/******/  // identity function for calling harmony imports with the correct context
	/******/  __webpack_require__.i = function(value) { return value; };
	
	/******/  // define getter function for harmony exports
	/******/  __webpack_require__.d = function(exports, name, getter) {
	/******/    if(!__webpack_require__.o(exports, name)) {
	/******/      Object.defineProperty(exports, name, {
	/******/        configurable: false,
	/******/        enumerable: true,
	/******/        get: getter
	/******/      });
	/******/    }
	/******/  };
	
	/******/  // getDefaultExport function for compatibility with non-harmony modules
	/******/  __webpack_require__.n = function(module) {
	/******/    var getter = module && module.__esModule ?
	/******/      function getDefault() { return module['default']; } :
	/******/      function getModuleExports() { return module; };
	/******/    __webpack_require__.d(getter, 'a', getter);
	/******/    return getter;
	/******/  };
	
	/******/  // Object.prototype.hasOwnProperty.call
	/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/  // __webpack_public_path__
	/******/  __webpack_require__.p = "/";
	
	/******/  // on error function for async loading
	/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };
	
	  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)
	  return f.default || f // try to call default if defined to also support babel esmodule exports
	}
	
	// http://stackoverflow.com/a/2593661/130442
	function quoteRegExp (str) {
	  return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
	}
	
	function getModuleDependencies (module) {
	  var retval = []
	  var fnString = module.toString()
	  var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/)
	  if (!wrapperSignature) return retval
	
	  var webpackRequireName = wrapperSignature[1]
	  var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + '\\((\/\\*.*?\\*\/)?\s?.*?([\\.|\\-|\\w|\/|@]+).*?\\)', 'g') // additional chars when output.pathinfo is true
	  var match
	  while ((match = re.exec(fnString))) {
	    retval.push(match[3])
	  }
	  return retval
	}
	
	function getRequiredModules (sources, moduleId) {
	  var modulesQueue = [moduleId]
	  var requiredModules = []
	  var seenModules = {}
	
	  while (modulesQueue.length) {
	    var moduleToCheck = modulesQueue.pop()
	    if (seenModules[moduleToCheck] || !sources[moduleToCheck]) continue
	    seenModules[moduleToCheck] = true
	    requiredModules.push(moduleToCheck)
	    var newModules = getModuleDependencies(sources[moduleToCheck])
	    modulesQueue = modulesQueue.concat(newModules)
	  }
	
	  return requiredModules
	}
	
	module.exports = function (moduleId, options) {
	  options = options || {}
	  var sources = __webpack_require__.m
	
	  var requiredModules = options.all ? Object.keys(sources) : getRequiredModules(sources, moduleId)
	  var src = '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[id].toString() }).join(',') + '})(self);'
	
	  var blob = new window.Blob([src], { type: 'text/javascript' })
	  if (options.bare) { return blob }
	
	  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL
	
	  var workerUrl = URL.createObjectURL(blob)
	  var worker = new window.Worker(workerUrl)
	  worker.objectURL = workerUrl
	
	  return worker
	}
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demux_demuxer_inline__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_events__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_events__);
	/* demuxer web worker.
	 *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
	 *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
	 */
	
	
	
	
	
	
	var DemuxerWorker = function DemuxerWorker(self) {
	  // observer setup
	  var observer = new __WEBPACK_IMPORTED_MODULE_3_events___default.a();
	  observer.trigger = function trigger(event) {
	    for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      data[_key - 1] = arguments[_key];
	    }
	
	    observer.emit.apply(observer, [event, event].concat(data));
	  };
	
	  observer.off = function off(event) {
	    for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      data[_key2 - 1] = arguments[_key2];
	    }
	
	    observer.removeListener.apply(observer, [event].concat(data));
	  };
	
	  var forwardMessage = function forwardMessage(ev, data) {
	    self.postMessage({ event: ev, data: data });
	  };
	
	  self.addEventListener('message', function (ev) {
	    var data = ev.data;
	    //console.log('demuxer cmd:' + data.cmd);
	    switch (data.cmd) {
	      case 'init':
	        var config = JSON.parse(data.config);
	        self.demuxer = new __WEBPACK_IMPORTED_MODULE_0__demux_demuxer_inline__["a" /* default */](observer, data.typeSupported, config, data.vendor);
	        try {
	          Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["a" /* enableLogs */])(config.debug === true);
	        } catch (err) {
	          console.warn('demuxerWorker: unable to enable logs');
	        }
	        // signal end of worker init
	        forwardMessage('init', null);
	        break;
	      case 'demux':
	        self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
	        break;
	      default:
	        break;
	    }
	  });
	
	  // forward events to main thread
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_DECRYPTED, forwardMessage);
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_INIT_SEGMENT, forwardMessage);
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSED, forwardMessage);
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].ERROR, forwardMessage);
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_METADATA, forwardMessage);
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_USERDATA, forwardMessage);
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].INIT_PTS_FOUND, forwardMessage);
	
	  // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
	  observer.on(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].FRAG_PARSING_DATA, function (ev, data) {
	    var transferable = [];
	    var message = { event: ev, data: data };
	    if (data.data1) {
	      message.data1 = data.data1.buffer;
	      transferable.push(data.data1.buffer);
	      delete data.data1;
	    }
	    if (data.data2) {
	      message.data2 = data.data2.buffer;
	      transferable.push(data.data2.buffer);
	      delete data.data2;
	    }
	    self.postMessage(message, transferable);
	  });
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (DemuxerWorker);
	
	/***/ })
	/******/ ])["default"];
	});
	//# sourceMappingURL=hls.js.map

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	module.exports = "<li class=rp-raceResult__horse data-ng-repeat=\"item in fastInfo\" data-outcome-desc=\"{{ item['outcome_code'] }}\"> <span class=rp-raceResult__horseName data-test-selector=\"text-horse-name-awaiting-{{ item['race_id']}}\"> {{item['saddle_cloth']}}. {{ item['horse_name']}} </span><span class=rp-raceResult__horsePrice data-ng-bind=\"item['price']\"></span> </li> <li class=rp-raceResult__horse_wait data-ng-show=fastResultsAvailable data-test-selector=text-awaiting data-test-view=list-results> Awaiting full result... </li>";

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	module.exports = "<div class=rp-horseTable__toolbar> <div class=\"rp-horseTable__pedigreesBtn ui-btn ui-btn_tiertiary ui-btn_small\" data-ng-click=togglePedigrees() data-ng-class=\"{'ui-btn_toggleActive': getPedigreesState()}\" data-test-selector=button-pedigree> <span class=\"ui-icon_pedigree ui-btn__icon\"> <svg class=\"ui-icon ui-icon_sizeMedium\"> <use xlink:href=img/icons.svg#icon-pedigree /> </svg> </span> Pedigrees </div> <div class=\"rp-horseTable__commentsBtn ui-btn ui-btn_tiertiary ui-btn_small\" data-ng-click=toggleComments() data-ng-class=\"{'ui-btn_toggleActive': getCommentsState()}\" data-test-selector=button-comments> <span class=\"ui-icon_comment ui-btn__icon\"> <svg class=\"ui-icon ui-icon_sizeComment\"> <use xlink:href=img/icons.svg#icon-comment /> </svg> </span> Comments </div> </div> ";

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1561),
	    hashDelete = __webpack_require__(1562),
	    hashGet = __webpack_require__(1563),
	    hashHas = __webpack_require__(1564),
	    hashSet = __webpack_require__(1565);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(350),
	    setCacheAdd = __webpack_require__(1592),
	    setCacheHas = __webpack_require__(1593);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(565);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(247),
	    keysIn = __webpack_require__(374);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(355);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1547);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1514),
	    keys = __webpack_require__(191);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	/**
	 * This function is like `baseIndexOf` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOfWith(array, value, fromIndex, comparator) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOfWith;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(351),
	    equalArrays = __webpack_require__(578),
	    equalByTag = __webpack_require__(1551),
	    equalObjects = __webpack_require__(1552),
	    getTag = __webpack_require__(186),
	    isArray = __webpack_require__(39),
	    isBuffer = __webpack_require__(371),
	    isTypedArray = __webpack_require__(597);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(186),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(351),
	    baseIsEqual = __webpack_require__(566);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(372),
	    isMasked = __webpack_require__(1573),
	    isObject = __webpack_require__(91),
	    toSource = __webpack_require__(593);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(186),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isLength = __webpack_require__(373),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91),
	    isPrototype = __webpack_require__(364),
	    nativeKeysIn = __webpack_require__(1588);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(355),
	    isArrayLike = __webpack_require__(189);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1521),
	    getMatchData = __webpack_require__(1556),
	    matchesStrictComparable = __webpack_require__(585);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(566),
	    get = __webpack_require__(1617),
	    hasIn = __webpack_require__(1618),
	    isKey = __webpack_require__(363),
	    isStrictComparable = __webpack_require__(584),
	    matchesStrictComparable = __webpack_require__(585),
	    toKey = __webpack_require__(187);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(563);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(184),
	    baseIndexOf = __webpack_require__(565),
	    baseIndexOfWith = __webpack_require__(1517),
	    baseUnary = __webpack_require__(246),
	    copyArray = __webpack_require__(185);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAllBy` without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAll(array, values, iteratee, comparator) {
	  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	      index = -1,
	      length = values.length,
	      seen = array;
	
	  if (array === values) {
	    values = copyArray(values);
	  }
	  if (iteratee) {
	    seen = arrayMap(array, baseUnary(iteratee));
	  }
	  while (++index < length) {
	    var fromIndex = 0,
	        value = values[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	      if (seen !== array) {
	        splice.call(seen, fromIndex, 1);
	      }
	      splice.call(array, fromIndex, 1);
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAll;


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1606),
	    defineProperty = __webpack_require__(577),
	    identity = __webpack_require__(188);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(150),
	    arrayMap = __webpack_require__(184),
	    isArray = __webpack_require__(39),
	    isSymbol = __webpack_require__(190);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1601);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(188);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194)(module)))

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(358);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(150);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(358);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(247),
	    getSymbols = __webpack_require__(361);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(247),
	    getSymbolsIn = __webpack_require__(583);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(189);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(248),
	    root = __webpack_require__(41);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(352),
	    createCtor = __webpack_require__(248),
	    createHybrid = __webpack_require__(575),
	    createRecurry = __webpack_require__(576),
	    getHolder = __webpack_require__(582),
	    replaceHolders = __webpack_require__(366),
	    root = __webpack_require__(41);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(352),
	    createCtor = __webpack_require__(248),
	    root = __webpack_require__(41);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(150),
	    Uint8Array = __webpack_require__(555),
	    eq = __webpack_require__(368),
	    equalArrays = __webpack_require__(578),
	    mapToArray = __webpack_require__(1584),
	    setToArray = __webpack_require__(1594);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(580);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1611),
	    overRest = __webpack_require__(588),
	    setToString = __webpack_require__(367);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(564),
	    getSymbolsIn = __webpack_require__(583),
	    keysIn = __webpack_require__(374);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(1590);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(584),
	    keys = __webpack_require__(191);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(150);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(572),
	    isArguments = __webpack_require__(370),
	    isArray = __webpack_require__(39),
	    isIndex = __webpack_require__(362),
	    isLength = __webpack_require__(373),
	    toKey = __webpack_require__(187);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(250);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(250);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(250);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(250);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(358),
	    cloneDataView = __webpack_require__(1538),
	    cloneRegExp = __webpack_require__(1539),
	    cloneSymbol = __webpack_require__(1540),
	    cloneTypedArray = __webpack_require__(1541);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(245),
	    getPrototype = __webpack_require__(360),
	    isPrototype = __webpack_require__(364);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(150),
	    isArguments = __webpack_require__(370),
	    isArray = __webpack_require__(39);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(348),
	    getData = __webpack_require__(581),
	    getFuncName = __webpack_require__(1555),
	    lodash = __webpack_require__(1638);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1544);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(244);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(244);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(244);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(244);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1505),
	    ListCache = __webpack_require__(242),
	    Map = __webpack_require__(349);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(249);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(249);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(249);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(249);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1627);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(573),
	    composeArgsRight = __webpack_require__(574),
	    replaceHolders = __webpack_require__(366);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(587);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(185),
	    isIndex = __webpack_require__(362);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(242);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(242),
	    Map = __webpack_require__(349),
	    MapCache = __webpack_require__(350);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(243),
	    arrayIncludes = __webpack_require__(1509);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(348),
	    LodashWrapper = __webpack_require__(554),
	    copyArray = __webpack_require__(185);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(359);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(561);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(359);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91),
	    now = __webpack_require__(1629),
	    toNumber = __webpack_require__(601);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(353),
	    baseFilter = __webpack_require__(1512),
	    baseIteratee = __webpack_require__(356),
	    isArray = __webpack_require__(39);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(562),
	    map = __webpack_require__(1626);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(562);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(243),
	    baseEach = __webpack_require__(355),
	    castFunction = __webpack_require__(1536),
	    isArray = __webpack_require__(39);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(1614),
	    fallbackHolder = __webpack_require__(251);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var defaultHolder = isLib ? func : fallbackHolder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;
	
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  _.placeholder = _;
	
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'ary': __webpack_require__(1604),
	  'assign': __webpack_require__(559),
	  'clone': __webpack_require__(1605),
	  'curry': __webpack_require__(1607),
	  'forEach': __webpack_require__(243),
	  'isArray': __webpack_require__(39),
	  'isError': __webpack_require__(1620),
	  'isFunction': __webpack_require__(372),
	  'isWeakMap': __webpack_require__(1623),
	  'iteratee': __webpack_require__(1624),
	  'keys': __webpack_require__(567),
	  'rearg': __webpack_require__(1633),
	  'toInteger': __webpack_require__(600),
	  'toPath': __webpack_require__(1636)
	};


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(369),
	    func = convert('flatMap', __webpack_require__(1610));
	
	func.placeholder = __webpack_require__(251);
	module.exports = func;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(563);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1516),
	    hasPath = __webpack_require__(1560);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(189),
	    isObjectLike = __webpack_require__(59);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(59),
	    isPlainObject = __webpack_require__(596);
	
	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag = '[object Error]';
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  var tag = baseGetTag(value);
	  return tag == errorTag || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	}
	
	module.exports = isError;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1520),
	    baseUnary = __webpack_require__(246),
	    nodeUtil = __webpack_require__(365);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1524),
	    baseUnary = __webpack_require__(246),
	    nodeUtil = __webpack_require__(365);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(186),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var weakMapTag = '[object WeakMap]';
	
	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike(value) && getTag(value) == weakMapTag;
	}
	
	module.exports = isWeakMap;


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(561),
	    baseIteratee = __webpack_require__(356);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	}
	
	module.exports = iteratee;


/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(184),
	    baseIteratee = __webpack_require__(356),
	    baseMap = __webpack_require__(1527),
	    isArray = __webpack_require__(39);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(350);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(568),
	    basePropertyDeep = __webpack_require__(1530),
	    isKey = __webpack_require__(363),
	    toKey = __webpack_require__(187);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(569),
	    pullAll = __webpack_require__(1632);
	
	/**
	 * Removes all given values from `array` using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	 * to remove elements from an array by predicate.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...*} [values] The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pull(array, 'a', 'c');
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	var pull = baseRest(pullAll);
	
	module.exports = pull;


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	var basePullAll = __webpack_require__(1531);
	
	/**
	 * This method is like `_.pull` except that it accepts an array of values to remove.
	 *
	 * **Note:** Unlike `_.difference`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pullAll(array, ['a', 'c']);
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	function pullAll(array, values) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values)
	    : array;
	}
	
	module.exports = pullAll;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(359),
	    flatRest = __webpack_require__(1553);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = flatRest(function(func, indexes) {
	  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	});
	
	module.exports = rearg;


/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(601);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(184),
	    copyArray = __webpack_require__(185),
	    isArray = __webpack_require__(39),
	    isSymbol = __webpack_require__(190),
	    stringToPath = __webpack_require__(592),
	    toKey = __webpack_require__(187),
	    toString = __webpack_require__(602);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(353),
	    arrayMap = __webpack_require__(184),
	    baseProperty = __webpack_require__(568),
	    baseTimes = __webpack_require__(571),
	    isArrayLikeObject = __webpack_require__(1619);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.zip` except that it accepts an array of grouped
	 * elements and creates an array regrouping the elements to their pre-zip
	 * configuration.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.2.0
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	 * // => [['a', 1, true], ['b', 2, false]]
	 *
	 * _.unzip(zipped);
	 * // => [['a', 'b'], [1, 2], [true, false]]
	 */
	function unzip(array) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var length = 0;
	  array = arrayFilter(array, function(group) {
	    if (isArrayLikeObject(group)) {
	      length = nativeMax(group.length, length);
	      return true;
	    }
	  });
	  return baseTimes(length, function(index) {
	    return arrayMap(array, baseProperty(index));
	  });
	}
	
	module.exports = unzip;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(348),
	    LodashWrapper = __webpack_require__(554),
	    baseLodash = __webpack_require__(357),
	    isArray = __webpack_require__(39),
	    isObjectLike = __webpack_require__(59),
	    wrapperClone = __webpack_require__(1603);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(569),
	    unzip = __webpack_require__(1637);
	
	/**
	 * Creates an array of grouped elements, the first of which contains the
	 * first elements of the given arrays, the second of which contains the
	 * second elements of the given arrays, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zip(['a', 'b'], [1, 2], [true, false]);
	 * // => [['a', 1, true], ['b', 2, false]]
	 */
	var zip = baseRest(unzip);
	
	module.exports = zip;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* loglevel - https://github.com/pimterry/loglevel
	*
	* Copyright (c) 2013 Tim Perry
	* Licensed under the MIT license.
	*/
	(function (root, definition) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(this, function () {
	    "use strict";
	
	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
	        /Trident\/|MSIE /.test(window.navigator.userAgent)
	    );
	
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	
	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	
	    // Trace() doesn't print the message in IE, so for that case we need to wrap it
	    function traceForIE() {
	        if (console.log) {
	            if (console.log.apply) {
	                console.log.apply(console, arguments);
	            } else {
	                // In old IE, native console methods themselves don't have apply().
	                Function.prototype.apply.apply(console.log, [console, arguments]);
	            }
	        }
	        if (console.trace) console.trace();
	    }
	
	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	
	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (methodName === 'trace' && isIE) {
	            return traceForIE;
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	
	    // These private functions always need `this` to be set properly
	
	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	
	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }
	
	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	
	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
	
	      var storageKey = "loglevel";
	      if (typeof name === "string") {
	        storageKey += ":" + name;
	      } else if (typeof name === "symbol") {
	        storageKey = undefined;
	      }
	
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	
	          if (typeof window === undefinedType || !storageKey) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	
	      function getPersistedLevel() {
	          var storedLevel;
	
	          if (typeof window === undefinedType || !storageKey) return;
	
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	
	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	
	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	
	          return storedLevel;
	      }
	
	      function clearPersistedLevel() {
	          if (typeof window === undefinedType || !storageKey) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage.removeItem(storageKey);
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	          } catch (ignore) {}
	      }
	
	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */
	
	      self.name = name;
	
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	
	      self.methodFactory = factory || defaultMethodFactory;
	
	      self.getLevel = function () {
	          return currentLevel;
	      };
	
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	
	      self.setDefaultLevel = function (level) {
	          defaultLevel = level;
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	
	      self.resetLevel = function () {
	          self.setLevel(defaultLevel, false);
	          clearPersistedLevel();
	      };
	
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	
	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	
	    /*
	     *
	     * Top-level API
	     *
	     */
	
	    var defaultLogger = new Logger();
	
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	
	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	
	        return defaultLogger;
	    };
	
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	
	    // ES6 default export, for compatibility
	    defaultLogger['default'] = defaultLogger;
	
	    return defaultLogger;
	}));


/***/ }),
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = analyticsPage;
	
	var _jquery = __webpack_require__(23);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rpAnalytics = __webpack_require__(105);
	
	var segmentio = _interopRequireWildcard(_rpAnalytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function analyticsPage() {
	    var _segmentio$setCommonT;
	
	    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var pageTraits = {};
	
	    segmentio.setCommonTraits((_segmentio$setCommonT = {}, _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SECTION, 'Results'), _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_1, (0, _jquery2.default)('[data-site-sub-section-1]').attr('data-site-sub-section-1')), _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_2, (0, _jquery2.default)('[data-site-sub-section-2]').attr('data-site-sub-section-2')), _segmentio$setCommonT));
	
	    var raceId = (0, _jquery2.default)('[data-analytics-race-id]').attr('data-analytics-race-id');
	    var raceDate = (0, _jquery2.default)('[data-analytics-race-date]').attr('data-analytics-race-date');
	    var raceTime = (0, _jquery2.default)('[data-analytics-race-time]').attr('data-analytics-race-time');
	    var coursename = (0, _jquery2.default)('[data-analytics-coursename]').attr('data-analytics-coursename');
	
	    if (raceId) {
	        pageTraits[segmentio.TRAIT_RACE_ID] = raceId;
	    }
	
	    if (raceDate) {
	        pageTraits[segmentio.TRAIT_RACE_DATE] = raceDate;
	    }
	
	    if (raceTime) {
	        pageTraits[segmentio.TRAIT_RACE_TIME] = raceTime;
	    }
	
	    if (coursename) {
	        pageTraits[segmentio.TRAIT_RACECOURSE] = coursename;
	    }
	
	    pageTraits = _jquery2.default.extend({}, traits, pageTraits);
	
	    var pageName = null; // not used for now
	    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS);
	}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$anchorScrollProvider", function ($anchorScrollProvider) {
	    'ngInject';
	
	    $anchorScrollProvider.disableAutoScrolling();
	}];

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$httpProvider", function ($httpProvider) {
	    'ngInject';
	
	    // initialize get if not there
	
	    if (!$httpProvider.defaults.headers.get) {
	        $httpProvider.defaults.headers.get = {};
	    }
	
	    // disable IE ajax request caching
	    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
	    // extra
	    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
	}];

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$locationProvider", function ($locationProvider) {
	    'ngInject';
	
	    $locationProvider.html5Mode(true);
	    $locationProvider.hashPrefix('!');
	}];

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$sceDelegateProvider", "$windowProvider", function ($sceDelegateProvider, $windowProvider) {
	    'ngInject';
	
	    $sceDelegateProvider.resourceUrlWhitelist([
	    // Allow same origin resource loads.
	    'self',
	    // Allow loading from our assets domain.
	    $windowProvider.$get().assetsURL + '**']);
	}];

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$location", "$timeout", "userPreference", function ($scope, $location, $timeout, userPreference) {
	    'ngInject';
	
	    /**
	     * Initial selected pane for accordion
	     * @type {object} Object of panes states. Generated from view with data-ng-init service
	     * @type {null|text} currentScreenSize
	     */
	
	    var keys = void 0;
	    var panes = {};
	    var expandText = 'Expand All';
	    var collapseText = 'Close All';
	
	    /**
	     * Getter for panes object
	     * @return {object} Object of panes states
	     */
	    $scope.getPanes = function () {
	        return panes;
	    };
	
	    /**
	     * Getter for expandText
	     * @returns {string}
	     */
	    $scope.getExpandText = function () {
	        return expandText;
	    };
	
	    /**
	     * Getter for collapseText
	     * @returns {string}
	     */
	    $scope.getCollapseText = function () {
	        return collapseText;
	    };
	
	    /**
	     * Set keys with keys of panes
	     */
	    $scope.updateKeys = function () {
	        keys = Object.keys($scope.getPanes());
	    };
	
	    /**
	     * Getter for keys
	     * @return {Array} Current screen size
	     */
	    $scope.getKeys = function () {
	        return keys;
	    };
	
	    /**
	     * Get text of button, depends on current state of panes
	     * @returns {string}
	     */
	    $scope.getExpandCollapseText = function () {
	        var state = $scope.checkPanesState();
	        return state ? $scope.getExpandText() : $scope.getCollapseText();
	    };
	
	    /**
	     * Get current pane state
	     * @return {boolean} State of current pane
	     */
	    $scope.getPaneState = function (index) {
	        return panes[index];
	    };
	
	    /**
	     * Expand current pane
	     * @param {number} index Index of current pane.
	     */
	    $scope.expandPane = function (index) {
	        panes[index] = true;
	    };
	
	    /**
	     * Collapse current pane
	     * @param {number} index Index of current pane.
	     */
	    $scope.collapsePane = function (index) {
	        panes[index] = false;
	    };
	
	    /**
	     * Check all panes for collapse state
	     * @returns {boolean}
	     */
	    $scope.checkPanesState = function () {
	        var panesState = false;
	        var panelist = $scope.getPanes();
	
	        Object.keys(panelist).forEach(function (key) {
	            if (!panelist[key]) {
	                panesState = true;
	            }
	        });
	
	        return panesState;
	    };
	
	    /**
	     * Depend on state of panes collapse or expand all
	     */
	    $scope.expandCollapseAllPanes = function () {
	        if ($scope.checkPanesState()) {
	            $scope.expandAllPanes();
	        } else {
	            $scope.collapseAllPanes();
	        }
	        userPreference.toggle(userPreference.TYPE_ACCORDION_STATE);
	    };
	
	    /**
	     * Check is current pane selected and appropriate breakpoint is viewed
	     * @param {number} index Index of pane to check.
	     * @return {boolean}
	     */
	    $scope.isPaneSelected = function (index) {
	        return $scope.getPaneState(index);
	    };
	
	    /**
	     * Expand each pane
	     */
	    $scope.expandAllPanes = function () {
	        var panesKeys = $scope.getKeys();
	
	        panesKeys.forEach(function (element) {
	            $scope.expandPane(element);
	        });
	    };
	
	    /**
	     * Collapse each pane
	     */
	    $scope.collapseAllPanes = function () {
	        var panesKeys = $scope.getKeys();
	
	        panesKeys.forEach(function (element) {
	            $scope.collapsePane(element);
	        });
	    };
	
	    /**
	     * Select pane. Collapse or expand current pane, depends on it initial state.
	     * If scroll flag is set, add hash to url
	     * and scroll page to appropriate pane
	     * @param {number} index Index of pane that was selected
	     * @param {boolean} scroll Flag for adding hash and scrolling the page
	     */
	    $scope.selectPane = function (index) {
	        if ($scope.isPaneSelected(index)) {
	            $scope.collapsePane(index);
	        } else {
	            $scope.expandPane(index);
	        }
	    };
	
	    /**
	     * Init controller, set current screen size, check hash and
	     * add handler for 'window' on resize event
	     */
	    $scope.init = function () {
	        $scope.updateKeys();
	    };
	}];

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$element", "$compile", "CommonFunctions", "$http", "config", function ($scope, $element, $compile, CommonFunctions, $http, config) {
	    'ngInject';
	
	    /**
	     * Initial state of variables for advancedSearch directive
	     */
	
	    var mainTemplateUrl = config.get('assetsURL') + 'views/advancedSearch.html';
	    var listTemplateUrl = config.get('assetsURL') + 'views/advancedSearchList.html';
	    var errorMessageTemplateUrl = config.get('assetsURL') + 'views/advancedSearchErrorMessage.html';
	    var resultsTemplateUrl = config.get('assetsURL') + 'views/advancedSearchResults.html';
	    var titles = [];
	    var initialTitle = 'Advanced Results Search';
	    /* eslint-disable */
	    var noMatchesMessage = 'No results found to match your search. \n Please try a different search';
	    var limitedMatchesMessage = 'Your search is too broad. Please narrow your criteria and try again.';
	    /* eslint-enable */
	    var initialScroll = null;
	    var errorMessage = '';
	    var renderedViews = [];
	    var initialView = null;
	    var searchBody = null;
	    var countryList = [];
	    var itemsList = null;
	    var restrictionMessage = '';
	    var searchResults = [];
	    var showErrorMessageTitle = true;
	    var dateToLabel = '';
	    var dateFromLabel = '';
	    var showResults = false;
	
	    /**
	     * Container for html element
	     */
	    $scope.$html = angular.element('html');
	
	    /**
	     * Container for body element
	     */
	    $scope.$body = angular.element('body');
	
	    /**
	     * Selector for search body element
	     */
	    $scope.searchBodySelector = '#searchBody';
	
	    /**
	     * Constant for days in a year
	     * @type {number}
	     */
	    $scope.EXCEEDING_DATE_YEAR = 365;
	
	    /**
	     * Constant for days in a week
	     * @type {number}
	     */
	    $scope.EXCEEDING_DATE_WEEK = 7;
	
	    /**
	     * Constant for milliseconds in a day
	     * @type {number}
	     */
	    $scope.MS_IN_DAY = 1000 * 60 * 60 * 24;
	
	    /**
	     * Model for search form
	     * @type {object}
	     */
	    $scope.inputs = {
	        raceTitle: '',
	        countryCode: '',
	        courseId: ''
	    };
	
	    /**
	     * Get url for main template
	     * @returns {string}
	     */
	    $scope.getMainTemplateUrl = function () {
	        return mainTemplateUrl;
	    };
	
	    /**
	     * Get url for list template
	     * @returns {string}
	     */
	    $scope.getListTemplateUrl = function () {
	        return listTemplateUrl;
	    };
	
	    /**
	     * Get url for error message template
	     * @returns {string}
	     */
	    $scope.getErrorMessageTemplateUrl = function () {
	        return errorMessageTemplateUrl;
	    };
	
	    /**
	     * Get url for error message template
	     * @returns {string}
	     */
	    $scope.getResultsTemplateUrl = function () {
	        return resultsTemplateUrl;
	    };
	
	    /**
	     * Getter for initial title
	     * @returns {string}
	     */
	    $scope.getInitialTitle = function () {
	        return initialTitle;
	    };
	
	    /**
	     * Getter for initial scroll state
	     * @returns {null|string}
	     */
	    $scope.getInitialScroll = function () {
	        return initialScroll;
	    };
	
	    $scope.setErrorMessage = function (message) {
	        errorMessage = message;
	    };
	
	    $scope.getErrorMessage = function () {
	        return errorMessage;
	    };
	
	    /**
	     * Getter for appropriate date restriction
	     * @returns {string}
	     */
	    $scope.getRestrictionMessage = function () {
	        return restrictionMessage;
	    };
	
	    $scope.getLimitedMatchesMessage = function () {
	        return limitedMatchesMessage;
	    };
	
	    $scope.getNoMatchesMessage = function () {
	        return noMatchesMessage;
	    };
	
	    $scope.setShowResults = function (boolean) {
	        showResults = boolean;
	    };
	
	    $scope.getShowResults = function () {
	        return showResults;
	    };
	
	    /**
	     * Setter for appropriate date restriction
	     * @param {number} date
	     */
	    $scope.setRestrictionMessage = function (date) {
	        /* eslint-disable */
	        restrictionMessage = 'Please enter at least 3 characters for the title or restrict your date range to ' + date + ' days';
	        /* eslint-enable */
	    };
	
	    $scope.setShowErrorMessageTitle = function (boolean) {
	        showErrorMessageTitle = boolean;
	    };
	
	    $scope.getShowErrorMessageTitle = function () {
	        return showErrorMessageTitle;
	    };
	
	    /**
	     * Setter for initial scroll state
	     * @param {string} param
	     */
	    $scope.setInitialScroll = function (param) {
	        initialScroll = param;
	    };
	
	    /**
	     * Getter for initial view
	     * @returns {boolean}
	     */
	    $scope.getInitialView = function () {
	        return initialView;
	    };
	
	    /**
	     * Setter for initial view
	     * @param {object} param
	     */
	    $scope.setInitialView = function (param) {
	        initialView = param;
	    };
	
	    /**
	     * Getter for list of rendered views
	     * @returns {Array}
	     */
	    $scope.getRenderedViews = function () {
	        return renderedViews;
	    };
	
	    /**
	     * Set list of rendered views to empty array
	     */
	    $scope.resetRenderedViews = function () {
	        renderedViews = [];
	    };
	
	    /**
	     * Getter for number of rendered views
	     * @returns {number}
	     */
	    $scope.getNumberOfViews = function () {
	        return renderedViews.length;
	    };
	
	    /**
	     * Getter for titles list
	     * @returns {Array}
	     */
	    $scope.getTitles = function () {
	        return titles;
	    };
	
	    /**
	     * Getter for last title in a array
	     * @returns {number}
	     */
	    $scope.getLastTitle = function () {
	        return titles[titles.length - 1];
	    };
	
	    /**
	     * Getter for body of advanced search
	     * @returns {object}
	     */
	    $scope.getSearchBody = function () {
	        return searchBody;
	    };
	
	    /**
	     * Setter for body of advanced search
	     * @param {object} param
	     */
	    $scope.setSearchBody = function (param) {
	        searchBody = param;
	    };
	
	    /**
	     * Setter for country's list
	     * @param {Array} data List of countries
	     */
	    $scope.setCountryList = function (data) {
	        countryList = data;
	    };
	
	    /**
	     * Getter for country's list
	     */
	    $scope.getCountryList = function () {
	        return countryList;
	    };
	
	    /**
	     * Get list of courses from selected country
	     */
	    $scope.getCourseList = function () {
	        return $scope.getCountryList().filter($scope.helperIsSelected)[0].courses;
	    };
	
	    /**
	     * Getter for itemsList
	     * @returns {Array}
	     */
	    $scope.getItemsList = function () {
	        return itemsList;
	    };
	
	    /**
	     * Setter for itemsList
	     * @param {Array} list List of items to be rendered in Advanced search list view
	     */
	    $scope.setItemsList = function (list) {
	        itemsList = list;
	    };
	
	    /**
	     * Getter for searchResults
	     * @returns {Array}
	     */
	    $scope.getSearchResults = function () {
	        return searchResults;
	    };
	
	    /**
	     * Getter for searchResults
	     * @returns {Array}
	     */
	    $scope.isSearchResultsEmpty = function () {
	        return !$scope.getSearchResults().length;
	    };
	
	    /**
	     * Setter for searchResults
	     * @param {Array} data Results search response
	     */
	    $scope.setSearchResults = function (data) {
	        searchResults = data;
	    };
	
	    $scope.setDateToLabel = function (string) {
	        dateToLabel = string;
	    };
	
	    $scope.getDateToLabel = function () {
	        return dateToLabel;
	    };
	
	    $scope.setDateFromLabel = function (string) {
	        dateFromLabel = string;
	    };
	
	    $scope.getDateFromLabel = function () {
	        return dateFromLabel;
	    };
	
	    var stopHandler = function stopHandler(e) {
	        e.stopPropagation();
	    };
	
	    $scope.setDefaultDateLabels = function () {
	        $scope.setDateToLabel(moment().format('DD MMM YYYY'));
	        $scope.setDateFromLabel(moment().subtract(7, 'days').format('DD MMM YYYY'));
	    };
	    /**
	     * Get property name from selected item. Depends on type of select
	     * @param {string} type Type of select ('Country' or 'Course')
	     * @returns {string} Value of selected item property name
	     */
	    $scope.getSelectedItemName = function (type) {
	        var list = $scope.getCountryList();
	        var result = list.filter($scope.helperIsSelected)[0];
	        return type === 'Country' ? result.name : result.courses.filter($scope.helperIsSelected)[0].name;
	    };
	
	    /**
	     * Get selected element. Used in Array.filter() method
	     * @param {object} element Element of array
	     * @returns {object} Array with one element, which property 'isSelected' is true
	     */
	    $scope.helperIsSelected = function (element) {
	        return element.isSelected;
	    };
	
	    /**
	     * Unset property 'isSelected', and if was used for country
	     * select reset courses. Used in Array.some() method
	     * @param {object} element Element of an array
	     * @param {number} index Index of current element in array
	     * @param {Array} array Array on which was called some()
	     */
	    $scope.helperUnsetSelected = function (element, index, array) {
	        if (element.isSelected) {
	            if (element.hasOwnProperty('courses')) {
	                $scope.resetSelection(array[index].courses);
	            }
	
	            array[index].isSelected = false;
	        }
	    };
	
	    /**
	     * Select item from the list and return user to previous view
	     * @param {object} event Event object
	     * @param {Array} list List of items
	     * @param {number} index Index of item, which should be selected
	     */
	    $scope.chooseItem = function (event, list, index) {
	        event.stopPropagation();
	        $scope.setSelectedItem(list, index);
	        $scope.back();
	    };
	
	    /**
	     * Set property 'isSelected' to 'true'
	     * @param {Array} list List of items
	     * @param {number} index Index of item, which should be selected
	     */
	    $scope.setSelectedItem = function (list, index) {
	        list.some($scope.helperUnsetSelected);
	        list[index].isSelected = true;
	        $scope.getSelectedItemParam(list[index]);
	    };
	
	    /**
	     * Get property name from selected item. Depends on type of select
	     * @returns {string} Value of selected item property name
	     */
	    $scope.getSelectedItemParam = function (selectedItem) {
	        if (selectedItem.hasOwnProperty('countryCode')) {
	            $scope.inputs.countryCode = selectedItem.countryCode;
	        } else {
	            $scope.inputs.courseId = selectedItem.courseId;
	        }
	    };
	
	    /**
	     * Reset to default state current list
	     * @param {Array} list List of items
	     */
	    $scope.resetSelection = function (list) {
	        $scope.setSelectedItem(list, 0);
	    };
	
	    /**
	     * Remove last title from array and last rendered view from the page
	     */
	    $scope.back = function () {
	        $scope.getInitialView().on('click', stopHandler);
	        $scope.getTitles().pop();
	        $scope.getRenderedViews().pop().remove();
	        $scope.$broadcast('datePickerHide');
	    };
	
	    /**
	     * Reset search items to default state
	     */
	    $scope.reset = function (manual) {
	        $scope.inputs.raceTitle = '';
	        $scope.initDate();
	        if (manual) {
	            $scope.$broadcast('datePickerReset', {
	                to: $scope.inputs.dateTo,
	                from: $scope.inputs.dateFrom
	            });
	        } else {
	            $scope.$broadcast('datePickerDestroy');
	        }
	        $scope.setDefaultDateLabels();
	        $scope.resetSelection($scope.getCountryList());
	    };
	
	    /**
	     * Render view on the page
	     * @param {string} templateUrl Link for appropriate template
	     * @param {object} parent Object where should be rendered new view
	     * @param {boolean} initial Flag for initial render
	     */
	    $scope.renderView = function (templateUrl, parent, initial) {
	        var view = null;
	
	        $http.get(templateUrl).success(function (data) {
	            view = $compile(data)($scope);
	            parent.append(view);
	
	            if (initial) {
	                $scope.setInitialView(view);
	                $scope.setSearchBody($scope.getInitialView().find($scope.searchBodySelector));
	                $scope.setPosition();
	                $scope.$broadcast('datePickerInit', {
	                    to: $scope.inputs.dateTo,
	                    from: $scope.inputs.dateFrom,
	                    container: $scope.getSearchBody()
	                });
	                $scope.getInitialView().on('click', stopHandler);
	            } else {
	                $scope.getRenderedViews().push(view);
	            }
	        }).finally(function () {
	            $scope.rendering = false;
	        });
	    };
	
	    /**
	     * Init default states for dateRange inputs
	     */
	    $scope.initDate = function () {
	        $scope.inputs.dateFrom = moment().subtract(7, 'days').format('YYYY-MM-DD');
	        $scope.inputs.dateTo = moment().format('YYYY-MM-DD');
	    };
	
	    $scope.$on('datePickerShow', function (event, data) {
	        var title = 'Choose Date (' + data + ')';
	        var view = angular.element();
	
	        $scope.getRenderedViews().push(view);
	        $scope.getTitles().push(title);
	        $scope.$apply();
	    });
	
	    $scope.$on('datePickerHidden', function () {
	        if ($scope.getNumberOfViews()) {
	            $scope.back();
	            $scope.$apply();
	        }
	    });
	
	    $scope.$on('datePickerChange', function (event, data) {
	        var date = data.date.format('YYYY-MM-DD');
	        var label = data.date.format('DD MMM YYYY');
	        if (data.type === 'from') {
	            $scope.inputs.dateFrom = date;
	            $scope.setDateFromLabel(label);
	        } else {
	            $scope.inputs.dateTo = date;
	            $scope.setDateToLabel(label);
	        }
	
	        $scope.$broadcast('datePickerChanged', data);
	    });
	
	    /**
	     * Render view for select button, form and save its title in a list of titles
	     * @param {string} type
	     */
	    $scope.openSelect = function (type) {
	        if ($scope.rendering) return;
	        $scope.rendering = true;
	        var title = 'Choose ' + type;
	        var list = type === 'Country' ? $scope.getCountryList() : $scope.getCourseList();
	        $scope.getTitles().push(title);
	        $scope.setItemsList(list);
	        $scope.renderView($scope.getListTemplateUrl(), $scope.getSearchBody(), false);
	    };
	
	    /**
	     * Prevent page scrolling
	     */
	    $scope.preventScroll = function () {
	        $scope.$html.css({ overflowY: 'hidden' });
	        $scope.$body.css({ position: 'fixed', width: '100%' });
	    };
	
	    /**
	     * Activate page scrolling
	     */
	    $scope.activateScroll = function () {
	        $scope.$html.css({ overflowY: $scope.getInitialScroll() });
	        $scope.$body.css({ position: '', width: '' });
	    };
	
	    /**
	     * Save initial state of page scroll, remove scrolling from page,
	     * push initial title to the list,
	     * render initial view append the body of a page
	     */
	    $scope.openSearch = function (event) {
	        event.preventDefault();
	        if ($scope.rendering || $scope.getInitialView()) return;
	        $scope.rendering = true;
	        $scope.initDate();
	        $scope.setDefaultDateLabels();
	        $scope.setInitialScroll($scope.$html.css('overflow-y'));
	        $scope.getTitles().push($scope.getInitialTitle());
	        $scope.renderView($scope.getMainTemplateUrl(), $scope.$body, true);
	        $scope.$body.on('click', $scope.closeSearch);
	    };
	
	    /**
	     * Set initial scroll for the page, remove all rendered views from the page
	     */
	    $scope.closeSearch = function (event, force) {
	        if ($scope.getInitialView() && !$scope.getInitialView()[0].contains(event.target) || force) {
	            $scope.reset();
	            $scope.resetRenderedViews();
	            $scope.getInitialView().off('click', stopHandler);
	            $scope.getInitialView().remove();
	            $scope.setInitialView(null);
	            $scope.activateScroll();
	            $scope.$body.off('click', $scope.closeSearch);
	        }
	    };
	
	    /**
	     * Check breakpoint and change a position of advanced search
	     */
	    $scope.setPosition = function () {
	        if ($scope.getInitialView()) {
	            var currentSize = CommonFunctions.getScreenSize();
	            if (currentSize === 'extraNarrow' || currentSize === 'narrow') {
	                $scope.getInitialView().css({ top: 0, left: 'auto' });
	                $scope.preventScroll();
	            } else {
	                var view = $scope.getInitialView();
	                var searchBox = view[0].getBoundingClientRect();
	                var position = CommonFunctions.getOffsetRect($element[0], searchBox, currentSize);
	                $scope.activateScroll();
	                if (position.left > searchBox.width / 2) {
	                    view.removeClass('align_left');
	                } else {
	                    view.addClass('align_left');
	                }
	
	                view.css({
	                    top: position.top,
	                    left: position.left
	                });
	            }
	        }
	    };
	
	    /**
	     * Perform AJAX request and set data into variable
	     */
	    $scope.getApiData = function () {
	        var url = config.get('resultsPath') + '/data/courses.json';
	
	        $http.get(url).success(function (data) {
	            $scope.setCountryList(data);
	        });
	    };
	
	    /**
	     * Perform AJAX request and set data into variable
	     */
	    $scope.requestSearchResults = function () {
	        /* eslint-disable */
	        var optionalParams = window.btoa(encodeURI($scope.inputs.raceTitle + '/' + $scope.inputs.countryCode + '/' + $scope.inputs.courseId));
	        var url = config.get('resultsPath') + '/data/search/' + optionalParams + '/' + $scope.inputs.dateFrom + '/' + $scope.inputs.dateTo + '.json';
	        /* eslint-enable */
	        $http.get(url).success(function (data) {
	            $scope.showSearchResults(data);
	        }).error(function () {
	            $scope.showPostRequestMessage($scope.getNoMatchesMessage());
	        });
	    };
	
	    $scope.showSearchResults = function (data) {
	        if (!data.results.length) {
	            $scope.showPostRequestMessage($scope.getNoMatchesMessage());
	        } else if (data.overLimit) {
	            $scope.showPostRequestMessage($scope.getLimitedMatchesMessage());
	        } else {
	            $scope.getTitles().push($scope.createResultTitle(data.results.length));
	            $scope.setSearchResults(data.results);
	            $scope.getInitialView().off('click', stopHandler);
	        }
	    };
	
	    $scope.showPostRequestMessage = function (message) {
	        $scope.setErrorMessage(message);
	        $scope.setShowErrorMessageTitle(false);
	        $scope.setShowResults(true);
	    };
	
	    $scope.createResultTitle = function (matches) {
	        return matches + (matches === 1 ? ' Match' : ' Matches');
	    };
	
	    /**
	     * Calculate range of selected dates
	     * @returns {number}
	     */
	    $scope.calculateDateRange = function () {
	        return (new Date($scope.inputs.dateTo) - new Date($scope.inputs.dateFrom)) / $scope.MS_IN_DAY;
	    };
	    /**
	     * Start search, check for restriction and render appropriate view
	     */
	    $scope.triggerSearch = function () {
	        var viewUrl = void 0;
	        $scope.rendering = true;
	        $scope.getTitles().push($scope.getInitialTitle());
	        $scope.setShowResults(false);
	
	        if ($scope.checkForRestrictions()) {
	            viewUrl = $scope.getResultsTemplateUrl();
	            $scope.setSearchResults([]);
	            $scope.requestSearchResults();
	        } else {
	            viewUrl = $scope.getErrorMessageTemplateUrl();
	            $scope.setErrorMessage($scope.getRestrictionMessage());
	            $scope.setShowErrorMessageTitle(true);
	        }
	
	        $scope.renderView(viewUrl, $scope.getSearchBody(), false);
	    };
	
	    /**
	     * Render error message in case selected parameters for search isn't pass restrictions
	     * @returns {boolean}
	     */
	    $scope.checkForRestrictions = function () {
	        if ($scope.calculateDateRange() > $scope.EXCEEDING_DATE_WEEK && (!$scope.inputs.raceTitle || $scope.inputs.raceTitle.length < 3)) {
	            // TODO: Change to appropriate value, when Tesla provide an example of required params
	            if ($scope.getSelectedItemName('Course') !== 'Course (any)') {
	                if ($scope.calculateDateRange() > $scope.EXCEEDING_DATE_YEAR) {
	                    $scope.setRestrictionMessage($scope.EXCEEDING_DATE_YEAR);
	                } else {
	                    return true;
	                }
	            } else {
	                $scope.setRestrictionMessage($scope.EXCEEDING_DATE_WEEK);
	            }
	        } else {
	            return true;
	        }
	
	        return false;
	    };
	
	    /**
	     * Add click handler for element.
	     */
	    $scope.init = function () {
	        $scope.getApiData();
	        $element.on('click', $scope.openSearch);
	        $(window).on('resize', $scope.setPosition);
	    };
	
	    $scope.init();
	}];

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$rootScope", "$scope", "$element", "$compile", function ($rootScope, $scope, $element, $compile) {
	  'ngInject';
	
	  /**
	   * Variables for directive
	   *
	   * @type {null|object} Model for directive
	   * @type {string} Race id
	   * @type {string} Name of event which directive should listen
	   */
	
	  $scope.fastResultsAvailable = false;
	  $scope.raceId = $element.data('raceId');
	  $scope.event = 'setFastResults[' + $scope.raceId + ']';
	  var view = $element.contents();
	
	  /**
	   * Set copy properties from param object to $scope.raceInfo
	   * @param {object} data Data from get request
	   */
	  $scope.setFastInfo = function (data) {
	    $scope.fastInfo = [];
	    $scope.fastResultsAvailable = true;
	    if (data) {
	      $scope.fastInfo = data;
	      $element.append($compile(view)($scope));
	      $scope.$digest();
	    }
	  };
	
	  /**
	   * Listen for appropriate event and call $scope.setFastInfo
	   */
	  $rootScope.$on($scope.event, function (event, data) {
	    $scope.setFastInfo(data);
	  });
	}];

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * @name results.controller:advancedSearch
	 * @description
	 * Controller for advancedSearch directive. On click open compile
	 * initial view of advanced search. Keep inside couple of
	 * methods for 'reset', 'select', 'back' and 'done' buttons
	 */
	exports.default = ["$scope", "$element", function ($scope, $element) {
	    'ngInject';
	
	    $scope.type = $element.data('type');
	    $scope.typeCapitalysed = $scope.type.replace($scope.type.charAt(0), $scope.type.charAt(0).toUpperCase());
	    $scope.datePickerCalendarClass = 'js-datePicker_' + $scope.type;
	    $scope.MIN_DATE = '1988-01-01'; // The date from which the results starts
	
	    $scope.datePickerInitOff = $scope.$on('datePickerInit', function (event, data) {
	        $scope.datePicker = $element.datePicker($scope.getInitialDatePickerObject(data));
	
	        $scope.datePicker.on('show.rp.datePicker', function () {
	            $scope.$emit('datePickerShow', $scope.type);
	        }).on('hidden.rp.datePicker', function () {
	            $scope.$emit('datePickerHidden');
	        }).on('change.rp.datePicker', function (changeEvent, date) {
	            $scope.$emit('datePickerChange', {
	                date: date,
	                type: $scope.type
	            });
	        });
	
	        // Important: Add appropriate data-test-selectors for automation testing, don't miss it.
	        angular.element('.' + $scope.datePickerCalendarClass).attr('data-test-selector', 'block-datePickerAdvSearch' + $scope.typeCapitalysed);
	    });
	
	    $scope.datePickerHideOff = $scope.$on('datePickerHide', function () {
	        if ($('.' + $scope.datePickerCalendarClass).is(':visible')) {
	            $scope.datePicker.datePicker('hide');
	        }
	    });
	
	    $scope.datePickerResetOff = $scope.$on('datePickerReset', function () {
	        $scope.datePicker.datePicker('restoreState');
	    });
	
	    $scope.datePickerChangedOff = $scope.$on('datePickerChanged', function (event, data) {
	        if ($scope.type !== data.type) {
	            var property = data.type === 'from' ? 'minDate' : 'maxDate';
	            $scope.datePicker.datePicker(property, data.date);
	        }
	    });
	
	    $scope.datePickerDestroyOff = $scope.$on('datePickerDestroy', function () {
	        $scope.datePicker.datePicker('destroy');
	        $scope.setDatePicker(null);
	        $scope.datePickerInitOff();
	        $scope.datePickerHideOff();
	        $scope.datePickerResetOff();
	        $scope.datePickerChangedOff();
	        $scope.datePickerDestroyOff();
	    });
	
	    $scope.setDatePicker = function (value) {
	        $scope.datePicker = value;
	    };
	
	    $scope.getInitialDatePickerObject = function (data) {
	        var initialDatePicker = {
	            date: data[$scope.type],
	            maxDate: moment(),
	            minDate: $scope.MIN_DATE,
	            container: data.container,
	            monthPickerAutoClose: false,
	            css: {
	                picker: 'ui-datePicker ' + $scope.datePickerCalendarClass
	            },
	            autoClose: true
	        };
	
	        return initialDatePicker;
	    };
	}];

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$element", "$http", "$rootScope", "$compile", "config", function ($scope, $element, $http, $rootScope, $compile, config) {
	    'ngInject';
	
	    /**
	     * Variables for event listening and broadcasting
	     *
	     * @type {string} Race id
	     * @type {string} Name of event which directive should listen
	     * @type {string} Name of event which directive should broadcast
	     */
	
	    $scope.raceId = $element.data('raceId');
	    $scope.emptySelector = $element.data('emptySelector');
	    $scope.crsId = $element.data('crsId');
	    $scope.getEvent = 'getFastResults[' + $scope.raceId + ']';
	    $scope.getFullEvent = 'getFullResults[' + $scope.raceId + ']';
	    $scope.showMeeting = 'showMeetingContainer[' + $scope.crsId + ']';
	    $scope.fastDiffusionResultEvent = 'setFastResults[' + $scope.raceId + ']';
	    // To avoid displaying a wrong view due to bug with API. Should be deleted when
	    // https://racingpost.atlassian.net/browse/PR-1643 would be fixed.
	    var fastReg = new RegExp(/data-directive-fast-result/);
	
	    /**
	     * Make get AJAX request for full race result. On success render response into view
	     *
	     * @param {string} raceDate Date of the race
	     * @param {number} raceId Race id
	     * @param {string} tab Name of the tab from which will be performed AJAX request
	     */
	    $scope.getFullResult = function (raceDate, raceId, tab) {
	        var additionalParam = tab ? 'time-order' : $scope.crsId;
	        var link = config.get('resultsPath') + '/' + raceDate + '/' + raceId + '/' + additionalParam;
	        $http.get(link).success(function (data) {
	            if (data && !fastReg.test(data)) {
	                $rootScope.$broadcast('hideErrorMessage');
	                $element.after($compile(data)($scope));
	                $element.parent().parent().removeClass($scope.emptySelector);
	                $element.remove();
	                $scope.$destroy();
	            }
	        });
	    };
	
	    /**
	     * Make get AJAX request for fast race result. On success check is full result
	     * for this race available. If true call $scope.getFullResult function, else
	     * broadcast event for applying fast results into view
	     *
	     * @param {number} fastRaceId Race id in fast result response
	     * @param {string} raceDate Date of the race
	     * @param {string} tab Name of the tab from which will be performed AJAX request
	     */
	    $scope.getFastResult = function (fastRaceId, raceDate, tab) {
	        if (fastRaceId) {
	            var url = config.get('resultsPath') + '/data/race/fast/' + fastRaceId + '.json';
	
	            $http.get(url).success(function (data) {
	                if (data.fullRaceId) {
	                    $scope.getFullResult(raceDate, data.fullRaceId, tab);
	                }
	                $scope.setFastResultReceived();
	            });
	        }
	    };
	
	    /**
	     * Shows meeting if it was hidden and removes error message
	     */
	    $scope.setFastResultReceived = function () {
	        $rootScope.$broadcast('hideErrorMessage');
	        $rootScope.$broadcast($scope.showMeeting);
	        $element.removeClass($scope.emptySelector);
	        $element.parent().parent().removeClass($scope.emptySelector);
	    };
	
	    /**
	     * Listen for appropriate event and call $scope.getFastResult
	     */
	    $scope.$on($scope.getEvent, function (event, data) {
	        $scope.getFastResult(data.fastRaceId, data.date, data.tab);
	    });
	
	    /**
	     * Listen for event when fast result receives from diffusion
	     */
	    $rootScope.$on($scope.fastDiffusionResultEvent, function () {
	        $scope.setFastResultReceived();
	    });
	
	    /**
	     * Listen for appropriate event and call $scope.getFullResult
	     */
	    $scope.$on($scope.getFullEvent, function (event, data) {
	        $scope.getFullResult(data.date, data.raceId, data.tab);
	    });
	}];

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	/**
	 * @name results.controller:FastResultTrigger
	 * @description
	 * # FastResultTrigger
	 * Perform get AJAX request for races id pairs.
	 * Check response and broadcast appropriate events
	 * or repeat a request.
	 * If flag for continue requesting ids for fast result is set in true - repeat
	 * AJAX request every minute
	 */
	
	
	exports.default = ["$scope", "$element", "$timeout", "$http", "$rootScope", "config", function ($scope, $element, $timeout, $http, $rootScope, config) {
	    'ngInject';
	
	    /**
	     * Variables for directive
	     *
	     * @type {string} Date of the race
	     * @type {string} Name of the tab from which will be performed AJAX request
	     */
	
	    $scope.date = $element.data('date');
	    $scope.tab = $element.data('tab');
	    $scope.parseResultsMessage = function (records) {
	        return records.map(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                record = _ref2[0];
	
	            return record;
	        }).filter(function (record) {
	            return record.includes('<h1>');
	        }).map(function (record) {
	            var parsed = record.split(/<\/?b>/).map(function (i) {
	                return i.trim();
	            });
	            return {
	                outcome_code: parsed[1],
	                saddle_cloth: parsed[2].replace('(', '').replace(')', ''),
	                horse_name: parsed[3],
	                price: parsed[4].replace('<h1>', '')
	            };
	        });
	    };
	
	    var getDiffusionAttributes = function getDiffusionAttributes(meetingElement) {
	        var $meetingElement = (0, _jquery2.default)(meetingElement).parent().parent();
	        var racedateAttr = 'data-diffusion-racedate';
	        return {
	            raceDate: $meetingElement.closest('[' + racedateAttr + ']').data('diffusionRacedate'),
	            raceTime: $meetingElement.data('diffusionRacetime'),
	            courseName: $meetingElement.data('diffusionCoursename'),
	            raceId: $meetingElement.data('diffusionRaceId'),
	            crsId: $meetingElement.data('crsId')
	        };
	    };
	
	    $scope.onDataReceive = function (WebClientMessage) {
	        var records = WebClientMessage.getRecords();
	        var topic = WebClientMessage.getTopic();
	
	        var _topic$split = topic.split('/'),
	            _topic$split2 = _slicedToArray(_topic$split, 4),
	            raceDate = _topic$split2[1],
	            courseName = _topic$split2[2],
	            raceTime = _topic$split2[3];
	
	        var isFullResult = records.some(function (record) {
	            return (/<b>\d+ ran<\/b>/.test(record[0])
	            );
	        });
	        if (isFullResult) {
	            $scope.session.unsubscribe(topic);
	        }
	        var fastResult = $scope.parseResultsMessage(records);
	        var meetingResult = $element.find('[data-directive-apply-fast-result]').toArray().map(getDiffusionAttributes).find(function (meeting) {
	            return meeting.raceDate === raceDate && meeting.raceTime === raceTime && meeting.courseName === courseName;
	        });
	        if (meetingResult) {
	            $rootScope.$broadcast('setFastResults[' + meetingResult.raceId + ']', fastResult);
	        }
	    };
	    $scope.session = new _rpDiffusionConnector2.default({
	        onDataFunction: $scope.onDataReceive
	    });
	    var topics = $element.find('[data-directive-apply-fast-result]').parent().parent().toArray().map(function (raceElement) {
	        return ['HORSES', $scope.date, raceElement.dataset.diffusionCoursename, raceElement.dataset.diffusionRacetime, 'RESULTSTEXT'].join('/');
	    });
	    $scope.session.subscribe({ topics: topics });
	    var hash = $element.data('blabla');
	
	    /**
	     * Form list of events with appropriate data and broadcast them
	     *
	     * @param {array} data Array of objects with race's ids pair (fastRaceId/raceId)
	     */
	    $scope.broadcastEvents = function (data) {
	        var event = void 0;
	        var raceData = {};
	        for (var i = 0, len = data.length; i < len; i++) {
	            event = 'get' + (data[i].fullResultAvailable ? 'Full' : 'Fast') + 'Results[' + data[i].raceId + ']';
	
	            raceData = {
	                fastRaceId: data[i].fastRaceId,
	                raceId: data[i].raceId,
	                date: $scope.date,
	                tab: $scope.tab
	            };
	
	            $rootScope.$broadcast(event, raceData);
	        }
	    };
	
	    /**
	     * Set timeout with specific callback and time from param
	     * @param {number} time Timeout value
	     */
	    $scope.setTimeout = function (time) {
	        $timeout($scope.getData, time);
	    };
	
	    /**
	     * Make AJAX get request to check for races which have fast race id.
	     * On success check if response is object and call
	     * $scope.broadcastEvents, if not will repeat AJAX request, also response
	     * has flag to know should we continue to
	     * perform AJAX requests.
	     */
	    $scope.getData = function () {
	        var url = config.get('resultsPath') + '/data/' + $scope.date + '/' + hash + '.json';
	
	        $http.get(url).success(function (data) {
	            if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	                if (data.data) {
	                    $scope.broadcastEvents(data.data);
	                }
	            } else {
	                if (data.continue) {
	                    $scope.getData();
	                }
	            }
	
	            if (data.continue) {
	                $scope.setTimeout(30000);
	            }
	        }).error(function () {
	            $scope.setTimeout(30000);
	        });
	    };
	
	    $scope.getData();
	}];
	
	var _rpDiffusionConnector = __webpack_require__(1480);
	
	var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);
	
	var _jquery = __webpack_require__(23);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$scope", "$element", function ($scope, $element) {
	  'ngInject';
	
	  /**
	   * Name of event which directive should listen
	   * @type {string}
	   */
	
	  $scope.event = 'showMeetingContainer[' + $scope.courseId + ']';
	
	  /*
	   * Init listener for appropriate event
	   */
	  $scope.init = function () {
	    $scope.$on($scope.event, function () {
	      $element.removeClass($scope.emptySelector);
	    });
	  };
	
	  $scope.init();
	}];

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$element", function ($scope, $element) {
	    'ngInject';
	
	    var _this = this;
	
	    var headerOffset = 0;
	    var header = void 0;
	    var searchBody = void 0;
	    var searchContainer = void 0;
	    var offsetTop = void 0;
	
	    this.mobileDetect = _rpGuiGuide.mobileDetect;
	
	    var hideHeader = function hideHeader() {
	        headerOffset = header.height();
	        header.hide();
	    };
	
	    var moveBodyToTop = function moveBodyToTop() {
	        searchBody.offset({ top: -offsetTop }).css('padding-bottom', offsetTop * 2 + headerOffset);
	    };
	
	    var restoreBodyOffset = function restoreBodyOffset() {
	        searchBody.offset({ top: headerOffset }).css('padding-bottom', 0);
	    };
	
	    var getSearchBodyClientOffset = function getSearchBodyClientOffset() {
	        return parseInt($('.js-advancedSearch__form').css('margin-top'), 10);
	    };
	
	    var restoreView = function restoreView(e) {
	        if (e.target !== $element[0]) {
	            header.show();
	            restoreBodyOffset();
	            searchContainer.off('click', restoreView);
	            _this.init();
	        }
	    };
	
	    this.focusElementHandler = function () {
	        searchContainer = $('.js-advancedSearch');
	        searchBody = $('#searchBody');
	        header = $('.js-advancedSearch__header');
	        hideHeader();
	        offsetTop = getSearchBodyClientOffset();
	        moveBodyToTop();
	        searchContainer.on('click', restoreView);
	    };
	
	    this.init = function () {
	        if (_this.mobileDetect.os() === 'AndroidOS') {
	            $element.one('focus', _this.focusElementHandler);
	        }
	    };
	
	    this.init();
	}];
	
	var _rpGuiGuide = __webpack_require__(134);

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$scope", "CommonFunctions", "userPreference", function ($scope, CommonFunctions, userPreference) {
	  'ngInject';
	
	  /**
	   * Initial state of variables for RaceCourse directive
	   * @type {object/null} isErrorMessageShown Flag for error message
	   */
	
	  var isErrorMessageShown = true;
	  /**
	   * Gets pedigree user preference
	   */
	  $scope.getIsPedigreeSelected = function () {
	    return userPreference.get(userPreference.TYPE_PEDIGREE);
	  };
	
	  /**
	   * Toggles pedigree state
	   */
	  $scope.togglePedigree = function () {
	    userPreference.toggle(userPreference.TYPE_PEDIGREE);
	    userPreference.initHideTodaysOffersPanel();
	  };
	
	  /**
	   * Primary menu results item getter
	   * @returns {object} Results item from primary navigation
	   */
	  $scope.getPrimaryNavigationItemResults = function () {
	    return _rpNavigation.primary.getItemByTitle('Results');
	  };
	  /**
	   * Navigation items getter
	   * @returns {Array} Array of secondary navigation items
	   */
	  $scope.getSecondaryNavigationItems = function () {
	    return _rpNavigation.secondary.getItemsBySelector('.rn-secondaryNav__list__link').slice(0, -2);
	  };
	  /**
	   * Click handler for ListSortCourse button
	   */
	  $scope.onClickListSortCourse = function () {
	    $scope.getPrimaryNavigationItemResults().clearItemState();
	    $scope.getSecondaryNavigationItems().forEach(function (element) {
	      element.clearItemState();
	    });
	  };
	
	  /**
	   * Click handler for ListSortItem button
	   */
	  $scope.onClickListSortTime = function () {
	    $scope.getPrimaryNavigationItemResults().setItemState({
	      path: 'time-order'
	    });
	  };
	
	  $scope.getIsErrorMessageShown = function () {
	    return isErrorMessageShown;
	  };
	
	  /*
	   * Set isErrorMessageShown to false
	   */
	  $scope.hideErrorMessage = function () {
	    isErrorMessageShown = false;
	  };
	
	  $scope.$on('hideErrorMessage', function () {
	    $scope.hideErrorMessage();
	  });
	}];
	
	var _rpNavigation = __webpack_require__(153);

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$element", "$window", "userPreference", "config", function ($scope, $element, $window, userPreference, config) {
	    'ngInject';
	
	    $scope.MIN_DATE = '1988-01-01'; // The date from which the results starts
	    $scope.TIME = '/time-order';
	    $scope.datePickerClass = 'rp-datePicker';
	    $scope.markedLinkClass = 'ui-link_marked';
	
	    $scope.initialDate = $element.data('date');
	
	    $scope.getInitialDatePickerObject = function () {
	        var now = moment();
	
	        var initialDatePicker = {
	            date: $scope.initialDate || now,
	            maxDate: now,
	            minDate: $scope.MIN_DATE,
	            monthPickerAutoClose: false,
	            position: {
	                my: 'top+16'
	            },
	            css: {
	                picker: 'ui-datePicker ' + $scope.datePickerClass
	            },
	            autoClose: true
	        };
	
	        return initialDatePicker;
	    };
	
	    $scope.init = function () {
	        $scope.datePicker = $element.datePicker($scope.getInitialDatePickerObject());
	
	        $scope.datePicker.on('change.rp.datePicker', function (event, date) {
	            var activeDate = _rpNavigation.primary.getItemByTitle('Results');
	            var prevState = activeDate.stateManager.prevState;
	            var url = config.get('resultsPath') + '/' + date.format('YYYY-MM-DD');
	
	            if (prevState && prevState.path) {
	                url += '/' + prevState.path;
	            }
	
	            $window.location.pathname = url;
	        }).on('show.rp.datePicker', function () {
	            $element.addClass($scope.markedLinkClass);
	            jQuery('.rn-secondaryNav').removeClass('rn-secondaryNav_active');
	            jQuery('.ui-overlay').remove();
	        }).on('hide.rp.datePicker', function () {
	            $element.removeClass($scope.markedLinkClass);
	        });
	
	        // Important: Add appropriate data-test-selectors for automation testing, don't miss it.
	        angular.element('.' + $scope.datePickerClass).attr('data-test-selector', 'block-datePickerStandAlone');
	    };
	
	    $scope.init();
	}];
	
	var _rpNavigation = __webpack_require__(153);

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "CommonFunctions", "$http", "config", "$timeout", function ($scope, CommonFunctions, $http, config, $timeout) {
	    'ngInject';
	
	    var baseImageUrl = 'https://www.rp-assets.com/furniture/bloodstock/';
	    var imageExtension = '.gif';
	    var breakpointMap = {
	        extraNarrow: 1,
	        narrow: 2,
	        medium: 4,
	        wide: 8,
	        extraWide: 16
	    };
	    var link = null;
	    var successBoxesList = [];
	
	    /**
	     * Set link for success boxes data
	     * @param {number} breakpointId Id for current breakpoint
	     */
	    $scope.setLink = function (breakpointId) {
	        /* eslint-disable */
	        link = config.get('resultsPath') + '/data/success-boxes/' + $scope.raceId + '/' + breakpointId + '.json';
	        /* eslint-enable  */
	    };
	
	    /**
	     * Getter for link
	     * @returns {string}
	     */
	    $scope.getLink = function () {
	        return link;
	    };
	
	    /**
	     * Get appropriate property form object
	     * @param {string} breakpoint Name of breakpoint
	     * @returns {number} Breakpoint code
	     */
	    $scope.getCurrentBreakpoint = function (breakpoint) {
	        return breakpointMap[breakpoint];
	    };
	
	    /**
	     * Getter for baseImageUrl
	     * @returns {string}
	     */
	    $scope.getImageUrl = function () {
	        return baseImageUrl;
	    };
	
	    /**
	     * Getter for imageExtension
	     * @returns {string}
	     */
	    $scope.getImageExtension = function () {
	        return imageExtension;
	    };
	
	    /**
	     * Set array of success boxes
	     * @param {Array} array List of objects with success box info
	     */
	    $scope.setSuccessBoxesList = function (array) {
	        successBoxesList = array.map($scope.setSuccessBoxesItem);
	    };
	
	    /**
	     * Getter for successBoxesList
	     * @returns {Array}
	     */
	    $scope.getSuccessBoxesList = function () {
	        return successBoxesList;
	    };
	
	    /**
	     * Check if url is email or web address and replace the href attribute value
	     * with the appropriate one.
	     *
	     * @param {Array} data
	     * @returns
	     */
	    $scope.formatUrl = function (data) {
	        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	        var urlRegex = /^(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\/.*)?$/;
	        var urlPrefixRegex = /^https?:\/\//;
	
	        // Note:
	        // This is a mocked data for testing purposes,
	        // because the issue with url missing https:// prefix is not reproducible on local environment.
	        // the issue is JP-9327
	
	        // const mockedData = [
	        //     {
	        //         name: 'was8499',
	        //         url: 'http://www.voutesales.com'
	        //     },
	        //     {
	        //         name: 'was8966',
	        //         url: 'www.worsallgrange.com'
	        //     },
	        //     {
	        //         name: 'was8421',
	        //         url: 'liz.whitaker1@btconnect.com'
	        //     }
	        // ];
	
	        return data.map(function (item) {
	            if (emailRegex.test(item.url)) {
	                item.url = 'mailto:' + item.url;
	            }
	
	            if (urlRegex.test(item.url)) {
	                item.url = urlPrefixRegex.test(item.url) ? '' + item.url : 'https://' + item.url;
	            }
	
	            return item;
	        });
	    };
	
	    /**
	     * Helper function for map Array.map method. Form object with appropriate properties
	     * @param {object} element Element from array
	     * @returns {{image: string, url: string}}
	     */
	    $scope.setSuccessBoxesItem = function (element) {
	        var successBoxesItem = {
	            image: $scope.getImageUrl() + element.name + $scope.getImageExtension(),
	            url: element.url
	        };
	        return successBoxesItem;
	    };
	
	    /**
	     * Set link with appropriate breakpoint code and perform AJAX get request.
	     * On success call setSuccessBoxesList.
	     * @param {string} breakpoint Name of current breakpoint
	     */
	    $scope.getSuccessBoxes = function (breakpoint) {
	        $scope.setLink($scope.getCurrentBreakpoint(breakpoint));
	
	        var box = angular.element(document.getElementsByClassName('rp-successBoxes'));
	
	        if (breakpoint === 'narrow' || breakpoint === 'extraNarrow') {
	            $timeout(function () {
	                box[0].style.display = 'none';
	                box[1].style.display = '';
	                box[1].style.margin = '0 auto 16px';
	            }, 0);
	        } else {
	            $timeout(function () {
	                box[0].style.display = '';
	                box[1].style.display = 'none';
	            }, 0);
	        }
	
	        $http.get($scope.getLink()).success(function (data) {
	            if (Array.isArray(data)) {
	                $scope.setSuccessBoxesList($scope.formatUrl(data));
	            }
	        });
	    };
	
	    /**
	     * Get success boxes and register listener for "breakpointChanged" event
	     */
	    $scope.init = function () {
	        $scope.getSuccessBoxes(CommonFunctions.getScreenSize());
	
	        $scope.$on('breakpointChanged', function (event, data) {
	            $scope.getSuccessBoxes(data);
	        });
	    };
	}];

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	'use strict';
	
	directiveTableToolbarCtrl.$inject = ["$scope", "userPreference"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = directiveTableToolbarCtrl;
	/**
	 * @name results.controller:directiveTableToolbar
	 * @description
	 * # directiveTableToolbarCtrl
	 * Controller for table toolbar directive
	 */
	function directiveTableToolbarCtrl($scope, userPreference) {
	  'ngInject';
	
	  var pedigree = userPreference.TYPE_PEDIGREE;
	  var comments = userPreference.TYPE_COMMENTS;
	
	  if (!userPreference.isPreferenceSet(comments)) {
	    userPreference.set(comments, true);
	  }
	
	  /**
	   * Returns pedigrees state
	   * @return {Boolean}
	   */
	  $scope.getPedigreesState = function () {
	    return userPreference.get(pedigree);
	  };
	
	  /**
	   * Toggles pedigrees
	   */
	  $scope.togglePedigrees = function () {
	    userPreference.toggle(pedigree);
	  };
	
	  /**
	   * Returns comments state
	   * @return {Boolean}
	   */
	  $scope.getCommentsState = function () {
	    return userPreference.get(comments);
	  };
	
	  /**
	   * Toggles comments
	   */
	  $scope.toggleComments = function () {
	    userPreference.toggle(comments);
	  };
	}

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$scope", "$element", function ($scope, $element) {
	  'ngInject';
	
	  /**
	   * Configuration for jquery.marquee plugin
	   * @type object
	   */
	
	  $scope.config = {
	    delayBeforeStart: 0,
	    duplicated: true,
	    gap: 100
	  };
	
	  /**
	   * Is ticker is playing or stopped
	   * @type boolean
	   */
	  $scope.isTickerPlaying = true;
	
	  /**
	   * Content of ticker
	   * @type object
	   */
	  $scope.$content = $element.find('#marquee');
	
	  /**
	   * Getter for $scope.isTickerPlaying
	   */
	  $scope.getIsTickerPlaying = function () {
	    return $scope.isTickerPlaying;
	  };
	
	  /**
	   * Setter for $scope.isTickerPlaying
	   */
	  $scope.setIsTickerPlaying = function (value) {
	    $scope.isTickerPlaying = value;
	  };
	
	  /**
	   * Initializes ticker
	   */
	  $scope.init = function () {
	    $scope.$content.html($scope.directiveTickerText);
	    $scope.$content.marquee($scope.config);
	    $scope.$content.marquee('play');
	    // Force initial position from start of the block
	    $scope.$content.find('.js-marquee-wrapper').css({
	      'margin-left': 0
	    }).attr('data-test-selector', 'block-tickerText');
	  };
	
	  /**
	   * Switching between playing and paused state of ticker
	   */
	  $scope.toggleTicker = function () {
	    $scope.$content.marquee('toggle');
	
	    $scope.setIsTickerPlaying(!$scope.getIsTickerPlaying());
	  };
	
	  $scope.init();
	}];

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$scope", "userPreference", function ($scope, userPreference) {
	  'ngInject';
	
	  $scope.generalInfo = {
	    length: null,
	    note: {
	      isExists: null,
	      value: null
	    }
	  };
	
	  angular.extend($scope, window.horseData);
	  delete window.horseData;
	
	  /**
	   * Returns pedigrees state
	   * @return {Boolean}
	   */
	  $scope.getPedigreesState = function () {
	    return userPreference.get(userPreference.TYPE_PEDIGREE);
	  };
	
	  /**
	   * Returns comments state
	   * @return {Boolean}
	   */
	  $scope.getCommentsState = function () {
	    return userPreference.get(userPreference.TYPE_COMMENTS);
	  };
	}];

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _accordion = __webpack_require__(1650);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _directiveAdvancedSearch = __webpack_require__(1651);
	
	var _directiveAdvancedSearch2 = _interopRequireDefault(_directiveAdvancedSearch);
	
	var _directiveApplyFastResult = __webpack_require__(1652);
	
	var _directiveApplyFastResult2 = _interopRequireDefault(_directiveApplyFastResult);
	
	var _directiveDatePickerWrapper = __webpack_require__(1653);
	
	var _directiveDatePickerWrapper2 = _interopRequireDefault(_directiveDatePickerWrapper);
	
	var _directiveFastResult = __webpack_require__(1654);
	
	var _directiveFastResult2 = _interopRequireDefault(_directiveFastResult);
	
	var _directiveFastResultTrigger = __webpack_require__(1655);
	
	var _directiveFastResultTrigger2 = _interopRequireDefault(_directiveFastResultTrigger);
	
	var _directiveMeetingStaff = __webpack_require__(1656);
	
	var _directiveMeetingStaff2 = _interopRequireDefault(_directiveMeetingStaff);
	
	var _directiveRaceCourse = __webpack_require__(1658);
	
	var _directiveRaceCourse2 = _interopRequireDefault(_directiveRaceCourse);
	
	var _directiveSelectDate = __webpack_require__(1659);
	
	var _directiveSelectDate2 = _interopRequireDefault(_directiveSelectDate);
	
	var _directiveSuccessBoxes = __webpack_require__(1660);
	
	var _directiveSuccessBoxes2 = _interopRequireDefault(_directiveSuccessBoxes);
	
	var _directiveTicker = __webpack_require__(1662);
	
	var _directiveTicker2 = _interopRequireDefault(_directiveTicker);
	
	var _directiveMoveTopOnFocus = __webpack_require__(1657);
	
	var _directiveMoveTopOnFocus2 = _interopRequireDefault(_directiveMoveTopOnFocus);
	
	var _directiveTableToolbarCtrl = __webpack_require__(1661);
	
	var _directiveTableToolbarCtrl2 = _interopRequireDefault(_directiveTableToolbarCtrl);
	
	var _horseTable = __webpack_require__(1663);
	
	var _horseTable2 = _interopRequireDefault(_horseTable);
	
	var _myRating = __webpack_require__(1667);
	
	var _myRating2 = _interopRequireDefault(_myRating);
	
	var _linkTrigger = __webpack_require__(1665);
	
	var _linkTrigger2 = _interopRequireDefault(_linkTrigger);
	
	var _main = __webpack_require__(1666);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _raceReplayCtrl = __webpack_require__(1669);
	
	var _raceReplayCtrl2 = _interopRequireDefault(_raceReplayCtrl);
	
	var _videoControlsCtrl = __webpack_require__(1670);
	
	var _videoControlsCtrl2 = _interopRequireDefault(_videoControlsCtrl);
	
	var _navBarCtrl = __webpack_require__(1668);
	
	var _navBarCtrl2 = _interopRequireDefault(_navBarCtrl);
	
	var _rpAuth = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _rpAuth.createBarriers)();
	
	var controllers = angular.module('results.controllers', []).controller('MainCtrl', _main2.default).controller('directiveAccordionCtrl', _accordion2.default).controller('directiveAdvancedSearchCtrl', _directiveAdvancedSearch2.default).controller('directiveApplyFastResultCtrl', _directiveApplyFastResult2.default).controller('directiveDatePickerWrapperCtrl', _directiveDatePickerWrapper2.default).controller('directiveFastResultCtrl', _directiveFastResult2.default).controller('directiveFastResultTriggerCtrl', _directiveFastResultTrigger2.default).controller('directiveMeetingStaffCtrl', _directiveMeetingStaff2.default).controller('DirectiveRaceCourseCtrl', _directiveRaceCourse2.default).controller('directiveSelectDateCtrl', _directiveSelectDate2.default).controller('directiveSuccessBoxesCtrl', _directiveSuccessBoxes2.default).controller('directiveTickerCtrl', _directiveTicker2.default).controller('directiveMoveTopOnFocusCtrl', _directiveMoveTopOnFocus2.default).controller('directiveTableToolbarCtrl', _directiveTableToolbarCtrl2.default).controller('horseTableCtrl', _horseTable2.default).controller('LinkTriggerCtrl', _linkTrigger2.default).controller('myRatingCtrl', _myRating2.default).controller('raceReplayCtrl', _raceReplayCtrl2.default).controller('videoControlsCtrl', _videoControlsCtrl2.default).controller('navBarCtrl', _navBarCtrl2.default);
	
	exports.default = controllers;

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$element", "CommonFunctions", function ($scope, $element, CommonFunctions) {
	    'ngInject';
	
	    /**
	     * Initial target for element
	     * @type {string}
	     */
	
	    $scope.currentScreenSize = null;
	
	    /**
	     * Adding or removing .js-popuplink when screen size is changing
	     * return 'extraNarrow' or 'narrow'
	     */
	    $scope.togglePopupClass = function () {
	        $scope.currentScreenSize = CommonFunctions.getScreenSize();
	        if ($scope.currentScreenSize === 'extraNarrow' || $scope.currentScreenSize === 'narrow') {
	            $element.addClass('js-popupLink');
	        } else {
	            $element.removeClass('js-popupLink');
	        }
	    };
	
	    /**
	     * Add click handler for element
	     */
	    $scope.init = function () {
	        $element.on('click', $scope.togglePopupClass);
	    };
	
	    $scope.init();
	}];

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @name results.controller:MainCtrl
	 * @description
	 * # MainCtrl
	 * Controller of the app
	 */
	exports.default = function () {
	  'ngInject';
	};

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$scope", "$element", "$http", "$compile", "config", "CommonFunctions", "ugc", function ($scope, $element, $http, $compile, config, CommonFunctions, ugc) {
	    'ngInject';
	
	    $scope.init = function () {
	        angular.extend($scope, window.horseData);
	        delete window.horseData;
	
	        $scope.getUgcData();
	        $scope.showBubbleOnlyFirstTime();
	    };
	
	    /**
	     * Error comment container status flag
	     * @type {boolean}
	     */
	    $scope.isErrorCommentShown = false;
	
	    /**
	     * Error lightBox container status flag
	     * @type {boolean}
	     */
	    $scope.isErrorLightBoxShown = false;
	
	    /**
	     * Save button disabled flag
	     * @type {boolean}
	     */
	    $scope.isSaveBtnDisabled = true;
	
	    /**
	     * Save button label flag
	     * @type {boolean}
	     */
	    $scope.isSaveLabelShown = true;
	
	    /**
	     * Tooltip info for calculate option
	     * @type {object}
	     */
	    $scope.tooltip = {
	        title: 'Will save this rating to the horse profile page',
	        shouldShow: true,
	        shown: {}
	    };
	
	    /**
	     * Retrieves ugc data via ajax
	     */
	    $scope.getUgcData = function () {
	        ugc.rpNavigationAuthReady().then(function (auth) {
	            if (!auth.user.isLoggedIn) {
	                $scope.showErrorComment();
	                return;
	            }
	
	            ugc.checkNotes().then(function (response) {
	                var _ref = response.data.hasNotes || {},
	                    hasCustomerNotes = _ref.customer_results_notes,
	                    hasRaceNotes = _ref.customer_race_results_notes;
	
	                if (!hasRaceNotes) {
	                    $scope.generalInfo = Object.assign({}, $scope.generalInfo, {
	                        note: {
	                            value: '',
	                            isExists: false
	                        }
	                    });
	                }
	
	                if (!hasCustomerNotes && !hasRaceNotes) {
	                    return;
	                }
	
	                ugc.get($scope.raceId, $scope).success(function (data) {
	                    if (data.runnerNotes && data.runnerNotes.error || data.raceNote && data.raceNote.error) {
	                        $scope.showErrorComment();
	                    } else {
	                        $scope.hideErrorComment();
	                        $scope.generalInfo = Object.assign({}, $scope.generalInfo, {
	                            note: {
	                                value: data.raceNote && data.raceNote.comment || '',
	                                isExists: !!(data.raceNote && data.raceNote.comment)
	                            }
	                        });
	                        data.runnerNotes.forEach(function (runnerRecord) {
	                            var item = $scope.items.find(function (_ref2) {
	                                var runnerInfo = _ref2.runnerInfo;
	                                return runnerInfo.horseId === +runnerRecord.horseId;
	                            });
	
	                            if (item) {
	                                item.runnerInfo.comment = runnerRecord.comment;
	                                item.runnerInfo.rating = runnerRecord.rating;
	                                item.runnerInfo.ratingFlag = runnerRecord.ratingFlag;
	                                item.runnerInfo.isExists = runnerRecord.isExists;
	                            }
	                        });
	                        angular.forEach($scope.items, function (item) {
	                            if (item.wgtAllowance === null) {
	                                item.wgtAllowance = 0;
	                            }
	                            if (item.wgtStNative === null) {
	                                item.wgtStNative = 0;
	                            }
	                            if (item.accumLengthNative === null) {
	                                item.accumLengthNative = 0;
	                            }
	                        });
	                    }
	                }).error(function () {
	                    return $scope.showErrorComment();
	                });
	            });
	        });
	    };
	
	    $scope.getTooltipPosition = function () {
	        var screenSize = CommonFunctions.getScreenSize();
	        return screenSize === 'extraNarrow' ? 'left' : 'top';
	    };
	
	    /**
	     * Close tooltip bubble
	     */
	    $scope.closeTooltip = function () {
	        $scope.setBubbleStorage();
	        $scope.tooltip.shouldShow = false;
	        $scope.tooltip.shown = {};
	    };
	
	    /**
	     * Input change handler for calculate checkbox
	     * @param index
	     */
	    $scope.onCalculateChange = function (index) {
	        $scope.toggleCalculate(index);
	        $scope.enableSaveButton();
	    };
	
	    /**
	     *
	     * @param idx
	     */
	    $scope.setMaster = function (idx) {
	        $scope.tooltip.shown = {};
	        $scope.tooltip.shown[idx] = true;
	        $scope.items[idx].runnerInfo.isMasterRating = !$scope.items[idx].runnerInfo.isMasterRating;
	        $scope.enableSaveButton();
	    };
	
	    /**
	     * Set localStorage when user first time on page
	     */
	    $scope.setBubbleStorage = function () {
	        try {
	            localStorage.setItem('showBubbleIfFirst', true);
	        } catch (e) {
	            console.warn('You are in a private mode, and we couldn\'t save your preference.');
	        }
	    };
	
	    /**
	     * Don't show bubble after user closed it
	     */
	    $scope.showBubbleOnlyFirstTime = function () {
	        if (localStorage.getItem('showBubbleIfFirst')) {
	            $scope.tooltip.shouldShow = false;
	        }
	    };
	
	    /**
	     * Reset all fields
	     */
	    $scope.clear = function () {
	        var isExists = void 0;
	        var horseId = null;
	        $scope.lastChangedIdx = null;
	        $scope.generalInfo = {
	            note: {
	                value: null,
	                isExists: $scope.generalInfo.note.isExists
	            },
	            length: $scope.generalInfo.length
	        };
	
	        var _loop = function _loop(i, len) {
	            if ($scope.items[i].hasOwnProperty('runnerInfo')) {
	                isExists = $scope.items[i].runnerInfo.isExists;
	                horseId = $scope.items[i].runnerInfo.horseId;
	                Object.keys($scope.items[i].runnerInfo).forEach(function (key) {
	                    $scope.items[i].runnerInfo[key] = null;
	                });
	                // Restoring state of horseId and isExists to be used on backend side
	                if (isExists) {
	                    $scope.items[i].runnerInfo.isExists = isExists;
	                }
	                if (horseId) {
	                    $scope.items[i].runnerInfo.horseId = horseId;
	                }
	            }
	        };
	
	        for (var i = 0, len = $scope.items.length; i < len; i++) {
	            _loop(i, len);
	        }
	        $scope.enableSaveButton();
	    };
	
	    /**
	     * Submits ratings form
	     */
	    $scope.quickNotesSubmit = function (event) {
	        var formData = {
	            raceId: $scope.raceId,
	            raceTypeCode: $scope.raceTypeCode,
	            horses: $scope.items.map(function (item) {
	                return item.runnerInfo;
	            }),
	            note: $scope.generalInfo.note ? $scope.generalInfo.note.value : null,
	            noteExists: $scope.generalInfo.note.isExists
	        };
	
	        ugc.post(formData).success(function (data) {
	            $scope.quickNotesCallback(event, data);
	        }).error(function () {
	            $scope.showErrorLightBox();
	        });
	    };
	
	    /**
	     * Callback for quickNotes ajax request
	     * Updates status of horse if record was saved successfully
	     *
	     * @param {Object} event Event object
	     * @param {Object} data Response object
	     */
	    $scope.quickNotesCallback = function (event, data) {
	        if (data.quickNotes) {
	            if (data.quickNotes.error) {
	                $scope.showErrorLightBox();
	            } else {
	                Object.keys(data.quickNotes).forEach(function (key) {
	                    return $scope.setUgcStatus(key);
	                });
	                $scope.showSavedLabel();
	            }
	        } else {
	            $scope.showSavedLabel();
	        }
	
	        $scope.setRaceNotesStatus(data.raceNotes);
	    };
	
	    /**
	     * Updates Ugc status of horse (is record exists in UGC or not)
	     *
	     * @param {Number} horseId Id of the horse
	     */
	    $scope.setUgcStatus = function (horseId) {
	        var item = $scope.items.find(function (horse) {
	            return horse.runnerInfo.horseId === +horseId;
	        });
	        if (item) {
	            item.runnerInfo.isExists = !!(item.runnerInfo.rating !== '' && (+item.runnerInfo.rating || +item.runnerInfo.rating === 0)) || item.runnerInfo.comment && (item.runnerInfo.comment.trim() || item.runnerInfo.comment === 0) || item.runnerInfo.ratingFlag && (item.runnerInfo.ratingFlag.trim() || item.runnerInfo.ratingFlag === 0);
	        }
	    };
	
	    /**
	     * Updates status of race comment depending if it was successfully updated on backend
	     *
	     * @param {Object} raceNotes
	     */
	    $scope.setRaceNotesStatus = function (raceNotes) {
	        $scope.generalInfo.note.isExists = $scope.generalInfo.note.value !== '' && raceNotes && raceNotes.data.result === true;
	    };
	
	    /**
	     * Run calculation on click Calculate button
	     * Formula:
	     * Basis rating - (distanceToWinner * entered on lb/length input value) -
	     * (difference between current horse and basis horse)
	     */
	    $scope.calculateRating = function () {
	        var idx = $scope.lastChangedIdx;
	        var lbLength = $scope.generalInfo.length;
	        var enteredRating = [];
	
	        angular.forEach($scope.items, function (value, index) {
	            if (value.runnerInfo.rating) {
	                enteredRating[index] = value.runnerInfo.rating;
	            }
	        });
	
	        var scopeItemByIndex = $scope.items[idx];
	        var basisRating = scopeItemByIndex.runnerInfo.rating;
	
	        var basisDistanceToWinner = scopeItemByIndex.accumLengthNative;
	        var weightOfFirstHorse = parseInt(scopeItemByIndex.wgtStNative, 10) + parseInt(scopeItemByIndex.wgtAllowance, 10) + parseInt(scopeItemByIndex.wfaAdjustment, 10);
	
	        angular.forEach($scope.items, function (value, index) {
	            var isNonFinisher = isNaN(parseInt(value.outcomeCode, 10)) && value.outcomeCode !== 'DSQ';
	            var weightAllowance = parseInt(value.wgtAllowance, 10);
	            var weightOfHorse = parseInt(value.wgtStNative, 10) + parseInt(value.wfaAdjustment, 10);
	
	            var distanceToWinner = value.accumLengthNative;
	
	            if (idx !== 0) {
	                distanceToWinner -= basisDistanceToWinner;
	            }
	
	            var weightDifference = weightOfFirstHorse - (weightOfHorse + weightAllowance);
	            var calculatedRating = Math.round(basisRating - distanceToWinner * lbLength - weightDifference);
	
	            if (calculatedRating < 0 || isNonFinisher) {
	                calculatedRating = '';
	            }
	
	            $scope.items[index].runnerInfo.rating = calculatedRating;
	        });
	    };
	
	    /**
	     * Input change handler for ratings inputs
	     * @param idx
	     * @param value
	     */
	    $scope.onRatingChange = function (idx, value) {
	        $scope.enableSaveButton();
	        $scope.validateMyRating(idx, value);
	    };
	
	    /**
	     * Validation for myRating inputs
	     * Only numbers and less/equal 500
	     * @param {Number} idx index of current button
	     * @param {Number} value Incoming typed value
	     */
	    $scope.validateMyRating = function (idx, value) {
	        $scope.items[idx].runnerInfo.rating = $scope.validateLength(value, 500);
	        $scope.lastChangedIdx = idx;
	    };
	
	    /**
	     * Input change handler for Lbs / Length input
	     * @param value
	     */
	    $scope.onLbsLengthChange = function (value) {
	        $scope.enableSaveButton();
	        $scope.validateLbLength(value);
	    };
	    /**
	     * Validation for lb/length input
	     * Only numbers and less/equal 10
	     * @param {Number} value Incoming typed value
	     */
	    $scope.validateLbLength = function (value) {
	        $scope.generalInfo.length = $scope.validateLength(value, 10);
	    };
	
	    /**
	     * Main validation of myRating inputs
	     * @param {String} value Incoming typed value
	     * @param {Number} maxNumber Maximum value allowed here
	     * @returns {String} validated data
	     */
	    $scope.validateLength = function (value, maxNumber) {
	        var result = void 0;
	        if (isNaN(value)) {
	            result = '';
	        } else if (parseFloat(value) > maxNumber) {
	            result = maxNumber;
	        } else {
	            result = value;
	        }
	
	        return String(result);
	    };
	
	    /**
	     * Enable Save button
	     * set label to Save
	     */
	    $scope.enableSaveButton = function () {
	        if (!$scope.isErrorCommentShown) {
	            $scope.isSaveBtnDisabled = false;
	            $scope.isSaveLabelShown = true;
	        }
	    };
	
	    /**
	     * Disables save button
	     * set label to Saved
	     */
	    $scope.showSavedLabel = function () {
	        $scope.isSaveBtnDisabled = true;
	        $scope.isSaveLabelShown = false;
	    };
	
	    /**
	     * Shows error messages after all inputs
	     */
	    $scope.showErrorComment = function () {
	        if (!$scope.isErrorCommentShown) {
	            $scope.isErrorCommentShown = true;
	        }
	    };
	
	    /**
	     * Hides error messages after all inputs
	     */
	    $scope.hideErrorComment = function () {
	        $scope.isErrorCommentShown = false;
	    };
	
	    /**
	     * Shows error lightBox
	     */
	    $scope.showErrorLightBox = function () {
	        $scope.isErrorLightBoxShown = true;
	    };
	
	    /**
	     * Removes error lightBox
	     */
	    $scope.hideErrorLightBox = function () {
	        $scope.isErrorLightBoxShown = false;
	    };
	
	    /**
	     * StopPropagation
	     */
	    $scope.stopPropagation = function (e) {
	        e.stopPropagation();
	    };
	
	    $scope.init();
	}];

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _rpAuth = __webpack_require__(193);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable */
	
	
	var _class = function _class($scope, $attrs) {
	    'ngInject'; // Dependency injection annotation for minification safety
	
	    _classCallCheck(this, _class);
	
	    var userSubscriptionLevel = $attrs.userSubscriptionLevel;
	    var sections = ['analysis', 'my-ratings', 'past-winners'];
	    var INSIGHTS = _rpAuth.subscriptionTypes.INSIGHTS,
	        ULTIMATE = _rpAuth.subscriptionTypes.ULTIMATE,
	        ESSENTIAL = _rpAuth.subscriptionTypes.ESSENTIAL;
	
	    var isAuthorized = userSubscriptionLevel === INSIGHTS || userSubscriptionLevel === ULTIMATE || userSubscriptionLevel === ESSENTIAL; //Only users that are Insights/Ultimate should be able to access the tabs
	    var urlChunks = window.location.href.split('/'); //Get all chunks from the url
	    var section = urlChunks[8]; //Get the desired section, since is the 8th chunk of the url
	
	    if (sections.includes(section) && !isAuthorized) {
	        window.location.href = window.location.origin + '/racecards?authme';
	    }
	
	    var pageName = 'result';
	    var step = 'Subscriptions';
	
	    $scope.handleClick = function ($event, link, title) {
	        $event.preventDefault();
	        var section = title.toLowerCase().replaceAll(' ', '_');
	        var text = 'Subscribe to Racing Post+ to access our in-depth results analysis on every British and Irish race, add your own notes and view past winners.';
	
	        if (section !== pageName) {
	            var hasAccess = (0, _rpAuth.checkForAccess)(step, true, false, { text: text, r: '' + window.location, service: 'both' }, true, userSubscriptionLevel, 'results', section);
	            if (hasAccess) {
	                window.location.href = link;
	            }
	        } else {
	            window.location.href = link;
	        }
	    };
	};
	_class.$inject = ["$scope", "$attrs"];
	
	exports.default = _class;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hls = __webpack_require__(1494);
	
	var _hls2 = _interopRequireDefault(_hls);
	
	var _rpGuiGuide = __webpack_require__(134);
	
	var _rpAuth = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	    _class.$inject = ["$scope", "$http", "$q", "$attrs", "raceReplayService"];
	    function _class($scope, $http, $q, $attrs, raceReplayService) {
	        'ngInject';
	
	        var _this = this;
	
	        _classCallCheck(this, _class);
	
	        this.handleStopTime = function () {
	            if (_this.videoHls.currentTime > _this.$scope.endSec) {
	                _this.videoHls.pause();
	            }
	        };
	
	        this.loadVideo = function () {
	            _this.videoHls.src = _this.$scope.videoSrc;
	
	            if (_hls2.default.isSupported() && _this.$scope.provider === 'ATR') {
	                _this.hls.loadSource(_this.$scope.videoSrc);
	                _this.hls.attachMedia(_this.videoHls);
	            }
	        };
	
	        this.loadIPhoneVideo = function () {
	            window.location = _this.$scope.videoSrc + '#t=' + _this.$scope.startSec + ',' + _this.$scope.endSec;
	        };
	
	        this.clearHash = function () {
	            if (window.location.hash) {
	                window.location.hash = '';
	            }
	        };
	
	        this.onError = function (errorMessage) {
	            _this.raceReplayService.exitFullScreen(_this.videoHls);
	            Object.assign(_this.$scope, { error: errorMessage, loading: false });
	
	            if (!errorMessage) {
	                _this.closeReplay();
	            }
	        };
	
	        this.openVideo = function (isFullClick, loadVideo) {
	            _this.raceReplayService.getVideo(isFullClick, _this.$scope, _this.onError).then(function (data) {
	                return _this.setVideoInfo(data, isFullClick);
	            }).then(_this.clearHash).then(loadVideo);
	        };
	
	        Object.assign(this, {
	            $scope: $scope,
	            $http: $http,
	            $q: $q,
	            $attrs: $attrs,
	            raceReplayService: raceReplayService,
	            videoHls: document.getElementById('replay-video'),
	            hls: new _hls2.default()
	        });
	
	        this.setDefaultValues();
	        this.initControls();
	        /**
	         *  [QW-795] Often rp-jquery-modal-lightbox not ready in moment of
	         *  replays initialization. That's why barriers not always shown.
	         *  So we need to postpone init.
	         */
	        setTimeout(function () {
	            return _this.init();
	        });
	    }
	
	    _createClass(_class, [{
	        key: 'setDefaultValues',
	        value: function setDefaultValues() {
	            var _this2 = this;
	
	            var provider = this.$attrs.directiveRaceReplayProvider;
	            var userSubscriptionLevel = this.$attrs.userSubscriptionLevel;
	            localStorage.setItem('userRole', userSubscriptionLevel);
	
	            Object.assign(this.$scope, {
	                fullShown: false,
	                closingShown: false,
	                loading: false,
	                error: '',
	                containerHovered: false,
	                provider: provider,
	                datetime: this.$attrs.directiveRaceReplayDatetime,
	                raceId: this.$attrs.directiveRaceReplayRaceId,
	                raceName: this.$attrs.directiveRaceReplayRaceName,
	                raceTime: this.$attrs.directiveRaceReplayRaceTime,
	                videoId: this.$attrs.directiveRaceReplay,
	                courseName: this.$attrs.directiveRaceReplayCourseName,
	                videoSrc: '',
	                videoType: '',
	                startSec: 0,
	                endSec: null,
	                onFullClick: function onFullClick() {
	                    return _this2.onButtonClick(true, userSubscriptionLevel);
	                },
	                onClosingClick: function onClosingClick() {
	                    return _this2.onButtonClick(false, userSubscriptionLevel);
	                },
	                closeReplay: function closeReplay() {
	                    return _this2.closeReplay();
	                }
	            });
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this3 = this;
	
	            /**
	             *  We unable to set currentTime when 'loadedmetadata' fires on iOS (closing stages).
	             *  We can't use 'canplay' because it fires on rewind video too.
	             */
	            var loadedEvent = _rpGuiGuide.mobileDetect.os() === 'iOS' ? 'loadeddata' : 'loadedmetadata';
	            this.videoHls.addEventListener(loadedEvent, function () {
	                _this3.$scope.loading = false;
	                _this3.$scope.$digest();
	                _this3.play();
	            });
	
	            if (window.location.hash.includes('fullReplay')) {
	                this.onButtonClick(true);
	            }
	        }
	    }, {
	        key: 'initControls',
	        value: function initControls() {
	            var isDesktop = !_rpGuiGuide.mobileDetect.isPhone() && !_rpGuiGuide.mobileDetect.tablet();
	            this.$scope.isCustomControls = isDesktop;
	
	            if (!isDesktop) {
	                this.videoHls.controls = true;
	            }
	        }
	    }, {
	        key: 'play',
	        value: function play() {
	            this.videoHls.currentTime = this.$scope.startSec;
	            this.videoHls.play();
	            if (this.$scope.endSec) {
	                this.videoHls.addEventListener('timeupdate', this.handleStopTime);
	            }
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this.videoHls.pause();
	            this.videoHls.removeEventListener('timeupdate', this.handleStopTime);
	        }
	    }, {
	        key: 'setVideoInfo',
	        value: function setVideoInfo(_ref, isFullClick) {
	            var raceStart = _ref.raceStart,
	                raceEnd = _ref.raceEnd,
	                closingStart = _ref.closingStart,
	                closingEnd = _ref.closingEnd,
	                url = _ref.url;
	
	            Object.assign(this.$scope, {
	                videoSrc: url,
	                videoType: this.$scope.provider === 'ATR' ? 'application/x-mpegURL' : 'video/mp4',
	                startSec: isFullClick ? raceStart : closingStart,
	                endSec: isFullClick ? raceEnd : closingEnd
	            });
	        }
	    }, {
	        key: 'toggleEmbeddedVideoPlayer',
	        value: function toggleEmbeddedVideoPlayer(isFullClick) {
	            if (isFullClick && this.$scope.fullShown || !isFullClick && this.$scope.closingShown) {
	                this.closeReplay();
	            } else {
	                this.stop();
	
	                Object.assign(this.$scope, {
	                    fullShown: isFullClick,
	                    closingShown: !isFullClick,
	                    loading: true,
	                    error: '',
	                    videoSrc: '',
	                    startSec: 0,
	                    endSec: null
	                });
	
	                this.openVideo(isFullClick, this.loadVideo);
	
	                if (_rpGuiGuide.mobileDetect.isPhone() || _rpGuiGuide.mobileDetect.tablet()) {
	                    this.play();
	                    this.raceReplayService.enterFullScreen(this.videoHls);
	                }
	            }
	        }
	    }, {
	        key: 'onButtonClick',
	        value: function onButtonClick(isFullClick, userSubscriptionLevel) {
	            if (this.$scope.loading) {
	                this.$scope.requestCanceler.resolve();
	            }
	
	            var isInsights = userSubscriptionLevel === _rpAuth.subscriptionTypes.ESSENTIAL || userSubscriptionLevel === _rpAuth.subscriptionTypes.INSIGHTS;
	            var raceType = isFullClick ? 'full_replay' : 'closing_stages_replay';
	            var text = isInsights ?
	            // eslint-disable-next-line max-len
	            'Access unlimited video race replays from all 86 racecourses in Britain and Ireland when you upgrade to a Racing Post+ Ultimate subscription.' : 'To see race replays from all 86 UK & Ireland racecourses, subscribe to Ultimate';
	
	            var hasAccess = (0, _rpAuth.checkForAccess)('Subscriptions', true, false, { text: text, r: '' + window.location, service: 'both' }, true, userSubscriptionLevel, 'results', raceType);
	
	            if (hasAccess) {
	                this.$scope.requestCanceler = this.$q.defer();
	
	                if (_rpGuiGuide.mobileDetect.os() === 'iOS' && _rpGuiGuide.mobileDetect.isPhone()) {
	                    this.openVideo(isFullClick, this.loadIPhoneVideo);
	                } else {
	                    this.toggleEmbeddedVideoPlayer(isFullClick);
	                }
	            }
	        }
	    }, {
	        key: 'closeReplay',
	        value: function closeReplay() {
	            this.stop();
	            Object.assign(this.$scope, { fullShown: false, closingShown: false, error: '' });
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	    _class.$inject = ["$scope", "raceReplayService", "browserDetectService", "localStorageService"];
	    function _class($scope, raceReplayService, browserDetectService, localStorageService) {
	        'ngInject';
	
	        var _this = this;
	
	        _classCallCheck(this, _class);
	
	        this.init = function () {
	            Object.assign(_this.$scope, {
	                play: _this.play,
	                mute: _this.mute,
	                fullScreen: _this.fullScreen,
	                exitFullScreen: _this.exitFullScreen,
	                isPlaying: !_this.video.paused,
	                isMuted: _this.video.muted,
	                isVideoControlsHovered: false,
	                hideTimer: null,
	                controlsHovered: false
	            });
	            _this.initVolume();
	        };
	
	        this.initVolume = function () {
	            var volume = _this.localStorageService.getItem('replay-volume') || 0.5;
	            _this.video.volume = volume;
	            _this.volumeBar.value = volume;
	
	            var isMuted = !!_this.localStorageService.getItem('replay-muted');
	            _this.video.muted = isMuted;
	            _this.$scope.isMuted = isMuted;
	        };
	
	        this.listenChanges = function () {
	            var rewindEvent = _this.browserDetectService.getBrowser() === 'IE' ? 'change' : 'input';
	
	            _this.video.addEventListener('playing', _this.onVideoPlay);
	            _this.video.addEventListener('pause', _this.onVideoPause);
	            _this.video.addEventListener('timeupdate', _this.onVideoTimeUpdate);
	
	            _this.volumeBar.addEventListener(rewindEvent, _this.onVolumeChange);
	
	            _this.seek.addEventListener(rewindEvent, _this.onRewindVideo);
	            _this.seek.addEventListener('mousedown', _this.onRewindingStart);
	            _this.seek.addEventListener('mouseup', _this.onRewindingEnd);
	
	            _this.replayContainer.addEventListener('mouseenter', _this.onMouseEnterReplayContainer);
	            _this.replayContainer.addEventListener('mouseleave', _this.onMouseLeaveReplayContainer);
	            _this.replayContainer.addEventListener('mousemove', _this.onMouseMoveReplayContainer);
	
	            _this.videoControls.addEventListener('mouseenter', _this.onMouseEnterVideoControls);
	            _this.videoControls.addEventListener('mouseleave', _this.onMouseLeaveVideoControls);
	        };
	
	        this.onMouseEnterReplayContainer = function () {
	            _this.showControls();
	            _this.startTimerHideControls();
	        };
	
	        this.onMouseLeaveReplayContainer = function () {
	            _this.hideControls();
	            _this.stopTimerHideControls();
	        };
	
	        this.onMouseMoveReplayContainer = function () {
	            _this.showControls();
	            _this.startTimerHideControls();
	        };
	
	        this.onMouseEnterVideoControls = function () {
	            _this.$scope.isVideoControlsHovered = true;
	        };
	
	        this.onMouseLeaveVideoControls = function () {
	            _this.$scope.isVideoControlsHovered = false;
	        };
	
	        this.onRewindingStart = function () {
	            _this.video.pause();
	        };
	
	        this.onRewindingEnd = function () {
	            var duration = _this.video.duration;
	            var end = _this.$scope.endSec && _this.$scope.endSec < duration ? _this.$scope.endSec : duration;
	            if (_this.video.currentTime >= end) return;
	
	            _this.video.play();
	        };
	
	        this.onVideoPlay = function () {
	            _this.$scope.isPlaying = true;
	            _this.$scope.$digest();
	        };
	
	        this.onVideoPause = function () {
	            _this.$scope.isPlaying = false;
	            _this.$scope.$digest();
	        };
	
	        this.onVideoTimeUpdate = function () {
	            // console.log('-----------------------------------------');
	            // console.log('ON VIDEO TIME UPDATE (setting seekValue)');
	            // console.log('seekValue: ', this.seek.value);
	            // console.log('currentTime: ', this.video.currentTime);
	            // console.log('duration: ', this.video.duration);
	            // console.log('startSec: ', this.$scope.startSec);
	            // console.log('endSec: ', this.$scope.endSec);
	
	            // this.seek.value = (100 / this.video.duration) * this.video.currentTime; // old
	            // this.seek.value = (100 / (this.$scope.endSec - this.$scope.startSec)) *
	            //     (this.video.currentTime - this.$scope.startSec); // new
	
	            var seekValue = 0;
	
	            var duration = _this.video.duration;
	            var currentTime = _this.video.currentTime;
	
	            var start = _this.$scope.startSec ? _this.$scope.startSec : 0;
	            var end = _this.$scope.endSec && _this.$scope.endSec < duration ? _this.$scope.endSec : duration;
	
	            duration = end - start;
	            currentTime = currentTime - start;
	
	            if (duration > 0) seekValue = 100 / duration * currentTime;
	            if (seekValue < 0) seekValue = 0;
	            if (seekValue > 100) seekValue = 100;
	
	            _this.seek.value = seekValue;
	        };
	
	        this.onVolumeChange = function () {
	            _this.video.volume = _this.volumeBar.value;
	            _this.localStorageService.setItem('replay-volume', _this.volumeBar.value);
	        };
	
	        this.onRewindVideo = function () {
	            // console.log('-----------------------------------------');
	            // console.log('ON REWIND VIDEO (setting currentTime)');
	            // console.log('seekValue: ', this.seek.value);
	            // console.log('currentTime: ', this.video.currentTime);
	            // console.log('duration: ', this.video.duration);
	            // console.log('startSec: ', this.$scope.startSec);
	            // console.log('endSec: ', this.$scope.endSec);
	
	            // this.video.currentTime = this.video.duration * (this.seek.value / 100); // old
	            // this.video.currentTime = (this.$scope.endSec - this.$scope.startSec) *
	            //     (this.seek.value / 100) + this.$scope.startSec; // new
	
	            var currentTime = 0;
	            var duration = _this.video.duration;
	
	            var start = +_this.$scope.startSec ? +_this.$scope.startSec : 0;
	            var end = +_this.$scope.endSec && +_this.$scope.endSec < duration ? +_this.$scope.endSec : duration;
	
	            duration = end - start;
	
	            if (duration < 0) duration = 0;
	
	            currentTime = duration * (_this.seek.value / 100) + start;
	
	            if (currentTime < start) currentTime = start;
	            if (currentTime > end) currentTime = end;
	
	            _this.video.currentTime = currentTime;
	        };
	
	        this.play = function () {
	            if (_this.video.paused === true) {
	                var duration = _this.video.duration;
	                var end = _this.$scope.endSec && _this.$scope.endSec < duration ? _this.$scope.endSec : duration;
	                if (_this.video.currentTime >= end) return;
	
	                _this.video.play();
	            } else {
	                _this.video.pause();
	            }
	        };
	
	        this.mute = function () {
	            var isMuted = !_this.video.muted;
	
	            _this.video.muted = isMuted;
	            _this.$scope.isMuted = isMuted;
	            _this.localStorageService.setItem('replay-muted', isMuted);
	        };
	
	        this.fullScreen = function () {
	            _this.raceReplayService.enterFullScreen(_this.replayContainer);
	        };
	
	        this.exitFullScreen = function () {
	            _this.raceReplayService.exitFullScreen();
	        };
	
	        Object.assign(this, {
	            $scope: $scope,
	            raceReplayService: raceReplayService,
	            browserDetectService: browserDetectService,
	            localStorageService: localStorageService,
	            replayContainer: document.getElementById('replay-container'),
	            videoControls: document.getElementsByClassName('rr-videoControls')[0],
	            video: document.getElementById('replay-video'),
	            seek: document.getElementById('seek'),
	            volumeBar: document.getElementById('volume-bar')
	        });
	
	        if ($scope.isCustomControls) {
	            this.listenChanges();
	            this.init();
	        }
	    }
	
	    _createClass(_class, [{
	        key: 'startTimerHideControls',
	        value: function startTimerHideControls() {
	            this.stopTimerHideControls();
	            this.$scope.hideTimer = setTimeout(this.hideControls.bind(this), 3000);
	        }
	    }, {
	        key: 'stopTimerHideControls',
	        value: function stopTimerHideControls() {
	            clearTimeout(this.$scope.hideTimer);
	            this.$scope.hideTimer = null;
	        }
	    }, {
	        key: 'showControls',
	        value: function showControls() {
	            this.$scope.controlsHovered = true;
	            this.$scope.$parent.containerHovered = true;
	            this.$scope.$digest();
	            this.$scope.$parent.$digest();
	        }
	    }, {
	        key: 'hideControls',
	        value: function hideControls() {
	            if (this.$scope.isPlaying && !this.$scope.isVideoControlsHovered) {
	                this.$scope.controlsHovered = false;
	                this.$scope.$parent.containerHovered = false;
	                this.$scope.$digest();
	                this.$scope.$parent.$digest();
	            }
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only element name can be used for directive definition
	        link: function link(directiveAccordionCtrl) {
	            directiveAccordionCtrl.init();
	        },
	        controller: 'directiveAccordionCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {},
	        controller: 'directiveAdvancedSearchCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    'ngInject';
	
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {},
	        controller: 'directiveApplyFastResultCtrl', // Executes before compile
	        template: _fastResults2.default
	    };
	};
	
	var _fastResults = __webpack_require__(1495);
	
	var _fastResults2 = _interopRequireDefault(_fastResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {},
	        controller: 'directiveDatePickerWrapperCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    restrict: 'E',
	    template: '<div class="rp-myRatings__errorComment js-runnerRowErrorComment">\n                        There\'s a technical problem that means notes and ratings content is \n                        currently unavailable. We are working to restore the service as fast\n                         as possible and are sorry for any inconvenience caused. Please click\n                        <span class="rp-myRatings__errorComment__link"\n                              data-ng-click="getUgcData()">here</span>\n                            to refresh the page or try again later.\n                    </div>'
	  };
	};

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'E',
	        template: '<div class="pr-errorLightbox__wrapper"\n                        data-ng-click="hideErrorLightBox()">\n                        <div class="pr-errorLightbox_container"\n                             data-ng-click="stopPropagation($event)">\n                            <div class="pr-errorLightbox__header">\n                                <div class="ui-btn ui-btn_small"\n                                     data-ng-click="hideErrorLightBox()">\n                                    <svg class="ui-icon\n                                                ui-icon_sizeMedium">\n                                        <use xlink:href="img/icons.svg#icon-cross"/>\n                                    </svg>\n                                </div>\n                            </div>\n                            <div class="pr-errorLightbox__content">\n                                Something\'s gone wrong\n                                and your changes could not be saved.\n                                Press save to try again.\n                            </div>\n                            <div class="pr-errorLightbox__button\n                                        ui-btn ui-btn_primary"\n                                  data-ng-click="hideErrorLightBox()">\n                                Ok\n                            </div>\n                        </div>\n                    </div>'
	    };
	};

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {},
	        controller: 'directiveFastResultCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {},
	        controller: 'directiveFastResultTriggerCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        link: function link(scope, element) {
	            $(element).hyphenate('en-us');
	        }
	    };
	};

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _accordion = __webpack_require__(1671);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _advancedSearch = __webpack_require__(1672);
	
	var _advancedSearch2 = _interopRequireDefault(_advancedSearch);
	
	var _applyFastResults = __webpack_require__(1673);
	
	var _applyFastResults2 = _interopRequireDefault(_applyFastResults);
	
	var _datePickerWrapper = __webpack_require__(1674);
	
	var _datePickerWrapper2 = _interopRequireDefault(_datePickerWrapper);
	
	var _fastResult = __webpack_require__(1677);
	
	var _fastResult2 = _interopRequireDefault(_fastResult);
	
	var _fastResultTrigger = __webpack_require__(1678);
	
	var _fastResultTrigger2 = _interopRequireDefault(_fastResultTrigger);
	
	var _hyphenation = __webpack_require__(1679);
	
	var _hyphenation2 = _interopRequireDefault(_hyphenation);
	
	var _linkTrigger = __webpack_require__(1681);
	
	var _linkTrigger2 = _interopRequireDefault(_linkTrigger);
	
	var _moveTopOnFocus = __webpack_require__(1685);
	
	var _moveTopOnFocus2 = _interopRequireDefault(_moveTopOnFocus);
	
	var _maxEqualWidth = __webpack_require__(1682);
	
	var _maxEqualWidth2 = _interopRequireDefault(_maxEqualWidth);
	
	var _mediaelement = __webpack_require__(1683);
	
	var _mediaelement2 = _interopRequireDefault(_mediaelement);
	
	var _meetingStaff = __webpack_require__(1684);
	
	var _meetingStaff2 = _interopRequireDefault(_meetingStaff);
	
	var _raceCourse = __webpack_require__(1686);
	
	var _raceCourse2 = _interopRequireDefault(_raceCourse);
	
	var _raceReplay = __webpack_require__(1687);
	
	var _raceReplay2 = _interopRequireDefault(_raceReplay);
	
	var _videoControls = __webpack_require__(1693);
	
	var _videoControls2 = _interopRequireDefault(_videoControls);
	
	var _selectDate = __webpack_require__(1688);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _tableToolbar = __webpack_require__(1690);
	
	var _tableToolbar2 = _interopRequireDefault(_tableToolbar);
	
	var _successBoxes = __webpack_require__(1689);
	
	var _successBoxes2 = _interopRequireDefault(_successBoxes);
	
	var _ticker = __webpack_require__(1691);
	
	var _ticker2 = _interopRequireDefault(_ticker);
	
	var _verticalScroll = __webpack_require__(1692);
	
	var _verticalScroll2 = _interopRequireDefault(_verticalScroll);
	
	var _errorComment = __webpack_require__(1675);
	
	var _errorComment2 = _interopRequireDefault(_errorComment);
	
	var _errorLightBox = __webpack_require__(1676);
	
	var _errorLightBox2 = _interopRequireDefault(_errorLightBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directives = angular.module('results.directives', []).directive('directiveAccordion', _accordion2.default).directive('directiveAdvancedSearch', _advancedSearch2.default).directive('directiveApplyFastResult', _applyFastResults2.default).directive('directiveDatePickerWrapper', _datePickerWrapper2.default).directive('directiveFastResult', _fastResult2.default).directive('directiveFastResultTrigger', _fastResultTrigger2.default).directive('directiveHyphenation', _hyphenation2.default).directive('directiveLinkTrigger', _linkTrigger2.default).directive('directiveMoveTopOnFocus', _moveTopOnFocus2.default).directive('maxEqualWidth', _maxEqualWidth2.default).directive('mediaelement', _mediaelement2.default).directive('directiveMeetingStaff', _meetingStaff2.default).directive('directiveRaceCourse', _raceCourse2.default).directive('directiveRaceReplay', _raceReplay2.default).directive('directiveVideoControls', _videoControls2.default).directive('directiveSelectDate', _selectDate2.default).directive('directiveSuccessBoxes', _successBoxes2.default).directive('directiveTicker', _ticker2.default).directive('verticalScroll', _verticalScroll2.default).directive('directiveTableToolbar', _tableToolbar2.default).directive('directiveErrorComment', _errorComment2.default).directive('directiveErrorLightBox', _errorLightBox2.default);
	
	exports.default = directives;

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only element name can be used for directive definition
	        scope: {}, // Define own scope for directive
	        controller: 'LinkTriggerCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A',
	        controller: ["$scope", "$element", function controller($scope, $element) {
	            // TODO: Separate controller from directive
	            'ngInject';
	
	            $scope.maxEqualWidth = 0;
	
	            $scope.getMaxEqualWidth = function () {
	                return $scope.maxEqualWidth;
	            };
	
	            $scope.$watch(function () {
	                return $element.width();
	            }, function () {
	                var elements = $element.children();
	                var elementWidth = void 0;
	
	                elements.each(function (index, element) {
	                    elementWidth = element.offsetWidth;
	
	                    if (elementWidth > $scope.maxEqualWidth) {
	                        $scope.maxEqualWidth = elementWidth;
	                    }
	                });
	            }, true);
	        }]
	    };
	};

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var config = {
	        nativeControlsForTouch: true // Native html5 player skin for mobile devices
	    };
	
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            // TODO: Separate controller from directive
	            videojs(element[0], config, function () {
	                // Player (this) is initialized and ready.
	            });
	        }
	    };
	};

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {
	            courseId: '=',
	            emptySelector: '='
	        },
	        controller: 'directiveMeetingStaffCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only element name can be used for directive definition
	        scope: {}, // Define own scope for directive
	        controller: 'directiveMoveTopOnFocusCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only element attribute can be used for directive definition
	        controller: 'DirectiveRaceCourseCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A',
	        controller: 'raceReplayCtrl',
	        scope: true
	    };
	};

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {},
	        controller: 'directiveSelectDateCtrl' // Executes before compile
	    };
	};

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["config", function (config) {
	    'ngInject';
	
	    return {
	        restrict: 'A', // Only attribute name can be used for directive definition
	        scope: {
	            raceId: '='
	        },
	        link: function link(directiveSuccessBoxesCtrl) {
	            directiveSuccessBoxesCtrl.init();
	        },
	        templateUrl: config.get('assetsURL') + 'views/successBox.html',
	        controller: 'directiveSuccessBoxesCtrl' // Executes before compile
	    };
	}];

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'E', // Only attribute name can be used for directive definition
	        controller: 'directiveTableToolbarCtrl', // Executes before compile
	        scope: {},
	        replace: true,
	        template: _tableToolbar2.default
	    };
	};
	
	var _tableToolbar = __webpack_require__(1496);
	
	var _tableToolbar2 = _interopRequireDefault(_tableToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["config", function (config) {
	    'ngInject';
	
	    return {
	        restrict: 'E', // Only element name can be used for directive definition
	        scope: {
	            directiveTickerText: '@'
	        },
	        // TODO: Remove internal links from js files and use only phalcon's `url` function for
	        // link generation, where we put router name and params for the router
	        templateUrl: config.get('assetsURL') + 'views/ticker.html',
	        controller: 'directiveTickerCtrl' // Executes before compile
	    };
	}];

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$rootScope", function ($rootScope) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            // TODO: Separate controller from directive
	            scope.$watch(element[0].clientWidth, function () {
	                $rootScope.$emit('resize');
	            });
	            $(window).on('resize', function () {
	                $rootScope.$emit('resize');
	            });
	        }
	    };
	}];

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'A',
	        controller: 'videoControlsCtrl',
	        scope: true
	    };
	};

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(1698);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _commonFunctions = __webpack_require__(1697);
	
	var _commonFunctions2 = _interopRequireDefault(_commonFunctions);
	
	var _browserDetectService = __webpack_require__(1696);
	
	var _browserDetectService2 = _interopRequireDefault(_browserDetectService);
	
	var _localStorageService = __webpack_require__(1699);
	
	var _localStorageService2 = _interopRequireDefault(_localStorageService);
	
	var _raceReplayService = __webpack_require__(1700);
	
	var _raceReplayService2 = _interopRequireDefault(_raceReplayService);
	
	var _userPreference = __webpack_require__(1703);
	
	var _userPreference2 = _interopRequireDefault(_userPreference);
	
	var _ugc = __webpack_require__(1702);
	
	var _ugc2 = _interopRequireDefault(_ugc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('CommonUtils', []).provider('config', _config2.default).factory('CommonFunctions', _commonFunctions2.default).service('browserDetectService', _browserDetectService2.default).service('localStorageService', _localStorageService2.default).service('raceReplayService', _raceReplayService2.default).service('userPreference', _userPreference2.default).service('ugc', _ugc2.default);

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1694);
	
	var _controllers = __webpack_require__(1664);
	
	var _controllers2 = _interopRequireDefault(_controllers);
	
	var _directives = __webpack_require__(1680);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	var _httpProvider = __webpack_require__(1647);
	
	var _httpProvider2 = _interopRequireDefault(_httpProvider);
	
	var _anchorScrollProvider = __webpack_require__(1646);
	
	var _anchorScrollProvider2 = _interopRequireDefault(_anchorScrollProvider);
	
	var _locationProvider = __webpack_require__(1648);
	
	var _locationProvider2 = _interopRequireDefault(_locationProvider);
	
	var _sceDelegateProvider = __webpack_require__(1649);
	
	var _sceDelegateProvider2 = _interopRequireDefault(_sceDelegateProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// configs
	
	
	/**
	 * @name results
	 * @description
	 *
	 * Main module of the application.
	 */
	angular.module('results', ['CommonUtils', 'monospaced.elastic', _controllers2.default.name, _directives2.default.name]).config(_httpProvider2.default).config(_anchorScrollProvider2.default).config(_locationProvider2.default).config(_sceDelegateProvider2.default);

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$window", function ($window) {
	    'ngInject';
	
	    var _this = this;
	
	    this.getBrowserPrefix = function () {
	        var browser = _this.getBrowser();
	
	        if (browser === 'Safari' || browser === 'Chrome') {
	            return 'webkit';
	        }
	        if (browser === 'IE' || browser === 'Edge') {
	            return 'MS';
	        }
	        if (browser === 'Firefox') {
	            return 'moz';
	        }
	        return '';
	    };
	
	    this.getBrowser = function () {
	        var userAgent = $window.navigator.userAgent;
	        if (userAgent.match(/trident|msie/i)) {
	            return 'IE';
	        }
	        if (userAgent.includes('Edge')) {
	            return 'Edge';
	        }
	        if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
	            return 'Safari';
	        }
	        if (userAgent.includes('Chrome')) {
	            return 'Chrome';
	        }
	        if (userAgent.includes('Firefox')) {
	            return 'Firefox';
	        }
	        return '';
	    };
	}];

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$rootScope", function ($rootScope) {
	    'ngInject';
	
	    var common = {};
	
	    common.parseBreakpointsName = function (name) {
	        switch (name) {
	            case 'extra narrow':
	                return 'extraNarrow';
	            case 'extra wide':
	                return 'extraWide';
	            default:
	                return name;
	        }
	    };
	
	    // TODO: Implement function that raises event when breakpoint was changed
	    common.getScreenSize = function (breakpointName) {
	        var breakpointCode = breakpointName || _rpMqBreakpoints2.default.current().name;
	        return common.parseBreakpointsName(breakpointCode);
	    };
	
	    /**
	     * Get values for positioning block relatively to the element
	     *
	     * @param {object} element DOM element
	     * @param {object} positionedElementRect rects of a DOM element that is being positioned
	     * @param {string} bp current breakpoint
	     */
	    common.getOffsetRect = function (element, positionedElementRect, bp) {
	        var box = element.getBoundingClientRect();
	        var body = $(document).context.body;
	        var docElem = $(document).context.documentElement;
	        var scrollTop = $(window).pageYOffset || docElem.scrollTop || body.scrollTop;
	        var scrollLeft = $(window).pageXOffset || docElem.scrollLeft || body.scrollLeft;
	        var clientTop = docElem.clientTop || body.clientTop || 0;
	        var clientLeft = docElem.clientLeft || body.clientLeft || 0;
	        var top = Math.round(box.top + scrollTop - clientTop + box.height);
	        var left = box.left + scrollLeft - clientLeft + box.width / 2;
	
	        if (left > positionedElementRect.width) {
	            left -= bp === 'medium' ? positionedElementRect.width : positionedElementRect.width / 2;
	            left = Math.round(left);
	        } else {
	            left = '';
	        }
	
	        return { top: top, left: left };
	    };
	
	    $(window).on('rpBreakpointsSwitch', function (e) {
	        $rootScope.$broadcast('breakpointChanged', common.getScreenSize(e.detail.breakpoint.name));
	    });
	
	    common.removeExistedSelector = function (element, selector) {
	        if (element.hasClass(selector)) {
	            element.removeClass(selector);
	        }
	    };
	
	    return common;
	}];
	
	var _rpMqBreakpoints = __webpack_require__(130);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ["$windowProvider", function ($windowProvider) {
	  'ngInject';
	  /**
	   * Application config
	   * @type {object}
	   * @default
	   */
	
	  var _this = this;
	
	  this.data = {
	    resultsPath: '/results',
	    assetsURL: $windowProvider.$get().assetsURL
	  };
	
	  /**
	   * Getter for data
	   */
	  this.getData = function () {
	    return _this.data;
	  };
	
	  /**
	   * Returns config property
	   * @param {number} key
	   */
	  this.get = function (key) {
	    var data = _this.getData();
	
	    if (!data.hasOwnProperty(key)) {
	      return false;
	    }
	
	    return data[key];
	  };
	
	  /**
	   * Returns instance of config
	   * @returns {CommonUtils.config}
	   */
	  this.$get = function () {
	    return _this;
	  };
	}];

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$window", function ($window) {
	    'ngInject';
	
	    this.setItem = function (key, value) {
	        $window.localStorage.setItem(key, JSON.stringify(value));
	    };
	
	    this.getItem = function (key) {
	        return JSON.parse($window.localStorage.getItem(key));
	    };
	}];

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _rpAuth = __webpack_require__(193);
	
	var _rpAnalytics = __webpack_require__(105);
	
	var segmentio = _interopRequireWildcard(_rpAnalytics);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @ngdoc service
	 * @name CommonUtils.raceReplay
	 */
	var _class = function _class($http, $q, $cacheFactory, browserDetectService) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, _class);
	
	    this.cacheExpirationCheck = function (isFullClick) {
	        var cacheName = _this.getCacheName(isFullClick);
	        var cacheExpiredName = cacheName + 'Expired';
	        if (_this[cacheExpiredName]) {
	            _this.clearCache(cacheName);
	            _this[cacheExpiredName] = false;
	            setTimeout(function () {
	                _this[cacheExpiredName] = true;
	            }, 20000);
	        }
	    };
	
	    this.clearCache = function (cacheName) {
	        return _this[cacheName].removeAll();
	    };
	
	    this.getCacheName = function (isFullClick) {
	        return isFullClick ? 'fullReplayCache' : 'closingStagesCache';
	    };
	
	    this.getDate = function () {
	        return window.location.pathname.split('/')[4].replace(/-/g, '');
	    };
	
	    this.enterFullScreen = function (video) {
	        if (video.requestFullscreen) {
	            video.requestFullscreen();
	            return;
	        }
	        if (video.mozRequestFullScreen) {
	            video.mozRequestFullScreen();
	            return;
	        }
	        if (video.webkitRequestFullscreen) {
	            video.webkitRequestFullscreen();
	            return;
	        }
	        if (video.msRequestFullscreen) {
	            video.msRequestFullscreen();
	            return;
	        }
	    };
	
	    this.exitFullScreen = function () {
	        // There are different full-screen API in browsers and versions
	        if (document.cancelFullScreen) {
	            document.cancelFullScreen();
	            return;
	        }
	        if (document.mozCancelFullScreen) {
	            document.mozCancelFullScreen();
	            return;
	        }
	        if (document.webkitCancelFullScreen) {
	            document.webkitCancelFullScreen();
	            return;
	        }
	        if (document.webkitExitFullScreen) {
	            document.webkitExitFullScreen();
	            return;
	        }
	        if (document.msExitFullscreen) {
	            document.msExitFullscreen();
	            return;
	        }
	    };
	
	    this.trackVideoReplay = function (data, isFullClick, scope) {
	        var params = Object.assign({
	            feed_supplier: scope.provider,
	            video_provided: !data.error
	        }, _this.getVideoParams(isFullClick, scope));
	        _this.segmentio.track('Video Replay', params);
	
	        return data.error ? _this.$q.reject(data) : data;
	    };
	
	    this.onRequestFailed = function (err, onError, isFullClick, scope) {
	        var cacheName = _this.getCacheName(isFullClick);
	        _this.clearCache(cacheName);
	
	        if (err.status === 0) {
	            return _this.$q.reject();
	        }
	
	        onError(err.error || err.data.error);
	
	        if (err.status === 401) {
	            _this.trackVideoReplay({ error: true }, isFullClick, scope);
	            (0, _rpAuth.checkForAccess)('Subscriptions', true, false, { r: '' + window.location });
	        } else {
	            console.warn(err);
	        }
	
	        return _this.$q.reject();
	    };
	
	    this.getClickLocation = function () {
	        var hash = window.location.hash;
	
	        if (hash.includes('resultList')) {
	            return 'Result List';
	        }
	        if (hash.includes('profiles')) {
	            return 'Profiles';
	        }
	        return 'In Player';
	    };
	
	    this.getVideoUrl = function (_ref) {
	        var provider = _ref.provider,
	            videoId = _ref.videoId,
	            datetime = _ref.datetime;
	
	        var date = (0, _moment2.default)(datetime).format('YYYYMMDD');
	
	        return 'stream/' + provider + '/' + videoId + '/' + date;
	    };
	
	    this.getVideoParams = function (isFullClick, _ref2) {
	        var raceId = _ref2.raceId,
	            raceName = _ref2.raceName,
	            datetime = _ref2.datetime,
	            raceTime = _ref2.raceTime,
	            courseName = _ref2.courseName;
	        return {
	            race_id: raceId,
	            race: raceName,
	            date: datetime,
	            replay_type: isFullClick ? 'Full Replay' : 'Closing Stages',
	            location: _this.getClickLocation(),
	            race_time: raceTime,
	            racecourse: courseName
	        };
	    };
	
	    this.getVideo = function (isFullClick, scope, onError) {
	        _this.cacheExpirationCheck(isFullClick);
	
	        return _this.$http.get(_this.getVideoUrl(scope), {
	            cache: isFullClick ? _this.fullReplayCache : _this.closingStagesCache,
	            headers: { 'X-Disable-Redirect': true },
	            timeout: scope.requestCanceler.promise
	        }).then(function (_ref3) {
	            var data = _ref3.data;
	            return data;
	        }).then(function (data) {
	            return _this.trackVideoReplay(data, isFullClick, scope);
	        }).catch(function (err) {
	            return _this.onRequestFailed(err, onError, isFullClick, scope);
	        });
	    };
	
	    Object.assign(this, {
	        $http: $http,
	        $q: $q,
	        fullReplayCache: new $cacheFactory('fullReplayCache'),
	        closingStagesCache: new $cacheFactory('closingStagesCache'),
	        fullReplayCacheExpired: true,
	        closingStagesCacheExpired: true,
	        browserDetectService: browserDetectService,
	        segmentio: segmentio
	    });
	};
	_class.$inject = ["$http", "$q", "$cacheFactory", "browserDetectService"];
	
	exports.default = _class;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = renderSecondaryNav;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(603);
	
	var _rpNavigation = __webpack_require__(153);
	
	var _jquery = __webpack_require__(23);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rpGuiGuide = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * SecondaryNavConfig
	 * Configuration module for secondary navigation.
	 * Builds list of items and renders whole secondary navigation.
	 * @constant navState - Current state of navigation.
	 *                      e.g. time-order
	 * @constant GBOffset - GB offset
	 */
	var navState = _rpNavigation.primary.getItemByTitle('Results').stateManager.prevState; /**
	                                                                                        * Third party imports
	                                                                                        */
	
	var GBOffset = (0, _moment2.default)().tz('Europe/London').utcOffset();
	/**
	 * Forms correct link for specific date.
	 * @param date - date, that should be reflected in link
	 * @param isToday - flag, determining whether passed date is for today
	 * @returns {string} - url
	 */
	function getListResultsLink(date, isToday) {
	    var state = navState && navState.hasOwnProperty('path') ? '/' + navState.path : '';
	    if (isToday) {
	        return state ? state.replace('/', '') : '.';
	    }
	    return '' + date.format('YYYY-MM-DD') + state;
	}
	/**
	 * Method to calculate the date of "now", in GB timezone.
	 * @returns {Moment|number|*}
	 */
	function getGBDate() {
	    var localOffset = GBOffset - (0, _moment2.default)().utcOffset();
	    return (0, _moment2.default)().add(localOffset, 'm');
	}
	/**
	 * Forms list of dates for secondary navigation menu.
	 * @param date - active date, that should be highlighted
	 * @returns {*[]} - array of secondary navigation items
	 */
	function getDateList(date) {
	    var daysCount = 7;
	    var today = getGBDate();
	    var lastDate = today.clone().subtract(daysCount, 'days');
	    var activeDate = date ? (0, _moment2.default)(date) : today;
	    var yesterday = today.clone().subtract(1, 'days');
	    var isYesterday = activeDate.isSame(yesterday, 'day');
	    var isSelectedKnown = !date || isYesterday;
	    var dates = [{
	        name: 'Today',
	        url: getListResultsLink(today, true),
	        isActive: !date || activeDate.isSame(today, 'day'),
	        class: ''
	    }, {
	        name: 'Yesterday',
	        url: getListResultsLink(yesterday),
	        isActive: isYesterday,
	        class: ''
	    }];
	
	    if (!lastDate.isBefore(activeDate)) {
	        isSelectedKnown = true;
	        dates.unshift({
	            name: activeDate.format('ddd, D MMM, YYYY'),
	            url: getListResultsLink(activeDate),
	            isActive: true,
	            class: 'hp-headerMenuItem_fromMedium'
	        });
	    }
	    for (var i = 2; i < daysCount; i++) {
	        var listDate = today.clone().subtract(i, 'days');
	
	        dates.push({
	            name: listDate.format('ddd D'),
	            url: getListResultsLink(listDate),
	            isActive: !isSelectedKnown && activeDate.isSame(listDate, 'day'),
	            class: ''
	        });
	    }
	
	    return dates;
	}
	/**
	 * Setter of item for secondary navigation.
	 * @param item
	 * @param index - item's index
	 * @param array - all items
	 */
	function setSecondaryItem(item, index, array) {
	    var outOfRange = array.length === 8;
	    _rpNavigation.secondary.addItem(item.name, item.url, '', {
	        target: '_self',
	        class: item.class,
	        'data-test-selector': 'link-secondaryMenuDay' + (outOfRange ? index : index + 1)
	    });
	    if (item.isActive) {
	        var activeItem = _rpNavigation.secondary.getItemByTitle(item.name);
	        _rpNavigation.secondary.setActiveItem(activeItem);
	    }
	}
	/**
	 * Removes placeholder (empty) item from initial secondary navigation.
	 */
	function removePlaceholderItem() {
	    var item = _rpNavigation.secondary.getItemByPosition(0);
	
	    _rpNavigation.secondary.removeItem(item);
	}
	/**
	 * Renders secondary navigation
	 */
	function renderSecondaryNav() {
	    var isFullResult = /\/(results|fast-results)\/\d*\//.test(window.location.pathname);
	    var isMobile = _rpGuiGuide.mobileDetect.mobile();
	    var isFullMobile = isMobile && isFullResult;
	    var showSecondary = !isFullResult || isMobile;
	    var dateRegex = isFullMobile ? /^(\/results\/|\/fast-results\/)[\d]*\/[\w|-]*\/([\d|-]*)\//g : /^(\/results\/|\/fast-results\/)([\d|-]*)\/?(.*)/g;
	
	    if (showSecondary) {
	        var parsedPath = dateRegex.exec(window.location.pathname);
	        var pageDate = parsedPath[2];
	        var dateList = getDateList(pageDate);
	
	        removePlaceholderItem();
	        dateList.forEach(setSecondaryItem);
	
	        _rpNavigation.secondary.addItem('Select Date', '', '', {
	            'data-date': pageDate,
	            'data-directive-select-date': '',
	            'data-test-selector': 'link-secondaryMenuDatePicker'
	        }).addItem('Advanced Results Search', '', '', {
	            'data-directive-advanced-search': '',
	            'data-test-selector': 'link-advancedSearch'
	        }).render();
	
	        if (isFullMobile) {
	            (0, _jquery2.default)('.js-secondary').slideDown(300).removeClass('ui-secondaryNavigation_hidden');
	        }
	    }
	}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$http", "config", function ($http, config) {
	    'ngInject';
	
	    var urlCheck = config.get('resultsPath') + '/ugc/checkNotes';
	    var urlGet = config.get('resultsPath') + '/ugc/quickNotesGet';
	    var urlPost = config.get('resultsPath') + '/ugc/quickNotesForm';
	
	    this.checkNotes = function () {
	        return $http.get('' + urlCheck);
	    };
	
	    this.get = function (raceId) {
	        return $http.get(urlGet + '/' + raceId);
	    };
	
	    this.post = function (formData) {
	        return $http.post(urlPost, formData);
	    };
	
	    this.rpNavigationAuthReady = function () {
	        return _rpNavigation.authReady;
	    };
	}];
	
	var _rpNavigation = __webpack_require__(153);

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    'ngInject';
	
	    /**
	     * Instance of userPreference
	     *
	     * @type {object}
	     * @default
	     */
	
	    var _this = this;
	
	    var instance = {};
	
	    /**
	     * Cookie name
	     *
	     * @constant
	     * @type {string}
	     * @default
	     */
	
	    instance.isLocalStorageAvailable = true;
	
	    /**
	     * Type pedigree
	     *
	     * @constant
	     * @type {number}
	     * @default
	     */
	    instance.TYPE_PEDIGREE = 'pedigree';
	
	    /**
	     * Type comments
	     *
	     * @constant
	     * @type {number}
	     * @default
	     */
	    instance.TYPE_COMMENTS = 'comments';
	
	    /**
	     * Type listSort
	     *
	     * @constant
	     * @type {number}
	     * @default
	     */
	    instance.TYPE_LIST_SORT = 'list_sort';
	
	    /**
	     * Type accordion state
	     *
	     * @constant
	     * @type {number}
	     * @default
	     */
	    instance.TYPE_ACCORDION_STATE = 'accordion_state';
	
	    /**
	     * Var listSort Course
	     *
	     * @constant
	     * @type {string}
	     * @default
	     */
	    instance.VAR_LIST_SORT_COURSE = 'course';
	
	    /**
	     * Var listSort Time
	     *
	     * @constant
	     * @type {string}
	     * @default
	     */
	    instance.VAR_LIST_SORT_TIME = 'time';
	
	    instance.storage = {
	        getItem: function getItem(key) {
	            if (_this.hasOwnProperty(key)) {
	                return _this[key];
	            }
	
	            return null;
	        },
	        setItem: function setItem(key, value) {
	            _this[key] = value;
	        }
	    };
	
	    /**
	     * Getter for cookieName
	     */
	    instance.getStorageItemName = function () {
	        return _storage.STORAGE_ITEM_NAME;
	    };
	
	    /**
	     * Setter for preferenceList
	     *
	     * @param {object} preferenceList
	     */
	    instance.setPreferenceList = function (preferenceList) {
	        try {
	            localStorage.setItem(instance.getStorageItemName(), JSON.stringify(preferenceList));
	        } catch (e) {
	            instance.isLocalStorageAvailable = false;
	            instance.storage.setItem(instance.getStorageItemName(), JSON.stringify(preferenceList));
	            console.warn('You are in a private mode, and we couldn\'t save your preference.');
	        }
	    };
	
	    /**
	     * Getter for preferencesList
	     */
	    instance.getPreferenceList = function () {
	        var storage = instance.isLocalStorageAvailable ? localStorage : instance.storage;
	
	        return JSON.parse(storage.getItem(instance.getStorageItemName())) || {};
	    };
	
	    /**
	     * Getter for preferencesList
	     *
	     * @param {number} key
	     */
	    instance.get = function (key) {
	        var preferencesList = instance.getPreferenceList();
	
	        if (!preferencesList.hasOwnProperty(key)) {
	            return false;
	        }
	
	        return preferencesList[key];
	    };
	
	    /**
	     * Setter for preferencesList
	     *
	     * @param {number} key
	     * @param {number|bool} value
	     */
	    instance.set = function (key, value) {
	        var preferencesList = instance.getPreferenceList();
	
	        preferencesList[key] = value;
	        instance.setPreferenceList(preferencesList);
	    };
	
	    /**
	     * Toggles user preference
	     *
	     * @param {number} key
	     */
	    instance.toggle = function (key) {
	        var preferencesList = instance.getPreferenceList();
	
	        preferencesList[key] = !preferencesList[key];
	        instance.setPreferenceList(preferencesList);
	        (0, _jquery2.default)(window).trigger(_storage.UPDATE_TARGETING);
	    };
	
	    /**
	     * Toggle today's offers panel hide class
	     */
	    instance.initHideTodaysOffersPanel = function () {
	        (0, _jquery2.default)(_storage.BETTING_SPECIAL_OFFER_CLASS).toggleClass(_storage.HIDE_OFFER_CLASS);
	    };
	
	    /**
	     * Indicates whether user has set specific preference
	     *
	     * @param {number} key
	     * */
	    instance.isPreferenceSet = function (key) {
	        var preferencesList = instance.getPreferenceList();
	
	        return preferencesList.hasOwnProperty(key);
	    };
	
	    return instance;
	};
	
	var _jquery = __webpack_require__(23);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _storage = __webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1704 */
783,
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(733);
	
	/*<replacement>*/
	var util = __webpack_require__(162);
	util.inherits = __webpack_require__(149);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(259).Buffer;
	var util = __webpack_require__(1879);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(732);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(734);
	exports.Duplex = __webpack_require__(151);
	exports.Transform = __webpack_require__(733);
	exports.PassThrough = __webpack_require__(1705);


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1707).Transform


/***/ }),
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */
/***/ (function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(252);
	var trees   = __webpack_require__(1719);
	var adler32 = __webpack_require__(741);
	var crc32   = __webpack_require__(742);
	var msg     = __webpack_require__(743);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(252);
	var adler32       = __webpack_require__(741);
	var crc32         = __webpack_require__(742);
	var inflate_fast  = __webpack_require__(1716);
	var inflate_table = __webpack_require__(1718);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(252);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(252);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(105));
		else if(typeof define === 'function' && define.amd)
			define(["rp-analytics"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 25);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var BREAKPOINTS = exports.BREAKPOINTS = {
	    TABLET: 719.9,
	    DESKTOP: 989.9
	};
	
	var isMobile = exports.isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
	var isTabletBeakpoint = exports.isTabletBeakpoint = window.screen.width > 719;
	var isDesktopBeakpoint = exports.isDesktopBeakpoint = window.screen.width > 989.9;
	
	var isRacecardsOrResults = exports.isRacecardsOrResults = window.location.pathname.includes('/racecards/') || window.location.pathname.includes('/results/') || window.location.pathname.includes('/fast-results/');
	
	var tierBookmakers = exports.tierBookmakers = {
	    tierOne: 'Tier 1',
	    tierTwo: 'Tier 2'
	};
	
	var BOOKMAKER_STATUS = exports.BOOKMAKER_STATUS = {
	    OPEN: 'open',
	    CLOSE: 'close'
	};
	
	var BOOKMAKER_ANALYTICS = exports.BOOKMAKER_ANALYTICS = {
	    MORE_OFFERS_TITLE: 'More Offers',
	    TODAYS_OFFERS_TITLE: "Today's Offers",
	    TODAYS_OFFERS_TITLE_QUICK_LINK: "Today's Offers - Quick Link"
	};
	
	var COUNTRY_CODES = exports.COUNTRY_CODES = {
	    IRE: 'IRE',
	    IE: 'IE'
	};
	
	var CURRENCY_SYMBOLS = exports.CURRENCY_SYMBOLS = {
	    GBP: '£',
	    EUR: '€'
	};
	
	var BOOKMAKER_OFFER_TYPE = exports.BOOKMAKER_OFFER_TYPE = {
	    TIER_ONE: 'Tier 1',
	    EXCLUSIVE: 'Exclusive'
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.v = exports.u = exports.t = exports.s = exports.r = exports.q = exports.p = exports.o = exports.n = exports.m = exports.l = exports.k = exports.j = exports.i = exports.h = exports.g = exports.f = exports.e = exports.d = exports.c = exports.b = exports.a = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ssrWindowEsm = __webpack_require__(6);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function classesToTokens(classes) {
	  if (classes === void 0) {
	    classes = '';
	  }
	  return classes.trim().split(' ').filter(function (c) {
	    return !!c.trim();
	  });
	}
	
	function deleteProps(obj) {
	  var object = obj;
	  Object.keys(object).forEach(function (key) {
	    try {
	      object[key] = null;
	    } catch (e) {
	      // no getter for object
	    }
	    try {
	      delete object[key];
	    } catch (e) {
	      // something got wrong
	    }
	  });
	}
	function nextTick(callback, delay) {
	  if (delay === void 0) {
	    delay = 0;
	  }
	  return setTimeout(callback, delay);
	}
	function now() {
	  return Date.now();
	}
	function getComputedStyle(el) {
	  var window = (0, _ssrWindowEsm.a)();
	  var style = void 0;
	  if (window.getComputedStyle) {
	    style = window.getComputedStyle(el, null);
	  }
	  if (!style && el.currentStyle) {
	    style = el.currentStyle;
	  }
	  if (!style) {
	    style = el.style;
	  }
	  return style;
	}
	function getTranslate(el, axis) {
	  if (axis === void 0) {
	    axis = 'x';
	  }
	  var window = (0, _ssrWindowEsm.a)();
	  var matrix = void 0;
	  var curTransform = void 0;
	  var transformMatrix = void 0;
	  var curStyle = getComputedStyle(el);
	  if (window.WebKitCSSMatrix) {
	    curTransform = curStyle.transform || curStyle.webkitTransform;
	    if (curTransform.split(',').length > 6) {
	      curTransform = curTransform.split(', ').map(function (a) {
	        return a.replace(',', '.');
	      }).join(', ');
	    }
	    // Some old versions of Webkit choke when 'none' is passed; pass
	    // empty string instead in this case
	    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	  } else {
	    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	    matrix = transformMatrix.toString().split(',');
	  }
	  if (axis === 'x') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
	    // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
	      // Normal Browsers
	      else curTransform = parseFloat(matrix[4]);
	  }
	  if (axis === 'y') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
	    // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
	      // Normal Browsers
	      else curTransform = parseFloat(matrix[5]);
	  }
	  return curTransform || 0;
	}
	function isObject(o) {
	  return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
	}
	function isNode(node) {
	  // eslint-disable-next-line
	  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
	    return node instanceof HTMLElement;
	  }
	  return node && (node.nodeType === 1 || node.nodeType === 11);
	}
	function extend() {
	  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
	  var noExtend = ['__proto__', 'constructor', 'prototype'];
	  for (var i = 1; i < arguments.length; i += 1) {
	    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
	    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
	      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
	        return noExtend.indexOf(key) < 0;
	      });
	      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	        var nextKey = keysArray[nextIndex];
	        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	        if (desc !== undefined && desc.enumerable) {
	          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend(to[nextKey], nextSource[nextKey]);
	            }
	          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            to[nextKey] = {};
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend(to[nextKey], nextSource[nextKey]);
	            }
	          } else {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	  }
	  return to;
	}
	function setCSSProperty(el, varName, varValue) {
	  el.style.setProperty(varName, varValue);
	}
	function animateCSSModeScroll(_ref) {
	  var swiper = _ref.swiper,
	      targetPosition = _ref.targetPosition,
	      side = _ref.side;
	
	  var window = (0, _ssrWindowEsm.a)();
	  var startPosition = -swiper.translate;
	  var startTime = null;
	  var time = void 0;
	  var duration = swiper.params.speed;
	  swiper.wrapperEl.style.scrollSnapType = 'none';
	  window.cancelAnimationFrame(swiper.cssModeFrameID);
	  var dir = targetPosition > startPosition ? 'next' : 'prev';
	  var isOutOfBound = function isOutOfBound(current, target) {
	    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
	  };
	  var animate = function animate() {
	    time = new Date().getTime();
	    if (startTime === null) {
	      startTime = time;
	    }
	    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	    var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
	    var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
	    if (isOutOfBound(currentPosition, targetPosition)) {
	      currentPosition = targetPosition;
	    }
	    swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
	    if (isOutOfBound(currentPosition, targetPosition)) {
	      swiper.wrapperEl.style.overflow = 'hidden';
	      swiper.wrapperEl.style.scrollSnapType = '';
	      setTimeout(function () {
	        swiper.wrapperEl.style.overflow = '';
	        swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
	      });
	      window.cancelAnimationFrame(swiper.cssModeFrameID);
	      return;
	    }
	    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
	  };
	  animate();
	}
	function getSlideTransformEl(slideEl) {
	  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
	}
	function elementChildren(element, selector) {
	  if (selector === void 0) {
	    selector = '';
	  }
	  return [].concat(_toConsumableArray(element.children)).filter(function (el) {
	    return el.matches(selector);
	  });
	}
	function showWarning(text) {
	  try {
	    console.warn(text);
	    return;
	  } catch (err) {
	    // err
	  }
	}
	function createElement(tag, classes) {
	  var _el$classList;
	
	  if (classes === void 0) {
	    classes = [];
	  }
	  var el = document.createElement(tag);
	  (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(Array.isArray(classes) ? classes : classesToTokens(classes)));
	  return el;
	}
	function elementOffset(el) {
	  var window = (0, _ssrWindowEsm.a)();
	  var document = (0, _ssrWindowEsm.g)();
	  var box = el.getBoundingClientRect();
	  var body = document.body;
	  var clientTop = el.clientTop || body.clientTop || 0;
	  var clientLeft = el.clientLeft || body.clientLeft || 0;
	  var scrollTop = el === window ? window.scrollY : el.scrollTop;
	  var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	  return {
	    top: box.top + scrollTop - clientTop,
	    left: box.left + scrollLeft - clientLeft
	  };
	}
	function elementPrevAll(el, selector) {
	  var prevEls = [];
	  while (el.previousElementSibling) {
	    var prev = el.previousElementSibling; // eslint-disable-line
	    if (selector) {
	      if (prev.matches(selector)) prevEls.push(prev);
	    } else prevEls.push(prev);
	    el = prev;
	  }
	  return prevEls;
	}
	function elementNextAll(el, selector) {
	  var nextEls = [];
	  while (el.nextElementSibling) {
	    var next = el.nextElementSibling; // eslint-disable-line
	    if (selector) {
	      if (next.matches(selector)) nextEls.push(next);
	    } else nextEls.push(next);
	    el = next;
	  }
	  return nextEls;
	}
	function elementStyle(el, prop) {
	  var window = (0, _ssrWindowEsm.a)();
	  return window.getComputedStyle(el, null).getPropertyValue(prop);
	}
	function elementIndex(el) {
	  var child = el;
	  var i = void 0;
	  if (child) {
	    i = 0;
	    // eslint-disable-next-line
	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) i += 1;
	    }
	    return i;
	  }
	  return undefined;
	}
	function elementParents(el, selector) {
	  var parents = []; // eslint-disable-line
	  var parent = el.parentElement; // eslint-disable-line
	  while (parent) {
	    if (selector) {
	      if (parent.matches(selector)) parents.push(parent);
	    } else {
	      parents.push(parent);
	    }
	    parent = parent.parentElement;
	  }
	  return parents;
	}
	function elementTransitionEnd(el, callback) {
	  function fireCallBack(e) {
	    if (e.target !== el) return;
	    callback.call(el, e);
	    el.removeEventListener('transitionend', fireCallBack);
	  }
	  if (callback) {
	    el.addEventListener('transitionend', fireCallBack);
	  }
	}
	function elementOuterSize(el, size, includeMargins) {
	  var window = (0, _ssrWindowEsm.a)();
	  if (includeMargins) {
	    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
	  }
	  return el.offsetWidth;
	}
	function makeElementsArray(el) {
	  return (Array.isArray(el) ? el : [el]).filter(function (e) {
	    return !!e;
	  });
	}
	
	exports.a = elementParents;
	exports.b = elementOffset;
	exports.c = createElement;
	exports.d = now;
	exports.e = elementChildren;
	exports.f = elementOuterSize;
	exports.g = elementIndex;
	exports.h = classesToTokens;
	exports.i = getTranslate;
	exports.j = elementTransitionEnd;
	exports.k = isObject;
	exports.l = getSlideTransformEl;
	exports.m = makeElementsArray;
	exports.n = nextTick;
	exports.o = elementStyle;
	exports.p = elementNextAll;
	exports.q = elementPrevAll;
	exports.r = animateCSSModeScroll;
	exports.s = setCSSProperty;
	exports.t = showWarning;
	exports.u = extend;
	exports.v = deleteProps;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.orderByPosition = undefined;
	
	var _shuffleArray = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// eslint-disable-next-line import/prefer-default-export
	var orderByPosition = exports.orderByPosition = function orderByPosition(offers) {
	    var withPosition = [];
	    var nonPositioned = [];
	    offers.forEach(function (offer) {
	        if (offer.position && offer.position !== 0) {
	            withPosition.push(offer);
	        } else nonPositioned.push(offer);
	    });
	
	    return [].concat(_toConsumableArray(withPosition.sort(function (a, b) {
	        return a.position - b.position;
	    })), _toConsumableArray((0, _shuffleArray.shuffleArray)(nonPositioned, new Date().getTime())));
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// eslint-disable-next-line import/prefer-default-export
	var BOOKMAKERS_DISPLAY_NAME = {
	    matchbook: 'Matchbook',
	    netbet: 'Netbet',
	    sbk: 'SBK',
	    copybet: 'CopyBet',
	    kwiff: 'Kwiff',
	    boylesports: 'Boyle Sports',
	    unibet: 'Unibet',
	    parimatch: 'Parimatch',
	    spreadex: 'SpreadEx',
	    planetsports: 'Planet Sports',
	    easybet: 'EasyBet',
	    bet365: 'bet365',
	    skybet: 'SkyBet',
	    coral: 'Coral',
	    ladbrokes: 'Ladbrokes',
	    paddypower: 'Paddy Power',
	    betfair: 'Betfair',
	    williamhill: 'William Hill',
	    tote: 'Tote',
	    betmgm: 'BetMGM',
	    betway: 'Betway',
	    livescore: 'Livescore',
	    virginbet: 'Virgin Bet',
	    midnite: 'Midnite',
	    bzeebet: 'Bzeebet',
	    betfred: 'Betfred',
	    betgoodwin: 'BetGoodwin',
	    starsports: 'Star Sports',
	    '10bet': '10Bet',
	    jeffbet: 'JeffBet'
	};
	
	/* eslint-disable import/prefer-default-export */
	var getBookmakersName = exports.getBookmakersName = function getBookmakersName(name) {
	    return BOOKMAKERS_DISPLAY_NAME[name.toLowerCase().replace(' ', '')];
	};
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// eslint-disable-next-line import/prefer-default-export
	var shuffleArray = exports.shuffleArray = function shuffleArray(items, seed) {
	    var arr = [].concat(_toConsumableArray(items));
	    var currentIndex = arr.length;
	    var temporaryValue = void 0;
	    var randomIndex = void 0;
	
	    // The numbers 9301, 49297, and 233280 are part of a linear congruential generator (LCG),
	    // A simple formula used to generate a sequence of pseudo-random numbers.
	    var random = function random(max) {
	        var newSeed = (seed * 9301 + 49297) % 233280;
	        return Math.floor(newSeed / 233280 * max);
	    };
	
	    while (currentIndex !== 0) {
	        randomIndex = random(currentIndex);
	        currentIndex -= 1;
	        temporaryValue = arr[currentIndex];
	        arr[currentIndex] = arr[randomIndex];
	        arr[randomIndex] = temporaryValue;
	    }
	
	    return arr;
	};
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * SSR Window 4.0.2
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2021, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: December 13, 2021
	 */
	/* eslint-disable no-param-reassign */
	function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
	}
	function extend(target, src) {
	  if (target === void 0) {
	    target = {};
	  }
	  if (src === void 0) {
	    src = {};
	  }
	  Object.keys(src).forEach(function (key) {
	    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
	      extend(target[key], src[key]);
	    }
	  });
	}
	var ssrDocument = {
	  body: {},
	  addEventListener: function addEventListener() {},
	  removeEventListener: function removeEventListener() {},
	
	  activeElement: {
	    blur: function blur() {},
	
	    nodeName: ''
	  },
	  querySelector: function querySelector() {
	    return null;
	  },
	  querySelectorAll: function querySelectorAll() {
	    return [];
	  },
	  getElementById: function getElementById() {
	    return null;
	  },
	  createEvent: function createEvent() {
	    return {
	      initEvent: function initEvent() {}
	    };
	  },
	  createElement: function createElement() {
	    return {
	      children: [],
	      childNodes: [],
	      style: {},
	      setAttribute: function setAttribute() {},
	      getElementsByTagName: function getElementsByTagName() {
	        return [];
	      }
	    };
	  },
	  createElementNS: function createElementNS() {
	    return {};
	  },
	  importNode: function importNode() {
	    return null;
	  },
	
	  location: {
	    hash: '',
	    host: '',
	    hostname: '',
	    href: '',
	    origin: '',
	    pathname: '',
	    protocol: '',
	    search: ''
	  }
	};
	function getDocument() {
	  var doc = typeof document !== 'undefined' ? document : {};
	  extend(doc, ssrDocument);
	  return doc;
	}
	var ssrWindow = {
	  document: ssrDocument,
	  navigator: {
	    userAgent: ''
	  },
	  location: {
	    hash: '',
	    host: '',
	    hostname: '',
	    href: '',
	    origin: '',
	    pathname: '',
	    protocol: '',
	    search: ''
	  },
	  history: {
	    replaceState: function replaceState() {},
	    pushState: function pushState() {},
	    go: function go() {},
	    back: function back() {}
	  },
	  CustomEvent: function CustomEvent() {
	    return this;
	  },
	  addEventListener: function addEventListener() {},
	  removeEventListener: function removeEventListener() {},
	  getComputedStyle: function getComputedStyle() {
	    return {
	      getPropertyValue: function getPropertyValue() {
	        return '';
	      }
	    };
	  },
	  Image: function Image() {},
	  Date: function Date() {},
	
	  screen: {},
	  setTimeout: function setTimeout() {},
	  clearTimeout: function clearTimeout() {},
	  matchMedia: function matchMedia() {
	    return {};
	  },
	  requestAnimationFrame: function requestAnimationFrame(callback) {
	    if (typeof setTimeout === 'undefined') {
	      callback();
	      return null;
	    }
	    return setTimeout(callback, 0);
	  },
	  cancelAnimationFrame: function cancelAnimationFrame(id) {
	    if (typeof setTimeout === 'undefined') {
	      return;
	    }
	    clearTimeout(id);
	  }
	};
	function getWindow() {
	  var win = typeof window !== 'undefined' ? window : {};
	  extend(win, ssrWindow);
	  return win;
	}
	
	exports.a = getWindow;
	exports.g = getDocument;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _swiperCore = __webpack_require__(19);
	
	Object.defineProperty(exports, 'Swiper', {
	  enumerable: true,
	  get: function get() {
	    return _swiperCore.S;
	  }
	});
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _swiperCore.S;
	  }
	});
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.replaceCurrencySigns = undefined;
	
	var _constants = __webpack_require__(0);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// eslint-disable-next-line import/prefer-default-export
	var replaceCurrencySigns = exports.replaceCurrencySigns = function replaceCurrencySigns() {
	    var oddsComparisonPrices = document.getElementsByClassName('RC-oddsRaceContent__dataOffer');
	    var betPopupsHeadline = document.getElementsByClassName('RC-oddsRaceContent__offerPopoverHeadline');
	    var betPopupsOffer = document.getElementsByClassName('RC-oddsRaceContent__offerPopoverOffer');
	    var chooseBookieOffers = document.getElementsByClassName('RC-chooseBookieMobile__buttonFreeBet');
	
	    Array.from([].concat(_toConsumableArray(oddsComparisonPrices), _toConsumableArray(betPopupsHeadline), _toConsumableArray(betPopupsOffer), _toConsumableArray(chooseBookieOffers))).forEach(function (element) {
	        // eslint-disable-next-line
	        element.innerHTML = element.innerHTML.replaceAll(_constants.CURRENCY_SYMBOLS.GBP, _constants.CURRENCY_SYMBOLS.EUR);
	    });
	};
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// eslint-disable-next-line import/prefer-default-export
	var chunkArray = exports.chunkArray = function chunkArray(array, chunkSize) {
	    var result = [];
	    for (var i = 0; i < array.length; i += chunkSize) {
	        result.push(array.slice(i, i + chunkSize));
	    }
	    return result;
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getBookmakersToShow = exports.shouldShowBookmaker = undefined;
	
	var _constants = __webpack_require__(0);
	
	var _localStorageHandlers = __webpack_require__(26);
	
	/**
	 * Filters out bookmakers that the user has either:
	 * - Marked as having an account with during the bookmaker quiz
	 * - Recently logged into
	 *
	 * Quiz location: 'https://www.racingpost.com/free-bets/bookmakers-quiz/'
	 *
	 * @param {Array} offers - List of bookmaker offers to filter.
	 *
	 * Excluded bookmakers are determined based on stored user data:s
	 * - `__user_traits` (stores bookmakers selected in the quiz)
	 * - `__recent_bookmakers` (stores recently logged-in bookmakers)
	 *
	 * @returns {Array} - A filtered list of bookmakers that are still eligible to be shown.
	 * NOTE: It's valid only for TIER ONE bookmaker offers.
	 */
	
	/* eslint-disable no-multi-spaces, arrow-parens, import/prefer-default-export */
	var getTransformedBookmakerName = function getTransformedBookmakerName(bookmaker, type, isContainInQuiz) {
	    if (isContainInQuiz) {
	        var bookmakerNameQuiz = type === _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE ? bookmaker.displayName.toLowerCase().replace(' ', '_') : bookmaker.name.toLowerCase().replace(' ', '_');
	
	        return bookmakerNameQuiz.includes('skybet') ? 'sky_bet_quiz' : bookmakerNameQuiz + '_quiz';
	    }
	
	    return type === _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE ? bookmaker.displayName.toLowerCase().replace(' ', '') : bookmaker.name.toLowerCase().replace(' ', '');
	};
	
	var shouldShowBookmaker = exports.shouldShowBookmaker = function shouldShowBookmaker(bookmaker, type) {
	    var userTraits = (0, _localStorageHandlers.tryParseJson)((0, _localStorageHandlers.getLocalStorageItem)('__user_traits') || '{}');
	    var recentBookmakers = (0, _localStorageHandlers.tryParseJson)((0, _localStorageHandlers.getLocalStorageItem)('recentBookmakers') || '{}');
	    var isTierOne = bookmaker.isTierOne || Number(bookmaker.bookmaker_tier) === 1;
	
	    if (!isTierOne) {
	        return true;
	    }
	
	    return !userTraits[getTransformedBookmakerName(bookmaker, type, true)] && !recentBookmakers[getTransformedBookmakerName(bookmaker, type, false)];
	};
	
	var getBookmakersToShow = exports.getBookmakersToShow = function getBookmakersToShow(bookmakerOffers, type) {
	    return bookmakerOffers.filter(function (bookmaker) {
	        return shouldShowBookmaker(bookmaker, type);
	    });
	};
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bookmakersExclusiveOffersPanel = __webpack_require__(20);
	
	var _bookmakersExclusiveOffersPanel2 = _interopRequireDefault(_bookmakersExclusiveOffersPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Tranfsorm bookmakers and filter
	 * by display_offer to be visible in the carousel
	 *
	 * @param { Object } bookmakers
	 * @returns { desktopBookmakers, mobileBookmakers }
	 *
	 */
	var transformBookmakersExclusive = function transformBookmakersExclusive(bookmakers) {
	    var desktopBookmakers = [];
	    var mobileBookmakers = [];
	
	    // eslint-disable-next-line no-restricted-syntax
	    for (var bookmakerKey in bookmakers) {
	        if (bookmakers[bookmakerKey].desktop && bookmakers[bookmakerKey].desktop.display_offer === 'true' && bookmakers[bookmakerKey].desktop.name !== null) {
	            desktopBookmakers.push(bookmakers[bookmakerKey].desktop);
	        }
	
	        if (bookmakers[bookmakerKey].mobile && bookmakers[bookmakerKey].mobile.display_offer === 'true' && bookmakers[bookmakerKey].mobile.name !== null) {
	            mobileBookmakers.push(bookmakers[bookmakerKey].mobile);
	        }
	    }
	
	    return { desktopBookmakers: desktopBookmakers, mobileBookmakers: mobileBookmakers };
	};
	
	var fetchBookmakerExclusiveOffers = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return fetch(window.location.origin + '/api/stubs/bookmaker-exclusive-offers/').then(function (response) {
	                            if (!response.ok) {
	                                throw new Error('Network response was not ok');
	                            }
	
	                            return response.json();
	                        }).then(function (data) {
	                            var _transformBookmakersE = transformBookmakersExclusive(data.exclusiveOffers),
	                                desktopBookmakers = _transformBookmakersE.desktopBookmakers,
	                                mobileBookmakers = _transformBookmakersE.mobileBookmakers;
	
	                            (0, _bookmakersExclusiveOffersPanel2.default)(desktopBookmakers, mobileBookmakers);
	                        }).catch(function (error) {
	                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
	                        });
	
	                    case 2:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function fetchBookmakerExclusiveOffers() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	exports.default = fetchBookmakerExclusiveOffers;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(0);
	
	var _replaceCurrencySigns = __webpack_require__(8);
	
	var _renderPromotedTierTwoBookmakers = __webpack_require__(23);
	
	var _renderPromotedTierTwoBookmakers2 = _interopRequireDefault(_renderPromotedTierTwoBookmakers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchBookmakersMixedTier = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-mixed-tier/').then(function (response) {
	                            if (!response.ok) {
	                                throw new Error('Network response was not ok');
	                            }
	
	                            return response.json();
	                        }).then(function (data) {
	                            if (data.shortCode === _constants.COUNTRY_CODES.IRE || data.shortCode === _constants.COUNTRY_CODES.IE) {
	                                (0, _replaceCurrencySigns.replaceCurrencySigns)();
	                            }
	
	                            var bookmakerOffersTierTwoDesktop = data.bookmakerOffersTierTwoDesktop,
	                                bookmakerOffersTierTwoMobile = data.bookmakerOffersTierTwoMobile;
	
	
	                            (0, _renderPromotedTierTwoBookmakers2.default)(bookmakerOffersTierTwoDesktop, bookmakerOffersTierTwoMobile);
	                        }).catch(function (error) {
	                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
	                        });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function fetchBookmakersMixedTier() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	exports.default = fetchBookmakersMixedTier;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _renderTierOneBookmakers = __webpack_require__(24);
	
	var _renderTierOneBookmakers2 = _interopRequireDefault(_renderTierOneBookmakers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fetchBookmakersTierOne = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-tier-one/').then(function (response) {
	                            if (!response.ok) {
	                                throw new Error('Network response was not ok');
	                            }
	
	                            return response.json();
	                        }).then(function (data) {
	                            (0, _renderTierOneBookmakers2.default)(data.bookmakerOffersDesktop, data.bookmakerOffersMobile, data.freeBetsDesktopOffers, data.freeBetsMobileOffers);
	                        }).catch(function (error) {
	                            console.error('There was an error fetching the data for tier 1 bookmaker offer', error);
	                        });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function fetchBookmakersTierOne() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	exports.default = fetchBookmakersTierOne;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(0);
	
	var _orderByPosition = __webpack_require__(2);
	
	var _bookmakersTierTwoPanel = __webpack_require__(22);
	
	var _bookmakersTierTwoPanel2 = _interopRequireDefault(_bookmakersTierTwoPanel);
	
	var _replaceCurrencySigns = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var transformBookmakersTierTwo = function transformBookmakersTierTwo(bookmakers) {
	    var bookmakerOffersTierTwoDesktop = bookmakers.bookmakerOffersTierTwoDesktop,
	        bookmakerOffersTierTwoMobile = bookmakers.bookmakerOffersTierTwoMobile;
	
	    // Those offers are used for T2/T3 bookmaker offers panel
	
	    var moreOffersBookmakers = _constants.isMobile ? bookmakerOffersTierTwoMobile : bookmakerOffersTierTwoDesktop;
	    var filteredMoreOffers = moreOffersBookmakers.filter(function (bookmaker) {
	        return bookmaker.name && bookmaker.includeInTier2Panel;
	    });
	    var filteredMoreOffersBookmakers = (0, _orderByPosition.orderByPosition)(filteredMoreOffers);
	
	    return { filteredMoreOffersBookmakers: filteredMoreOffersBookmakers };
	};
	
	var fetchBookmakersTierTwo = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-tier-two/').then(function (response) {
	                            if (!response.ok) {
	                                throw new Error('Network response was not ok');
	                            }
	
	                            return response.json();
	                        }).then(function (data) {
	                            var _transformBookmakersT = transformBookmakersTierTwo(data),
	                                filteredMoreOffersBookmakers = _transformBookmakersT.filteredMoreOffersBookmakers;
	
	                            if (_constants.isRacecardsOrResults) {
	                                (0, _bookmakersTierTwoPanel2.default)(filteredMoreOffersBookmakers);
	                            }
	
	                            if (data.shortCode === _constants.COUNTRY_CODES.IRE || data.shortCode === _constants.COUNTRY_CODES.IE) {
	                                (0, _replaceCurrencySigns.replaceCurrencySigns)();
	                            }
	                        }).catch(function (error) {
	                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
	                        });
	
	                    case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                    case 3:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function fetchBookmakersTierTwo() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	exports.default = fetchBookmakersTierTwo;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _classesToSelector = __webpack_require__(17);
	
	var _createElementIfNotDefined = __webpack_require__(18);
	
	var _utils = __webpack_require__(1);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function Pagination(_ref) {
	  var swiper = _ref.swiper,
	      extendParams = _ref.extendParams,
	      on = _ref.on,
	      emit = _ref.emit;
	
	  var pfx = 'swiper-pagination';
	  extendParams({
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets',
	      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: function formatFractionCurrent(number) {
	        return number;
	      },
	      formatFractionTotal: function formatFractionTotal(number) {
	        return number;
	      },
	      bulletClass: pfx + '-bullet',
	      bulletActiveClass: pfx + '-bullet-active',
	      modifierClass: pfx + '-',
	      currentClass: pfx + '-current',
	      totalClass: pfx + '-total',
	      hiddenClass: pfx + '-hidden',
	      progressbarFillClass: pfx + '-progressbar-fill',
	      progressbarOppositeClass: pfx + '-progressbar-opposite',
	      clickableClass: pfx + '-clickable',
	      lockClass: pfx + '-lock',
	      horizontalClass: pfx + '-horizontal',
	      verticalClass: pfx + '-vertical',
	      paginationDisabledClass: pfx + '-disabled'
	    }
	  });
	  swiper.pagination = {
	    el: null,
	    bullets: []
	  };
	  var bulletSize = void 0;
	  var dynamicBulletIndex = 0;
	  function isPaginationDisabled() {
	    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
	  }
	  function setSideBullets(bulletEl, position) {
	    var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
	
	    if (!bulletEl) return;
	    bulletEl = bulletEl[(position === 'prev' ? 'previous' : 'next') + 'ElementSibling'];
	    if (bulletEl) {
	      bulletEl.classList.add(bulletActiveClass + '-' + position);
	      bulletEl = bulletEl[(position === 'prev' ? 'previous' : 'next') + 'ElementSibling'];
	      if (bulletEl) {
	        bulletEl.classList.add(bulletActiveClass + '-' + position + '-' + position);
	      }
	    }
	  }
	  function onBulletClick(e) {
	    var bulletEl = e.target.closest((0, _classesToSelector.c)(swiper.params.pagination.bulletClass));
	    if (!bulletEl) {
	      return;
	    }
	    e.preventDefault();
	    var index = (0, _utils.g)(bulletEl) * swiper.params.slidesPerGroup;
	    if (swiper.params.loop) {
	      if (swiper.realIndex === index) return;
	      swiper.slideToLoop(index);
	    } else {
	      swiper.slideTo(index);
	    }
	  }
	  function update() {
	    // Render || Update Pagination bullets/items
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    var el = swiper.pagination.el;
	    el = (0, _utils.m)(el);
	    // Current/Total
	    var current = void 0;
	    var previousIndex = void 0;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	    if (swiper.params.loop) {
	      previousIndex = swiper.previousRealIndex || 0;
	      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	      previousIndex = swiper.previousSnapIndex;
	    } else {
	      previousIndex = swiper.previousIndex || 0;
	      current = swiper.activeIndex || 0;
	    }
	    // Types
	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      var firstIndex = void 0;
	      var lastIndex = void 0;
	      var midIndex = void 0;
	      if (params.dynamicBullets) {
	        bulletSize = (0, _utils.f)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
	        el.forEach(function (subEl) {
	          subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = bulletSize * (params.dynamicMainBullets + 4) + 'px';
	        });
	        if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
	          dynamicBulletIndex += current - (previousIndex || 0);
	          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
	            dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (dynamicBulletIndex < 0) {
	            dynamicBulletIndex = 0;
	          }
	        }
	        firstIndex = Math.max(current - dynamicBulletIndex, 0);
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }
	      bullets.forEach(function (bulletEl) {
	        var _bulletEl$classList;
	
	        var classesToRemove = [].concat(_toConsumableArray(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(function (suffix) {
	          return '' + params.bulletActiveClass + suffix;
	        }))).map(function (s) {
	          return typeof s === 'string' && s.includes(' ') ? s.split(' ') : s;
	        }).flat();
	        (_bulletEl$classList = bulletEl.classList).remove.apply(_bulletEl$classList, _toConsumableArray(classesToRemove));
	      });
	      if (el.length > 1) {
	        bullets.forEach(function (bullet) {
	          var bulletIndex = (0, _utils.g)(bullet);
	          if (bulletIndex === current) {
	            var _bullet$classList;
	
	            (_bullet$classList = bullet.classList).add.apply(_bullet$classList, _toConsumableArray(params.bulletActiveClass.split(' ')));
	          } else if (swiper.isElement) {
	            bullet.setAttribute('part', 'bullet');
	          }
	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              var _bullet$classList2;
	
	              (_bullet$classList2 = bullet.classList).add.apply(_bullet$classList2, _toConsumableArray((params.bulletActiveClass + '-main').split(' ')));
	            }
	            if (bulletIndex === firstIndex) {
	              setSideBullets(bullet, 'prev');
	            }
	            if (bulletIndex === lastIndex) {
	              setSideBullets(bullet, 'next');
	            }
	          }
	        });
	      } else {
	        var bullet = bullets[current];
	        if (bullet) {
	          var _bullet$classList3;
	
	          (_bullet$classList3 = bullet.classList).add.apply(_bullet$classList3, _toConsumableArray(params.bulletActiveClass.split(' ')));
	        }
	        if (swiper.isElement) {
	          bullets.forEach(function (bulletEl, bulletIndex) {
	            bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
	          });
	        }
	        if (params.dynamicBullets) {
	          var firstDisplayedBullet = bullets[firstIndex];
	          var lastDisplayedBullet = bullets[lastIndex];
	          for (var i = firstIndex; i <= lastIndex; i += 1) {
	            if (bullets[i]) {
	              var _bullets$i$classList;
	
	              (_bullets$i$classList = bullets[i].classList).add.apply(_bullets$i$classList, _toConsumableArray((params.bulletActiveClass + '-main').split(' ')));
	            }
	          }
	          setSideBullets(firstDisplayedBullet, 'prev');
	          setSideBullets(lastDisplayedBullet, 'next');
	        }
	      }
	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.forEach(function (bullet) {
	          bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = bulletsOffset + 'px';
	        });
	      }
	    }
	    el.forEach(function (subEl, subElIndex) {
	      if (params.type === 'fraction') {
	        subEl.querySelectorAll((0, _classesToSelector.c)(params.currentClass)).forEach(function (fractionEl) {
	          fractionEl.textContent = params.formatFractionCurrent(current + 1);
	        });
	        subEl.querySelectorAll((0, _classesToSelector.c)(params.totalClass)).forEach(function (totalEl) {
	          totalEl.textContent = params.formatFractionTotal(total);
	        });
	      }
	      if (params.type === 'progressbar') {
	        var progressbarDirection = void 0;
	        if (params.progressbarOpposite) {
	          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	        } else {
	          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	        }
	        var scale = (current + 1) / total;
	        var scaleX = 1;
	        var scaleY = 1;
	        if (progressbarDirection === 'horizontal') {
	          scaleX = scale;
	        } else {
	          scaleY = scale;
	        }
	        subEl.querySelectorAll((0, _classesToSelector.c)(params.progressbarFillClass)).forEach(function (progressEl) {
	          progressEl.style.transform = 'translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')';
	          progressEl.style.transitionDuration = swiper.params.speed + 'ms';
	        });
	      }
	      if (params.type === 'custom' && params.renderCustom) {
	        subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
	        if (subElIndex === 0) emit('paginationRender', subEl);
	      } else {
	        if (subElIndex === 0) emit('paginationRender', subEl);
	        emit('paginationUpdate', subEl);
	      }
	      if (swiper.params.watchOverflow && swiper.enabled) {
	        subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
	      }
	    });
	  }
	  function render() {
	    // Render Container
	    var params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
	    var el = swiper.pagination.el;
	    el = (0, _utils.m)(el);
	    var paginationHTML = '';
	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
	        numberOfBullets = slidesLength;
	      }
	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          // prettier-ignore
	          paginationHTML += '<' + params.bulletElement + ' ' + (swiper.isElement ? 'part="bullet"' : '') + ' class="' + params.bulletClass + '"></' + params.bulletElement + '>';
	        }
	      }
	    }
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML = '<span class="' + params.currentClass + '"></span>' + ' / ' + ('<span class="' + params.totalClass + '"></span>');
	      }
	    }
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = '<span class="' + params.progressbarFillClass + '"></span>';
	      }
	    }
	    swiper.pagination.bullets = [];
	    el.forEach(function (subEl) {
	      if (params.type !== 'custom') {
	        subEl.innerHTML = paginationHTML || '';
	      }
	      if (params.type === 'bullets') {
	        var _swiper$pagination$bu;
	
	        (_swiper$pagination$bu = swiper.pagination.bullets).push.apply(_swiper$pagination$bu, _toConsumableArray(subEl.querySelectorAll((0, _classesToSelector.c)(params.bulletClass))));
	      }
	    });
	    if (params.type !== 'custom') {
	      emit('paginationRender', el[0]);
	    }
	  }
	  function init() {
	    swiper.params.pagination = (0, _createElementIfNotDefined.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
	      el: 'swiper-pagination'
	    });
	    var params = swiper.params.pagination;
	    if (!params.el) return;
	    var el = void 0;
	    if (typeof params.el === 'string' && swiper.isElement) {
	      el = swiper.el.querySelector(params.el);
	    }
	    if (!el && typeof params.el === 'string') {
	      el = [].concat(_toConsumableArray(document.querySelectorAll(params.el)));
	    }
	    if (!el) {
	      el = params.el;
	    }
	    if (!el || el.length === 0) return;
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
	      el = [].concat(_toConsumableArray(swiper.el.querySelectorAll(params.el)));
	      // check if it belongs to another nested Swiper
	      if (el.length > 1) {
	        el = el.filter(function (subEl) {
	          if ((0, _utils.a)(subEl, '.swiper')[0] !== swiper.el) return false;
	          return true;
	        })[0];
	      }
	    }
	    if (Array.isArray(el) && el.length === 1) el = el[0];
	    Object.assign(swiper.pagination, {
	      el: el
	    });
	    el = (0, _utils.m)(el);
	    el.forEach(function (subEl) {
	      if (params.type === 'bullets' && params.clickable) {
	        var _subEl$classList;
	
	        (_subEl$classList = subEl.classList).add.apply(_subEl$classList, _toConsumableArray((params.clickableClass || '').split(' ')));
	      }
	      subEl.classList.add(params.modifierClass + params.type);
	      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
	      if (params.type === 'bullets' && params.dynamicBullets) {
	        subEl.classList.add('' + params.modifierClass + params.type + '-dynamic');
	        dynamicBulletIndex = 0;
	        if (params.dynamicMainBullets < 1) {
	          params.dynamicMainBullets = 1;
	        }
	      }
	      if (params.type === 'progressbar' && params.progressbarOpposite) {
	        subEl.classList.add(params.progressbarOppositeClass);
	      }
	      if (params.clickable) {
	        subEl.addEventListener('click', onBulletClick);
	      }
	      if (!swiper.enabled) {
	        subEl.classList.add(params.lockClass);
	      }
	    });
	  }
	  function destroy() {
	    var params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    var el = swiper.pagination.el;
	    if (el) {
	      el = (0, _utils.m)(el);
	      el.forEach(function (subEl) {
	        subEl.classList.remove(params.hiddenClass);
	        subEl.classList.remove(params.modifierClass + params.type);
	        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
	        if (params.clickable) {
	          var _subEl$classList2;
	
	          (_subEl$classList2 = subEl.classList).remove.apply(_subEl$classList2, _toConsumableArray((params.clickableClass || '').split(' ')));
	          subEl.removeEventListener('click', onBulletClick);
	        }
	      });
	    }
	    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function (subEl) {
	      var _subEl$classList3;
	
	      return (_subEl$classList3 = subEl.classList).remove.apply(_subEl$classList3, _toConsumableArray(params.bulletActiveClass.split(' ')));
	    });
	  }
	  on('changeDirection', function () {
	    if (!swiper.pagination || !swiper.pagination.el) return;
	    var params = swiper.params.pagination;
	    var el = swiper.pagination.el;
	
	    el = (0, _utils.m)(el);
	    el.forEach(function (subEl) {
	      subEl.classList.remove(params.horizontalClass, params.verticalClass);
	      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
	    });
	  });
	  on('init', function () {
	    if (swiper.params.pagination.enabled === false) {
	      // eslint-disable-next-line
	      disable();
	    } else {
	      init();
	      render();
	      update();
	    }
	  });
	  on('activeIndexChange', function () {
	    if (typeof swiper.snapIndex === 'undefined') {
	      update();
	    }
	  });
	  on('snapIndexChange', function () {
	    update();
	  });
	  on('snapGridLengthChange', function () {
	    render();
	    update();
	  });
	  on('destroy', function () {
	    destroy();
	  });
	  on('enable disable', function () {
	    var el = swiper.pagination.el;
	
	    if (el) {
	      el = (0, _utils.m)(el);
	      el.forEach(function (subEl) {
	        return subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass);
	      });
	    }
	  });
	  on('lock unlock', function () {
	    update();
	  });
	  on('click', function (_s, e) {
	    var targetEl = e.target;
	    var el = (0, _utils.m)(swiper.pagination.el);
	    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
	      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
	      var isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
	      if (isHidden === true) {
	        emit('paginationShow');
	      } else {
	        emit('paginationHide');
	      }
	      el.forEach(function (subEl) {
	        return subEl.classList.toggle(swiper.params.pagination.hiddenClass);
	      });
	    }
	  });
	  var enable = function enable() {
	    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
	    var el = swiper.pagination.el;
	
	    if (el) {
	      el = (0, _utils.m)(el);
	      el.forEach(function (subEl) {
	        return subEl.classList.remove(swiper.params.pagination.paginationDisabledClass);
	      });
	    }
	    init();
	    render();
	    update();
	  };
	  var disable = function disable() {
	    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
	    var el = swiper.pagination.el;
	
	    if (el) {
	      el = (0, _utils.m)(el);
	      el.forEach(function (subEl) {
	        return subEl.classList.add(swiper.params.pagination.paginationDisabledClass);
	      });
	    }
	    destroy();
	  };
	  Object.assign(swiper.pagination, {
	    enable: enable,
	    disable: disable,
	    render: render,
	    update: update,
	    init: init,
	    destroy: destroy
	  });
	}
	
	exports.default = Pagination;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function classesToSelector(classes) {
	  if (classes === void 0) {
	    classes = '';
	  }
	  return '.' + classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
	  .replace(/ /g, '.');
	}
	
	exports.c = classesToSelector;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.c = undefined;
	
	var _utils = __webpack_require__(1);
	
	function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
	  if (swiper.params.createElements) {
	    Object.keys(checkProps).forEach(function (key) {
	      if (!params[key] && params.auto === true) {
	        var element = (0, _utils.e)(swiper.el, '.' + checkProps[key])[0];
	        if (!element) {
	          element = (0, _utils.c)('div', checkProps[key]);
	          element.className = checkProps[key];
	          swiper.el.append(element);
	        }
	        params[key] = element;
	        originalParams[key] = element;
	      }
	    });
	  }
	  return params;
	}
	
	exports.c = createElementIfNotDefined;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.d = exports.S = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _ssrWindowEsm = __webpack_require__(6);
	
	var _utils = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var support = void 0;
	function calcSupport() {
	  var window = (0, _ssrWindowEsm.a)();
	  var document = (0, _ssrWindowEsm.g)();
	  return {
	    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
	    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
	  };
	}
	function getSupport() {
	  if (!support) {
	    support = calcSupport();
	  }
	  return support;
	}
	
	var deviceCached = void 0;
	function calcDevice(_temp) {
	  var _ref3 = _temp === void 0 ? {} : _temp,
	      userAgent = _ref3.userAgent;
	
	  var support = getSupport();
	  var window = (0, _ssrWindowEsm.a)();
	  var platform = window.navigator.platform;
	  var ua = userAgent || window.navigator.userAgent;
	  var device = {
	    ios: false,
	    android: false
	  };
	  var screenWidth = window.screen.width;
	  var screenHeight = window.screen.height;
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  var windows = platform === 'Win32';
	  var macos = platform === 'MacIntel';
	
	  // iPadOs 13 fix
	  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
	  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + 'x' + screenHeight) >= 0) {
	    ipad = ua.match(/(Version)\/([\d.]+)/);
	    if (!ipad) ipad = [0, 1, '13_0_0'];
	    macos = false;
	  }
	
	  // Android
	  if (android && !windows) {
	    device.os = 'android';
	    device.android = true;
	  }
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  }
	
	  // Export object
	  return device;
	}
	function getDevice(overrides) {
	  if (overrides === void 0) {
	    overrides = {};
	  }
	  if (!deviceCached) {
	    deviceCached = calcDevice(overrides);
	  }
	  return deviceCached;
	}
	
	var browser = void 0;
	function calcBrowser() {
	  var window = (0, _ssrWindowEsm.a)();
	  var device = getDevice();
	  var needPerspectiveFix = false;
	  function isSafari() {
	    var ua = window.navigator.userAgent.toLowerCase();
	    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
	  }
	  if (isSafari()) {
	    var ua = String(window.navigator.userAgent);
	    if (ua.includes('Version/')) {
	      var _ua$split$1$split$0$s = ua.split('Version/')[1].split(' ')[0].split('.').map(function (num) {
	        return Number(num);
	      }),
	          _ua$split$1$split$0$s2 = _slicedToArray(_ua$split$1$split$0$s, 2),
	          major = _ua$split$1$split$0$s2[0],
	          minor = _ua$split$1$split$0$s2[1];
	
	      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
	    }
	  }
	  var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
	  var isSafariBrowser = isSafari();
	  var need3dFix = isSafariBrowser || isWebView && device.ios;
	  return {
	    isSafari: needPerspectiveFix || isSafariBrowser,
	    needPerspectiveFix: needPerspectiveFix,
	    need3dFix: need3dFix,
	    isWebView: isWebView
	  };
	}
	function getBrowser() {
	  if (!browser) {
	    browser = calcBrowser();
	  }
	  return browser;
	}
	
	function Resize(_ref) {
	  var swiper = _ref.swiper,
	      on = _ref.on,
	      emit = _ref.emit;
	
	  var window = (0, _ssrWindowEsm.a)();
	  var observer = null;
	  var animationFrame = null;
	  var resizeHandler = function resizeHandler() {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    emit('beforeResize');
	    emit('resize');
	  };
	  var createObserver = function createObserver() {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    observer = new ResizeObserver(function (entries) {
	      animationFrame = window.requestAnimationFrame(function () {
	        var width = swiper.width,
	            height = swiper.height;
	
	        var newWidth = width;
	        var newHeight = height;
	        entries.forEach(function (_ref2) {
	          var contentBoxSize = _ref2.contentBoxSize,
	              contentRect = _ref2.contentRect,
	              target = _ref2.target;
	
	          if (target && target !== swiper.el) return;
	          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
	          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
	        });
	        if (newWidth !== width || newHeight !== height) {
	          resizeHandler();
	        }
	      });
	    });
	    observer.observe(swiper.el);
	  };
	  var removeObserver = function removeObserver() {
	    if (animationFrame) {
	      window.cancelAnimationFrame(animationFrame);
	    }
	    if (observer && observer.unobserve && swiper.el) {
	      observer.unobserve(swiper.el);
	      observer = null;
	    }
	  };
	  var orientationChangeHandler = function orientationChangeHandler() {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    emit('orientationchange');
	  };
	  on('init', function () {
	    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
	      createObserver();
	      return;
	    }
	    window.addEventListener('resize', resizeHandler);
	    window.addEventListener('orientationchange', orientationChangeHandler);
	  });
	  on('destroy', function () {
	    removeObserver();
	    window.removeEventListener('resize', resizeHandler);
	    window.removeEventListener('orientationchange', orientationChangeHandler);
	  });
	}
	
	function Observer(_ref) {
	  var swiper = _ref.swiper,
	      extendParams = _ref.extendParams,
	      on = _ref.on,
	      emit = _ref.emit;
	
	  var observers = [];
	  var window = (0, _ssrWindowEsm.a)();
	  var attach = function attach(target, options) {
	    if (options === void 0) {
	      options = {};
	    }
	    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	    var observer = new ObserverFunc(function (mutations) {
	      // The observerUpdate event should only be triggered
	      // once despite the number of mutations.  Additional
	      // triggers are redundant and are very costly
	      if (swiper.__preventObserver__) return;
	      if (mutations.length === 1) {
	        emit('observerUpdate', mutations[0]);
	        return;
	      }
	      var observerUpdate = function observerUpdate() {
	        emit('observerUpdate', mutations[0]);
	      };
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(observerUpdate);
	      } else {
	        window.setTimeout(observerUpdate, 0);
	      }
	    });
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	    });
	    observers.push(observer);
	  };
	  var init = function init() {
	    if (!swiper.params.observer) return;
	    if (swiper.params.observeParents) {
	      var containerParents = (0, _utils.a)(swiper.hostEl);
	      for (var i = 0; i < containerParents.length; i += 1) {
	        attach(containerParents[i]);
	      }
	    }
	    // Observe container
	    attach(swiper.hostEl, {
	      childList: swiper.params.observeSlideChildren
	    });
	
	    // Observe wrapper
	    attach(swiper.wrapperEl, {
	      attributes: false
	    });
	  };
	  var destroy = function destroy() {
	    observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    observers.splice(0, observers.length);
	  };
	  extendParams({
	    observer: false,
	    observeParents: false,
	    observeSlideChildren: false
	  });
	  on('init', init);
	  on('destroy', destroy);
	}
	
	/* eslint-disable no-underscore-dangle */
	
	var eventsEmitter = {
	  on: function on(events, handler, priority) {
	    var self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(function (event) {
	      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  },
	  once: function once(events, handler, priority) {
	    var self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    function onceHandler() {
	      self.off(events, onceHandler);
	      if (onceHandler.__emitterProxy) {
	        delete onceHandler.__emitterProxy;
	      }
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      handler.apply(self, args);
	    }
	    onceHandler.__emitterProxy = handler;
	    return self.on(events, onceHandler, priority);
	  },
	  onAny: function onAny(handler, priority) {
	    var self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	    if (self.eventsAnyListeners.indexOf(handler) < 0) {
	      self.eventsAnyListeners[method](handler);
	    }
	    return self;
	  },
	  offAny: function offAny(handler) {
	    var self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsAnyListeners) return self;
	    var index = self.eventsAnyListeners.indexOf(handler);
	    if (index >= 0) {
	      self.eventsAnyListeners.splice(index, 1);
	    }
	    return self;
	  },
	  off: function off(events, handler) {
	    var self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsListeners) return self;
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  },
	  emit: function emit() {
	    var self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsListeners) return self;
	    var events = void 0;
	    var data = void 0;
	    var context = void 0;
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }
	    data.unshift(context);
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(function (event) {
	      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
	        self.eventsAnyListeners.forEach(function (eventHandler) {
	          eventHandler.apply(context, [event].concat(_toConsumableArray(data)));
	        });
	      }
	      if (self.eventsListeners && self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler) {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  }
	};
	
	function updateSize() {
	  var swiper = this;
	  var width = void 0;
	  var height = void 0;
	  var el = swiper.el;
	  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
	    width = swiper.params.width;
	  } else {
	    width = el.clientWidth;
	  }
	  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
	    height = swiper.params.height;
	  } else {
	    height = el.clientHeight;
	  }
	  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
	    return;
	  }
	
	  // Subtract paddings
	  width = width - parseInt((0, _utils.o)(el, 'padding-left') || 0, 10) - parseInt((0, _utils.o)(el, 'padding-right') || 0, 10);
	  height = height - parseInt((0, _utils.o)(el, 'padding-top') || 0, 10) - parseInt((0, _utils.o)(el, 'padding-bottom') || 0, 10);
	  if (Number.isNaN(width)) width = 0;
	  if (Number.isNaN(height)) height = 0;
	  Object.assign(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height
	  });
	}
	
	function updateSlides() {
	  var swiper = this;
	  function getDirectionPropertyValue(node, label) {
	    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
	  }
	  var params = swiper.params;
	  var wrapperEl = swiper.wrapperEl,
	      slidesEl = swiper.slidesEl,
	      swiperSize = swiper.size,
	      rtl = swiper.rtlTranslate,
	      wrongRTL = swiper.wrongRTL;
	
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  var slides = (0, _utils.e)(slidesEl, '.' + swiper.params.slideClass + ', swiper-slide');
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];
	  var offsetBefore = params.slidesOffsetBefore;
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }
	  var offsetAfter = params.slidesOffsetAfter;
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }
	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.slidesGrid.length;
	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
	  } else if (typeof spaceBetween === 'string') {
	    spaceBetween = parseFloat(spaceBetween);
	  }
	  swiper.virtualSize = -spaceBetween;
	
	  // reset margins
	  slides.forEach(function (slideEl) {
	    if (rtl) {
	      slideEl.style.marginLeft = '';
	    } else {
	      slideEl.style.marginRight = '';
	    }
	    slideEl.style.marginBottom = '';
	    slideEl.style.marginTop = '';
	  });
	
	  // reset cssMode offsets
	  if (params.centeredSlides && params.cssMode) {
	    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-before', '');
	    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-after', '');
	  }
	  var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
	  if (gridEnabled) {
	    swiper.grid.initSlides(slides);
	  } else if (swiper.grid) {
	    swiper.grid.unsetSlides();
	  }
	
	  // Calc slides
	  var slideSize = void 0;
	  var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function (key) {
	    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
	  }).length > 0;
	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var _slide = void 0;
	    if (slides[i]) _slide = slides[i];
	    if (gridEnabled) {
	      swiper.grid.updateSlide(i, _slide, slides);
	    }
	    if (slides[i] && (0, _utils.o)(_slide, 'display') === 'none') continue; // eslint-disable-line
	
	    if (params.slidesPerView === 'auto') {
	      if (shouldResetSlideSize) {
	        slides[i].style[swiper.getDirectionLabel('width')] = '';
	      }
	      var slideStyles = getComputedStyle(_slide);
	      var currentTransform = _slide.style.transform;
	      var currentWebKitTransform = _slide.style.webkitTransform;
	      if (currentTransform) {
	        _slide.style.transform = 'none';
	      }
	      if (currentWebKitTransform) {
	        _slide.style.webkitTransform = 'none';
	      }
	      if (params.roundLengths) {
	        slideSize = swiper.isHorizontal() ? (0, _utils.f)(_slide, 'width', true) : (0, _utils.f)(_slide, 'height', true);
	      } else {
	        // eslint-disable-next-line
	        var width = getDirectionPropertyValue(slideStyles, 'width');
	        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
	        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
	        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
	        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
	        var boxSizing = slideStyles.getPropertyValue('box-sizing');
	        if (boxSizing && boxSizing === 'border-box') {
	          slideSize = width + marginLeft + marginRight;
	        } else {
	          var _slide2 = _slide,
	              clientWidth = _slide2.clientWidth,
	              offsetWidth = _slide2.offsetWidth;
	
	          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
	        }
	      }
	      if (currentTransform) {
	        _slide.style.transform = currentTransform;
	      }
	      if (currentWebKitTransform) {
	        _slide.style.webkitTransform = currentWebKitTransform;
	      }
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	    } else {
	      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	      if (slides[i]) {
	        slides[i].style[swiper.getDirectionLabel('width')] = slideSize + 'px';
	      }
	    }
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	    slidesSizesGrid.push(slideSize);
	    if (params.centeredSlides) {
	      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	    } else {
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }
	    swiper.virtualSize += slideSize + spaceBetween;
	    prevSlideSize = slideSize;
	    index += 1;
	  }
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    wrapperEl.style.width = swiper.virtualSize + spaceBetween + 'px';
	  }
	  if (params.setWrapperSize) {
	    wrapperEl.style[swiper.getDirectionLabel('width')] = swiper.virtualSize + spaceBetween + 'px';
	  }
	  if (gridEnabled) {
	    swiper.grid.updateWrapperSize(slideSize, snapGrid);
	  }
	
	  // Remove last grid elements depending on width
	  if (!params.centeredSlides) {
	    var newSlidesGrid = [];
	    for (var _i = 0; _i < snapGrid.length; _i += 1) {
	      var slidesGridItem = snapGrid[_i];
	      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
	      if (snapGrid[_i] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(slidesGridItem);
	      }
	    }
	    snapGrid = newSlidesGrid;
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	  if (isVirtual && params.loop) {
	    var size = slidesSizesGrid[0] + spaceBetween;
	    if (params.slidesPerGroup > 1) {
	      var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
	      var groupSize = size * params.slidesPerGroup;
	      for (var _i2 = 0; _i2 < groups; _i2 += 1) {
	        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
	      }
	    }
	    for (var _i3 = 0; _i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; _i3 += 1) {
	      if (params.slidesPerGroup === 1) {
	        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
	      }
	      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
	      swiper.virtualSize += size;
	    }
	  }
	  if (snapGrid.length === 0) snapGrid = [0];
	  if (spaceBetween !== 0) {
	    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
	    slides.filter(function (_, slideIndex) {
	      if (!params.cssMode || params.loop) return true;
	      if (slideIndex === slides.length - 1) {
	        return false;
	      }
	      return true;
	    }).forEach(function (slideEl) {
	      slideEl.style[key] = spaceBetween + 'px';
	    });
	  }
	  if (params.centeredSlides && params.centeredSlidesBounds) {
	    var allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      allSlidesSize += slideSizeValue + (spaceBetween || 0);
	    });
	    allSlidesSize -= spaceBetween;
	    var maxSnap = allSlidesSize - swiperSize;
	    snapGrid = snapGrid.map(function (snap) {
	      if (snap <= 0) return -offsetBefore;
	      if (snap > maxSnap) return maxSnap + offsetAfter;
	      return snap;
	    });
	  }
	  if (params.centerInsufficientSlides) {
	    var _allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      _allSlidesSize += slideSizeValue + (spaceBetween || 0);
	    });
	    _allSlidesSize -= spaceBetween;
	    if (_allSlidesSize < swiperSize) {
	      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
	      snapGrid.forEach(function (snap, snapIndex) {
	        snapGrid[snapIndex] = snap - allSlidesOffset;
	      });
	      slidesGrid.forEach(function (snap, snapIndex) {
	        slidesGrid[snapIndex] = snap + allSlidesOffset;
	      });
	    }
	  }
	  Object.assign(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid
	  });
	  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
	    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-before', -snapGrid[0] + 'px');
	    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-after', swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2 + 'px');
	    var addToSnapGrid = -swiper.snapGrid[0];
	    var addToSlidesGrid = -swiper.slidesGrid[0];
	    swiper.snapGrid = swiper.snapGrid.map(function (v) {
	      return v + addToSnapGrid;
	    });
	    swiper.slidesGrid = swiper.slidesGrid.map(function (v) {
	      return v + addToSlidesGrid;
	    });
	  }
	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) swiper.checkOverflow();
	    swiper.emit('snapGridLengthChange');
	  }
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }
	  if (params.watchSlidesProgress) {
	    swiper.updateSlidesOffset();
	  }
	  swiper.emit('slidesUpdated');
	  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
	    var backFaceHiddenClass = params.containerModifierClass + 'backface-hidden';
	    var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
	    if (slidesLength <= params.maxBackfaceHiddenSlides) {
	      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
	    } else if (hasClassBackfaceClassAdded) {
	      swiper.el.classList.remove(backFaceHiddenClass);
	    }
	  }
	}
	
	function updateAutoHeight(speed) {
	  var swiper = this;
	  var activeSlides = [];
	  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	  var newHeight = 0;
	  var i = void 0;
	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  }
	  var getSlideByIndex = function getSlideByIndex(index) {
	    if (isVirtual) {
	      return swiper.slides[swiper.getSlideIndexByData(index)];
	    }
	    return swiper.slides[index];
	  };
	  // Find slides currently in view
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    if (swiper.params.centeredSlides) {
	      (swiper.visibleSlides || []).forEach(function (slide) {
	        activeSlides.push(slide);
	      });
	    } else {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        var index = swiper.activeIndex + i;
	        if (index > swiper.slides.length && !isVirtual) break;
	        activeSlides.push(getSlideByIndex(index));
	      }
	    }
	  } else {
	    activeSlides.push(getSlideByIndex(swiper.activeIndex));
	  }
	
	  // Find new height from highest slide in view
	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  }
	
	  // Update Height
	  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = newHeight + 'px';
	}
	
	function updateSlidesOffset() {
	  var swiper = this;
	  var slides = swiper.slides;
	  // eslint-disable-next-line
	  var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
	  }
	}
	
	function updateSlidesProgress(translate) {
	  if (translate === void 0) {
	    translate = this && this.translate || 0;
	  }
	  var swiper = this;
	  var params = swiper.params;
	  var slides = swiper.slides,
	      rtl = swiper.rtlTranslate,
	      snapGrid = swiper.snapGrid;
	
	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
	  var offsetCenter = -translate;
	  if (rtl) offsetCenter = translate;
	
	  // Visible Slides
	  slides.forEach(function (slideEl) {
	    slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
	  });
	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];
	  var spaceBetween = params.spaceBetween;
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
	  } else if (typeof spaceBetween === 'string') {
	    spaceBetween = parseFloat(spaceBetween);
	  }
	  for (var i = 0; i < slides.length; i += 1) {
	    var _slide3 = slides[i];
	    var slideOffset = _slide3.swiperSlideOffset;
	    if (params.cssMode && params.centeredSlides) {
	      slideOffset -= slides[0].swiperSlideOffset;
	    }
	    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide3.swiperSlideSize + spaceBetween);
	    var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide3.swiperSlideSize + spaceBetween);
	    var slideBefore = -(offsetCenter - slideOffset);
	    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	    var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
	    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
	    if (isVisible) {
	      swiper.visibleSlides.push(_slide3);
	      swiper.visibleSlidesIndexes.push(i);
	      slides[i].classList.add(params.slideVisibleClass);
	    }
	    if (isFullyVisible) {
	      slides[i].classList.add(params.slideFullyVisibleClass);
	    }
	    _slide3.progress = rtl ? -slideProgress : slideProgress;
	    _slide3.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
	  }
	}
	
	function updateProgress(translate) {
	  var swiper = this;
	  if (typeof translate === 'undefined') {
	    var multiplier = swiper.rtlTranslate ? -1 : 1;
	    // eslint-disable-next-line
	    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
	  }
	  var params = swiper.params;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress,
	      isBeginning = swiper.isBeginning,
	      isEnd = swiper.isEnd,
	      progressLoop = swiper.progressLoop;
	
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / translatesDiff;
	    var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
	    var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
	    isBeginning = isBeginningRounded || progress <= 0;
	    isEnd = isEndRounded || progress >= 1;
	    if (isBeginningRounded) progress = 0;
	    if (isEndRounded) progress = 1;
	  }
	  if (params.loop) {
	    var firstSlideIndex = swiper.getSlideIndexByData(0);
	    var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
	    var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
	    var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
	    var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
	    var translateAbs = Math.abs(translate);
	    if (translateAbs >= firstSlideTranslate) {
	      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
	    } else {
	      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
	    }
	    if (progressLoop > 1) progressLoop -= 1;
	  }
	  Object.assign(swiper, {
	    progress: progress,
	    progressLoop: progressLoop,
	    isBeginning: isBeginning,
	    isEnd: isEnd
	  });
	  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
	    swiper.emit('fromEdge');
	  }
	  swiper.emit('progress', progress);
	}
	
	function updateSlidesClasses() {
	  var swiper = this;
	  var slides = swiper.slides,
	      params = swiper.params,
	      slidesEl = swiper.slidesEl,
	      activeIndex = swiper.activeIndex;
	
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
	  var getFilteredSlide = function getFilteredSlide(selector) {
	    return (0, _utils.e)(slidesEl, '.' + params.slideClass + selector + ', swiper-slide' + selector)[0];
	  };
	  slides.forEach(function (slideEl) {
	    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
	  });
	  var activeSlide = void 0;
	  var prevSlide = void 0;
	  var nextSlide = void 0;
	  if (isVirtual) {
	    if (params.loop) {
	      var slideIndex = activeIndex - swiper.virtual.slidesBefore;
	      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
	      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
	      activeSlide = getFilteredSlide('[data-swiper-slide-index="' + slideIndex + '"]');
	    } else {
	      activeSlide = getFilteredSlide('[data-swiper-slide-index="' + activeIndex + '"]');
	    }
	  } else {
	    if (gridEnabled) {
	      activeSlide = slides.filter(function (slideEl) {
	        return slideEl.column === activeIndex;
	      })[0];
	      nextSlide = slides.filter(function (slideEl) {
	        return slideEl.column === activeIndex + 1;
	      })[0];
	      prevSlide = slides.filter(function (slideEl) {
	        return slideEl.column === activeIndex - 1;
	      })[0];
	    } else {
	      activeSlide = slides[activeIndex];
	    }
	  }
	  if (activeSlide) {
	    // Active classes
	    activeSlide.classList.add(params.slideActiveClass);
	    if (gridEnabled) {
	      if (nextSlide) {
	        nextSlide.classList.add(params.slideNextClass);
	      }
	      if (prevSlide) {
	        prevSlide.classList.add(params.slidePrevClass);
	      }
	    } else {
	      // Next Slide
	      nextSlide = (0, _utils.p)(activeSlide, '.' + params.slideClass + ', swiper-slide')[0];
	      if (params.loop && !nextSlide) {
	        nextSlide = slides[0];
	      }
	      if (nextSlide) {
	        nextSlide.classList.add(params.slideNextClass);
	      }
	
	      // Prev Slide
	      prevSlide = (0, _utils.q)(activeSlide, '.' + params.slideClass + ', swiper-slide')[0];
	      if (params.loop && !prevSlide === 0) {
	        prevSlide = slides[slides.length - 1];
	      }
	      if (prevSlide) {
	        prevSlide.classList.add(params.slidePrevClass);
	      }
	    }
	  }
	  swiper.emitSlidesClasses();
	}
	
	var processLazyPreloader = function processLazyPreloader(swiper, imageEl) {
	  if (!swiper || swiper.destroyed || !swiper.params) return;
	  var slideSelector = function slideSelector() {
	    return swiper.isElement ? 'swiper-slide' : '.' + swiper.params.slideClass;
	  };
	  var slideEl = imageEl.closest(slideSelector());
	  if (slideEl) {
	    var lazyEl = slideEl.querySelector('.' + swiper.params.lazyPreloaderClass);
	    if (!lazyEl && swiper.isElement) {
	      if (slideEl.shadowRoot) {
	        lazyEl = slideEl.shadowRoot.querySelector('.' + swiper.params.lazyPreloaderClass);
	      } else {
	        // init later
	        requestAnimationFrame(function () {
	          if (slideEl.shadowRoot) {
	            lazyEl = slideEl.shadowRoot.querySelector('.' + swiper.params.lazyPreloaderClass);
	            if (lazyEl) lazyEl.remove();
	          }
	        });
	      }
	    }
	    if (lazyEl) lazyEl.remove();
	  }
	};
	var unlazy = function unlazy(swiper, index) {
	  if (!swiper.slides[index]) return;
	  var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
	  if (imageEl) imageEl.removeAttribute('loading');
	};
	var preload = function preload(swiper) {
	  if (!swiper || swiper.destroyed || !swiper.params) return;
	  var amount = swiper.params.lazyPreloadPrevNext;
	  var len = swiper.slides.length;
	  if (!len || !amount || amount < 0) return;
	  amount = Math.min(amount, len);
	  var slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
	  var activeIndex = swiper.activeIndex;
	  if (swiper.params.grid && swiper.params.grid.rows > 1) {
	    var activeColumn = activeIndex;
	    var preloadColumns = [activeColumn - amount];
	    preloadColumns.push.apply(preloadColumns, _toConsumableArray(Array.from({
	      length: amount
	    }).map(function (_, i) {
	      return activeColumn + slidesPerView + i;
	    })));
	    swiper.slides.forEach(function (slideEl, i) {
	      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
	    });
	    return;
	  }
	  var slideIndexLastInView = activeIndex + slidesPerView - 1;
	  if (swiper.params.rewind || swiper.params.loop) {
	    for (var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
	      var realIndex = (i % len + len) % len;
	      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
	    }
	  } else {
	    for (var _i4 = Math.max(activeIndex - amount, 0); _i4 <= Math.min(slideIndexLastInView + amount, len - 1); _i4 += 1) {
	      if (_i4 !== activeIndex && (_i4 > slideIndexLastInView || _i4 < activeIndex)) {
	        unlazy(swiper, _i4);
	      }
	    }
	  }
	};
	
	function getActiveIndexByTranslate(swiper) {
	  var slidesGrid = swiper.slidesGrid,
	      params = swiper.params;
	
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var activeIndex = void 0;
	  for (var i = 0; i < slidesGrid.length; i += 1) {
	    if (typeof slidesGrid[i + 1] !== 'undefined') {
	      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
	        activeIndex = i;
	      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	        activeIndex = i + 1;
	      }
	    } else if (translate >= slidesGrid[i]) {
	      activeIndex = i;
	    }
	  }
	  // Normalize slideIndex
	  if (params.normalizeSlideIndex) {
	    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
	  }
	  return activeIndex;
	}
	function updateActiveIndex(newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var snapGrid = swiper.snapGrid,
	      params = swiper.params,
	      previousIndex = swiper.activeIndex,
	      previousRealIndex = swiper.realIndex,
	      previousSnapIndex = swiper.snapIndex;
	
	  var activeIndex = newActiveIndex;
	  var snapIndex = void 0;
	  var getVirtualRealIndex = function getVirtualRealIndex(aIndex) {
	    var realIndex = aIndex - swiper.virtual.slidesBefore;
	    if (realIndex < 0) {
	      realIndex = swiper.virtual.slides.length + realIndex;
	    }
	    if (realIndex >= swiper.virtual.slides.length) {
	      realIndex -= swiper.virtual.slides.length;
	    }
	    return realIndex;
	  };
	  if (typeof activeIndex === 'undefined') {
	    activeIndex = getActiveIndexByTranslate(swiper);
	  }
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	  if (activeIndex === previousIndex && !swiper.params.loop) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	    return;
	  }
	  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
	    swiper.realIndex = getVirtualRealIndex(activeIndex);
	    return;
	  }
	  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
	
	  // Get real index
	  var realIndex = void 0;
	  if (swiper.virtual && params.virtual.enabled && params.loop) {
	    realIndex = getVirtualRealIndex(activeIndex);
	  } else if (gridEnabled) {
	    var firstSlideInColumn = swiper.slides.filter(function (slideEl) {
	      return slideEl.column === activeIndex;
	    })[0];
	    var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
	    if (Number.isNaN(activeSlideIndex)) {
	      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
	    }
	    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
	  } else if (swiper.slides[activeIndex]) {
	    var slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
	    if (slideIndex) {
	      realIndex = parseInt(slideIndex, 10);
	    } else {
	      realIndex = activeIndex;
	    }
	  } else {
	    realIndex = activeIndex;
	  }
	  Object.assign(swiper, {
	    previousSnapIndex: previousSnapIndex,
	    snapIndex: snapIndex,
	    previousRealIndex: previousRealIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex
	  });
	  if (swiper.initialized) {
	    preload(swiper);
	  }
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	    if (previousRealIndex !== realIndex) {
	      swiper.emit('realIndexChange');
	    }
	    swiper.emit('slideChange');
	  }
	}
	
	function updateClickedSlide(el, path) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = el.closest('.' + params.slideClass + ', swiper-slide');
	  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
	    [].concat(_toConsumableArray(path.slice(path.indexOf(el) + 1, path.length))).forEach(function (pathEl) {
	      if (!slide && pathEl.matches && pathEl.matches('.' + params.slideClass + ', swiper-slide')) {
	        slide = pathEl;
	      }
	    });
	  }
	  var slideFound = false;
	  var slideIndex = void 0;
	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) {
	        slideFound = true;
	        slideIndex = i;
	        break;
	      }
	    }
	  }
	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = slideIndex;
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}
	
	var update = {
	  updateSize: updateSize,
	  updateSlides: updateSlides,
	  updateAutoHeight: updateAutoHeight,
	  updateSlidesOffset: updateSlidesOffset,
	  updateSlidesProgress: updateSlidesProgress,
	  updateProgress: updateProgress,
	  updateSlidesClasses: updateSlidesClasses,
	  updateActiveIndex: updateActiveIndex,
	  updateClickedSlide: updateClickedSlide
	};
	
	function getSwiperTranslate(axis) {
	  if (axis === void 0) {
	    axis = this.isHorizontal() ? 'x' : 'y';
	  }
	  var swiper = this;
	  var params = swiper.params,
	      rtl = swiper.rtlTranslate,
	      translate = swiper.translate,
	      wrapperEl = swiper.wrapperEl;
	
	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }
	  if (params.cssMode) {
	    return translate;
	  }
	  var currentTranslate = (0, _utils.i)(wrapperEl, axis);
	  currentTranslate += swiper.cssOverflowAdjustment();
	  if (rtl) currentTranslate = -currentTranslate;
	  return currentTranslate || 0;
	}
	
	function setTranslate(translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtlTranslate,
	      params = swiper.params,
	      wrapperEl = swiper.wrapperEl,
	      progress = swiper.progress;
	
	  var x = 0;
	  var y = 0;
	  var z = 0;
	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }
	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }
	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y;
	  if (params.cssMode) {
	    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
	    if (swiper.isHorizontal()) {
	      x -= swiper.cssOverflowAdjustment();
	    } else {
	      y -= swiper.cssOverflowAdjustment();
	    }
	    wrapperEl.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)';
	  }
	
	  // Check if we need to update progress
	  var newProgress = void 0;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
	  }
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }
	  swiper.emit('setTranslate', swiper.translate, byController);
	}
	
	function minTranslate() {
	  return -this.snapGrid[0];
	}
	
	function maxTranslate() {
	  return -this.snapGrid[this.snapGrid.length - 1];
	}
	
	function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
	  if (translate === void 0) {
	    translate = 0;
	  }
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  if (translateBounds === void 0) {
	    translateBounds = true;
	  }
	  var swiper = this;
	  var params = swiper.params,
	      wrapperEl = swiper.wrapperEl;
	
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }
	  var minTranslate = swiper.minTranslate();
	  var maxTranslate = swiper.maxTranslate();
	  var newTranslate = void 0;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;
	
	  // Update progress
	  swiper.updateProgress(newTranslate);
	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	    } else {
	      var _wrapperEl$scrollTo;
	
	      if (!swiper.support.smoothScroll) {
	        (0, _utils.r)({
	          swiper: swiper,
	          targetPosition: -newTranslate,
	          side: isH ? 'left' : 'top'
	        });
	        return true;
	      }
	      wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty(_wrapperEl$scrollTo, 'behavior', 'smooth'), _wrapperEl$scrollTo));
	    }
	    return true;
	  }
	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(newTranslate);
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionEnd');
	    }
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(newTranslate);
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionStart');
	    }
	    if (!swiper.animating) {
	      swiper.animating = true;
	      if (!swiper.onTranslateToWrapperTransitionEnd) {
	        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.onTranslateToWrapperTransitionEnd = null;
	          delete swiper.onTranslateToWrapperTransitionEnd;
	          if (runCallbacks) {
	            swiper.emit('transitionEnd');
	          }
	        };
	      }
	      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	    }
	  }
	  return true;
	}
	
	var translate = {
	  getTranslate: getSwiperTranslate,
	  setTranslate: setTranslate,
	  minTranslate: minTranslate,
	  maxTranslate: maxTranslate,
	  translateTo: translateTo
	};
	
	function setTransition(duration, byController) {
	  var swiper = this;
	  if (!swiper.params.cssMode) {
	    swiper.wrapperEl.style.transitionDuration = duration + 'ms';
	    swiper.wrapperEl.style.transitionDelay = duration === 0 ? '0ms' : '';
	  }
	  swiper.emit('setTransition', duration, byController);
	}
	
	function transitionEmit(_ref) {
	  var swiper = _ref.swiper,
	      runCallbacks = _ref.runCallbacks,
	      direction = _ref.direction,
	      step = _ref.step;
	  var activeIndex = swiper.activeIndex,
	      previousIndex = swiper.previousIndex;
	
	  var dir = direction;
	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }
	  swiper.emit('transition' + step);
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransition' + step);
	      return;
	    }
	    swiper.emit('slideChangeTransition' + step);
	    if (dir === 'next') {
	      swiper.emit('slideNextTransition' + step);
	    } else {
	      swiper.emit('slidePrevTransition' + step);
	    }
	  }
	}
	
	function transitionStart(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  var swiper = this;
	  var params = swiper.params;
	
	  if (params.cssMode) return;
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }
	  transitionEmit({
	    swiper: swiper,
	    runCallbacks: runCallbacks,
	    direction: direction,
	    step: 'Start'
	  });
	}
	
	function transitionEnd(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  var swiper = this;
	  var params = swiper.params;
	
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);
	  transitionEmit({
	    swiper: swiper,
	    runCallbacks: runCallbacks,
	    direction: direction,
	    step: 'End'
	  });
	}
	
	var transition = {
	  setTransition: setTransition,
	  transitionStart: transitionStart,
	  transitionEnd: transitionEnd
	};
	
	function slideTo(index, speed, runCallbacks, internal, initial) {
	  if (index === void 0) {
	    index = 0;
	  }
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  if (typeof index === 'string') {
	    index = parseInt(index, 10);
	  }
	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;
	  var params = swiper.params,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      previousIndex = swiper.previousIndex,
	      activeIndex = swiper.activeIndex,
	      rtl = swiper.rtlTranslate,
	      wrapperEl = swiper.wrapperEl,
	      enabled = swiper.enabled;
	
	  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial || swiper.destroyed) {
	    return false;
	  }
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	  var translate = -snapGrid[snapIndex];
	  // Normalize slideIndex
	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      var normalizedTranslate = -Math.floor(translate * 100);
	      var normalizedGrid = Math.floor(slidesGrid[i] * 100);
	      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
	          slideIndex = i;
	        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
	          slideIndex = i + 1;
	        }
	      } else if (normalizedTranslate >= normalizedGrid) {
	        slideIndex = i;
	      }
	    }
	  }
	  // Directions locks
	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) {
	        return false;
	      }
	    }
	  }
	  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }
	
	  // Update progress
	  swiper.updateProgress(translate);
	  var direction = void 0;
	  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';
	
	  // Update Index
	  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
	    swiper.updateActiveIndex(slideIndex);
	    // Update Height
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	    swiper.updateSlidesClasses();
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }
	    return false;
	  }
	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	    var t = rtl ? translate : -translate;
	    if (speed === 0) {
	      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	      if (isVirtual) {
	        swiper.wrapperEl.style.scrollSnapType = 'none';
	        swiper._immediateVirtual = true;
	      }
	      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
	        swiper._cssModeVirtualInitialSet = true;
	        requestAnimationFrame(function () {
	          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	        });
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	      }
	      if (isVirtual) {
	        requestAnimationFrame(function () {
	          swiper.wrapperEl.style.scrollSnapType = '';
	          swiper._immediateVirtual = false;
	        });
	      }
	    } else {
	      var _wrapperEl$scrollTo2;
	
	      if (!swiper.support.smoothScroll) {
	        (0, _utils.r)({
	          swiper: swiper,
	          targetPosition: t,
	          side: isH ? 'left' : 'top'
	        });
	        return true;
	      }
	      wrapperEl.scrollTo((_wrapperEl$scrollTo2 = {}, _defineProperty(_wrapperEl$scrollTo2, isH ? 'left' : 'top', t), _defineProperty(_wrapperEl$scrollTo2, 'behavior', 'smooth'), _wrapperEl$scrollTo2));
	    }
	    return true;
	  }
	  swiper.setTransition(speed);
	  swiper.setTranslate(translate);
	  swiper.updateActiveIndex(slideIndex);
	  swiper.updateSlidesClasses();
	  swiper.emit('beforeTransitionStart', speed, internal);
	  swiper.transitionStart(runCallbacks, direction);
	  if (speed === 0) {
	    swiper.transitionEnd(runCallbacks, direction);
	  } else if (!swiper.animating) {
	    swiper.animating = true;
	    if (!swiper.onSlideToWrapperTransitionEnd) {
	      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	        if (!swiper || swiper.destroyed) return;
	        if (e.target !== this) return;
	        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	        swiper.onSlideToWrapperTransitionEnd = null;
	        delete swiper.onSlideToWrapperTransitionEnd;
	        swiper.transitionEnd(runCallbacks, direction);
	      };
	    }
	    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	  }
	  return true;
	}
	
	function slideToLoop(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  if (typeof index === 'string') {
	    var indexAsNumber = parseInt(index, 10);
	    index = indexAsNumber;
	  }
	  var swiper = this;
	  if (swiper.destroyed) return;
	  var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
	  var newIndex = index;
	  if (swiper.params.loop) {
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      // eslint-disable-next-line
	      newIndex = newIndex + swiper.virtual.slidesBefore;
	    } else {
	      var targetSlideIndex = void 0;
	      if (gridEnabled) {
	        var slideIndex = newIndex * swiper.params.grid.rows;
	        targetSlideIndex = swiper.slides.filter(function (slideEl) {
	          return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex;
	        })[0].column;
	      } else {
	        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
	      }
	      var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
	      var centeredSlides = swiper.params.centeredSlides;
	
	      var slidesPerView = swiper.params.slidesPerView;
	      if (slidesPerView === 'auto') {
	        slidesPerView = swiper.slidesPerViewDynamic();
	      } else {
	        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
	        if (centeredSlides && slidesPerView % 2 === 0) {
	          slidesPerView = slidesPerView + 1;
	        }
	      }
	      var needLoopFix = cols - targetSlideIndex < slidesPerView;
	      if (centeredSlides) {
	        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
	      }
	      if (needLoopFix) {
	        var direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
	        swiper.loopFix({
	          direction: direction,
	          slideTo: true,
	          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
	          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
	        });
	      }
	      if (gridEnabled) {
	        var _slideIndex = newIndex * swiper.params.grid.rows;
	        newIndex = swiper.slides.filter(function (slideEl) {
	          return slideEl.getAttribute('data-swiper-slide-index') * 1 === _slideIndex;
	        })[0].column;
	      } else {
	        newIndex = swiper.getSlideIndexByData(newIndex);
	      }
	    }
	  }
	  requestAnimationFrame(function () {
	    swiper.slideTo(newIndex, speed, runCallbacks, internal);
	  });
	  return swiper;
	}
	
	/* eslint no-unused-vars: "off" */
	function slideNext(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  var swiper = this;
	  var enabled = swiper.enabled,
	      params = swiper.params,
	      animating = swiper.animating;
	
	  if (!enabled || swiper.destroyed) return swiper;
	  var perGroup = params.slidesPerGroup;
	  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
	    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
	  }
	  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  if (params.loop) {
	    if (animating && !isVirtual && params.loopPreventsSliding) return false;
	    swiper.loopFix({
	      direction: 'next'
	    });
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.wrapperEl.clientLeft;
	    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
	      requestAnimationFrame(function () {
	        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	      });
	      return true;
	    }
	  }
	  if (params.rewind && swiper.isEnd) {
	    return swiper.slideTo(0, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slidePrev(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  var swiper = this;
	  var params = swiper.params,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      rtlTranslate = swiper.rtlTranslate,
	      enabled = swiper.enabled,
	      animating = swiper.animating;
	
	  if (!enabled || swiper.destroyed) return swiper;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  if (params.loop) {
	    if (animating && !isVirtual && params.loopPreventsSliding) return false;
	    swiper.loopFix({
	      direction: 'prev'
	    });
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.wrapperEl.clientLeft;
	  }
	  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
	  function normalize(val) {
	    if (val < 0) return -Math.floor(Math.abs(val));
	    return Math.floor(val);
	  }
	  var normalizedTranslate = normalize(translate);
	  var normalizedSnapGrid = snapGrid.map(function (val) {
	    return normalize(val);
	  });
	  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	  if (typeof prevSnap === 'undefined' && params.cssMode) {
	    var prevSnapIndex = void 0;
	    snapGrid.forEach(function (snap, snapIndex) {
	      if (normalizedTranslate >= snap) {
	        // prevSnap = snap;
	        prevSnapIndex = snapIndex;
	      }
	    });
	    if (typeof prevSnapIndex !== 'undefined') {
	      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
	    }
	  }
	  var prevIndex = 0;
	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
	    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
	      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
	      prevIndex = Math.max(prevIndex, 0);
	    }
	  }
	  if (params.rewind && swiper.isBeginning) {
	    var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
	    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
	  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
	    requestAnimationFrame(function () {
	      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	    });
	    return true;
	  }
	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slideReset(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  var swiper = this;
	  if (swiper.destroyed) return;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}
	
	/* eslint no-unused-vars: "off" */
	function slideToClosest(speed, runCallbacks, internal, threshold) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }
	  if (threshold === void 0) {
	    threshold = 0.5;
	  }
	  var swiper = this;
	  if (swiper.destroyed) return;
	  var index = swiper.activeIndex;
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  if (translate >= swiper.snapGrid[snapIndex]) {
	    // The current translate is on or after the current snap index, so the choice
	    // is between the current index and the one after it.
	    var currentSnap = swiper.snapGrid[snapIndex];
	    var nextSnap = swiper.snapGrid[snapIndex + 1];
	    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
	      index += swiper.params.slidesPerGroup;
	    }
	  } else {
	    // The current translate is before the current snap index, so the choice
	    // is between the current index and the one before it.
	    var prevSnap = swiper.snapGrid[snapIndex - 1];
	    var _currentSnap = swiper.snapGrid[snapIndex];
	    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
	      index -= swiper.params.slidesPerGroup;
	    }
	  }
	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}
	
	function slideToClickedSlide() {
	  var swiper = this;
	  if (swiper.destroyed) return;
	  var params = swiper.params,
	      slidesEl = swiper.slidesEl;
	
	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex = void 0;
	  var slideSelector = swiper.isElement ? 'swiper-slide' : '.' + params.slideClass;
	  if (params.loop) {
	    if (swiper.animating) return;
	    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
	    if (params.centeredSlides) {
	      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
	        swiper.loopFix();
	        slideToIndex = swiper.getSlideIndex((0, _utils.e)(slidesEl, slideSelector + '[data-swiper-slide-index="' + realIndex + '"]')[0]);
	        (0, _utils.n)(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = swiper.getSlideIndex((0, _utils.e)(slidesEl, slideSelector + '[data-swiper-slide-index="' + realIndex + '"]')[0]);
	      (0, _utils.n)(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}
	
	var slide = {
	  slideTo: slideTo,
	  slideToLoop: slideToLoop,
	  slideNext: slideNext,
	  slidePrev: slidePrev,
	  slideReset: slideReset,
	  slideToClosest: slideToClosest,
	  slideToClickedSlide: slideToClickedSlide
	};
	
	function loopCreate(slideRealIndex) {
	  var swiper = this;
	  var params = swiper.params,
	      slidesEl = swiper.slidesEl;
	
	  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
	  var initSlides = function initSlides() {
	    var slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
	    slides.forEach(function (el, index) {
	      el.setAttribute('data-swiper-slide-index', index);
	    });
	  };
	  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
	  var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
	  var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
	  var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
	  var addBlankSlides = function addBlankSlides(amountOfSlides) {
	    for (var i = 0; i < amountOfSlides; i += 1) {
	      var slideEl = swiper.isElement ? (0, _utils.c)('swiper-slide', [params.slideBlankClass]) : (0, _utils.c)('div', [params.slideClass, params.slideBlankClass]);
	      swiper.slidesEl.append(slideEl);
	    }
	  };
	  if (shouldFillGroup) {
	    if (params.loopAddBlankSlides) {
	      var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
	      addBlankSlides(slidesToAdd);
	      swiper.recalcSlides();
	      swiper.updateSlides();
	    } else {
	      (0, _utils.t)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
	    }
	    initSlides();
	  } else if (shouldFillGrid) {
	    if (params.loopAddBlankSlides) {
	      var _slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
	      addBlankSlides(_slidesToAdd);
	      swiper.recalcSlides();
	      swiper.updateSlides();
	    } else {
	      (0, _utils.t)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
	    }
	    initSlides();
	  } else {
	    initSlides();
	  }
	  swiper.loopFix({
	    slideRealIndex: slideRealIndex,
	    direction: params.centeredSlides ? undefined : 'next'
	  });
	}
	
	function loopFix(_temp) {
	  var _ref4 = _temp === void 0 ? {} : _temp,
	      slideRealIndex = _ref4.slideRealIndex,
	      _ref4$slideTo = _ref4.slideTo,
	      slideTo = _ref4$slideTo === undefined ? true : _ref4$slideTo,
	      direction = _ref4.direction,
	      setTranslate = _ref4.setTranslate,
	      activeSlideIndex = _ref4.activeSlideIndex,
	      byController = _ref4.byController,
	      byMousewheel = _ref4.byMousewheel;
	
	  var swiper = this;
	  if (!swiper.params.loop) return;
	  swiper.emit('beforeLoopFix');
	  var slides = swiper.slides,
	      allowSlidePrev = swiper.allowSlidePrev,
	      allowSlideNext = swiper.allowSlideNext,
	      slidesEl = swiper.slidesEl,
	      params = swiper.params;
	  var centeredSlides = params.centeredSlides;
	
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  if (swiper.virtual && params.virtual.enabled) {
	    if (slideTo) {
	      if (!params.centeredSlides && swiper.snapIndex === 0) {
	        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
	      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
	        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
	      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
	        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
	      }
	    }
	    swiper.allowSlidePrev = allowSlidePrev;
	    swiper.allowSlideNext = allowSlideNext;
	    swiper.emit('loopFix');
	    return;
	  }
	  var slidesPerView = params.slidesPerView;
	  if (slidesPerView === 'auto') {
	    slidesPerView = swiper.slidesPerViewDynamic();
	  } else {
	    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
	    if (centeredSlides && slidesPerView % 2 === 0) {
	      slidesPerView = slidesPerView + 1;
	    }
	  }
	  var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
	  var loopedSlides = slidesPerGroup;
	  if (loopedSlides % slidesPerGroup !== 0) {
	    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
	  }
	  loopedSlides += params.loopAdditionalSlides;
	  swiper.loopedSlides = loopedSlides;
	  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
	  if (slides.length < slidesPerView + loopedSlides) {
	    (0, _utils.t)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
	  } else if (gridEnabled && params.grid.fill === 'row') {
	    (0, _utils.t)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
	  }
	  var prependSlidesIndexes = [];
	  var appendSlidesIndexes = [];
	  var activeIndex = swiper.activeIndex;
	  if (typeof activeSlideIndex === 'undefined') {
	    activeSlideIndex = swiper.getSlideIndex(slides.filter(function (el) {
	      return el.classList.contains(params.slideActiveClass);
	    })[0]);
	  } else {
	    activeIndex = activeSlideIndex;
	  }
	  var isNext = direction === 'next' || !direction;
	  var isPrev = direction === 'prev' || !direction;
	  var slidesPrepended = 0;
	  var slidesAppended = 0;
	  var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
	  var activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
	  var activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
	  // prepend last slides before start
	  if (activeColIndexWithShift < loopedSlides) {
	    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
	    for (var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
	      var index = i - Math.floor(i / cols) * cols;
	      if (gridEnabled) {
	        var colIndexToPrepend = cols - index - 1;
	        for (var _i5 = slides.length - 1; _i5 >= 0; _i5 -= 1) {
	          if (slides[_i5].column === colIndexToPrepend) prependSlidesIndexes.push(_i5);
	        }
	        // slides.forEach((slide, slideIndex) => {
	        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
	        // });
	      } else {
	        prependSlidesIndexes.push(cols - index - 1);
	      }
	    }
	  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
	    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
	
	    var _loop = function _loop(_i6) {
	      var index = _i6 - Math.floor(_i6 / cols) * cols;
	      if (gridEnabled) {
	        slides.forEach(function (slide, slideIndex) {
	          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
	        });
	      } else {
	        appendSlidesIndexes.push(index);
	      }
	    };
	
	    for (var _i6 = 0; _i6 < slidesAppended; _i6 += 1) {
	      _loop(_i6);
	    }
	  }
	  swiper.__preventObserver__ = true;
	  requestAnimationFrame(function () {
	    swiper.__preventObserver__ = false;
	  });
	  if (isPrev) {
	    prependSlidesIndexes.forEach(function (index) {
	      slides[index].swiperLoopMoveDOM = true;
	      slidesEl.prepend(slides[index]);
	      slides[index].swiperLoopMoveDOM = false;
	    });
	  }
	  if (isNext) {
	    appendSlidesIndexes.forEach(function (index) {
	      slides[index].swiperLoopMoveDOM = true;
	      slidesEl.append(slides[index]);
	      slides[index].swiperLoopMoveDOM = false;
	    });
	  }
	  swiper.recalcSlides();
	  if (params.slidesPerView === 'auto') {
	    swiper.updateSlides();
	  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
	    swiper.slides.forEach(function (slide, slideIndex) {
	      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
	    });
	  }
	  if (params.watchSlidesProgress) {
	    swiper.updateSlidesOffset();
	  }
	  if (slideTo) {
	    if (prependSlidesIndexes.length > 0 && isPrev) {
	      if (typeof slideRealIndex === 'undefined') {
	        var currentSlideTranslate = swiper.slidesGrid[activeIndex];
	        var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
	        var diff = newSlideTranslate - currentSlideTranslate;
	        if (byMousewheel) {
	          swiper.setTranslate(swiper.translate - diff);
	        } else {
	          swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
	          if (setTranslate) {
	            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
	            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
	          }
	        }
	      } else {
	        if (setTranslate) {
	          var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
	          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
	          swiper.touchEventsData.currentTranslate = swiper.translate;
	        }
	      }
	    } else if (appendSlidesIndexes.length > 0 && isNext) {
	      if (typeof slideRealIndex === 'undefined') {
	        var _currentSlideTranslate = swiper.slidesGrid[activeIndex];
	        var _newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
	        var _diff = _newSlideTranslate - _currentSlideTranslate;
	        if (byMousewheel) {
	          swiper.setTranslate(swiper.translate - _diff);
	        } else {
	          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
	          if (setTranslate) {
	            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - _diff;
	            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - _diff;
	          }
	        }
	      } else {
	        var _shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
	        swiper.slideTo(swiper.activeIndex - _shift, 0, false, true);
	      }
	    }
	  }
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  if (swiper.controller && swiper.controller.control && !byController) {
	    var loopParams = {
	      slideRealIndex: slideRealIndex,
	      direction: direction,
	      setTranslate: setTranslate,
	      activeSlideIndex: activeSlideIndex,
	      byController: true
	    };
	    if (Array.isArray(swiper.controller.control)) {
	      swiper.controller.control.forEach(function (c) {
	        if (!c.destroyed && c.params.loop) c.loopFix(_extends({}, loopParams, {
	          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
	        }));
	      });
	    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
	      swiper.controller.control.loopFix(_extends({}, loopParams, {
	        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
	      }));
	    }
	  }
	  swiper.emit('loopFix');
	}
	
	function loopDestroy() {
	  var swiper = this;
	  var params = swiper.params,
	      slidesEl = swiper.slidesEl;
	
	  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
	  swiper.recalcSlides();
	  var newSlidesOrder = [];
	  swiper.slides.forEach(function (slideEl) {
	    var index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
	    newSlidesOrder[index] = slideEl;
	  });
	  swiper.slides.forEach(function (slideEl) {
	    slideEl.removeAttribute('data-swiper-slide-index');
	  });
	  newSlidesOrder.forEach(function (slideEl) {
	    slidesEl.append(slideEl);
	  });
	  swiper.recalcSlides();
	  swiper.slideTo(swiper.realIndex, 0);
	}
	
	var loop = {
	  loopCreate: loopCreate,
	  loopFix: loopFix,
	  loopDestroy: loopDestroy
	};
	
	function setGrabCursor(moving) {
	  var swiper = this;
	  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
	  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
	  if (swiper.isElement) {
	    swiper.__preventObserver__ = true;
	  }
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	  if (swiper.isElement) {
	    requestAnimationFrame(function () {
	      swiper.__preventObserver__ = false;
	    });
	  }
	}
	
	function unsetGrabCursor() {
	  var swiper = this;
	  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
	    return;
	  }
	  if (swiper.isElement) {
	    swiper.__preventObserver__ = true;
	  }
	  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
	  if (swiper.isElement) {
	    requestAnimationFrame(function () {
	      swiper.__preventObserver__ = false;
	    });
	  }
	}
	
	var grabCursor = {
	  setGrabCursor: setGrabCursor,
	  unsetGrabCursor: unsetGrabCursor
	};
	
	// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
	function closestElement(selector, base) {
	  if (base === void 0) {
	    base = this;
	  }
	  function __closestFrom(el) {
	    if (!el || el === (0, _ssrWindowEsm.g)() || el === (0, _ssrWindowEsm.a)()) return null;
	    if (el.assignedSlot) el = el.assignedSlot;
	    var found = el.closest(selector);
	    if (!found && !el.getRootNode) {
	      return null;
	    }
	    return found || __closestFrom(el.getRootNode().host);
	  }
	  return __closestFrom(base);
	}
	function preventEdgeSwipe(swiper, event, startX) {
	  var window = (0, _ssrWindowEsm.a)();
	  var params = swiper.params;
	
	  var edgeSwipeDetection = params.edgeSwipeDetection;
	  var edgeSwipeThreshold = params.edgeSwipeThreshold;
	  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
	    if (edgeSwipeDetection === 'prevent') {
	      event.preventDefault();
	      return true;
	    }
	    return false;
	  }
	  return true;
	}
	function onTouchStart(event) {
	  var swiper = this;
	  var document = (0, _ssrWindowEsm.g)();
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  var data = swiper.touchEventsData;
	  if (e.type === 'pointerdown') {
	    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
	      return;
	    }
	    data.pointerId = e.pointerId;
	  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
	    data.touchId = e.targetTouches[0].identifier;
	  }
	  if (e.type === 'touchstart') {
	    // don't proceed touch event
	    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
	    return;
	  }
	  var params = swiper.params,
	      touches = swiper.touches,
	      enabled = swiper.enabled;
	
	  if (!enabled) return;
	  if (!params.simulateTouch && e.pointerType === 'mouse') return;
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return;
	  }
	  if (!swiper.animating && params.cssMode && params.loop) {
	    swiper.loopFix();
	  }
	  var targetEl = e.target;
	  if (params.touchEventsTarget === 'wrapper') {
	    if (!swiper.wrapperEl.contains(targetEl)) return;
	  }
	  if ('which' in e && e.which === 3) return;
	  if ('button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return;
	
	  // change target el for shadow root component
	  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
	  // eslint-disable-next-line
	  var eventPath = e.composedPath ? e.composedPath() : e.path;
	  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
	    targetEl = eventPath[0];
	  }
	  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : '.' + params.noSwipingClass;
	  var isTargetShadow = !!(e.target && e.target.shadowRoot);
	
	  // use closestElement for shadow root element to get the actual closest for nested shadow root element
	  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
	    swiper.allowClick = true;
	    return;
	  }
	  if (params.swipeHandler) {
	    if (!targetEl.closest(params.swipeHandler)) return;
	  }
	  touches.currentX = e.pageX;
	  touches.currentY = e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY;
	
	  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
	
	  if (!preventEdgeSwipe(swiper, e, startX)) {
	    return;
	  }
	  Object.assign(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined
	  });
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = (0, _utils.d)();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;
	  var preventDefault = true;
	  if (targetEl.matches(data.focusableElements)) {
	    preventDefault = false;
	    if (targetEl.nodeName === 'SELECT') {
	      data.isTouched = false;
	    }
	  }
	  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) {
	    document.activeElement.blur();
	  }
	  var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
	    e.preventDefault();
	  }
	  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
	    swiper.freeMode.onTouchStart();
	  }
	  swiper.emit('touchStart', e);
	}
	
	function onTouchMove(event) {
	  var document = (0, _ssrWindowEsm.g)();
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate,
	      enabled = swiper.enabled;
	
	  if (!enabled) return;
	  if (!params.simulateTouch && event.pointerType === 'mouse') return;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  if (e.type === 'pointermove') {
	    if (data.touchId !== null) return; // return from pointer if we use touch
	    var id = e.pointerId;
	    if (id !== data.pointerId) return;
	  }
	  var targetTouch = void 0;
	  if (e.type === 'touchmove') {
	    targetTouch = [].concat(_toConsumableArray(e.changedTouches)).filter(function (t) {
	      return t.identifier === data.touchId;
	    })[0];
	    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
	  } else {
	    targetTouch = e;
	  }
	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	    return;
	  }
	  var pageX = targetTouch.pageX;
	  var pageY = targetTouch.pageY;
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	  if (!swiper.allowTouchMove) {
	    if (!e.target.matches(data.focusableElements)) {
	      swiper.allowClick = false;
	    }
	    if (data.isTouched) {
	      Object.assign(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY
	      });
	      data.touchStartTime = (0, _utils.d)();
	    }
	    return;
	  }
	  if (params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
	      return;
	    }
	  }
	  if (document.activeElement) {
	    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	  touches.previousX = touches.currentX;
	  touches.previousY = touches.currentY;
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle = void 0;
	    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if (diffX * diffX + diffY * diffY >= 25) {
	        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
	      }
	    }
	  }
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	  if (typeof data.startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	  if (!data.startMoving) {
	    return;
	  }
	  swiper.allowClick = false;
	  if (!params.cssMode && e.cancelable) {
	    e.preventDefault();
	  }
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }
	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
	  if (params.oneWayMovement) {
	    diff = Math.abs(diff) * (rtl ? 1 : -1);
	    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
	  }
	  touches.diff = diff;
	  diff *= params.touchRatio;
	  if (rtl) {
	    diff = -diff;
	    touchesDiff = -touchesDiff;
	  }
	  var prevTouchesDirection = swiper.touchesDirection;
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
	  var isLoop = swiper.params.loop && !params.cssMode;
	  var allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
	  if (!data.isMoved) {
	    if (isLoop && allowLoopFix) {
	      swiper.loopFix({
	        direction: swiper.swipeDirection
	      });
	    }
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	    if (swiper.animating) {
	      var evt = new window.CustomEvent('transitionend', {
	        bubbles: true,
	        cancelable: true
	      });
	      swiper.wrapperEl.dispatchEvent(evt);
	    }
	    data.allowMomentumBounce = false;
	    // Grab Cursor
	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	    swiper.emit('sliderFirstMove', e);
	  }
	  var loopFixed = void 0;
	  new Date().getTime();
	  if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
	    Object.assign(touches, {
	      startX: pageX,
	      startY: pageY,
	      currentX: pageX,
	      currentY: pageY,
	      startTranslate: data.currentTranslate
	    });
	    data.loopSwapReset = true;
	    data.startTranslate = data.currentTranslate;
	    return;
	  }
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	  data.currentTranslate = diff + data.startTranslate;
	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	  if (diff > 0) {
	    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) {
	      swiper.loopFix({
	        direction: 'prev',
	        setTranslate: true,
	        activeSlideIndex: 0
	      });
	    }
	    if (data.currentTranslate > swiper.minTranslate()) {
	      disableParentSwiper = false;
	      if (params.resistance) {
	        data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
	      }
	    }
	  } else if (diff < 0) {
	    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) {
	      swiper.loopFix({
	        direction: 'next',
	        setTranslate: true,
	        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
	      });
	    }
	    if (data.currentTranslate < swiper.maxTranslate()) {
	      disableParentSwiper = false;
	      if (params.resistance) {
	        data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
	      }
	    }
	  }
	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  }
	
	  // Directions locks
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
	    data.currentTranslate = data.startTranslate;
	  }
	
	  // Threshold
	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }
	  if (!params.followFinger || params.cssMode) return;
	
	  // Update active index in free mode
	  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
	    swiper.freeMode.onTouchMove();
	  }
	  // Update progress
	  swiper.updateProgress(data.currentTranslate);
	  // Update translate
	  swiper.setTranslate(data.currentTranslate);
	}
	
	function onTouchEnd(event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  var targetTouch = void 0;
	  var isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
	  if (!isTouchEvent) {
	    if (data.touchId !== null) return; // return from pointer if we use touch
	    if (e.pointerId !== data.pointerId) return;
	    targetTouch = e;
	  } else {
	    targetTouch = [].concat(_toConsumableArray(e.changedTouches)).filter(function (t) {
	      return t.identifier === data.touchId;
	    })[0];
	    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
	  }
	  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
	    var proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
	    if (!proceed) {
	      return;
	    }
	  }
	  data.pointerId = null;
	  data.touchId = null;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate,
	      slidesGrid = swiper.slidesGrid,
	      enabled = swiper.enabled;
	
	  if (!enabled) return;
	  if (!params.simulateTouch && e.pointerType === 'mouse') return;
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	  data.allowTouchCallbacks = false;
	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	
	  // Return Grab Cursor
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  }
	
	  // Time diff
	  var touchEndTime = (0, _utils.d)();
	  var timeDiff = touchEndTime - data.touchStartTime;
	
	  // Tap, doubleTap, Click
	  if (swiper.allowClick) {
	    var pathTree = e.path || e.composedPath && e.composedPath();
	    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
	    swiper.emit('tap click', e);
	    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
	      swiper.emit('doubleTap doubleClick', e);
	    }
	  }
	  data.lastClickTime = (0, _utils.d)();
	  (0, _utils.n)(function () {
	    if (!swiper.destroyed) swiper.allowClick = true;
	  });
	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	  var currentPos = void 0;
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }
	  if (params.cssMode) {
	    return;
	  }
	  if (params.freeMode && params.freeMode.enabled) {
	    swiper.freeMode.onTouchEnd({
	      currentPos: currentPos
	    });
	    return;
	  }
	
	  // Find current slide
	  var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];
	  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
	    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	    if (typeof slidesGrid[i + _increment] !== 'undefined') {
	      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
	      }
	    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  }
	  var rewindFirstIndex = null;
	  var rewindLastIndex = null;
	  if (params.rewind) {
	    if (swiper.isBeginning) {
	      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
	    } else if (swiper.isEnd) {
	      rewindFirstIndex = 0;
	    }
	  }
	  // Find current slide size
	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > 1 - params.longSwipesRatio) {
	        swiper.slideTo(stopIndex + increment);
	      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
	        swiper.slideTo(rewindLastIndex);
	      } else {
	        swiper.slideTo(stopIndex);
	      }
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
	    if (!isNavButtonTarget) {
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
	      }
	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
	      }
	    } else if (e.target === swiper.navigation.nextEl) {
	      swiper.slideTo(stopIndex + increment);
	    } else {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}
	
	function onResize() {
	  var swiper = this;
	  var params = swiper.params,
	      el = swiper.el;
	
	  if (el && el.offsetWidth === 0) return;
	
	  // Breakpoints
	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  }
	
	  // Save locks
	  var allowSlideNext = swiper.allowSlideNext,
	      allowSlidePrev = swiper.allowSlidePrev,
	      snapGrid = swiper.snapGrid;
	
	  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	
	  // Disable locks on resize
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	  swiper.updateSize();
	  swiper.updateSlides();
	  swiper.updateSlidesClasses();
	  var isVirtualLoop = isVirtual && params.loop;
	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
	    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
	    if (swiper.params.loop && !isVirtual) {
	      swiper.slideToLoop(swiper.realIndex, 0, false, true);
	    } else {
	      swiper.slideTo(swiper.activeIndex, 0, false, true);
	    }
	  }
	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	    clearTimeout(swiper.autoplay.resizeTimeout);
	    swiper.autoplay.resizeTimeout = setTimeout(function () {
	      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	        swiper.autoplay.resume();
	      }
	    }, 500);
	  }
	  // Return locks after resize
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}
	
	function onClick(e) {
	  var swiper = this;
	  if (!swiper.enabled) return;
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) e.preventDefault();
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}
	
	function onScroll() {
	  var swiper = this;
	  var wrapperEl = swiper.wrapperEl,
	      rtlTranslate = swiper.rtlTranslate,
	      enabled = swiper.enabled;
	
	  if (!enabled) return;
	  swiper.previousTranslate = swiper.translate;
	  if (swiper.isHorizontal()) {
	    swiper.translate = -wrapperEl.scrollLeft;
	  } else {
	    swiper.translate = -wrapperEl.scrollTop;
	  }
	  // eslint-disable-next-line
	  if (swiper.translate === 0) swiper.translate = 0;
	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();
	  var newProgress = void 0;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
	  }
	  if (newProgress !== swiper.progress) {
	    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }
	  swiper.emit('setTranslate', swiper.translate, false);
	}
	
	function onLoad(e) {
	  var swiper = this;
	  processLazyPreloader(swiper, e.target);
	  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
	    return;
	  }
	  swiper.update();
	}
	
	function onDocumentTouchStart() {
	  var swiper = this;
	  if (swiper.documentTouchHandlerProceeded) return;
	  swiper.documentTouchHandlerProceeded = true;
	  if (swiper.params.touchReleaseOnEdges) {
	    swiper.el.style.touchAction = 'auto';
	  }
	}
	
	var events = function events(swiper, method) {
	  var document = (0, _ssrWindowEsm.g)();
	  var params = swiper.params,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device;
	
	  var capture = !!params.nested;
	  var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
	  var swiperMethod = method;
	
	  // Touch Events
	  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
	    passive: false,
	    capture: capture
	  });
	  el[domMethod]('touchstart', swiper.onTouchStart, {
	    passive: false
	  });
	  el[domMethod]('pointerdown', swiper.onTouchStart, {
	    passive: false
	  });
	  document[domMethod]('touchmove', swiper.onTouchMove, {
	    passive: false,
	    capture: capture
	  });
	  document[domMethod]('pointermove', swiper.onTouchMove, {
	    passive: false,
	    capture: capture
	  });
	  document[domMethod]('touchend', swiper.onTouchEnd, {
	    passive: true
	  });
	  document[domMethod]('pointerup', swiper.onTouchEnd, {
	    passive: true
	  });
	  document[domMethod]('pointercancel', swiper.onTouchEnd, {
	    passive: true
	  });
	  document[domMethod]('touchcancel', swiper.onTouchEnd, {
	    passive: true
	  });
	  document[domMethod]('pointerout', swiper.onTouchEnd, {
	    passive: true
	  });
	  document[domMethod]('pointerleave', swiper.onTouchEnd, {
	    passive: true
	  });
	  document[domMethod]('contextmenu', swiper.onTouchEnd, {
	    passive: true
	  });
	
	  // Prevent Links Clicks
	  if (params.preventClicks || params.preventClicksPropagation) {
	    el[domMethod]('click', swiper.onClick, true);
	  }
	  if (params.cssMode) {
	    wrapperEl[domMethod]('scroll', swiper.onScroll);
	  }
	
	  // Resize handler
	  if (params.updateOnWindowResize) {
	    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
	  } else {
	    swiper[swiperMethod]('observerUpdate', onResize, true);
	  }
	
	  // Images loader
	  el[domMethod]('load', swiper.onLoad, {
	    capture: true
	  });
	};
	function attachEvents() {
	  var swiper = this;
	  var params = swiper.params;
	
	  swiper.onTouchStart = onTouchStart.bind(swiper);
	  swiper.onTouchMove = onTouchMove.bind(swiper);
	  swiper.onTouchEnd = onTouchEnd.bind(swiper);
	  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
	  if (params.cssMode) {
	    swiper.onScroll = onScroll.bind(swiper);
	  }
	  swiper.onClick = onClick.bind(swiper);
	  swiper.onLoad = onLoad.bind(swiper);
	  events(swiper, 'on');
	}
	function detachEvents() {
	  var swiper = this;
	  events(swiper, 'off');
	}
	var events$1 = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents
	};
	
	var isGridEnabled = function isGridEnabled(swiper, params) {
	  return swiper.grid && params.grid && params.grid.rows > 1;
	};
	function setBreakpoint() {
	  var swiper = this;
	  var realIndex = swiper.realIndex,
	      initialized = swiper.initialized,
	      params = swiper.params,
	      el = swiper.el;
	
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
	
	  // Get breakpoint for window width and update parameters
	  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
	  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
	  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	  var wasMultiRow = isGridEnabled(swiper, params);
	  var isMultiRow = isGridEnabled(swiper, breakpointParams);
	  var wasEnabled = params.enabled;
	  if (wasMultiRow && !isMultiRow) {
	    el.classList.remove(params.containerModifierClass + 'grid', params.containerModifierClass + 'grid-column');
	    swiper.emitContainerClasses();
	  } else if (!wasMultiRow && isMultiRow) {
	    el.classList.add(params.containerModifierClass + 'grid');
	    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
	      el.classList.add(params.containerModifierClass + 'grid-column');
	    }
	    swiper.emitContainerClasses();
	  }
	
	  // Toggle navigation, pagination, scrollbar
	  ['navigation', 'pagination', 'scrollbar'].forEach(function (prop) {
	    if (typeof breakpointParams[prop] === 'undefined') return;
	    var wasModuleEnabled = params[prop] && params[prop].enabled;
	    var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
	    if (wasModuleEnabled && !isModuleEnabled) {
	      swiper[prop].disable();
	    }
	    if (!wasModuleEnabled && isModuleEnabled) {
	      swiper[prop].enable();
	    }
	  });
	  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
	  var wasLoop = params.loop;
	  if (directionChanged && initialized) {
	    swiper.changeDirection();
	  }
	  (0, _utils.u)(swiper.params, breakpointParams);
	  var isEnabled = swiper.params.enabled;
	  var hasLoop = swiper.params.loop;
	  Object.assign(swiper, {
	    allowTouchMove: swiper.params.allowTouchMove,
	    allowSlideNext: swiper.params.allowSlideNext,
	    allowSlidePrev: swiper.params.allowSlidePrev
	  });
	  if (wasEnabled && !isEnabled) {
	    swiper.disable();
	  } else if (!wasEnabled && isEnabled) {
	    swiper.enable();
	  }
	  swiper.currentBreakpoint = breakpoint;
	  swiper.emit('_beforeBreakpoint', breakpointParams);
	  if (initialized) {
	    if (needsReLoop) {
	      swiper.loopDestroy();
	      swiper.loopCreate(realIndex);
	      swiper.updateSlides();
	    } else if (!wasLoop && hasLoop) {
	      swiper.loopCreate(realIndex);
	      swiper.updateSlides();
	    } else if (wasLoop && !hasLoop) {
	      swiper.loopDestroy();
	    }
	  }
	  swiper.emit('breakpoint', breakpointParams);
	}
	
	function getBreakpoint(breakpoints, base, containerEl) {
	  if (base === void 0) {
	    base = 'window';
	  }
	  if (!breakpoints || base === 'container' && !containerEl) return undefined;
	  var breakpoint = false;
	  var window = (0, _ssrWindowEsm.a)();
	  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
	  var points = Object.keys(breakpoints).map(function (point) {
	    if (typeof point === 'string' && point.indexOf('@') === 0) {
	      var minRatio = parseFloat(point.substr(1));
	      var value = currentHeight * minRatio;
	      return {
	        value: value,
	        point: point
	      };
	    }
	    return {
	      value: point,
	      point: point
	    };
	  });
	  points.sort(function (a, b) {
	    return parseInt(a.value, 10) - parseInt(b.value, 10);
	  });
	  for (var i = 0; i < points.length; i += 1) {
	    var _points$i = points[i],
	        point = _points$i.point,
	        value = _points$i.value;
	
	    if (base === 'window') {
	      if (window.matchMedia('(min-width: ' + value + 'px)').matches) {
	        breakpoint = point;
	      }
	    } else if (value <= containerEl.clientWidth) {
	      breakpoint = point;
	    }
	  }
	  return breakpoint || 'max';
	}
	
	var breakpoints = {
	  setBreakpoint: setBreakpoint,
	  getBreakpoint: getBreakpoint
	};
	
	function prepareClasses(entries, prefix) {
	  var resultClasses = [];
	  entries.forEach(function (item) {
	    if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
	      Object.keys(item).forEach(function (classNames) {
	        if (item[classNames]) {
	          resultClasses.push(prefix + classNames);
	        }
	      });
	    } else if (typeof item === 'string') {
	      resultClasses.push(prefix + item);
	    }
	  });
	  return resultClasses;
	}
	function addClasses() {
	  var _el$classList;
	
	  var swiper = this;
	  var classNames = swiper.classNames,
	      params = swiper.params,
	      rtl = swiper.rtl,
	      el = swiper.el,
	      device = swiper.device;
	  // prettier-ignore
	
	  var suffixes = prepareClasses(['initialized', params.direction, {
	    'free-mode': swiper.params.freeMode && params.freeMode.enabled
	  }, {
	    'autoheight': params.autoHeight
	  }, {
	    'rtl': rtl
	  }, {
	    'grid': params.grid && params.grid.rows > 1
	  }, {
	    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
	  }, {
	    'android': device.android
	  }, {
	    'ios': device.ios
	  }, {
	    'css-mode': params.cssMode
	  }, {
	    'centered': params.cssMode && params.centeredSlides
	  }, {
	    'watch-progress': params.watchSlidesProgress
	  }], params.containerModifierClass);
	  classNames.push.apply(classNames, _toConsumableArray(suffixes));
	  (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(classNames));
	  swiper.emitContainerClasses();
	}
	
	function removeClasses() {
	  var _el$classList2;
	
	  var swiper = this;
	  var el = swiper.el,
	      classNames = swiper.classNames;
	
	  (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(classNames));
	  swiper.emitContainerClasses();
	}
	
	var classes = {
	  addClasses: addClasses,
	  removeClasses: removeClasses
	};
	
	function checkOverflow() {
	  var swiper = this;
	  var wasLocked = swiper.isLocked,
	      params = swiper.params;
	  var slidesOffsetBefore = params.slidesOffsetBefore;
	
	  if (slidesOffsetBefore) {
	    var lastSlideIndex = swiper.slides.length - 1;
	    var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
	    swiper.isLocked = swiper.size > lastSlideRightEdge;
	  } else {
	    swiper.isLocked = swiper.snapGrid.length === 1;
	  }
	  if (params.allowSlideNext === true) {
	    swiper.allowSlideNext = !swiper.isLocked;
	  }
	  if (params.allowSlidePrev === true) {
	    swiper.allowSlidePrev = !swiper.isLocked;
	  }
	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	  }
	  if (wasLocked !== swiper.isLocked) {
	    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
	  }
	}
	var checkOverflow$1 = {
	  checkOverflow: checkOverflow
	};
	
	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  oneWayMovement: false,
	  swiperElementNodeName: 'SWIPER-CONTAINER',
	  touchEventsTarget: 'wrapper',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  resizeObserver: true,
	  nested: false,
	  createElements: false,
	  eventsPrefix: 'swiper',
	  enabled: true,
	  focusableElements: 'input, select, option, textarea, button, video, label',
	  // Overrides
	  width: null,
	  height: null,
	  //
	  preventInteractionOnTransition: false,
	  // ssr
	  userAgent: null,
	  url: null,
	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,
	  // Autoheight
	  autoHeight: false,
	  // Set wrapper width
	  setWrapperSize: false,
	  // Virtual Translate
	  virtualTranslate: false,
	  // Effects
	  effect: 'slide',
	  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	
	  // Breakpoints
	  breakpoints: undefined,
	  breakpointsBase: 'window',
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  slidesPerGroupAuto: false,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0,
	  // in px
	  slidesOffsetAfter: 0,
	  // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: true,
	  // Round length
	  roundLengths: false,
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 5,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	  // Progress
	  watchSlidesProgress: false,
	  // Cursor
	  grabCursor: false,
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	  // loop
	  loop: false,
	  loopAddBlankSlides: true,
	  loopAdditionalSlides: 0,
	  loopPreventsSliding: true,
	  // rewind
	  rewind: false,
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null,
	  // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	  // Passive Listeners
	  passiveListeners: true,
	  maxBackfaceHiddenSlides: 10,
	  // NS
	  containerModifierClass: 'swiper-',
	  // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideFullyVisibleClass: 'swiper-slide-fully-visible',
	  slideNextClass: 'swiper-slide-next',
	  slidePrevClass: 'swiper-slide-prev',
	  wrapperClass: 'swiper-wrapper',
	  lazyPreloaderClass: 'swiper-lazy-preloader',
	  lazyPreloadPrevNext: 0,
	  // Callbacks
	  runCallbacksOnInit: true,
	  // Internals
	  _emitClasses: false
	};
	
	function moduleExtendParams(params, allModulesParams) {
	  return function extendParams(obj) {
	    if (obj === void 0) {
	      obj = {};
	    }
	    var moduleParamName = Object.keys(obj)[0];
	    var moduleParams = obj[moduleParamName];
	    if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object' || moduleParams === null) {
	      (0, _utils.u)(allModulesParams, obj);
	      return;
	    }
	    if (params[moduleParamName] === true) {
	      params[moduleParamName] = {
	        enabled: true
	      };
	    }
	    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
	      params[moduleParamName].auto = true;
	    }
	    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
	      params[moduleParamName].auto = true;
	    }
	    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
	      (0, _utils.u)(allModulesParams, obj);
	      return;
	    }
	    if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
	      params[moduleParamName].enabled = true;
	    }
	    if (!params[moduleParamName]) params[moduleParamName] = {
	      enabled: false
	    };
	    (0, _utils.u)(allModulesParams, obj);
	  };
	}
	
	/* eslint no-param-reassign: "off" */
	var prototypes = {
	  eventsEmitter: eventsEmitter,
	  update: update,
	  translate: translate,
	  transition: transition,
	  slide: slide,
	  loop: loop,
	  grabCursor: grabCursor,
	  events: events$1,
	  breakpoints: breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes: classes
	};
	var extendedDefaults = {};
	
	var Swiper = function () {
	  function Swiper() {
	    _classCallCheck(this, Swiper);
	
	    var el = void 0;
	    var params = void 0;
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
	      params = args[0];
	    } else {
	      el = args[0];
	      params = args[1];
	    }
	    if (!params) params = {};
	    params = (0, _utils.u)({}, params);
	    if (el && !params.el) params.el = el;
	    var document = (0, _ssrWindowEsm.g)();
	    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
	      var swipers = [];
	      document.querySelectorAll(params.el).forEach(function (containerEl) {
	        var newParams = (0, _utils.u)({}, params, {
	          el: containerEl
	        });
	        swipers.push(new Swiper(newParams));
	      });
	      // eslint-disable-next-line no-constructor-return
	      return swipers;
	    }
	
	    // Swiper Instance
	    var swiper = this;
	    swiper.__swiper__ = true;
	    swiper.support = getSupport();
	    swiper.device = getDevice({
	      userAgent: params.userAgent
	    });
	    swiper.browser = getBrowser();
	    swiper.eventsListeners = {};
	    swiper.eventsAnyListeners = [];
	    swiper.modules = [].concat(_toConsumableArray(swiper.__modules__));
	    if (params.modules && Array.isArray(params.modules)) {
	      var _swiper$modules;
	
	      (_swiper$modules = swiper.modules).push.apply(_swiper$modules, _toConsumableArray(params.modules));
	    }
	    var allModulesParams = {};
	    swiper.modules.forEach(function (mod) {
	      mod({
	        params: params,
	        swiper: swiper,
	        extendParams: moduleExtendParams(params, allModulesParams),
	        on: swiper.on.bind(swiper),
	        once: swiper.once.bind(swiper),
	        off: swiper.off.bind(swiper),
	        emit: swiper.emit.bind(swiper)
	      });
	    });
	
	    // Extend defaults with modules params
	    var swiperParams = (0, _utils.u)({}, defaults, allModulesParams);
	
	    // Extend defaults with passed params
	    swiper.params = (0, _utils.u)({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = (0, _utils.u)({}, swiper.params);
	    swiper.passedParams = (0, _utils.u)({}, params);
	
	    // add event listeners
	    if (swiper.params && swiper.params.on) {
	      Object.keys(swiper.params.on).forEach(function (eventName) {
	        swiper.on(eventName, swiper.params.on[eventName]);
	      });
	    }
	    if (swiper.params && swiper.params.onAny) {
	      swiper.onAny(swiper.params.onAny);
	    }
	
	    // Extend Swiper
	    Object.assign(swiper, {
	      enabled: swiper.params.enabled,
	      el: el,
	      // Classes
	      classNames: [],
	      // Slides
	      slides: [],
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	      //
	      isBeginning: true,
	      isEnd: false,
	      // Props
	      translate: 0,
	      previousTranslate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	      cssOverflowAdjustment: function cssOverflowAdjustment() {
	        // Returns 0 unless `translate` is > 2**23
	        // Should be subtracted from css values to prevent overflow
	        return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
	      },
	
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	      // Touch Events
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        focusableElements: swiper.params.focusableElements,
	        // Last click time
	        lastClickTime: 0,
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        startMoving: undefined,
	        pointerId: null,
	        touchId: null
	      },
	      // Clicks
	      allowClick: true,
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0
	      },
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0
	    });
	    swiper.emit('_swiper');
	
	    // Init
	    if (swiper.params.init) {
	      swiper.init();
	    }
	
	    // Return app instance
	    // eslint-disable-next-line no-constructor-return
	    return swiper;
	  }
	
	  _createClass(Swiper, [{
	    key: 'getDirectionLabel',
	    value: function getDirectionLabel(property) {
	      if (this.isHorizontal()) {
	        return property;
	      }
	      // prettier-ignore
	      return {
	        'width': 'height',
	        'margin-top': 'margin-left',
	        'margin-bottom ': 'margin-right',
	        'margin-left': 'margin-top',
	        'margin-right': 'margin-bottom',
	        'padding-left': 'padding-top',
	        'padding-right': 'padding-bottom',
	        'marginRight': 'marginBottom'
	      }[property];
	    }
	  }, {
	    key: 'getSlideIndex',
	    value: function getSlideIndex(slideEl) {
	      var slidesEl = this.slidesEl,
	          params = this.params;
	
	      var slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
	      var firstSlideIndex = (0, _utils.g)(slides[0]);
	      return (0, _utils.g)(slideEl) - firstSlideIndex;
	    }
	  }, {
	    key: 'getSlideIndexByData',
	    value: function getSlideIndexByData(index) {
	      return this.getSlideIndex(this.slides.filter(function (slideEl) {
	        return slideEl.getAttribute('data-swiper-slide-index') * 1 === index;
	      })[0]);
	    }
	  }, {
	    key: 'recalcSlides',
	    value: function recalcSlides() {
	      var swiper = this;
	      var slidesEl = swiper.slidesEl,
	          params = swiper.params;
	
	      swiper.slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var swiper = this;
	      if (swiper.enabled) return;
	      swiper.enabled = true;
	      if (swiper.params.grabCursor) {
	        swiper.setGrabCursor();
	      }
	      swiper.emit('enable');
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var swiper = this;
	      if (!swiper.enabled) return;
	      swiper.enabled = false;
	      if (swiper.params.grabCursor) {
	        swiper.unsetGrabCursor();
	      }
	      swiper.emit('disable');
	    }
	  }, {
	    key: 'setProgress',
	    value: function setProgress(progress, speed) {
	      var swiper = this;
	      progress = Math.min(Math.max(progress, 0), 1);
	      var min = swiper.minTranslate();
	      var max = swiper.maxTranslate();
	      var current = (max - min) * progress + min;
	      swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	  }, {
	    key: 'emitContainerClasses',
	    value: function emitContainerClasses() {
	      var swiper = this;
	      if (!swiper.params._emitClasses || !swiper.el) return;
	      var cls = swiper.el.className.split(' ').filter(function (className) {
	        return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
	      });
	      swiper.emit('_containerClasses', cls.join(' '));
	    }
	  }, {
	    key: 'getSlideClasses',
	    value: function getSlideClasses(slideEl) {
	      var swiper = this;
	      if (swiper.destroyed) return '';
	      return slideEl.className.split(' ').filter(function (className) {
	        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
	      }).join(' ');
	    }
	  }, {
	    key: 'emitSlidesClasses',
	    value: function emitSlidesClasses() {
	      var swiper = this;
	      if (!swiper.params._emitClasses || !swiper.el) return;
	      var updates = [];
	      swiper.slides.forEach(function (slideEl) {
	        var classNames = swiper.getSlideClasses(slideEl);
	        updates.push({
	          slideEl: slideEl,
	          classNames: classNames
	        });
	        swiper.emit('_slideClass', slideEl, classNames);
	      });
	      swiper.emit('_slideClasses', updates);
	    }
	  }, {
	    key: 'slidesPerViewDynamic',
	    value: function slidesPerViewDynamic(view, exact) {
	      if (view === void 0) {
	        view = 'current';
	      }
	      if (exact === void 0) {
	        exact = false;
	      }
	      var swiper = this;
	      var params = swiper.params,
	          slides = swiper.slides,
	          slidesGrid = swiper.slidesGrid,
	          slidesSizesGrid = swiper.slidesSizesGrid,
	          swiperSize = swiper.size,
	          activeIndex = swiper.activeIndex;
	
	      var spv = 1;
	      if (typeof params.slidesPerView === 'number') return params.slidesPerView;
	      if (params.centeredSlides) {
	        var slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
	        var breakLoop = void 0;
	        for (var i = activeIndex + 1; i < slides.length; i += 1) {
	          if (slides[i] && !breakLoop) {
	            slideSize += Math.ceil(slides[i].swiperSlideSize);
	            spv += 1;
	            if (slideSize > swiperSize) breakLoop = true;
	          }
	        }
	        for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
	          if (slides[_i7] && !breakLoop) {
	            slideSize += slides[_i7].swiperSlideSize;
	            spv += 1;
	            if (slideSize > swiperSize) breakLoop = true;
	          }
	        }
	      } else {
	        // eslint-disable-next-line
	        if (view === 'current') {
	          for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
	            var slideInView = exact ? slidesGrid[_i8] + slidesSizesGrid[_i8] - slidesGrid[activeIndex] < swiperSize : slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize;
	            if (slideInView) {
	              spv += 1;
	            }
	          }
	        } else {
	          // previous
	          for (var _i9 = activeIndex - 1; _i9 >= 0; _i9 -= 1) {
	            var _slideInView = slidesGrid[activeIndex] - slidesGrid[_i9] < swiperSize;
	            if (_slideInView) {
	              spv += 1;
	            }
	          }
	        }
	      }
	      return spv;
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var swiper = this;
	      if (!swiper || swiper.destroyed) return;
	      var snapGrid = swiper.snapGrid,
	          params = swiper.params;
	      // Breakpoints
	
	      if (params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	      [].concat(_toConsumableArray(swiper.el.querySelectorAll('[loading="lazy"]'))).forEach(function (imageEl) {
	        if (imageEl.complete) {
	          processLazyPreloader(swiper, imageEl);
	        }
	      });
	      swiper.updateSize();
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	      function setTranslate() {
	        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	        swiper.setTranslate(newTranslate);
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      }
	      var translated = void 0;
	      if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
	        setTranslate();
	        if (params.autoHeight) {
	          swiper.updateAutoHeight();
	        }
	      } else {
	        if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
	          var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
	          translated = swiper.slideTo(slides.length - 1, 0, false, true);
	        } else {
	          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	        }
	        if (!translated) {
	          setTranslate();
	        }
	      }
	      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	        swiper.checkOverflow();
	      }
	      swiper.emit('update');
	    }
	  }, {
	    key: 'changeDirection',
	    value: function changeDirection(newDirection, needUpdate) {
	      if (needUpdate === void 0) {
	        needUpdate = true;
	      }
	      var swiper = this;
	      var currentDirection = swiper.params.direction;
	      if (!newDirection) {
	        // eslint-disable-next-line
	        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	      }
	      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
	        return swiper;
	      }
	      swiper.el.classList.remove('' + swiper.params.containerModifierClass + currentDirection);
	      swiper.el.classList.add('' + swiper.params.containerModifierClass + newDirection);
	      swiper.emitContainerClasses();
	      swiper.params.direction = newDirection;
	      swiper.slides.forEach(function (slideEl) {
	        if (newDirection === 'vertical') {
	          slideEl.style.width = '';
	        } else {
	          slideEl.style.height = '';
	        }
	      });
	      swiper.emit('changeDirection');
	      if (needUpdate) swiper.update();
	      return swiper;
	    }
	  }, {
	    key: 'changeLanguageDirection',
	    value: function changeLanguageDirection(direction) {
	      var swiper = this;
	      if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
	      swiper.rtl = direction === 'rtl';
	      swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
	      if (swiper.rtl) {
	        swiper.el.classList.add(swiper.params.containerModifierClass + 'rtl');
	        swiper.el.dir = 'rtl';
	      } else {
	        swiper.el.classList.remove(swiper.params.containerModifierClass + 'rtl');
	        swiper.el.dir = 'ltr';
	      }
	      swiper.update();
	    }
	  }, {
	    key: 'mount',
	    value: function mount(element) {
	      var swiper = this;
	      if (swiper.mounted) return true;
	
	      // Find el
	      var el = element || swiper.params.el;
	      if (typeof el === 'string') {
	        el = document.querySelector(el);
	      }
	      if (!el) {
	        return false;
	      }
	      el.swiper = swiper;
	      if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
	        swiper.isElement = true;
	      }
	      var getWrapperSelector = function getWrapperSelector() {
	        return '.' + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
	      };
	      var getWrapper = function getWrapper() {
	        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	          var res = el.shadowRoot.querySelector(getWrapperSelector());
	          // Children needs to return slot items
	          return res;
	        }
	        return (0, _utils.e)(el, getWrapperSelector())[0];
	      };
	      // Find Wrapper
	      var wrapperEl = getWrapper();
	      if (!wrapperEl && swiper.params.createElements) {
	        wrapperEl = (0, _utils.c)('div', swiper.params.wrapperClass);
	        el.append(wrapperEl);
	        (0, _utils.e)(el, '.' + swiper.params.slideClass).forEach(function (slideEl) {
	          wrapperEl.append(slideEl);
	        });
	      }
	      Object.assign(swiper, {
	        el: el,
	        wrapperEl: wrapperEl,
	        slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
	        hostEl: swiper.isElement ? el.parentNode.host : el,
	        mounted: true,
	        // RTL
	        rtl: el.dir.toLowerCase() === 'rtl' || (0, _utils.o)(el, 'direction') === 'rtl',
	        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, _utils.o)(el, 'direction') === 'rtl'),
	        wrongRTL: (0, _utils.o)(wrapperEl, 'display') === '-webkit-box'
	      });
	      return true;
	    }
	  }, {
	    key: 'init',
	    value: function init(el) {
	      var swiper = this;
	      if (swiper.initialized) return swiper;
	      var mounted = swiper.mount(el);
	      if (mounted === false) return swiper;
	      swiper.emit('beforeInit');
	
	      // Set breakpoint
	      if (swiper.params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	
	      // Add Classes
	      swiper.addClasses();
	
	      // Update size
	      swiper.updateSize();
	
	      // Update slides
	      swiper.updateSlides();
	      if (swiper.params.watchOverflow) {
	        swiper.checkOverflow();
	      }
	
	      // Set Grab Cursor
	      if (swiper.params.grabCursor && swiper.enabled) {
	        swiper.setGrabCursor();
	      }
	
	      // Slide To Initial Slide
	      if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
	        swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
	      } else {
	        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
	      }
	
	      // Create loop
	      if (swiper.params.loop) {
	        swiper.loopCreate();
	      }
	
	      // Attach events
	      swiper.attachEvents();
	      var lazyElements = [].concat(_toConsumableArray(swiper.el.querySelectorAll('[loading="lazy"]')));
	      if (swiper.isElement) {
	        lazyElements.push.apply(lazyElements, _toConsumableArray(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
	      }
	      lazyElements.forEach(function (imageEl) {
	        if (imageEl.complete) {
	          processLazyPreloader(swiper, imageEl);
	        } else {
	          imageEl.addEventListener('load', function (e) {
	            processLazyPreloader(swiper, e.target);
	          });
	        }
	      });
	      preload(swiper);
	
	      // Init Flag
	      swiper.initialized = true;
	      preload(swiper);
	
	      // Emit
	      swiper.emit('init');
	      swiper.emit('afterInit');
	      return swiper;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(deleteInstance, cleanStyles) {
	      if (deleteInstance === void 0) {
	        deleteInstance = true;
	      }
	      if (cleanStyles === void 0) {
	        cleanStyles = true;
	      }
	      var swiper = this;
	      var params = swiper.params,
	          el = swiper.el,
	          wrapperEl = swiper.wrapperEl,
	          slides = swiper.slides;
	
	      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	        return null;
	      }
	      swiper.emit('beforeDestroy');
	
	      // Init Flag
	      swiper.initialized = false;
	
	      // Detach events
	      swiper.detachEvents();
	
	      // Destroy loop
	      if (params.loop) {
	        swiper.loopDestroy();
	      }
	
	      // Cleanup styles
	      if (cleanStyles) {
	        swiper.removeClasses();
	        el.removeAttribute('style');
	        wrapperEl.removeAttribute('style');
	        if (slides && slides.length) {
	          slides.forEach(function (slideEl) {
	            slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
	            slideEl.removeAttribute('style');
	            slideEl.removeAttribute('data-swiper-slide-index');
	          });
	        }
	      }
	      swiper.emit('destroy');
	
	      // Detach emitter events
	      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	        swiper.off(eventName);
	      });
	      if (deleteInstance !== false) {
	        swiper.el.swiper = null;
	        (0, _utils.v)(swiper);
	      }
	      swiper.destroyed = true;
	      return null;
	    }
	  }], [{
	    key: 'extendDefaults',
	    value: function extendDefaults(newDefaults) {
	      (0, _utils.u)(extendedDefaults, newDefaults);
	    }
	  }, {
	    key: 'installModule',
	    value: function installModule(mod) {
	      if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
	      var modules = Swiper.prototype.__modules__;
	      if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
	        modules.push(mod);
	      }
	    }
	  }, {
	    key: 'use',
	    value: function use(module) {
	      if (Array.isArray(module)) {
	        module.forEach(function (m) {
	          return Swiper.installModule(m);
	        });
	        return Swiper;
	      }
	      Swiper.installModule(module);
	      return Swiper;
	    }
	  }, {
	    key: 'extendedDefaults',
	    get: function get() {
	      return extendedDefaults;
	    }
	  }, {
	    key: 'defaults',
	    get: function get() {
	      return defaults;
	    }
	  }]);
	
	  return Swiper;
	}();
	
	Object.keys(prototypes).forEach(function (prototypeGroup) {
	  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	  });
	});
	Swiper.use([Resize, Observer]);
	
	exports.S = Swiper;
	exports.d = defaults;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rpAnalytics = __webpack_require__(5);
	
	var SegmentIO = _interopRequireWildcard(_rpAnalytics);
	
	var _swiper = __webpack_require__(7);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _chunkArray = __webpack_require__(9);
	
	var _orderByPosition = __webpack_require__(2);
	
	var _outsideClickHandler = __webpack_require__(27);
	
	var _constants = __webpack_require__(0);
	
	var _constants2 = __webpack_require__(21);
	
	var _getBookmakersName = __webpack_require__(3);
	
	var _filterBookmakers = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OPEN = _constants.BOOKMAKER_STATUS.OPEN;
	var EXCLUSIVE = _constants.BOOKMAKER_OFFER_TYPE.EXCLUSIVE;
	
	
	var initBookmakersExclusiveOffersPanel = function initBookmakersExclusiveOffersPanel(desktopBookmakers, mobileBookmakers) {
	    var bookmakers = _constants.isMobile ? mobileBookmakers : desktopBookmakers;
	    var filteredBookmakers = (0, _filterBookmakers.getBookmakersToShow)(bookmakers, EXCLUSIVE);
	    /**
	     * bookmakerPosition is the index of displayed bookmaker card
	     * position is the position from API response and may be different from bookmakerPosition
	     * TODO: refactor and choose which prop is needed
	     */
	    var orderedBookmakers = (0, _orderByPosition.orderByPosition)(filteredBookmakers).map(function (bookmaker, index) {
	        return _extends({}, bookmaker, {
	            bookmakerPosition: index + 1
	        });
	    });
	
	    // Carousel wrapper will not be present if carousel_visibility is set to false - JP-9212
	    var containers = document.querySelectorAll(_constants2.selectors.mainContainer);
	
	    if (!bookmakers.length && containers.length) {
	        containers.forEach(function (container) {
	            container.classList.add(_constants2.classes.mainContainerHide);
	        });
	
	        return;
	    }
	
	    var swiperWrapper = document.createElement('div');
	    var chunkedBookmakers = (0, _chunkArray.chunkArray)(orderedBookmakers, 4);
	
	    chunkedBookmakers.forEach(function (chunk) {
	        chunk.forEach(function (bookmaker) {
	            var bookmakerOffer = bookmaker.altOffer ? bookmaker.altOffer : bookmaker.offer;
	
	            var swiperSlide = document.createElement('div');
	            swiperSlide.classList.add(_constants2.classes.slide);
	            swiperSlide.classList.add(_constants2.classes.offersContainer);
	            var bookmakerElement = document.createElement('div');
	            if (bookmaker.takeover_image) {
	                bookmakerElement.style.backgroundImage = 'url(' + bookmaker.takeover_image + ')';
	                bookmakerElement.style.backgroundSize = 'contain';
	                bookmakerElement.style.padding = '0px';
	            } else if (bookmaker.background_image) {
	                bookmakerElement.style.backgroundImage = 'url(' + bookmaker.background_image + ')';
	            } else {
	                bookmakerElement.style.backgroundColor = bookmaker.colourBranding || '#fff';
	            }
	
	            bookmakerElement.classList.add(_constants2.classes.bookmaker);
	
	            var tsAndCs = bookmaker.tsAndCs ? '\n                <div class="bookmakersExclusive__terms">\n                <p class="bookmakersExclusive__terms-text" data-terms-hidden="false" ' + (!bookmaker.colourBranding && 'style="background: #000"') + '">Terms</p>\n                </div>\n                <div class="bookmakersExclusive__terms-expand-wrapper" data-expanded="false" ' + (!bookmaker.colourBranding && 'style="background: #000"') + '">\n                    <p class="bookmakersExclusive__terms-hide" ' + (!bookmaker.colourBranding && 'style="background: #000"') + '">Hide</p>\n                    <p class="bookmakersExclusive__terms-expand-text">' + bookmaker.tsAndCs + '</p>\n                </div>\n            ' : '';
	
	            if (bookmaker.takeover_image) {
	                bookmakerElement.innerHTML = '\n                    ' + tsAndCs + '\n                    <a href=\'' + bookmaker.sign_up_link_1 + '\' target="_blank" \n                    class="bookmakersExclusive__takeoverImageLink bookmakersExclusive__claim-btn"\n                    data-name=\'' + bookmaker.name + '\'\n                    bookmaker-position=\'' + bookmaker.bookmakerPosition + '\'\n                    slide-item-position=\'' + bookmaker.position + '\'\n                    bookmaker-offer=\'null\'\n                    bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                    rel="noreferrer nofollow sponsored"\n                    ></a>';
	            } else {
	                bookmakerElement.innerHTML = '\n                ' + tsAndCs + '\n                <div class="bookmakersExclusive__container">\n                    <img class="bookmakersExclusive__logo" src="' + bookmaker.bookmaker_logo + '"/>\n                    ' + (bookmaker.offer && '<p class="bookmakersExclusive__offer"\n                            style="color: ' + (bookmaker.textColour || '#000') + '"\n                        >' + bookmaker.offer + '</p>') + '\n                </div>\n                ' + (bookmaker.tsAndCsRequired === 'true' ? '<button\n                                class="bookmakersExclusive__claim-btn"\n                                data-name=\'' + bookmaker.name + '\'\n                                bookmaker-position=\'' + bookmaker.bookmakerPosition + '\'\n                                slide-item-position=\'' + bookmaker.position + '\'\n                                bookmaker-offer=\'' + bookmakerOffer + '\'\n                                bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                                style="\n                                    background-color: ' + (bookmaker.linkColour || '#F01E28') + ';\n                                    color: ' + (bookmaker.linkTextColour || '#fff') + '\n                                    "\n                            >\n                                ' + (window.innerWidth > 989 ? bookmaker.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                            </button>' : '<a href=\'' + bookmaker.sign_up_link_1 + '\'\n                                data-name=\'' + bookmaker.name + '\'\n                                bookmaker-position=' + bookmaker.bookmakerPosition + '\n                                bookmaker-offer=\'' + bookmakerOffer + '\'\n                                bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                                target="_blank"\n                                rel="noreferrer nofollow sponsored"\n                                style="\n                                    background-color: ' + (bookmaker.linkColour || '#F01E28') + ';\n                                    color: ' + (bookmaker.linkTextColour || '#fff') + '\n                                    "\n                                class="bookmakersExclusive__claim-btn">\n                                ' + (window.innerWidth > 989 ? bookmaker.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                            </a>');
	            }
	            bookmakerElement.setAttribute(_constants2.attributes.slidePerPosition, bookmaker.bookmakerPosition);
	            bookmakerElement.setAttribute(_constants2.attributes.requiredTerms, bookmaker.tsAndCsRequired);
	            swiperSlide.appendChild(bookmakerElement);
	            swiperWrapper.appendChild(swiperSlide);
	        });
	    });
	
	    var swiperContainer = document.createElement('div');
	    swiperContainer.innerHTML = '\n        <div class="bookmakersExclusive__heading">\n            <div class="bookmakersExclusive__headingText">Today\u2019s Top Offers</div>\n            <div class="bookmakersExclusive__subHeading">\n                <p class="bookmakersExclusive__subHeadingText">Exclusive new offers</p>\n                <div class="bookmakersExclusive__subHeadingWrapper">\n                    <p class="bookmakersExclusive__subHeadingTextDragMore">Drag to view more</p>\n                    <a href="/free-bets/" target="_blank" class="bookmakersExclusive__subHeadingTextAllOffers">\n                        All offers\n                        <svg class="ui-icon ui-icon_sizeSmall">\n                            <use xlink:href="#icon-right"/>\n                        </svg>\n                    </a>\n                </div>\n            </div>\n        </div>\n        <div class="swiper bookmakersExclusive__swiperContainer">\n            <div class="swiper-wrapper">\n                ' + swiperWrapper.innerHTML + '\n            </div>\n        </div>\n    ';
	
	    document.querySelectorAll(_constants2.selectors.skeleton).forEach(function (skeleton) {
	        skeleton.remove();
	    });
	    var carouselContainers = document.querySelectorAll(_constants2.selectors.carouselContainer);
	
	    var slides = [];
	
	    // Carousel containers will not be present if carousel_visibility is set to false - JP-9212
	    if (carouselContainers.length > 0) {
	        document.querySelectorAll(_constants2.selectors.carouselContainer).forEach(function (container) {
	            // eslint-disable-next-line no-param-reassign
	            container.innerHTML = swiperContainer.innerHTML;
	        });
	
	        var bookmakersExclusiveContainer = document.querySelector(_constants2.selectors.container);
	        slides = bookmakersExclusiveContainer.querySelectorAll('.' + _constants2.classes.offersContainer);
	
	        // eslint-disable-next-line no-unused-vars
	        var swiper = new _swiper2.default(bookmakersExclusiveContainer, {
	            spaceBetween: 8,
	            allowTouchMove: true,
	            slidesPerView: 'auto'
	        });
	    }
	    /**
	     *
	     * @param {Object} data
	     */
	    var createPopUp = function createPopUp(data) {
	        var container = document.querySelector(_constants2.selectors.popUpContainer);
	        var popUpWrapper = document.createElement('div');
	        popUpWrapper.classList.add(_constants2.classes.popUpWrapper);
	        popUpWrapper.setAttribute('' + _constants2.attributes.slidePerPosition, data.position);
	        popUpWrapper.dataset.visible = false;
	        popUpWrapper.innerHTML = '\n            <div class="bookmakersExclusive__popUp" style="background: ' + (data.colourBranding || '#fff') + '">\n                <img class="bookmakersExclusive__popUpLogo" src="' + data.bookmaker_logo + '"/>\n                ' + (data.offer.length && '<p\n                        class="bookmakersExclusive__popUpTitle"\n                        style="color: ' + (data.textColour || '#000') + '"\n                    >' + data.offer + '</p>') + '\n                <a href=\'' + (data.sign_up_link_1 === '' ? '/' : data.sign_up_link_1) + '\'\n                    style="\n                        background-color: ' + (data.linkColour || '#F01E28') + ';\n                        color: ' + (data.linkTextColour || '#000') + '\n                        "\n                    target="_blank" class="bookmakersExclusive__PopUpClaimBtn"\n                    rel="noreferrer nofollow sponsored">\n                    ' + (window.innerWidth > 989 ? data.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                </a>\n                ' + (data.tsAndCs.length && '<p\n                        class="bookmakersExclusive__popUpTsAndCs"\n                        ' + (!data.colourBranding && 'style="color: #000"') + '\n                    >' + data.tsAndCs + '</p>') + '\n            </div>\n        ';
	
	        container.appendChild(popUpWrapper);
	    };
	
	    var bookmakerName = void 0;
	    var bookmakerPosition = void 0;
	    var bookmakerOffer = void 0;
	    var bookmakerTier = void 0;
	    var headerTitle = 'Offer’s Carousel';
	
	    var claimButtons = Array.from(document.querySelectorAll(_constants2.selectors.claimButton));
	    if (claimButtons.length) {
	        claimButtons.forEach(function (button) {
	            return button.addEventListener('click', function () {
	                bookmakerName = (0, _getBookmakersName.getBookmakersName)(button.getAttribute(_constants2.attributes.dataName));
	                bookmakerPosition = Number(button.getAttribute(_constants2.attributes.bookmakerPosition));
	
	                bookmakerOffer = button.getAttribute(_constants2.attributes.bookmakerOffer);
	                bookmakerTier = button.getAttribute(_constants2.attributes.bookmakerTier);
	
	                if (button.tagName === 'BUTTON') {
	                    var _SegmentIO$trackOffer;
	
	                    SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_STATUS, OPEN), _SegmentIO$trackOffer));
	                } else {
	                    var _SegmentIO$trackBookm;
	
	                    SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer === 'null' ? null : bookmakerOffer), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _SegmentIO$trackBookm));
	                }
	            });
	        });
	    }
	
	    var bookmakersCards = document.querySelectorAll(_constants2.selectors.offers);
	
	    bookmakersCards.forEach(function (bookmaker) {
	        var offersCard = bookmaker.querySelector(_constants2.selectors.offersCard);
	        var dataTermsAndConditions = offersCard.getAttribute(_constants2.attributes.requiredTerms);
	        var currentOfferData = orderedBookmakers[Number(offersCard.getAttribute(_constants2.attributes.slidePerPosition)) - 1];
	
	        if (dataTermsAndConditions.toLowerCase() === 'true') {
	            createPopUp(currentOfferData);
	        }
	    });
	
	    var button = document.querySelector(_constants2.selectors.allOffersButton);
	
	    // All offers button will not be present if carousel_visibility is set to false - JP-9212
	    if (button) {
	        button.addEventListener('click', function () {
	            SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle));
	        });
	    }
	
	    var popUpWrappers = document.querySelectorAll(_constants2.selectors.popUpWrapper);
	
	    // Slides will not be present if carousel_visibility is set to false - JP-9212
	    if (slides.length > 0) {
	        slides.forEach(function (slide) {
	            slide.addEventListener('click', function (e) {
	                if (e.target.classList.contains(_constants2.classes.termsText)) {
	                    var termsExpand = slide.querySelector(_constants2.selectors.expandWrapper);
	
	                    e.target.dataset.termsHidden = !JSON.parse(e.target.dataset.termsHidden);
	                    termsExpand.dataset.expanded = !JSON.parse(termsExpand.dataset.expanded);
	                } else if (e.target.classList.contains(_constants2.classes.termsHide)) {
	                    var termsBtn = slide.querySelector('.' + _constants2.classes.termsText);
	                    var _termsExpand = slide.querySelector(_constants2.selectors.expandWrapper);
	
	                    termsBtn.dataset.termsHidden = !JSON.parse(termsBtn.dataset.termsHidden);
	                    _termsExpand.dataset.expanded = !JSON.parse(_termsExpand.dataset.expanded);
	                } else if (e.target.tagName === 'BUTTON') {
	                    var popUp = Array.from(popUpWrappers).find(function (element) {
	                        return element.getAttribute(_constants2.attributes.slidePerPosition) === e.target.getAttribute(_constants2.attributes.slidePerPosition);
	                    });
	                    popUp.dataset.visible = 'true';
	                    document.documentElement.classList.add('no-scroll');
	                    (0, _outsideClickHandler.handleClickOutside)(_constants2.selectors.popUp, function () {
	                        popUp.dataset.visible = false;
	                        document.documentElement.classList.remove('no-scroll');
	                    });
	                }
	            });
	        });
	    }
	
	    popUpWrappers.forEach(function (wrapper) {
	        var claimButton = wrapper.querySelector(_constants2.selectors.popUpClaimButton);
	
	        claimButton.addEventListener('click', function () {
	            var _SegmentIO$trackBookm2;
	
	            var popUp = document.querySelector('.bookmakersExclusive__popUpWrapper[data-visible="true"]');
	            popUp.dataset.visible = false;
	            document.documentElement.classList.remove('no-scroll');
	
	            SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm2 = {}, _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _SegmentIO$trackBookm2));
	        });
	    });
	};
	
	exports.default = initBookmakersExclusiveOffersPanel;
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var selectors = exports.selectors = Object.freeze({
	    carouselContainer: '.carousel-container',
	    container: '.bookmakersExclusive__swiperContainer',
	    expandWrapper: '.bookmakersExclusive__terms-expand-wrapper',
	    skeleton: '.bookmakersExclusive__skeleton',
	    claimButton: '.bookmakersExclusive__claim-btn',
	    takeoverImageLink: '.bookmakersExclusive__takeoverImageLink',
	    allOffersButton: '.bookmakersExclusive__subHeadingTextAllOffers',
	    offers: '.bookmakersExclusive__offersContainer',
	    offersCard: '.bookmakersExclusive__bookmaker',
	    popUpContainer: '.bookmakersExclusive__popUpContainer',
	    popUpWrapper: '.bookmakersExclusive__popUpWrapper',
	    popUpClaimButton: '.bookmakersExclusive__PopUpClaimBtn',
	    headerTitle: '.bookmakersExclusive__headingText',
	    popUp: '.bookmakersExclusive__popUp',
	    mainContainer: '.js-carouselWrapper'
	});
	
	var classes = exports.classes = Object.freeze({
	    termsText: 'bookmakersExclusive__terms-text',
	    termsHide: 'bookmakersExclusive__terms-hide',
	    offersContainer: 'bookmakersExclusive__offersContainer',
	    bookmaker: 'bookmakersExclusive__bookmaker',
	    slide: 'swiper-slide',
	    popUpWrapper: 'bookmakersExclusive__popUpWrapper',
	    mainContainerHide: 'js-carouselWrapper--hide'
	});
	
	var attributes = exports.attributes = Object.freeze({
	    dataName: 'data-name',
	    bookmakerPosition: 'bookmaker-position',
	    bookmakerOffer: 'bookmaker-offer',
	    requiredTerms: 'required-terms-and-conditions',
	    slidePerPosition: 'slide-item-position',
	    bookmakerTier: 'bookmaker-tier'
	});
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _swiper = __webpack_require__(7);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _pagination = __webpack_require__(16);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _orderByPosition = __webpack_require__(2);
	
	var _chunkArray = __webpack_require__(9);
	
	var _constants = __webpack_require__(0);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initTierTwoBookmakersPanel = function initTierTwoBookmakersPanel(bookmakers) {
	    var _breakpoints;
	
	    var filteredBookmakers = bookmakers.filter(function (bookmaker) {
	        return bookmaker.name && bookmaker.includeInTier2Panel;
	    });
	    var orderedBookmakers = (0, _orderByPosition.orderByPosition)(filteredBookmakers);
	    var bookmakersPerSlide = 6;
	
	    var chunkedBookmakers = (0, _chunkArray.chunkArray)(orderedBookmakers, bookmakersPerSlide);
	    if (chunkedBookmakers.length > 1) {
	        var lastSlider = chunkedBookmakers[chunkedBookmakers.length - 1];
	        var neededOffersInLastSlider = bookmakersPerSlide - lastSlider.length;
	        lastSlider.push.apply(lastSlider, _toConsumableArray(bookmakers.slice(0, neededOffersInLastSlider)));
	    }
	
	    var swiperWrapper = document.createElement('div');
	    chunkedBookmakers.forEach(function (chunk, chunkIndex) {
	        var swiperSlide = document.createElement('div');
	        swiperSlide.classList.add('swiper-slide');
	        swiperSlide.classList.add('bookmakersTierTwo__offersContainer');
	        chunk.forEach(function (bookmaker, bookmakerIndex) {
	            var bookmakerOffer = bookmaker.altOffer || bookmaker.offer;
	            var bookmakerPosition = chunkIndex > 0 ? bookmakerIndex + 1 + bookmakersPerSlide * chunkIndex : bookmakerIndex + 1;
	            var bookmakerElements = document.createElement('a');
	            bookmakerElements.setAttribute('bookmaker-position', bookmakerPosition);
	            bookmakerElements.setAttribute('bookmaker-name', bookmaker.name);
	            bookmakerElements.setAttribute('href', bookmaker.signUpLink1);
	            bookmakerElements.setAttribute('bookmaker-offer', bookmakerOffer);
	            bookmakerElements.setAttribute('target', '_blank');
	            bookmakerElements.setAttribute('rel', 'noreferrer nofollow sponsored');
	            bookmakerElements.classList.add('bookmakersTierTwo__bookmaker');
	            bookmakerElements.innerHTML = '\n            <img class="bookmakersTierTwo__logo" src="' + bookmaker.bookmakerLogo + '"/>\n            <p class="bookmakersTierTwo__offer"\n                style="color: ' + (bookmaker.textColour || '#fff') + '"\n            >\n                ' + (bookmaker.offer ? bookmaker.offer : '') + '\n            </p>\n            ';
	            bookmakerElements.style.backgroundColor = bookmaker.colourBranding;
	            swiperSlide.appendChild(bookmakerElements);
	        });
	        swiperWrapper.appendChild(swiperSlide);
	    });
	
	    var swiperContainer = document.createElement('div');
	    swiperContainer.innerHTML = '\n        <div class="bookmakersTierTwo__heading">\n            <div class="bookmakersTierTwo__headingContainer">\n                <div class="bookmakersTierTwo__headingText">MORE OFFERS</div>\n                <div class="bookmakersTierTwo__badge">' + filteredBookmakers.length + '</div>\n            </div>\n            <div class="bookmakersTierTwo__subHeading">\n                <p class="bookmakersTierTwo__subHeadingText">Exclusive new customer offers</p>\n                <a href="/free-bets/" target="_blank" class="bookmakersTierTwo__subHeadingTextAllOffers">\n                    All offers\n                    <svg class="ui-icon ui-icon_sizeSmall">\n                        <use xlink:href="#icon-right"/>\n                    </svg>\n                </a>\n            </div>\n        </div>\n        <div class="swiper bookmakersTierTwo__swiperContainer">\n            <div class="swiper-wrapper">\n                ' + swiperWrapper.innerHTML + '\n            </div>\n            <p class="bookmakersTierTwo__BookmakerOffersContentTcApplyTierTwo">T&Cs apply. 18+ GambleAware.org</p>\n            <div class="swiper-pagination"></div>\n        </div>\n    ';
	
	    document.querySelectorAll('#bookmakersTierTwoSkeleton').forEach(function (skeleton) {
	        skeleton.remove();
	    });
	
	    document.querySelectorAll('#bookmakersTierTwoSwiper').forEach(function (div) {
	        var clone = swiperContainer.cloneNode(true);
	        div.appendChild(clone);
	
	        if (!chunkedBookmakers.length) {
	            div.parentNode.classList.add('bookmakersTierTwo--hidden');
	        }
	    });
	
	    // eslint-disable-next-line no-unused-vars
	    var swiper = new _swiper2.default('.bookmakersTierTwo__swiperContainer', {
	        modules: [_pagination2.default],
	        slidesPerView: 1,
	        spaceBetween: 10,
	        pagination: {
	            el: '.swiper-pagination',
	            clickable: true,
	            bulletClass: 'bookmakersTierTwo__paginationBullet',
	            bulletActiveClass: 'bookmakersTierTwo__paginationBulletActive'
	        },
	        breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, _constants.BREAKPOINTS.TABLET, {
	            slidesPerView: 2
	        }), _defineProperty(_breakpoints, _constants.BREAKPOINTS.DESKTOP, {
	            slidesPerView: 1
	        }), _breakpoints)
	    });
	};
	
	exports.default = initTierTwoBookmakersPanel;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(0);
	
	var renderPromotedTierTwoBookmakers = function renderPromotedTierTwoBookmakers(desktopOffers, mobileOffers) {
	    var defaultLinkText = 'Claim this offer';
	    var displayNone = 'display:none;';
	
	    desktopOffers.forEach(function (_ref) {
	        var altOffer = _ref.altOffer,
	            discBookmakerLogo = _ref.discBookmakerLogo,
	            bookmakerLogo = _ref.bookmakerLogo,
	            bookmakerLogoSquare = _ref.bookmakerLogoSquare,
	            bookmakerLogoLargeUrl = _ref.bookmakerLogoLargeUrl,
	            colourBranding = _ref.colourBranding,
	            linkText = _ref.linkText,
	            name = _ref.name,
	            offer = _ref.offer,
	            signUpLink1 = _ref.signUpLink1,
	            tsAndCs = _ref.tsAndCs;
	
	        var lowercaseName = name.toLowerCase().replace(' ', '');
	        var bookmakerOffer = altOffer || offer;
	        // bookmakerLogoSquare is in the response for tier2
	
	        // desktop promoted T2/T3 offers
	        var desktopOffer = document.createElement('li');
	        desktopOffer.classList.add('rh-bookmaker');
	        desktopOffer.classList.add('rh-bookmaker--' + lowercaseName);
	        desktopOffer.setAttribute('data-name', name);
	        desktopOffer.setAttribute('data-index', lowercaseName);
	        desktopOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
	        desktopOffer.setAttribute('bookmaker-color', colourBranding);
	        desktopOffer.setAttribute('promoted-bookmaker', 'true');
	        desktopOffer.setAttribute('bookmaker-offer', bookmakerOffer);
	
	        // For local testing -> square logo fetch from Janus
	        // ->  <img src="http://dev-beta.racingpost.com:8080/svgs/bookmaker-logos/${lowercaseName}-square.svg" class="rh-bookmaker__logo rh-logo--${key} rh-bookmaker__logo__square" alt="${displayName} logo" />
	        // -> <img src="http://dev-beta.racingpost.com:8080/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />
	        var innerHTMLDesktop = '\n                <div\n                    class="rh-bookmaker__header rh-bookmaker__header--' + lowercaseName + '"\n                >\n                    <img\n                        src=' + bookmakerLogoSquare + '\n                        width={32}\n                        height={32}\n                        alt=' + name + '\n                        class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + ' rh-bookmaker__logo__square"\n                    />\n                    <img\n                        src=' + bookmakerLogo + '\n                        width={70}\n                        height={32}\n                        alt=' + name + '\n                        class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + ' rh-bookmaker__logo--open"\n                    />\n                    <p class="rh-bookmaker__headline">' + offer + '</p>\n\n                       <a\n                           href=' + signUpLink1 + '\n                           target="_blank"\n                           class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker__btn_claim_header"\n                           style="' + (!_constants.isDesktopBeakpoint ? displayNone : '') + '"\n                           data-name=' + name + '\n                           data-index=' + lowercaseName + '\n                           data-test-selector="link-bm-' + lowercaseName + '"\n                           bookmaker-offer="' + bookmakerOffer + '"\n                           rel="noreferrer nofollow sponsored"\n                        >\n                        \n                         <img src="/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />\n                          CLAIM\n                       </a>\n\n                       <div class="rh-bookmaker__header rh-bookmaker-hidden-element rh-bookmaker-hidden-element-' + name.toLowerCase() + '" data-testid="Text__BookmakerOfferItemOffer">\n                          <div class="rh-bookmaker-light-text">' + tsAndCs + '</div>\n                       </div>\n\n                </div>\n\n                <div class="rh-bookmaker-offer">\n                    <p class="rh-bookmaker__headline">' + offer + '</p>\n                    <div class="rh-bookmaker-offer__headline">' + bookmakerOffer + '</div>\n                    <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n                    <a\n                        href=' + signUpLink1 + '\n                        target="_blank"\n                        class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker-offer__claim-btn-analytics"\n                        data-name=' + name + '\n                        data-index=' + lowercaseName + '\n                        data-test-selector="link-bm-' + lowercaseName + '"\n                        bookmaker-offer="' + bookmakerOffer + '"\n                        rel="noreferrer nofollow sponsored"\n                    >\n                        ' + (linkText || defaultLinkText) + '\n                    </a>\n                </div>\n            </div>\n    ';
	
	        var bookmakerContainersDesktop = document.querySelectorAll('.rh-bookmakers__list--web');
	        Array.from(bookmakerContainersDesktop).forEach(function (container) {
	            desktopOffer.innerHTML = innerHTMLDesktop;
	            container.appendChild(desktopOffer.cloneNode(true));
	        });
	
	        // tablet promoted T2/T3 offers
	        var tabletOffer = document.createElement('li');
	        tabletOffer.classList.add('rh-bookmaker');
	        tabletOffer.classList.add('rh-bookmaker--' + lowercaseName);
	        tabletOffer.setAttribute('data-name', name);
	        tabletOffer.setAttribute('data-index', lowercaseName);
	        tabletOffer.setAttribute('data-type', 'discOffer');
	        tabletOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
	        tabletOffer.setAttribute('bookmaker-color', colourBranding);
	        tabletOffer.setAttribute('promoted-bookmaker', 'true');
	        tabletOffer.setAttribute('bookmaker-offer', bookmakerOffer);
	
	        var innerHTMLTablet = '\n        <div class="rh-bookmaker__header">\n            <img\n                src=' + discBookmakerLogo + '\n                alt=' + name + '\n                class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + lowercaseName + '">\n            <img\n                src=' + (bookmakerLogoLargeUrl || '') + '\n                width=100\n                height=55\n                alt=' + name + '\n                class="rh-bookmaker__logo__text rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n            <div class="rh-bookmaker-offer__headline">' + offer + '</div>\n            <a\n                href=' + signUpLink1 + '\n                target="_blank"\n                class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                data-name=' + name + '\n                data-index=' + lowercaseName + '\n                data-test-selector="link-bm-' + lowercaseName + '"\n                bookmaker-offer="' + bookmakerOffer + '"\n                rel="noreferrer nofollow sponsored"\n            >\n                ' + (linkText || defaultLinkText) + '\n            </a>\n            <div class="rh-bookmaker-offer__copy">\n                ' + tsAndCs + '\n            </div>\n        </div>\n    ';
	
	        var bookmakerContainersTablet = document.querySelectorAll('.rh-bookmakers__list--tablet');
	        Array.from(bookmakerContainersTablet).forEach(function (container) {
	            tabletOffer.innerHTML = innerHTMLTablet;
	            container.appendChild(tabletOffer.cloneNode(true));
	        });
	    });
	
	    mobileOffers.forEach(function (_ref2) {
	        var altOffer = _ref2.altOffer,
	            offer = _ref2.offer,
	            discBookmakerLogo = _ref2.discBookmakerLogo,
	            tsAndCs = _ref2.tsAndCs,
	            discLinkURL = _ref2.discLinkURL,
	            bookmakerLogoLargeUrl = _ref2.bookmakerLogoLargeUrl,
	            colourBranding = _ref2.colourBranding,
	            linkText = _ref2.linkText,
	            name = _ref2.name;
	
	        var lowercaseName = name.toLowerCase().replace(' ', '');
	        var bookmakerOffer = altOffer || offer;
	
	        // mobile promoted T2/T3 offers
	        var mobileOffer = document.createElement('li');
	        mobileOffer.classList.add('rh-bookmaker');
	        mobileOffer.classList.add('rh-bookmaker--' + lowercaseName);
	        mobileOffer.setAttribute('data-name', name);
	        mobileOffer.setAttribute('data-index', lowercaseName);
	        mobileOffer.setAttribute('data-type', 'discOffer');
	        mobileOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
	        mobileOffer.setAttribute('bookmaker-color', colourBranding);
	        mobileOffer.setAttribute('promoted-bookmaker', 'true');
	        mobileOffer.setAttribute('bookmaker-offer', bookmakerOffer);
	
	        var innerHTMLMobile = '\n        <div class="rh-bookmaker__header">\n            <img\n                src=' + discBookmakerLogo + '\n                alt=' + name + '\n                class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + lowercaseName + '">\n            <img\n                src=' + (bookmakerLogoLargeUrl || '') + '\n                alt=' + name + '\n                class="rh-bookmaker__logo__text rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n            <div class="rh-bookmaker-offer__headline">' + offer + '</div>\n            <a\n                href=' + discLinkURL + '\n                target="_blank"\n                class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                data-name=' + name + '\n                data-index=' + lowercaseName + '\n                data-test-selector="link-bm-' + lowercaseName + '"\n                bookmaker-offer="' + bookmakerOffer + '"\n                rel="noreferrer nofollow sponsored"\n            >\n                ' + (linkText || defaultLinkText) + '\n            </a>\n            <div class="rh-bookmaker-offer__copy">\n                ' + tsAndCs + '\n            </div>\n        </div>\n    ';
	
	        var bookmakerContainersMobile = document.querySelectorAll('.rh-bookmakers__list--mobile');
	        Array.from(bookmakerContainersMobile).forEach(function (container) {
	            mobileOffer.innerHTML = innerHTMLMobile;
	            container.appendChild(mobileOffer.cloneNode(true));
	        });
	    });
	}; /* eslint-disable camelcase */
	exports.default = renderPromotedTierTwoBookmakers;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(0);
	
	var _filterBookmakers = __webpack_require__(10);
	
	/* eslint-disable camelcase, arrow-parens, no-multi-spaces */
	var TIER_ONE = _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE;
	// tier 1
	
	var keys = {
	    williamhill: 'williamHill',
	    raceBets: 'raceBets'
	};
	
	var isValidTopOffer = function isValidTopOffer(publishTime, archiveTime) {
	    var publishTimeObj = new Date(publishTime);
	    var archiveTimeObj = new Date(archiveTime);
	    if (isNaN(archiveTimeObj) || isNaN(publishTimeObj)) {
	        return false;
	    }
	    var currentTime = new Date();
	    if (currentTime < publishTimeObj || currentTime > archiveTimeObj) {
	        return false;
	    }
	    return true;
	};
	
	var discOfferRender = function discOfferRender(offers, device) {
	    offers.forEach(function (_ref) {
	        var altOffer = _ref.altOffer,
	            linkText = _ref.linkText,
	            name = _ref.name,
	            displayName = _ref.displayName,
	            offer = _ref.offer,
	            discLinkURL = _ref.discLinkURL,
	            discOfferHeadline = _ref.discOfferHeadline,
	            signUpLink3 = _ref.signUpLink3,
	            tsAndCs = _ref.tsAndCs,
	            topOfferPublishTime = _ref.topOfferPublishTime,
	            topOfferArchiveTime = _ref.topOfferArchiveTime;
	
	        var lowercaseName = name.toLowerCase();
	        var key = keys[lowercaseName] || lowercaseName;
	        var bookmakerOffer = altOffer || offer;
	
	        var discOffer = document.createElement('li');
	        discOffer.classList.add('rh-bookmaker');
	        discOffer.classList.add('rh-bookmaker--' + key);
	        discOffer.setAttribute('data-name', displayName);
	        discOffer.setAttribute('data-type', 'discOffer');
	        discOffer.setAttribute('data-index', key);
	        discOffer.setAttribute('data-test-selector', 'link-bm-' + key);
	        discOffer.setAttribute('data-valid-topoffer', isValidTopOffer(topOfferPublishTime, topOfferArchiveTime));
	        discOffer.setAttribute('bookmaker-offer', bookmakerOffer);
	
	        var discOfferInnerHTML = '\n            <div class="rh-bookmaker__header">\n                <svg class="rh-bookmaker__logo rh-logo--' + key + '">\n                    <use xlink:href="#logo-disc-' + key + '"/>\n                </svg>\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + key + '">\n                <svg class="rh-bookmaker__logo__text rh-logo--' + key + '">\n                    <use xlink:href="#logo-text-' + key + '"/>\n                </svg>\n                <div class="rh-bookmaker-offer__headline">' + (_constants.isMobile ? discOfferHeadline : bookmakerOffer) + '</div>\n                <a href="' + (_constants.isMobile ? discLinkURL : signUpLink3) + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                    data-name="' + name + '"\n                    data-index="' + key + '"\n                    data-test-selector="link-bm-' + key + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + linkText + '\n                </a>\n                <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n            </div>\n        ';
	
	        var discContainers = document.querySelectorAll('.rh-bookmakers__list--' + device);
	        Array.from(discContainers).forEach(function (container) {
	            discOffer.innerHTML = discOfferInnerHTML;
	            container.appendChild(discOffer.cloneNode(true));
	        });
	    });
	};
	
	var renderTierOneBookmakers = function renderTierOneBookmakers(desktopOffers, mobileOffers, freeBetsOffers) {
	    var displayNone = 'display:none;';
	    var bet365btnClass = 'width:181px;';
	
	    // NOTE: [JP-9948] Filter tierOne after bookmaker quiz or recent logged bookmaker account
	    var filteredDesktopOffers = (0, _filterBookmakers.getBookmakersToShow)(desktopOffers, TIER_ONE);
	    var filteredMobileOffers = (0, _filterBookmakers.getBookmakersToShow)(mobileOffers, TIER_ONE);
	
	    filteredDesktopOffers.forEach(function (_ref2) {
	        var altOffer = _ref2.altOffer,
	            linkText = _ref2.linkText,
	            name = _ref2.name,
	            displayName = _ref2.displayName,
	            offer = _ref2.offer,
	            signUpLink3 = _ref2.signUpLink3,
	            tsAndCs = _ref2.tsAndCs,
	            topOfferPublishTime = _ref2.topOfferPublishTime,
	            topOfferArchiveTime = _ref2.topOfferArchiveTime;
	
	        var lowercaseName = name.toLowerCase();
	        var key = keys[lowercaseName] || lowercaseName;
	        var isSkybet = lowercaseName === 'skybet';
	        var isBet365 = lowercaseName === 'bet365';
	        var bookmakerOffer = altOffer || offer;
	        var desktopOffer = document.createElement('li');
	        desktopOffer.classList.add('rh-bookmaker');
	        desktopOffer.classList.add('rh-bookmaker--' + key);
	        desktopOffer.setAttribute('data-name', displayName);
	        desktopOffer.setAttribute('data-index', key);
	        desktopOffer.setAttribute('data-test-selector', 'link-bm-' + key);
	        desktopOffer.setAttribute('data-valid-topoffer', isValidTopOffer(topOfferPublishTime, topOfferArchiveTime));
	        desktopOffer.setAttribute('bookmaker-offer', bookmakerOffer);
	
	        // For local testing -> square logo fetch from Janus
	        // ->  <img src="http://dev-beta.racingpost.com:8080/svgs/bookmaker-logos/${lowercaseName}-square.svg" class="rh-bookmaker__logo rh-logo--${key} rh-bookmaker__logo__square" alt="${displayName} logo" />
	        // -> <img src="http://dev-beta.racingpost.com:8080/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />
	        var innerHTMLDesktop = '\n            <div class="rh-bookmaker__header rh-bookmaker__header--' + key + '">\n                <svg class="rh-bookmaker__logo rh-logo--' + key + ' rh-bookmaker__logo--open" style="' + (isSkybet ? displayNone : '') + '">\n                    <use xlink:href="#logo-' + key + '"/>\n                </svg>\n                \n                <img src="/svgs/bookmaker-logos/' + lowercaseName + '-square.svg" class="rh-bookmaker__logo rh-logo--' + key + ' rh-bookmaker__logo__square" alt="' + displayName + ' logo" />\n\n                <div class="rh-bookmaker__logo rh-bookmaker__logo--skybet rh-logo--skybet rh-bookmaker__logo--open" style="' + (!isSkybet ? displayNone : '') + '">\n                </div>\n\n                <p class="rh-bookmaker__headline">' + offer + '</p>\n\n                <a\n                    href="' + signUpLink3 + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker__btn_claim_header"\n                    style="' + (_constants.isDesktopBeakpoint ? '' : displayNone) + '"\n                    data-name="' + name + '"\n                    data-index="' + key + '"\n                    data-test-selector="link-bm-' + key + '"\n                    rel="noreferrer nofollow sponsored"\n                 >\n\n                  <img src="/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />\n                   CLAIM\n                </a>\n                <div class="top-offer-label">TOP OFFER</div>\n\n                <div class="rh-bookmaker__header rh-bookmaker-hidden-element rh-bookmaker-hidden-element-' + name.toLowerCase() + '" data-testid="Text__BookmakerOfferItemOffer">\n                  <div class="rh-bookmaker-light-text">' + tsAndCs + '</div>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer">\n                <div class="rh-bookmaker-offer__headline">' + bookmakerOffer + '</div>\n                <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n                <a href="' + signUpLink3 + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker-offer__claim-btn-analytics"\n                    data-name="' + name + '"\n                    data-index="' + lowercaseName + '" \n                    data-test-selector="link-bm-' + lowercaseName + '"\n                    style="' + (isBet365 ? bet365btnClass : '') + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                  <div class="freeBets__LinkContainer opened-offer" style="' + (isBet365 ? displayNone : '') + '">\n                     <svg>\n                       <use xlink:href="img/icons.svg#icon-open-in-new-window"/>\n                     </svg>\n                  </div>\n                    ' + linkText + '\n                </a>\n            </div>';
	
	        var bookmakerContainersDesktop = document.querySelectorAll('.rh-bookmakers__list--web');
	        Array.from(bookmakerContainersDesktop).forEach(function (container) {
	            desktopOffer.innerHTML = innerHTMLDesktop;
	            container.appendChild(desktopOffer.cloneNode(true));
	        });
	    });
	
	    discOfferRender(filteredDesktopOffers, 'tablet');
	    discOfferRender(filteredMobileOffers, 'mobile');
	
	    // Free bets
	
	    var freeBets = document.createElement('a');
	    freeBets.classList.add('freeBets__Anchor');
	    freeBets.setAttribute('href', '/free-bets/');
	    freeBets.setAttribute('target', '_blank');
	
	    // note: icon for expanded offers on everything except bet365
	
	    var freeBetsHTML = '\n        <div class="freeBets__ItemContainer">\n            <div class="freeBets__LogoContainer">\n                <span class="freeBets__Logo">' + freeBetsOffers.name + '</span>\n            </div>\n            <span class="freeBets__Title">' + freeBetsOffers.offer + '</span>\n\n            <img src="/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />\n        </div>';
	
	    var freeBetsContainer = document.querySelectorAll('.rh-freeBets__Container');
	    Array.from(freeBetsContainer).forEach(function (container) {
	        freeBets.innerHTML = freeBetsHTML;
	        container.appendChild(freeBets.cloneNode(true));
	    });
	};
	
	exports.default = renderTierOneBookmakers;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _rpAnalytics = __webpack_require__(5);
	
	var SegmentIO = _interopRequireWildcard(_rpAnalytics);
	
	__webpack_require__(15);
	
	var _fetchBookmakersTierTwo = __webpack_require__(14);
	
	var _fetchBookmakersTierTwo2 = _interopRequireDefault(_fetchBookmakersTierTwo);
	
	var _fetchBookmakerExclusiveOffers = __webpack_require__(11);
	
	var _fetchBookmakerExclusiveOffers2 = _interopRequireDefault(_fetchBookmakerExclusiveOffers);
	
	var _constants = __webpack_require__(0);
	
	var _shuffleArray = __webpack_require__(4);
	
	var _getBookmakersName = __webpack_require__(3);
	
	var _fetchBookmakersTierOne = __webpack_require__(13);
	
	var _fetchBookmakersTierOne2 = _interopRequireDefault(_fetchBookmakersTierOne);
	
	var _fetchBookmakersMixedTier = __webpack_require__(12);
	
	var _fetchBookmakersMixedTier2 = _interopRequireDefault(_fetchBookmakersMixedTier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
	/* eslint-disable no-param-reassign */
	
	
	var OPEN = _constants.BOOKMAKER_STATUS.OPEN,
	    CLOSE = _constants.BOOKMAKER_STATUS.CLOSE;
	var MORE_OFFERS_TITLE = _constants.BOOKMAKER_ANALYTICS.MORE_OFFERS_TITLE,
	    TODAYS_OFFERS_TITLE = _constants.BOOKMAKER_ANALYTICS.TODAYS_OFFERS_TITLE,
	    TODAYS_OFFERS_TITLE_QUICK_LINK = _constants.BOOKMAKER_ANALYTICS.TODAYS_OFFERS_TITLE_QUICK_LINK;
	
	
	var initBookmakerRegPanel = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var tierOne, tierTwo, openedBookmakerClass, openedOverlayClass, openedOverlayHeaderClass, overlayActiveClass, selectedBreakpointUi, overlay, overlayHeader, bookmakerListMobile, webOffers, tabletOffers, mobileOffers, offerLists, closeOpenDiscOfferUi;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        closeOpenDiscOfferUi = function closeOpenDiscOfferUi() {
	                            var openedBookmakerOffer = document.querySelector('.rh-bookmaker--open');
	
	                            overlay.classList.remove(openedOverlayClass);
	                            overlayHeader.classList.remove(openedOverlayHeaderClass);
	                            openedBookmakerOffer.classList.remove(openedBookmakerClass);
	                            bookmakerListMobile.classList.remove(overlayActiveClass);
	                        };
	
	                        tierOne = _constants.tierBookmakers.tierOne, tierTwo = _constants.tierBookmakers.tierTwo;
	
	                        if (!_constants.isRacecardsOrResults) {
	                            _context.next = 5;
	                            break;
	                        }
	
	                        _context.next = 5;
	                        return (0, _fetchBookmakerExclusiveOffers2.default)();
	
	                    case 5:
	                        _context.next = 7;
	                        return (0, _fetchBookmakersTierOne2.default)();
	
	                    case 7:
	                        _context.next = 9;
	                        return (0, _fetchBookmakersTierTwo2.default)();
	
	                    case 9:
	                        _context.next = 11;
	                        return (0, _fetchBookmakersMixedTier2.default)();
	
	                    case 11:
	                        openedBookmakerClass = 'rh-bookmaker--open';
	                        openedOverlayClass = 'rh-bookmakers__overlay--open';
	                        openedOverlayHeaderClass = 'overlayWrap--open';
	                        overlayActiveClass = 'activeDiscOffersOverlay';
	                        selectedBreakpointUi = _constants.isTabletBeakpoint ? '.rh-bookmakers__list--tablet' : '.rh-bookmakers__list--mobile';
	
	                        // GET element after injecting
	
	                        overlay = document.querySelector('.rh-bookmakers__overlay');
	                        overlayHeader = document.querySelector('main .overlayWrap');
	                        bookmakerListMobile = document.querySelector('.rh-bookmakers ' + selectedBreakpointUi);
	                        webOffers = document.querySelectorAll('.rh-bookmakers__list--web');
	                        tabletOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--tablet');
	                        mobileOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--mobile');
	                        offerLists = document.querySelectorAll('.rh-bookmakers__list');
	
	
	                        offerLists.forEach(function (unorderedList) {
	                            var listItems = Array.from(unorderedList.querySelectorAll('li'));
	
	                            var validTopOfferItems = listItems.filter(function (item) {
	                                return item.getAttribute('data-valid-topoffer') === 'true';
	                            });
	                            var shuffledValidTopOffers = (0, _shuffleArray.shuffleArray)(validTopOfferItems, new Date().getTime());
	
	                            var invalidTopOfferItems = listItems.filter(function (item) {
	                                return item.getAttribute('data-valid-topoffer') === 'false';
	                            });
	
	                            var shuffledInvalidTopOffers = (0, _shuffleArray.shuffleArray)(invalidTopOfferItems, new Date().getTime());
	
	                            var promotedTierTwoItems = listItems.filter(function (item) {
	                                return item.getAttribute('promoted-bookmaker') === 'true';
	                            });
	
	                            // eslint-disable-next-line no-param-reassign
	                            unorderedList.innerHTML = '';
	
	                            [].concat(_toConsumableArray(shuffledValidTopOffers), _toConsumableArray(shuffledInvalidTopOffers), _toConsumableArray(promotedTierTwoItems)).forEach(function (item) {
	                                return unorderedList.appendChild(item);
	                            });
	                        });
	
	                        webOffers.forEach(function (desktopList) {
	                            desktopList.children[0].classList.add(openedBookmakerClass);
	
	                            // Once all bookmaker offers were shuffled,
	                            // then we need to add the position attribute to each offer
	                            desktopList.childNodes.forEach(function (bookmaker, index) {
	                                bookmaker.setAttribute('bookmaker-position', index + 1);
	                            });
	                        });
	
	                        // Once all bookmaker offers were shuffled,
	                        // then we need to add the position attribute to each offer
	                        Array.from(tabletOffers).forEach(function (tabletList) {
	                            return tabletList.childNodes.forEach(function (bookmaker, index) {
	                                bookmaker.setAttribute('bookmaker-position', index + 1);
	                            });
	                        });
	                        Array.from(mobileOffers).forEach(function (mobileList) {
	                            return mobileList.childNodes.forEach(function (bookmaker, index) {
	                                bookmaker.setAttribute('bookmaker-position', index + 1);
	                            });
	                        });
	
	                        if (_constants.isMobile) {
	                            Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
	                                return webBookmakersNode.remove();
	                            });
	                        }
	
	                        Array.from(document.querySelectorAll('main .rh-bookmakers ' + selectedBreakpointUi)).forEach(function (listNode) {
	                            return listNode.addEventListener('click', function (e) {
	                                if (e.target !== e.currentTarget) return;
	
	                                closeOpenDiscOfferUi();
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('main .overlayWrap')).forEach(function (listNode) {
	                            return listNode.addEventListener('click', function () {
	                                closeOpenDiscOfferUi();
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).forEach(function (headerNode) {
	                            return headerNode.addEventListener('click', function () {
	                                var _SegmentIO$trackOffer;
	
	                                var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
	                                var bookmakerNode = headerNode.parentNode;
	                                var isWebPanel = headerNode.parentNode.parentNode.classList.contains('rh-bookmakers__list--web');
	                                var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
	                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
	                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
	                                // Bet365 comes with uppercase B, but it is required to be lowercase
	                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
	                                var isOverlayOpened = overlay.classList.contains(openedOverlayClass);
	
	                                if (!isOverlayOpened && !isWebPanel) {
	                                    overlay.classList.add(openedOverlayClass);
	                                    bookmakerListMobile.classList.add(overlayActiveClass);
	                                    overlayHeader.classList.add(openedOverlayHeaderClass);
	                                }
	
	                                if (openedBookmakerNodes.length > 0) {
	                                    Array.from(openedBookmakerNodes).forEach(function (node) {
	                                        if (node === bookmakerNode) {
	                                            overlay.classList.remove(openedOverlayClass);
	                                            if (overlayHeader) {
	                                                overlayHeader.classList.remove(openedOverlayHeaderClass);
	                                            }
	                                            bookmakerNode.classList.remove(openedBookmakerClass);
	                                            bookmakerListMobile.classList.remove(overlayActiveClass);
	
	                                            var isPromotedBookmaker = node.getAttribute('promoted-bookmaker');
	
	                                            if (isPromotedBookmaker) {
	                                                node.childNodes[1].style.backgroundColor = '';
	                                            } else {
	                                                node.classList.remove(openedBookmakerClass);
	
	                                                if (isPromotedBookmaker) {
	                                                    node.childNodes[1].style.backgroundColor = '';
	                                                }
	                                            }
	                                            bookmakerNode.classList.remove(openedBookmakerClass);
	                                            bookmakerListMobile.classList.remove(overlayActiveClass);
	                                        } else {
	                                            node.classList.remove(openedBookmakerClass);
	                                            node.childNodes[1].style.backgroundColor = '';
	                                        }
	                                    });
	                                }
	
	                                if (!isBookmakerNodeOpened) {
	                                    bookmakerNode.classList.add(openedBookmakerClass);
	                                    var isDiscOffer = bookmakerNode.getAttribute('data-type') === 'discOffer';
	
	                                    if (!isDiscOffer) {
	                                        var isPromotedBookmaker = bookmakerNode.getAttribute('promoted-bookmaker');
	                                        var bookmakerColor = bookmakerNode.getAttribute('bookmaker-color');
	
	                                        if (isPromotedBookmaker) {
	                                            bookmakerNode.childNodes[1].style.backgroundColor = bookmakerColor;
	                                        }
	                                    } else if (isDiscOffer) {
	                                        var _isPromotedBookmaker = bookmakerNode.getAttribute('promoted-bookmaker');
	                                        var _bookmakerColor = bookmakerNode.getAttribute('bookmaker-color');
	
	                                        if (_isPromotedBookmaker) {
	                                            bookmakerNode.childNodes[3].style.backgroundColor = _bookmakerColor;
	                                        }
	                                    }
	                                }
	                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');
	
	                                SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_STATUS, !isBookmakerNodeOpened ? OPEN : CLOSE), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackOffer), isTierTwo);
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn-analytics')).forEach(function (el) {
	                            return el.addEventListener('click', function () {
	                                var _SegmentIO$trackBookm;
	
	                                var bookmakerNode = el.parentNode.parentNode;
	                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
	                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
	                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
	                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');
	
	                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_TIER, isTierTwo ? tierTwo : tierOne), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm), isTierTwo);
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.rh-bookmaker__btn_claim_header')).forEach(function (el) {
	                            return el.addEventListener('click', function (e) {
	                                var _SegmentIO$trackBookm2;
	
	                                e.stopPropagation();
	                                var bookmakerNode = el.parentNode.parentNode;
	                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
	                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
	                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
	                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');
	
	                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm2 = {}, _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE_QUICK_LINK), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_TIER, isTierTwo ? tierTwo : tierOne), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm2), isTierTwo);
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.rh-bookmakers__sub-heading-allOffers')).forEach(function (el) {
	                            return el.addEventListener('click', function () {
	                                SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE));
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.freeBets__Anchor')).forEach(function (el) {
	                            return el.addEventListener('click', function () {
	                                SegmentIO.trackFreeBetsTap({});
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.bookmakersTierTwo__subHeadingTextAllOffers')).forEach(function (anchor) {
	                            if (!anchor) return;
	
	                            anchor.addEventListener('click', function () {
	                                SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, MORE_OFFERS_TITLE));
	                            });
	                        });
	
	                        Array.from(document.querySelectorAll('.bookmakersTierTwo__bookmaker')).forEach(function (el) {
	                            return el.addEventListener('click', function () {
	                                var _SegmentIO$trackBookm3;
	
	                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(el.getAttribute('bookmaker-name'));
	                                var bookmakerPosition = Number(el.getAttribute('bookmaker-position'));
	                                var bookmakerOffer = el.getAttribute('bookmaker-offer');
	
	                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm3 = {}, _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_OFFERS_BANNER, MORE_OFFERS_TITLE), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_TIER, tierTwo), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm3), true);
	                            });
	                        });
	
	                    case 37:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function initBookmakerRegPanel() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	exports.default = initBookmakerRegPanel;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var tryParseJson = exports.tryParseJson = function tryParseJson(json) {
	    try {
	        return JSON.parse(json);
	    } catch (err) {
	        console.log('Error parsing JSON', err);
	
	        return null;
	    }
	};
	
	var getLocalStorageItem = exports.getLocalStorageItem = function getLocalStorageItem(key) {
	    return localStorage.getItem(key);
	};
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Reussable global click handler for executing custom code
	 * whenever the user clicks outside of the designated target.
	 *
	 * useCapture is set in order to ensure the document click event
	 * is always executed first. Likewise, the event propagation
	 * is stopped so as to not retrigger events reattaching
	 * another outside click handler.
	 *
	 * @param {String} target
	 * @param {function} callback
	 */
	// eslint-disable-next-line import/prefer-default-export
	var handleClickOutside = exports.handleClickOutside = function handleClickOutside(target, callback) {
	    var clickHandler = function clickHandler(e) {
	        if (!e.target.closest(target)) {
	            callback();
	            document.removeEventListener('click', clickHandler, true);
	        }
	    };
	
	    document.addEventListener('click', clickHandler, true);
	};
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=rpbettingspecialoffer.js.map

/***/ }),
/* 1811 */,
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _connector = __webpack_require__(381);
	
	var _webClientMessage = __webpack_require__(1832);
	
	var _webClientMessage2 = _interopRequireDefault(_webClientMessage);
	
	var _topicConverter = __webpack_require__(1831);
	
	var _topicConverter2 = _interopRequireDefault(_topicConverter);
	
	var _cookie = __webpack_require__(382);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var topicConverter = (0, _topicConverter2.default)();
	
	/**
	 * @class DiffusionSession
	 */
	
	var DiffusionSession = function () {
	    /**
	     * Constructor for DiffusionSession
	     * @param {Object} customConfig
	     * @param {Boolean} [customConfig.debugConnector] Turn on connector trace logging.
	     * @param {Function} [customConfig.onCallbackFunction] On connected handler.
	     * @param {Function} customConfig.onDataFunction
	     * @memberOf DiffusionSession
	     */
	    function DiffusionSession(customConfig) {
	        _classCallCheck(this, DiffusionSession);
	
	        this.subscriptions = {};
	        this.onData = function (data, topic) {
	            var message = (0, _webClientMessage2.default)(data, topicConverter.from(topic));
	            customConfig.onDataFunction(message);
	        };
	        this.subscribe = this.subscribe.bind(this);
	        this.unsubscribe = this.unsubscribe.bind(this);
	        this.unsubscribeAll = this.unsubscribeAll.bind(this);
	        if (customConfig.onCallbackFunction) {
	            var connector = (0, _connector.getConnector)();
	            connector.on('connected', function () {
	                customConfig.onCallbackFunction(true);
	            });
	            connector.on('error', function () {
	                customConfig.onCallbackFunction(false);
	            });
	            connector.connect();
	        }
	        var logLevel = (0, _cookie2.default)('logLevel');
	        if (logLevel) {
	            (0, _connector.setLogLevel)(logLevel);
	        }
	        if (customConfig.debugConnector) {
	            (0, _connector.setLogLevel)('debug');
	        }
	    }
	
	    _createClass(DiffusionSession, [{
	        key: 'subscribe',
	        value: function subscribe(config) {
	            var _this = this;
	
	            var subscribeTopics = config.topics || [config.topic];
	            subscribeTopics.filter(function (topic) {
	                return _this.subscriptions[topic];
	            }).forEach(function (topic) {
	                _this.subscriptions[topic].fetch();
	            });
	            var preparedTopics = subscribeTopics.filter(function (topic) {
	                return !_this.subscriptions[topic];
	            }).map(topicConverter.to);
	            if (preparedTopics.length) {
	                (0, _connector.getConnector)().subscribe(preparedTopics).forEach(function (subscription, index) {
	                    var topic = preparedTopics[index];
	                    subscription.on('update', _this.onData);
	                    _this.subscriptions[topic] = subscription;
	                });
	            }
	        }
	    }, {
	        key: 'unsubscribe',
	        value: function unsubscribe(config) {
	            var _this2 = this;
	
	            var unsubscribeTopics = config.topics || [config.topic];
	            unsubscribeTopics.filter(function (topic) {
	                return _this2.subscriptions[topic];
	            }).forEach(function (topic) {
	                var topicSubscription = _this2.subscriptions[topic];
	                topicSubscription.close();
	                delete _this2.subscriptions[topic];
	            });
	        }
	    }, {
	        key: 'unsubscribeAll',
	        value: function unsubscribeAll() {
	            this.unsubscribe({
	                topics: Object.keys(this.subscriptions)
	            });
	        }
	    }]);
	
	    return DiffusionSession;
	}();
	
	exports.default = DiffusionSession;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = diffusionConnector;
	
	var _wildemitter = __webpack_require__(260);
	
	var _wildemitter2 = _interopRequireDefault(_wildemitter);
	
	var _topicStore = __webpack_require__(1816);
	
	var _topicStore2 = _interopRequireDefault(_topicStore);
	
	var _cachedValue = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function connector(state) {
	    var emitter = state.emitter;
	    var provider = state.provider;
	
	    var currentSession = void 0;
	    var topicStore = (0, _topicStore2.default)();
	    var createEmit = function createEmit(eventName) {
	        return emitter.emit.bind(emitter, eventName);
	    };
	    var onConnected = createEmit('connected');
	    var onConnectionError = createEmit('connectionError');
	    var sessionSubscriptions = {
	        disconnect: createEmit('disconnect'),
	        error: createEmit('error'),
	        reconnect: createEmit('reconnect'),
	        close: createEmit('close')
	    };
	
	    function closeSession() {
	        if (currentSession) {
	            currentSession.close();
	        }
	    }
	
	    function setProvider(newProvider) {
	        provider = newProvider;
	        closeSession();
	    }
	
	    function updateSession(session) {
	        session.on(sessionSubscriptions);
	        topicStore.setSession(session);
	        currentSession = session;
	        return currentSession;
	    }
	
	    var _singleValueCache = (0, _cachedValue.singleValue)(function () {
	        return (
	            // JP-10398
	            // if (!shouldEstablishSession()) {
	            //     return null;
	            // }
	
	            provider().then(updateSession).then(onConnected).catch(onConnectionError)
	        );
	    }),
	        connect = _singleValueCache.getValue,
	        resetConnected = _singleValueCache.reset;
	
	    emitter.on('close', function () {
	        currentSession.off(sessionSubscriptions);
	        resetConnected();
	        connect();
	
	        // JP-10398
	        // if (shouldEstablishSession()) {
	        //     connect();
	        // }
	    });
	
	    var subscribe = function subscribe(topics) {
	        // JP-10398
	        // if (!shouldEstablishSession()) {
	        //     return [];
	        // }
	
	        connect();
	        return topicStore.subscribe(topics);
	    };
	
	    return {
	
	        /**
	         *
	         * @deprecated
	         * @param {any} topic
	         * @returns
	         */
	        connect: connect,
	
	        /**
	         * This function is called from DiffusionService
	         * @param {String} topic
	         * @return {Subscription}
	         * @memberOf DiffusionConnector
	         */
	        subscribe: subscribe,
	
	        setProvider: setProvider,
	
	        closeSession: closeSession
	    };
	}
	
	/**
	 * Wrapper upon the [Diffusion Unified Library]{@link https://www.npmjs.com/package/diffusion}
	 * [API DOC 5.7.5]{@link http://docs.pushtechnology.com/docs/5.7.5/js/index.html}
	 * [USER MANUAL 5.7.5]{@link http://docs.pushtechnology.com/docs/5.7.5/manual/html/developerguide/apis/javascript/using.html}
	 * @class DiffusionConnector
	 * @extends {Emitter}
	 */
	function diffusionConnector(provider) {
	    var emitter = new _wildemitter2.default();
	    var state = {
	        emitter: emitter,
	        provider: provider
	    };
	    return Object.assign(emitter, connector(state));
	}

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = storeRegistry;
	
	var _filter = __webpack_require__(594);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flatMap = __webpack_require__(1616);
	
	var _flatMap2 = _interopRequireDefault(_flatMap);
	
	var _forEach = __webpack_require__(595);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _subscriptionStore = __webpack_require__(1815);
	
	var _subscriptionStore2 = _interopRequireDefault(_subscriptionStore);
	
	var _squasher = __webpack_require__(1830);
	
	var _squasher2 = _interopRequireDefault(_squasher);
	
	var _cachedValue = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function flow(actions) {
	    return function (value) {
	        return actions.reduce(function (args, action) {
	            return action(args);
	        }, value);
	    };
	}
	var getTopicSubscription = function getTopicSubscription(stores) {
	    return flow([stores.getValue, function (store) {
	        return store.getSubscription();
	    }]);
	};
	
	var closeEmptyStores = flow([(0, _filter2.default)(function (store) {
	    return store.isEmpty();
	}), (0, _forEach2.default)(function (store) {
	    store.closeConnection('no active connections');
	})]);
	
	var getUsedTopics = flow([(0, _filter2.default)(function (store) {
	    return !store.isEmpty();
	}), (0, _flatMap2.default)(function (store) {
	    return store.getDataTopics();
	})]);
	
	function storeRegistry() {
	    var currentSession = void 0;
	    var didCloseHandler = void 0;
	    var squashDictionary = (0, _cachedValue.dictionary)(_squasher2.default);
	    var createSubscription = function createSubscription(topic) {
	        var newSubscriptionStore = (0, _subscriptionStore2.default)(topic, currentSession, squashDictionary);
	        if (didCloseHandler) {
	            newSubscriptionStore.on('didClose', didCloseHandler);
	        }
	        return newSubscriptionStore;
	    };
	    var topicsDictionary = (0, _cachedValue.dictionary)(createSubscription);
	
	    var createStream = getTopicSubscription(topicsDictionary);
	    return {
	        getStores: topicsDictionary.values,
	        getTopics: topicsDictionary.keys,
	        setSession: function setSession(session) {
	            currentSession = session;
	            topicsDictionary.values().forEach(function (store) {
	                store.setSession(session);
	            });
	        },
	        createStream: createStream,
	        setCloseListener: function setCloseListener(handler) {
	            didCloseHandler = handler;
	            topicsDictionary.values().forEach(function (store) {
	                store.off('didClose');
	                store.on('didClose', handler);
	            });
	        },
	        closeEmptyStores: flow([topicsDictionary.values, closeEmptyStores]),
	        getUsedTopics: flow([topicsDictionary.values, getUsedTopics])
	    };
	}

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = subscriptionStore;
	
	var _wildemitter = __webpack_require__(260);
	
	var _wildemitter2 = _interopRequireDefault(_wildemitter);
	
	var _pull = __webpack_require__(1631);
	
	var _pull2 = _interopRequireDefault(_pull);
	
	var _logger = __webpack_require__(257);
	
	var _subscription = __webpack_require__(383);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logger = (0, _logger.create)('Subscription store');
	
	/**
	 * @module SubscriptionStore
	 */
	var ON_WRAP_DATA_DELAY = 0;
	
	function subscrioptionsKeeper(state) {
	    var subscribed = [];
	    var topicSquasher = state.topicSquasher,
	        emitter = state.emitter;
	    var session = state.session;
	
	    var sourceStream = void 0;
	
	    var isEmpty = function isEmpty() {
	        return subscribed.length === 0;
	    };
	
	    function onUpdate(data, topic) {
	        logger.debug('Get new data from: ' + state.topic + '\n' + data);
	
	        var fullData = topicSquasher.getValue(topic).squash(data);
	
	        subscribed.forEach(function (subscr) {
	            subscr.onUpdate(fullData, topic);
	        });
	    }
	
	    function onClose() {
	        sourceStream.off('close', onClose);
	        sourceStream.off('update', onUpdate);
	        sourceStream = null;
	    }
	
	    function closeConnection(reason) {
	        if (sourceStream) {
	            sourceStream.close(reason);
	        }
	    }
	
	    function getDataTopics() {
	        return [state.topic];
	    }
	
	    function createFetch(subscr) {
	        return function () {
	            getDataTopics().map(function (topic) {
	                return {
	                    topic: topic,
	                    data: topicSquasher.getValue(topic).getState()
	                };
	            }).filter(function (_ref) {
	                var data = _ref.data;
	                return data;
	            }).forEach(function (_ref2) {
	                var topic = _ref2.topic,
	                    data = _ref2.data;
	
	                subscr.onUpdate(data, topic);
	            });
	            emitter.emit('didFetch');
	        };
	    }
	
	    function createClose(subscr) {
	        return function (reason) {
	            (0, _pull2.default)(subscribed, subscr);
	            subscr.onClose(reason);
	            emitter.emit('didClose');
	        };
	    }
	
	    function openConnection() {
	        if (!sourceStream && session && subscribed.length) {
	            var topic = state.topic;
	            sourceStream = session.stream(topic);
	            sourceStream.on('close', onClose);
	            sourceStream.on('update', onUpdate);
	        }
	    }
	
	    return {
	        closeConnection: closeConnection,
	        getDataTopics: getDataTopics,
	        isEmpty: isEmpty,
	
	        /**
	         * Wraps subscription and propagate last squashed data to subscriber.
	         * @memberOf subscriptionStore
	         * @instance
	         * which should listen for subscription updates.
	         */
	        getSubscription: function getSubscription() {
	            var newSubscription = (0, _subscription2.default)();
	            subscribed.push(newSubscription);
	            newSubscription.setSubscription({
	                close: createClose(newSubscription),
	                fetch: createFetch(newSubscription)
	            });
	            if (getDataTopics().some(function (topic) {
	                return topicSquasher.getValue(topic).getState();
	            })) {
	                setTimeout(createFetch(newSubscription), ON_WRAP_DATA_DELAY);
	            }
	            openConnection();
	            return newSubscription;
	        },
	
	        setSession: function setSession(newSession) {
	            if (sourceStream) {
	                onClose();
	            }
	            session = newSession;
	            openConnection();
	        }
	    };
	}
	
	/**
	 * Class which implements logic of merging diffusion data and handling multiple subscriptions.
	 * @class subscriptionStore
	 */
	function subscriptionStore(topic, session, topicSquasher) {
	    var emitter = new _wildemitter2.default();
	    var state = {
	        emitter: emitter,
	        topic: topic,
	        session: session,
	        topicSquasher: topicSquasher
	    };
	    return Object.assign(emitter, subscrioptionsKeeper(state));
	}

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = topicStore;
	
	var _debounce = __webpack_require__(1608);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _filter = __webpack_require__(594);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _forEach = __webpack_require__(595);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _storeRegistry = __webpack_require__(1814);
	
	var _storeRegistry2 = _interopRequireDefault(_storeRegistry);
	
	var _prepareSelectorSets = __webpack_require__(1827);
	
	var _prepareSelectorSets2 = _interopRequireDefault(_prepareSelectorSets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Max for single subscription request
	 */
	var TOPICS_PER_SELECTOR_SET = 31 * 1024;
	var SUBSCRIPTION_CLOSE_DELAY = 200;
	
	function flow(actions) {
	    return function (value) {
	        return actions.reduce(function (args, action) {
	            return action(args);
	        }, value);
	    };
	}
	
	var getSubscribedTopics = function getSubscribedTopics(subscribed) {
	    return (0, _filter2.default)(function (topic) {
	        return !subscribed.get(topic);
	    });
	};
	
	function subscriber() {
	    var subscribedTopics = new Map();
	    var currentSession = void 0;
	    var stores = (0, _storeRegistry2.default)();
	
	    var closeInactiveTopics = (0, _debounce2.default)(function () {
	        stores.closeEmptyStores();
	        var topicsUse = stores.getUsedTopics();
	        subscribedTopics.forEach(function (isSubscribed, topic) {
	            if (isSubscribed && topicsUse.indexOf(topic) < 0) {
	                subscribedTopics.set(topic, false);
	                currentSession.unsubscribe(topic);
	            }
	        });
	    }, SUBSCRIPTION_CLOSE_DELAY);
	
	    stores.setCloseListener(closeInactiveTopics);
	
	    var subscribeForTopics = flow([function (topics) {
	        if (topics.length === 1) {
	            return topics;
	        }
	        return (0, _prepareSelectorSets2.default)(topics, TOPICS_PER_SELECTOR_SET);
	    }, (0, _forEach2.default)(function (topic) {
	        currentSession.subscribe(topic).on('subscribe', function (details, subTopic) {
	            subscribedTopics.set(subTopic, true);
	        });
	    })]);
	
	    var subscribeTopics = flow([getSubscribedTopics(subscribedTopics), function (topics) {
	        if (topics.length > 0) {
	            subscribeForTopics(topics);
	        }
	    }]);
	
	    var subscribe = function subscribe(topics) {
	        var subscriptions = topics.map(stores.createStream);
	        if (currentSession) {
	            subscribeTopics(topics);
	        }
	        return subscriptions;
	    };
	
	    var setSession = function setSession(session) {
	        currentSession = session;
	        stores.setSession(session);
	        if (currentSession) {
	            subscribeTopics(stores.getTopics());
	        }
	    };
	
	    return {
	        subscribe: subscribe,
	        setSession: setSession
	    };
	}
	
	function topicStore() {
	    var state = {};
	    return Object.assign({}, subscriber(state));
	}

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.shouldEstablishSession = exports.setLogLevel = exports.stubController = exports.default = undefined;
	
	var _DiffusionSession = __webpack_require__(1812);
	
	var _DiffusionSession2 = _interopRequireDefault(_DiffusionSession);
	
	var _stubController = __webpack_require__(1825);
	
	var stubController = _interopRequireWildcard(_stubController);
	
	var _connector = __webpack_require__(381);
	
	var _shouldEstablishSession = __webpack_require__(1829);
	
	var _shouldEstablishSession2 = _interopRequireDefault(_shouldEstablishSession);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DiffusionSession2.default;
	exports.stubController = stubController;
	exports.setLogLevel = _connector.setLogLevel;
	exports.shouldEstablishSession = _shouldEstablishSession2.default;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = diffusionProviderFactory;
	
	var _diffusion = __webpack_require__(1158);
	
	var diffusion = _interopRequireWildcard(_diffusion);
	
	var _subscription = __webpack_require__(383);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _domConfigurationStrategy = __webpack_require__(751);
	
	var _domConfigurationStrategy2 = _interopRequireDefault(_domConfigurationStrategy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function sessionWrapper(session) {
	    return {
	
	        stream: function stream(topic) {
	            var diffusionSubscription = session.addStream(topic, diffusion.datatypes.recordv2())
	            // eslint-disable-next-line no-unused-vars
	            .on('value', function (topicString, specification, newValue, oldValue) {
	                // eslint-disable-next-line no-use-before-define
	                subscr.onUpdate(newValue.asRecords(), topicString);
	            });
	
	            var subscr = (0, _subscription2.default)();
	            subscr.subscribe(diffusionSubscription);
	
	            return subscr;
	        },
	        subscribe: function subscribe(topic) {
	            var initCallback = void 0;
	            var events = {
	                on: function on(eventType, callback) {
	                    initCallback = callback;
	                }
	            };
	            session.select(topic).then(function () {
	                initCallback(topic, true);
	            });
	            return events;
	        },
	        unsubscribe: session.unsubscribe,
	        on: session.on.bind(session),
	        off: session.off.bind(session),
	        close: session.close.bind(session)
	    };
	}
	
	function diffusionProviderFactory() {
	    function provider() {
	        var configurationStrategy = (0, _domConfigurationStrategy2.default)();
	        return diffusion.connect(configurationStrategy.getConfig()).then(sessionWrapper);
	    }
	    return {
	        provider: provider,
	        log: function log(level) {
	            return diffusion.log(level);
	        }
	    };
	}

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getApiStubData;
	
	var _cookie = __webpack_require__(382);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _flatPath = __webpack_require__(1821);
	
	var _flatPath2 = _interopRequireDefault(_flatPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function getApiStubData(_ref) {
	    var apiStubUrl = _ref.url;
	
	    var stubDataUrl = (0, _cookie2.default)('apiStubs');
	    if (!stubDataUrl || !apiStubUrl) {
	        return Promise.resolve(null);
	    }
	    return Promise.resolve(stubDataUrl).then(function (group) {
	        return JSON.parse(group);
	    }).then(function (stubInfo) {
	        return fetch(apiStubUrl, {
	            method: 'POST',
	            headers: {
	                'content-type': 'application/x-www-form-urlencoded'
	            },
	            body: 'type=diffusion&group=' + encodeURIComponent(stubInfo.case)
	        });
	    }).then(function (response) {
	        return response.json();
	    }).then(function (diffusionData) {
	        var steps = [];
	        if (diffusionData.initial) {
	            steps.push(diffusionData.initial);
	        }
	        if (diffusionData.steps) {
	            steps.push.apply(steps, _toConsumableArray(diffusionData.steps));
	        }
	        return steps.map(_flatPath2.default).reduce(function (acc, item, index) {
	            var actions = Object.keys(item).map(function (topic) {
	                return {
	                    topic: topic,
	                    value: item[topic],
	                    step: index
	                };
	            });
	            return [].concat(_toConsumableArray(acc), _toConsumableArray(actions));
	        }, []);
	    });
	}

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = delayedActionsFactory;
	
	var _cachedValue = __webpack_require__(152);
	
	function delayedActionsFactory() {
	    var actionsStore = (0, _cachedValue.dictionary)(function () {
	        return [];
	    });
	    return {
	        add: function add(topic, value) {
	            actionsStore.getValue(topic).push(value);
	        },
	        get: function get(topic) {
	            return actionsStore.getValue(topic);
	        },
	        execute: function execute(topic, action) {
	            return function () {
	                actionsStore.getValue(topic).forEach(function (value) {
	                    action(topic, value);
	                });
	                actionsStore.delete(topic);
	            };
	        }
	    };
	}

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = flatPath;
	
	var _isPlainObject = __webpack_require__(596);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function flatPath(obj) {
	    if (!obj) {
	        return {};
	    }
	    var hasChanges = false;
	    var resultObject = Object.keys(obj).reduce(function (aggr, key) {
	        var value = obj[key];
	        if ((0, _isPlainObject2.default)(value)) {
	            hasChanges = true;
	            var newProps = Object.keys(value).reduce(function (acum, valueKey) {
	                var resultKey = [key, valueKey].join('/');
	                return _extends({}, acum, _defineProperty({}, resultKey, value[valueKey]));
	            }, {});
	            return _extends({}, newProps, aggr);
	        }
	        return _extends(_defineProperty({}, key, value), aggr);
	    }, {});
	    if (!hasChanges) {
	        return resultObject;
	    }
	    return flatPath(resultObject);
	}

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stub;
	
	var _logger = __webpack_require__(257);
	
	var _sequence = __webpack_require__(1828);
	
	var _sequence2 = _interopRequireDefault(_sequence);
	
	var _stubUI = __webpack_require__(1826);
	
	var _stubUI2 = _interopRequireDefault(_stubUI);
	
	var _apiStubLoader = __webpack_require__(1819);
	
	var _apiStubLoader2 = _interopRequireDefault(_apiStubLoader);
	
	var _delayedActionsFactory = __webpack_require__(1820);
	
	var _delayedActionsFactory2 = _interopRequireDefault(_delayedActionsFactory);
	
	var _topicDictionaryFactory = __webpack_require__(1824);
	
	var _topicDictionaryFactory2 = _interopRequireDefault(_topicDictionaryFactory);
	
	var _stubSessionFactory = __webpack_require__(1823);
	
	var _stubSessionFactory2 = _interopRequireDefault(_stubSessionFactory);
	
	var _domConfigurationStrategy = __webpack_require__(751);
	
	var _domConfigurationStrategy2 = _interopRequireDefault(_domConfigurationStrategy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logger = (0, _logger.create)('Stub provider');
	
	function createSequenceAction(topicDictionary, delayedActions) {
	    return function (_ref) {
	        var topic = _ref.topic,
	            value = _ref.value;
	
	        if (topicDictionary.keys().includes(topic)) {
	            topicDictionary.update(topic, value);
	        } else {
	            delayedActions.add(topic, value);
	        }
	    };
	}
	
	function stub() {
	    var currentSession = void 0;
	    var topicDictionary = (0, _topicDictionaryFactory2.default)();
	    var delayedActions = (0, _delayedActionsFactory2.default)();
	    var sequenceAction = createSequenceAction(topicDictionary, delayedActions);
	    var mainSequence = (0, _sequence2.default)(sequenceAction);
	
	    function enableStubUI() {
	        var next = mainSequence.next,
	            play = mainSequence.play,
	            reset = mainSequence.reset;
	
	        var steps = mainSequence.getSteps();
	        if (steps.length > 1) {
	            var ui = new _stubUI2.default({ next: next, play: play, reset: reset });
	            ui.init();
	        }
	    }
	
	    function setValue(topic, value, step) {
	        mainSequence.addValues([{ topic: topic, value: value, step: step }]);
	    }
	
	    function setValues(values) {
	        mainSequence.addValues(values);
	    }
	
	    function provider() {
	        var configurationStrategy = (0, _domConfigurationStrategy2.default)();
	        return (0, _apiStubLoader2.default)(configurationStrategy.getStubConfig()).then(function (values) {
	            if (values) {
	                setValues(values);
	                enableStubUI();
	                mainSequence.next();
	            }
	        }).then(function () {
	            return currentSession = (0, _stubSessionFactory2.default)(topicDictionary, delayedActions);
	        }).catch(logger.error);
	    }
	
	    return {
	        play: function play() {
	            var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
	            return mainSequence.play(interval);
	        },
	        next: function next() {
	            return mainSequence.next();
	        },
	        reset: function reset() {
	            return mainSequence.reset();
	        },
	        getSubscribedTopics: function getSubscribedTopics() {
	            return currentSession.getSubscribedTopics();
	        },
	        getPageTopics: topicDictionary.keys,
	        log: _logger.setLevel,
	        provider: provider,
	        setValue: setValue,
	        setValues: setValues
	    };
	}

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stubSessionFactory;
	
	var _wildemitter = __webpack_require__(260);
	
	var _wildemitter2 = _interopRequireDefault(_wildemitter);
	
	var _logger = __webpack_require__(257);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var logger = (0, _logger.create)('Stub session');
	
	var forEach = function forEach(obj, func) {
	    return Object.keys(obj).forEach(function (key) {
	        func(key, obj[key]);
	    });
	};
	
	function getTopicFromSubscription(selectorSet) {
	    if (selectorSet.startsWith('#>')) {
	        return selectorSet.substr(2).split('////>');
	    }
	    return [selectorSet];
	}
	
	function stubSessionFactory(topicDictionary, delayedActions) {
	    var subscribedTopics = [];
	    var emitter = new _wildemitter2.default();
	    var session = {
	        stream: topicDictionary.getValue,
	        subscribe: function subscribe(selectorSet) {
	            subscribedTopics = subscribedTopics.concat(selectorSet);
	            logger.debug('Subscribe: ' + selectorSet);
	
	            getTopicFromSubscription(selectorSet).filter(function (topic) {
	                return delayedActions.get(topic);
	            }).forEach(function (topic) {
	                setTimeout(delayedActions.execute(topic, topicDictionary.update), 0);
	            });
	            return {
	                on: function on(eventName, handler) {
	                    return getTopicFromSubscription(selectorSet).forEach(function (singleTopic) {
	                        return handler(null, singleTopic);
	                    });
	                }
	            };
	        },
	        unsubscribe: function unsubscribe(topic) {
	            subscribedTopics = subscribedTopics.filter(function (item) {
	                return item !== topic;
	            });
	            logger.debug('Unsubscribe: ' + topic);
	        },
	        on: function on(config) {
	            forEach(config, emitter.on.bind(emitter));
	            return session;
	        },
	        off: function off(config) {
	            forEach(config, emitter.off.bind(emitter));
	            return session;
	        },
	        close: function close() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            emitter.emit.apply(emitter, ['close'].concat(args));
	        },
	        emit: emitter.emit.bind(emitter),
	        getSubscribedTopics: function getSubscribedTopics() {
	            return [].concat(_toConsumableArray(subscribedTopics));
	        }
	    };
	    return session;
	}

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = topicDictionaryFactory;
	
	var _subscription = __webpack_require__(383);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _cachedValue = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function topicDictionaryFactory() {
	    var topicDictionary = (0, _cachedValue.dictionary)(function () {
	        var subsr = (0, _subscription2.default)();
	        subsr.setSubscription({
	            close: function close(reason) {
	                subsr.emit('close', reason);
	            }
	        });
	        return subsr;
	    });
	    topicDictionary.update = function (topic, value) {
	        topicDictionary.getValue(topic).onUpdate(value, topic);
	    };
	    return topicDictionary;
	}

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reset = exports.play = exports.next = exports.getSubscribedTopics = exports.getPageTopics = exports.setValues = exports.setValue = undefined;
	exports.useStub = useStub;
	
	var _connector = __webpack_require__(381);
	
	var _providers = __webpack_require__(752);
	
	var stubInstance = (0, _providers.getStub)();
	function useStub() {
	    (0, _connector.setProvider)(stubInstance.provider);
	}
	var setValue = stubInstance.setValue,
	    setValues = stubInstance.setValues,
	    getPageTopics = stubInstance.getPageTopics,
	    getSubscribedTopics = stubInstance.getSubscribedTopics,
	    next = stubInstance.next,
	    play = stubInstance.play,
	    reset = stubInstance.reset;
	exports.setValue = setValue;
	exports.setValues = setValues;
	exports.getPageTopics = getPageTopics;
	exports.getSubscribedTopics = getSubscribedTopics;
	exports.next = next;
	exports.play = play;
	exports.reset = reset;

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* babel-plugin-inline-import './stubInterface.css' */var styles = '.DC-debugger {\n   position: fixed;\n   z-index: 999999999999;\n   right: 10px;\n   bottom: 10px;\n   width: 190px;\n   background: #eee;\n   box-shadow: 0 1px 8px rgba(0, 0, 0, .2);\n   padding: 7px 7px 6px 7px;\n   display: flex;\n   flex-direction: column;\n   opacity: .3;\n   -webkit-transition: opacity .2s ease-in-out;\n   -moz-transition: opacity .2s ease-in-out;\n   -ms-transition: opacity .2s ease-in-out;\n   -o-transition: opacity .2s ease-in-out;\n   transition: opacity .2s ease-in-out; \n}\n.DC-debugger:hover {\n    opacity: 1;\n}\n.DC-debugger_toggled .DC-extraTools {\n    display: flex;\n}\n\n.DC-extraTools {\n   display: none;\n   align-items: center;\n   justify-content: space-between;\n   flex-direction: row;\n   border-bottom: 1px solid white;\n   box-shadow: 0 2px 1px -2px grey;\n   margin-bottom: 5px;\n   padding-bottom: 5px;\n}\n.DC-extraTools__input {\n    width: 37px;\n}\n\n.DC-mainTools {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.DC-mainTools__logo {\n    display: inline-block;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n}\n.DC-mainTools__logoLabel {\n    font-family: Oswald, "Arial Black", sans-serif;\n    text-align: center;\n    color: #464547;\n    flex-grow: 1;\n}\n\n.DC-mainTools__logoLabel_blue {\n   color: #39C2D7;\n}\n\n.DC-mainTools__button,\n.DC-extraTools__button {\n    display: inline-block;\n    cursor: pointer;\n    padding: 5px 7px;\n    vertical-align: middle;\n    background: #39C2D7;\n    -webkit-transition: all .2s ease-in-out;\n    -moz-transition: all .2s ease-in-out;\n    -ms-transition: all .2s ease-in-out;\n    -o-transition: all .2s ease-in-out;\n    transition: all .2s ease-in-out; \n}\n\n.DC-mainTools__button:hover,\n.DC-extraTools__button:hover {\n    background: #29b2c7; \n}\n\n.DC-mainTools__buttonImage,\n.DC-extraTools__buttonImage {\n    width: 16px;\n    height: 16px;\n    fill: #fff;\n    vertical-align: middle;\n}\n\n.DC-extraTools__button_stop {\n    display: none;\n}\n\n.DC-extraTools__playing .DC-extraTools__button_play {\n    display: none;\n}\n.DC-extraTools__playing .DC-extraTools__button_stop {\n    display: inline-block;\n}\n#api-stub-debugger #api-stub-debugger-toggle {\n    right: 200px;\n}\n';
	/* babel-plugin-inline-import './stubInterface.html' */var interfaceHtml = '<div class="DC-debugger js-DC-debugger">\n\t<div class="DC-extraTools js-DC-extraTools">\n\t\t<div\n\t\t\tclass="DC-extraTools__button DC-extraTools__button_play js-DC-extraTools__button_play"\n\t\t\ttitle="automaticaly updates topics with delay"\n\t\t>\n\t\t\t<svg class="DC-extraTools__buttonImage" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t\t\t\tviewBox="0 0 232.153 232.153" style="enable-background:new 0 0 232.153 232.153;" xml:space="preserve">\n\t\t\t\t<g id="Play">\n\t\t\t\t\t<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M203.791,99.628L49.307,2.294c-4.567-2.719-10.238-2.266-14.521-2.266\n\t\t\t\t\t\tc-17.132,0-17.056,13.227-17.056,16.578v198.94c0,2.833-0.075,16.579,17.056,16.579c4.283,0,9.955,0.451,14.521-2.267\n\t\t\t\t\t\tl154.483-97.333c12.68-7.545,10.489-16.449,10.489-16.449S216.471,107.172,203.791,99.628z"/>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\t\t<div\n\t\t\tclass="DC-extraTools__button DC-extraTools__button_stop js-DC-extraTools__button_stop"\n\t\t\ttitle="stop updating"\n\t\t>\n\t\t\t<svg class="DC-extraTools__buttonImage" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t\t\t\tviewBox="0 0 232.679 232.679" style="enable-background:new 0 0 232.679 232.679;" xml:space="preserve">\n\t\t\t\t<g id="Stop">\n\t\t\t\t\t<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M214.781,0H17.898C8.013,0,0,8.014,0,17.898v196.883\n\t\t\t\t\t\tc0,9.885,8.013,17.898,17.898,17.898h196.883c9.886,0,17.898-8.013,17.898-17.898V17.898C232.679,8.014,224.666,0,214.781,0z"/>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\t\t<div>\n\t\t\t<input class="DC-extraTools__input js-DC-extraTools__input" type="number" min="1" max="60" value="5"/>\n\t\t\t<span>s.</span>\n\t\t</div>\n\t\t<div\n\t\t\tclass="DC-extraTools__button DC-extraTools__button_reset js-DC-extraTools__button_reset"\n\t\t\ttitle="reset to the first value"\n\t\t>\n\t\t\t<svg class="DC-extraTools__buttonImage" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t\t\t\tviewBox="0 0 286.375 286.375" style="enable-background:new 0 0 286.375 286.375;" xml:space="preserve">\n\t\t\t\t<g id="Repeat_playlist">\n\t\t\t\t\t<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M227.925,196.882l58.45-62.644h-36.15\n\t\t\t\t\t\tc-4.593-65.016-58.749-116.34-124.936-116.34C56.09,17.898,0,73.989,0,143.188c0,69.198,56.09,125.289,125.289,125.289\n\t\t\t\t\t\tc30.038,0,57.592-10.592,79.171-28.215l-31.934-31.935c-13.275,9.643-29.565,15.403-47.237,15.403\n\t\t\t\t\t\tc-44.484,0-80.543-36.059-80.543-80.543c0-44.484,36.059-80.544,80.543-80.544c41.455,0,75.562,31.327,80.018,71.594h-35.272\n\t\t\t\t\t\tL227.925,196.882z"/>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\t</div>\n\t<div class="DC-mainTools">\n\t\t<div class="DC-mainTools__logo js-DC-mainTools__logo">\n\t\t\t<div class="DC-mainTools__logoLabel">\n\t\t\t\t<span class="DC-mainTools__logoLabel_blue">\n\t\t\t\t\tDIFFUSION\n\t\t\t\t</span>\n\t\t\t\tSTUB\n\t\t\t</div>\n\t\t</div>\n\t\t<div\n\t\t\tclass="DC-mainTools__button_next DC-mainTools__button js-DC-mainTools__button_next"\n\t\t\ttitle="next topics update"\n\t\t>\n\t\t\t<svg class="DC-mainTools__buttonImage" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t\t\t\tviewBox="0 0 250.488 250.488" style="enable-background:new 0 0 250.488 250.488;" xml:space="preserve">\n\t\t\t\t<g id="Next_track_2">\n\t\t\t\t\t<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M242.381,110.693L140.415,24.591c-3.48-2.406-7.805-2.005-11.071-2.005\n\t\t\t\t\t\tc-13.061,0-13.003,11.7-13.003,14.666v65.249l-92.265-77.91c-3.482-2.406-7.807-2.005-11.072-2.005\n\t\t\t\t\t\tC-0.057,22.587,0,34.287,0,37.252v175.983c0,2.507-0.057,14.666,13.004,14.666c3.265,0,7.59,0.401,11.072-2.005l92.265-77.91\n\t\t\t\t\t\tv65.249c0,2.507-0.058,14.666,13.003,14.666c3.266,0,7.591,0.401,11.071-2.005l101.966-86.101\n\t\t\t\t\t\tc9.668-6.675,7.997-14.551,7.997-14.551S252.049,117.367,242.381,110.693z"/>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\t</div>\n</div>\n';
	
	
	function insertStyles(stylesString) {
	    /* istanbul ignore next */
	    var head = document.head || document.getElementsByTagName('head')[0];
	    var style = document.createElement('style');
	    style.type = 'text/css';
	    /* istanbul ignore if */
	    if (style.styleSheet) {
	        style.styleSheet.cssText = stylesString;
	    } else {
	        style.appendChild(document.createTextNode(stylesString));
	    }
	    head.appendChild(style);
	}
	
	var StubUI = function () {
	    function StubUI(_ref) {
	        var next = _ref.next,
	            play = _ref.play,
	            reset = _ref.reset;
	
	        _classCallCheck(this, StubUI);
	
	        this.next = next;
	        this.play = play;
	        this.reset = reset;
	        this.onNext = this.onNext.bind(this);
	        this.onPlay = this.onPlay.bind(this);
	        this.onReset = this.onReset.bind(this);
	        this.onStop = this.onStop.bind(this);
	    }
	
	    _createClass(StubUI, [{
	        key: 'init',
	        value: function init() {
	            insertStyles(styles);
	            this.render();
	            this.container = document.querySelector('.js-DC-debugger');
	            this.panel = document.querySelector('.js-DC-extraTools');
	            this.toggleButton = document.querySelector('.js-DC-mainTools__logo');
	            this.nextButton = document.querySelector('.js-DC-mainTools__button_next');
	            this.playButton = document.querySelector('.js-DC-extraTools__button_play');
	            this.stopButton = document.querySelector('.js-DC-extraTools__button_stop');
	            this.resetButton = document.querySelector('.js-DC-extraTools__button_reset');
	            this.bindDomEvents();
	        }
	    }, {
	        key: 'bindDomEvents',
	        value: function bindDomEvents() {
	            this.nextButton.addEventListener('click', this.onNext);
	            this.playButton.addEventListener('click', this.onPlay);
	            this.resetButton.addEventListener('click', this.onReset);
	            this.stopButton.addEventListener('click', this.onStop);
	            this.container.addEventListener('click', function (event) {
	                event.stopPropagation();
	            });
	            this.toggleButton.addEventListener('click', this.toggle.bind(this));
	            window.addEventListener('click', this.hide.bind(this));
	        }
	    }, {
	        key: 'onNext',
	        value: function onNext() {
	            this.next();
	        }
	    }, {
	        key: 'onPlay',
	        value: function onPlay() {
	            var intervalInput = document.querySelector('.js-DC-extraTools__input');
	            var intervalInSeconds = parseInt(intervalInput.value, 10);
	            if (!isNaN(intervalInSeconds)) {
	                this.playActions = this.play(intervalInSeconds * 1000);
	                this.panel.classList.add('DC-extraTools__playing');
	                intervalInput.setAttribute('disabled', 'disabled');
	            }
	        }
	    }, {
	        key: 'onStop',
	        value: function onStop() {
	            var intervalInput = document.querySelector('.js-DC-extraTools__input');
	            this.playActions.abort();
	            this.panel.classList.remove('DC-extraTools__playing');
	            intervalInput.removeAttribute('disabled');
	        }
	    }, {
	        key: 'onReset',
	        value: function onReset() {
	            this.reset();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var body = document.querySelector('body');
	            var container = document.createElement('div');
	            container.innerHTML = interfaceHtml;
	            body.appendChild(container);
	        }
	    }, {
	        key: 'toggle',
	        value: function toggle(event) {
	            event.stopPropagation();
	            this.container.classList.toggle('DC-debugger_toggled');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.container.classList.remove('DC-debugger_toggled');
	        }
	    }]);
	
	    return StubUI;
	}();
	
	exports.default = StubUI;

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = prepareTopics;
	var SELECTOR_START = '#>';
	var TOPICS_SPLITTER = '////>';
	
	var chunk = function chunk(array, maxLength) {
	    var result = array.reduce(function (reduced, item, index) {
	        var nextLength = reduced.length + item.length;
	        if (nextLength > maxLength) {
	            var start = reduced.chunkStart;
	            var end = index;
	            return {
	                length: item.length + TOPICS_SPLITTER.length,
	                chunkStart: end,
	                chunkIndex: reduced.chunkIndex.concat([{
	                    start: start,
	                    end: end
	                }])
	            };
	        }
	        return Object.assign({}, reduced, {
	            length: nextLength + TOPICS_SPLITTER.length
	        });
	    }, {
	        length: SELECTOR_START.length,
	        chunkStart: 0,
	        chunkIndex: []
	    });
	    var resultChunks = result.chunkIndex.map(function (index) {
	        return array.slice(index.start, index.end);
	    });
	    resultChunks.push(array.slice(result.chunkStart));
	    return resultChunks;
	};
	function prepareTopics(topics, maxLength) {
	    return chunk(topics, maxLength).map(function (topicsChunk) {
	        return '' + SELECTOR_START + topicsChunk.join(TOPICS_SPLITTER);
	    });
	}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sequence;
	function sequence(action) {
	    var sequenceValues = [];
	    var steps = [];
	    var currentStep = -1;
	
	    var isItemStep = function isItemStep(stepName) {
	        return function (_ref) {
	            var itemStepName = _ref.step;
	            return itemStepName === stepName;
	        };
	    };
	
	    var executeStep = function executeStep(stepName) {
	        sequenceValues.filter(isItemStep(stepName)).forEach(action);
	    };
	
	    var next = function next() {
	        if (currentStep < steps.length - 1) {
	            currentStep += 1;
	            var stepName = steps[currentStep];
	            executeStep(stepName);
	        } else if (steps.length > 1) {
	            currentStep = -1;
	            next();
	        }
	    };
	
	    return {
	        next: next,
	        play: function play(interval) {
	            next();
	            var intervalId = setInterval(next, interval);
	            return {
	                abort: function abort() {
	                    clearInterval(intervalId);
	                }
	            };
	        },
	        reset: function reset() {
	            currentStep = -1;
	        },
	        addValues: function addValues(items) {
	            sequenceValues = sequenceValues.concat(items);
	            steps = sequenceValues.map(function (_ref2) {
	                var step = _ref2.step;
	                return step;
	            }).filter(function (item, index, array) {
	                return array.indexOf(item) === index;
	            });
	        },
	
	        getSteps: function getSteps() {
	            return steps;
	        },
	        getCurrentStep: function getCurrentStep() {
	            if (currentStep >= 0) {
	                return steps[currentStep];
	            }
	            return null;
	        }
	    };
	}

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = shouldEstablishSession;
	
	var _dayjs = __webpack_require__(301);
	
	var _dayjs2 = _interopRequireDefault(_dayjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shouldEstablishSession() {
	    var excludedPaths = ['/racecards/', '/racecards/time-order/', '/racecards/time-order', '/racecards/tomorrow', '/racecards/tomorrow/', '/racecards/big-race-entries/', '/racecards/big-race-entries', '/racecards/us-racing/', '/racecards/us-racing', '/horse-tracker/tracked', '/horse-tracker/tracked/', '/horse-tracker/settings', '/horse-tracker/settings/', '/bloodstock/stallion-book/', '/bloodstock/sales/catalogues/', '/non-runners/'];
	
	    var currentPath = window.location.pathname;
	
	    if (excludedPaths.includes(currentPath)) {
	        return false;
	    }
	
	    var racecardDatePattern = /^\/racecards\/\d{4}-\d{2}-\d{2}\/?$/;
	    if (racecardDatePattern.test(currentPath)) {
	        return false;
	    }
	
	    var resultsPattern = /^\/results\/(\d{4}-\d{2}-\d{2})\/time-order\/?$/;
	    var match = currentPath.match(resultsPattern);
	
	    if (match) {
	        var dateInUrl = (0, _dayjs2.default)(match[1]);
	        var today = (0, _dayjs2.default)().startOf('day');
	        var yesterday = today.subtract(1, 'day');
	
	        if (dateInUrl.isBefore(today) && !dateInUrl.isBefore(yesterday)) {
	            return false;
	        }
	    }
	
	    return true;
	} /* eslint-disable no-console */
	// eslint-disable-next-line import/no-extraneous-dependencies

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = squasher;
	
	var _zip = __webpack_require__(1639);
	
	var _zip2 = _interopRequireDefault(_zip);
	
	var _last = __webpack_require__(1625);
	
	var _last2 = _interopRequireDefault(_last);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Merge two two-dimensional arrays.
	 * @protected
	 * @memberOf SquashedSubscription
	 * @instance
	 * @param {String[][]} source Source data for applying.
	 * @param {String[][]} source Data with difference for applying.
	 * @return {String[][]} Resulted applyied data.
	 */
	function mergeArrays(source, diff) {
	    return (0, _zip2.default)(source, diff).map(function (recordValues) {
	        return _zip2.default.apply(undefined, _toConsumableArray(recordValues)).map(function (fieldValues) {
	            return (0, _last2.default)(fieldValues.filter(function (value) {
	                return !!value;
	            }));
	        });
	    });
	}
	
	function squasher() {
	    var topicState = void 0;
	    return {
	        /**
	         * Squash passed data with previous.
	         * @protected
	         * @memberOf squasher
	         * @instance
	         * @param {Object} data Parsed diffusion record.
	         * @returns {String[][]} Squashed data.
	         */
	        squash: function squash(data) {
	            topicState = !topicState ? data : mergeArrays(topicState, data);
	            return topicState;
	        },
	        getState: function getState() {
	            return topicState;
	        }
	    };
	}

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = createConverter;
	
	var _cachedValue = __webpack_require__(152);
	
	function createConverter() {
	    var replacements = [[/\?/g, '<Q>'], [/\*/g, '<A>'], [/!/g, '<E>'], [/\$/g, '<D>'], [/\(/g, '<O>'], [/\\/g, '<B>'], [/\)/g, '<C>'], [/\+/g, '<P>'], [/\^/g, '<X>'], [/\|/, '<I>'], [/,/g, '<M>'], [/\./g, '<F>'], [/\[/g, '<S>'], [/]/g, '<R>'], [/À|Á|Â|Ã|Ä|Å|à|á|â|ã|ä|å/g, 'A'], [/Æ|æ/g, 'A,E'], [/Ç|ç/g, 'C'], [/È|É|Ê|Ë|è|é|ê|ë/g, 'E'], [/Ì|Í|Î|Ï|ì|í|î|ï/g, 'I'], [/Ð|ð/g, 'D,H'], [/Ò|Ó|Ô|Õ|Ö|ò|ó|ô|õ|ö|ø/g, 'O'], [/Ù|Ú|Û|Ü|ù|ú|û|ü/g, 'U'], [/Ý|ý|ÿ|Ÿ/g, 'Y'], [/Ñ|ñ/g, 'N'], [/Ø|ø/g, 'O'], [/Þ|þ/g, 'T,H'], [/ß/g, 'S,S'], [/[a-z]/g, function (item) {
	        return item.toUpperCase();
	    }], [/[\u0000-\u001f]/g, ' ']];
	    var prepareReplacement = function prepareReplacement(_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            regex = _ref2[0],
	            value = _ref2[1];
	
	        return function (item) {
	            return item.replace(regex, value);
	        };
	    };
	    var replaceActions = replacements.map(prepareReplacement);
	    var topicDictionary = (0, _cachedValue.dictionary)(function (value) {
	        return replaceActions.reduce(function (result, replaceAction) {
	            return replaceAction(result);
	        }, value);
	    });
	
	    return {
	        /**
	         * convert from topic
	         */
	        from: topicDictionary.getKey,
	        /**
	         * convert to topic
	         */
	        to: topicDictionary.getValue
	    };
	}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.webClientMessageWrapper = webClientMessageWrapper;
	exports.default = webClientMessage;
	function webClientMessageWrapper(state) {
	    var getRecords = function getRecords() {
	        return state.records;
	    };
	    var getFields = function getFields() {
	        var recordIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        return getRecords()[recordIndex];
	    };
	    return {
	        getTopic: function getTopic() {
	            return state.topic;
	        },
	        getRecords: getRecords,
	        getFields: getFields,
	        getRecord: function getRecord(recordIndex) {
	            return { fields: getFields(recordIndex) };
	        }
	    };
	}
	
	function webClientMessage(data, topic) {
	    var replaceEmptyWithString = function replaceEmptyWithString(item) {
	        return item === undefined || item === null ? '' : item;
	    };
	    var records = data.map(function (record) {
	        return record.map(replaceEmptyWithString);
	    });
	    var state = {
	        topic: topic,
	        records: records.map(function (record) {
	            return { fields: record };
	        })
	    };
	    return Object.assign(state, webClientMessageWrapper({
	        topic: topic,
	        records: records
	    }));
	}

/***/ }),
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESULTS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = exports.CARDS_PREFERRED_TAB = undefined;
	exports.getPrefValue = getPrefValue;
	
	var _jquery = __webpack_require__(23);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CARDS_PREFERRED_TAB = exports.CARDS_PREFERRED_TAB = 'cdt_tab_pref';
	var CARDS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = 'cdt_list_pref';
	var RESULTS_LIST_VIEW_TYPE = exports.RESULTS_LIST_VIEW_TYPE = 'rsp_list_pref';
	
	function getValuesIfExist(value, possibleValues) {
	    return value in possibleValues;
	}
	
	function getPrefValue(prefType, prefDefaultValue) {
	    return localStorage.getItem(prefType) || prefDefaultValue;
	}
	
	function buildUrl(className, prefType, prefDefaultValue, possibleValues) {
	    var prefValue = void 0;
	
	    (0, _jquery2.default)(document).on('touchstart mousedown', '.' + className, function (e) {
	        var $target = (0, _jquery2.default)(e.currentTarget);
	
	        function updateHref(value) {
	            $target.attr('href', function (index, href) {
	                return '' + href.replace(/\/$/, '') + possibleValues[value];
	            });
	            $target.removeClass(className);
	        }
	
	        if (prefValue) {
	            updateHref(prefValue);
	        } else {
	            prefValue = getPrefValue(prefType, prefDefaultValue);
	            updateHref(prefValue);
	        }
	    });
	}
	
	function setPref(selector, storageKeyName, possibleValues) {
	    var value = (0, _jquery2.default)(selector).attr('data-pref-type');
	    if (!getValuesIfExist(value, possibleValues)) {
	        return;
	    }
	
	    if (value) {
	        try {
	            localStorage.setItem(storageKeyName, value);
	        } catch (e) {
	            /* eslint-disable no-console */
	            console.warn('You are in a private mode, so, we couldn\'t save your preference.');
	        }
	    }
	}
	
	function navigate() {
	    var cardTabsPossibleValues = {
	        free: '/',
	        pro: '/pro',
	        'at-a-glance': '/at-a-glance',
	        'odds-comparison': '/odds-comparison',
	        'raceday-live': '/raceday-live'
	    };
	    var cardListTypePossibleValues = {
	        byCourse: '/',
	        byTime: '/time-order'
	    };
	
	    var resultsListTypePossibleValues = {
	        byCourse: '/',
	        byTime: '/time-order'
	    };
	
	    // Racecards tab preferences
	    // TODO: change to more related name
	    setPref('.js-navigate-type', CARDS_PREFERRED_TAB, cardTabsPossibleValues);
	    buildUrl('js-navigate-url', CARDS_PREFERRED_TAB, 'free', cardTabsPossibleValues);
	
	    // Racecards list types preferences
	    setPref('.js-rc-list-type', CARDS_LIST_VIEW_TYPE, cardListTypePossibleValues);
	    buildUrl('js-rc-list-url', CARDS_LIST_VIEW_TYPE, 'byCourse', cardListTypePossibleValues);
	
	    // Results list types preferences
	    setPref('.js-rsp-list-type', RESULTS_LIST_VIEW_TYPE, resultsListTypePossibleValues);
	    buildUrl('js-rsp-list-url', RESULTS_LIST_VIEW_TYPE, 'byCourse', resultsListTypePossibleValues);
	}
	
	exports.default = navigate;

/***/ }),
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1874 */
769,
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
	  function getOwnPropertyDescriptors(obj) {
	    var keys = Object.keys(obj);
	    var descriptors = {};
	    for (var i = 0; i < keys.length; i++) {
	      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
	    }
	    return descriptors;
	  };
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  if (typeof process !== 'undefined' && process.noDeprecation === true) {
	    return fn;
	  }
	
	  // Allow for deprecating things in the process of starting up.
	  if (typeof process === 'undefined') {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1874);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(149);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
	
	exports.promisify = function promisify(original) {
	  if (typeof original !== 'function')
	    throw new TypeError('The "original" argument must be of type Function');
	
	  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
	    var fn = original[kCustomPromisifiedSymbol];
	    if (typeof fn !== 'function') {
	      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
	    }
	    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	      value: fn, enumerable: false, writable: false, configurable: true
	    });
	    return fn;
	  }
	
	  function fn() {
	    var promiseResolve, promiseReject;
	    var promise = new Promise(function (resolve, reject) {
	      promiseResolve = resolve;
	      promiseReject = reject;
	    });
	
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	    args.push(function (err, value) {
	      if (err) {
	        promiseReject(err);
	      } else {
	        promiseResolve(value);
	      }
	    });
	
	    try {
	      original.apply(this, args);
	    } catch (err) {
	      promiseReject(err);
	    }
	
	    return promise;
	  }
	
	  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
	
	  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	    value: fn, enumerable: false, writable: false, configurable: true
	  });
	  return Object.defineProperties(
	    fn,
	    getOwnPropertyDescriptors(original)
	  );
	}
	
	exports.promisify.custom = kCustomPromisifiedSymbol
	
	function callbackifyOnRejected(reason, cb) {
	  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
	  // Because `null` is a special error value in callbacks which means "no error
	  // occurred", we error-wrap so the callback consumer can distinguish between
	  // "the promise rejected with null" or "the promise fulfilled with undefined".
	  if (!reason) {
	    var newReason = new Error('Promise was rejected with a falsy value');
	    newReason.reason = reason;
	    reason = newReason;
	  }
	  return cb(reason);
	}
	
	function callbackify(original) {
	  if (typeof original !== 'function') {
	    throw new TypeError('The "original" argument must be of type Function');
	  }
	
	  // We DO NOT return the promise as it gives the user a false sense that
	  // the promise is actually somehow related to the callback's execution
	  // and that the callback throwing will reject the promise.
	  function callbackified() {
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	
	    var maybeCb = args.pop();
	    if (typeof maybeCb !== 'function') {
	      throw new TypeError('The last argument must be of type Function');
	    }
	    var self = this;
	    var cb = function() {
	      return maybeCb.apply(self, arguments);
	    };
	    // In true node style we process the callback on `nextTick` with all the
	    // implications (stack, `uncaughtException`, `async_hooks`)
	    original.apply(this, args)
	      .then(function(ret) { process.nextTick(cb, null, ret) },
	            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
	  }
	
	  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
	  Object.defineProperties(callbackified,
	                          getOwnPropertyDescriptors(original));
	  return callbackified;
	}
	exports.callbackify = callbackify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 1876 */,
/* 1877 */
1880,
/* 1878 */
1880,
/* 1879 */
1880
]);


// WEBPACK FOOTER //
// app.min.js